// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class IonicVhframeworksService {

//   constructor() { }
// }
/**
 * bill_type = 38 : hủy hàng trong kho
 * bill_type = 39 : bù hàng trong kho
 */
/**
 * ng build --prod 
 * Bản thương mại (hoàn thiện code) bỏ các hàm này ra makeCorrectQuantity
 */
 import { Injectable, Component, OnInit, Input, Output, EventEmitter, Pipe, PipeTransform, Renderer2, RendererFactory2, PLATFORM_ID, Inject} from "@angular/core";
 import { Router, NavigationEnd } from "@angular/router";
 import { VhMGDB_auth, VhMGDB_database, VhMGDB_rootdatabase, VhMGDB_f3rdclouds, VhMGDB_image, VhMGDB_socketMongoDB,
   VhMGDB_paymentVNPAY, VhMGDB_clouds, VhMGDB_shopee, VhMGDB_tiki, VhMGDB_sendo, VhMGDB_lazada, VhMGDB_tiktok, 
   VhMGDB_socketFacebook, VhMGDB_pattern, VhFB_OTP
 } from 'vhmongo-new';
 import { ImagePicker } from "@ionic-native/image-picker/ngx";
 import { WebView } from "@ionic-native/ionic-webview/ngx";//bỏ
 import { Camera, CameraOptions } from "@ionic-native/camera/ngx";//bỏ
 import { Device } from '@capacitor/device';
 import { Socket } from 'ngx-socket-io';
 import { ObjectUnsubscribedError, Observable, Subject, BehaviorSubject, forkJoin, Subscription } from 'rxjs';
 import { InAppPurchase2, IAPProduct  } from '@ionic-native/in-app-purchase-2/ngx';//bỏ   
 import { Platform } from "@ionic/angular";
 import { formatCurrency, formatDate, formatPercent, FormatWidth, getCurrencySymbol, isPlatformBrowser} from '@angular/common';
 import cloneDeep from 'lodash/cloneDeep';
 import {DomSanitizer} from '@angular/platform-browser';
 import { Papa } from "ngx-papaparse";
 
 import { SocialSharing } from '@ionic-native/social-sharing/ngx';
 import { File, FileWriter } from '@ionic-native/file/ngx';
 import * as XLSX from 'xlsx'; 
 
 import Cleave from "cleave.js";   
 //import * as CleaveOptions from 'cleave.js/options';
 import "cleave.js/dist/addons/cleave-phone.i18n";
 import { initDB, closeDB, deleteDB } from './db.dexie';

 import { MqttService, IMqttMessage } from "ngx-mqtt";
 import { WifiWizard2 } from '@ionic-native/wifi-wizard-2/ngx';
 import { BluetoothSerial } from '@ionic-native/bluetooth-serial/ngx'; 
 import domtoimage from 'dom-to-image';
 import { TranslateDefaultParser, TranslateLoader, TranslateService } from '@ngx-translate/core';
 import { HttpClient } from '@angular/common/http';
 import axios from 'axios';
 import html2canvas from 'html2canvas';
 import kindOf from "kind-of";
 import { MyUploadImageAdapter} from "./my-class";
 import {
   checkSales_addProductAndSubsProduct, 
   checkSales_addSubProduct, 
   checkSales_updateSubProduct,
   checkSales_updateProduct_Type3_fw,      
   checkSales_updateProduct_Type3,      
   checkSales_updateProduct_Type2,    
   checkSales_updateProduct_Type5,
   checkCafe_addProductAndSubsProduct_type1, 
   checkCafe_addProductAndSubsProduct_type3, 
   checkCafe_addSubProduct_type1,
   checkCafe_addSubProduct_type3,  
   checkCafe_updateSubProduct_type1,
   checkCafe_updateSubProduct_type3,
   checkCafe_updateProduct_Type1_fw,      
   checkCafe_updateProduct_Type3_fw, 
   checkCafe_updateProduct_Type1,      
   checkCafe_updateProduct_Type3, 
   checkCafe_updateProduct_Type2,    
   checkCafe_updateProduct_Type5
 } from './check-parameters';

 import {
  addCustomer,
  insertCustomer,
  getCustomerById,
  getAllCustomers,
  updateCustomer,
  deleteCustomer,
  getLiveAllCustomers  
} from './customers.dexie';
 
 import Dexie, { Table } from 'dexie';

import { AnyARecord, AnyCnameRecord, resolve } from "dns";
import { Tracing } from "trace_events";
import { ExecOptionsWithStringEncoding } from "child_process";
 //import Check_Parameters_Sales from './check-parameters-sales'
import "cordova-plugin-purchase";

//declare function structuredClone<T>(value: T): T;

// ✅ Biến toàn cục từ plugin (bắt buộc có)
declare var CdvPurchase: any;
 
 declare var WSAvcPlayer:any;
 declare var JSMpeg:any;
 declare var chrome:any; 
 declare var esptouch:any;
 declare var electron: any;
 declare var $: any;

export class VhIDB {
  private db:any =null;
  constructor(database:string) {
    this.db = new Dexie(database)
    this.db.version(1).stores({
      atw_pages: '++id',
      atw_blocks: '++id',
      atw_objects: '++id',
    });
  }

   /**
    * @example:
    * this.vhQuery.addDoc('products', {name:'camera 2', quantity:20, price:200000})
             .then((response)=>{
               console.log('addDoc', response);
             },(error:any)=>{
               console.log('error', error);
             })  
    * @param colname 
    * @param data 
    * @return Promise => object = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
    public addDoc(colname:string, data:object){
    return new Promise((resolve, reject) => {
      if((colname === 'atw_pages')||(colname === 'atw_blocks')||(colname === 'atw_objects'))
      this.db[colname].add(data)  
          .then((result:any) => {
            resolve(result);
          }).catch((err:any) => {
            console.log("added fail: " + err)
            reject(err);
          });  
    })
  }

  /**
   * @example:
   * this.vhQuery.addDocbyID('products', 'nvliw974854hf848ugrgh3498', {name:'camera 2', quantity:20, price:200000})
            .then((response)=>{
              console.log('addDocbyID', response);
              }, error=>{
                console.log('error', error);
            })
    * @param colname 
    * @param data 
    * @return Promise => obj = {}
    * Luu y: truong hop trung _id nó sẽ báo lỗi error
    */
  public addDocbyID(colname:string, _id:string, data:object){
    return new Promise((resolve, reject) => {
            
    })
  }

  /**
   * @example:
   * this.vhQuery.updateDoc('products', '5fb6780ca2148e09806c5b01', {quantity:400})
            .then((bool:any)=>{
              console.log('updateDoc', bool);
            }, error=>{
              console.log('error', error);
            })
    * @param colname 
    * @param _id 
    * @param data 
    * @return Promise => bool = true or false
    */
  public updateDoc(colname:string, _id:string, data:object){
    return new Promise((resolve, reject) => {      
                       
    })
  }

  /**
   * @example:
       * this.vhQuery.deleteDoc('products', '5fb67fda87c0f21d484cbdf3')
            .then(bool=>{
              console.log('deleteDoc', bool);
            })
    * @param colname 
    * @param _id 
    * @return Promise => bool = true or false
    */
  public deleteDoc(colname:string, _id:string){
    return new Promise((resolve, reject) => {
           
    })
  }

  /**
   * @example
   * this.vhQuery.getDoc('products', '5fb67fda87c0f21d484cbdf3')
            .then((product)=>{
              console.log('getDoc', product);
            },(error:any)=>{
              console.log('error', error);
            })
    * @param colname 
    * @param _id 
    * @return Promise => obj ={} or null
    */
  public getDoc(colname:string, _id:string){
    return new Promise((resolve,reject) => {
               
    })
  }

  /**
   * @example
   * this.vhQuery.getDoc('products', '5fb67fda87c0f21d484cbdf3')
            .then((response)=>{
              console.log('getDoc', response);
            })
    * @param colname 
    * @param _id 
    * @return array(object) = [{},{},..]
    */
  public getDocs(colname:string){
    return new Promise((resolve) => {
               
    })
  }
  
    /**
   * @example:
   * this.vhQuery.getDocsByFields('products', {name:{$eq:'name abc'}}, {},{},0)
      .then((products)=>{
        console.log('getDocsByFields', products);
      })
  * @param colname 
  * @param query
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
  public getDocsByFields(colname:string, query: object, projection?:object, sort?:object, limit?:number){
    return new Promise((resolve) => {
            
    })
  }

}
 
 export function vhDate(value: any, format: string, locate?: string){
   let _format = ''; 
   if(format === 'time'){
     _format = 'HH:mm:ss';
   }else if(format === 'date'){
     _format = 'dd/MM/YYYY';
   }else if(format === 'datetime'){
     _format = 'dd/MM/YYYY HH:mm:ss';
   }else if(format === 'YYYY-MM-dd HH:mm:ss'){
     _format = 'YYYY-MM-dd HH:mm:ss';
   }else{     
     return 'wrong format';
   }
   return formatDate(value, _format, 'en-VI');
 }



@Injectable({ providedIn: 'root' })  
export class VhEventMediator  
{ 
    /**
     * configChanged event
     */
    private configChangedSubject$ = new BehaviorSubject<any>(null);  
    /**
     * this.vhEventMediator.configChanged.subscribe((msg: any) => {
          if(msg.status === 'update-gap'){
            if(msg.code === this.blockChoosing._id){
              //code thêm ở đây
            }else{
              //code thêm ở đây
            }
          }
      })
     */
    public configChanged = this.configChangedSubject$.asObservable();  
  
    /**
     * this.vhEventMediator.notifyOnConfigChanged({ status: 'update-gap', code: this.blockChoosing._id });
     * @param configData 
     */
    public notifyOnConfigChanged(configData: any): void {        
        this.configChangedSubject$.next(configData);  
    }   



    /**
     * configSelected event
     */
    private configSelectedSubject$ = new BehaviorSubject<any>(null);  
    /**
     * this.vhEventMediator.configSelected.subscribe((msg: any) => {
          if(msg.status === 'choose-object-selected-ruler'){
            if(msg.code === this.object._id){
              //code thêm ở đây
            }else{
              //code thêm ở đây
            }
          }
      })
     */
    public configSelected = this.configSelectedSubject$.asObservable();  
  
    /**
     * this.vhEventMediator.notifyOnConfigSelected({ status: 'choose-object-selected-ruler', code: this.object._id });
     * @param configData 
     */
    public notifyOnConfigSelected(configData: any): void {        
        this.configChangedSubject$.next(configData);  
    }   
}

/**
 * 🧩 Iap2Service
 * -------------------------
 * Service quản lý toàn bộ luồng In-App Purchase (IAP)
 * Sử dụng plugin: `cordova-plugin-purchase`
 * 
 * 👉 Hỗ trợ cả:
 *    - Android (Google Play)
 *    - iOS (App Store)
 * 
 * Các nhiệm vụ chính:
 *   - Khởi tạo store
 *   - Đăng ký danh sách sản phẩm
 *   - Theo dõi sự kiện mua hàng
 *   - Xử lý các trạng thái giao dịch (approved, verified, expired, ...)
 *   - Cho phép refresh / restore / purchase thủ công
 */
/*************************** CÁCH DÙNG FW Iap2Service *******************************************
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Iap2Service } from '../services/iap2.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage implements OnInit, OnDestroy {
  private PRODUCT_IDS: string[] = [
    "inapp_xprinterpos_main_standard_1day,
    "inapp_xprinterpos_main_standard_1month",
    "inapp_xprinterpos_main_standard_12month",
    "inapp_xprinterpos_main_pro_1month",
    "inapp_xprinterpos_main_pro_12month",
    "inapp_xprinterpos_main_super_pro_1month",
    "inapp_xprinterpos_main_super_pro_12month",
  ];
  products: Array<{ id: string; title: string; desc: string; price: string; saveTag?: string }> = [];
  selectedPlanIndex: number = 0;
  private productsSub?: Subscription;

  constructor(private iap2Service: Iap2Service) {}

  ngOnInit(): void {
    this.iap2Service.initPurchase(this.PRODUCT_IDS);
    this.productsSub = this.iap2Service.products$.subscribe((tmp: any[]) => {
      this.products = (tmp || []).map((item: any) => {
        let price: string = '';
        if (Array.isArray(item.offers) && item.offers.length > 0 && Array.isArray(item.offers[0].pricingPhases) && item.offers[0].pricingPhases.length > 0) {
          price = item.offers[0].pricingPhases[0].price;
        }
        return {
          id: item.id as string,
          title: item.title as string,
          desc: item.description as string,
          price: price,
        };
      });
    });
  }

  ngOnDestroy(): void {
    this.productsSub?.unsubscribe();
  }

  selectPlan(i: number): void {
    this.selectedPlanIndex = i;
  }

  purchaseSelectedPlan(): void {
    const selectedProduct = this.products[this.selectedPlanIndex];
    if (selectedProduct) {
      console.log("==> product id", selectedProduct.id);
      this.iap2Service.purchase(selectedProduct.id, 'oIpCK6jgMxLHOPrwV1Sm');
    }
  }
}
 */
@Injectable({
  providedIn: "root",
})
export class Iap2Service {
  /** 
   * 🔸 Danh sách ID sản phẩm trên Store (Google / Apple)
   * 
   * 👉 Các ID này phải trùng với phần bạn cấu hình trên Google Play Console hoặc App Store Connect.
   * 👉 Nếu sai, store sẽ không nhận diện được sản phẩm.
   */
  private PRODUCT_IDS: string[] = new Array();
  private app_product: any = null;
  private id_branch: any = null;

  /** 
   * 🔹 Biến lưu instance store (được plugin quản lý)
   * - Là trung tâm quản lý mọi giao dịch mua hàng
   */
  private store?: CdvPurchase.Store;

  /** Observable phát danh sách sản phẩm đã load */
  private productsSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public products$: Observable<any[]> = this.productsSubject.asObservable();

  constructor(
    private platform: Platform,
    private vhMGDB_auth:VhMGDB_auth
  ){}
  /**
   * 🚀 Khởi tạo hệ thống In-App Purchase
   * -----------------------------------
   * Thực hiện tuần tự:
   * 1️⃣ Chờ thiết bị sẵn sàng (Platform Ready)
   * 2️⃣ Lấy instance `CdvPurchase.store`
   * 3️⃣ Xác định nền tảng (Android hoặc iOS)
   * 4️⃣ Đăng ký sản phẩm vào store
   * 5️⃣ Gắn các event handler xử lý giao dịch
   * 6️⃣ Khởi tạo và làm mới store
   * 7️⃣ Chờ store sẵn sàng hoàn toàn (store.ready())
   *  PRODUCT_IDS: string[] = [
        "store_main_package_standard_1month",
        "store_main_package_standard_12month",
        "store_main_package_standard_24month",
        "store_main_package_standard_60month",
      ];
   */
  public initPurchase(PRODUCT_IDS:any): void {
    this.PRODUCT_IDS = PRODUCT_IDS;
      this.platform.ready().then(() => {
        console.log("==> initPurchase");

        // Lấy instance của store từ CdvPurchase
        this.store = CdvPurchase.store;
        if (!this.store) {
          console.log("==> CdvPurchase store not available.");
          return;
        }

        // Thiết lập mức độ log để debug
        try {
          (this.store as any).verbosity =
            (CdvPurchase as any).LogLevel?.DEBUG ?? (this.store as any).DEBUG;
          console.log("==> Set verbosity thành công");
        } catch (e) {
          console.error("==> Lỗi khi set verbosity", e);
        }

        // Xác định platform (Android/iOS) và thiết lập platform constant
        const w: any = window;
        let platformConst: any;
        if (w.cordova && w.cordova.platformId === "android") {
          platformConst = CdvPurchase.Platform.GOOGLE_PLAY;
          console.log("==> Platform: ANDROID");
        } else if (w.cordova && w.cordova.platformId === "ios") {
          platformConst = CdvPurchase.Platform.APPLE_APPSTORE;
          console.log("==> Platform: IOS");
        } else {
          console.log("==> Unsupported platform for IAP");
          return;
        }

        // Đăng ký tất cả sản phẩm với store
        this.PRODUCT_IDS.forEach((id) => {
          try {
            (this.store as any).register({
              id,
              type: CdvPurchase.ProductType.CONSUMABLE,
              platform: platformConst,
            } as any);
            console.log(`==> Đã register product: ${id}`);
          } catch (e) {
            console.error(`==> Lỗi khi register product: ${id}`, e);
          }
        });

        // Đăng ký các event handlers cho purchase flow
        try {
          this.registerHandlersForPurchase();
          console.log("==> Đã đăng ký global purchase handlers");
        } catch (e) {
          console.error("==> Lỗi khi đăng ký global purchase handlers", e);
        }

        // Đăng ký error handler cho store
        try {
          this.store.error((err: any) => {
            console.log("==> Store Error:", err.code, err.message);
          });
          console.log("==> Đã đăng ký error handler cho store");
        } catch (e) {
          console.error("==> Lỗi khi đăng ký error handler", e);
        }

        // Khởi tạo store (bắt buộc từ v13+)
        try {
          this.store.initialize([{ platform: platformConst }]);
          console.log("==> Đã gọi store.initialize()");
        } catch (e) {
          console.error("==> Lỗi khi gọi store.initialize()", e);
        }

        // Kiểm tra trạng thái store sau 3 giây
        // Phát danh sách sản phẩm hiện có (nếu đã có)
        try {
          const current = this.getRegisteredProducts();
          this.productsSubject.next(current);
          console.log("==> Emit products ngay sau initialize", current);
        } catch (e) {
          console.error("==> Lỗi khi emit products sau initialize", e);
        }

        // Refresh store để lấy thông tin sản phẩm mới nhất
        try {
          this.store.refresh();
          console.log("==> Đã gọi store.refresh()");
        } catch (e) {
          console.error("==> Lỗi khi gọi store.refresh()", e);
        }
        console.log("==> initPurchase 3");
      });
    }


  /**
   * 🧠 Gắn các event handler xử lý luồng mua hàng
   * ---------------------------------------------
   * Mỗi bước của giao dịch (approved, verified, refunded, expired, rejected, error)
   * đều được log ra console để dev theo dõi và xử lý nghiệp vụ phía backend nếu cần.
   */
  private registerHandlersForPurchase(): void {
    const store: any = this.store;
    if (!store) return;

    // Sử dụng builder pattern để đăng ký các event handlers
    store
      .when()
      // Khi thông tin sản phẩm được cập nhật
      .productUpdated((product: any) => {
        console.log("==> productUpdated (global)", product.id, product);
        console.log("==> productUpdated (global)", product.id, product.pricing);
        console.log("==> productUpdated (global)", product.id, product.owned);
        // Mỗi lần product cập nhật, phát lại danh sách sản phẩm
        try {
          const products = this.getRegisteredProducts();
          this.productsSubject.next(products);
        } catch (e) {
          console.error("==> Lỗi khi emit products trong productUpdated", e);
        }
      })
      // Khi giao dịch được chấp thuận
      .approved((transaction: any) => {
        console.log("==> approved (global)", transaction.id, transaction);
        // Bắt đầu quá trình verify receipt
        transaction.verify();
      })
      // Khi receipt được verify thành công
      .verified((receipt: any) => {
        console.log("==> verified (global)", receipt.id, receipt);
        // Hoàn tất giao dịch
        receipt.finish();
        this.create_Payment_Apple_Google_Pay(this.app_product, this.id_branch)
      })
      // Khi sản phẩm được hoàn tiền
      .refunded((product: any) => {
        console.log("==> refunded (global)", product.id, product);
      })
      // Khi subscription hết hạn
      .expired((product: any) => {
        console.log("==> expired (global)", product.id, product);
      })
      // Khi giao dịch bị từ chối
      .rejected((err: any) => {
        console.warn("==> rejected (global)", err);
      })
      // Khi có lỗi xảy ra
      .error((err: any) => {
        console.error("==> purchase error (global)", err);
      });
  }

  /**
   * Thực hiện mua sản phẩm
   * @param app_product - sản phẩm trên chplay, appstore cần mua
   */
  public purchase(app_product: any, id_branch:string) {    
    this.app_product = app_product;
    const app_productID = this.app_product.id;
    this.id_branch = id_branch;
    // Lấy thông tin sản phẩm từ store
    const product = this.store?.get(app_productID);
    if (!product) {
      console.error("==> Product chưa load:", this.app_product);
      return;
    }

    // Thực hiện mua sản phẩm
    product
      .getOffer()
      ?.order()
      .then((err: any) => {
        if (err) {
          console.error("==> Purchase failed", err);
        } else {
          console.log("==> Purchase flow started");
        }
      });
  }

  /**
   * Refresh thông tin sản phẩm từ store
   * Cập nhật giá cả và thông tin sản phẩm mới nhất
   */
  public refreshPurchase() {
    this.store?.refresh();
  }

  /**
   * Lấy danh sách các sản phẩm đã được đăng ký
   * @returns Mảng các sản phẩm đã được load thành công
   */
  public getRegisteredProducts() {
    const products: any[] = [];

    // Duyệt qua tất cả product IDs và lấy thông tin từ store
    for (let i = 0; i < this.PRODUCT_IDS.length; i++) {
      const product =
        this.store && (this.store as any).get(this.PRODUCT_IDS[i]);
      console.log("==> product", product);
      if (product) {
        products.push(product);
      }
    }
    return products;
  }

  /**
   * Khôi phục các giao dịch đã mua trước đó
   * Hữu ích khi user cài đặt lại app hoặc chuyển thiết bị
   */
  public restorePurchase() {
    this.store?.restorePurchases();
  }

  private create_Payment_Apple_Google_Pay(app_product: any, id_branch:string){
    return new Promise<any>((resolve, reject) => {
      let body = {id_store:this.vhMGDB_auth.getDatabase(), projectname: this.vhMGDB_auth.getProjectName(),app_product, id_branch};   
      console.log('create_Payment_Apple_Google_Pay', body);
      console.log(this.vhMGDB_auth.getCUMserverURL());   
      axios.post(this.vhMGDB_auth.getCUMserverURL() + '/paymentviethas/create_payment_apple_google_pay', {...body})
                  .then((response:any)=> {                    
                    resolve(response.data);                             
                  })
                  .catch((e:any)=> {                    
                    reject(e);
                  });          
    })
  }
}

   
 @Injectable({providedIn: 'root'})
 export class VhAlgorithm { 
   constructor(
    private platform: Platform, private file: File, private socialSharing: SocialSharing, private papa: Papa, private dom:DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object
    ) {}  

    
private _keyStr = "ACEGIKMOQSUWYBDFHJLNPRTVXZ" + "acegikmoqsuwybdfhjlnprtvxz0246813579=/+";
public encodeString(e:any) {        
    let t = "";
    let n, r, i, s, o, u, a;
    let f = 0;
    e = this._utf8_encode(e);
    while (f < e.length) {
        n = e.charCodeAt(f++);
        r = e.charCodeAt(f++);
        i = e.charCodeAt(f++);
        s = n >> 2;
        o = (n & 3) << 4 | r >> 4;
        u = (r & 15) << 2 | i >> 6;
        a = i & 63;
        if (isNaN(r)) {
            u = a = 64
        } else if (isNaN(i)) {
            a = 64
        }
        t = t +
            this._keyStr.charAt(s) +
            this._keyStr.charAt(o) +
            this._keyStr.charAt(u) +
            this._keyStr.charAt(a)
    }
    return t
}
public decodeString(e:any) {
    return e
    let t = "";
    let n, r, i;
    let s, o, u, a;
    let f = 0;
    e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (f < e.length) {
        s = this._keyStr.indexOf(e.charAt(f++));
        o = this._keyStr.indexOf(e.charAt(f++));
        u = this._keyStr.indexOf(e.charAt(f++));
        a = this._keyStr.indexOf(e.charAt(f++));
        n = s << 2 | o >> 4;
        r = (o & 15) << 4 | u >> 2;
        i = (u & 3) << 6 | a;
        t = t + String.fromCharCode(n);
        if (u != 64) {
            t = t + String.fromCharCode(r)
        }
        if (a != 64) {
            t = t + String.fromCharCode(i)
        }
    }
    t = this._utf8_decode(t);
    return t
}
private _utf8_encode(e:any) {
    e = e.replace(/\r\n/g, "\n");
    let t = "";
    for (let n = 0; n < e.length; n++) {
        let r = e.charCodeAt(n);
        if (r < 128) {
            t += String.fromCharCode(r)
        } else if (r > 127 && r < 2048) {
            t +=
                String.fromCharCode(r >> 6 | 192);
            t +=
                String.fromCharCode(r & 63 | 128)
        } else {
            t +=
                String.fromCharCode(r >> 12 | 224);
            t +=
                String.fromCharCode(r >> 6 & 63 | 128);
            t +=
                String.fromCharCode(r & 63 | 128)
        }
    }
    return t
}
private _utf8_decode(e:any) {
    let t = "";
    let n = 0;
    let r = 0;
    let c1 = 0;
    let c2 = 0;
    let c3 = 0;
    while (n < e.length) {
        r = e.charCodeAt(n);
        if (r < 128) {
            t += String.fromCharCode(r);
            n++
        } else if (r > 191 && r < 224) {
            c2 = e.charCodeAt(n + 1);
            t += String.fromCharCode(
                (r & 31) << 6 | c2 & 63);

            n += 2
        } else {
            c2 = e.charCodeAt(n + 1);
            c3 = e.charCodeAt(n + 2);
            t += String.fromCharCode(
                (r & 15) << 12 | (c2 & 63)
                << 6 | c3 & 63);
            n += 3
        }
    }
    return t
}
/**
 * Hàm dùng xác định biến, trường dữ liệu nào đó có phải là stringify (JSON) hay ko (stringify là loại dữ liệu
 * mà có thể thể parse thành mảng hoặc object)
 * @example:
 * obj = this.vhAlgorithm.isJSON(stringify)
 * @param stringify 
 * @returns true/false
 */
  isJSON(stringify:any){
    if(kindOf(stringify) !='string') return false;
    // if (/^[\],:{}\s]*$/.test(stringify.replace(/\\["\\\/bfnrtu]/g, '@').
    //   replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
    //   replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
    //   return true;
    // }else return false;
    try {
      JSON.parse(stringify);
    } catch (e) {
        return false;
    }
    return true;
  }

  /**
   * Do mysql ko lưu đc kiểu dữ liệu array, object nên khi lưu các trường này phải chuyển sang json(string),
   * do đó khi lấy về phải chuyển các trường này lại thành array, object
   * @example:
   * obj = this.vhAlgorithm.normalizationData_fromMySQL(data)
   * @param array_or_obj 
   * @returns 
   */
  normalizationData_fromMySQL(array_or_obj:any){  
    if(kindOf(array_or_obj) == 'array'){
      for(let i=0; i<array_or_obj.length; i++){
        if((kindOf(array_or_obj[i]) == 'object')||kindOf(array_or_obj[i]) == 'array'){
          this.normalizationData_fromMySQL(array_or_obj[i]); 
        }                
      }  
    }else if(kindOf(array_or_obj) == 'object'){
      for(let p in array_or_obj){
        if(array_or_obj[p] == null){ 
          delete array_or_obj[p];
        }else if((kindOf(array_or_obj[p]) == 'object')||kindOf(array_or_obj[p]) == 'array'){
          this.normalizationData_fromMySQL(array_or_obj[p]);        
        }else if(this.isJSON(array_or_obj[p])){         
          array_or_obj[p] = JSON.parse(array_or_obj[p]);   
          this.normalizationData_fromMySQL(array_or_obj[p]);         
        }               
      }

      for(let p in array_or_obj){
        if(p=='id'){
          array_or_obj['_id'] = array_or_obj[p];
          break;
        } 
      }
    }    
  }
 
 /**
  * Chuyển kiểu dữ liệu obj là contructor thành object
  * @example:
  * obj = this.vhAlgorithm.stringify(obj)
  * @param obj 
  * @returns 
  */
 public stringify(obj:any) {
  let cache:any = [];
  let str = JSON.stringify(obj, function(key, value) {
    if (typeof value === "object" && value !== null) {
      if (cache.indexOf(value) !== -1) {
        // Circular reference found, discard key
        return;
      }
      // Store value in our collection
      cache.push(value);
    }
    return value;
  });
  cache = null; // reset the cache
  return str;
}

 
 /**
  * Hàm này kiểm tra ngày trên bill có phải là ngày hiện tại của thiết bị không
  * @Example :
  * if(this.vhAlgorithm.isToday(date)){
  *       //Your code
  * }
  * @param date : ngày trên bill
  * @returns true: nếu ngày trên bill trùng với ngày của thiết bị; false: nếu ngày trên bill khác với ngày của thiết bị
  */
 public isToday(date:any){
   let date_bill = new Date(date);
   date_bill.setHours(0);
   date_bill.setMinutes(0);
   date_bill.setSeconds(0);    
   date_bill.setMilliseconds(0);        
   let date_today = new Date();                  
   date_today.setHours(0);
   date_today.setMinutes(0);
   date_today.setSeconds(0);    
   date_today.setMilliseconds(0);        
   if(date_today.getTime() === date_bill.getTime()){
     return true;
   }else return false;     
   
 }

 /**
  * Hàm lấy thời điểm bắt đầu (00:00:00.000) của một ngày bất kỳ như sau
  * @param date 
  * @returns 
  */
public getStartOfDay(date: Date | string): Date {
  const d = new Date(date); // xử lý nếu đầu vào là chuỗi
  d.setHours(0, 0, 0, 0);
  return d;
}
 /**
  * Hàm lấy thời điểm kết thúc của một ngày bất kỳ (tức là 23:59:59.999)
  * @param date 
  * @returns 
  */
public getEndOfDay(date: Date | string): Date {
  const d = new Date(date); // xử lý nếu đầu vào là chuỗi
  d.setHours(23, 59, 59, 999);
  return d;
}

 
/**
 * @example SET:
 * localStorageSET('local_name', {a=1, b='hai'});
 * localStorageSET('local_name', 15000);
 * localStorageSET('local_name', 'muoi lam nghin dong');
 * @returns 
 */
  localStorageSET(name:string, value:any){      
    if(isPlatformBrowser(this.platformId)){
      if(typeof value === 'object') localStorage.setItem(name, JSON.stringify(value)); 
      else localStorage.setItem(name, value); 
    }
  }
  
  /**  
   * @example GET:
   * let object = localStorageGET('local_name');
   * @returns 
   */
  localStorageGET(name:string){
    if(!isPlatformBrowser(this.platformId)) return null;
    // let obj:any = localStorage.getItem(name);
    // return JSON.parse(obj);
    let str:any = localStorage.getItem(name)
    try {
      const obj = JSON.parse(str);
      return obj;
    } catch (e) {
      return str;
    }
  }

 /**
  * Hàm này so sanh sâu 2 object bằng nhau
  * @param object1 
  * @param object2 
  * @returns 
  */
   public deepObjectEqual(object1:any, object2:any) {
     const keys1 = Object.keys(object1);
     const keys2 = Object.keys(object2);
   
     if (keys1.length !== keys2.length) {
       return false;
     }
   
     for (const key of keys1) {
       const val1 = object1[key];
       const val2 = object2[key];
       const areObjects = this.isObject(val1) && this.isObject(val2);
    
       if (
         areObjects && !this.deepObjectEqual(val1, val2) ||
         !areObjects && val1 !== val2
       ) {
         return false;
       }
     }
   
     return true;
   }
   
   /**
    * Hàm này kiểm tra có phải là object không
    * @param object 
    * @returns 
    */
   public isObject(object:any) {
     return (object != null) && (object != null) && (typeof object === 'object');
   }
 
   /**
    * Hàm này tạo chuỗi số, ký tự ngẫy nhiên có chiều dài là length
    * @param length 
    * @returns 
    */
   public ObjectId(length?:number) {
     if((length===undefined)||(length === null)) length = 24;
     var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
     var randS = "";
     while(length > 0) {
         randS += chars.charAt(Math.floor(Math.random() * chars.length));
         length--;
     }
     return randS;
   }
 
  /** 
   * Đọc dữ liệu từ file excel và ghi vào mảng danh sách, dùng để hiển thị lên báo cáo hoặc lưu trữ
    * @example:
     <div class="col-md-8 form-group">        
       <input type="file" class="form-control" (change)="addfile($event)" placeholder="Upload file" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">        
     </div>     
     const file = event.target.files[0];
     this.vhAlgorithm.importXLSX(file)
         .then(obj=>{
           console.log('obj', obj);
         })    
    * @param file 
    * @return Promise (Array): import .xlsx/.xls/.csv file => arraylist
    */
   importXLSX(file: any){
     let csvfile = file || ''; 
     return new Promise((resolve, reject) => {  
       //Khởi tạo bộ đọc file excel tên là fileReader
       let fileReader = new FileReader();       
       fileReader.readAsArrayBuffer(file);     
       //thông qua bộ đọc fileReader, load tất cả dữ liệu từ file excel vào mảng arraylist (RAM)
       fileReader.onload = (e) => {    
           let arrayBuffer:any = fileReader.result;    
           let data = new Uint8Array(arrayBuffer);    
           let arr = new Array();    
           for(let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);    
           let bstr = arr.join("");    
           let workbook = XLSX.read(bstr, {type:"binary"});    
           let first_sheet_name = workbook.SheetNames[0];    
           let worksheet = workbook.Sheets[first_sheet_name];              
           let arraylist = XLSX.utils.sheet_to_json(worksheet,{raw:true});     
           //trả danh sách mảng dữ liệu lấy được từ file excel về cho người dùng   
           resolve(arraylist);
       }
     })
   }
 
   /**
    * @example:
    * this.vhAlgorithm.exportXLSX(arrayData, name).then(() => this.status = false).catch(err => this.status = false);
    * @param arrayData => format  [{field_a1: val_a1, field_a2: val_a2, field_a3: val_a3}
    *                              {field_b1: val_b1, field_b2: val_b2, field_b3: val_b3}
    *                              {field_c1: val_c1, field_c2: val_c2, field_c3: val_c3}]
    * @param excelFileName 
    * @return Promise => export .xlsx/.xls/.csv file
    */
   exportXLSX(arrayData: any, excelFileName: any) {
     return new Promise<any>((resolve, reject) => {
       // excel type
       const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
       const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(arrayData);
       const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
       const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
       //tạo blod to write file
       const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
       // download file
       //--------------------------------WEB---------------------------------//
       if (this.platform.is("desktop") || this.platform.is("mobileweb")) {
         var a = window.document.createElement("a");
         a.href = window.URL.createObjectURL(data);
         //console.log(a.href);
         a.download = `${excelFileName}.xlsx`;
         document.body.appendChild(a);
         a.click();
         document.body.removeChild(a);
         resolve(null);
       }     
       //--------------------------------MOBILE---------------------------------//
       else {
         this.file
           .writeFile(this.file.dataDirectory, `${excelFileName}.xlsx`, data, {
             replace: true
           })
           .then((res:any) => {
             this.socialSharing.share(`${excelFileName}.xlsx`, `${excelFileName}.xlsx`, res.nativeURL)
               .then(() => resolve(null))
               .catch((err) => {
                 console.error(err)
                 reject(err)
               });
           });
       }
       //--------------------------------MOBILE---------------------------------//
     })
   }
 
   /**
    * @example:
     const file = e.target.files[0];
     this.vhAlgorithm.importCSV(file)
         .then(obj=>{
           console.log('obj', obj);
         })    
    * @param file => import .csv file
    */
   importCSV(file: any){
     let csvfile = file || ''; 
     return new Promise((resolve, reject) => {   
       this.papa.parse(csvfile, {
         complete: (parsedData) => {
           let headerRow = parsedData.data.splice(0, 1)[0];
           let csvData = parsedData.data;
           resolve({headerRow: headerRow, csvData: csvData});
         }
       })
     })
   }
 
   /**
    * @example:
    * this.vhAlgorithmexportCSV(headerRow, csvData, 'data1');
    * @param headerRow 
    * @param csvData => export .csv file
    */
   exportCSV(headerRow: any, csvData: any, filename: any){
     let csv = this.papa.unparse({
       fields: headerRow,
       data: csvData
     });
     var blob = new Blob(["\uFEFF",csv]);
     var a = window.document.createElement('a');
     a.href = window.URL.createObjectURL(blob);
     a.download = filename + '.csv';
     document.body.appendChild(a);
     a.click();
     document.body.removeChild(a);
   }
 
   public waitingStack(){
     return new Promise((resolve, reject) => {       
       setTimeout(() => {
         resolve(null);
       }, 0);
     })
   }
   /*
    *vhAlgorithm
    * Hàm trả về mảng có đối tượng trong array_list thỏa điều kiện tìm kiếm
    * @param value : giá trị cần search
    * @param array_list : mảng các đối tượng
    * @param array_field : mảng các trường của đối tượng sẽ đc search
    * @returns Array
    */
   public searchList(value: any, array_list: any, array_field: any){    
     let data_seached = new Array();     
     data_seached = array_list.filter((arr:any) => {
       let check = false;
       for(let i=0; i<array_field.length; i++){
         if(arr[array_field[i]])
           check = check || this.changeAlias(arr[array_field[i]]["toString"]()["toLowerCase"]()).indexOf(this.changeAlias(value)) !==-1;//chỗ này sửa lại mà chưa test
         //Phần dưới này chỉ dùng cho sản phẩn của sales viethas, sau này hàm serchlist này có thể tách thành hàm riêng
         if(array_field[i] === 'barcode'){
           if(arr.units){
             for(let j=0; j<arr.units.length; j++){
               check = check || this.changeAlias(arr.units[j][array_field[i]]["toString"]()["toLowerCase"]()).indexOf(this.changeAlias(value)) !==-1;
             }
           }
           if(arr.lots){
             for(let j=0; j<arr.lots.length; j++){
               check = check || this.changeAlias(arr.lots[j][array_field[i]]["toString"]()["toLowerCase"]()).indexOf(this.changeAlias(value)) !==-1;
             }
           }
         }
       }
       if (check){
         return true;
       }else return false;
 
     });
     return data_seached; 
   }
 
   /**
    * Ham đổi chuỗi alias có dấu thành không dấu
    * @example:
    * this.vhAlgorithm.changeAlias(alias);
    * @alias: chuỗi có dấu và các ký tự đặc biệt
    * @return string
    */
   public changeAlias(alias:string) {
     let str = alias;
     //Đổi chuỗi có ký tự hoa thành chuỗi toàn ký tự thường
     str = str.toLowerCase();
     //Thay để các ký tự có dấu thành không dấu
     str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
     str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
     str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
     str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
     str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
     str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
     str = str.replace(/đ/g, "d");
     //Thay thế các ký tự đặc biệt thành khoảng trắng
     str = str.replace(
       /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
       " "
     );
     str = str.replace(/ + /g, " ");
     // bỏ khoảng trắng đầu và cuối chuỗi
     str = str.trim();
     return str;
   }

  /**
  * Ham đổi chuỗi alias có dấu thành không dấu, giữ lại ký tự đặc biệt
  * @example:
  * this.vhAlgorithm.changeAlias_withCharacter(alias);
  * @alias: chuỗi có dấu và các ký tự đặc biệt
  */
  public changeAlias_withCharacter(alias:any) {
    let str = alias;
    //Đổi chuỗi có ký tự hoa thành chuỗi toàn ký tự thường
    str = str.toLowerCase();
    //Thay để các ký tự có dấu thành không dấu
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    //Thay thế các ký tự đặc biệt thành khoảng trắng
    // str = str.replace(
    //   /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    //   " "
    // );
    //str = str.replace(/ + /g, " ");
    // bỏ khoảng trắng đầu và cuối chuỗi
    str = str.trim();
    return str;
  }

/**
 * Hàm trả về mảng gồm các phần tử là chuỗi con liên tiếp có m, m+1, m+2,... ký tự thỏa điều kiện m>-4 và m<=n
 * let keywords = this.vhAlgorithm.getSequentialSubstrings('+84909925354, 6); 
 */
  public getSequentialSubstrings(str:string, m:number) {
    const n = str.length;  
    // Kiểm tra điều kiện hợp lệ
    if (m < 4 || m > n) {
      return []; // Trả về mảng rỗng nếu m không hợp lệ
    }  
    const result = [];
    for (let i = m; i <= n; i++) {  
      for (let j = 0; j <= n - i; j++) {// Duyệt từ 0 đến n - m
        const substring = str.substring(j, j + i); // Lấy chuỗi con từ j đến j + i
        result.push(substring);
      }
    }
    return result;
  }

  /**
  * Hàm trả về số đt mã đã bỏ đi mã quốc gia (nếu có)
  * console.log(removeCountryCode("+84901234567", "+84"));     // "0901234567"
  * console.log(removeCountryCode("0084901234567", "+84"));    // "0901234567"
  * console.log(removeCountryCode("84901234567", "+84"));      // "0901234567"
  * console.log(removeCountryCode("0901234567", "+84"));       // "0901234567" (không đổi)
  * @example:
  * let phone = this.vhAlgorithm.removeCountryCode(phoneNumber, countryCode)
  */
  public removeCountryCode(phoneNumber:string, countryCode:string) {
    // Chuẩn hóa đầu vào: bỏ khoảng trắng, dấu gạch ngang...
    let phone = phoneNumber.replace(/\D/g, ""); // Chỉ giữ lại số  
    const cleanCode = countryCode.replace(/\D/g, ""); // Chuẩn hóa mã quốc gia  
    // Nếu bắt đầu bằng '00' + mã quốc gia
    if (phone.startsWith("00" + cleanCode)) {
      return phone.slice(("00" + cleanCode).length);
    }  
    // Nếu bắt đầu bằng mã quốc gia (không có '00')
    if (phone.startsWith(cleanCode)) {
      return phone.slice(cleanCode.length);
    }  
    // Nếu không có mã quốc gia thì trả về nguyên
    return phone;
  }

  /**
   * Kiểm tra 1 chuỗi str bất kỳ với tất cả các ký tự trong chuỗi đều phải là số
   * @example:
   * let bool = this.vhAlgorithm.isNumericString('123345083')
   * @param str 
   * @returns true/false
   */
  public isNumericString(str:string) {
    return /^\d+$/.test(str);
  }

  /**
   * Chuẩn hóa chuỗi str, nếu có nhiều hơn 1 khoảng trống liên tiếp thì chỉ giữ lại 1 khoảng trống, bỏ cả khoảng trống đầu và cuối chuỗi
   * @example:
   * str = this.vhAlgorithm.normalizeSpaces(str)
   * @param str 
   * @returns string
   */
  public normalizeSpaces(str:string) {
    return str.replace(/\s+/g, ' ').trim();
  }
/**
 * Hàm bỏ tất cả các ký tự trống trong chuỗi
 */
  public removeAllSpaces(str:string) {
    return str.replace(/\s+/g, '');
  }

  /**
   * Hàm trả ra tất cả chuỗi con liên tiếp từ 2 từ trở lên
   * @param str 
   * @returns array
   */
  public getWordSubstrings(str:string) {
    const words = str.trim().split(/\s+/); // Tách các từ, loại bỏ khoảng trắng thừa
    const result = [];
    //trả ra tất cả chuỗi con liên tiếp từ 2 từ trở lên
    for (let start = 0; start < words.length - 1; start++) {
      for (let end = start + 1; end < words.length; end++) {
        const phrase = words.slice(start, end + 1).join(' ');
        result.push(phrase);
      }
    }  
    return result;
  }
 
   /**
   * Hàm này lấy về 1 unit của sản phẩm theo ratio truyền vào
   * @example
   * let unit = this.vhAlgorithm.getUnit_byRatio(units, 1, 1); 
   * @param units
   * @param ratio
   * @param type 
   * type = 1 : unit của sản phẩm
   * type = 2 : unit của dịch vụ
   * type = 3 : unit của combo
   * type = 4 : unit của coupon
   * type = 5 : unit của voucher
   * type = 6 : unit của payment_card
   * @return Object => obj = {} hoặc null
   */
    public getUnit_byRatio(units:any, ratio:number, type?:number){
      for(let i=0; i<units.length; i++){
        if(units[i].ratio === ratio){
          return units[i];        
        }
      }
      let unit:any = {
        unit: '--',
        ratio: ratio,
        barcode: '',
        price: 0,
        price2: 0,
        price_import: 0
      }
      if(type === 4) unit = {default: true, points: 0, ratio: ratio, unit: '--', value: 0};
      if(type === 5) unit = {default: true, points: 0, price: 0, price_origin: 0,  ratio: ratio, unit: '--'};
      if(type === 6) unit = {default: true, points: 0, price: 0, price_origin: 0,  ratio: ratio, unit: '--'};
      return unit;
    }

    /**
   * Hàm này tạo chuỗi số, ký tự ngẫy nhiên có chiều dài là length
   * @param length: không truyền length vào mặc định chuỗi tạo ra có chiều dài 24
   * @returns 
   */
    public createObjectID(length?:number) {
      if((length===undefined)||(length === null)) length = 24;
      var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var randS = "";
      while(length > 0) {
          randS += chars.charAt(Math.floor(Math.random() * chars.length));
          length--;
      }
      return randS;
    }

  /**
   * Hàm này tạo chuỗi ký tự (ID) từ bí danh truyền vào (alias)
   * @param alias
   * @param length chiều dài chuỗi ký tự ID được tạo ra; ko truyền vào chiều dãi ID = chiều dài chuỗi alias
   * @returns 
   */
  public createObjectID_fromAlias(alias:string, length?:number){  
    let str = alias;  
      if(length){
        if(str.length >=length) str= str.slice(0, length);
      }
      str = str.toLowerCase();
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(
        ///\//g,
        //""
        /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
        ""
      );
      str = str.replace(/ + /g, " ");//gom 2 khoảng trắng thành 1 khoảng trắng
      str = str.replace(/ /g, "-"); // thay 1 khoảng trắng thành '-'
      str = str.trim();
      return str;    
  }
 /**
  * @example
     let bill_code = this.vhAlgorithm.createBillCode();
     console.log(bill_code);
  * @return String  -----> "3YU0409"
  */
   public createBillCode(billdate?:any):any{           
       let randomId = Math.random().toString(36).substr(2, 4);
       let date = billdate?new Date(billdate): new Date();
       //console.log('date', date);
       let soHD:any =    
         randomId 
         +      
         ((date.getMonth() + 1).toString().length == 1
           ? "0" + (date.getMonth() + 1).toString()
           : (date.getMonth() + 1).toString()) 
         +
         (date.getDate().toString().length == 1
           ? "0" + date.getDate().toString()
           : date.getDate().toString());
       //console.log('soHD.toUpperCase()', soHD.toUpperCase());     
       return soHD.toUpperCase();        
   } 
 
   /**
  * @example
     let payment_code = this.vhAlgorithmcreatePaymentCode();
     console.log(payment_code);
  * @return String  -----> "R3YU0409"
  */
   public createPaymentCode(paymentdate?:any):any{        
     let randomId = Math.random().toString(36).substr(2, 6);
     let date = paymentdate?new Date(paymentdate): new Date();
     //console.log('date', date);
     let soHD:any =    
       randomId 
       +      
       ((date.getMonth() + 1).toString().length == 1
         ? "0" + (date.getMonth() + 1).toString()
         : (date.getMonth() + 1).toString()) 
       +
       (date.getDate().toString().length == 1
         ? "0" + date.getDate().toString()
         : date.getDate().toString());
     //console.log('soHD.toUpperCase()', soHD.toUpperCase());     
     return soHD.toUpperCase();        
   }
 
    /**
  * @example
     let card_code = this.vhAlgorithmcreateCardCode();
     console.log(card_code);
  * @return String  -----> "1KR3YU0409"
  */
   public createCardCode(carddate?:any):any{        
     let randomId = Math.random().toString(36).substr(2, 6);
     let date = carddate?new Date(carddate): new Date();
     let soHD:any =    
       randomId 
       +      
       ((date.getMonth() + 1).toString().length == 1
         ? "0" + (date.getMonth() + 1).toString()
         : (date.getMonth() + 1).toString()) 
       +
       (date.getDate().toString().length == 1
         ? "0" + date.getDate().toString()
         : date.getDate().toString());
     //console.log('soHD.toUpperCase()', soHD.toUpperCase());     
     return soHD.toUpperCase();        
   }
  
   /**
    * @example:
    * 0 -> 0
    * 1 -> 1.0
    * 2 -> 2.00
    * 3 -> 3.000
    * @param money 
    */
   public vhcurrencyunit(money:any){
     let currencyFormat = localStorage.getItem('vhsales_currencyFormat');
     if (currencyFormat) {
       let digitDecimal = JSON.parse(String(currencyFormat)).digitDecimal.value;
       let digitFormat: any;
       if (digitDecimal === 0) digitFormat ='1.0-0';
       else if (digitDecimal === 1) digitFormat ='1.1-1';
       else if (digitDecimal === 2) digitFormat ='1.2-2';
       else if (digitDecimal === 3) digitFormat ='1.3-3';
       else if (digitDecimal === 4) digitFormat ='1.4-4';
       else if (digitDecimal === 5) digitFormat ='1.5-5';     
        
         return formatCurrency(
           money,
           'en-VI',
           getCurrencySymbol('', 'wide'),
           '',
           digitFormat, //a.b-c; a là lấy trước dấu chấm a số 0; c là khi thực hiện lấy c số; b là hiện thị ra b số;0.2-2
         );
     }else return money;    
   }
 
   public vhcurrencyunit_symbol(money:any){
     let currencyFormat = localStorage.getItem('vhsales_currencyFormat');
     if (currencyFormat) {
       let digitDecimal = JSON.parse(String(currencyFormat)).digitDecimal.value;
       let digitFormat: any;
       if (digitDecimal === 0) digitFormat ='1.0-0';
       else if (digitDecimal === 1) digitFormat ='1.1-1';
       else if (digitDecimal === 2) digitFormat ='1.2-2';
       else if (digitDecimal === 3) digitFormat ='1.3-3';
       else if (digitDecimal === 4) digitFormat ='1.4-4';
       else if (digitDecimal === 5) digitFormat ='1.5-5';     
 
       let symbol = JSON.parse(String(currencyFormat)).symbol.text;      
       let position = JSON.parse(String(currencyFormat)).position.value;     
       let prefix = '';
       let suffixes = '';
      
       if(position === 0) prefix = symbol + ' ';
       else if(position === 1) suffixes = ' ' + symbol;
       let regex = /\(([^)]+)\)/;
       let result_prefix = regex.exec(prefix); // lấy các giá trị trong ()
       if(result_prefix) prefix = result_prefix[1];
       let result_suffixes = regex.exec(suffixes); // lấy các giá trị trong ()
       if(result_suffixes) suffixes = result_suffixes[1];  
       
         return prefix + formatCurrency(
           money,
           'en-VI',
           getCurrencySymbol('', 'wide'),
           '',
           digitFormat, //a.b-c; a là lấy trước dấu chấm a số 0; c là khi thực hiện lấy c số; b là hiện thị ra b số;0.2-2
         ) + suffixes;
     }else return money;     
   }
 
   public vhpercent(number:any){    
     return formatPercent(
       number, 
       'en-VI',
       '1.2-2' 
       ); 
   } 
 /**
  * @example:
  * 123456.78 ->123456.78
  * 123456.78 ->123,456.78
  * 123456.78 ->12,3456.78
  * 123456.78 ->1,23,456.78
  * @param classname 
  */
   public vhnumeral(classname:any){    
     return new Cleave(classname, {
       numeral: true,
       numeralThousandsGroupStyle: "thousand" //"thousand" | "lakh" | "wan" | "none" 
     });
   }  
 
   public vhphoneNumber(classname:any){    
     return new Cleave(classname, {     
       phone: true,
       phoneRegionCode: 'VN'
     });
   }
 
   public vhYoutubeLink(value:any){        
       return this.dom.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + value);     
   }
 
  /**
  * @example
     array = this.sortVietnamesebyASC(array, 'name');
  * @return array
  */
   public sortVietnamesebyASC(array:any, field:any) {
     return array = array.sort((n1:any, n2:any) => {
       if (this.changeAlias(n1[field]) > this.changeAlias(n2[field])) return 1;
       return -1;
     });
   }
 
  /**
  * @example
     array = this.sortVietnamesebyDESC(array, 'name');
  * @return array
  */
   public sortVietnamesebyDESC(array:any, field:any) {
     return array = array.sort((n1:any, n2:any) => {
       if (this.changeAlias(n1[field]) < this.changeAlias(n2[field])) return 1;
       return -1;
     });
   }  
 
   public sortDatebyASC(array:any, field:any) {
     return array = array.sort((n1:any, n2:any) => {
       if((new Date(n1[field])).getTime() > (new Date(n2[field])).getTime()) return 1;
       return -1;
     });
   }
 
   public sortDatebyDESC(array:any, field:any) {
     return array = array.sort((n1:any, n2:any) => {
       if ((new Date(n1[field])).getTime() < (new Date(n2[field])).getTime()) return 1;
       return -1;
     });
   }
 
   public sortStringbyASC(array:any, field:any) {   
     return array = array.sort((n1:any, n2:any) => {
       if (n1[field].toUpperCase() > n2[field].toUpperCase()) return 1;
       return -1;
     });
   }
 
   public sortStringbyDESC(array:any, field:any) {   
     return array = array.sort((n1:any, n2:any) => {
       if (n1[field].toUpperCase() < n2[field].toUpperCase()) return 1;
       return -1;
     });
   }
 
   public sortNumberbyASC(array:any, field:any) {
     return array = array.sort((n1:any, n2:any) => {
       if (n1[field] > n2[field]) return 1;
       return -1;
     });
   }
 
   public sortNumberbyDESC(array:any, field:any) {
     return array = array.sort((n1:any, n2:any) => {
       if (n1[field] < n2[field]) return 1;
       return -1;
     });
   }
 
 
   
 
   
 
     /**
    * Hàm trả về số ngày trong tháng của một thời gian
    * @param year
    * @param month
    */
   public getNumberOfDaysInMonth(year: number, month: number) {
     switch (month) {
       case 1:
       case 3:
       case 5:
       case 7:
       case 8:
       case 10:
       case 12:
         return 31;
         break;
       case 2:
         if (year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)) {
           return 29;
           break;
         } else {
           return 28;
           break;
         }
       default:
         return 30;
     }
   }
   
 
   public Compare(field:any, condition:any, value:any){
     if (condition === '=='){
       return field == value? true: false;
     }else if(condition === '>'){
       return field > value? true: false;
     }else if(condition === '>='){
       return field >= value? true: false;
     }else if(condition === '<'){
       return field < value? true: false;
     }else if(condition === '<='){
       return field <= value? true: false;
     }else return false;
   }
 
   /**
    * Hàm đổi chuỗi sang object
   * @example: data = "{"field":1, "field2": "val"}";
   *  => data = {
   *               field1: 1,
   *               field2: "val",
   *            }
   * 
   * @param data 
   */
   public convert_STRING2OBJECT(string:any){   
     try {
       return JSON.parse(string);     
     }
     catch (e) {   
       return ({})    
     }                     
   }
 
   /**
    * Hàm đổi object sang chuỗi
   * @example: 
   *  data = {
   *            field1: 1,
   *            field2: "val",
   *         }
   * => data = "{"field":1, "field2": "val"}";
   * @param data 
   */
   public convert_OBJECT2STRING(obj:any){    
     if(typeof obj === 'object'){
       return JSON.stringify(obj);
     }else{
       return ('')    
     }                     
   }

   public formatDateToString(date:any) {
    if (!(date instanceof Date)) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  public roundTo3Decimals(value:any) {
    return Math.round(value * 1000) / 1000;
  }
 
 
 /**
  * @example
     let dotmoney = this.vhAlgorithm.changeMoneyToDotMoney(money:string, 20);
     console.log(dotmoney);
  * @return "1234567890"  -----> "1.234.567.890"
  */
   public changeMoneyToDotMoney(money:string, length:number){
     let str = money;
     for(let i=money.length; i>0; i--){
       if(i === (money.length - 3)) str = str.slice(0, i)  + '.' + str.slice(i);
       if(i === (money.length - 6)) str = str.slice(0, i)  + '.' + str.slice(i);
       if(i === (money.length - 9)) str = str.slice(0, i)  + '.' + str.slice(i);
       if(i === (money.length - 12)) str = str.slice(0, i)  + '.' + str.slice(i);
       if(i === (money.length - 15)) str = str.slice(0, i)  + '.' + str.slice(i);
     }
     str = str.slice(0, length);
     return str;
   }
 
 
 }
   
 @Injectable()
 export class VhForFirstTime { 
   constructor(
     private vhMGDB_auth:VhMGDB_auth, 
     private vhMGDB_database: VhMGDB_database, 
     private vhMGDB_f3rdclouds: VhMGDB_f3rdclouds, 
     private http: HttpClient,
     private vhAlgorithm: VhAlgorithm
     ) {
   } 
 
   public addAPPdatabase_forFirstTime(){
     return new Promise((resolve, reject) => {             
       if(this.vhMGDB_auth.getProjectName()==='vhsmhome'){
         resolve(null);          
       }else if((this.vhMGDB_auth.getProjectName()==='vhcloudcam')||(this.vhMGDB_auth.getProjectName()==='securitycam')||(this.vhMGDB_auth.getProjectName()==='bsecuritycam')){
         this.vhMGDB_f3rdclouds.createEUtokenFromUtoken()
             .then((response)=>{
               if(response.vcode ===0){
                 this.vhMGDB_f3rdclouds.saveEUtokenToDatabase(response.eutoken)
                     .then(()=>{                     
                       resolve(true);
                     }, error=>{
                       reject(error);
                     }) 
               }else{
                 resolve(false);
               }             
             }, error=>{
               reject(error);
             })        
       }else  if(this.vhMGDB_auth.getProjectName()==='vhcare'){
         resolve(null);     
       }else  if(this.vhMGDB_auth.getProjectName()==='vhclouds'){        
         resolve(null);                                  
       }else {
         console.log('Lưu ý, projectname này không khởi tạo giá trị: ', this.vhMGDB_auth.getProjectName());
         resolve(null);        
       }
     })
   }
 
   public addAPPdatabase_forFirstTime_Sales_Cafe(){
     return new Promise((resolve, reject) => {       
       if((this.vhMGDB_auth.getProjectName()==='vhsales')||(this.vhMGDB_auth.getProjectName()==='bvhsales')){          
         this.vhMGDB_database.getDocs('branchs')
             .then((branchs:any)=>{             
                if(branchs.length){
                  let promise:any = new Array();   
                  let id_branch = branchs[0]._id;
                  promise[0] = this.addSales_id_retail();       
                  promise[1] = this.addSales_tax(id_branch);
                  promise[2] = this.addSales_category_product(id_branch);       
                  promise[3] = this.addSales_supplier(id_branch);
                  promise[4] = this.addSales_customer(id_branch);      
                  promise[5] = this.addSales_wallet_Cash();   
                  promise[6] = this.addSales_incoming_group(id_branch);   
                  promise[7] = this.addSales_spending_group(id_branch);    
                  promise[8] = this.addSales_StoreInfo(id_branch);
                  promise[9] = this.addSales_wallet(id_branch); 

                  Promise.all(promise).then(()=>{          
                        resolve(null);                                  
                      },(error:any)=>{
                        resolve(error)
                      }) 
                }
              },(error:any)=>{
              console.log('error', error);
              })             
 
       }else if((this.vhMGDB_auth.getProjectName()==='vhcafe')||(this.vhMGDB_auth.getProjectName()==='bvhcafe')){
         this.vhMGDB_database.getDocs('branchs')
             .then((branchs:any)=>{             
                 if(branchs.length){
                   let promise:any = new Array();   
                   let id_branch = branchs[0]._id;
                   promise[0] = this.addSales_id_retail();//id_retail chỉ có ở frontend, ko tạo sẳn ở database       
                   promise[1] = this.addSales_tax(id_branch);
                   promise[2] = this.addCafe_category_product(id_branch);       
                   promise[3] = this.addSales_supplier(id_branch);
                   promise[4] = this.addSales_customer(id_branch);       
                   promise[5] = this.addSales_wallet_Cash(); //id_cash chỉ có ở frontend, ko tạo sẳn ở database    
                   promise[6] = this.addCafe_area_table_GoHome();  //id_go_home chỉ có ở frontend, ko tạo sẳn ở database 
                   promise[7] = this.addCafe_area_table(id_branch);                  
                   promise[8] = this.addSales_incoming_group(id_branch);   
                   promise[9] = this.addSales_spending_group(id_branch);     
                   promise[10] = this.addSales_StoreInfo(id_branch);
                   promise[11] = this.addSales_wallet(id_branch); 
 
                   Promise.all(promise).then(()=>{          
                         resolve(null);                                  
                       },(error:any)=>{
                         resolve(error)
                       }) 
                 }
               },(error:any)=>{
               console.log('error', error);
               })                                      
       }else {
         console.log('Lưu ý, projectname này không khởi tạo giá trị: ', this.vhMGDB_auth.getProjectName());
         resolve(null);        
       }
     })
   }

   /*
   this.vhMGDB_database.addDocbyID('customers', 'id_retail', {name: 'Retail customer', type:2})
           .then(()=>{
             resolve(null);
           }, error=>{
             reject(error);
           })                  
     })
   }
 
   private addSales_tax(id_branch:any){
     return new Promise((resolve, reject) => {
       let promise_1 = this.vhMGDB_database.addDoc('taxs', { name: 'VAT', value: 0, status: true, default: true, id_branch: id_branch});
   */

   public addAPPdatabase_forFirstTime_Sales365(main_sector:string){
    return new Promise((resolve, reject) => {       
      //console.log('id_main_sector', main_sector);
      if((this.vhMGDB_auth.getProjectName()==='vhsales')||(this.vhMGDB_auth.getProjectName()==='bvhsales')||(this.vhMGDB_auth.getProjectName()==='vhcafe')){          
        this.vhMGDB_database.getDocs('branchs')
            .then((branchs:any)=>{             
              if(branchs.length){
                this.http.get('assets/documents/configuration/generate-first-database/' + main_sector + '.json').subscribe({
                      next: (first_data: any) => {   
                        //console.log('first_data', first_data);      
                        //let language_code = JSON.parse(<any>localStorage.getItem(this.vhMGDB_auth.getProjectName() + '_' + 'language_code'));     
                        let language_code:any = localStorage.getItem(this.vhMGDB_auth.getProjectName() + '_' + 'language_code')
                        try {
                          language_code = JSON.parse(language_code);
                        } catch (e) {}   
                        if(first_data[language_code]) first_data = first_data[language_code];
                        else{
                          const firstField = Object.keys(first_data)[0];  // Lấy tên trường đầu tiên
                          first_data = first_data[firstField];      // Lấy giá trị của trường đầu tiên
                        }                         
                        //console.log('first_data1', first_data);      
                        let promise = new Array();       
                        for(let i=0; i<first_data.length; i++){
                          let colname = first_data[i]['colname'];
                          let datas = first_data[i]['datas'];    
                          for(let j=0; j<datas.length; j++){
                            datas[j].id_branch = branchs[0]._id;
                            if(datas[j].quantity !== undefined){
                              datas[j].quantity_branch = {};
                              datas[j].quantity_branch[branchs[0]._id] = datas[j].quantity
                            }
                            if(datas[j]?._id){
                              let _id = datas[j]._id;  
                              delete datas[j]._id;                             
                              promise[promise.length] = this.vhMGDB_database.addDocbyID(colname, _id, datas[j])
                            }else{
                              promise[promise.length] = this.vhMGDB_database.addDoc(colname, datas[j]);
                            }
                          }                          
                        }
                        Promise.all(promise)
                              .then(()=>{
                                //console.log('finished addAPPdatabase_forFirstTime_Sales365');  
                                resolve(null);         
                              })
                              .catch(e=>{
                                reject(e)
                              })
                      },
                      error: (error) => {
                        console.error('An error occurred:', error);
                        reject(error)
                      },
                      complete: () => {          
                      }
                    })
              }
            })
      }
    })
   }
   
   private addSales_id_retail(){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDocbyID('customers', 'id_retail', {name: 'Retail customer', type:2})
           .then(()=>{
             resolve(null);
           }, error=>{
             reject(error);
           })                  
     })
   }
 
   private addSales_tax(id_branch:any){
     return new Promise((resolve, reject) => {
       let promise_1 = this.vhMGDB_database.addDoc('taxs', { name: 'VAT', value: 0, status: true, default: true, id_branch: id_branch});
       let promise_2 = this.vhMGDB_database.addDoc('taxs', { name: 'VAT', value: 5, status: true, default: false, id_branch: id_branch});
       let promise_3 = this.vhMGDB_database.addDoc('taxs', { name: 'VAT', value: 10, status: true, default: false, id_branch: id_branch});    
       Promise.all([                                             
         promise_1,
         promise_2,
         promise_3                                             
       ]).then(()=>{          
               resolve(null);                                  
             },(error:any)=>{
               resolve(error)
             })                  
     })
   }
 
   private addSales_category_product(id_branch:any): Promise<any> {
     return new Promise((resolve, reject) => {
       let promise_1 = new Promise<any>((resolve, reject)=>{ 
         this.vhMGDB_database.addDoc('categorys', {name: 'Danh mục sản phẩm', type: 1, id_branch: id_branch})
             .then((category:any)=>{
               this.vhMGDB_database.addDoc('products',
                   {        
                     id_branch: id_branch,
                     id_category: category._id,
                     allow_sell:true,
                     selling:true,
                     manysize:false,
                     manylot:false,                    
                     brand: 'APPLE',
                     cost_stock_last: 0,
                     img: "./assets/img/default/iphone-12-pro-max-512gb.jpg",                   
                     name: 'Iphone 12 Pro Max 512Gb',                    
                     quantity: 0,
                     quantity_branch: {},                    
                     warning_number: 2,
                     item_code: '',
                     type: 1,
                     units:[{barcode: '0123456789', default: true, price: 20000000, price2: 19000000, price_import: 18000000, ratio:1, unit: 'Cái'}]
                   }).then(()=>{resolve(null)});  
             })  
         })
       let promise_2 = new Promise<any>((resolve, reject)=>{   
         this.vhMGDB_database.addDoc('categorys', {name: 'Danh mục dịch vụ', type: 2, id_branch: id_branch})
             .then((category:any)=>{
               this.vhMGDB_database.addDoc('products',
                   {        
                     id_branch: id_branch,
                     id_category: category._id,
                     allow_sell:true,
                     selling:true,                                
                     img: "./assets/img/default/bao-duong-ve-sinh-laptop.jpg",                        
                     //img: 'https://firebasestorage.googleapis.com/v0/b/bvhsales-94a3f.appspot.com/o/appdata%2Fthumbnail%2Fbao-duong-ve-sinh-laptop.jpg?alt=media&token=ac105127-b63b-445b-98f6-75726ceba17d',
                     name: 'Phí bảo dưỡng, vệ sinh laptop',                                          
                     type: 2,
                     units:[{barcode: '814881446640', default: true, price: 20000000, ratio:1, unit: 'Công'}]   
                 }).then(()=>{resolve(null)});  
             })  
         })
       let promise_3 = new Promise<any>((resolve, reject)=>{   
           this.vhMGDB_database.addDocbyID('categorys', 'id_category_combo', {name: 'Danh mục món kết hợp', type: 5, id_branch: id_branch})
               .then(()=>{
                 resolve(null);
               }, error=>{
                 reject(error);
               })   
           })  
       Promise.all([                                             
         promise_1,
         promise_2,
         promise_3                                             
       ]).then(()=>{          
               resolve(null);                                  
             },(error:any)=>{
               resolve(error)
             })                         
     })  
     
   }
 
   private addSales_supplier(id_branch:any): Promise<any> {
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('suppliers', 
           {
             id_branch: id_branch,
             address:'116/18 Thiên Phước, F9, Tân Bình',
             email:'viethas.info@gmail.com',
             name:'Công Ty TNHH GPCN VIETHAS',
             note:'không có',
             phone:'02838661111',
             taxcode:'312122525'
           })
           .then(()=>{
             resolve(null);
           }, error=>{
             reject(error);
           })                  
     })    
   }
 
   private addSales_customer(id_branch:any): Promise<any> {
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('customers', 
           {
             id_branch: id_branch,
             address:'115 đường TL8, phường Phú Mỹ',
             date: new Date(),
             datebirth: new Date(),
             debt_enable: true,
             district:'Củ chi',
             email:'vanminh@gmail.com',
             gender: 'Nam',
             type: 1,
             name:'Nguyễn Văn Minh',
             note:' ',
             phone:'0971606060',
             province:'Hồ chí minh',
             time_for_payment: 30
           })
           .then(()=>{
             resolve(null);
           }, error=>{
             reject(error);
           })                  
     })    
   }
 
   private addSales_wallet_Cash(){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDocbyID('wallets', 'id_cash', {name: 'Cash'})
           .then(()=>{
             resolve(null);
           }, error=>{
             reject(error);
           })                     
     })
   }
 
   private addSales_incoming_group(id_branch:any){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('incoming_groups', {name: 'Thu khác', default: true, id_branch: id_branch}) 
           .then(()=>{
             resolve(null);
           }, error=>{
             reject(error);
           })                         
     })
   }
 
   private addSales_spending_group(id_branch:any){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('spending_groups', {name: 'Chi khác', default: true, id_branch: id_branch}) 
           .then(()=>{
             resolve(null);
           }, error=>{
             reject(error);
           })                    
     })
   }
 
   private addSales_wallet(id_branch:string): Promise<any> {
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('wallets', 
           {
             address:'Hồ chí minh',
             bank_name:'Ngân Hàng Ngoại Thương',
             holder:'Trương Thị Thu Hương',
             name:'Vietcombank',
             note:'',
             number:'1940201041052',
             id_branch: id_branch
           })
           .then(()=>{
             resolve(null);
           }, error=>{
             reject(error);
           })                  
     })    
   }
 
   /**
    * Hàm này khởi tạo tạm ở đây, vài bữa cho khởi tạo lúc tạo tài khoản
    * @returns 
    */
   /*private addSales_branch(): Promise<any> {    
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('branchs', 
           {
             name:'Chi nhánh 1',
             address: this.vhMGDB_auth.getUser().address,
             countrycode: this.vhMGDB_auth.getUser().countrycode,
             phone: this.vhMGDB_auth.getUser().phone,
             email: this.vhMGDB_auth.getUser().email,
             company: this.vhMGDB_auth.getUser().company,
             active: true           
           })
           .then((branch:any)=>{                 
             let promise_1 = this.addSales_StoreInfo(branch._id);
             let promise_2 = this.addSales_wallet(branch._id);
             Promise.all([promise_1, promise_2]).then(()=>{resolve(null)});
           }, error=>{            
             reject(error);
           })                  
     })    
   }*/
 
   /*private addCafe_branch(): Promise<any> {    
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('branchs', 
           {
             name:'Chi nhánh 1',
             address: this.vhMGDB_auth.getUser().address,
             countrycode: this.vhMGDB_auth.getUser().countrycode,
             phone: this.vhMGDB_auth.getUser().phone,
             email: this.vhMGDB_auth.getUser().email,
             company: this.vhMGDB_auth.getUser().company,
             active: true           
           })
           .then((branch:any)=>{                 
             let promise_1 = this.addSales_StoreInfo(branch._id);
             let promise_2 = this.addSales_wallet(branch._id);
             let promise_3 = this.addCafe_area_table(branch._id);
             Promise.all([promise_1, promise_2, promise_3]).then(()=>{resolve(null)});
           }, error=>{            
             reject(error);
           })                  
     })    
   }*/
 
   
   private addSales_StoreInfo(id_branch:any){
     return new Promise((resolve, reject) => {
       let stores = this.vhMGDB_auth.getStore();
       let obj:any = {
         name: stores.name,
         phone: stores.phone,
         countrycode: stores?.countrycode,
         address: stores.address,
         company: stores.company,
         email: stores.email,
         tax_number:'',
         opentime:'8h:00 AM',
         closetime:'10h:00 PM',
         img:''
       };
       obj.appsetting_name = 'store_info';
       obj.id_branch = id_branch;     
       this.vhMGDB_database.addDoc('appsettingbranchs',obj)
           .then(()=>{
             resolve(null);
           }, error=>{
             reject(error)
           }) 
     })
   }
 
   private addCafe_category_product(id_branch:any): Promise<any> {
     return new Promise((resolve, reject) => {
       let promise = new Array();
       promise[0] = new Promise<any>((resolve, reject)=>{ 
         this.vhMGDB_database.addDoc('categorys', {name: 'Danh mục nước pha chế', type: 1, id_branch: id_branch})
             .then((category:any)=>{
               this.vhMGDB_database.addDoc('products',
                   {  
                     id_branch: id_branch,
                     id_category: category._id,
                     allow_sell:true,
                     manysize: false,
                     describe:"",                                          
                     img:"./assets/img/default/ca-phe-sua-da.jpg",
                     name:"Cà phê sửa đá",
                     type: 1,               
                     time_warning: 5,                    
                     units:[{barcode: '0123456781', default: true, price: 150000, price2: 0, ratio:1, unit: 'Ly'}]                
                   }).then(()=>{
                     resolve(null)                                               
                   },(error:any)=>{
                     reject(error)
                   })                  
             },(error:any)=>{
               reject(error)
             })  
         })
       promise[1] = new Promise<any>((resolve, reject)=>{ 
         this.vhMGDB_database.addDoc('categorys', {name: 'Danh mục món ăn', type: 1, id_branch: id_branch})
             .then((category:any)=>{
               this.vhMGDB_database.addDoc('products',
                   {  
                     id_branch: id_branch, //dùng trong trường hợp chi nhánh nào tải về sản phẩm của chi nhánh đó
                     id_category: category._id,                    
                     describe:"",                                          
                     img:"./assets/img/default/com-chien-hai-san.jpg",
                     manysize: true,
                     name:"Cơm chiên hải sản",                               
                     time_warning: 15,
                     type: 1    
                   }).then((product:any)=>{
                     this.vhMGDB_database.addDoc('products',
                       {        
                         allow_sell:true,
                         id_branch: id_branch,                       
                         id_subs_group: product._id,    
                         name:"Size nhỏ",                        
                         selling:true,                               
                         units:[{barcode: '0123456781', default: true, price: 150000, price2: 0, ratio:1, unit: 'Dĩa'}]     
                     }).then(()=>{resolve(null)});  
                     this.vhMGDB_database.addDoc('products',
                       {        
                         allow_sell:true,
                         id_branch: id_branch,                       
                         id_subs_group: product._id,    
                         name:"Size lớn",                        
                         selling:true,                               
                         units:[{barcode: '0123456782', default: true, price: 150000, price2: 0, ratio:1, unit: 'Dĩa'}]     
                     }).then(()=>{resolve(null)}); 
                                               
                   },(error:any)=>{
                     reject(error)
                   })   
             },(error:any)=>{
               reject(error)
             })  
 
         })
       promise[2] = new Promise<any>((resolve, reject)=>{   
         this.vhMGDB_database.addDoc('categorys', {name: 'Danh mục dịch vụ', type: 2, id_branch: id_branch})
             .then((category:any)=>{
               this.vhMGDB_database.addDoc('products',
                   {        
                     id_branch: id_branch,
                     id_category: category._id,   
                     allow_sell: true,                                                             
                     img:"./assets/img/default/phong-vip.jpg",
                     name:"Phòng VIP",                               
                     type: 2,                       
                     units:[{barcode: '814881446640', default: true, price: 100000, ratio:1, unit: 'Giờ'}]                   
                 }).then(()=>{
                   resolve(null);          
                 });  
             })  
         }) 
       promise[3] = new Promise<any>((resolve, reject)=>{         
         this.vhMGDB_database.addDoc('categorys', {name: 'Danh mục nước đóng sẳn', type: 3, id_branch: id_branch})
             .then((category:any)=>{
               this.vhMGDB_database.addDoc('products',
                   {  
                     id_branch: id_branch,
                     id_category: category._id,     
                     allow_sell:true,
                     selling:true,
                     manysize:false,
                     maylot:false,
                     brand: "CocaCola",                   
                     describe:"",                                          
                     img:"./assets/img/default/coca-cola.jpg",
                     name:"Coca cola",                        
                     type: 3,                       
                     time_warning: 10,
                     warning_number: 5,
                     item_code: '',
                     quantity: 0,
                     quantity_branch: {},
                     units:[{barcode: '0123456789', default: true, price: 20000, price2: 25000, price_import: 10000, ratio:1, unit: 'Lon'}]                
                   }).then(()=>{
                     resolve(null)                                               
                   },(error:any)=>{
                     reject(error)
                   })                  
             },(error:any)=>{
               reject(error)
             })  
         })
       
       promise[4] = new Promise<any>((resolve, reject)=>{   
         this.vhMGDB_database.addDoc('categorys', {name: 'Danh mục nguyên liệu', type: 3, id_branch: id_branch})
             .then((category:any)=>{
               this.vhMGDB_database.addDoc('products',
                   {        
                     id_branch: id_branch,
                     id_category: category._id,    
                     allow_sell:false,
                     selling:false,
                     manysize:false,
                     maylot:false,
                     brand: "Bé Bầu",                   
                     describe:"",                                                                      
                     img:"./assets/img/default/nuoc-mam-nam-ngu-750ml.jpg",
                     name:"Nước mắm 750ml",                     
                     type: 3,                      
                     warning_number: 5,
                     item_code: '',
                     quantity: 0,
                     quantity_branch: {},
                     units:[{barcode: '0123456789', default: true, price: 50000, price2: 60000, price_import: 4000, ratio:1, unit: 'Chai'}]     
                 }).then(()=>{resolve(null)});  
             })  
         })
       promise[5] = new Promise<any>((resolve, reject)=>{   
         this.vhMGDB_database.addDocbyID('categorys', 'id_category_topping', {name: 'Danh mục món bán kèm', type: 4, id_branch: id_branch})
             .then(()=>{
               resolve(null);
             }, error=>{
               reject(error);
             })   
         }) 
       promise[6] = new Promise<any>((resolve, reject)=>{   
         this.vhMGDB_database.addDocbyID('categorys', 'id_category_combo', {name: 'Danh mục món kết hợp', type: 5, id_branch: id_branch})
             .then(()=>{
               resolve(null);
             }, error=>{
               reject(error);
             })   
         })            
       Promise.all(promise)
             .then(()=>{          
               resolve(null);                                  
             },(error:any)=>{
               resolve(error)
             })                         
     })  
     
   }
 
   private addCafe_area_table_GoHome(){
     return new Promise((resolve, reject) => {
       let promise = new Array();
       promise[promise.length] = this.vhMGDB_database.addDocbyID('areas', 'go_home', {name: 'Take away', status: true});        
       promise[promise.length] = this.vhMGDB_database.addDocbyID('tables', 'go_home', {id_area: 'go_home', name: 'Take away', status: true});        
       Promise.all(promise).then(()=>{          
             resolve(true);                                  
           },(error:any)=>{
             reject(error)
           })      
     })
   }
 
   private addCafe_area_table(id_branch:string){
     return new Promise((resolve, reject) => {   
       let promise_zero = new Array(); 
       promise_zero[promise_zero.length] = new Promise<any>((resolve, reject)=>{ 
         this.vhMGDB_database.addDoc('areas', {name: 'Khu vực A', status: true, id_branch: id_branch})
             .then((area:any)=>{
               let promise_one = new Array();
               promise_one[promise_one.length] = this.vhMGDB_database.addDoc('tables',{id_area: area._id, name: 'Bàn A1', status: false, id_branch: id_branch});                     
               promise_one[promise_one.length] = this.vhMGDB_database.addDoc('tables',{id_area: area._id, name: 'Bàn A2', status: false, id_branch: id_branch});
               Promise.all(promise_one).then(()=>{          
                       resolve(true);                                  
                     },(error:any)=>{
                       reject(error)
                     })   
               })  
       })
       promise_zero[promise_zero.length] = new Promise<any>((resolve, reject)=>{ 
         this.vhMGDB_database.addDoc('areas', {name: 'Khu vực B', status: true, id_branch: id_branch})
             .then((area:any)=>{
               let promise_two = new Array();
               promise_two[promise_two.length] = this.vhMGDB_database.addDoc('tables',{id_area: area._id, name: 'Bàn B1', status: false, id_branch: id_branch});                     
               promise_two[promise_two.length] = this.vhMGDB_database.addDoc('tables',{id_area: area._id, name: 'Bàn B2', status: false, id_branch: id_branch});
               Promise.all(promise_two).then(()=>{          
                       resolve(true);                                  
                     },(error:any)=>{
                       reject(error)
                     })   
               })  
       })
       Promise.all(promise_zero).then(()=>{          
               resolve(true);                                  
             },(error:any)=>{
               reject(error)
             }) 
     })
   } 
 }

 @Injectable()
 export class VhOTP { 
  constructor(
    private platform: Platform,
    private vhFB_OTP:VhFB_OTP, 
  ){
  }

  /**
   * Khởi động, kết nối vào Server đang chạy dịch vụ OTP
   * @example:
   * this.vhOTP.initializeProject('Youtube');  
   * @param projectname: tên dự án được đăng ký trước đó trên firebase, xác thực OTP sẽ đc chạy trên dự án này 
   * @returns 
   */
  public initializeProject(projectname:string){    
    return this.vhFB_OTP.initializeProject(projectname);
  }

  /**
   * QUY TRÌNH KHÁCH GỬI YÊU CẦU XÁC THỰC QUA OTP
   * 1. Khách điện đầy đủ thông tin vào FORM mẫu, sau đó nhấn nút "Submit" để gửi đi
   * 2. FORM sẽ kiểm tra tính đúng đắn các trường dữ liệu khách nhập vào, nếu sai phản hồi để khách nhập lại
   * 3. FORM gọi hàm initReCaptchaVerifier để yêu cầu server gửi mã otp đến số điện thoại của mình; 
   * 4. Nếu server trả về vcode 1 thì số đt bị sai, 
   * 5. FORM yêu cầu người dùng nhập lại;
   * 6. Nếu server trả về vcode 0 thì server đã gửi mã otp cho số điện thoại trên
   * 7. FORM sẽ gọi 1 FORM khác để cho khách nhập mã opt vào, sau đó chạy hàm verificationOTP
   * 8. Nếu server trả về false thì mã otp nhập sai; Nếu server trả về true thì mã otp nhập đúng, lúc đó gửi yêu cầu của khách lên server để lưu lại
   * Initialize the reCAPTCHA verifier.
   * @example:
   * this.vhOTP.initReCaptchaVerifier(phoneNumber)
            .then((rsp)=>{                                 
              if(rsp.vcode==0){
                //Gọi hộp thoại nhập mã OTP đã gửi đến điện thoại   
              }else{
                //thông báo người dùng đã nhập sai số điện thoại
              }       
            },error=>{
                 
            });
   * @param phoneNumber
   * @return Promise => rsp = {vcode, message}
   * vcode = 0: 'Please enter the verification code that was sent to your mobile device'
   * vcode = 1: 'The format of the phone number provided is incorrect'
   */
  public initReCaptchaVerifier(phoneNumber:any){
    console.log('phoneNumber', phoneNumber)
    let os = 'web/android'; 
    //if (this.platform.is('ios') || this.platform.is('ipad') || this.platform.is('iphone')) os = 'ios';
    if (this.platform.is('desktop') || this.platform.is('pwa') || this.platform.is('cordova') || this.platform.is('capacitor') || this.platform.is('electron')
         || this.platform.is('mobileweb'))  os = 'web';
    return this.vhFB_OTP.initReCaptchaVerifier(os, phoneNumber);
  }

  /**
   * @example:
   * this.vhOTP.verificationOTP(verificationCode)
            .then((bool)=>{                                 
              if(bool){
                console.log('verificationOTP', bool);        
              }else{
                //thông báo người dùng đã nhập sai mã otp
              }       
            },error=>{
                 
            });
   * @param verificationCode: mã otp được viethas gửi đến số điện thoại của bạn 
   * @returns Promise => owner = true: mã verificationCode nhập vào đúng;  owner = null: mã verificationCode nhập vào sai;
   */
  public verificationOTP(verificationCode:string){
    let os = 'web/android'; 
    //if (this.platform.is('ios') || this.platform.is('ipad') || this.platform.is('iphone')) os = 'ios';
    if (this.platform.is('desktop') || this.platform.is('pwa') || this.platform.is('cordova') || this.platform.is('capacitor') || this.platform.is('electron')
         || this.platform.is('mobileweb'))  os = 'web';
    return this.vhFB_OTP.verificationOTP(os, verificationCode);
  }
 }

 @Injectable()
 export class VhAuth {  
   private mypermission: any = {};
   private employees: any = new Array(); 
   private endusers: any = new Array(); 
   private appsetting_stations: any = new Array();
   private hwinfo: any = {};
   private renderer: Renderer2;  
   private subjectemployees = new Subject<any>();
 
   constructor(
     private platform: Platform,
     private vhMGDB_rootdatabase: VhMGDB_rootdatabase,     
     private vhMGDB_auth:VhMGDB_auth, 
     private vhMGDB_database: VhMGDB_database,
     private vhForFirstTime:VhForFirstTime, 
     private renderFactory: RendererFactory2,
     @Inject(PLATFORM_ID) private platformId: Object
    ){
     Device.getId().then((info:any)=>{
       let local_hwinfo = this.localStorageGET('hwinfo');
       if((local_hwinfo != null)&&(local_hwinfo != undefined)){
         this.hwinfo = local_hwinfo;       
       }else{
        this.hwinfo = {uuid: info.identifier};     
         this.localStorageSET('hwinfo',this.hwinfo);        
       }           
     });     
     this.renderer = this.renderFactory.createRenderer(null, null);
   } 




   /**
   * Hàm lấy thông tin thiết bị đang dùng phần mềm: ngôn ngữ, nước nào, vị trí địa lý, IP....
   * @example:
   * this.vhAuth.getDVinfo()
        	.then((str)=>{
          }, error=>{
            console.log(error)
          })
   * @returns Promise => rsp =string / error
   */
  public getDVinfo(){
    return new Promise((resolve, reject) => {  
      axios.get('https://mienphi.viethas.com/getdvinfo') //tương đương https://giatot.sales365.vn/getdvinfo
          .then((response:any)=> {                        
            resolve(response.data);
          })
          .catch((e:any)=> {                          
            reject(e.response.data);
          });
    })
  }

  /**
   * Hàm lấy thông tin banner muốn hiển thị ở giao diện đầu tiên của phần mềm (giao diện signin)
   * @example:
   * this.vhAuth.getViethasPOS_Banner_Signin()
        	.then((str)=>{
          }, error=>{
            console.log(error)
          })
   * @returns Promise => rsp =string / error
   */
  public getViethasPOS_Banner_Signin(){
    return new Promise((resolve, reject) => {  
      axios.get('https://mienphi.viethas.com/viethaspos_banner_signin') //tương đương https://giatot.sales365.vn/viethaspos_banner_signin
          .then((response:any)=> {                        
            resolve(response.data);
          })
          .catch((e:any)=> {                          
            reject(e.response.data);
          });
    })
  }
   
 
/**
  * Nếu paymentIOS == true : cho phép hiển thị các chức năng liên quan đến thanh toán trên iphone, ipad. Ngược lại thì ko
  * lưu ý: hàm này chỉ dùng cho iphone và ipad
  * @example:
  * this.vhAuth.checkPaymentIOS()
        .then((bool:any)=>{                     
          console.log('bool', bool);
        },(error:any)=>{
          console.log('error', error);
        })
  * @returns Promise => boolean
  */
  public checkPaymentIOS(){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_auth.checkPaymentIOS()                    
          .then((bool:any)=>{  
            resolve(bool);
          },(error:any)=>{
            reject(error)
          })
    })
  }

    /**
  * @example:
  * this.vhAuth.checkPaymentIOS2()
        .then((bool:any)=>{                     
          console.log('bool', bool);
        },(error:any)=>{
          console.log('error', error);
        })
  * @returns Promise => boolean
  */
  public checkPaymentIOS2(){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_auth.checkPaymentIOS2()                    
          .then((bool:any)=>{  
            resolve(bool);
          },(error:any)=>{
            reject(error)
          })
    })
  }

    /**
  * @example:
  * this.vhAuth.checkPaymentIOS3()
        .then((bool:any)=>{                     
          console.log('bool', bool);
        },(error:any)=>{
          console.log('error', error);
        })
  * @returns Promise => boolean
  */
  public checkPaymentIOS3(){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_auth.checkPaymentIOS3()                    
          .then((bool:any)=>{  
            resolve(bool);
          },(error:any)=>{
            reject(error)
          })
    })
  }
  
  
/**
  * @example:
  * let data = {   
      created_at: new Date(),    
      suggestion: "Lỗi đăng xuất",
      img:"",
      id_store: "5fb6780ca2148e09806c5b01"
  }
  * this.vhAuth.createSuggestion(data)
          .then((suggestion)=>{
            console.log('createSuggestion', suggestion);
          },(error:any)=>{
            console.log('error', error);
          })     
    * @param data : object 
    * @return  Promise => suggestion = {} / error
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
    public createSuggestion(data:any){    
      return new Promise((resolve, reject) => {
        if(!this.vhMGDB_auth.getStore()._id) reject('bạn chưa đăng nhập');     
        this.vhMGDB_rootdatabase.addDoc('suggestions', data)
            .then((suggestion)=>{
              resolve(suggestion);
            },(error:any)=>{
              reject(error);
            })         
      })
    }

  /**
   * @example:
   * this.vhAuth.getSuggestion('5fb67fda87c0f21d484cbdf3')
        .then((suggestion)=>{
          console.log('getSuggestion', suggestion);
        })
    *  @param id_suggestion 
    *  @return Promise => suggestion ={} or null / error
    */
  public getSuggestion(id_suggestion:any) {
    return new Promise((resolve, reject) => { 
      if(!this.vhMGDB_auth.getStore()._id) reject('bạn chưa đăng nhập');     
      this.vhMGDB_rootdatabase.getDoc('suggestions', id_suggestion)
          .then((response:any) => {              
              resolve(response);
            },
            (error:any) => {
              reject(error);
            }) 
    })
  }   
    
/**
 * @example:
 * this.vhAuth.updateSuggestion('5fb6780ca2148e09806c5b01', {feedback: "đã xử lý" })
        .then((response)=>{
          console.log('updateSuggestion', response);
        }, error=>{
          console.log('error', error);
        })
  * @param id_suggestion 
  * @param value 
  * @return Promise => response = undefined / error
  */
  public updateSuggestion(id_suggestion:string, value:any){        
    return new Promise((resolve, reject) => {  
      value.updated_at = new Date();
      if(!this.vhMGDB_auth.getStore()._id) reject('bạn chưa đăng nhập');     
      this.vhMGDB_rootdatabase.updateDoc('suggestions', id_suggestion, value)
        .then((response)=>{
          resolve(response);       
        }, error=>{
          reject(error);  
        })     
    })
  }  

  /**
   * @example:
   * this.vhAuth.deleteSuggestion('5fb67fda87c0f21d484cbdf3')
        .then((response)=>{
          console.log('deleteSuggestion', response);
        }, error=>{
          console.log(error, error);
        }) 
    * @param id_suggestion 
    * @return Promise => response = undefined / error
    */
  public deleteSuggestion(id_suggestion:any){
    return new Promise((resolve, reject) => {
      if(!this.vhMGDB_auth.getStore()._id) reject('bạn chưa đăng nhập');     
      this.vhMGDB_rootdatabase.deleteDoc('suggestions', id_suggestion)
          .then((response)=>{
            resolve(response);          
          }, error=>{
            console.log(error, error);
          })              
    })
  }

    /**
  * @example:
  * let time = new Date();
  * time.setDate(time.getDate()-7);
  * this.vhAuth.getSuggestion_byFields({payment_type:{$eq:5}}, {},{},0)
        .then((suggestions)=>{
          console.log('getSuggestion_byFields', suggestions);
        })
  * @param query
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
  public getSuggestion_byFields(query: any, projection?:object, sort?:object, limit?:number) {
    return new Promise((resolve, reject) => {       
      if(!this.vhMGDB_auth.getStore()._id) reject('bạn chưa đăng nhập');     
      this.vhMGDB_rootdatabase.getDocsByFields('suggestions', query, {}, sort, limit)
          .then((suggestions)=>{
            resolve(suggestions);
          }, error=>{
            console.log(error, error);
          })       
    })
  } 

 
     /**
    * @example:
    *   this.vhAuth.signInWithEmailAndPasswordOfEndUser('emp11@gmail.com', '123456')
         .then((res)=>{
           console.log('res', res);
         },(error:any)=>{
           console.log('error', error);          
         })
    * @param email 
    * @param password 
    */
     public signInWithEmailAndPasswordOfEndUser(email:string, password:string){
       return new Promise((resolve, reject) => { 
         this.vhMGDB_auth.signInWithEmailAndPasswordOfEndUser(email, password)
             .then((res)=>{
               resolve(res);
             },(error:any)=>{
               reject(error);
             })
       })
     }
 
       /**
    * @example:
    * this.vhAuth.onAuthStateChangedOfEndUser()
           .then((user)=>{
             console.log('onAuthStateChanged', user);
           },(error:any)=>{
             console.log('onAuthStateChanged', error);
           })  
     * @return Promise => user = {}       
     */
   public onAuthStateChangedOfEndUser(){
     return new Promise((resolve, reject) => { 
       this.vhMGDB_auth.onAuthStateChangedOfEndUser()
           .then((res)=>{
             resolve(res);
           },(error:any)=>{
             reject(error);
           })
     })
   }
  
   /**
    * @example:
    *   this.vhAuth.signInWithEmailAndPassword('emp11@gmail.com', '123456')
         .then((user)=>{
           console.log('user', user);
         },(error:any)=>{
           console.log('error', error);          
         })
    * @param email 
    * @param password 
    * @return Promise => user = {}     
    */
   public signInWithEmailAndPassword(email:string, password:string){    
     return new Promise((resolve, reject) => { 
       this.vhMGDB_auth.signInWithEmailAndPassword(email, password)
           .then((res)=>{
             resolve(res);
           },(error:any)=>{
             reject(error);
           })
     })
   }
 
 /**
  * @example:
  * this.vhAuth.onAuthStateChanged()
         .then((user)=>{
           console.log('onAuthStateChanged', user);
         },(error:any)=>{
           console.log('onAuthStateChanged', error);
         })  
   * @return Promise => user = {}       
   */
   public onAuthStateChanged(){    
     return new Promise((resolve, reject) => { 
       this.vhMGDB_auth.onAuthStateChanged()
           .then((res)=>{
             resolve(res);
           },(error:any)=>{
             reject(error);
           })
     })
   }
 
   /**
    * Hàm này dành cho Designer đăng ký
    * @example:
    * this.vhAuth.signUpOwner_AutoWeb_Designer('huyleduc92@gmail.com', 'Vh123456', '+84909925359',{})
        .then((rsp:any)=>{  
          if(rsp.vcode === 0){
           let owner = rsp.data;
          }else if(rsp.vcode === 1){
            //thông báo trùng số đt                            
          }else if(rsp.vcode === 2){
            //thông báo trùng email               
          }else if(rsp.vcode === 3){
            //thông báo số điện thoại sai định dạng           
          }
        })     
    * @param email 
    * @param pwd: password  
    * @param phoneNumber 
    * @param info 
    * @return Promise object => rsp = {vcode, message}
    * vcode === 0: phoneNumber, email trước  đây chưa ký trên hệ thông nên bây giờ có thể dùng để đăng ký
    * mã opt gửi về điện thoại người dùng
    * vcode === 1: Hiện thị ra thông báo cho người dùng biết rằng số điện thoại của họ đã được đăng ký sử dụng trước đây, nên giờ ko dùng đc nữa, phải dùng số đt khác
    * vcode === 2: Hiện thị ra thông báo cho người dùng biết rằng email của họ đã được đăng ký sử dụng trước đây, nên giờ ko dùng đc nữa, phải dùng email khác
    * vcode === 3: Hiện thị ra thông báo cho người dùng biết rằng số điện thoại của họ nhập vào không đúng với định dạng của nhà mạng
    * @notice : nhớ kiểm tra email đúng cú pháp và chuỗi trước @gmail.com có chiều dài lớn hơn bằng 6 thì nút "Đồng ý" mới sáng lên
    */
   public signUpOwner_AutoWeb_Designer(email:string, pwd:string, phoneNumber: string, info:object){      
     return new Promise((resolve, reject) => {     
      if(this.getDBstorage() === 'firebase'){  
        this.vhMGDB_auth.signUpOwner_AutoWeb(email, pwd, phoneNumber, info)
            .then((owner:any)=>{                  
              resolve(owner);                                                                               
            },(error:any)=>{            
              reject(error);
            })   
      }else  if(this.getDBstorage() === 'mongo'){
        this.vhMGDB_auth.signUpOwner_AutoWeb_Mongo_Designer(email, pwd, phoneNumber, info)
            .then((owner:any)=>{                  
              resolve(owner);                                                                       
            },(error:any)=>{            
              reject(error);
            })     
      }                   
     }) 
   }


      /**
    * Hàm này dành cho Developer đăng ký
    * @example:
    * this.vhAuth.signUpOwner_AutoWeb_Developer('huyleduc92@gmail.com', 'Vh123456', '+84909925359',{})
        .then((rsp:any)=>{  
          if(rsp.vcode === 0){
           let owner = rsp.data;
          }else if(rsp.vcode === 1){
            //thông báo trùng số đt                            
          }else if(rsp.vcode === 2){
            //thông báo trùng email               
          }else if(rsp.vcode === 3){
            //thông báo số điện thoại sai định dạng           
          }
        })     
    * @param email 
    * @param pwd: password  
    * @param phoneNumber 
    * @param info 
    * @return Promise object => rsp = {vcode, message}
    * vcode === 0: phoneNumber, email trước  đây chưa ký trên hệ thông nên bây giờ có thể dùng để đăng ký
    * mã opt gửi về điện thoại người dùng
    * vcode === 1: Hiện thị ra thông báo cho người dùng biết rằng số điện thoại của họ đã được đăng ký sử dụng trước đây, nên giờ ko dùng đc nữa, phải dùng số đt khác
    * vcode === 2: Hiện thị ra thông báo cho người dùng biết rằng email của họ đã được đăng ký sử dụng trước đây, nên giờ ko dùng đc nữa, phải dùng email khác
    * vcode === 3: Hiện thị ra thông báo cho người dùng biết rằng số điện thoại của họ nhập vào không đúng với định dạng của nhà mạng
    * @notice : nhớ kiểm tra email đúng cú pháp và chuỗi trước @gmail.com có chiều dài lớn hơn bằng 6 thì nút "Đồng ý" mới sáng lên
    */
   public signUpOwner_AutoWeb_Developer(email:string, password:string, phoneNumber: string, info:any){      
    return new Promise((resolve, reject) => {       
      info.isDeveloper = true;
      if(this.getDBstorage() === 'mongo'){  
        this.vhMGDB_auth.signUpOwner_AutoWeb_Mongo_Developer(email, password, phoneNumber, info)
            .then((owner:any)=>{                  
              resolve(owner);                                         
            },(error:any)=>{            
              reject(error);
            }) 
      }                     
    }) 
  }
  
   /**
    * @example:
    *   this.vhAuth.signInWithEmailAndPassword_AutoWeb_Designer('emp11@gmail.com', '123456')
            .then((rsp)=>{
              if(rsp.vcode===0){
              this.vhQueryAutoWeb.syncCollections_Desktop()
                    .then(()=>{
                      do something.....
                      console.log('user', user);
                    })   
              }else if(rsp.vcode===5){
                  console.log('Signin sai LOẠI tài khoản developer');
              }        
            },(error:any)=>{
              console.log('error', error);          
            })
    * @param email 
    * @param password 
    * @return Promise => rsp ={vcode, message, data(object or null)} / error
    * vcode === 0: Đăng nhập thành công
    * vcode === 5: Đăng nhập thất bại vì sai LOẠI tài khoản developer
    */
   public signInWithEmailAndPassword_AutoWeb_Designer(email:string, password:string){
     return new Promise((resolve, reject) => { 
      if(this.getDBstorage() === 'firebase'){
       this.vhMGDB_auth.signInWithEmailAndPassword_AutoWeb(email, password)
           .then((user:any)=>{             
            if(!user.isDeveloper){
              resolve({vcode:0, message:'Logged in successfully', data: user});
            }else{
              this.signOut()
                  .then(()=>{                    
                    resolve({vcode:5, message:'Login failed because of wrong account type', data: null});
                  },(error:any)=>{
                    reject(error);         
                  })  
            }
           },(error:any)=>{
             reject(error);
           })
      }else if(this.getDBstorage() === 'mongo'){
        this.vhMGDB_auth.signInWithEmailAndPassword_AutoWeb_Mongo_Designer(email, password)
            .then((user:any)=>{                           
              if(!user.isDeveloper){                
                resolve({vcode:0, message:'Logged in successfully', data: user});
              }else{
                this.signOut_AutoWeb_Designer()
                    .then(()=>{                    
                      resolve({vcode:5, message:'Login failed because of wrong account type', data: null});
                    },(error:any)=>{
                      reject(error);         
                    })  
              }
            },(error:any)=>{
              reject(error);
            })
      }
     })
   }

   /**
    * @example:
    *   this.vhAuth.signInWithEmailAndPassword_AutoWeb_Developer('emp11@gmail.com', '123456')
            .then((rsp)=>{
                if(rsp.vcode===0){
                this.vhQueryAutoWeb.syncCollections_Desktop()
                      .then(()=>{
                        do something.....
                        console.log('user', user);
                      })   
                }else if(rsp.vcode===5){
                    console.log('Signin sai LOẠI tài khoản designer');
                }        
              },(error:any)=>{
                console.log('error', error);          
              })
    * @param email 
    * @param password 
    * @return Promise => rsp ={vcode, message, data(object or null)} / error
    * vcode === 0: Đăng nhập thành công
    * vcode === 5: Đăng nhập thất bại vì sai LOẠI tài khoản designer      
    */
    public signInWithEmailAndPassword_AutoWeb_Developer(email:string, password:string){
    return new Promise((resolve, reject) => { 
      if(this.getDBstorage() === 'firebase'){
        this.vhMGDB_auth.signInWithEmailAndPassword_AutoWeb(email, password)
            .then((res)=>{
              if(res.isDeveloper){
                resolve({vcode:0, message:'Logged in successfully', data: res});
              }else{
                this.signOut()
                    .then(()=>{                  
                      resolve({vcode:5, message:'Login failed because of wrong account type', data: null});
                    },(error:any)=>{
                      reject(error);         
                    })  
              }
            },(error:any)=>{
              reject(error);
            })
      }else if(this.getDBstorage() === 'mongo'){
        this.vhMGDB_auth.signInWithEmailAndPassword_AutoWeb_Mongo_Developer(email, password)
            .then((user:any)=>{                           
              if(user.isDeveloper){                
                resolve({vcode:0, message:'Logged in successfully', data: user});
              }else{
                this.signOut_AutoWeb_Developer()
                    .then(()=>{                    
                      resolve({vcode:5, message:'Login failed because of wrong account type', data: null});
                    },(error:any)=>{
                      reject(error);         
                    })  
              }
            },(error:any)=>{
              reject(error);
            })
      }
    })
  }
  
 /**
  * @example:
  * this.vhAuth.onAuthStateChanged_AutoWeb_Designer()
         .then((rsp)=>{
              if(rsp.vcode===0){
                //Designer
                this.vhQueryAutoWeb.syncCollections_Desktop()
                      .then(()=>{
                        do something.....
                        console.log('user', user);
                      })   
              }else if(rsp.vcode===10){
                //Developer
                this.vhQueryAutoWeb.syncCollections_Desktop()
                  .then(()=>{
                    do something.....
                    console.log('user', user);
                  }) 
              }        
            },(error:any)=>{
              console.log('error', error);          
            })
  * @return Promise => rsp ={vcode, message, data(object)} / error
  * vcode === 0: Designer logged in successfully
  * vcode === 10: Developer logged in successfully      
  */
   public onAuthStateChanged_AutoWeb_Designer(){
     return new Promise((resolve, reject) => {    
      if(this.getDBstorage() === 'firebase'){           
       this.vhMGDB_auth.onAuthStateChanged_AutoWeb()
           .then((user)=>{
              if(!user.isDeveloper){
                resolve({vcode:0, message:'Designer logged in successfully', data: user});
              }else{
                resolve({vcode:10, message:'Developer logged in successfully', data: user});  
              }            
           },(error:any)=>{
             reject(error);
           })
      }else if(this.getDBstorage() === 'mongo'){         
        this.vhMGDB_auth.onAuthStateChanged_AutoWeb_Mongo_Designer()
            .then((user)=>{
              if(!user.isDeveloper){
                resolve({vcode:0, message:'Designer logged in successfully', data: user});
              }else{
                resolve({vcode:10, message:'Developer logged in successfully', data: user});  
              }            
            },(error:any)=>{
              reject(error);
            })
      }
     })
   }

   /**
  * @example:
  * this.vhAuth.onAuthStateChanged_AutoWeb_Developer()
         .then((rsp)=>{
              if(rsp.vcode===0){
                //Designer
                this.vhQueryAutoWeb.syncCollections_Desktop()
                      .then(()=>{
                        do something.....
                        console.log('user', user);
                      })   
              }else if(rsp.vcode===10){
                //Developer
                this.vhQueryAutoWeb.syncCollections_Desktop()
                  .then(()=>{
                    do something.....
                    console.log('user', user);
                  }) 
              }        
            },(error:any)=>{
              console.log('error', error);          
            })
  * @return Promise => rsp ={vcode, message, data(object)} / error
  * vcode === 0: Designer logged in successfully
  * vcode === 10: Developer logged in successfully      
  */
   public onAuthStateChanged_AutoWeb_Developer(){
     return new Promise((resolve, reject) => {    
      if(this.getDBstorage() === 'firebase'){           
       this.vhMGDB_auth.onAuthStateChanged_AutoWeb()
           .then((user)=>{
              if(!user.isDeveloper){
                resolve({vcode:0, message:'Designer logged in successfully', data: user});
              }else{
                resolve({vcode:10, message:'Developer logged in successfully', data: user});  
              }            
           },(error:any)=>{
             reject(error);
           })
      }else if(this.getDBstorage() === 'mongo'){         
        this.vhMGDB_auth.onAuthStateChanged_AutoWeb_Mongo_Developer()
            .then((user)=>{
              if(!user.isDeveloper){
                resolve({vcode:0, message:'Designer logged in successfully', data: user});
              }else{
                resolve({vcode:10, message:'Developer logged in successfully', data: user});  
              }            
            },(error:any)=>{
              reject(error);
            })
      }
     })
   }

  public signUpOwner_Sales365(email:string, password:string, phoneNumber: string, info:any){  
    email = email.toLowerCase();
    info.email = info.email.toLowerCase();   
    if(info.phoneNumber === undefined) {console.log('info truyền vào thiếu trường phoneNumber');return null}// các bạn frontend thêm phoneNumber vào info xong sẽ xóa dòng này đi  
     return new Promise((resolve, reject) => {       
       this.vhMGDB_auth.signUpOwner_Sales365(email, password, phoneNumber, info)
           .then((owner:any)=>{   
             //console.log('owner1', owner);                                
             this.signInWithEmailAndPassword_Sales(email,password)
                 .then(()=>{         
                   initDB(this.getStore()._id);                                                           
                   this.vhForFirstTime.addAPPdatabase_forFirstTime_Sales365(info?.main_sector)
                       .then(()=>{      
                         //console.log('owner3', owner);                                                                                        
                         resolve(owner);
                         this.signOut();
                       })
                 })                                       
           },(error:any)=>{
             reject(error);
           })                      
     }) 
   }
  
    /**
    * @example:
    * this.vhAuth.signUpOwner_Sales('huyleduc92', '123456', '+84909925359',{})
           .then((owner)=>{            
             console.log('signUpOwner_Sales', owner);           
           },(error:any)=>{            
             console.log('error', error);
           })
     * @param email 
     * @param password  
     * @param scode 
     * @param info 
     * @return Promise => owner={}
     */
     public signUpOwner_Sales(email:string, password:string, phoneNumber: string, info:any){  
      email = email.toLowerCase();
      info.email = info.email.toLowerCase();   
      if(info.phoneNumber === undefined) {console.log('info truyền vào thiếu trường phoneNumber');return null}// các bạn frontend thêm phoneNumber vào info xong sẽ xóa dòng này đi  
       return new Promise((resolve, reject) => {       
         this.vhMGDB_auth.signUpOwner_Sales(email, password, phoneNumber, info)
             .then((owner:any)=>{                                               
               this.signInWithEmailAndPassword_Sales(email,password)
                   .then(()=>{         
                     initDB(this.getStore()._id);                                                            
                     this.vhForFirstTime.addAPPdatabase_forFirstTime_Sales_Cafe()
                         .then(()=>{      
                           //console.log('owner3', owner);                                                                                        
                           resolve(owner);
                           this.signOut();
                         })
                   })                                       
             },(error:any)=>{
               reject(error);
             })                      
       }) 
     }
     
     //Tạo 2 biến toàn cục này dùng tạm, sau này tìm cách xử lý đc hàm sẽ bỏ
     private tam_email:any ="";
     private tam_pw:any = "";
     private tam_info:any = "";
    /**
    * @example:
    * if (this.platform.is('ios')) {
        //Đăng ký bình thường như cách cũ
      }else{
        this.vhAuth.verificationSignup_byOTP_Sales365('huyleduc92@gmail.com', 'Vh123456', '+84909925359',{})
            .then((rsp:any)=>{  
              if(rsp.vcode === 0){
                //Nếu số đt và email trước đây chưa được đăng ký sử dụng thì bây giờ có thể đăng ký
                //Khởi động hàm xác minh người dùng đúng người đúng số đt
                const verificationCode = window.prompt(
                  'Please enter the verification code that was sent to your mobile device.',
                )!;
                this.vhAuth.verificationSignup_byOTP_Sales365(verificationCode)
                    .then((owner)=>{                
                      if(owner){
                        //Thông báo người dùng đã đăng ký thành công và trở về lại trang đăng nhập
                        console.log('verificationSignup_byOTP_Sales365', owner);        
                      }else{
                        //thông báo người dùng đã nhập sai mã otp
                      }          
                    },(error:any)=>{
                      console.log('error', error);   
                    });
              }else if(rsp.vcode === 1){
                //thông báo trùng số đt                            
              }else if(rsp.vcode === 2){
                //thông báo trùng email               
              }else if(rsp.vcode === 3){
                //thông báo số điện thoại sai định dạng           
              }
            })     
      }
    * @param email 
    * @param password  
    * @param phoneNumber 
    * @param info 
    * @return Promise object => rsp = {vcode, message}
    * vcode === 0: phoneNumber, email trước  đây chưa ký trên hệ thông nên bây giờ có thể dùng để đăng ký, tiếp tục dùng hàm verificationSignup_byOTP_Sales để xác minh 
    * mã opt gửi về điện thoại người dùng
    * vcode === 1: Hiện thị ra thông báo cho người dùng biết rằng số điện thoại của họ đã được đăng ký sử dụng trước đây, nên giờ ko dùng đc nữa, phải dùng số đt khác
    * vcode === 2: Hiện thị ra thông báo cho người dùng biết rằng email của họ đã được đăng ký sử dụng trước đây, nên giờ ko dùng đc nữa, phải dùng email khác
    * vcode === 3: Hiện thị ra thông báo cho người dùng biết rằng số điện thoại của họ nhập vào không đúng với định dạng của nhà mạng
    * @notice : nhớ kiểm tra email đúng cú pháp và chuỗi trước @gmail.com có chiều dài lớn hơn bằng 6 thì nút "Đồng ý" mới sáng lên
    */
    public signUpOwner_byOTP_Sales365(email:string, password:string, phoneNumber: string, info:any){   
      email = email.toLowerCase();
      info.email = info.email.toLowerCase();
      if(info.phoneNumber === undefined) {console.log('info truyền vào thiếu trường phoneNumber');return null}// các bạn frontend thêm phoneNumber vào info xong sẽ xóa dòng này đi   
      return new Promise((resolve, reject) => { 
        this.tam_email = email;
        this.tam_pw = password;
        this.tam_info = info;
        let os = 'web/android'; 
        //if (this.platform.is('ios') || this.platform.is('ipad') || this.platform.is('iphone')) os = 'ios';
        if (this.platform.is('desktop') || this.platform.is('pwa') || this.platform.is('cordova') || this.platform.is('capacitor') || this.platform.is('electron')
         || this.platform.is('mobileweb'))  os = 'web';

        this.vhMGDB_auth.signUpOwner_byOTP_Sales(os, email, password, phoneNumber, info)
            .then((rsp:any)=>{   
              resolve(rsp);              
            })      
      }) 
    }
    /**
     * @example:
     * this.vhAuth.verificationSignup_byOTP_Sales365(verificationCode)
            .then((owner)=>{  
              if(owner){
                console.log('verificationSignup_byOTP_Sales365', owner);        
              }else{
                //thông báo người dùng đã nhập sai mã otp
              }                                   
            },(error:any)=>{
              console.log('error', error);   
            });
     * @param verificationCode: mã otp được viethas gửi đến số điện thoại của bạn 
     * @returns Promise => owner = obj: mã verificationCode nhập vào đúng và trả về thông tin người dùng;  owner = null: mã verificationCode nhập vào sai;
     */
    public verificationSignup_byOTP_Sales365(verificationCode:string){
      return new Promise((resolve, reject) => {  
        let os = 'web/android'; 
        //if(this.platform.is('ios') || this.platform.is('ipad') || this.platform.is('iphone')) os = 'ios';  
        if (this.platform.is('desktop') || this.platform.is('pwa') || this.platform.is('cordova') || this.platform.is('capacitor') || this.platform.is('electron')
         || this.platform.is('mobileweb'))  os = 'web';
        this.vhMGDB_auth.verificationSignup_byOTP_Sales(os, verificationCode)
            .then((owner:any)=>{       
              if(owner){                    
                //Do đăng ký bằng OTP nên sau khi đăng ký xong là đã đăng nhập luôn rồi   
                //this.vhMGDB_auth.signInWithEmailAndPassword_byOTP_Sales(owner._id)
                this.vhMGDB_auth.signInWithEmailAndPassword_Sales(this.tam_email, this.tam_pw)
                   .then(()=>{                                              
                      this.vhForFirstTime.addAPPdatabase_forFirstTime_Sales365(this.tam_info?.main_sector)
                          .then(()=>{                                                                                                                                         
                            resolve(owner);
                            this.signOut();
                          })               
                    })   
              }else resolve(null);                   
            },(error:any)=>{
              reject(error);              
            });
      })
    }
   /**
    * @example:
    *   this.vhAuth.signInWithEmailAndPassword_Sales('emp11@gmail.com', '123456')
         .then((user)=>{
           this.vhQuerySales.refreshLocalBranchs()
                 .then(()=>{
                   do something.....
                   console.log('user', user);
                 })           
         },(error:any)=>{
           console.log('error', error);          
         })
    * @param email 
    * @param password 
    * @return Promise => user = {}     
    */
     public signInWithEmailAndPassword_Sales(email:string, password:string){
       return new Promise((resolve, reject) => {          
         this.vhMGDB_auth.signInWithEmailAndPassword_Sales(email, password)
             .then((res)=>{
                initDB(this.getStore()._id);  
               resolve(res);
             },(error:any)=>{
               reject(error);
             })
       })
     }

   /**
    * @example:
    * this.vhAuth.onAuthStateChanged_Sales()
           .then((user)=>{
             this.vhQuerySales.refreshLocalBranchs()
                 .then(()=>{
                   do something.....
                   console.log('onAuthStateChanged_Sales', user);
                 })              
           },(error:any)=>{
             console.log('onAuthStateChanged_Sales', error);
           })  
     * @return Promise => user = {}       
     */
     public onAuthStateChanged_Sales(){
       return new Promise((resolve, reject) => { 
         this.vhMGDB_auth.onAuthStateChanged_Sales()
             .then((res)=>{
              initDB(this.getStore()._id);  
               resolve(res);
             },(error:any)=>{
               reject(error);
             })
       })
     }

    /**
    * @example:
    *   this.vhAuth.signInWithEmailAndPassword_Sales365('emp11@gmail.com', '123456')
         .then((user)=>{
           this.vhQuerySales.refreshLocalBranchs()
                 .then(()=>{
                   do something.....
                   console.log('user', user);
                 })           
         },(error:any)=>{
           console.log('error', error);          
         })
    * @param email 
    * @param password 
    * @return Promise => user = {}     
    */
     public signInWithEmailAndPassword_Sales365(email:string, password:string){
       return new Promise((resolve, reject) => {          
         this.vhMGDB_auth.signInWithEmailAndPassword_Sales(email, password)
             .then((res)=>{
              initDB(this.getStore()._id);  
               resolve(res);
             },(error:any)=>{
               reject(error);
             })
       })
     }

   /**
    * @example:
    * this.vhAuth.onAuthStateChanged_Sales365()
           .then((user)=>{
             this.vhQuerySales.refreshLocalBranchs()
                 .then(()=>{
                   do something.....
                   console.log('onAuthStateChanged_Sales365', user);
                 })              
           },(error:any)=>{
             console.log('onAuthStateChanged_Sales365', error);
           })  
     * @return Promise => user = {}       
     */
     public onAuthStateChanged_Sales365(){
       return new Promise((resolve, reject) => { 
         this.vhMGDB_auth.onAuthStateChanged_Sales()
             .then((res)=>{
              initDB(this.getStore()._id);  
               resolve(res);
             },(error:any)=>{
               reject(error);
             })
       })
     }

/**
  * @example:
  *   this.vhAuth.signInWithEmailAndPassword_Sales365_byAffiliater('emp11@gmail.com', '123456')
        .then((user)=>{
          console.log('signInWithEmailAndPassword_Sales365_byAffiliater', user);  
        },(error:any)=>{
          console.log('error', error);          
        })
  * @param email 
  * @param password 
  * @return Promise => user = {}     
  */
  public signInWithEmailAndPassword_Sales365_byAffiliater(email:string, password:string){
    return new Promise((resolve, reject) => {          
      this.vhMGDB_auth.signInWithEmailAndPassword_Sales365_byAffiliater(email, password)
          .then((res)=>{
            resolve(res);
          },(error:any)=>{
            reject(error);
          })
    })
  }

  /**
* @example:
* this.vhAuth.onAuthStateChanged_Sales365_byAffiliater()
        .then((user)=>{
          console.log('onAuthStateChanged_Sales365_byAffiliater', user);     
        },(error:any)=>{
          console.log('error', error);
        })  
  * @return Promise => user = {}       
  */
  public onAuthStateChanged_Sales365_byAffiliater(){
    return new Promise((resolve, reject) => { 
      this.vhMGDB_auth.onAuthStateChanged_Sales365_byAffiliater()
          .then((res:any)=>{
            resolve(res);
          },(error:any)=>{
            reject(error);
          })
    })
  }

/**
  * @example:
  *   this.vhAuth.signInWithEmailAndPassword_Sales365_byDealer('emp11@gmail.com', '123456')
        .then((user)=>{
          console.log('signInWithEmailAndPassword_Sales365_byDealer', user);  
        },(error:any)=>{
          console.log('error', error);          
        })
  * @param email 
  * @param password 
  * @return Promise => user = {}     
  */
  public signInWithEmailAndPassword_Sales365_byDealer(email:string, password:string){
    return new Promise((resolve, reject) => {          
      this.vhMGDB_auth.signInWithEmailAndPassword_Sales365_byDealer(email, password)
          .then((res)=>{
            resolve(res);
          },(error:any)=>{
            reject(error);
          })
    })
  }

/**
* @example:
* this.vhAuth.onAuthStateChanged_Sales365_byDealer()
        .then((user)=>{
          console.log('onAuthStateChanged_Sales365_byDealer', user);     
        },(error:any)=>{
          console.log('error', error);
        })  
  * @return Promise => user = {}       
  */
  public onAuthStateChanged_Sales365_byDealer(){
    return new Promise((resolve, reject) => { 
      this.vhMGDB_auth.onAuthStateChanged_Sales365_byDealer()
          .then((res:any)=>{
            resolve(res);
          },(error:any)=>{
            reject(error);
          })
    })
  }

  /**
  * @example:
  *   this.vhAuth.signInWithEmailAndPassword_Sales365_byAdmin('emp11@gmail.com', '123456')
        .then((user)=>{
          console.log('signInWithEmailAndPassword_Sales365_byAdmin', user);  
        },(error:any)=>{
          console.log('error', error);          
        })
  * @param email 
  * @param password 
  * @return Promise => user = {}     
  */
  public signInWithEmailAndPassword_Sales365_byAdmin(email:string, password:string){
    return new Promise((resolve, reject) => {          
      this.vhMGDB_auth.signInWithEmailAndPassword_Sales365_byAdmin(email, password)
          .then((res)=>{
            resolve(res);
          },(error:any)=>{
            reject(error);
          })
    })
  }

/**
* @example:
* this.vhAuth.onAuthStateChanged_Sales365_byAdmin()
        .then((user)=>{
          console.log('onAuthStateChanged_Sales365_byDealer', user);     
        },(error:any)=>{
          console.log('error', error);
        })  
  * @return Promise => user = {}       
  */
  public onAuthStateChanged_Sales365_byAdmin(){
    return new Promise((resolve, reject) => { 
      this.vhMGDB_auth.onAuthStateChanged_Sales365_byAdmin()
          .then((res:any)=>{
            resolve(res);
          },(error:any)=>{
            reject(error);
          })
    })
  }
 
     /**
    * @example:
    * this.vhAuth.signUpOwner_Cafe('huyleduc92', '123456', '+84909925359',{})
           .then((owner)=>{            
             console.log('signUpOwner_Cafe', owner);           
           },(error:any)=>{            
             console.log('error', error);
           })
     * @param email 
     * @param password  
     * @param scode 
     * @param info 
     * @return Promise => owner={}
     */
     public signUpOwner_Cafe(email:string, password:string, phoneNumber: string, info:any){      
        email = email.toLowerCase();
        info.email = info.email.toLowerCase();   
        if(info.phoneNumber === undefined) {console.log('info truyền vào thiếu trường phoneNumber');return null}// các bạn frontend thêm phoneNumber vào info xong sẽ xóa dòng này đi 
       return new Promise((resolve, reject) => {       
         this.vhMGDB_auth.signUpOwner_Cafe(email, password, phoneNumber, info)
             .then((owner:any)=>{   
               //console.log('owner1', owner);                                
               this.signInWithEmailAndPassword_Cafe(email,password)
                   .then(()=>{         
                     //console.log('owner2', owner);                                                           
                     this.vhForFirstTime.addAPPdatabase_forFirstTime_Sales_Cafe()
                         .then(()=>{      
                           //console.log('owner3', owner);                                                                                        
                           resolve(owner);
                           this.signOut();
                         })
                   })                                       
             },(error:any)=>{
               reject(error);
             })                      
       }) 
     }
     /**
    * @example:
    *   this.vhAuth.signInWithEmailAndPassword_Cafe('emp11@gmail.com', '123456')
         .then((user)=>{
           console.log('user', user);
         },(error:any)=>{
           console.log('error', error);          
         })
     * @param email 
     * @param password 
     * @return Promise => user = {}     
     */
     public signInWithEmailAndPassword_Cafe(email:string, password:string){
       return new Promise((resolve, reject) => { 
         this.vhMGDB_auth.signInWithEmailAndPassword_Cafe(email, password)
             .then((res)=>{
               resolve(res);
             },(error:any)=>{
               reject(error);
             })
       })
     }
 
   /**
    * @example:
    * this.vhAuth.onAuthStateChanged_Cafe()
           .then((user)=>{
             console.log('onAuthStateChanged_Cafe', user);
           },(error:any)=>{
             console.log('onAuthStateChanged_Cafe', error);
           })  
     * @return Promise => user = {}       
     */
     public onAuthStateChanged_Cafe(){
       return new Promise((resolve, reject) => { 
         this.vhMGDB_auth.onAuthStateChanged_Cafe()
             .then((res)=>{
               resolve(res);
             },(error:any)=>{
               reject(error);
             })
       })
     }
 
   /**
    * @example:
    *  this.vhAuth.signOut()
         .then((res:any)=>{
           console.log('res1', res);
         },(error:any)=>{
           console.log('error1', error);          
         })  
    * @notice : luôn luôn trả về null
    * @return: null
    */
   public signOut(){
     return new Promise<any>((resolve, reject) => {
      if(this.getDBstorage() === 'firebase'){
        this.vhMGDB_auth.signOut()
            .then((res)=>{
              this.mypermission = {};
              resolve(res);
            },(error:any)=>{
              reject(error);
            })
      }else if(this.getDBstorage() === 'mongo'){
      }           
     })
   }

   /**
    * @example:
    *  this.vhAuth.signOut_AutoWeb_Designer()
         .then((res:any)=>{
           console.log('res1', res);
         },(error:any)=>{
           console.log('error1', error);          
         })  
    * @notice : luôn luôn trả về null
    * @return: null
    */
   public signOut_AutoWeb_Designer(){
     return new Promise<any>((resolve, reject) => {
      if(this.getDBstorage() === 'mongo'){
        this.vhMGDB_auth.signOut_AutoWeb_Mongo_Designer()
            .then((res:any)=>{
              resolve(res);
            },(error:any)=>{
              reject(error);
            })
      }           
     })
   }

   /**
    * @example:
    *  this.vhAuth.signOut_AutoWeb_Developer()
         .then((res:any)=>{
           console.log('res1', res);
         },(error:any)=>{
           console.log('error1', error);          
         })  
    * @notice : luôn luôn trả về null
    * @return: null
    */
   public signOut_AutoWeb_Developer(){
     return new Promise<any>((resolve, reject) => {
      if(this.getDBstorage() === 'mongo'){
        this.vhMGDB_auth.signOut_AutoWeb_Mongo_Developer()
            .then((res:any)=>{
              resolve(res);
            },(error:any)=>{
              reject(error);
            })
      }           
     })
   }
 /**
  * @example:
  *  this.vhAuth.resetPasswordbyEmail()
         .then((bool:any)=>{
           if(bool){
             console.log('Email sent');   
           }else{
             console.log('An error happened');   
           }                       
         })
  * @param emailAddress 
  */
   public resetPasswordbyEmail(emailAddress:any){
     return new Promise<any>((resolve, reject) => {
       this.vhMGDB_auth
           .sendPasswordResetEmail(emailAddress).then(()=> {
             // Email sent.
             resolve(true);
           }).catch(()=> {
             // An error happened.
             resolve(false);
           });
     });
   }
   
      
  /**
   * Hàm này dùng để đổi email của người dùng
   * @example:
   * this.vhAuth.updateUserEmail('5fb6780ca2148e09806c5b01', toilaai@gmail.com, 'member')      
       .then((rsp)=> {  
             if(rsp.vcode === 0){
               //-----------your code 0-----------              
               console.log('updateUserEmail', rsp);           
             }else
                 //-----------your code 1-----------
             }                                        
       },(error:any) => {
         console.log(error);
       }) 
   * @param id_employee   
   * @param email : nhớ kiểm tra chuẩn email trước, và chuỗi trước @ có chiều dài lớn hơn bằng 6
   * @param owner : 'boss' or 'member'
   * @return Promise object => rsp = {vcode, message}
   * vcode == 0: Successfully updated user
   * vcode != 1: This email has been registered by someone else
   * @notice : nhớ kiểm tra email đúng cú pháp và chuỗi trước @ có chiều dài lớn hơn bằng 6 thì nút "Đồng ý" mới sáng lên
   */
   public updateUserEmail(id_employee:string, email:string, owner:string){  
     return new Promise<any>((resolve, reject) => {
       this.vhMGDB_auth.updateUserEmail(id_employee, email, owner)
           .then((rsp)=>{
             resolve(rsp);
           },(error:any)=>{
             reject(error);
           })
     })
   }
   /**
    * @example:
    * let projectname = this.vhAuth.getProjectName();
    * @returns 
    */
   public getProjectName(){
     return this.vhMGDB_auth.getProjectName();
   }  
 
   public getUser(){    
     return this.vhMGDB_auth.getUser();
   }
 
   public getUID(){    
     return this.vhMGDB_auth.getUID();
   }
 
   /**
    * uuid: ID định danh cho platform đang sử dụng APP 'fd40681f-8907-4768-9a12-7a6a05338e51'
    * @example:
    * let uuid = this.vhAuth.getUUID();
    * @returns 
    */
   public getUUID(){    
     return this.hwinfo;
   }
 
    /**
    * @example:
    * let token = this.vhAuth.getToken();
    */
   public getToken(){
     return this.vhMGDB_auth.getToken();
   }
 
    /**
    * @example:
    * let dbcloudurl = this.vhAuth.getDBCloudURL();
    */  
   public getDBCloudURL(){
     return this.vhMGDB_auth.getDBCloudURL();
   }
 
  /**
    * @example:
    * let store = this.vhAuth.getStore();
    */  
   public getStore(){
     return this.vhMGDB_auth.getStore();
   }

  /**
    * @example:
    * let dealer = this.vhAuth.getDealer();
    */  
    public getDealer(){
      return this.vhMGDB_auth.getDealer();
    }
 
    /**
    * @example:
    * let dbstorage = this.vhAuth.getDBstorage();
    * @return: nơi lưu trữ dữ liệu 'firebase-mongo' hoặc 'firebase'
    */  
   public getDBstorage(){   
     return this.vhMGDB_auth.getDBstorage();
   }

  /**
    * @example:
    * let tplstorage = this.vhAuth.getTPLstorage();
    * @return: nơi lưu trữ template 'mongo' hoặc 'file'
    */  
       public getTPLstorage(){   
        return this.vhMGDB_auth.getTPLstorage();
      }

    /**
    * @example:
    * let imgstorage = this.vhAuth.getDBstorage();
    * @return: nơi lưu trữ dữ liệu 'firebase' hoặc 'viethas'
    */  
    public getIMGstorage(){   
      return this.vhMGDB_auth.getIMGstorage();
    }

 
 
    /**
    * @example:
    * let imgserverURL = this.vhAuth.getIMGserverURL();
    * @return: đường dẫn (url) nơi server lưu trữ hình ảnh
    */  
     public getIMGserverURL(){   
      return this.vhMGDB_auth.getIMGserverURL();
    }


   /**
    * @notice : dữ liệu Date query từ mongo về có dạng '2021-06-18T16:27:16.276Z', từ firebase có dạng {nanosecond:42345, second:1840298}
    * do đó muốn lấy Date về dạng chuẩn 'starttime Thu Jul 01 2021 00:00:00 GMT+0700 (Indochina Time)', thì Date sau khi query về dùng hàm newDate
    * để chuyển đổi.
    * @example:
    * let store = this.vhAuth.newDate(bill[0].date);
    * @return: nơi lưu trữ dữ liệu 'firebase-mongo' hoặc 'firebase'
    */  
   public newDate(date:any){
     if(this.vhMGDB_auth.getDBstorage() === 'firebase-mongo') return new Date(date);
     else if(this.vhMGDB_auth.getDBstorage() === 'firebase') return date.toDate();
   }
  
 
   /**
    * @example:
    * this.vhAuth.initializeDB('http://115.78.100.57:8011');         
    * @param url 
    */
   private initializeDB(url:string){
     //this.vhMGDB_initializeDB(url);
   }
 
   /**
    * @example:
    * this.vhAuth.initializeProject('vhsales','firebase-mongo', 'firebase', 'firebase', 'research', 'research', 324852, 'all');        
    * @param projectname 
    * @param dbstorage: 'firebase' or 'firebase-mongo'
    * @param imgstorage: 'firebase' or 'viethas'
    * @param tplstorage : nơi css sẽ được lưu trữ 'local', 'mongo', or 'file'
    * @param dbserverversion 
    * @param camserverversion 
    * @param fwcode 
    * @param database : tất cả database 'all' hoặc một database nào đó '4wk3JMSwSjh4kOLWOMbLbWt0Rdk2' 
    * @returns Promise => boolean
   * - boolean: true cho phép chạy dự án
   * - boolean: false không cho chạy dự án, thường bị là mở từ 2 tab của 1 trình duyệt trở lên => đề nghị đóng tab đang mở
    */
   public initializeProject(projectname:string, dbstorage:string, imgstorage:string, tplstorage:string, dbserverversion:string, camserverversion:string, fwcode:number, database:string):Promise<any>{
      let bool = (fwcode == 240415)
      if(!bool) throw 'wrong fwcode'; 
      return this.vhMGDB_auth.initializeProject(projectname, dbstorage, imgstorage, tplstorage, dbserverversion, camserverversion, database);    
   }  
   
   /**
    * @example:
    * this.vhAuth.initializeBuildProject('vhsales','mongo', 'viethas', 'file', 'research', 'research', 324852, 'all')
           .then(()=>{
              resolve(null);   
            },error=>{
              reject(error);
            })       
    * @param projectname 
    * @param dbstorage: 'firebase', 'firebase-mongo', 'mongo', or 'mysqlphp'
    * @param imgstorage: 'firebase', 'viethas' or 'hosting'
    * @param tplstorage : nơi template sẽ được lưu trữ 'mongo', or 'file'
    * @param dbserverversion 
    * @param camserverversion 
    * @param fwcode 
    * @param database : tất cả database 'all' hoặc một database nào đó '4wk3JMSwSjh4kOLWOMbLbWt0Rdk2' 
    * @returns Promise
    */
  public initializeBuildProject(projectname:string, dbstorage:string, imgstorage:string, tplstorage:string, dbserverversion:string, camserverversion:string, fwcode:number, database:string){
    return new Promise((resolve, reject) => {
      let bool = (fwcode == 240415)
      if(!bool) resolve(null); 
      this.vhMGDB_auth.initializeBuildProject(projectname, dbstorage, imgstorage, tplstorage, dbserverversion, camserverversion, database)
          .then(()=>{
            resolve(null); 
          },error=>{
            reject(error);
          })    
    })
  }  

  /**
    * @example:
    * this.vhAuth.initializeDesignProject('vhuserweb','mongo', 'viethas', 'mongo', 'research', 'research', 240...)
           .then(()=>{
              resolve(null);   
            },error=>{
              reject(error);
            })       
    * @param projectname 
    * @param dbstorage: 'firebase', 'firebase-mongo', or 'mongo'
    * @param imgstorage: 'firebase' or 'viethas'
    * @param tplstorage : nơi css sẽ được lưu trữ 'local', 'firebase', 'mongo' or 'file'
    * @param dbserverversion 
    * @param camserverversion 
    * @param fwcode 
    * @returns Promise
    */
    public initializeDesignProject(projectname:string, dbstorage:string, imgstorage:string, tplstorage:string, dbserverversion:string, camserverversion:string, fwcode:number){
      let bool = (fwcode == 240415)
      if(!bool) return <any>null;
      return this.vhMGDB_auth.initializeDesignProject(projectname, dbstorage, imgstorage, tplstorage, dbserverversion, camserverversion);    
    } 
 
   /**
    * @example:
    * this.vhAuth.initializeWebAppProject('vhsales', 356842, 'all');        
    * @param projectname    
    * @param fwcode 
    * @param database : tất cả database 'all' hoặc một database nào đó '4wk3JMSwSjh4kOLWOMbLbWt0Rdk2' 
    * @returns 
    */
     public initializeWebAppProject(projectname:string, fwcode:number, database:string){
       let bool = (fwcode == 240415)
       if(!bool) return <any>null;
       this.vhMGDB_auth.initializeWebAppProject(projectname, database);    
     } 
 
   /**
    * @example:
    * this.vhAuth.runOnMGDBServerVersion();         
    * @param url 
    */
   private runOnMGDBServerVersion(MGDBserverversion?:string){
     this.vhMGDB_auth.runOnMGDBServerVersion(MGDBserverversion);    
   } 
  
   /**
    * @example:
    * this.vhAuth.runOnCamServerVersion();         
    * @param url 
    */
   private runOnCamServerVersion(camserverversion?:string){
     this.vhMGDB_auth.runOnCamServerVersion(camserverversion);    
   }
 
   
    /**
    * @example SET:
    * localStorageSET('local_name', {a=1, b='hai'});
    * localStorageSET('local_name', 15000);
    * localStorageSET('local_name', 'muoi lam nghin dong');
    * @returns 
    */
 
     localStorageSET(name:string, value:any){
      if(isPlatformBrowser(this.platformId)){
       //localStorage.setItem(this.vhMGDB_auth.getProjectName() + '_' + name, JSON.stringify(value)); 
       if(typeof value === 'object') localStorage.setItem(this.vhMGDB_auth.getProjectName() + '_' + name, JSON.stringify(value)); 
       else localStorage.setItem(this.vhMGDB_auth.getProjectName() + '_' + name, value); 
      }
     }
   
   /**  
    * @example GET:
    * let object = this.vhAuth.localStorageGET('local_name');
    * @returns 
    */
     localStorageGET(name:string){ 
      if(!isPlatformBrowser(this.platformId)) return null;
       //return JSON.parse(localStorage.getItem(this.vhMGDB_auth.getProjectName() + '_' + name));   
      // return JSON.parse(<any>localStorage.getItem(this.vhMGDB_auth.getProjectName() + '_' + name));      
        let str:any = localStorage.getItem(this.vhMGDB_auth.getProjectName() + '_' + name)
        try {
          const obj = JSON.parse(str);
          return obj;
        } catch (e) {
          return str;
        }
     }
 
     /**
      * Hàm này dùng xóa tài khoản người dùng đã đăng nhập vào hệ thống
     * @example:
     * this.vhAuth.deleteUserAccount('huyleduc92')
           .then((bool:any)=>{        
             if(bool){              
               this.vhAuth.signOut();
             }else{
               console.log('Mật khẩu không đúng, vui lòng kiểm tra lại');           
             }               
           },(error:any)=>{            
             console.log('error', error);
           })
     * @param password 
     * @returns 
     */
     public deleteUserAccount(password:string){
       return new Promise((resolve, reject) => {       
         this.vhMGDB_auth.deleteUserAccount(password)
             .then((bool:any)=>{                                   
               resolve(bool)
             },(error:any)=>{
               reject(error)
             })
       })
     }
   /**
    * @example:
    * this.vhAuth.signUpOwner('huyleduc92', '123456', '+84909925359',{})
           .then((owner)=>{            
             console.log('signUpOwner', owner);           
           },(error:any)=>{            
             console.log('error', error);
           })
     * @param email 
     * @param password  
     * @param scode 
     * @param info 
     * @return Promise => owner={}
     */
   public signUpOwner(email:string, password:string, phoneNumber: string, info:object){      
     return new Promise((resolve, reject) => {       
       this.vhMGDB_auth.signUpOwner(email, password, phoneNumber, info)
           .then((owner:any)=>{                                   
             this.signInWithEmailAndPassword(email,password)
                 .then(()=>{                                                           
                   this.vhForFirstTime.addAPPdatabase_forFirstTime()
                       .then(()=>{                                                                                        
                         resolve(owner);
                         this.signOut();
                       })
                 })                                       
           },(error:any)=>{
             reject(error);
           })                      
     }) 
   }
 
   /**
    * @example:
    * this.vhAuth.signUpMember('huyleduc92', '123456',{})
          .then((rsp)=>{
            if(rsp.vcode == 0){
              //signUpMember thành công
            }else if(rsp.vcode == 0){
              //This phone number is already in use with another customer
            }
          },(error:any)=>{
            console.log('error', error);
          })
    * @param email 
    * @param password 
    * @param info : Có cả 3 trường countryCode, phone và phoneNumber
    * @return Promise => member={}
    * vcode = 0: 'succes'
    * vcode = 1: 'This phone number is already in use with another employee'
    */
   public signUpMember(email:string, password:string, phoneNumber:string, info:any){ 
     return new Promise((resolve, reject) => {  
      // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
      if (!(info.countryCode && info.phone && info.phoneNumber)) {
        // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
        return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
      }    
      if(this.getDBstorage() === 'firebase'){     
        this.vhMGDB_database.getDocsByFields('vhemployees', {phoneNumber:{$eq:info.phoneNumber}}, {})
          .then((employees:any)=>{
            if(employees.length == 0){
              this.vhMGDB_auth.signUpMember(email, password, phoneNumber, info) 
                  .then( (member)=> {            
                    resolve({vcode:0, msg: 'success', data: member});  
                  }, error=>{
                    reject(error);
                  }) 
            }else{
              resolve({vcode:1, msg: `${info.phoneNumber}, this phone number is already in use with another employee`}); 
            }
          },error=>{
            reject(error);
          })              
      }else{
        console.log('Nói anh Huy check lại database');
      } 
     }) 
     
   }
 
   /**
    * @example:
    * this.vhAuth.signUpEndUser('huyleduc92', '123456',{})
           .then(enduser=>{            
             console.log('signUpEndUser', enduser);           
           },(error:any)=>{            
             console.log('error', error);
           })
    * @param email 
    * @param password 
    * @param info 
    * @return Promise => member={}
    */
     public signUpEndUser(email:string, password:string, phoneNumber:string, info:object){       
       return new Promise((resolve, reject) => { 
         let _info:any = {...info};
         _info.eucode = Math.random().toString(10).substr(2, 11);                
         this.vhMGDB_auth.signUpEndUser(email, password, phoneNumber, _info) 
             .then( (member)=> {            
               resolve(member);  
             }, error=>{
               reject(error);
             })   
       }) 
       
     }
 
   private getLocalMyPermission(){    
     return this.mypermission;
   }
   
   /**
    * Hàm này chỉ dùng cho FW, Dev không dùng nhé
    * @returns 
    */
   public refreshLocalMyPermission(){
     return new Promise((resolve, reject) => { 
       this.vhMGDB_database.getDoc('vhpermissions', this.getUser()._id)
           .then(mypermission => {       
             //console.log('mypermission', mypermission);
             if(mypermission){
               this.mypermission = mypermission;       
             }                            
             resolve(null);
           },error => {
             reject(error);
           });        
     })
   }
 
   /**
    * Hàm này chỉ trả về kết quả chính xác khi mà các permission_name có giá trị trả về là kiểu boolean
    * Hàm checkMyPermission tương đương hàm checkLocalMyPermissionName, sau này sẽ bỏ hàm checkMyPermission
    * @example:
     if(this.vhAuth.checkMyPermission('login_enable_login')){
       this.login();
     }
    * @param permission_name 
    * @param message 
    * @return Boolean => true or false
    */
   public checkMyPermission(permission_name:any){    
     if(this.getUser().owner == 'boss'){
       return true;
     }else{      
         if(this.getLocalMyPermission()[permission_name]){
           return true;
         }else{         
           return false;
         }
     }   
   }
 
   /**
    * Hàm này chỉ trả về kết quả chính xác khi mà các permission_name có giá trị trả về là kiểu boolean
    * @example:
     if(this.vhAuth.checkLocalMyPermissionName('login_enable_login')){
       this.login();
     }
    * @param permission_name 
    * @param message 
    * @return Boolean => true or false
    */
     public checkLocalMyPermissionName(permission_name:any){    
       if(this.getUser().owner == 'boss'){
         return true;
       }else{      
           if(this.getLocalMyPermission()[permission_name]){
             return true;
           }else{         
             return false;
           }
       }   
     }
 
   /**
    * Hàm này chỉ trả về kết quả khi mà permission_name mà có giá trị không phải kiểu boolean, nếu là kiểu boolean hàm sẽ không trả kết quả về
    * @example:
    * let mypermissionname = this.vhAuth.getLocalMyPermissionName('default_display_page');
    * @param permission_name 
    * @return number/string/object
    */
     public getLocalMyPermissionName(permission_name:any){    
       if(typeof this.getLocalMyPermission()[permission_name] != 'boolean'){
         return this.getLocalMyPermission()[permission_name];
       } 
     }
   /**
    * @example:
     this.vhAuth.updatePermission('2rVieBQTubQ2hjUnpwU4w7qSlD83',{login_enable_login: false, default_display_page: 'admin_display_page'})
         .then((result)=>{
           console.log(result);
         }) 
    * @format value = {login_enable_login:true} or value = {login_reset_password:true}  
    * @param value 
    * @return Promise Boolean => true or false
    */
     public updateMyPermission(value:any) {
       let id_employee = this.getUID();
       return new Promise((resolve, reject) => {             
         // for(const p in this.mypermission){
         //   for(const q in value){         
         //     if(p === q){            
         //       this.mypermission[p] = value[q];   //check = true;   
         //     }           
         //   }
         // }     
         for(const q in value){                   
             this.mypermission[q] = value[q];            
         }  
         this.getPermission(id_employee)
             .then((permission:any)=>{
               if(permission){
                 this.vhMGDB_database.updateDoc('vhpermissions', id_employee, value)
                     .then((bool:any)=>{
                       resolve(bool);
                     }, error=>{
                       reject(error);  
                     })
               }else{
                 this.vhMGDB_database.addDocbyID('vhpermissions', id_employee, value)
                     .then(()=>{
                       resolve(true);//xem lại giá trị (), rồi cho resolve ra giá trị phù hợp 
                     }, error=>{
                       reject(error);  
                     })
               }            
             },(error:any)=>{
               reject(error);  
             })            
       })    
     }
   
    /**
    * @example:
     this.vhAuth.updatePermission('2rVieBQTubQ2hjUnpwU4w7qSlD83',{login_enable_login: false})
         .then((result)=>{
           console.log(result);
         }) 
    * @format value = {login_enable_login:true} or value = {login_reset_password:true}  
    * @param value 
    * @return Promise Boolean => true or false
    */
   public updatePermission(id_employee:string, value:object) {
      return new Promise((resolve, reject) => {     
       this.getPermission(id_employee)
           .then((permission:any)=>{
             if(permission){
               this.vhMGDB_database.updateDoc('vhpermissions', id_employee, value)
                   .then((bool:any)=>{
                     resolve(bool);
                   }, error=>{
                     reject(error);  
                   })
             }else{
               this.vhMGDB_database.addDocbyID('vhpermissions', id_employee, value)
                   .then(()=>{
                     resolve(true);//xem lại giá trị (), rồi cho resolve ra giá trị phù hợp 
                   }, error=>{
                     reject(error);  
                   })
             }            
           },(error:any)=>{
             reject(error);  
           })            
     })    
   }
 
   /**
    * Hàm này lấy về phân quyền của nhân viên
    * Lưu ý không dùng hàm này cho Boss, vì Boss không bị giới hạn phân quyền 
    * @example:
     this.vhAuth.getPermission('5fccf8b675b75a1fc84342e9')
         .then((permission)=>{
           console.log('permission', permission)              
         },error => {
            console.log('error', error);
         });  
    * @return Promise => permission = {} or null
    */
   public getPermission(id_employee:any):any {
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.getDoc('vhpermissions', id_employee)
             .then((permission)=>{
               resolve(permission);
             },(error:any)=>{
               reject(error)
             })          
     })   
   } 
 
   public publishObservableEventEmployees() {
     this.subjectemployees.next(this.employees);
   }  
 
   private observableLocalEmployees():Subject<any> {      
     return this.subjectemployees; 
   }
  /**
    * @example:
    * this.observableEmployee = this.vhAuth.getObservableLocalEmployees().subscribe((localEmployees:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableEmployee.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalEmployees(){   
    return new Observable((observer:any) => {    
     this.observableLocalEmployees().subscribe((employees) => {   
       observer.next(employees);
     })
     this.publishObservableEventEmployees();
    })
   }
 
   /**
    * @Notice : hàm này Dev không được dùng
    * @example: 
    * this.vhAuth.clearLocalEmployeeFromSyncCollection();
    * @param id_employee 
    * @return => void
    */
     public clearLocalEmployeeFromSyncCollection(){
       this.employees = new Array();     
     } 
   
   /**
    * @Notice : hàm này Dev không được dùng
    * @example: 
    * let bool = this.vhAuth.deleteLocalEmployeeFromSyncCollection('5fb6780ca2148e09806c5b01');
    * @param id_employee 
    * @return => bool = true or false
    */
   public deleteLocalEmployeeFromSyncCollection(id_employee:any){
     let exists = false;
     for(let i=0; i<this.employees.length; i++){
       if(this.employees[i]._id === id_employee){
         this.employees.splice(i, 1);     
         exists = true;         
         break;
       }
     }
     return exists; 
   }  
 
   /**
    * @Notice : hàm này Dev không được dùng
    * @example: 
    * let bool = this.vhAuth.updateLocalEmployeeFromSyncCollection('5fb6780ca2148e09806c5b01',{name:'Nguyen Hoang Nam'});
    * @param id_employee 
    * @param data 
    * @return => bool = true or false
    */
     public updateLocalEmployeeFromSyncCollection(id_employee:any, data:any){
       let exists = false;
       for(let i=0; i<this.employees.length; i++){
         if(this.employees[i]._id === id_employee){
           this.employees[i] = {...this.employees[i], ...data};   
           exists = true;          
           break;
         }
       }
       return exists; 
     }  
 
   /**
    * @Notice : hàm này Dev không được dùng
    * @example: 
    * let employee = this.vhAuth.insertlocalEmployeeFromSyncCollection({_id:'5fb6780ca2148e09806c5b01', name:'LE DUC HUY'});
    * @param employee 
    * @return => bool = true or false
    */
   public insertlocalEmployeeFromSyncCollection(employee:any){
     let exists = false; 
     if(!this.getlocalEmployee(employee._id)){
       this.employees.push(employee);
       exists = true;     
     }else{
        for(let n=0; n<this.employees.length; n++){
          if(this.employees[n]._id === employee._id){
            this.employees[n] = employee;
            break;
          }
        } 
      }   
     return exists; 
   }

 
   /**
    * @example: 
    * let employee = this.vhAuth.getlocalEmployees('5fb6780ca2148e09806c5b01');
    * @param id_employee 
    * @return obj = {} or null
    */
   public getlocalEmployee(id_employee:any){
     for(let i=0; i<this.employees.length; i++){
       if(this.employees[i]._id === id_employee){
         return this.employees[i];
         break;
       }
     }
     return null; 
   }

   /**
   * @example: 
   * this.vhAuth.getlocalEmployee_Async('ETxNu8exrvGtXFjkIhnc')
          .then((employee)=>{
          }, error=>{
            console.log('error', error);
          })
   * @param id_employee
   * @return Object => obj = {} or null
   */
    private getlocalEmployee_Async(id_employee:string):Promise<any>{   
      return new Promise((resolve, reject) => {
        (async () => {
          try{
            for(let i=0; i<this.employees.length; i++){
              if(this.employees[i]._id === id_employee){
                return resolve(this.employees[i]);
              }
            } 
            let _employee = await this.getEmployee(id_employee);
            resolve(_employee)
          } catch (err) {
            console.error('❌ Lỗi getlocalEmployee_Async:', err);
            reject(err);
          }  
        })();
      })
    }

   /**
    * @example: 
    * let employees = this.vhAuth.getlocalEmployees();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalEmployees(){    
     return this.employees;
   }
 
    /**
    * Hàm này refresh giá trị mới nhất cho hàm getlocalEmployees() trong localstorage
    * @return Promise => null
    */
   public refreshLocalEmployees():any{    
     return new Promise((resolve, reject) => { 
       // this.getEmployees()
       //     .then(()=>{resolve(null)})  
       resolve(null)     
     })
   }

    /**
   * Hàm này dùng để đồng bộ dữ liệu ẩn (delete_hidden = true) từ database về local
   * @example:
   * this.vhAuth.refreshLocalEmployees_Delete_Hidden()
        .then(()=>{
          do something.....
        })
  * Hàm này refresh giá trị mới nhất cho hàm getlocalCustomer(), getlocalCustomers() trong localstorage
  * @param type
  * @return Promise => null
  */
  public refreshLocalEmployees_Delete_Hidden(type:any):any{
    return new Promise((resolve, reject) => { 
      this.vhMGDB_database.getDocsByFields('employees', {delete_hidden:{$eq:true}})
          .then((employees:any)=>{
            // Đồng bộ thông tin lấy được vào danh sách `employees` trong bộ nhớ local
            for(let i=0; i<employees.length; i++){
              delete employees[i].name_keywords;
              delete employees[i].phone_keywords;        
              if(!this.getlocalEmployee(employees[i]._id)){
                this.employees.push(employees[i]);      
              }   
            }              
            resolve(null);
          }, error=>{
            reject(error)
          })               
    })
  }
 
   /**
    * @example:
    * this.vhAuth.updateEmployee('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateEmployee', bool);
           })
    * @param id_employee 
    * @param value 
    * @return Promise => bool = true or false
    */
   public updateEmployee(id_employee:string, value:any){
     return new Promise((resolve, reject) => {
      value.updated_at = new Date();
      // Nếu ít nhất một trong ba trường countryCode, phone hoặc phoneNumber có giá trị
      if (value.countryCode || value.phone || value.phoneNumber) {
        // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
        if (!(value.countryCode && value.phone && value.phoneNumber)) {
          // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
          return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
        }  
      }
      this.vhMGDB_database.updateDoc('vhemployees', id_employee, value)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error);
          })          
     })
   }
 
   /**
    * @example:
    * this.vhAuth.deleteEmployee('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteEmployee', bool);
         })
    * @param id_employee 
    * @return Promise => bool = true or false
    */
   public deleteEmployee(id_employee:string){      
     return new Promise((resolve, reject) => {
      let startyear = (new Date(this.getStore()?.registrationdate)).getFullYear();
      let endyear = (new Date()).getFullYear(); 
      let arr_years = new Array();
      arr_years.push(startyear);
      while(arr_years[arr_years.length-1] <endyear){
        arr_years.push(arr_years[arr_years.length-1] + 1);
      }
      //let years_query = this.getYearsArray_fromQuery(query);
      let promise = new Array();
      for(let i=0; i<arr_years.length; i++){
        promise[promise.length] = this.vhMGDB_database.getDocsByFields('vhs_bills_' + arr_years[i], {id_employee:{$eq:id_employee}},{},{},1);
      }
    
      Promise.all(promise)
            .then((array:any)=>{
              let bills = array.flat();       
              //resolve(bills);
              if(bills.length===0){              
                this.getEmployee(id_employee)
                    .then((employee:any)=>{
                      if(!employee) return resolve(false);
                      if(employee.owner == 'member') {   
                        this.getPermission(id_employee)
                            .then((permission:any)=>{
                              if(permission){
                                this.vhMGDB_database.deleteDoc('vhpermissions', id_employee);
                              }
                              this.vhMGDB_database.deleteDoc('vhemployees', id_employee)
                                  .then((bool:any)=>{
                                    resolve(bool);
                                  }, error=>{
                                    reject(error);
                                  })  
                            }, (error:any)=>{
                              reject(error);
                            }) 
                      }else return resolve(false);                    
                    })  
              }else resolve(false);
            },error=>{
              reject(error);
            }) 



       /*this.getBills_byFields({id_employee:{$eq:id_employee}},{},{},1)
           .then((bills:any)=>{                      
             if(bills.length===0){              
               this.getEmployee(id_employee)
                   .then((employee:any)=>{
                     if(!employee) return resolve(false);
                     if(employee.owner == 'member') {   
                       this.getPermission(id_employee)
                           .then((permission:any)=>{
                             if(permission){
                               this.vhMGDB_database.deleteDoc('vhpermissions', id_employee);
                             }
                             this.vhMGDB_database.deleteDoc('vhemployees', id_employee)
                                 .then((bool:any)=>{
                                   resolve(bool);
                                 }, error=>{
                                   reject(error);
                                 })  
                           }, (error:any)=>{
                             reject(error);
                           }) 
                     }else return resolve(false);                    
                   })  
             }else resolve(false);
           }, error=>{
             reject(error)
           })  */
                  
     })
   }
 
   /**
    * @example
    * this.vhAuth.getEmployee('5fb67fda87c0f21d484cbdf3')
             .then((obj)=>{
               console.log('getEmployee', obj);
             })
    * @param id_employee 
    * @return Promise => obj ={} or null
    */
   public getEmployee(id_employee:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.getDoc('vhemployees', id_employee)
             .then((employee)=>{
              if(employee){
                let exist = false;
                for(let i=0; i<this.employees.length; i++){
                  if(this.employees[i]._id == id_employee){
                    exist = true;                    
                    break;
                  }
                }
                if(!exist) this.employees.push(employee);
              }
              resolve(employee);
             }, error=>{
               reject(error);
             })           
     })
   }
 
   /**
    * @example
    * this.vhAuth.getEmployees()
             .then((array:any)=>{
               console.log('getEmployees', array);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getEmployees(){    
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.getDocs('vhemployees')
             .then((array:any)=>{                         
               this.employees = array;
               resolve(array);
             }, error=>{              
               reject(error);
             })          
     })
   }
 
     /**
    * @example: 
    * let employee = this.vhAuth.updateLocalEndUser('5fb6780ca2148e09806c5b01',{name:'Nguyen Hoang Nam'});
    * @param id_enduser 
    * @param data 
    * @return obj = {} or null
    */
     private updateLocalEndUser(id_enduser:any, data:any){
     for(let i=0; i<this.endusers.length; i++){
       if(this.endusers[i]._id === id_enduser){
         this.endusers[i] = {...this.endusers[i], ...data};           
         break;
       }
     }
     return true; 
   } 
 
   /**
    * @example: 
    * let enduser = this.vhAuth.getlocalEndUser('5fb6780ca2148e09806c5b01');
    * @param id_enduser 
    * @return obj = {} or null
    */
    private getlocalEndUser(id_enduser:any){
     for(let i=0; i<this.endusers.length; i++){
       if(this.endusers[i]._id === id_enduser){
         return this.endusers[i];
         break;
       }
     }
     return null; 
   }
   /**
    * @example: 
    * let endusers = this.vhAuth.getlocalEndUsers();
    * @return Array(object) => array = [{},{},...]
    */
   private getlocalEndUsers(){    
     return this.endusers;
   }
 
    /**
    * Hàm này refresh giá trị mới nhất cho hàm refreshLocalEndUsers() trong localstorage
    * @return Promise => null
    */
   private refreshLocalEndUsers():any{    
     return new Promise((resolve, reject) => { 
       this.getEndUsers()
           .then(()=>{resolve(null)})       
     })
   }
 
   /**
    * @example:
    * this.vhAuth.updateEndUser('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateEndUser', bool);
           })
    * @param id_enduser 
    * @param data 
    * @return Promise => bool = true or false
    */
   public updateEndUser(id_enduser:string, data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.updateDoc('vhendusers', id_enduser, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error);
           })          
     })
   }
 
   /**
    * @example:
    * this.vhAuth.deleteEndUser('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteEndUser', bool);
         })
    * @param id_enduser 
    * @return Promise => bool = true or false
    */
   public deleteEndUser(id_enduser:string){      
     return new Promise((resolve, reject) => {
      let startyear = (new Date(this.getStore()?.registrationdate)).getFullYear();
      let endyear = (new Date()).getFullYear(); 
      let arr_years = new Array();
      arr_years.push(startyear);
      while(arr_years[arr_years.length-1] <endyear){
        arr_years.push(arr_years[arr_years.length-1] + 1);
      }
      //let years_query = this.getYearsArray_fromQuery(query);
      let promise = new Array();
      for(let i=0; i<arr_years.length; i++){
        promise[promise.length] = this.vhMGDB_database.getDocsByFields('vhs_bills_' + arr_years[i], {id_employee:{$eq:id_enduser}},{},{},1);
      }    
      Promise.all(promise)
          .then((array:any)=>{
            let bills = array.flat();  
            if(bills.length===0){              
              this.getEndUser(id_enduser)
                  .then((enduser:any)=>{
                    if(!enduser) return resolve(false);
                    if(enduser.owner == 'enduser'){           
                      this.getPermission(id_enduser)
                          .then((permission:any)=>{
                            if(permission){
                              this.vhMGDB_database.deleteDoc('vhpermissions', id_enduser);
                            }
                            this.vhMGDB_database.deleteDoc('vhendusers', id_enduser)
                                .then((bool:any)=>{
                                  resolve(bool);
                                }, error=>{
                                  reject(error);
                                })  
                          }, (error:any)=>{
                            reject(error);
                          })     
                    }else return resolve(false);         
                  })  
            }else resolve(false);
          })           
     })
   }
 
   /**
    * @example
    * this.vhAuth.getEndUser('5fb67fda87c0f21d484cbdf3')
             .then((obj)=>{
               console.log('getEndUser', obj);
             })
    * @param id_enduser 
    * @return Promise => obj ={} or null
    */
   public getEndUser(id_enduser:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.getDoc('vhendusers', id_enduser)
             .then((obj)=>{
               resolve(obj);
             }, error=>{
               reject(error);
             })           
     })
   }
 
   /**
    * @example
    * this.vhAuth.getEndUsers()
             .then((array:any)=>{
               console.log('getEndUsers', array);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   private getEndUsers(){    
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.getDocs('vhendusers')
             .then((array:any)=>{                         
               //this.endusers = array;
               resolve(array);
             }, error=>{              
               reject(error);
             })          
     })
   }
 
 /**
  * @example
  * this.vhAuth.getEndUsers_byFields({name:{$eq:'name abc'}}, {},{},0)
           .then((endusers)=>{
             console.log('getEndUsers_byFields', endusers);
           })
   this.vhAuth.getEndUsers_byFields({eucode:{$eq:'45876542720'}}, {},{},0)
           .then((endusers)=>{
             console.log('getEndUsers_byFields', endusers);
           })        
   * @param query 
   * @param projection : {}
   * @param sort : {}
   * @param limit : 0
   * @return Promise => array(object) = [{},{},..]
   */
   public getEndUsers_byFields(query: any, projection: object, sort: any, limit: number){
     return new Promise((resolve, reject) => {  
       this.vhMGDB_database.getDocsByFields('vhendusers', query,{},sort,limit)
           .then((endusers)=>{              
             resolve(endusers);
           },(error:any)=>{
             reject(error);
           })                    
     })
   } 
  
 
 
 
  /**chưa dùng đến */
  private getExistedCurrencyFormat():object | null {   
   let currencyFormat = localStorage.getItem('vhsales_currencyFormat');
   if (currencyFormat) {
     return JSON.parse(String(currencyFormat));
   }else{
     return null;
   }   
 }
 
 public syncExistedCurrencyFormat(){   
   let currencyFormat = localStorage.getItem('vhsales_currencyFormat');
   if (!currencyFormat) {
     localStorage.setItem("vhsales_currencyFormat", JSON.stringify({ symbol:{text: "₫", value:5}, position: {text:"1", value:0}, digitDecimal: {text:'0', value:0}, digitGroup: {text:"123,456", value:1} }))
   }
 }
 
 private getExistedTheme(): string | null {
   return localStorage.getItem("vh_theme");
 }
 
 /**
  * vhAuth
  * @param color 
  * @returns 
  */
 private setTheme(color: string) {
   // Remove old themes by filter by className string
   let bodyClasses: Array<any> = Array.from(document.body.classList);  
   for (let i = 0; i < bodyClasses.length; i++)
     if (bodyClasses[i].indexOf("-theme") > -1) bodyClasses.splice(i, 1);
   document.body.className = bodyClasses.join(" ");  
   // Set new theme
   if (color == "vh-theme") {
     localStorage.removeItem("vh_theme");
     return;
   }
   this.renderer.addClass(document.body, color);
   localStorage.setItem("vh_theme", color);
 }
 
 public syncExistedTheme(){
   let theme = this.getExistedTheme();  
   if(theme) this.setTheme(theme);
 }
 
 public changeThemeIcon() {    
   let existedTheme = this.getExistedTheme();      
   if (existedTheme) {
     let element: HTMLElement = document.getElementsByClassName(
       "color " + existedTheme
     )[0] as HTMLElement;        
     element.click();
   } else {
     let element: HTMLElement = document.getElementsByClassName(
       "vh-theme"
     )[0] as HTMLElement;    
     element.click();
   }
 }
 
 /**
  * @example:
  * this.vhAuth.changeTheme(theme, event)
  * @param theme 
  * @param event 
  */
 public changeTheme(theme:any, event:any) {
   for (let elem of event.target.parentElement.children) elem.innerHTML = "";
   event.target.innerHTML = 
   `<ion-icon color="vh-white" src='data:image/svg+xml;utf8,
     <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 600 600" style="enable-background:new 0 0 512 512;" xml:space="preserve"> 
         <path d="M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,264.311c-9.997-9.998-26.205-9.997-36.204,0
           c-9.998,9.997-9.998,26.205,0,36.203l135.994,135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7
           C514.5,101.703,514.499,85.494,504.502,75.496z"/> 
     </svg>'>
   </ion-icon>`;
   this.setTheme(theme);
 }

 /**
  * @example:
  * let theme = this.vhAuth.getThemeValue())
  * @returns 
  */
 public getThemeValue(): string | null {
  return localStorage.getItem("vh_theme");
}
 /**
  * @example:
  * this.vhAuth.getManualVideos(type:string)
         .then((manualvideos)=>{
           console.log('manualvideos', manualvideos);
         },(error:any)=>{
           console.log('error', error);          
         })
  */
 public getManualVideos(type:string):any {    
   return new Promise<any>((resolve, reject) => {      
     this.vhMGDB_database.getManualVideos(type)
           .then((obj:any)=>{
             resolve(obj);
           }, (error:any)=>{
             reject(error)
           })       
   })
 }
 
 
 
    
 
 } 
 
 @Component({
   selector: 'vh-camplayback',
   template:`   
       <iframe id="cpb" allow="autoplay" allowfullscreen frameborder="0" style="object-fit: fill; width: 100%; height: 100%;" marginheight="0" marginwidth="0">               
       </iframe>   
   `
 })
 export class VhCamPlaybackComponent implements OnInit{
   @Input() licensecam:any = ''; 
   @Input() filename:any = ''; 
   @Input() camplaybackURL:any = '';
     //http://localhost:8013/miscellaneous/video?licensecam=4z3wh9B0XtuHptoMJKi5&filename=2021-02-05%2021_54_17
   private _src:any = '';
   private camplayback:any;
   private randomId: any = 'cpb';
   private oldrandomId: any = 'cpb';
   constructor(
     private vhMGDB_clouds: VhMGDB_clouds,
     private platform: Platform, private router: Router
     ){
     platform.ready().then(()=>{      
     })     
   }
   ngOnChanges(what: any){ 
     if((this.filename != '')&&(this.licensecam != '')) this.playbackVideo();
   }   
   ngOnInit() {   
 
   }
   playbackVideo() {        
     this.randomId = Math.random().toString(36).substr(2, 5);         
     let element:any =  document.getElementById(this.oldrandomId);
     element.id = this.randomId;    
     this.camplayback = document.getElementById(this.randomId);   
     this.oldrandomId = this.randomId;       
     this.camplayback.src = '';
       this.makePlaybackVideoByUser()
           .then((bool:any)=>{           
             if(bool){              
               let _licensecam = 'licensecam=' + this.licensecam;
               let _filename = 'filename=' + 'playbackvideo';
               let rd = 'rd=' + this.randomId;
               this._src = this.camplaybackURL + '/cloudcamplayback/playbackvideo' + '?'+_licensecam +'&' + _filename + '&' + rd;
               this.camplayback.src = this._src;                                    
             }                 
           })                 
   }
 
   ngOnDestroy(): void {     
     let element:any =  document.getElementById(this.oldrandomId);    
     element.src = "";
   }   
 
   feAdjustVideoPlaybackInFrame(frame:any, playbackRate:any) {
     var i;
     for (i=0; i<frame.frames.length; i++) {
       try {
         this.feAdjustVideoPlaybackInFrame(frame.frames[i], playbackRate);
         frame.frames[i].document.querySelector('video').playbackRate = playbackRate;
       }
       catch(e) {};
     }
   }
   //feAdjustVideoPlaybackInFrame(window, 1.5);
   makePlaybackVideoByUser(){
     return new Promise((resolve, reject) => {
       this.vhMGDB_clouds.makePlaybackVideoByUser(this.licensecam, this. camplaybackURL, this.filename)
         .then((resp:any)=>{
           resolve(resp);
         },(error:any)=>{         
           reject(error); 
         }) 
     }) 
   }  
   
 }
 
 @Component({
   selector: 'vh-camera-msev',
   template:`
   <!--video id="mse"  poster={{_poster}} autoplay=true style="object-fit: fill; width: 100%; height: 100%;">
   </video-->
   `
 })
 export class VhCameraMSEVcomponent implements OnInit{
   @Input('url') url:string = '';   
   @Input() licensecam:any = ''; 
   @Input() camliveURL:any = '';
   @Input() poster:any = '';
   @Input() roomid:any = '';
   @Input() width:any;
   @Input() height:any; 
   @Input() play:any = true;
   @Input() monitor:any = 1;
   @Input() os:any = 'android';
   //@Input() testnumber:any = 0;
   //@Input() autoplay:any = true;
   @Output() change: EventEmitter<any> = new EventEmitter();
   private list_camera:any=[];
   //private _visible: any = false;
   private _src:any = '';
   private _video:any={};
   private socket:any;
   private _run: any = undefined;
   private _first_time: any = true;
   //_autoplay:any = false;
   private _play: any = true;
   private _count: any = 0;
   public _poster:any = '';
   //_id_div: any;
    
   private config: any;
   //private mime:any = 'video/mp4; codecs="avc1.64001F, mp4a.40.2"'; ko đc cái nào cả    
   //private mime: any = 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"';ko đc cái nào cả 
   //private mime = 'video/mp4; codecs="avc1.420020"'; //được cho cam cũ
   private mime = 'video/mp4; codecs="avc1.640032"';
   //private mime = 'video/mp4; codecs="avc1.667479"';
   //private mime = 'video/mp4; codecs="avc1.42E01E"'; được cho cam cũ
   private video:any={};
   private mediaSource:any; 
   private buffer:any;
   private subscription_listenBuffer:any;
   private subscription_listenMediaSource:any;    
   private randomId: any = '';
   private integer = 0;
   
   constructor(private platform: Platform, private router: Router) {        
     platform.ready().then(()=>{       
         this.router.events.subscribe((event:any) => {          
           if ((event instanceof NavigationEnd && event.url === "/mobile/tabs/settings")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scripts")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scene")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/play-back"))
           {
             if(this._run) this.stopVideo();
           }
         });        
        
         this.randomId = Math.random().toString(36).substr(2, 5);
         this._poster = localStorage.getItem(this.licensecam);          
         let element:any =  document.getElementById('mse');
         element.id = this.randomId;        
         if(this._play) this.loadVideo();   
         
     })    
   }
 
   ngOnInit() {                      
   }
 
   ngOnChanges(what: any){            
     this._play = this.play;       
     if(this._run != undefined){
       if(this._play){
         if(!this._run) {                    
           this.startVideo();         
         }
       }else{
         if(this._run) {        
           this.stopVideo();          
         }
       }
     }
   }   
 
   ngOnDestroy(): void {      
     if(this._run) this.stopVideo();   
     console.log('destroyed camera');
   } 
  
 
   private loadVideo(){
     console.log('loadVideo');     
     //console.log('this.licensecam', this.licensecam);
     this.config = {        
         channelid: this.licensecam,
         channelname: this.licensecam,     
         url: this.url,
         monitor: this.monitor,
         os: this.os
     };  
      
     let range = 0;
     let lasttime = 0;
     let count: any = new Array();
     for(let i=0; i<10; i++) count[i] = 0;
     this.video = document.getElementById(this.randomId);
     
     this.mediaSource = new MediaSource();
     this.video.src = URL.createObjectURL(this.mediaSource);      
     this.subscription_listenMediaSource = this.listenMediaSource().subscribe((data1:any)=> {           
         this.subscription_listenBuffer = this.listenBuffer().subscribe((data:any)=> {             
             if ( this.mediaSource.duration !== Number.POSITIVE_INFINITY &&  this.video.currentTime === 0 &&
                 this.mediaSource.duration > 0) {
                 this.video.currentTime =  this.mediaSource.duration - 1;
                 this.mediaSource.duration = Number.POSITIVE_INFINITY;
             }  
             range = this.video.currentTime - lasttime;
             lasttime = this.video.currentTime;
             
            
             let max = 0;
             if(range != 0) {
               count[Math.round(range)]++;             
               for(let i=0; i<count.length; i++) if(count[i] > max) {max = count[i]; this.integer = i};                     
               if(this.integer !=0){
                 //if((range > 0)&&(range/this.integer < 1) ) this.video.playbackRate = 0.9; 
                 //else {this.video.playbackRate = range/this.integer + 0.1;}    
                 this.video.playbackRate = range/this.integer + 0.1;   
               }                        
             }
 
             //console.log('this.range', range); 
             //console.log('this.video.currentTime', this.video.currentTime);             
           },(error:any) => {
             console.log(error);
           })          
 
           if(this._play) this.startVideo();      
           else {
             this._run = false;
             this.change.emit({status:'loaded'});
           }    
            
       },(error:any) => { 
         console.log(error); 
       })
   }
  
   private startVideo(){            
     this.change.emit({status:'play'});   
     this.config.monitor = this.monitor;
     let _this = this;    
     let geturl = '?channelid=' + this.config.channelid 
                 + '&' + 'channelname=' + this.config.channelname
                 + '&' + 'url=' + this.config.url
                 + '&' + 'monitor=' + this.config.monitor 
                 + '&' + 'os=' + this.config.os;
     this.socket = new WebSocket(this.camliveURL + geturl);
     this.socket.addEventListener("open", function(event:any) {      
     });
     this.socket.addEventListener("message", (event:any)=> {
       let blob:any = new Blob([event.data], {type: 'image/jpeg'});//mimeString
       //console.log('blob:', blob);   
       blob.arrayBuffer().then((data:any) => {
         //console.log('data:', data);                  
           let udata = new Uint8Array(data);          
           _this.buffer.appendBuffer(udata);   
           if(_this._count == 5)  _this.getScreenshot();                
           //console.log('channelid:', _this.config.channelid);       
           _this._count++;
       });     
       
     });    
     this.video.muted = true;      
     this._run = true; 
     console.log('startVideo');          
   }
 
   private stopVideo(){        
     this.video.pause();
     this._run = false;         
     this.socket.removeAllListeners();       
     this.socket.close();   
     console.log('stopVideo');  
   }
 
   private listenMediaSource(){
     let _this = this;
     return Observable.create((observer:any) => {  
         this.mediaSource.addEventListener('updateend', function (e:any) {
           console.log('updateend: ' +  _this.mediaSource.readyState);
           //_this.mediaSource.endOfStream();
         });
         this.mediaSource.addEventListener('sourceended', function (e:any) {
             console.log('sourceended: ' +  _this.mediaSource.readyState);
         });
         this.mediaSource.addEventListener('sourceclose', function (e:any) {
             console.log('sourceclose: ' +  _this.mediaSource.readyState);
         });
         this.mediaSource.addEventListener('error', function (e:any) {
             console.log('error: ' +  _this.mediaSource.readyState);
         });
         this.mediaSource.addEventListener('sourceopen', function (e:any) {         
           //console.log('sourceopen: ' +  _this.mediaSource.readyState);  
             observer.next('sourceopen');
         }, true);
     })
   }
 
   private listenBuffer(){
     return Observable.create((observer:any) => {   
         this.buffer =  this.mediaSource.addSourceBuffer(this.mime);
         this.buffer.mode = 'sequence';      
         this.buffer.addEventListener('updateend', function (e:any) {
             observer.next('updateend');
         })
     })
   }
 
   private getScreenshot(){
     const video:any = document.getElementById(this.randomId);
     const canvas:any = document.createElement("canvas");
     // scale the canvas accordingly
     if(video?.videoWidth >=1280){
       canvas.width = video.videoWidth/4;
       canvas.height = video.videoHeight/4;
     }else if(video?.videoWidth < 1280){
       canvas.width = video.videoWidth/2;
       canvas.height = video.videoHeight/2;
     }
    
     // draw the video at that frame
     canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
     //canvas.getContext('2d').drawImage(video, 0, 0, this.width, this.height);
     // convert it to a usable data URL
     const image64 = canvas.toDataURL();    
     //console.log('this.licensecam', this.licensecam);
     localStorage.setItem(this.licensecam,image64);    
    
   }
 
 
 
 }
 
 
 // <div id="vh-camera-canvas">   
 // </div>  
 
 
 @Component({
   selector: 'vh-camera-h265c', 
   template:`   
   <canvas id="vh-camera-canvas">
   </canvas>   
   ` 
 })
 export class VhCameraH265Ccomponent implements OnInit{
   @Input('url') url:string = '';   
   @Input() licensecam:any = ''; 
   @Input() camliveURL:any = '';
   @Input() poster:any = '';
   @Input() roomid:any = '';
   @Input() width:any;
   @Input() height:any; 
   @Input() play:any = true;
   @Input() monitor:any = 1;
   @Input() os:any = 'ios';
   //@Input() testnumber:any = 0;
   //@Input() autoplay:any = true;
   @Output() change: EventEmitter<any> = new EventEmitter();
   @Output() online: EventEmitter<any> = new EventEmitter();
   @Output() detection: EventEmitter<any> = new EventEmitter();
   private list_camera:any=[]; 
   private _src:any = '';  
   private socket:any;
   private _run: any = undefined;  
   _autoplay:any = false;
   private _play: any = true;  
   private _poster:any = '';  
    
   private config: any;  
   private randomId: any = '';  
   private player:any;
   private wsavc:any;
 
   private settimeout:any;
   
   constructor(private platform: Platform, private router: Router) {     
      
     platform.ready().then(()=>{                
         this.router.events.subscribe((event:any) => {          
           if ((event instanceof NavigationEnd && event.url === "/mobile/tabs/settings")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scripts")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scene")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/play-back"))
           {
             if(this._run) this.stopVideo();
           }
         });                       
         this._poster = localStorage.getItem(this.licensecam);    
 
         this.randomId = Math.random().toString(36).substr(2, 5);           
         let element:any =  document.getElementById('vh-camera-canvas');
         element.id = this.randomId;         
         if(this._play) this.loadVideo();   
     })    
   }
 
   ngOnInit() {           
   }
 
   ngOnChanges(what: any){            
     this._play = this.play;       
     if(this._run != undefined){
       if(this._play){
         if(!this._run) {                    
           this.startVideo();         
         }
       }else{
         if(this._run) {        
           this.stopVideo();          
         }
       }
     }
   }   
 
   ngOnDestroy(): void {      
     if(this._run) this.stopVideo();   
     //console.log('destroyedCamera on desktop');
   }  
 
   private loadVideo(){
     //console.log('loadCamera on desktop');         
     this.config = {        
         channelid: this.licensecam,
         channelname: this.licensecam,     
         url: this.url,
         monitor: this.monitor,
         os: this.os
     };  
     if(this._play) this.startVideo();      
     else {
       this._run = false;      
     }       
   }
   
   private startVideo(){            
     this.online.emit({status:true});     
     this.config.monitor = this.monitor;   
     let geturl = '?channelid=' + this.config.channelid 
                 + '&' + 'channelname=' + this.config.channelname
                 + '&' + 'url=' + this.config.url
                 + '&' + 'monitor=' + this.config.monitor 
                 + '&' + 'os=' + this.config.os;
     /*var canvas = document.getElementById(this.randomId);
     this.player = new JSMpeg.Player(this.camliveURL + geturl, {canvas: canvas });*/   
     
     /*this.wsavc = new WSAvcPlayer.default({useWorker:true});
     console.log('wsavc.AvcPlayer.canvas', this.wsavc.AvcPlayer.canvas);
     document.getElementById(this.randomId).appendChild(this.wsavc.AvcPlayer.canvas);
 
     this.wsavc.connect(this.camliveURL + geturl);
     this.wsavc.on('disconnected',()=>console.log('WS Disconnected'));
     this.wsavc.on('connected',()=>console.log('WS connected'));
     let _count: 0;
     this.wsavc.on('frame_shift',(fbl)=>{
      // console.log('frame_shift', fbl)
      //fb.innerText = 'fl: '+fbl
      if(fbl == 0) _count++;else _count=0;
      if(_count > 100) {
         console.log('restart video', _count)
         if(this._run) {
           this.stopVideo(); 
           setTimeout(() => {
             this.startVideo();
           }, 60000);
           
         }
      }
     })
     this.wsavc.on('resized',(payload)=>{
        console.log('resized', payload);
        //let vb:any = document.getElementById(this.randomId);
        //vb.style = `padding-bottom: calc( 100% * ${payload.height} / ${ payload.width })`
      })
     this.wsavc.on('stream_active',active=>console.log('Stream is ',active?'active':'offline'));
     this.wsavc.on('custom_event_from_server',event=>console.log('got event from server', event));*/
 
     var canvas = document.getElementById(this.randomId);
     this.wsavc = new WSAvcPlayer(canvas, "webgl", 1, 35);
     this.wsavc.connect(this.camliveURL + geturl);       
     this.wsavc.on('deadprocess',()=>{
       //console.log('WS deadprocess', this.config.channelid);
       if(this._run) {
         this.stopVideo(); 
         this.settimeout = setTimeout(() => {
           //console.log('WS start new process', this.config.channelid);
           this.startVideo();
         }, 5000);        
       }
     });
     this.wsavc.on('detection',(result:any)=>{      
       this.detection.emit({status:result}); 
       //console.log('result', result);
     });
 
     this._run = true; 
     //console.log('startCamera on desktop');     
   }
 
   private stopVideo(){          
     this.online.emit({status:false});  
     if(this.settimeout) clearTimeout(this.settimeout);
     this._run = false;    
     //hàm này dùng cho thư viện WSAvcPlayer.js   
     //document.getElementById(this.randomId).removeChild(this.wsavc.AvcPlayer.canvas);        
     this.wsavc.disconnect();        
     //console.log('stopCamera  on desktop');  
   }
   
 
   private getScreenshot(){
     const video:any = document.getElementById(this.randomId);
     const canvas:any = document.createElement("canvas");
     // scale the canvas accordingly
     if(video?.videoWidth >=1280){
       canvas.width = video.videoWidth/4;
       canvas.height = video.videoHeight/4;
     }else if(video?.videoWidth < 1280){
       canvas.width = video.videoWidth/2;
       canvas.height = video.videoHeight/2;
     }
    
     // draw the video at that frame
     canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
     //canvas.getContext('2d').drawImage(video, 0, 0, this.width, this.height);
     // convert it to a usable data URL
     const image64 = canvas.toDataURL();    
     //console.log('this.licensecam', this.licensecam);
     localStorage.setItem(this.licensecam,image64);    
    
   }
 
 
 }
 /*
 @Component({
   selector: 'vh-camera-desktop', 
   template:`  
   <canvas id="vh-camera-canvas">
   </canvas>  
   ` 
 })
 export class VhCameraDesktopComponent implements OnInit{
   @Input('url') url:string = '';   
   @Input() licensecam:any = ''; 
   @Input() camliveURL:any = '';
   @Input() poster:any = '';
   @Input() roomid:any = '';
   @Input() width:any;
   @Input() height:any; 
   @Input() play:any = true;
   @Input() monitor:any = 1;
   @Input() os:any = 'ios';
   //@Input() testnumber:any = 0;
   //@Input() autoplay:any = true;
   @Output() change: EventEmitter<any> = new EventEmitter();
   private list_camera:any=[]; 
   private _src:any = '';  
   private socket:any;
   private _run: any = undefined;  
   _autoplay:any = false;
   private _play: any = true;  
   private _poster:any = '';  
    
   private config: any;  
   private randomId: any = '';  
   private player:any;
   
   constructor(private platform: Platform, private router: Router) {     
      
     platform.ready().then(()=>{                
         this.router.events.subscribe((event:any) => {          
           if ((event instanceof NavigationEnd && event.url === "/mobile/tabs/settings")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scripts")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scene")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/play-back"))
           {
             if(this._run) this.stopVideo();
           }
         });                       
         this._poster = localStorage.getItem(this.licensecam);    
 
         this.randomId = Math.random().toString(36).substr(2, 5);           
         let element:any =  document.getElementById('vh-camera-canvas');
         element.id = this.randomId;         
         if(this._play) this.loadVideo();   
     })    
   }
 
   ngOnInit() {           
   }
 
   ngOnChanges(what: any){            
     this._play = this.play;       
     if(this._run != undefined){
       if(this._play){
         if(!this._run) {                    
           this.startVideo();         
         }
       }else{
         if(this._run) {        
           this.stopVideo();          
         }
       }
     }
   }   
 
   ngOnDestroy(): void {      
     if(this._run) this.stopVideo();   
     console.log('destroyedCamera on desktop');
   }  
 
   private loadVideo(){
     console.log('loadCamera on desktop');         
     this.config = {        
         channelid: this.licensecam,
         channelname: this.licensecam,     
         url: this.url,
         monitor: this.monitor,
         os: this.os
     };  
     if(this._play) this.startVideo();      
     else {
       this._run = false;      
     }       
   }
  
   private startVideo(){            
     //this.change.emit({status:'play'});       
     let _this = this;
     this.config.monitor = this.monitor;   
     let geturl = '?channelid=' + this.config.channelid 
                 + '&' + 'channelname=' + this.config.channelname
                 + '&' + 'url=' + this.config.url
                 + '&' + 'monitor=' + this.config.monitor 
                 + '&' + 'os=' + this.config.os;
     var canvas = document.getElementById(this.randomId);
     this.player = new JSMpeg.Player(this.camliveURL + geturl, {canvas: canvas });   
     this._run = true; 
     console.log('startCamera on desktop');     
   }
 
   private stopVideo(){          
     this._run = false;     
     this.player.destroy();         
     console.log('stopCamera  on desktop');  
   }
   
 
   private getScreenshot(){
     const video:any = document.getElementById(this.randomId);
     const canvas:any = document.createElement("canvas");
     // scale the canvas accordingly
     if(video?.videoWidth >=1280){
       canvas.width = video.videoWidth/4;
       canvas.height = video.videoHeight/4;
     }else if(video?.videoWidth < 1280){
       canvas.width = video.videoWidth/2;
       canvas.height = video.videoHeight/2;
     }
    
     // draw the video at that frame
     canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
     //canvas.getContext('2d').drawImage(video, 0, 0, this.width, this.height);
     // convert it to a usable data URL
     const image64 = canvas.toDataURL();    
     //console.log('this.licensecam', this.licensecam);
     localStorage.setItem(this.licensecam,image64);    
    
   }
 
 
 }*/
 
 /*declare var JMuxer:any;
 
 @Component({
   selector: 'vh-camera-desktop-h264', 
   template:`  
   <video id="vhcamera">
   </video>  
   ` 
 })
 export class VhCameraDesktopH264Component implements OnInit{
   @Input('url') url:string = '';   
   @Input() licensecam:any = ''; 
   @Input() camliveURL:any = '';
   @Input() poster:any = '';
   @Input() roomid:any = '';
   @Input() width:any;
   @Input() height:any; 
   @Input() play:any = true;
   @Input() monitor:any = 1;
   @Input() os:any = 'ios';
   //@Input() testnumber:any = 0;
   //@Input() autoplay:any = true;
   @Output() change: EventEmitter<any> = new EventEmitter();
   private list_camera:any=[]; 
   private _src:any = '';  
   private socket:any;
   private _run: any = undefined;  
   _autoplay:any = false;
   private _play: any = true;  
   private _poster:any = '';  
    
   private config: any;  
   private randomId: any = '';  
   private player:any;
   
   constructor(private platform: Platform, private router: Router) {     
      
     platform.ready().then(()=>{                
         this.router.events.subscribe((event:any) => {          
           if ((event instanceof NavigationEnd && event.url === "/mobile/tabs/settings")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scripts")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scene")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/play-back"))
           {
             if(this._run) this.stopVideo();
           }
         });                       
         this._poster = localStorage.getItem(this.licensecam);    
 
         //this.randomId = Math.random().toString(36).substr(2, 5);           
         //let element:any =  document.getElementById('vh-camera-canvas');
         //element.id = this.randomId;         
         if(this._play) this.loadVideo();   
     })    
   }
 
   ngOnInit() {           
   }
 
   ngOnChanges(what: any){            
     this._play = this.play;       
     if(this._run != undefined){
       if(this._play){
         if(!this._run) {                    
           this.startVideo();         
         }
       }else{
         if(this._run) {        
           this.stopVideo();          
         }
       }
     }
   }   
 
   ngOnDestroy(): void {      
     if(this._run) this.stopVideo();   
     console.log('destroyedCamera on desktop');
   }  
 
   private loadVideo(){
     console.log('loadCamera on desktop');         
     this.config = {        
         channelid: this.licensecam,
         channelname: this.licensecam,     
         url: this.url,
         monitor: this.monitor,
         os: this.os
     };  
     if(this._play) this.startVideo();      
     else {
       this._run = false;      
     }       
   }
  
   private startVideo(){            
     //this.change.emit({status:'play'});       
     let _this = this;
     this.config.monitor = this.monitor;   
     let geturl = '?channelid=' + this.config.channelid 
                 + '&' + 'channelname=' + this.config.channelname
                 + '&' + 'url=' + this.config.url
                 + '&' + 'monitor=' + this.config.monitor 
                 + '&' + 'os=' + this.config.os;
     //let canvas = document.getElementById(this.randomId);
     //this.player = new JSMpeg.Player(this.camliveURL + geturl, {canvas: canvas });  
     
     let jmuxer = new JMuxer({
       node: 'vhcamera',
       //mode: 'both',
        mode: 'video',
        flushingTime: 1000,
        fps: 10,
       debug: true
     });
     let count = 0;
     let ws = new WebSocket(this.camliveURL + geturl);
     ws.binaryType = 'arraybuffer';
     ws.addEventListener('message',function(event) {
       let data = _this.parse(event.data);
           //jmuxer.feed(data);
         jmuxer.feed({
             video: new Uint8Array(event.data)
         });
         // console.log('event.data', event.data);
         console.log('count', count++);
         //console.log('Uint8Array(event.data)', new Uint8Array(event.data));
     });
     ws.addEventListener('error', function(e) {
         console.log('Socket Error');
     });
     
     
     
     this._run = true; 
     console.log('startCamera on desktop');     
   }
 
   private stopVideo(){          
     this._run = false;     
     this.player.destroy();         
     console.log('stopCamera  on desktop');  
   }
 
   parse(data:any) {
     let input = new Uint8Array(data),
         dv = new DataView(input.buffer),
         duration,
         audioLength,
         audio,
         video;
 
     duration = dv.getUint16(0, true);
     audioLength = dv.getUint16(2, true);
     audio = input.subarray(4, (audioLength + 4));
     video = input.subarray(audioLength + 4);
 
     return {
       video: video
       // audio: audio,
       // video: video,
       // duration: duration
     };
 }
   
 
   private getScreenshot(){
     const video:any = document.getElementById(this.randomId);
     const canvas:any = document.createElement("canvas");
     // scale the canvas accordingly
     if(video?.videoWidth >=1280){
       canvas.width = video.videoWidth/4;
       canvas.height = video.videoHeight/4;
     }else if(video?.videoWidth < 1280){
       canvas.width = video.videoWidth/2;
       canvas.height = video.videoHeight/2;
     }
    
     // draw the video at that frame
     canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
     //canvas.getContext('2d').drawImage(video, 0, 0, this.width, this.height);
     // convert it to a usable data URL
     const image64 = canvas.toDataURL();    
     //console.log('this.licensecam', this.licensecam);
     localStorage.setItem(this.licensecam,image64);    
    
   }
 
 
 }*/
 
 @Component({
   selector: 'vh-camera-jsmpegc', 
   template:`  
   <canvas id="vh-camera-mobile-canvas">
   </canvas>  
   ` 
 })
 export class VhCameraJSMPEGCcomponent implements OnInit{
   @Input('url') url:string = '';   
   @Input() licensecam:any = ''; 
   @Input() camliveURL:any = '';
   @Input() poster:any = '';
   @Input() roomid:any = '';
   @Input() width:any;
   @Input() height:any; 
   @Input() play:any = true;
   @Input() monitor:any = 1;
   @Input() os:any = 'ios';
   //@Input() testnumber:any = 0;
   //@Input() autoplay:any = true;
   @Output() change: EventEmitter<any> = new EventEmitter();
   private list_camera:any=[]; 
   private _src:any = '';  
   private socket:any;
   private _run: any = undefined;  
   _autoplay:any = false;
   private _play: any = true;  
   private _poster:any = '';  
    
   private config: any;  
   private randomId: any = '';  
   private player:any;
   
   constructor(private platform: Platform, private router: Router) {     
      
     platform.ready().then(()=>{                
         this.router.events.subscribe((event:any) => {          
           if ((event instanceof NavigationEnd && event.url === "/mobile/tabs/settings")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scripts")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scene")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/play-back"))
           {
             if(this._run) this.stopVideo();
           }
         });                       
         this._poster = localStorage.getItem(this.licensecam);    
 
         this.randomId = Math.random().toString(36).substr(2, 5);           
         let element:any =  document.getElementById('vh-camera-mobile-canvas');
         element.id = this.randomId;         
         if(this._play) this.loadVideo();   
     })    
   }
 
   ngOnInit() {           
   }
 
   ngOnChanges(what: any){            
     this._play = this.play;       
     if(this._run != undefined){
       if(this._play){
         if(!this._run) {                    
           this.startVideo();         
         }
       }else{
         if(this._run) {        
           this.stopVideo();          
         }
       }
     }
   }   
 
   ngOnDestroy(): void {      
     if(this._run) this.stopVideo();   
     console.log('destroyed camera');
   }  
 
   private loadVideo(){
     console.log('loadVideo on mobile');         
     this.config = {        
         channelid: this.licensecam,
         channelname: this.licensecam,     
         url: this.url,
         monitor: this.monitor,
         os: this.os
     };  
     if(this._play) this.startVideo();      
     else {
       this._run = false;      
     }       
   }
  
   private startVideo(){            
     //this.change.emit({status:'play'});       
     let _this = this;
     this.config.monitor = this.monitor;   
     let geturl = '?channelid=' + this.config.channelid 
                 + '&' + 'channelname=' + this.config.channelname
                 + '&' + 'url=' + this.config.url
                 + '&' + 'monitor=' + this.config.monitor 
                 + '&' + 'os=' + this.config.os;
     var canvas = document.getElementById(this.randomId);
     this.player = new JSMpeg.Player(this.camliveURL + geturl, {canvas: canvas });   
     this._run = true; 
     console.log('startVideo on mobile');     
   }
 
   private stopVideo(){          
     this._run = false;     
     this.player.destroy();         
     console.log('stopVideo  on mobile');  
   }
   
 
   private getScreenshot(){
     const video:any = document.getElementById(this.randomId);
     const canvas:any = document.createElement("canvas");
     // scale the canvas accordingly
     if(video?.videoWidth >=1280){
       canvas.width = video.videoWidth/4;
       canvas.height = video.videoHeight/4;
     }else if(video?.videoWidth < 1280){
       canvas.width = video.videoWidth/2;
       canvas.height = video.videoHeight/2;
     }
    
     // draw the video at that frame
     canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
     //canvas.getContext('2d').drawImage(video, 0, 0, this.width, this.height);
     // convert it to a usable data URL
     const image64 = canvas.toDataURL();    
     //console.log('this.licensecam', this.licensecam);
     localStorage.setItem(this.licensecam,image64);    
    
   }
 
 
 }
 
 
 
 @Component({
   selector: 'vh-camera-img', 
   template:`
   <img src={{_src}}> 
   ` 
 })
 export class VhCameraIMGcomponent implements OnInit{
   @Input('url') url:string = '';   
   @Input() licensecam:any = ''; 
   @Input() camliveURL:any = '';
   @Input() poster:any = '';
   @Input() roomid:any = '';
   @Input() width:any;
   @Input() height:any; 
   @Input() play:any = true;
   @Input() monitor:any = 1;
   @Input() os:any = 'ios';
   //@Input() testnumber:any = 0;
   //@Input() autoplay:any = true;
   @Output() change: EventEmitter<any> = new EventEmitter();
   private list_camera:any=[]; 
   public _src:any = '';  
   private socket:any;
   private _run: any = undefined;  
   _autoplay:any = false;
   private _play: any = true;  
   private _poster:any = '';  
    
   private config: any;  
   private randomId: any = '';  
   
   constructor(private platform: Platform, private router: Router) {     
      
     platform.ready().then(()=>{            
       //console.log('this.camliveURL', this.camliveURL);
        //this.socket = new Socket({url:this.camliveURL}); 
         this.router.events.subscribe((event:any) => {          
           if ((event instanceof NavigationEnd && event.url === "/mobile/tabs/settings")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scripts")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/scene")||
             (event instanceof NavigationEnd && event.url === "/mobile/tabs/play-back"))
           {
             if(this._run) this.stopVideo();
           }
         });                       
         this._poster = localStorage.getItem(this.licensecam);         
         if(this._play) this.loadVideo();   
     })    
   }
 
   ngOnInit() {                      
   }
 
   ngOnChanges(what: any){            
     this._play = this.play;       
     if(this._run != undefined){
       if(this._play){
         if(!this._run) {                    
           this.startVideo();         
         }
       }else{
         if(this._run) {        
           this.stopVideo();          
         }
       }
     }
   }   
 
   ngOnDestroy(): void {      
     if(this._run) this.stopVideo();   
     console.log('destroyed camera');
   }  
 
   private loadVideo(){
     console.log('loadVideo');         
     this.config = {        
         channelid: this.licensecam,
         channelname: this.licensecam,     
         url: this.url,
         monitor: this.monitor,
         os: this.os
     };  
     if(this._play) this.startVideo();      
     else {
       this._run = false;
       this.change.emit({status:'loaded'});
     }       
   }
  
   private startVideo(){            
     this.change.emit({status:'play'});       
     let _this = this;
     //this.socket.connect(); 
     this.socket = new Socket({url:this.camliveURL}); 
     //this.socket = new Socket({url:this.camliveURL}); 
     this.socket.emit('start', JSON.stringify(this.config));
     this.socket.on('segment-ios', function (data:any) {              
       if(data) _this._src = 'data:image/jpeg;base64,' + data;      
       console.log('channelid:', _this.config.channelid);           
     });  
     this._run = true; 
     console.log('startVideo ios');     
   }
 
   private stopVideo(){          
     this._run = false;   
     this.change.emit({status:'stop'});   
     this.socket.disconnect();
     this.socket.removeAllListeners();            
     console.log('stopVideo');  
   }
   
 
   private getScreenshot(){
     const video:any = document.getElementById(this.randomId);
     const canvas:any = document.createElement("canvas");
     // scale the canvas accordingly
     if(video?.videoWidth >=1280){
       canvas.width = video.videoWidth/4;
       canvas.height = video.videoHeight/4;
     }else if(video?.videoWidth < 1280){
       canvas.width = video.videoWidth/2;
       canvas.height = video.videoHeight/2;
     }
    
     // draw the video at that frame
     canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
     //canvas.getContext('2d').drawImage(video, 0, 0, this.width, this.height);
     // convert it to a usable data URL
     const image64 = canvas.toDataURL();    
     //console.log('this.licensecam', this.licensecam);
     localStorage.setItem(this.licensecam,image64);    
    
   }
 
 
 }

 @Injectable()
 export class VhHosting {
    private user:any = null;
    private signedin:any =  false;
    private hostingURL: any = "https://developer.webappgiare.vn:2440";
    constructor(
      private vhAlgorithm: VhAlgorithm
    ) {
    }  

    
/**
   * @example: 
   * this.vhHosting.forgotPasswordUser_byEmail('salesf110@gmail.com','h674567')
         .then(response=>{
            console.log('response', response);
            if(response.vcode === 0){
                //-----------your code 0-----------
                let user = response.data;
            }else if(response.vcode === 1){
                //-----------your code 1-----------
            }           
         },(error:any)=>{
            console.log('error', error)
         }) 
   * @param email 
   * @param password 
   * @return Promise object => response = {vcode, message}
   * vcode == 0: Message sent to email address successfully
   * vcode == 1: Email address does not exist
   */
  public forgotPasswordUser_byEmail(email:string, password: string) {
    return new Promise<any>((resolve, reject) => {
      // let auth = {database, dbstorage: this.vhAuth.getDBstorage(), projectname: this.getProjectName()};   
      // let body = {email, password, auth};      
      // axios.post(this.hostingURL + '/webapp_auto/forgotpasswordenduser_byemail', {...body})
      //             .then((response:any)=> {                    
      //               resolve(response.data);                             
      //             })
      //             .catch((e:any)=> {                    
      //               reject(e);
      //             });          
    })
  }

  /**
   * @example: 
   * this.vhHosting.changePasswordUser_byEmail('salesf110@gmail.com','h674567', 'V12345678')
         .then(response=>{
            console.log('response', response);
            if(response.vcode === 0){
                //-----------your code 0-----------
                let user = response.data;
            }else if(response.vcode === 1){
                //-----------your code 1-----------
            }else if(response.vcode === 2){
                //-----------your code 2-----------
            }else if(response.vcode === 3){
                //-----------your code 3-----------
            }            
          },(error:any)=>{
            console.log('error', error)
          }) 
    * @param email 
    * @param oldpassword 
    * @param newpassword 
    * @return Promise object => response = {vcode, message}
    * vcode == 0: Message sent to email address successfully
    * vcode == 1: Email address does not exist
    * vcode == 2: wrong oldpassword
    * vcode == 3: please reset your password
    */
    public changePasswordUser_byEmail(email:string, oldpassword: string, newpassword:string) {
    return new Promise<any>((resolve, reject) => {
      // let auth = {database, dbstorage: this.vhAuth.getDBstorage(), projectname: this.getProjectName()};   
      // let body = {email, oldpassword, newpassword, auth};      
      // axios.post(this.hostingURL + '/webapp_auto/changepasswordenduser_byemail', {...body})
      //             .then((response:any)=> {                    
      //               if(response.data.vcode === 0){                          
      //                 this.vhAlgorithm.localStorageSET(this.getProjectName() + '_' + database + '_webapp_auto_enduser', JSON.stringify(response.data.data.access_token)); 
      //                 delete response.data.data;                                          
      //               } 
      //               resolve(response.data);                          
      //             })
      //             .catch((e:any)=> {                    
      //               reject(e);
      //             });          
    })
  }

/**
   * @example: 
   * this.vhHosting.signupEndUser_byEmail('salesf110@gmail.com','h674567',{})
         .then(rsp=>{
            console.log('signupEndUser_byEmail', rsp);
            if(rsp.vcode === 0){
                //-----------your code 1-----------
                let enduser = rsp.data;
            }else if(rsp.vcode === 1){
                //-----------your code 2-----------
            }           
          },(error:any)=>{
            console.log('error', error)
          }) 
    * @param email 
    * @param password 
    * @param info : thông tin của enduser 
    * @return Promise object => rsp = {vcode, message, data}
    * vcode == 0: User account registered successful
    * vcode == 1: User Email already exists
    * @notice : sau khi đăng ký thành công, người dùng phải vào email xác nhận xác nhận việc đăng ký này
    */
    public signupUser_byEmail(database:string, email:string, password: string, info:object) {
    return new Promise<any>((resolve, reject) => {
      // let auth = {database, dbstorage: this.vhAuth.getDBstorage(), projectname: this.getProjectName()};   
      // let body = {email, password, info, auth};      
      // axios.post(this.hostingURL + '/webapp_auto/signupenduser_byemail', {...body})
      //             .then((rsp:any)=> {    
      //               if(rsp.data.vcode === 0){                             
      //                 this.enduser = {...rsp.data.data.user};               
      //                 this.vhAlgorithm.localStorageSET(this.getProjectName() + '_' + database  + '_webapp_auto_enduser', JSON.stringify(rsp.data.data.access_token)); 
      //                 delete rsp.data.data;      
      //                 this.signedin = true;               
      //               } 
      //               resolve(rsp.data);         
      //             })
      //             .catch((e:any)=> {                    
      //               reject(e);
      //             });          
    })
  }

/**
   * @example: 
   * this.vhHosting.signinUser_byEmail('salesf110@gmail.com','h674567')
         .then(response=>{
            console.log('response', response);
            if(response.vcode === 0){
                //-----------your code 0-----------
                let user = response.data;
            }else if(response.vcode === 1){
                //-----------your code 1-----------
            }else if(response.vcode === 2){
                //-----------your code 2-----------
            }else if(response.vcode === 3){
                //-----------your code 3-----------
            }else if(response.vcode === 4){
                //-----------your code 4-----------
            }              
          },(error:any)=>{
            console.log('error', error)
          }) 
    * @param email 
    * @param password 
    * @return Promise object => response = {vcode, message, data}
    * vcode == 0: Signed in successfully
    * vcode == 1: Wrong email
    * vcode == 2: Please login into your email to confirm your account on my website or APP
    * vcode == 3: Please reset your password
    * vcode == 4: Wrong password
    */
  public signinUser_byEmail(email:string, password: string) {
    return new Promise<any>((resolve, reject) => {
      // Mã hóa chuỗi sang Base64
      let base64EncodedString = btoa(email+":"+password);      
      const options = {
        method: 'GET',
        url: this.hostingURL + '/api/user/signin',
        headers: {          
          Authorization: 'Basic ' + base64EncodedString
        }
      };
      
      axios.request(options).then((response:any)=> {
        this.signedin = false;
        console.log('signinUser_byEmail', JSON.stringify(response.data));
        if(response.data.vcode === 0){                    
          this.vhAlgorithm.localStorageSET('webapp_auto_hosting_user', JSON.stringify(response.data.data.access_token));                 
          this.user = {...response.data.data};               
          delete this.user.access_token;           
          delete response.data.data;  
          this.signedin = true;                          
        } 
        resolve(response.data);       
      }).catch((e)=> {
        reject(e);
      }); 
    })
  }
  
  /**
  * @example: 
  * this.vhHosting.onAuthStateChangedUser()
        .then(response=>{
          console.log('response', response);            
          if(response.vcode === 0){
              //-----------your code 0-----------
              let user = response.data;
          }else if(response.vcode === 1){
              //-----------your code 1-----------
          }else if(response.vcode === 2){
              //-----------your code 2-----------
          }else if(response.vcode === 3){
              //-----------your code 3-----------
          }else if(response.vcode === 4){
              //-----------your code 4-----------
          }       
        },(error:any)=>{
          console.log('error', error)
        }) 
  * @return Promise object => response = {vcode, message}
  * vcode == 0: Signed in successfully
  * vcode == 1: wrong access_token->email
  * vcode == 2: wrong access_token->password
  * vcode == 3: Please login into your email to confirm your account on my website or APP
  * vcode == 4: Please reset your password 
  */
  public onAuthStateChangedUser() {
    return new Promise<any>((resolve, reject) => {
      let access_token = this.vhAlgorithm.localStorageGET('webapp_auto_hosting_user');
      if(!access_token) return resolve({vcode:1, message: 'empty access_token'});                   
        const options = {
          method: 'GET',
          url: this.hostingURL + '/api/user/get_user',
          headers: {          
            Authorization: 'Bearer ' + access_token
          }
        };
        
        axios.request(options).then((response:any)=> {    
          console.log('onAuthStateChangedUser', JSON.stringify(response.data));      
          if(response.data.vcode === 0){                               
            this.user = {...response.data.data};                               
            delete response.data.data;       
            this.signedin = true;                                             
          }else{     
            this.vhAlgorithm.localStorageSET('webapp_auto_hosting_user', JSON.stringify(null)); 
          } 
          return resolve(response.data); 
        }).catch((e)=> {
          reject(e);
        });         
    })
  }

  /**
  * @example
  * this.vhHosting.signoutUser();  
  * @return void
  */
  public signoutUser(database:string) {
    this.vhAlgorithm.localStorageSET('webapp_auto_hosting_user', JSON.stringify(null));    
    this.user = null;
    this.signedin = false;   
  }

/**
  * @example
  * let bool = this.vhHosting.checkLocalSigninUser();        
  * @return Boolean => true or false
  */
  public checkLocalSigninUser() {   
    return this.signedin;
  }

/**
* @example: 
* let enduser = this.vhHosting.getLocalUser();
* @return object => obj = {} or null
*/
public getLocalUser(){    
  return this.user;
}

  

    public signUpUser(email:string, password:string, phoneNumber:string, info:object){       
      return new Promise((resolve, reject) => { 
        let body = {};
        axios.post(this.hostingURL + '/api/user/create', {...body})
             .then((response:any)=> {                        
               if(response.data.vcode === 0) resolve(response.data);    
               else reject(response.data.message);  
             })
             .catch((e:any)=> {                          
               reject(e);
             });
      })     
    }

    public signInUser(email:string, password:string){       
      return new Promise((resolve, reject) => { 
        
      })     
    }

    public getToken(email:string, password:string){       
      return new Promise((resolve, reject) => { 
        
      })     
    }

    public getProfile(token:string){       
      return new Promise((resolve, reject) => { 
        
      })     
    }

    public getUser(token:string){       
      return new Promise((resolve, reject) => { 
        
      })     
    }

    /**
   * @example:Lấy hình file bất kỳ từ Desktop đẩy lên hosting
   * onUpload(e?) {
        const file = e.target.files[0];
        this.vhHosting.uploadFileFromDesktop(file,"subdomain1.webappgiare.vn", "public_html")
          .then((rsp:any)=>{
              console.log('rsp', rsp);
              if(rsp.vcode === 0){
                 
              }else if(rsp.vcode === 1){

              }else if(rsp.vcode === 2){

              }else if(rsp.vcode === 3){

              }       
              this.vhComponent.showToast(2000, (this.languageService.translate("File was loaded successfully")));      
          },error => {
            this.vhComponent.showToast(2000, (this.languageService.translate("File was failed")));
          }
        );
  }
  * @param file 
  * @param hosting
  * @param oldFipathleURL : String
  * @notice
  * @returns Object => obj = {vcode, message, data} 
  * vcode === 0 : upload file thành công
  * vcode === 1 : 
  * vcode === 2 : 
  * vcode === 3 : 
  */
  public uploadFileFromDesktop(file:string, hosting:string, path:string){      
    return new Promise((resolve, reject) => { 
      let access_token = this.vhAlgorithm.localStorageGET('webapp_auto_hosting_user');
      if(!access_token) return resolve({vcode:1, message: 'empty access_token'});  
      const form = new FormData();
      form.append("hosting", hosting);
      form.append("path", path);
      form.append("file", file);
      const options = {
        method: 'POST',
        url: this.hostingURL + '/api/file_manager/upload',
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + access_token
        },
        data: form
      };      
      axios.request(options).then(function (response) {
        if(response.data.vcode === 0){                          
        }else if(response.data.vcode === 1){            
        }else{
        }        
        resolve(response.data); 
      }).catch((e:any)=> {                    
        reject(e);
      });
    })
  }

  public extractFile(hosting:string, path:string){      
    return new Promise((resolve, reject) => { 
      let access_token = this.vhAlgorithm.localStorageGET('webapp_auto_hosting_user');
      if(!access_token) return resolve({vcode:1, message: 'empty access_token'});  
      const form = new FormData();
      form.append("hosting", hosting);
      form.append("path", path);
      
      const options = {
        method: 'POST',
        url: this.hostingURL + '/api/file_manager/extract',
        headers: {
          'Content-Type': 'multipart/form-data',           
          Authorization: 'Bearer ' + access_token
        },
        data: form
      };
      
      axios.request(options).then(function (response) {
        resolve(response.data); 
      }).catch((e:any)=> {                          
        reject(e);
      });
    })
  }

  public reNewHosting(hosting:string){      
    return new Promise((resolve, reject) => { 
      let access_token = this.vhAlgorithm.localStorageGET('webapp_auto_hosting_user');
      if(!access_token) return resolve({vcode:1, message: 'empty access_token'});  
      const form = new FormData();
      form.append("hosting", hosting);
      form.append("path", "public_html");
      form.append("all", "true");

      const options = {
        method: 'POST',
        url: this.hostingURL + '/api/file_manager/remove',
        headers: {
          'Content-Type': 'multipart/form-data',         
          Authorization: 'Bearer ' + access_token
        },
        data: form
      };

      axios.request(options).then(function (response) {
        resolve(response.data); 
      }).catch((e:any)=> {                          
        reject(e);
      });      
    })
  }

  public reSetHosting(hosting:string){      
    return new Promise((resolve, reject) => { 
      let access_token = this.vhAlgorithm.localStorageGET('webapp_auto_hosting_user');
      if(!access_token) return resolve({vcode:1, message: 'empty access_token'});  
      const form = new FormData();
      form.append("hosting", hosting);
      form.append("path", "public_html");
      form.append("all", "true");

      const options = {
        method: 'POST',
        url: this.hostingURL + '/api/file_manager/reset',
        headers: {
          'Content-Type': 'multipart/form-data',         
          Authorization: 'Bearer ' + access_token
        },
        data: form
      };

      axios.request(options).then(function (response) {
        resolve(response.data); 
      }).catch((e:any)=> {                          
        reject(e);
      });      
    })
  }

}
 
 
 @Injectable()
 export class VhImage {
   constructor(
     private vhMGDB_image: VhMGDB_image, 
     //private vhMGDB_auth: VhMGDB_auth,     
     private imagePicker: ImagePicker,private webview: WebView, private camera: Camera) {
   }    
  
  /**
   * @example:Lấy hình ảnh từ Camera thiết bị
   *  this.vhImage.getThumbnailFromCamera(128, 128, "employees", this.img).then(
        photoURL => {
          this.img = photoURL;
          this.detailEmployee.controls["img"].setValue(photoURL);
          this.vhComponent.showToast(2000, (this.languageService.translate("Image was loaded successfully")));
          this.updateEmployee(this.detailEmployee.value);
        },
        () => {
          this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
        }
      );
   * @param w 
   * @param h 
   * @param path: 'products' or 'data/products'   
   * @param oldthumbnailURL 
   * @returns 
   */
  public getThumbnailFromCamera(w:any, h:any, path:any, oldthumbnailURL?:any) {   
    //console.log('oldthumbnailURL', oldthumbnailURL); 
    return new Promise<any>((resolve, reject)=>{
      const options: CameraOptions = {
        quality: 100,
        destinationType: this.camera.DestinationType.FILE_URI,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE
      };
      this.camera.getPicture(options)
          .then(
            imageData => {
              if((oldthumbnailURL === null) || (oldthumbnailURL === undefined) || (oldthumbnailURL?.length <30)){ //dùng trong trường hợp tên file hình mặc định, có chiều dài nhỏ hơn 40
              }else{
                this.vhMGDB_image.deleteThumbnail([oldthumbnailURL]).then(
                  (success) => {            
                  },
                  (error) => {
                    console.log("Lỗi này chỉ xảy ra khi đường link hình ko tồn tại trong storage firebase, hoặc hàm deleteThumbnail bị lỗi");
                  });               
              }
              let image_src = this.webview.convertFileSrc(imageData);
              let filename = Math.random().toString(36).substr(2, 5);  
              let type = 'image/jpeg';
              this.vhMGDB_image.uploadThumbnail(image_src, type, w, h, filename, path)              
                  .then((image:any)=>{
                    resolve(image);
                  },
                  (err2:any) => {                   
                    reject(err2);
                  })                  
            },
            err1 => {                 
              reject(err1);
            })
    })
  } 
  
/**
   * @example:Lấy hình ảnh từ Album thiết bị
   *  this.vhImage.getThumbnailFromAlbum(128, 128, "employees", this.img).then(
        photoURL => {
          this.img = photoURL;
          this.detailEmployee.controls["img"].setValue(photoURL);
          this.vhComponent.showToast(2000, (this.languageService.translate("Image was loaded successfully")));
          this.updateEmployee(this.detailEmployee.value);
        },
        () => {
          this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
        }
      );
    * @param w 
    * @param h 
    * @param path: 'products' or 'data/products'  
    * @param oldthumbnailURL 
    * @returns 
    */
  public getThumbnailFromAlbum(w:any, h:any, path:any, oldthumbnailURL?:any) {   
    //console.log('oldthumbnailURL', oldthumbnailURL); 
    return new Promise<any>((resolve, reject)=>{
      this.imagePicker.hasReadPermission()
          .then(
            result => {
              if (!result) {            
                this.imagePicker.requestReadPermission();
                reject({message: 'cancel'})
              } else {
                this.imagePicker
                    .getPictures({maximumImagesCount: 1})
                    .then(results => {
                      if(results.length>0){   
                        if((oldthumbnailURL === null) || (oldthumbnailURL === undefined) || (oldthumbnailURL?.length <30)){ //dùng trong trường hợp tên file hình mặc định, có chiều dài nhỏ hơn 40
                        }else{
                          this.deleteThumbnail([oldthumbnailURL]).then(
                            (success) => {            
                            },
                            (error) => {
                              console.log("Lỗi này chỉ xảy ra khi đường link hình ko tồn tại trong storage firebase, hoặc hàm deleteThumbnail bị lỗi");
                            });                        
                        }     
                        let image_src = this.webview.convertFileSrc(results[0]);
                        let filename = Math.random().toString(36).substr(2, 5);  
                        let type = 'image/jpeg';
                        this.vhMGDB_image.uploadThumbnail(image_src, type, w, h, filename, path)
                            .then((image:any)=>{
                              resolve(image);
                            },
                            (err3:any) => {                        
                              reject(err3);
                            })              
                      }else{
                        reject({message: 'cancel'})
                      }            
                    },err2 => {                
                      reject(err2);
                    })
              }
            },
            err1 => {          
              reject(err1);
            })
    })
  }  

  /**
   * @example:Lấy hình ảnh từ Album thiết bị
   *  this.vhImage.getImageFromAlbum("employees", this.img).then(
        photoURL => {
          this.img = photoURL;
          this.detailEmployee.controls["img"].setValue(photoURL);
          this.vhComponent.showToast(2000, (this.languageService.translate("Image was loaded successfully")));
          this.updateEmployee(this.detailEmployee.value);
        },
        () => {
          this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
        }
      );
    * @param path: 'products' or 'data/products'   
    * @param oldthumbnailURL 
    * @returns 
    */
  public getImageFromAlbum(path:any, oldthumbnailURL?:any) {   
    //console.log('oldthumbnailURL', oldthumbnailURL); 
    return new Promise<any>((resolve, reject)=>{
      this.imagePicker.hasReadPermission()
          .then(
            result => {
              if (!result) {            
                this.imagePicker.requestReadPermission();
                reject({message: 'cancel'})
              } else {
                this.imagePicker
                    .getPictures({maximumImagesCount: 1})
                    .then(results => {
                      if(results.length>0){   
                        if((oldthumbnailURL === null) || (oldthumbnailURL === undefined) || (oldthumbnailURL?.length <30)){ //dùng trong trường hợp tên file hình mặc định, có chiều dài nhỏ hơn 40
                        }else{
                          this.deleteThumbnail([oldthumbnailURL]).then(
                            (success) => {            
                            },
                            (error) => {
                              console.log("Lỗi này chỉ xảy ra khi đường link hình ko tồn tại trong storage firebase, hoặc hàm deleteThumbnail bị lỗi");
                            });                        
                        }     
                        let image_src = this.webview.convertFileSrc(results[0]);
                        let filename = Math.random().toString(36).substr(2, 5);  
                        let type = 'image/jpeg';
                        this.vhMGDB_image.uploadImage(image_src, type, filename, path)
                            .then((image:any)=>{
                              resolve(image);
                            },
                            (err3:any) => {                        
                              reject(err3);
                            })              
                      }else{
                        reject({message: 'cancel'})
                      }            
                    },err2 => {                
                      reject(err2);
                    })
              }
            },
            err1 => {          
              reject(err1);
            })
    })
  } 

/**
   * @example:Lấy hình ảnh từ Desktop với kích thước tùy chỉnh
   * onUpload(e?) {
        const file = e.target.files[0];
        this.vhImage.getThumbnailFromDesktop(file, 128, 128, "employees", this.img).then(
          photoURL => {             
              this.img = photoURL;
              this.detailEmployee.controls["img"].setValue(photoURL);
              this.vhComponent.showToast(2000, (this.languageService.translate("Image was loaded successfully")));
              this.updateEmployee(this.detailEmployee.value);
            }            
          },error => {
            this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
          }
        );
  }
    * @param file 
    * @param w 
    * @param h 
    * @param path: 'products' or 'data/products'  
    * @param oldthumbnailURL : String
    * @returns 
    * @notice: trường hợp cập nhật hình ảnh, phải truyền vào hàm tham số oldthumbnailURL để xóa ảnh cũ đi, tránh làm server bị rác
    */
  public getThumbnailFromDesktop(file:any, w:any, h:any, path:any, oldthumbnailURL?:any) { 
    return new Promise<any>((resolve, reject)=>{  
      //console.log('oldthumbnailURL', oldthumbnailURL);      
      if((file != undefined)){//chọn từ Desktop lần đầu ok, bấm vô chọn tiếp, click cancel báo file undefine          
        if((oldthumbnailURL === null) || (oldthumbnailURL === undefined) || (oldthumbnailURL?.length <30)){ //dùng trong trường hợp tên file hình mặc định, có chiều dài nhỏ hơn 40
        }else{          
            this.deleteThumbnail([oldthumbnailURL]).then(
              (success) => {                                         
              },
              (error) => {
                console.log("link hình muốn xóa, ko tồn tại trên imageserver ", error);
              });                    
        }    
        const reader = new FileReader();
        reader.addEventListener('load', (event:any) => {    
          let type = file.type;    
          let filename = file.name;
          filename = filename.slice(0, filename.lastIndexOf('.'));
          //let randomId = Math.random().toString(36).substr(2, 5);
          //uploads img to firebase storage
          this.vhMGDB_image.uploadThumbnail(event.target.result, type, w, h, filename, path)
              .then(
                photoURL => {    
                  //resolve({vcode: 0, message: "success", data:photoURL});                           
                  resolve(photoURL);
                },
                err => {              
                  reject(err);
                })
        });
        reader.readAsDataURL(file); 
      }else{
        reject({error: "lỗi import file ảnh"});
      }
    })
  }
  

  /**
   * @example:Lấy hình ảnh từ Desktop đẩy lên server với kích thước hình ko thay đổi
   * onUpload(e?) {
        const file = e.target.files[0];
        this.vhImage.getImageFromDesktop(file,"employees", this.img)
          .then((rsp:any)=>{
              console.log('rsp', rsp);
              if(rsp.vcode === 0){
                this.img = rsp.data;
                this.detailEmployee.controls["img"].setValue(this.img);                
                this.updateEmployee(this.detailEmployee.value);      
              }else if(rsp.vcode === 1){

              }else if(rsp.vcode === 2){

              }else if(rsp.vcode === 3){

              }       
              this.vhComponent.showToast(2000, (this.languageService.translate("Image was loaded successfully")));      
          },error => {
            this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
          }
        );
  }
    * @param file 
    * @param path: 'products' or 'data/products'  
    * @param oldthumbnailURL : String   * 
    * @param maxSize : file ảnh có dung lượng tối đa cho phép, đơn vị byte
    * @notice : trường hợp cập nhật hình ảnh, phải truyền vào hàm tham số oldthumbnailURL để xóa ảnh cũ đi, tránh làm server bị rác
    * @returns Object => obj = {vcode, message, data, error} 
    * vcode === 0 : upload ảnh thành công
    * vcode === 1 : lỗi import file ảnh
    * vcode === 2 : lỗi upload file ảnh
    * vcode === 3 : không thể upload file ảnh lớn hơn maxSize (byte)
    * vcode === 4 : import file ảnh không đúng định dạng
    */
  public getImageFromDesktop(file:any, path:any, oldthumbnailURL?:any, maxSize?:any) { 
    return new Promise<any>((resolve, reject)=>{            
      //Sau này test và fix lỗi sau, chọn từ Desktop lần đầu ok, bấm vô chọn tiếp, click cancel báo file undefine     
      if((file == undefined)||(file === null)) return resolve({vcode:1, message: 'lỗi import file ảnh'});           
      if((file.size > maxSize)) return resolve({vcode:3, message: `không thể upload file ảnh lớn hơn ${maxSize} bytes`});        
      if(!((file.type ==='image/jpeg')||(file.type ==='image/jpg')||(file.type ==='image/png')||(file.type ==='image/gif')))  return resolve({vcode:4, message: 'import file ảnh không đúng định dạng'});  

      if((oldthumbnailURL === null) || (oldthumbnailURL === undefined) || (oldthumbnailURL?.length <30)){ //dùng trong trường hợp tên file hình mặc định, có chiều dài nhỏ hơn 40
      }else{          
          this.deleteThumbnail([oldthumbnailURL]).then(
            (success) => {                                         
            },
            (error) => {
              console.log("link hình muốn xóa, ko tồn tại trên imageserver ", error);
            });                    
      }          
      const reader = new FileReader();
      reader.addEventListener('load', (event:any) => {    
        let type = file.type;    
        let filename = file.name;
        filename = filename.slice(0, filename.lastIndexOf('.'));
        //let randomId = Math.random().toString(36).substr(2, 5);
        //uploads img to firebase storage        
        this.vhMGDB_image.uploadImage(event.target.result, type, filename, path)
            .then(photoURL => {    
                //resolve(photoURL);                
                resolve({vcode: 0, message: "success", data:photoURL});                           
              },
              err => {                    
                resolve({vcode: 2, message: "lỗi upload file ảnh", error: err});            
              })
      });
      reader.readAsDataURL(file);       

    })
  }   

   /**
   * @example:Lấy hình ảnh từ Desktop đẩy lên server với kích thước hình theo options truyền vào
   * onUpload(e?) {
        const file = e.target.files[0];
        this.vhImage.getImageFromDesktop_Autoweb(file,"images/database/categories", options)
          .then((rsp:any)=>{
              console.log('rsp', rsp);
              if(rsp.vcode === 0){
                if(options.compress_type == 'no-compress'){

                }else if(options.compress_type == 'compress-screen'){
                  
                }else if(options.compress_type == 'compress-frame'){
                  
                }
              }else if(rsp.vcode === 1){

              }else if(rsp.vcode === 2){

              }else if(rsp.vcode === 3){

              }       
              this.vhComponent.showToast(2000, (this.languageService.translate("Image was loaded successfully")));      
          },error => {
            this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
          }
        );
  }
    * @param file 
    * @param path: 'images/database/categories' or 'images/database/categories/products'  
    * @param options: {compress_type, resolution}
    * @field compress_type: 
    * + 'no-compress': Không nén ảnh sau khi tải lên 
    * + 'compress-screen': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi thiết bị
    * + 'compress-frame': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi khung hình thiết bị
    * @field resolution: {} hoặc {width, height} của màn hình hoặc {width, height} của khung hình
    * @returns Object => obj = {vcode, msg, data} hoặc error 
    * vcode === 0 : upload ảnh thành công
    * vcode === 1 : lỗi import file ảnh
    * vcode === 2 : lỗi upload file ảnh
    * vcode === 3 : không thể upload file ảnh lớn hơn maxSize (byte)
    * vcode === 4 : import file ảnh không đúng định dạng
    */
  public getImageFromDesktop_Autoweb(file:any, path:any, options:any) { 
    return new Promise<any>((resolve, reject)=>{           
      let maxSize = 10000000; 
      //Sau này test và fix lỗi sau, chọn từ Desktop lần đầu ok, bấm vô chọn tiếp, click cancel báo file undefine     
      if((file == undefined)||(file === null)) return resolve({vcode:1, msg: 'lỗi import file ảnh'});           
      if((file.size > maxSize)) return resolve({vcode:3, msg: `không thể upload file ảnh lớn hơn ${maxSize} bytes`});        
      if(!((file.type ==='image/jpeg')||(file.type ==='image/jpg')||(file.type ==='image/png')||(file.type ==='image/gif')))  return resolve({vcode:4, msg: 'import file ảnh không đúng định dạng'});  
            
      const reader = new FileReader();
      reader.addEventListener('load', (event:any) => {    
        let type = file.type;    
        let filename = file.name;
        filename = filename.slice(0, filename.lastIndexOf('.'));
        //let randomId = Math.random().toString(36).substr(2, 5);
        //uploads img to máy chủ ảnh viethas        
        this.vhMGDB_image.uploadImage_Autoweb(event.target.result, type, filename, path, options)
            .then(photoURL => {                         
                resolve({vcode: 0, msg: "success", data:photoURL});                           
              },
              err => {         
                console.log('lỗi upload file ảnh', err);           
                resolve({vcode: 2, msg: "lỗi upload file ảnh", error: err});            
              })
      });
      reader.readAsDataURL(file);       

    })
  }


  /**
   * @example:Lấy hình file bất kỳ từ Desktop đẩy lên server với kích thước ko thay đổi
   * onUpload(e?) {
        const file = e.target.files[0];
        this.vhImage.uploadFileFromDesktop(file,"employees", this.img)
          .then((rsp:any)=>{
              console.log('rsp', rsp);
              if(rsp.vcode === 0){
                this.img = rsp.data;
                this.detailEmployee.controls["img"].setValue(this.img);                
                this.updateEmployee(this.detailEmployee.value);      
              }else if(rsp.vcode === 1){

              }else if(rsp.vcode === 2){

              }else if(rsp.vcode === 3){

              }       
              this.vhComponent.showToast(2000, (this.languageService.translate("Image was loaded successfully")));      
          },error => {
            this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
          }
        );
  }
    * @param file 
    * @param path: 'documents' or 'data/documents'  
    * @param oldFileURL : String   * 
    * @param maxSize : file có dung lượng tối đa cho phép, đơn vị byte
    * @notice : trường hợp cập nhật file, phải truyền vào hàm tham số oldFileURL để xóa file cũ đi, tránh làm server bị rác
    * @returns Object => obj = {vcode, message, data, error} 
    * vcode === 0 : upload file thành công
    * vcode === 1 : lỗi import file 
    * vcode === 2 : lỗi upload file
    * vcode === 3 : không thể upload file lớn hơn maxSize (byte)
    */
  public uploadFileFromDesktop(file:any, path:any, oldFileURL?:any, maxSize?:any) { 
    return new Promise<any>((resolve, reject)=>{  
      //Sau này test và fix lỗi sau, chọn từ Desktop lần đầu ok, bấm vô chọn tiếp, click cancel báo file undefine  
      if((file == undefined)||(file === null)) return resolve({vcode:1, message: 'lỗi import file'});           
      if((file.size > maxSize)) return resolve({vcode:3, message: `không thể upload file lớn hơn ${maxSize} bytes`});    

      if((oldFileURL === null) || (oldFileURL === undefined) || (oldFileURL?.length <30)){ //dùng trong trường hợp tên file hình mặc định, có chiều dài nhỏ hơn 40
      }else{          
          this.deleteThumbnail([oldFileURL]).then(
            (success) => {                                         
            },
            (error) => {
              console.log("link file muốn xóa, ko tồn tại trên imageserver ", error);
            });                    
      }    
      const reader = new FileReader();
      reader.addEventListener('load', (event:any) => {    
        let type = file.type;    
        let filename = file.name;
        filename = filename.slice(0, filename.lastIndexOf('.'));
        //let randomId = Math.random().toString(36).substr(2, 5);
        //uploads img to firebase storage
        this.vhMGDB_image.uploadFile(event.target.result, type, filename, path)
            .then(
              fileURL => {                    
                resolve({vcode: 0, message: "success", data:fileURL});                           
              },
              err => {      
                resolve({vcode: 2, message: "lỗi upload file", error: err});            
              })
      });
      reader.readAsDataURL(file);       
      
    })
  } 

  private uploadfile_danglam(files:any, path:string, folder:string){
    return new Promise<any>((resolve, reject)=>{  
      /*//console.log('file', file);      
      if((file != undefined)){//chọn từ Desktop lần đầu ok, bấm vô chọn tiếp, click cancel báo file undefine     
         
        const reader = new FileReader();
        reader.addEventListener('load', (event:any) => {    
          let type = file.type;    
          let filename = file.name;
          console.log('---type', type);
          console.log('---filename', filename);
          console.log('---event', event);
          //filename = filename.slice(0, filename.lastIndexOf('.'));
          //let randomId = Math.random().toString(36).substr(2, 5);
          //uploads img to firebase storage
          this.vhMGDB_image.uploadfile(filename, path, folder)
              .then(
                photoURL => {    
                  resolve(photoURL);
                  //resolve({vcode: 0, message: "success", data:photoURL});                           
                },
                err => {      
                  //resolve({vcode: 2, message: "lỗi upload file ảnh", error: err});            
                })
        });
        reader.readAsDataURL(file);       
      }else{
        reject({error: "lỗi import file ảnh"});
      }*/
      this.vhMGDB_image.uploadfile_danglam(files, path, folder)
          .then(
            photoURL => {    
              resolve(photoURL);
              //resolve({vcode: 0, message: "success", data:photoURL});                           
            },
            err => {      
              //resolve({vcode: 2, message: "lỗi upload file ảnh", error: err});            
            })
    })
  }
/**
   * @example:Lấy hình ảnh từ url đẩy lên server với kích thước tùy chỉnh
   * onUpload(e?) {
        const file = e.target.files[0];
        this.vhImage.getThumbnailFromUrl(file, 128, 128, "employees", this.img).then(
          photoURL => {             
              this.img = photoURL;
              this.detailEmployee.controls["img"].setValue(photoURL);
              this.vhComponent.showToast(2000, (this.languageService.translate("Image was loaded successfully")));
              this.updateEmployee(this.detailEmployee.value);
            }            
          },error => {
            this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
          }
        );
  }
    * @param file 
    * @param w 
    * @param h 
    * @param path: 'products' or 'data/products'  
    * @param oldthumbnailURL : String
    * @returns 
    * @notice: trường hợp cập nhật hình ảnh, phải truyền vào hàm tham số oldthumbnailURL để xóa ảnh cũ đi, tránh làm server bị rác
    */
  public getThumbnailFromUrl(url:any, w:any, h:any, path:any, oldthumbnailURL?:any) { 
    return new Promise<any>((resolve, reject)=>{  
      //console.log('oldthumbnailURL', oldthumbnailURL);      
      if((url != undefined)){//chọn từ Desktop lần đầu ok, bấm vô chọn tiếp, click cancel báo file undefine          
        if((oldthumbnailURL === null) || (oldthumbnailURL === undefined) || (oldthumbnailURL?.length <30)){ //dùng trong trường hợp tên file hình mặc định, có chiều dài nhỏ hơn 40
        }else{          
            this.deleteThumbnail([oldthumbnailURL]).then(
              (success) => {                                         
              },
              (error) => {
                console.log("link hình muốn xóa, ko tồn tại trên imageserver ", error);
              });                    
        }   
        let _this = this;
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();           
            reader.onloadend = function() {
              let type = 'image/jpeg';   
              let filename = url;
              if((filename.lastIndexOf('/') != -1)&&(filename.lastIndexOf('.') != -1)){
                filename = filename.slice(filename.lastIndexOf('/')+1, filename.lastIndexOf('.'));
              }else{
                filename = Math.random().toString(36).substr(2, 8);
              }              
              //uploads img to firebase storage
              _this.vhMGDB_image.uploadThumbnail(reader.result, type, w, h, filename, path)
                  .then(
                    photoURL => {    
                      resolve(photoURL);                                              
                    },
                    err => {      
                      reject(err)     
                    })                
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();           
      }else{
        reject({error: "lỗi import file ảnh"});
      }
    })
  }
  
  /**
   * @example:Lấy hình ảnh từ url đẩy lên server với kích thước hình ko thay đổi     
    this.vhImage.getImageFromURL(url,"images/design/objects")
      .then((rsp:any)=>{
          console.log('rsp', rsp);
          if(rsp.vcode === 0){
            this.img = rsp.data;          
          }else if(rsp.vcode === 1){

          }else if(rsp.vcode === 2){

          }else if(rsp.vcode === 3){

          }                
      },error => {
        
      }
    );
    * @param file 
    * @param path: 'images/database/products' or 'images/design/blocks' 
    * @param oldthumbnailURL : String   * 
    * @notice : trường hợp cập nhật hình ảnh, phải truyền vào hàm tham số oldthumbnailURL để xóa ảnh cũ đi, tránh làm server bị rác
    * @returns Object => obj = {vcode, message, data, error} 
    * vcode === 0 : upload ảnh thành công
    * vcode === 1 : lỗi import file ảnh
    * vcode === 2 : lỗi upload file ảnh
    * vcode === 3 : không thể upload file ảnh lớn hơn 1Mb
    */
  public getImageFromURL(url:any, path:any, oldthumbnailURL?:any) { 
    return new Promise<any>((resolve, reject)=>{  
      //console.log('file', file);      
      if((url != undefined)){
          //return resolve({vcode:1, message: 'lỗi import file ảnh'}); 
        //if((file.size > 1048576)) return resolve({vcode:3, message: 'không thể upload file ảnh lớn hơn 1Mb'});      
        if((oldthumbnailURL === null) || (oldthumbnailURL === undefined) || (oldthumbnailURL?.length <30)){ //dùng trong trường hợp tên file hình mặc định, có chiều dài nhỏ hơn 40
        }else{          
            this.deleteThumbnail([oldthumbnailURL]).then(
              (success) => {                                         
              },
              (error) => {
                console.log("link hình muốn xóa, ko tồn tại trên imageserver ", error);
              });                    
        }    
        let _this = this;
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();           
            reader.onloadend = function() {
              let type = 'image/jpeg';   
              let filename = url;
              if((filename.lastIndexOf('/') != -1)&&(filename.lastIndexOf('.') != -1)){
                filename = filename.slice(filename.lastIndexOf('/')+1, filename.lastIndexOf('.'));
                filename = decodeURI(filename);
              }else{
                filename = Math.random().toString(36).substr(2, 8);
              }              
              //uploads img to firebase storage
              _this.vhMGDB_image.uploadImage(reader.result, type, filename, path)
                  .then(
                    photoURL => {    
                      resolve(photoURL);                                              
                    },
                    err => {      
                      reject(err)     
                    })                
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();          
      }else{
        reject({error: "lỗi import file ảnh"});
      }
    })
  } 

/**
 * Lấy hình ảnh từ url đẩy lên server với kích thước hình theo options truyền vào
 * @example:  
  this.vhImage.getImageFromURL_Autoweb(url,"images/design/objects")
    .then((rsp:any)=>{
        console.log('rsp', rsp);
        if(rsp.vcode === 0){
          if(options.compress_type == 'no-compress'){

          }else if(options.compress_type == 'compress-screen'){
            
          }else if(options.compress_type == 'compress-frame'){
            
          }
        }else if(rsp.vcode === 1){

        }else if(rsp.vcode === 2){

        }else if(rsp.vcode === 3){

        }                   
    },error => {
      
    }
  );
  * @param url: đường link ảnh (sống) tồn tại trên mạng internet 
  * @param path: 'images/database/categories' or 'images/database/categories/products'  
  * @param options: {compress_type, resolution}
  * @field compress_type: 
  * + 'no-compress': Không nén ảnh sau khi tải lên 
  * + 'compress-screen': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi thiết bị
  * + 'compress-frame': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi khung hình thiết bị
  * @field resolution: {} hoặc {width, height} của màn hình hoặc {width, height} của khung hình
  * @returns Object => obj = {vcode, msg, data} hoặc error 
  * vcode === 0 : upload ảnh thành công
  * vcode === 1 : lỗi import file ảnh
  * vcode === 2 : lỗi upload file ảnh
  * vcode === 3 : không thể upload file ảnh lớn hơn maxSize (byte)
  * vcode === 4 : import file ảnh không đúng định dạng
  */
  public getImageFromURL_Autoweb(url:any, path:any, options:any) { 
    return new Promise<any>((resolve, reject)=>{  
      if((url == undefined)||(url === null)||(url === '')) return resolve({vcode:1, msg: 'lỗi import file ảnh'});       
      if((url != undefined)){
        let _this = this;
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();           
            reader.onloadend = function() {
              let type = 'image/jpeg';   
              let filename = url;
              if((filename.lastIndexOf('/') != -1)&&(filename.lastIndexOf('.') != -1)){
                filename = filename.slice(filename.lastIndexOf('/')+1, filename.lastIndexOf('.'));
                filename = decodeURI(filename);
              }else{
                filename = Math.random().toString(36).substr(2, 8);
              }              
              //uploads img to firebase storage
              // _this.vhMGDB_image.uploadImage(reader.result, type, filename, path)
              //     .then(
              //       photoURL => {    
              //         resolve(photoURL);                                              
              //       },
              //       err => {      
              //         reject(err)     
              //       })             
              _this.vhMGDB_image.uploadImage_Autoweb(reader.result, type, filename, path, options)
                  .then(photoURL => {    
                      //resolve(photoURL);                
                      resolve({vcode: 0, msg: "success", data:photoURL});                           
                    },
                    err => {          
                      console.log('lỗi upload file ảnh', err);                
                      resolve({vcode: 2, msg: "lỗi upload file ảnh"});            
                    })   
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();          
      }else{
        resolve({vcode:1, msg: 'lỗi import file ảnh'});  
      }
    })
  } 

  
/**
   * @example:Lấy hình ảnh từ nút insertImange của toolbar của Ckeditor
    public onReady(editor: any): void {
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
      editor.plugins.get('FileRepository').createUploadAdapter = (
        loader: any
      ) => {     
        return this.vhImage.MyUploadImageAdapter(loader,128, 128, "employees")     
      };
    }
    * @param file 
    * @param w 
    * @param h 
    * @param path: 'products' or 'data/products' 
    * @returns class
    * @notice: hàm này chỉ insert ảnh, muốn xóa ảnh phải vào trình quản lý ảnh
    */
  public MyUploadImageAdapter(loader:any, path?:any,  w?:any, h?:any) { 
    return new MyUploadImageAdapter(loader, this, path, w, h);
  }  
  
/**
 * Lấy về danh sách thư mục, file trong thư mục định vị bởi đường dẫn path, số ảnh mỗi lần lấy về limit, và ở trang ảnh có số tứ tự là page
 * @example:
   this.vhImage.getImageFilenames("hinhanh/hinh")
        .then((rsp)=> {
          if(rsp.vcode ==0){
            //your code here...
          }
        },(error:any)=>{
          console.log('error', error);
        })
  * @param path : folder gốc (root) truyền vào "", hoặc dạng folder1/folder2/folder2
  * @returns Promise Array => array = {vcode, msg, data:[{name, type, path},{name, type, href}, limit, page, totalpages]; type = 0 là folder, type !=0 là file
  */
  public getImageFilenames(path:string, limit?:any, page?:any){    
    return this.vhMGDB_image.getImageFilenames(path, limit, page);     
  }

/**
 * Lấy về danh sách thư mục, file trong thư mục định vị bởi đường dẫn path theo mảng số thứ ảnh imgsordinal trong đường dẫn thư mục
 * @example:
   this.vhImage.getImageFilenames_byImgsOrdinal("images/database/products", [0,1,2,3,4,5])
        .then((rsp)=> {
          if(rsp.vcode ==0){
            //your code here...
          }
        },(error:any)=>{
          console.log('error', error);
        })
  * @param path : folder gốc (root) truyền vào "", hoặc dạng folder1/folder2/folder2
  * @returns Promise Array => array = {vcode, msg, data:[{name, type, path},{name, type, href}, imgsordinal, totalimgs]; type = 0 là folder, type !=0 là file
  */
  public getImageFilenames_byImgsOrdinal(path:string, imgsordinal:any){    
    return this.vhMGDB_image.getImageFilenames_byImgsOrdinal(path, imgsordinal);     
  }

  /**
 * Tạo thư mục mới trong thư mục định vị bởi đường dẫn path
 * @example:
   this.vhImage.createImageFolder("hinhanh", "hinh")
        .then((child_list)=> {
          //your code here...
        },(error:any)=>{
          console.log('error', error);
        })
  * @param path : folder gốc (root) truyền vào "", hoặc dạng folder1/folder2/folder2
  * @param folder : tên thư mục
  * @returns Array => array = [{name, type, path},{name, type, href}]; type = 0 là folder, type !=0 là file
  */
  public createImageFolder(path:string, folder:string){
    return this.vhMGDB_image.createImageFolder(path, folder);    
  }
  
  /**
 * Xóa thư mục, file (đang có) trong thư mục định vị bởi đường dẫn path
 * @example:
   this.vhImage.deleteImageFolder("hinhanh", "hinh")
        .then((child_list)=> {
          //your code here...
        },(error:any)=>{
          console.log('error', error);
        })
  * @param path : folder gốc (root) truyền vào "", hoặc dạng folder1/folder2/folder2
  * @param folder : tên thư mục
  * @returns Array => array = [{name, type, path},{name, type, href}]; type = 0 là folder, type !=0 là file
  */
  public deleteImageFolder(path:string, folder:string){
    return this.vhMGDB_image.deleteImageFolder(path, folder);
  }

  /**
  * Đổi tên thư mục (đang có) trong thư mục định vị bởi đường dẫn path thành tên khác
  * @example:
    this.vhImage.renameImageFolder("hinhanh", "hinh")
        .then((child_list)=> {
          //your code here...
        },(error:any)=>{
          console.log('error', error);
        })
  * @param path : folder gốc (root) truyền vào "", hoặc dạng folder1/folder2/folder2
  * @param folder : tên thư mục
  * @returns Array => array = [{name, type, path},{name, type, href}]; type = 0 là folder, type !=0 là file
  */
  public renameImageFolder(path:string, oldfolder:string, newfolder:string){
    return this.vhMGDB_image.renameImageFolder(path, oldfolder, newfolder)
  }
  
  /**
   * @example:
   * this.vhImage.deleteImage(thumbnailURL[i])
          .then(()=> {
            //your code here...
          },(error:any)=>{
            console.log('error', error);
          }) 
    * @param imageURL
    * @returns 
    */
  public deleteImage(imageURL:string){
    return this.vhMGDB_image.deleteImage(imageURL);
  } 
  
  /**
   *@example
      this.vhImage.deleteThumbnail([url_img, url_img1])
          .then(()=>{    
            //-----------your code here-----------                      
          },(error:any)=>{
              console.log('error', error)
          })
    * @param thumbnailURL : Array
    * @returns Promise => true or false : xóa thành công tất cả hình trong mảng về true, xóa không thành công hoặc link một hình sai trả về false
    */
  public deleteThumbnail(thumbnailURL:any){   
    return this.vhMGDB_image.deleteThumbnail([thumbnailURL]);
  }  

  
 
 }
   
 @Injectable()
 export class VhQuery{
   constructor(private vhMGDB_database: VhMGDB_database) {
   }
  /**
   * @example
   * this.vhQuery.listener('abc',{}).subscribe((data:any)=>{   
         console.log('data', data);
     })
   * @param colname 
   * @param condition 
   */
   private listener(colname:string, condition: object){
     return Observable.create((observer:any) => {
       this.vhMGDB_database.listener(colname, condition).subscribe((data:any)=>{   
         observer.next(data);
       })
     })
   }
 
   /**
    * @example:
    * this.vhQuery.addDoc('products', {name:'camera 2', quantity:20, price:200000})
             .then((response)=>{
               console.log('addDoc', response);
             },(error:any)=>{
               console.log('error', error);
             })  
    * @param colname 
    * @param data 
    * @return Promise => object = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addDoc(colname:string, data:object){
     return new Promise((resolve, reject) => {
       if(colname === 'vhbill_details') return resolve(null);
       else if(colname === 'printers') return resolve(null);
       else if(colname === 'vhpermissions') return resolve(null);
       else if(colname === 'vhemployees') return resolve(null);
       else if(colname === 'branchs') return resolve(null);
       else if(colname === 'appsettingstations') return resolve(null);
       this.vhMGDB_database.addDoc(colname, data)
           .then((response)=>{           
             resolve(response);
           },(error:any)=>{
             reject(error);
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuery.addDocbyID('products', 'nvliw974854hf848ugrgh3498', {name:'camera 2', quantity:20, price:200000})
             .then((response)=>{
               console.log('addDocbyID', response);
              }, error=>{
                console.log('error', error);
             })
    * @param colname 
    * @param data 
    * @return Promise => obj = {}
    * Luu y: truong hop trung _id nó sẽ báo lỗi error
    */
   public addDocbyID(colname:string, _id:string, data:object){
     return new Promise((resolve, reject) => {
       if(colname === 'vhbill_details') return resolve(null);
       else if(colname === 'printers') return resolve(null);
       else if(colname === 'vhpermissions') return resolve(null);
       else if(colname === 'vhemployees') return resolve(null);
       else if(colname === 'branchs') return resolve(null);
       else if(colname === 'appsettingstations') return resolve(null);
       this.vhMGDB_database.addDocbyID(colname, _id, data)
           .then((response)=>{
             resolve(response);
           }, error=>{
             reject(error);
          })          
     })
   }
 
   /**
    * @example:
    * this.vhQuery.updateDoc('products', '5fb6780ca2148e09806c5b01', {quantity:400})
             .then((bool:any)=>{
               console.log('updateDoc', bool);
             }, error=>{
               console.log('error', error);
             })
    * @param colname 
    * @param _id 
    * @param data 
    * @return Promise => bool = true or false
    */
   public updateDoc(colname:string, _id:string, data:object){
     return new Promise((resolve, reject) => {      
       if(colname === 'vhbill_details') return resolve(false);
       else if(colname === 'printers') return resolve(false);
       else if(colname === 'vhpermissions') return resolve(false);
       else if(colname === 'vhemployees') return resolve(false);
       else if(colname === 'branchs') return resolve(false);
       else if(colname === 'appsettingstations') return resolve(false);
       this.vhMGDB_database.updateDoc(colname, _id, data)
             .then((bool:any)=>{
               resolve(bool);
             }, error=>{
               reject(error);
             })                    
     })
   }
 
   /**
    * @example:
        * this.vhQuery.deleteDoc('products', '5fb67fda87c0f21d484cbdf3')
             .then(bool=>{
               console.log('deleteDoc', bool);
             })
    * @param colname 
    * @param _id 
    * @return Promise => bool = true or false
    */
   public deleteDoc(colname:string, _id:string){
     return new Promise((resolve, reject) => {
       if(colname === 'vhbill_details') return resolve(false);
       else if(colname === 'printers') return resolve(false);
       else if(colname === 'vhpermissions') return resolve(false);
       else if(colname === 'vhemployees') return resolve(false);
       else if(colname === 'branchs') return resolve(false);
       else if(colname === 'appsettingstations') return resolve(false);
       this.vhMGDB_database.deleteDoc(colname, _id)
             .then((bool:any)=>{
               resolve(bool);
             }, error=>{
               reject(error);
             })         
     })
   }
 
   /**
    * @example
    * this.vhQuery.getDoc('products', '5fb67fda87c0f21d484cbdf3')
             .then((product)=>{
               console.log('getDoc', product);
             },(error:any)=>{
               console.log('error', error);
             })
    * @param colname 
    * @param _id 
    * @return Promise => obj ={} or null
    */
   public getDoc(colname:string, _id:string){
     return new Promise((resolve,reject) => {
       if(colname === 'vhbill_details') return resolve(null);
       else if(colname === 'printers') return resolve(null);
       else if(colname === 'vhpermissions') return resolve(null);
       else if(colname === 'vhemployees') return resolve(null);
       else if(colname === 'branchs') return resolve(null);
       else if(colname === 'appsettingstations') return resolve(null);
       this.vhMGDB_database.getDoc(colname, _id)
             .then((response)=>{
               resolve(response);
             },(error:any)=>{
               reject(error)
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuery.getDoc('products', '5fb67fda87c0f21d484cbdf3')
             .then((response)=>{
               console.log('getDoc', response);
             })
    * @param colname 
    * @param _id 
    * @return array(object) = [{},{},..]
    */
   public getDocs(colname:string){
     return new Promise((resolve) => {
       if(colname === 'vhbill_details') return resolve([]);
       else if(colname === 'printers') return resolve([]);
       else if(colname === 'vhpermissions') return resolve([]);
       else if(colname === 'vhemployees') return resolve([]);
       else if(colname === 'branchs') return resolve([]);
       else if(colname === 'appsettingstations') return resolve([]);
       this.vhMGDB_database.getDocs(colname)
             .then((response)=>{
               resolve(response);
             })          
     })
   }
  
     /**
    * @example:
    * this.vhQuery.getDocsByFields('products', {name:{$eq:'name abc'}}, {},{},0)
       .then((products)=>{
         console.log('getDocsByFields', products);
       })
   * @param colname 
   * @param query
   * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
   * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
   * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
   * @return — Array -> array = [{},{},...] 
   */
   public getDocsByFields(colname:string, query: object, projection?:object, sort?:object, limit?:number){
     return new Promise((resolve) => {
       if(colname === 'vhbill_details') return resolve([]);
       else if(colname === 'printers') return resolve([]);
       else if(colname === 'vhpermissions') return resolve([]);
       else if(colname === 'vhemployees') return resolve([]);
       else if(colname === 'branchs') return resolve([]);
       else if(colname === 'appsettingstations') return resolve([]);
       this.vhMGDB_database.getDocsByFields(colname, query, projection, sort, limit)
             .then((response)=>{
               resolve(response);
             })          
     })
   }
 
   /**
    let promise = new Array();
    for(let i=0; i<length; i++){
      promise[i] = new Promise((resolve, reject)=>{});
    }
    this.asyncPromiseAll(promise)
       .then((array:any)=>{
         console.log(array);        
       },(error:any)=>{
         onsole.log(error); 
       })
    * @param array 
    * @return Promise Array_Value => array =[value1, value2,...]
    */
   public asyncPromiseAll(array_Promise:any):any{
     return new Promise((resolve, reject) => {       
       Promise.all(array_Promise)
               .then(array_Value => { 
                 resolve(array_Value);
               })
               .catch(error => { 
                 reject(error)
               })
     })    
   }
     
  
 }
 
 @Injectable()
 export class VhQueryCafe{  
  private paymentIOS = false;
  private restriction_main_package:any = null;
  private areas: any = new Array();
  private tables: any = new Array();

  private products: any = new Array();
  private detailproducts: any = new Array();
  private rawproducts: any = new Array();

  private customers: any = new Array();
  private suppliers: any = new Array();
  private dispatcherzones: any = new Array();
  private wallets: any = new Array();
  private taxs: any = new Array();
  private categorys: any = new Array();
  private inventorytimes: any = new Array();  
  private deliverys: any = new Array();
  private addresss: any = new Array();
  private incoming_groups: any = new Array();
  private spending_groups: any = new Array();
  private branchs: any = new Array();
  private promotions: any = new Array(); 
  private patternmenus: any = new Array(); 
  
  private printers: any = new Array();
  private print_pages: any = new Array();
  private discount_bills: any = new Array();
  private discount_saless: any = new Array();
  private customer_classs: any = new Array();
  private commissions: any = new Array();

  private hwinfo: any = {};
  private appsettingstations: any = new Array();
  private appsettingbranchs: any = new Array();
  private kitchendispatcherlist: any = new Array();
  private rawkitchendispatcherlist: any = new Array();
  private servicedispatcherlist: any = new Array();
  private warehousedispatcherlist: any = new Array();

  private subjectwallets = new Subject<any>();
  private subjectappsettingstations = new Subject<any>();
  private subjectappsettingbranchs = new Subject<any>();
  private subjectbranchs = new Subject<any>();
  private subjectcategorys = new Subject<any>();
  private subjectcustomers = new Subject<any>();
  private subjectinventorytimes = new Subject<any>();
  private subjectprinters = new Subject<any>();
  private subjectproducts = new Subject<any>();
  private subjectpromotions = new Subject<any>();
  private subjectsuppliers = new Subject<any>();
  private subjectdispatcherzones = new Subject<any>();
  private subjecttaxs = new Subject<any>();
  private subjectareas = new Subject<any>();
  private subjecttables = new Subject<any>();
  private subjectlistbilltype5 = new Subject<any>();
  private syncLocalBillType5_start = true;
  private subjectdiscount_bills = new Subject<any>(); 
  private subjectcustomer_classs = new Subject<any>(); 
  private callbackdispatcher: Subscription = new Subscription();
  
  private callbacksyncopeningbill:Subscription = new Subscription();
  private listbill_bybilltype:any= new Array();
  private callback1syncbilltype:Subscription = new Subscription();
  private callback2syncbilltype:Subscription = new Subscription();
  private sync_code:any =  Math.random().toString(36).substr(2, 10).toUpperCase();
   private colname_array = new Array();

  /**
   * @Nghiệp vụ tạo (bill_type 5->1), hủy đơn hàng bán món ăn (dùng hàm)
   * {createBill, getBill} -> {createBill_detail, updateBill_detail, deleteBill_detail} -> {saveBill_Billdetail, deleteBill_Billdetail}
   * @Nghiệp vụ cập nhật hóa đơn bán hàng món ăn (dùng hàm)
   * {getBill, getBill_Billdetail} -> {updateBill_Billdetail}
   * @Nghiệp vụ tạo, cập nhật, hủy đơn xuất nhập nguyên liệu (dùng hàm)
   * {createBill_Billdetail} -> {updateBill_Billdetail, deleteBill_Billdetail}
   */
  constructor(   
    private vhMGDB_auth:VhMGDB_auth, 
    private vhMGDB_database: VhMGDB_database,
    private vhMGDB_rootdatabase: VhMGDB_rootdatabase, 
    private vhMGDB_socketMongoDB: VhMGDB_socketMongoDB, 
    private vhMGDB_paymentVNPAY: VhMGDB_paymentVNPAY,
    
    
    private vhQuery:VhQuery, 
    private vhAuth: VhAuth, 
    private vhAlgorithm:VhAlgorithm,
    private vhDisplayLEDService :VhDisplayLEDService
    ) {
    Device.getId().then((info:any)=>{
      let local_hwinfo = this.vhAuth.localStorageGET('hwinfo');
      if((local_hwinfo != null)&&(local_hwinfo != undefined)){
        this.hwinfo = local_hwinfo;       
      }else{
       this.hwinfo = {uuid: info.identifier};    
        this.vhAuth.localStorageSET('hwinfo',this.hwinfo);        
      }           
    });      
  }

   
 /**
  * Hàm trả về năm của billdate
  * @param billdate 
  * @returns 
  */
 private getYear(billdate:any){
   return (new Date(billdate)).getFullYear();
 }

 /**
   * Hàm trả về mảng (năm), gồm những năm từ năm tạo shop (thời điểm khách dùng phần mềm) đến năm hiện tại
   * @returns 
   */
 private getYearsArray(){
   let startyear = (new Date(this.vhAuth.getStore()?.registrationdate)).getFullYear();
   let endyear = (new Date()).getFullYear(); 
   let arr_years = new Array();
   arr_years.push(startyear);
   while(arr_years[arr_years.length-1] <endyear){
     arr_years.push(arr_years[arr_years.length-1] + 1);
   }
   return arr_years;
 }
 /**
   * Hảm trả về mảng năm liên tiếp tương ứng trường date có trong tham số query truyền vào,
   * nếu trong query không có trường date thì lấy từ hàm getYearsArray()
   * @param query 
   * @returns 
   */
 private getYearsArray_fromQuery(query:any){
   let vals = new Array();
   let query_years = new Array();
   for(const p in query){
     if(p=='date'){
       for(const q in query[p]){         
         vals.push(query[p][q].getFullYear());                      
       }
     }
   }
   //loại bỏ những phần tử có giá trị trùng nhau trong mảng
   vals = [...new Set(vals)];
   if(vals.length == 0){
     query_years = this.getYearsArray();
   }else if(vals.length == 1){
     query_years.push(vals[0]);
   }else if(vals.length == 2){
     //sắp xếp tăng dần
     vals = vals.sort((n1:any, n2:any) => {
       if (n1 > n2) return 1;
       return -1;
     });
     //tạo mạng những năm liên tiếp
     for (let i = vals[0]; i <= vals[1]; i++) {
       query_years.push(i);
     }
   }
   //console.log('query_years', query_years)
   return query_years;
 }

  /**
 * Hàm này lấy về các trường trong phạm vi quản lý bán hàng trong cài đặt
  * @example:
  * let branch_management_scope = this.vhQueryCafe.getBranch_Management_Scope();        
  * @return Object = {product_scope, employee_scope, customer_scope, supplier_scope, cafe_program_scope}
  *  => true áp dụng cho toàn chi nhánh, false áp dụng riêng cho từng chi nhánh
  */
   public getBranch_Management_Scope(){    
    if(this.vhAuth.getStore().branch_management_scope != undefined){
      let branch_management_scope = {...this.vhAuth.getStore().branch_management_scope};
      if(branch_management_scope.product_scope === undefined) branch_management_scope.product_scope = true;
      if(branch_management_scope.employee_scope === undefined) branch_management_scope.employee_scope = true;
      if(branch_management_scope.customer_scope === undefined) branch_management_scope.customer_scope = true;
      if(branch_management_scope.supplier_scope === undefined) branch_management_scope.supplier_scope = true;
      if(branch_management_scope.cafe_program_scope === undefined) branch_management_scope.cafe_program_scope = true;
      return branch_management_scope;
    }else{
      return {product_scope:true, employee_scope:true, customer_scope: true, supplier_scope:true, cafe_program_scope:true}
    }
  }

  /**
   * Hàm này cấp nhật lại các trường trong phạm vi quản lý bán hàng trong cài đặt
   * @example:
   * this.vhQueryCafe.updateBranch_Management_Scope({product_scope:1, employee_scope:1, customer_scope:1, supplier_scope:1, sales_program_scope:2})
          .then(()=>{
            console.log('updateBranch_Management_Scope');
          }, error=>{
            reject(error);
          })
   * @param value = {product_scope, employee_scope, customer_scope, supplier_scope, sales_program_scope}
   * true áp dụng cho toàn chi nhánh, false áp dụng riêng cho từng chi nhánh
   * @return Promise => udefined/error
   */
  public updateBranch_Management_Scope(value:any){    
    return new Promise((resolve, reject) => {
      let branch_management_scope:any = this.getBranch_Management_Scope();        
      for(const q in value){                   
        branch_management_scope[q] = value[q];            
      }     
      this.vhMGDB_database.updateDoc_onRootCollectionsFirebase('stores', this.vhMGDB_auth.getDatabase(), {branch_management_scope})
            .then(()=>{        
              this.vhMGDB_auth.setStore({branch_management_scope})                    
              resolve(undefined);  
            }, error=>{
              reject(error);
            })
    })
  }


  /**
   * @description: hàm này lấy về những hạn chế của gói main_package trong localstorage
   * @example
   * let restriction_main_package = this.vhQueryCafe.getLocalRestrictionMainPackage();         
   * @return Object => obj ={} or null
   */
    public getLocalRestrictionMainPackage(){
      let id_branch = this.getDefaultBranch()._id;
      this.restriction_main_package = {...this.vhAuth.getStore()[id_branch]['main_package_expire']}
      delete this.restriction_main_package.id_restriction;    
      delete this.restriction_main_package.id_package;
      delete this.restriction_main_package.id_licenseKEY;
      return this.restriction_main_package;
    }

   /**
   * @example:
    this.vhQueryCafe.syncCollections_Mobile().then((bool:any)=>{
        if(bool){
          do something...
        }
    })
   * @returns Promise bool = true or false
   */
    public syncCollections_Mobile(){    
      return new Promise((resolve, reject)=>{       
        let promise_zero = new Array();      
        promise_zero[promise_zero.length] = this.getLocalLiveIndexDB();    
        Promise.all(promise_zero)
          .then(()=>{     
            let promise_one = new Array();    
            this.initSyncCollections();
            promise_one[promise_one.length] = this.callbackCollectionInsert();        
            promise_one[promise_one.length] = this.callbackCollectionUpdate();
            promise_one[promise_one.length] = this.callbackCollectionDelete();            
            Promise.all(promise_one)
                .then(()=>{                                
                    let promise_two = new Array();                      
                    promise_two[promise_two.length] = this.vhAuth.refreshLocalMyPermission(); 
                    promise_two[promise_two.length] = this.refreshLocalDeliverys(); 
                    promise_two[promise_two.length] = this.refreshLocalAddresss();
                    promise_two[promise_two.length] = this.checkExpireBranch_Cafe();       
                    promise_two[promise_two.length] = this.refreshLocalPrintPages();
                    Promise.all(promise_two)
                        .then(()=>{  
                          this.syncCashBookEveryDay_Stock1stDayOfMonth()
                              .then(()=>{
                                this.syncInventoryEveryDay_Stock1stDayOfMonth()
                                    .then(()=>{
                                      resolve(true);
                                    })             
                              })   
                        })
                  })  
        })     
      })    
    }
    

  /**
   * @example:
    this.vhQueryCafe.syncCollections_Desktop().then((bool:any)=>{
        if(bool){
          do something...
        }
    })
   * @returns Promise bool = true or false
   */
  public syncCollections_Desktop(){    
    return new Promise((resolve, reject)=>{         
      let promise_zero = new Array();      
      promise_zero[promise_zero.length] = this.getLocalLiveIndexDB();    
      Promise.all(promise_zero)
         .then(()=>{          
            let promise_one = new Array();    
            this.initSyncCollections();     
            promise_one[promise_one.length] = this.callbackCollectionInsert();         
            promise_one[promise_one.length] = this.callbackCollectionUpdate();      
            promise_one[promise_one.length] = this.callbackCollectionDelete();           
            Promise.all(promise_one)
                .then(()=>{                                
                  let promise_two = new Array();                      
                  promise_two[promise_two.length] = this.vhAuth.refreshLocalMyPermission(); 
                  promise_two[promise_two.length] = this.refreshLocalDeliverys(); 
                  promise_two[promise_two.length] = this.refreshLocalAddresss();
                  promise_two[promise_two.length] = this.checkExpireBranch_Cafe();         
                  promise_two[promise_two.length] = this.refreshLocalPrintPages();
                  promise_two[promise_two.length] = this.vhDisplayLEDService.refreshLocalDisplayLEDs_byEnable();
                  Promise.all(promise_two)
                        .then(()=>{  
                          this.syncCashBookEveryDay_Stock1stDayOfMonth()
                              .then(()=>{
                                this.syncInventoryEveryDay_Stock1stDayOfMonth()
                                    .then(()=>{
                                      resolve(true);
                                    })             
                              })   
                        })            
                })     
        }) 
    })    
  }

  private checkExpireBranch_Cafe(){    
   return new Promise((resolve, reject)=>{ 
      let branch = this.getDefaultBranch();      
      if(branch){
        let id_branch = this.getDefaultBranch()._id;
        this.vhMGDB_auth.checkExpireBranch_Cafe(id_branch)
            .then(()=>{
              console.log('success checkExpireBranch_Cafe');
              resolve(true);
            }, error=>{
              console.log('no success checkExpireBranch_Cafe');
              reject(error);
            })
      }
   })
  }

  private checkExpireBranch_Sales365(){    
   return new Promise((resolve, reject)=>{ 
      let branch = this.getDefaultBranch();      
      if(branch){
        let id_branch = this.getDefaultBranch()._id;
        this.vhMGDB_auth.checkExpireBranch_Sales365(id_branch)
            .then(()=>{
               resolve(true);
            }, error=>{
               reject(error);
            })
      }
   })
  }

   /**
   * @example:
    this.vhQueryCafe.syncCollections_Sales365_Mobile().then((bool:any)=>{
        if(bool){
          do something...
        }
    })
   * @returns Promise bool = true or false
   */
    public syncCollections_Sales365_Mobile(){    
     return new Promise((resolve, reject)=>{           
        let promise_zero = new Array();      
        promise_zero[promise_zero.length] = this.getLocalLiveIndexDB();    
        Promise.all(promise_zero)
          .then(()=>{         
            let promise_one = new Array();    
            this.initSyncCollections();
            promise_one[promise_one.length] = this.callbackCollectionInsert();        
            promise_one[promise_one.length] = this.callbackCollectionUpdate();
            promise_one[promise_one.length] = this.callbackCollectionDelete();           
            Promise.all(promise_one)
                .then(()=>{                                
                    let promise_two = new Array();                      
                    promise_two[promise_two.length] = this.vhAuth.refreshLocalMyPermission(); 
                    promise_two[promise_two.length] = this.refreshLocalDeliverys(); 
                    promise_two[promise_two.length] = this.refreshLocalAddresss();     
                    promise_two[promise_two.length] = this.refreshLocalPrintPages();
                    promise_two[promise_two.length] = this.checkExpireBranch_Sales365(); 
                    Promise.all(promise_two)
                        .then(()=>{  
                          this.syncCashBookEveryDay_Stock1stDayOfMonth()
                              .then(()=>{
                                this.syncInventoryEveryDay_Stock1stDayOfMonth()
                                    .then(()=>{
                                      resolve(true);
                                    })             
                              })   
                        })
                  })      
          }) 
     })    
   }

   /**
   * @example:
    this.vhQueryCafe.syncCollections_Sales365_Desktop().then((bool:any)=>{
        if(bool){
          do something...
        }
    })
   * @returns Promise bool = true or false
   */
  public syncCollections_Sales365_Desktop(){   
   return new Promise((resolve, reject)=>{      
      let promise_zero = new Array();      
      promise_zero[promise_zero.length] = this.getLocalLiveIndexDB();    
      Promise.all(promise_zero)
         .then(()=>{               
            let promise_one = new Array();    
            this.initSyncCollections();     
            promise_one[promise_one.length] = this.callbackCollectionInsert();         
            promise_one[promise_one.length] = this.callbackCollectionUpdate();      
            promise_one[promise_one.length] = this.callbackCollectionDelete();           
            Promise.all(promise_one)
                .then(()=>{                              
                  let promise_two = new Array();                      
                  promise_two[promise_two.length] = this.vhAuth.refreshLocalMyPermission(); 
                  promise_two[promise_two.length] = this.refreshLocalDeliverys(); 
                  promise_two[promise_two.length] = this.refreshLocalAddresss();       
                  promise_two[promise_two.length] = this.refreshLocalPrintPages();
                  promise_two[promise_two.length] = this.checkExpireBranch_Sales365(); 
                  promise_two[promise_two.length] = this.vhDisplayLEDService.refreshLocalDisplayLEDs_byEnable();
                  Promise.all(promise_two)
                        .then(()=>{  
                          this.syncCashBookEveryDay_Stock1stDayOfMonth()
                              .then(()=>{
                                this.syncInventoryEveryDay_Stock1stDayOfMonth()
                                    .then(()=>{
                                      resolve(true);
                                    })             
                              })   
                        })            
                })  
        })    
   })    
 }

 
 /**
  * vhQueryCafe
  * Hàm này lấy về tất cả các collections mà firebase lưu trong cache ứng dụng, dữ liệu trong cache này dùng ko mất phí
  * @returns 
  */
 private async getLocalLiveIndexDB(){
  return new Promise((resolve, reject)=>{
    let promise_zero = new Array();
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('products')
            .then((products:any)=>{
              //this.products = products;
              if(products.length){
                let updatedAt = 1609434000000;
                products.forEach((product:any) => {
                  //console.log("-product", product); 
                  this.syncRaw_Detail_ProductInsert(product);
                  if(product.updatedAt != undefined){
                    if(product.updatedAt > updatedAt) updatedAt = product.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'products', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'products', syncAll: true});
              }     
              //console.log("products", products);      
              resolve(null);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('customers')
            .then((customers)=>{
              this.customers = customers;
              if(this.customers.length){
                let updatedAt = 1609434000000;
                this.customers.forEach((customer:any) => {
                  if(customer.updatedAt != undefined){
                    if(customer.updatedAt > updatedAt) updatedAt = customer.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'customers', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'customers', syncAll: true});
              }     
              //console.log("this.customers", customers);          
              resolve(customers);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('suppliers')
            .then((suppliers)=>{
              this.suppliers = suppliers;
              if(this.suppliers.length){
                let updatedAt = 1609434000000;
                this.suppliers.forEach((supplier:any) => {
                  if(supplier.updatedAt != undefined){
                    if(supplier.updatedAt > updatedAt) updatedAt = supplier.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'suppliers', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'suppliers', syncAll: true});
              }     
              //console.log("this.suppliers", suppliers);          
              resolve(suppliers);
            },(error:any)=>{
              reject(error);
            })            
    })
     promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('categorys')
            .then((categorys)=>{
              this.categorys = categorys;
              if(this.categorys.length){
                let updatedAt = 1609434000000;
                this.categorys.forEach((category:any) => {
                  if(category.updatedAt != undefined){
                    if(category.updatedAt > updatedAt) updatedAt = category.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'categorys', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'categorys', syncAll: true});
              }     
              //console.log("this.categorys", categorys);          
              resolve(categorys);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('wallets')
            .then((wallets)=>{
              this.wallets = wallets;
              if(this.wallets.length){
                let updatedAt = 1609434000000;
                this.wallets.forEach((wallet:any) => {
                  if(wallet.updatedAt != undefined){
                    if(wallet.updatedAt > updatedAt) updatedAt = wallet.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'wallets', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'wallets', syncAll: true});
              }     
              //console.log("this.wallets", wallets);          
              resolve(wallets);
            },(error:any)=>{
              reject(error);
            })            
    })
         promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('taxs')
            .then((taxs)=>{
              this.taxs = taxs;
              if(this.taxs.length){
                let updatedAt = 1609434000000;
                this.taxs.forEach((tax:any) => {
                  if(tax.updatedAt != undefined){
                    if(tax.updatedAt > updatedAt) updatedAt = tax.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'taxs', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'taxs', syncAll: true});
              }     
              //console.log("this.taxs", taxs);          
              resolve(taxs);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('vhemployees')
            .then((employees:any)=>{
              if(employees.length){
                let updatedAt = 1609434000000;
                employees.forEach((employee:any) => {
                  this.vhAuth.insertlocalEmployeeFromSyncCollection(employee);   
                  if(employee.updatedAt != undefined){
                    if(employee.updatedAt > updatedAt) updatedAt = employee.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'vhemployees', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'vhemployees', syncAll: true});
              }     
              //console.log("vhemployees", employees);          
              resolve(employees);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('printers')
            .then((printers)=>{
              this.printers = printers;
              if(this.printers.length){
                let updatedAt = 1609434000000;
                this.printers.forEach((printer:any) => {
                  if(printer.updatedAt != undefined){
                    if(printer.updatedAt > updatedAt) updatedAt = printer.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'printers', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'printers', syncAll: true});
              }     
              //console.log("this.printers", printers);          
              resolve(printers);
            },(error:any)=>{
              reject(error);
            })            
    })
         promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('appsettingstations')
            .then((appsettingstations)=>{
              this.appsettingstations = appsettingstations;
              if(this.appsettingstations.length){
                let updatedAt = 1609434000000;
                this.appsettingstations.forEach((appsettingstation:any) => {
                  if(appsettingstation.updatedAt != undefined){
                    if(appsettingstation.updatedAt > updatedAt) updatedAt = appsettingstation.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'appsettingstations', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'appsettingstations', syncAll: true});
              }     
              //console.log("this.appsettingstations", appsettingstations);          
              resolve(appsettingstations);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('appsettingbranchs')
            .then((appsettingbranchs)=>{
              this.appsettingbranchs = appsettingbranchs;
              if(this.appsettingbranchs.length){
                let updatedAt = 1609434000000;
                this.appsettingbranchs.forEach((appsettingbranch:any) => {
                  if(appsettingbranch.updatedAt != undefined){
                    if(appsettingbranch.updatedAt > updatedAt) updatedAt = appsettingbranch.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'appsettingbranchs', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'appsettingbranchs', syncAll: true});
              }     
              //console.log("this.appsettingbranchs", appsettingbranchs);          
              resolve(appsettingbranchs);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('discount_bills')
            .then((discount_bills)=>{
              this.discount_bills = discount_bills;
              if(this.discount_bills.length){
                let updatedAt = 1609434000000;
                this.discount_bills.forEach((discount_bill:any) => {
                  if(discount_bill.updatedAt != undefined){
                    if(discount_bill.updatedAt > updatedAt) updatedAt = discount_bill.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'discount_bills', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'discount_bills', syncAll: true});
              }     
              //console.log("this.discount_bills", discount_bills);          
              resolve(discount_bills);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('customer_classs')
            .then((customer_classs)=>{
              this.customer_classs = customer_classs;
              if(this.customer_classs.length){
                let updatedAt = 1609434000000;
                this.customer_classs.forEach((customer_class:any) => {
                  if(customer_class.updatedAt != undefined){
                    if(customer_class.updatedAt > updatedAt) updatedAt = customer_class.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'customer_classs', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'customer_classs', syncAll: true});
              }     
              //console.log("this.customer_classs", customer_classs);          
              resolve(customer_classs);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('areas')
            .then((areas)=>{
              this.areas = areas;
              if(this.areas.length){
                let updatedAt = 1609434000000;
                this.areas.forEach((area:any) => {
                  if(area.updatedAt != undefined){
                    if(area.updatedAt > updatedAt) updatedAt = area.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'areas', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'areas', syncAll: true});
              }     
              //console.log("this.areas", areas);          
              resolve(areas);
            },(error:any)=>{
              reject(error);
            })            
    })
        promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('tables')
            .then((tables)=>{
              this.tables = tables;
              if(this.tables.length){
                let updatedAt = 1609434000000;
                this.tables.forEach((table:any) => {
                  if(table.updatedAt != undefined){
                    if(table.updatedAt > updatedAt) updatedAt = table.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'tables', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'tables', syncAll: true});
              }     
              //console.log("this.tables", tables);          
              resolve(tables);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('vhs_dispatcherzones')
            .then((dispatcherzones)=>{
              this.dispatcherzones = dispatcherzones;
              if(this.dispatcherzones.length){
                let updatedAt = 1609434000000;
                this.dispatcherzones.forEach((dispatcherzone:any) => {
                  if(dispatcherzone.updatedAt != undefined){
                    if(dispatcherzone.updatedAt > updatedAt) updatedAt = dispatcherzone.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'vhs_dispatcherzones', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'vhs_dispatcherzones', syncAll: true});
              }     
              //console.log("this.dispatcherzones", dispatcherzones);          
              resolve(dispatcherzones);
            },(error:any)=>{
              reject(error);
            })            
    })
    Promise.all(promise_zero)
          .then(arr=>{
            resolve(null);
          })
  })
 }



  private initSyncCollections(){      
    // this.categorys = new Array();
    // this.printers = new Array();    
    // this.suppliers = new Array();
    // this.customers = new Array();
    // this.dispatcherzones = new Array();
    // this.wallets = new Array();
    // this.areas = new Array();
    // this.tables = new Array();  
    // this.taxs = new Array();    
    // this.appsettingbranchs = new Array();
    // this.appsettingstations = new Array();
    // this.discount_bills = new Array();
    // this.customer_classs = new Array();
    // this.products = new Array();
    // this.vhAuth.clearLocalEmployeeFromSyncCollection();       
    // let colname_array = new Array(); 
    // colname_array[0] = 'categorys'; colname_array[1] = 'printers'; colname_array[2] = 'suppliers'; colname_array[3] = 'customers'; 
    // colname_array[4] = 'wallets'; colname_array[5] = 'areas'; colname_array[6] = 'tables'; colname_array[7] = 'taxs'; colname_array[8] = 'vhemployees'; 
    // colname_array[9] = 'appsettingstations'; colname_array[10] = 'appsettingbranchs'; colname_array[11] = 'discount_bills'; colname_array[12] = 'customer_classs';
    // colname_array[13] = 'vhs_dispatcherzones'; colname_array[14] = 'products';     
    this.vhMGDB_socketMongoDB.initSyncCollections(this.colname_array,{},"");  
  }

    /**
   * @example:
   * this.vhQueryCafe.closeSyncCollections();
   * disconnect collections synchronization in the APP
   * @returns void
   */
    public closeSyncCollections(){
      // this.callbackcollections.unsubscribe();
      this.vhMGDB_socketMongoDB.closeSyncCollections();
    }

    /**
   * Khi lấy obj từ database về, hàm syncRaw_Detail_ProductInsert sẽ đồng bộ obj vào 3 loại local rawproducts, detailproducts và products
   * (3 loại dữ liệu local đc fw sử dụng để tính toán hoặc trả về cho frontend khi cần), dùng cho type =3
   * @example:
   * this.syncRaw_Detail_ProductInsert(obj);  
   * @param obj 
   */
  private syncRaw_Detail_ProductInsert(obj:any){
    //let obj = {...data.data}; obj._id = data._id;                      
    //Đồng bộ dữ liệu product mới từ database đến rawproducts ở local - RAW
    let exists = false;
    let change_delete_hidden = false;
    for(let i=0; i<this.rawproducts.length; i++){
      if(obj._id === this.rawproducts[i]._id){
        exists = true;
        //if(obj.delete_hidden !== this.rawproducts[i].delete_hidden) change_delete_hidden = true;
        this.syncRaw_Detail_ProductUpdate(obj)
        break;
      }
    }
    //if(change_delete_hidden) this.syncRaw_Detail_ProductUpdate(obj)
    if(!exists) {
      this.rawproducts.push(obj);                   
      //Đồng bộ dữ liệu product mới từ database đến detailproducts ở local - DETAIL    
      //Nếu obj là con thì đi tìm trong rawproducts có cha nào ko ráp vào        
      if(obj.id_subs_group){
        for(let i=0; i<this.rawproducts.length; i++){  
          if(obj.id_subs_group === this.rawproducts[i]._id){                         
            let product = {...obj, ...this.rawproducts[i]};//cha chép đè lên con (obj là con)
            if(kindOf(obj.delete_hidden) != undefined) product.delete_hidden = obj.delete_hidden;
            product.id_subproduct = obj._id;
            product.name = this.rawproducts[i].name + ' (' + obj.name +')';
            delete product.id_subs_group;
            delete product.manysize;
            this.detailproducts.push(product);
          }
        }
      }else{//Nếu obj là cha thì đi tìm trong rawproducts có con nào ko ráp vào  
        if(obj.manysize){               
          for(let i=0; i<this.rawproducts.length; i++){
            if(obj._id === this.rawproducts[i]?.id_subs_group){
              let product = {...this.rawproducts[i], ...obj};//cha chép đè lên con (obj là cha)
              if(kindOf(this.rawproducts[i].delete_hidden) != undefined) product.delete_hidden = this.rawproducts[i].delete_hidden;
              product.id_subproduct = this.rawproducts[i]._id;
              product.name = obj.name + ' (' + this.rawproducts[i].name +')';
              delete product.id_subs_group;
              delete product.manysize;
              this.detailproducts.push(product);
            }
          }
        }else{
          this.detailproducts.push(obj);                   
        }
      }
      //Đồng bộ dữ liệu product mới từ database đến products ở local - PRODUCTS            
      if(obj.id_subs_group){                    
        for(let i=0; i<this.products.length; i++){  
          if(this.products[i]._id === obj.id_subs_group){
            let sub:any = {
              _id: obj._id,
              name: obj.name,                     
              quantity: obj.quantity,
              quantity_branch: obj.quantity_branch,
              warning_number: obj.warning_number,
              item_code: obj.item_code,
              allow_sell: obj.allow_sell,
              selling: obj.selling,
              units: obj.units,
              delete_hidden: obj.delete_hidden,
              //ratio_default: obj.ratio_default,
              manylot: obj.manylot
            }                      
            if(sub.manylot){     
              sub.days_import_warning = obj.days_import_warning; // Số ngày HSD còn lại được phép nhập hàng
              sub.days_exp_warning = obj.days_exp_warning; // Số ngày HSD còn lại được cảnh báo            
              sub.lots = obj.lots;              
            }
            this.products[i].subs.push(sub);                      
            for(const p in sub.quantity_branch){
              let exists = false;
              for(const q in this.products[i].quantity_branch){
                if(p===q) exists = true;
              }
              if(exists){
                this.products[i].quantity_branch[p] = this.products[i].quantity_branch[p] + sub.quantity_branch[p];
              }else{
                this.products[i].quantity_branch[p] = sub.quantity_branch[p];
              }
              this.products[i].quantity = this.products[i].quantity + sub.quantity_branch[p];
            }
          }
        }          
      }else{
        if(obj.manysize){              
          let subs = new Array();
          let quantity = 0;
          let quantity_branch:any = {};
          for(let i=0; i<this.rawproducts.length; i++){
            if(obj._id === this.rawproducts[i]?.id_subs_group){                 
              let sub:any = {
                _id: this.rawproducts[i]._id,
                name: this.rawproducts[i].name,                
                quantity: this.rawproducts[i].quantity,
                quantity_branch: this.rawproducts[i].quantity_branch,
                warning_number: this.rawproducts[i].warning_number,
                item_code: this.rawproducts[i].item_code,
                allow_sell: this.rawproducts[i].allow_sell,
                selling: this.rawproducts[i].selling,
                units: this.rawproducts[i].units,
                delete_hidden: this.rawproducts[i].delete_hidden,
                //ratio_default: this.rawproducts[i].ratio_default,                   
                manylot: this.rawproducts[i].manylot
              }
              if(sub.manylot){     
                sub.days_import_warning = this.rawproducts[i].days_import_warning; // Số ngày HSD còn lại được phép nhập hàng
                sub.days_exp_warning = this.rawproducts[i].days_exp_warning; // Số ngày HSD còn lại được cảnh báo            
                sub.lots = this.rawproducts[i].lots;              
              }
              for(const p in sub.quantity_branch){
                let exists = false;
                for(const q in quantity_branch){
                  if(p===q) exists = true;
                }
                if(exists){
                  quantity_branch[p] = quantity_branch[p] + sub.quantity_branch[p];
                }else{
                  quantity_branch[p] = sub.quantity_branch[p];
                }
                quantity = quantity + sub.quantity_branch[p];
              }
              subs.push(sub);
            }
          }
          let _product = {...obj};
          _product.subs = subs;
          _product.quantity = quantity;
          _product.quantity_branch = {...quantity_branch};
          //_product.type = 3;
          this.products.push(_product);   
        }else{
          this.products.push(obj);                   
        }
      }                             
    }
  }

  /**
   * VhQueryCafe
   */
  private syncRaw_Detail_ProductUpdate(obj:any){    
    //Đồng bộ dữ liệu product sửa từ database đến rawproducts ở local - RAW
    let exists = false;
    for(let i=0; i<this.rawproducts.length; i++){
      if(obj._id === this.rawproducts[i]._id){
        this.rawproducts[i] = {...obj};
        exists = true;
        break;
      }
    }
    if(exists){                   
        //Cập nhật dữ liệu product sửa từ database đến detailproducts ở local - DETAIL           
        //Nếu obj là con thì đi tìm trong rawproducts có cha nào ko ráp vào        
        if(obj.id_subs_group){
          for(let i=0; i<this.rawproducts.length; i++){  
            if(obj.id_subs_group === this.rawproducts[i]._id){
              let _detailproduct = {...obj, ...this.rawproducts[i]};//cha chép đè lên con (obj là con)
              if(kindOf(obj.delete_hidden) != undefined) _detailproduct.delete_hidden = obj.delete_hidden;
              _detailproduct.id_subproduct = obj._id;
              _detailproduct.name = this.rawproducts[i].name + ' (' + obj.name +')';
              delete _detailproduct.id_subs_group;
              delete _detailproduct.manysize;                    
              for(let j=0; j<this.detailproducts.length; j++){
                if(_detailproduct.id_subproduct === this.detailproducts[j].id_subproduct){
                  this.detailproducts[j] = {..._detailproduct};
                  break;
                }
              }
            }
          }
        }else{
          if(obj.manysize){//Nếu obj là cha thì đi tìm trong rawproducts có con nào ko ráp vào                                      
            for(let i=0; i<this.rawproducts.length; i++){
              if(obj._id === this.rawproducts[i]?.id_subs_group){
                //tạo lại các _detailproduct
                let _detailproduct = {...this.rawproducts[i], ...obj}; //cha chép đè lên con (obj là cha)
                if(kindOf(this.rawproducts[i].delete_hidden) != undefined) _detailproduct.delete_hidden = this.rawproducts[i].delete_hidden;
                _detailproduct.id_subproduct = this.rawproducts[i]._id;
                _detailproduct.name = obj.name + ' (' + this.rawproducts[i].name +')';
                delete _detailproduct.id_subs_group;
                delete _detailproduct.manysize;                      
                //chép đè _detailproduct lên các detailproduct của nó trong detailproducts
                for(let j=0; j<this.detailproducts.length; j++){
                  if(_detailproduct.id_subproduct === this.detailproducts[j].id_subproduct){                          
                    this.detailproducts[j] = {..._detailproduct};
                    break;
                  }
                }
              }
            }
          }else{
            for(let i=0; i<this.detailproducts.length; i++){
              if(obj._id === this.detailproducts[i]._id){
                this.detailproducts[i] = {...this.detailproducts[i], ...obj};     
                break;
              }
            }    
          }                   
        }                            
        //Cập nhật dữ liệu product sửa từ database đến products ở local - PRODUCTS            
        if(obj.id_subs_group){                 
          for(let i=0; i<this.products.length; i++){  
            if(this.products[i]._id === obj.id_subs_group){                   
              for(let j=0; j<this.products[i].subs.length; j++){ 
                if(this.products[i].subs[j]._id === obj._id){
                  let sub_old = {...this.products[i].subs[j]};
                  for(const p in this.products[i].quantity_branch){
                    let exists = false;
                    for(const q in sub_old.quantity_branch){
                      if(p===q) exists = true;
                    }
                    if(exists){
                      this.products[i].quantity_branch[p] = this.products[i].quantity_branch[p] - sub_old.quantity_branch[p];
                    }else{
                      this.products[i].quantity_branch[p] = - sub_old.quantity_branch[p];
                    }
                    this.products[i].quantity = this.products[i].quantity - sub_old.quantity_branch[p];
                  }

                  let sub_new:any = {
                    _id: obj._id,
                    name: obj.name,
                    //barcode: obj.barcode,                
                    //price: obj.price,
                    //price2: obj.price2,
                    //price_import: obj.price_import,
                    quantity: obj.quantity,
                    quantity_branch: obj.quantity_branch,
                    warning_number: obj.warning_number,
                    item_code: obj.item_code,
                    allow_sell: obj.allow_sell,
                    selling: obj.selling,
                    units: obj.units,
                    delete_hidden: obj.delete_hidden,
                    manylot: obj.manylot
                  }
                  if(sub_new.manylot){     
                    sub_new.days_import_warning = obj.days_import_warning; // Số ngày HSD còn lại được phép nhập hàng
                    sub_new.days_exp_warning = obj.days_exp_warning; // Số ngày HSD còn lại được cảnh báo            
                    sub_new.lots = obj.lots;              
                  }
                  this.products[i].subs[j] = {...sub_new};
                  for(const p in this.products[i].quantity_branch){
                    let exists = false;
                    for(const q in sub_new.quantity_branch){
                      if(p===q) exists = true;
                    }
                    if(exists){
                      this.products[i].quantity_branch[p] = this.products[i].quantity_branch[p] + sub_new.quantity_branch[p];
                    }else{
                      this.products[i].quantity_branch[p] = sub_new.quantity_branch[p];
                    }
                    this.products[i].quantity = this.products[i].quantity + sub_new.quantity_branch[p];
                  }
                }
              } 
              
              
            }
          }
        }else{
          for(let i=0; i<this.products.length; i++){
            if(this.products[i]._id === obj._id){                  
              this.products[i] = {...this.products[i], ...obj}
            }
          }   
        }                                        
    }        
  }

    /**
     * VhQueryCafe
     * @returns 
     */
  private callbackCollectionInsert(){    
    //return new Observable((observer:any) => {    
    return new Promise((resolve, reject) => {
      let colname_counts = 0;
      this.vhMGDB_socketMongoDB.callbackCollectionInsert().subscribe((array_Addeds:any)=>{          
        for(let i=0; i<array_Addeds.length; i++){
            let data = array_Addeds[i];
            let obj = {...data.data}; obj._id = data._id; 
            if(data.colname === 'categorys'){         
              if(!this.getlocalCategory(data._id)){                  
                  this.categorys.push(obj);      
                }else{
                  for(let n=0; n<this.categorys.length; n++){
                    if(this.categorys[n]._id === data._id){
                      this.categorys[n] = obj;
                      break;
                    }
                  } 
                }                    
            }else if(data.colname === 'products'){                        
              this.syncRaw_Detail_ProductInsert(obj);            
            }else if(data.colname === 'suppliers'){      
              delete data.name_keywords;
                delete data.phone_keywords;       
                if(!this.getlocalSupplier(data._id)){                  
                  this.suppliers.push(obj);       
                }else{
                  for(let n=0; n<this.suppliers.length; n++){
                    if(this.suppliers[n]._id === data._id){
                      this.suppliers[n] = obj;
                      break;
                    }
                  } 
                }                                                      
            }else if(data.colname === 'customers'){    
              delete data.name_keywords;
              delete data.phone_keywords;        
              if(!this.getlocalCustomer(data._id)){                 
                this.customers.push(obj);                         
              }else{
                for(let n=0; n<this.customers.length; n++){
                  if(this.customers[n]._id === data._id){
                    this.customers[n] = obj;
                    break;
                  }
                } 
              }                                         
            }else if(data.colname === 'wallets'){          
              if(!this.getlocalWallet(data._id)){
                  this.wallets.push(obj);     
              }else{
                for(let n=0; n<this.wallets.length; n++){
                  if(this.wallets[n]._id === data._id){
                    this.wallets[n] = obj;
                    break;
                  }
                } 
              }                
            }else if(data.colname === 'branchs'){                         
              // if(!this.getlocalBranch(data._id)){
              //   
              //   this.branchs.push(obj);   
              //   this.publishObservableEventBranchs();       
              //   observer.next(data.colname);    
              // }                                 
            }else if(data.colname === 'taxs'){          
              if(!this.getlocalTax(data._id)){
                  this.taxs.push(obj);             
              }else{
                for(let n=0; n<this.taxs.length; n++){
                  if(this.taxs[n]._id === data._id){
                    this.taxs[n] = obj;
                    break;
                  }
                } 
              }                                  
            }else if(data.colname === 'vhemployees'){                 
              this.vhAuth.insertlocalEmployeeFromSyncCollection(obj);         
            }else if(data.colname === 'promotions'){          
              if(!this.getlocalPromotion(data._id)){                
                this.promotions.push(obj);   
                //this.publishObservableEventPromotions();      
                //observer.next(data.colname);    
              }                                                          
            }else if(data.colname === 'inventorytimes'){          
              if(!this.getlocalInventorytime(data._id)){
                
                this.inventorytimes.push(obj);   
                //this.publishObservableEventInventorytimes();
                //observer.next(data.colname); 
              } 
            }else if(data.colname === 'appsettingbranchs'){    
              if(!this.getLocalAppSettingBranch(data._id)){            
                if(data.data.id_branch === this.getDefaultBranch()._id){
                  this.appsettingbranchs.push(obj);                         
                }              
              }else{
                if(data.data.id_branch === this.getDefaultBranch()._id){
                  for(let n=0; n<this.appsettingbranchs.length; n++){
                    if(this.appsettingbranchs[n]._id === data._id){
                      this.appsettingbranchs[n] = obj;
                      break;
                    }
                  } 
                }                 
              }                                         
            }else if(data.colname === 'appsettingstations'){         
              if(!this.getLocalAppSettingStation(data._id)){            
                if(data.data.uuid === this.hwinfo.uuid){
                  delete obj.uuid;
                  this.appsettingstations.push(obj);                 
                }              
              }else{
                if(data.data.uuid === this.hwinfo.uuid){
                  for(let n=0; n<this.appsettingstations.length; n++){
                    if(this.appsettingstations[n]._id === data._id){
                      delete obj.uuid;
                      this.appsettingstations[n] = obj;
                      break;
                    }
                  }
                }                   
              }                                 
            }else if(data.colname === 'printers'){        
              if(!this.getlocalPrinter(data._id)){
                if(data.data.uuid === this.hwinfo.uuid){    
                  delete obj.uuid;
                  this.printers.push(obj); 
                }              
              }else{
                if(data.data.uuid === this.hwinfo.uuid){    
                  for(let n=0; n<this.printers.length; n++){
                    if(this.printers[n]._id === data._id){
                      delete obj.uuid;
                      this.printers[n] = obj;
                      break;
                    }
                  }
                }                   
              }   
            }else if(data.colname === 'discount_bills'){         
                if(!this.getlocalDiscount_bill(data._id)){    
                  this.discount_bills.push(obj);        
                }else{
                  for(let n=0; n<this.discount_bills.length; n++){
                    if(this.discount_bills[n]._id === data._id){
                      this.discount_bills[n] = obj;
                      break;
                    }
                  } 
                }     
            }else if(data.colname === 'customer_classs'){         
                if(!this.getlocalCustomerClass(data._id)){    
                  this.customer_classs.push(obj);        
                }else{
                  for(let n=0; n<this.customer_classs.length; n++){
                    if(this.customer_classs[n]._id === data._id){
                      this.customer_classs[n] = obj;
                      break;
                    }
                  } 
                }         
            }else if(data.colname === 'areas'){
              if(!this.getlocalArea(data._id)){                
                this.areas.push(obj);              
              }else{
                for(let n=0; n<this.areas.length; n++){
                  if(this.areas[n]._id === data._id){
                    this.areas[n] = obj;
                    break;
                  }
                } 
              }   
            }else if(data.colname === 'tables'){
              if(!this.getlocalTable(data._id)){
                this.tables.push(obj);           
              }else{
                for(let n=0; n<this.tables.length; n++){
                  if(this.tables[n]._id === data._id){
                    this.tables[n] = obj;
                    break;
                  }
                } 
              } 
            }else if(data.colname === 'vhs_dispatcherzones'){          
              if(!this.getlocalDispatcherZone(data._id)){
                this.dispatcherzones.push(obj);                     
              }                                       
            }else{
              for(let n=0; n<this.dispatcherzones.length; n++){
                if(this.dispatcherzones[n]._id === data._id){
                  this.dispatcherzones[n] = obj;
                  break;
                }
              } 
            } 
        }
        if(array_Addeds.length){
          if(array_Addeds[0].colname === 'categorys') this.publishObservableEventCategorys();
          if(array_Addeds[0].colname === 'printers') this.publishObservableEventPrinters();
          if(array_Addeds[0].colname === 'suppliers') this.publishObservableEventSuppliers();
          if(array_Addeds[0].colname === 'customers') this.publishObservableEventCustomers();
          if(array_Addeds[0].colname === 'vhs_dispatcherzones') this.publishObservableEventDispatcherZones();
          if(array_Addeds[0].colname === 'wallets') this.publishObservableEventWallets();
          if(array_Addeds[0].colname === 'areas') this.publishObservableEventAreas();
          if(array_Addeds[0].colname === 'tables') this.publishObservableEventTables();
          if(array_Addeds[0].colname === 'taxs') this.publishObservableEventTaxs();
          if(array_Addeds[0].colname === 'vhemployees') this.vhAuth.publishObservableEventEmployees();
          if(array_Addeds[0].colname === 'appsettingbranchs') this.publishObservableEventAppSettingNameBranchs();
          if(array_Addeds[0].colname === 'appsettingstations') this.publishObservableEventAppSettingNameStations();
          if(array_Addeds[0].colname === 'discount_bills') this.publishObservableEventDiscount_bills();
          if(array_Addeds[0].colname === 'customer_classs') this.publishObservableEventCustomerClasss();   
          if(array_Addeds[0].colname === 'products') this.publishObservableEventProducts();          
        }    
        if(++colname_counts === this.colname_array.length)  resolve(null);   
      })      
    })
  }  

  /**
   * VhQueryCafe
   * @returns 
   */
  private callbackCollectionUpdate(){    
    //return new Observable((observer:any) => {  
    return new Promise((resolve, reject) => {        
      this.vhMGDB_socketMongoDB.callbackCollectionUpdate().subscribe((array_Modifieds:any)=>{ 
        for(let i=0; i<array_Modifieds.length; i++){
          let data = array_Modifieds[i];  
          //if(data.colname === 'vhemployees') data.colname = 'employees';
          if(data.colname === 'categorys'){
            for(let i=0; i<this.categorys.length; i++){
              if(this.categorys[i]._id === data._id){
                this.categorys[i] = {...this.categorys[i], ...data.data};     
                //this.publishObservableEventCategorys();  
                //observer.next(data.colname);         
                break;
              }
            }            
          }else if(data.colname === 'products'){
            let obj = {...data.data}; obj._id = data._id;        
            this.syncRaw_Detail_ProductUpdate(obj);                                   
          }else if(data.colname === 'suppliers'){
            delete data.name_keywords;
            delete data.phone_keywords;
            for(let i=0; i<this.suppliers.length; i++){
              if(this.suppliers[i]._id === data._id){
                this.suppliers[i] = {...this.suppliers[i], ...data.data};     
                //this.publishObservableEventSuppliers();   
                //observer.next(data.colname);         
                break;
              }
            }          
          }else if(data.colname === 'customers'){
            delete data.name_keywords;
            delete data.phone_keywords;
            for(let i=0; i<this.customers.length; i++){
              if(this.customers[i]._id === data._id){
                this.customers[i] = {...this.customers[i], ...data.data};    
                //this.publishObservableEventCustomers();   
                //observer.next(data.colname);           
                break;
              }
            }
          }else if(data.colname === 'wallets'){
            for(let i=0; i<this.wallets.length; i++){
              if(this.wallets[i]._id === data._id){
                this.wallets[i] = {...this.wallets[i], ...data.data};          
                //this.publishObservableEventWallets();
                //observer.next(data.colname);        
                break;
              }
            } 
          }else if(data.colname === 'branchs'){
            for(let i=0; i<this.branchs.length; i++){
              if(this.branchs[i]._id === data._id){
                this.branchs[i] = {...this.branchs[i], ...data.data};  
                //this.publishObservableEventBranchs();       
                //observer.next(data.colname);                
                break;
              }
            }          
          }else if(data.colname === 'taxs'){
            for(let i=0; i<this.taxs.length; i++){
              if(this.taxs[i]._id === data._id){
                this.taxs[i] = {...this.taxs[i], ...data.data};  
                //this.publishObservableEventTaxs();   
                //observer.next(data.colname);             
                break;
              }
            }          
          }else if(data.colname === 'vhemployees'){        
            this.vhAuth.updateLocalEmployeeFromSyncCollection(data._id, data.data);    
            //this.vhAuth.publishObservableEventEmployees();
            //observer.next(data.colname);              
          }else if(data.colname === 'promotions'){
            for(let i=0; i<this.promotions.length; i++){
              if(this.promotions[i]._id === data._id){
                this.promotions[i] = {...this.promotions[i], ...data.data};  
                //this.publishObservableEventPromotions();      
                //observer.next(data.colname);                
                break;
              }
            }         
          }else if(data.colname === 'inventorytimes'){
            for(let i=0; i<this.inventorytimes.length; i++){
              if(this.inventorytimes[i]._id === data._id){
                this.inventorytimes[i] = {...this.inventorytimes[i], ...data.data};    
                //this.publishObservableEventInventorytimes();
                //observer.next(data.colname);           
                break;
              }
            }   
          }else if(data.colname === 'appsettingbranchs'){
            for(let i=0; i<this.appsettingbranchs.length; i++){
              if(this.appsettingbranchs[i]._id === data._id){
                this.appsettingbranchs[i] = {...this.appsettingbranchs[i], ...data.data};   
                //this.publishObservableEventAppSettingNameBranchs(); 
                //observer.next(data.colname);               
                break;
              }
            }        
          }else if(data.colname === 'appsettingstations'){
            for(let i=0; i<this.appsettingstations.length; i++){
              if(this.appsettingstations[i]._id === data._id){
                this.appsettingstations[i] = {...this.appsettingstations[i], ...data.data};   
                //this.publishObservableEventAppSettingNameStations(); 
                //observer.next(data.colname);               
                break;
              }
            }         
          }else if(data.colname === 'printers'){
            for(let i=0; i<this.printers.length; i++){
              if(this.printers[i]._id === data._id){
                this.printers[i] = {...this.printers[i], ...data.data};           
                //this.publishObservableEventPrinters();   
                //observer.next(data.colname);   
                break;
              }
            }         
          }else if(data.colname === 'discount_bills'){
            for(let i=0; i<this.discount_bills.length; i++){
              if(this.discount_bills[i]._id === data._id){
                this.discount_bills[i] = {...this.discount_bills[i], ...data.data};       
                //this.publishObservableEventDiscount_bills(); 
                //observer.next(data.colname);         
                break;
              }
            }          
          }else if(data.colname === 'customer_classs'){
            for(let i=0; i<this.customer_classs.length; i++){
              if(this.customer_classs[i]._id === data._id){
                this.customer_classs[i] = {...this.customer_classs[i], ...data.data};       
                //this.publishObservableEventCustomerClasss(); 
                //observer.next(data.colname);         
                break;
              }
            }          
          }else if(data.colname === 'areas'){
            for(let i=0; i<this.areas.length; i++){
              if(this.areas[i]._id === data._id){
                this.areas[i] = {...this.areas[i], ...data.data};  
                //this.publishObservableEventAreas();   
                //observer.next(data.colname);             
                break;
              }
            } 
          }else if(data.colname === 'tables'){
            for(let i=0; i<this.tables.length; i++){
              if(this.tables[i]._id === data._id){
                this.tables[i] = {...this.tables[i], ...data.data};  
                //this.publishObservableEventTables();   
                //observer.next(data.colname);             
                break;
              }
            }           
          }else if(data.colname === 'vhs_dispatcherzones'){
            for(let i=0; i<this.dispatcherzones.length; i++){
              if(this.dispatcherzones[i]._id === data._id){
                this.dispatcherzones[i] = {...this.dispatcherzones[i], ...data.data};           
                break;
              }
            }
          }         
          //console.log('updated', data.colname);
        }
        if(array_Modifieds.length){
          if(array_Modifieds[0].colname === 'categorys') this.publishObservableEventCategorys();
          if(array_Modifieds[0].colname === 'printers') this.publishObservableEventPrinters();
          if(array_Modifieds[0].colname === 'suppliers') this.publishObservableEventSuppliers();
          if(array_Modifieds[0].colname === 'customers') this.publishObservableEventCustomers();
          if(array_Modifieds[0].colname === 'vhs_dispatcherzones') this.publishObservableEventDispatcherZones();
          if(array_Modifieds[0].colname === 'wallets') this.publishObservableEventWallets();
          if(array_Modifieds[0].colname === 'areas') this.publishObservableEventAreas();
          if(array_Modifieds[0].colname === 'tables') this.publishObservableEventTables();
          if(array_Modifieds[0].colname === 'taxs') this.publishObservableEventTaxs();
          if(array_Modifieds[0].colname === 'vhemployees') this.vhAuth.publishObservableEventEmployees();
          if(array_Modifieds[0].colname === 'appsettingbranchs') this.publishObservableEventAppSettingNameBranchs();
          if(array_Modifieds[0].colname === 'appsettingstations') this.publishObservableEventAppSettingNameStations();
          if(array_Modifieds[0].colname === 'discount_bills') this.publishObservableEventDiscount_bills();
          if(array_Modifieds[0].colname === 'customer_classs') this.publishObservableEventCustomerClasss();   
          if(array_Modifieds[0].colname === 'products') this.publishObservableEventProducts();          
        }              
      })
      resolve(null);
    })
  }

  /**
   * VhQueryCafe
   * @returns 
   */
  private callbackCollectionDelete(){
    //return new Observable((observer:any) => {  
    return new Promise((resolve, reject) => {  
      this.vhMGDB_socketMongoDB.callbackCollectionDelete().subscribe((array_Removeds:any)=>{      
        for(let i=0; i<array_Removeds.length; i++){
          let data = array_Removeds[i];  
          if(data.colname === 'vhemployees') data.colname = 'employees';
          if(data.colname === 'categorys'){
            for(let i=0; i<this.categorys.length; i++){
              if(this.categorys[i]._id === data._id){
                this.categorys.splice(i, 1);       
                //this.publishObservableEventCategorys();  
                //observer.next(data.colname);                        
                break;
              }
            }         
          }else if(data.colname === 'products'){    
             //xóa khỏi PRODUCTS           
             for(let i=0; i<this.products.length; i++){
               if(this.products[i]._id === data._id){
                 this.products.splice(i, 1);                             
                 break;
               }
             }  
             
             //xóa khỏi SUB-PRODUCTS          
             // for(let i=0; i<this.products.length; i++){                       
             //   for(let j=0; j<this.products[i].subs?.length; j++){ 
             //     if(this.products[i].subs[j]._id === data._id){                            
             //       this.products[i].subs.splice(j, 1);   
             //       break;                           
             //     }
             //   }                    
             // }   

             //xóa khỏi rawproducts 
             for(let k=0; k<this.rawproducts.length; k++){
               if(this.rawproducts[k]._id === data._id){           
                 this.rawproducts.splice(k, 1);                 
                 break;
               }
             } 
             //xóa khỏi SUB-PRODUCTS      
             outerLoop: // Đặt tên cho vòng lặp ngoài
             for(let i=0; i<this.products.length; i++){       
               if(this.products[i].subs){                          
                 for(let j=0; j<this.products[i].subs.length; j++){ 
                   if(this.products[i].subs[j]._id === data._id){
                     let sub_old = {...this.products[i].subs[j]};                       
                     for(const p in this.products[i].quantity_branch){
                       let exists = false;
                       for(const q in sub_old.quantity_branch){
                         if(p===q) exists = true;
                       }
                       if(exists){
                         this.products[i].quantity_branch[p] = this.products[i].quantity_branch[p] - sub_old.quantity_branch[p];
                       }else{
                         this.products[i].quantity_branch[p] = - sub_old.quantity_branch[p];
                       }
                       this.products[i].quantity = this.products[i].quantity - sub_old.quantity_branch[p];
                     }
                     this.products[i].subs.splice(j, 1);    
                     break outerLoop;                          
                   }
                 }     
               }  
             }

             //Xóa khỏi DETAILPRODUCT
             for(let i=0; i<this.detailproducts.length; i++){ 
               if(this.detailproducts[i]?.id_subproduct === data._id) {
                 this.detailproducts.splice(i, 1); 
                 break;
               }
               if(this.detailproducts[i]._id === data._id) {
                 this.detailproducts.splice(i, 1); 
                 break;
               }
             }      
          }else if(data.colname === 'suppliers'){
            for(let i=0; i<this.suppliers.length; i++){
              if(this.suppliers[i]._id === data._id){
                this.suppliers.splice(i, 1);    
                //this.publishObservableEventSuppliers();   
                //observer.next(data.colname);            
                break;
              }
            }          
          }else if(data.colname === 'customers'){
            for(let i=0; i<this.customers.length; i++){
              if(this.customers[i]._id === data._id){
                this.customers.splice(i, 1);
                //this.publishObservableEventCustomers();   
                //observer.next(data.colname);                          
                break;
              }
            }       
          }else if(data.colname === 'wallets'){
            for(let i=0; i<this.wallets.length; i++){
              if(this.wallets[i]._id === data._id){
                this.wallets.splice(i, 1);   
                //this.publishObservableEventWallets();
                //observer.next(data.colname);                      
                break;
              }
            } 
          }else if(data.colname === 'branchs'){
            for(let i=0; i<this.branchs.length; i++){
              if(this.branchs[i]._id === data._id){
                this.branchs.splice(i, 1);     
                //this.publishObservableEventBranchs();       
                //observer.next(data.colname);                  
                break;
              }
            }          
          }else if(data.colname === 'taxs'){
            for(let i=0; i<this.taxs.length; i++){
              if(this.taxs[i]._id === data._id){
                this.taxs.splice(i, 1);   
                //this.publishObservableEventTaxs();   
                //observer.next(data.colname);              
                break;
              }
            }         
          }else if(data.colname === 'vhemployees'){
            this.vhAuth.deleteLocalEmployeeFromSyncCollection(data._id);    
            //this.vhAuth.publishObservableEventEmployees();
            //observer.next(data.colname);                
          }else if(data.colname === 'promotions'){
            for(let i=0; i<this.promotions.length; i++){
              if(this.promotions[i]._id === data._id){
                this.promotions.splice(i, 1);    
                //this.publishObservableEventPromotions();
                //observer.next(data.colname);               
                break;
              }
            }              
          }else if(data.colname === 'inventorytimes'){
            for(let i=0; i<this.inventorytimes.length; i++){
              if(this.inventorytimes[i]._id === data._id){
                this.inventorytimes.splice(i, 1);     
                //this.publishObservableEventInventorytimes();
                //observer.next(data.colname);             
                break;
              }
            }
          }else if(data.colname === 'appsettingbranchs'){
            for(let i=0; i<this.appsettingbranchs.length; i++){
              if(this.appsettingbranchs[i]._id === data._id){
                this.appsettingbranchs.splice(i, 1); 
                //this.publishObservableEventAppSettingNameBranchs(); 
                //observer.next(data.colname);                
                break;
              }
            }    
          }else if(data.colname === 'appsettingstations'){
            for(let i=0; i<this.appsettingstations.length; i++){
              if(this.appsettingstations[i]._id === data._id){
                this.appsettingstations.splice(i, 1); 
                //this.publishObservableEventAppSettingNameStations(); 
                //observer.next(data.colname);                
                break;
              }
            }                   
          }else if(data.colname === 'printers'){
            for(let i=0; i<this.printers.length; i++){
              if(this.printers[i]._id === data._id){
                this.printers.splice(i, 1);             
                //this.publishObservableEventPrinters();   
                //observer.next(data.colname);   
                break;
              }
            }                   
          }else if(data.colname === 'discount_bills'){
            for(let i=0; i<this.discount_bills.length; i++){
              if(this.discount_bills[i]._id === data._id){
                this.discount_bills.splice(i, 1);       
                //this.publishObservableEventDiscount_bills(); 
                //observer.next(data.colname);            
                break;
              }
            }                   
          }else if(data.colname === 'customer_classs'){
            for(let i=0; i<this.customer_classs.length; i++){
              if(this.customer_classs[i]._id === data._id){
                this.customer_classs.splice(i, 1);       
                //this.publishObservableEventCustomerClasss(); 
                //observer.next(data.colname);            
                break;
              }
            }                   
          }else if(data.colname === 'areas'){
            for(let i=0; i<this.areas.length; i++){
              if(this.areas[i]._id === data._id){
                this.areas.splice(i, 1);    
                //this.publishObservableEventAreas();
                //observer.next(data.colname);               
                break;
              }
            }          
          }else if(data.colname === 'tables'){
            for(let i=0; i<this.tables.length; i++){
              if(this.tables[i]._id === data._id){
                this.tables.splice(i, 1);   
                //this.publishObservableEventTables();
                //observer.next(data.colname);              
                break;
              }
            }                    
          }else if(data.colname === 'vhs_dispatcherzones'){
            for(let i=0; i<this.dispatcherzones.length; i++){
              if(this.dispatcherzones[i]._id === data._id){
                this.dispatcherzones.splice(i, 1);                        
                break;
              }
            }       
          }                 
          console.log('deleted', data.colname);  
        }
        if(array_Removeds.length){
          if(array_Removeds[0].colname === 'categorys') this.publishObservableEventCategorys();
          if(array_Removeds[0].colname === 'printers') this.publishObservableEventPrinters();
          if(array_Removeds[0].colname === 'suppliers') this.publishObservableEventSuppliers();
          if(array_Removeds[0].colname === 'customers') this.publishObservableEventCustomers();
          if(array_Removeds[0].colname === 'vhs_dispatcherzones') this.publishObservableEventDispatcherZones();
          if(array_Removeds[0].colname === 'wallets') this.publishObservableEventWallets();
          if(array_Removeds[0].colname === 'areas') this.publishObservableEventAreas();
          if(array_Removeds[0].colname === 'tables') this.publishObservableEventTables();
          if(array_Removeds[0].colname === 'taxs') this.publishObservableEventTaxs();
          if(array_Removeds[0].colname === 'vhemployees') this.vhAuth.publishObservableEventEmployees();
          if(array_Removeds[0].colname === 'appsettingbranchs') this.publishObservableEventAppSettingNameBranchs();
          if(array_Removeds[0].colname === 'appsettingstations') this.publishObservableEventAppSettingNameStations();
          if(array_Removeds[0].colname === 'discount_bills') this.publishObservableEventDiscount_bills();
          if(array_Removeds[0].colname === 'customer_classs') this.publishObservableEventCustomerClasss();   
          if(array_Removeds[0].colname === 'products') this.publishObservableEventProducts();          
        }             
      })
      resolve(null);
    })
  }

  /**
   * VhQueryCafe
   * @returns 
   */
  public initChatToAppCare(){      
    return this.vhMGDB_socketMongoDB.initChat('vhmessages',{});  
  }

  /**
   * VhQueryCafe
   * @returns 
   */
  public listeningChatToAppCare_Insert(){
    return new Observable((observer:any) => {    
      this.vhMGDB_socketMongoDB.callbackChatInsert().subscribe((data:any)=>{      
        observer.next(data);
      })
    })
  }

  /**
   * VhQueryCafe
   * @returns 
   */
  public listeningChatToAppCare_Update(){
    return new Observable((observer:any) => {    
      this.vhMGDB_socketMongoDB.callbackChatUpdate().subscribe((data:any)=>{          
        observer.next(data);
      })
    })
  }

  /**
   * 
   * @param limit VhQueryCafe
   * @returns 
   */
  public getOldMessages(limit:number){
    return this.vhMGDB_database.getDocsByFields('vhmessages',{},{},{date:1},limit);
  }

  /**
   * @example:
   this.vhQueryCafe.sendMessageToAppCare('hello' ).then((res:any) => {      
   });
   * @param message 
   */
  public sendMessageToAppCare(message:any) {	  
    //console.log(this.getLocalAppSetting_Branch('store_info'));
    return new Promise((resolve, reject) => {      
      let data:any = {
        msg: message,
        date: new Date(),
        //sid: this.firebaseAuth.getSID(),
        avatar: this.getLocalAppSettingNameStation('store_info').img,
        email: this.getLocalAppSettingNameStation('store_info').email,
        company: this.getLocalAppSettingNameStation('store_info').company,
        align: 'left'
      };// nên dùng store_info
      //if(typeof(this.firebaseAuth.getUser().img) != 'undefined') data.avatar = this.firebaseAuth.getUser().img;
      this.vhMGDB_database.addDoc('vhmessages', data)
          .then((message)=>{
            //console.log('addDoc', message);
            resolve(message);
          },(error:any)=>{
            //console.log('error', error);
            reject(error)
          })      
      this.vhMGDB_socketMongoDB.saytoAppCareFirebase();                
    })
  }

  /**
   * @example:
   this.vhQueryCafe.sendMessageToAppCare('hello' ).then((res:any) => {      
   });
   * @param message 
   */
  public sendImageToAppCare(image:string) {	  
    //console.log(this.getLocalAppSetting_Branch('store_info'));
    return new Promise((resolve, reject) => {      
      let data:any = {
        img: image,
        date: new Date(),
        //sid: this.firebaseAuth.getSID(),
        avatar: this.getLocalAppSettingNameStation('store_info').img,
        email: this.getLocalAppSettingNameStation('store_info').email,
        company: this.getLocalAppSettingNameStation('store_info').company,
        align: 'left'
      };// nên dùng store_info
      //if(typeof(this.firebaseAuth.getUser().img) != 'undefined') data.avatar = this.firebaseAuth.getUser().img;
      this.vhMGDB_database.addDoc('vhmessages', data)
          .then((message)=>{
            //console.log('addDoc', message);
            resolve(message);
          },(error:any)=>{
            //console.log('error', error);
            reject(error)
          })
                 
    })
  }

  public startLocalStorage(){
    return new Promise<any>((resolve) => {
      let promise = new Array();  
      //promise[0] = this.vhAuth.refreshLocalEmployees();
    //  promise[0] = this.vhAuth.refreshLocalMyPermission();  
      //promise[2] = this.refreshLocalCategorys();
     // promise[4] = this.refreshLocalProducts();   
     // promise[4] = this.refreshLocalCustomers();
      //promise[5] = this.refreshLocalSuppliers();
      //promise[6] = this.refreshLocalWallets();
    //  promise[1] = this.refreshLocalDeliverys(); 
    //  promise[2] = this.refreshLocalAddresss();
      //promise[3] = this.refreshLocalBranchs();
      //promise[10] = this.refreshLocalInventorytimes();      
      //promise[11] = this.refreshLocalPrinters();
      //promise[12] = this.refreshLocalPromotions();
      //promise[13] = this.refreshLocalAppSettings_Branch();
      //promise[14] = this.refreshLocalTables();
      //promise[15] = this.refreshLocalAreas();
      //promise[16] = this.refreshLocalTaxs();      
      this.vhQuery.asyncPromiseAll(promise).then(()=>{resolve(null)});              
    })
  }  
 
  /**
  * Hàm này dùng để đồng bộ với dữ liệu điều phối ứng với khu vực điều phối id_dispatcherzone
  * @example:
  * this.vhQueryCafe.observableDispatcher('5fb6780ca2148e09806c5b01')      
        .subscribe((data)=> {  
          console.log('observableDispatcher', data);                            
        },(error:any) => {
          console.log(error);
        }) 
  * @param id_dispatcherzone   
  * @returns Observable => data 
  * @notice : nhớ đóng closeDispatcher() khi thoát trang hiện tại this.vhQueryCafe.closeDispatcher();
  */
  public observableDispatcher(id_dispatcherzone:any){       
    return new Observable<any>((observer:any) => {  
      this.kitchendispatcherlist = new Array();      
      this.initDispatcher(id_dispatcherzone)
          .then(bool => {                 
            if (bool) {                                     
              this.callbackdispatcher = this.callbackDispatcher().subscribe(data => {                 
                observer.next(data);               
              })
            }
          })
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.initDispatcher();
   * Initialize dispatcher in the APP
   * @returns Promise => true or false
   */
  private initDispatcher(id_dispatcherzone:string){      
      let id_branch = this.getDefaultBranch()._id;       
      return this.vhMGDB_socketMongoDB.initDispatcher(id_branch, id_dispatcherzone);    
  }

  /**
   * @example:
   * this.vhQueryCafe.closeDispatcher();
   * disconnect dispatcher in the APP
   * @returns void
   */
  public closeDispatcher(){
    this.callbackdispatcher.unsubscribe();
    this.vhMGDB_socketMongoDB.closeDispatcher();
  }

  /**
   * @example:
   * this.vhQueryCafe.doneDispatcher('5fb6780ca2148e09806c5b01')
          .then((bool:any)=>{
            console.log('doneDispatcher', bool);
          }, error=>{
            console.log('error', error);
          })
    * @param id_billdetail 
    * @param data 
    * @return Promise => bool = true or false
  */
  public doneDispatcher(id_billdetail:string){
    return new Promise((resolve, reject) => {
      this.updateBill_Detail(id_billdetail, {dispatcher_done:true})
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }

    
  /**
   * @example:
   * this.vhQueryCafe.callbackDispatcher(1)
        .subscribe((data)=> {                       
                  console.log('callbackDispatcher', data);                         
        },(error:any) => {
          console.log(error);
        })  
   * @param ptype =  1: kitchen; 2: service; 3: warehouse      
   * @returns Observable =>{bills_takeaway: new Array(), bills_table: new Array(), products: new Array()}
   */
    private callbackDispatcher(){          
      //let id_branch = this.getDefaultBranch()._id;    
      return new Observable<any>((observer:any) => {  //firebase ok rồi, firebase-mongo thì nhớ get về dữ liệu ban đầu        
        this.listeningDispatcher_Insert()
            .subscribe((array_Addeds:any)=> {               
              //thêm sản phẩm vào bill nhảy vô đây       
              //console.log('array_Addeds1', array_Addeds);    
              for(let i=0; i<array_Addeds.length; i++){
                let data = array_Addeds[i]; 
                if((data.ptype ===1)||(data.ptype ===2)||(data.ptype ===3)||(data.ptype ===4)){      
                  let dataArray = this.changeBillDetails_withNameUnitsLots([data]);                             
                  this.kitchendispatcherlist.push(dataArray[0]);
                }else{

                }        
              }          
              this.refreshKitchenDispatcherList().then(_data=>{observer.next(_data);});                                                        
            },(error:any) => {
              console.log(error);
            })  
            
        this.listeningDispatcher_Update()
            .subscribe((array_Modifieds:any)=> {               
              //Sửa món ắn trên bill nhảy vô đây  
              for(let i=0; i<array_Modifieds.length; i++){
                let data = array_Modifieds[i];                                
                for(let j=0; j<this.kitchendispatcherlist.length; j++){
                  if(this.kitchendispatcherlist[j]._id === data._id){
                    if(data.value?.dispatcher_done === true){
                      this.kitchendispatcherlist.splice(j, 1);                           
                    }else{
                      for(const q in data.value){
                        this.kitchendispatcherlist[i][q] = data.value[q];
                      }
                    }                    
                    this.refreshKitchenDispatcherList().then(_data=>{observer.next(_data);});                 
                    break;                
                  }
                }   
              }                                               
            })
        this.listeningDispatcher_Delete()
            .subscribe((array_Removeds:any)=> {                              
              //Xóa món ăn trên bill hoặc xác nhận cho món ăn xuất bếp nhảy vô đây  
              for(let i=0; i<array_Removeds.length; i++){
                let data = array_Removeds[i];                             
                for(let j=0; j<this.kitchendispatcherlist.length; j++){
                  if(this.kitchendispatcherlist[j]._id === data._id){                  
                    this.kitchendispatcherlist.splice(j, 1); 
                    this.refreshKitchenDispatcherList().then(_data=>{observer.next(_data);});        
                    break;                                  
                  }
                } 
              }                              
            })    

      })
    }

  /**
   * @example:
   * this.vhQueryCafe.listeningDispatcher_Insert()
          .subscribe((data)=> {                       
              console.log(data);                         
          },(error:any) => {
            console.log(error);
          })
   * @returns Observable (callback)
   */
  private listeningDispatcher_Insert(){    
    return new Observable((observer:any) => {          
      this.vhMGDB_socketMongoDB.callbackDispatcherInsert().subscribe((data:any)=>{             
        observer.next(data);        
      })
    })
  }

  /**
  * @example:
  * this.vhQueryCafe.listeningDispatcher_Update()
        .subscribe((data)=> {                       
            console.log(data);                         
        },(error:any) => {
          console.log(error);
        })
  * @returns Observable (callback) 
  */
  private listeningDispatcher_Update(){
    return new Observable((observer:any) => {    
      this.vhMGDB_socketMongoDB.callbackDispatcherUpdate().subscribe((data:any)=>{            
        observer.next(data);
      })
    })
  }

    /**
  * @example:
  * this.vhQueryCafe.listeningDispatcher_Delete()
        .subscribe((data)=> {                       
            console.log(data);                         
        },(error:any) => {
          console.log(error);
        })
  * @returns Observable (callback) 
  */
  private listeningDispatcher_Delete(){
    return new Observable((observer:any) => {    
      this.vhMGDB_socketMongoDB.callbackDispatcherDelete().subscribe((data:any)=>{          
        observer.next(data);
      })
    })
  }

  private refreshKitchenDispatcherList(){       
    return new Promise((resolve, reject) => {
      let jsons:any = {
        bills_takeaway: new Array(),  
        bills_table: new Array(), 
        products: new Array()                   
      }
      let vhbill_details = this.kitchendispatcherlist;       
      //console.log('kitchendispatcherlist', this.kitchendispatcherlist);
      if(vhbill_details.length > 0){     
            //products
            //Tạo các món cần điều phối                            
            let products = this.getlocalDetailProducts(12345);                                
            for(let i=0; i<products.length; i++){
              delete products[i]?.allow_sell;   
              delete products[i]?.describe;  
              delete products[i]?.id_category;     
              delete products[i]?.toppings; 
              delete products[i]?.combos;  

              products[i].late_warning = false;
              products[i].quantity = 0;             
              products[i].bill_details = new Array();                 
            }                             
                                           
            //bills_table  
            //tạo các bàn (đang có khách) cần điều phối        
            let bills_table = new Array();       
            for(let i=0; i<vhbill_details.length; i++){
              let exist = false;           
              for(let j=0; j<bills_table.length; j++){
                if(vhbill_details[i].id_bill === bills_table[j].id_bill){
                  exist = true;
                  break;
                }
              }
              if(!exist) if(vhbill_details[i].id_table != 'go_home'){
                let table = this.getlocalTable(vhbill_details[i].id_table);
                let data = {               
                  id_bill: vhbill_details[i].id_bill,              
                  id_table: vhbill_details[i].id_table,
                  table_name: table.name,                  
                  quantity: 0,
                  orders: 0,                                
                  bill_details:new Array(),
                  late_warning: false
                }
                bills_table.push(data);              
              } 
            }
                
            //bills_takeaway 
             //tạo các bill mang về cần điều phối
            let bills_takeaway = new Array(); 
            for(let i=0; i<vhbill_details.length; i++){
              let exist = false;                
              for(let j=0; j<bills_takeaway.length; j++){
                if(vhbill_details[i].id_bill === bills_takeaway[j].id_bill){
                  exist = true;
                  break;
                }
              }
              if(!exist) if(vhbill_details[i].id_table === 'go_home') {
                let data = {                  
                  id_bill: vhbill_details[i].id_bill,                       
                  bill_code: vhbill_details[i].bill_code,         
                  table_name: "Take away",         
                  quantity: 0,
                  orders: 0,                                 
                  bill_details:new Array(),
                  late_warning: false
                }                  
                bills_takeaway.push(data); 
              }               
            }
            //Thêm data
            for(let i=0; i<vhbill_details.length; i++){      
              let data = {...vhbill_details[i]};
              let table = this.getlocalTable(vhbill_details[i].id_table);
              data.late_warning = false;
              data.table_name = table.name;
              data._id = vhbill_details[i]._id;                                        
              delete data?.date;                                        
              delete data?.tax;
              delete data?.bill_type;
              delete data?.id_cashier;
              delete data?.id_employee;
              delete data?.id_supplier;
              delete data.id_customer;   
              delete data.id_branch;   
              delete data.id_category;

              delete data?.dispatcher_done;  
              delete data?.price;   
              
              if(data.toppings != undefined){
                for(let j=0; j<data.toppings.length; j++){
                  data.toppings[j].name = this.getlocalDetailProduct(data.toppings[j].id_product).name;
                }               
              }

              if(data.combos != undefined){
                for(let j=0; j<data.combos.length; j++){
                  data.combos[j].name = this.getlocalDetailProduct(data.combos[j].id_subproduct?data.combos[j].id_subproduct:data.combos[j].id_product).name;
                }               
              }
              
              let time_late = <any>(new Date()).getTime() - <any>(new Date(data.time_start_order)).getTime();
              time_late = Math.floor(time_late/60000); 
              if(time_late > this.getlocalDetailProduct(data.id_subproduct?data.id_subproduct:data.id_product).time_warning){
                data.late_warning = true;                    
              }else{
                data.late_warning = false;   
              } 
                        
              //thêm data cho bills_table   
              for(let j=0; j<bills_table.length; j++){
                if(bills_table[j].id_bill === data.id_bill){                                            
                  bills_table[j].orders++;
                  bills_table[j].quantity = bills_table[j].quantity + data.quantity;                  
                  
                  if(time_late > this.getlocalDetailProduct(data.id_subproduct?data.id_subproduct:data.id_product).time_warning){
                    bills_table[j].late_warning = true;                    
                  } 
                  bills_table[j].bill_details.push(data);                    
                }
              }  

              //thêm data cho bills_takeaway   
              for(let j=0; j<bills_takeaway.length; j++){
                if(bills_takeaway[j].id_bill === data.id_bill){                                            
                  bills_takeaway[j].orders++;
                  bills_takeaway[j].quantity = bills_takeaway[j].quantity + data.quantity;                  
                  
                  if(time_late > this.getlocalDetailProduct(data.id_subproduct?data.id_subproduct:data.id_product).time_warning){
                    bills_takeaway[j].late_warning = true;                    
                  }
                  bills_takeaway[j].bill_details.push(data);                    
                }
              }  

              //thêm data cho products
              for(let j=0; j<products.length; j++){          
                if(time_late > products[j].time_warning){                
                  products[j].late_warning = true;                 
                }                   
                if(products[j]._id === data.id_product){
                  if(data.id_subproduct){
                    if(products[j].id_subproduct === data.id_subproduct){
                      products[j].quantity = products[j].quantity + data.quantity;                  
                      products[j].bill_details.push(data);
                    }
                  }else{
                    products[j].quantity = products[j].quantity + data.quantity;                  
                    products[j].bill_details.push(data);
                  }               
                }
              }                                         
            }
          
            products = products.filter((item:any)=>{return item.quantity > 0});                                                        

            if(bills_table.length > 0){
              jsons.bills_table = bills_table;             
            }

            if(bills_takeaway.length > 0){
              jsons.bills_takeaway = bills_takeaway;              
            }     
            
            if(products.length > 0){
              jsons.products = products;              
            }                                     
      }
      //console.log('jsons', jsons)  
      resolve(jsons);        
    })
  }  

  private refreshWarehouseDispatcherList(){//ko dùng xóa đi       
    return new Promise((resolve, reject) => {
      let jsons:any = {
        bills_takeaway: new Array(),  
        bills_table: new Array(), 
        products: new Array()                   
      }
      let vhbill_details = this.warehousedispatcherlist;  
      if(vhbill_details.length > 0){                           
            let products = this.getlocalProducts(3);                                
            for(let i=0; i<products.length; i++){
              delete products[i]?.allow_sell;   
              delete products[i]?.describe;  
              delete products[i]?.id_category;     
              products[i].late_warning = false;
              products[i].quantity = 0;             
              products[i].bill_details = new Array();   
              if(products[i].subs != undefined)
                for(let j=0; j<products[i].subs.length; j++){
                  delete products[i].subs[j]?.active;                 
                  delete products[i].subs[j]?.price;                        
                  products[i].subs[j].late_warning = false;
                  products[i].subs[j].quantity = 0;                                              
                  products[i].subs[j].bill_details = new Array();               
                }
            }                               
              
            let bills_table = new Array();     
            let bills_takeaway = new Array(); 
                                    
            //bills_table         
            for(let i=0; i<vhbill_details.length; i++){
              let exist = false;           
              for(let j=0; j<bills_table.length; j++){
                if(vhbill_details[i].id_bill === bills_table[j].id_bill){
                  exist = true;
                  break;
                }
              }
              if(!exist) if(vhbill_details[i].id_table != 'go_home'){
                let table = this.getlocalTable(vhbill_details[i].id_table);
                let data = {               
                  id_bill: vhbill_details[i].id_bill,              
                  id_table: vhbill_details[i].id_table,
                  table_name: table.name,                  
                  quantity: 0,
                  orders: 0,                                
                  bill_details:new Array(),
                  late_warning: false
                }
                bills_table.push(data);              
              } 
            }

                
            //bills_takeaway 
            for(let i=0; i<vhbill_details.length; i++){
              let exist = false;                
              for(let j=0; j<bills_takeaway.length; j++){
                if(vhbill_details[i].id_bill === bills_takeaway[j].id_bill){
                  exist = true;
                  break;
                }
              }
              if(!exist) if(vhbill_details[i].id_table === 'go_home') {
                let data = {                  
                  id_bill: vhbill_details[i].id_bill,                       
                  bill_code: vhbill_details[i].bill_code,         
                  table_name: "Take away",         
                  quantity: 0,
                  orders: 0,                                 
                  bill_details:new Array(),
                  late_warning: false
                }                  
                bills_takeaway.push(data); 
              }               
            }
                //console.log('bills_takeaway ', bills_takeaway);       

            //products
            for(let i=0; i<vhbill_details.length; i++){              

              let data = {...vhbill_details[i]};
              let table = this.getlocalTable(vhbill_details[i].id_table);
              data.late_warning = false;
              data.table_name = table.name;
              data._id = vhbill_details[i]._id;                                        
              delete data?.date;                                        
              delete data?.tax;
              delete data?.bill_type;
              delete data?.id_cashier;
              delete data?.id_employee;
              delete data?.id_supplier;
              delete data.id_customer;   
              delete data.id_branch;   
              delete data.id_category;

              delete data?.dispatcher_done;  
              delete data?.price;                     
              
              let time_late = <any>(new Date()).getTime() - <any>(new Date(data.time_start_order)).getTime();
              time_late = Math.floor(time_late/60000); 
              if(time_late > this.getlocalProduct(data.id_product).time_warning){
                data.late_warning = true;                    
              }else{
                data.late_warning = false;   
              } 
                        
              //thêm data cho bills_table   
              for(let j=0; j<bills_table.length; j++){
                if(bills_table[j].id_bill === data.id_bill){                                            
                  bills_table[j].orders++;
                  bills_table[j].quantity = bills_table[j].quantity + data.quantity;                  
                  
                  if(time_late > this.getlocalProduct(data.id_product).time_warning){
                    bills_table[j].late_warning = true;                    
                  } 
                  bills_table[j].bill_details.push(data);                    
                }
              }  

              //thêm data cho bills_takeaway   
              for(let j=0; j<bills_takeaway.length; j++){
                if(bills_takeaway[j].id_bill === data.id_bill){                                            
                  bills_takeaway[j].orders++;
                  bills_takeaway[j].quantity = bills_takeaway[j].quantity + data.quantity;                  
                  
                  if(time_late > this.getlocalProduct(data.id_product).time_warning){
                    bills_takeaway[j].late_warning = true;                    
                  }
                  bills_takeaway[j].bill_details.push(data);                    
                }
              }  

              //thêm data cho products
              for(let j=0; j<products.length; j++){          
                if(time_late > products[j].time_warning){                
                  products[j].late_warning = true;                 
                }       
                if(products[j]._id === data.id_product){
                  products[j].quantity = products[j].quantity + data.quantity;    
                  if(products[j].subs != undefined)              
                    for(let k=0; k<products[j].subs.length; k++){                    
                      if(products[j].subs[k]._id === data.id_subproduct){
                        products[j].subs[k].quantity = products[j].subs[k].quantity + data.quantity;
                                      
                        if(time_late > products[j].time_warning){
                          products[j].subs[k].late_warning = true;                        
                        }                      
                        products[j].subs[k].bill_details.push(data);                        
                      }
                    }
                  products[j].bill_details.push(data);
                }
              }                                         
            }
          
            products = products.filter((item:any)=>{return item.quantity > 0});
            for(let i=0; i<products.length; i++){
              if(products[i].subs != undefined){
                let subproducts = products[i].subs.filter((item:any)=>{return item.quantity > 0});              
                delete products[i].subs;
                products[i].subs = subproducts;
              }                
            }                                                  

            if(bills_table.length > 0){
              jsons.bills_table = bills_table;             
            }

            if(bills_takeaway.length > 0){
              jsons.bills_takeaway = bills_takeaway;              
            }     
            
            if(products.length > 0){
              jsons.products = products;              
            }                                     
      }
      //console.log('jsons', jsons)  
      resolve(jsons);        
    })
  }

  private refreshServiceDispatcherList(){//ko dùng xóa đi       
    return new Promise((resolve, reject) => {
      let jsons:any = {
        bills_takeaway: new Array(),  
        bills_table: new Array(), 
        products: new Array()                   
      }
      let vhbill_details = this.servicedispatcherlist;  
      if(vhbill_details.length > 0){                           
            let products = this.getlocalProducts(2);            
            //products
            //Tạo các món cần điều phối                    
            for(let i=0; i<products.length; i++){
              delete products[i]?.allow_sell;   
              delete products[i]?.describe;  
              delete products[i]?.id_category;     
              products[i].late_warning = false;
              products[i].quantity = 0;             
              products[i].bill_details = new Array();   
              if(products[i].subs != undefined)
                for(let j=0; j<products[i].subs.length; j++){
                  delete products[i].subs[j]?.active;                 
                  delete products[i].subs[j]?.price;                        
                  products[i].subs[j].late_warning = false;
                  products[i].subs[j].quantity = 0;                                              
                  products[i].subs[j].bill_details = new Array();               
                }
            }                               
              
            let bills_table = new Array();     
            let bills_takeaway = new Array(); 
                                    
            //bills_table        
            //tạo các bàn (đang có khách) cần điều phối 
            for(let i=0; i<vhbill_details.length; i++){
              let exist = false;           
              for(let j=0; j<bills_table.length; j++){
                if(vhbill_details[i].id_bill === bills_table[j].id_bill){
                  exist = true;
                  break;
                }
              }
              if(!exist) 
              if(vhbill_details[i].id_table != 'go_home'){
                let table = this.getlocalTable(vhbill_details[i].id_table);
                let data = {               
                  id_bill: vhbill_details[i].id_bill,              
                  id_table: vhbill_details[i].id_table,
                  table_name: table.name,                  
                  quantity: 0,
                  orders: 0,                                
                  bill_details:new Array(),
                  late_warning: false
                }
                bills_table.push(data);              
              } 
            }

                
            //bills_takeaway 
            //tạo các bill mang về cần điều phối
            for(let i=0; i<vhbill_details.length; i++){
              let exist = false;                
              for(let j=0; j<bills_takeaway.length; j++){
                if(vhbill_details[i].id_bill === bills_takeaway[j].id_bill){
                  exist = true;
                  break;
                }
              }
              if(!exist) 
              if(vhbill_details[i].id_table === 'go_home') {
                let data = {                  
                  id_bill: vhbill_details[i].id_bill,                       
                  bill_code: vhbill_details[i].bill_code,         
                  table_name: "Take away",         
                  quantity: 0,
                  orders: 0,                                 
                  bill_details:new Array(),
                  late_warning: false
                }                  
                bills_takeaway.push(data); 
              }               
            }
               
            
            for(let i=0; i<vhbill_details.length; i++){              

              let data = {...vhbill_details[i]};
              let table = this.getlocalTable(vhbill_details[i].id_table);
              data.late_warning = false;
              data.table_name = table.name;
              data._id = vhbill_details[i]._id;                                        
              delete data?.date;                                        
              delete data?.tax;
              delete data?.bill_type;
              delete data?.id_cashier;
              delete data?.id_employee;
              delete data?.id_supplier;
              delete data.id_customer;   
              delete data.id_branch;   
              delete data.id_category;

              delete data?.dispatcher_done;  
              delete data?.price;                     
              
              let time_late = <any>(new Date()).getTime() - <any>(new Date(data.time_start_order)).getTime();
              time_late = Math.floor(time_late/60000); 
              if(time_late > this.getlocalProduct(data.id_product).time_warning){
                data.late_warning = true;                    
              }else{
                data.late_warning = false;   
              } 
                        
              //thêm data cho bills_table   
              for(let j=0; j<bills_table.length; j++){
                if(bills_table[j].id_bill === data.id_bill){                                            
                  bills_table[j].orders++;
                  bills_table[j].quantity = bills_table[j].quantity + data.quantity;                  
                  
                  if(time_late > this.getlocalProduct(data.id_product).time_warning){
                    bills_table[j].late_warning = true;                    
                  } 
                  bills_table[j].bill_details.push(data);                    
                }
              }  

              //thêm data cho bills_takeaway   
              for(let j=0; j<bills_takeaway.length; j++){
                if(bills_takeaway[j].id_bill === data.id_bill){                                            
                  bills_takeaway[j].orders++;
                  bills_takeaway[j].quantity = bills_takeaway[j].quantity + data.quantity;                  
                  
                  if(time_late > this.getlocalProduct(data.id_product).time_warning){
                    bills_takeaway[j].late_warning = true;                    
                  }
                  bills_takeaway[j].bill_details.push(data);                    
                }
              }  

              //thêm data cho products
              for(let j=0; j<products.length; j++){          
                if(time_late > products[j].time_warning){                
                  products[j].late_warning = true;                 
                }       
                if(products[j]._id === data.id_product){
                  products[j].quantity = products[j].quantity + data.quantity;  
                  if(products[j].subs != undefined)                   
                    for(let k=0; k<products[j].subs.length; k++){                    
                      if(products[j].subs[k]._id === data.id_subproduct){
                        products[j].subs[k].quantity = products[j].subs[k].quantity + data.quantity;
                                      
                        if(time_late > products[j].time_warning){
                          products[j].subs[k].late_warning = true;                        
                        }                      
                        products[j].subs[k].bill_details.push(data);                        
                      }
                    }
                  products[j].bill_details.push(data);
                }
              }                                         
            }
          
            products = products.filter((item:any)=>{return item.quantity > 0});
            for(let i=0; i<products.length; i++){     
              if(products[i].subs != undefined){    
                let subproducts = products[i].subs.filter((item:any)=>{return item.quantity > 0});              
                delete products[i].subs;
                products[i].subs = subproducts;
              }
            }                                                  

            if(bills_table.length > 0){
              jsons.bills_table = bills_table;             
            }

            if(bills_takeaway.length > 0){
              jsons.bills_takeaway = bills_takeaway;              
            }     
            
            if(products.length > 0){
              jsons.products = products;              
            }                                     
      }
      //console.log('jsons', jsons)  
      resolve(jsons);        
    })
  }

      
  private publishObservableEventAreas() {
    this.subjectareas.next(this.areas);
  }  

  private observableLocalAreas():Subject<any> {      
    return this.subjectareas; 
  }

  /**
   * @example:
    this.observableArea = this.vhQueryCafe.getObservableLocalAreas().subscribe((localAreas:any) => {       
    })       
   
    ngOnDestroy(){
      this.observableArea.unsubscribe();    
    }
   * @returns 
   */
  public getObservableLocalAreas(){   
   return new Observable((observer:any) => {    
    this.observableLocalAreas().subscribe((areas) => {   
      observer.next(areas);
    })
    this.publishObservableEventAreas();
   })
  }
  /**
   * @example: 
   * let area = this.vhQueryCafe.getlocalArea('5fb6780ca2148e09806c5b01');
   * @param id_area 
   * @return Object => obj = {} or null
   */
  public getlocalArea(id_area:any){
    for(let i=0; i<this.areas.length; i++){
      if(this.areas[i]._id === id_area){
        return this.areas[i];
        break;
      }
    }
    return null; 
  }
  /**
   * @example
   * let areas = this.vhQueryCafe.getlocalAreas(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalAreas(){    
    return this.areas;
  }

   /**
   * @example:
   * this.vhQueryCafe.refreshLocalAreas()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalArea(), getlocalAreas() trong localstorage
   * @return Promise => null
   */
  public refreshLocalAreas():any{
    return new Promise((resolve, reject) => { 
      //this.getAreas().then(()=>{resolve(null)})     
      resolve(null)  
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addArea({name:'Khu vực 2', id_branch:'j7H8FADQlxQWB0pPq4Qt', status:true})
          .then((are)=>{
            console.log('addArea', area);
          }, error=>{
            console.log('error', error);
          })
   * @param data 
   * @return Promise => object = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addArea(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('areas', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateArea('5fb6780ca2148e09806c5b01', {name: 'Khu vực sảnh'})
          .then((bool:any)=>{
            console.log('updateArea', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_area 
   * @param data 
   * @return Promise => bool = true or false
   */
  public updateArea(id_area:string, data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.updateDoc('areas', id_area, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteArea('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteArea', bool);
        }, error=>{
          reject(error)
        })
   * @param id_area 
   * @return Promise => bool = true or false
   */
  public deleteArea(id_area:string){   
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('tables', {id_area:{$eq:id_area}},{},{},1)
          .then((products:any)=>{                      
            if(products.length===0){              
              this.vhMGDB_database.deleteDoc('areas', id_area)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })    
            }else resolve(false);
          }, error=>{
            reject(error)
          })           
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getArea('5fb67fda87c0f21d484cbdf3')
            .then((area)=>{
              console.log('getArea', area);
            })
   * @param id_area 
   * @return false or object
   */
  public getArea(id_area:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('areas', id_area)
            .then((area)=>{
              resolve(area);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getAreas()
          .then((response)=>{
            console.log('getAreas', response);
          })
   * @return array(object) = [{},{},..]
   */
  public getAreas(){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDocs('areas')
            .then((response)=>{
              this.areas = response;
              resolve(response);
            })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.addAdss({name:name: 'Quảng cáo 1'})
          .then((ads)=>{
            console.log('addAdss', ads);
          }, error=>{
            console.log('error', error);
          })
   * @param data 
   * @return Promise => object = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addAdss(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('adss', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateAds('5fb6780ca2148e09806c5b01', {name: 'Quảng cáo 1'})
          .then((bool:any)=>{
            console.log('updateAds', bool);
          }, error=>{
            console.log('error', error);
          })
    * @param id_ads 
    * @param data 
    * @return Promise => bool = true or false
    */
  public updateAds(id_ads:string, data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.updateDoc('adss', id_ads, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteAds('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteAds', bool);
        }, error=>{
          reject(error)
        })
    * @param id_ads 
    * @return Promise => bool = true or false
    */
  public deleteAds(id_ads:string){   
    return new Promise((resolve, reject) => {                 
        this.vhMGDB_database.deleteDoc('adss', id_ads)
            .then((bool:any)=>{            
              resolve(bool);
            }, error=>{
              reject(error)
            })    
                    
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getAds('5fb67fda87c0f21d484cbdf3')
            .then((ads)=>{
              console.log('getAds', ads);
            })
    * @param id_ads 
    * @return false or object
    */
  public getAds(id_ads:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('adss', id_ads)
            .then((ads)=>{
              resolve(ads);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getAdss()
          .then((adss)=>{
            console.log('getAdss', adss);
          })
    * @return array(object) = [{},{},..]
    */
  public getAdss(){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDocs('adss')
            .then((adss)=>{                
              resolve(adss);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getAdss_byFields({quantity:{$gte:10}}, {}, {}, 0)
            .then((adss)=>{
              console.log('getAdss_byFields', adss);
            })
   * @param query 
   * @param projection 
   * @param sort 
   * @param limit 
   * @return Promise => array(object) = [{},{},..]
   */
  public getAdss_byFields(query: any, projection?: object, sort?: any, limit?: number){
    return new Promise((resolve, reject) => { 
      if(projection ===undefined) projection = {};
      if(sort ===undefined) sort = {};
      if(limit ===undefined) limit = 0;
      this.vhMGDB_database.getDocsByFields('adss', query, projection, sort, limit)
          .then((adss)=>{              
            resolve(adss);
          },(error:any)=>{
            reject(error);
          })                    
    })
  } 

  private publishObservableEventTables() {
    this.subjecttables.next(this.tables);
  }  

  private observableLocalTables():Subject<any> {      
    return this.subjecttables; 
  }

  /**
   * @example:
    this.observableTable = this.vhQueryCafe.getObservableLocalTables().subscribe((localTables:any) => {       
    })       
   
    ngOnDestroy(){
      this.observableTable.unsubscribe();    
    }
   * @returns 
   */
  public getObservableLocalTables(){   
   return new Observable((observer:any) => {    
    this.observableLocalTables().subscribe((tables) => {   
      observer.next(tables);
    })
    this.publishObservableEventTables();
   })
  }

  /**
   * @example: 
   * let table = this.vhQueryCafe.getlocalTable('5fb6780ca2148e09806c5b01');
   * @param id_table 
   * @return Object => obj = {} or null
   */
  public getlocalTable(id_table:any){
    for(let i=0; i<this.tables.length; i++){
      if(this.tables[i]._id === id_table){
        return this.tables[i];
        break;
      }
    }
    return null; 
  }
  /**
   * @example
   * let tables = this.vhQueryCafe.getlocalTables(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalTables(){    
    return this.tables;
  }

   /**
   * @example:
   * this.vhQueryCafe.refreshLocalTables()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalTable(), getlocalTables() trong localstorage
   * @return Promise => null
   */
  public refreshLocalTables():any{
    return new Promise((resolve, reject) => { 
      // this.getTables()
      //     .then(()=>{resolve(null)})      
      resolve(null) 
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addTable({name:'Bàn 2', id_area:'hou9080asdfasdfashf', id_branch:'j7H8FADQlxQWB0pPq4Qt', status:false})
          .then((table)=>{
            console.log('addTable', table);
          }, error=>{
            console.log('error', error);
          })
   * @param data 
   * @return Promise => object = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addTable(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('tables', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateTable('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateTable', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_table 
   * @param data 
   * @return Promise => bool = true or false
   */
  public updateTable(id_table:string, data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.updateDoc('tables', id_table, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteTable('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteTable', bool);
        }, error=>{
          reject(error)
        })
   * @param id_table 
   * @return Promise => bool = true or false
   */
  public deleteTable(id_table:string){
    return new Promise((resolve, reject) => {
     this.getBills_byFields({id_table:{$eq:id_table}},{},{},1)      
          .then((bills:any)=>{                      
            if(bills.length===0){              
              this.vhMGDB_database.deleteDoc('tables', id_table)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })    
            }else resolve(false);
          }, error=>{
            reject(error)
          })           
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getTable('5fb67fda87c0f21d484cbdf3')
            .then((table)=>{
              console.log('table', table);
            })
   * @param id_table 
   * @return false or object
   */
  public getTable(id_table:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('tables', id_table)
            .then((table)=>{
              resolve(table);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getTables()
          .then((response)=>{
            console.log('getTables', response);
          })
   * @return array(object) = [{},{},..]
   */
  public getTables(){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDocs('tables')
            .then((response)=>{
              this.tables = response;
              resolve(response);
            })          
    })
  }

  private publishObservableEventProducts() {
    this.subjectproducts.next();
  }  

  private observableLocalProducts():Subject<any> {      
    return this.subjectproducts; 
  }
  
  /**
   * @example:
   * this.observableProduct = this.vhQueryCafe.getObservableLocalProducts(1).subscribe((localProducts:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableProduct.unsubscribe();    
    }
   * @param type = 1 là món, = 2 là dịch vụ, = 3 là nguyên liệu, = 4 là topping, = 13 là món và nguyên liệu, ko truyền vào hoặc giá trị khác là cả ba
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalProducts(type?:any){   
   return new Observable((observer:any) => {    
    this.observableLocalProducts().subscribe(() => {   
      observer.next(this.getlocalProducts(type));
    })
    this.publishObservableEventProducts();
   })
  }    

  private getlocalProductAndCombosAndToppings(id_product:any){
    let _products:any = new Array();
    for(let i=0; i<this.products.length; i++){
      if(this.products[i]._id === id_product){      
        _products.push({...this.products[i]});
        if(this.products[i].subs != undefined){
          let _subs = [...this.products[i].subs];         
          _products[_products.length-1].subs = new Array();
          _subs.forEach(sub => {_products[_products.length-1].subs.push({...sub})});     
        }      
      }

      if(this.products[i].combos != undefined)
        for(let j=0; j<this.products[i].combos.length; j++){
          if(this.products[i].combos[j].id_product === id_product){
            _products.push({...this.products[i]});
            break;
          }
        }

      if(this.products[i].toppings != undefined)
        for(let j=0; j<this.products[i].toppings.length; j++){
          if(this.products[i].toppings[j].id_product === id_product){
            _products.push({...this.products[i]});
            break;
          }
        }  
      
    }
    return _products;
  }  

  /**
   * @example: 
   * let product = this.vhQueryCafe.getlocalProduct('5fb6780ca2148e09806c5b01');
   * @param id_product 
   * @return Object => obj = {} or null
   */
   private getlocalProduct1(id_product:any){
    /*for(let i=0; i<this.products.length; i++){
      if(this.products[i]._id === id_product){      
        let _product = {...this.products[i]};
        if(_product.subs != undefined){
          let _subs = [..._product.subs];         
          _product.subs = new Array();
          _subs.forEach(sub => {_product.subs.push({...sub})});     
        }   
        if(_product.toppings != undefined){
          let _toppings = [..._product.toppings];         
          _product.toppings = new Array();
          _toppings.forEach(topping => {_product.toppings.push({...topping})});     
        }
        if(_product.combos != undefined){
          let _combos = [..._product.combos];         
          _product.combos = new Array();
          _combos.forEach(combo => {_product.combos.push({...combo})});     
        }
        return _product;
      }
    }*/
    return null; 
  }

   /**
   * @example
   * let products = this.vhQueryCafe.getlocalProducts(); 
   * @param type = 1 là món, = 2 là dịch vụ, = 3 là nguyên liệu, = 4 là topping, = 5 là combo, = 13 là món và nguyên liệu,
   * = 145 là món, topping và combo, ko truyền vào hoặc giá trị khác là cả ba
   * @return Array(object) => array = [{},{},...]
   */
    private getlocalProducts1(type?:any){        
      let _products = new Array(); 
      /*this.products.forEach((element:any) => {
        let _element = {...element};
        if(_element.subs != undefined){
          let _subs = [..._element.subs];         
          _element.subs = new Array();
          _subs.forEach(sub => {_element.subs.push({...sub})});     
        }   
        if(_element.toppings != undefined){
          let _toppings = [..._element.toppings];         
          _element.toppings = new Array();
          _toppings.forEach(topping => {
            let _product = this.getlocalProduct(topping.id_product);
            topping.name = _product.name;
            topping.price = _product.price;
            topping.img = _product.img;
            topping.id_category = _product.id_category;
            topping.ptype = _product.type;
            _element.toppings.push({...topping});
          });     
        }  
        if(_element.combos != undefined){
          let _combos = [..._element.combos];         
          _element.combos = new Array();
          _combos.forEach(combo => {
            let _product = this.getlocalProduct(combo.id_product);
            combo.name = _product.name;
            combo.img = _product.img;
            combo.id_category = _product.id_category;
            combo.ptype = _product.type;
            if(combo.id_subproduct !=undefined){
              for(let i=0; i<_product.subs.length;i++){
                if(combo.id_subproduct === _product.subs[i]._id) {
                  combo.name = combo.name + '(' + _product.subs[i].name + ')';
                  break;
                }                
              }              
            }
            _element.combos.push({...combo});
          });     
        }             

        if((type===1)||(type===2)||(type===3)||(type===4)||(type===5)){
          if(_element.type === type) _products.push({..._element});

        }else if(type===13){
          if((_element.type === 1)||(_element.type === 3)) _products.push({..._element});

        }else if(type===15){
          if((_element.type === 1)||(_element.type === 5)) _products.push({..._element});

        }else if(type===25){
          if((_element.type === 2)||(_element.type === 5)) _products.push({..._element});

        }else if(type===35){
          if((_element.type === 3)||(_element.type === 5)) _products.push({..._element});

        }else if(type===41){
          if((_element.type === 1)||(_element.type === 4)) _products.push({..._element});

        }else if(type===1234){
          if((_element.type === 1)||(_element.type === 2)||(_element.type === 3)||(_element.type === 4)) _products.push({..._element});
        }else{
          _products.push({..._element});
        }
        
      }); */
      return _products;          
    }

 /**
   * @example:
   * this.vhQueryCafe.refreshLocalProduct('5fb6780ca2148e09806c5b01')
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalProduct() trong localstorage
   * @return Promise => null
   */
  public refreshLocalProduct(id_product:string):any{
    return new Promise((resolve, reject) => { 
      // this.getProduct(id_product)
      //     .then(()=>{resolve(null)})  
      resolve(null)     
    })
  }

   /**
   * @example:
   * this.vhQueryCafe.refreshLocalProducts()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalProduct(), getlocalProducts() trong localstorage
   * @return Promise => null
   */
  public refreshLocalProducts():any{
    return new Promise((resolve, reject) => { 
      // this.getProducts()
      //     .then(()=>{resolve(null)})       
      resolve(null);
    })
  }

  /**
   * Hàm này dùng để đồng bộ dữ liệu ẩn (delete_hidden = true) từ database về local
   * @example:
   * this.vhQueryCafe.refreshLocalProducts_Delete_Hidden(3)
        .then(()=>{
          do something.....
        })
  * Hàm này refresh giá trị mới nhất cho hàm getlocalProduct(), getlocalProducts() trong localstorage
  * @param type
  * @return Promise => null
  */
  public refreshLocalProducts_Delete_Hidden(type:any):any{
    return new Promise((resolve, reject) => { 
      if(this.getBranch_Management_Scope().product_scope){
        this.vhMGDB_database.getDocsByFields('products', {delete_hidden:{$eq:true}, type:{$eq:type}})
            .then((rawproducts:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `rawproducts` trong bộ nhớ local
              for(let i=0; i<rawproducts.length; i++){
                this.syncRaw_Detail_ProductInsert(rawproducts[i]);
              }
              resolve(null);
            }, error=>{
              reject(error)
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('products', {id_branch:{$eq: this.getDefaultBranch()._id},delete_hidden:{$eq:true}, type:{$eq:type}})
            .then((rawproducts:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `rawproducts` trong bộ nhớ local
              for(let i=0; i<rawproducts.length; i++){
                this.syncRaw_Detail_ProductInsert(rawproducts[i]);
              }
              resolve(null);
            }, error=>{
              reject(error)
            })  
      }    
    })
  }
  
  /**
   * @example:
   * this.vhQueryCafe.addProduct({name:'camera 2', quantity:20, price:200000})
          .then((product)=>{
            console.log('addProduct', product);
          }, error=>{
            console.log('error', error);
          })
   * @param data 
   * @return Promise => object = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addProduct(data:any){
    return new Promise((resolve, reject) => {
      if(data?.type === 3) {      
        data.quantity = 0; data.quantity_branch = {};           
            this.branchs.forEach((element:any) => {
              data.quantity_branch[element._id] = 0;
            });
      }
      this.vhMGDB_database.addDoc('products', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.addProducts([{name:'Nguyên liệu 1', quantity:20, price:200000},{},...])
          .then((products)=>{
            console.log('addProducts', products);
          }, error=>{
            console.log('error', error);
          })
   * @param data : array(object)
   * @return Promise => array = [{},{},...]
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addProducts(data_array:any){
      return new Promise((resolve, reject) => {
        let promise = new Array();
        for(let i=0; i<data_array.length; i++){
          if(data_array[i]?.type === 3) {           
            data_array[i].quantity = 0; data_array[i].quantity_branch = {};           
            this.branchs.forEach((element:any) => {
              data_array[i].quantity_branch[element._id] = 0;
            });
          }     
          promise[i] = new Promise(resolve=>{
            this.vhMGDB_database.addDoc('products', data_array[i])
                .then((obj)=>{
                  resolve(obj);
                }, ()=>{                 
                  resolve(null);
                }) 
          })                       
        }
        Promise.all(promise).then((array:any)=>{
          let _array = array.filter((item:any)=> (item != null))
          resolve(_array);
        })                 
      })
    }

  /**
   * @example:
   * this.vhQueryCafe.updateProduct('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateProduct', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_product 
   * @param value 
   * @return Promise => bool = true or false
   */
  public updateProduct(id_product:string, value:object){
    return new Promise((resolve, reject) => {
      let product = this.getlocalProduct(id_product);          
      if(product.type ===1){
        if(checkCafe_updateProduct_Type1(id_product, value)) return; 
      }else if(product.type ===2){
        //if(checkSales_updateProduct_Type2(id_product, value)) return;     
      }else if(product.type ===3){
        if(checkCafe_updateProduct_Type3(id_product, value)) return;     
      }else if(product.type ===5){
        //if(checkSales_updateProduct_Type5(id_product, value)) return;   
      } 
      this.vhMGDB_database.updateDoc('products', id_product, value)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteProduct('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteDoc', bool);
        }, error=>{
          reject(error)
        })
   * @param id_product 
   * @return Promise => bool = true or false
   */
  public deleteProduct(id_product:string){
    return new Promise((resolve, reject) => {
      let IDproducts = new Array();
      this.getlocalProductAndCombosAndToppings(id_product).forEach((doc:any) => {
        IDproducts.push(doc._id);
      }); 
      if(IDproducts.length === 1){
       this.getBill_details_byID({id_product:{$in:IDproducts}},{},1)
          .then((vhbill_details:any)=>{                      
            if(vhbill_details.length===0){              
              this.vhMGDB_database.deleteDoc('products', id_product)  
                  .then((bool:any)=>{                   
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  }) 
            }else resolve(false);
          }, error=>{
            reject(error)
          })   
      }else{
        console.log('Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm khác')
        resolve(false);
      }
                
    })     
  }

  /**
   * @example
   * this.vhQueryCafe.getProduct('5fb67fda87c0f21d484cbdf3')
            .then((product)=>{
              console.log('getProduct', product);
            })
   * @param id_product 
   * @return false or object
   */
  public getProduct(id_product:string){
    return new Promise((resolve, reject) => {       
      this.vhMGDB_database.getDoc('products', id_product)
          .then((product)=>{
            resolve(product);
          },(error:any)=>{
            reject(error);
          })        
      
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getProducts()
            .then((response)=>{
              console.log('getProducts', response);
            })
   * @return array(object) = [{},{},..]
   */
    public getProducts(){    
      return new Promise((resolve, reject) => {       
        return new Promise((resolve) => {
          this.vhMGDB_database.getDocs('products')
                .then((products)=>{
                  this.products = products;
                  resolve(products);
                },(error:any)=>{
                  reject(error);
                })         
        })   
      })          
  }

   /**
   * Hàm lấy chi tiết sản phẩm dựa vào id sản phẩm hoặc id sản phẩm con
   * @example
   * this.vhQueryCafe.getDetailProduct('5fb67fda87c0f21d484cbdf3')
            .then((product)=>{
              console.log('getDetailProduct', product);
            })
   * @param id_product 
   * @return null or object
   */
private getDetailProduct(id_sub_or_product: string) {
  return new Promise((resolve) => {
    console.log('getDetailProduct', id_sub_or_product);
    // Gọi đến database để lấy thông tin sản phẩm/subproduct dựa vào id truyền vào
    this.vhMGDB_database.getDoc('products', id_sub_or_product)
      .then((subproduct: any) => {        
        // Nếu tìm thấy sản phẩm/subproduct
        if (subproduct) {
          // Đồng bộ thông tin lấy được vào danh sách `detailproducts` trong bộ nhớ local
          this.syncRaw_Detail_ProductInsert(subproduct);
          // Thử tìm lại sản phẩm chi tiết từ local (bộ nhớ tạm)
          let detailproduct = this.getlocalDetailProduct(id_sub_or_product);
          // Nếu tìm được trong local, trả kết quả ngay
          if (detailproduct) return resolve(detailproduct);
          // Nếu sản phẩm có thuộc nhóm sản phẩm cha (gợi ý rằng đây là subproduct)
          if (subproduct.id_subs_group) {
            // Gọi tiếp đến database để lấy sản phẩm cha
            this.vhMGDB_database.getDoc('products', subproduct.id_subs_group)
              .then((product: any) => {
                // Nếu tìm thấy sản phẩm cha
                if (product) {
                  // (Có thể là thừa) Đồng bộ lại thông tin subproduct vào local
                  this.syncRaw_Detail_ProductInsert(subproduct);
                  // Nếu sản phẩm cha có thuộc tính `manysize` (tức là có nhiều size hoặc phân loại)
                  if (product.manysize) {
                    // Gộp thông tin sản phẩm cha và con lại
                    let _detailproduct = { ...subproduct, ...product };
                    // Lưu lại id của subproduct
                    _detailproduct.id_subproduct = subproduct._id;
                    // Ghép tên cha và con để tạo tên đầy đủ
                    _detailproduct.name = product.name + ' (' + subproduct.name + ')';
                    // Xoá các thuộc tính không còn cần thiết sau khi ghép
                    delete _detailproduct.id_subs_group;
                    delete _detailproduct.manysize;
                    // Trả về sản phẩm đã ghép
                    resolve(_detailproduct);
                  } else {
                    // Nếu không phải sản phẩm manysize => không hợp lệ
                    resolve(null);
                  }
                } else {
                  // Không tìm thấy sản phẩm cha
                  resolve(null);
                }
              });

          } else {
            // Nếu không có `id_subs_group` → subproduct là sản phẩm độc lập → trả về luôn
            resolve(subproduct);
          }
        } else {
          // Không tìm thấy sản phẩm/subproduct ban đầu
          resolve(null);
        }
      });
  });
}   

  

/**
 * Hàm này thêm topping vào món ăn/ thức uống
 * @example:
 *  let dataArray = [{
      id_product: 'DGBzFiK22KgY09UBY7JU',
      quantity: 1,
      price: 0,
      ratio: 1
    }]
  * this.vhQueryCafe.addToppingsProduct('5fb6780ca2148e', data)
        .then((toppings)=>{
          console.log('addToppingProduct', toppings);
        }, error=>{
          console.log('error', error);
        })
  * @param id_product
  * @param dataArray
  * @return Promise => object = {id_product, quantity, price, ratio}
  * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
  */
  public addToppingsProduct(id_product:any, dataArray:any){
    return new Promise((resolve, reject) => {                              
        let product = this.getlocalProduct(id_product);
        if(product){          
          if(product.toppings == undefined)  product.toppings = new Array();   
          //let _toppings = [...product.toppings];          
          let _toppings = cloneDeep(product.toppings);    
          for(let i=0; i<dataArray.length; i++){        
            _toppings.push(dataArray[i]);   
          }                                            
          this.vhMGDB_database.updateDoc('products', id_product, {toppings:_toppings})
              .then(()=>{                      
                resolve(dataArray);
              }, error=>{                      
                reject(error)
              })               
        }else{
          reject({error: 'id_product không tồn tại'})
        }                        
    })
  }
  private addToppingsProduct_old(id_product:any, dataArray:any){
    return new Promise((resolve, reject) => {     
        let promise = new Array();
        let toppings = new Array();
        for(let i=0; i<dataArray.length; i++){        
          toppings[i] = {...dataArray[i], _id:this.vhAlgorithm.ObjectId()};   
        }      
        let bool = false;
        let product:any;
        let number = 0;        
        let setinterval = setInterval(() => {
            number++;
            product = this.getlocalProduct(id_product);
            if(product){
              bool = true;
              if(product.toppings === undefined)  product.toppings = new Array();               
              for(let i=0; i<product.toppings.length; i++){ 
                delete product.toppings[i]?.name; delete product.toppings[i]?.price; delete product.toppings[i]?.img;                
              }             
              let _toppings = [...product.toppings, ...toppings];                         
              this.vhMGDB_database.updateDoc('products', id_product, {toppings:_toppings})
                  .then(()=>{                 
                    for(let j=0; j<toppings.length; j++){        
                      toppings[j].name = this.getlocalProduct(toppings[j].id_product).name;  
                      toppings[j].price = this.getlocalProduct(toppings[j].id_product).price;  
                      toppings[j].img = this.getlocalProduct(toppings[j].id_product).img;       
                    } 
                    resolve(toppings);
                  }, error=>{                      
                    reject(error)
                  })               
            }       
            if((bool===true)||(number ===20)) clearInterval(setinterval);         
        }, 100);                      
    })
  }

/**
 * Hàm này cập nhật lại topping trong món ăn/ thức uống
  * this.vhQueryCafe.updateToppingProduct('kgVZB4OveSOqlKBiDBPV','56s46ww54HFG3H265', {quantity: 2})
        .then((bool:any)=>{
          console.log('updateToppingProduct', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_product 
  * @param id_toppingproduct 
  * @param value 
  * @return Promise => bool = true or false
  */
  public updateToppingProduct(id_product:string, id_toppingproduct:string, value:any){
    return new Promise((resolve, reject) => {
      let product = this.getlocalProduct(id_product);          
      if(product){
        if(product.toppings){        
          let _toppings = cloneDeep(product.toppings);          
          for(let i=0; i<_toppings.length; i++){
            if(_toppings[i].id_product === id_toppingproduct){   
              _toppings[i] = {..._toppings[i], ...value};  
              break;            
            }
          }
          this.vhMGDB_database.updateDoc('products', id_product,  {toppings:_toppings})
              .then(()=>{
                resolve(true);
              }, error=>{
                reject(error)
              })   
            
        }   
      }else{
        reject({error: 'id_product không tồn tại'})
      }                          
    })
  } 

  /**
   * Hàm này xóa topping trong món ăn/ thức uống
   * @example:
   * this.vhQueryCafe.deleteToppingProduct('5fb67fda87c0f21d484cbdf3', 'jhit98q2rhfn9q38900913fr')
        .then((bool:any)=>{
          console.log('deleteToppingProduct', bool);
        }, error=>{
          reject(error)
        })
   * @param id_product 
   * @param id_toppingproduct      
   * @return Promise => bool = true or false
   */
  public deleteToppingProduct(id_product:string, id_toppingproduct:any){
    return new Promise((resolve, reject) => {    
        let product:any = this.getlocalProduct(id_product);            
        if(product.toppings != undefined)
          for(let i=0; i<product.toppings.length; i++){
            if(product.toppings[i].id_product === id_toppingproduct){
              product.toppings.splice(i,1);                      
              this.vhMGDB_database.updateDoc('products', product._id, {toppings: product.toppings})
                  .then((bool:any)=>{
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  }) 
              break;
            }
          }                            
    })
  }  
  

  /**
   * @example:
   * this.vhQueryCafe.addCombosProduct('5fb6780ca2148e',[{id_product:'rtw554b5634573456', id_subproduct: 'gty3456ygw454287', quantity:2, price: 20000, type: 1},{},..])
          .then((combos)=>{
            console.log('addCombosProduct', combos);
          }, error=>{
            console.log('error', error);
          })
   * @param id_product
   * @param dataArray : array
   * @return Promise => object = [{id_product, name, price},{},...] hoặc null
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là null
   */
  public addCombosProduct(id_product:any, dataArray:any){    
    for(let i=0; i<dataArray.length; i++){   //xóa khi nhân viên sửa xong
      delete dataArray[i]?.name;
    }
    //console.log('dataArray', dataArray)// xóa khi nhân viên sửa xong
    return new Promise((resolve, reject) => {         
        let combos = new Array();
        for(let i=0; i<dataArray.length; i++){        
          combos[i] = {...dataArray[i], _id:this.vhAlgorithm.ObjectId()};   
        }      
        let bool = false;
        let product:any;
        let number = 0;        
        let setinterval = setInterval(() => {
            number++;
            product = this.getlocalProduct(id_product);
            if(product){
              //console.log('product', product)        
              bool = true;
              if(product.combos === undefined)  product.combos = new Array();               
              for(let i=0; i<product.combos.length; i++){ 
                delete product.combos[i]?.name; delete product.combos[i]?.img;                
              }             
              let _combos = [...product.combos, ...combos];                                    
              this.vhMGDB_database.updateDoc('products', id_product, {combos:_combos})
                  .then(()=>{                 
                    for(let i=0; i<combos.length; i++){        
                      let _product = this.getlocalProduct(combos[i].id_product)
                      combos[i].name = _product.name;                        
                      combos[i].img = _product.img;                         
                      if(combos[i].id_subproduct !=undefined){
                        for(let j=0; j<_product.subs.length;j++){
                          if(combos[i].id_subproduct === _product.subs[j]._id) {
                            combos[i].name = combos[i].name + '(' + _product.subs[j].name + ')';
                            break;
                          }                
                        }              
                      }
                    } 
                    resolve(combos);
                  }, ()=>{   
                    reject(null);                       
                  })               
            }       
            if((bool===true)||(number ===20)) clearInterval(setinterval);         
        }, 100);                      
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateComboProduct('5fb6780ca2148e', 'rtw554b5634573456', {name:'Cơm chiên (nhỏ)', quantity: 2, price: 20000})
          .then((bool:any)=>{
            console.log('updateCombo', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_product 
   * @param data 
   * @return Promise => bool = true or false
   */
    public updateComboProduct(id_product:string, id_comboproduct:string, data:any){
      //console.log('updateComboProduct', data);//nhân viên sửa xong sẽ xóa
      delete data?.name; delete data?.quantity;// nhân viên sửa xong sẽ xóa
      return new Promise((resolve, reject) => {
        let product:any = this.getlocalProduct(id_product);          
        if(product.combos != undefined){
          product.combos.forEach((item:any) => {
            delete item?.name; delete item?.img; 
          });
          for(let i=0; i<product.combos.length; i++){            
            if(product.combos[i]._id === id_comboproduct){              
              product.combos[i] = {...product.combos[i],...data};              
              this.vhMGDB_database.updateDoc('products', product._id, {combos: product.combos})
                  .then((bool:any)=>{
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })   
              break;
            }
          }   
        }                    
      })
    }    

  /**
   * @example:
   * this.vhQueryCafe.addSubProduct('5fb6780ca2148e09806c5b01',{acive:true, price:0, name:'small'})
          .then((subproduct)=>{
            console.log('addSubProduct', subproduct);
          }, error=>{
            console.log('error', error);
          })
   * @param data 
   * @return Promise => object = {} or null
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là null
   */
  private addSubProduct(id_product:any, data:any){
    return new Promise((resolve, reject) => {
      let sub = {...data, _id:this.vhAlgorithm.ObjectId()}; 
      let bool = false;
      let product:any;
      let number = 0;
      let setinterval = setInterval(() => {
          number++;
          product = this.getlocalProduct(id_product);
          if(product){
            bool = true;
            if(product.subs === undefined)  product.subs = new Array();
            let subs = product.subs;
            subs.push(sub);
            this.vhMGDB_database.updateDoc('products', id_product, {subs:subs})
                .then(()=>{
                  resolve(sub);
                }, error=>{
                  //reject(error)
                  resolve(null);
                })
          }             
          if((bool===true)||(number ===5)) clearInterval(setinterval);             
        }, 100);
                           
    })
  }

   /**
   * @example:
   * this.vhQueryCafe.addSubsProduct('5fb6780ca2148e09806c5b01',[{price:0, name:'small'},{},...])
          .then((subproducts)=>{
            console.log('addSubsProduct', subproducts);
          }, error=>{
            console.log('error', error);
          })
   * @param data 
   * @return Promise => object = {} hoặc null
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là null
   */
  public addSubsProduct(id_product:any, dataArray:any){
    return new Promise((resolve, reject) => {       
        let subs = new Array();
        for(let i=0; i<dataArray.length; i++){        
          subs[i] = {...dataArray[i], _id:this.vhAlgorithm.ObjectId()};   
        }      
        let bool = false;
        let product:any;
        let number = 0;        
        let setinterval = setInterval(() => {
            number++;
            product = this.getlocalProduct(id_product);
            if(product){
              bool = true;
              if(product.subs === undefined)  product.subs = new Array();                              
              let _subs = [...product.subs, ...subs];                         
              this.vhMGDB_database.updateDoc('products', id_product, {subs:_subs})
                  .then(()=>{                     
                    resolve(subs);
                  }, error=>{                      
                    //reject(error)
                    resolve(null);
                  })               
            }       
            if((bool===true)||(number ===20)) clearInterval(setinterval);         
        }, 100);                      
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateProduct('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateProduct', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_product 
   * @param id_subproduct       
   * @param data 
   * @return Promise => bool = true or false
   */
  public updateSubProduct(id_product: string, id_subproduct:string, data:object){
    return new Promise((resolve, reject) => {
      let product:any = this.getlocalProduct(id_product);    
        if(product.subs != undefined)
          for(let j=0; j<product.subs.length; j++){
            if(product.subs[j]._id === id_subproduct){
              product.subs[j] = {...product.subs[j],...data};              
              this.vhMGDB_database.updateDoc('products', product._id, {subs: product.subs})
                  .then((bool:any)=>{
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })   
              break;
            }
          }                    
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteSubProduct('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteDoc', bool);
        }, error=>{
          reject(error)
        })
   * @param id_product 
   * @param id_subproduct      
   * @return Promise => bool = true or false
   */
  public deleteSubProduct(id_product: string, id_subproduct:string){
    return new Promise((resolve, reject) => {
      let IDproducts = new Array();
      this.getlocalProductAndCombosAndToppings(id_product).forEach((doc:any) => {
        IDproducts.push(doc._id);
      }); 
      if(IDproducts.length === 1){
       this.getBill_details_byID({id_subproduct:{$eq:id_subproduct}},{},1)
                .then((vhbill_details:any)=>{                      
                  if(vhbill_details.length===0){   
                    let product:any = this.getlocalProduct(id_product);           
                      if(product.subs != undefined)
                        for(let j=0; j<product.subs.length; j++){
                          if(product.subs[j]._id === id_subproduct){
                            product.subs.splice(j,1);                      
                            this.vhMGDB_database.updateDoc('products', product._id, {subs: product.subs})
                                .then((bool:any)=>{
                                  resolve(bool);
                                }, error=>{
                                  reject(error)
                                }) 
                            break;
                          }
                        }                                   
                    resolve(true)
                  }else resolve(false);
                }, error=>{
                  reject(error)
                })  
      }else{
        console.log('Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm khác')
        resolve(false);
      }             
    })
  } 






  /**
   * *************************************** HÀM MỚI CAFE ******************************************
   */

  
  /**
   * Hàm này lấy về 1 unit của sản phẩm theo ratio truyền vào
   * @example
   * let unit = this.vhQueryCafe.getUnit_byRatio(1); 
   * @param units
   * @param ratio
   * @return Object => obj = {} hoặc null
   */
   public getUnit_byRatio(units:any, ratio:number){
    for(let i=0; i<units.length; i++){
      if(units[i].ratio === ratio){
        return units[i];        
      }
    }
    let unit = {
      unit: '--',
      ratio: ratio,
      barcode: '',
      price: 0,
      price2: 0,
      price_import: 0
    }
    return unit;
  }

  


  /**
   * @example: new
   * let product = this.vhQueryCafe.getlocalProduct('5fb6780ca2148e09806c5b01');
   * @param id_product 
   * @return Object => obj = {} or null
   */ 
   public getlocalProduct(id_product:any){
     //console.log('products',this.products)
     for(let i=0; i<this.products.length; i++){
       if(this.products[i]._id === id_product){   
         let _product:any = {...this.products[i]};
         if(_product.type === 5){      
           if(_product.combos){//sau này tạo combo có hàm mới sẽ bỏ điều kiện này
             for(let j=0; j<_product.combos.length; j++){
               let _id_sub_or_product = _product.combos[j].id_subproduct?_product.combos[j].id_subproduct:_product.combos[j].id_product;
               let __product = this.getlocalDetailProduct(_id_sub_or_product);
               if(__product){
                 let _unit = this.getUnit_byRatio(__product.units, _product.combos[j].ratio);
                 _product.combos[j].name = __product.name;                  
                 _product.combos[j].units = __product.units;     
                 //_product.combos[j].unit = _unit.unit;      
                 if(__product.lots) _product.combos[j].lots = __product.lots;   
               }       
             }    
           }            
         }
         return cloneDeep(_product);     
         //return _product;       
      }
    }
    return null; 
  }

  /**
   * @example new
   * let products = this.vhQueryCafe.getlocalProducts(); 
   * @param type = 1 là sản phẩm, = 2 là dịch vụ, = 3 nguyên liệu, = 5 là combo, =12 là sản phẩm và dịch vụ, giá trị khác là cả 3
   * @return Array(object) => array = [{},{},...]
   */
 
  public getlocalProducts(type?:any){        
    let _products = new Array();    
    _products = this.products.filter((item:any)=>{
        if((type===1)||(type===2)||(type===3)||(type===4)||(type===5)||(type===6)){
          if(item.type === type) return <any>true;
        }else if(type===12){
          if((item.type === 1)||(item.type === 2)||(item.type === 3)) return true;
        }else if(type===123){
          if((item.type === 1)||(item.type === 2)||(item.type === 3)) return true;
        }else if(type===1234){
          if((item.type === 1)||(item.type === 2)||(item.type === 3)||(item.type === 4)) return true;      
        }else if(type===12345){
          if((item.type === 1)||(item.type === 2)||(item.type === 3)||(item.type === 4)||(item.type === 5)) return true;
        }else if(type===123456){
          if((item.type === 1)||(item.type === 2)||(item.type === 3)||(item.type === 4)||(item.type === 5)||(item.type === 6)) return true;
        }else if(type===26){
          if((item.type === 2)||(item.type === 6)) return true;
        }else{
          return true;
        }
    }) 
    for(let i=0; i<_products.length; i++){      
      if(_products[i].type === 5){      
        if(_products[i].combos){//sau này tạo combo có hàm mới sẽ bỏ điều kiện này
          for(let j=0; j<_products[i].combos.length; j++){
            let _id_sub_or_product = _products[i].combos[j].id_subproduct?_products[i].combos[j].id_subproduct:_products[i].combos[j].id_product;
            let _product = this.getlocalDetailProduct(_id_sub_or_product);
            if(_product){
              let _unit = this.getUnit_byRatio(_product.units, _products[i].combos[j].ratio);
              _products[i].combos[j].name = _product.name;                  
              _products[i].combos[j].units = _product.units;     
              //_products[i].combos[j].unit = _unit.unit;          
              if(_product.lots) _products[i].combos[j].lots = _product.lots;   
            }             
          }    
        }            
      }
    }         
    return cloneDeep(_products);      
  }
  
  
  /**
   * Hàm này lấy về tất cả detailproducts theo type của sản phẩm
   * @example
   * let detailproducts = this.vhQueryCafe.getlocalDetailProducts(); 
   * @param type = 1 là sản phẩm, = 2 là dịch vụ, = 5 là combo, =12 là sản phẩm và dịch vụ, giá trị khác hoặc trống là cả 3 (lấy về tất cả sản phẩm)
   * @return Array(object) => array = [{},{},...]
   */
   public getlocalDetailProducts(type?:any){    
    let _detailproducts = new Array();    
    _detailproducts = this.detailproducts.filter((item:any)=>{
        if((type===1)||(type===2)||(type===3)||(type===4)||(type===5)||(type===6)){
          if(item.type === type) return <any>true;
        }else if(type===12){
          if((item.type === 1)||(item.type === 2)) return true;
        }else if(type===123){
          if((item.type === 1)||(item.type === 2)||(item.type === 3)) return true;
        }else if(type===1234){
          if((item.type === 1)||(item.type === 2)||(item.type ===3)||(item.type ===4)) return true;
        }else if(type===12345){
          if((item.type === 1)||(item.type === 2)||(item.type ===3)||(item.type ===4)||(item.type ===5)) return true;
        }else if(type===123456){
          if((item.type === 1)||(item.type === 2)||(item.type ===3)||(item.type ===4)||(item.type ===5)||(item.type ===6)) return true;
        }else if(type===26){
          if((item.type === 2)||(item.type === 6)) return true;
        }else{
          return true;
        }

    })    
    _detailproducts = this.vhAlgorithm.sortVietnamesebyASC(_detailproducts, 'name');
    for(let i=0; i<_detailproducts.length; i++){     
      if(_detailproducts[i].toppings){//sau này tạo combo có hàm mới sẽ bỏ điều kiện này
        for(let j=0; j<_detailproducts[i].toppings.length; j++){
          //let _id_sub_or_product = _detailproducts[i].combos[j].id_subproduct?_detailproducts[i].combos[j].id_subproduct:_detailproducts[i].combos[j].id_product;
          let _product = this.getlocalDetailProduct(_detailproducts[i].toppings[j].id_product);
          if(_product){          
            _detailproducts[i].toppings[j].name = _product.name;                  
            _detailproducts[i].toppings[j].units = _product.units;                       
          }       
        }    
      } 
      if(_detailproducts[i].type === 5){      
        if(_detailproducts[i].combos){//sau này tạo combo có hàm mới sẽ bỏ điều kiện này
          for(let j=0; j<_detailproducts[i].combos.length; j++){
            let _id_sub_or_product = _detailproducts[i].combos[j].id_subproduct?_detailproducts[i].combos[j].id_subproduct:_detailproducts[i].combos[j].id_product;
            let _product = this.getlocalDetailProduct(_id_sub_or_product);
            if(_product){
            //let _unit = this.getUnit_byRatio(_product.units, _detailproducts[i].combos[j].ratio);
              _detailproducts[i].combos[j].name = _product.name;                  
              _detailproducts[i].combos[j].units = _product.units;     
              //_detailproducts[i].combos[j].unit = _unit.unit;      
              if(_product.lots) _detailproducts[i].combos[j].lots = _product.lots; 
            }       
          }    
        }            
      }
    }     
    return cloneDeep(_detailproducts);    
    //return _detailproducts; 
  }

  /**
   * Hàm này lấy về 1 detailproduct theo tham số truyền vào, hoặc là id_product hoặc cả id_subproduct
   * @example
   * let id_sub_or_product = id_subproduct?id_subproduct:id_product;
   * let detailproduct = this.vhQueryCafe.getlocalDetailProduct('ETxNu8exrvGtXFjkIhnc'); 
   * @param id_sub_or_product : id_subproduct hoặc id_product
   * @return Object => obj = {}  hoặc null
   */
   public getlocalDetailProduct(id_sub_or_product:string){    
    let _detailproduct = null;
    for(let i=0; i<this.detailproducts.length; i++){
      if(this.detailproducts[i].id_subproduct === id_sub_or_product){
        _detailproduct = {...this.detailproducts[i]}
        break;        
      }else if(this.detailproducts[i]._id === id_sub_or_product){
        if(!this.detailproducts[i].id_subproduct){
          _detailproduct = {...this.detailproducts[i]};
          break;    
        }else{
          console.log('Kiểm tra lại, đối tượng truyền vào hàm thiếu id_subproduct');
        }   
      }
    } 
    if(_detailproduct) {       
      if(_detailproduct.toppings){
        for(let j=0; j<_detailproduct.toppings.length; j++){          
          let __product = this.getlocalDetailProduct(_detailproduct.toppings[j].id_product);
          if(__product){            
            _detailproduct.toppings[j].name = __product.name;                  
            _detailproduct.toppings[j].units = __product.units;                
            
          }         
        }    
      }                  
      if(_detailproduct.type === 5){      
        if(_detailproduct.combos){//sau này tạo combo có hàm mới sẽ bỏ điều kiện này
          for(let j=0; j<_detailproduct.combos.length; j++){
            let _id_sub_or_product = _detailproduct.combos[j].id_subproduct?_detailproduct.combos[j].id_subproduct:_detailproduct.combos[j].id_product;
            let __product = this.getlocalDetailProduct(_id_sub_or_product);
            if(__product){
              //let _unit = this.getUnit_byRatio(__product.units, _detailproduct.combos[j].ratio);
              _detailproduct.combos[j].name = __product.name;                  
              _detailproduct.combos[j].units = __product.units;     
              //_detailproduct.combos[j].unit = _unit.unit;    
              if(__product.lots) _detailproduct.combos[j].lots = __product.lots; 
            }         
          }    
        }            
      }
      //return _detailproduct;
      return cloneDeep(_detailproduct); 
    }
    return null;
  }

  /**
 * @example:
 * this.vhQueryCafe.getlocalDetailProduct_Async('ETxNu8exrvGtXFjkIhnc')
        .then((detailproduct)=>{
        }, error=>{
          console.log('error', error);
        })
  * @param data : object
  * @return Promise => object or null
  */
  private getlocalDetailProduct_Async(id_sub_or_product:string):Promise<any>{   
    return new Promise((resolve, reject) => {
      (async () => {
        try { 
          let _detailproduct = null;
          for(let i=0; i<this.detailproducts.length; i++){
            if(this.detailproducts[i].id_subproduct === id_sub_or_product){
              _detailproduct = {...this.detailproducts[i]}
              break;        
            }else if(this.detailproducts[i]._id === id_sub_or_product){
              if(!this.detailproducts[i].id_subproduct){
                _detailproduct = {...this.detailproducts[i]};
                break;    
              }else{
                console.log('Kiểm tra lại, đối tượng truyền vào hàm thiếu id_subproduct');
              }   
            }
          } 
          if(!_detailproduct) _detailproduct = await this.getDetailProduct(id_sub_or_product)
          if(_detailproduct) {
            if(_detailproduct.type === 5){      
              if(_detailproduct.combos){//sau này tạo combo có hàm mới sẽ bỏ điều kiện này
                for(let j=0; j<_detailproduct.combos.length; j++){
                  let _id_sub_or_product = _detailproduct.combos[j].id_subproduct?_detailproduct.combos[j].id_subproduct:_detailproduct.combos[j].id_product;
                  let __product = await this.getlocalDetailProduct_Async(_id_sub_or_product);
                  if(__product){
                    //let _unit = this.getUnit_byRatio(__product.units, _detailproduct.combos[j].ratio);
                    _detailproduct.combos[j].name = __product.name;                  
                    _detailproduct.combos[j].units = __product.units;     
                    //_detailproduct.combos[j].unit = _unit.unit;    
                    if(__product.lots) _detailproduct.combos[j].lots = __product.lots; 
                  }         
                }    
              }            
            }
          }
          console.log('getlocalDetailProduct_Async', id_sub_or_product, _detailproduct);   
          resolve(_detailproduct);
        } catch (err) {
          console.error('❌ Lỗi trong getlocalDetailProduct_Async:', err);
          reject(err); // ✅ đừng quên reject nếu có lỗi
        }
      })();
    })
  }

  /**
   * Hàm kiểm tra và đồng bộ các sản phẩm trong bill_details (chi tiết hóa đơn)
   * @example:
   * this.vhQueryCafe.syncBillDetails_Products(array)
          .then(()=>{
          }, error=>{
            console.log('error', error);
          })
    * @param bill_details : Array
    * @return Promise => null
    * Luu ý: chỉ có 2 trường hợp, hoặc là sync thành công, hoặc là báo lỗi error
    */
  private syncBillDetails_Products(bill_details: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // Mảng chứa các promise cần thực hiện (tức là các sản phẩm cần tải về)
      let promise = new Array();
      // Duyệt qua từng dòng chi tiết trong bill_details
      for (let i = 0; i < bill_details.length; i++) {
        // Gán cờ kiểm tra xem sản phẩm đã tồn tại chưa
        let exist = false;
        // Lấy ra id của subproduct hoặc product (tùy theo cấu trúc dữ liệu)
        let id_sub_or_product = bill_details[i]?.id_subproduct
          ? bill_details[i]?.id_subproduct
          : bill_details[i].id_product;
        // Kiểm tra xem sản phẩm này đã có trong this.detailproducts chưa
        for (let j = 0; j < this.detailproducts.length; j++) {
          if (this.detailproducts[j]._id == id_sub_or_product) {
            exist = true;
            break; // nếu tìm thấy rồi thì dừng
          }
        }
        // Nếu chưa có trong danh sách => cần đồng bộ
        if (!exist) {
          console.log('syncBillDetails_Products', id_sub_or_product);
          // Gọi hàm getDetailProduct để lấy dữ liệu và lưu vào danh sách detailproducts
          promise[promise.length] = this.getDetailProduct(id_sub_or_product);
        }
      }

      // Khi tất cả các promise tải dữ liệu xong
      Promise.all(promise)
        .then(() => {
          // ✅ Đồng bộ xong hết
          resolve(null);
        })
        .catch(e => {
          // ❌ Nếu có lỗi trong quá trình tải
          reject(e);
        });
    });
  }

  
    /**
   * Hàm kiểm tra và đồng bộ các khách hàng trong bill_details (chi tiết hóa đơn), đảm bảo khách hàng trong bill_detail đã tồn tại trong local
   * @example:
   * this.vhQueryCafe.syncBillDetails_Customers(array)
          .then(()=>{
          }, error=>{
            console.log('error', error);
          })
   * @param bill_details : Array
   * @return Promise => null
   * Luu ý: chỉ có 2 trường hợp, hoặc là sync thành công, hoặc là báo lỗi error
   */
  private syncBillDetails_Customers(bill_details: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // Mảng chứa các promise cần thực hiện (tức là các khách hàng cần tải về)
      let promise = new Array();
      // Duyệt qua từng dòng chi tiết trong bill_details
      for (let i = 0; i < bill_details.length; i++) {
        if(bill_details[i].id_customer){
          // Gán cờ kiểm tra xem khách hàng đã tồn tại chưa
          let exist = false;
          // Lấy ra id của subproduct hoặc product (tùy theo cấu trúc dữ liệu)
          let id_customer = bill_details[i].id_customer
          // Kiểm tra xem khách hàng này đã có trong this.customers chưa
          for (let j = 0; j < this.customers.length; j++) {
            if (this.customers[j]._id == id_customer) {
              exist = true;
              break; // nếu tìm thấy rồi thì dừng
            }
          }
          // Nếu chưa có trong danh sách => cần đồng bộ
          if (!exist) {
            //console.log('syncBillDetails_Customers', id_customer);
            // Gọi hàm getCustomer để lấy dữ liệu và lưu vào danh sách customers
            promise[promise.length] = this.getCustomer(id_customer);
          }
        }        
      }

      // Khi tất cả các promise tải dữ liệu xong
      Promise.all(promise)
        .then(() => {
          // ✅ Đồng bộ xong hết
          resolve(null);
        })
        .catch(e => {
          // ❌ Nếu có lỗi trong quá trình tải
          reject(e);
        });
    });
  }

    /**
    * Hàm kiểm tra và đồng bộ các nhà cung cấp trong bill_details (chi tiết hóa đơn), đảm bảo nhà cung cấp trong bill_detail đã tồn tại trong local
    * @example:
    * this.vhQueryCafe.syncBillDetails_Suppliers(array)
          .then(()=>{
          }, error=>{
            console.log('error', error);
          })
    * @param bill_details : Array
    * @return Promise => null
    * Luu ý: chỉ có 2 trường hợp, hoặc là sync thành công, hoặc là báo lỗi error
    */
  private syncBillDetails_Suppliers(bill_details: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // Mảng chứa các promise cần thực hiện (tức là các nhà cung cấp cần tải về)
      let promise = new Array();
      // Duyệt qua từng dòng chi tiết trong bill_details
      for (let i = 0; i < bill_details.length; i++) {
        if(bill_details[i].id_supplier){
          // Gán cờ kiểm tra xem nhà cung cấp đã tồn tại chưa
          let exist = false;
          // Lấy ra id của supplier
          let id_supplier = bill_details[i]?.id_supplier
          // Kiểm tra xem nhà cung cấp này đã có trong this.suppliers chưa
          for (let j = 0; j < this.suppliers.length; j++) {
            if (this.suppliers[j]._id == id_supplier) {
              exist = true;
              break; // nếu tìm thấy rồi thì dừng
            }
          }
          // Nếu chưa có trong danh sách => cần đồng bộ
          if (!exist) {
            console.log('syncBillDetails_Suppliers', id_supplier);
            // Gọi hàm getSupplier để lấy dữ liệu và lưu vào danh sách suppliers
            promise[promise.length] = this.getSupplier(id_supplier);
          }
        }
      }

      // Khi tất cả các promise tải dữ liệu xong
      Promise.all(promise)
        .then(() => {
          // ✅ Đồng bộ xong hết
          resolve(null);
        })
        .catch(e => {
          // ❌ Nếu có lỗi trong quá trình tải
          reject(e);
        });
    });
  }

    /**
    * Hàm kiểm tra và đồng bộ các sản phẩm trong bill_details (chi tiết hóa đơn), đảm bảo nhân viên trong bill_detail đã tồn tại trong local
    * @example:
    * this.vhQueryCafe.syncBillDetails_Employees(array)
          .then(()=>{
          }, error=>{
            console.log('error', error);
          })
    * @param bill_details : Array
    * @return Promise => null
    * Luu ý: chỉ có 2 trường hợp, hoặc là sync thành công, hoặc là báo lỗi error
    */
  private syncBillDetails_Employees(bill_details: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // Mảng chứa các promise cần thực hiện (tức là các nhân viên cần tải về)
      let promise = new Array();
      // Duyệt qua từng dòng chi tiết trong bill_details
      for (let i = 0; i < bill_details.length; i++) {
        if(bill_details[i].id_employee){
          // Gán cờ kiểm tra xem nhân viên đã tồn tại chưa
          let exist = false;
          // Lấy ra id của employee
          let id_employee = bill_details[i]?.id_employee
          // Kiểm tra xem nhân viên này đã có trong this.employees chưa
          let employees = this.vhAuth.getlocalEmployees();
          for (let j = 0; j < employees.length; j++) {
            if (employees[j]._id == id_employee) {
              exist = true;
              break; // nếu tìm thấy rồi thì dừng
            }
          }
          // Nếu chưa có trong danh sách => cần đồng bộ
          if (!exist) {          
            // Gọi hàm getEmployee để lấy dữ liệu và lưu vào danh sách employees
            promise[promise.length] = this.vhAuth.getEmployee(id_employee);
          }
        }
      }

      // Khi tất cả các promise tải dữ liệu xong
      Promise.all(promise)
        .then(() => {
          // ✅ Đồng bộ xong hết
          resolve(null);
        })
        .catch(e => {
          // ❌ Nếu có lỗi trong quá trình tải
          reject(e);
        });
    });
  }
  
        

  /**
   * Hàm này tìm, kiểm tra barcode bất kỳ có tồn tại không, nếu có thì trả về 1 detailproduct, nếu ko thì trả về null
   * Hàm này dùng trong 2 trường hợp:
   * - Tìm kiếm sản phẩm có mã là barcode (dùng máy quét tìm sản phẩm đưa vào bill_detail)
   * - Kiểm tra xem đã tồn tại sản phẩm có mã là barcode chưa (khi thêm, sửa sản phẩm)
   * @example
   * let detailproduct = this.vhQueryCafe.getlocalDetailProduct_byBarcode('121212'); 
   * @param barcode
   * @return Object => obj = [{},{},...] hoặc null
   */
  public getlocalDetailProduct_byBarcode_Cafe(barcode:string){
    if((barcode ===null)||(barcode ==='')||(barcode ===undefined)) return null;
   let detailproducts = this.getlocalDetailProducts();
    for(let i=0; i<detailproducts.length; i++){
      //kiểm tra barcode ở ĐVT, nếu trùng thì return về và ngừng tìm
      if(detailproducts[i].units){
        for(let j=0; j<detailproducts[i].units.length; j++){
          if(detailproducts[i].units[j].barcode === barcode){
            let unit = {...detailproducts[i].units[j]};
           // delete unit.barcode;
            //return {...detailproducts[i], ...unit};
            return {...detailproducts[i], ratio: unit.ratio};
          }
        }
      }

      if(detailproducts[i].lots){
        for(let j=0; j<detailproducts[i].lots.length; j++){
          if(detailproducts[i].lots[j].barcode === barcode){
            let lot = {...detailproducts[i].lots[j]};
            //delete lot.barcode;
            return {...detailproducts[i], id_lotproduct: lot._id};
          }
        }
      }
      //kiểm tra barcode ở sản phẩm nếu trùng thì return về và ngừng tìm
      // if(detailproducts[i].barcode === barcode){
      //   return detailproducts[i]
      // }     
    }
    //Nếu đã tìm barcode ở tất cả trên từng tree của sản phẩm rồi mà ko có thì trả về null
    return null;
  }


   /**
   * @example:
   * this.vhQueryCafe.addProduct({name:'camera 2', quantity:20, price:200000})
          .then((product)=>{
            console.log('addProduct', product);
          }, error=>{
            console.log('error', error);
          })
   * @param data : object
   * @return Promise => object = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addProduct_Cafe(data:any){
      return new Promise((resolve, reject) => {          
        if(!data.manysize) {
          if(data?.type === 3) {  
            data.quantity = 0; data.quantity_branch = {};
            this.branchs.forEach((element:any) => {
              data.quantity_branch[element._id] = 0;
            }); 
          }
        }     
        data.id_branch = this.getDefaultBranch()._id;
        this.vhMGDB_database.addDoc('products', data)
            .then((obj)=>{
              resolve(obj);
            }, error=>{
              reject(error)
            })          
      })
    }  
   
    /**
     * @example:
     * this.vhQueryCafe.updateProduct('5fb6780ca2148e09806c5b01', {quantity:400})
            .then((bool:any)=>{
              console.log('updateProduct', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_product 
      * @param data 
      * @return Promise => bool = true or false
      */
    public updateProduct_Cafe(id_product:string, value:any){     
      return new Promise((resolve, reject) => {
        //if(checkSales_updateProduct(id_product, value)) return;      
        //let product = this.getlocalDetailProduct(id_product);    
        //if(product){
          // if(value.lots){
          //   for(let i=0; i<value.lots.length; i++){
          //     for(let j=0; j<product.lots.length; j++){
          //       if(value.lots[i]._id === product.lots[j]._id){
          //         value.lots[i] = {...product.lots[i], ...value.lots[j]};
          //       }
          //     }
          //   }
          // }  
          this.vhMGDB_database.updateDoc('products', id_product, value)
              .then((bool:any)=>{
                resolve(bool);
              }, error=>{
                reject(error)
              })         
        //}
      })
    }
    
  /**
   * @example:
   * this.vhQueryCafe.deleteProduct_Cafe('5fb67fda87c0f21d484cbdf3')
        .then((rsp)=>{
            if(rsp.vcode === 0){
                //-----------your code 0-----------            
            }else if(rsp.vcode === 1){
                //-----------your code 1-----------
            }else if(rsp.vcode === 2){
                //-----------your code 2-----------
            }             
        }, error=>{
          reject(error)
        })
    * @param id_product 
    *  @return Observable object => rsp = {vcode, message}
    * vcode == 0: xóa thành công
    * vcode == 1: Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác
    * vcode == 2: Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn
    * vcode == 3: Bạn không thể xóa, bạn phải xóa các thuộc tính của sản phẩm trước
    */
    public deleteProduct_Cafe(id_product:string){  //kiểm tra trong các chương trình bán hàng nữa
      return new Promise((resolve, reject) => {
        let product = this.getlocalProduct(id_product);
        //console.log('product', product);
        if((product.type === 1)||product.type === 3){
          if(product.subs?.length){
            console.log('Bạn không thể xóa, bạn phải xóa các thuộc tính của sản phẩm trước')
            return resolve({vcode:3, message: 'Bạn không thể xóa, bạn phải xóa các thuộc tính của sản phẩm trước'});
          }else{
            for(let i=0; i<this.products.length; i++){        
              if(this.products[i].combos?.length)
                for(let j=0; j<this.products[i].combos.length; j++){
                  if(this.products[i].combos[j]?.id_product === id_product){
                    console.log('Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác')
                    return resolve({vcode:1, message: 'Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác'});
                  }
                }                        
            }     
          }
  
          this.getBill_details_byID({id_product:{$eq:id_product}},{},1)
              .then((vhbill_details:any)=>{                      
                if(vhbill_details.length===0){         
                  this.vhMGDB_database.deleteDoc('products', id_product)
                      .then(()=>{                       
                          resolve({vcode:0, message: 'success'});                           
                      }, error=>{
                        reject(error)
                      }) 
                }else {
                  console.log('Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn')
                  resolve({vcode:2, message: 'Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn'});            
                }
              }, error=>{
                reject(error)
              })   
  
        }else if(product.type === 2){        
          for(let i=0; i<this.products.length; i++){        
            if(this.products[i].combos?.length)
              for(let j=0; j<this.products[i].combos.length; j++){
                if(this.products[i].combos[j]?.id_product === id_product){
                  console.log('Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác')
                  return resolve({vcode:1, message: 'Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác'});
                }
              }                        
          }             
          this.getBill_details_byID({id_product:{$eq:id_product}},{},1)
              .then((vhbill_details:any)=>{                      
                if(vhbill_details.length===0){         
                  this.vhMGDB_database.deleteDoc('products', id_product)
                      .then(()=>{                       
                          resolve({vcode:0, message: 'success'});                           
                      }, error=>{
                        reject(error)
                      }) 
                }else {
                  console.log('Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn')
                  resolve({vcode:2, message: 'Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn'});            
                }
              }, error=>{
                reject(error)
              }) 
        }else if(product.type === 5){
         this.getBill_details_byID({id_combos_group:{$eq:id_product}},{},1)
              .then((vhbill_details:any)=>{                      
                if(vhbill_details.length===0){         
                  this.vhMGDB_database.deleteDoc('products', id_product)
                      .then(()=>{                       
                          resolve({vcode:0, message: 'success'});                           
                      }, error=>{
                        reject(error)
                      }) 
                }else {
                  console.log('Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn')
                  resolve({vcode:2, message: 'Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn'});            
                }
              }, error=>{
                reject(error)
              }) 
        }else if(product.type === 4){
          for(let i=0; i<this.products.length; i++){
            if(this.products[i].type ===1){
              if(this.products[i].toppings){
                for(let j=0; j<this.products[i].toppings.length; j++){
                  if(this.products[i].toppings[j]?.id_product === id_product){
                    console.log('Bạn không thể xóa, bạn phải xóa topping này trong các sản phẩm trước')
                    return resolve({vcode:3, message: 'Bạn không thể xóa, bạn phải xóa topping này trong các sản phẩm trước'});
                  }
                }
              }
            }else if(this.products[i].type ===5){
              if(this.products[i].combos?.length){
                for(let j=0; j<this.products[i].combos.length; j++){
                  if(this.products[i].combos[j]?.id_product === id_product){
                    console.log('Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác')
                    return resolve({vcode:1, message: 'Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác'});
                  }
                }  
              }
            }
          }
          this.getBill_details_byID({id_product:{$eq:id_product}},{},1)
              .then((vhbill_details:any)=>{                      
                if(vhbill_details.length===0){         
                  this.vhMGDB_database.deleteDoc('products', id_product)
                      .then(()=>{                       
                          resolve({vcode:0, message: 'success'});                           
                      }, error=>{
                        reject(error)
                      }) 
                }else {
                  console.log('Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn')
                  resolve({vcode:2, message: 'Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn'});            
                }
              }, error=>{
                reject(error)
              })  
        }else if(product.type === 6){                    
          this.getBill_details_byID({id_product:{$eq:id_product}},{},1)
              .then((vhbill_details:any)=>{                      
                if(vhbill_details.length===0){         
                  this.vhMGDB_database.deleteDoc('products', id_product)
                      .then(()=>{                       
                          resolve({vcode:0, message: 'success'});                           
                      }, error=>{
                        reject(error)
                      }) 
                }else {
                  console.log('Bạn không thể xóa, vì địch vụ này đã phát sinh hóa đơn')
                  resolve({vcode:2, message: 'Bạn không thể xóa, vì dịch vụ này đã phát sinh hóa đơn'});            
                }
              }, error=>{
                reject(error)
              }) 
        }            
      })      
    }
  
  /**
   * @example:
   * this.vhQueryCafe.addCombosProduct('5fb6780ca2148e',[{id_product:'rtw554b5634573456', id_subproduct: 'gty3456ygw454287', quantity:2, price: 20000, type: 1},{},..])
          .then((combos)=>{
            console.log('addCombosProduct', combos);
          }, error=>{
            console.log('error', error);
          })
   * @param id_product
   * @param dataArray
   * @return Promise => object = [{id_product, name, price},{},...] hoặc null
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là null
   */
    public addCombosProduct_Cafe(id_product:any, dataArray:any){    
      for(let i=0; i<dataArray.length; i++){   //xóa khi nhân viên sửa xong
        delete dataArray[i]?.name;
      }
      //console.log('dataArray', dataArray)// xóa khi nhân viên sửa xong
      return new Promise((resolve, reject) => {         
          let combos = new Array();
          for(let i=0; i<dataArray.length; i++){        
            combos[i] = {...dataArray[i], _id:this.vhAlgorithm.ObjectId()};   
          }      
          let bool = false;
          let product:any;
          let number = 0;        
          let setinterval = setInterval(() => {
              number++;
              product = this.getlocalProduct(id_product);
              if(product){
                //console.log('product', product)        
                bool = true;
                if(product.combos === undefined)  product.combos = new Array();               
                for(let i=0; i<product.combos.length; i++){ 
                  delete product.combos[i]?.name; delete product.combos[i]?.img;                
                }             
                let _combos = [...product.combos, ...combos];                                    
                this.vhMGDB_database.updateDoc('products', id_product, {combos:_combos})
                    .then(()=>{                 
                      for(let i=0; i<combos.length; i++){        
                        let _product = this.getlocalProduct(combos[i].id_product);
                        //console.log('_product', _product)
                        combos[i].name = _product.name;                        
                        combos[i].img = _product.img;                         
                        if(combos[i].id_subproduct !=undefined){
                          for(let j=0; j<_product.subs.length;j++){
                            if(combos[i].id_subproduct === _product.subs[j]._id) {
                              combos[i].name = combos[i].name + '(' + _product.subs[j].name + ')';
                              break;
                            }                
                          }              
                        }
                      } 
                      resolve(combos);
                    }, ()=>{   
                      reject(null);                       
                    })               
              }       
              if((bool===true)||(number ===20)) clearInterval(setinterval);         
          }, 100);                      
      })
    }
  
    /**
     * @example:
     * this.vhQueryCafe.updateComboProduct('5fb6780ca2148e', 'rtw554b5634573456', {name:'Cơm chiên (nhỏ)', quantity: 2, price: 20000})
            .then((bool:any)=>{
              console.log('updateCombo', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_product 
      * @param data 
      * @return Promise => bool = true or false
      */
      public updateComboProduct_Cafe(id_product:string, id_comboproduct:string, data:any){
        //console.log('updateComboProduct', data);//nhân viên sửa xong sẽ xóa
        delete data?.name; delete data?.quantity;// nhân viên sửa xong sẽ xóa
        return new Promise((resolve, reject) => {
          let product:any = this.getlocalProduct(id_product);          
          if(product.combos != undefined){
            product.combos.forEach((item:any) => {
              delete item?.name; delete item?.img; 
            });
            for(let i=0; i<product.combos.length; i++){            
              if(product.combos[i]._id === id_comboproduct){              
                product.combos[i] = {...product.combos[i],...data};              
                this.vhMGDB_database.updateDoc('products', product._id, {combos: product.combos})
                    .then((bool:any)=>{
                      resolve(bool);
                    }, error=>{
                      reject(error)
                    })   
                break;
              }
            }   
          }                    
        })
      }      
      
  
    /**
      * hàm này tạo product và thêm subs vào product (lần đầu)
      * Lưu ý: trong product, subProductArray không có các trường quantity, quantity_branch và subs
      * @example:
      * @case 1: manysize (false)
      * let product = {
          allow_sell: true,
          brand: "OEM",
          tax: 0,
          id_category: "vTr90aYfhDqSCyuRh4DR",
          img: "image link",
          manysize: false,
          name: "test ko sub 3",
          selling: true,
          type: 1,
          warning_number: 3,
          item_code: '',
          units:[{
            barcode: "3103",
            price: 3100,
            price2: 3101,
            price_import: 3102,
            ratio: 1,
            unit: "Cái"
          }]      
      * }
      * @case 2: manysize (true)
      * let product = {
          allow_sell: true,
          brand: "OEM",
          tax: 0,
          id_category: "vTr90aYfhDqSCyuRh4DR",
          img: "image link",
          manysize: true,
          name: "test sub 4",
          selling: true,
          type: 1,
          warning_number: 3,
          item_code: '',
          units:[{          
            ratio: 1,
            unit: "Cái"
          },{
            barcode: "4203",
            price: 4200,
            price2: 4101,
            price_import: 4202,
            ratio: 10,
            unit: "Hộp"
          }]      
        }
        let subProductArray = [{
          barcode: "43004",
          name: "Lớn",
          price: 43000,
          price2: 43002,
          price_import: 43001,
          warning_number: 43003,
          item_code: ''
        }]
      * this.vhQueryCafe.addProductAndSubsProduct_Cafe(product,subProductArray)
            .then(()=>{
              console.log('addProductAndSubsProduct');
            }, error=>{
              console.log('error', error);
            })
      * @param product 
      * @param subProductArray 
      * @return Promise => object(product)
      * Promise => object = {} Luu ý: chỉ có 2 trường hợp, hoặc là tạo thành công, hoặc là báo lỗi error
      */
    public addProductAndSubsProduct_Cafe(product:any, subProductArray:any){        
      return new Promise((resolve, reject) => {  
        if(product.type ===1) if(checkCafe_addProductAndSubsProduct_type1(product, subProductArray)) return;  
        if(product.type ===3) if(checkCafe_addProductAndSubsProduct_type3(product, subProductArray)) return;  
        if(product.type ===1){            
          this.addProduct(product)
              .then((_product:any)=>{                 
                let promise = new Array();
                for(let i=0; i<subProductArray.length; i++){                  
                  subProductArray[i].id_branch = this.getDefaultBranch()._id;
                  subProductArray[i].id_subs_group = _product._id;              
                  promise[i] = this.vhMGDB_database.addDoc('products', subProductArray[i]);
                }    
                Promise.all(promise).then(()=>{              
                  resolve(_product);
                }, error=>{
                  console.log('error', error);
                  reject(error);
                })              
              }, error=>{
                console.log('error', error);
                reject(error);
              })
        }else if(product.type ===3){  
          if(!product.manysize){ 
            if(product.manylot){
              for(let j=0; j<product.lots.length; j++){
                product.lots[j]._id = this.vhAlgorithm.ObjectId();             
                  product.lots[j].quantity = 0;
                  product.lots[j].quantity_branch = {};
                  this.branchs.forEach((e:any) => {
                    product.lots[j].quantity_branch[e._id] = 0;
                  });               
              } 
            } 
          }
          this.addProduct(product)
              .then((_product:any)=>{                 
                let promise = new Array();
                for(let i=0; i<subProductArray.length; i++){                  
                  subProductArray[i].id_branch = this.getDefaultBranch()._id;
                  subProductArray[i].id_subs_group = _product._id;                     
                  subProductArray[i].quantity = 0;    
                  subProductArray[i].quantity_branch = {};    
                  this.branchs.forEach((e:any) => {
                    subProductArray[i].quantity_branch[e._id] = 0;
                  }); 
                  if(subProductArray[i].manylot){
                    for(let j=0; j<subProductArray[i].lots.length; j++){
                      subProductArray[i].lots[j]._id = this.vhAlgorithm.ObjectId();
                      subProductArray[i].lots[j].quantity = 0;
                      subProductArray[i].lots[j].quantity_branch = {};
                      this.branchs.forEach((e:any) => {
                        subProductArray[i].lots[j].quantity_branch[e._id] = 0;
                      }); 
                    } 
                  }             
                  promise[i] = this.vhMGDB_database.addDoc('products', subProductArray[i]);
                }    
                Promise.all(promise).then(()=>{              
                  resolve(_product);
                }, error=>{
                  console.log('error', error);
                  reject(error);
                })              
              }, error=>{
                console.log('error', error);
                reject(error);
              })
        }
      })    
    }
  
    /**
     * Hàm này cập nhật lại những thay đổi trong sub (cỡ) của sản phẩm
     * @example:
     * this.vhQueryCafe.updateSubProduct('5fb6780ca2148e09806c5b01', {quantity:400})
            .then((bool:any)=>{
              console.log('updateSubProduct', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_product 
      * @param id_subproduct       
      * @param data 
      * @return Promise => bool = true or false
      */
    public updateSubProduct_Cafe(id_subproduct:string, value:any){
      return new Promise((resolve, reject) => {  
        let product = this.getlocalDetailProduct(id_subproduct);        
        if(product.type ===1){                   
          if(checkCafe_updateSubProduct_type1(id_subproduct, value)) return;   
        }else if(product.type ===3){
          if(checkCafe_updateSubProduct_type3(id_subproduct, value)) return; 
        }  
        if(product){
          if(value.lots){
            for(let i=0; i<value.lots.length; i++){
              for(let j=0; j<product.lots.length; j++){ 
                if(value.lots[i]._id === product.lots[j]._id){
                  value.lots[i] = {...product.lots[i], ...value.lots[j]};
                }
              }
            }
          }        
          this.vhMGDB_database.updateDoc('products', id_subproduct, value)
              .then((bool:any)=>{
                resolve(bool);
              }, error=>{
                reject(error)
              })     
        }                 
      })
    }
  
    /**
      * Hàm này thêm Sub vào Product
      * @example:
      * let subProduct ={
          allow_sell: true,
          manylot: true,
          name: "Lớn",
          selling: true,
          type: 1,
          warning_number: 5,
          item_code: '',
          units:[{
            barcode: "384807544448",
            default: true,
            price: 70000,
            price2: 60000,
            price_import: 50000,
            ratio: 1,
            unit: "Cái"
          }],
          days_exp_warning: 30,
          days_import_warning: 60,
          lots:[{
            _id: "tgwOaMDVmQaHfaL8FD02SMl9"
            barcode: "337953449785"
            date_exp: 'October 7, 2022 at 11:59:59 PM UTC+7'
            date_mfg: 'March 1, 2022 at 12:00:00 AM UTC+7'
            hidden: false
            lot_number: "lo1101"
          }]
        }
      * this.vhQueryCafe.addSubProduct('5fb6780ca2148e09806c5b01',{price:0, name:'small'})
            .then((subproduct)=>{
              console.log('addSubProduct', subproduct);
            }, error=>{
              console.log('error', error);
            })
      * @param id_product 
      * @param subProduct 
      * @return Promise => null hoặc error
      * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công trả về null (resolve), hoặc là thất bại trả về error (reject)
      */
    public addSubProduct_Cafe(id_product:string, subProduct:any){ 
      return new Promise((resolve, reject) => { 
        let product = this.getlocalProduct(id_product);          
        if(product.type ===1){                   
          if(checkCafe_addSubProduct_type1(id_product, subProduct)) return;
        }else if(product.type ===3){
          if(checkCafe_addSubProduct_type3(id_product, subProduct)) return;
        }
        //sau này sẽ xem lại giá trị nào bên dưới ko cần thì bỏ đi
        subProduct.id_branch = this.getDefaultBranch()._id;
        subProduct.id_subs_group = id_product;    
        subProduct.type = 1;
        subProduct.quantity = 0;    
        subProduct.quantity_branch = {};    
        this.branchs.forEach((e:any) => {
          subProduct.quantity_branch[e._id] = 0;
        }); 
        if(subProduct.manylot){
          for(let j=0; j<subProduct.lots.length; j++){
            subProduct.lots[j]._id = this.vhAlgorithm.ObjectId();
            subProduct.lots[j].quantity = 0;
            subProduct.lots[j].quantity_branch = {};
            this.branchs.forEach((e:any) => {
              subProduct.lots[j].quantity_branch[e._id] = 0;
            }); 
          } 
        }    
        this.vhMGDB_database.addDoc('products', subProduct)
            .then(()=>{              
              resolve(null);
            }, error=>{
              console.log('error', error);
              reject(error);
            })              
                
      })
    }
  /**
    * Hàm này thêm Lot vào Product
    * @example:
    * let lot:{          
        barcode: "337953449785",
        date_exp: new Date('October 7, 2022 at 11:59:59 PM UTC+7'),
        date_mfg: new Date('March 1, 2022 at 12:00:00 AM UTC+7'),
        hidden: false,
        lot_number: "lo1101"
      }
    * this.vhQueryCafe.addLotProduct('5fb6780ca2148e09806c5b01',lot)
            .then(()=>{
              console.log('addLotProduct');
            }, error=>{
              console.log('error', error);
            })
      * @param id_sub_or_product 
      * @param lot 
      * @return Promise => newlot (lot có _id) hoặc error
      * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công trả về newlot (resolve), hoặc là thất bại trả về error (reject)
      */
    public addLotProduct_Cafe(id_sub_or_product:string, lot:any){
      return new Promise((resolve, reject) => {      
        let product = this.getlocalDetailProduct(id_sub_or_product); 
        let _lot = cloneDeep(lot);     
        if(product){
          if(product.lots){        
            _lot._id = this.vhAlgorithm.ObjectId();            
            _lot.quantity = 0;
            _lot.quantity_branch = {};       
            this.branchs.forEach((e:any) => {
              _lot.quantity_branch[e._id] = 0;
            });     
          }
          product.lots.push(_lot);        
          let data_branch:any = {};       
          this.branchs.forEach((e:any) => {          
            data_branch[e._id + '_ivtr'] = null;
          });         
          this.vhMGDB_database.updateDoc('products', id_sub_or_product,  {lots:[...product.lots], ...data_branch})
              .then(()=>{
                resolve(_lot);
              }, error=>{
                reject(error)
              })               
        }    
      }) 
    }
  
    /**
    * @example:
    * this.vhQueryCafe.deleteLotProduct('5fb67fda87c0f21d484cbdf3', 'NdbCy50cz5nNQyFVtITS')
          .then((rsp)=>{
            if(rsp.vcode === 0){
                //-----------your code 0-----------            
            }else if(rsp.vcode === 1){
                //-----------your code 1-----------
            }else if(rsp.vcode === 2){
                //-----------your code 2-----------
            }     
        }, error=>{
          reject(error)
        })
    * @param id_sub_or_product   
    * @param id_lotproduct       
    * @return Promise object => rsp = {vcode, message}
    * vcode == 0: xóa thành công
    * vcode == 1: Bạn không thể xóa, vì lô sản phẩm này không tồn tại
    * vcode == 2: Bạn không thể xóa, vì lô sản phẩm này đã phát sinh hóa đơn
    */ 
    public deleteLotProduct_Cafe(id_sub_or_product:string, id_lotproduct:string){
      return new Promise((resolve, reject) => {      
        let product = this.getlocalDetailProduct(id_sub_or_product);    
        let exists = false;  
        if(product){
          if(product.lots){        
            for(let i=0; i<product.lots.length; i++){
              if(product.lots[i]._id === id_lotproduct){
                product.lots.splice(i, 1); exists = true;
                break;
              }
            }   
          }               
        } 
        
        if(exists){
         this.getBill_details_byID({id_lotproduct:{$eq:id_lotproduct}},{},1)
              .then((vhbill_details:any)=>{                      
                if(vhbill_details.length===0){ 
                  let data_branch:any = {};       
                  this.branchs.forEach((e:any) => {          
                    data_branch[e._id + '_ivtr'] = null;
                  }); 
                  //console.log('product.lots', product.lots);
                  this.vhMGDB_database.updateDoc('products', id_sub_or_product,  {lots:[...product.lots], ...data_branch})
                      .then(()=>{
                        resolve({vcode:0, message: 'success'}); 
                      }, error=>{
                        reject(error)
                      })            
                }else {
                  console.log('Bạn không thể xóa, vì lô sản phẩm này đã phát sinh hóa đơn')
                  resolve({vcode:2, message: 'Bạn không thể xóa, vì lô sản phẩm này đã phát sinh hóa đơn'});       
                }
              }, error=>{
                reject(error)
              })  
        }else{
          console.log('Bạn không thể xóa, vì lô sản phẩm này không tồn tại')
          resolve({vcode:1, message: 'Bạn không thể xóa, vì lô sản phẩm này không tồn tại'});    
        } 
      }) 
    }
  
    /**
      * this.vhQueryCafe.updateLotProduct('5fb6780ca2148e09806c5b01','56s46ww54HFG3H265', {barcode: '13464160156465'})
            .then((bool:any)=>{
              console.log('updateLotProduct', bool);
            }, error=>{
              console.log('error', error);
            })
      * @param id_sub_or_product 
      * @param id_lotproduct 
      * @param value 
      * @return Promise => bool = true or false
      */
    public updateLotProduct_Cafe(id_sub_or_product:string, id_lotproduct:string, value:any){
      return new Promise((resolve, reject) => {
        let product = this.getlocalDetailProduct(id_sub_or_product);    
        //let exists = false;  
        if(product){
          if(product.lots){        
            for(let i=0; i<product.lots.length; i++){
              if(product.lots[i]._id === id_lotproduct){          
                for(const p in value){
                  product.lots[i][p] = value[p]
                }
                this.vhMGDB_database.updateDoc('products', id_sub_or_product,  {lots:[...product.lots]})
                    .then(()=>{
                      resolve(true);
                    }, error=>{
                      reject(error)
                    })   
                break;           
              }
            }   
          }               
        } 
      })
    }
  
    /**
    * Hàm này thêm Subs vào Product
    * @example:
    * this.vhQueryCafe.addSubsProduct('5fb6780ca2148e09806c5b01',[{price:0, name:'small'},{},...])
          .then((subproducts)=>{
            console.log('addSubsProduct', subproducts);
          }, error=>{
            console.log('error', error);
          })
    * @param id_product 
    * @param subProductArray 
    * @return Promise => null hoặc error
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công trả về null (resolve), hoặc là thất bại trả về error (reject)
    */
    private addSubsProduct_Cafe(id_product:any, subProductArray:any){
      return new Promise((resolve, reject) => {       
        let promise = new Array();
        for(let i=0; i<subProductArray.length; i++){ 
          //sau này sẽ xem lại giá trị nào bên dưới ko cần thì bỏ đi
          subProductArray[i].id_branch = this.getDefaultBranch()._id;
          subProductArray[i].id_subs_group = id_product;    
          subProductArray[i].type = 1;
          subProductArray[i].quantity = 0;    
          subProductArray[i].quantity_branch = {};    
          this.branchs.forEach((e:any) => {
            subProductArray[i].quantity_branch[e._id] = 0;
          }); 
          if(subProductArray[i].manylot){
            for(let j=0; j<subProductArray[i].lots.length; j++){
              subProductArray[i].lots[j]._id = this.vhAlgorithm.ObjectId();
            } 
          }    
          promise[i] = this.vhMGDB_database.addDoc('products', subProductArray[i]);
        }    
        Promise.all(promise).then(()=>{              
          resolve(null);
        }, error=>{
          console.log('error', error);
          reject(error);
        })              
                
      })
    }
  
  /**
    * @example:
    * this.vhQueryCafe.deleteSubProduct('5fb67fda87c0f21d484cbdf3')
          .then((rsp)=>{
            if(rsp.vcode === 0){
                //-----------your code 0-----------            
            }else if(rsp.vcode === 1){
                //-----------your code 1-----------
            }else if(rsp.vcode === 2){
                //-----------your code 2-----------
            }     
        }, error=>{
          reject(error)
        })
    * @param id_subproduct      
    * @return Promise object => rsp = {vcode, message}
    * vcode == 0: xóa thành công
    * vcode == 1: Bạn không thể xóa, vì sản phẩm con này đang liên kết với sản phẩm combo khác
    * vcode == 2: Bạn không thể xóa, vì sản phẩm con này đã phát sinh hóa đơn
    */  
    public deleteSubProduct_Cafe(id_subproduct:string){  
      return new Promise((resolve, reject) => {
        let IDproducts = new Array();
        for(let i=0; i<this.products.length; i++){        
          if(this.products[i].combos){
            for(let j=0; j<this.products[i].combos.length; j++){
              if(this.products[i].combos[j].id_subproduct === id_subproduct){
                console.log('Bạn không thể xóa, vì sản phẩm con này đang liên kết với sản phẩm combo khác');
                return resolve({vcode:1, message: 'Bạn không thể xóa, vì sản phẩm con này đang liên kết với sản phẩm combo khác'});
              }
            }         
          } 
        }     
        this.getBill_details_byID({id_subproduct:{$eq:id_subproduct}},{},1)
            .then((vhbill_details:any)=>{                      
              if(vhbill_details.length===0){              
                this.vhMGDB_database.deleteDoc('products', id_subproduct)  
                    .then(()=>{                   
                      resolve({vcode:0, message: 'success'});                           
                    }, error=>{
                      reject(error)
                    }) 
              }else {
                console.log('Bạn không thể xóa, vì sản phẩm con này đã phát sinh hóa đơn')
                resolve({vcode:2, message: 'Bạn không thể xóa, vì sản phẩm con này đã phát sinh hóa đơn'});       
              }
            }, error=>{
              reject(error)
            })    
      })
    }

  private publishObservableEventCustomers() {
    this.subjectcustomers.next(this.customers);
  }  

  private observableLocalCustomers():Subject<any> {      
    return this.subjectcustomers; 
  }
  
   /**
   * @example:
   * this.observableCustomer = this.vhQueryCafe.getObservableLocalCustomers().subscribe((localCustomers:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableCustomer.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalCustomers(){   
   return new Observable((observer:any) => {    
    this.observableLocalCustomers().subscribe((customers) => {   
      observer.next(customers);
    })
    this.publishObservableEventCustomers();
   })
  }

  /**
   * @example: 
   * let customer = this.vhQueryCafe.getlocalCustomer('5fb6780ca2148e09806c5b01');
   * @param id_customer 
   * @return Object => obj = {} or null
   */
  public getlocalCustomer(id_customer:any){
    for(let i=0; i<this.customers.length; i++){
      if(this.customers[i]._id === id_customer){
        return this.customers[i];
        break;
      }
    } 
    return null; 
  }

  /**
   * @example: 
   * this.vhQueryCafe.getlocalCustomer_Async('ETxNu8exrvGtXFjkIhnc')
          .then((customer)=>{
          }, error=>{
            console.log('error', error);
          })
   * @param id_customer 
   * @return Object => obj = {} or null
   */
  private getlocalCustomer_Async(id_customer:string):Promise<any>{   
    return new Promise((resolve, reject) => {
      (async () => {
        try{
          for(let i=0; i<this.customers.length; i++){
            if(this.customers[i]._id === id_customer){
              return resolve(this.customers[i]);
            }
          } 
          let _customer = await this.getCustomer(id_customer);
          resolve(_customer)
        } catch (err) {
          console.error('❌ Lỗi getlocalCustomer_Async:', err);
          reject(err);
        }  
      })();
    })
  }
  /**
   * @example: 
   * let customers = this.vhQueryCafe.getlocalCustomers();
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalCustomers(){    
    return this.customers;
  }
  
  /**
   * @example:
   * this.vhQueryCafe.refreshLocalCustomers()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalCustomer(), getlocalCustomers() trong localstorage
   * @return Promise => null
   */
  public refreshLocalCustomers():any{
    return new Promise((resolve) => { 
      // this.getCustomers()
      //     .then(()=>{resolve(null)})       
      resolve(null)
    })
  }

  /**
   * Hàm này dùng để đồng bộ dữ liệu ẩn (delete_hidden = true) từ database về local
   * @example:
   * this.vhQueryCafe.refreshLocalCustomers_Delete_Hidden()
        .then(()=>{
          do something.....
        })
  * Hàm này refresh giá trị mới nhất cho hàm getlocalCustomer(), getlocalCustomers() trong localstorage
  * @param type
  * @return Promise => null
  */
  public refreshLocalCustomers_Delete_Hidden():any{
    return new Promise((resolve, reject) => { 
      if(this.getBranch_Management_Scope().product_scope){
        this.vhMGDB_database.getDocsByFields('customers', {delete_hidden:{$eq:true}})
            .then((customers:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `customers` trong bộ nhớ local
              for(let i=0; i<customers.length; i++){
                delete customers[i].name_keywords;
                delete customers[i].phone_keywords;        
                if(!this.getlocalCustomer(customers[i]._id)){
                  this.customers.push(customers[i]);      
                }   
              }              
              resolve(null);
            }, error=>{
              reject(error)
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('customers', {id_branch:{$eq: this.getDefaultBranch()._id},delete_hidden:{$eq:true}})
            .then((customers:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `customers` trong bộ nhớ local
              for(let i=0; i<customers.length; i++){
                delete customers[i].name_keywords;
                delete customers[i].phone_keywords;        
                if(!this.getlocalCustomer(customers[i]._id)){
                  this.customers.push(customers[i]);      
                }   
              }              
              resolve(null);
            }, error=>{
              reject(error)
            })  
      }    
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addCustomer({name:'Khách hàng 1', address: 'HCM'})
          .then((rsp)=>{
            if(rsp.vcode == 0){
              //addCustomer thành công
            }else if(rsp.vcode == 0){
              //This phone number is already in use with another customer
            }
          },(error:any)=>{
            console.log('error', error);
          })
   * @param data: Có cả 3 trường countryCode, phone và phoneNumber
   * @return Promise => rsp ={vcode, msg, data(obj)}
   * vcode = 0: 'success'
   * vcode = 1: 'This phone number is already in use with another customer'
   */
  public addCustomer(data:any){
    return new Promise((resolve, reject) => {
      //Setting trong phần mềm sẽ thay thế biến này
      let unique_phone_number = true;
      // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
      if (!(data.countryCode && data.phone && data.phoneNumber)) {
        // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
        return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
      } 
      if(data.name) {
        data.name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(data.name)).toLowerCase());
      }
      if(data.phone) {
        data.phone_keywords = this.vhAlgorithm.getSequentialSubstrings(data.phone,6)
      }
      if(unique_phone_number){     
        this.vhMGDB_database.getDocsByFields('customers', {phoneNumber:{$eq:data.phoneNumber}}, {})
            .then((customers:any)=>{
              if(customers.length == 0){
                this.vhMGDB_database.addDoc('customers', data)
                    .then((customer:any)=>{
                      resolve({vcode:0, msg: 'success', data: customer}); 
                    },(error:any)=>{
                      reject(error);
                    })   
              }else{
                resolve({vcode:1, msg: 'This phone number is already in use with another customer'}); 
              }
          },error=>{
            reject(error);
          })              
      }else{
        this.vhMGDB_database.addDoc('customers', data)
            .then((customer:any)=>{
              resolve({vcode:0, msg: 'success', data: customer}); 
            },(error:any)=>{
              reject(error);
            }) 
      }             
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.addCustomers([{name:'Khách hàng 1', address: 'HCM'},{},...])
        .then((rsp)=>{
            if(rsp.vcode == 0){
              //addCustomers thành công
            }else if(rsp.vcode == 0){
              //Phone numbers in the list are duplicated
            }
          },(error:any)=>{
            console.log('error', error);
          })
  * @param data : array(object), Có cả 3 trường countryCode, phone và phoneNumber
  * @return  Promise => {vcode, msg, data(array)}
  * vcode = 0: 'success'
  * vcode = 1: 'Phone numbers in the list are duplicated'
  */
  public addCustomers(arr_data:any){
    return new Promise((resolve, reject) => {
      //Setting trong phần mềm sẽ thay thế biến này
      let unique_phone_number = true;
      for(let i=0; i<arr_data.length; i++){  
        // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
        if (!(arr_data[i].countryCode && arr_data[i].phone && arr_data[i].phoneNumber)) {
          // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
          return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
        }
        //Thời điểm tạo khách hàng
        arr_data[i].updated_at = new Date();
        //Tạo keywords cho name và phone
        if(arr_data[i].name) {
          arr_data[i].name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(arr_data[i].name)).toLowerCase());
        }
        if(arr_data[i].phone) {
          arr_data[i].phone_keywords = this.vhAlgorithm.getSequentialSubstrings(arr_data[i].phone,6)
        }
      }
      if(unique_phone_number){
        for(let i=0; i<arr_data.length; i++){
          //check các sô trong arr_data trùng nhau
          for(let j=i+1; j<arr_data.length; j++){
            if(arr_data[j].phoneNumber == arr_data[i].phoneNumber) return resolve({vcode:1, msg: 'Phone numbers in the list are duplicated'}); 
          }
        }
        let promise = new Array();
        for(let i=0; i<arr_data.length; i++){
          promise[i] = new Promise(resolve=>{
            this.vhMGDB_database.getDocsByFields('customers', {phoneNumber:{$eq:arr_data[i].phoneNumber}}, {})
                .then((customers:any)=>{
                  if(customers.length == 0){
                    this.vhMGDB_database.addDoc('customers', arr_data[i])
                        .then((customer:any)=>{
                          resolve(customer); 
                        },(error:any)=>{
                          resolve(null);
                        })   
                  }else{
                    resolve(null); 
                  }                            
                },error=>{
                  reject(error);
                }) 
          })
        } 
        Promise.all(promise).then((array:any)=>{
          let _array = array.filter((item:any)=> (item != null))
          resolve({vcode:0, msg: 'success', data: _array});       
        })   
      }else{
        let promise = new Array();
        for(let i=0; i<arr_data.length; i++){         
          promise[i] = new Promise(resolve=>{
            arr_data[i].id_branch = this.getDefaultBranch()._id;
            this.vhMGDB_database.addDoc('customers', arr_data[i])
                .then((customer)=>{
                  resolve(customer);
                }, (error)=>{                 
                  resolve(null);
                }) 
          })                       
        }
        Promise.all(promise).then((array:any)=>{
          let _array = array.filter((item:any)=> (item != null))
          resolve({vcode:0, msg: 'success', data: _array});       
        })   
      }
                    
    })
  }

 /**
   * @example:
   * this.vhQueryCafe.updatePCustomer('5fb6780ca2148e09806c5b01', {name: Nguyễn Thị Nở})
          .then((rsp)=>{
            if(rsp.vcode == 0){
              //updatePCustomer thành công
            }else if(rsp.vcode == 0){
              //This phone number is already in use with another customer
            }
          },(error:any)=>{
            console.log('error', error);
          })
   * @param id_customer 
   * @param value : Nếu value hoặc có cả 3 trường countryCode, phone, phoneNumber hoặc ko có
   * @return  Promise => {vcode, msg, data(true/false)}
   * vcode = 0: 'success'
   * vcode = 1: 'This phone number is already in use with another supplier'
   */
  public updateCustomer(id_customer:string, value:any){
    return new Promise((resolve, reject) => {      
      //Setting trong phần mềm sẽ thay thế biến này
      let unique_phone_number = true; 
      // Nếu ít nhất một trong ba trường countryCode, phone hoặc phoneNumber có giá trị
      if (value.countryCode || value.phone || value.phoneNumber) {
        // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
        if (!(value.countryCode && value.phone && value.phoneNumber)) {
          // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
          return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
        }
      }
      if(value.name) {
        value.name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(value.name)).toLowerCase());
      }
      if(value.phone) {
        value.phone_keywords = this.vhAlgorithm.getSequentialSubstrings(value.phone,6)
      }
      if(value.phoneNumber && unique_phone_number){
        this.vhMGDB_database.getDocsByFields('customers', {phoneNumber:{$eq:value.phoneNumber}}, {})
            .then((customers:any)=>{
              if(customers.length == 0){
                this._updateCustomer(id_customer, value)
                    .then((bool:any)=>{
                      resolve({vcode:0, msg: 'success', data: bool}); 
                    }, error=>{
                      reject(error)
                    }) 
              }else{
                if(customers[0]._id == id_customer){
                  this._updateCustomer(id_customer, value)
                      .then((bool:any)=>{
                        resolve({vcode:0, msg: 'success', data: bool}); 
                      }, error=>{
                        reject(error)
                      }) 
                }else{
                  resolve({vcode:1, msg: 'This phone number is already in use with another customer'}); 
                }
              }
            },error=>{
              reject(error);
            })     
      }else{
        this._updateCustomer(id_customer, value)
            .then((bool:any)=>{
              resolve({vcode:0, msg: 'success', data: bool}); 
            }, error=>{
              reject(error)
            }) 
      }        
    })
  }

  private _updateCustomer(id_customer:string, value:any){
    return new Promise((resolve, reject) => {
      value.updated_at = new Date();
      this.vhMGDB_database.updateDoc('customers', id_customer, value)
          .then((bool:any)=>{
            resolve(bool); 
          }, error=>{
            reject(error)
          }) 
    })    
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteCustomer('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteCustomer', bool);
        })
   * @param id_customer 
   * @return Promise => bool = true or false
   */
  public deleteCustomer(id_customer:string){
    return new Promise((resolve, reject) => {
      this.getBills_byFields({id_customer:{$eq:id_customer}},{},{},1)
          .then((bills:any)=>{                      
            if(bills.length===0){              
              this.vhMGDB_database.deleteDoc('customers', id_customer)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })    
            }else resolve(false);
          }, error=>{
            reject(error)
          })           
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getCustomer('5fb67fda87c0f21d484cbdf3')
            .then((customer)=>{
              console.log('getCustomer', customer);
            })
   * @param id_customer 
   * @return Promise => obj = {} or null
   */
  public getCustomer(id_customer:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('customers', id_customer)
            .then((customer:any)=>{
              if(customer){
                let exist = false;
                for(let i=0; i<this.customers.length; i++){
                  if(this.customers[i]._id == id_customer){
                    exist = true;                    
                    break;
                  }
                }
                if(!exist) this.customers.push(customer);
              }
              resolve(customer);
            },(error:any)=>{
              reject(error);
            })            
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getCustomers()
            .then((customers)=>{
              console.log('getCustomers', customers);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getCustomers(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('customers')
            .then((customers)=>{
              this.customers = customers;
              resolve(customers);
            },(error:any)=>{
              reject(error);
            })            
    })
  }

  
  /**
   * Hàm này dùng để xóa hoặc đặt lại điểm mới cho khách hàng
   * @example:
   * this.vhQueryCafe.updateCustomer_byPoints('5fb6780ca2148e09806c5b01', 1000)
          .then((bool:any)=>{
            console.log('updateCustomer_byPoints', bool);
          })
   * @param _id 
   * @param points 
   * @return Promise => bool = true or false
   */
  public updateCustomer_byPoints(_id:string, points:number){
    return new Promise((resolve,reject) => {
      let customer = this.getlocalCustomer(_id);
      if(customer.earned_points != undefined){
        customer.earned_points = points;
      }else{
        customer.earned_points = points;
      }
      let branch = this.getDefaultBranch();
      if(customer.branch_earned_points !=undefined){
        if(customer.branch_earned_points[branch._id] !=undefined){
          customer.branch_earned_points[branch._id] = points;
        }else{
          customer.branch_earned_points[branch._id] = points;
        }
      }else{
        customer.branch_earned_points = {};
        customer.branch_earned_points[branch._id] = points;
      }
      let value_customer = {
        earned_points: customer.earned_points,
        branch_earned_points: customer.branch_earned_points    
      }
      //promise_one[promise_one.length] = this._updateCustomer(customer._id, value_customer);
      this._updateCustomer(_id, {...value_customer})
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * Hàm này thêm điểm mới kiếm được vào quỹ điểm khách hàng đang có
   * points = points(tích được trên bill) - point (sử dụng thanh toán trên bill)
   * @example:
   * this.vhQueryCafe.updateCustomer_byEarnedPoints('5fb6780ca2148e09806c5b01', 200)
          .then((bool:any)=>{
            console.log('updateCustomer_byEarnedPoints', bool);
          })
    * @param _id 
    * @param points 
    * @return Promise => bool = true or false
    */
  public updateCustomer_byEarnedPoints(_id:string, points:number){
    return new Promise((resolve,reject) => {
      let customer = this.getlocalCustomer(_id);
      if(customer.earned_points != undefined){
        customer.earned_points = customer.earned_points + points;
      }else{
        customer.earned_points = points;
      }
      let branch = this.getDefaultBranch();
      if(customer.branch_earned_points !=undefined){
        if(customer.branch_earned_points[branch._id] !=undefined){
          customer.branch_earned_points[branch._id] = customer.branch_earned_points[branch._id] + points;
        }else{
          customer.branch_earned_points[branch._id] = points;
        }
      }else{
        customer.branch_earned_points = {};
        customer.branch_earned_points[branch._id] = points;
      }
      let value_customer = {
        earned_points: customer.earned_points,
        branch_earned_points: customer.branch_earned_points    
      }
      //promise_one[promise_one.length] = this._updateCustomer(customer._id, value_customer);
      this._updateCustomer(_id, {...value_customer})
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }


  /**
   * Hàm này trả về điểm của khách hàng theo phạm vị chương trình bán hàng là toàn chi nhánh hay là từng chi nhánh
   * @example: 
   * let customer = this.vhQueryCafe.getlocalCustomer_byPoints('5fb6780ca2148e09806c5b01');
   * @param id_customer 
   * @return Object => obj = {} or null
   */
  public getlocalCustomerPoints(id_customer:any){     
    let branch = this.getDefaultBranch(); 
    for(let i=0; i<this.customers.length; i++){
      if(this.customers[i]._id === id_customer){
        if(this.getBranch_Management_Scope().sales_program_scope){
          if(this.customers[i].earned_points != undefined){
            return this.customers[i].earned_points;
          }else{
            return 0;
          }
        }else{
          if(this.customers[i].branch_earned_points !=undefined){
            if(this.customers[i].branch_earned_points[branch._id] !=undefined){
              return this.customers[i].branch_earned_points[branch._id];
            }else{
              return 0;
            }
          }else{
            return 0;
          }
        }         
        break;
      }
    }       
  }

  /**
    * Hàm tìm kiếm tên chủ sở hữu và số điện thoại, nghĩa là nhập 1 chuỗi tên (2 từ trở lên) hoặc chuỗi số (6 ký tự trở lên) hàm sẽ
    * trả về những chủ sở hữu có tên hoặc số điện thoại tương ứng với keyword tìm kiếm
    *  @example:
    * this.vhQuerySales.searchKeyword_NamePhone({'customers, '925354'})
          .then((rsp)=>{
            console.log('searchKeyword_NamePhone', rsp);
          },(error:any)=>{
            console.log('error', error);
          })
    * @param name_or_phone 
    * @param countryCode 
    * @returns Promise = > {vcode, msg, data(array)}
    */
    public searchKeyword_NamePhone(colname:string, name_or_phone:string, countryCode?:string){
      return new Promise((resolve, reject) => {
        //Bỏ dấu và chuyển sang chuỗi các ký tự thường
        name_or_phone = (this.vhAlgorithm.changeAlias_withCharacter(name_or_phone)).toLowerCase();
        //Chuẩn hóa chuỗi, nếu có nhiều hơn 1 khoảng trống liên tiếp thì chỉ giữ lại 1 khoảng trống, bỏ cả khoảng trống đầu và cuối chuỗi
        name_or_phone = this.vhAlgorithm.normalizeSpaces(name_or_phone);
        //Nếu chuỗi số (các ký tự trong chuôi là số)
        if(this.vhAlgorithm.isNumericString(this.vhAlgorithm.removeAllSpaces(name_or_phone))){
          let keyword = this.vhAlgorithm.removeAllSpaces(name_or_phone);
          let query = {phone_keywords:{$array_contains:keyword}}
          this.vhMGDB_database.getDocsByFields(colname, query, {}, {}, 20)
              .then((rsp:any)=>{
                  //console.log('searchList_Keyword', rsp);
                  if(rsp.vcode ==0){
                    for(let i=0; i<rsp.data?.length; i++){
                      delete rsp.data[i].name_keywords;
                      delete rsp.data[i].phone_keywords;
                    }
                  }
                  resolve(rsp)
                },error=>{
                  reject(error)
                })
        }else{//Nếu chuỗi ký tự (trong chuỗi có chữ)
          let keywords = name_or_phone.split(" ");
          if(keywords.length >= 2){
            let keyword = name_or_phone;
            let query = {name_keywords:{$array_contains:keyword}}
            this.vhMGDB_database.getDocsByFields(colname, query, {}, {}, 20)
                .then((rsp:any)=>{
                    //console.log('searchList_Keyword', rsp);
                    if(rsp.vcode ==0){
                      for(let i=0; i<rsp.data?.length; i++){
                        delete rsp.data[i].name_keywords;
                        delete rsp.data[i].phone_keywords;
                      }
                    }
                    resolve(rsp)
                  },error=>{
                    reject(error)
                  })
          }
        }
      })
    }
        

  private publishObservableEventSuppliers() {
    this.subjectsuppliers.next(this.suppliers);
  }  

  private observableLocalSuppliers():Subject<any> {      
    return this.subjectsuppliers; 
  }
  
   /**
   * @example:
   * this.observableSupplier = this.vhQueryCafe.getObservableLocalSuppliers().subscribe((localSuppliers:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableSupplier.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalSuppliers(){   
   return new Observable((observer:any) => {    
    this.observableLocalSuppliers().subscribe((suppliers) => {   
      observer.next(suppliers);
    })
    this.publishObservableEventSuppliers();
   })
  }

   /**
   * @example: 
   * let supplier = this.vhQueryCafe.getlocalSupplier('5fb6780ca2148e09806c5b01');
   * @param id_supplier 
   * @return Object => obj = {} or null
   */
  public getlocalSupplier(id_supplier:any){
    for(let i=0; i<this.suppliers.length; i++){
      if(this.suppliers[i]._id === id_supplier){
        return {...this.suppliers[i]};       
      }
    } 
    return null; 
  }

  /**
   * @example: 
   * this.vhQueryCafe.getlocalSupplier_Async('ETxNu8exrvGtXFjkIhnc')
          .then((customer)=>{
          }, error=>{
            console.log('error', error);
          })
   * @param id_supplier
   * @return Object => obj = {} or null
   */
    private getlocalSupplier_Async(id_supplier:string):Promise<any>{   
      return new Promise((resolve, reject) => {
        (async () => {
          try{
            for(let i=0; i<this.suppliers.length; i++){
              if(this.suppliers[i]._id === id_supplier){
                return resolve(this.suppliers[i]);
              }
            } 
            let _supplier = await this.getCustomer(id_supplier);
            resolve(_supplier)
          } catch (err) {
            console.error('❌ Lỗi getlocalSupplier_Async:', err);
            reject(err);
          }  
        })();
      })
    }

  /**
   * @example: 
   * let suppliers = this.vhQueryCafe.getlocalWallets();
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalSuppliers(){    
    return this.suppliers;
  }
  
   /**
   * this.vhQueryCafe.refreshLocalSuppliers()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalSupplier(), getlocalSuppliers() trong localstorage
   * @return Promise => null
   */
  public refreshLocalSuppliers():any{
    return new Promise((resolve) => { 
      // this.getSuppliers()
      //     .then(()=>{resolve(null)})      
      resolve(null) 
    })
  }

  /**
   * Hàm này dùng để đồng bộ dữ liệu ẩn (delete_hidden = true) từ database về local
   * @example:
   * this.vhQueryCafe.refreshLocalSuppliers_Delete_Hidden()
        .then(()=>{
          do something.....
        })
  * Hàm này refresh giá trị mới nhất cho hàm getlocalSupplier(), getlocalSuppliers() trong localstorage
  * @param type
  * @return Promise => null
  */
  public refreshLocalSuppliers_Delete_Hidden():any{
    return new Promise((resolve, reject) => { 
      if(this.getBranch_Management_Scope().product_scope){
        this.vhMGDB_database.getDocsByFields('suppliers', {delete_hidden:{$eq:true}})
            .then((suppliers:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `suppliers` trong bộ nhớ local
              for(let i=0; i<suppliers.length; i++){
                delete suppliers[i].name_keywords;
                delete suppliers[i].phone_keywords;        
                if(!this.getlocalSupplier(suppliers[i]._id)){
                  this.suppliers.push(suppliers[i]);      
                }   
              }              
              resolve(null);
            }, error=>{
              reject(error)
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('suppliers', {id_branch:{$eq: this.getDefaultBranch()._id},delete_hidden:{$eq:true}})
            .then((suppliers:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `suppliers` trong bộ nhớ local
              for(let i=0; i<suppliers.length; i++){
                delete suppliers[i].name_keywords;
                delete suppliers[i].phone_keywords;        
                if(!this.getlocalSupplier(suppliers[i]._id)){
                  this.suppliers.push(suppliers[i]);      
                }   
              }              
              resolve(null);
            }, error=>{
              reject(error)
            })  
      }    
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.addSupplier({name:'Nhà cung cấp 1', address: 'HCM'})
          .then((rsp)=>{
            if(rsp.vcode == 0){
              //addSupplier thành công
            }else if(rsp.vcode == 0){
              //This phone number is already in use with another customer
            }
          },(error:any)=>{
            console.log('error', error);
          })
   * @param data: Có cả 3 trường countryCode, phone và phoneNumber
   * @return Promise => rsp ={vcode, msg, data(obj)}
   * vcode = 0: 'success'
   * vcode = 1: 'This phone number is already in use with another supplier'
   */
    public addSupplier(data:any){
      return new Promise((resolve, reject) => {
        //Thời điểm tạo nhà cung cấp
        data.updated_at = new Date();
        //Setting trong phần mềm sẽ thay thế biến này
        let unique_phone_number = true;
        // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
        if (!(data.countryCode && data.phone && data.phoneNumber)) {
          // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
          return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
        }
        data.id_branch = this.getDefaultBranch()._id;
        if(data.name) {
          data.name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(data.name)).toLowerCase());
        }
        if(data.phone) {
          data.phone_keywords = this.vhAlgorithm.getSequentialSubstrings(data.phone,6)
        }
        if(unique_phone_number){     
          this.vhMGDB_database.getDocsByFields('suppliers', {phoneNumber:{$eq:data.phoneNumber}}, {})
              .then((suppliers:any)=>{
                if(suppliers.length == 0){
                  this.vhMGDB_database.addDoc('suppliers', data)
                      .then((supplier:any)=>{
                        resolve({vcode:0, msg: 'success', data: supplier}); 
                      },(error:any)=>{
                        reject(error);
                      })   
                }else{
                  resolve({vcode:1, msg: 'This phone number is already in use with another supplier'}); 
                }
            },error=>{
              reject(error);
            })              
        }else{
          this.vhMGDB_database.addDoc('suppliers', data)
              .then((supplier:any)=>{
                resolve({vcode:0, msg: 'success', data: supplier}); 
              },(error:any)=>{
                reject(error);
              })   
        }         
      })
    }
  /**
   * @example:
   * this.vhQueryCafe.addSuppliers([{name:'Nhà cung cấp 1', address: 'HCM'},{},...])
        .then((rsp)=>{
          if(rsp.vcode == 0){
            //addSuppliers thành công
          }else if(rsp.vcode == 0){
            //Phone numbers in the list are duplicated
          }
        },(error:any)=>{
          console.log('error', error);
        })
  * @param data: array(object), Có cả 3 trường countryCode, phone và phoneNumber
  * @return  Promise => {vcode, msg, data(array)}
  * vcode = 0: 'success'
  * vcode = 1: 'Phone numbers in the list are duplicated'
  */
  public addSuppliers(arr_data:any){
    return new Promise((resolve, reject) => {
      //Setting trong phần mềm sẽ thay thế biến này
      let unique_phone_number = true;
      for(let i=0; i<arr_data.length; i++){  
        // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
        if (!(arr_data[i].countryCode && arr_data[i].phone && arr_data[i].phoneNumber)) {
          // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
          return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
        }
        //Thời điểm tạo nhà cung cấp
        arr_data[i].updated_at = new Date();
        if(arr_data[i].name) {
          arr_data[i].name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(arr_data[i].name)).toLowerCase());
        }
        if(arr_data[i].phone) {
          arr_data[i].phone_keywords = this.vhAlgorithm.getSequentialSubstrings(arr_data[i].phone,6)
        }
      }
      if(unique_phone_number){
        for(let i=0; i<arr_data.length; i++){
          //check các sô trong arr_data trùng nhau
          for(let j=i+1; j<arr_data.length; j++){
            if(arr_data[j].phoneNumber == arr_data[i].phoneNumber) return resolve({vcode:1, msg: 'Phone numbers in the list are duplicated'}); 
          }
        }
        let promise = new Array();
        for(let i=0; i<arr_data.length; i++){
          promise[i] = new Promise(resolve=>{
            this.vhMGDB_database.getDocsByFields('suppliers', {phoneNumber:{$eq:arr_data[i].phoneNumber}}, {})
                .then((suppliers:any)=>{
                  if(suppliers.length == 0){
                    this.vhMGDB_database.addDoc('suppliers', arr_data[i])
                        .then((supplier:any)=>{
                          resolve(supplier); 
                        },(error:any)=>{
                          resolve(null);
                        })   
                  }else{
                    resolve(null); 
                  }                            
                },error=>{
                  reject(error);
                }) 
          })
        } 
        Promise.all(promise).then((array:any)=>{
          let _array = array.filter((item:any)=> (item != null))
          resolve({vcode:0, msg: 'success', data: _array});       
        })   
      }else{
        let promise = new Array();
        for(let i=0; i<arr_data.length; i++){         
          promise[i] = new Promise(resolve=>{
            arr_data[i].id_branch = this.getDefaultBranch()._id;
            this.vhMGDB_database.addDoc('suppliers', arr_data[i])
                .then((supplier)=>{
                  resolve(supplier);
                }, (error)=>{                 
                  resolve(null);
                }) 
          })                       
        }
        Promise.all(promise).then((array:any)=>{
          let _array = array.filter((item:any)=> (item != null))
          resolve({vcode:0, msg: 'success', data: _array});       
        })   
      }
                    
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateSupplier('5fb6780ca2148e09806c5b01', {name: Nguyễn Thị Nở})
          .then((rsp)=>{
            if(rsp.vcode == 0){
              //updateSupplier thành công
            }else if(rsp.vcode == 0){
              //This phone number is already in use with another customer
            }
          },(error:any)=>{
            console.log('error', error);
          })
    * @param id_customer 
    * @param value : Nếu value hoặc có cả 3 trường countryCode, phone, phoneNumber hoặc ko có
    * @return  Promise => {vcode, msg, data(true/false)}
    * vcode = 0: 'success'
    * vcode = 1: 'This phone number is already in use with another supplier'
    */
  public updateSupplier(id_supplier:string, value:any){
    return new Promise((resolve,reject) => {
      value.updated_at = new Date();
        //Setting trong phần mềm sẽ thay thế biến này
        let unique_phone_number = true;
      // Nếu ít nhất một trong ba trường countryCode, phone hoặc phoneNumber có giá trị
      if (value.countryCode || value.phone || value.phoneNumber) {
        // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
        if (!(value.countryCode && value.phone && value.phoneNumber)) {
          // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
          return reject('3 trường countryCode, phone, phoneNumber luôn đi chung với nhau');
        }
      }
      if(value.name) {
        value.name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(value.name)).toLowerCase());
      }
      if(value.phone) {
        value.phone_keywords = this.vhAlgorithm.getSequentialSubstrings(value.phone,6)
      }
      if(value.phoneNumber && unique_phone_number){
        this.vhMGDB_database.getDocsByFields('suppliers', {phoneNumber:{$eq:value.phoneNumber}}, {})
            .then((suppliers:any)=>{
              if(suppliers.length == 0){
                this._updateSupplier( id_supplier, value)
                    .then((bool:any)=>{
                      resolve({vcode:0, msg: 'success', data: bool}); 
                    }, error=>{
                      reject(error)
                    }) 
              }else{
                if(suppliers[0]._id == id_supplier){
                  this._updateSupplier( id_supplier, value)
                      .then((bool:any)=>{
                        resolve({vcode:0, msg: 'success', data: bool}); 
                      }, error=>{
                        reject(error)
                      }) 
                }else{
                  resolve({vcode:1, msg: 'This phone number is already in use with another supplier'}); 
                }
              }
            },error=>{
              reject(error);
            })     
      }else{
        this._updateSupplier( id_supplier, value)
            .then((bool:any)=>{
              resolve({vcode:0, msg: 'success', data: bool}); 
            }, error=>{
              reject(error)
            }) 
      }
                
    })
  }

  private _updateSupplier(id_supplier:string, value:any){
    return new Promise((resolve, reject) => {
      value.updated_at = new Date();
      this.vhMGDB_database.updateDoc('suppliers', id_supplier, value)
          .then((bool:any)=>{
            resolve(bool); 
          }, error=>{
            reject(error)
          }) 
    })    
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteSupplier('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteSupplier', bool);
        })
   * @param id_supplier 
   * @return Promise => bool = true or false 
   */
  public deleteSupplier(id_supplier:string){
    return new Promise((resolve, reject) => {
      this.getBills_byFields({id_supplier:{$eq:id_supplier}},{},{},1)
          .then((bills:any)=>{                      
            if(bills.length===0){              
              this.vhMGDB_database.deleteDoc('suppliers', id_supplier)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })    
            }else resolve(false);
          }, error=>{
            reject(error)
          })           
    })   
  }

  /**
   * @example
   * this.vhQueryCafe.getSupplier('5fb67fda87c0f21d484cbdf3')
            .then((supplier)=>{
              console.log('getSupplier', supplier);
            })
   * @param id_supplier 
   * @return Promise => obj ={} or null
   */
  public getSupplier(id_supplier:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('suppliers', id_supplier)
            .then((supplier)=>{
              if(supplier){
                let exist = false;
                for(let i=0; i<this.suppliers.length; i++){
                  if(this.suppliers[i]._id == id_supplier){
                    exist = true;                    
                    break;
                  }
                }
                if(!exist) this.suppliers.push(supplier);
              }
              resolve(supplier);
            })          
    }) 
  }

  /**
   * @example
   * this.vhQueryCafe.getSuppliers()
            .then((suppliers)=>{
              console.log('getSuppliers', suppliers);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getSuppliers(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('suppliers')
            .then((suppliers)=>{
              this.suppliers = suppliers;
              resolve(suppliers);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  
  private publishObservableEventDispatcherZones() {
    this.subjectdispatcherzones.next(this.dispatcherzones);
  }  

  private observableLocalDispatcherZones():Subject<any> {      
    return this.subjectdispatcherzones; 
  }
  
    /**
   * @example:
   * this.observableKitchen = this.vhQueryCafe.getObservableLocalDispatcherZones().subscribe((localDispatcherZones:any) => {          
        do something... 
      })       
    
    ngOnDestroy(){
      this.observableDispatcherZone.unsubscribe();    
    }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
  public getObservableLocalDispatcherZones(){   
    return new Observable((observer:any) => {    
    this.observableLocalDispatcherZones().subscribe((dispatcherzones) => {   
      observer.next(dispatcherzones);
    })
    this.publishObservableEventDispatcherZones();
    })
  }

  /**
   * @example: 
   * let dispatcherzone = this.vhQueryCafe.getlocalDispatcherZone('5fb6780ca2148e09806c5b01');
   * @param id_dispatcherzone 
   * @return Object => obj = {} or null
   */
  public getlocalDispatcherZone(id_dispatcherzone:any){
    for(let i=0; i<this.dispatcherzones.length; i++){
      if(this.dispatcherzones[i]._id === id_dispatcherzone){
        return {...this.dispatcherzones[i]};       
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let dispatcherzones = this.vhQueryCafe.getlocalDispatcherZones();
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalDispatcherZones(){    
    return this.dispatcherzones;
  }
  
  /**
   * @example:
   * this.vhQueryCafe.addDispatcherZone({name:'Nhà cung cấp 1', address: 'HCM'})
          .then((dispatcherzone)=>{
            console.log('addDispatcherZone', dispatcherzone);
          },(error:any)=>{
            console.log('error', error);
          })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
  public addDispatcherZone(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('vhs_dispatcherzones', data)
          .then((dispatcherzone)=>{
            resolve(dispatcherzone);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateDispatcherZone('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateDispatcherZone', bool);
          })
    * @param id_dispatcherzone 
    * @param data 
    * @return Promise => bool = true or false 
    */
  public updateDispatcherZone(id_dispatcherzone:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('vhs_dispatcherzones', id_dispatcherzone, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteDispatcherZone('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteDispatcherZone', bool);
        })
    * @param id_dispatcherzone 
    * @return Promise => bool = true or false 
    */
  public deleteDispatcherZone(id_dispatcherzone:string){
    return new Promise((resolve, reject) => {           
      this.vhMGDB_database.deleteDoc('vhs_dispatcherzones', id_dispatcherzone)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })                     
    })   
  }

  /**
   * @example
   * this.vhQueryCafe.getDispatcherZone('5fb67fda87c0f21d484cbdf3')
            .then((dispatcherzone)=>{
              console.log('getDispatcherZone', dispatcherzone);
            })
    * @param id_dispatcherzone 
    * @return Promise => obj ={} or null
    */
  public getDispatcherZone(id_dispatcherzone:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('vhs_dispatcherzones', id_dispatcherzone)
            .then((dispatcherzone)=>{
              resolve(dispatcherzone);
            })          
    }) 
  }

  /**
   * @example
   * this.vhQueryCafe.getDispatcherZones()
            .then((dispatcherzones)=>{
              console.log('getDispatcherZones', dispatcherzones);
            })
    * @return Promise => array(object) = [{},{},..]
    */
  public getDispatcherZones(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('vhs_dispatcherzones')
            .then((dispatcherzones)=>{
              this.dispatcherzones = dispatcherzones;
              resolve(dispatcherzones);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  private publishObservableEventWallets() {
    this.subjectwallets.next(this.wallets);
  }  

  private observableLocalWallets():Subject<any> {      
    return this.subjectwallets; 
  }

  /**
   * @example:  
    this.observableWallet = this.vhQueryCafe.getObservableLocalWallets().subscribe((localwallets:any) => {           
    })     

    ngOnDestroy(){
      this.observableWallet.unsubscribe();    
    }
   * @returns 
   */
  public getObservableLocalWallets(){   
   return new Observable((observer:any) => {    
    this.observableLocalWallets().subscribe((wallets) => {   
      observer.next(wallets);
    })
    this.publishObservableEventWallets();
   })
  }

  /**
   * @example: 
   * let wallet = this.vhQueryCafe.getlocalWallet('5fb6780ca2148e09806c5b01');
   * @param id_wallet 
   * @return Object => obj = {} or null
   */
  public getlocalWallet(id_wallet:any){
    for(let i=0; i<this.wallets.length; i++){
      if(this.wallets[i]._id === id_wallet){
        return this.wallets[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let wallets = this.vhQueryCafe.getlocalWallets();
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalWallets(){    
    return this.wallets;
  }
  
   /**
   * @example:
   * this.vhQueryCafe.refreshLocalWallets()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalWallet(), getlocalWallets() trong localstorage
   * @return Promise => null
   */
  public refreshLocalWallets():any{
    return new Promise((resolve) => { 
      // this.getWallets()
      //     .then(()=>{resolve(null)})       
      resolve(null)
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addWallet({name:'camera 2', quantity:20, price:200000})
          .then((wallet)=>{
            console.log('addWallet', wallet);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addWallet(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('wallets', data)
          .then((wallet)=>{
            resolve(wallet);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateWallet('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateWallet', bool);
          })
   * @param id_wallet 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateWallet(id_wallet:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('wallets', id_wallet, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteWallet('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteWallet', bool);
        })
   * @param id_wallet 
   * @return Promise => bool = true or false 
   */
  public deleteWallet(id_wallet:string){
    return new Promise((resolve, reject) => {
      this.getBills_byFields({id_wallet:{$eq:id_wallet}},{},{},1)
          .then((bills:any)=>{                      
            if(bills.length===0){              
              this.vhMGDB_database.deleteDoc('wallets', id_wallet)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })    
            }else resolve(false);
          }, error=>{
            reject(error)
          })           
    }) 
  }

  /**
   * @example
   * this.vhQueryCafe.getWallet('5fb67fda87c0f21d484cbdf3')
            .then((wallet)=>{
              console.log('getWallet', wallet);
            })
   * @param id_wallet 
   * @return Promise => obj ={} or null
   */
  public getWallet(id_wallet:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('wallets', id_wallet)
            .then((wallet)=>{
              resolve(wallet);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getWallets()
            .then((wallets)=>{
              console.log('getWallets', wallets);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getWallets(){
    return new Promise((resolve, reject) => {
      this.wallets = new Array();
      this.vhMGDB_database.getDocs('wallets')
            .then((wallets)=>{
              this.wallets = wallets;
              resolve(wallets);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  private publishObservableEventTaxs() {
    this.subjecttaxs.next(this.taxs);
  }  

  private observableLocalTaxs():Subject<any> {      
    return this.subjecttaxs; 
  }
  
 /**
   * @example:
   * this.observableTax = this.vhQueryCafe.getObservableLocalTaxs().subscribe((localTaxs:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableTax.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalTaxs(){   
   return new Observable((observer:any) => {    
    this.observableLocalTaxs().subscribe((taxs) => {   
      observer.next(taxs);
    })
    this.publishObservableEventTaxs();
   })
  }
  
  /**
   * @example: 
   * let tax = this.vhQueryCafe.getlocalTax('5fb6780ca2148e09806c5b01');
   * @param id_tax 
   * @return Object => obj = {} or null
   */
  public getlocalTax(id_tax:any){
    for(let i=0; i<this.taxs.length; i++){
      if(this.taxs[i]._id === id_tax){
        return this.taxs[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let taxs = this.vhQueryCafe.getlocalTaxs(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalTaxs(){    
    return this.taxs;
  }
  
  /**
   * @example:
   * this.vhQueryCafe.refreshLocalTaxs()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalTax(), getlocalTaxs() trong localstorage
   * @return Promise => null
   */
  public refreshLocalTaxs():any{
    return new Promise((resolve) => { 
      //this.getTaxs().then(()=>{resolve(null)})  
      resolve(null)     
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addTax({name:'camera 2', quantity:20, price:200000})
          .then((tax)=>{
            console.log('addTax', tax);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addTax(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('taxs', data)
          .then((tax)=>{
            resolve(tax);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateTax('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateTax', bool);
          })
   * @param id_tax 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateTax(id_tax:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('taxs', id_tax, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteTax('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteTax', bool);
        })
   * @param id_tax 
   * @return Promise => bool = true or false 
   */
  public deleteTax(id_tax:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('taxs', id_tax)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getTax('5fb67fda87c0f21d484cbdf3')
            .then((tax)=>{
              console.log('getTax', tax);
            })
   * @param id_tax 
   * @return Promise => obj ={} or null
   */
  public getTax(id_tax:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('taxs', id_tax)
            .then((tax)=>{
              resolve(tax);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getTaxs()
            .then((taxs)=>{
              console.log('getTaxs', taxs);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getTaxs(){
    return new Promise((resolve, reject) => {
      this.taxs = new Array();
      this.vhMGDB_database.getDocs('taxs')
            .then((taxs)=>{
              this.taxs = taxs;
              resolve(taxs);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  private publishObservableEventCategorys() {
    this.subjectcategorys.next();
  }  

  private observableLocalCategorys():Subject<any> {      
    return this.subjectcategorys; 
  }
  /**
   * @example:
   * this.observableCategory = this.vhQueryCafe.getObservableLocalCategorys(1).subscribe((localCategorys:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableCategory.unsubscribe();    
    }
   * @param type = 1 là danh mục món, = 2 là danh mục dịch vụ, = 3 là danh mục nguyên liệu, = 13 là danh mục món và nguyên liệu, ko truyền vào hoặc giá trị khác là cả ba 
   * @returns Observable (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalCategorys(type?:any){   
   return new Observable((observer:any) => {    
    this.observableLocalCategorys().subscribe(() => {   
      observer.next(this.getlocalCategorys(type));
    })
    this.publishObservableEventCategorys();
   })
  }

  /**
   * @example: 
   * let category = this.vhQueryCafe.getlocalCategory('5fb6780ca2148e09806c5b01');
   * @param id_category 
   * @return Object => obj = {} or null
   */
  public getlocalCategory(id_category:any){
    for(let i=0; i<this.categorys.length; i++){
      if(this.categorys[i]._id === id_category){
        return {...this.categorys[i]};        
      }
    } 
    return null; 
  }
  
    /**
   * @example: 
   * let categorys = this.vhQueryCafe.getlocalCategorys(1234);
   * @param type =1 là danh mục món, =2 là danh mục dịch vụ, =3 là danh mục nguyên liệu, =4 là topping, =5 là combo, 
   * = 1234 là danh mục món, dịch vụ, nguyên liệu và topping, ko truyền vào hoặc giá trị khác là cả 5
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalCategorys(type?:any){     
    let categorys = new Array();
    if((type===1)||(type===2)||(type===3)||(type===4)||(type===4)){
      this.categorys.forEach((element:any) => {
        if(element.type === type) categorys.push({...element});
      });        
    }else if(type===1234){
      this.categorys.forEach((element:any) => {
        if((element.type === 1)||(element.type === 2)||(element.type === 3)||(element.type === 4)) categorys.push({...element});
      });        
    }else{
      this.categorys.forEach((element:any) => {
        categorys.push({...element});
      });        
    }
    return categorys;      
  }

  /**
   * @example: 
   * let categorys = this.vhQueryCafe.getlocalFoodCategorys(); 
   * @return Array(object) => array = [{},{},...]
   */
  // public getlocalFoodCategorys(){    
  //   let foodcategorys = new Array();
  //   for(let i=0; i<this.categorys.length; i++){
  //     if(this.categorys[i].type === 1){
  //       foodcategorys.push(this.categorys[i]);        
  //     }
  //   } 
  //   return foodcategorys;     
  // }

   /**
   * @example: 
   * let categorys = this.vhQueryCafe.getlocalMaterialCategorys(); 
   * @return Array(object) => array = [{},{},...]
   */
  // public getlocalMaterialCategorys(){    
  //   let materialcategorys = new Array();
  //   for(let i=0; i<this.categorys.length; i++){
  //     if(this.categorys[i].type === 3){
  //       materialcategorys.push(this.categorys[i]);        
  //     }
  //   } 
  //   return materialcategorys;     
  // }
  
  /**
   * @example:
   * this.vhQueryCafe.refreshLocalCategory()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalCategory(), getlocalCategorys() trong localstorage
   * @return Promise => null
   */
  public refreshLocalCategorys():any{
    return new Promise((resolve) => { 
      // this.getCategorys()
      //     .then(()=>{resolve(null)})  
      resolve(null)     
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addCategory({name:'Danh mục 1'})
          .then((category)=>{
            console.log('addCategory', category);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addCategory(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('categorys', data)
          .then((category)=>{
            resolve(category);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.addCategorys([{name:'Danh mục 1'},{},...])
          .then((categorys)=>{
            console.log('addCategorys', categorys);
          }, error=>{
            console.log('error', error);
          })
   * @param data : array(object)
   * @return Promise => array = [{},{},...]
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addCategorys(data_array:any){
      return new Promise((resolve, reject) => {
        let promise = new Array();
        for(let i=0; i<data_array.length; i++){         
          promise[i] = new Promise(resolve=>{
            this.vhMGDB_database.addDoc('categorys', data_array[i])
                .then((category)=>{
                  resolve(category);
                }, ()=>{                 
                  resolve(null);
                }) 
          })                       
        }
        Promise.all(promise).then((array:any)=>{
          let _array = array.filter((item:any)=> (item != null))
          resolve(_array);
        })                 
      })
    }

  /**
   * @example:
   * this.vhQueryCafe.updateCategory('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateCategory', bool);
          })
   * @param id_category 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateCategory(id_category:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('categorys', id_category, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteCategory('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteCategory', bool);
        })
   * @param id_category 
   * @return Promise => bool = true or false 
   */
  public deleteCategory(id_category:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('products', {id_category:{$eq:id_category}},{},{},1)
          .then((products:any)=>{                      
            if(products.length===0){              
              this.vhMGDB_database.deleteDoc('categorys', id_category)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })    
            }else resolve(false);
          }, error=>{
            reject(error)
          })             
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getCategory('5fb67fda87c0f21d484cbdf3')
            .then((category)=>{
              console.log('getCategory', category);
            })
   * @param id_category 
   * @return Promise => obj ={} or null
   */
  public getCategory(id_category:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('categorys', id_category)
            .then((category)=>{
              resolve(category);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getCategorys()
            .then((categorys)=>{
              console.log('getCategorys', categorys);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getCategorys(){
    return new Promise((resolve, reject) => {     
      this.vhMGDB_database.getDocs('categorys')
            .then((categorys)=>{
              this.categorys = categorys;
              resolve(categorys);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  private publishObservableEventInventorytimes() {
    this.subjectinventorytimes.next(this.inventorytimes);
  }  

  private observableLocalInventorytimes():Subject<any> {      
    return this.subjectinventorytimes; 
  }
  
    /**
   * @example:
   * this.observableInventorytime = this.vhQueryCafe.getObservableLocalInventorytimes().subscribe((localInventorytimes:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableInventorytime.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalInventorytimes(){   
   return new Observable((observer:any) => {    
    this.observableLocalInventorytimes().subscribe((inventorytimes) => {   
      observer.next(inventorytimes);
    })
    this.publishObservableEventInventorytimes();
   })
  }

  /**
   * @example: 
   * let inventorytime = this.vhQueryCafe.getlocalInventorytime('5fb6780ca2148e09806c5b01');
   * @param id_inventorytime 
   * @return Object => obj = {} or null
   */
  public getlocalInventorytime(id_inventorytime:any){
    for(let i=0; i<this.inventorytimes.length; i++){
      if(this.inventorytimes[i]._id === id_inventorytime){
        return this.inventorytimes[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let inventorytimes = this.vhQueryCafe.getlocalInventorytimes(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalInventorytimes(){    
    return this.inventorytimes;
  }
  
  /**
   * @example:
   * this.vhQueryCafe.refreshLocalTaxs()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalInventorytime(), getlocalInventorytimes() trong localstorage
   * @return Promise => null
   */
  public refreshLocalInventorytimes():any{
    return new Promise((resolve) => { 
      // this.getInventorytimes()
      //     .then(()=>{resolve(null)})       
      resolve(null)
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addInventorytime({name:'camera 2', quantity:20, price:200000})
          .then((inventorytime)=>{
            console.log('addInventorytime', inventorytime);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addInventorytime(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      data.balanced = false;
      this.vhMGDB_database.addDoc('inventorytimes', data)
          .then((inventorytime)=>{
            resolve(inventorytime);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateInventorytime('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateInventorytime', bool);
          })
   * @param id_inventorytime 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateInventorytime(id_inventorytime:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('inventorytimes', id_inventorytime, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteInventorytime('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteInventorytime', bool);
        })
   * @param id_inventorytime 
   * @return Promise => bool = true or false 
   */
  public deleteInventorytime(id_inventorytime:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('inventorytimes', id_inventorytime)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getInventorytime('5fb67fda87c0f21d484cbdf3')
            .then((inventorytime)=>{
              console.log('getInventorytime', inventorytime);
            })
   * @param id_inventorytime 
   * @return Promise => obj ={} or null
   */
  public getInventorytime(id_inventorytime:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('inventorytimes', id_inventorytime)
            .then((inventorytime)=>{
              resolve(inventorytime);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getInventorytimes()
            .then((inventorytimes)=>{
              console.log('getInventorytimes', inventorytimes);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getInventorytimes(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('inventorytimes')
            .then((inventorytimes)=>{
              this.inventorytimes = inventorytimes;
              resolve(inventorytimes);
            },(error:any)=>{
              reject(error);
            })          
    })
  }








  
  private publishObservableEventCustomerClasss() {
    this.subjectcustomer_classs.next(this.customer_classs);
  }  

  private observableLocalCustomerClasss():Subject<any> {      
    return this.subjectcustomer_classs; 
  }
  
   /**
   * @example:
   * this.observableCustomerClasss = this.vhQueryCafe.getObservableLocalCustomerClasss().subscribe((localCustomer_classs:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableCustomerClasss.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  private getObservableLocalCustomerClasss(){//chưa cần sài đến public   
   return new Observable((observer:any) => {    
    this.observableLocalCustomerClasss().subscribe((customer_classs) => {   
      observer.next(customer_classs);
    })
    this.publishObservableEventCustomerClasss();
   })
  }

  /**
   * @example: 
   * let customer_class = this.vhQueryCafe.getlocalCustomerClass('5fb6780ca2148e09806c5b01');
   * @param id_customer_class
   * @return Object => obj = {} or null
   */
  public getlocalCustomerClass(id_customer_class:any){
    for(let i=0; i<this.customer_classs.length; i++){
      if(this.customer_classs[i]._id === id_customer_class){    
        return cloneDeep(this.customer_classs[i]);             
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let customer_classs = this.vhQueryCafe.getlocalCustomerClasss(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalCustomerClasss(){      
    return cloneDeep(this.customer_classs);       
  }  

  /**
   * @example:
   * this.vhQueryCafe.addCustomerClass({name:'camera 2', quantity:20, price:200000})
          .then((customer_class)=>{
            console.log('addCustomerClass', customer_class);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addCustomerClass(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('customer_classs', data)
          .then((customer_class)=>{
            resolve(customer_class);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateCustomerClass('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateCustomerClass', bool);
          })
   * @param id_customer_class
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateCustomerClass(id_customer_class:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('customer_classs', id_customer_class, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteCustomerClass('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteCustomerClass', bool);
        })
   * @param id_customer_class 
   * @return Promise => bool = true or false 
   */
  public deleteCustomerClass(id_customer_class:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('customer_classs', id_customer_class)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * vhQueryCafe
   */
  private publishObservableEventDiscount_bills() {
    this.subjectdiscount_bills.next(this.discount_bills);
  }  
/**
 * vhQueryCafe
 * @returns 
 */
  private observableLocalDiscount_bills():Subject<any> {      
    return this.subjectdiscount_bills; 
  }
  
   /**
   * @example:
   * this.observableDiscount_bills = this.vhQueryCafe.getObservableLocalDiscount_bills().subscribe((localDiscount_bills:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableDiscount_bills.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  private getObservableLocalDiscount_bills(){//chưa cần sài đến public   
   return new Observable((observer:any) => {    
    this.observableLocalDiscount_bills().subscribe((discount_bills) => {   
      observer.next(discount_bills);
    })
    this.publishObservableEventDiscount_bills();
   })
  }

  /**
   * @example: 
   * let discount_bill = this.vhQueryCafe.getlocalDiscount_bill('5fb6780ca2148e09806c5b01');
   * @param id_discount_bill
   * @return Object => obj = {} or null
   */
  public getlocalDiscount_bill(id_discount_bill:any){
    for(let i=0; i<this.discount_bills.length; i++){
      if(this.discount_bills[i]._id === id_discount_bill){    
        return cloneDeep(this.discount_bills[i]);             
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let discount_bills = this.vhQueryCafe.getlocalDiscount_bills(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalDiscount_bills(){      
    return cloneDeep(this.discount_bills);       
  }  

  /**
   * @example:
   * this.vhQueryCafe.addDiscount_bill({name:'camera 2', quantity:20, price:200000})
          .then((discount_bill)=>{
            console.log('addDiscount_bill', discount_bill);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addDiscount_bill(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('discount_bills', data)
          .then((discount_bill)=>{
            resolve(discount_bill);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateDiscount_bill('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateDiscount_bill', bool);
          })
   * @param id_discount_bill
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateDiscount_bill(id_discount_bill:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('discount_bills', id_discount_bill, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteDiscount_bill('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteDiscount_bill', bool);
        })
   * @param id_discount_bill 
   * @return Promise => bool = true or false 
   */
  public deleteDiscount_bill(id_discount_bill:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('customer_classs',{id_discount_bill:{$eq:id_discount_bill}})
          .then((customer_classs:any)=>{       
            for(let i=0; i<customer_classs.length; i++){
              this.vhMGDB_database.updateDoc('customer_classs', customer_classs[i]._id, {id_discount_bill:null});
            }       
            this.vhMGDB_database.deleteDoc('discount_bills', id_discount_bill)
                .then((bool:any)=>{            
                  resolve(bool);
                }, error=>{
                  reject(error)
                })   
          },(error:any)=>{
            reject(error);
          })                     
    })
  }




  /**
   * @example:
   * this.vhQueryCafe.addDiscount_sales({name:'camera 2', quantity:20, price:200000})
          .then((discount_saless)=>{
            console.log('addDiscount_sales', discount_sales);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addDiscount_sales(data:object){
      return new Promise((resolve, reject) => {
        this.vhMGDB_database.addDoc('discount_saless', data)
            .then((discount_sales)=>{
              resolve(discount_sales);
            },(error:any)=>{
              reject(error);
            })         
      })
    }
  
    /**
     * @example:
     * this.vhQueryCafe.updateDiscount_sales('5fb6780ca2148e09806c5b01', {quantity:400})
            .then((bool:any)=>{
              console.log('updateDiscount_sales', bool);
            })
      * @param id_discount_sales
      * @param data 
      * @return Promise => bool = true or false 
      */
    public updateDiscount_sales(id_discount_sales:string, data:object){
      return new Promise((resolve,reject) => {
        this.vhMGDB_database.updateDoc('discount_saless', id_discount_sales, data)
            .then((bool:any)=>{
              resolve(bool);
            }, error=>{
              reject(error)
            })          
      })
    }
  
    /**
     * @example:
     * this.vhQueryCafe.deleteDiscount_sales('5fb67fda87c0f21d484cbdf3')
          .then((bool:any)=>{
            console.log('deleteDiscount_sales', bool);
          })
      * @param id_discount_sales
      * @return Promise => bool = true or false 
      */
    public deleteDiscount_sales(id_discount_sales:string){
      return new Promise((resolve, reject) => {
        this.vhMGDB_database.getDocsByFields('customer_classs',{id_discount_sales:{$eq:id_discount_sales}})
            .then((customer_classs:any)=>{       
              for(let i=0; i<customer_classs.length; i++){
                this.vhMGDB_database.updateDoc('customer_classs', customer_classs[i]._id, {id_discount_sales:null});
              }       
              this.vhMGDB_database.deleteDoc('discount_saless', id_discount_sales)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })  
          },(error:any)=>{
            reject(error);
          })                   
      })
    }
  
    /**
     * @example
     * this.vhQueryCafe.getDiscount_sales('5fb67fda87c0f21d484cbdf3')
              .then((discount_sales)=>{
                console.log('getDiscount_sales', discount_sales);
              })
      * @param id_discount_sales
      * @return Promise => obj ={} or null
      */
    public getDiscount_sales(id_discount_sales:string){
      return new Promise((resolve) => {
        this.vhMGDB_database.getDoc('discount_saless', id_discount_sales)
              .then((discount_sales)=>{
                resolve(discount_sales);
              })          
      })
    }
  
    /**
     * @example
     * this.vhQueryCafe.getDiscount_saless()
              .then((discount_saless)=>{
                console.log('getDiscount_saless', discount_saless);
              })
      * @return Promise => array(object) = [{},{},..]
      */
    public getDiscount_saless(){
      return new Promise((resolve, reject) => {
        this.discount_saless = new Array();
        this.vhMGDB_database.getDocs('discount_saless')
              .then((discount_saless)=>{
                this.discount_saless = discount_saless;
                resolve(discount_saless);
              },(error:any)=>{
                reject(error);
              })          
      })
    }


    /**
   * @example:
   * this.vhQueryCafe.addCommission({name:'camera 2', quantity:20, price:200000})
          .then((commissions)=>{
            console.log('addCommission', commissions);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addCommission(data:object){
      return new Promise((resolve, reject) => {
        this.vhMGDB_database.addDoc('commissions', data)
            .then((commission)=>{
              resolve(commission);
            },(error:any)=>{
              reject(error);
            })         
      })
    }
  
    /**
     * @example:
     * this.vhQueryCafe.updateCommission('5fb6780ca2148e09806c5b01', {quantity:400})
            .then((bool:any)=>{
              console.log('updateCommission', bool);
            })
      * @param id_commission
      * @param data 
      * @return Promise => bool = true or false 
      */
    public updateCommission(id_commission:string, data:object){
      return new Promise((resolve,reject) => {
        this.vhMGDB_database.updateDoc('commissions', id_commission, data)
            .then((bool:any)=>{
              resolve(bool);
            }, error=>{
              reject(error)
            })          
      })
    }
  
    /**
     * @example:
     * this.vhQueryCafe.deleteCommission('5fb67fda87c0f21d484cbdf3')
          .then((bool:any)=>{
            console.log('deleteCommission', bool);
          })
      * @param id_commission 
      * @return Promise => bool = true or false 
      */
    public deleteCommission(id_commission:string){
      return new Promise((resolve, reject) => {
        this.vhMGDB_database.deleteDoc('commissions', id_commission)
            .then((bool:any)=>{            
              resolve(bool);
            }, error=>{
              reject(error)
            })          
      })
    }
  
    /**
     * @example
     * this.vhQueryCafe.getCommission('5fb67fda87c0f21d484cbdf3')
              .then((commission)=>{
                console.log('getCommission', commission);
              })
      * @param id_commission
      * @return Promise => obj ={} or null
      */
    public getCommission(id_commission:string){
      return new Promise((resolve) => {
        this.vhMGDB_database.getDoc('commissions', id_commission)
              .then((commission)=>{
                resolve(commission);
              })          
      })
    }
  
    /**
     * @example
     * this.vhQueryCafe.getCommissions()
              .then((commissions)=>{
                console.log('getCommissions', commissions);
              })
      * @return Promise => array(object) = [{},{},..]
      */
    public getCommissions(){
      return new Promise((resolve, reject) => {
        this.commissions = new Array();
        this.vhMGDB_database.getDocs('commissions')
              .then((commissions)=>{
                this.commissions = commissions;
                resolve(commissions);
              },(error:any)=>{
                reject(error);
              })          
      })
    }


  /**
   * @example: 
   * let delivery = this.vhQueryCafe.getlocalDelivery('5fb6780ca2148e09806c5b01');
   * @param id_delivery 
   * @return Object => obj = {} or null
   */
  public getlocalDelivery(id_delivery:any){
    for(let i=0; i<this.deliverys.length; i++){
      if(this.deliverys[i]._id === id_delivery){
        return this.deliverys[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let deliverys = this.vhQueryCafe.getlocalDeliverys(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalDeliverys(){    
    return this.deliverys;
  }
  
  /**
   * @example:
   * this.vhQueryCafe.refreshLocalDeliverys()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalDelivery(), getlocalDeliverys() trong localstorage
   * @return Promise => null
   */
  public refreshLocalDeliverys():any{
    return new Promise((resolve) => { 
      this.getDeliverys()
          .then(()=>{resolve(null)})       
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addDelivery({name:'camera 2', quantity:20, price:200000})
          .then((delivery)=>{
            console.log('addDelivery', delivery);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addDelivery(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('deliverys', data)
          .then((delivery)=>{
            resolve(delivery);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateDelivery('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateDelivery', bool);
          })
   * @param id_delivery 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateDelivery(id_delivery:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('deliverys', id_delivery, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteDelivery('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteDelivery', bool);
        })
   * @param id_delivery 
   * @return Promise => bool = true or false 
   */
  public deleteDelivery(id_delivery:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('deliverys', id_delivery)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getDelivery('5fb67fda87c0f21d484cbdf3')
            .then((delivery)=>{
              console.log('getDelivery', delivery);
            })
   * @param id_delivery 
   * @return Promise => obj ={} or null
   */
  public getDelivery(id_delivery:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('deliverys', id_delivery)
            .then((delivery)=>{
              resolve(delivery);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getDeliverys()
            .then((deliverys)=>{
              console.log('getDeliverys', deliverys);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getDeliverys(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('deliverys')
            .then((deliverys)=>{
              this.deliverys = deliverys;
              resolve(deliverys);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  /**
   * @example: 
   * let address = this.vhQueryCafe.getlocalAddress('5fb6780ca2148e09806c5b01');
   * @param id_address 
   * @return Object => obj = {} or null
   */
  public getlocalAddress(id_address:any){
    for(let i=0; i<this.addresss.length; i++){
      if(this.addresss[i]._id === id_address){
        return this.addresss[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let addresss = this.vhQueryCafe.getlocalAddresss(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalAddresss(){    
    return this.addresss;
  } 
  
  /**
   * @example:
   * this.vhQueryCafe.refreshLocalAddresss()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalAddress(), getlocalAddresss() trong localstorage
   * @return Promise => null
   */
  public refreshLocalAddresss():any{
    return new Promise((resolve) => { 
      this.getAddresss()
          .then(()=>{resolve(null)})       
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addAddress({name:'camera 2', quantity:20, price:200000})
          .then((address)=>{
            console.log('addAddress', address);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addAddress(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('addresss', data)
          .then((address)=>{
            resolve(address);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateAddress('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateAddress', bool);
          })
   * @param id_address 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateAddress(id_address:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('addresss', id_address, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteAddress('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteAddress', bool);
        })
   * @param id_address 
   * @return Promise => bool = true or false 
   */
  public deleteAddress(id_address:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('addresss', id_address)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getAddress('5fb67fda87c0f21d484cbdf3')
            .then((address)=>{
              console.log('getAddress', address);
            })
   * @param id_address 
   * @return Promise => obj ={} or null
   */
  public getAddress(id_address:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('addresss', id_address)
            .then((address)=>{
              resolve(address);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getAddresss()
            .then((addresss)=>{
              console.log('getAddresss', addresss);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getAddresss(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('addresss')
            .then((addresss)=>{
              this.addresss = addresss;
              resolve(addresss);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  
  /**
   * @example: 
   * let incoming_group = this.vhQueryCafe.getlocalIncoming_group('5fb6780ca2148e09806c5b01');
   * @param id_incoming_group
   * @return Object => obj = {} or null
   */
   public getlocalIncoming_group(id_incoming_group:any){
    for(let i=0; i<this.incoming_groups.length; i++){
      if(this.incoming_groups[i]._id === id_incoming_group){
        return {...this.incoming_groups[i]};
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let incoming_groups = this.vhQueryCafe.getlocalIncoming_groups(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalIncoming_groups(){    
    return [...this.incoming_groups];
  } 
  
  /**
   * @example:
   * this.vhQueryCafe.refreshLocalIncoming_groups()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalIncoming_group(), getlocalIncoming_groups() trong localstorage
   * @return Promise => null
   */
  public refreshLocalIncoming_groups():any{
    return new Promise((resolve) => { 
      this.getIncoming_groups()
          .then(()=>{resolve(null)})       
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addIncoming_group({name:'camera 2', quantity:20, price:200000})
          .then((incoming_group)=>{
            console.log('addIncoming_group', incoming_group);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addIncoming_group(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('incoming_groups', data)
          .then((incoming_group)=>{
            resolve(incoming_group);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateIncoming_group('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateIncoming_group', bool);
          })
   * @param id_incoming_group 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateIncoming_group(id_incoming_group:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('incoming_groups', id_incoming_group, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteIncoming_group('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteIncoming_group', bool);
        })
   * @param id_incoming_group 
   * @return Promise => bool = true or false 
   */
  public deleteIncoming_group(id_incoming_group:string){
    return new Promise((resolve, reject) => {
      this.getBills_byFields({id_incoming_group:{$eq:id_incoming_group}},{},{},1)
          .then((bills:any)=>{                      
            if(bills.length===0){
              this.vhMGDB_database.deleteDoc('incoming_groups', id_incoming_group)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  }) 
            }else resolve(false);
          }, error=>{
            reject(error)
          })                 
    })  
  }

  /**
   * @example
   * this.vhQueryCafe.getIncoming_groups()
            .then((incoming_groups)=>{
              console.log('getIncoming_groups', incoming_groups);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getIncoming_groups(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('incoming_groups')
            .then((incoming_groups)=>{
              this.incoming_groups = incoming_groups;             
              this.incoming_groups = this.vhAlgorithm.sortVietnamesebyASC(this.incoming_groups, 'name');                
              resolve(this.incoming_groups);
            },(error:any)=>{
              reject(error);
            })          
    })
  }
  
  /**
   * @example: 
   * let spending_group = this.vhQueryCafe.getlocalSpending_group('5fb6780ca2148e09806c5b01');
   * @param id_spending_group 
   * @return Object => obj = {} or null
   */
   public getlocalSpending_group(id_spending_group:any){
    for(let i=0; i<this.spending_groups.length; i++){
      if(this.spending_groups[i]._id === id_spending_group){
        return {...this.spending_groups[i]};
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let spending_groups = this.vhQueryCafe.getlocalSpending_groups(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalSpending_groups(){    
    return [...this.spending_groups];
  } 
  
  /**
   * @example:
   * this.vhQueryCafe.refreshLocalSpending_groups()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm refreshLocalSpending_group(), refreshLocalSpending_groups() trong localstorage
   * @return Promise => null
   */
  public refreshLocalSpending_groups():any{
    return new Promise((resolve) => { 
      this.getSpending_groups()
          .then(()=>{resolve(null)})       
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addSpending_group({name:'camera 2', quantity:20, price:200000})
          .then((spending_groups)=>{
            console.log('addSpending_group', spending_groups);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addSpending_group(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('spending_groups', data)
          .then((spending_group)=>{
            resolve(spending_group);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updateSpending_group('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateSpending_group', bool);
          })
   * @param id_spending_group 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateSpending_group(id_spending_group:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('spending_groups', id_spending_group, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteSpending_group('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteSpending_group', bool);
        })
   * @param id_spending_group 
   * @return Promise => bool = true or false 
   */
  public deleteSpending_group(id_spending_group:string){
    return new Promise((resolve, reject) => {
      this.getBills_byFields({id_spending_group:{$eq:id_spending_group}},{},{},1)
          .then((bills:any)=>{                      
            if(bills.length===0){
              this.vhMGDB_database.deleteDoc('spending_groups', id_spending_group)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  }) 
            }else resolve(false);
          }, error=>{
            reject(error)
          })                 
    })  
  }

  /**
   * @example
   * this.vhQueryCafe.getSpending_groups()
            .then((spending_groups)=>{
              console.log('getSpending_groups', spending_groups);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getSpending_groups(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('spending_groups')
            .then((spending_groups)=>{
              this.spending_groups = spending_groups;             
              this.spending_groups = this.vhAlgorithm.sortVietnamesebyASC(this.spending_groups, 'name');                
              resolve(this.spending_groups);
            },(error:any)=>{
              reject(error);
            })          
    })
  } 



  /**
   * @example:
   * this.vhQueryCafe.addPatternMenu({name:'Pattern Menu 1', ...............})
          .then((patternmenu)=>{
            console.log('addPatternMenu', patternmenus);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addPatternMenu(data:object){
      return new Promise((resolve, reject) => {
        let _data = {...data, id_branch: this.getDefaultBranch()._id}       
        this.vhMGDB_database.addDoc('patternmenus', _data)
            .then((patternmenu)=>{
              resolve(patternmenu);
            },(error:any)=>{
              reject(error);
            })         
      })
    }
  
    /**
     * @example:
     * this.vhQueryCafe.updatePatternMenu('5fb6780ca2148e09806c5b01', {quantity:400})
            .then((bool:any)=>{
              console.log('updatePatternMenu', bool);
            })
      * @param id_patternmenu 
      * @param data 
      * @return Promise => bool = true or false 
      */
    public updatePatternMenu(id_patternmenu:string, data:object){
      return new Promise((resolve,reject) => {
        this.vhMGDB_database.updateDoc('patternmenus', id_patternmenu, data)
            .then((bool:any)=>{
              resolve(bool);
            }, error=>{
              reject(error)
            })          
      })
    }
  
    /**
     * @example:
     * this.vhQueryCafe.deletePatternMenu('5fb67fda87c0f21d484cbdf3')
          .then((bool:any)=>{
            console.log('deletePatternMenu', bool);
          })
      * @param id_patternmenu
      * @return Promise => bool = true or false 
      */
    public deletePatternMenu(id_patternmenu:string){
      return new Promise((resolve, reject) => {
        this.vhMGDB_database.deleteDoc('patternmenus', id_patternmenu)
            .then((bool:any)=>{            
              resolve(bool);
            }, error=>{
              reject(error)
            })          
      })
    }
  
    /**
     * @example
     * this.vhQueryCafe.getPatternMenu('5fb67fda87c0f21d484cbdf3')
              .then((patternmenu)=>{
                console.log('getPatternMenu', patternmenu);
              })
      * @param id_patternmenu 
      * @return Promise => obj ={} or null
      */
    public getPatternMenu(id_patternmenu:string){
      return new Promise((resolve) => {
        this.vhMGDB_database.getDoc('patternmenus', id_patternmenu)
              .then((patternmenu)=>{
                resolve(patternmenu);
              })          
      })
    }
  
    /**
     * @example
     * this.vhQueryCafe.getPatternMenus()
              .then((patternmenus)=>{
                console.log('getPatternMenus', patternmenus);
              })
      * @return Promise => array(object) = [{},{},..]
      */
    public getPatternMenus(){
      return new Promise((resolve, reject) => {
        this.taxs = new Array();       
        this.vhMGDB_database.getDocsByFields('patternmenus',{id_branch: {$eq: this.getDefaultBranch()._id}},{},{},0)
              .then((patternmenus)=>{
                this.patternmenus = patternmenus;
                resolve(patternmenus);
              },(error:any)=>{
                reject(error);
              })          
      })
    }

 /**
 * @example:
 * this.vhQueryCafe.updateDebtAtBeginningCustomer('5fb6780ca2148e09806c5b01', '56345gy34t12tf12', 2000000)
        .then((bool:any)=>{
          console.log('updateDebtAtBeginningCustomer', bool);
        })
  * @param id_customer 
  * @param id_branch 
  * @param debt_beginning 
  * @return Promise => bool = true or false 
  */
  public updateDebtAtBeginningCustomer(id_customer:string, id_branch:string, debt_beginning:number){
    return new Promise((resolve, reject) => {
      let customer = this.getlocalCustomer(id_customer);
      let value:any = {};
      if(customer[id_branch] != undefined){        
        value[id_branch] = customer[id_branch];       
      }else{ 
        value[id_branch] = {};        
      }
      value[id_branch].debt_beginning = debt_beginning;     
      this._updateCustomer(id_customer, {...value})
            .then((bool:any)=>{
              resolve(bool);
            },(error:any)=>{             
              reject(error);
            })  
    })
  }

/**
 * @example
 * this.vhQueryCafe.getDebtAtBeginningCustomers_byIDcustomer()
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningCustomers_byIDcustomer', debtatbeginnings);
          })
  * @param id_customer 
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningCustomers_byIDcustomer(id_customer:string){
    return new Promise((resolve, reject) => {     
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_customers', {id_customer:{$eq:id_customer}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }

/**
 * @example
 * this.vhQueryCafe.getDebtAtBeginningCustomers_byIDbranch()
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningCustomers_byIDbranch', debtatbeginnings);
          })
  * @param id_customer 
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningCustomers_byIDbranch(id_branch:string){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_customers', {id_branch:{$eq:id_branch}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }

    /**
 * @example
 * this.vhQueryCafe.getDebtAtBeginningCustomers_byIDcustomer_byIDbranch('3546235ytrhdghyw465', 'i5455234trgxi8675eg')
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningCustomers_byIDcustomer_byIDbranch', debtatbeginnings);
          })
  * @param id_customer 
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningCustomers_byIDcustomer_byIDbranch(id_customer:string, id_branch:string){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_customers', {id_customer:{$eq:id_customer}, id_branch:{$eq:id_branch}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }

  /**
 * @example
 * this.vhQueryCafe.getDebtAtBeginningCustomers()
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningCustomers', debtatbeginnings);
          })
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningCustomers(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('debt_at_beginning_customers')
            .then((debtatbeginnings)=>{                
              resolve(debtatbeginnings);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  /**
 * @example:
 * this.vhQueryCafe.updateDebtAtBeginningSupplier('5fb6780ca2148e09806c5b01', '56345gy34t12tf12', 2000000)
      .then((bool:any)=>{
        console.log('updateDebtAtBeginningSupplier', bool);
      })
  * @param id_supplier 
  * @param id_branch 
  * @param debt_beginning 
  * @return  Promise => bool = true or false 
  */
  public updateDebtAtBeginningSupplier(id_supplier:string, id_branch:string, debt_beginning:number){
    return new Promise((resolve, reject) => {
      let supplier = this.getlocalSupplier(id_supplier);
      let value:any = {};
      if(supplier[id_branch] != undefined){        
        value[id_branch] = supplier[id_branch];       
      }else{ 
        value[id_branch] = {};        
      }
      value[id_branch].debt_beginning = debt_beginning;     
      this._updateSupplier( id_supplier, {...value})
            .then((bool:any)=>{
              resolve(bool);
            },(error:any)=>{             
              reject(error);
            })  
    })
  }

/**
 * @example
 * this.vhQueryCafe.getDebtAtBeginningSuppliers_byIDsupplier()
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningSuppliers_byIDsupplier', debtatbeginnings);
          })
  * @param id_supplier 
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningSuppliers_byIDsupplier(id_supplier:string){
    return new Promise((resolve, reject) => {     
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_suppliers', {id_supplier:{$eq:id_supplier}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }

/**
 * @example
 * this.vhQueryCafe.getDebtAtBeginningSuppliers_byIDbranch()
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningSuppliers_byIDbranch', debtatbeginnings);
          })
  * @param id_branch         
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningSuppliers_byIDbranch(id_branch:string){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_suppliers', {id_branch:{$eq:id_branch}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }

   /**
 * @example
 * this.vhQueryCafe.getDebtAtBeginningSuppliers_byIDsupplier_byIDbranch('4ye5r6tyhdfdfaenm', '576dfgbdshdmiret3')
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningSuppliers_byIDsupplier_byIDbranch', debtatbeginnings);
          })
  * @param id_supplier         
  * @param id_branch         
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningSuppliers_byIDsupplier_byIDbranch(id_supplier:string, id_branch:string){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_suppliers', {id_supplier:{$eq:id_supplier}, id_branch:{$eq:id_branch}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }
        

  /**
 * @example
 * this.vhQueryCafe.getDebtAtBeginningSuppliers()
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningSuppliers', debtatbeginnings);
          })
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningSuppliers(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('debt_at_beginning_suppliers')
            .then((debtatbeginnings)=>{                
              resolve(debtatbeginnings);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  public setDefaultBranch(id_branch:any){      
    for(let i=0; i<this.branchs.length; i++){
      if(this.branchs[i]._id === id_branch){                                
        localStorage.setItem(this.vhMGDB_auth.getProjectName() + '_default_branch', JSON.stringify(this.branchs[i]));     
        break;
      }
    }     
  }  
  
  public getDefaultBranch():any{        
    if(this.branchs.length == 0) return null;  
    if(localStorage.getItem(this.vhMGDB_auth.getProjectName() + '_default_branch')){
      return JSON.parse(<any>localStorage.getItem(this.vhMGDB_auth.getProjectName() + '_default_branch'));
    }else{
      return null;
    }
  }

  public clearDefaultBranch(){   
    localStorage.setItem(this.vhMGDB_auth.getProjectName() + '_default_branch', <any>null);        
  }  

  public isChains(){
    if(this.branchs.length == 0) return null;
    else if(this.branchs.length == 1) return false;
    else return true;
  }
  
  private publishObservableEventBranchs() {
    this.subjectbranchs.next(this.branchs);
  }  

  private observableLocalBranchs():Subject<any> {      
    return this.subjectbranchs; 
  }
  
  /**
   * @example:
   * this.observableBranch = this.vhQueryCafe.getObservableLocalBranchs().subscribe((localBranchs:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableBranch.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalBranchs(){   
   return new Observable((observer:any) => {    
    this.observableLocalBranchs().subscribe((branchs) => {   
      observer.next(branchs);
    })
    this.publishObservableEventBranchs();
   })
  }

  /**
   * @example: 
   * let branch = this.vhQueryCafe.getlocalBranch('5fb6780ca2148e09806c5b01');
   * @param id_branch 
   * @return Object => obj = {} or null
   */
  public getlocalBranch(id_branch:any){
    for(let i=0; i<this.branchs.length; i++){
      if(this.branchs[i]._id === id_branch){
        return this.branchs[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let branchs = this.vhQueryCafe.getlocalBranchs(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalBranchs(){    
    return this.branchs;
  } 
  
  /**
   * @example:
   * this.vhQueryCafe.refreshLocalBranchs()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalBranch(), getlocalBranchs() trong localstorage
   * @return Promise => null
   */
  public refreshLocalBranchs():any{
    return new Promise((resolve) => { 
      this.getBranchs()
          .then(()=>{resolve(null)})       
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addBranch({name:'Chi nhánh 2'})
          .then((branch)=>{
            console.log('addBranch', branch);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addBranch(data:any){
      return new Promise((resolve, reject) => {
       if(!this.vhAuth.getStore().isDeveloper) {
         console.log('Vui lòng liên hệ A Huy để tạo chi nhánh mới');
         return reject({error:'Vui lòng liên hệ A Huy để tạo chi nhánh mới'});
       }
        this.vhMGDB_auth.getServerDate()
          .then((serverdate:any)=>{           
            let database = this.vhMGDB_auth.getDatabase();
            data.activate = true;
            this.vhMGDB_database.addDoc('branchs', data)
                .then((branch:any)=>{   
                    let promise_zero = new Array();    
                    let products = this.getlocalDetailProducts(3);

                    let obj = {...branch, opentime:'8h:00 AM', closetime:'10h:00 PM', img:'', tax_number:''};              
                    obj.appsetting_name = 'store_info';
                    obj.id_branch = branch._id;     
                    delete obj._id;

                    promise_zero[promise_zero.length] = this.vhMGDB_database.addDoc('appsettingbranchs',obj);                   
                    //Phần từ đây xuống dưới, update ở fronend đỡ, vài bữa giao cho server làm, vì số lượng sản phẩm nhiều, sợ frontend chạy ko nỗi
                    for(let i=0; i<products.length; i++){
                      let data_branch:any = {};
                      data_branch[branch._id + '_ivtr'] = null;

                      let quantity_branch:any = {};   
                      quantity_branch = {...products[i].quantity_branch};
                      quantity_branch[branch._id] = 0;
                    
                      if(products[i].lots){
                        let lots = cloneDeep(products[i].lots);
                        for(let m=0; m<products[i].lots.length; m++){  
                          lots[m].quantity_branch[branch._id] = 0;                                 
                        }  
                        promise_zero[promise_zero.length] = this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {quantity_branch, ...data_branch, lots})
                        //promise_zero[promise_zero.length] = this.updateProduct_fw(products[i]._id, {quantity_branch, ...data_branch, lots});      
                      }else{
                        promise_zero[promise_zero.length] = this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {quantity_branch, ...data_branch})
                        //promise_zero[promise_zero.length] = this.updateProduct_fw(products[i]._id, {quantity_branch, ...data_branch});     
                      }       
                    }
                    let main_id_branch = this.getDefaultBranch()._id;
                    let value_store:any = {};
                    value_store[branch._id] = cloneDeep(this.vhAuth.getStore()[main_id_branch]);
                    let expire_date =  new Date(serverdate);
                    expire_date.setDate(expire_date.getDate() + 1);                                                                                                                                                                              
                    value_store[branch._id]['main_package_expire']['expire_date'] = expire_date;  
                    
                    promise_zero[promise_zero.length] =  this.vhMGDB_rootdatabase.updateDoc('stores', database, {...value_store});
                    Promise.all(promise_zero)
                        .then(()=>{              
                            this.branchs.push(branch);     
                            this.publishObservableEventBranchs();                                                                                             
                            resolve(branch);
                          }).
                          catch((e)=>{
                            reject(e);     
                          })                        
                },(error:any)=>{
                  reject(error);
                })     
          }).
          catch((e)=>{
            reject(e);     
          })             
      })
    }  
  private addBranch_old(data:object){
    return new Promise((resolve, reject) => {
       if(!this.vhAuth.getStore().isDeveloper) {
         console.log('Vui lòng liên hệ A Huy để tạo chi nhánh mới');
         return reject({error:'Vui lòng liên hệ A Huy để tạo chi nhánh mới'});
       }
      this.vhMGDB_database.addDoc('branchs', data)
          .then((branch:any)=>{    
              let promise = new Array();    
              let products = this.getlocalProducts(3);

              let obj = {...branch, opentime:'8h:00 AM', closetime:'10h:00 PM', img:'', tax_number:''};              
              obj.appsetting_name = 'store_info';
              obj.id_branch = branch._id;     
              delete obj._id;

              promise.push(this.vhMGDB_database.addDoc('appsettingbranchs',obj));                   
              for(let i=0; i<products.length; i++){
                products[i].quantity_branch[branch._id] = 0;
                promise.push(this.updateProduct(products[i]._id, {quantity_branch: products[i].quantity_branch}));    
              }   
              Promise.all(promise).then(()=>{                                   
                resolve(branch);
              })           
          },(error:any)=>{
            reject(error);
          })         
    })
  }  

  /**
   * @example:
   * this.vhQueryCafe.updateBranch('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateBranch', bool);
          })
    * @param id_branch 
    * @param data 
    * @return Promise => bool = true or false 
    */
  public updateBranch(id_branch:string, data:object){
   return new Promise((resolve,reject) => {
     this.vhMGDB_database.updateDoc('branchs', id_branch, data)
         .then((bool:any)=>{
            if(bool){
              for(let i=0; i<this.branchs.length; i++){
                if(this.branchs[i]._id === id_branch){
                  this.branchs[i] = {...this.branchs[i],...data};
                  break;
                }
              } 
            }
            resolve(bool);
         }, error=>{
           reject(error)
         })          
   })
  }

  /**
   * @example:
   * this.vhQueryCafe.deleteBranch('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteBranch', bool);
        })
    * @param id_branch 
    * @return Promise => bool = true or false 
    */
  public deleteBranch(id_branch:string){
    return new Promise((resolve, reject) => {
      let promise = new Array();
      promise[0] = this.vhMGDB_database.getDocsByFields('wallets', {id_branch:{$eq:id_branch}},{},{},1);
      promise[1] = this.getBills_byFields({id_branch:{$eq:id_branch}},{},{},1);
      promise[2] = this.getBills_byFields({id_branch_receive:{$eq:id_branch}},{},{},1);
      Promise.all(promise)
            .then((array:any)=>{                      
              if((array[0].length===0)&&(array[1].length===0)&&(array[2].length===0)){              
                this.vhMGDB_database.deleteDoc('branchs', id_branch)
                    .then((bool:any)=>{            
                      resolve(bool);
                    }, error=>{
                      reject(error)
                    })    
              }else resolve(false);
            }, error=>{
              reject(error)
            })             
      })   
  }

  /**
   * @example
   * this.vhQueryCafe.getBranch('5fb67fda87c0f21d484cbdf3')
            .then((branch)=>{
              console.log('getBranch', branch);
            })
   * @param id_branch 
   * @return Promise => obj ={} or null
   */
  private getBranch(id_branch:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('branchs', id_branch)
            .then((branch)=>{
              resolve(branch);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getBranchs()
            .then((branchs)=>{
              console.log('getBranchs', branchs);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  private getBranchs(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('branchs')
            .then((branchs)=>{
              this.branchs = branchs;              
              resolve(branchs);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  private publishObservableEventPrinters() {
    this.subjectprinters.next(this.printers);
  }  

  private observableLocalPrinters():Subject<any> {      
    return this.subjectprinters; 
  }
  
   /**
   * @example:
   * this.observablePrinter = this.vhQueryCafe.getObservableLocalPrinters().subscribe((localPrinters:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observablePrinter.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalPrinters(){   
   return new Observable((observer:any) => {    
    this.observableLocalPrinters().subscribe((printers) => {   
      observer.next(printers);
    })
    this.publishObservableEventPrinters();
   })
  }  

/**
  * @notice :  lưu ý các hàm print này nó sẽ chỉ được tạo ra trên 1 máy vật lý (station), qua máy khác phải tạo lại
  * @example: 
  * let printer = this.vhQueryCafe.getlocalPrinter('5fb6780ca2148e09806c5b01');
  * @param id_printer 
  * @return Object => obj = {} or null
  */
  public getlocalPrinter(id_printer:any){
    for(let i=0; i<this.printers.length; i++){
      if(this.printers[i]._id === id_printer){
        return this.printers[i];
        break;
      }
    }
    return null; 
  }
  /**
   * @example
   * let printers = this.vhQueryCafe.getlocalPrinters(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalPrinters(){    
    return this.printers;
  }

   /**
   * @example:
   * this.vhQueryCafe.refreshLocalPrinters()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalPrinter(), getlocalPrinters() trong localstorage
   * @return Promise => null
   */
  public refreshLocalPrinters():any{
    return new Promise((resolve, reject) => { 
      // this.getPrinters()
      //     .then(()=>{resolve(null)})     
      resolve(null)  
    })
  }
  /**
   * @example:
   * this.vhQueryCafe.addPrinter({name:'camera 2', quantity:20, price:200000})
          .then((printer)=>{
            console.log('addPrinter', printer);
          }, error=>{
            console.log('error', error);
          })
   * @param data 
   * Promise => object = {} Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addPrinter(data:object){
    return new Promise((resolve, reject) => {
      let obj:any = {...data};
      obj.uuid = this.hwinfo.uuid;
      this.vhMGDB_database.addDoc('printers', obj)
          .then((printer)=>{
            resolve(printer);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updatePrinter('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updatePrinter', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_printer 
   * @param data 
   * @return Promise => bool = true or false
   */
  public updatePrinter(id_printer:string, data:object){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.updateDoc('printers', id_printer, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deletePrinter('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deletePrinter', bool);
        })
   * @param id_printer 
   * @return Promise => bool = true or false
   */
  public deletePrinter(id_printer:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('printers', id_printer)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getPrinter('5fb67fda87c0f21d484cbdf3')
            .then((printer)=>{
              console.log('getPrinter', printer);
            })
   * @param id_printer 
   * @return false or object
   */
  public getPrinter(id_printer:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('printers', id_printer)
            .then((printer:any)=>{
              if(printer) delete printer?.uuid;
              resolve(printer);
            }, error=>{
              reject(error)
            })         
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getPrinters()
            .then((printers)=>{
              console.log('getDoc', printers);
            })
   * @return array(object) = [{},{},..]
   */
  public getPrinters(){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDocsByFields('printers',{uuid: {$eq: this.hwinfo.uuid}},{},{},0)
            .then((printers:any)=>{
              this.printers = new Array();
              if(printers.length>0){
                printers.forEach((element:any) => {
                  delete element?.uuid;
                  this.printers.push(element);
                });
              }              
              resolve(this.printers);
            })          
    })
  }

  
  
   /**
   * @example:
   * this.vhQueryCafe.refreshLocalPrintPages()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalPrintPage(), getlocalPrintPages() trong localstorage
   * @return Promise => null
   */
    private refreshLocalPrintPages():any{
      return new Promise((resolve, reject) => { 
        this.getPrintPages()
            .then(()=>{resolve(null)})       
        resolve(null)
      })
    }

  /**
   * @example: 
   * let print_page = this.vhQueryCafe.getLocalPrintPage('page_desktop_sales');
   * @param print_page_type 
   * @return Object => obj = {} or null
   */
    public getLocalPrintPage(print_page_type:string){
    for(let i=0; i<this.print_pages.length; i++){
      if(this.print_pages[i].print_page_type === print_page_type){
        return this.print_pages[i];       
      }
    }                 
    return null; 
  }



    /**
   * @example: 
   * let pagesize = this.vhQueryCafe.getLocalDefaultPageSize('page_desktop_sales');
   * @param print_page_type 
   * @return Object => obj = {} or null
   */
    public getLocalDefaultPageSize(print_page_type:string){
    for(let i=0; i<this.print_pages.length; i++){
      if(this.print_pages[i].print_page_type === print_page_type){
        for(let j=0; j<this.print_pages[i]['print_sizes'].length; j++){
          if(this.print_pages[i]['print_sizes'][j]._id === this.print_pages[i].print_size_default){
            return this.print_pages[i]['print_sizes'][j];            
          }
        }        
      }
    }                 
    return null; 
  }
  /**
   * @example:
   * this.vhQueryCafe.addPrintPage('page_desktop_sales', {name:'camera 2', quantity:20, price:200000})
          .then((print_page)=>{
            console.log('addPrintPage', print_page);
          }, error=>{
            console.log('error', error);
          })
    * @param data 
    * Promise => object = {} Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
    public addPrintPage(print_page_type:string, data:any){
      return new Promise((resolve, reject) => {        
        let obj:any = {...data};
        obj.id_branch = this.getDefaultBranch()._id;
        obj.uuid = this.hwinfo.uuid;
        this.vhMGDB_database.getDocsByFields('print_pages', {id_branch:{$eq:obj.id_branch}, uuid:{$eq:obj.uuid}, print_page_type:{$eq:print_page_type}}, {})
            .then((print_pages:any)=>{
              if(print_pages.length===0){
                this.vhMGDB_database.addDoc('print_pages', obj)
                    .then((print_page)=>{
                      this.print_pages.push(print_page);
                      resolve(print_page);
                    }, error=>{
                      reject(error)
                    })
              }          
            },(error:any)=>{              
              reject(error)
            })
                  
      })
    }

    /**
   * @example:
   * this.vhQueryCafe.updatePrintPage('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updatePrintPage', bool);
          }, error=>{
            console.log('error', error);
          })
    * @param id_print_page
    * @param data 
    * @return Promise => bool = true or false
    */
  public updatePrintPage(id_print_page:string, data:object){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.updateDoc('print_pages', id_print_page, data)
          .then((bool:any)=>{
            if(bool){
              for(let i=0; i<this.print_pages.length; i++){
                if(this.print_pages[i]._id === id_print_page){
                  this.print_pages[i] = {...this.print_pages[i], ...data};
                  break;
                }
              }
            }
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.deletePrintPage('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deletePrintPage', bool);
        })
    * @param id_print_page 
    * @return Promise => bool = true or false
    */
  public deletePrintPage(id_print_page:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('print_pages', id_print_page)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getPrintPages()
            .then((print_pages)=>{
              console.log('getPrintPages', print_pages);
            })
    * @return array(object) = [{},{},..]
    */
    public getPrintPages(){
      return new Promise((resolve) => {
        this.vhMGDB_database.getDocsByFields('print_pages',{id_branch:{$eq:this.getDefaultBranch()._id}, uuid: {$eq: this.hwinfo.uuid}},{},{},0)
              .then((print_pages:any)=>{
                this.print_pages = new Array();
                if(print_pages.length>0){
                  print_pages.forEach((e:any) => {
                    delete e?.uuid;
                    delete e?.id_branch;
                    this.print_pages.push(e);
                  });
                }              
                resolve(this.print_pages);
              })          
      })
    }

/**
  * Hàm này dùng để thực hiện trừ hàng hóa trong nhiều Payment_Card
  * Hàm chạy ổn định anh sẽ thêm phần trừ số lượng hàng hóa đã sử dụng trong payment_card_code
  * @example
      let bill = {
          bill_type: 51,
          id_employee: '2rVieBQTubQ2hjUnpwU4w7qSlD83',
          id_branch: 'ADGNX9HFzffJ59yRtqNd',
          id_customer: 'cus001',
          id_wallet: 'wallet001',
          note: '',
          date: new Date(),
          bill_code: 'L46K0502'
      }
      let bill_details =[{     
        id_payment_card: '7Q5BZVRlyySrhShngMDv',
        id_payment_card_code: '33cTgnd2xZo3OW9tsu1d',
        pctype: 1,          
        quantity: 1,
        ratio: 1,
        products:[{
            id_product:'9tg6UxzK26DDVEVHsvq5'
            quantity: 5
            price: 100000
            ptype: 1,
            unit: 'cái',
            ratio:1				
          },{
            id_product:'jUqd5bE6y2JhX0aCd5TF',
            quantity: 1
            price: 50000
            ptype: 2,
            unit: 'cái',
            ratio:1	
          },{
            id_product,
            quantity,
            price,
            ptype: 1,
            unit: 'cái',
            ratio:1	
      }]	
      //dưới là cái cũ, sẽ bỏ đi
      let bill_details =[{
          id_payment_card: '7Q5BZVRlyySrhShngMDv',
          id_payment_card_code: '33cTgnd2xZo3OW9tsu1d',
          pctype: 1,  
          id_product:'9tg6UxzK26DDVEVHsvq5'
          quantity: 2
          price: 200000
          ptype: 1
      },{
          id_payment_card: '7Q5BZVRlyySrhShngMDv',
          id_payment_card_code: '33cTgnd2xZo3OW9tsu1d',
          pctype: 1,  
          id_product:'jUqd5bE6y2JhX0aCd5TF',
          quantity: 1
          price: 100000
          ptype: 2            
      }]	       
      this.vhQueryCafe.createBill_Billdetail_51(bill, bill_details)
          .then((bill:any)=>{
              console.log(bill._id);
          },(error:any)=>{
              console.log('error ', error);
          })
  * @param bill
  * @param bill_details
  * @returns Promise => object = {} or null
  */
public createBill_Billdetail_51(bill:any, bill_details:any):any{
  return new Promise((resolve, reject) => {  
    let bill_details_new = new Array();
    this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
    bill.sync_code = this.sync_code;

    bill.date = new Date();
    bill.bill_type = 51;       
    bill.bill_code = this.vhAlgorithm.createBillCode(bill?.date);
    this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(bill.date), bill)
        .then((bill_get:any) => {     
          if(bill_get){                     
              for(let i=0; i<bill_details.length; i++){
                let data = {...bill_details[i]};
                data.id_bill = bill_get._id;
                //---------------NEW-----------------
                if(bill.bill_code) data.bill_code = bill.bill_code;
                if(bill.date) data.date = bill.date;
                if(typeof bill.tax == 'number') data.tax = bill.tax;
                data.bill_type = 51;
                if(bill.id_cashier) data.id_cashier = bill.id_cashier;
                if(bill.id_employee) data.id_employee = bill.id_employee;                 
                if(bill.id_customer) data.id_customer = bill.id_customer;              
                if(bill.id_branch) data.id_branch = bill.id_branch;
                //-----------------------------------
                //Tạo phiếu bill_details_new                
                if(data.products != undefined){
                  for(let j=0; j<data.products.length; j++){
                    let bill_detail_payment_card = {...data, ...data.products[j]};
                    delete bill_detail_payment_card.products;                         
                    bill_details_new.push(bill_detail_payment_card);
                  }
                }                     
              }    
              let promise_zero = new Array();
              for(let i=0; i<bill_details_new.length; i++){
                promise_zero[i] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details_new[i]);   
              }                  
              this.vhQuery.asyncPromiseAll(promise_zero)
                  .then(()=>{
                    if(bill.bill_type === 51){//phiếu đổi payment_card
                      let _bill_details = cloneDeep(bill_details);
                      let promise_one = new Array();
                      for(let i=0; i<_bill_details.length; i++){
                        promise_one[i] = new Promise((resolve, reject)=>{
                        this.getPaymentCardCode(_bill_details[i].id_payment_card_code)
                            .then((payment_card_code:any)=>{   
                              for(let j=0; j<_bill_details[i].products.length; j++){
                                for(let k=0; k<payment_card_code.products.length; k++){
                                  if(payment_card_code.products[k].id_product === _bill_details[i].products[j].id_product){// nhớ khởi động giá trị outquantity
                                    if(payment_card_code.products[k].id_subproduct){
                                      if(payment_card_code.products[k].id_subproduct === _bill_details[i].products[j].id_subproduct){
                                        payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity + _bill_details[i].products[j].quantity;
                                        //payment_card_code.products[k].restquantity = payment_card_code.products[k].restquantity - _bill_details[i].products[j].restquantity;
                                      }
                                    }else{
                                      payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity + _bill_details[i].products[j].quantity;
                                      //payment_card_code.products[k].restquantity = payment_card_code.products[k].restquantity - _bill_details[i].products[j].restquantity;
                                    }                                                                        
                                  }
                                }                                 
                              }
                              this.updatePaymentCardCode(payment_card_code._id, {products: payment_card_code.products, date_used : bill.date, status: 4})                              
                                  .then(()=>{
                                    resolve(null)
                                  }) 
                            })
                        })                          
                      }

                      
                      let promise_products = new Array();
                      for(let i=0; i<bill_details_new.length; i++){      
                          //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                     
                          if(bill_details_new[i].ptype ===1){                                                
                              if(!bill_details_new[i].calculated){
                                let quantity_all_bill_details = bill_details_new[i].quantity;                                  
                                bill_details_new[i].calculated = true;
                                for(let j=0; j<bill_details_new.length; j++){                                    
                                  if(bill_details_new[j].id_product === bill_details_new[i].id_product){
                                    if(!bill_details_new[j].calculated){
                                      quantity_all_bill_details = quantity_all_bill_details + bill_details_new[j].quantity;
                                      bill_details_new[j].calculated = true;
                                    }                                        
                                  }
                                  if(bill_details_new[j].ptype ===5){  
                                    for(let k=0; k<bill_details_new[j].combos.length; k++){
                                      if(bill_details_new[j].combos[k].id_product === bill_details_new[i].id_product){
                                        if(!bill_details_new[j].combos[k].calculated){
                                          quantity_all_bill_details = quantity_all_bill_details + bill_details_new[j].quantity * bill_details_new[j].combos[k].quantity;
                                          bill_details_new[j].combos[k].calculated = true;
                                        }                                        
                                      }
                                    }
                                  }
                                }                                      
                                                          
                                let product = this.getlocalProduct(bill_details_new[i].id_product);                                       
                                let quantity_branch:any = {};                                        
                                if(product.quantity_branch != undefined){
                                  quantity_branch = product.quantity_branch;                                        
                                  if(product.quantity_branch[bill.id_branch] != undefined){                                           
                                    quantity_branch[bill.id_branch] = quantity_branch[bill.id_branch] - quantity_all_bill_details;
                                  }else{                                                                             
                                    quantity_branch[bill.id_branch]= - quantity_all_bill_details;
                                  }                                                 
                                }else{                                          
                                  quantity_branch[bill.id_branch] = - quantity_all_bill_details;                                                                               
                                }   
                                let quantity = product.quantity - quantity_all_bill_details;                                                                                                           
                                promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', product._id,{quantity: quantity, quantity_branch: quantity_branch});
                              }
                          }else if(bill_details_new[i].ptype ===5){                                                       
                              for(let m=0; m<bill_details_new[i].combos.length; m++){
                                if(!bill_details_new[i].combos[m].calculated){
                                    let quantity_all_bill_details = bill_details_new[i].quantity * bill_details_new[i].combos[m].quantity;                                  
                                    bill_details_new[i].combos[m].calculated = true;
                                    for(let j=0; j<bill_details_new.length; j++){                                    
                                      if(bill_details_new[j].id_product === bill_details_new[i].combos[m].id_product){
                                        if(!bill_details_new[j].calculated){
                                          quantity_all_bill_details = quantity_all_bill_details + bill_details_new[j].quantity;
                                          bill_details_new[j].calculated = true;
                                        }                                        
                                      }
                                      if(bill_details_new[j].ptype ===5){  
                                        for(let k=0; k<bill_details_new[j].combos.length; k++){
                                          if(bill_details_new[j].combos[k].id_product === bill_details_new[i].combos[m].id_product){
                                            if(!bill_details_new[j].combos[k].calculated){
                                              quantity_all_bill_details = quantity_all_bill_details + bill_details_new[j].quantity * bill_details_new[j].combos[k].quantity;
                                              bill_details_new[j].combos[k].calculated = true;
                                            }                                        
                                          }
                                        }
                                      }
                                    }   

                                    let product = this.getlocalProduct(bill_details_new[i].combos[m].id_product);
                                    let quantity_branch:any = {};                                        
                                    if(product.quantity_branch != undefined){
                                      quantity_branch = product.quantity_branch;                                        
                                      if(product.quantity_branch[bill.id_branch] != undefined){                                           
                                        quantity_branch[bill.id_branch] = quantity_branch[bill.id_branch] - quantity_all_bill_details;
                                      }else{                                                                             
                                        quantity_branch[bill.id_branch]= - quantity_all_bill_details;
                                      }                                                 
                                    }else{                                          
                                      quantity_branch[bill.id_branch] = - quantity_all_bill_details;                                                                               
                                    }   
                                    let quantity = product.quantity - quantity_all_bill_details;                                              

                                    promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', product._id,{quantity: quantity, quantity_branch: quantity_branch});
                                }
                              }                                                                
                          }else{
                            promise_products[promise_products.length] = new Promise<any>((resolve)=>{resolve(null);});
                          }                               
                      }
                      this.vhQuery.asyncPromiseAll([...promise_one, ...promise_products])
                          .then(()=>{  
                            resolve(bill_get)
                          }) 

                    } 
                  })
          }
        })
  })
}
/**
* Hàm này dùng để thực hiện đổi voucher lấy hàng hóa
* @example
    let bill = {
        bill_type: 41,
        id_employee: '2rVieBQTubQ2hjUnpwU4w7qSlD83',
        id_branch: '2rVieBQTubQ2hjUnpwU4w7qSlD83',
        id_customer: 'cus001',
        id_wallet: 'wallet001',
        note: '',
        date: new Date(),
        bill_code: ''
    }
    let bill_details =[{     
        id_voucher: 'voucher006',
        id_voucher_code: 'MHRD9N0531',
        vtype: 1,
        quantity: 2//bỏ đi
        products:[{
            id_product:'9tg6UxzK26DDVEVHsvq5'
            quantity: 5
            price: 100000
            ptype: 1,
            unit: 'cái',
            ratio:1				
          },{
            id_product:'jUqd5bE6y2JhX0aCd5TF',
            quantity: 1
            price: 50000
            ptype: 2,
            unit: 'cái',
            ratio:1	
          },{
            id_product,
            quantity,
            price,
            ptype: 5// bây giờ phần mềm chưa dùng voucher có combo
            combos:[{
                id_product,
                quantity,
                price,
                ptype: 1,
                unit: 'cái',
                ratio:1	
            },{
                id_product,
                quantity,
                price,
                ptype: 2,
                unit: 'cái',
                ratio:1					          
        }]	        
    }]	       
    this.vhQueryCafe.createBill_Billdetail_41(bill, bill_details)
        .then((bill:any)=>{
            console.log(bill._id);
        },(error:any)=>{
            console.log('error ', error);
        })
* @param bill
* @param bill_details
* @returns Promise => object = {} or null
*/
  public createBill_Billdetail_41(bill:any, bill_details:any):any{     
    return new Promise((resolve, reject) => {  
      this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
      bill.sync_code = this.sync_code;

      bill.date = new Date();
      bill.bill_type = 41;       
      bill.bill_code = this.vhAlgorithm.createBillCode(bill?.date);
      this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(bill.date), bill)
          .then((bill_get:any) => {     
            if(bill_get){                       
                let bill_details_new = new Array();
                for(let i=0; i<bill_details.length; i++){
                  let data = {...bill_details[i]};
                  data.id_bill = bill_get._id;
                  //---------------NEW-----------------
                  if(bill.bill_code) data.bill_code = bill.bill_code;
                  if(bill.date) data.date = bill.date;
                  if(typeof bill.tax == 'number') data.tax = bill.tax;
                  data.bill_type = 41;
                  if(bill.id_cashier) data.id_cashier = bill.id_cashier;
                  if(bill.id_employee) data.id_employee = bill.id_employee;                 
                  if(bill.id_customer) data.id_customer = bill.id_customer;              
                  if(bill.id_branch) data.id_branch = bill.id_branch;
                  //-----------------------------------
                  //Tạo phiếu bill_billdetails
                  if(data.products != undefined){
                    for(let j=0; j<data.products.length; j++){
                      let bill_detail_voucher = {...data, ...data.products[j]};
                      delete bill_detail_voucher.products;     
                      bill_details_new.push(bill_detail_voucher);
                    }
                  }        
                }       
                let promise_zero = new Array();
                for(let i=0; i<bill_details_new.length; i++){
                  promise_zero[i] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details_new[i]);   
                }                              
                this.vhQuery.asyncPromiseAll(promise_zero)
                    .then(()=>{
                      if(bill.bill_type === 41){//phiếu đổi voucher
                          let promise_one = new Array();
                          for(let i=0; i<bill_details.length; i++){
                            promise_one[i] = this.updateVoucherCode(bill_details[i].id_voucher_code,{date_used : bill.date, status: 4, id_bill: bill_get._id, id_customer_used: bill.id_customer});                             
                          }
                          
                          let promise_products = new Array();
                          for(let i=0; i<bill_details_new.length; i++){      
                              //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                     
                              if(bill_details_new[i].ptype ===1){                                                
                                  if(!bill_details_new[i].calculated){
                                    let quantity_all_bill_details = bill_details_new[i].quantity;                                  
                                    bill_details_new[i].calculated = true;
                                    for(let j=0; j<bill_details_new.length; j++){                                    
                                      if(bill_details_new[j].id_product === bill_details_new[i].id_product){
                                        if(!bill_details_new[j].calculated){
                                          quantity_all_bill_details = quantity_all_bill_details + bill_details_new[j].quantity;
                                          bill_details_new[j].calculated = true;
                                        }                                        
                                      }
                                      if(bill_details_new[j].ptype ===5){  
                                        for(let k=0; k<bill_details_new[j].combos.length; k++){
                                          if(bill_details_new[j].combos[k].id_product === bill_details_new[i].id_product){
                                            if(!bill_details_new[j].combos[k].calculated){
                                              quantity_all_bill_details = quantity_all_bill_details + bill_details_new[j].quantity * bill_details_new[j].combos[k].quantity;
                                              bill_details_new[j].combos[k].calculated = true;
                                            }                                        
                                          }
                                        }
                                      }
                                    }                                      
                                                              
                                    let product = this.getlocalProduct(bill_details_new[i].id_product);                                       
                                    let quantity_branch:any = {};                                        
                                    if(product.quantity_branch != undefined){
                                      quantity_branch = product.quantity_branch;                                        
                                      if(product.quantity_branch[bill.id_branch] != undefined){                                           
                                        quantity_branch[bill.id_branch] = quantity_branch[bill.id_branch] - quantity_all_bill_details;
                                      }else{                                                                             
                                        quantity_branch[bill.id_branch]= - quantity_all_bill_details;
                                      }                                                 
                                    }else{                                          
                                      quantity_branch[bill.id_branch] = - quantity_all_bill_details;                                                                               
                                    }   
                                    let quantity = product.quantity - quantity_all_bill_details;                                                                                                           
                                    promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', product._id,{quantity: quantity, quantity_branch: quantity_branch});
                                  }
                              }else if(bill_details_new[i].ptype ===5){                                                       
                                  for(let m=0; m<bill_details_new[i].combos.length; m++){
                                    if(!bill_details_new[i].combos[m].calculated){
                                        let quantity_all_bill_details = bill_details_new[i].quantity * bill_details_new[i].combos[m].quantity;                                  
                                        bill_details_new[i].combos[m].calculated = true;
                                        for(let j=0; j<bill_details_new.length; j++){                                    
                                          if(bill_details_new[j].id_product === bill_details_new[i].combos[m].id_product){
                                            if(!bill_details_new[j].calculated){
                                              quantity_all_bill_details = quantity_all_bill_details + bill_details_new[j].quantity;
                                              bill_details_new[j].calculated = true;
                                            }                                        
                                          }
                                          if(bill_details_new[j].ptype ===5){  
                                            for(let k=0; k<bill_details_new[j].combos.length; k++){
                                              if(bill_details_new[j].combos[k].id_product === bill_details_new[i].combos[m].id_product){
                                                if(!bill_details_new[j].combos[k].calculated){
                                                  quantity_all_bill_details = quantity_all_bill_details + bill_details_new[j].quantity * bill_details_new[j].combos[k].quantity;
                                                  bill_details_new[j].combos[k].calculated = true;
                                                }                                        
                                              }
                                            }
                                          }
                                        }   

                                        let product = this.getlocalProduct(bill_details_new[i].combos[m].id_product);
                                        let quantity_branch:any = {};                                        
                                        if(product.quantity_branch != undefined){
                                          quantity_branch = product.quantity_branch;                                        
                                          if(product.quantity_branch[bill.id_branch] != undefined){                                           
                                            quantity_branch[bill.id_branch] = quantity_branch[bill.id_branch] - quantity_all_bill_details;
                                          }else{                                                                             
                                            quantity_branch[bill.id_branch]= - quantity_all_bill_details;
                                          }                                                 
                                        }else{                                          
                                          quantity_branch[bill.id_branch] = - quantity_all_bill_details;                                                                               
                                        }   
                                        let quantity = product.quantity - quantity_all_bill_details;                                              

                                        promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', product._id,{quantity: quantity, quantity_branch: quantity_branch});
                                    }
                                  }                                                                
                              }else{
                                promise_products[promise_products.length] = new Promise<any>((resolve)=>{resolve(null);});
                              }                               
                          }
                          this.vhQuery.asyncPromiseAll([...promise_one, ...promise_products])
                              .then(()=>{  
                                resolve(bill_get)
                              })                       
                      } 
                    })
            }else resolve(null);
          },(error)=>{
            reject(error);
          })
    })
  }
      

  /**
    * Hàm này dùng cho những bill nào được tao ra thêm bill_detail vào và lưu lên database luôn
   * @example
    let bill ={       
      id_employee: '2rVieBQTubQ2hjUnpwU4w7qSlD83',
      id_cashier: '2rVieBQTubQ2hjUnpwU4w7qSlD83',
      id_customer: 'cus001',
      total: 10000000,
      bill_type: 1,
      tax_value: 0,
      fee: 0,
      date: new Date()
    }
    let bill_details =[{
      id_product: 'pro006',
      price: 10000000,
      quantity: 1
    },{
      id_product: 'pro007',
      price: 12000000,
      quantity: 1
    }]
    this.vhQueryCafe.createBill_Billdetail(bill, bill_details)
        .then((bill:any)=>{
          console.log(bill._id);
        },(error:any)=>{
          console.log('error ', error);
        })
   * @param bill 
   * @param bill_details 
   * @return Promise => object = {} or null
   */
  public createBill_Billdetail(bill:any, bill_details:any):any{//nhớ add id_branch vào         
    console.log('c_createBill_Billdetail', bill, bill_details)
    let _bill_details = cloneDeep(bill_details);
    if((bill.bill_type != 40)&&(bill.bill_type != 42)&&(bill.bill_type != 43)&&(bill.bill_type != 50)&&(bill.bill_type != 52)&&(bill.bill_type != 53)){
      bill_details = this.changeBillDetails_withPromotions_toRaw(bill_details);
      if(!bill_details) return null;    
    }    
    return new Promise((resolve, reject) => {         
        this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
        bill.sync_code = this.sync_code;
        this.createBillCode(bill.date, bill.bill_type)
          .then((bill_code)=>{
            bill.bill_code = bill_code;
            if(bill.bill_type == 1) bill.cqt_status = 1;   
            //bill.bill_code = this.vhAlgorithm.createBillCode(bill?.date);
            this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(bill.date), bill)
                .then((bill_get:any) => {     
                  if(bill_get){       
                      let promise = new Array();
                      for(let i=0; i<bill_details.length; i++){
                        let data = bill_details[i];
                        data.id_bill = bill_get._id;
                        //---------------NEW-----------------                        
                        if(bill.bill_code) data.bill_code = bill.bill_code;
                        if(bill.date) data.date = bill.date;
                        if(bill.id_area) data.id_area = bill.id_area; 
                        if(bill.id_table) data.id_table = bill.id_table; 
                        
                        if(typeof bill.tax == 'number') data.tax = bill.tax;
                        if(typeof bill.bill_type == 'number') data.bill_type = bill.bill_type;
                        if(bill.id_cashier) data.id_cashier = bill.id_cashier;
                        if(bill.id_employee) data.id_employee = bill.id_employee;
                        if(bill.id_supplier) data.id_supplier = bill.id_supplier;
                        if(bill.id_customer) data.id_customer = bill.id_customer;
                        if(bill.id_inventorytime) data.id_inventorytime = bill.id_inventorytime;
                        if(bill.id_branch) data.id_branch = bill.id_branch;   
                        
                        
                        //-----------------------------------
                        //Tạo phiếu bill_billdetails
                        promise[i] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data)                  
                      }     
                      this.vhQuery.asyncPromiseAll(promise)
                          .then((message:any)=>{                                                   
                            //Tạo các bill_type này làm giảm quantity trong products
                            if((bill.bill_type === 1)||(bill.bill_type === 3)||(bill.bill_type === 10)||(bill.bill_type === 30)||(bill.bill_type === 38)){                                                
                              //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                         
                              this.calculateQuantityProduct_DOWN(bill_details, bill.id_branch)
                                  .then(()=>{
                                    resolve(bill_get);
                                  })
                            //Các bill_type này làm tăng quantity trong products  
                            }else if(bill.bill_type === 2){   
                              this.calculateQuantityProduct_UP(bill_details, bill.id_branch)
                                  .then(()=>{                                   
                                    this.calculateUpdateImportPrice(bill_details, bill.id_branch)
                                        .then(()=>{
                                          resolve(bill_get);
                                        })
                                  })   
                            //Các bill_type này làm tăng quantity trong products  
                            }else if((bill.bill_type === 16)||(bill.bill_type === 31)){
                              this.calculateQuantityProduct_UP(bill_details, bill.id_branch)
                                    .then(()=>{                                   
                                      resolve(bill_get);
                                    })   
                            }else if(bill.bill_type === 9){
                                //Sau khi tạo đơn tồn đầu kỳ, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại
                                this.calculateQuantityProduct_UP_9(bill_details, bill.id_branch)
                                    .then(()=>{
                                      resolve(bill_get);
                                    })   
                            //Các bill_type này không làm thay đổi quantity trong products                                       
                            }else if((bill.bill_type === 5)||(bill.bill_type === 6)||(bill.bill_type === 13)||(bill.bill_type === 14)||(bill.bill_type === 15)||(bill.bill_type === 17)||(bill.bill_type === 18)
                                  ||(bill.bill_type === 20)||(bill.bill_type === 29)){
                              resolve(bill_get)
                            }else if(bill.bill_type === 40){//bán voucher     
                              let promise_40 = new Array();                                    
                              for(let i=0; i<bill_details.length; i++){                        
                                //cập nhật lại trạng thái thẻ
                                let _products = [...bill_details[i].products];
                                promise_40[promise_40.length] = this.updateVoucherCode(bill_details[i].id_voucher_code, {products: _products, date_sold : bill.date, status: 2, id_customer: bill.id_customer});                             
                              }   
                              Promise.all(promise_40)
                                    .then(()=>{
                                      resolve(bill_get);
                                    })  
                            }else if(bill.bill_type === 41){//đổi voucher                            
                              let promise_41 = new Array();
                              for(let i=0; i<bill_details.length; i++){
                                promise_41[promise_41.length] = this.updateVoucherCode(bill_details[i].id_voucher_code,{date_used : bill.date, status: 4, id_bill: bill_get._id, id_customer_used: bill.id_customer});                             
                              }                
                              //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                               
                              promise_41[promise_41.length] = this.calculateQuantityProduct_DOWN(bill_details, bill.id_branch);                       
                              this.vhQuery.asyncPromiseAll(promise_41)
                                  .then(()=>{  
                                    resolve(bill_get)
                                  })                                                                      
                            }else if(bill.bill_type === 50){//bán thẻ trả trước    
                              let promise_50 = new Array();                                             
                              for(let i=0; i<bill_details.length; i++){                          
                                let _products = [...bill_details[i].products];
                                for(let j=0; j<_products.length; j++){
                                  _products[j].outquantity = 0;                            
                                }
                                //cập nhật lại trạng thái thẻ
                                promise_50[promise_50.length] =  this.updatePaymentCardCode(bill_details[i].id_payment_card_code, {products: _products, date_sold : bill.date, status: 2, id_customer: bill.id_customer});                              
                              }
                              Promise.all(promise_50)
                                    .then(()=>{
                                      resolve(bill_get);
                                    })   
                            }else if(bill.bill_type === 51){//đổi thẻ trả trước         
                              let promise_51 = new Array();                      
                              for(let i=0; i<_bill_details.length; i++){
                                promise_51[i] = new Promise((resolve, reject)=>{
                                  this.getPaymentCardCode(_bill_details[i].id_payment_card_code)
                                      .then((payment_card_code:any)=>{                                 
                                        for(let j=0; j<_bill_details[i].products.length; j++){
                                          for(let k=0; k<payment_card_code.products.length; k++){
                                            if(payment_card_code.products[k].id_product === _bill_details[i].products[j].id_product){// nhớ khởi động giá trị outquantity
                                              if(payment_card_code.products[k].id_subproduct){
                                                if(payment_card_code.products[k].id_subproduct === _bill_details[i].products[j].id_subproduct){                                        
                                                  payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity + _bill_details[i].products[j].quantity;   
                                                }
                                              }else{                                      
                                                payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity + _bill_details[i].products[j].quantity;   
                                              }                                                                     
                                            }
                                          }                                 
                                        }
                                        this.updatePaymentCardCode(payment_card_code._id, {products: payment_card_code.products, date_used : bill.date, status: 4})                              
                                            .then(()=>{                                    
                                              resolve(null)
                                            }) 
                                      })
                                })                          
                              }
                              //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại   
                              promise_51[promise_51.length] = this.calculateQuantityProduct_DOWN(bill_details, bill.id_branch);    
                              Promise.all(promise_51)                      
                                    .then(()=>{  
                                      resolve(bill_get)
                                    }) 
                            }            
                        })                                        
                  }else reject({message: 'Invoice creation failed'});
                },
                (error:any) => {
                  reject(error);
                })  
          })      
    })
  }

   /**
   * @example
   * this.vhQueryCafe.changeBill_toInvoice_byMinvoice(id_bill,invoiceSeries)       
          .then((rsp)=>{    
            //-----------your code here-----------                      
          },(error:any)=>{
              console.log('error', error)
          })
   * @param id_bill 
   * @param invoiceSeries   
   * @returns Promise => {vcode, msg, data(array)}
   */
  public changeBill_toInvoice_byMinvoice(id_bill:string, invoiceSeries: string):Promise<any>{
    return new Promise<any>((resolve, reject) => {  
      (async () => {
        try{ 
          let invoices = new Array(); 
          // Khởi tạo mảng Promise
          const promises = [
            this.getBill(id_bill),
            this.getBill_details_byID({ id_bill: { $eq: id_bill } })
          ];
          // Sử dụng await để lấy kết quả từ Promise.all()
          const [bill, bill_details] = await Promise.all(promises).catch((err) => {
            console.error('❌ Lỗi trong quá trình lấy dữ liệu:', err);
            throw new Error('Không thể lấy dữ liệu hóa đơn');
          }) as [any, any[]];
          let invoice:any = {
            inv_invoiceSeries: invoiceSeries,
            inv_invoiceIssuedDate: this.vhAlgorithm.formatDateToString(new Date()),
            inv_currencyCode: "VND",
            inv_exchangeRate: 1,
            //inv_buyerDisplayName: "",
            // inv_buyerLegalName: "",
            // inv_buyerTaxCode: "",
            //inv_buyerAddressLine: "",
            inv_discountAmount: 0,
            inv_TotalAmountWithoutVat: bill.total,
            inv_vatAmount: bill.total*bill.tax/100,          
            inv_TotalAmount: bill.total*(1 + bill.tax/100),
            key_api: id_bill
          }
          if(bill.id_customer == "id_retail"){
            if(bill.retail_name) invoice.inv_buyerDisplayName = bill.retail_name;
            if(bill.retail_address) invoice.inv_buyerAddressLine = bill.retail_address;
          }else{
            let customer = await this.getlocalCustomer_Async(bill.id_customer);  
            if(customer?.isBusiness ){
              if(customer.taxcode) invoice.inv_buyerTaxCode = customer.taxcode;
              if(customer.name) invoice.inv_buyerLegalName = customer.name;
              if(customer.address) invoice.inv_buyerAddressLine = customer.address;
              if(bill.retail_name) invoice.inv_buyerDisplayName = bill.retail_name;
            }else{
              if(customer.name) invoice.inv_buyerDisplayName = customer.name;
              if(customer.address) invoice.inv_buyerAddressLine = customer.address;
            }
          }
          let invoice_details = new Array();
          for(let i=0; i<bill_details.length; i++){
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product;
            let product:any = await this.getlocalDetailProduct_Async(id_sub_or_product)
            let invoice_detail = {
              tchat: 1,
              stt_rec0: i+1,
              inv_itemCode: bill_details[i]._id,
              inv_itemName: product.name,
              inv_unitCode: this.getUnit_byRatio(product.units, bill_details[i].ratio)?.unit,//nhớ đổi về ratio 1
              inv_quantity:  bill_details[i].quantity,
              inv_unitPrice: bill_details[i].price,
              inv_discountPercentage: (bill_details[i].price_origin - bill_details[i].price)/bill_details[i].price_origin,
              inv_discountAmount: bill_details[i].price_origin - bill_details[i].price,
              inv_TotalAmountWithoutVat: bill_details[i].price *  bill_details[i].quantity,
              ma_thue: bill_details[i].tax,
              inv_vatAmount: bill_details[i].quantity*bill_details[i].price*bill_details[i].tax/100,
              inv_TotalAmount: bill_details[i].quantity*bill_details[i].price*(1 +  bill_details[i].tax/100)
            }

            invoice_details.push(invoice_detail)
          }
          
          invoices = [{...invoice, details:[{data:invoice_details}]}];
          console.log('data', invoices); 
          resolve({vcode: 0, msg: 'success', data: invoices});                      
        } catch (err) {
          console.error('❌ Lỗi saveInvoice_noSign_byMinvoice:', err);
          reject(err);
        }  
      })()       
    })
  }
 
  /**
   * hàm này chỉ dùng cho trường hợp bill_type 5->1, 29->3031, 36->1, 42->40, 43->41, 52->50, 53->51
   * @example
    this.vhQueryCafe.saveBill_Billdetail('SzyEYNN39Mq90NkzUFpz')
        .then(()=>{
          console.log("success");
        })
   * @param id_bill 
   * @param newbill_type
   * @return Promise => undefined     
   */
  public saveBill_Billdetail(id_bill:any, newbill_type:number):any {   
    console.log('c_saveBill_Billdetail', id_bill, newbill_type)  
    //Nghiệp vụ nhà hàng chọn món là dùng hàm createbill_detail tạo bill_detail luôn, nên khi nào tính tiền mới dùng đến hàm này (hàm này ko thể bỏ đc) 
    //Nghiệp vụ bán hàng khác là chọn sản phẩm xong la dùng hàm updateBill_Billdetail để lưu bill_detail đó cùng với bill lại, ko là mất dữ liệu đã chọn đó
    if(!newbill_type) newbill_type = 1;
    return new Promise((resolve, reject) => {           
        this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
        let promise_0 = this.getBill(id_bill);
        let promise_1 = this.getBill_details_byID({id_bill:{$eq:id_bill}})
        Promise.all([promise_0, promise_1])
            .then((array:any)=>{   
              //console.log('array', array);    
              let billdate = array[0].date;  
              this.createBillCode(array[0].date, newbill_type)
                  .then((bill_code)=>{      
                    //console.log('bill_code', bill_code);                
                      if((array[0].bill_type === 5)||(array[0].bill_type === 36)){                 
                          let promise = new Array();      
                          for(let i=0; i<array[1].length; i++){                               
                            let value_bill_detail ={
                              bill_code: bill_code, 
                              bill_type: newbill_type
                            }
                            promise[i] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id, value_bill_detail);                   
                          }    
                          let value_bill:any ={
                            bill_code: bill_code, 
                            bill_type: newbill_type,
                            sync_code: this.sync_code,
                            
                          }
                          if(newbill_type == 1) value_bill.cqt_status = 1;
                          promise[array[1].length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, value_bill);                        
                          Promise.all(promise)
                                .then(()=>{  
                                  //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                                  this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch)
                                        .then(()=>{
                                          resolve(undefined);
                                        })                                                                                       
                                })
                                
                      }else if(array[0].bill_type === 29){//sinh ra 2 bill_type 30(chi nhánh A xuất đến chi nhánh B) và 31(chi nhánh B nhận từ chi nhánh A), vẫn giữ bill_code của 29
                        let promise = new Array();             
                        promise[promise.length] = new Promise((resolve, reject)=>{
                            let promise_30 = new Array();                                        
                            promise_30[promise_30.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, {bill_type:30});
          
                            for(let i=0; i<array[1].length; i++){                             
                              promise_30[promise_30.length]  = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id, {bill_type:30});                  
                            }
                            promise_30[promise_30.length]  = this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch);
                                    
                            this.vhQuery.asyncPromiseAll(promise_30)
                                .then(()=>{                        
                                  resolve(null);                            
                                }) 
                        })
                        promise[promise.length] = new Promise((resolve, reject)=>{                   
                            let _bill_31 = {...array[0]}; //kiểm tra và xóa các giá trị ko cần thiết
                            delete _bill_31._id;   
                            delete _bill_31?.id_branch_receive;
                            _bill_31.bill_type = 31;             
                            _bill_31.id_branch = array[0].id_branch_receive;   
                            _bill_31.id_branch_send = array[0].id_branch;      
                            _bill_31.id_employee = this.vhAuth.getUser()._id; 
                            this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(billdate), _bill_31)             
                                .then((response:any)=>{    
                                  let promise_31 = new Array();                     
                                  for(let i=0; i<array[1].length; i++){
                                    let data = {...array[1][i]};
                                    delete data._id;   
                                    data.id_bill = response._id;                        
                                    data.id_branch = array[0].id_branch_receive;                                   
                                    data.bill_type = 31;                          
                                    data.id_employee = _bill_31.id_employee;                                       
                                    //-----------------------------------
                                    promise_31[promise_31.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(billdate), data);                  
                                  }
                                  promise_31[promise_31.length] = this.calculateQuantityProduct_UP(array[1],_bill_31.id_branch);
                                    
                                  this.vhQuery.asyncPromiseAll(promise_31)
                                      .then(()=>{                        
                                        resolve(null);                            
                                      })  
                                },(error:any)=>{
                                  console.log('error', error);
                                })
                        })
          
                        this.vhQuery.asyncPromiseAll(promise)
                            .then(()=>{                              
                              resolve(undefined)
                            })  
                      }else if(array[0].bill_type === 42){
                        let promise = new Array();                              
                        for(let i=0; i<array[1].length; i++){                                  
                          let value_voucher_code = {
                            products: array[1][i].products, 
                            date_sold : array[0].date, 
                            status: 2, 
                            id_customer: array[0].id_customer
                          }                     
                          promise[promise.length] = this.updateVoucherCode(array[1][i].id_voucher_code, value_voucher_code);    
                          let value_bill_detail ={
                            bill_code: bill_code, 
                            bill_type: newbill_type
                          }
                          promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id, value_bill_detail);         
                        }     
                        let value_bill ={
                          bill_code: bill_code, 
                          bill_type: newbill_type, 
                          sync_code: this.sync_code
                        }                       
                        promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, value_bill);                        
                        Promise.all(promise)
                              .then(()=>{  
                                resolve(undefined);                                                                                   
                              })
                      }else if(array[0].bill_type === 43){
                        let promise = new Array();      
                        for(let i=0; i<array[1].length; i++){                                   
                          let value_voucher_code = {                            
                            date_used : array[0].date, 
                            status: 4, 
                            id_customer: array[0].id_customer
                          }
                          promise[promise.length] = this.updateVoucherCode(array[1][i].id_voucher_code, value_voucher_code);                         
                          promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id);         
                        }  
                        
                        let bill_details = this.changeBillDetails_withPromotions_toRaw(array[1]);
                        for(let i=0; i<bill_details.length; i++){       
                          let bill_detail = {...bill_details[i]};                    
                          bill_detail.bill_code = bill_code;
                          bill_detail.bill_type = newbill_type;
                          delete bill_detail._id;
                          promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(billdate), bill_detail);
                        }
                        let value_bill ={
                          bill_code: bill_code, 
                          bill_type: newbill_type, 
                          sync_code: this.sync_code
                        }                       
                        promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, value_bill);                        
                        Promise.all(promise)
                              .then(()=>{  
                                //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                                this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch)
                                .then(()=>{
                                  resolve(undefined);
                                })                                                                                                     
                              })                      
                      }else if(array[0].bill_type === 52){
                        let promise = new Array();      
                        for(let i=0; i<array[1].length; i++){           
                          let _products = array[1][i].products;
                          for(let j=0; j<_products.length; j++){
                            _products[j].outquantity = 0;//giá trị này chỉ đc set khi bán thành công                            
                          }
                          let value_payment_card_code = {                            
                            products: _products, 
                            date_sold : array[0].date, 
                            status: 2, 
                            id_customer: array[0].id_customer
                          }
                          promise[promise.length] = this.updatePaymentCardCode(array[1][i].id_payment_card_code, value_payment_card_code);    
                          let value_bill_detail ={
                            bill_code: bill_code, 
                            bill_type: newbill_type
                          }
                          promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id, value_bill_detail);         
                        }     
                        let value_bill ={
                          bill_code: bill_code, 
                          bill_type: newbill_type, 
                          sync_code: this.sync_code
                        }                       
                        promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, value_bill);                        
                        Promise.all(promise)
                              .then(()=>{  
                                //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                                this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch)
                                      .then(()=>{
                                        resolve(undefined);
                                      })                                                                                       
                              })
                      }else if(array[0].bill_type === 53){
                        let promise = new Array();      
                        for(let i=0; i<array[1].length; i++){                            
                          let value_payment_card_code = {                                     
                            date_used : array[0].date, 
                            status: 4, 
                            id_customer: array[0].id_customer
                          }
                          promise[promise.length] = this.updatePaymentCardCode(array[1][i].id_payment_card_code, value_payment_card_code);    
                          promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id);                                 
                        }     
                        let bill_details = this.changeBillDetails_withPromotions_toRaw(array[1]);
                        for(let i=0; i<bill_details.length; i++){       
                          let bill_detail = {...bill_details[i]};                    
                          bill_detail.bill_code = bill_code;
                          bill_detail.bill_type = newbill_type;
                          delete bill_detail._id;
                          promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(billdate), bill_detail);
                        }

                        let value_bill ={
                          bill_code: bill_code, 
                          bill_type: newbill_type, 
                          sync_code: this.sync_code
                        }                       
                        promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, value_bill);                        
                        Promise.all(promise)
                              .then(()=>{  
                                //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                                this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch)
                                      .then(()=>{
                                        resolve(undefined);
                                      })                                                                                       
                              })
                      }
                  })
        })      
    })  
  } 
  private saveBill_Billdetail_old(id_bill:any):any {    
    //Nghiệp vụ nhà hàng chọn món là dùng hàm createbill_detail tạo bill_detail luôn, nên khi nào tính tiền mới dùng đến hàm này (hàm này ko thể bỏ đc) 
    //Nghiệp vụ bán hàng khác là chọn sản phẩm xong la dùng hàm updateBill_Billdetail để lưu bill_detail đó cùng với bill lại, ko là mất dữ liệu đã chọn đó
    return new Promise((resolve, reject) => {      
        this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();   

        let promise_1 = this.getBill(id_bill);
        let promise_2 = this.getBill_details_byID({id_bill:{$eq:id_bill}});
        Promise.all([promise_1, promise_2])
            .then((array:any)=>{              
              if(array[0].bill_type === 5){                 
                  let promise = new Array();      
                  let billdate = array[0].date;
                  for(let i=0; i<array[1].length; i++){   
                    let data = {...array[1][i]};
                    data.id_bill = array[0]._id;  
                    data.bill_type = 1;
                    //---------------NEW-----------------    
                    if(array[0].id_area) data.id_area = array[0].id_area; 
                    if(array[0].id_table) data.id_table = array[0].id_table;                   
                    if(array[0].date) data.date = array[0].date;
                    if(typeof array[0].tax == 'number') data.tax = array[0].tax;
                    if(typeof array[0].bill_type == 'number') data.bill_type = 1;
                    if(array[0].id_cashier) data.id_cashier = array[0].id_cashier;
                    if(array[0].id_employee) data.id_employee = array[0].id_employee;
                    if(array[0].id_supplier) data.id_supplier = array[0].id_supplier;
                    if(array[0].id_customer) data.id_customer = array[0].id_customer;
                    //-----------------------------------
                    promise[i] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id, data);                   
                  }    
                  
                  promise[array[1].length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, {bill_type:1, uuid:null, sync_code: this.sync_code});   
                  //Promise.all(promise).then(()=>{resolve(null)})         
                  Promise.all(promise)
                        .then(()=>{  
                          let promise_products = new Array();
                          for(let i=0; i<array[1].length; i++){  
                            //Sau khi bán, giảm số lượng kho xuống
                            promise_products[i] = new Promise<any>((resolve)=>{ 
                              if(array[1][i].ptype ===3){            
                                let product = this.getlocalProduct(array[1][i].id_product);         
                                let quantity_branch:any = {};                                        
                                if(product.quantity_branch != undefined){
                                  quantity_branch = product.quantity_branch;                                        
                                  if(product.quantity_branch[array[0].id_branch] != undefined){                                           
                                    quantity_branch[array[0].id_branch] = quantity_branch[array[0].id_branch] - array[1][i].quantity;
                                  }else{                                                                             
                                    quantity_branch[array[0].id_branch]= - array[1][i].quantity;
                                  }                                                 
                                }else{                                          
                                  quantity_branch[array[0].id_branch] = - array[1][i].quantity;                                                                               
                                }   
                                let quantity = product.quantity - array[1][i].quantity;                                                                                                           
                                this.vhMGDB_database.updateDoc('products', product._id,{quantity: quantity, quantity_branch: quantity_branch}).then(()=>{resolve(null)})
                              }else resolve(null);                            
                            })                             
                          }  
                          this.vhQuery.asyncPromiseAll(promise_products)
                              .then(()=>{  
                                resolve(array)
                              })                                                               
                        })           
              }
        })      
    })  
  }

  private saveBill_Billdetail1(id_bill:any):any {    
    //Nghiệp vụ nhà hàng chọn món là dùng hàm createbill_detail tạo bill_detail luôn, nên khi nào tính tiền mới dùng đến hàm này (hàm này ko thể bỏ đc) 
    //Nghiệp vụ bán hàng khác là chọn sản phẩm xong la dùng hàm updateBill_Billdetail để lưu bill_detail đó cùng với bill lại, ko là mất dữ liệu đã chọn đó
    return new Promise((resolve, reject) => {      
        this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();   

        let promise_1 = this.getBill(id_bill);
        let promise_2 = this.getBill_details_byID({id_bill:{$eq:id_bill}});
        Promise.all([promise_1, promise_2])
            .then((array:any)=>{              
              if(array[0].bill_type === 5){                 
                  let promise = new Array();   
                  let billdate = array[0].date;   
                  for(let i=0; i<array[1].length; i++){   
                    let data = {...array[1][i]};
                    data.id_bill = array[0]._id;  
                    data.bill_type = 1;
                    //---------------NEW-----------------    
                    if(array[0].id_area) data.id_area = array[0].id_area; 
                    if(array[0].id_table) data.id_table = array[0].id_table;                   
                    if(array[0].date) data.date = array[0].date;
                    if(typeof array[0].tax == 'number') data.tax = array[0].tax;
                    if(typeof array[0].bill_type == 'number') data.bill_type = 1;
                    if(array[0].id_cashier) data.id_cashier = array[0].id_cashier;
                    if(array[0].id_employee) data.id_employee = array[0].id_employee;
                    if(array[0].id_supplier) data.id_supplier = array[0].id_supplier;
                    if(array[0].id_customer) data.id_customer = array[0].id_customer;
                    //-----------------------------------
                    promise[i] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id, data);                   
                  }    
                  
                  promise[array[1].length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, {bill_type:1, uuid:null, sync_code: this.sync_code});   
                  //Promise.all(promise).then(()=>{resolve(null)})         
                  Promise.all(promise)
                        .then(()=>{  
                          let promise_products = new Array();
                          for(let i=0; i<array[1].length; i++){  
                            //Sau khi bán, giảm số lượng kho xuống
                            promise_products[i] = new Promise<any>((resolve)=>{ 
                              if(array[1][i].ptype ===3){            
                                let product = this.getlocalProduct(array[1][i].id_product);         
                                let quantity_branch:any = {};                                        
                                if(product.quantity_branch != undefined){
                                  quantity_branch = product.quantity_branch;                                        
                                  if(product.quantity_branch[array[0].id_branch] != undefined){                                           
                                    quantity_branch[array[0].id_branch] = quantity_branch[array[0].id_branch] - array[1][i].quantity;
                                  }else{                                                                             
                                    quantity_branch[array[0].id_branch]= - array[1][i].quantity;
                                  }                                                 
                                }else{                                          
                                  quantity_branch[array[0].id_branch] = - array[1][i].quantity;                                                                               
                                }   
                                let quantity = product.quantity - array[1][i].quantity;                                                                                                           
                                this.vhMGDB_database.updateDoc('products', product._id,{quantity: quantity, quantity_branch: quantity_branch}).then(()=>{resolve(null)})
                              }else resolve(null);                            
                            })                             
                          }  
                          this.vhQuery.asyncPromiseAll(promise_products)
                              .then(()=>{  
                                resolve(array)
                              })                                                               
                        })           
              }
        })      
    })  
  }  

  /**
   * hàm này chỉ dùng cho trường hợp bill đã lưu rồi mà muốn sửa
   * @example
    this.vhQueryCafe.updateBill_Billdetail('SzyEYNN39Mq90NkzUFpz',{},[{},{},...])
        .then(()=>{
          console.log("success");
        })
   * @param id_bill 
   * @param bill 
   * @param bill_details 
   * @returns 
   */
  public updateBill_Billdetail(id_bill:any, bill:any, bill_details:any):any {         
    console.log('c_updateBill_Billdetail', id_bill, bill) 
    return new Promise((resolve, reject) => { 
      if((bill.bill_type != 40)&&(bill.bill_type != 42)&&(bill.bill_type != 43)&&(bill.bill_type != 50)&&(bill.bill_type != 52)&&(bill.bill_type != 53)){
        bill_details = this.changeBillDetails_withPromotions_toRaw(bill_details);      
        if(!bill_details) return <any>null;              
      }   
          this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
          bill.sync_code = this.sync_code;
          let bill_code:any = this.vhAlgorithm.createBillCode(bill.date); 
          let delete_Bill_Billdetail = new Promise<any>((resolve)=>{
            let promise_0 = this.getBill(id_bill);
            let promise_1 = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + this.getYear(bill.date), {id_bill:{$eq:id_bill}},{},{},0);
            let promise_2 =  this.createBillCode(bill.date, bill.bill_type);
            Promise.all([promise_0, promise_1, promise_2])
                .then((array:any)=>{      
                //  console.log('---array[1]', array[1])
                  //Cập nhật trường done cho điều phối món
                 /* for(let i=0; i<array[1].length; i++){
                    if(array[1][i].dispatcher_done !== undefined){
                      for(let j=0; j<bill_details.length; j++){
                        if(array[1][i]._id == bill_details[j]._id) {
                          bill_details[j].dispatcher_done = array[1][i].dispatcher_done;
                //          console.log('--- bill_details[j]',  bill_details[j])
                        }
                      }
                    } 
                  }*/
                  //console.log('------array', array);
                  if(array[0].bill_type === bill.bill_type) bill_code = array[0].bill_code;           
                  else bill_code = array[2];             
                  //Xóa các bill_type này làm tăng quantity nguyên liệu trong products  
                  if ((array[0].bill_type === 1)||(array[0].bill_type === 3)||(array[0].bill_type === 10)||(array[0].bill_type === 38)){
                    let promise = new Array();        
                    for(let i=0; i<array[1].length; i++){
                      promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), array[1][i]._id); 
                    }   
                    promise[promise.length] = this.calculateQuantityProduct_UP(array[1],array[0].id_branch);                                    
                    this.vhQuery.asyncPromiseAll(promise)
                        .then(()=>{          
                          resolve(array);                     
                        })       

                  //Xóa bill_type này làm giảm quantity nguyên liệu trong products        
                  }else if((array[0].bill_type === 2)||(array[0].bill_type === 16)||(array[0].bill_type === 39)){
                    let promise = new Array();        
                    for(let i=0; i<array[1].length; i++){
                      promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), array[1][i]._id); 
                    }
                    promise[promise.length] = this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch);                                    
                    this.vhQuery.asyncPromiseAll(promise)
                        .then(()=>{          
                          resolve(array);                     
                        })           
                  //Xóa bill_type này làm giảm quantity nguyên liệu trong products        
                  }else if(array[0].bill_type === 9){
                    let promise = new Array();        
                    for(let i=0; i<array[1].length; i++){
                      promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), array[1][i]._id); 
                    }
                    promise[promise.length] = this.calculateQuantityProduct_DOWN_9(array[1],array[0].id_branch);                                    
                    this.vhQuery.asyncPromiseAll(promise)
                        .then(()=>{          
                          resolve(array);                     
                        })             
                  //Xóa các bill_type lưu tạm này ko làm thay đổi quantity nguyên liệu trong products                            
                  }else if((array[0].bill_type === 5)||(array[0].bill_type === 6)||(array[0].bill_type === 13)||(array[0].bill_type === 14)||(array[0].bill_type === 15)||(array[0].bill_type === 17)
                          ||(array[0].bill_type === 20)||(array[0].bill_type === 29)||(array[0].bill_type === 36)){
                    let promise = new Array();        
                    for(let i=0; i<array[1].length; i++){
                      promise[i] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), array[1][i]._id); 
                    }                       
                    Promise.all(promise)
                        .then(()=>{  
                          resolve(array);                         
                        })                   
                  }else if((array[0].bill_type === 40)||(array[0].bill_type === 42)||(array[0].bill_type === 43)
                          ||(array[0].bill_type === 50)||(array[0].bill_type === 52)||(array[0].bill_type === 53)){
                    let promise = new Array();        
                    for(let i=0; i<array[1].length; i++){
                      promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), array[1][i]._id); 
                    }               
                    this.vhQuery.asyncPromiseAll(promise)
                        .then(()=>{  
                          resolve(array);                         
                        }) 
                  }else if(bill.bill_type === 41){              
                    console.log('Nói anh Huy viết hàm trường hợp bill_type 41');
                  }else if(bill.bill_type === 51){              
                    console.log('Nói anh Huy viết hàm trường hợp bill_type 51');
                  }else{
                    reject('Lưu không thành công, vui lòng kiểm tra lại.')
                  }               
                })
          });   
          
          
          //this.ordinaryQuery.async_waiting_newPromiseAll(delete_Bill_Billdetail).then((array:any)=>{
          delete_Bill_Billdetail.then((array:any)=>{           
            //Tạo các bill_type này làm giảm quantity nguyên liệu trong products  
            if((bill.bill_type === 1)||(bill.bill_type === 3)||(bill.bill_type === 10)||(array[0].bill_type === 38)){              
                let promise = new Array();                                                    
                let _bill = {...bill}; 
                _bill.bill_code = bill_code;                                             
                //test xong xóa hàm này 
                //_bill.date = array[0].date;   
                if(bill.bill_type == 1) bill.cqt_status = 1;                      
                promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, _bill);

                for(let i=0; i<bill_details.length; i++){
                  let data = {...bill_details[i]};
                  data.id_bill = id_bill;
                  //---------------NEW-----------------
                  data.bill_code = bill_code;   
                  //if(array[0].date) data.date = array[0].date;
                  if(bill.date) data.date = bill.date;
                  if(bill.id_area) data.id_area = bill.id_area;
                  if(bill.id_table) data.id_table = bill.id_table;

                  if(typeof bill.tax == 'number') data.tax = bill.tax;
                  if(typeof bill.bill_type == 'number') data.bill_type = bill.bill_type;
                  if(bill.id_cashier) data.id_cashier = bill.id_cashier;
                  if(bill.id_employee) data.id_employee = bill.id_employee;
                  if(bill.id_supplier) data.id_supplier = bill.id_supplier;
                  if(bill.id_customer) data.id_customer = bill.id_customer;
                  if(bill.id_inventorytime) data.id_inventorytime = bill.id_inventorytime;
                  if(bill.id_branch) data.id_branch = bill.id_branch;                  
                  //-----------------------------------
                  promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);                  
                }
                promise[promise.length] = this.calculateQuantityProduct_DOWN(bill_details,bill.id_branch);
                this.vhQuery.asyncPromiseAll(promise)
                    .then(()=>{          
                      resolve(id_bill);                                          
                    })   
            //Tạo các bill_type này làm tăng quantity nguyên liệu trong products           
            }else if((bill.bill_type === 2)||(bill.bill_type === 16)||(array[0].bill_type === 39)){
                let promise = new Array();                                                    
                let _bill = {...bill}; 
                _bill.bill_code = bill_code;                                            
                //test xong xóa hàm này 
                _bill.date = array[0].date;                         
                promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, _bill);

                for(let i=0; i<bill_details.length; i++){
                  let data = {...bill_details[i]};
                  data.id_bill = id_bill;
                  //---------------NEW-----------------
                  data.bill_code = bill_code;  
                  if(array[0].date) data.date = array[0].date;
                  if(bill.id_area) data.id_area = bill.id_area;
                  if(bill.id_table) data.id_table = bill.id_table;

                  if(typeof bill.tax == 'number') data.tax = bill.tax;
                  if(typeof bill.bill_type == 'number') data.bill_type = bill.bill_type;
                  if(bill.id_cashier) data.id_cashier = bill.id_cashier;
                  if(bill.id_employee) data.id_employee = bill.id_employee;
                  if(bill.id_supplier) data.id_supplier = bill.id_supplier;
                  if(bill.id_customer) data.id_customer = bill.id_customer;
                  if(bill.id_inventorytime) data.id_inventorytime = bill.id_inventorytime;
                  if(bill.id_branch) data.id_branch = bill.id_branch;                 
                  //-----------------------------------
                  promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);                  
                }

                promise[promise.length] = this.calculateQuantityProduct_UP(bill_details,bill.id_branch);        
                this.vhQuery.asyncPromiseAll(promise)
                    .then(()=>{          
                      this.calculateUpdateImportPrice(bill_details, bill.id_branch)
                            .then(()=>{
                              resolve(id_bill);
                            })                 
                    })           
            //Tạo các bill_type này làm tăng quantity nguyên liệu trong products           
            }else if(bill.bill_type === 9){
              let promise = new Array();                                                    
              let _bill = {...bill}; 
              _bill.bill_code = bill_code;                                    
              //test xong xóa hàm này 
              _bill.date = array[0].date;                         
              promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, _bill);

              for(let i=0; i<bill_details.length; i++){
                let data = {...bill_details[i]};
                data.id_bill = id_bill;
                //---------------NEW-----------------
                data.bill_code = bill_code;  
                if(array[0].date) data.date = array[0].date;
                if(bill.id_area) data.id_area = bill.id_area;
                if(bill.id_table) data.id_table = bill.id_table;

                if(typeof bill.tax == 'number') data.tax = bill.tax;
                if(typeof bill.bill_type == 'number') data.bill_type = bill.bill_type;
                if(bill.id_cashier) data.id_cashier = bill.id_cashier;
                if(bill.id_employee) data.id_employee = bill.id_employee;
                if(bill.id_supplier) data.id_supplier = bill.id_supplier;
                if(bill.id_customer) data.id_customer = bill.id_customer;
                if(bill.id_inventorytime) data.id_inventorytime = bill.id_inventorytime;
                if(bill.id_branch) data.id_branch = bill.id_branch;                 
                //-----------------------------------
                promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);                  
              }

              promise[promise.length] = this.calculateQuantityProduct_UP_9(bill_details,bill.id_branch);
              this.vhQuery.asyncPromiseAll(promise)
                  .then(()=>{          
                    resolve(id_bill);                                      
                  })         
             //Tạo các bill_type này ko làm thay đổi quantity nguyên liệu trong products          
            }else if((bill.bill_type === 5)||(bill.bill_type === 6)||(bill.bill_type === 13)||(bill.bill_type === 14)||(bill.bill_type === 15)||(bill.bill_type === 17)||(bill.bill_type === 20)||(bill.bill_type === 29)||(bill.bill_type === 36)
                  ||(bill.bill_type === 40)||(bill.bill_type === 42)||(bill.bill_type === 43)||(bill.bill_type === 50)||(bill.bill_type === 52)||(bill.bill_type === 53)){
                let promise = new Array();                                                    
                let _bill = {...bill}; 
                _bill.bill_code = bill_code;                                      
                //test xong xóa hàm này 
                _bill.date = array[0].date;                         
                promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, _bill);

                for(let i=0; i<bill_details.length; i++){
                  let data = {...bill_details[i]};
                  data.id_bill = id_bill;
                  //---------------NEW-----------------
                  data.bill_code = bill_code;  
                  if(array[0].date) data.date = array[0].date;
                  if(bill.id_area) data.id_area = bill.id_area;
                  if(bill.id_table) data.id_table = bill.id_table;

                  if(typeof bill.tax == 'number') data.tax = bill.tax;
                  if(typeof bill.bill_type == 'number') data.bill_type = bill.bill_type;
                  if(bill.id_cashier) data.id_cashier = bill.id_cashier;
                  if(bill.id_employee) data.id_employee = bill.id_employee;
                  if(bill.id_supplier) data.id_supplier = bill.id_supplier;
                  if(bill.id_customer) data.id_customer = bill.id_customer;
                  if(bill.id_inventorytime) data.id_inventorytime = bill.id_inventorytime;
                  if(bill.id_branch) data.id_branch = bill.id_branch;                 
                  //-----------------------------------
                  promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);                  
                } 

                Promise.all(promise)
                    .then(()=>{  
                      resolve(id_bill);                
                    })  
            }else if(bill.bill_type === 3031){//sinh ra 2 bill_type 30(chi nhánh A xuất đến chi nhánh B) và 31(chi nhánh B nhận từ chi nhánh A)
              let promise = new Array();             
              promise[promise.length] = new Promise((resolve, reject)=>{
                  let promise_30 = new Array();       
                  //lấy giá trị lúc tạo bill_type = 29                                             
                  let _bill_30 = {...array[0]};            
                  delete _bill_30._id;   
                  _bill_30.bill_type = 30;                
                                      
                  promise_30[promise_30.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, {bill_type:30});

                  for(let i=0; i<array[1].length; i++){
                    let data = {...array[1][i]};
                    delete data._id;                  
                    data.bill_type = 30;               
                    promise_30[promise_30.length]  = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);                  
                  }
                  promise_30[promise_30.length]  = this.calculateQuantityProduct_DOWN(array[1],_bill_30.id_branch);
                          
                  this.vhQuery.asyncPromiseAll(promise_30)
                      .then(()=>{                        
                        resolve(null);                            
                      }) 
              })
              promise[promise.length] = new Promise((resolve, reject)=>{                   
                  let _bill_31 = {...array[0]}; //kiểm tra và xóa các giá trị ko cần thiết
                  delete _bill_31._id;   
                  delete _bill_31?.id_branch_receive;
                  _bill_31.bill_type = 31;             
                  _bill_31.id_branch = array[0].id_branch_receive;   
                  _bill_31.id_branch_send = array[0].id_branch;      
                  _bill_31.id_employee = this.vhAuth.getUser()._id; 
                  this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(_bill_31.date), _bill_31)             
                      .then((response:any)=>{    
                        let promise_31 = new Array();                     
                        for(let i=0; i<array[1].length; i++){
                          let data = {...array[1][i]};
                          delete data._id;   
                          data.id_bill = response._id;                        
                          data.id_branch = array[0].id_branch_receive;                                   
                          data.bill_type = 31;                          
                          data.id_employee = _bill_31.id_employee;                                       
                          //-----------------------------------
                          promise_31[promise_31.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);                  
                        }
                        promise_31[promise_31.length] = this.calculateQuantityProduct_UP(array[1],_bill_31.id_branch);
                          
                        this.vhQuery.asyncPromiseAll(promise_31)
                            .then(()=>{                        
                              resolve(null);                            
                            })  
                      },(error:any)=>{
                        console.log('error', error);
                      })
              })

              this.vhQuery.asyncPromiseAll(promise)
                  .then(()=>{                              
                    resolve(id_bill)
                  })      
            }else if(bill.bill_type === 41){              
              console.log('Nói anh Huy viết hàm trường hợp bill_type 41');
            }else if(bill.bill_type === 51){              
              console.log('Nói anh Huy viết hàm trường hợp bill_type 51');
            }    
                     
          })              
      
    })         
  }



  /**
   * VhQueryCafe
   * Lưu ý: xóa tất cả các bill_type(từ 1 đến 28) đều dùng hàm này
   * @example
   this.vhQueryCafe.deleteBill_Billdetail('RcECbNgU9BdYQo37s30p')
        .then(()=>{
          console.log('success');
        },(error:any)=>{
          console.log('error ', error);
        })   
   * @param id_bill 
   * @return Promise => true or orror
   */
  public deleteBill_Billdetail(id_bill:any):any { 
    return new Promise((resolve, reject) => {    
        let promise_0 = this.getBill(id_bill);        
        let promise_1 = this.getBill_details_byID({id_bill:{$eq:id_bill}});  
        let promise_2 = this.vhMGDB_database.getDocsByFields('coupon_codes', {id_bill:{$eq:id_bill}},{},{},0); 
        let promise_3 = this.vhMGDB_database.getDocsByFields('voucher_codes', {id_bill:{$eq:id_bill}},{},{},0);  //không dùng sẽ bỏ đi
        let promise_4 = this.vhMGDB_database.getDocsByFields('payment_card_codes', {id_bill:{$eq:id_bill}},{},{},0); //không dùng sẽ bỏ đi        
        this.vhQuery.asyncPromiseAll([promise_0, promise_1, promise_2, promise_3, promise_4])
            .then((array:any)=>{ 
              let promise = new Array();    
              let bill = {...array[0]};
              let bill_details = [...array[1]];
              let display_bill_details = this.changeBillDetails_withRaw_toPromotions(array[1]);                  
              if(bill){                   
                //xóa bill_type(bán hàng, nguyên liệu, dịch vụ) này làm tăng quantity trong products, và vẫn giữ bill lại nhưng chuyển trang thái 4 
                if(bill.bill_type === 1){                 
                    for(let i=0; i<bill_details.length; i++){
                      promise[i] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                    }
                    promise[bill_details.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);

                    for(let i=0; i<array[2].length; i++){
                      this.vhMGDB_database.updateDoc('coupon_codes', array[2][i]._id, {id_bill:null, date_used: null, status:3}); 
                    }
                    Promise.all(promise)
                          .then(()=>{
                            //Sau khi xóa, tăng số lượng nguyên liệu kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                            this.calculateQuantityProduct_UP(bill_details,bill.id_branch)
                                .then(()=>{
                                  resolve(true);
                                })  
                          }) 
                //xóa bill_type(nhập nguyên liệu) này làm giảm quantity trong products, và vẫn giữ bill lại nhưng chuyển trang thái 22     
                }else if(bill.bill_type === 2){                    
                  for(let i=0; i<bill_details.length; i++){
                    promise[i] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }
                  promise[bill_details.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);   
                  Promise.all(promise)
                          .then(()=>{
                            //Sau khi xóa, giảm số lượng nguyên liệu kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                            this.calculateQuantityProduct_DOWN(bill_details,bill.id_branch)
                                .then(()=>{
                                  resolve(true);
                                }) 
                          }) 
                //xóa bill_type(xuất nguyên liệu cho bếp) này làm tăng quantity trong products, và vẫn giữ bill lại nhưng chuyển trang thái 23     
                }else if(bill.bill_type === 3){                   
                  for(let i=0; i<bill_details.length; i++){
                    promise[i] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }
                  promise[bill_details.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);       
                  Promise.all(promise)
                          .then(()=>{
                            //Sau khi xóa, tăng số lượng nguyên liệu kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                            this.calculateQuantityProduct_UP(bill_details,bill.id_branch)
                                .then(()=>{
                                  resolve(true);
                                })  
                          })       
                //Xóa bill_type(tồn đầu kỳ) này làm giảm quantity trong products, và bill bị xóa luôn    
                }else if(bill.bill_type === 9){                         
                    for(let i=0; i<bill_details.length; i++){
                      promise[i] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                    }                                               
                    promise[bill_details.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);   
                    Promise.all(promise)
                          .then(()=>{
                            //Sau khi xóa, giảm số lượng kho xuống 
                            this.calculateQuantityProduct_DOWN_9(bill_details,bill.id_branch)
                                .then(()=>{
                                  resolve(true);
                                })  
                          })                      
                 //xóa bill_type(trả nguyên liệu NCC) này làm tăng quantity trong products, và vẫn giữ bill lại nhưng chuyển trang thái 24    
                }else if(bill.bill_type === 10){                    
                  for(let i=0; i<bill_details.length; i++){
                    promise[i] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }
                  promise[bill_details.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);   
                  Promise.all(promise)
                        .then(()=>{
                          //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                          this.calculateQuantityProduct_UP(bill_details,bill.id_branch)
                              .then(()=>{
                                resolve(true);
                              })  
                        }) 
                 //xóa bill_type(bếp trả nguyên liệu lại cho kho) này làm giảm quantity trong products, và vẫn giữ bill lại nhưng chuyển trang thái 21      
                }else if(bill.bill_type === 16){                                  
                  for(let i=0; i<bill_details.length; i++){
                    promise[i] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }
                  promise[bill_details.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);   
                  Promise.all(promise)
                          .then(()=>{
                            //Sau khi xóa, giảm số lượng nguyên liệu kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                            this.calculateQuantityProduct_DOWN(bill_details,bill.id_branch)
                                .then(()=>{
                                  resolve(true);
                                }) 
                          }) 
                //xóa những bill_type này ko làm thay đổi quantity trong products, và bill bị xóa luôn         
                }else if ((bill.bill_type === 5)||(bill.bill_type === 6)||(bill.bill_type === 13)
                        ||(bill.bill_type === 14)||(bill.bill_type === 15)||(bill.bill_type === 17)||(bill.bill_type === 18)||(bill.bill_type === 20)||(bill.bill_type === 29)){                        
                  for(let i=0; i<bill_details.length; i++){
                    promise[i] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }                                               
                  promise[bill_details.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);                      
                  Promise.all(promise)
                  .then(()=>{
                    resolve(true);
                  })  
                //xóa bill_type này, vẫn giữ bill lại nhưng chuyển trang thái khác    
                }else if((bill.bill_type === 7)||(bill.bill_type === 8)||(bill.bill_type === 11)||(bill.bill_type === 12)){               
                  return reject({message: 'Loại bill_type ' + bill.bill_type + 'này không phát sinh bill_detail dùng hàm deleteBill xóa'});            
                //xóa bill_type(xuất hóa đơn hủy hàng hóa) này làm tăng quantity trong products  
                }else if(bill.bill_type === 38){              
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);
                  Promise.all(promise)
                        .then(()=>{
                          //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                          this.calculateQuantityProduct_UP(bill_details,bill.id_branch)
                              .then(()=>{
                                resolve(true);
                              })  
                        })     
                }else if (bill.bill_type === 40){//phiếu bán voucher   
                  //Kiểm tra xem có voucher nào được sử dụng đổi hàng hàng chưa, nếu sử dụng rồi thì không xóa được                         
                  let promise_bill_details = new Array();
                  for(let i=0; i<bill_details.length; i++){                              
                    promise_bill_details[i] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + this.getYear(bill.date), {id_voucher_code: {$eq:bill_details[i].id_voucher_code}, bill_type: {$eq:41}})           
                  }
                  this.vhQuery.asyncPromiseAll(promise_bill_details)
                      .then((array:any)=>{  
                        array = array.filter((e:any)=>e.length >0);                                          
                        if(array.length >0){      
                          console.log({error:'Voucher đã được sử dụng đổi hàng hóa nên không xóa được'});  
                          return resolve(false);
                        }else{                              
                          for(let i=0; i<bill_details.length; i++){
                            promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                          }                                               
                          promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                          this.vhQuery.asyncPromiseAll(promise)
                              .then(()=>{   
                                let promise_updatevouchers = new Array();
                                for(let i=0; i<bill_details.length; i++){                 
                                  promise_updatevouchers[i] = this.vhMGDB_database.updateDoc('voucher_codes', bill_details[i].id_voucher_code, {date_sold:null, status:1, id_customer: null})           
                                }
                                this.vhQuery.asyncPromiseAll(promise_updatevouchers)
                                    .then(()=>{  
                                      return resolve(true)
                                    })    
                              }) 
                        }
                      })              
                  }else if (bill.bill_type === 41){//phiếu đổi voucher
                    for(let i=0; i<bill_details.length; i++){
                      promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                    }                                               
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);     
                    Promise.all(promise)
                          .then(()=>{
                            let promise_one = new Array();
                            //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                            promise_one[promise_one.length] = this.calculateQuantityProduct_UP(bill_details,bill.id_branch);
                                                    
                            //trả voucher về trạng thái đã bán 2 hoặc đã đổi từ điểm 3    
                            promise_one[promise_one.length] = new Promise((resolve, reject)=>{
                              this.vhMGDB_database.getDoc('voucher_codes', bill_details[0].id_voucher_code)
                                  .then((voucher_code:any)=>{
                                    if(voucher_code){
                                      let value:any = {
                                        date_used: null
                                      }
                                      if(voucher_code.date_sold) value.status= 2;                                                                    
                                      else value.status= 3; 
                                      this.vhMGDB_database.updateDoc('voucher_codes', bill_details[0].id_voucher_code, value)
                                          .then(()=>{
                                            resolve(null)
                                          })
                                    }
                                  })
                            })                        
                            this.vhQuery.asyncPromiseAll(promise_one)
                                .then(()=>{
                                  resolve(true)}) 
                                }) 
                  }else if (bill.bill_type === 42){//phiếu đặt mua voucher   
                    //Kiểm tra xem có voucher nào đã được mua, hoặc được sử dụng đổi hàng hàng chưa, nếu rồi thì không xóa được                         
                    let promise_bill_details = new Array();
                    for(let i=0; i<bill_details.length; i++){                              
                      promise_bill_details[i] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + this.getYear(bill.date), {id_voucher_code: {$eq:bill_details[i].id_voucher_code}, bill_type: {$eq:[40,41]}})           
                    }
                    this.vhQuery.asyncPromiseAll(promise_bill_details)
                        .then((array:any)=>{  
                          array = array.filter((e:any)=>e.length >0);                                                   
                          if(array.length >0){      
                            console.log({error:'Voucher đã được sử dụng đổi hàng hóa nên không xóa được'});  
                            return resolve(false);
                          }else{                              
                            for(let i=0; i<bill_details.length; i++){
                              promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                            }                                               
                            promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                            this.vhQuery.asyncPromiseAll(promise)
                                .then(()=>{   
                                  let promise_updatevouchers = new Array();
                                  for(let i=0; i<bill_details.length; i++){                
                                    promise_updatevouchers[i] = this.vhMGDB_database.deleteDoc('voucher_codes', bill_details[i].id_voucher_code)           
                                  }
                                  this.vhQuery.asyncPromiseAll(promise_updatevouchers)
                                      .then(()=>{  
                                        return resolve(true)
                                      })    
                                }) 
                          }
                        })              
                  }else if (bill.bill_type === 43){//phiếu đặt đổi voucher lấy hàng hóa
                    for(let i=0; i<bill_details.length; i++){
                      promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                    }                                               
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);     
                    Promise.all(promise)
                          .then(()=>{
                            let promise_one = new Array();
                            //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                            //promise_one[promise_one.length] = this.calculateQuantityProduct_UP(bill_details,bill.id_branch);
                                                    
                            //trả voucher về trạng thái đã bán 2 hoặc đã đổi từ điểm 3    
                            promise_one[promise_one.length] = new Promise((resolve, reject)=>{
                              this.vhMGDB_database.getDoc('voucher_codes', bill_details[0].id_voucher_code)
                                  .then((voucher_code:any)=>{
                                    if(voucher_code){
                                      let value:any = {
                                        date_used: null
                                      }
                                      if(voucher_code.date_sold) value.status= 2;                                                                    
                                      else value.status= 3; 
                                      this.vhMGDB_database.updateDoc('voucher_codes', bill_details[0].id_voucher_code, value)
                                          .then(()=>{
                                            resolve(null)
                                          })
                                    }
                                  })
                            })                        
                            this.vhQuery.asyncPromiseAll(promise_one)
                                .then(()=>{
                                  resolve(true)}) 
                                }) 
                  }else if (bill.bill_type === 50){//phiếu bán payment_card
                    //Kiểm tra xem có payment_card nào được sử dụng đổi hàng hàng chưa, nếu sử dụng rồi thì không xóa được    
                    let promise_bill_details = new Array();
                    for(let i=0; i<bill_details.length; i++){                 
                      promise_bill_details[i] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + this.getYear(bill.date), {id_payment_card_code: {$eq:bill_details[i].id_payment_card_code}, bill_type: {$eq:51}});       
                    }
                    this.vhQuery.asyncPromiseAll(promise_bill_details)
                        .then((array:any)=>{                            
                          array = array.filter((e:any)=>e.length >0);
                          if(array.length >0){                                  
                            console.log({error:'payment_card đã được sử dụng đổi hàng hóa nên không xóa được'})                  
                            return resolve(false);
                          }else{
                            for(let i=0; i<bill_details.length; i++){
                              promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                            }                                               
                            promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                            this.vhQuery.asyncPromiseAll(promise)
                                .then(()=>{   
                                  let promise_updatepaymentcards = new Array();
                                  for(let i=0; i<bill_details.length; i++){                 
                                    promise_updatepaymentcards[i] = this.vhMGDB_database.updateDoc('payment_card_codes', bill_details[i].id_payment_card_code, {date_sold:null, status:1, id_customer: null})           
                                  }
                                  this.vhQuery.asyncPromiseAll(promise_updatepaymentcards)
                                      .then(()=>{  
                                        return resolve(true)
                                      })    
                                }) 
                          }
                        })   
                    
                  }else if (bill.bill_type === 51){//phiếu đổi payment_card
                    for(let i=0; i<bill_details.length; i++){
                      promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                    }                                               
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                    Promise.all(promise)
                          .then(()=>{
                            let promise_one = new Array();                      
                            for(let i=0; i<display_bill_details.length; i++){
                              promise_one[promise_one.length] = new Promise((resolve, reject)=>{
                                this.getPaymentCardCode(display_bill_details[i].id_payment_card_code)
                                    .then((payment_card_code:any)=>{                                 
                                      for(let j=0; j<display_bill_details[i].products.length; j++){
                                        for(let k=0; k<payment_card_code.products.length; k++){
                                          if(payment_card_code.products[k].id_product === display_bill_details[i].products[j].id_product){
                                            if(payment_card_code.products[k].id_subproduct){
                                              if(payment_card_code.products[k].id_subproduct === display_bill_details[i].products[j].id_subproduct){                                        
                                                payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity - display_bill_details[i].products[j].quantity;   
                                              }
                                            }else{                                      
                                              payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity - display_bill_details[i].products[j].quantity;   
                                            }                                                                     
                                          }
                                        }                                 
                                      }

                                      let value:any = {
                                        products: payment_card_code.products                            
                                      }                        
                                      
                                      let check_firstbill = true;
                                      for(let j=0; j<payment_card_code.products.length; j++){
                                        if(payment_card_code.products[j].outquantity > 0) check_firstbill = false;
                                      }
                                      
                                      if(check_firstbill){
                                        value.date_used = null;
                                        if(payment_card_code.date_sold) value.status= 2;                                                                    
                                        else value.status= 3; 
                                      }
                                      this.updatePaymentCardCode(payment_card_code._id, {value})                              
                                          .then(()=>{                                    
                                            resolve(null)
                                          }) 
                                    })
                              })                          
                            }       
                            //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                            promise_one[promise_one.length] = this.calculateQuantityProduct_UP(bill_details,bill.id_branch);               
                            Promise.all(promise_one)
                                  .then(()=>{
                                    resolve(true);
                                  }) 
                          })
                  }else if (bill.bill_type === 52){//phiếu đặt mua payment_card
                    //Kiểm tra xem có payment_card nào đã được mua, hoặc  được sử dụng đổi hàng hàng chưa, nếu rồi thì không xóa được    
                    let promise_bill_details = new Array();
                    for(let i=0; i<bill_details.length; i++){                 
                      promise_bill_details[i] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + this.getYear(bill.date), {id_payment_card_code: {$eq:bill_details[i].id_payment_card_code}, bill_type: {$eq:[50,51]}});       
                    }
                    this.vhQuery.asyncPromiseAll(promise_bill_details)
                        .then((array:any)=>{                          
                          array = array.filter((e:any)=>e.length >0);
                          if(array.length >0){                                  
                            console.log({error:'payment_card đã được sử dụng đổi hàng hóa nên không xóa được'})                  
                            return resolve(false);
                          }else{
                            for(let i=0; i<bill_details.length; i++){
                              promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                            }                                               
                            promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                            this.vhQuery.asyncPromiseAll(promise)
                                .then(()=>{   
                                  let promise_updatepaymentcards = new Array();
                                  for(let i=0; i<bill_details.length; i++){                 
                                    promise_updatepaymentcards[i] = this.vhMGDB_database.deleteDoc('payment_card_codes', bill_details[i].id_payment_card_code)           
                                  }
                                  this.vhQuery.asyncPromiseAll(promise_updatepaymentcards)
                                      .then(()=>{  
                                        return resolve(true)
                                      })    
                                }) 
                          }
                        })   
                  }else if (bill.bill_type === 53){//phiếu đặt đổi payment_card lấy hàng hóa
                    for(let i=0; i<bill_details.length; i++){
                      promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                    }                                               
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                    Promise.all(promise)
                          .then(()=>{
                            let promise_one = new Array();                      
                            for(let i=0; i<display_bill_details.length; i++){
                              promise_one[promise_one.length] = new Promise((resolve, reject)=>{
                                this.getPaymentCardCode(display_bill_details[i].id_payment_card_code)
                                    .then((payment_card_code:any)=>{                                 
                                      for(let j=0; j<display_bill_details[i].products.length; j++){
                                        for(let k=0; k<payment_card_code.products.length; k++){
                                          if(payment_card_code.products[k].id_product === display_bill_details[i].products[j].id_product){
                                            if(payment_card_code.products[k].id_subproduct){
                                              if(payment_card_code.products[k].id_subproduct === display_bill_details[i].products[j].id_subproduct){                                        
                                                payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity - display_bill_details[i].products[j].quantity;   
                                              }
                                            }else{                                      
                                              payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity - display_bill_details[i].products[j].quantity;   
                                            }                                                                     
                                          }
                                        }                                 
                                      }

                                      let value:any = {
                                        products: payment_card_code.products                            
                                      }                        
                                      
                                      let check_firstbill = true;
                                      for(let j=0; j<payment_card_code.products.length; j++){
                                        if(payment_card_code.products[j].outquantity > 0) check_firstbill = false;
                                      }
                                      
                                      if(check_firstbill){
                                        value.date_used = null;
                                        if(payment_card_code.date_sold) value.status= 2;                                                                    
                                        else value.status= 3; 
                                      }
                                      this.updatePaymentCardCode(payment_card_code._id, {value})                              
                                          .then(()=>{                                    
                                            resolve(null)
                                          }) 
                                    })
                              })                          
                            }       
                            //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                            //promise_one[promise_one.length] = this.calculateQuantityProduct_UP(bill_details,bill.id_branch);               
                            Promise.all(promise_one)
                                  .then(()=>{
                                    resolve(true);
                                  }) 
                          })
                  }else{
                    return reject({message: 'Loại bill_type ' + bill.bill_type + ' này không thể xóa hoặc liên hệ anh Huy sửa hàm'});
                  }
              }else return reject({message: 'id_bill ' + id_bill + ' không tồn tại'});              

            },(error:any)=>{
              console.log('error', error);
              reject(error);
            })         
    })
  }  



  /**
   * Hàm lấy về các có kèm chương trình khuyến mãi
   * @example
   this.vhQueryCafe.getBill_details_byId_bill('RcECbNgU9BdYQo37s30p')
        .then((bill_details:any)=>{
          console.log('getBill_details_byId_bill', bill_details);
        },(error:any)=>{
          console.log('error ', error);
        })   
   * @param id_bill 
   * @return Promise => array / orror
   */
  public getBill_details_byId_bill(id_bill:any):any {     
    return new Promise((resolve, reject) => { 
      let promise = new Array();    
      promise[0] = this.getBill(id_bill);  
      promise[1] = this.getBill_details_byID({id_bill:{$eq:id_bill}});    
      Promise.all(promise)
          .then((array:any) => {
            let bill = {...array[0]};
            let bill_details = [...array[1]];
            if((bill.bill_type != 40)&&(bill.bill_type != 42)&&(bill.bill_type != 43)&&(bill.bill_type != 50)&&(bill.bill_type != 52)&&(bill.bill_type != 53)){
              bill_details = this.changeBillDetails_withRaw_toPromotions(bill_details);
            }            
            if(bill.bill_type ===40){//phiếu bán voucher              
              let array_bill_details_voucher = new Array();                                                 
              for(let i=0; i<bill_details.length; i++){                                  
                let data = {...bill_details[i]}; 
                delete data?.bill_code;                
                delete data?.date;
                delete data?.tax;
                delete data?.bill_type;                  
                delete data?.id_cashier;
                delete data?.id_employee;
                delete data?.id_supplier;
                delete data?.id_customer;                  
                delete data?.id_inventorytime;   
                delete data?.id_branch;                 
                array_bill_details_voucher.push(data);                     
              };  
              resolve(array_bill_details_voucher);          
            }else if(bill.bill_type ===41){//phiếu đổi voucher              
                  let array_bill_details_voucher = new Array();                                                 
                  for(let i=0; i<bill_details.length; i++){                                  
                    let data = {...bill_details[i]}; 
                    delete data?.bill_code;                
                    delete data?.date;
                    delete data?.tax;
                    delete data?.bill_type;                  
                    delete data?.id_cashier;
                    delete data?.id_employee;
                    delete data?.id_supplier;
                    delete data?.id_customer;                  
                    delete data?.id_inventorytime;   
                    delete data?.id_branch;                 
                    array_bill_details_voucher.push(data);                     
                  };  
                  let promise_voucher = new Array();
                  for(let i=0; i<array_bill_details_voucher.length; i++){  
                    promise_voucher[promise_voucher.length] = new Promise(resolve=>{
                      this.getVoucher_Code_Name_Release(array_bill_details_voucher[i].id_voucher_code)               
                          .then((voucher:any)=>{
                            //array_bill_details_voucher[i].name = voucher.name_voucher_release + ' (' + voucher.name_voucher + ')';
                            array_bill_details_voucher[i].name_voucher = voucher.name_voucher
                            array_bill_details_voucher[i].name_voucher_release = voucher.name_voucher_release
                            resolve(null);
                          })
                    })
                  }
    
                  Promise.all(promise_voucher)
                      .then(()=>{
                        array_bill_details_voucher = this.changeBillDetails_withNameUnitsLots(array_bill_details_voucher);                   
                        resolve(array_bill_details_voucher);
                      })                    
            }else if(bill.bill_type ===50){//phiếu bán payment_card                  
              let array_bill_details_payment_card = new Array();                                                 
              for(let i=0; i<bill_details.length; i++){                                  
                let data = {...bill_details[i]}; 
                delete data?.bill_code;                
                delete data?.date;
                delete data?.tax;
                delete data?.bill_type;                  
                delete data?.id_cashier;
                delete data?.id_employee;
                delete data?.id_supplier;
                delete data?.id_customer;                  
                delete data?.id_inventorytime;   
                delete data?.id_branch;                 
                array_bill_details_payment_card.push(data);                     
              };  
              resolve(array_bill_details_payment_card);
            }else if(bill.bill_type === 51){//phiếu đổi payment_card                  
                  let array_bill_details_payment_card = new Array();                                                 
                  for(let i=0; i<bill_details.length; i++){                                  
                    let data = {...bill_details[i]}; 
                    delete data?.bill_code;                
                    delete data?.date;
                    delete data?.tax;
                    delete data?.bill_type;                  
                    delete data?.id_cashier;
                    delete data?.id_employee;
                    delete data?.id_supplier;
                    delete data?.id_customer;                  
                    delete data?.id_inventorytime;   
                    delete data?.id_branch;                 
                    array_bill_details_payment_card.push(data);                     
                  };  
                  let promise_payment_card = new Array();
                  for(let i=0; i<array_bill_details_payment_card.length; i++){  
                    promise_payment_card[promise_payment_card.length] = new Promise(resolve=>{
                      this.getPaymentCard_Code_Name_Release(array_bill_details_payment_card[i].id_payment_card_code)               
                          .then((payment_card:any)=>{                        
                            array_bill_details_payment_card[i].name_payment_card = payment_card.name_payment_card
                            array_bill_details_payment_card[i].name_payment_card_release = payment_card.name_payment_card_release
                            resolve(null);
                          })
                    })
                  }
    
                  Promise.all(promise_payment_card)
                      .then(()=>{
                        array_bill_details_payment_card = this.changeBillDetails_withNameUnitsLots(array_bill_details_payment_card);                    
                        resolve(array_bill_details_payment_card);
                      })
    
            }else{              
              let array_bill_details_product = new Array();
              if(bill_details.length > 0){                                       
                for(let i=0; i<bill_details.length; i++){                                  
                  let data = {...bill_details[i]}; 
                  delete data?.bill_code;                
                  delete data?.date;
                  delete data?.tax;
                  delete data?.bill_type;                  
                  delete data?.id_cashier;
                  delete data?.id_employee;
                  delete data?.id_supplier;
                  delete data?.id_customer;                  
                  delete data?.id_inventorytime;   
                  delete data?.id_branch;                 
                  array_bill_details_product.push(data);                     
                };                                                 
              }   
              //resolve(array_bill_details_product); 
              this.changeBillDetails_withPromotionNameUnitsLots(array_bill_details_product)
                  .then((array:any)=>{
                    resolve(array); 
                  },(error:any)=>{
                    console.log('error', error);
                  })
            }              
          },
          (error:any) => {
            reject(error);
          }) 
    })
  }

  /** 
  * @example:
  * this.vhQueryCafe.getBill_details_byID({id_bill:{$eq:id_bill}, bill_type:{$eq:5}}, {},{date:1},0)
        .then((bill_details)=>{
          console.log('bill_details', bill_details);
        })
  * @param query : trong query phải có query id_bill or id_product or id_subproduct....
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
   private getBill_details_byID(query: any, sort?:object, limit?:number) {
   return new Promise((resolve, reject) => { 
     let arr_years = this.getYearsArray();
     this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + arr_years[arr_years.length-1], query, {}, sort, limit)
         .then((bill_details1:any) => {    
             if(bill_details1.length) return resolve(bill_details1);   
             if(arr_years.length == 1) return resolve(bill_details1);          
             this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + arr_years[arr_years.length-2], query,{}, sort,limit)
                 .then((bill_details2:any) => {    
                   if(bill_details2.length) return resolve(bill_details2);   
                   if(arr_years.length == 2) return resolve(bill_details2);       
                   let promise = new Array();
                   for(let i=0; i<arr_years.length-2;i++){
                     promise[promise.length] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + arr_years[i], query, {}, sort,limit)
                   }  
                   Promise.all(promise)
                         .then((array:any)=>{      
                           let bill_details = array.flat();     
                           resolve(bill_details);                       
                         })                       
                 },(error:any) => {
                   reject(error);
                 }) 
           },(error:any) => {
             reject(error);
           }) 
     })
   } 

     /** 
  * @example:
  * let time = new Date();
  * time.setDate(time.getDate()-7);
  * this.vhQueryCafe.getBill_details_byFields({date:{$gte:time}, {bill_type:{$eq:5}}, {},{date:1},0)
        .then((bill_details)=>{
          console.log('getBill_details_byFields', bill_details);
        })
  * @param query trong query phải có date
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
  private getBill_details_byFields(query: any, projection?:object, sort?:object, limit?:number) {
    return new Promise((resolve, reject) => { 
      let years_query = this.getYearsArray_fromQuery(query);
      let promise = new Array();
      for(let i=0; i<years_query.length; i++){
        promise[promise.length] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + years_query[i], query, {}, sort, limit);
      }
    
      Promise.all(promise)
          .then((array:any)=>{
            let bill_details = array.flat();  
            let promise_zero = new Array();  
            promise_zero[promise_zero.length] = this.syncBillDetails_Products(bill_details)               
            promise_zero[promise_zero.length] = this.syncBillDetails_Customers(bill_details)
            promise_zero[promise_zero.length] = this.syncBillDetails_Suppliers(bill_details)
            promise_zero[promise_zero.length] = this.syncBillDetails_Employees(bill_details)
            Promise.all(promise_zero)
                  .then(()=>{
                        resolve(bill_details);
                      }, error=>{
                        reject(error);
                      })
          },error=>{
            reject(error);
          })        
     })
   } 

  /**
   * VhQueryCafe:
   * @example
   this.vhQueryCafe.getBill_details('RcECbNgU9BdYQo37s30p')
        .then((bill_details:any)=>{
          console.log('getBill_details', bill_details);
        },(error:any)=>{
          console.log('error ', error);
        })   
   * @param id_bill 
   * @return Promise => array / orror
   */
  private getBill_details(id_bill:any):any {
    return new Promise((resolve, reject) => { 
      let promise = new Array();
      promise[0] = this.getBill(id_bill) 
      promise[1] = this.getBill_details_byID({id_bill:{$eq:id_bill}})          
      Promise.all(promise)
          .then((array:any) => {
            let bill = {...array[0]};
            let bill_details = [...array[1]];
            if(bill.bill_type ===41){
              let array_bill_details_voucher:any = new Array();             
              for(let i=0; i<bill_details.length; i++){    
                let products = [];
                for(let j=i; j<bill_details.length; j++){  
                  if(!bill_details[j].check) 
                    if((bill_details[i].id_voucher_code === bill_details[j].id_voucher_code)&&bill_details[i].id_voucher === bill_details[j].id_voucher){
                      let value = {
                        id_product: bill_details[j].id_product,
                        price: bill_details[j].price, 
                        quantity: bill_details[j].quantity, 
                        ptype: bill_details[j].ptype,
                        unit: bill_details[j].unit, 
                        ratio: bill_details[j].ratio 
                      };                  
                      products.push({...value});
                      bill_details[j].check = true;
                  }
                }
                bill_details[i].products = [...products];
                delete bill_details[i]?.bill_code;                
                delete bill_details[i]?.date;
                delete bill_details[i]?.tax;
                delete bill_details[i]?.bill_type;                  
                delete bill_details[i]?.id_cashier;
                delete bill_details[i]?.id_employee;
                delete bill_details[i]?.id_supplier;
                delete bill_details[i]?.id_customer;                  
                delete bill_details[i]?.id_inventorytime;   
                delete bill_details[i]?.id_branch;                 

                delete bill_details[i].id_product;
                delete bill_details[i].price;
                delete bill_details[i].quantity;
                delete bill_details[i].ptype;
                delete bill_details[i].unit;
                delete bill_details[i].ratio;
                delete bill_details[i].check;
                if(bill_details[i].products.length >0) array_bill_details_voucher.push({...bill_details[i]});
              }
              console.log('array_bill_details_voucher', array_bill_details_voucher);
              resolve(array_bill_details_voucher);     
            }else if(bill.bill_type ===51){
              let array_bill_details_payment_card:any = new Array();             
              for(let i=0; i<bill_details.length; i++){    
                let products = [];
                for(let j=i; j<bill_details.length; j++){  
                  if(!bill_details[j].check) 
                    if((bill_details[i].id_payment_card_code === bill_details[j].id_payment_card_code)&&bill_details[i].id_payment_card === bill_details[j].id_payment_card){
                      let value = {
                        id_product: bill_details[j].id_product,
                        price: bill_details[j].price, 
                        quantity: bill_details[j].quantity, 
                        ptype: bill_details[j].ptype,
                        unit: bill_details[j].unit, 
                        ratio: bill_details[j].ratio,
                        restquantity: bill_details[j].restquantity
                      };                  
                      products.push({...value});
                      bill_details[j].check = true;
                  }
                }
                bill_details[i].products = [...products];
                delete bill_details[i]?.bill_code;                
                delete bill_details[i]?.date;
                delete bill_details[i]?.tax;
                delete bill_details[i]?.bill_type;                  
                delete bill_details[i]?.id_cashier;
                delete bill_details[i]?.id_employee;
                delete bill_details[i]?.id_supplier;
                delete bill_details[i]?.id_customer;                  
                delete bill_details[i]?.id_inventorytime;   
                delete bill_details[i]?.id_branch;              
                
                delete bill_details[i].id_product;
                delete bill_details[i].price;
                delete bill_details[i].quantity;
                delete bill_details[i].ptype;
                delete bill_details[i].unit;
                delete bill_details[i].ratio;
                delete bill_details[i].check;
                delete bill_details[i].restquantity;
                if(bill_details[i].products.length >0) array_bill_details_payment_card.push({...bill_details[i]});
              }
              console.log('array_bill_details_payment_card', array_bill_details_payment_card);
              resolve(array_bill_details_payment_card);     

            }else{              
              let array_bill_details_product = new Array();
              if(bill_details.length > 0){                                       
                for(let i=0; i<bill_details.length; i++){                                  
                  let data = {...bill_details[i]}; 
                  delete data?.bill_code;                
                  delete data?.date;
                  delete data?.tax;
                  delete data?.bill_type;                  
                  delete data?.id_cashier;
                  delete data?.id_employee;
                  delete data?.id_supplier;
                  delete data?.id_customer;                  
                  delete data?.id_inventorytime;   
                  delete data?.id_branch;                 
                  array_bill_details_product.push(data);                     
                };                  
                console.log('array_bill_details_product', array_bill_details_product);                                
              }   
              resolve(array_bill_details_product); 
            }    
          
          },
          (error:any) => {
            reject(error);
          }) 
    })
  }

  
  private _getBill_details(id_bill:any):any {//hàm cũ
    return new Promise((resolve, reject) => { 
     this.getBill_details_byID({id_bill:{$eq:id_bill}})          
          .then((objs:any) => {
            let array = new Array(); 
              if(objs.length > 0){                   
                for(let i=0; i<objs.length; i++){                    
                  let data = {...objs[i]}; 
                  delete data?.bill_code;                
                  delete data?.date;
                  delete data?.tax;
                  delete data?.bill_type;                  
                  delete data?.id_cashier;
                  delete data?.id_employee;
                  delete data?.id_supplier;
                  delete data?.id_customer;                  
                  delete data?.id_inventorytime;      
                  delete data?.id_branch;              
                  array.push(data);                     
                };                   
              }                          
            resolve(array);
          },
          (error:any) => {
            reject(error);
          }) 
    })
  } 


  /**
   * @example:
   * this.vhQueryCafe.createBill_Detail({})
          .then((vhbill_detail)=>{
            console.log('createBill_Detail', vhbill_detail);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public createBill_Detail(data:any):any {  
    return new Promise((resolve, reject) => {
      if(data.id_bill){
       this.getBill(data.id_bill)
            .then((bill:any)=>{
                let _data = data;           
                if(bill.bill_code) _data.bill_code = bill.bill_code;    
                if(bill.date) _data.date = bill.date; 
                if(bill.id_table) _data.id_table = bill.id_table;  
                if(bill.id_branch) _data.id_branch = bill.id_branch;                        
                if(typeof bill.bill_type == 'number') _data.bill_type = bill.bill_type;
                this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), _data)
                    .then((vhbill_detail)=>{                      
                      resolve(vhbill_detail);
                    },(error:any)=>{
                      reject(error);
                    })   
                
            },(error:any)=>{
            console.log('error', error);
            })
      }else{
        console.log('error', 'không tồn tại id_bill trong data');
      } 
            
    })
  } 
  /**
   * Hàm này chỉ áp dụng cho bill_type 1,5 và bill_detail có ptype 5
   * @example:
   * this.vhQueryCafe.createBill_Detail_ptype_5({})
          .then((vhbill_detail)=>{
            console.log('createBill_Detail_ptype_5', vhbill_detail);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public createBill_Detail_ptype_5(data:any):any {
    return new Promise((resolve, reject) => {
      // let _bill_details = cloneDeep(bill_details);
      // if((bill.bill_type != 40)&&(bill.bill_type != 42)&&(bill.bill_type != 43)&&(bill.bill_type != 50)&&(bill.bill_type != 52)&&(bill.bill_type != 53)){
      //   bill_details = this.changeBillDetails_withPromotions_toRaw(bill_details);
      //   if(!bill_details) return null;    
      // } 
      //
      
      
        if(data.id_bill){
          //console.log('-------data', data);
          let dataArray = this.changeBillDetails_withPromotions_toRaw([data]);
          let promise = new Array();
          //console.log('-------dataArray', dataArray);
          for(let i=0; i<dataArray.length; i++){  
            promise[promise.length] = new Promise((resolve, reject)=>{
             this.getBill(dataArray[i].id_bill)
                  .then((bill:any)=>{
                      let _data = {...dataArray[i]};           
                      if(bill.bill_code) _data.bill_code = bill.bill_code;    
                      if(bill.date) _data.date = bill.date; 
                      if(bill.id_table) _data.id_table = bill.id_table;         
                      if(bill.id_branch) _data.id_branch = bill.id_branch;         
                      if(typeof bill.bill_type == 'number') _data.bill_type = bill.bill_type;
                      this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), _data)
                          .then((vhbill_detail)=>{   
                            //console.log('-----------vhbill_detail', vhbill_detail);                   
                            resolve(vhbill_detail);
                          },(error:any)=>{
                            reject(error);
                          })   
                    
                  },(error:any)=>{
                    console.log('error', error);
                  })
            })
          }
          Promise.all(promise)
                .then((array:any)=>{
                  data = {...data, _id: array[0].bill_detail_ID};
                  //console.log('---data', data);              
                  resolve(data);
                })
        }else{
          console.log('error', 'không tồn tại id_bill trong data');
        } 
            
    })
  } 

  /**
   * @example:
   * this.vhQueryCafe.updateBill_Detail('5fb6780ca2148e09806c5b01', {name:'Khuyến mãi 12/12'})
          .then((bool:any)=>{
            console.log('updateBill_Detail', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_bill 
   * @param data 
   * @return Promise => bool = true or false
   */
   public updateBill_Detail(id_bill_detail:string, value:object){   
   return new Promise((resolve, reject) => {   
       let arr_years = this.getYearsArray();
       this.vhMGDB_database.updateDoc('vhs_bill_details_' + arr_years[arr_years.length-1], id_bill_detail, value)
           .then((obj1:any) => {    
               if(obj1) return resolve(obj1);   
               if(arr_years.length == 1) return resolve(obj1);          
               this.vhMGDB_database.updateDoc('vhs_bill_details_' + arr_years[arr_years.length-2], id_bill_detail, value)
                   .then((obj2:any) => {    
                     if(obj2) return resolve(obj2);   
                     if(arr_years.length == 2) return resolve(obj2);       
                     let promise = new Array();
                     for(let i=0; i<arr_years.length-2;i++){
                       promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + arr_years[i], id_bill_detail, value);
                     }  
                     Promise.all(promise)
                           .then((array)=>{
                             array = array.filter((e:any)=>e!=false);
                             if(array.length == 0) resolve(false);     
                             else if(array.length == 1) resolve(array[0]);  
                             else{
                               reject(`Lỗi nghiêm trọng, id_bill_detail ${id_bill_detail} tồn tại trên nhiều collection, báo anh Huy trường hợp này gấp!`);
                             } 
                           })                       
                   },(error:any) => {
                     reject(error);
                   }) 
             },(error:any) => {
               reject(error);
             })      
   })
 }

  /**
  * Hàm này chỉ áp dụng cho bill_type 1,5 và bill_detail có ptype 5
  * @example:
  * this.vhQueryCafe.updateBill_Detail_btype_5('5fb6780ca2148e09806c5b01', {name:'Khuyến mãi 12/12'})
        .then((bool:any)=>{
          console.log('updateBill_Detail', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_bill_detail 
  * @param value 
  * @return Promise => bool = true or false
  */
  public updateBill_Detail_btype_5(id_bill_detail:string, value:any){     
    return new Promise((resolve, reject) => {
      if(value.combos) delete value.combos;//return resolve(false);  
      let query = {bill_detail_ID:{$eq:id_bill_detail}};
      this.getBill_details_byFields(query, {}, {}, 0)
          .then((bill_details:any)=>{
            if(bill_details.length >0){                      
              let promise = new Array();                
              for(let i=0; i<bill_details.length; i++){  
                if(value.quantity){                    
                  bill_details[i].quantity = bill_details[i].quantity * value.quantity / bill_details[i].combos_group.quantity; 
                  bill_details[i].combos_group.quantity = value.quantity;
                }
                if(value.price) bill_details[i].combos_group.price = value.price;
                if(value.price_origin) bill_details[i].combos_group.price_origin = value.price_origin;
                if(value.ratio) bill_details[i].combos_group.ratio = value.ratio;

                let _id = bill_details[i]._id;
                delete bill_details[i]._id;                                    
                promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill_details[i].date), _id, bill_details[i]);                      
              }
              Promise.all(promise)
                    .then(()=>{
                      resolve(true);  
                    })
            }else{
              console.log('error', {error: 'id_bill_detail truyền vào không tồn tại'});
              resolve(false);  
            }            
          }, error=>{
            console.log('error', error);
            resolve(false);  
          })        
              
    })
  } 

  /**
 * @example:
 * this.vhQueryCafe.deleteBill_Detail('5fb67fda87c0f21d484cbdf3')
      .then((bool:any)=>{
        console.log('deleteBill_Detail', bool);
      })
  * @param id_bill_detail 
  * @return Promise => bool = true or false 
  */
  public deleteBill_Detail(id_bill_detail:any){
    return new Promise((resolve, reject) => {
     let arr_years = this.getYearsArray();
     let promise = new Array();
     for(let i=0; i<arr_years.length;i++){
       promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + arr_years[i], id_bill_detail);
     }  
     Promise.all(promise)
           .then(()=>{
             resolve(true);     
           })          
    })
  }

/**
 * Hàm này chỉ áp dụng cho bill_type 1,5 và bill_detail có ptype 5
 * @example:
 * this.vhQueryCafe.deleteBill_Detail_ptype_5('5fb67fda87c0f21d484cbdf3')
      .then((bool:any)=>{
        console.log('deleteBill_Detail', bool);
      })
  * @param id_bill_detail 
  * @return Promise => bool = true or false 
  */
  public deleteBill_Detail_ptype_5(id_bill_detail:any){
    return new Promise((resolve, reject) => {
      let query = {bill_detail_ID:{$eq:id_bill_detail}};
      this.getBill_details_byFields(query, {}, {}, 0)
          .then((bill_details:any)=>{
            if(bill_details.length >0){   
              let promise = new Array();                
              for(let i=0; i<bill_details.length; i++){  
                promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill_details[i].date), bill_details[i]._id);                    
              }
              Promise.all(promise)
                    .then((array:any)=>{
                      resolve(array[0]);  
                    })
            }else{
              console.log('error', {error: 'id_bill_detail truyền vào không tồn tại'});
              resolve(false);  
            }  
          }, error=>{
            console.log('error', error);
            resolve(false);  
          })          
    })
  }


  /**
   * @example:
   * this.vhQueryCafe.getBill('5fb67fda87c0f21d484cbdf3')
        .then((bill)=>{
          console.log('getBill', bill);
        })
   *  @param id_bill 
   */
   public getBill(id_bill:any) {
     return new Promise((resolve, reject) => { 
       let arr_years = this.getYearsArray();
       this.vhMGDB_database.getDoc('vhs_bills_' + arr_years[arr_years.length-1], id_bill)
           .then((obj1:any) => {    
               if(obj1) return resolve(obj1);   
               if(arr_years.length == 1) return resolve(obj1);          
               this.vhMGDB_database.getDoc('vhs_bills_' + arr_years[arr_years.length-2], id_bill)
                   .then((obj2:any) => {    
                     if(obj2) return resolve(obj2);   
                     if(arr_years.length == 2) return resolve(obj2);       
                     let promise = new Array();
                     for(let i=0; i<arr_years.length-2;i++){
                       promise[promise.length] = this.vhMGDB_database.getDoc('vhs_bills_' + arr_years[i], id_bill);
                     }  
                     Promise.all(promise)
                           .then((array)=>{
                             array = array.filter((e:any)=>e!=null);
                             if(array.length == 0) resolve(null);     
                             else if(array.length == 1) resolve(array[0]);  
                             else{
                               reject(`Lỗi nghiêm trọng, id_bill ${id_bill} tồn tại trên nhiều collection, báo anh Huy trường hợp này gấp!`);
                             } 
                           })                       
                   },(error:any) => {
                     reject(error);
                   }) 
             },(error:any) => {
               reject(error);
             }) 
     })
   } 

  /**
   * @example:
   * let time = new Date();
   * time.setDate(time.getDate()-7);
   * this.vhQueryCafe.getBills({date:{$gte:time}}, {},{date:1},0))
      .then((bills)=>{
        console.log('getBills', bills);
      })
  * @param query
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
  public getBills(query: object, projection?:object, sort?:object, limit?:number) {
    return new Promise((resolve, reject) => { 
      this.getBills_byFields(query, {}, sort, limit)
          .then((bills)=>{
            resolve(bills);
          })
          .catch((e)=>{
            reject(e);
          })        
    })
  } 

  /**
  * @example:
  * let time = new Date();
  * time.setDate(time.getDate()-7);
  * this.vhQueryCafe.getBills_byFields({date:{$gte:time}, {bill_type:{$eq:5}}, {},{date:1},0)
        .then((bills)=>{
          console.log('getBills', bills);
        })
  * @param query
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
   public getBills_byFields(query: any, projection?:object, sort?:object, limit?:number) {
   return new Promise((resolve, reject) => { 
     let years_query = this.getYearsArray_fromQuery(query);
     let promise = new Array();
     for(let i=0; i<years_query.length; i++){
       promise[promise.length] = this.vhMGDB_database.getDocsByFields('vhs_bills_' + years_query[i], query, {}, sort, limit);
     }
   
     Promise.all(promise)
           .then((array:any)=>{
             let bills = array.flat();       
             resolve(bills);
           },error=>{
             reject(error);
           })       
   })
 } 

  /**
   * @example:
   * this.vhQueryCafe.createBill({name:'Cuối tuần vui vẻ', type:2, active:true, date_start:new Date(), date_end: new Date()})
          .then((bill)=>{
            console.log('createBill', bill);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * @notice : hàm này chỉ dùng tạo những bill_type mà không có phát sinh bill_detail
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
   public createBill(data:any){    
     return new Promise((resolve, reject) => {
       this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
       data.sync_code = this.sync_code;
       this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(data.date), data)
           .then((bill)=>{
             resolve(bill);
           },(error:any)=>{
             reject(error);
           })         
     })
   }

  /**
   * @example:
   * this.vhQueryCafe.updateBill('5fb6780ca2148e09806c5b01', {name:'Khuyến mãi 12/12'})
          .then((bool:any)=>{
            console.log('updateBill', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_bill 
   * @param bill 
   * @return Promise => bool = true or false
   * @notice : hàm này chỉ dùng cập nhật những bill_type mà không có phát sinh bill_detail
   */
   public updateBill(id_bill:string, bill:any){        
     return new Promise((resolve, reject) => {   
       this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
       bill.sync_code = this.sync_code;  
       this.getBill(id_bill)
           .then((_bill:any)=>{   
             if(bill?.bill_type === '3334'){           
               if(_bill.bill_type === 32){                       
                   let promise = new Array();        
                   promise[0] = this.vhMGDB_database.updateDoc('vhs_bills_' +  this.getYear(_bill.date), id_bill, {bill_type:33, sync_code: this.sync_code});
                   let _bill_34 = {...bill}; 
                   delete _bill_34?.id_branch_receive;
                   _bill_34.bill_type = 34;
                   _bill_34.bill_code = _bill.bill_code;
                   _bill_34.id_branch = _bill.id_branch_receive;   
                   _bill_34.id_branch_send = _bill.id_branch;  
                   _bill_34.date = _bill.date;                
                   promise[1] = this.vhMGDB_database.addDoc('vhs_bills_' +  this.getYear(_bill.date), _bill_34);  
                   Promise.all(promise)
                         .then(() => { 
                           resolve(true);
                         })
                         .catch(e => { 
                           reject(e)
                         })
                     
               }else{
                 reject('Lưu không thành công, vui lòng kiểm tra lại.')
               }
             }else{
               this.vhMGDB_database.updateDoc('vhs_bills_' +  this.getYear(_bill.date), id_bill, bill)
                 .then((bool:any)=>{
                   resolve(bool);
                 }, error=>{
                   reject(error)
                 }) 
             }
           })   
     })
   }          

  /**
   * @example:
   * this.vhQueryCafe.deleteBill('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteBill', bool);
        })
   * @param id_bill_detail 
   * @return Promise => bool = true or false 
   * @notice : hàm này chỉ dùng xóa những bill_type(7,8,11,12) mà không có phát sinh bill_detail 
   */
     public deleteBill(id_bill:any){
       return new Promise((resolve, reject) => {
         this.getBill(id_bill)
             .then((bill:any)=>{              
               if(bill){
                 let promise:any;  
                 //xóa bill_type(thu khác), vẫn giữ bill lại nhưng chuyển trang thái 25  
                 if(bill.bill_type === 7){
                   promise = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);                     
                 //xóa bill_type(chi khác), vẫn giữ bill lại nhưng chuyển trang thái 26  
                 }else if(bill.bill_type === 8){
                   promise = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);             
                 //xóa bill_type(thu công nợ KH), vẫn giữ bill lại nhưng chuyển trang thái 27                     
                 }else if(bill.bill_type === 11){ 
                   promise = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);           
                 //xóa bill_type(chi công nợ NCC), vẫn giữ bill lại nhưng chuyển trang thái 28               
                 }else if(bill.bill_type === 12){  
                   promise = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);                      
                 }else if(bill.bill_type === 32){
                   promise = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);                                   
                 }                 
                 promise.then((bool:any)=>resolve(bool))
               }else reject({message: id_bill + ' no exist'});    
             })           
       })
     }    
    
 /**
  * Hàm này dùng để đồng bộ hóa đơn đang mở ở 2 giao diện hoặc 2 thiết bị khác nhau
  * @example:
  * this.vhQueryCafe.observableSyncOpeningBill('5fb6780ca2148e09806c5b01', 5)      
      .subscribe((rsp)=> {  
            if(rsp.vcode === 0){
              //-----------your code 0-----------
              let bill = rsp.data;
              console.log('observableSyncOpeningBill', bill);           
            }else if(rsp.vcode === 1){
                //-----------your code 1-----------
            }else if(rsp.vcode === 2){
                //-----------your code 2-----------
            }                                         
      },(error:any) => {
        console.log(error);
      }) 
  * @param id_bill   
  * @param bill_type
  * @returns Observable => bill hoặc null; 
  * @return Observable object => rsp = {vcode, message, data}
  * vcode == 0: repaired bill by another device
  * vcode == 1: changed bill_type by another device
  * vcode == 2: deleted bill by unknown device
  * @notice : nhớ đóng closeSyncOpeningBill() khi thoát trang hiện tại this.vhQueryCafe.closeSyncOpeningBill();
  */
   public observableSyncOpeningBill(id_bill:string, bill_type:number){  
     return new Observable((observer:any) => {   
       let count = 0;       
       let arr_years = this.getYearsArray();
       this.callbacksyncopeningbill = this.vhMGDB_socketMongoDB.initSyncOpeningBill('vhs_bills_' + arr_years[arr_years.length-1], id_bill).subscribe((doc:any)=>{                    
           if(doc.exists) {              
               if(doc.data().sync_code != this.sync_code){               
                 if(doc.data().bill_type === bill_type){              
                   if(count++){
                     let bill = {                         
                       ...this.vhMGDB_auth.cvtDataFB2MG(doc.data()),
                       _id: doc.id
                     };                            
                     console.log('id_bill', id_bill);
                     observer.next({vcode:0, message:'repaired bill by another device', data: bill}); 
                   }                                  
                 }else{        
                   console.log('id_bill', id_bill);         
                   observer.next({vcode:1, message:'changed bill_type by another device'}); 
                 }      
               }else{
                 count++;
               }           
           }else{     
            if(arr_years.length >= 2){
              this.closeSyncOpeningBill();
              this.callbacksyncopeningbill = this.vhMGDB_socketMongoDB.initSyncOpeningBill('vhs_bills_' + arr_years[arr_years.length-1], id_bill).subscribe((doc:any)=>{                    
                if(doc.exists) {              
                    if(doc.data().sync_code != this.sync_code){               
                      if(doc.data().bill_type === bill_type){              
                        if(count++){
                          let bill = {                         
                            ...this.vhMGDB_auth.cvtDataFB2MG(doc.data()),
                            _id: doc.id
                          };                            
                          console.log('id_bill', id_bill);
                          observer.next({vcode:0, message:'repaired bill by another device', data: bill}); 
                        }                                  
                      }else{        
                        console.log('id_bill', id_bill);         
                        observer.next({vcode:1, message:'changed bill_type by another device'}); 
                      }      
                    }else{
                      count++;
                    }           
                }else{ 
                  console.log('id_bill', id_bill);                         
                  observer.next({vcode:2, message:'deleted bill by unknown device'}); 
                }
              })
            }else{
              console.log('id_bill', id_bill);                         
              observer.next({vcode:2, message:'deleted bill by unknown device'}); 
            }             
           }       
       })
     })        
   }    
    

  /**
   * @example:
   * this.vhQueryCafe.closeSyncOpeningBill();
   * @returns void
   */
  public closeSyncOpeningBill(){
    this.callbacksyncopeningbill.unsubscribe();
    this.vhMGDB_socketMongoDB.closeSyncOpeningBill();
  }    


  private publishSyncEventList_BillType5() {
    this.subjectlistbilltype5.next(this.listbill_bybilltype);
  }  

  private _syncLocalList_BillType5():Subject<any> {      
    return this.subjectlistbilltype5; 
  }
 
  
  /**
   * Hàm callback trả về danh sách hóa đơn bill_type5 mới nhất
   * @example:
    this.observableList_BillType5 = this.vhQueryCafe.syncLocalList_BillType5()
        .subscribe((listbill_bybilltype)=> {                       
            console.log('syncLocalList_BillType5', listbill_bybilltype);                         
        },(error:any) => {
          console.log(error);
        })       
   
    ngOnDestroy(){
      this.observableList_BillType5.unsubscribe();    
    }
   * @returns Observable => array
   */
  public syncLocalList_BillType5(){   
   return new Observable((observer:any) => {   
      this._syncLocalList_BillType5().subscribe((list_billtype5) => {   
        observer.next(list_billtype5);
      })
      if(this.syncLocalBillType5_start){
        this.syncLocalBillType5_start = false;
        let bill_type = 5;
        let id_branch = this.getDefaultBranch()._id;
        let arr_years = this.getYearsArray();        
        this.callback1syncbilltype = this.vhMGDB_socketMongoDB.init1SyncBillType(id_branch, 'vhs_bills_' + arr_years[arr_years.length-1], bill_type).subscribe((change:any)=>{             
          if (change.type === "added") {                                                  
            let data = {            
              _id: change.doc.id,
              ...this.vhMGDB_auth.cvtDataFB2MG(change.doc.data())
            };
            this.listbill_bybilltype.push(data);               
                    
          }else if (change.type === "modified") {                               
              let data = {               
                _id: change.doc.id,
                ...this.vhMGDB_auth.cvtDataFB2MG(change.doc.data())
              };       
              for(let i=0; i<this.listbill_bybilltype.length; i++){
                if(this.listbill_bybilltype[i]._id === data._id){
                  this.listbill_bybilltype[i] = {...this.listbill_bybilltype[i], ...data};                   
                  break;
                }
              }
                          
          }else if (change.type === "removed") {                               
              let data = {              
                _id: change.doc.id                                  
              };
              for(let i=0; i<this.listbill_bybilltype.length; i++){
                if(this.listbill_bybilltype[i]._id === data._id){
                  this.listbill_bybilltype.splice(i,1);
                  break;
                }
              }
          }     
          //observer.next(this.listbill_bybilltype);  
          this.publishSyncEventList_BillType5();
        })
        if(arr_years.length >=2)
        this.callback2syncbilltype = this.vhMGDB_socketMongoDB.init2SyncBillType(id_branch, 'vhs_bills_' + arr_years[arr_years.length-2], bill_type).subscribe((change:any)=>{             
          if (change.type === "added") {                                                  
            let data = {            
              _id: change.doc.id,
              ...this.vhMGDB_auth.cvtDataFB2MG(change.doc.data())
            };
            this.listbill_bybilltype.push(data);               
                    
          }else if (change.type === "modified") {                               
              let data = {               
                _id: change.doc.id,
                ...this.vhMGDB_auth.cvtDataFB2MG(change.doc.data())
              };       
              for(let i=0; i<this.listbill_bybilltype.length; i++){
                if(this.listbill_bybilltype[i]._id === data._id){
                  this.listbill_bybilltype[i] = {...this.listbill_bybilltype[i], ...data};                   
                  break;
                }
              }
                          
          }else if (change.type === "removed") {                               
              let data = {              
                _id: change.doc.id                                  
              };
              for(let i=0; i<this.listbill_bybilltype.length; i++){
                if(this.listbill_bybilltype[i]._id === data._id){
                  this.listbill_bybilltype.splice(i,1);
                  break;
                }
              }
          }     
          //observer.next(this.listbill_bybilltype);  
          this.publishSyncEventList_BillType5();
        })
      }else{     
        this.publishSyncEventList_BillType5();
      }    
   })
  }

    /**
   * Hàm đóng Observable của syncLocalList_BillType5(), mỗi lần thoát hẳn (ko vào ra thường xuyên) trang, thoát hẳn component nên gọi hàm này
   * @example:
   * this.vhQueryCafe.closeSyncLocalList_BillType5();
   * @returns void
   */
    private closeSyncLocalList_BillType5(){//chưa cần dùng hàm này
      this.syncLocalBillType5_start = true;
      this.listbill_bybilltype = new Array();
      this.callback1syncbilltype.unsubscribe();
      this.callback2syncbilltype.unsubscribe();
      this.vhMGDB_socketMongoDB.closeSyncBillType();
    }

   /**
    * @example:
    * this.vhQueryCafe.createPaymentVnpay(10000, 'Thanh toan hoa don so A7TG2004, vao luc: 2021-11-19 13:11:27', 'o0wEpPDhR8QiGDkp2hLG', 'http://localhost:4200/')
    * @param amount 
    * @param orderDescription (lưu ý chữ không dấu)
    * @param id_payment : id của hóa đơn khách hàng cần thanh toán
    * @param backHref : lấy link mà chạy khởi động lại trang 
    * Nê
    * @Return void
    */
    private createPaymentVnpay(amount:number, orderDescription:string, id_payment:string, backHref?:any):any {          
      this.vhMGDB_paymentVNPAY.createPaymentVnpay(amount, orderDescription, id_payment, backHref)
          .then((response:any)=>{           
            window.location = response.data; 
            //resolve(response);
          },(error:any)=>{
            console.log('error', error);
          })   
    }

     /**
    * @example:
    * this.vhQueryCafe.createPaymentVnpay_web(10000, 'Thanh toan hoa don so A7TG2004, vao luc: 2021-11-19 13:11:27', 'o0wEpPDhR8QiGDkp2hLG', 'http://localhost:4200/')
    * @param amount 
    * @param orderDescription (lưu ý chữ không dấu)
    * @param id_payment : id của hóa đơn khách hàng cần thanh toán
    * @param backHref : lấy link mà chạy khởi động lại trang, link này gán trong nút back của trang trả về
    * @Return Void
    */
    public createPaymentVnpay_web(amount:number, orderDescription:string, id_payment:string, backHref:string):any {   
      return new Promise((resolve, reject) => {         
        this.vhMGDB_paymentVNPAY.createPaymentVnpay(amount, orderDescription, id_payment, backHref)
            .then((response:any)=>{             
              window.location = response.data;              
            },(error:any)=>{
              console.log('error', error);
            })   
      })
    }

/**
  * @example:
  * this.vhQueryCafe.createPaymentVnpay_soft(10000, 'Thanh toan hoa don so A7TG2004, vao luc: 2021-11-19 13:11:27', 'o0wEpPDhR8QiGDkp2hLG')
        .then((payment_url)=>{
            //Hiện loading chờ ở đây
            setTimeout(() => {
              //Sau 15s đóng loading lại và refresh trang lại                
              window.location = backHref; 
            }, 15000);         
            //Đồng thời mở 1 browser trong 1 window mới vơi ulr là payment_url cho khách hàng thanh toán           
        },(error:any)=>{
          console.log('error', error);
        })
  * @param amount 
  * @param orderDescription (lưu ý chữ không dấu)
  * @param id_payment : id của hóa đơn khách hàng cần thanh toán
  * @Return Promise => payment_url
  */
  public createPaymentVnpay_soft(amount:number, orderDescription:string, id_payment:string):any {   
    return new Promise((resolve, reject) => {         
      this.vhMGDB_paymentVNPAY.createPaymentVnpay(amount, orderDescription, id_payment, <any>null)
          .then((response:any)=>{               
            //window.open(response.data,"_blank","fullscreen=yes");               
            resolve(response.data)        
          },(error:any)=>{
            console.log('error', error);
          })   
    })
  }

/**
  * @example:
  * this.vhQueryCafe.createPaymentVnpay_app(10000, 'Thanh toan hoa don so A7TG2004, vao luc: 2021-11-19 13:11:27', 'o0wEpPDhR8QiGDkp2hLG')
        .then((payment_url)=>{
            //Dùng thư viện chạy browser trong app vơi ulr là payment_url cho khách hàng thanh toán                         
        },(error:any)=>{
          console.log('error', error);
        })
  * @param amount 
  * @param orderDescription (lưu ý chữ không dấu)
  * @param id_payment : id của hóa đơn khách hàng cần thanh toán
  * @Return payment_url
  */
  public createPaymentVnpay_app(amount:number, orderDescription:string, id_payment:string):any {   
    return new Promise((resolve, reject) => {         
      this.vhMGDB_paymentVNPAY.createPaymentVnpay(amount, orderDescription, id_payment, <any>null)
          .then((response:any)=>{            
            //window.location = response.data;   
            resolve(response.data)         
          },(error:any)=>{
            console.log('error', error);
          })   
    })
  }

    
   /**
    * @example:
    * this.vhQueryCafe.createPaymentVnpay(10000, 'Thanh toan hoa don so A7TG2004, vao luc: 2021-11-19 13:11:27', 'o0wEpPDhR8QiGDkp2hLG', 'http://localhost:4200/')
          .then(link=>{
            //Nếu Desktop chạy luôn link này: window.location = response.data; 
            // Nếu Mobile chạy luôn link này trong tag frame html
          },(error:any)=>{
            console.log('error', error);
          }) 
    * @param platform : "mobile"/"desktop" 
    * @param amount 
    * @param orderDescription (lưu ý chữ không dấu)
    * @param id_payment : id của hóa đơn khách hàng cần thanh toán
    * @param backHref : lấy link mà chạy khởi động lại trang 
    * @Return Promise => trả về link thanh toán vnpay
    */
    private createPaymentVnpay_Mobile(amount:number, orderDescription:string, id_payment:string, backHref:string, platform:string):any {        
      return new Promise((resolve, reject) => {  
        this.vhMGDB_paymentVNPAY.createPaymentVnpay(amount, orderDescription, id_payment, backHref)
            .then((response:any)=>{           
              //window.location = response.data; 
              resolve(response.data);
            },(error:any)=>{
              console.log('error', error);
              reject(error)
            })   
      })
    }

    /**
   * @example:
   * let data = {//truyền vào   
      date: new Date(),        
      payment_type: 5, //1 lưu (khách đã thanh toán cho vnpay); 5 lưu tạm (khách chưa thanh toán vnpay), hệ thống sẽ tự động xóa những payment này hoặc trên giao diện hiện ra cho khách tự xóa
      payment: 990.000,
      tax: 0,
      total: 990.000      
      }
    * this.vhQueryCafe.createPayment(data)
          .then((payment)=>{
            console.log('createPayment', payment);
          },(error:any)=>{
            console.log('error', error);
          })
    * payment = {//trả về
          _id, 
          payment_code, 
          id_store, 
          invalid,

          date
          payment_type, 
          payment, 
          tax, 
          total          
      }      
    * @param payment : object 
    * @return  Promise => payment = {} / error
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    * @notice : hàm này chỉ dùng tạo những payment_type mà không có phát sinh payment_detail
    */
    public createPayment(data:any){    
      return new Promise((resolve, reject) => {
        data.payment_code = this.vhAlgorithm.createPaymentCode(data?.date);
        data.id_store = this.vhMGDB_auth.getDatabase();
        this.vhMGDB_rootdatabase.addDoc('payments', data)
            .then((payment)=>{
              resolve(payment);
            },(error:any)=>{
              reject(error);
            })         
      })
    }

/**
 * @example:
 * this.vhQueryCafe.updatePayment('5fb6780ca2148e09806c5b01', {total:990000})
        .then((response)=>{
          console.log('updatePayment', response);
        }, error=>{
          console.log('error', error);
        })
  * @param id_payment 
  * @param value 
  * @return Promise => response = undefined / error
  */
  public updatePayment(id_payment:string, value:any){        
    return new Promise((resolve, reject) => {  
      this.vhMGDB_rootdatabase.updateDoc('payments', id_payment, value)
        .then((response)=>{
          resolve(response);       
        }, error=>{
          reject(error);  
        })     
    })
  }  

  /**
   * @example:
   * this.vhQueryCafe.deletePayment('5fb67fda87c0f21d484cbdf3')
        .then((response)=>{
          console.log('deleteBill', response);
        }, error=>{
          console.log(error, error);
        }) 
    * @param id_payment 
    * @return Promise => response = undefined / error
    */
  public deletePayment(id_payment:any){
    return new Promise((resolve, reject) => {
      let query = {id_payment:{$eq:id_payment}};
      this.vhMGDB_rootdatabase.getDocsByFields('payment_details', query, {}, {}, 0)
          .then((payment_details:any)=>{
            if(payment_details.length >0){
              for(let i=0; i<payment_details.length; i++){
                this.vhMGDB_rootdatabase.deleteDoc('payment_details', payment_details[i]._id);
              }
            }            
          }, error=>{
            console.log(error, error);
          })
      this.vhMGDB_rootdatabase.deleteDoc('payments', id_payment)
          .then((response)=>{
            resolve(response);          
          }, error=>{
            console.log(error, error);
          })              
    })
  }

    /**
  * @example:
  * let time = new Date();
  * time.setDate(time.getDate()-7);
  * this.vhQueryCafe.getPayments({id_store: {$eq: this.vhAuth.getUser()._id}, payment_type:{$eq:5}}, {},{},0)
        .then((payments)=>{
          console.log('getPayments', payments);
        })
  * @param query
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
  public getPayments(query: object, projection?:object, sort?:object, limit?:number) {//sửa lại hàm này vì chỉ có 1 store thôi
    return new Promise((resolve, reject) => { 
      this.vhMGDB_rootdatabase.getDocsByFields('payments', query, {}, sort, limit)
          .then((bills)=>{
            resolve(bills);
          }, error=>{
            console.log(error, error);
          })       
    })
  } 

  /**
   * @example:
   * this.vhQueryCafe.getPayment('5fb67fda87c0f21d484cbdf3')
        .then((payment)=>{
          console.log('getPayment', payment);
        })
    *  @param id_payment 
    *  @return Promise => payment ={} or null / error
    */
    public getPayment(id_payment:any) {
      return new Promise((resolve, reject) => { 
        this.vhMGDB_rootdatabase.getDoc('payments', id_payment)
            .then((response:any) => {              
                resolve(response);
              },
              (error:any) => {
                reject(error);
              }) 
      })
    } 

  
  /**
   * @example:    
    let payment_detail_main = {      
      id_branch: 'AEUWSWZXA4iHv8BmCNz2', //khách chọn
      id_payment: '5D4XGdZ2q5XLnOUa0mMx', //payment._id     
      id_restriction: 'main_package_advanced', //package.id_restriction
      id_package: 'main_package_advanced_1month', //có được khi khách chọn gói để mua
      package_type: 1,  //package.package_type,                                                                                               
      day: 31, //package.day,                                                                                           
      tax: 0, package.tax,                               
      price: 99000, package.price,
      quantity: 1, //khách chọn                        
      payment_detail_type: 1, //1: gói gia hạng mới, 2: gói nâng cấp, 3: gói kéo dài thêm thời gian                           
    }
    this.vhQueryCafe.createPayment_Detail({})
        .then((payment_detail)=>{
          console.log('createPayment_Detail', payment_detail);
        },(error:any)=>{
          console.log('error', error);
        })
    payment_detail = {
        _id, 
        id_store,
        payment_type,
        activating,
        invalid,
        date,
      
        id_branch,
        id_payment,
        id_restriction,
        id_package,
        package_type,
        payment_type,
        payment_detail_type,        
        day,
        tax,
        price,
        quantity        
    }      
    * @param data 
    * @return  Promise => response = {} / error
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */ 
    public createPayment_Detail(data:any):any {      
      return new Promise((resolve, reject) => {
        if((data.id_payment != undefined) && (data.id_payment != null)){
          this.vhMGDB_rootdatabase.getDoc('payments', data.id_payment)
              .then((payment:any)=>{
                  let _data = data;     
                  _data.activating = false;  
                  _data.invalid = false;       
                  _data.date = payment.date;    
                  if(payment.id_store) _data.id_store = payment.id_store;  
                  if(typeof payment.payment_type == 'number') _data.payment_type = payment.payment_type;                                
                  
                  this.vhMGDB_rootdatabase.addDoc('payment_details', _data)
                      .then((payment_detail)=>{                      
                        resolve(payment_detail);
                      },(error:any)=>{
                        reject(error);
                      })   
                  
              },(error:any)=>{
              console.log('error', error);
              })
        }else{
          console.log('error', 'không tồn tại id_bill trong data');
        } 
              
      })
    }  
  
    /**
     * @example:
     * this.vhQueryCafe.updatePayment_Detail('5fb6780ca2148e09806c5b01', {name:'Khuyến mãi 12/12'})
            .then((response)=>{
              console.log('updatePayment_Detail', response);          
            },(error:any)=>{
              reject(error);
            }) 
      * @param id_payment_detail 
      * @param value 
      * @return Promise => response = undefined / error
      */
    public updatePayment_Detail(id_payment_detail:string, value:object){    
      return new Promise((resolve, reject) => {
        this.vhMGDB_rootdatabase.updateDoc('payment_details', id_payment_detail, value)
            .then((response)=>{
              resolve(response);
            },(error:any)=>{
              reject(error);
            })         
      })
    }

  /**
  * @example:
  * let time = new Date();
  * time.setDate(time.getDate()-7);
  * this.vhQueryCafe.getPayment_details({id_payment:{$eq:'5fb67fda87c0f21d484cbdf3'}}, {},{},0)
        .then((payment_details)=>{
          console.log('getPayment_details', payment_details);
        })
  * @param query
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return Promise Array => array = [{},{},...] / error 
  */
  public getPayment_details(query: object, projection?:object, sort?:object, limit?:number) {//sửa lại hàm này vì chỉ có 1 store thôi
    return new Promise((resolve, reject) => { 
      this.vhMGDB_rootdatabase.getDocsByFields('payment_details', query, {}, sort, limit)
          .then((payment_details)=>{
            resolve(payment_details);
          }, error=>{
            console.log(error, error);
          })       
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.getPayment_detail('5fb67fda87c0f21d484cbdf3')
        .then((payment_detail)=>{
          console.log('getPayment_detail', payment_detail);
        })
    *  @param id_payment_detail 
    *  @return Promise => payment_detail ={} or null / error
    */
    public getPayment_detail(id_payment_detail:any) {
      return new Promise((resolve, reject) => { 
        this.vhMGDB_rootdatabase.getDoc('payment_details', id_payment_detail)
            .then((response:any) => {              
                resolve(response);
              },
              (error:any) => {
                reject(error);
              }) 
      })
    }
  
  /**
   * @example:
   * this.vhQueryCafe.deletePayment_Detail('5fb67fda87c0f21d484cbdf3')
        .then((response)=>{
          console.log('deletePayment_Detail', response);
        },(error:any)=>{
          reject(error);
        })
    * @param id_payment_detail 
    * @return Promise => Promise => response = undefined / error
    */
  public deletePayment_Detail(id_payment_detail:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_rootdatabase.deleteDoc('payment_details', id_payment_detail)
          .then((bool:any)=>{            
            resolve(bool);
          },(error:any)=>{
            reject(error);
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.getPackage('5fb67fda87c0f21d484cbdf3')
        .then((package)=>{
          console.log('getPackage', package);
        })
    *  @param id_package 
    *  @return Promise => package ={} or null / error
    */
    public getPackage(id_package:any) {
      return new Promise((resolve, reject) => { 
        this.vhMGDB_rootdatabase.getDoc('packages', id_package)
            .then((response:any) => {              
                resolve(response);
              },
              (error:any) => {
                reject(error);
              }) 
      })
    }

/**
* @example:
* this.vhQueryCafe.extendLicenseValidaty_byLicenseKEY('5fb6780ca2148e09806c5b01', '674fd94a9ace7267deb685fd')
       .then((response)=>{
         console.log('extendLicenseValidaty_byLicenseKEY', response);
       }, error=>{
         console.log('error', error);
       })
 * @param id_branch 
 * @param id_licenseKEY 
 * @return Promise => response = {vcode, msg}
 * vcode = 0: gia hạn thành công
 * vcode = 1: id_licenseKEY không thuộc về Store
 * vcode = 2: id_licenseKEY đã được kích hoạt trước đây
 * vcode = 3: id_licenseKEY đã bị vô hiệu hóa trước đây
 */
 public extendLicenseValidaty_byLicenseKEY(id_branch:string, id_licenseKEY:string){       
   return new Promise((resolve, reject) => {       
     this.vhMGDB_rootdatabase.getDoc('licenseKEYs', id_licenseKEY)
         .then((licenseKEY:any) => {   
             if(licenseKEY){
               if(licenseKEY?.id_store != this.vhMGDB_auth.getStore()._id) return reject({error:`${id_licenseKEY} không thuộc shop`});  
               this.vhMGDB_auth.extendLicenseValidaty_byLicenseKEY_byShop(id_branch, id_licenseKEY)
                   .then((rsp)=>{
                     resolve(rsp);             
                   }, error=>{                      
                     reject(error);
                   })
             }else reject({error:`${id_licenseKEY} không tìm thấy licenseKEY`});                          
           },
           (error:any) => {
             reject(error);
           }) 
       
   })
 } 
 
 /**
 * @example:
 * let time = new Date();
 * time.setDate(time.getDate()-7);
 * this.vhQueryCafe.getLicenseKEYs({payment_type:{$eq:5}}, {},{},0)
       .then((payments)=>{
         console.log('getLicenseKEYs', payments);
       })
 * @param query
 * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
 * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
 * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
 * @return — Array -> array = [{},{},...] 
 */
 public getLicenseKEYs(query: any, projection?:object, sort?:object, limit?:number) {
   return new Promise((resolve, reject) => {       
     if(!this.vhMGDB_auth.getStore()._id) reject('bạn chưa đăng nhập');
     query.id_store = {$eq:this.vhMGDB_auth.getStore()._id} ;
     this.vhMGDB_rootdatabase.getDocsByFields('licenseKEYs', query, {}, sort, limit)
         .then((bills)=>{
           resolve(bills);
         }, error=>{
           console.log(error, error);
         })       
   })
 }

  /**
 * Lấy về danh sách các ngân hàng (kèm logo) mà vietqr hỗ trợ tạo mã QR
 * @example:
 * this.vhQueryCafe.vietqr_getBanks()
        .then((rsp:any)=>{
          if(rsp.vcode === 0){            
          }
        }, error=>{
          console.log(error)
        })
  * @returns Promise => rsp ={vcode, msg, data(array)} / error
  * vcode == 0: success
  */
  public vietqr_getBanks(){
    return new Promise((resolve, reject) => {  
      axios.get('https://api.vietqr.io/v2/banks')
          .then((response:any)=> {                        
            if(response.data.code == '00')  resolve({vcode:0, msg:response.data.desc, data: response.data.data});
            else resolve({code:1, msg:response.data.desc, data: null});
          })
          .catch((e:any)=> {                          
            reject(e.response.data);
          });
    })
  }
  
 /**
  * Tạo mã QR cho Shop quét thanh toán vào tài khoản ngân hàng đã đăng ký Casso
  * @example:
  * this.vhQueryCafe.vietqr_generateQR('0909925354', 'LE DUC HUY', '970422', 'compact2', '674fd94a9ace7267deb685fd', 99000)
         .then((rsp:any)=>{
           if(rsp.vcode === 0){            
           }
         }, error=>{
           console.log(error)
         })
   * @param accountNo: số tài khoản ngân hàng
   * @param accountName: tên chủ tài khoản
   * @param acqId: mã bin của ngân hàng (lấy từ hàm vietqr_getBanks())
   * @param template: compact2, compact, qr_only, print
   + compact2:	540x640	Bao gồm : Mã QR, các logo , thông tin chuyển khoản
   + compact:	540x540	QR kèm logo VietQR, Napas, ngân hàng
   + qr_only:	480x480	Trả về ảnh QR đơn giản, chỉ bao gồm QR
   + print:	600x776	Bao gồm : Mã QR, các logo và đầy đủ thông tin chuyển khoản
   * @param id_bill: _id của đơn hàng
   * @param amount: tổng tiền khách phải thanh toán
   * @returns Promise => rsp ={vcode, msg, data(img_base64)} / error
   * vcode == 0: success
   */
   public vietqr_generateQR(accountNo:string, accountName:string, acqId:string, template:string, id_payment:string, amount:number){
     return new Promise((resolve, reject) => {       
       let data = {
         accountNo,
         accountName,
         acqId,
         template,
         format: "text",
         amount,
       }      
       let projectname_code = "-1"; //ko phải là mã của dự án nào cả
       if(this.vhMGDB_auth.getProjectName()  === 'vhsales') projectname_code = "2";
       else if(this.vhMGDB_auth.getProjectName()  === 'bvhsales') projectname_code = "3";
       else if(this.vhMGDB_auth.getProjectName()  === 'vhcafe') projectname_code = "4";
       //let addInfo =  btoa(this.vhMGDB_auth.getProjectName() + "||" + "payer_store" + "||" + id_payment);
       //"2" là dự án vhsales
       let addInfo = projectname_code + "|" + "PS" + "|" + id_payment; //project + "|" + "payer_store" + "|" + id_payment
       //Lấy mảng ký tự gồm những ký tự mà không tồn tại trong chuỗi addInfo
       const allChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"; //mở rộng sẽ làm thêm cho sô '0123456789'
       let missingChars = allChars.split("").filter(char => !addInfo.includes(char));
       let lowerCaseMap = new Map();
       // Đếm số lần xuất hiện của mỗi ký tự (không phân biệt hoa/thường)
       for (let char of missingChars) {
           let lowerChar = char.toLowerCase();
           lowerCaseMap.set(lowerChar, (lowerCaseMap.get(lowerChar) || 0) + 1);
       }
       // Chỉ giữ lại những phần tử xuất hiện từ 2 lần trở lên (không phân biệt hoa/thường)
       missingChars =  missingChars.filter(char => lowerCaseMap.get(char.toLowerCase()) > 1);
       //Xóa tất cả các ký thường chỉ giữ lại ký tự hoa và sô
       missingChars = missingChars.filter(char => char >= 'A' && char <= 'Z');
       //missingChars phải có ít nhất 2 phần tử mới làm thuật toán đc, đó làm mã hóa ký tự "|" và đánh dấu các chuỗi thương
       if(missingChars.length <2) return reject({vcode:1, msg:'no success'})
       //Thay thế tất cả ký tự '|' thành ký tự số missingChars[0]
       addInfo = addInfo.replace(/\|/g, missingChars[1]);     
       //Thêm 1 ký tự vào trước và sau các chuỗi ký tự thường hoặc vừa số vưa chữ thường nắm trong chuỗi cha addInfo
       addInfo = addInfo.replace(/([a-z0-9]*[a-z]+[a-z0-9]*)/g, missingChars[0] + '$&' + missingChars[0]);
       //Đổi các ký tự trong chuỗi addInfo sang chữ hoa
       //addInfo = addInfo.toUpperCase();
       //Thêm vào đầu chuỗi addInfo 1 ký tự số
       addInfo = missingChars[1] + addInfo;
       //Thêm vào đầu chuỗi addInfo 1 ký tự số
       addInfo = missingChars[0] + addInfo;  
       //if(this.vhAuth.getDBstorage() === 'mongo'){        
         axios.post('https://api.vietqr.io/v2/generate', {...data, addInfo})
             .then((response:any)=> {      
               if(response.data.code == '00')  resolve({vcode:0, msg:response.data.desc, data: response.data.data.qrDataURL});
               else resolve({code:1, msg:response.data.desc, data: null});
             })
             .catch((e:any)=> {                          
               reject(e.response.data);
             });
       //}     
     })
   }

    private publishObservableEventPromotions() {
      this.subjectpromotions.next(this.promotions);
    }  
  
    private observableLocalPromotions():Subject<any> {      
      return this.subjectpromotions; 
    }
    
     /**
     * @example:
     * this.observablePromotion = this.vhQueryCafe.getObservableLocalPromotions().subscribe((localPromotions:any) => {          
          do something... 
       })       
      
      ngOnDestroy(){
        this.observablePromotion.unsubscribe();    
      }
     * @returns Observerble (Array) => Array(object) => array = [{},{},...]
     */
    public getObservableLocalPromotions(){   
     return new Observable((observer:any) => {    
      this.observableLocalPromotions().subscribe((promotions) => {   
        observer.next(promotions);
      })
      this.publishObservableEventPromotions();
     })
    }
  
   /**
   * @example: 
   * let promotion = this.vhQueryCafe.getlocalPromotion('5fb6780ca2148e09806c5b01');
   * @param id_promotion 
   * @return Object => obj = {} or null
   */
  public getlocalPromotion(id_promotion:any){
    for(let i=0; i<this.promotions.length; i++){
      if(this.promotions[i]._id === id_promotion){
        return this.suppliers[i];
        break;
      }
    } 
    return null; 
  }


   /**
   * @example: 
   * let promotions = this.vhQueryCafe.getlocalPromotions();
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalPromotions(){
    return this.promotions;
  }

   /**
   * @example:
   * this.vhQueryCafe.refreshLocalPromotions()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalPromotion(), getlocalPromotions() trong localstorage
   * @return Promise => null
   */
  public refreshLocalPromotions():any{
     return new Promise((resolve, reject) => { 
      // this.getPromotions()
      //     .then(()=>{resolve(null)})    
      resolve(null)  
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.addPromotion({name:'Cuối tuần vui vẻ', type:2, active:true, date_start:new Date(), date_end: new Date()})
          .then((promotion)=>{
            console.log('addPromotion', promotion);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addPromotion(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('promotions', data)
          .then((promotion)=>{
            resolve(promotion);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updatePromotion('5fb6780ca2148e09806c5b01', {name:'Khuyến mãi 12/12'})
          .then((bool:any)=>{
            console.log('updatePromotion', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_promotion 
   * @param data 
   * @return Promise => bool = true or false
   */
  public updatePromotion(id_promotion:string, data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.updateDoc('promotions', id_promotion, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }
  

  /**
   * @example:
   * this.vhQueryCafe.deletePromotion('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deletePromotion', bool);
        })
   * @param id_promotion 
   * @return Promise => bool = true or false 
   */
  public deletePromotion(id_promotion:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('promotions', id_promotion)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getPromotion('5fb67fda87c0f21d484cbdf3')
            .then((promotion)=>{
              console.log('getPromotion', promotion);
            })
   * @param id_promotion 
   * @return false or object
   */
  public getPromotion(id_promotion:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('promotions', id_promotion)
            .then((promotion)=>{
              resolve(promotion);
            })          
    })
  }
  
  /**
   * @example
   * this.vhQueryCafe.getPromotions()
            .then((response)=>{
              console.log('getPromotions', response);
            })
   * @return array(object) = [{},{},..]
   */
  public getPromotions(){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDocs('promotions')
            .then((response)=>{
              this.promotions = response;
              resolve(response);
            })          
    })
  } 
  
  /**
 * @example:
 * this.vhQueryCafe.addPromotion_detail({name:'promition 1'})
        .then((promotion_details)=>{
          console.log('promotion_details', promotion_details);
        },(error:any)=>{
          console.log('error', error);
        })
  * @param colname 
  * @param data 
  * @return  Promise => obj = {}
  * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
  */
  public addPromotion_detail(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('promotion_details', data)
          .then((promotion_details)=>{
            resolve(promotion_details);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updatePromotion_detail('5fb6780ca2148e09806c5b01', {name:'promoiton 2'})
          .then((bool:any)=>{
            console.log('updatePromotion_detail', bool);
          })
   * @param id_promotion 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updatePromotion_detail(id_promotion:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('promotion_details', id_promotion, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.id_promotion_detail('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('id_promotion_detail', bool);
        })
   * @param id_promotion_detail 
   * @return Promise => bool = true or false 
   */
  public deletePromotion_detail(id_promotion_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('promotion_details', id_promotion_detail)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
 
  /**
   * @example
   * this.vhQueryCafe.getPromotion_detail('5fb67fda87c0f21d484cbdf3')
            .then((promotion)=>{
              console.log('getPromotion_detail', promotion);
            })
   * @param id_promotion 
   * @return false or object
   */
  public getPromotion_detail(id_promotion:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('promotion_details', id_promotion)
            .then((promotion)=>{
              resolve(promotion);
            })          
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getPromotion_details()
            .then((response)=>{
              console.log('getPromotion_details', response);
            })
   * @return array(object) = [{},{},..]
   */
  public getPromotion_details(){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDocs('promotion_details')
            .then((response)=>{              
              resolve(response);
            })          
    })
  } 
  
  

  //Promotions and promotion_details
  /**
   * @example
    let promotion ={       
      name: "Chuong Trinh Giam Gia 10",
      date_start: new Date(),
      date_end: new Date()         
    }
    let promotion_details =[{
      barcode: '01435438426',
      id_product: 'pro001',
      id_sub_product: 'pro00105',
      new_price: 10000,
      type: 1
    },{
      barcode: '0989070707786',
      id_product: 'pro002',
      id_sub_product: 'pro00201',
      new_price: 20000,
      type: 2
    }]
    this.vhQueryCafe.addPromotion_Promotiondetail(promotion, promotion_details)
        .then((bill:any)=>{
          console.log(bill._id);
        },(error:any)=>{
          console.log('error ', error);
        })
   * @param promotion 
   * @param promotion_details   
   *  Promise Object => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addPromotion_Promotiondetail(promotion:any, promotion_details:any):any{       
     return new Promise((resolve, reject) => {    
      this.vhMGDB_database.addDoc('promotions', promotion)
          .then((promotion_get:any)=>{            
            let promise = new Array();
            for(let i=0; i<promotion_details.length; i++){
              let data = promotion_details[i];
              data.id_promotion = promotion_get._id;
              promise[i] = this.vhMGDB_database.addDoc('promotion_details', data)                  
            }
            Promise.all(promise)
                  .then(() => { 
                    resolve(promotion_get);
                  })
                  .catch(error => { 
                    reject(error)
                  })
          },(error:any)=>{
            reject(error);
          })           
    })
  }

  /**
   * @example:
   * this.vhQueryCafe.updatePromotion_Promotiondetail('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updatePromotion_Promotiondetail', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_promotion 
   * @param promotion 
   * @param promotion_details  
   * @return Promise => bool = true or false
   */
  public updatePromotion_Promotiondetail(id_promotion:any, promotion:any, promotion_details:any):any {    
     return new Promise((resolve, reject) => { 
      this.vhMGDB_database.getDocsByFields('promotion_details', {id_promotion:{$eq:id_promotion}},{},{},0)
          .then((promotion_details_get:any)=>{  
            let promise = new Array();        
            for(let i=0; i<promotion_details_get.length; i++){
              promise[i] = this.vhMGDB_database.deleteDoc('promotion_details', promotion_details_get[i]._id);             
            }   
            let data = {...promotion};                                                        
            promise[promotion_details_get.length] = this.vhMGDB_database.updateDoc('promotions', id_promotion, data);

            for(let i=0; i<promotion_details.length; i++){
              let data_2 = promotion_details[i];
              data_2.id_promotion = id_promotion;
              promise[i+promotion_details_get.length+1] = this.vhMGDB_database.addDoc('promotion_details', data_2);                  
            }
            Promise.all(promise)
              .then(() => { 
                resolve(true);
              })
              .catch(error => { 
                reject(error)
              })

          }) 
          .catch(()=>{
            resolve(false);
          })                 
    })  
  }

  /**
   * @example:
   * this.vhQueryCafe.deletePromotion_Promotiondetail('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deletePromotion_Promotiondetail', bool);
        })
   * @param id_promotion 
   * @return Promise => bool = true or false 
   */
  public deletePromotion_Promotiondetail(id_promotion:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('promotion_details', {id_promotion:{$eq:id_promotion}},{},{},0)
            .then((promotion_details:any)=>{
              let promise = new Array();        
              for(let i=0; i<promotion_details.length; i++){
                promise[i] = this.vhMGDB_database.deleteDoc('promotion_details', promotion_details[i]._id);             
              }                                                                                              
              promise[promotion_details.length] = this.vhMGDB_database.deleteDoc('promotions', id_promotion);
              Promise.all(promise)
                    .then(() => { 
                      resolve(true);
                    })
                    .catch(error => { 
                      reject(error)
                    })
              
            }) 
            .catch(()=>{
              resolve(false);
            })   
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getPromotion_details_byId_promotion()
            .then((promotion_details)=>{
              console.log('promotion_details', promotion_details);
            })
   * @return array(object) = [{},{},..]
   */
  public getPromotion_details_byId_promotion(id_promotion:any){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDocsByFields('promotion_details', {id_promotion:{$eq:id_promotion}},{},{},0)
              .then((promotion_details:any)=>{
                resolve(promotion_details);
              }) 
              .catch(()=>{
                resolve(false);
              })
    })  
  }


  /**
   * 
   * @param starttime 
   * @param endtime 
   * @param array_IDproduct 
   * @return Promise Array => array.length == 0 hợp lệ, được phép tạo promotion;  array.length > 0 không hợp lệ, không được phép tạo promotion
   */
  public checkNewPromotion(starttime:any, endtime:any, array_IDproduct:any){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.getDocs('promotions')
          .then((promotions:any)=>{            
            let array_promotion_id = new Array();
            let duplicates = new Array;
            if(promotions.length > 0){
              for(let i=0; i<promotions.length; i++){                
                if(new Date(starttime) < new Date(promotions[i].date_start)){
                  if(new Date(endtime) >= new Date(promotions[i].date_start)){
                    array_promotion_id.push(promotions[i]._id);                                       
                  }                  
                }else if ((new Date(starttime) >= new Date(promotions[i].date_start))&&(new Date(starttime) <= new Date(promotions[i].date_end))){
                  array_promotion_id.push(promotions[i]._id);                                     
                }
              }
              
              if(array_promotion_id.length >0){
                this.vhMGDB_database.getDocsByFields('promotion_details', {id_promotion:{$in:array_promotion_id}},{},{},0)
                    .then((promotion_details:any)=>{                                        
                      if(promotion_details.length){                      
                        for(let i=0; i<array_IDproduct.length; i++){
                          for(let j=0; j<promotion_details.length; j++){
                            if(array_IDproduct[i] === promotion_details[j].id_product){
                              duplicates.push(array_IDproduct[i]);
                              break;
                            }
                          }
                        }                        
                        resolve(duplicates);
                      }else resolve(duplicates);  
                    }) 
                    .catch((e)=>{
                      reject(e);
                    })                
              }else resolve(duplicates);  
            }else resolve(duplicates);
          },(error:any)=>{
            console.log('error', error);
          })      
    })
  }

  /**
   * 
   * @param starttime 
   * @param endtime 
   * @param array_IDproduct 
   * @param id_promotion 
   * @return Promise Array => array.length == 0 hợp lệ, được phép cập nhật promotion;  array.length > 0 không hợp lệ, không được phép cập nhật promotion
   */
  public checkOldPromotion(starttime:any, endtime:any, array_IDproduct:any, id_promotion: any){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.getDocs('promotions')
          .then((promotions:any)=>{  
            let array_promotion_id = new Array();
            let duplicates = new Array;
            if(promotions.length>0){
              for(let i=0; i<promotions.length; i++){
                if(new Date(starttime) < new Date(promotions[i].date_start)){
                  if(new Date(endtime) >= new Date(promotions[i].date_start)){
                    if(promotions[i]._id != id_promotion) array_promotion_id.push(promotions[i]._id);                                       
                  }                  
                }else if ((new Date(starttime) >= new Date(promotions[i].date_start))&&(new Date(starttime) <= new Date(promotions[i].date_end))){
                  if(promotions[i]._id != id_promotion) array_promotion_id.push(promotions[i]._id);                                     
                }
              }
              
              if(array_promotion_id.length >0){
                this.vhMGDB_database.getDocsByFields('promotion_details', {id_promotion:{$in:array_promotion_id}},{},{},0)
                    .then((promotion_details:any)=>{   
                      if(promotion_details.length>0){                      
                        for(let i=0; i<array_IDproduct.length; i++){
                          for(let j=0; j<promotion_details.length; j++){
                            if(array_IDproduct[i] === promotion_details[j].id_product){
                              duplicates.push(array_IDproduct[i]);
                              break;
                            }
                          }
                        }
                        resolve(duplicates);
                      }else resolve(duplicates);  
                    },(error:any)=>{
                      console.log('error', error);
                    })                
              }else resolve(duplicates);  
            }else resolve(duplicates); 
          })   
     
    })
  }

   
  private publishObservableEventAppSettingNameStations() {
    this.subjectappsettingstations.next();
  }  

  private observableLocalAppSettingNameStations():Subject<any> {      
    return this.subjectappsettingstations; 
  }
  
   /**
    * Các hàm AppSettingNameStations thêm, xóa, sửa, lấy về thông tin (dạng object) riêng giữa các thiết bi, như: thông tin máy in
   * @example:
   * this.observableAppSetting = this.vhQueryCafe.getObservableLocalAppSettingNameStations().subscribe(() => {          
        let info_header_footer_bill = this.vhQueryCafe.getLocalAppSettingNameStation('info_header_footer_bill');
        console.log(info_header_footer_bill);
     })       
    
    ngOnDestroy(){
      this.observableAppSetting.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalAppSettingNameStations(){   
   return new Observable((observer:any) => {    
    this.observableLocalAppSettingNameStations().subscribe(() => {   
      // let list = new Array();
      // for(let i =0; i<this.appsettingstations.length; i++){
      //   list.push(this.appsettingstations[i].appsetting_name);
      // }     
      // observer.next(list);
      observer.next(null);
    })
    this.publishObservableEventAppSettingNameStations();
   })
  }
  
  /**
  *@example:
    this.vhQueryCafe.getLocalAppSettingNameStations()
        .then((list)=>{
            console.log(list);
          })  
  * @return object => list of appsetting_names
  */
 public getLocalAppSettingNameStations(){  
  let list = new Array();
  for(let i =0; i<this.appsettingstations.length; i++){
    list.push(this.appsettingstations[i].appsetting_name);
  }
  return list;     
}

/**
 * @example:
  let appsetting = this.vhQueryCafe.getLocalAppSettingNameStation('info_header_footer_bill');
  console.log(appsetting);
 * @param appsetting_name   
 * @return object => {title:'title',name:'name', quantity: 10}
 */
public getLocalAppSettingNameStation(appsetting_name:any){  
  let obj:any = {};   
  for(let i =0; i<this.appsettingstations.length; i++){
    if(this.appsettingstations[i].appsetting_name === appsetting_name){
      obj = {...this.appsettingstations[i]};
      delete obj._id;
      delete obj.appsetting_name;   
      break;   
    }        
  }
  return obj;
}

 /**
   * @example: 
   * let appsetting = this.vhQueryCafe.getLocalAppSettingStation('5fb6780ca2148e09806c5b01');
   * @param id_appsetting 
   * @return Object => obj = {} or null
   */
  private getLocalAppSettingStation(id_appsetting:any){
    for(let i=0; i<this.appsettingstations.length; i++){
      if(this.appsettingstations[i]._id === id_appsetting){
        return this.appsettingstations[i];      
      }
    } 
    return null;        
  }

/**
 * Hàm này refresh giá trị mới nhất cho hàm getLocalAppSettingNameStations(), getLocalAppSettingNameStation() trong localstorage
 * @return Promise => null
 */
private refreshLocalAppSettingNameStations():any{
  return new Promise((resolve, reject) => { 
    // this.getAppSettingStations().then(()=>{resolve(null)})   
    resolve(null)   
  })
}

/**
 * @example
 * this.vhQueryCafe.getAppSettingStations()
          .then((settings)=>{
            console.log('getAppSettings', settings);
          })
  * @return Promise => array(object) = [{},{},..]
  */
private getAppSettingStations():any{
  return new Promise((resolve, reject) => {      
    this.vhMGDB_database.getDocsByFields('appsettingstations',{uuid: {$eq: this.hwinfo.uuid}},{},{},0)
          .then((appsettingstations:any)=>{
            if(appsettingstations.length>0){      
              this.appsettingstations = appsettingstations;  
            }
            resolve(null);
          },(error:any)=>{
            reject(error);
          })          
  })  
}

/**
 * @example:
  this.vhQueryCafe.updateAppSettingNameStation('info_header_footer_bill',{title:'title',name:'name'})
      .then((bool:any)=>{
        console.log(bool);
      })       
 * @param appsetting_name 
 * @param value 
 * @format value = {title:'title',name:'name'} 
 * @return Promise Boolean => bool = true or false 
 */ 
public updateAppSettingNameStation(appsetting_name:any, value:any) {
  return new Promise((resolve,reject) => {    
    this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid: {$eq: this.hwinfo.uuid}},{},{},0)
        .then((appsettingstations:any)=>{
             if(appsettingstations.length>0){               
              this.vhMGDB_database.updateDoc('appsettingstations', appsettingstations[0]._id, value)
                  .then((bool:any)=>{
                    resolve(bool);                   
                  }, error=>{
                    reject(error)
                  })     
             }else{
               let obj:any = {...value};
               obj.appsetting_name = appsetting_name;               
               obj.uuid = this.hwinfo.uuid;
               this.vhMGDB_database.addDoc('appsettingstations',obj)
                    .then(()=>{
                      resolve(true);
                    }, error=>{
                      reject(error)
                    }) 
             }
        })              
  })  
}
 

/**
 * @example
 * this.vhQueryCafe.deleteAppSettingNameStation('info_header_footer_bill')
      .then((bool:any)=>{
        console.log(bool); 
      })
 * @param appsetting_name 
 * @return Promise Boolean => bool = true or false 
 */
public deleteAppSettingNameStation(appsetting_name:any) {
  return new Promise((resolve, reject) => {
    this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid:{$eq:this.hwinfo.uuid}},{},{},0)
        .then((appsettingstations:any)=>{
            if(appsettingstations.length>0){               
              this.vhMGDB_database.deleteDoc('appsettingstations', appsettingstations[0]._id)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })              
            }else resolve(false);
          })            
  })     
}

private publishObservableEventAppSettingNameBranchs() {
  this.subjectappsettingbranchs.next();
}  

private observableLocalAppSettingNameBranchs():Subject<any> {      
  return this.subjectappsettingbranchs; 
}

 /**
  * Các hàm AppSettingNameBranchs thêm, xóa, sửa, lấy vê thông tin (dạng object) riêng giữa các chi nhánh, như: thông tin cửa hàng
 * @example:
 * this.observableAppSettingName = this.vhQueryCafe.getObservableLocalAppSettingNameBranchs().subscribe(() => {          
      let store_info = this.vhQueryCafe.getLocalAppSettingNameBranch('store_info');
      console.log(store_info);
   })       
  
  ngOnDestroy(){
    this.observableAppSettingName.unsubscribe();    
  }
 * @returns Observerble (Array) => Array(object) => array = [{},{},...]
 */
public getObservableLocalAppSettingNameBranchs(){   
 return new Observable((observer:any) => {    
  this.observableLocalAppSettingNameBranchs().subscribe(() => {    
    observer.next(null);
  })
  this.publishObservableEventAppSettingNameBranchs();
 })
}

/**
 * Hàm này dùng lấy về tất cả phân quyền ở cấp độ chi nhánh
*@example:
  this.vhQueryCafe.getLocalAppSettingNameBranchs()
      .then((list)=>{
          console.log(list);
        })  
* @return object => list of appsetting_names
*/
public getLocalAppSettingNameBranchs(){  
let list = new Array();
for(let i =0; i<this.appsettingbranchs.length; i++){
  list.push(this.appsettingbranchs[i].appsetting_name);
}
return list;     
}

/**
 * Hàm này dùng lấy về phân quyền ở cấp độ chi nhánh
* @example:
let appsetting = this.vhQueryCafe.getLocalAppSettingNameBranch('info_header_footer_bill');
console.log(appsetting);
* @param appsetting_name   
* @return object => {title:'title',name:'name', quantity: 10}
*/
public getLocalAppSettingNameBranch(appsetting_name:any){  
let obj:any = {};   
for(let i =0; i<this.appsettingbranchs.length; i++){
  if(this.appsettingbranchs[i].appsetting_name === appsetting_name){
    obj = {...this.appsettingbranchs[i]};
    delete obj._id;
    delete obj.appsetting_name;   
    break;   
  }        
}
return obj;
}

/**
 * @example: 
 * let appsetting = this.vhQueryCafe.getLocalAppSettingBranch('5fb6780ca2148e09806c5b01');
 * @param id_appsetting 
 * @return Object => obj = {} or null
 */
private getLocalAppSettingBranch(id_appsetting:any){  
  for(let i=0; i<this.appsettingbranchs.length; i++){
    if(this.appsettingbranchs[i]._id === id_appsetting){
      return this.appsettingbranchs[i];      
    }
  } 
  return null;        
}

 

/**
 * Hàm này dùng cập nhật phân quyền ở cấp độ chi nhánh
* @example:
this.vhQueryCafe.updateAppSettingNameBranch('info_header_footer_bill',{title:'title',name:'name'})
    .then((bool:any)=>{
      console.log(bool);
    })       
* @param appsetting_name 
* @param value 
* @format value = {title:'title',name:'name'} 
* @return Promise Boolean => bool = true or false 
*/ 
public updateAppSettingNameBranch(appsetting_name:any, value:any) {
return new Promise((resolve,reject) => {    
  this.vhMGDB_database.getDocsByFields('appsettingbranchs',{appsetting_name:{$eq:appsetting_name}, id_branch: {$eq: this.getDefaultBranch()._id}},{},{},1)
      .then((appsettingbranchs:any)=>{
           if(appsettingbranchs.length>0){               
            this.vhMGDB_database.updateDoc('appsettingbranchs', appsettingbranchs[0]._id, value)
                .then((bool:any)=>{
                  resolve(bool);                   
                }, error=>{
                  reject(error)
                })     
           }else{
             let obj:any = {...value};
             obj.appsetting_name = appsetting_name;               
             obj.id_branch = this.getDefaultBranch()._id;
             this.vhMGDB_database.addDoc('appsettingbranchs',obj)
                  .then(()=>{
                    resolve(true);
                  }, error=>{
                    reject(error)
                  }) 
           }
      })              
})  
}


/**
* @example
* this.vhQueryCafe.deleteAppSettingNameBranch('info_header_footer_bill')
    .then((bool:any)=>{
      console.log(bool); 
    })
* @param appsetting_name 
* @return Promise Boolean => bool = true or false 
*/
public deleteAppSettingNameBranch(appsetting_name:any) {
  return new Promise((resolve, reject) => {
    this.vhMGDB_database.getDocsByFields('appsettingbranchs',{appsetting_name:{$eq:appsetting_name}, id_branch:{$eq:this.getDefaultBranch()._id}},{},{},0)
        .then((appsettingbranchs:any)=>{
            if(appsettingbranchs.length>0){               
              this.vhMGDB_database.deleteDoc('appsettingbranchs', appsettingbranchs[0]._id)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })              
            }else resolve(false);
          })            
  })     
}


  /**
   * @Usage : Hàm này lấy về tiền chiết khấu trên tổng giá trị hàng hóa bán ra của mỗi đơn hàng theo hạng khách mua hàng
   * @example :
   * let discount = this.vhQueryCafe.getDiscount_bill_byCustomer(43000000, '7YLcm0cFKLu2KaQQ8cyv');
   * @param total_price : Tổng giá
   * @param id_customer 
   * @returns Object or null  => obj = {discount}, discount là số tiền đc chiết khấu,
   * trả về null nghĩa là khách hàng này không có chiết khấu theo hóa đơn
   */ 
   public getDiscount_bill_byCustomer(total_price: number, id_customer:any){      
    let customer = this.getlocalCustomer(id_customer);
    let discount_bills:any = this.getlocalDiscount_bills();
    let customer_classs:any = this.getlocalCustomerClasss();
    let data = null;
    for(let j=0; j<customer_classs.length; j++){     
      if(customer_classs[j]._id === customer.id_customer_class){     
        if((customer_classs[j].id_discount_bill != undefined)&&(customer_classs[j].id_discount_bill != null)){   
              for(let k=0; k<discount_bills.length; k++){
                if(discount_bills[k]._id === customer_classs[j].id_discount_bill){  
                  data = {
                    discount: 0          
                    //type: discount_bills[k].type
                  };  
                  if(discount_bills[k].method === 1){//theo từng mức
                    if(((discount_bills[k].level5.sales != 0)||(discount_bills[k].level5.discount != 0)) && (total_price >= discount_bills[k].level5.sales)){                                      
                      if(discount_bills[k].type === 1) {              
                        data.discount = data.discount + (discount_bills[k].level2.sales - discount_bills[k].level1.sales) * discount_bills[k].level1.discount/100;
                        data.discount = data.discount + (discount_bills[k].level3.sales - discount_bills[k].level2.sales) * discount_bills[k].level2.discount/100;
                        data.discount = data.discount + (discount_bills[k].level4.sales - discount_bills[k].level3.sales) * discount_bills[k].level3.discount/100;
                        data.discount = data.discount + (discount_bills[k].level5.sales - discount_bills[k].level4.sales) * discount_bills[k].level4.discount/100;
                        data.discount = data.discount + (total_price - discount_bills[k].level5.sales) * discount_bills[k].level5.discount/100;
                      }else if(discount_bills[k].type === 2) {
                        data.discount =                 discount_bills[k].level1.discount; 
                        data.discount = data.discount + discount_bills[k].level2.discount; 
                        data.discount = data.discount + discount_bills[k].level3.discount; 
                        data.discount = data.discount + discount_bills[k].level4.discount; 
                        data.discount = data.discount + discount_bills[k].level5.discount; 
                      }
                    }else if(((discount_bills[k].level4.sales != 0)||(discount_bills[k].level4.discount != 0)) && (total_price >= discount_bills[k].level4.sales)){                                      
                      if(discount_bills[k].type === 1) {              
                        data.discount = data.discount + (discount_bills[k].level2.sales - discount_bills[k].level1.sales) * discount_bills[k].level1.discount/100;
                        data.discount = data.discount + (discount_bills[k].level3.sales - discount_bills[k].level2.sales) * discount_bills[k].level2.discount/100;
                        data.discount = data.discount + (discount_bills[k].level4.sales - discount_bills[k].level3.sales) * discount_bills[k].level3.discount/100;                    
                        data.discount = data.discount + (total_price - discount_bills[k].level4.sales) * discount_bills[k].level4.discount/100;
                      }else if(discount_bills[k].type === 2) {
                        data.discount =                 discount_bills[k].level1.discount; 
                        data.discount = data.discount + discount_bills[k].level2.discount; 
                        data.discount = data.discount + discount_bills[k].level3.discount; 
                        data.discount = data.discount + discount_bills[k].level4.discount; 

                      }
                    }else if(((discount_bills[k].level3.sales != 0)||(discount_bills[k].level3.discount != 0)) && (total_price >= discount_bills[k].level3.sales)){                                      
                      if(discount_bills[k].type === 1) {              
                        data.discount = data.discount + (discount_bills[k].level2.sales - discount_bills[k].level1.sales) * discount_bills[k].level1.discount/100;
                        data.discount = data.discount + (discount_bills[k].level3.sales - discount_bills[k].level2.sales) * discount_bills[k].level2.discount/100;                                                 
                        data.discount = data.discount + (total_price - discount_bills[k].level3.sales) * discount_bills[k].level3.discount/100;
                      }else if(discount_bills[k].type === 2) {
                        data.discount =                 discount_bills[k].level1.discount; 
                        data.discount = data.discount + discount_bills[k].level2.discount; 
                        data.discount = data.discount + discount_bills[k].level3.discount;                           
                      }
                    }else if(((discount_bills[k].level2.sales != 0)||(discount_bills[k].level2.discount != 0)) && (total_price >= discount_bills[k].level2.sales)){                                      
                      if(discount_bills[k].type === 1) {              
                        data.discount = data.discount + (discount_bills[k].level2.sales - discount_bills[k].level1.sales) * discount_bills[k].level1.discount/100;                                                
                        data.discount = data.discount + (total_price - discount_bills[k].level2.sales) * discount_bills[k].level2.discount/100;
                      }else if(discount_bills[k].type === 2) {
                        data.discount =                 discount_bills[k].level1.discount; 
                        data.discount = data.discount + discount_bills[k].level2.discount;                                   
                      }
                    }else if(((discount_bills[k].level1.sales != 0)||(discount_bills[k].level1.discount != 0)) && (total_price >= discount_bills[k].level1.sales)){                                      
                      if(discount_bills[k].type === 1) {                                                                                        
                        data.discount = data.discount + (total_price - discount_bills[k].level1.sales) * discount_bills[k].level1.discount/100;
                      }else if(discount_bills[k].type === 2) {
                        data.discount =                      discount_bills[k].level1.discount;                                                               
                      }
                    }                                    
                    
                  }else if(discount_bills[k].method === 2){//theo mức cuối
                    if(((discount_bills[k].level5.sales != 0)||(discount_bills[k].level5.discount != 0)) && (total_price >= discount_bills[k].level5.sales)){                                   
                      if(discount_bills[k].type === 1) data.discount = total_price * discount_bills[k].level5.discount/100;
                      else if(discount_bills[k].type === 2) data.discount = discount_bills[k].level5.discount;                                      
                    
                    }else if(((discount_bills[k].level4.sales != 0)||(discount_bills[k].level4.discount != 0)) && (total_price >= discount_bills[k].level4.sales)){                                     
                      if(discount_bills[k].type === 1) data.discount = total_price * discount_bills[k].level4.discount/100;
                      else if(discount_bills[k].type === 2) data.discount = discount_bills[k].level4.discount;    

                    }else if(((discount_bills[k].level3.sales != 0)||(discount_bills[k].level3.discount != 0))&& (total_price >= discount_bills[k].level3.sales)){                                     
                      if(discount_bills[k].type === 1) data.discount = total_price * discount_bills[k].level3.discount/100;
                      else if(discount_bills[k].type === 2) data.discount = discount_bills[k].level3.discount;    

                    }else if(((discount_bills[k].level2.sales != 0)||(discount_bills[k].level2.discount != 0)) && (total_price >= discount_bills[k].level2.sales)){                                   
                      if(discount_bills[k].type === 1) data.discount = total_price * discount_bills[k].level2.discount/100;
                      else if(discount_bills[k].type === 2) data.discount = discount_bills[k].level2.discount;    

                    }else if(((discount_bills[k].level1.sales != 0)||(discount_bills[k].level1.discount != 0)) && (total_price >= discount_bills[k].level1.sales)){                                    
                      if(discount_bills[k].type === 1) data.discount = total_price * discount_bills[k].level1.discount/100;
                      else if(discount_bills[k].type === 2) data.discount = discount_bills[k].level1.discount;    
                    }
                  }       
                  break; 
                }      
              }
            }
          }
        }
    return data;//{type(% or money),discount}
   }
  /** 
   * @Usage :Hàm này dùng trong page CHIẾT KHẤU KHÁCH HÀNG -> Chọn TẤT CẢ hoặc MỘT khách hàng
   * @notice : Mỗi công thức chiết khấu có 5 mức (level1, level2, level3, level4, level5), giá trị doanh số (sales) level sau phải lơn hơn level trước
   * type : 1 chiết khấu %, 2 chiết khấu tiền
   * method : 1 phương pháp tính theo từng mức, 2 phương pháp tính theo mức cuối
   * usage: 1 chiết khấu trên hóa đơn, 2 chiết khấu trên doanh số
   * @example :
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportDiscount_sales_Customers(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((discounts)=>{
            console.log('discounts', discounts);
            console.log('discounts.docs[0]', discounts.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDcustomer : 'all' or id_customer
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, img, discount_name,sales_btax, discount_btax, sales_atax, discount_atax}
   */

  public getReportDiscount_sales_Customers(starttime:any, endtime:any, IDcustomer:any, IDbranch?:string){     
    return new Promise<any>((resolve, reject) => { 
      let customers:any = new Array();   
      if(IDcustomer === 'all') customers = this.getlocalCustomers()   
      else {
        let customer = this.getlocalCustomer(IDcustomer);          
        customers.push(customer);      
      }             
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        discount_btax: 0,
        discount_atax: 0
        //quantity: 0 
      }    
      console.log('hello customers', customers);           
      if(customers.length>0){                                
        let query:any;
        if(IDcustomer === 'all'){        
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};          
          }
        }else{
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:[1]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};            
          }
          
        }        
        console.log('hello query', query);  
        let promise1 =  this.vhMGDB_database.getDocsByFields('discount_saless', {}, {},{},0);            
        let promise2 =  this.getBill_details_byFields(query, {},{date:1},0);
        let promise3 =  this.vhMGDB_database.getDocsByFields('customer_classs', {}, {},{},0); 
        Promise.all([promise1, promise2, promise3])
                .then((array:any)=>{   
                 console.log('hello array', array);                                
                    let discounts = array[0];
                    let vhbill_details = array[1];
                    let customer_classs = array[2];
                    
                    if(vhbill_details.length>0){                                                 
                      for(let i=0; i<customers.length; i++){   
                        let transaction = false;                                                                 
                        let data:any ={   
                          id_customer: customers[i]._id,                  
                          name: customers[i].name,                          
                          img: customers[i]?.img,                                   
                          sales_btax: 0,
                          sales_atax: 0,
                          quantity: 0,
                          discount_btax: 0,
                          discount_atax: 0,
                          discount_name: ''
                        }      
                        //Tính doanh số cho mỗi khách hàng                                                                       
                        for(let j=0; j<vhbill_details.length; j++){                           
                          if(customers[i]._id ===vhbill_details[j].id_customer){  
                              transaction = true;                        
                              if(vhbill_details[j].ptype ===5){
                                if(vhbill_details[j].combos != undefined)
                                  for(let m=0; m<vhbill_details[j].combos.length; m++){                                                   
                                      data.quantity = data.quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                       
                                  } 
                              }else{                                                                 
                                data.quantity = data.quantity + vhbill_details[j].quantity;
                                data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                              }                                    
                          }
                        }

                        //Tính chiết khấu trên doanh số cho mỗi khách hàng
                        if(transaction){
                          if((customers[i].id_customer_class != undefined)&&(customers[i].id_customer_class != null)){            
                            for(let j=0; j<customer_classs.length; j++){     
                              if(customer_classs[j]._id === customers[i].id_customer_class){     
                                if((customer_classs[j].id_discount_sales != undefined)&&(customer_classs[j].id_discount_sales != null)){  
                                    for(let k=0; k<discounts.length; k++){                                     
                                      if(discounts[k]._id === customer_classs[j].id_discount_sales){     
                                        data.discount_name = discounts[k].name;                                             
                                          //Tính cho gia trị trước thuế
                                          if(discounts[k].method === 1){//theo từng mức
                                            if(((discounts[k].level5.sales != 0)||(discounts[k].level5.discount != 0)) && (data.sales_btax >= discounts[k].level5.sales)){                                      
                                              if(discounts[k].type === 1) {                                       
                                                //data.discount_btax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                data.discount_btax = data.discount_btax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                data.discount_btax = data.discount_btax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                                data.discount_btax = data.discount_btax + (discounts[k].level4.sales - discounts[k].level3.sales) * discounts[k].level3.discount/100;
                                                data.discount_btax = data.discount_btax + (discounts[k].level5.sales - discounts[k].level4.sales) * discounts[k].level4.discount/100;
                                                data.discount_btax = data.discount_btax + (data.sales_btax - discounts[k].level5.sales) * discounts[k].level5.discount/100;
                                              }else if(discounts[k].type === 2) {
                                                data.discount_btax =                      discounts[k].level1.discount; 
                                                data.discount_btax = data.discount_btax + discounts[k].level2.discount; 
                                                data.discount_btax = data.discount_btax + discounts[k].level3.discount; 
                                                data.discount_btax = data.discount_btax + discounts[k].level4.discount; 
                                                data.discount_btax = data.discount_btax + discounts[k].level5.discount; 
                                              }
                                            }else if(((discounts[k].level4.sales != 0)||(discounts[k].level4.discount != 0)) && (data.sales_btax >= discounts[k].level4.sales)){                                      
                                              if(discounts[k].type === 1) {                                        
                                                //data.discount_btax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                data.discount_btax = data.discount_btax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                data.discount_btax = data.discount_btax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                                data.discount_btax = data.discount_btax + (discounts[k].level4.sales - discounts[k].level3.sales) * discounts[k].level3.discount/100;                    
                                                data.discount_btax = data.discount_btax + (data.sales_btax - discounts[k].level4.sales) * discounts[k].level4.discount/100;
                                              }else if(discounts[k].type === 2) {
                                                data.discount_btax =                      discounts[k].level1.discount; 
                                                data.discount_btax = data.discount_btax + discounts[k].level2.discount; 
                                                data.discount_btax = data.discount_btax + discounts[k].level3.discount; 
                                                data.discount_btax = data.discount_btax + discounts[k].level4.discount; 
                                  
                                              }
                                            }else if(((discounts[k].level3.sales != 0)||(discounts[k].level3.discount != 0)) && (data.sales_btax >= discounts[k].level3.sales)){                                      
                                              if(discounts[k].type === 1) {                                        
                                                //data.discount_btax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                data.discount_btax = data.discount_btax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                data.discount_btax = data.discount_btax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;                                                 
                                                data.discount_btax = data.discount_btax + (data.sales_btax - discounts[k].level3.sales) * discounts[k].level3.discount/100;
                                              }else if(discounts[k].type === 2) {
                                                data.discount_btax =                      discounts[k].level1.discount; 
                                                data.discount_btax = data.discount_btax + discounts[k].level2.discount; 
                                                data.discount_btax = data.discount_btax + discounts[k].level3.discount;                           
                                              }
                                            }else if(((discounts[k].level2.sales != 0)||(discounts[k].level2.discount != 0)) && (data.sales_btax >= discounts[k].level2.sales)){                                      
                                              if(discounts[k].type === 1) {                                        
                                                //data.discount_btax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                data.discount_btax = data.discount_btax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;                                                
                                                data.discount_btax = data.discount_btax + (data.sales_btax - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                              }else if(discounts[k].type === 2) {
                                                data.discount_btax =                      discounts[k].level1.discount; 
                                                data.discount_btax = data.discount_btax + discounts[k].level2.discount;                                   
                                              }
                                            }else if(((discounts[k].level1.sales != 0)||(discounts[k].level1.discount != 0)) && (data.sales_btax >= discounts[k].level1.sales)){                                      
                                              if(discounts[k].type === 1) {                                       
                                                //data.discount_btax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;                                                                            
                                                data.discount_btax = data.discount_btax + (data.sales_btax - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                              }else if(discounts[k].type === 2) {
                                                data.discount_btax =                      discounts[k].level1.discount;                                                               
                                              }
                                            }                                    
                                            
                                          }else if(discounts[k].method === 2){//theo mức cuối
                                            if(((discounts[k].level5.sales != 0)||(discounts[k].level5.discount != 0)) && (data.sales_btax >= discounts[k].level5.sales)){                                   
                                              if(discounts[k].type === 1) data.discount_btax = data.sales_btax * discounts[k].level5.discount/100;
                                              else if(discounts[k].type === 2) data.discount_btax = discounts[k].level5.discount;                                      
                                            
                                            }else if(((discounts[k].level4.sales != 0)||(discounts[k].level4.discount != 0)) && (data.sales_btax >= discounts[k].level4.sales)){                                     
                                              if(discounts[k].type === 1) data.discount_btax = data.sales_btax * discounts[k].level4.discount/100;
                                              else if(discounts[k].type === 2) data.discount_btax = discounts[k].level4.discount;    

                                            }else if(((discounts[k].level3.sales != 0)||(discounts[k].level3.discount != 0))&& (data.sales_btax >= discounts[k].level3.sales)){                                     
                                              if(discounts[k].type === 1) data.discount_btax = data.sales_btax * discounts[k].level3.discount/100;
                                              else if(discounts[k].type === 2) data.discount_btax = discounts[k].level3.discount;    

                                            }else if(((discounts[k].level2.sales != 0)||(discounts[k].level2.discount != 0)) && (data.sales_btax >= discounts[k].level2.sales)){                                   
                                              if(discounts[k].type === 1) data.discount_btax = data.sales_btax * discounts[k].level2.discount/100;
                                              else if(discounts[k].type === 2) data.discount_btax = discounts[k].level2.discount;    

                                            }else if(((discounts[k].level1.sales != 0)||(discounts[k].level1.discount != 0)) && (data.sales_btax >= discounts[k].level1.sales)){                                    
                                              if(discounts[k].type === 1) data.discount_btax = data.sales_btax * discounts[k].level1.discount/100;
                                              else if(discounts[k].type === 2) data.discount_btax = discounts[k].level1.discount;    
                                            }
                                          }
                                          //Tính cho gia trị sau thuế
                                          if(discounts[k].method === 1){//theo từng mức
                                            if(((discounts[k].level5.sales != 0)||(discounts[k].level5.discount != 0)) && (data.sales_atax >= discounts[k].level5.sales)){                                      
                                              if(discounts[k].type === 1) {
                                                //data.discount_atax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                data.discount_atax = data.discount_atax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                data.discount_atax = data.discount_atax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                                data.discount_atax = data.discount_atax + (discounts[k].level4.sales - discounts[k].level3.sales) * discounts[k].level3.discount/100;
                                                data.discount_atax = data.discount_atax + (discounts[k].level5.sales - discounts[k].level4.sales) * discounts[k].level4.discount/100;
                                                data.discount_atax = data.discount_atax + (data.sales_atax - discounts[k].level5.sales) * discounts[k].level5.discount/100;
                                              }else if(discounts[k].type === 2) {
                                                data.discount_atax =                      discounts[k].level1.discount; 
                                                data.discount_atax = data.discount_atax + discounts[k].level2.discount; 
                                                data.discount_atax = data.discount_atax + discounts[k].level3.discount; 
                                                data.discount_atax = data.discount_atax + discounts[k].level4.discount; 
                                                data.discount_atax = data.discount_atax + discounts[k].level5.discount; 
                                              }
                                            }else if(((discounts[k].level4.sales != 0)||(discounts[k].level4.discount != 0)) && (data.sales_atax >= discounts[k].level4.sales)){                                      
                                              if(discounts[k].type === 1) {
                                                //data.discount_atax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                data.discount_atax = data.discount_atax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                data.discount_atax = data.discount_atax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                                data.discount_atax = data.discount_atax + (discounts[k].level4.sales - discounts[k].level3.sales) * discounts[k].level3.discount/100;                    
                                                data.discount_atax = data.discount_atax + (data.sales_atax - discounts[k].level4.sales) * discounts[k].level4.discount/100;
                                              }else if(discounts[k].type === 2) {
                                                data.discount_atax =                      discounts[k].level1.discount; 
                                                data.discount_atax = data.discount_atax + discounts[k].level2.discount; 
                                                data.discount_atax = data.discount_atax + discounts[k].level3.discount; 
                                                data.discount_atax = data.discount_atax + discounts[k].level4.discount; 
                                  
                                              }
                                            }else if(((discounts[k].level3.sales != 0)||(discounts[k].level3.discount != 0)) && (data.sales_atax >= discounts[k].level3.sales)){                                      
                                              if(discounts[k].type === 1) {
                                                //data.discount_atax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                data.discount_atax = data.discount_atax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                data.discount_atax = data.discount_atax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;                                                 
                                                data.discount_atax = data.discount_atax + (data.sales_atax - discounts[k].level3.sales) * discounts[k].level3.discount/100;
                                              }else if(discounts[k].type === 2) {
                                                data.discount_atax =                      discounts[k].level1.discount; 
                                                data.discount_atax = data.discount_atax + discounts[k].level2.discount; 
                                                data.discount_atax = data.discount_atax + discounts[k].level3.discount;                           
                                              }
                                            }else if(((discounts[k].level2.sales != 0)||(discounts[k].level2.discount != 0)) && (data.sales_atax >= discounts[k].level2.sales)){                                      
                                              if(discounts[k].type === 1) {
                                                //data.discount_atax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                data.discount_atax = data.discount_atax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;                                                
                                                data.discount_atax = data.discount_atax + (data.sales_atax - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                              }else if(discounts[k].type === 2) {
                                                data.discount_atax =                      discounts[k].level1.discount; 
                                                data.discount_atax = data.discount_atax + discounts[k].level2.discount;                                   
                                              }
                                            }else if(((discounts[k].level1.sales != 0)||(discounts[k].level1.discount != 0)) && (data.sales_atax >= discounts[k].level1.sales)){                                      
                                              if(discounts[k].type === 1) {
                                                //data.discount_atax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;                                                                            
                                                data.discount_atax = data.discount_atax + (data.sales_atax - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                              }else if(discounts[k].type === 2) {
                                                data.discount_atax =                      discounts[k].level1.discount;                                                               
                                              }
                                            }  
                                          }else if(discounts[k].method === 2){//theo mức cuối
                                            if(((discounts[k].level5.sales != 0)||(discounts[k].level5.discount != 0)) && (data.sales_atax >= discounts[k].level5.sales)){
                                              if(discounts[k].type === 1) data.discount_atax = data.sales_atax * discounts[k].level5.discount/100;
                                              else if(discounts[k].type === 2) data.discount_atax = discounts[k].level5.discount;                                      
                                            
                                            }else if(((discounts[k].level4.sales != 0)||(discounts[k].level4.discount != 0)) && (data.sales_atax >= discounts[k].level4.sales)){
                                              if(discounts[k].type === 1) data.discount_atax = data.sales_atax * discounts[k].level4.discount/100;
                                              else if(discounts[k].type === 2) data.discount_atax = discounts[k].level4.discount;    

                                            }else if(((discounts[k].level3.sales != 0)||(discounts[k].level3.discount != 0)) && (data.sales_atax >= discounts[k].level3.sales)){
                                              if(discounts[k].type === 1) data.discount_atax = data.sales_atax * discounts[k].level3.discount/100;
                                              else if(discounts[k].type === 2) data.discount_atax = discounts[k].level3.discount;    

                                            }else if(((discounts[k].level2.sales != 0)||(discounts[k].level2.discount != 0)) && (data.sales_atax >= discounts[k].level2.sales)){
                                              if(discounts[k].type === 1) data.discount_atax = data.sales_atax * discounts[k].level2.discount/100;
                                              else if(discounts[k].type === 2) data.discount_atax = discounts[k].level2.discount;    

                                            }else if(((discounts[k].level1.sales != 0)||(discounts[k].level1.discount != 0)) && (data.sales_atax >= discounts[k].level1.sales)){
                                              if(discounts[k].type === 1) data.discount_atax = data.sales_atax * discounts[k].level1.discount/100;
                                              else if(discounts[k].type === 2) data.discount_atax = discounts[k].level1.discount;    
                                            }
                                          }
                                          json.sales_btax = json.sales_btax + data.sales_btax;
                                          json.sales_atax = json.sales_atax + data.sales_atax;
                                          json.discount_btax = json.discount_btax + data.discount_btax;
                                          json.discount_atax = json.discount_atax + data.discount_atax;
                                          data.index = json.size + 1;
                                          json.docs.push(data);
                                          json.size++;                        
                                          json.empty = false;
                                          break;
                                      }
                                    }   
                                }
                              }
                            }
                                                            
                          }                           
                        }                          
                      }                      
                    }          
                    console.log('getReportDiscount_Customers', json);             
                    resolve(json);
              })
      }else resolve(json);     
    })
  }

  /** 
   * @Usage :Hàm này dùng trong page HOA HỒNG hạng NHÂN VIÊN -> Chọn TẤT CẢ hoặc MỘT nhân viên
   * @notice : Mỗi công thức chiết khấu có 5 mức (level1, level2, level3, level4, level5), giá trị doanh số (sales) level sau phải lơn hơn level trước
   * type : 1 chiết khấu %, 2 chiết khấu tiền
   * method : 1 phương pháp tính theo từng mức, 2 phương pháp tính theo mức cuối
   * @example :
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportCommission_Employees(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((commissions)=>{
            console.log('commissions', commissions);
            console.log('commissions.docs[0]', commissions.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDemployee : 'all' or id_employee
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, img, commission_name, sales_btax, commission_btax, sales_atax, commission_atax}
   */
    
  public getReportCommission_Employees(starttime:any, endtime:any, IDemployee:any, IDbranch?:string){   
    return new Promise<any>((resolve, reject) => { 
      let employees:any = new Array();   
      if(IDemployee === 'all') employees = this.vhAuth.getlocalEmployees()   
      else {
        let employee = this.vhAuth.getlocalEmployee(IDemployee);          
        employees.push(employee);      
      }             
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        commission_btax: 0,
        commission_atax: 0
        //quantity: 0 
      }               
      if(employees.length>0){                                
        let query:any;
        if(IDemployee === 'all'){        
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};          
          }
        }else{
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:IDemployee}, bill_type: {$in:[1]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:IDemployee}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};            
          }
          
        }        
        let promise1 =  this.vhMGDB_database.getDocsByFields('commissions', {}, {},{},0);            
        let promise2 =  this.getBill_details_byFields(query, {},{date:1},0);
        let promise3 =  this.vhMGDB_database.getDocsByFields('employee_classs', {}, {},{},0);   
        Promise.all([promise1, promise2, promise3])
                .then((array:any)=>{                                
                    let commissions = array[0];
                    let vhbill_details = array[1];               
                    let employee_classs = array[2];          
                    if(vhbill_details.length>0){                                                 
                      for(let i=0; i<employees.length; i++){   
                        let transaction = false;                                                     
                        let data:any ={   
                          id_employee: employees[i]._id,                  
                          name: employees[i].name,                                                             
                          sales_btax: 0,
                          sales_atax: 0,
                          quantity: 0,
                          commission_btax: 0,
                          commission_atax: 0,
                          commission_name: ''
                        }                                      
                        //Tính doanh số cho mỗi nhân viên                                
                        for(let j=0; j<vhbill_details.length; j++){                           
                          if(employees[i]._id ===vhbill_details[j].id_employee){  
                              transaction = true;                              
                              if(vhbill_details[j].ptype ===5){
                                if(vhbill_details[j].combos != undefined)
                                  for(let m=0; m<vhbill_details[j].combos.length; m++){                                                   
                                      data.quantity = data.quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                       
                                  } 
                              }else{                                                                 
                                data.quantity = data.quantity + vhbill_details[j].quantity;
                                data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                              }                                        
                          }
                        }
                        //Tính hoa hồng trên doanh số cho mỗi nhân viên
                        if(transaction){                         
                          if((employees[i].id_employee_class != undefined)&&(employees[i].id_employee_class != null)){
                            for(let j=0; j<employee_classs.length; j++){     
                              if(employee_classs[j]._id === employees[i].id_employee_class){     
                                if((employee_classs[j].id_commission != undefined)&&(employee_classs[j].id_commission != null)){   
                                    for(let k=0; k<commissions.length; k++){
                                      if(commissions[k]._id === employee_classs[j].id_commission){                                         
                                          data.commission_name = commissions[k].name;                             
                                            //Tính cho gia trị trước thuế
                                            if(commissions[k].method === 1){//theo từng mức
                                              if(((commissions[k].level5.sales != 0)||(commissions[k].level5.commission != 0)) && (data.sales_btax >= commissions[k].level5.sales)){                                      
                                                if(commissions[k].type === 1) {
                                                  //data.commission_btax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                  data.commission_btax = data.commission_btax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                  data.commission_btax = data.commission_btax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                                  data.commission_btax = data.commission_btax + (commissions[k].level4.sales - commissions[k].level3.sales) * commissions[k].level3.commission/100;
                                                  data.commission_btax = data.commission_btax + (commissions[k].level5.sales - commissions[k].level4.sales) * commissions[k].level4.commission/100;
                                                  data.commission_btax = data.commission_btax + (data.sales_btax - commissions[k].level5.sales) * commissions[k].level5.commission/100;
                                                }else if(commissions[k].type === 2) {
                                                  data.commission_btax =                      commissions[k].level1.commission; 
                                                  data.commission_btax = data.commission_btax + commissions[k].level2.commission; 
                                                  data.commission_btax = data.commission_btax + commissions[k].level3.commission; 
                                                  data.commission_btax = data.commission_btax + commissions[k].level4.commission; 
                                                  data.commission_btax = data.commission_btax + commissions[k].level5.commission; 
                                                }
                                              }else if(((commissions[k].level4.sales != 0)||(commissions[k].level4.commission != 0)) && (data.sales_btax >= commissions[k].level4.sales)){                                      
                                                if(commissions[k].type === 1) {
                                                  //data.commission_btax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                  data.commission_btax = data.commission_btax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                  data.commission_btax = data.commission_btax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                                  data.commission_btax = data.commission_btax + (commissions[k].level4.sales - commissions[k].level3.sales) * commissions[k].level3.commission/100;                    
                                                  data.commission_btax = data.commission_btax + (data.sales_btax - commissions[k].level4.sales) * commissions[k].level4.commission/100;
                                                }else if(commissions[k].type === 2) {
                                                  data.commission_btax =                      commissions[k].level1.commission; 
                                                  data.commission_btax = data.commission_btax + commissions[k].level2.commission; 
                                                  data.commission_btax = data.commission_btax + commissions[k].level3.commission; 
                                                  data.commission_btax = data.commission_btax + commissions[k].level4.commission; 
                                    
                                                }
                                              }else if(((commissions[k].level3.sales != 0)||(commissions[k].level3.commission != 0)) && (data.sales_btax >= commissions[k].level3.sales)){                                      
                                                if(commissions[k].type === 1) {
                                                  //data.commission_btax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                  data.commission_btax = data.commission_btax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                  data.commission_btax = data.commission_btax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;                                                 
                                                  data.commission_btax = data.commission_btax + (data.sales_btax - commissions[k].level3.sales) * commissions[k].level3.commission/100;
                                                }else if(commissions[k].type === 2) {
                                                  data.commission_btax =                      commissions[k].level1.commission; 
                                                  data.commission_btax = data.commission_btax + commissions[k].level2.commission; 
                                                  data.commission_btax = data.commission_btax + commissions[k].level3.commission;                           
                                                }
                                              }else if(((commissions[k].level2.sales != 0)||(commissions[k].level2.commission != 0)) && (data.sales_btax >= commissions[k].level2.sales)){                                      
                                                if(commissions[k].type === 1) {
                                                  //data.commission_btax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                  data.commission_btax = data.commission_btax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;                                                
                                                  data.commission_btax = data.commission_btax + (data.sales_btax - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                                }else if(commissions[k].type === 2) {
                                                  data.commission_btax =                      commissions[k].level1.commission; 
                                                  data.commission_btax = data.commission_btax + commissions[k].level2.commission;                                   
                                                }
                                              }else if(((commissions[k].level1.sales != 0)||(commissions[k].level1.commission != 0)) && (data.sales_btax >= commissions[k].level1.sales)){                                      
                                                if(commissions[k].type === 1) {
                                                  //data.commission_btax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;                                                                            
                                                  data.commission_btax = data.commission_btax + (data.sales_btax - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                }else if(commissions[k].type === 2) {
                                                  data.commission_btax =                      commissions[k].level1.commission;                                                               
                                                }
                                              }                                    
                                              
                                            }else if(commissions[k].method === 2){//theo mức cuối                                    
                                              if(((commissions[k].level5.sales != 0)||(commissions[k].level5.commission != 0)) && (data.sales_btax >= commissions[k].level5.sales)){                                   
                                                if(commissions[k].type === 1) data.commission_btax = data.sales_btax * commissions[k].level5.commission/100;
                                                else if(commissions[k].type === 2) data.commission_btax = commissions[k].level5.commission;                                      
                                              
                                              }else if(((commissions[k].level4.sales != 0)||(commissions[k].level4.commission != 0)) && (data.sales_btax >= commissions[k].level4.sales)){                                     
                                                if(commissions[k].type === 1) data.commission_btax = data.sales_btax * commissions[k].level4.commission/100;
                                                else if(commissions[k].type === 2) data.commission_btax = commissions[k].level4.commission;    

                                              }else if(((commissions[k].level3.sales != 0)||(commissions[k].level3.commission != 0))&& (data.sales_btax >= commissions[k].level3.sales)){                                     
                                                if(commissions[k].type === 1) data.commission_btax = data.sales_btax * commissions[k].level3.commission/100;
                                                else if(commissions[k].type === 2) data.commission_btax = commissions[k].level3.commission;    

                                              }else if(((commissions[k].level2.sales != 0)||(commissions[k].level2.commission != 0)) && (data.sales_btax >= commissions[k].level2.sales)){                                   
                                                if(commissions[k].type === 1) data.commission_btax = data.sales_btax * commissions[k].level2.commission/100;
                                                else if(commissions[k].type === 2) data.commission_btax = commissions[k].level2.commission;    

                                              }else if(((commissions[k].level1.sales != 0)||(commissions[k].level1.commission != 0)) && (data.sales_btax >= commissions[k].level1.sales)){                                    
                                                if(commissions[k].type === 1) data.commission_btax = data.sales_btax * commissions[k].level1.commission/100;
                                                else if(commissions[k].type === 2) data.commission_btax = commissions[k].level1.commission;    
                                              }                                    
                                            }


                                            //Tính cho gia trị sau thuế
                                            if(commissions[k].method === 1){//theo từng mức
                                              if(((commissions[k].level5.sales != 0)||(commissions[k].level5.commission != 0)) && (data.sales_atax >= commissions[k].level5.sales)){                                      
                                                if(commissions[k].type === 1) {
                                                  //data.commission_atax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                  data.commission_atax = data.commission_atax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                  data.commission_atax = data.commission_atax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                                  data.commission_atax = data.commission_atax + (commissions[k].level4.sales - commissions[k].level3.sales) * commissions[k].level3.commission/100;
                                                  data.commission_atax = data.commission_atax + (commissions[k].level5.sales - commissions[k].level4.sales) * commissions[k].level4.commission/100;
                                                  data.commission_atax = data.commission_atax + (data.sales_atax - commissions[k].level5.sales) * commissions[k].level5.commission/100;
                                                }else if(commissions[k].type === 2) {
                                                  data.commission_atax =                      commissions[k].level1.commission; 
                                                  data.commission_atax = data.commission_atax + commissions[k].level2.commission; 
                                                  data.commission_atax = data.commission_atax + commissions[k].level3.commission; 
                                                  data.commission_atax = data.commission_atax + commissions[k].level4.commission; 
                                                  data.commission_atax = data.commission_atax + commissions[k].level5.commission; 
                                                }
                                              }else if(((commissions[k].level4.sales != 0)||(commissions[k].level4.commission != 0)) && (data.sales_atax >= commissions[k].level4.sales)){                                      
                                                if(commissions[k].type === 1) {
                                                  //data.commission_atax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                  data.commission_atax = data.commission_atax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                  data.commission_atax = data.commission_atax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                                  data.commission_atax = data.commission_atax + (commissions[k].level4.sales - commissions[k].level3.sales) * commissions[k].level3.commission/100;                    
                                                  data.commission_atax = data.commission_atax + (data.sales_atax - commissions[k].level4.sales) * commissions[k].level4.commission/100;
                                                }else if(commissions[k].type === 2) {
                                                  data.commission_atax =                      commissions[k].level1.commission; 
                                                  data.commission_atax = data.commission_atax + commissions[k].level2.commission; 
                                                  data.commission_atax = data.commission_atax + commissions[k].level3.commission; 
                                                  data.commission_atax = data.commission_atax + commissions[k].level4.commission; 
                                    
                                                }
                                              }else if(((commissions[k].level3.sales != 0)||(commissions[k].level3.commission != 0)) && (data.sales_atax >= commissions[k].level3.sales)){                                      
                                                if(commissions[k].type === 1) {
                                                  //data.commission_atax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                  data.commission_atax = data.commission_atax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                  data.commission_atax = data.commission_atax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;                                                 
                                                  data.commission_atax = data.commission_atax + (data.sales_atax - commissions[k].level3.sales) * commissions[k].level3.commission/100;
                                                }else if(commissions[k].type === 2) {
                                                  data.commission_atax =                      commissions[k].level1.commission; 
                                                  data.commission_atax = data.commission_atax + commissions[k].level2.commission; 
                                                  data.commission_atax = data.commission_atax + commissions[k].level3.commission;                           
                                                }
                                              }else if(((commissions[k].level2.sales != 0)||(commissions[k].level2.commission != 0)) && (data.sales_atax >= commissions[k].level2.sales)){                                      
                                                if(commissions[k].type === 1) {
                                                  //data.commission_atax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                  data.commission_atax = data.commission_atax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;                                                
                                                  data.commission_atax = data.commission_atax + (data.sales_atax - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                                }else if(commissions[k].type === 2) {
                                                  data.commission_atax =                      commissions[k].level1.commission; 
                                                  data.commission_atax = data.commission_atax + commissions[k].level2.commission;                                   
                                                }
                                              }else if(((commissions[k].level1.sales != 0)||(commissions[k].level1.commission != 0)) && (data.sales_atax >= commissions[k].level1.sales)){                                      
                                                if(commissions[k].type === 1) {
                                                  //data.commission_atax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;                                                                            
                                                  data.commission_atax = data.commission_atax + (data.sales_atax - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                }else if(commissions[k].type === 2) {
                                                  data.commission_atax =                      commissions[k].level1.commission;                                                               
                                                }
                                              }  
                                            }else if(commissions[k].method === 2){//theo mức cuối
                                              if(((commissions[k].level5.sales != 0)||(commissions[k].level5.commission != 0)) && (data.sales_atax >= commissions[k].level5.sales)){
                                                if(commissions[k].type === 1) data.commission_atax = data.sales_atax * commissions[k].level5.commission/100;
                                                else if(commissions[k].type === 2) data.commission_atax = commissions[k].level5.commission;                                      
                                              
                                              }else if(((commissions[k].level4.sales != 0)||(commissions[k].level4.commission != 0)) && (data.sales_atax >= commissions[k].level4.sales)){
                                                if(commissions[k].type === 1) data.commission_atax = data.sales_atax * commissions[k].level4.commission/100;
                                                else if(commissions[k].type === 2) data.commission_atax = commissions[k].level4.commission;    

                                              }else if(((commissions[k].level3.sales != 0)||(commissions[k].level3.commission != 0)) && (data.sales_atax >= commissions[k].level3.sales)){
                                                if(commissions[k].type === 1) data.commission_atax = data.sales_atax * commissions[k].level3.commission/100;
                                                else if(commissions[k].type === 2) data.commission_atax = commissions[k].level3.commission;    

                                              }else if(((commissions[k].level2.sales != 0)||(commissions[k].level2.commission != 0)) && (data.sales_atax >= commissions[k].level2.sales)){
                                                if(commissions[k].type === 1) data.commission_atax = data.sales_atax * commissions[k].level2.commission/100;
                                                else if(commissions[k].type === 2) data.commission_atax = commissions[k].level2.commission;    

                                              }else if(((commissions[k].level1.sales != 0)||(commissions[k].level1.commission != 0)) && (data.sales_atax >= commissions[k].level1.sales)){
                                                if(commissions[k].type === 1) data.commission_atax = data.sales_atax * commissions[k].level1.commission/100;
                                                else if(commissions[k].type === 2) data.commission_atax = commissions[k].level1.commission;    
                                              }
                                            }
                                            json.sales_btax = json.sales_btax + data.sales_btax;
                                            json.sales_atax = json.sales_atax + data.sales_atax;
                                            json.commission_btax = json.commission_btax + data.commission_btax;
                                            json.commission_atax = json.commission_atax + data.commission_atax;
                                            data.index = json.size + 1;
                                            json.docs.push(data);
                                            json.size++;                        
                                            json.empty = false;
                                            break;
                                        }
                                      }      
                                    }
                                  }
                                }                     
                          } 
                    
                        }                          
                      }                      
                    }          
                    console.log('getReportCommission_Employees', json);             
                    resolve(json);
                  })
      }else resolve(json);     
    })
  }
  


  /**   
   * VhQueryCafe:
   * cashbook_first: tiền mặt đầu kỳ (starttime),
   * income: tiền thu trong kỳ
   * expenditure: tiền chi trong kỳ
   * cashbook_last: tiền mặt cuối kỳ (endtime)  
   * IDwallet = 'all' hoặc id_wallet của ví nào đó
   * @param IDbranch : 'all' or id_branch
   * @notice : ở giao diện APP, chọn IDbranch rồi mới hiện ra những IDwallet của chi nhánh đó để chọn tiếp. Nếu IDbranch = 'all' thì IDwallet phải là 'all'
   */
  public getReportCashBook(starttime:any, endtime:any, IDwallet:any, IDbranch?:any){        
    starttime = new Date(starttime); endtime = new Date(endtime);
    let array_bill_type = [1,7,10,11,34,40,50,2,8,12,33];   
    let store = this.vhAuth.getStore(); 
    return new Promise((resolve, reject) => {                
      let query:any;
      let cash = 0;
      let day:any = null;
      if(IDwallet==='all'){ 
          if((IDbranch==='all')||(IDbranch===undefined)){//ok
            let wallets = this.getlocalWallets(); 
            let id_branch = this.getDefaultBranch()._id;            
            let index:any = null;
            for(let i=0; i<wallets.length; i++){
              if(wallets[i]._id === 'id_cash'){
                if((wallets[i][IDbranch] !=undefined)&&(wallets[i][IDbranch].cashbook !=undefined))
                for(let k=0; k<wallets[i][id_branch].cashbook.length; k++){
                  if((new Date(wallets[i][id_branch].cashbook[k].date)).getTime() > starttime.getTime()){
                    break;
                  }else{
                    day = new Date(wallets[i][id_branch].cashbook[k].date);                 
                    index = k;
                  }
                }                           
              }
            }              
            if(day){
              for(let i=0; i<wallets.length; i++){
                if(wallets[i]._id === 'id_cash'){
                  let branchs = this.getlocalBranchs();                  
                  for(let j=0; j<branchs.length; j++){
                    cash = cash + wallets[i][branchs[j]._id].cashbook[index].cashbook_first;
                  }                
                }else{
                  cash = cash + wallets[i].cashbook[index].cashbook_first;
                }
              }
            }              
          }else{//ok            
            let wallets = this.getlocalWallets().filter((item:any)=> {if(item.id_branch === IDbranch) return true; else if(item._id === 'id_cash') return true; else return false}); 
            let index:any = null;
            for(let i=0; i<wallets.length; i++){
              if(wallets[i]._id === 'id_cash'){
                if((wallets[i][IDbranch] !=undefined)&&(wallets[i][IDbranch].cashbook !=undefined))
                for(let k=0; k<wallets[i][IDbranch].cashbook.length; k++){
                  if((new Date(wallets[i][IDbranch].cashbook[k].date)).getTime() > starttime.getTime()){
                    break;
                  }else{
                    day = new Date(wallets[i][IDbranch].cashbook[k].date);                 
                    index = k;
                  }
                }                            
              }
            }              
            if(day){
              for(let i=0; i<wallets.length; i++){
                if(wallets[i]._id === 'id_cash'){
                  cash = cash + wallets[i][IDbranch].cashbook[index].cashbook_first;
                }else{
                  cash = cash + wallets[i].cashbook[index].cashbook_first;
                }
              }
            }                   
          }
      }else{
          if((IDbranch==='all')||(IDbranch===undefined)){
            console.log('trường hợp này chưa có hàm, liên hệ anh Huy viết');
            //Trương hợp này thực tế chưa sửa dụng
          }else{ 
            let wallet:any = this.getlocalWallet(IDwallet);
            if(wallet._id === 'id_cash'){
              if((wallet[IDbranch] !=undefined)&&(wallet[IDbranch].cashbook !=undefined))
              for(let k=0; k<wallet[IDbranch].cashbook.length; k++){
                if((new Date(wallet[IDbranch].cashbook[k].date)).getTime() > starttime.getTime()){
                  break;
                }else{
                  day = new Date(wallet[IDbranch].cashbook[k].date);
                  cash = wallet[IDbranch].cashbook[k].cashbook_first;
                }
              }                                   
            }else{//ok
              if(wallet.cashbook !=undefined)
              for(let k=0; k<wallet.cashbook.length; k++){
                if((new Date(wallet.cashbook[k].date)).getTime() > starttime.getTime()){
                  break;
                }else{
                  day = new Date(wallet.cashbook[k].date);
                  cash = wallet.cashbook[k].cashbook_first;
                }
              }                           
            }
          }
      }
      
      if(!day) day = new Date(store.registrationdate);      
     
      let promise = new Array();      
      while (array_bill_type.length) {      
        let array_10_bill_type = array_bill_type.splice(0, 10);  
        if(IDwallet==='all'){       
          if((IDbranch==='all')||(IDbranch===undefined)){
            //query = {date:{$lte:endtime}, bill_type: {$in:array_10_bill_type}};
            //promise.push(this.getBills_byFields(query, {},{date:1},0));    
            let query_zero = {date:{$gte:day, $lte:endtime}, bill_type: {$in:array_10_bill_type}, payment_type:{$eq:1}}; //ok
            let query_one = {date:{$gte:day, $lte:endtime}, bill_type: {$in:array_10_bill_type}, payment_type:{$eq:3}}; //ok   
            promise.push(this.getBills_byFields(query_zero, {},{date:1},0));  
            promise.push(this.getBills_byFields(query_one, {},{date:1},0));       
          }else{
            let query_zero = {date:{$gte:day, $lte:endtime}, id_branch: {$eq:IDbranch}, bill_type: {$in:array_10_bill_type}, payment_type:{$eq:1}}; //ok
            let query_one = {date:{$gte:day, $lte:endtime}, id_branch: {$eq:IDbranch}, bill_type: {$in:array_10_bill_type}, payment_type:{$eq:3}}; //ok   
            promise.push(this.getBills_byFields(query_zero, {},{date:1},0));  
            promise.push(this.getBills_byFields(query_one, {},{date:1},0));      
          }
        }else{        
          if((IDbranch==='all')||(IDbranch===undefined)){
            //query = {date:{$lte:endtime}, id_wallet:{$eq:IDwallet}, bill_type: {$in:array_10_bill_type}};
            //promise.push(this.getBills_byFields(query, {},{date:1},0));     
          }else{
            query = {date:{$gte:day, $lte:endtime}, id_wallet:{$eq:IDwallet}, id_branch: {$eq:IDbranch}, bill_type: {$in:array_10_bill_type}};//ok   
            promise.push(this.getBills_byFields(query, {},{date:1},0));             
          }
        }      
       
        //console.log('query1', query);
        //console.log('cash', cash);
      }   
        
   
      Promise.all(promise).then((_bills:any)=>{ 
        //console.log('_bills', _bills);                      
            let bills = _bills.flat();          
            bills = this.vhAlgorithm.sortDatebyASC(bills, 'date')      
            //console.log('bills', bills);             
            let json: any={
              docs:  new Array(),
              empty: true,
              size: 0,              
              cashbook_first: cash,
              income: 0,
              expenditure: 0,
              cashbook_last: 0 
            }         
           
            if(bills.length >0){ 
              for(let i=0; i<bills.length; i++){          
                let bill = {...bills[i]};        
                
                if(bill?.payment_type != 2){
                  delete bill.fee; delete bill.discount; delete bill.note; delete bill.total;  delete bill.tax;                  
                  let date = new Date(bill.date);                 
                  //thu tiền
                  if((bill.bill_type === 1)||(bill.bill_type === 7)||(bill.bill_type === 10)||(bill.bill_type === 11)||(bill.bill_type === 34)||(bill.bill_type === 40)||(bill.bill_type === 50)){
                    if(date >= starttime){
                      json.income = json.income + bill.payment;                    
                      bill.index = json.size + 1;
                      json.docs.push(bill);
                      json.size++;
                      json.empty = false;
                    }else{                     
                      json.cashbook_first = json.cashbook_first + bill.payment; 
                    }
                  }
                  //chi tiền
                  else if((bill.bill_type === 2)||(bill.bill_type === 8)||(bill.bill_type === 12)||(bill.bill_type === 33)){
                    if(date >= starttime){                      
                      json.expenditure = json.expenditure + bill.payment;                 
                      bill.index = json.size + 1;
                      json.docs.push(bill);
                      json.size++;
                      json.empty = false;
                    }else{                                          
                      json.cashbook_first = json.cashbook_first - bill.payment; 
                    }
                  }

                }else{
                  //console.log('bill', bill);
                }
              } 
            }
            json.cashbook_last = json.cashbook_first + json.income - json.expenditure;           
            resolve(json);              
            //console.log('json1', json);   
          })
    })
  }
  private getReportCashBook_oldnew(starttime:any, endtime:any, IDwallet:any, IDbranch?:any){        
    starttime = new Date(starttime); endtime = new Date(endtime);
    let array_bill_type = [1,7,10,11,34,40,50,2,8,12,33];   
    let store = this.vhAuth.getStore();  
    return new Promise((resolve, reject) => {                
      let query:any;
      let cash = 0;
      let day:any = null;
      if(IDwallet==='all'){ 
          if((IDbranch==='all')||(IDbranch===undefined)){//ok
            let wallets = this.getlocalWallets(); 
            let id_branch = this.getDefaultBranch()._id;            
            let index:any = null;
            for(let i=0; i<wallets.length; i++){
              if(wallets[i]._id === 'id_cash'){
                if((wallets[i][IDbranch] !=undefined)&&(wallets[i][IDbranch].cashbook !=undefined))
                for(let k=0; k<wallets[i][id_branch].cashbook.length; k++){
                  if((new Date(wallets[i][id_branch].cashbook[k].date)).getTime() > starttime.getTime()){
                    break;
                  }else{
                    day = new Date(wallets[i][id_branch].cashbook[k].date);                 
                    index = k;
                  }
                }                                 
              }
            }              
            if(day){
              for(let i=0; i<wallets.length; i++){
                if(wallets[i]._id === 'id_cash'){
                  let branchs = this.getlocalBranchs();                  
                  for(let j=0; j<branchs.length; j++){
                    cash = cash + wallets[i][branchs[j]._id].cashbook[index].cashbook_first;
                  }                
                }else{
                  cash = cash + wallets[i].cashbook[index].cashbook_first;
                }
              }
            }                          
          }else{//ok           
            let wallets = this.getlocalWallets().filter((item:any)=> {if(item.id_branch === IDbranch) return true; else if(item._id === 'id_cash') return true; else return false}); 
            let index:any = null;
            for(let i=0; i<wallets.length; i++){
              if(wallets[i]._id === 'id_cash'){             
                if((wallets[i][IDbranch] !=undefined)&&(wallets[i][IDbranch].cashbook !=undefined))  
                for(let k=0; k<wallets[i][IDbranch].cashbook.length; k++){
                  if((new Date(wallets[i][IDbranch].cashbook[k].date)).getTime() > starttime.getTime()){
                    break;
                  }else{
                    day = new Date(wallets[i][IDbranch].cashbook[k].date);                 
                    index = k;
                  }
                }                          
              }
            }               
            if(day){              
              for(let i=0; i<wallets.length; i++){
                if(wallets[i]._id === 'id_cash'){
                  cash = cash + wallets[i][IDbranch].cashbook[index].cashbook_first;
                }else{
                  cash = cash + wallets[i].cashbook[index].cashbook_first;
                }
              }
            }             
          }
      }else{
          if((IDbranch==='all')||(IDbranch===undefined)){
            console.log('trường hợp này chưa có hàm, liên hệ anh Huy viết');
            //Trương hợp này thực tế chưa sửa dụng
          }else{ 
            let wallet:any = this.getlocalWallet(IDwallet);
            if(wallet._id === 'id_cash'){
              if((wallet[IDbranch] !=undefined)&&(wallet[IDbranch].cashbook !=undefined))
              for(let k=0; k<wallet[IDbranch].cashbook.length; k++){
                if((new Date(wallet[IDbranch].cashbook[k].date)).getTime() > starttime.getTime()){
                  break;
                }else{
                  day = new Date(wallet[IDbranch].cashbook[k].date);
                  cash = wallet[IDbranch].cashbook[k].cashbook_first;
                }
              }                          
            }else{//ok
              if(wallet.cashbook !=undefined)
              for(let k=0; k<wallet.cashbook.length; k++){
                if((new Date(wallet.cashbook[k].date)).getTime() > starttime.getTime()){
                  break;
                }else{
                  day = new Date(wallet.cashbook[k].date);
                  cash = wallet.cashbook[k].cashbook_first;
                }
              }                   
            }              
          }         
      }
      if(!day) day = new Date(store.registrationdate);        
      let promise = new Array();         
      if(IDwallet==='all'){           
        if((IDbranch==='all')||(IDbranch===undefined)){
          //query = {date:{$lte:endtime}, bill_type: {$in:array_10_bill_type}};
          //promise.push(this.getBills_byFields(query, {},{date:1},0));    
          let query_zero = {date:{$gte:day, $lte:endtime}, bill_type: {$in:array_bill_type}, payment_type:{$eq:1}}; //ok
          let query_one = {date:{$gte:day, $lte:endtime}, bill_type: {$in:array_bill_type}, payment_type:{$eq:3}}; //ok   
          promise.push(this.getBills_byFields(query_zero, {},{date:1},0));  
          promise.push(this.getBills_byFields(query_one, {},{date:1},0));       
        }else{           
          let query_zero = {date:{$gte:day, $lte:endtime}, id_branch: {$eq:IDbranch}, bill_type: {$in:array_bill_type}, payment_type:{$eq:1}}; //ok
          let query_one = {date:{$gte:day, $lte:endtime}, id_branch: {$eq:IDbranch}, bill_type: {$in:array_bill_type}, payment_type:{$eq:3}}; //ok   
          promise.push(this.getBills_byFields(query_zero, {},{date:1},0));  
          promise.push(this.getBills_byFields(query_one, {},{date:1},0));      
        }
      }else{        
        if((IDbranch==='all')||(IDbranch===undefined)){
          //query = {date:{$lte:endtime}, id_wallet:{$eq:IDwallet}, bill_type: {$in:array_10_bill_type}};
          //promise.push(this.getBills_byFields(query, {},{date:1},0));     
        }else{
          query = {date:{$gte:day, $lte:endtime}, id_wallet:{$eq:IDwallet}, id_branch: {$eq:IDbranch}, bill_type: {$in:array_bill_type}};//ok   
          promise.push(this.getBills_byFields(query, {},{date:1},0));             
        }
      }     
        
   
      Promise.all(promise).then((_bills:any)=>{            
            let bills = _bills.flat();                 
            bills = this.vhAlgorithm.sortDatebyASC(bills, 'date')      
            //console.log('bills', bills);             
            let json: any={
              docs:  new Array(),
              empty: true,
              size: 0,              
              cashbook_first: cash,
              income: 0,
              expenditure: 0,
              cashbook_last: 0 
            }         
           
            if(bills.length >0){ 
              for(let i=0; i<bills.length; i++){          
                let bill = {...bills[i]};        
                
                if(bill?.payment_type != 2){
                  delete bill.fee; delete bill.discount; delete bill.note; delete bill.total;  delete bill.tax;                  
                  let date = new Date(bill.date);                 
                  //thu tiền
                  if((bill.bill_type === 1)||(bill.bill_type === 7)||(bill.bill_type === 10)||(bill.bill_type === 11)||(bill.bill_type === 34)){
                    if(date >= starttime){
                      json.income = json.income + bill.payment;                    
                      bill.index = json.size + 1;
                      json.docs.push(bill);
                      json.size++;
                      json.empty = false;
                    }else{                     
                      json.cashbook_first = json.cashbook_first + bill.payment; 
                    }
                  }
                  //chi tiền
                  else if((bill.bill_type === 2)||(bill.bill_type === 8)||(bill.bill_type === 12)||(bill.bill_type === 33)){
                    if(date >= starttime){                      
                      json.expenditure = json.expenditure + bill.payment;                 
                      bill.index = json.size + 1;
                      json.docs.push(bill);
                      json.size++;
                      json.empty = false;
                    }else{                                          
                      json.cashbook_first = json.cashbook_first - bill.payment; 
                    }
                  }

                }else{
                  //console.log('bill', bill);
                }
              } 
            }
            json.cashbook_last = json.cashbook_first + json.income - json.expenditure;           
            resolve(json);              
            //console.log('json1', json);   
          })
    })
  }
  private getReportCashBook_old(starttime:any, endtime:any, IDwallet:any, IDbranch?:string){
    starttime = new Date(starttime); endtime = new Date(endtime);
    return new Promise((resolve, reject) => {                
      let query:any;
      if(IDwallet==='all'){       
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date:{$lte:endtime}};
        }else{
          query = {date:{$lte:endtime}, id_branch: {$eq:IDbranch}};          
        }
      }else{        
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date:{$lte:endtime}, id_wallet:{$eq:IDwallet}};
        }else{
          query = {date:{$lte:endtime}, id_wallet:{$eq:IDwallet}, id_branch: {$eq:IDbranch}};                
        }
      }
      this.getBills_byFields(query, {},{date:1},0)
          .then((bills:any)=>{                
              let json: any={
                docs:  new Array(),
                empty: true,
                size: 0,              
                cashbook_first: 0,
                income: 0,
                expenditure: 0,
                cashbook_last: 0 
              }         
            
              if(bills.length >0){ 
                for(let i=0; i<bills.length; i++){          
                  let bill = {...bills[i]};        
                  
                  if(bill?.payment_type != 2){
                    delete bill.fee; delete bill.discount; delete bill.note; delete bill.total;  delete bill.tax;
                    let date = new Date(bill.date);  
                    //thu tiền
                    if((bill.bill_type === 1)||(bill.bill_type === 7)||(bill.bill_type === 10)||(bill.bill_type === 11)||(bill.bill_type === 34)){
                    //if((bill.bill_type === 1)||(bill.bill_type === 7)||(bill.bill_type === 10)||(bill.bill_type === 11)||(bill.bill_type === 15)||(bill.bill_type === 34)){
                      if(date >= starttime){
                        json.income = json.income + bill.payment;                    
                        bill.index = json.size + 1;
                        json.docs.push(bill);
                        json.size++;
                        json.empty = false;
                      }else{                     
                        json.cashbook_first = json.cashbook_first + bill.payment; 
                      }
                    }
                    //chi tiền
                    if((bill.bill_type === 2)||(bill.bill_type === 8)||(bill.bill_type === 12)||(bill.bill_type === 33)){
                    //if((bill.bill_type === 2)||(bill.bill_type === 3)||(bill.bill_type === 8)||(bill.bill_type === 12)||(bill.bill_type === 33)){
                      if(date >= starttime){
                        json.expenditure = json.expenditure + bill.payment;                 
                        bill.index = json.size + 1;
                        json.docs.push(bill);
                        json.size++;
                        json.empty = false;
                      }else{                    
                        json.cashbook_first = json.cashbook_first - bill.payment; 
                      }
                    }
                  }
                } 
              }
              json.cashbook_last = json.cashbook_first + json.income - json.expenditure;
              resolve(json);              

            })
    })
  }

  /**
  * vhQueryCafe
  * Hàm này chỉ chạy trên giao diện Desktop
  * @returns Promise
  */
  private syncCashBookEveryDay_Stock1stDayOfMonth(){//lưu ý bill_type 33, 34 đã là công nợ rồi thì hàm này ko cần đưa vô tính
    return new Promise((resolve, reject) => {  
      let store = this.vhAuth.getStore();            
      //let branchs = this.getlocalBranchs();  
      let branchs = [{...this.getDefaultBranch()}];     
      //console.log('branchs', branchs);
      this.vhMGDB_auth.getServerDate()
            .then((serverdate:any)=>{              
              let DayArray = this.get1stDayOfMonthArray(store.registrationdate, serverdate);//'2021-02-29T17:00:00.000Z'                   
              //console.log('DayArray', DayArray);
              if(DayArray.length >0){
                let promise_branch = new Array();
                for(let m=0; m<branchs.length; m++){
                  let id_branch = branchs[m]._id; 

                      let wallets = this.getlocalWallets().filter((item:any)=> {if(item.id_branch === id_branch) return true; else if(item._id === 'id_cash') return true; else return false}); 
                      let promise = new Array();
                      for(let i=0; i<wallets.length; i++){
                        if(wallets[i]._id === 'id_cash'){
                            if((wallets[i][id_branch] !=undefined)&&(wallets[i][id_branch].cashbook !=undefined)){   
                                let cashbook = wallets[i][id_branch].cashbook[wallets[i][id_branch].cashbook.length -1];    
                                if((new Date(cashbook.date)).getTime() != (new Date(DayArray[DayArray.length-1])).getTime()){
                                  for(let k= wallets[i][id_branch].cashbook.length; k <DayArray.length; k++){
                                    wallets[i][id_branch].cashbook[k] = {};
                                    wallets[i][id_branch].cashbook[k].date = DayArray[k];
                                    wallets[i][id_branch].cashbook[k].cashbook_first =cashbook.cashbook_first;
                                  }                     
                                  
                                  promise[i] = new Promise(resolve=>{
                                    let promise_bill:any = [];
                                    let array_bill_type = [1,7,10,11,34,40,50,2,8,12,33];
                                    while (array_bill_type.length) {      
                                      let array_10_bill_type = array_bill_type.splice(0, 10);    
                                      let query = {date: {$gte:new Date(cashbook.date)}, id_branch: {$eq:id_branch}, id_wallet: {$eq:'id_cash'}, bill_type: {$in:array_10_bill_type}};
                                      //console.log('query1', query);               
                                      promise_bill.push(this.getBills_byFields(query, {},{date:1},0));
                                    }
                                    Promise.all(promise_bill).then((_bills:any)=>{                     
                                            let bills = _bills.flat();      
                                            //console.log('cash_bills1.length', bills.length);                                              
                                            if(bills.length >0){
                                              for(let j=0; j<bills.length; j++){
                                                if(bills[j].id_wallet === 'id_cash'){                    
                                                  for(let k=0; k<wallets[i][id_branch].cashbook.length; k++){                   
                                                    if((new Date(bills[j].date)) < (new Date(wallets[i][id_branch].cashbook[k].date))){
                                                      if((bills[j].bill_type === 1)||(bills[j].bill_type === 7)||(bills[j].bill_type === 10)||(bills[j].bill_type === 11)||(bills[j].bill_type === 34)||(bills[j].bill_type === 40)||(bills[j].bill_type === 50)){
                                                        wallets[i][id_branch].cashbook[k].cashbook_first = wallets[i][id_branch].cashbook[k].cashbook_first + bills[j].payment; 
                                                      }else if((bills[j].bill_type === 2)||(bills[j].bill_type === 8)||(bills[j].bill_type === 12)||(bills[j].bill_type === 33)){
                                                        wallets[i][id_branch].cashbook[k].cashbook_first = wallets[i][id_branch].cashbook[k].cashbook_first - bills[j].payment; 
                                                      }
                                                    }
                                                  }
                                                }
                                              }                                               
                                            }
                                            resolve(wallets[i]);                                           
                                          })
                                    }) 
                                }else{                                  
                                  resolve(null); 
                                }                                   
                            }else{                                             
                                promise[i] = new Promise(resolve=>{                            
                                    let promise_bill:any = [];
                                    let array_bill_type = [1,7,10,11,34,40,50,2,8,12,33];
                                    while (array_bill_type.length) {      
                                      let array_10_bill_type = array_bill_type.splice(0, 10);    
                                      let query = {id_branch: {$eq:id_branch}, id_wallet: {$eq:'id_cash'}, bill_type: {$in:array_10_bill_type}};    
                                      //console.log('query0', query);                                    
                                      promise_bill.push(this.getBills_byFields(query, {},{date:1},0));
                                    }
                                    Promise.all(promise_bill).then((_bills:any)=>{                     
                                            let bills = _bills.flat();         
                                            //console.log('cash_bills0.length', bills.length);
                                            wallets[i][id_branch] = {};
                                            wallets[i][id_branch].cashbook = new Array();
                                            for(let k=0; k<DayArray.length; k++){    
                                              wallets[i][id_branch].cashbook[k] = {};
                                              wallets[i][id_branch].cashbook[k].date = DayArray[k];
                                              wallets[i][id_branch].cashbook[k].cashbook_first = 0;
                                            }
                                            if(bills.length >0){                                                 
                                                for(let j=0; j<bills.length; j++){
                                                  if(bills[j].id_wallet === 'id_cash'){                    
                                                    for(let k=0; k<wallets[i][id_branch].cashbook.length; k++){                   
                                                      if((new Date(bills[j].date)) < (new Date(wallets[i][id_branch].cashbook[k].date))){
                                                        if((bills[j].bill_type === 1)||(bills[j].bill_type === 7)||(bills[j].bill_type === 10)||(bills[j].bill_type === 11)||(bills[j].bill_type === 34)||(bills[j].bill_type === 40)||(bills[j].bill_type === 50)){
                                                          wallets[i][id_branch].cashbook[k].cashbook_first = wallets[i][id_branch].cashbook[k].cashbook_first + bills[j].payment; 
                                                        }else if((bills[j].bill_type === 2)||(bills[j].bill_type === 8)||(bills[j].bill_type === 12)||(bills[j].bill_type === 33)){
                                                          wallets[i][id_branch].cashbook[k].cashbook_first = wallets[i][id_branch].cashbook[k].cashbook_first - bills[j].payment; 
                                                        }
                                                      }
                                                    }
                                                  }
                                                }                                          
                                            }
                                            resolve(wallets[i]);
                                          })
                                        })                      
                            }                                          
                        }else if(wallets[i]._id != 'id_cash'){
                            if(wallets[i].cashbook !=undefined){   
                              let cashbook = wallets[i].cashbook[wallets[i].cashbook.length -1];    
                              if((new Date(cashbook.date)).getTime() != (new Date(DayArray[DayArray.length-1])).getTime()){
                                for(let k= wallets[i].cashbook.length; k <DayArray.length; k++){
                                  wallets[i].cashbook[k] = {};
                                  wallets[i].cashbook[k].date = DayArray[k];
                                  wallets[i].cashbook[k].cashbook_first =cashbook.cashbook_first;
                                }                     
                                
                                promise[i] = new Promise(resolve=>{
                                  let promise_bill:any = [];
                                  let array_bill_type = [1,7,10,11,34,40,50,2,8,12,33];
                                  while (array_bill_type.length) {      
                                    let array_10_bill_type = array_bill_type.splice(0, 10);    
                                    let query = {date: {$gte:new Date(cashbook.date)}, id_branch: {$eq:id_branch}, id_wallet: {$eq:wallets[i]._id}, bill_type: {$in:array_10_bill_type}};
                                    promise_bill.push(this.getBills_byFields(query, {},{date:1},0));
                                  }
                                  Promise.all(promise_bill).then((_bills:any)=>{                     
                                          let bills = _bills.flat();                                                   
                                          if(bills.length >0){
                                              for(let j=0; j<bills.length; j++){
                                                if(bills[j].id_wallet === wallets[i]._id){                    
                                                  for(let k=0; k<wallets[i].cashbook.length; k++){                   
                                                    if((new Date(bills[j].date)) < (new Date(wallets[i].cashbook[k].date))){
                                                      if((bills[j].bill_type === 1)||(bills[j].bill_type === 7)||(bills[j].bill_type === 10)||(bills[j].bill_type === 11)||(bills[j].bill_type === 34)||(bills[j].bill_type === 40)||(bills[j].bill_type === 50)){
                                                        wallets[i].cashbook[k].cashbook_first = wallets[i].cashbook[k].cashbook_first + bills[j].payment; 
                                                      }else if((bills[j].bill_type === 2)||(bills[j].bill_type === 8)||(bills[j].bill_type === 12)||(bills[j].bill_type === 33)){
                                                        wallets[i].cashbook[k].cashbook_first = wallets[i].cashbook[k].cashbook_first - bills[j].payment; 
                                                      }
                                                    }
                                                  }
                                                }
                                              }                                                
                                          }
                                          resolve(wallets[i]);
                                        })
                                  }) 

                              }else{
                                //console.log(wallets[i]._id);
                                resolve(null);
                              }                                   
                            }else{                                                                 
                                promise[i] = new Promise(resolve=>{
                                  let promise_bill:any = [];
                                  let array_bill_type = [1,7,10,11,34,40,50,2,8,12,33];
                                  while (array_bill_type.length) {                                              
                                    let array_10_bill_type = array_bill_type.splice(0, 10);    
                                    let query = {id_branch: {$eq:id_branch}, id_wallet: {$eq:wallets[i]._id}, bill_type: {$in:array_10_bill_type}};                                      
                                    promise_bill.push(this.getBills_byFields(query, {},{date:1},0));
                                  }
                                  Promise.all(promise_bill).then((_bills:any)=>{                     
                                          let bills = _bills.flat();                                      
                                          //console.log(wallets[i].name, bills.length);
                                          wallets[i].cashbook = new Array();
                                          for(let k=0; k<DayArray.length; k++){    
                                            wallets[i].cashbook[k] = {};
                                            wallets[i].cashbook[k].date = DayArray[k];
                                            wallets[i].cashbook[k].cashbook_first = 0;
                                          }
                                          if(bills.length >0){                                              
                                              for(let j=0; j<bills.length; j++){
                                                if(bills[j].id_wallet === wallets[i]._id){                    
                                                  for(let k=0; k<wallets[i].cashbook.length; k++){                   
                                                    if((new Date(bills[j].date)) < (new Date(wallets[i].cashbook[k].date))){
                                                      if((bills[j].bill_type === 1)||(bills[j].bill_type === 7)||(bills[j].bill_type === 10)||(bills[j].bill_type === 11)||(bills[j].bill_type === 34)||(bills[j].bill_type === 40)||(bills[j].bill_type === 50)){
                                                        wallets[i].cashbook[k].cashbook_first = wallets[i].cashbook[k].cashbook_first + bills[j].payment; 
                                                      }else if((bills[j].bill_type === 2)||(bills[j].bill_type === 8)||(bills[j].bill_type === 12)||(bills[j].bill_type === 33)){
                                                        wallets[i].cashbook[k].cashbook_first = wallets[i].cashbook[k].cashbook_first - bills[j].payment; 
                                                      }
                                                    }
                                                  }
                                                }
                                              }                                               
                                          }
                                          resolve(wallets[i]);
                                        })
                                      })                      
                            }   
                        }
                      }
                      promise_branch[m] = new Promise(resolve=>{
                        Promise.all(promise).then(array=>{                          
                          for(let i=0; i<array.length; i++){
                            if(array[i]){                      
                              if(array[i]._id === 'id_cash'){
                                let value:any = {};
                                value[id_branch] = array[i][id_branch];
                                this.vhMGDB_database.updateDoc('wallets', array[i]._id, {...value});
                              }else{
                                this.vhMGDB_database.updateDoc('wallets', array[i]._id, {cashbook: array[i].cashbook});
                              }
                              
                            }
                          }
                          resolve(array);
                        })
                      })
                        
                }
                Promise.all(promise_branch).then(array_branch=>{  
                  console.log('syncCashBookEveryDay');    
                  resolve(null);   
                })
              }else{
                console.log('syncCashBookEveryDay');    
                resolve(null);   
              }
            },(error:any)=>{
              console.log('syncCashBookEveryDay', error);
            }) 
    })
  }

 /**
   * Cafe:
   * @example:
   * let DayArray = this.get1stDayOfMonthArray(store.registrationdate, serverdate);
   * @param startdate 
   * @param enddate 
   * @returns 
   */
  private get1stDayOfMonthArray(startdate: any, enddate: any){
    let dayArray = new Array();
    enddate = new Date(enddate);
    startdate = new Date(startdate);        
    startdate.setDate(1);
    startdate.setHours(0);
    startdate.setMinutes(0);
    startdate.setSeconds(0);   
    startdate.setMilliseconds(0);
    startdate.setMonth(startdate.getMonth() + 1);
    enddate.setDate(1);
    enddate.setHours(0);
    enddate.setMinutes(0);
    enddate.setSeconds(0);  
    enddate.setMilliseconds(0);       
    enddate.setMonth(enddate.getMonth() - 1);
    while(startdate.getTime() <= enddate.getTime()){    
      dayArray.push(new Date(startdate));    
      startdate.setMonth(startdate.getMonth() + 1);                      
    }
    return dayArray;
  }


  /**
   * Hàm này kiểm tra ngày tạo bill, sửa bill đã chọn có hợp lệ không
   * Ngày hợp lệ phải thỏa mãn: 
   * 1. phải sau ngày cửa hàng đăng ký sử dụng phần mềm cafe viethas
   * 2. thuộc tháng mà trước tháng hiện tại 1 tháng
   * @example:
   * this.vhQueryCafe.getValidityDate('2021-06-18T16:27:16.276Z')
        .then((validitydate)=>{          
          if(validitydate) console.log('Bạn chỉ có thể tạo/chỉnh sửa hóa đơn này từ ngày', validitydate);
        })
   * @param date (String or Date): ngày tạo bill, sửa bill 
   * @returns Promise => validitydate = null nếu hợp lệ; validitydate != null nếu không hợp lệ, và từ ngày validitydate trở đi là có thể tạo bill và sửa bill 
   */
  public getValidityDate(date:any){    
    return new Promise((resolve, reject) => {  
      date = new Date(date);            
      this.vhMGDB_auth.getServerDate()// lấy về ngày hệ thống
          .then((serverdate:any)=>{
            serverdate = new Date(serverdate);
            serverdate.setMonth(serverdate.getMonth() - 1);
            serverdate.setDate(1);
            serverdate.setHours(0);
            serverdate.setMinutes(0);
            serverdate.setSeconds(0);   
            if(date.getTime() > serverdate.getTime()){
              if(date.getTime() < new Date(this.vhAuth.getStore().registrationdate).getTime()){
                resolve(new Date(this.vhAuth.getStore().registrationdate));
              }else{
                resolve(null);
              }
              
            }else{
              if(serverdate.getTime() < new Date(this.vhAuth.getStore().registrationdate).getTime()){
                resolve(new Date(this.vhAuth.getStore().registrationdate));
              }else{
                resolve(serverdate);
              }              
            }                  
          })         
    })   
  }

  /**
   * VhQueryCafe: đã check
   * @param starttime 
   * @param endtime 
   * @param id_wallet là 'all' hoặc id của ví nào đó
   * @param id_cashier là 'all' hoặc id của thu ngân nào đó
   * @param array_bill_type 
   * array_bill_type (all) = [1,7,10,11,34,2,8,12,33]; thu:1,7,10,11,34 - chi: 2,8,12,33
   * 
   */
   public getReportIncomeExpenditureDiary(starttime:any, endtime:any,id_wallet:any, id_employee:any, array_bill_type:any, IDbranch?:string){
    //cần xem lại array_bill_type set cứng luôn hay là tham số truyền như hiện có
    return new Promise((resolve, reject) => { 
      let promise:any; 
      if((IDbranch==='all')||(IDbranch===undefined)){
        if((id_wallet==='all')&&(id_employee==='all')) promise = this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, bill_type: {$in:array_bill_type}}, {},{date:1},0);
        if((id_wallet==='all')&&(id_employee!='all')) promise = this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_employee:{$eq:id_employee}, bill_type: {$in:array_bill_type}}, {},{date:1},0);
        if((id_wallet!='all')&&(id_employee==='all')) promise = this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_wallet:{$eq:id_wallet}, bill_type: {$in:array_bill_type}}, {},{date:1},0);
        if((id_wallet!='all')&&(id_employee!='all')) promise = this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_wallet:{$eq:id_wallet}, id_employee:{$eq:id_employee}, bill_type: {$in:array_bill_type}}, {},{date:1},0);  
      }else{
        if((id_wallet==='all')&&(id_employee==='all')) promise = this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, bill_type: {$in:array_bill_type}, id_branch: {$eq:IDbranch}}, {},{date:1},0);
        if((id_wallet==='all')&&(id_employee!='all')) promise = this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_employee:{$eq:id_employee}, bill_type: {$in:array_bill_type}, id_branch: {$eq:IDbranch}}, {},{date:1},0);
        if((id_wallet!='all')&&(id_employee==='all')) promise = this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_wallet:{$eq:id_wallet}, bill_type: {$in:array_bill_type}, id_branch: {$eq:IDbranch}}, {},{date:1},0);
        if((id_wallet!='all')&&(id_employee!='all')) promise = this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_wallet:{$eq:id_wallet}, id_employee:{$eq:id_employee}, bill_type: {$in:array_bill_type}, id_branch: {$eq:IDbranch}}, {},{date:1},0);     
      }  
                
      promise.then((bills:any)=>{             
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,                        
          income: 0,
          expenditure: 0         
        }         
       
        if(bills.length >0){ 
          for(let i=0; i<bills.length; i++){          
            let bill = {...bills[i]};                     
            //thu tiền
            if((bill?.payment_type != 2)){
              if((bill.bill_type === 1)||(bill.bill_type === 7)||(bill.bill_type === 10)||(bill.bill_type === 11)||(bill.bill_type === 34)){              
                  json.income = json.income + bill.payment;                  
                  json.docs.push(bill);        
                  json.size++;
                  json.empty = false;     
              }
              //chi tiền
              if((bill.bill_type === 2)||(bill.bill_type === 8)||(bill.bill_type === 12)||(bill.bill_type === 33)){              
                  json.expenditure = json.expenditure + bill.payment;                    
                  json.docs.push(bill);            
                  json.size++;
                  json.empty = false;  
              }
            }
          } 
        }                
        resolve(json); 
      })
      
    })
  }

  /**
 * @example:
 * let endtime = new Date();
 * let starttime = new Date('2020-07-01T05:24:00');
 * this.vhQueryCafe.getDebtSuppliers(starttime, endtime, 'yewwg44667njdt443s', 'gtrtyery56646577456')
      .then((debts)=>{
        console.log('getDebtSuppliers', debts);
      })
  * @param starttime
  * @param endtime
  * @param IDsuppiler: id_supplier hoặc 'all' 
  * @param IDbranch: id_branch hoặc 'all' 
  * @return JSON(Array) => json.docs = [{id, name, index, debt, payment, rest,...},{},....]
  * Lưu ý: giá trị này trả về dạng array
  */  
public getDebtSuppliers(starttime:any, endtime:any, IDsuppiler:string, IDbranch?:string){  
  starttime = new Date(starttime); endtime = new Date(endtime);
  let store = this.vhAuth.getStore();    
  return new Promise<any>((resolve,reject) => {
    let suppliers:any = new Array();   
    if(IDsuppiler === 'all') suppliers = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalSuppliers(), 'name');  
    else {
      let supplier = this.getlocalSupplier(IDsuppiler);           
      suppliers.push(supplier);
    }

    let branchs = this.getlocalBranchs();
    let id_branch = this.getDefaultBranch()._id;
    let query_bill:any;     
    let index:any = null;
    let day:any = null;
    if((suppliers[0][id_branch] != undefined)&&(suppliers[0][id_branch].debt != undefined))
      for(let k=0; k<suppliers[0][id_branch].debt.length; k++){
        if((new Date(suppliers[0][id_branch].debt[k].date)).getTime() > starttime.getTime()){
          break;
        }else{
          day = new Date(suppliers[0][id_branch].debt[k].date);
          index = k;
        }
      }             
    if(!day) day = new Date(store.registrationdate);       
    if(IDsuppiler === 'all'){ 
      if((IDbranch === 'all')||(IDbranch === undefined)){              
        query_bill = {date:{$gte:day, $lte:endtime}, bill_type: {$in:[2,10,12]}};        
      }else{        
        query_bill = {date:{$gte:day, $lte:endtime}, bill_type: {$in:[2,10,12]}, id_branch: {$eq:IDbranch}};        
      }     
    }else{
      if((IDbranch === 'all')||(IDbranch === undefined)){              
        query_bill = {date:{$gte:day, $lte:endtime}, id_supplier: {$eq:IDsuppiler}, bill_type: {$in:[2,10,12]}};        
      }else{                   
        query_bill = {date:{$gte:day, $lte:endtime}, id_supplier: {$eq:IDsuppiler}, bill_type: {$in:[2,10,12]}, id_branch: {$eq:IDbranch}}; 
      }    
    }    
    this.getBills_byFields(query_bill, {},{date:1},0) 
        .then((bills:any)=>{              
            let json:any = {
              docs: new Array(),   
              debt_beginning: 0,                                 
              payment: 0,
              debt: 0,
              rest: 0
            } 
            
            for(let i=0; i<suppliers.length; i++){
              let supplier:any = {
                _id:  suppliers[i]._id,
                name:  suppliers[i].name
              };                                      
              json.docs.push(supplier);                    
              let debt = 0; let pay = 0; let debt_beginning = 0; let debt_first = 0;
              for(let j=0; j<bills.length; j++){                   
                  if(bills[j].id_supplier === suppliers[i]._id){
                      if((new Date(bills[j].date)).getTime() >= starttime.getTime()){
                          if(bills[j].bill_type === 2){
                            debt = debt + bills[j].total * (1 + bills[j].tax/100);
                            pay = pay + bills[j].payment;
                          }
                          else if(bills[j].bill_type === 12){
                            pay = pay + bills[j].payment;
                          }
                          else if(bills[j].bill_type === 10){
                            pay = pay + bills[j].total * (1 + bills[j].tax/100);
                            debt = debt + bills[j].payment;
                          }
                      }else{
                          if(bills[j].bill_type === 2){                             
                            debt_first = debt_first + bills[j].total * (1 + bills[j].tax/100) - bills[j].payment;
                          }
                          else if(bills[j].bill_type === 10){                             
                            debt_first = debt_first + bills[j].payment - bills[j].total * (1 + bills[j].tax/100);
                          }
                          else if(bills[j].bill_type === 12){                             
                            debt_first = debt_first - bills[j].payment;
                          }                            
                      } 
                  }                                           
              }

              if((IDbranch === 'all')||(IDbranch === undefined)){                 
                for(let j=0; j<branchs.length; j++){
                  if((suppliers[i][branchs[j]._id] != undefined)&&(suppliers[i][branchs[j]._id].debt_beginning != undefined)){
                    debt_beginning = debt_beginning + suppliers[i][branchs[j]._id].debt_beginning;
                  }
                }
              }else{
                if((suppliers[i][IDbranch] != undefined)&&(suppliers[i][IDbranch].debt_beginning != undefined)){
                  debt_beginning = suppliers[i][IDbranch].debt_beginning;
                }

                if((suppliers[i][IDbranch] != undefined)&&(suppliers[i][IDbranch].debt != undefined)){
                  if(!index)
                    if(suppliers[i][IDbranch].debt[index] !=undefined)
                      debt_first = debt_first + suppliers[i][IDbranch].debt[index].debt_first;
                }
              }                  
              
              debt = debt_beginning + debt_first + debt;
              json.docs[json.docs.length -1].index = json.docs.length;
              json.docs[json.docs.length -1].debt = debt;
              json.docs[json.docs.length -1].payment = pay;
              json.docs[json.docs.length -1].rest = debt - pay;
              
              
              json.debt_beginning = json.debt_beginning + debt_beginning;
              json.debt = json.debt + debt;
              json.payment = json.payment + pay;   
              json.rest = json.rest + debt - pay;   

              let _json:any = {
                docs: new Array(), 
                empty: true,
                size:0,
                debt_beginning: debt_beginning + debt_first,
                debt: debt_beginning + debt_first,
                payment: 0,
                rest: debt_beginning + debt_first
              }                 
                      
              for(let j=0; j<bills.length; j++){
                if(suppliers[i]._id === bills[j].id_supplier){                    
                  if((new Date(bills[j].date)).getTime() >= starttime.getTime()){
                    let bill:any = {...bills[j]};
                    delete bill?.discount; delete bill?.fee; delete bill?.id_supplier;
                    delete bill?.note; delete bill?.payment_type; delete bill?.tax;
                    _json.docs.push(bill);         
                    _json.docs[_json.docs.length -1].debt = 0;
                    _json.docs[_json.docs.length -1].payment = 0;
                    
                    if(bills[j].bill_type === 2){
                      _json.docs[_json.docs.length -1].debt = bills[j].total * (1 + bills[j]?.tax/100);
                      _json.docs[_json.docs.length -1].payment = bills[j].payment;         
                      _json.docs[_json.docs.length -1].rest = _json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;     
                    }
                    else if(bills[j].bill_type === 10){
                      _json.docs[_json.docs.length -1].payment = bills[j].total * (1 + bills[j]?.tax/100);
                      _json.docs[_json.docs.length -1].debt = bills[j].payment;           
                      _json.docs[_json.docs.length -1].rest = _json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;      
                    }
                    else if(bills[j].bill_type === 12){
                      _json.docs[_json.docs.length -1].payment = bills[j].payment;
                      _json.docs[_json.docs.length -1].rest = - bills[j].payment;
                    }                      
    
                    _json.debt = _json.debt + _json.docs[_json.docs.length -1].debt;
                    _json.payment = _json.payment + _json.docs[_json.docs.length -1].payment   
                    _json.rest = _json.rest +_json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;   
                    _json.size++;
                    _json.empty = false;   
                    _json.docs[_json.docs.length -1].index = _json.docs.length;    
                  }               
                }
              }
              json.docs[json.docs.length -1].json = _json;
            }
              
            console.log('json', json)    
            resolve(json);
        })     
  })
}

/**
 * CÔNG NỢ KHÁCH HÀNG
 * @example:
 * let endtime = new Date();
 * let starttime = new Date('2020-07-01T05:24:00');
 * this.vhQueryCafe.getDebtCustomers(starttime, endtime, 'yewwg44667njdt443s', 'gtrtyery56646577456')
      .then((debts)=>{
        console.log('getDebtCustomers', debts);
      })
  * @param starttime
  * @param endtime
  * @param IDcustomer: id_customer hoặc 'all'  
  * @param IDbranch: id_branch hoặc 'all'  
  * @return JSON(Array) => json.docs = [{id, name, index, debt, payment, rest,...},{},....]
  * Lưu ý: giá trị này trả về dạng array
  */
  public getDebtCustomers(starttime:any, endtime:any, IDcustomer:string, IDbranch?:string){
    return new Promise<any>((resolve,reject) => {
      let json:any = {
        docs: new Array(),   
        debt_beginning: 0,                                 
        payment: 0,
        debt: 0,
        rest: 0
      } 
      if((IDbranch == 'all')|| (IDbranch == undefined)) return resolve(json);
      if((IDcustomer == 'all')|| (IDcustomer == undefined)) return resolve(json);

      let store = this.vhAuth.getStore();  
      let customers:any = new Array();   
      if(IDcustomer === 'all') customers = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalCustomers().filter((item:any)=> item._id != 'id_retail'), 'name');  
      else {
        let customer = this.getlocalCustomer(IDcustomer);           
        customers.push(customer);
      }  
      let branchs = this.getlocalBranchs();
      let id_branch = this.getDefaultBranch()._id;
      let query_bill:any;     
      let index:any = null;
      let day:any = null;
      if((customers[0][id_branch] != undefined)&&(customers[0][id_branch].debt != undefined))
        for(let k=0; k<customers[0][id_branch].debt.length; k++){
          if((new Date(customers[0][id_branch].debt[k].date)).getTime() > starttime.getTime()){
            break;
          }else{
            day = new Date(customers[0][id_branch].debt[k].date);
            index = k;
          }
        }            
      if(!day) day = new Date(store.registrationdate);   
      if(IDcustomer === 'all'){ 
        if((IDbranch === 'all')||(IDbranch === undefined)){              
          query_bill = {date:{$gte:day, $lte:endtime}, bill_type: {$in:[1,11]}};      
        }else{        
          query_bill = {date:{$gte:day, $lte:endtime}, bill_type: {$in:[1,11]}, id_branch: {$eq:IDbranch}};        
        }     
      }else{
        if((IDbranch === 'all')||(IDbranch === undefined)){              
          query_bill = {date:{$gte:day, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:[1,11]}};        
        }else{        
          query_bill = {date:{$gte:day, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:[1,11]}, id_branch: {$eq:IDbranch}};   
        }    
      }

      this.getBills_byFields(query_bill, {},{date:1},0) 
          .then((bills:any)=>{              
              // let json:any = {
              //   docs: new Array(),   
              //   debt_beginning: 0,                                 
              //   payment: 0,
              //   debt: 0,
              //   rest: 0
              // } 
              
              for(let i=0; i<customers.length; i++){
                let customer:any = {
                  _id:  customers[i]._id,
                  name:  customers[i].name
                };                                      
                json.docs.push(customer);                    
                let debt = 0; let pay = 0; let debt_beginning = 0; let debt_first = 0;
                for(let j=0; j<bills.length; j++){
                    if(bills[j].id_customer === customers[i]._id){
                      if((new Date(bills[j].date)).getTime() >= starttime.getTime()){
                        if(bills[j].bill_type === 1){                               
                          debt = debt + bills[j].total * (1 + bills[j].tax/100);
                          pay = pay + bills[j].payment;
                        }
                        else if(bills[j].bill_type === 11){                              
                          pay = pay + bills[j].payment;
                        }                        
                      }else{
                        if(bills[j].bill_type === 1){                         
                          debt_first = debt_first + bills[j].total * (1 + bills[j].tax/100) - bills[j].payment;
                        }
                        else if(bills[j].bill_type === 11){    
                          debt_first = debt_first - bills[j].payment;                     
                        }                          
                      } 
                    }                          
                }                 

                if((IDbranch === 'all')||(IDbranch === undefined)){                 
                  for(let j=0; j<branchs.length; j++){
                    if((customers[i][branchs[j]._id] != undefined)&&(customers[i][branchs[j]._id].debt_beginning != undefined)){
                      debt_beginning = debt_beginning + customers[i][branchs[j]._id].debt_beginning;
                    }
                  }
                }else{
                  if((customers[i][IDbranch] != undefined)&&(customers[i][IDbranch].debt_beginning != undefined)){
                    debt_beginning = customers[i][IDbranch].debt_beginning;
                  }
                  if((customers[i][IDbranch] != undefined)&&(customers[i][IDbranch].debt != undefined)){
                    if(!index)
                      if(customers[i][IDbranch].debt[index] !=undefined)
                        debt_first = debt_first + customers[i][IDbranch].debt[index].debt_first;
                  }
                }                  
                
                debt = debt_beginning + debt_first + debt;
                json.docs[json.docs.length -1].index = json.docs.length;
                json.docs[json.docs.length -1].debt = debt;
                json.docs[json.docs.length -1].payment = pay;
                json.docs[json.docs.length -1].rest = debt - pay;
                
                
                json.debt_beginning = json.debt_beginning + debt_beginning;
                json.debt = json.debt + debt;
                json.payment = json.payment + pay;   
                json.rest = json.rest + debt - pay;   

                let _json:any = {
                  docs: new Array(), 
                  empty: true,
                  size:0,
                  debt_beginning: debt_beginning + debt_first,
                  debt: debt_beginning + debt_first,
                  payment: 0,
                  rest: debt_beginning + debt_first
                }                 
                        
                for(let j=0; j<bills.length; j++){
                  if(customers[i]._id === bills[j].id_customer){
                    if((new Date(bills[j].date)).getTime() >= starttime.getTime()){
                        let bill:any = {...bills[j]};
                        delete bill?.discount; delete bill?.fee; delete bill?.id_customer;
                        delete bill?.note; delete bill?.payment_type; delete bill?.tax;
                        _json.docs.push(bill);
                        _json.docs[_json.docs.length -1].debt = 0;
                        _json.docs[_json.docs.length -1].payment = 0;
                        
                        if(bills[j].bill_type === 1){
                          _json.docs[_json.docs.length -1].debt = bills[j].total * (1 + bills[j]?.tax/100);
                          _json.docs[_json.docs.length -1].payment = bills[j].payment;
                          _json.docs[_json.docs.length -1].rest = _json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;  
                        }else if(bills[j].bill_type === 11){
                          _json.docs[_json.docs.length -1].payment = bills[j].payment;
                          _json.docs[_json.docs.length -1].rest = - bills[j].payment;
                        }
                        
                        _json.debt = _json.debt + _json.docs[_json.docs.length -1].debt;
                        _json.payment = _json.payment + _json.docs[_json.docs.length -1].payment   
                        _json.rest = _json.rest +_json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;   
                        _json.size++;
                        _json.empty = false;  
                        _json.docs[_json.docs.length -1].index = _json.docs.length;   
                    }                                  
                  }
                }
                json.docs[json.docs.length -1].json = _json;
              }
                
              console.log('json', json)    
              resolve(json);
          })     
    })
  }  

  /**
   * @Usage Hàm này dùng trong page DOANH SỐ DANH MỤC (layer 1) -> Chọn TẤT CẢ hoặc MỘT danh mục
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Categorys_byCategorys(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDcategory = 'all' or id_category
   * @param IDbranch : 'all' or id_branch
   * @param type = 1 là món, = 2 là dịch vụ,  = 3 là nguyên liệu, = 4 là topping, = 5 combo, =1234 món - dịch vụ - nguyên liệu - topping
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, id_category, quantity, sales_btax, sales_atax}
   */  
    public getReportSales_Categorys_byCategorys(starttime:any, endtime:any, IDcategory:any, type?:any, IDbranch?:string){//ko cần truyền vào type
      //hàm này chỉ dành cho sản phẩm và dịch vụ
      console.log('type', type);   
      if(IDcategory === 'all') type = 1234;
      else{
        type = this.getlocalCategory(IDcategory).type;
      }
      //console.log('_type', type); 
      return new Promise<any>((resolve, reject) => {      
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0
        }  
            
        let categorys:any = new Array();   
        let query:any; 
        let promise = new Array();
        if(IDcategory === 'all') {
          categorys = this.getlocalCategorys(type);    
        }else{
          categorys.push(this.getlocalCategory(IDcategory));    
        }
        let bill_types = [1,41,51]
        
        if(IDcategory === 'all') {                 
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};           
          }
        }else{                 
          if((IDbranch==='all')||(IDbranch===undefined)){        
            query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:type}, bill_type: {$in:bill_types}};         
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:type}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};         
          }
        }     
            
        if(categorys.length>0){   
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                         
                if(vhbill_details.length>0){                
                            for(let i=0; i<categorys.length; i++){       
                                  let transaction = false;           
                                  let category =  {...categorys[i]};                                   
                                  let data:any ={   
                                    id_category: category._id,  
                                    name: category.name,                                                           
                                    sales_btax: 0,
                                    sales_atax: 0,
                                    quantity: 0
                                  }                            
                                  for(let j=0; j<vhbill_details.length; j++){
                                    let _id_category = this.getlocalDetailProduct(vhbill_details[j].id_subproduct?vhbill_details[j].id_subproduct:vhbill_details[j].id_product).id_category;
                                   
                                      if((type === 1)||(type === 2)||(type === 3)||(type === 4)){                                                          
                                        if(categorys[i]._id === _id_category){
                                          transaction = true;                                
                                          data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                          data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                          data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                                        }                                    
                                      }else if(type === 1234){
                                          if(vhbill_details[j].ptype === 1){           
                                              if(categorys[i]._id === _id_category){
                                                transaction = true                         
                                                data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                                data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                                data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                              }                                                                                                                                               
                                          }else if(vhbill_details[j].ptype === 2){
                                              if(categorys[i]._id === _id_category){
                                                transaction = true                         
                                                data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                                data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                                data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                 
                                              }                                               
                                          }else if(vhbill_details[j].ptype === 3){
                                            if(categorys[i]._id === _id_category){
                                              transaction = true                         
                                              data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                              data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                              data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                 
                                            }                                                               
                                          }else if(vhbill_details[j].ptype === 4){
                                            if(categorys[i]._id === _id_category){
                                              transaction = true                         
                                              data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                              data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                              data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                 
                                            }                                                               
                                          }                                               
                                      }                                    
                                  }
                                  //console.log('---------------data', data);
                                  if(transaction){
                                    /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                    data.sales_atax = this.vhAlgorithm.roundTo3Decimals(data.sales_atax);
                                    // if(data.subs != undefined)
                                    //   data.subs.forEach((item:any) => {
                                    //     item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                    //   });
                                    // if(data.combos != undefined)  
                                    //   data.combos.forEach((item:any) => {
                                    //     item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                    //   });
                                    json.quantity = json.quantity + data.quantity;
                                    json.sales_btax = json.sales_btax + data.sales_btax;
                                    json.sales_atax = json.sales_atax + data.sales_atax;
                                    data.index = json.size + 1;
                                    json.docs.push(data);
                                    json.size++;                        
                                    json.empty = false; 
                                  }                                               
                            }
                }    
                console.log('getReportSales_Categorys_byCategorys', json);                     
                resolve(json);
              })
        }else resolve(json);      
      })
    }

/**
   * @Usage Hàm này dùng trong page DOANH SỐ DANH MỤC (layer 2) -> Chọn TẤT CẢ hoặc MỘT sản phẩm -> Chọn một danh mục trong list hiện ra
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Categorys_byProducts(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param id_category
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, id_product, name, barcode, unit, img, quantity, sales_btax, sales_atax}
   */ 
  public getReportSales_Categorys_byProducts(starttime:any, endtime:any, id_category:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0 
      }                        
      let type = this.getlocalCategory(id_category).type;        
      let query:any;                  
      let bill_types = [1,41,51]            
      if((IDbranch==='all')||(IDbranch===undefined)){        
        query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq: type}, bill_type: {$in:bill_types}};         
      }else{
        query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq: type}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};         
      }    
                    
      this.getBill_details_byFields(query, {},{date:1},0)
          .then((vhbill_details:any)=>{                
            if(vhbill_details.length>0){  
              let products:any = this.getlocalDetailProducts().filter((item:any)=>{
                if(item.id_category === id_category) return <any>true;
              })                
              for(let i=0; i<products.length; i++){       
                let transaction = false;           
                let product =  {...products[i]};    
                let unit = this.getUnit_byRatio(product.units, 1);                                        
                let record:any ={   
                  id_product: product._id,                  
                  name: product.name, 
                  unit: unit.unit,
                  barcode: unit.barcode,
                  img: product.img,                                   
                  sales_btax: 0,
                  sales_atax: 0,
                  quantity: 0                                   
                }                                                
                if(product.id_subproduct) record.id_subproduct = product.id_subproduct;   
                if(products[i].lots) {
                  record.lots = cloneDeep(products[i].lots);
                  for(let m = 0; m<record.lots.length; m++){
                    record.lots[m].quantity = 0;
                    record.lots[m].sales_btax = 0;
                    record.lots[m].sales_atax = 0;
                  }
                }          
                for(let j=0; j<vhbill_details.length; j++){
                  let is_sub_or_product = false;
                  if(record.id_subproduct) is_sub_or_product = vhbill_details[j].id_subproduct === record.id_subproduct;
                  else is_sub_or_product = vhbill_details[j].id_product === record.id_product;
                  
                  if(is_sub_or_product){                                              
                    transaction = true   
                    if(record.lots){
                      for(let m=0; m<record.lots.length; m++){
                        if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                          record.lots[m].quantity =   record.lots[m].quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                          record.lots[m].sales_btax = record.lots[m].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                          record.lots[m].sales_atax = record.lots[m].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                        }
                      }   
                    }                         
                    record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                    record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                    record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                              
                    
                  }                                 
                }
                if(transaction){
                  /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                  record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);
                  if(record.subs != undefined)
                  record.subs.forEach((item:any) => {
                      item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                    });
                  if(record.combos != undefined)  
                    record.combos.forEach((item:any) => {
                      item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                    });
                  json.quantity = json.quantity + record.quantity;
                  json.sales_btax = json.sales_btax + record.sales_btax;
                  json.sales_atax = json.sales_atax + record.sales_atax;
                  record.index = json.size + 1;
                  json.docs.push(record);
                  json.size++;                        
                  json.empty = false; 
                }                                               
              }
            }    
            console.log('getReportSales_Categorys_byProducts', json);                     
            resolve(json);
          })
    })
  }  

  
  /**
  * @Usage Hàm này dùng trong page DOANH SỐ DANH MỤC (layer 3) ->  Chọn TẤT CẢ hoặc MỘT danh mục -> Chọn một danh mục trong list hiện ra -> Chọn một sản phẩm trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Categorys_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_sub_or_product 
  * @param IDbranch : 'all' or id_branch 
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman}
  */
  public getReportSales_Categorys_byProduct(starttime:any, endtime:any, id_sub_or_product:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {  
      (async () => {
        try{
          let json:any = {
            docs: new Array(),
            empty: true,
            size:0,
            sales_btax: 0,   
            sales_atax: 0,  
            quantity: 0
          }       
          let product = await this.getlocalDetailProduct_Async(id_sub_or_product);  
          let query:any;                  
          let bill_types = [1,41,51]  
    
          if((IDbranch==='all')||(IDbranch===undefined)){
            if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:bill_types}};
            else                      query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:bill_types}};
          }else{
            if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};    
            else                      query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};        
          }   
        
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                          
                if(vhbill_details.length>0){    
                  for(let i=0; i<vhbill_details.length; i++){                         
                    let transaction = false;
                    let unit = this.getUnit_byRatio(product.units, 1); 
                    let record:any ={   
                      id_product: product._id,                  
                      name: product.name,                         
                      img: product.img,        

                      ratio: unit.ratio,
                      unit: unit.unit,
                      barcode: unit.barcode,
                      
                      bill_code: vhbill_details[i].bill_code,
                      bill_type:  vhbill_details[i].bill_type,
                      id_bill: vhbill_details[i].id_bill,
                      date: vhbill_details[i].date,
                      tax: vhbill_details[i].tax,
                      salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                      customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                    }  
                    if(vhbill_details[i].id_subproduct) record.id_subproduct = vhbill_details[i].id_subproduct;                      
                    if(vhbill_details[i].id_lotproduct){
                      record.id_lotproduct = vhbill_details[i].id_lotproduct; 
                      record.lots = new Array;
                      for(let m = 0; m<product.lots.length; m++){
                        if(product.lots[m]._id === record.id_lotproduct) {
                          record.lots.push(product.lots[m]);
                          break;
                        }
                      }
                    } 
                                    
                    transaction = true;
                    record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                      
                    record.price = vhbill_details[i].price/vhbill_details[i].ratio;                        
                    
                    if(transaction){
                      record.sales_btax = record.price * record.quantity;
                      record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                      record.index = json.size + 1;                   
                      json.docs.push(record);
                      json.size++;
                      json.empty = false;
                      json.quantity = json.quantity + record.quantity;
                      json.sales_btax = json.sales_btax + record.price * record.quantity;
                      json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                    }                                                                              
                  }                                 
                }           
                console.log('getReportSales_Categorys_byProduct', json);      
                resolve(json);                
              })
		    } catch (err) {
          console.error('❌ Lỗi getReportSales_Employees_byProduct:', err);
          reject(err);
        }  
      })();            
    })      
  }


     /**
   * @Usage Hàm này dùng trong page DOANH SỐ KHU VỰC (layer 1) -> Chọn TẤT CẢ hoặc MỘT khu vực
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Areas_byAreas(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDarea = 'all' or id_area
   * @param IDbranch = 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, id_category, quantity, sales_btax, sales_atax}
   */
  public getReportSales_Areas_byAreas(starttime:any, endtime:any, IDarea:any, IDbranch?:string){   
    return new Promise<any>((resolve, reject) => { 
      let areas:any = new Array();   
      if(IDarea === 'all') areas = this.getlocalAreas()   
      else {
        let area = this.getlocalArea(IDarea);          
        areas.push(area);      
      }             
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0 
      }               
      if(areas.length>0){                                
        let query:any;
        let bill_types = [1,40,50]
        if(IDarea === 'all'){        
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};          
          }
        }else{
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:IDarea}, bill_type: {$in:bill_types}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:IDarea}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};            
          }
          
        }        
        this.getBill_details_byFields(query, {},{date:1},0)
            .then((vhbill_details:any)=>{                     
                    if(vhbill_details.length>0){                                                 
                      for(let i=0; i<areas.length; i++){   
                        let transaction = false;                                                                 
                        let data:any ={   
                          id_area: areas[i]._id,                  
                          name: areas[i].name,                          
                          img: areas[i]?.img,                                   
                          sales_btax: 0,
                          sales_atax: 0,
                          quantity: 0
                        }                                                                       
                        for(let j=0; j<vhbill_details.length; j++){                           
                          if(areas[i]._id ===vhbill_details[j].id_area){  
                            transaction = true;                           
                            if((vhbill_details[j].ptype ===1)||(vhbill_details[j].ptype ===2)||(vhbill_details[j].ptype ===3)||(vhbill_details[j].ptype ===4)||(vhbill_details[j].vtype ===1)||(vhbill_details[j].pctype ===1)){
                              data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                              data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                              data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                            }                                          
                          }
                        }
                        if(transaction){
                          json.quantity = json.quantity + data.quantity;
                          json.sales_btax = json.sales_btax + data.sales_btax;
                          json.sales_atax = json.sales_atax + data.sales_atax;
                          data.index = json.size + 1;
                          json.docs.push(data);
                          json.size++;                        
                          json.empty = false; 
                        }                          
                      }                      
                    }          
                    console.log('getReportSales_Areas_byAreas', json);             
                    resolve(json);
                  })
      }else resolve(json);     
    })
  }
  private getReportSales_Areas_byAreas_old(starttime:any, endtime:any, IDarea:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      let areas:any = new Array();   
      if(IDarea === 'all') areas = this.getlocalAreas(); 
      else {
        let area = this.getlocalArea(IDarea);          
        areas.push(area);      
      }        
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0 
      }               
      if(areas.length>0){                                 
        let query:any;       
        if(IDarea === 'all'){        
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};        
          }
        }else{
          if((IDbranch==='all')||(IDbranch===undefined)){            
            query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:IDarea}, bill_type: {$in:[1]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:IDarea}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};                 
          }        
        }            
        this.getBill_details_byFields(query, {},{date:1},0)                          
            .then((vhbill_details:any)=>{       
                      if(vhbill_details.length>0){                                                 
                        for(let i=0; i<areas.length; i++){                               
                            let transaction = false;                                                     
                            let data:any ={   
                              id_area: areas[i]._id,                  
                              name: areas[i].name,                                                             
                              sales_btax: 0,
                              sales_atax: 0,
                              quantity: 0
                            }                                                  
                            for(let j=0; j<vhbill_details.length; j++){                           
                              if(areas[i]._id ===vhbill_details[j].id_area){  
                                if(vhbill_details[j].ptype ===5){
                                  if(vhbill_details[j].combos != undefined)
                                    for(let m=0; m<vhbill_details[j].combos.length; m++){                                                   
                                        data.quantity = data.quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                        data.sales_btax = data.sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                        data.sales_atax = data.sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                       
                                    } 
                                }else{
                                  transaction = true;                                
                                  data.quantity = data.quantity + vhbill_details[j].quantity;
                                  data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
      
                                  if(vhbill_details[j].toppings != undefined)
                                    for(let m=0; m<vhbill_details[j].toppings.length; m++){                                                   
                                        data.quantity = data.quantity + vhbill_details[j].toppings[m].quantity;
                                        data.sales_btax = data.sales_btax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity;
                                        data.sales_atax = data.sales_atax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity * (1 + vhbill_details[j].tax / 100);                       
                                    } 
                                }
                              }
                            }
                            if(transaction){
                              json.quantity = json.quantity + data.quantity;
                              json.sales_btax = json.sales_btax + data.sales_btax;
                              json.sales_atax = json.sales_atax + data.sales_atax;
                              data.index = json.size + 1;
                              json.docs.push(data);
                              json.size++;                        
                              json.empty = false; 
                            }                                                      
                        }
                      }                       
                      resolve(json);
                    })
      }else resolve(json);     
    })
  }
 
  /**
 * @Usage Hàm này dùng trong page DOANH SỐ DANH MỤC KHU VỰC (layer 2) -> Chọn TẤT CẢ hoặc MỘT khu vực -> Chọn một khu vực món trong list hiện ra
 * @example
 *  let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Areas_byProducts(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_area
  * @param IDbranch = 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, id_product, name, barcode, unit, img, quantity, sales_btax, sales_atax}
  */    
  private getReportSales_Areas_byProducts(starttime:any, endtime:any, id_area:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
        let products:any = this.getlocalProducts(1234);                                    
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, bill_type: {$in:[1]}};
        }else{
          query = query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};          
        }   
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0 
        }                    
        if(products.length>0){ 
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                         
                if(vhbill_details.length>0){                
                    for(let i=0; i<products.length; i++){       
                        let transaction = false;           
                        let product =  {...products[i]};                                   
                        let data:any ={   
                          id_product: product._id,                  
                          name: product.name, 
                          unit: product.unit,
                          barcode: product.barcode,
                          img: product.img,                                   
                          sales_btax: 0,
                          sales_atax: 0,
                          quantity: 0,
                          subs: new Array()//
                        }  
                        if(product.subs != undefined){
                          //data.subs = new Array();
                          for(let k=0; k<product.subs.length; k++){
                            let sub:any ={
                              id_subproduct: product.subs[k]._id,                    
                              name: product.subs[k]?.name,
                              sales_btax: 0,
                              sales_atax: 0,
                              quantity: 0                          
                            }
                            data.subs.push(sub);
                          }
                        }                        
                        
                        for(let j=0; j<vhbill_details.length; j++){                                                            
                                if(vhbill_details[j].ptype === 1){                                                            
                                  if(products[i].type === 1){
                                    if(products[i]._id ===vhbill_details[j].id_product){
                                      transaction = true                         
                                      data.quantity = data.quantity + vhbill_details[j].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                      if(data.subs != undefined)
                                        for(let k=0; k<data.subs.length; k++){
                                          if(products[i].subs[k]._id === vhbill_details[j].id_subproduct){
                                            data.subs[k].quantity = data.subs[k].quantity + vhbill_details[j].quantity;
                                            data.subs[k].sales_btax = data.subs[k].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                            data.subs[k].sales_atax = data.subs[k].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                            break;
                                          }
                                        }  
                                    }
                                  }
                                  
                                  if(products[i].type === 4){                                                             
                                    if(vhbill_details[j].toppings != undefined){                                                                                                             
                                      for(let m=0; m<vhbill_details[j].toppings.length; m++){                                                                 
                                        if(products[i]._id ===vhbill_details[j].toppings[m].id_product){
                                          transaction = true                         
                                          data.quantity = data.quantity + vhbill_details[j].toppings[m].quantity;
                                          data.sales_btax = data.sales_btax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity;
                                          data.sales_atax = data.sales_atax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity * (1 + vhbill_details[j].tax / 100);                                                                                   
                                        }
                                      }
                                    }
                                  }
                                                                                    
                                }else if(vhbill_details[j].ptype === 2){
                                    if(products[i]._id ===vhbill_details[j].id_product){
                                      transaction = true                         
                                      data.quantity = data.quantity + vhbill_details[j].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                 
                                    }
                                      
                                }else if(vhbill_details[j].ptype === 3){
                                    if(products[i]._id ===vhbill_details[j].id_product){
                                      transaction = true                         
                                      data.quantity = data.quantity + vhbill_details[j].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                               
                                    }  
                                }else if(vhbill_details[j].ptype === 4){
                                    if(products[i]._id ===vhbill_details[j].id_product){
                                      transaction = true                         
                                      data.quantity = data.quantity + vhbill_details[j].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                  
                                    }                                 
                                }else if(vhbill_details[j].ptype === 5){  
                                  for(let m=0; m<vhbill_details[j].combos.length; m++){
                                      if(products[i]._id ===vhbill_details[j].combos[m].id_product){
                                        transaction = true                         
                                        data.quantity = data.quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                        data.sales_btax = data.sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                        data.sales_atax = data.sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                        if(data.subs != undefined)
                                          for(let k=0; k<data.subs.length; k++){                                    
                                            if(products[i].subs[k]._id === vhbill_details[j].combos[m].id_subproduct){
                                              data.subs[k].quantity = data.subs[k].quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                              data.subs[k].sales_btax = data.subs[k].sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                              data.subs[k].sales_atax = data.subs[k].sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                              break;
                                            }
                                          }                                                     
                                      }
                                  }                                                          
                                }
                        }
                        if(transaction){
                          /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                          data.sales_atax = this.vhAlgorithm.roundTo3Decimals(data.sales_atax);
                          if(data.subs != undefined)
                            data.subs.forEach((item:any) => {
                              item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                            });                                    
                          json.quantity = json.quantity + data.quantity;
                          json.sales_btax = json.sales_btax + data.sales_btax;
                          json.sales_atax = json.sales_atax + data.sales_atax;
                          data.index = json.size + 1;
                          json.docs.push(data);
                          json.size++;                        
                          json.empty = false; 
                        }                                               
                    }
                }                
                console.log('getReportSales_Areas_byProducts');                         
                resolve(json);
              })
        }else resolve(json);            
      
    })
  }

  
  /**
   * @Usage Hàm này dùng trong page DOANH SỐ KHU VỰC (layer 2) -> Chọn TẤT CẢ hoặc MỘT khu vực -> Chọn một khu vực trong list hiện ra
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00'); 
      this.vhQueryCafe.getReportSales_Areas_byProducts_Vouchers_PaymentCards(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param id_area
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_product, ptype, hoặc id_voucher, vtype, hoặc id_payment_card, pctype, index, name, barcode, unit, img, id_area, quantity, sales_btax, sales_atax}
   */
  public getReportSales_Areas_byProducts_Vouchers_PaymentCards(starttime:any, endtime:any, id_area:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
        let products:any = this.getlocalDetailProducts(1234);                                    
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, bill_type: {$in:[1,40,50]}};
        }else{
          query = query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, bill_type: {$in:[1,40,50]}, id_branch: {$eq:IDbranch}};          
        }   
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0 
        }                    
        //if(products.length>0){ 
          let vouchers = new Array();
          let payment_cards = new Array();     
          let promise = new Array();
          promise[0] = this.vhMGDB_database.getDocs('vouchers');
          promise[1] = this.vhMGDB_database.getDocs('payment_cards');
          Promise.all(promise)
                .then((array:any)=>{              
                  vouchers = [...array[0]];
                  payment_cards = [...array[1]];     
                  this.getBill_details_byFields(query, {},{date:1},0)
                      .then((vhbill_details:any)=>{                                 
                        if(vhbill_details.length>0){                
                            for(let i=0; i<products.length; i++){       
                                let transaction = false;                                        
                                let unit = this.getUnit_byRatio(products[i].units, 1);                             
                                let record:any ={   
                                  id_product: products[i]._id,              
                                  name: products[i].name,
                                  img: products[i].img,
                                  ptype: products[i].type,     

                                  ratio: unit.ratio,
                                  unit: unit.unit,
                                  barcode: unit.barcode,       
                                
                                  //id_area:id_area,                                            
                                  sales_btax: 0,
                                  sales_atax: 0,
                                  quantity: 0                        
                                }      
                                if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct; 
                                if(products[i].lots) {
                                  record.lots = cloneDeep(products[i].lots);
                                  for(let m = 0; m<record.lots.length; m++){
                                    record.lots[m].quantity = 0;
                                    record.lots[m].sales_btax = 0;
                                    record.lots[m].sales_atax = 0;
                                  }
                                }                   
                                for(let j=0; j<vhbill_details.length; j++){ 
                                  let is_sub_or_product = false;
                                  if(record.id_subproduct) is_sub_or_product = vhbill_details[j]?.id_subproduct === record.id_subproduct;
                                  else is_sub_or_product = vhbill_details[j].id_product === record.id_product;                                                                             
                                  if(is_sub_or_product){                                          
                                    transaction = true         
                                    if(record.lots){
                                      for(let m=0; m<record.lots.length; m++){
                                        if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                          record.lots[m].quantity =   record.lots[m].quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                          record.lots[m].sales_btax = record.lots[m].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                          record.lots[m].sales_atax = record.lots[m].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                                        }
                                      } 
                                    }                                 
                                    record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                    record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                    record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                       
                                  }                                   
                                }
                                if(transaction){
                                  /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                  record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                  json.quantity = json.quantity + record.quantity;
                                  json.sales_btax = json.sales_btax + record.sales_btax;
                                  json.sales_atax = json.sales_atax + record.sales_atax;
                                  record.index = json.size + 1;
                                  json.docs.push(record);
                                  json.size++;                        
                                  json.empty = false; 
                                }                                               
                            }
                            for(let i=0; i<vouchers.length; i++){   
                              let transaction = false;                         
                              let unit = this.getUnit_byRatio(vouchers[i].units, 1);                             
                              let record:any ={           
                                id_voucher: vouchers[i]._id,                                                  
                                name: vouchers[i].name,
                                img: vouchers[i].img,  
                                vtype: vouchers[i].type, 
  
                                ratio: unit.ratio,
                                unit: unit.unit,
                                barcode: unit.barcode,  
  
                                sales_btax: 0,
                                sales_atax: 0,
                                quantity: 0                        
                              }   
                              for(let j=0; j<vhbill_details.length; j++){      
                                if(record.id_voucher ===vhbill_details[j]?.id_voucher){
                                  transaction = true;    
                                  record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                  record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                                }
                              } 
                              if(transaction){                        
                                /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                json.quantity = json.quantity + record.quantity;
                                json.sales_btax = json.sales_btax + record.sales_btax;
                                json.sales_atax = json.sales_atax + record.sales_atax;
                                record.index = json.size + 1;
                                json.docs.push(record);
                                json.size++;                        
                                json.empty = false; 
                              } 
                            }
                            for(let i=0; i<payment_cards.length; i++){   
                              let transaction = false;                         
                              let unit = this.getUnit_byRatio(payment_cards[i].units, 1);                             
                              let record:any ={           
                                id_payment_card: payment_cards[i]._id,                                                  
                                name: payment_cards[i].name,
                                img: payment_cards[i].img,  
                                pctype: payment_cards[i].type, 
  
                                ratio: unit.ratio,
                                unit: unit.unit,
                                barcode: unit.barcode,  
  
                                sales_btax: 0,
                                sales_atax: 0,
                                quantity: 0                        
                              }    
                              for(let j=0; j<vhbill_details.length; j++){      
                                if(record.id_payment_card ===vhbill_details[j]?.id_payment_card){
                                  transaction = true;    
                                  record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                  record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                                }             
                              }
                              if(transaction){                        
                                /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                json.quantity = json.quantity + record.quantity;
                                json.sales_btax = json.sales_btax + record.sales_btax;
                                json.sales_atax = json.sales_atax + record.sales_atax;
                                record.index = json.size + 1;
                                json.docs.push(record);
                                json.size++;                        
                                json.empty = false; 
                              } 
                            }
                        }                
                        console.log('getReportSales_Areas_byProducts_Vouchers_PaymentCards', json);                         
                        resolve(json);
                      })
              })  
        //}else resolve(json);                  
    })
  }

  
  /**
  * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 3) ->  Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một khách hàng trong list hiện ra -> Chọn một voucher trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Areas_byVoucher(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_area 
  * @param id_voucher:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_voucher, vtype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Areas_byVoucher(starttime:any, endtime:any, id_area:string, id_voucher:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('vouchers', id_voucher)
          .then((voucher:any)=>{
            if(voucher){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(voucher.units, 1);           
                        let record:any ={   
                          id_voucher: voucher._id,    
                          vtype: voucher.type,                    
                          name: voucher.name, 
                          img: voucher.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Areas_byVoucher', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 3) ->  Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một khách hàng trong list hiện ra -> Chọn một payment_card trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Areas_byPaymentCard(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_area 
  * @param id_payment_card:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_payment_card, pctype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Areas_byPaymentCard(starttime:any, endtime:any, id_area:string, id_payment_card:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('payment_cards', id_payment_card)
          .then((payment_card:any)=>{
            if(payment_card){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(payment_card.units, 1);           
                        let record:any ={   
                          id_payment_card: payment_card._id,  
                          pctype: payment_card.type,      

                          name: payment_card.name, 
                          img: payment_card.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Areas_byPaymentCard', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }
  
    /**
    * @Usage Hàm này dùng trong page DOANH SỐ KHU VỰC (layer 3) ->  Chọn TẤT CẢ hoặc MỘT khu vực -> Chọn một khu vực trong list hiện ra -> Chọn một sản phẩm trong list tiếp theo hiện ra
    * @example:
    * let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Areas_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
    * @param starttime 
    * @param endtime 
    * @param id_area 
    * @param id_product
    * @param IDbranch = 'all' or id_branch 
    * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, id_subproduct, salesman}
    */    
    public getReportSales_Areas_byProduct(starttime:any, endtime:any, id_area:any, id_sub_or_product:any, IDbranch?:string){
      return new Promise<any>((resolve, reject) => {     
        let product = this.getlocalDetailProduct(id_sub_or_product);    
        let json:any = {
          docs: new Array(),
          empty: true,
          size:0,
          sales_btax: 0,   
          sales_atax: 0,  
          quantity: 0
        }                       
        let query:any;               
        let bill_types = [1];    
        if((IDbranch==='all')||(IDbranch===undefined)){
          if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in:bill_types}};
          else                      query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, id_product: {$eq:product._id}, bill_type: {$in:bill_types}};
        }else{
          if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};       
          else query = {date: {$gte:starttime, $lte:endtime}, id_area: {$eq:id_area}, id_product: {$eq:product._id}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};        
        }   
        
        this.getBill_details_byFields(query, {},{date:1},0)
            .then((vhbill_details:any)=>{                   
                  if(vhbill_details.length>0){    
                    for(let i=0; i<vhbill_details.length; i++){        
                        let transaction = false;                       
                        let unit = this.getUnit_byRatio(product.units, 1);   
                        let record:any ={   
                          id_product: product._id,                  
                          name: product.name, 
                          img: product.img, 
    
                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                            
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name,    
                          area: this.getlocalArea(vhbill_details[i].id_area).name                                                
                        }  
                        if(vhbill_details[i].id_subproduct) record.id_subproduct = vhbill_details[i].id_subproduct;                      
                        if(vhbill_details[i].id_lotproduct){
                          record.id_lotproduct = vhbill_details[i].id_lotproduct; 
                          record.lots = new Array;
                          for(let m = 0; m<product.lots.length; m++){
                            if(product.lots[m]._id === record.id_lotproduct) {
                              record.lots.push(product.lots[m]);
                              break;
                            }
                          }
                        }        
                      
                        transaction = true;                                                                                                                                    
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                     
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;                         
                        
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                    }                                 
                  }           
                  console.log('getReportSales_Areas_byProduct', json);      
                  resolve(json);         
            })          
      })      
    }

  /**
   * @Usage Hàm này dùng trong page DOANH SỐ MÓN, DỊCH VỤ, NGUYÊN LIỆU, TOPPING, COMBO (layer 1) -> Chọn tất cả hoặc một MÓN, DỊCH VỤ, NGUYÊN LIỆU, TOPPING, COMBO
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Products_byProducts(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDsub_or_product : 'all'/id_subproduct/id_product
   * @param type = 1 là món, = 2 là dịch vụ,  = 3 là nguyên liệu, = 4 là topping, = 5 combo, =1234 món - dịch vụ - nguyên liệu - topping
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, quantity, sales_btax, sales_atax}
   */  
  public getReportSales_Products_byProducts(starttime:any, endtime:any, IDsub_or_product:any, type:number, IDbranch?:string){  
    return new Promise<any>((resolve, reject) => {    
      (async () => {
        try{
          let json: any={
            docs:  new Array(),
            empty: true,
            size: 0, 
            sales_btax: 0,   
            sales_atax: 0,
            quantity: 0
          }            
          let product:any = null;
          if(IDsub_or_product != 'all') product = await this.getlocalDetailProduct_Async(IDsub_or_product);        
          let query:any;     
          let bill_types = [1]; //40,50 voucher, thẻ trả trước ko phải sản phẩm, và có hàm riêng    
          if(IDsub_or_product === 'all') {            
            if((IDbranch==='all')||(IDbranch===undefined)){
              query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}};
            }else{
              query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};           
            }
          }else{              
            if((IDbranch==='all')||(IDbranch===undefined)){        
              if(product.id_subproduct){
                query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:bill_types}};
              }else{
                query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:bill_types}};
              }
            }else{   
              if(product.id_subproduct){      
                query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};
              }else{
                query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};
              }
            }
          }                  
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                     
                if(vhbill_details.length>0){  
                  let products:any = new Array();
                  if(IDsub_or_product === 'all') {
                    products = this.getlocalDetailProducts(type);      
                  }else{
                    products.push(this.getlocalDetailProduct(IDsub_or_product));       
                  }                        
                  for(let i=0; i<products.length; i++){       
                    let transaction = false;                                      
                    let unit = this.getUnit_byRatio(products[i].units, 1);                                  
                    let record:any ={   
                      id_product: products[i]._id,                  
                      name: products[i].name, 
                      img: products[i].img, 
    
                      ratio: unit.ratio,
                      unit: unit.unit,
                      barcode: unit.barcode,
                                                        
                      sales_btax: 0,
                      sales_atax: 0,
                      quantity: 0
                    } 
                    if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;     
                    if(products[i].lots) {
                      record.lots = cloneDeep(products[i].lots);
                      for(let m = 0; m<record.lots.length; m++){
                        record.lots[m].quantity = 0;
                        record.lots[m].sales_btax = 0;
                        record.lots[m].sales_atax = 0;
                      }
                    }                        
                    for(let j=0; j<vhbill_details.length; j++){
                      let is_sub_or_product = false;
                      if(record.id_subproduct) is_sub_or_product = vhbill_details[j].id_subproduct === record.id_subproduct;
                      else is_sub_or_product = vhbill_details[j].id_product === record.id_product;   
    
                      if(is_sub_or_product){                                  
                        transaction = true    
                        if(record.lots){
                          for(let m=0; m<record.lots.length; m++){
                            if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                              record.lots[m].quantity =   record.lots[m].quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                              record.lots[m].sales_btax = record.lots[m].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                              record.lots[m].sales_atax = record.lots[m].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                            }
                          }   
                        }                      
                        record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                        record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                        record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                      
                      }                                
                    }
                    if(transaction){
                      /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                      record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);
                      if(record.subs != undefined)
                      record.subs.forEach((item:any) => {
                          item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                        });
                      if(record.combos != undefined)  
                      record.combos.forEach((item:any) => {
                          item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                        });
                      json.quantity = json.quantity + record.quantity;
                      json.sales_btax = json.sales_btax + record.sales_btax;
                      json.sales_atax = json.sales_atax + record.sales_atax;
                      record.index = json.size + 1;
                      json.docs.push(record);
                      json.size++;                        
                      json.empty = false; 
                    }                                               
                  }
                }    
                console.log('getReportSales_Products_byProducts', json);                     
                resolve(json);
              }) 
        } catch (err) {
          console.error('❌ Lỗi getReportSales_Products_byProduct:', err);
          reject(err);
        }  
      })();         
    })
  }
        
  /**
  * @Usage Hàm này dùng trong page DOANH SỐ MÓN, DỊCH VỤ, NGUYÊN LIỆU, TOPPING, COMBO (layer 2) -> Chọn tất cả hoặc một MÓN, DỊCH VỤ, NGUYÊN LIỆU, TOPPING, COMBO -> Chọn một MÓN, DỊCH VỤ, NGUYÊN LIỆU, TOPPING, COMBO trong list
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Products_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_sub_or_product : id_subproduct or id_product 
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman}
  */  
  public getReportSales_Products_byProduct(starttime:any, endtime:any, id_sub_or_product:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      (async () => {
        try{
          let json:any = {
            docs: new Array(),
            empty: true,
            size:0,
            sales_btax: 0,   
            sales_atax: 0,  
            quantity: 0
          }      
          let product = await this.getlocalDetailProduct_Async(id_sub_or_product);       
          let query:any;                  
          let bill_types = [1];     
          if((IDbranch==='all')||(IDbranch===undefined)){
            if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:bill_types}};
            else                      query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:bill_types}};
          }else{
            if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}}; 
            else                      query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};        
          }        
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){      
                      for(let i=0; i<vhbill_details.length; i++){                        
                        let transaction = false;                       
                        let unit = this.getUnit_byRatio(product.units, 1);   
                        let record:any ={   
                          id_product: product._id,                  
                          name: product.name, 
                          img: product.img,  
    
                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                            
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        } 
                        if(vhbill_details[i].id_subproduct) record.id_subproduct = vhbill_details[i].id_subproduct;                      
                        if(vhbill_details[i].id_lotproduct){
                          record.id_lotproduct = vhbill_details[i].id_lotproduct; 
                          record.lots = new Array;
                          for(let m = 0; m<product.lots.length; m++){
                            if(product.lots[m]._id === record.id_lotproduct) {
                              record.lots.push(product.lots[m]);
                              break;
                            }
                          }
                        }                       
                       
                        transaction = true;
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                     
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;   
                                   
                        if(transaction){
                          record.sales_btax = record.price * record.quantity; 
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity; 
                          json.sales_btax = json.sales_btax + record.price * record.quantity; 
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    } 
                    console.log('getReportSales_Products_byProduct', json)
                    resolve(json);
                  })   
		    } catch (err) {
          console.error('❌ Lỗi getReportSales_Employees_byProduct:', err);
          reject(err);
        }  
      })(); 
         
    })      
  }

   /**
   * @Usage Hàm này dùng trong page DOANH SỐ COMBO (layer 1) -> Chọn TẤT CẢ hoặc MỘT combo
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Combos_byProducts(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDproduct : 'all'/id_product (của combo)
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, quantity, sales_btax, sales_atax}
   */    
  public getReportSales_Combos_byProducts(starttime:any, endtime:any, IDproduct:any, IDbranch?:string){
    //Doanh số COMBO sẽ có hàm khác
    return new Promise<any>((resolve, reject) => {    
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0
      }            
        
      let query:any; 
      let bill_types = [1,41,51];    
      if(IDproduct === 'all') {            
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, cbtype: {$eq:5}, bill_type: {$in:bill_types}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, cbtype: {$eq:5}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};           
        }
      }else{              
        if((IDbranch==='all')||(IDbranch===undefined)){        
            query = {date: {$gte:starttime, $lte:endtime}, id_combos_group: {$eq:IDproduct}, bill_type: {$in:bill_types}};         
        }else{  
            query = {date: {$gte:starttime, $lte:endtime}, id_combos_group: {$eq:IDproduct}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};
        }
      }                 
      this.getBill_details_byFields(query, {},{date:1},0)
          .then((vhbill_details:any)=>{    
            let products:any = new Array(); 
            if(IDproduct === 'all') {
              products = this.getlocalDetailProducts(5);      
            }else{
              products.push(this.getlocalDetailProduct(IDproduct));       
            }
            //console.log('bill_details', vhbill_details);      
            //Đổi nhiều bill_detail là thành phần của 1 combos nào đó gom thành 1 bill_detail mà có 1 combos
            let bill_details_combo = new Array();
            for(let i=0; i<vhbill_details.length; i++){
              if((vhbill_details[i].id_combos_group)&&(!vhbill_details[i].chose)){
                //Tạo bill_detail mà chưa có combos
                let bill_detail = {...vhbill_details[i]};
                delete bill_detail.id_product;
                delete bill_detail.price;
                delete bill_detail.ptype;
                delete bill_detail.quantity;
                delete bill_detail.ratio;
                delete bill_detail.unit;
                bill_detail = {...bill_detail, ...vhbill_details[i].combos_group};
                delete bill_detail.combos_group;      
                bill_detail.id_product = bill_detail.id_combos_group;        
                delete bill_detail.id_combos_group;
                let combos = new Array();
                for(let j=0; j<vhbill_details.length; j++){
                  let bill_detail_J = {...vhbill_details[j]};                               
                    if(vhbill_details[i].bill_detail_ID === bill_detail_J.bill_detail_ID){
                      vhbill_details[j].chose  = true;                    
                    let combo:any = {
                      id_product: bill_detail_J.id_product,
                      price: bill_detail_J.price,
                      ptype: bill_detail_J.ptype,
                      quantity: bill_detail_J.quantity/(bill_detail_J.combos_group.quantity * bill_detail_J.combos_group.ratio),//kiểm tra chỗ này có nhân với ratio ko
                      ratio: bill_detail_J.ratio,                      
                    }
                    if(bill_detail_J.id_subproduct){
                      combo.id_subproduct = bill_detail_J.id_subproduct;                                  
                    }
                    if(bill_detail_J.id_lotproduct){
                      combo.id_lotproduct = bill_detail_J.id_lotproduct;                        
                    }
                    combos.push(combo);
                  }
                }
                bill_detail.combos = [...combos];//map combos vào bill_detail
                delete bill_detail.id_subproduct;
                delete bill_detail.id_lotproduct;
                bill_details_combo.push(bill_detail);//trong 1 hóa đơn sẽ có nhiều bill_detail (có combo)
              }
            }
            vhbill_details = vhbill_details.filter((e:any)=>!e.chose);
            for(let i=0; i<bill_details_combo.length; i++){
              vhbill_details.push(bill_details_combo[i]);
            }
            //let vhbill_details = this.changeBillDetails_withRaw_toPromotions(bill_details);     
                
            if(vhbill_details.length>0){                        
                      for(let i=0; i<products.length; i++){       
                            let transaction = false;                                      
                            let unit = this.getUnit_byRatio(products[i].units, 1);                                  
                            let record:any ={   
                              id_product: products[i]._id,                  
                              name: products[i].name, 
                              img: products[i].img, 
                              type: products[i].type, 

                              ratio: unit.ratio,
                              unit: unit.unit,
                              barcode: unit.barcode,
                                                                
                              sales_btax: 0,
                              sales_atax: 0,
                              quantity: 0
                            }                                          
                            for(let j=0; j<vhbill_details.length; j++){                                
                              if(record.id_product === vhbill_details[j].id_product){                                  
                                transaction = true                                                   
                                record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                              
                              }                                
                            }
                            if(transaction){
                              /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                              record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);
                              if(record.subs != undefined)
                              record.subs.forEach((item:any) => {
                                  item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                });
                              if(record.combos != undefined)  
                              record.combos.forEach((item:any) => {
                                  item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                });
                              json.quantity = json.quantity + record.quantity;
                              json.sales_btax = json.sales_btax + record.sales_btax;
                              json.sales_atax = json.sales_atax + record.sales_atax;
                              record.index = json.size + 1;
                              json.docs.push(record);
                              json.size++;                        
                              json.empty = false; 
                            }                                               
                    }
            }    
            console.log('getReportSales_Combos_byProducts', json);                     
            resolve(json);
          })     
    })
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ COMBO (layer 2) -> Chọn TẤT CẢ hoặc MỘT combo -> Chọn MỘT combo trong list
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Combos_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_product
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman}
  */  
  public getReportSales_Combos_byProduct(starttime:any, endtime:any, id_product:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      (async () => {
        try{
          let json:any = {
            docs: new Array(),
            empty: true,
            size:0,
            sales_btax: 0,   
            sales_atax: 0,  
            quantity: 0
          }      
          let product = await this.getlocalDetailProduct_Async(id_product);            
          let query:any;            
          let promise = new Array();
          let bill_types = [1,41,51]     
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, id_combos_group: {$eq:id_product}, bill_type: {$in:bill_types}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, id_combos_group: {$eq:id_product}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};        
          }    
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{   
                let bill_details_combo = new Array();
                  for(let i=0; i<vhbill_details.length; i++){
                    if((vhbill_details[i].id_combos_group)&&(!vhbill_details[i].chose)){
                      //Tạo bill_detail mà chưa có combos
                      let bill_detail = {...vhbill_details[i]};
                      delete bill_detail.id_product;
                      delete bill_detail.price;
                      delete bill_detail.ptype;
                      delete bill_detail.quantity;
                      delete bill_detail.ratio;
                      delete bill_detail.unit;
                      bill_detail = {...bill_detail, ...vhbill_details[i].combos_group};
                      delete bill_detail.combos_group;      
                      bill_detail.id_product = bill_detail.id_combos_group;        
                      delete bill_detail.id_combos_group;
                      let combos = new Array();
                      for(let j=0; j<vhbill_details.length; j++){
                        let bill_detail_J = {...vhbill_details[j]};                               
                          if(vhbill_details[i].bill_detail_ID === bill_detail_J.bill_detail_ID){
                            vhbill_details[j].chose  = true;                    
                          let combo:any = {
                            id_product: bill_detail_J.id_product,
                            price: bill_detail_J.price,
                            ptype: bill_detail_J.ptype,
                            quantity: bill_detail_J.quantity/(bill_detail_J.combos_group.quantity * bill_detail_J.combos_group.ratio),//kiểm tra chỗ này có nhân với ratio ko
                            ratio: bill_detail_J.ratio,                      
                          }
                          if(bill_detail_J.id_subproduct){
                            combo.id_subproduct = bill_detail_J.id_subproduct;                                  
                          }
                          if(bill_detail_J.id_lotproduct){
                            combo.id_lotproduct = bill_detail_J.id_lotproduct;                        
                          }
                          combos.push(combo);
                        }
                      }
                      bill_detail.combos = [...combos];//map combos vào bill_detail
                      delete bill_detail.id_subproduct;
                      delete bill_detail.id_lotproduct;
                      bill_details_combo.push(bill_detail);//trong 1 hóa đơn sẽ có nhiều bill_detail (có combo)
                    }
                  }
                  vhbill_details = vhbill_details.filter((e:any)=>!e.chose);
                  for(let i=0; i<bill_details_combo.length; i++){
                    vhbill_details.push(bill_details_combo[i]);
                  }             
                  if(vhbill_details.length>0){      
                    for(let i=0; i<vhbill_details.length; i++){                        
                      let transaction = false;                       
                      let unit = this.getUnit_byRatio(product.units, 1);   
                      let record:any ={   
                        id_product: product._id,                  
                        name: product.name, 
                        img: product.img,  
  
                        ratio: unit.ratio,
                        unit: unit.unit,
                        barcode: unit.barcode,                            
                        
                        bill_code: vhbill_details[i].bill_code,
                        bill_type:  vhbill_details[i].bill_type,
                        id_bill: vhbill_details[i].id_bill,
                        date: vhbill_details[i].date,
                        tax: vhbill_details[i].tax,
                        salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                        customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                      }                
                    
                      transaction = true;
                      record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                      
                      record.price = vhbill_details[i].price/vhbill_details[i].ratio;   
                                
                      if(transaction){
                        record.sales_btax = record.price * record.quantity;
                        record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                        record.index = json.size + 1;                   
                        json.docs.push(record);
                        json.size++;
                        json.empty = false;
                        json.quantity = json.quantity + record.quantity;
                        json.sales_btax = json.sales_btax + record.price * record.quantity;
                        json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                      }                                                                                
                    }                                 
                  } 
                  console.log('getReportSales_Combos_byProduct', json)
                  resolve(json);
                }) 
		    } catch (err) {
          console.error('❌ Lỗi getReportSales_Employees_byProduct:', err);
          reject(err);
        }  
      })();
           
    })      
  }
    /**
    * @Usage Hàm này dùng trong page DOANH SỐ VOUCHER (layer 1) -> Chọn TẤT CẢ hoặc MỘT voucher
    * @example
    *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Vouchers_byVouchers(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
    * @param starttime 
    * @param endtime 
    * @param IDvoucher : 'all'/id_voucher
    * @param vtype = 1 là voucher
    * @param IDbranch : 'all' or id_branch
    * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, quantity, sales_btax, sales_atax}
    */
  public getReportSales_Vouchers_byVouchers(starttime:any, endtime:any, IDvoucher:any, vtype:number, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {    
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0
      }            

      let vouchers:any = new Array();          
      let query:any; 
      let promise = new Array();    
      
      if(IDvoucher === 'all') {        
        promise[promise.length] = new Promise(resolve=>{
          this.vhMGDB_database.getDocs('vouchers')
                .then((_vouchers:any)=>{    
                  if(_vouchers.length) vouchers = [..._vouchers];                            
                  resolve(null);              
                })  
          })    
      }else{
        promise[promise.length] = new Promise(resolve=>{ 
          this.vhMGDB_database.getDoc('vouchers', IDvoucher)
                .then((voucher)=>{
                  if(voucher) vouchers.push(voucher);                    
                  resolve(null);                  
                }) 
          }) 
      }
  
      if(IDvoucher === 'all') {            
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$eq:40}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$eq:40}, id_branch: {$eq:IDbranch}};           
        }
      }else{              
        if((IDbranch==='all')||(IDbranch===undefined)){        
          query = {date: {$gte:starttime, $lte:endtime}, id_voucher: {$eq:IDvoucher}, bill_type: {$eq:40}};
        }else{   
          query = {date: {$gte:starttime, $lte:endtime}, id_voucher: {$eq:IDvoucher}, bill_type: {$eq:40}, id_branch: {$eq:IDbranch}};
        }
      }           
      Promise.all(promise)
            .then(()=>{
              if(vouchers.length>0){       
                //console.log('---------vouchers', vouchers);   
                this.getBill_details_byFields(query, {},{date:1},0)
                    .then((vhbill_details:any)=>{           
                      //console.log('---------vhbill_details', vhbill_details);            
                      if(vhbill_details.length>0){                        
                                for(let i=0; i<vouchers.length; i++){       
                                      let transaction = false;                                      
                                      let unit = this.getUnit_byRatio(vouchers[i].units, 1);                                  
                                      let record:any ={   
                                        id_voucher: vouchers[i]._id,    
                                        vtype:vouchers[i].type,
                                        
                                        name: vouchers[i].name, 
                                        img: vouchers[i].img, 

                                        ratio: unit.ratio,
                                        unit: unit.unit,
                                        barcode: unit.barcode,
                                                                          
                                        sales_btax: 0,
                                        sales_atax: 0,
                                        quantity: 0
                                      } 
                                                        
                                      for(let j=0; j<vhbill_details.length; j++){                               
                                        if(vhbill_details[j].bill_type == 40){                            
                                          if(vhbill_details[j].id_voucher === vouchers[i]._id){                                    
                                            transaction = true                                               
                                            record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                            record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                            record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                        
                                          }                                      
                                        }
                                      }
                                      if(transaction){
                                        /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                        record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);
                                        if(record.subs != undefined)
                                        record.subs.forEach((item:any) => {
                                            item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                          });
                                        if(record.combos != undefined)  
                                        record.combos.forEach((item:any) => {
                                            item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                          });
                                        json.quantity = json.quantity + record.quantity;
                                        json.sales_btax = json.sales_btax + record.sales_btax;
                                        json.sales_atax = json.sales_atax + record.sales_atax;
                                        record.index = json.size + 1;
                                        json.docs.push(record);
                                        json.size++;                        
                                        json.empty = false; 
                                      }                                               
                              }
                      }    
                      console.log('getReportSales_Vouchers_byVouchers', json);                     
                      resolve(json);
                    })
              }else resolve(json);   
      })   
    })
  }

  
    /**
    * @Usage Hàm này dùng trong page DOANH SỐ PAYMENT_CARD (layer 1) -> Chọn TẤT CẢ hoặc MỘT payment_card
    * @example
    *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_PaymentCards_byPaymentCards(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
    * @param starttime 
    * @param endtime 
    * @param IDpayment_card : 'all'/id_payment_card
    * @param pctype = 1 là payment_card
    * @param IDbranch : 'all' or id_branch
    * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, quantity, sales_btax, sales_atax}
    */
  public getReportSales_PaymentCards_byPaymentCards(starttime:any, endtime:any, IDpayment_card:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {    
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0
      }            

      let payment_cards:any = new Array();          
      let query:any; 
      let promise = new Array();    
      
      if(IDpayment_card === 'all') {        
        promise[promise.length] = new Promise(resolve=>{
          this.vhMGDB_database.getDocs('payment_cards')
                .then((_payment_cards:any)=>{    
                  if(_payment_cards.length) payment_cards = [..._payment_cards];                            
                  resolve(null);              
                })  
          })    
      }else{
        promise[promise.length] = new Promise(resolve=>{ 
          this.vhMGDB_database.getDoc('payment_cards', IDpayment_card)
                .then((_payment_card)=>{
                  if(_payment_card) payment_cards.push(_payment_card);                    
                  resolve(null);                  
                }) 
          }) 
      }
  
      if(IDpayment_card === 'all') {            
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$eq:50}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$eq:50}, id_branch: {$eq:IDbranch}};           
        }
      }else{              
        if((IDbranch==='all')||(IDbranch===undefined)){        
          query = {date: {$gte:starttime, $lte:endtime}, id_payment_card: {$eq:IDpayment_card}, bill_type: {$eq:50}};
        }else{   
          query = {date: {$gte:starttime, $lte:endtime}, id_payment_card: {$eq:IDpayment_card}, bill_type: {$eq:50}, id_branch: {$eq:IDbranch}};
        }
      }           
      Promise.all(promise)
            .then(()=>{
              if(payment_cards.length>0){       
                //console.log('---------payment_cards', payment_cards);   
                this.getBill_details_byFields(query, {},{date:1},0)
                    .then((vhbill_details:any)=>{                     
                      if(vhbill_details.length>0){                        
                                for(let i=0; i<payment_cards.length; i++){       
                                      let transaction = false;                                      
                                      let unit = this.getUnit_byRatio(payment_cards[i].units, 1);                                  
                                      let record:any ={   
                                        id_payment_card: payment_cards[i]._id,    
                                        pctype: payment_cards[i].type,

                                        name: payment_cards[i].name, 
                                        img: payment_cards[i].img,                                         

                                        ratio: unit.ratio,
                                        unit: unit.unit,
                                        barcode: unit.barcode,
                                                                          
                                        sales_btax: 0,
                                        sales_atax: 0,
                                        quantity: 0
                                      } 
                                                        
                                      for(let j=0; j<vhbill_details.length; j++){                               
                                        if(vhbill_details[j].bill_type == 50){                            
                                          if(vhbill_details[j].id_payment_card === payment_cards[i]._id){                                    
                                            transaction = true                                               
                                            record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                            record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                            record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                        
                                          }                                      
                                        }
                                      }
                                      if(transaction){
                                        /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                        record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);
                                        if(record.subs != undefined)
                                        record.subs.forEach((item:any) => {
                                            item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                          });
                                        if(record.combos != undefined)  
                                        record.combos.forEach((item:any) => {
                                            item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                          });
                                        json.quantity = json.quantity + record.quantity;
                                        json.sales_btax = json.sales_btax + record.sales_btax;
                                        json.sales_atax = json.sales_atax + record.sales_atax;
                                        record.index = json.size + 1;
                                        json.docs.push(record);
                                        json.size++;                        
                                        json.empty = false; 
                                      }                                               
                              }
                      }    
                      console.log('getReportSales_PaymentCards_byPaymentCards', json);                     
                      resolve(json);
                    })
              }else resolve(json);   
      })   
    })
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ VOUCHER (layer 2) -> Chọn TẤT CẢ hoặc MỘT voucher -> Chọn MỘT sản phẩm trong list
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Vouchers_byVoucher(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_voucher
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman}
  */ 
  public getReportSales_Vouchers_byVoucher(starttime:any, endtime:any, id_voucher:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }      
      //let voucher = this.getlocalDetailProduct(id_voucher);  
        this.vhMGDB_database.getDoc('vouchers', id_voucher)
              .then((voucher:any)=>{
                if(voucher){
                  let query:any;  
                  if((IDbranch==='all')||(IDbranch===undefined)){
                    query = {date: {$gte:starttime, $lte:endtime}, id_voucher: {$eq:id_voucher}, bill_type: {$eq:40}};
                  }else{
                    query = {date: {$gte:starttime, $lte:endtime}, id_voucher: {$eq:id_voucher}, bill_type:  {$eq:40}, id_branch: {$eq:IDbranch}};        
                  }     
                  this.getBill_details_byFields(query, {},{date:1},0)
                      .then((vhbill_details:any)=>{                
                            if(vhbill_details.length>0){      
                              for(let i=0; i<vhbill_details.length; i++){                        
                                let transaction = false;                       
                                let unit = this.getUnit_byRatio(voucher.units, 1);   
                                let record:any ={   
                                  id_voucher: voucher._id,   
                                  vtype: voucher.type,

                                  name: voucher.name, 
                                  img: voucher.img,  
            
                                  ratio: unit.ratio,
                                  unit: unit.unit,
                                  barcode: unit.barcode,                            
                                  
                                  bill_code: vhbill_details[i].bill_code,
                                  bill_type:  vhbill_details[i].bill_type,
                                  id_bill: vhbill_details[i].id_bill,
                                  date: vhbill_details[i].date,
                                  tax: vhbill_details[i].tax,
                                  salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                                  customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                                } 
                                
                                if(vhbill_details[i].bill_type == 40){  
                                  transaction = true;
                                  record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                      
                                  record.price = vhbill_details[i].price/vhbill_details[i].ratio;   
                                }             
                                if(transaction){
                                  record.sales_btax = record.price * record.quantity; 
                                  record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                                  record.index = json.size + 1;                   
                                  json.docs.push(record);
                                  json.size++;
                                  json.empty = false;
                                  json.quantity = json.quantity + record.quantity; 
                                  json.sales_btax = json.sales_btax + record.price * record.quantity; 
                                  json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                                }                                                                                
                              }                                 
                            } 
                            console.log('getReportSales_Vouchers_byVoucher', json)
                            resolve(json);
                          })      
                }                          
              }) 
          
      
    })      
  }
/**
  * @Usage Hàm này dùng trong page DOANH SỐ PAYMENT_CARD (layer 2) -> Chọn TẤT CẢ hoặc MỘT payment_card -> Chọn MỘT payment_card trong list
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_PaymentCards_byPaymentCard(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_payment_card
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman}
  */ 
  public getReportSales_PaymentCards_byPaymentCard(starttime:any, endtime:any, id_payment_card:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }      
      //let voucher = this.getlocalDetailProduct(id_payment_card);  
        this.vhMGDB_database.getDoc('payment_cards', id_payment_card)
              .then((payment_card:any)=>{
                if(payment_card){
                  let query:any;  
                  if((IDbranch==='all')||(IDbranch===undefined)){
                    query = {date: {$gte:starttime, $lte:endtime}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq:50}};
                  }else{
                    query = {date: {$gte:starttime, $lte:endtime}, id_payment_card: {$eq:id_payment_card}, bill_type:  {$eq:50}, id_branch: {$eq:IDbranch}};        
                  }     
                  this.getBill_details_byFields(query, {},{date:1},0)
                      .then((vhbill_details:any)=>{                
                            if(vhbill_details.length>0){      
                              for(let i=0; i<vhbill_details.length; i++){                        
                                let transaction = false;                       
                                let unit = this.getUnit_byRatio(payment_card.units, 1);   
                                let record:any ={   
                                  id_payment_card: payment_card._id, 
                                  pctype: payment_card.type,

                                  name: payment_card.name, 
                                  img: payment_card.img,  
            
                                  ratio: unit.ratio,
                                  unit: unit.unit,
                                  barcode: unit.barcode,                            
                                  
                                  bill_code: vhbill_details[i].bill_code,
                                  bill_type:  vhbill_details[i].bill_type,
                                  id_bill: vhbill_details[i].id_bill,
                                  date: vhbill_details[i].date,
                                  tax: vhbill_details[i].tax,
                                  salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                                  customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                                } 
                                
                                if(vhbill_details[i].bill_type == 50){  
                                  transaction = true;
                                  record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                      
                                  record.price = vhbill_details[i].price;   
                                }             
                                if(transaction){
                                  record.sales_btax = record.price * record.quantity; 
                                  record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                                  record.index = json.size + 1;                   
                                  json.docs.push(record);
                                  json.size++;
                                  json.empty = false;
                                  json.quantity = json.quantity + record.quantity; 
                                  json.sales_btax = json.sales_btax + record.price * record.quantity; 
                                  json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                                }                                                                                
                              }                                 
                            } 
                            console.log('getReportSales_PaymentCards_byPaymentCard', json)
                            resolve(json);
                          })      
                }                          
              }) 
          
      
    })      
  }
        

  
  /**
   * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 1) -> Chọn TẤT CẢ hoặc MỘT khách hàng
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Customers_byCustomers(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDcustomer : 'all' or id_customer
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, img, id_customer, quantity, sales_btax, sales_atax}
   */
    public getReportSales_Customers_byCustomers(starttime:any, endtime:any, IDcustomer:any, IDbranch?:string){   
      return new Promise<any>((resolve, reject) => {             
          let json: any={
            docs:  new Array(),
            empty: true,
            size: 0, 
            sales_btax: 0,   
            sales_atax: 0,
            quantity: 0 
          }                                            
          let query:any;
          let bill_types = [1,40,50]
          if(IDcustomer === 'all'){        
            if((IDbranch==='all')||(IDbranch===undefined)){
              query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}};
            }else{
              query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};          
            }
          }else{
            if((IDbranch==='all')||(IDbranch===undefined)){
              query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:bill_types}};
            }else{
              query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};            
            }
            
          }        
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                     
                if(vhbill_details.length>0){   
                  let customers:any = new Array();   
                  if(IDcustomer === 'all') customers = this.getlocalCustomers()   
                  else {
                    let customer = this.getlocalCustomer(IDcustomer);          
                    customers.push(customer);      
                  }                                               
                  for(let i=0; i<customers.length; i++){   
                    let transaction = false;                                                                 
                    let data:any ={   
                      id_customer: customers[i]._id,                  
                      name: customers[i].name,                          
                      img: customers[i]?.img,                                   
                      sales_btax: 0,
                      sales_atax: 0,
                      quantity: 0
                    }                                                                       
                    for(let j=0; j<vhbill_details.length; j++){                           
                      if(customers[i]._id ===vhbill_details[j].id_customer){  
                        transaction = true;                               
                        if((vhbill_details[j].ptype ===1)||(vhbill_details[j].ptype ===2)||(vhbill_details[j].ptype ===3)||(vhbill_details[j].ptype ===4)||(vhbill_details[j].vtype ===1)||(vhbill_details[j].pctype ===1)){
                          data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                          data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                          data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                        }                                            
                      }
                    }
                    if(transaction){
                      json.quantity = json.quantity + data.quantity;
                      json.sales_btax = json.sales_btax + data.sales_btax;
                      json.sales_atax = json.sales_atax + data.sales_atax;
                      data.index = json.size + 1;
                      json.docs.push(data);
                      json.size++;                        
                      json.empty = false; 
                    }                          
                  }                      
                }          
                console.log('getReportSales_Customers_byCustomers');             
                resolve(json);
              }) 
      })
    }
      
  /**
   * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 2) -> Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một khách hàng trong list hiện ra
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Customers_byProducts(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
    * @param starttime 
    * @param endtime 
    * @param id_customer
    * @param IDbranch : 'all' or id_branch
    * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, id_customer, name, barcode, unit, img, quantity, sales_btax, sales_atax}
    */
  
  private getReportSales_Customers_byProducts(starttime:any, endtime:any, id_customer:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                                            
      let query:any;
      if((IDbranch==='all')||(IDbranch===undefined)){
        query = query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, bill_type: {$in:[1]}};
      }else{
        query = query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};          
      }   
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0 
      }                    
      this.getBill_details_byFields(query, {},{date:1},0)
          .then((vhbill_details:any)=>{                         
            if(vhbill_details.length>0){    
                let products:any = this.getlocalProducts(1234);             
                for(let i=0; i<products.length; i++){       
                    let transaction = false;           
                    let product =  {...products[i]};                                   
                    let data:any ={   
                      id_product: product._id,                  
                      name: product.name, 
                      unit: product.unit,
                      barcode: product.barcode,
                      img: product.img,                                   
                      sales_btax: 0,
                      sales_atax: 0,
                      quantity: 0
                      //subs: new Array()//
                    }  
                    if(product.subs != undefined){
                      data.subs = new Array();
                      for(let k=0; k<product.subs.length; k++){
                        let sub:any ={
                          id_subproduct: product.subs[k]._id,                    
                          name: product.subs[k]?.name,
                          sales_btax: 0,
                          sales_atax: 0,
                          quantity: 0                          
                        }
                        data.subs.push(sub);
                      }
                    }                        
                    
                    for(let j=0; j<vhbill_details.length; j++){                                                            
                            if(vhbill_details[j].ptype === 1){                                                            
                              if(products[i].type === 1){
                                if(products[i]._id ===vhbill_details[j].id_product){
                                  transaction = true                         
                                  data.quantity = data.quantity + vhbill_details[j].quantity;
                                  data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                  if(data.subs != undefined)
                                    for(let k=0; k<data.subs.length; k++){
                                      if(products[i].subs[k]._id === vhbill_details[j].id_subproduct){
                                        data.subs[k].quantity = data.subs[k].quantity + vhbill_details[j].quantity;
                                        data.subs[k].sales_btax = data.subs[k].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                        data.subs[k].sales_atax = data.subs[k].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                        break;
                                      }
                                    }  
                                }
                              }
                              
                              if(products[i].type === 4){                                                             
                                if(vhbill_details[j].toppings != undefined){                                                                                                             
                                  for(let m=0; m<vhbill_details[j].toppings.length; m++){                                                                 
                                    if(products[i]._id ===vhbill_details[j].toppings[m].id_product){
                                      transaction = true                         
                                      data.quantity = data.quantity + vhbill_details[j].toppings[m].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity * (1 + vhbill_details[j].tax / 100);                                                                                   
                                    }
                                  }
                                }
                              }
                                                                                
                            }else if(vhbill_details[j].ptype === 2){
                                if(products[i]._id ===vhbill_details[j].id_product){
                                  transaction = true                         
                                  data.quantity = data.quantity + vhbill_details[j].quantity;
                                  data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                 
                                }
                                  
                            }else if(vhbill_details[j].ptype === 3){
                                if(products[i]._id ===vhbill_details[j].id_product){
                                  transaction = true                         
                                  data.quantity = data.quantity + vhbill_details[j].quantity;
                                  data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                               
                                }  
                            }else if(vhbill_details[j].ptype === 4){
                                if(products[i]._id ===vhbill_details[j].id_product){
                                  transaction = true                         
                                  data.quantity = data.quantity + vhbill_details[j].quantity;
                                  data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                  
                                }                                 
                            }else if(vhbill_details[j].ptype === 5){  
                              for(let m=0; m<vhbill_details[j].combos.length; m++){
                                  if(products[i]._id ===vhbill_details[j].combos[m].id_product){
                                    transaction = true                         
                                    data.quantity = data.quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                    data.sales_btax = data.sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                    data.sales_atax = data.sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                    if(data.subs != undefined)
                                      for(let k=0; k<data.subs.length; k++){                                    
                                        if(products[i].subs[k]._id === vhbill_details[j].combos[m].id_subproduct){
                                          data.subs[k].quantity = data.subs[k].quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                          data.subs[k].sales_btax = data.subs[k].sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                          data.subs[k].sales_atax = data.subs[k].sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                          break;
                                        }
                                      }                                                     
                                  }
                              }                                                          
                            }
                    }
                    if(transaction){
                      /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                      data.sales_atax = this.vhAlgorithm.roundTo3Decimals(data.sales_atax);
                      if(data.subs != undefined)
                        data.subs.forEach((item:any) => {
                          item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                        });                                    
                      json.quantity = json.quantity + data.quantity;
                      json.sales_btax = json.sales_btax + data.sales_btax;
                      json.sales_atax = json.sales_atax + data.sales_atax;
                      data.index = json.size + 1;
                      json.docs.push(data);
                      json.size++;                        
                      json.empty = false; 
                    }                                               
                }
            }                
            console.log('getReportSales_Customers_byProducts');                         
            resolve(json);
          })
    })
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 3) ->  Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một khách hàng trong list hiện ra -> Chọn một sản phẩm trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Customers_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_customer 
  * @param id_sub_or_product 
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman, customer}
  */
 public getReportSales_Customers_byProduct(starttime:any, endtime:any, id_customer:any, id_sub_or_product:any, IDbranch?:string){
  return new Promise<any>((resolve, reject) => {   
    (async () => {
      try{    
        let product = await this.getlocalDetailProduct_Async(id_sub_or_product);  
        let json:any = {
          docs: new Array(),
          empty: true,
          size:0,
          sales_btax: 0,   
          sales_atax: 0,  
          quantity: 0
        }                       
        let query:any;               
        let bill_types = [1];
    
        if((IDbranch==='all')||(IDbranch===undefined)){
          if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in:bill_types}};
          else                      query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_product: {$eq:product._id}, bill_type: {$in:bill_types}};
        }else{
          if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};       
          else query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_product: {$eq:product._id}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};        
        }   
       
        this.getBill_details_byFields(query, {},{date:1},0)
            .then((vhbill_details:any)=>{                   
                if(vhbill_details.length>0){    
                  for(let i=0; i<vhbill_details.length; i++){        
                      let transaction = false;                       
                      let unit = this.getUnit_byRatio(product.units, 1);   
                      let record:any ={   
                        id_product: product._id,                  
                        name: product.name, 
                        img: product.img, 
  
                        ratio: unit.ratio,
                        unit: unit.unit,
                        barcode: unit.barcode,                            
                        
                        bill_code: vhbill_details[i].bill_code,
                        bill_type:  vhbill_details[i].bill_type,
                        id_bill: vhbill_details[i].id_bill,
                        date: vhbill_details[i].date,
                        tax: vhbill_details[i].tax,
                        salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                        customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                      }  
                      if(vhbill_details[i].id_subproduct) record.id_subproduct = vhbill_details[i].id_subproduct;                      
                      if(vhbill_details[i].id_lotproduct){
                        record.id_lotproduct = vhbill_details[i].id_lotproduct; 
                        record.lots = new Array;
                        for(let m = 0; m<product.lots.length; m++){
                          if(product.lots[m]._id === record.id_lotproduct) {
                            record.lots.push(product.lots[m]);
                            break;
                          }
                        }
                      }    
                    
                      transaction = true;                                                                                                                                    
                      record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                     
                      record.price = vhbill_details[i].price/vhbill_details[i].ratio;                     
                      
                      if(transaction){
                        record.sales_btax = record.price * record.quantity;
                        record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                        record.index = json.size + 1;                   
                        json.docs.push(record);
                        json.size++;
                        json.empty = false;
                        json.quantity = json.quantity + record.quantity;
                        json.sales_btax = json.sales_btax + record.price * record.quantity;
                        json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                      }                                                                                
                  }                                 
                }           
                console.log('getReportSales_Customers_byProduct', json);      
                resolve(json);         
            }) 
      } catch (err) {
        console.error('❌ Lỗi getReportSales_Employees_byProduct:', err);
        reject(err);
      }  
    })();               
  })      
}
    
  /**
   * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 2) -> Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một khách hàng trong list hiện ra
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00'); 
      this.vhQueryCafe.getReportSales_Customers_byProducts_Vouchers_PaymentCards(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param id_customer
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_product, ptype, hoặc id_voucher, vtype, hoặc id_payment_card, pctype, index, name, barcode, unit, img, id_customer, quantity, sales_btax, sales_atax}
   */
  public getReportSales_Customers_byProducts_Vouchers_PaymentCards(starttime:any, endtime:any, id_customer:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                               
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, bill_type: {$in:[1,40,50]}};
        }else{
          query = query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, bill_type: {$in:[1,40,50]}, id_branch: {$eq:IDbranch}};          
        }   
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0 
        }                    
        //if(products.length>0){ 
          let vouchers = new Array();
          let payment_cards = new Array();     
          let promise = new Array();
          promise[0] = this.vhMGDB_database.getDocs('vouchers');
          promise[1] = this.vhMGDB_database.getDocs('payment_cards');
          Promise.all(promise)
                .then((array:any)=>{              
                  vouchers = [...array[0]];
                  payment_cards = [...array[1]];     
                  this.getBill_details_byFields(query, {},{date:1},0)
                      .then((vhbill_details:any)=>{                                 
                        if(vhbill_details.length>0){    
                          let products:any = this.getlocalDetailProducts(1234);                  
                            for(let i=0; i<products.length; i++){       
                                let transaction = false;                                        
                                let unit = this.getUnit_byRatio(products[i].units, 1);                             
                                let record:any ={   
                                  id_product: products[i]._id,              
                                  name: products[i].name,
                                  img: products[i].img,
                                  ptype: products[i].type,     

                                  ratio: unit.ratio,
                                  unit: unit.unit,
                                  barcode: unit.barcode,       
                                
                                  id_customer:id_customer,                                            
                                  sales_btax: 0,
                                  sales_atax: 0,
                                  quantity: 0                        
                                }      
                                if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct; 
                                if(products[i].lots) {
                                  record.lots = cloneDeep(products[i].lots);
                                  for(let m = 0; m<record.lots.length; m++){
                                    record.lots[m].quantity = 0;
                                    record.lots[m].sales_btax = 0;
                                    record.lots[m].sales_atax = 0;
                                  }
                                }                   
                                for(let j=0; j<vhbill_details.length; j++){ 
                                  let is_sub_or_product = false;
                                  if(record.id_subproduct) is_sub_or_product = vhbill_details[j]?.id_subproduct === record.id_subproduct;
                                  else is_sub_or_product = vhbill_details[j].id_product === record.id_product;                                                                             
                                  if(is_sub_or_product){                                          
                                    transaction = true         
                                    if(record.lots){
                                      for(let m=0; m<record.lots.length; m++){
                                        if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                          record.lots[m].quantity =   record.lots[m].quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                          record.lots[m].sales_btax = record.lots[m].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                          record.lots[m].sales_atax = record.lots[m].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                                        }
                                      } 
                                    }                                 
                                    record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                    record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                    record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                       
                                  }                                   
                                }
                                if(transaction){
                                  /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                  record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                  json.quantity = json.quantity + record.quantity;
                                  json.sales_btax = json.sales_btax + record.sales_btax;
                                  json.sales_atax = json.sales_atax + record.sales_atax;
                                  record.index = json.size + 1;
                                  json.docs.push(record);
                                  json.size++;                        
                                  json.empty = false; 
                                }                                               
                            }
                            for(let i=0; i<vouchers.length; i++){   
                              let transaction = false;                         
                              let unit = this.getUnit_byRatio(vouchers[i].units, 1);                             
                              let record:any ={           
                                id_voucher: vouchers[i]._id,                                                  
                                name: vouchers[i].name,
                                img: vouchers[i].img,  
                                vtype: vouchers[i].type, 
  
                                ratio: unit.ratio,
                                unit: unit.unit,
                                barcode: unit.barcode,  
  
                                sales_btax: 0,
                                sales_atax: 0,
                                quantity: 0                        
                              }   
                              for(let j=0; j<vhbill_details.length; j++){      
                                if(record.id_voucher ===vhbill_details[j]?.id_voucher){
                                  transaction = true;    
                                  record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                  record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                                }
                              } 
                              if(transaction){                        
                                /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                json.quantity = json.quantity + record.quantity;
                                json.sales_btax = json.sales_btax + record.sales_btax;
                                json.sales_atax = json.sales_atax + record.sales_atax;
                                record.index = json.size + 1;
                                json.docs.push(record);
                                json.size++;                        
                                json.empty = false; 
                              } 
                            }
                            for(let i=0; i<payment_cards.length; i++){   
                              let transaction = false;                         
                              let unit = this.getUnit_byRatio(payment_cards[i].units, 1);                             
                              let record:any ={           
                                id_payment_card: payment_cards[i]._id,                                                  
                                name: payment_cards[i].name,
                                img: payment_cards[i].img,  
                                pctype: payment_cards[i].type, 
  
                                ratio: unit.ratio,
                                unit: unit.unit,
                                barcode: unit.barcode,  
  
                                sales_btax: 0,
                                sales_atax: 0,
                                quantity: 0                        
                              }    
                              for(let j=0; j<vhbill_details.length; j++){      
                                if(record.id_payment_card ===vhbill_details[j]?.id_payment_card){
                                  transaction = true;    
                                  record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                  record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                                }             
                              }
                              if(transaction){                        
                                /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                json.quantity = json.quantity + record.quantity;
                                json.sales_btax = json.sales_btax + record.sales_btax;
                                json.sales_atax = json.sales_atax + record.sales_atax;
                                record.index = json.size + 1;
                                json.docs.push(record);
                                json.size++;                        
                                json.empty = false; 
                              } 
                            }
                        }                
                        console.log('getReportSales_Customers_byProducts', json);                         
                        resolve(json);
                      })
              })  
        //}else resolve(json);                  
    })
  }

  
  /**
  * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 3) ->  Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một khách hàng trong list hiện ra -> Chọn một voucher trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Customers_byVoucher(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_customer 
  * @param id_voucher:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_voucher, vtype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Customers_byVoucher(starttime:any, endtime:any, id_customer:string, id_voucher:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('vouchers', id_voucher)
          .then((voucher:any)=>{
            if(voucher){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(voucher.units, 1);           
                        let record:any ={   
                          id_voucher: voucher._id,    
                          vtype: voucher.type,                    
                          name: voucher.name, 
                          img: voucher.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Customers_byVoucher', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 3) ->  Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một khách hàng trong list hiện ra -> Chọn một payment_card trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Customers_byPaymentCard(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_customer 
  * @param id_payment_card:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_payment_card, pctype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Customers_byPaymentCard(starttime:any, endtime:any, id_customer:string, id_payment_card:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('payment_cards', id_payment_card)
          .then((payment_card:any)=>{
            if(payment_card){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(payment_card.units, 1);           
                        let record:any ={   
                          id_payment_card: payment_card._id,  
                          pctype: payment_card.type,      

                          name: payment_card.name, 
                          img: payment_card.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Customers_byPaymentCard', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }
/**
   * @Usage Hàm này dùng trong page DOANH SỐ NHÂN VIÊN (layer 1) -> Chọn TẤT CẢ hoặc MỘT nhân viên
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Employees_byEmployees(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDemployee = 'all' or id_employee
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, img, id_employee, quantity, sales_btax, sales_atax}
   */  
  public getReportSales_Employees_byEmployees(starttime:any, endtime:any, IDemployee:any, IDbranch?:string){   
    return new Promise<any>((resolve, reject) => {                 
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0 
      }                                            
      let query:any;
      let bill_types = [1,40,50];
      if(IDemployee === 'all'){        
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};          
        }
      }else{
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:IDemployee}, bill_type: {$in:bill_types}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:IDemployee}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};            
        }          
      }        
      this.getBill_details_byFields(query, {},{date:1},0)
          .then((vhbill_details:any)=>{                     
                  if(vhbill_details.length>0){      
                    let employees:any = new Array();   
                    if(IDemployee === 'all') employees = this.vhAuth.getlocalEmployees();   
                    else {        
                      employees.push(this.vhAuth.getlocalEmployee(IDemployee));      
                    }                                             
                    for(let i=0; i<employees.length; i++){   
                      let transaction = false;                                                     
                      let data:any ={   
                        id_employee: employees[i]._id,                  
                        name: employees[i].name,                                                             
                        sales_btax: 0,
                        sales_atax: 0,
                        quantity: 0
                      }                                                  
                      for(let j=0; j<vhbill_details.length; j++){                           
                        if(employees[i]._id ===vhbill_details[j].id_employee){  
                          transaction = true;                             
                          if((vhbill_details[j].ptype ===1)||(vhbill_details[j].ptype ===2)||(vhbill_details[j].ptype ===3)||(vhbill_details[j].ptype ===4)||(vhbill_details[j].vtype ===1)||(vhbill_details[j].pctype ===1)){
                            data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                            data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                            data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100); 
                          }                                  
                        }
                      }
                      if(transaction){
                        json.quantity = json.quantity + data.quantity;
                        json.sales_btax = json.sales_btax + data.sales_btax;
                        json.sales_atax = json.sales_atax + data.sales_atax;
                        data.index = json.size + 1;
                        json.docs.push(data);
                        json.size++;                        
                        json.empty = false; 
                      }                          
                    }                      
                  }          
                  console.log('getReportSales_Employees_byEmployees');             
                  resolve(json);
                })   
    })
  }
      
  /**
   * @Usage Hàm này dùng trong page DOANH KHÁCH NHÂN VIÊN (layer 2) -> Chọn TẤT CẢ hoặc MỘT nhân viên -> Chọn một nhân viên trong list hiện ra
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Employees_byProducts(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
    * @param starttime 
    * @param endtime 
    * @param id_employee
    * @param IDbranch : 'all' or id_branch
    * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, id_employee, name, barcode, unit, img, quantity, sales_btax, sales_atax}
    */
    private getReportSales_Employees_byProducts(starttime:any, endtime:any, id_employee:any, IDbranch?:string){
      return new Promise<any>((resolve, reject) => {                                             
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, bill_type: {$in:[1]}};
        }else{
          query = query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};          
        }   
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0 
        }                    
        this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                         
                if(vhbill_details.length>0){ 
                    let products:any = this.getlocalProducts(1234);                 
                    for(let i=0; i<products.length; i++){       
                        let transaction = false;           
                        let product =  {...products[i]};                                   
                        let data:any ={   
                          id_product: product._id,                  
                          name: product.name, 
                          unit: product.unit,
                          barcode: product.barcode,
                          img: product.img,                                   
                          sales_btax: 0,
                          sales_atax: 0,
                          quantity: 0
                          //subs: new Array()//
                        }  
                        if(product.subs != undefined){
                          data.subs = new Array();
                          for(let k=0; k<product.subs.length; k++){
                            let sub:any ={
                              id_subproduct: product.subs[k]._id,                    
                              name: product.subs[k]?.name,
                              sales_btax: 0,
                              sales_atax: 0,
                              quantity: 0                          
                            }
                            data.subs.push(sub);
                          }
                        }                        
                        
                        for(let j=0; j<vhbill_details.length; j++){                                                            
                                if(vhbill_details[j].ptype === 1){                                                            
                                  if(products[i].type === 1){
                                    if(products[i]._id ===vhbill_details[j].id_product){
                                      transaction = true                         
                                      data.quantity = data.quantity + vhbill_details[j].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                      if(data.subs != undefined)
                                        for(let k=0; k<data.subs.length; k++){
                                          if(products[i].subs[k]._id === vhbill_details[j].id_subproduct){
                                            data.subs[k].quantity = data.subs[k].quantity + vhbill_details[j].quantity;
                                            data.subs[k].sales_btax = data.subs[k].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                            data.subs[k].sales_atax = data.subs[k].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                            break;
                                          }
                                        }  
                                    }
                                  }
                                  
                                  if(products[i].type === 4){                                                             
                                    if(vhbill_details[j].toppings != undefined){                                                                                                             
                                      for(let m=0; m<vhbill_details[j].toppings.length; m++){                                                                 
                                        if(products[i]._id ===vhbill_details[j].toppings[m].id_product){
                                          transaction = true                         
                                          data.quantity = data.quantity + vhbill_details[j].toppings[m].quantity;
                                          data.sales_btax = data.sales_btax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity;
                                          data.sales_atax = data.sales_atax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity * (1 + vhbill_details[j].tax / 100);                                                                                   
                                        }
                                      }
                                    }
                                  }
                                                                                    
                                }else if(vhbill_details[j].ptype === 2){
                                    if(products[i]._id ===vhbill_details[j].id_product){
                                      transaction = true                         
                                      data.quantity = data.quantity + vhbill_details[j].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                 
                                    }
                                      
                                }else if(vhbill_details[j].ptype === 3){
                                    if(products[i]._id ===vhbill_details[j].id_product){
                                      transaction = true                         
                                      data.quantity = data.quantity + vhbill_details[j].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                               
                                    }  
                                }else if(vhbill_details[j].ptype === 4){
                                    if(products[i]._id ===vhbill_details[j].id_product){
                                      transaction = true                         
                                      data.quantity = data.quantity + vhbill_details[j].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                  
                                    }                                 
                                }else if(vhbill_details[j].ptype === 5){  
                                  for(let m=0; m<vhbill_details[j].combos.length; m++){
                                      if(products[i]._id ===vhbill_details[j].combos[m].id_product){
                                        transaction = true                         
                                        data.quantity = data.quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                        data.sales_btax = data.sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                        data.sales_atax = data.sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                        if(data.subs != undefined)
                                          for(let k=0; k<data.subs.length; k++){                                    
                                            if(products[i].subs[k]._id === vhbill_details[j].combos[m].id_subproduct){
                                              data.subs[k].quantity = data.subs[k].quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                              data.subs[k].sales_btax = data.subs[k].sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                              data.subs[k].sales_atax = data.subs[k].sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                              break;
                                            }
                                          }                                                     
                                      }
                                  }                                                          
                                }
                        }
                        if(transaction){
                          /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                          data.sales_atax = this.vhAlgorithm.roundTo3Decimals(data.sales_atax);
                          if(data.subs != undefined)
                            data.subs.forEach((item:any) => {
                              item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                            });                                    
                          json.quantity = json.quantity + data.quantity;
                          json.sales_btax = json.sales_btax + data.sales_btax;
                          json.sales_atax = json.sales_atax + data.sales_atax;
                          data.index = json.size + 1;
                          json.docs.push(data);
                          json.size++;                        
                          json.empty = false; 
                        }                                               
                    }
                }                
                console.log('getReportSales_Employees_byProduct');                         
                resolve(json);
              })
      })
    }
/**
  * @Usage Hàm này dùng trong page DOANH SỐ NHÂN VIÊN (layer 3) ->  Chọn TẤT CẢ hoặc MỘT nhân viên -> Chọn một nhân viên trong list hiện ra -> Chọn một sản phẩm trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Employees_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_employee 
  * @param id_sub_or_product : id_subproduct or id_product
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_product, type, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Employees_byProduct(starttime:any, endtime:any, id_employee:string, id_sub_or_product:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      (async () => {
        try{
          let product:any = await this.getlocalDetailProduct_Async(id_sub_or_product); 
          let json:any = {
            docs: new Array(),
            empty: true,
            size:0,
            sales_btax: 0,   
            sales_atax: 0,  
            quantity: 0
          }                       
          let query:any;           
          let bill_types = [1]      
            if((IDbranch==='all')||(IDbranch===undefined)){
              if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in: bill_types}};
              else              query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_product: {$eq:product._id}, bill_type: {$in: bill_types}};
            }else{
              if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in: bill_types}, id_branch: {$eq:IDbranch}};        
              else              query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_product: {$eq:product._id}, bill_type: {$in: bill_types}, id_branch: {$eq:IDbranch}};     
            }     
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                
                if(vhbill_details.length>0){    
                  for(let i=0; i<vhbill_details.length; i++){    
                    let transaction = false;                              
                    let unit = this.getUnit_byRatio(product.units, 1);           
                    let record:any ={   
                      id_product: product._id,    
                      ptype: product.type,      

                      name: product.name, 
                      img: product.img,   

                      ratio: unit.ratio,
                      unit: unit.unit,
                      barcode: unit.barcode,                         
                      
                      bill_code: vhbill_details[i].bill_code,
                      bill_type:  vhbill_details[i].bill_type,
                      id_bill: vhbill_details[i].id_bill,
                      date: vhbill_details[i].date,
                      tax: vhbill_details[i].tax,
                      salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                      customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                    }  
                    if(vhbill_details[i].id_subproduct) record.id_subproduct = vhbill_details[i].id_subproduct;                      
                    if(vhbill_details[i].id_lotproduct){
                      record.id_lotproduct = vhbill_details[i].id_lotproduct; 
                      record.lots = new Array;
                      for(let m = 0; m<product.lots.length; m++){
                        if(product.lots[m]._id === record.id_lotproduct) {
                          record.lots.push(product.lots[m]);
                          break;
                        }
                      }
                    }    
      
                    transaction = true;                  
                    record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                    record.price = vhbill_details[i].price/vhbill_details[i].ratio;                 
                    
                    if(transaction){
                      record.sales_btax = record.price * record.quantity;
                      record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                      record.index = json.size + 1;                   
                      json.docs.push(record);
                      json.size++;
                      json.empty = false;
                      json.quantity = json.quantity + record.quantity;
                      json.sales_btax = json.sales_btax + record.price * record.quantity;
                      json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                    }                                                                                
                  }                                 
                }           
                console.log('getReportSales_Employees_byProduct', json);      
                resolve(json);
          })     
        } catch (err) {
          console.error('❌ Lỗi getReportSales_Employees_byProduct:', err);
          reject(err);
        }  
      })();             
    })      
  }
  
  /**
  * @Usage Hàm này dùng trong page DOANH SỐ NHÂN VIÊN (layer 3) ->  Chọn TẤT CẢ hoặc MỘT nhân viên -> Chọn một nhân viên trong list hiện ra -> Chọn một voucher trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Employees_byVoucher(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_employee 
  * @param id_voucher:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_voucher, vtype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Employees_byVoucher(starttime:any, endtime:any, id_employee:string, id_voucher:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('vouchers', id_voucher)
          .then((voucher:any)=>{
            if(voucher){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(voucher.units, 1);           
                        let record:any ={   
                          id_voucher: voucher._id,    
                          vtype: voucher.type,                    
                          name: voucher.name, 
                          img: voucher.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Employees_byVoucher', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ NHÂN VIÊN (layer 3) ->  Chọn TẤT CẢ hoặc MỘT nhân viên -> Chọn một nhân viên trong list hiện ra -> Chọn một payment_card trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Employees_byPaymentCard(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_employee 
  * @param id_payment_card:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_payment_card, pctype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Employees_byPaymentCard(starttime:any, endtime:any, id_employee:string, id_payment_card:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('payment_cards', id_payment_card)
          .then((payment_card:any)=>{
            if(payment_card){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(payment_card.units, 1);           
                        let record:any ={   
                          id_payment_card: payment_card._id,  
                          pctype: payment_card.type,      

                          name: payment_card.name, 
                          img: payment_card.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Employees_byPaymentCard', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }

  /**
   * @Usage Hàm này dùng trong page DOANH SỐ NHÂN VIÊN (layer 2) -> Chọn TẤT CẢ hoặc MỘT nhân viên -> Chọn một nhân viên trong list hiện ra
   * Hàm đã bao gồm doanh số bán voucher và payment_card
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Employees_byProducts_Vouchers_PaymentCards(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param id_employee
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_product, ptype, hoặc id_voucher, vtype, hoặc id_payment_card, pctype, index, name, barcode, unit, img, id_employee, quantity, sales_btax, sales_atax}
   */
  public getReportSales_Employees_byProducts_Vouchers_PaymentCards(starttime:any, endtime:any, id_employee:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                                             
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, bill_type: {$in:[1,40,50]}};
        }else{
          query = query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, bill_type: {$in:[1,40,50]}, id_branch: {$eq:IDbranch}};          
        }   
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0 
        }                    

        let vouchers = new Array();
        let payment_cards = new Array();     
        let promise = new Array();
        promise[0] = this.vhMGDB_database.getDocs('vouchers');
        promise[1] = this.vhMGDB_database.getDocs('payment_cards');
        Promise.all(promise)
              .then((array:any)=>{              
                vouchers = [...array[0]];
                payment_cards = [...array[1]];               
                this.getBill_details_byFields(query, {},{date:1},0)
                    .then((vhbill_details:any)=>{                                                    
                      if(vhbill_details.length>0){     
                          let products:any = this.getlocalDetailProducts(1234);               
                          for(let i=0; i<products.length; i++){       
                              let transaction = false;                         
                              let unit = this.getUnit_byRatio(products[i].units, 1);                             
                              let record:any ={          
                                id_product: products[i]._id,                                               
                                name: products[i].name,
                                img: products[i].img,
                                ptype: products[i].type,      

                                ratio: unit.ratio,
                                unit: unit.unit,
                                barcode: unit.barcode,  

                                sales_btax: 0,
                                sales_atax: 0,
                                quantity: 0                        
                              }                          
                              
                              if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct; 
                              if(products[i].lots) {
                                record.lots = cloneDeep(products[i].lots);
                                for(let m = 0; m<record.lots.length; m++){
                                  record.lots[m].quantity = 0;
                                  record.lots[m].sales_btax = 0;
                                  record.lots[m].sales_atax = 0;
                                }
                              }           

                              for(let j=0; j<vhbill_details.length; j++){                                                     
                                  let is_sub_or_product = false;
                                  if(record.id_subproduct) is_sub_or_product = vhbill_details[j]?.id_subproduct === record.id_subproduct;
                                  else is_sub_or_product = vhbill_details[j].id_product === record.id_product;    

                                  if(is_sub_or_product){                                     
                                    transaction = true         
                                    if(record.lots){
                                      for(let m=0; m<record.lots.length; m++){
                                        if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                          record.lots[m].quantity =   record.lots[m].quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                          record.lots[m].sales_btax = record.lots[m].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                          record.lots[m].sales_atax = record.lots[m].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                                        }
                                      }   
                                    }                               
                                    record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                    record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                    record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                    
                                  }                                  
                                }                              
                                                  
                              if(transaction){                        
                                /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                json.quantity = json.quantity + record.quantity;
                                json.sales_btax = json.sales_btax + record.sales_btax;
                                json.sales_atax = json.sales_atax + record.sales_atax;
                                record.index = json.size + 1;
                                json.docs.push(record);
                                json.size++;                        
                                json.empty = false; 
                              } 
                                                                          
                          }
                          for(let i=0; i<vouchers.length; i++){   
                            let transaction = false;                         
                            let unit = this.getUnit_byRatio(vouchers[i].units, 1);                             
                            let record:any ={           
                              id_voucher: vouchers[i]._id,                                                  
                              name: vouchers[i].name,
                              img: vouchers[i].img,  
                              vtype: vouchers[i].type, 

                              ratio: unit.ratio,
                              unit: unit.unit,
                              barcode: unit.barcode,  

                              sales_btax: 0,
                              sales_atax: 0,
                              quantity: 0                        
                            }   
                            for(let j=0; j<vhbill_details.length; j++){      
                              if(record.id_voucher ===vhbill_details[j]?.id_voucher){
                                transaction = true;    
                                record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                              }
                            } 
                            if(transaction){                        
                              /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                              record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                              json.quantity = json.quantity + record.quantity;
                              json.sales_btax = json.sales_btax + record.sales_btax;
                              json.sales_atax = json.sales_atax + record.sales_atax;
                              record.index = json.size + 1;
                              json.docs.push(record);
                              json.size++;                        
                              json.empty = false; 
                            } 
                          }
                          for(let i=0; i<payment_cards.length; i++){   
                            let transaction = false;                         
                            let unit = this.getUnit_byRatio(payment_cards[i].units, 1);                             
                            let record:any ={           
                              id_payment_card: payment_cards[i]._id,                                                  
                              name: payment_cards[i].name,
                              img: payment_cards[i].img,  
                              pctype: payment_cards[i].type, 

                              ratio: unit.ratio,
                              unit: unit.unit,
                              barcode: unit.barcode,  

                              sales_btax: 0,
                              sales_atax: 0,
                              quantity: 0                        
                            }    
                            for(let j=0; j<vhbill_details.length; j++){      
                              if(record.id_payment_card ===vhbill_details[j]?.id_payment_card){
                                transaction = true;    
                                record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                              }             
                            }
                            if(transaction){                        
                              /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                              record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                              json.quantity = json.quantity + record.quantity;
                              json.sales_btax = json.sales_btax + record.sales_btax;
                              json.sales_atax = json.sales_atax + record.sales_atax;
                              record.index = json.size + 1;
                              json.docs.push(record);
                              json.size++;                        
                              json.empty = false; 
                            } 
                          }
                      }                           
                      console.log('getReportSales_Employees_byProducts', json);                         
                      resolve(json);
                    })
          },(error:any)=>{
            reject(error);
          }) 
    })
  }
  

    /**
 * @Usage Hàm này dùng trong page DOANH SỐ BÀN (layer 1) -> Chọn TẤT CẢ hoặc MỘT bàn
 * @example
 *  let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Tables_byTables(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param IDtable = 'all' or id_table
  * @param IDbranch : 'all' or id_branch
  * @param type = 1 là sản phẩm, = 2 là dịch vụ, = 3 là nguyên liêu, ko truyền vào hoặc giá trị khác là cả ba
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, id_product, quantity, sales_btax, sales_atax}
  */
  public getReportSales_Tables_byTables(starttime:any, endtime:any, IDtable:any, IDbranch?:string){   
    return new Promise<any>((resolve, reject) => { 
      let tables:any = new Array();   
      if(IDtable === 'all') tables = this.getlocalTables()   
      else {
        let table = this.getlocalTable(IDtable);          
        tables.push(table);      
      }             
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0 
      }               
      if(tables.length>0){                                
        let query:any;
        let bill_types = [1,40,50]
        if(IDtable === 'all'){        
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};          
          }
        }else{
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:IDtable}, bill_type: {$in:bill_types}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:IDtable}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};            
          }
          
        }        
        this.getBill_details_byFields(query, {},{date:1},0)
            .then((vhbill_details:any)=>{                     
                    if(vhbill_details.length>0){                                                 
                      for(let i=0; i<tables.length; i++){   
                        let transaction = false;                                                                 
                        let data:any ={   
                          id_table: tables[i]._id,                  
                          name: tables[i].name,                          
                          img: tables[i]?.img,                                   
                          sales_btax: 0,
                          sales_atax: 0,
                          quantity: 0
                        }                                                                       
                        for(let j=0; j<vhbill_details.length; j++){                           
                          if(tables[i]._id ===vhbill_details[j].id_table){  
                            transaction = true;                           
                            if((vhbill_details[j].ptype ===1)||(vhbill_details[j].ptype ===2)||(vhbill_details[j].ptype ===3)||(vhbill_details[j].ptype ===4)||(vhbill_details[j].vtype ===1)||(vhbill_details[j].pctype ===1)){
                              data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                              data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                              data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                            }                                          
                          }
                        }
                        if(transaction){
                          json.quantity = json.quantity + data.quantity;
                          json.sales_btax = json.sales_btax + data.sales_btax;
                          json.sales_atax = json.sales_atax + data.sales_atax;
                          data.index = json.size + 1;
                          json.docs.push(data);
                          json.size++;                        
                          json.empty = false; 
                        }                          
                      }                      
                    }          
                    console.log('getReportSales_Tables_byTables', json);             
                    resolve(json);
                  })
      }else resolve(json);     
    })
  }
  private getReportSales_Tables_byTables_old(starttime:any, endtime:any, IDtable:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      let tables:any = new Array();   
      if(IDtable === 'all') tables = this.getlocalTables(); 
      else {
        let table = this.getlocalTable(IDtable);          
        tables.push(table);      
      }        
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0 
      }               
      if(tables.length>0){                                 
        let query:any;       
        if(IDtable === 'all'){        
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};        
          }
        }else{
          if((IDbranch==='all')||(IDbranch===undefined)){            
            query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:IDtable}, bill_type: {$in:[1]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:IDtable}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};                 
          }        
        }            
        this.getBill_details_byFields(query, {},{date:1},0)                          
            .then((vhbill_details:any)=>{       
                      if(vhbill_details.length>0){                                                 
                        for(let i=0; i<tables.length; i++){   
                          if(tables[i]._id != 'go_home'){
                            let transaction = false;                                                     
                            let data:any ={   
                              id_table: tables[i]._id,                  
                              name: tables[i].name,                                                             
                              sales_btax: 0,
                              sales_atax: 0,
                              quantity: 0
                            }                                                  
                            for(let j=0; j<vhbill_details.length; j++){                           
                              if(tables[i]._id ===vhbill_details[j].id_table){  
                                if(vhbill_details[j].ptype ===5){
                                  if(vhbill_details[j].combos != undefined)
                                    for(let m=0; m<vhbill_details[j].combos.length; m++){                                                   
                                        data.quantity = data.quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                        data.sales_btax = data.sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                        data.sales_atax = data.sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                       
                                    } 
                                }else{
                                  transaction = true;                                
                                  data.quantity = data.quantity + vhbill_details[j].quantity;
                                  data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
      
                                  if(vhbill_details[j].toppings != undefined)
                                    for(let m=0; m<vhbill_details[j].toppings.length; m++){                                                   
                                        data.quantity = data.quantity + vhbill_details[j].toppings[m].quantity;
                                        data.sales_btax = data.sales_btax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity;
                                        data.sales_atax = data.sales_atax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity * (1 + vhbill_details[j].tax / 100);                       
                                    } 
                                }
                              }
                            }
                            if(transaction){
                              json.quantity = json.quantity + data.quantity;
                              json.sales_btax = json.sales_btax + data.sales_btax;
                              json.sales_atax = json.sales_atax + data.sales_atax;
                              data.index = json.size + 1;
                              json.docs.push(data);
                              json.size++;                        
                              json.empty = false; 
                            }  
                          }                        
                        }
                      }      
                      console.log('getReportSales_Tables_byTables')                 
                      resolve(json);
                    })
      }else resolve(json);     
    })
  }
      
  /**
   * @Usage Hàm này dùng trong page DOANH KHÁCH HÀNG (layer 2) -> Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một sản phẩm trong list hiện ra
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Tables_byProducts(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
    * @param starttime 
    * @param endtime 
    * @param id_table
    * @param IDbranch : 'all' or id_branch
    * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, id_table, name, barcode, unit, img, quantity, sales_btax, sales_atax}
    */  
  private getReportSales_Tables_byProducts(starttime:any, endtime:any, id_table:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                                           
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, bill_type: {$in:[1]}};
        }else{
          query = query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};          
        }   
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0 
        }                    
        this.getBill_details_byFields(query, {},{date:1},0)
            .then((vhbill_details:any)=>{                         
              if(vhbill_details.length>0){          
                  let products:any = this.getlocalProducts(1234);        
                  for(let i=0; i<products.length; i++){       
                      let transaction = false;           
                      let product =  {...products[i]};                                   
                      let data:any ={   
                        id_product: product._id,                  
                        name: product.name, 
                        unit: product.unit,
                        barcode: product.barcode,
                        img: product.img,                                   
                        sales_btax: 0,
                        sales_atax: 0,
                        quantity: 0
                        //subs: new Array()//
                      }  
                      if(product.subs != undefined){
                        data.subs = new Array();
                        for(let k=0; k<product.subs.length; k++){
                          let sub:any ={
                            id_subproduct: product.subs[k]._id,                    
                            name: product.subs[k]?.name,
                            sales_btax: 0,
                            sales_atax: 0,
                            quantity: 0                          
                          }
                          data.subs.push(sub);
                        }
                      }                        
                      
                      for(let j=0; j<vhbill_details.length; j++){                                                            
                              if(vhbill_details[j].ptype === 1){                                                            
                                if(products[i].type === 1){
                                  if(products[i]._id ===vhbill_details[j].id_product){
                                    transaction = true                         
                                    data.quantity = data.quantity + vhbill_details[j].quantity;
                                    data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                    data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                    if(data.subs != undefined)
                                      for(let k=0; k<data.subs.length; k++){
                                        if(products[i].subs[k]._id === vhbill_details[j].id_subproduct){
                                          data.subs[k].quantity = data.subs[k].quantity + vhbill_details[j].quantity;
                                          data.subs[k].sales_btax = data.subs[k].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                          data.subs[k].sales_atax = data.subs[k].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                          break;
                                        }
                                      }  
                                  }
                                }
                                
                                if(products[i].type === 4){                                                             
                                  if(vhbill_details[j].toppings != undefined){                                                                                                             
                                    for(let m=0; m<vhbill_details[j].toppings.length; m++){                                                                 
                                      if(products[i]._id ===vhbill_details[j].toppings[m].id_product){
                                        transaction = true                         
                                        data.quantity = data.quantity + vhbill_details[j].toppings[m].quantity;
                                        data.sales_btax = data.sales_btax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity;
                                        data.sales_atax = data.sales_atax + vhbill_details[j].toppings[m].price * vhbill_details[j].toppings[m].quantity * (1 + vhbill_details[j].tax / 100);                                                                                   
                                      }
                                    }
                                  }
                                }
                                                                                  
                              }else if(vhbill_details[j].ptype === 2){
                                  if(products[i]._id ===vhbill_details[j].id_product){
                                    transaction = true                         
                                    data.quantity = data.quantity + vhbill_details[j].quantity;
                                    data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                    data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                 
                                  }
                                    
                              }else if(vhbill_details[j].ptype === 3){
                                  if(products[i]._id ===vhbill_details[j].id_product){
                                    transaction = true                         
                                    data.quantity = data.quantity + vhbill_details[j].quantity;
                                    data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                    data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                               
                                  }  
                              }else if(vhbill_details[j].ptype === 4){
                                  if(products[i]._id ===vhbill_details[j].id_product){
                                    transaction = true                         
                                    data.quantity = data.quantity + vhbill_details[j].quantity;
                                    data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                    data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                  
                                  }                                 
                              }else if(vhbill_details[j].ptype === 5){  
                                for(let m=0; m<vhbill_details[j].combos.length; m++){
                                    if(products[i]._id ===vhbill_details[j].combos[m].id_product){
                                      transaction = true                         
                                      data.quantity = data.quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                      data.sales_btax = data.sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                      data.sales_atax = data.sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                      if(data.subs != undefined)
                                        for(let k=0; k<data.subs.length; k++){                                    
                                          if(products[i].subs[k]._id === vhbill_details[j].combos[m].id_subproduct){
                                            data.subs[k].quantity = data.subs[k].quantity + vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                            data.subs[k].sales_btax = data.subs[k].sales_btax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity;
                                            data.subs[k].sales_atax = data.subs[k].sales_atax + vhbill_details[j].combos[m].price * vhbill_details[j].combos[m].quantity * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                            break;
                                          }
                                        }                                                     
                                    }
                                }                                                          
                              }
                      }
                      if(transaction){
                        /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                        data.sales_atax = this.vhAlgorithm.roundTo3Decimals(data.sales_atax);
                        if(data.subs != undefined)
                          data.subs.forEach((item:any) => {
                            item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                          });                                    
                        json.quantity = json.quantity + data.quantity;
                        json.sales_btax = json.sales_btax + data.sales_btax;
                        json.sales_atax = json.sales_atax + data.sales_atax;
                        data.index = json.size + 1;
                        json.docs.push(data);
                        json.size++;                        
                        json.empty = false; 
                      }                                               
                  }
              }                
              console.log('getReportSales_Tables_byProducts');                         
              resolve(json);
            })           
    })
  }
  /**
  * @Usage Hàm này dùng trong page DOANH SỐ BÀN (layer 3) ->  Chọn TẤT CẢ hoặc MỘT bàn -> Chọn một bàn trong list hiện ra -> Chọn một sản phẩm trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Tables_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_table 
  * @param id_sub_or_product 
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, id_subproduct, salesman}
  */
  public getReportSales_Tables_byProduct(starttime:any, endtime:any, id_table:any, id_sub_or_product:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      (async () => {
        try{
          let product = this.getlocalDetailProduct(id_sub_or_product);    
          let json:any = {
            docs: new Array(),
            empty: true,
            size:0,
            sales_btax: 0,   
            sales_atax: 0,  
            quantity: 0
          }                       
          let query:any;               
          let bill_types = [1];
      
          if((IDbranch==='all')||(IDbranch===undefined)){
            if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in:bill_types}};
            else                      query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, id_product: {$eq:product._id}, bill_type: {$in:bill_types}};
          }else{
            if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};       
            else                      query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, id_product: {$eq:product._id}, bill_type: {$in:bill_types}, id_branch: {$eq:IDbranch}};        
          }         
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                   
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){        
                          let transaction = false;                       
                          let unit = this.getUnit_byRatio(product.units, 1);   
                          let record:any ={   
                            id_product: product._id,                  
                            name: product.name, 
                            img: product.img, 
      
                            ratio: unit.ratio,
                            unit: unit.unit,
                            barcode: unit.barcode,                            
                            
                            bill_code: vhbill_details[i].bill_code,
                            bill_type:  vhbill_details[i].bill_type,
                            id_bill: vhbill_details[i].id_bill,
                            date: vhbill_details[i].date,
                            tax: vhbill_details[i].tax,
                            salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                            customer: this.getlocalCustomer(vhbill_details[i].id_customer).name,     
                            table: this.getlocalTable(vhbill_details[i].id_table).name                                                
                          }  
                          if(vhbill_details[i].id_subproduct) record.id_subproduct = vhbill_details[i].id_subproduct;                      
                          if(vhbill_details[i].id_lotproduct){
                            record.id_lotproduct = vhbill_details[i].id_lotproduct; 
                            record.lots = new Array;
                            for(let m = 0; m<product.lots.length; m++){
                              if(product.lots[m]._id === record.id_lotproduct) {
                                record.lots.push(product.lots[m]);
                                break;
                              }
                            }
                          }        
                        
                          transaction = true;                                                                                                                                    
                          record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                     
                          record.price = vhbill_details[i].price/vhbill_details[i].ratio;                         
                          
                          if(transaction){
                            record.sales_btax = record.price * record.quantity;
                            record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                            record.index = json.size + 1;                   
                            json.docs.push(record);
                            json.size++;
                            json.empty = false;
                            json.quantity = json.quantity + record.quantity;
                            json.sales_btax = json.sales_btax + record.price * record.quantity;
                            json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                          }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Tables_byProduct', json);      
                    resolve(json);         
              })     
        } catch (err) {
          console.error('❌ Lỗi getReportSales_Products_byProduct:', err);
          reject(err);
        }  
      })();  
           
    })      
  }

  /**
   * @Usage Hàm này dùng trong page DOANH SỐ BÀN (layer 2) -> Chọn tất cả hoặc một BÀN -> Chọn một BÀN trong list hiện ra
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00'); 
      this.vhQueryCafe.getReportSales_Tables_byProducts_Vouchers_PaymentCards(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param id_table
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_product, ptype, hoặc id_voucher, vtype, hoặc id_payment_card, pctype, index, name, barcode, unit, img, id_table, quantity, sales_btax, sales_atax}
   */
  public getReportSales_Tables_byProducts_Vouchers_PaymentCards(starttime:any, endtime:any, id_table:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                                          
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, bill_type: {$in:[1,40,50]}};
        }else{
          query = query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, bill_type: {$in:[1,40,50]}, id_branch: {$eq:IDbranch}};          
        }   
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0 
        }                    
        let vouchers = new Array();
        let payment_cards = new Array();     
        let promise = new Array();
        promise[0] = this.vhMGDB_database.getDocs('vouchers');
        promise[1] = this.vhMGDB_database.getDocs('payment_cards');
        Promise.all(promise)
              .then((array:any)=>{              
                vouchers = [...array[0]];
                payment_cards = [...array[1]];     
                this.getBill_details_byFields(query, {},{date:1},0)
                    .then((vhbill_details:any)=>{                                 
                      if(vhbill_details.length>0){    
                          let products:any = this.getlocalDetailProducts(1234);               
                          for(let i=0; i<products.length; i++){       
                              let transaction = false;                                        
                              let unit = this.getUnit_byRatio(products[i].units, 1);                             
                              let record:any ={   
                                id_product: products[i]._id,              
                                name: products[i].name,
                                img: products[i].img,
                                ptype: products[i].type,     

                                ratio: unit.ratio,
                                unit: unit.unit,
                                barcode: unit.barcode,       
                              
                                //id_area:id_area,                                            
                                sales_btax: 0,
                                sales_atax: 0,
                                quantity: 0                        
                              }      
                              if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct; 
                              if(products[i].lots) {
                                record.lots = cloneDeep(products[i].lots);
                                for(let m = 0; m<record.lots.length; m++){
                                  record.lots[m].quantity = 0;
                                  record.lots[m].sales_btax = 0;
                                  record.lots[m].sales_atax = 0;
                                }
                              }                   
                              for(let j=0; j<vhbill_details.length; j++){ 
                                let is_sub_or_product = false;
                                if(record.id_subproduct) is_sub_or_product = vhbill_details[j]?.id_subproduct === record.id_subproduct;
                                else is_sub_or_product = vhbill_details[j].id_product === record.id_product;                                                                             
                                if(is_sub_or_product){                                          
                                  transaction = true         
                                  if(record.lots){
                                    for(let m=0; m<record.lots.length; m++){
                                      if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                        record.lots[m].quantity =   record.lots[m].quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                        record.lots[m].sales_btax = record.lots[m].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                        record.lots[m].sales_atax = record.lots[m].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                                      }
                                    } 
                                  }                                 
                                  record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                  record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                       
                                }                                   
                              }
                              if(transaction){
                                /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                json.quantity = json.quantity + record.quantity;
                                json.sales_btax = json.sales_btax + record.sales_btax;
                                json.sales_atax = json.sales_atax + record.sales_atax;
                                record.index = json.size + 1;
                                json.docs.push(record);
                                json.size++;                        
                                json.empty = false; 
                              }                                               
                          }
                          for(let i=0; i<vouchers.length; i++){   
                            let transaction = false;                         
                            let unit = this.getUnit_byRatio(vouchers[i].units, 1);                             
                            let record:any ={           
                              id_voucher: vouchers[i]._id,                                                  
                              name: vouchers[i].name,
                              img: vouchers[i].img,  
                              vtype: vouchers[i].type, 

                              ratio: unit.ratio,
                              unit: unit.unit,
                              barcode: unit.barcode,  

                              sales_btax: 0,
                              sales_atax: 0,
                              quantity: 0                        
                            }   
                            for(let j=0; j<vhbill_details.length; j++){      
                              if(record.id_voucher ===vhbill_details[j]?.id_voucher){
                                transaction = true;    
                                record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                              }
                            } 
                            if(transaction){                        
                              /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                              record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                              json.quantity = json.quantity + record.quantity;
                              json.sales_btax = json.sales_btax + record.sales_btax;
                              json.sales_atax = json.sales_atax + record.sales_atax;
                              record.index = json.size + 1;
                              json.docs.push(record);
                              json.size++;                        
                              json.empty = false; 
                            } 
                          }
                          for(let i=0; i<payment_cards.length; i++){   
                            let transaction = false;                         
                            let unit = this.getUnit_byRatio(payment_cards[i].units, 1);                             
                            let record:any ={           
                              id_payment_card: payment_cards[i]._id,                                                  
                              name: payment_cards[i].name,
                              img: payment_cards[i].img,  
                              pctype: payment_cards[i].type, 

                              ratio: unit.ratio,
                              unit: unit.unit,
                              barcode: unit.barcode,  

                              sales_btax: 0,
                              sales_atax: 0,
                              quantity: 0                        
                            }    
                            for(let j=0; j<vhbill_details.length; j++){      
                              if(record.id_payment_card ===vhbill_details[j]?.id_payment_card){
                                transaction = true;    
                                record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                              }             
                            }
                            if(transaction){                        
                              /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                              record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                              json.quantity = json.quantity + record.quantity;
                              json.sales_btax = json.sales_btax + record.sales_btax;
                              json.sales_atax = json.sales_atax + record.sales_atax;
                              record.index = json.size + 1;
                              json.docs.push(record);
                              json.size++;                        
                              json.empty = false; 
                            } 
                          }
                      }                
                      console.log('getReportSales_Tables_byProducts_Vouchers_PaymentCards', json);                         
                      resolve(json);
                    })
            })               
    })
  }

  
  /**
  * @Usage Hàm này dùng trong page DOANH SỐ BÀN (layer 3) ->  Chọn tất cả hoặc một BÀN -> Chọn một BÀN trong list hiện ra -> Chọn một voucher trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Tables_byVoucher(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_table 
  * @param id_voucher:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_voucher, vtype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Tables_byVoucher(starttime:any, endtime:any, id_table:string, id_voucher:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('vouchers', id_voucher)
          .then((voucher:any)=>{
            if(voucher){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(voucher.units, 1);           
                        let record:any ={   
                          id_voucher: voucher._id,    
                          vtype: voucher.type,                    
                          name: voucher.name, 
                          img: voucher.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Tables_byVoucher', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ BÀN (layer 3) ->  Chọn tất cả hoặc một BÀN -> Chọn một BÀN trong list hiện ra -> Chọn một payment_card trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_Tables_byPaymentCard(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_table 
  * @param id_payment_card:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_payment_card, pctype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Tables_byPaymentCard(starttime:any, endtime:any, id_table:string, id_payment_card:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_table: {$eq:id_table}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('payment_cards', id_payment_card)
          .then((payment_card:any)=>{
            if(payment_card){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(payment_card.units, 1);           
                        let record:any ={   
                          id_payment_card: payment_card._id,  
                          pctype: payment_card.type,      

                          name: payment_card.name, 
                          img: payment_card.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Tables_byPaymentCard', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }

  /**
   * Hàm này dùng trong page XUẤT-NHẬP-TRẢ -> tất cả các trường hợp
   * @example:
   * let starttime = new Date('2020-12-10T05:24:00');
     let endtime = new Date();    
    this.vhQueryCafe.getReportInputOutputReturns_byTime_byIDProduct_byBillTypeArray(starttime, endtime, 'all', 1, [1])
        .then((products)=>{
          console.log('products', products);
        })
   * @param starttime 
   * @param endtime 
   * @param IDsub_or_product : 'all' or id_subproduct or id_product (type 3)
   * @param IDbranch : 'all' or id_branch
   * @param ptype 
   * @param array_bill_type 
   * @return Promise Array
   * @Notice array_bill_type = [bill_types];[1,3,10,30,38,41,51,2,9,16,31,39]
   */ 
  public getReportInputOutputReturns_byTime_byIDMaterial_byBillTypeArray(starttime:any, endtime:any, IDsub_or_product:string, array_bill_type:any, IDbranch?:string){
    console.log('array_bill_type', array_bill_type);
    return new Promise<any>((resolve, reject) => {  
        let products:any = new Array();           
        if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');   
        else {
          let product = this.getlocalDetailProduct(IDsub_or_product);           ;  
          products.push(product);           
        }       
        let json:any = {
          docs: new Array(),
          empty: true,
          size:0,
          quantity: 0,
          pay_btax: 0,
          pay_atax: 0
        }              
        if(products.length>0){          
          let promise = new Array();                  
          let query1:any = {};
          let query2:any = {};
          let array_bill_type1 = new Array();
          let array_bill_type2 = new Array();
          for(let i=0; i<array_bill_type.length; i++){
            if(i<=9) array_bill_type1.push(array_bill_type[i]);
            else array_bill_type2.push(array_bill_type[i]);
          }
          if(IDsub_or_product === 'all'){
            if((IDbranch === 'all')||(IDbranch === undefined)){
              query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:array_bill_type1}};   
              query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:array_bill_type2}};              
            }else{
              query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:array_bill_type1}, id_branch: {$eq:IDbranch}}; 
              query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:array_bill_type2}, id_branch: {$eq:IDbranch}}; 
            }
          }else{
            if((IDbranch === 'all')||(IDbranch === undefined)){
              if(products[0].id_subproduct) {
                query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type1}};      
                query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type2}};      
              }else{
                query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type1}};  
                query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type2}};  
              }         
            }else{
              if(products[0].id_subproduct){
                query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type1}, id_branch: {$eq:IDbranch}};
                query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type2}, id_branch: {$eq:IDbranch}};
              }else{
                query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type1}, id_branch: {$eq:IDbranch}};
                query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type2}, id_branch: {$eq:IDbranch}};
              }
            }
          }      
          
          if(array_bill_type.length<=10){
            promise[promise.length] = this.getBill_details_byFields(query1, {},{date:1},0);
          }else{
            promise[promise.length] = this.getBill_details_byFields(query1, {},{date:1},0)
            promise[promise.length] = this.getBill_details_byFields(query2, {},{date:1},0)
          }
          
          Promise.all(promise)
              .then((array:any)=>{            
                let bill_details = array.flat();                             
                for(let i=0; i<products.length; i++){
                  let unit = this.getUnit_byRatio(products[i].units, 1);                 
                  let record: any ={
                    id_product: products[i]._id,              
                    name: products[i].name,
                    img: products[i].img,  
                    type: products[i].type,

                    ratio: unit.ratio,
                    unit: unit.unit,
                    barcode: unit.barcode,               

                    quantity: 0,
                    pay_btax: 0,
                    pay_atax: 0
                  }
                  if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;       
                  if(products[i].lots) {
                    record.lots = cloneDeep(products[i].lots);
                    for(let m = 0; m<record.lots.length; m++){
                      record.lots[m].quantity = 0;
                      record.lots[m].pay_btax = 0;
                      record.lots[m].pay_atax = 0;
                    } 
                  }              
                  
                  for(let j=0; j<bill_details.length; j++){   
                    let is_sub_or_product = false;
                    if(record.id_subproduct) is_sub_or_product = bill_details[j].id_subproduct === record.id_subproduct;
                    else is_sub_or_product = bill_details[j].id_product === record.id_product;
                    //if(bill_details[j].ptype === 1){
                    if(is_sub_or_product){       
                      if(record.lots){
                        for(let m=0; m<record.lots.length; m++){
                          if(record.lots[m]._id === bill_details[j].id_lotproduct){    
                            record.lots[m].pay_btax = record.lots[m].pay_btax + bill_details[j].price * bill_details[j].quantity; 
                            record.lots[m].pay_atax = record.lots[m].pay_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                            record.lots[m].quantity = record.lots[m].quantity + bill_details[j].quantity * bill_details[j].ratio;                       
                          }
                        }   
                      }                  
                      record.pay_btax = record.pay_btax + bill_details[j].price * bill_details[j].quantity;  
                      record.pay_atax = record.pay_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                      record.quantity = record.quantity + bill_details[j].quantity * bill_details[j].ratio; 
                      
                      json.pay_btax = json.pay_btax + bill_details[j].price  * bill_details[j].quantity; 
                      json.pay_atax = json.pay_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                      json.quantity = json.quantity + bill_details[j].quantity * bill_details[j].ratio;                                        
                    }   
                    //} 
                  }                    
                  record.pay_atax = this.vhAlgorithm.roundTo3Decimals(record.pay_atax);   
                  json.pay_atax = this.vhAlgorithm.roundTo3Decimals(json.pay_atax);   
                  json.docs.push(record);
                  json.size++;                        
                  json.empty = false;                               
                }
                console.log('getReportInputOutputReturns_byTime_byIDMaterial_byBillTypeArray', json);
                resolve(json);   
              })                      
        
        }else{
          console.log('server -> products khong ton tai trong CSDL: ');
          resolve(json);           
        }  
                
    })    
  }

  /**
   * Hàm này dùng trong page XUẤT-NHẬP-TRẢ NGUYÊN LIỆU (xem từng loại bill_type một) -> tất cả các trường hợp
   * @example:
   * let starttime = new Date('2020-12-10T05:24:00');
     let endtime = new Date();    
    this.vhQueryCafe.getReportInputOutputReturns_byTime_byIDMaterial_byBillTypeArray(starttime, endtime, 'all', 1, [1])
        .then((materials)=>{
          console.log('materials', materials);
        })
   * @param starttime 
   * @param endtime 
   * @param IDmaterial : id_material = 'all' or id_material;
   * @param ptype 
   * @param array_bill_type 
   * @param IDbranch 
   * @return Promise Array
   * @Notice array_bill_type = [bill_type], 1,3,10,30,2,9,16,31
   */ 
  private getReportInputOutputReturns_byTime_byIDMaterial_byBillTypeArray_old(starttime:any, endtime:any, IDmaterial:any, array_bill_type:any, IDbranch?:string){
    //cần xem lại array_bill_type set cứng luôn hay là tham số truyền như hiện có
    return new Promise<any>((resolve, reject) => {  
        let materials:any = new Array();   
        if(IDmaterial === 'all') materials = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalProducts(3), 'name');   
        else {
          let material = this.getlocalProduct(IDmaterial);                 
          materials.push(material);
        }
        let json:any = {
          docs: new Array(),
          empty: true,
          size:0,
          quantity: 0,
          pay_btax: 0,
          pay_atax: 0
        }              
        if(materials.length>0){           
          let query:any;
          if(IDmaterial === 'all'){
            if((IDbranch === 'all')||(IDbranch === undefined)){
              query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:array_bill_type}};              
            }else{
              query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:array_bill_type}, id_branch: {$eq:IDbranch}}; 
            }
          }else{
            if((IDbranch === 'all')||(IDbranch === undefined)){
              query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDmaterial}, bill_type: {$in:array_bill_type}};              
            }else{
              query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDmaterial}, bill_type: {$in:array_bill_type}, id_branch: {$eq:IDbranch}};
            }
          }
         
          this.getBill_details_byFields(query, {},{date:1},0)       
              .then((bill_details:any)=>{                           
                for(let i=0; i<materials.length; i++){
                  let transaction = false;   
                  let material: any ={
                    _id: materials[i]._id,
                    name: materials[i].name,
                    type: materials[i].type,
                    unit: materials[i].unit,
                    quantity: 0,
                    pay_btax: 0,
                    pay_atax: 0
                  }
                  for(let j=0; j<bill_details.length; j++){   
                    if(bill_details[j].id_product === materials[i]._id){ 
                      transaction = true;                      
                      if((bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 16)){
                        material.quantity = material.quantity + bill_details[j].quantity;     
                      }else{
                        material.pay_btax = material.pay_btax + bill_details[j].price * bill_details[j].quantity; 
                        material.pay_atax = material.pay_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                        material.quantity = material.quantity + bill_details[j].quantity;    
                      }                                                                                   
                    }                                    
                  }     
                  if(transaction){
                    json.pay_btax = json.pay_btax + material.price  * material.quantity;
                    json.pay_atax = json.pay_atax + material.price  * material.quantity * (1 + material.tax / 100);       
                    json.quantity = json.quantity + material.quantity;  
                    json.docs.push(material);
                    json.size++;                        
                    json.empty = false;    
                  }               
                }
                console.log('json', json);
                resolve(json);   
              })                      
        
        }else{
          console.log('server -> products khong ton tai trong CSDL: ');
          resolve(json);           
        }  
                
    })    
  }

  /**         
   * Hàm này dùng trong page XUẤT-NHẬP-TRẢ NGUYÊN LIỆU (xem từng loại bill_type một)  -> tất cả các trường hợp -> chi tiết
   * @example:
   *  this.vhQueryCafe.getReportInputOutputReturns_Detail_byTime_byIDMaterial_byBillTypeArray(time['startTime'], time['endTime'], 'UTWXdaU3UDq3xq7aK77p', [1])
        .then((bill_details:any)=>{
          console.log('vhs_bill_details_', bill_details);
        })
    * @param starttime 
    * @param endtime 
    * @param id_material 
    * @param array_bill_type 
    * @return Promise Array
    * @Notice array_bill_type = [bill_type], 1,3,10,30,2,9,16,31
    */
  public getReportInputOutputReturns_Detail_byTime_byIDMaterial_byBillTypeArray(starttime:any, endtime:any, IDsub_or_product:any,array_bill_type:any, IDbranch?:string){
    //cần xem lại array_bill_type set cứng luôn hay là tham số truyền như hiện có
    return new Promise<any>((resolve, reject) => {  
      let product = this.getlocalDetailProduct(IDsub_or_product);  
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        quantity: 0,
        pay_btax: 0,
        pay_atax: 0
      }        
      if(!product) resolve(json);

      let query:any; 
      if((IDbranch==='all')||(IDbranch===undefined)){
        if(product.id_subproduct) {
          query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type}};
        }        
      }else{
        if(product.id_subproduct) {
          query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type}, id_branch: {$eq:IDbranch}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type}, id_branch: {$eq:IDbranch}};
        }        
      }      
      this.getBill_details_byFields(query, {},{date:1},0)                  
          .then((bill_details:any)=>{                                    
              for(let j=0; j<bill_details.length; j++){   
                let bill_detail:any ={
                  id_bill: bill_details[j]?.id_bill,
                  bill_code: bill_details[j]?.bill_code,
                  bill_type: bill_details[j]?.bill_type,
                  date: bill_details[j]?.date,
                  price_btax: bill_details[j]?.price,
                  price_atax: bill_details[j]?.price * (1 + bill_details[j].tax/100),
                  pay_btax: bill_details[j]?.price * bill_details[j]?.quantity,
                  pay_atax: this.vhAlgorithm.roundTo3Decimals(bill_details[j]?.price * bill_details[j]?.quantity * (1 + bill_details[j].tax/100)),
                  quantity: bill_details[j]?.quantity,
                  name: product.name,
                  unit: product.unit                  
                }
                if(bill_details[j]?.id_cashier) bill_detail.id_cashier = bill_details[j]?.id_cashier;
                if(bill_details[j]?.id_employee) bill_detail.id_employee = bill_details[j]?.id_employee;
                if(bill_details[j]?.id_customer) bill_detail.id_customer = bill_details[j]?.id_customer;
                if(bill_details[j]?.id_supplier) bill_detail.id_supplier = bill_details[j]?.id_supplier;
                json.quantity = json.quantity + bill_details[j].quantity;
                json.pay_btax = json.pay_btax + bill_details[j].price  * bill_details[j].quantity;
                json.pay_atax = json.pay_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);                                                
                                  
                json.docs.push(bill_detail);
                json.size++;                        
                json.empty = false; 
                              
              }         
              resolve(json);

          })
    })
  }
    /**  
   * Hàm này dùng trong page XUẤT-NHẬP-TỒN -> Xuất nhập tồn
   * @example:
   * this.vhQueryCafe.getReportInputOutputInventory_byTime_byIDMaterial(starttime , endtime, 'all', 'tj1iYodbVoShwtEetACx')
        .then((json)=>{
          console.log('json', json);
        })
   * @param starttime 
   * @param endtime 
   * @param IDsub_or_product: 'all' or id_subproduct or id_product;  
   * @param IDbranch: 'all' or id_branch; 
   * @return Promise Array   * 
   * @Notice bill_type = [1,10,15,30,38,41,51,2,3,9,31,39]
   */
  public getReportInputOutputInventory_byTime_byIDMaterial(starttime:any, endtime:any, IDsub_or_product:any, IDbranch:any){
    return new Promise<any>((resolve, reject) => {  
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        outquantity: 0,
        inquantity: 0, 
        revenue_btax: 0,   
        revenue_atax: 0,  
        cost_btax: 0,     
        cost_atax: 0,
        
        stock_first: 0,   
        stock_last: 0,   
        cost_stock_first_btax: 0,   
        cost_stock_first_atax: 0,                          
        cost_stock_last_btax: 0,   
        cost_stock_last_atax: 0  
      }    
      let store = this.vhAuth.getStore();  
      let products:any = new Array();   
      if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
      else {
        let product = this.getlocalDetailProduct(IDsub_or_product);            
        products.push(product);
      }
        //console.log('products', products);   
      let query:any;
      let cash = 0;
      let index:any = null;
      let day:any = null;      
      let index1 = null;
      let index2 = null;      
      this.checkAndsyncInventoryOfMaterials(products, IDbranch)
      .then((check)=>{                  
         if(check){
           if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
           else {
             let product = this.getlocalDetailProduct(IDsub_or_product);            
             products.push(product);
           }
         }
         if((IDbranch==='all')||(IDbranch===undefined)){//ok
           console.log('trường hợp này chưa có hàm, liên hệ anh Huy viết');
           return  resolve(json);   
         }else{//ok         
           if(products[0][IDbranch + '_ivtr'] != undefined){
             for(let k=0; k<products[0][IDbranch + '_ivtr'].length; k++){              
               if((new Date(products[0][IDbranch + '_ivtr'][k].date)).getTime() > starttime.getTime()){               
                 break;
               }else{
                 day = new Date(products[0][IDbranch + '_ivtr'][k].date);
                 index = k; 
                 index1 = k;               
               }
             }    
             for(let k=0; k<products[0][IDbranch + '_ivtr'].length; k++){              
               if((new Date(products[0][IDbranch + '_ivtr'][k].date)).getTime() > endtime.getTime()){               
                 break;
               }else{                
                 index2 = k;                
               }
             }             
           }               
         }    
         if(!day) day = new Date(store.registrationdate);                     
         if(products.length>0){           
           //nhớ kiểm tra có cần thêm sắp xếp asc ko  
           let query1:any = {};
           let query2:any = {};           
           let promise = new Array();     
           if(IDsub_or_product === 'all'){
             if((IDbranch === 'all')||(IDbranch === undefined)){
               query1 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,51,2,9,16,39]}};   
               query2 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}};        
             }else{
               query1 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,51,2,9,16,39]}, id_branch: {$eq:IDbranch}};
               query2 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
             }            
           }else{         
               if((IDbranch === 'all')||(IDbranch === undefined)){                 
                 if(products[0].id_subproduct){ 
                   query1 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,9,16,39]}};
                   query2 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};
                 }else{                      
                   query1 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,9,16,39]}};
                   query2 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};
                 }
               }else{                
                 if(products[0].id_subproduct){
                   query1 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,9,16,39]}, id_branch: {$eq:IDbranch}};
                   query2 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                 }else{
                   query1 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,9,16,39]}, id_branch: {$eq:IDbranch}};
                   query2 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                 }
               }         
           }  
           promise[0] = this.getBill_details_byFields(query1, {},{date:1},0)
           promise[1] = this.getBill_details_byFields(query2, {},{date:1},0)
           Promise.all(promise)
               .then((array:any)=>{            
                   let bill_details = array.flat();                         
                   for(let i=0; i<products.length; i++){
                     //if((products[i][IDbranch] != undefined)&&(products[i][IDbranch + '_ivtr'] != undefined)){
                       let first = {
                         stock_first: 0,
                         cost_stock_first_btax: 0,
                         cost_stock_first_atax: 0                    
                       }                    
                       let unit = this.getUnit_byRatio(products[i].units,1);                 
                       let record: any ={                   
                         id_product:  products[i]._id,
                         name: products[i].name,
                         img: products[i].img,
                         type: products[i].type,
   
                         ratio: unit.ratio,
                         unit: unit.unit,
                         barcode: unit.barcode,
                         
                         outquantity: 0,
                         inquantity: 0, 
                         revenue_btax: 0,   
                         revenue_atax: 0,  
                         cost_btax: 0,     
                         cost_atax: 0 
                       }
                       if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;  
                       if(products[i].lots) {
                         record.lots = cloneDeep(products[i].lots);
                         for(let m = 0; m<record.lots.length; m++){                       
                           record.lots[m].outquantity = 0;
                           record.lots[m].inquantity = 0;
                           record.lots[m].revenue_btax = 0;
                           record.lots[m].revenue_atax = 0;
                           record.lots[m].cost_btax = 0;
                           record.lots[m].cost_atax = 0;                      
   
                           record.lots[m].soluongra_dauky = 0;
                           record.lots[m].soluongvao_dauky = 0;
                           record.lots[m].tientra_dauky_btax = 0;
                           record.lots[m].tientra_dauky_atax = 0;
                           record.lots[m].soluongvao_cuoiky = 0;
                           record.lots[m].tientra_cuoiky_btax = 0;
                           record.lots[m].tientra_cuoiky_atax = 0;
                           
                           record.lots[m].first ={
                             stock_first: 0,
                             stock_last: 0,
                             cost_stock_first_btax: 0,
                             cost_stock_first_atax: 0
                           }
                           record.lots[m].cost_stock_last_btax = 0;   
                           record.lots[m].cost_stock_last_atax = 0;                    
                         }
                       }   
   
                       record.stock_first = 0;   
                       record.stock_last = 0;   
                       record.cost_stock_first_btax = 0;   
                       record.cost_stock_first_atax = 0;                          
                       record.cost_stock_last_btax = 0;   
                       record.cost_stock_last_atax = 0;       
                       
                       //các biến tiếng việt này là khoản thời gian từ day đến startime
                       let soluongra_dauky = 0;
                       let soluongvao_dauky = 0;
                       let tientra_dauky_btax = 0;
                       let tientra_dauky_atax = 0;
                       let soluongvao_cuoiky = 0;
                       let tientra_cuoiky_btax = 0;
                       let tientra_cuoiky_atax = 0;                  
                     
                       for(let j=0; j<bill_details.length; j++){ //1,3,10,38,41,51,2,9,16,39
                         let is_sub_or_product = false;
                         if(record.id_subproduct) is_sub_or_product = bill_details[j].id_subproduct === record.id_subproduct;
                         else is_sub_or_product = bill_details[j].id_product === record.id_product;
                         if(bill_details[j].ptype === 3){  
                           if(is_sub_or_product){  
                             let date = new Date(bill_details[j].date);   
                             if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                               if(date >= new Date(starttime)){      
                                 //XUẤT 
                                 if(record.lots){
                                   for(let m=0; m<record.lots.length; m++){
                                     if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                       record.lots[m].revenue_btax = record.lots[m].revenue_btax + bill_details[j].price * bill_details[j].quantity;  
                                       record.lots[m].revenue_atax = record.lots[m].revenue_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                       record.lots[m].outquantity = record.lots[m].outquantity + bill_details[j].quantity * bill_details[j].ratio; 
                                     }
                                   }   
                                 }                                
                                 record.revenue_btax = record.revenue_btax + bill_details[j].price * bill_details[j].quantity;  
                                 record.revenue_atax = record.revenue_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                 record.outquantity = record.outquantity + bill_details[j].quantity * bill_details[j].ratio; 
   
                                 json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity; 
                                 json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                                 json.outquantity = json.outquantity + bill_details[j].quantity * bill_details[j].ratio;                                  
                               }else{
                                 if(record.lots){
                                   for(let m=0; m<record.lots.length; m++){
                                     if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                       record.lots[m].soluongra_dauky = record.lots[m].soluongra_dauky + bill_details[j].quantity * bill_details[j].ratio; 
                                     }
                                   }   
                                 } 
                                 soluongra_dauky = soluongra_dauky + bill_details[j].quantity * bill_details[j].ratio;                          
                               }
                                                               
                             }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 16)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){ 
                               if(date >= new Date(starttime)){  
                                 //NHẬP  
                                 if(record.lots){
                                   for(let m=0; m<record.lots.length; m++){
                                     if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                       record.lots[m].cost_btax = record.lots[m].cost_btax + bill_details[j].price * bill_details[j].quantity; 
                                       record.lots[m].cost_atax = record.lots[m].cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                       record.lots[m].inquantity = record.lots[m].inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                                     }
                                   }   
                                 }                      
                                 record.cost_btax = record.cost_btax + bill_details[j].price * bill_details[j].quantity; 
                                 record.cost_atax = record.cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                 record.inquantity = record.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                               
                                 json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity; 
                                 json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                                 json.inquantity = json.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
   
                               }else{
                                 if(record.lots){
                                   for(let m=0; m<record.lots.length; m++){
                                     if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                       record.lots[m].soluongvao_dauky = record.lots[m].soluongvao_dauky + bill_details[j].quantity * bill_details[j].ratio; 
                                       record.lots[m].tientra_dauky_btax = record.lots[m].tientra_dauky_btax + bill_details[j].price * bill_details[j].quantity; 
                                       record.lots[m].tientra_dauky_atax = this.vhAlgorithm.roundTo3Decimals(record.lots[m].tientra_dauky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                     }
                                   }   
                                 } 
                                 soluongvao_dauky = soluongvao_dauky + bill_details[j].quantity * bill_details[j].ratio; 
                                 tientra_dauky_btax = tientra_dauky_btax + bill_details[j].price * bill_details[j].quantity; 
                                 tientra_dauky_atax = this.vhAlgorithm.roundTo3Decimals(tientra_dauky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                               }
                               if(record.lots){
                                 for(let m=0; m<record.lots.length; m++){
                                   if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                     record.lots[m].soluongvao_cuoiky = record.lots[m].soluongvao_cuoiky + bill_details[j].quantity * bill_details[j].ratio; 
                                     record.lots[m].tientra_cuoiky_btax = record.lots[m].tientra_cuoiky_btax + bill_details[j].price * bill_details[j].quantity; 
                                     record.lots[m].tientra_cuoiky_atax = this.vhAlgorithm.roundTo3Decimals(record.lots[m].tientra_cuoiky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                   }
                                 }   
                               } 
                               soluongvao_cuoiky = soluongvao_cuoiky + bill_details[j].quantity * bill_details[j].ratio; 
                               tientra_cuoiky_btax = tientra_cuoiky_btax + bill_details[j].price * bill_details[j].quantity; 
                               tientra_cuoiky_atax = this.vhAlgorithm.roundTo3Decimals(tientra_cuoiky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                             
                             }else if(bill_details[j].bill_type === 9){//bill_type_9 là tồn đầu kỳ, ko xem nó là hàng nhập như báo cáo trước đây
                               if(record.lots){
                                 for(let m=0; m<record.lots.length; m++){
                                   if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                     record.lots[m].first.stock_first = record.lots[m].first.stock_first + bill_details[j].quantity * bill_details[j].ratio; 
                                     record.lots[m].first.cost_stock_first_btax = record.lots[m].first.cost_stock_first_btax + bill_details[j].price * bill_details[j].quantity; 
                                     record.lots[m].first.cost_stock_first_atax = record.lots[m].first.cost_stock_first_atax +  bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);   
                                   }
                                 }   
                               } 
                               first.stock_first = first.stock_first + bill_details[j].quantity * bill_details[j].ratio; 
                               first.cost_stock_first_btax = first.cost_stock_first_btax + bill_details[j].price * bill_details[j].quantity; 
                               first.cost_stock_first_atax = first.cost_stock_first_atax +  bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);   
                                                     
                             }                                                        
                           } 
                         }                                    
                       }
   
                       if(record.lots){
                         for(let m=0; m<record.lots.length; m++){                       
                           record.lots[m].stock_first = record.lots[m].first.stock_first + record.lots[m].soluongvao_dauky - record.lots[m].soluongra_dauky;//ok                               
                           record.lots[m].stock_last = record.lots[m].stock_first + record.lots[m].inquantity - record.lots[m].outquantity;//ok
                         
                           if(index !=null) record.lots[m].first = {...products[i][IDbranch + '_ivtr'][index].lots[m]};     
                                   
                           record.lots[m].stock_first = record.lots[m].first.stock_first + record.lots[m].soluongvao_dauky - record.lots[m].soluongra_dauky;//ok                               
                           record.lots[m].stock_last = record.lots[m].stock_first + record.lots[m].inquantity - record.lots[m].outquantity;//ok
                           if((record.lots[m].first.stock_first + record.lots[m].soluongvao_dauky)!=0){
                             record.lots[m].cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(((record.lots[m].first.cost_stock_first_btax + record.lots[m].tientra_dauky_btax)/(record.lots[m].first.stock_first + record.lots[m].soluongvao_dauky)) * record.lots[m].stock_first);
                             record.lots[m].cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(((record.lots[m].first.cost_stock_first_atax + record.lots[m].tientra_dauky_atax)/(record.lots[m].first.stock_first + record.lots[m].soluongvao_dauky)) * record.lots[m].stock_first);
                           }
       
                           if((record.lots[m].first.stock_first + record.lots[m].soluongvao_cuoiky)!=0){
                             record.lots[m].cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals(((record.lots[m].first.cost_stock_first_btax + record.lots[m].tientra_cuoiky_btax)/(record.lots[m].first.stock_first + record.lots[m].soluongvao_cuoiky)) * record.lots[m].stock_last);
                             record.lots[m].cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(((record.lots[m].first.cost_stock_first_atax + record.lots[m].tientra_cuoiky_atax)/(record.lots[m].first.stock_first + record.lots[m].soluongvao_cuoiky)) * record.lots[m].stock_last);
                           }
                         
                         }   
                       } 
                     
                       if(index !=null) first = {...products[i][IDbranch + '_ivtr'][index]};     
                                   
                       record.stock_first = first.stock_first + soluongvao_dauky - soluongra_dauky;//ok                               
                       record.stock_last = record.stock_first + record.inquantity - record.outquantity;//ok
                       if((first.stock_first + soluongvao_dauky)!=0){
                         record.cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_btax + tientra_dauky_btax)/(first.stock_first + soluongvao_dauky)) * record.stock_first);
                         record.cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_atax + tientra_dauky_atax)/(first.stock_first + soluongvao_dauky)) * record.stock_first);
                       }
   
                       if((first.stock_first + soluongvao_cuoiky)!=0){
                         record.cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_btax + tientra_cuoiky_btax)/(first.stock_first + soluongvao_cuoiky)) * record.stock_last);
                         record.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_atax + tientra_cuoiky_atax)/(first.stock_first + soluongvao_cuoiky)) * record.stock_last);
                       }
                       //if(soluongvao_dauky!=0) product.cost_stock_first_btax = (tientra_dauky_btax/soluongvao_dauky) * product.stock_first;//ok 
                       //if(soluongvao_dauky!=0) product.cost_stock_first_atax = (tientra_dauky_atax/soluongvao_dauky) * product.stock_first;//ok 
                       //if(soluongvao_cuoiky!=0) product.cost_stock_last_btax = (tientra_cuoiky_btax/soluongvao_cuoiky) * product.stock_last;  
                       //if(soluongvao_cuoiky!=0) product.cost_stock_last_atax = (tientra_cuoiky_atax/soluongvao_cuoiky) * product.stock_last; 
   
                       json.stock_first = json.stock_first + record.stock_first;
                       json.stock_last = json.stock_last + record.stock_last;
                       json.cost_stock_first_btax = json.cost_stock_first_btax + record.cost_stock_first_btax;
                       json.cost_stock_first_atax = json.cost_stock_first_atax + record.cost_stock_first_atax;
                       json.cost_stock_last_btax = json.cost_stock_last_btax + record.cost_stock_last_btax;
                       json.cost_stock_last_atax = json.cost_stock_last_atax + record.cost_stock_last_atax;
   
                       if((record.stock_first !=0)||(record.stock_last !=0)||(record.inquantity !=0)||(record.outquantity !=0)){
                         record.revenue_atax = this.vhAlgorithm.roundTo3Decimals(record.revenue_atax);     
                         record.cost_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_atax);    
                         record.cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_stock_first_atax);     
                         record.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_stock_last_atax);   
   
                         record.index = json.size + 1;
                         json.docs.push(record);
                         json.size++;                        
                         json.empty = false;   
                       }  
                     //}                                        
                   }
                   resolve(json);                                 
                   console.log('getReportInputOutputInventory_byTime_byIDProduct', json);
                 })                      
         
         }else{
           console.log('server -> products khong ton tai trong CSDL: ');
           resolve(json);           
         } 
       }) 
                
    })    
  }

 /**
 * Hàm này kiểm tra các detailproducts (type=1) nào đã thỏa mãn 60days mà chưa có ký sinh inventory trong sản phẩm thì sẽ gọi hàm
 * syncInventoryEveryDay_Stock1stDayOfMonth để tính lại
 * @example:
 * this.vhQueryCafe.checkAndsyncInventoryOfMaterials(endtime, 'all')
       .then(()=>{
         
       })
 */
 private checkAndsyncInventoryOfMaterials(detailproducts:any, IDbranch:string){
   return new Promise<any>((resolve, reject) => {  
     if(IDbranch!='all'){
       let counts = 0;
       for(let i=0; i<detailproducts.length; i++){
         if((detailproducts[i][IDbranch] == undefined)||(detailproducts[i][IDbranch + '_ivtr'] == undefined)){
           counts++;
         }
       }
       if((counts >0)&&(counts <detailproducts.length)){
         this.syncInventoryEveryDay_Stock1stDayOfMonth()
             .then(()=>{            
                 resolve(true);                  
             })   
       }else{
         resolve(false);   
       }
     }else{
       resolve(false); 
     }
   })
 }
       
  private getReportInputOutputInventory_byTime_byIDMaterial1(starttime:any, endtime:any, IDmaterial:any, IDbranch?:any){
    return new Promise<any>((resolve, reject) => {  
        let products:any = new Array();   
        if(IDmaterial === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalProducts(3), 'name');  
        else {
          let product = this.getlocalProduct(IDmaterial);            
          products.push(product);
        }
        let json:any = {
          docs: new Array(),
          empty: true,
          size:0,
          outquantity: 0,
          inquantity: 0, 
          revenue_btax: 0,   
          revenue_atax: 0,  
          cost_btax: 0,     
          cost_atax: 0,
          
          stock_first: 0,   
          stock_last: 0,   
          cost_stock_first_btax: 0,   
          cost_stock_first_atax: 0,                          
          cost_stock_last_btax: 0,   
          cost_stock_last_atax: 0  
        }              
        if(products.length>0){           
          //nhớ kiểm tra có cần thêm sắp xếp asc ko    
          let query:any;
          if(IDmaterial === 'all'){
            if((IDbranch === 'all')||(IDbranch === undefined)){
              query = {date: {$lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,30,2,9,16,31]}};              
            }else{
              query = {date: {$lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,30,2,9,16,31]}, id_branch: {$eq:IDbranch}};
            }
          }else{
            if((IDbranch === 'all')||(IDbranch === undefined)){              
              query = {date: {$lte:endtime}, ptype: {$eq:3}, id_product: {$eq:IDmaterial}, bill_type: {$in:[1,3,10,30,2,9,16,31]}};
            }else{              
              query = {date: {$lte:endtime}, ptype: {$eq:3}, id_product: {$eq:IDmaterial}, bill_type: {$in:[1,10,15,30,2,3,9,31]}, id_branch: {$eq:IDbranch}};
            }
          }     
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((bill_details:any)=>{                                
                for(let i=0; i<products.length; i++){
                  let product: any ={
                    _id: products[i]._id,
                    name: products[i].name,
                    type: products[i].type,
                    unit: products[i].unit,
                    
                    outquantity: 0,
                    inquantity: 0, 
                    revenue_btax: 0,   
                    revenue_atax: 0,  
                    cost_btax: 0,     
                    cost_atax: 0 
                  }

                  product.stock_first = 0;   
                  product.stock_last = 0;   
                  product.cost_stock_first_btax = 0;   
                  product.cost_stock_first_atax = 0;                          
                  product.cost_stock_last_btax = 0;   
                  product.cost_stock_last_atax = 0;       
                  
                  let soluongra_dauky = 0;
                  let soluongvao_dauky = 0;
                  let tientra_dauky_btax = 0;
                  let tientra_dauky_atax = 0;
                  let soluongvao_cuoiky = 0;
                  let tientra_cuoiky_btax = 0;
                  let tientra_cuoiky_atax = 0;                  
                  
                  for(let j=0; j<bill_details.length; j++){   
                    if(bill_details[j].id_product === products[i]._id){  
                      let date = new Date(bill_details[j].date);   
                      if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 30)){
                        if(date >= new Date(starttime)){      
                          product.revenue_btax = product.revenue_btax + bill_details[j].price * bill_details[j].quantity; 
                          product.revenue_atax = product.revenue_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                          product.outquantity = product.outquantity + bill_details[j].quantity; 

                          json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity;
                          json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                          json.outquantity = json.outquantity + bill_details[j].quantity;  

                        }else{
                          soluongra_dauky = soluongra_dauky + bill_details[j].quantity;                          
                        }
                      }else if(bill_details[j].bill_type === 3){
                        if(date >= new Date(starttime)){                               
                          product.outquantity = product.outquantity + bill_details[j].quantity;                               
                          json.outquantity = json.outquantity + bill_details[j].quantity;  
                        }else{
                          soluongra_dauky = soluongra_dauky + bill_details[j].quantity;                          
                        }      
                      }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 31)){ 
                        if(date >= new Date(starttime)){  
                          product.cost_btax = product.cost_btax + bill_details[j].price * bill_details[j].quantity; 
                          product.cost_atax = product.cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                          product.inquantity = product.inquantity + bill_details[j].quantity; 

                          json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                          json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                          json.inquantity = json.inquantity + bill_details[j].quantity;
                        }else{
                          soluongvao_dauky = soluongvao_dauky + bill_details[j].quantity;
                          tientra_dauky_btax = tientra_dauky_btax + bill_details[j].price * bill_details[j].quantity;
                          tientra_dauky_atax = this.vhAlgorithm.roundTo3Decimals(tientra_dauky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                        }
                        soluongvao_cuoiky = soluongvao_cuoiky + bill_details[j].quantity;
                        tientra_cuoiky_btax = tientra_cuoiky_btax + bill_details[j].price * bill_details[j].quantity;
                        tientra_cuoiky_atax = this.vhAlgorithm.roundTo3Decimals(tientra_cuoiky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                            
                      }else if(bill_details[j].bill_type === 16){ 
                        if(date >= new Date(starttime)){                           
                          product.inquantity = product.inquantity + bill_details[j].quantity;     
                          json.inquantity = json.inquantity + bill_details[j].quantity;
                        }else{
                          soluongvao_dauky = soluongvao_dauky + bill_details[j].quantity;                         
                        }
                        soluongvao_cuoiky = soluongvao_cuoiky + bill_details[j].quantity;                      
                            
                      }                      
                                                            
                    }                                     
                  }
                  product.stock_first = soluongvao_dauky - soluongra_dauky;                               
                  product.stock_last = product.stock_first + product.inquantity - product.outquantity;

                  if(soluongvao_dauky!=0) product.cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((tientra_dauky_btax/soluongvao_dauky) * product.stock_first); 
                  if(soluongvao_dauky!=0) product.cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((tientra_dauky_atax/soluongvao_dauky) * product.stock_first); 
                  if(soluongvao_cuoiky!=0) product.cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals((tientra_cuoiky_btax/soluongvao_cuoiky) * product.stock_last);  
                  if(soluongvao_cuoiky!=0) product.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals((tientra_cuoiky_atax/soluongvao_cuoiky) * product.stock_last); 

                  json.stock_first = json.stock_first + product.stock_first;
                  json.stock_last = json.stock_last + product.stock_last;
                  json.cost_stock_first_btax = json.cost_stock_first_btax + product.cost_stock_first_btax;
                  json.cost_stock_first_atax = json.cost_stock_first_atax + product.cost_stock_first_atax;
                  json.cost_stock_last_btax = json.cost_stock_last_btax + product.cost_stock_last_btax;
                  json.cost_stock_last_atax = json.cost_stock_last_atax + product.cost_stock_last_atax;

                  if((product.stock_first !=0)||(product.inquantity !=0)||(product.outquantity !=0)){
                    product.index = json.size + 1;
                    json.docs.push(product);
                    json.size++;                        
                    json.empty = false;   
                  }        
                                  
                }
                resolve(json);   
              })                      
        
        }else{
          console.log('server -> products khong ton tai trong CSDL: ');
          resolve(json);           
        }  
                
    })    
  }

/**
 * Hàm này kiểm tra, tính toán tồn kho cho nguyên liệu theo thuật toán 60days lúc khởi động Desktop hoặc Mobile:
 * + Nếu nguyên liệu nào mà tháng gần nhất chưa tính thì hàm sẽ tính
 * + Nếu nguyên liệu mới thêm vào thì hàm sẽ tính
 * vhQueryCafe
 * @returns 
 */
private syncInventoryEveryDay_Stock1stDayOfMonth(){
  return new Promise<any>((resolve, reject) => {        
    let store = this.vhAuth.getStore();         
    //let branchs = this.getlocalBranchs();        
    let branchs = [{...this.getDefaultBranch()}];   
    this.vhMGDB_auth.getServerDate()
       .then((serverdate:any)=>{              
         //lấy các móc thời gian ngày 1 lúc 0h-0m-0s của các tháng trong khoản thời gian (store.registrationdate + 1) và (serverdate-1)
         let array60Days = this.get1stDayOfMonthArray(store.registrationdate, serverdate);//'2021-02-29T17:00:00.000Z'   
         let arrayNew60Days = this.get1stDayOfMonthArray(store.registrationdate, serverdate);     
         for(let m=arrayNew60Days.length-12; m>=0; m--){               
          //if((arrayNew60Days[m].getMonth() != 0)&&(arrayNew60Days[m].getMonth() != 6)) arrayNew60Days[m] = null;
         }           
         arrayNew60Days = arrayNew60Days.filter((e:any)=> e!=null);
         //console.log('---01 array60Days', array60Days);  
         //console.log('---02 arrayNew60Days', arrayNew60Days);   
         //Nếu không thỏa 60days sẽ ko tính inventory
         if(array60Days.length >0){                 
           let products = this.getlocalDetailProducts(3);           
           
           //for(let l=0; l<branchs.length; l++){
           let array_branch = new Array();
           for(let i=0; i<branchs.length; i++) array_branch.push(branchs[i]._id);    
           if(array_branch.length === 0) resolve(null); 
           let id_branch:any = array_branch.splice(0, 1)[0];               
           let loop_branch = true;
           let setinterval_branch = setInterval(async () => {
             if(loop_branch){
               loop_branch = false;               
               let query1 = {};
               let query2 = {};
               let counts_null = 0;
               let counts_nonull = 0;
               let bill_details_all:any = null;
               /*---------------------------------------------------------------------------------*/                                  
               /*Kiểm tra:
                 - trường date (products[m][id_branch + '_ivtr'][n].date) có tồn tại ko
                 - hoặc lý do nào đó mà giá trị trường date ko đúng giá trị chuẩn
                 - hoặc một phần tử nào đó trong mảng products[m][id_branch + '_ivtr'] không tồn tại trong array60Days
                 Nếu xảy ra thì gán bằng null để phần mềm cập nhật lại
                 Ghi chú: đoạn code này lọc bớt các trường hợp không thỏa mãn sẽ cho products[m][id_branch + '_ivtr'] = null, để phần code dưới đơn giản hơn dễ hiểu hơn
               */
               for(let m=0; m<products.length; m++){                        
                 if(products[m][id_branch + '_ivtr'] != undefined){
                   for(let n=0; n<products[m][id_branch + '_ivtr'].length; n++){   
                     let exist = false;                
                     for(let o =0;  o<array60Days.length; o++){  
                       if((new Date(products[m][id_branch + '_ivtr'][n].date)).getTime() == (new Date(array60Days[o])).getTime()){  
                         exist = true;
                         break;
                       }
                     }
                     if(!exist) {
                       console.log('Báo anh Huy hàm syncInventoryEveryDay_Stock1stDayOfMonth có lỗi 01');
                       products[m][id_branch + '_ivtr'] = null;
                       break;
                     }
                   }
                 }
               }
               
               /*------------------------------------------------------------------------------*/
               //Xác định 2 thời điểm quan trọng để getBill_details() về sẳn, (1) thời điểm đầu tháng mà product chưa có trường inventory, (2) thời điểm đầu tháng mà đã có trường inventory
               for(let m=0; m<products.length; m++){                        
                 if(products[m][id_branch + '_ivtr'] != undefined){
                   if((new Date(products[m][id_branch + '_ivtr'][products[m][id_branch + '_ivtr'].length -1].date)).getTime() < (new Date(array60Days[array60Days.length-1])).getTime()){   
                     counts_nonull++;
                   } 
                 }else{
                   counts_null++;
                 }
               }                 
               /*-----------------------------------------------------------------------------*/    
               //Nếu tất cả hoặc lượng lớn sản phẩm có trường (id_branch + '_ivtr') bằng null thì lấy về tất cả bill_detail (bill_details_all) 1 lần giúp việc tính toán nhanh hơn
               //Nếu chỉ có vài sản phẩm có trường (id_branch + '_ivtr') bằng null thì sau này tính toán đến sản phẩm nào lấy về bill_detail của sản phẩm đó để tính       
               if(((counts_nonull !=0)&&(counts_nonull === products.length))||(counts_nonull>=50)){                       
                 let promise_zero = new Array();                                                                                                                       
                 query1 = {date: {$gte: new Date(array60Days[array60Days.length-2]), $lt: new Date(array60Days[array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:id_branch}};   
                 query2 = {date: {$gte: new Date(array60Days[array60Days.length-2]), $lt: new Date(array60Days[array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}};   
                   
                 //Lấy về các bill_details của các tháng (chưa đc tính 60days) tiếp theo                                  
                 promise_zero[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                 promise_zero[1] = this.getBill_details_byFields(query2, {},{date:1},0);
                 await new Promise(resolve=>{                    
                   Promise.all(promise_zero)
                         .then((bill_details:any)=>{                               
                            bill_details_all = bill_details.flat();                                                   
                            resolve(null);
                         })
                 })                    
               }                                  
               let promise_branch = new Array();
               promise_branch[0] = new Promise(resolve=>{                                              
                   //let times = products.length;
                   let array_number = new Array();
                   for(let i=0; i<products.length; i++) array_number.push(i);                        
                   let loop_product = true; 
                   let array_10 = array_number.splice(0, 1);  
                   let setinterval_product = setInterval(() => {//mỗi lần kiểm tra và tính toán  thuật toán 60days cho 10 sản phẩm
                     if(loop_product){
                       loop_product = false;              
                           let promise_products = new Array();
                           //console.log('array_10', array_10); 
                           for(let i=array_10[0]; i<=array_10[array_10.length-1]; i++){   
                             promise_products[promise_products.length] = new Promise(resolve=>{                                      
                                 //Nếu trong product nào đó mà đã có trường inventory thì sẽ được tính toán và thêm vào những tháng gần nhất                    
                                 if(products[i][id_branch + '_ivtr'] != undefined){   
                                    //if(products[i]._id === 'LKJq7SCBYlbl2KErEKi3') 
                                    //console.log('---11', i, products[i][id_branch + '_ivtr']);  
                                    //inventory của tháng gần nhất đã tính theo 60days   
                                    const inventory = products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length -1];      
                                    //Kiểm tra trong inventory có tháng tiếp nào cần phải tính 60days ko, nếu có thì phải tính                                    
                                    if((new Date(inventory.date)).getTime() < (new Date(array60Days[array60Days.length-1])).getTime()){     
                                      let _array60Days = [...array60Days]; 
                                      //Tính lại và chỉ lấy các phần tử đầu của mảng _array60Days giống với tất cả các phẩn tử đang có trong mảng products[i][id_branch + '_ivtr']
                                      //Tìm vị trí cuối cùng của mảng products[i][id_branch + '_ivtr'] là vị trí nào trong mảng _array60Days
                                      let vitri = 0; 
                                      for (let m = 0; m < _array60Days.length; m++) {
                                       const currentDay = new Date(_array60Days[m]).getTime();
                                       const inventoryDay = new Date(inventory.date).getTime();                                      
                                       vitri++;                                      
                                       // Nếu ngày trùng khớp với ngày tồn kho thì dừng vòng lặp
                                       if (currentDay === inventoryDay) break;                                      
                                       // Kiểm tra xem ngày đó có tồn tại trong danh sách tồn kho chi nhánh không
                                       const hasData = products[i][id_branch + '_ivtr'].some((item:any) => {
                                         return new Date(item.date).getTime() === currentDay;
                                       });                                      
                                       // Nếu không tồn tại, loại bỏ ngày đó và giảm lại vị trí
                                       if (!hasData) {
                                         _array60Days[m] = null;
                                         vitri--;
                                       }
                                      }
                                      _array60Days = _array60Days.filter((e:any)=> e!=null);
                                      if(vitri>0){  
                                        //khởi tạo giá trị ban đầu (mặc định) cho inventory của các tháng tiếp theo mà thỏa 60days                                     
                                        for(let k= vitri; k <_array60Days.length; k++){
                                          products[i][id_branch + '_ivtr'][k] = {};
                                          products[i][id_branch + '_ivtr'][k].date = _array60Days[k];                                 
                                          products[i][id_branch + '_ivtr'][k].inquantity_tofirst = inventory.inquantity_tofirst;  //tổng SL nhập từ lúc dùng phần mềm đến cuối tháng trước
                                          products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = inventory.pay_tofirst_btax;      //tổng số tiền nhập hàng từ lúc dùng phần mềm đến cuối tháng trước
                                          products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = inventory.pay_tofirst_atax;
                                          products[i][id_branch + '_ivtr'][k].outquantity_tofirst = inventory.outquantity_tofirst;//tổng SL xuất từ lúc dùng phần mềm đến cuối tháng trước
                                          products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = inventory.sales_tofirst_btax;  //tổng số tiền xuất từ lúc dùng phần mềm đến cuối tháng trước
                                          products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = inventory.sales_tofirst_atax;

                                          products[i][id_branch + '_ivtr'][k].stock_first = 0;
                                          products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = 0;
                                          products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = 0;
                                          products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = 0;
                                          products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = 0;
                                          products[i][id_branch + '_ivtr'][k].profit_first_btax = 0;
                                          products[i][id_branch + '_ivtr'][k].profit_first_atax = 0;

                                          if(products[i].lots){
                                            products[i][id_branch + '_ivtr'][k].lots = new Array();
                                            for(let m=0; m<products[i].lots.length; m++){    
                                              products[i][id_branch + '_ivtr'][k].lots[m] = {};
                                              products[i][id_branch + '_ivtr'][k].lots[m]._id = products[i].lots[m]._id;

                                              products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = 0;
                                              products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = 0;
                                              products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = 0;
                                              products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = 0;

                                              products[i][id_branch + '_ivtr'][k].lots[m].stock_first = 0;
                                              products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = 0;
                                              products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = 0;
                                              products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = 0;

                                              //Nạp các giá của tháng trước vào tháng này, sau đó dựa vào bill_details để tính lại nó
                                              //Có kiểm tra qua _id, phòng trường hợp vị trí các lot này bị thay đổi thay đổi trong mảng lots
                                              for(let n=0; n<inventory.lots.length; n++){    
                                                if(products[i][id_branch + '_ivtr'][k].lots[m]._id === inventory.lots[n]._id){
                                                  products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = inventory.lots[n].inquantity_tofirst;  //tổng SL nhập từ lúc dùng phần mềm đến cuối tháng trước
                                                  products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = inventory.lots[n].pay_tofirst_btax;      //tổng số tiền nhập hàng từ lúc dùng phần mềm đến cuối tháng trước
                                                  products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = inventory.lots[n].pay_tofirst_atax;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = inventory.lots[n].outquantity_tofirst;//tổng SL xuất từ lúc dùng phần mềm đến cuối tháng trước
                                                  products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = inventory.lots[n].sales_tofirst_btax;  //tổng số tiền xuất từ lúc dùng phần mềm đến cuối tháng trước
                                                  products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = inventory.lots[n].sales_tofirst_atax;
                                                }
                                              }
                                            }                                                
                                          }
                                        }  
                                        
                                        let promise_one = new Array();                                
                                          //Nếu bill_details_all có dữ liệu và chỉ tháng gần nhất chưa cập nhật 60days thôi, còn nhiều tháng chưa cập nhật 60days thì get dữ liệu từng sản phẩm một về tính toán        
                                          if(bill_details_all && (_array60Days.length ==  vitri + 1)){                                       
                                            promise_one[0] = new Promise(resolve=>{
                                              let _bill_details = new Array();
                                              if(products[i].id_subproduct){  
                                                _bill_details = bill_details_all.filter((e:any)=>e.id_subproduct === products[i].id_subproduct);
                                              }else{
                                                _bill_details = bill_details_all.filter((e:any)=>e.id_product === products[i]._id);
                                              }                                                                                      
                                              resolve(_bill_details);                                           
                                            })
                                          }else{                                                                            
                                            if(products[i].id_subproduct){                                             
                                              query1 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}};   
                                              query2 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}};   
                                            }else{                                                       
                                              query1 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}};
                                              query2 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}};     
                                            }                                               
                                            //Lấy về các bill_details của các tháng (chưa đc tính 60days) tiếp theo                                  
                                            promise_one[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                                            promise_one[1] = this.getBill_details_byFields(query2, {},{date:1},0);                                         
                                          }
                                        Promise.all(promise_one)
                                            .then((bill_details:any)=>{                                                                          
                                              bill_details = bill_details.flat();                                                                                                                                                 
                                              if(bill_details.length >0){                                                                             
                                                for(let j=0; j<bill_details.length; j++){                                                                                         
                                                  for(let k= vitri; k <_array60Days.length; k++){                  
                                                    if((new Date(bill_details[j].date)).getTime() < (new Date(products[i][id_branch + '_ivtr'][k].date)).getTime()){                                                   
                                                        if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 54)){                                                     
                                                          if(products[i][id_branch + '_ivtr'][k].lots){
                                                            for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                              if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                                products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;                
                                                                products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                                products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                              }
                                                            }
                                                          }
                                                          products[i][id_branch + '_ivtr'][k].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;               
                                                          products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                          products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));

                                                        }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 16)||(bill_details[j].bill_type === 39)){                                                       
                                                          if(products[i][id_branch + '_ivtr'][k].lots)
                                                            for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                              if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                                products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                                products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                                products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                              }
                                                            }
                                                          products[i][id_branch + '_ivtr'][k].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                          products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                          products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                                                            
                                                        }                                   
                                                    }
                                                  }                                                                                 
                                                }
                                              }
                                                
                                              for(let k= vitri; k <_array60Days.length; k++){       
                                                if(products[i][id_branch + '_ivtr'][k].lots){
                                                  for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                    let _slnhaptrongky = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].inquantity_tofirst;
                                                    let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_btax;
                                                    let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_atax;
                                                    products[i][id_branch + '_ivtr'][k].lots[m].stock_first = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst;   
                                                    
                                                    if(_slnhaptrongky ===0){
                                                      products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_btax;
                                                      products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_atax;                                                              
                                                    }else{
                                                      if(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax ===0){
                                                        products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                        products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                      }else{
                                                        products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax) + _tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                        products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_atax) + _tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                      }
                                                    }
                                                    products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first; 
                                                    products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first;  

                                                    let _slbantrongky = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].outquantity_tofirst;
                                                    let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                    let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                    let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_btax;
                                                    let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_atax;
                                                    products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                    products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                  }    
                                                }                                     
                                                let slnhaptrongky = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].inquantity_tofirst;
                                                let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_btax;
                                                let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_atax;
                                                products[i][id_branch + '_ivtr'][k].stock_first = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].outquantity_tofirst;   
                                                                                                    
                                                if(slnhaptrongky ===0){
                                                  products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_btax;
                                                  products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_atax;
                                                }else{
                                                  if(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax === 0){                                                            
                                                    products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                    products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);                                                           
                                                  }else{
                                                    products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax) + tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                    products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_atax) + tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                  }
                                                }
                                                products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].stock_first; 
                                                products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].stock_first;  

                                                let slbantrongky = products[i][id_branch + '_ivtr'][k].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].outquantity_tofirst;
                                                let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * slbantrongky;
                                                let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * slbantrongky;
                                                let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_btax;
                                                let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_atax;
                                                products[i][id_branch + '_ivtr'][k].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                products[i][id_branch + '_ivtr'][k].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                              }       
                                
                                              /*let _length = products[i][id_branch + '_ivtr']?.length;
                                              for(let m=_length-12; m>=0; m--){
                                                let date = new Date(products[i][id_branch + '_ivtr'][m]?.date);
                                                if((date.getMonth() != 0)&&(date.getMonth() != 6)) products[i][id_branch + '_ivtr'][m] = null;
                                              }                                               
                                              products[i][id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'].filter((e:any)=> e!=null);   */                                            
                                              let value:any = {};  
                                              value[id_branch + '_ivtr'] = products[i][id_branch + '_ivtr']; 
                                              
                                              //cập nhật việc ký sinh tồn kho mới cho các tháng tiếp theo thỏa mãn 60days                                          
                                              this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                                  .then(()=>{                                                                                                                                                 
                                                    resolve(true);
                                                  })
                                            })  
                                      }else{
                                        //kiểm lại lại vt=0 là vô lý
                                        console.log(products[i]._id, 'có vt=0 là vô lý') ;                                    
                                        resolve(null); 
                                      }              
                                   }else{//các tháng đã thỏa 60days rồi ko cần tính nữa   
                                     //Đoạn code dưới này khi nào cần chạy thì bật lên vì rất khó xảy ra (xảy ra khi có người tác động vào dữ liệu), mà chạy hoài thì mỗi lần khởi động 
                                     //phần mềm tốn tài nguyên máy. Sau mỗi tháng cập nhật lại 60days cũng đã kiểm tra vụ này và sai dữ liệu sẽ bị cập nhật null để tính lại ở lần khởi động sau
                                     /*
                                     //Các tháng đã thỏa 60days rồi mà số phần tử trong  products[i][id_branch + '_ivtr'] và trong arrayNew60Days không khớp nhau về length và vị trí
                                     //thì dữ liệu này có thể đã bị sai do nhiều nguyên nhân (hoặc có người tác động vào dữ liệu), nên xóa đi để phần mềm tính toán lại ở lần chạy lại phần mềm tới.                       
                                     for(let n=0; n<arrayNew60Days.length; n++){   
                                       if((new Date(arrayNew60Days[n])).getTime() != (new Date(products[i][id_branch + '_ivtr'][n].date)).getTime()){  
                                         products[i][id_branch + '_ivtr'] = null;
                                         let value:any = {};  
                                         value[id_branch + '_ivtr'] = null;                                          
                                         //cập nhật null cho dữ liệu 60days, để lần khởi động tới giá trị này sẽ đc tính toán lại                                          
                                         this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                         break;
                                       }                                                  
                                     }*/           
                                    
                                     //Đoạn code này cũng giải quyết đc vấn đề trên, nhưng ít tốn tài nguyên máy khi khởi động phần mềm hơn
                                     if(products[i][id_branch + '_ivtr'].length != arrayNew60Days.length){
                                       products[i][id_branch + '_ivtr'] = null;
                                       let value:any = {};  
                                       value[id_branch + '_ivtr'] = null;                                          
                                       //cập nhật null cho dữ liệu 60days, để lần khởi động tới giá trị này sẽ đc tính toán lại                                          
                                       this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                           .then(()=>{                                                                                                                                                 
                                             resolve(null);
                                           })
                                     }else{
                                       resolve(null);
                                     }                                         
                                   }
                             //---------------------------------------------------------------------     
                                 //Nếu trong product nào đó mà chưa có trường inventory thì sẽ được tính toán và thêm vào từ lúc sài phần mềm đến những tháng gần nhất    
                                 }else{//Nếu trong product nào đó mà chưa có trường inventory thì sẽ được tính toán lại và thêm vô    
                                     //console.log('---21', i, products[i][id_branch + '_ivtr']);                                      
                                     let promise_two = new Array();
                                     if(products[i].id_subproduct){                        
                                       query1 = { ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}}; 
                                       query2 = { ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}}; 
                                     }else{                                        
                                       query1 = { ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}}; 
                                       query2 = { ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}}; 
                                     }                                        
                                     promise_two[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                                     promise_two[1] = this.getBill_details_byFields(query2, {},{date:1},0);
                                     Promise.all(promise_two)
                                         .then((bill_details:any)=>{                                             
                                           bill_details = bill_details.flat();                                            
                                           products[i][id_branch + '_ivtr'] = new Array();
                                           for(let k=0; k<array60Days.length; k++){    
                                             products[i][id_branch + '_ivtr'][k] = {};
                                             products[i][id_branch + '_ivtr'][k].date = array60Days[k];                                       
                                             products[i][id_branch + '_ivtr'][k].inquantity_tofirst = 0;
                                             products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = 0;
                                             products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = 0;
                                             products[i][id_branch + '_ivtr'][k].outquantity_tofirst = 0;
                                             products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = 0;
                                             products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = 0;

                                             products[i][id_branch + '_ivtr'][k].stock_first = 0;
                                             products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = 0;
                                             products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = 0;
                                             products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = 0;
                                             products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = 0;
                                             products[i][id_branch + '_ivtr'][k].profit_first_btax = 0;
                                             products[i][id_branch + '_ivtr'][k].profit_first_atax = 0;

                                             if(products[i].lots){
                                               products[i][id_branch + '_ivtr'][k].lots = new Array();
                                               for(let m=0; m<products[i].lots.length; m++){    
                                                 products[i][id_branch + '_ivtr'][k].lots[m] = {};
                                                 products[i][id_branch + '_ivtr'][k].lots[m]._id = products[i].lots[m]._id;
                                               }
                                               for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){    
                                                 products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = 0;
                                                 products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = 0;
                                                 products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = 0;
                                                 products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = 0;
                                                 products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = 0;
                                                 products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = 0;

                                                 products[i][id_branch + '_ivtr'][k].lots[m].stock_first = 0;
                                                 products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = 0;
                                                 products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = 0;
                                                 products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = 0;
                                                 products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = 0;
                                                 products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = 0;
                                                 products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = 0;

                                               }
                                             }
                                           }
                                           if(bill_details.length >0){
                                             for(let j=0; j<bill_details.length; j++){                                                                                     
                                               for(let k=0; k<products[i][id_branch + '_ivtr'].length; k++){                   
                                                 if((new Date(bill_details[j].date)).getTime() < (new Date(products[i][id_branch + '_ivtr'][k].date)).getTime()){                                                   
                                                     if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){ 
                                                       if(products[i][id_branch + '_ivtr'][k].lots){
                                                         for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                           if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                             products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;          
                                                             products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                             products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                           } 
                                                         } 
                                                       }                                                  
                                                       products[i][id_branch + '_ivtr'][k].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;          
                                                       products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                       products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity  * bill_details[j].ratio * (1 + bill_details[j].tax/100));
                                                       
                                                     }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 16)||(bill_details[j].bill_type === 39)){      
                                                       
                                                       if(products[i][id_branch + '_ivtr'][k].lots){
                                                       
                                                         for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                           
                                                           if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                             
                                                             products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                             products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                             products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                           }
                                                         }  
                                                       }  
                                                                                           
                                                       products[i][id_branch + '_ivtr'][k].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                       products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                       products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                                                         
                                                     }                                   
                                                 }
                                               }                                                                        
                                             }
                                             
                                             for(let k=0; k<products[i][id_branch + '_ivtr'].length; k++){  
                                               if(k===0){
                                                 if(products[i][id_branch + '_ivtr'][k].lots)
                                                   for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                     let _slnhaptrongky = products[i][id_branch + '_ivtr'][0].lots[m].inquantity_tofirst;
                                                     let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].pay_tofirst_btax;
                                                     let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].pay_tofirst_atax;
                                                     products[i][id_branch + '_ivtr'][0].lots[m].stock_first = products[i][id_branch + '_ivtr'][0].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][0].lots[m].outquantity_tofirst;   
                                                     
                                                     if(_slnhaptrongky !=0){
                                                       products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                       products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                       products[i][id_branch + '_ivtr'][0].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][0].lots[m].stock_first; 
                                                       products[i][id_branch + '_ivtr'][0].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][0].lots[m].stock_first;  
                                                     }
                                                     let _slbantrongky = products[i][id_branch + '_ivtr'][0].lots[m].outquantity_tofirst;
                                                     let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                     let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                     let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].sales_tofirst_btax;
                                                     let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].sales_tofirst_atax
                                                     products[i][id_branch + '_ivtr'][0].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                     products[i][id_branch + '_ivtr'][0].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                   }
                                                 let slnhaptrongky = products[i][id_branch + '_ivtr'][0].inquantity_tofirst;
                                                 let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][0].pay_tofirst_btax;
                                                 let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][0].pay_tofirst_atax;
                                                 products[i][id_branch + '_ivtr'][0].stock_first = products[i][id_branch + '_ivtr'][0].inquantity_tofirst - products[i][id_branch + '_ivtr'][0].outquantity_tofirst;   
                                                 
                                                 if(slnhaptrongky !=0){
                                                   products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                   products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);
                                                   products[i][id_branch + '_ivtr'][0].cost_stock_first_btax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][0].stock_first; 
                                                   products[i][id_branch + '_ivtr'][0].cost_stock_first_atax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][0].stock_first;  
                                                 }
                                                 let slbantrongky = products[i][id_branch + '_ivtr'][0].outquantity_tofirst;
                                                 let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax * slbantrongky;
                                                 let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax * slbantrongky;
                                                 let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][0].sales_tofirst_btax;
                                                 let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][0].sales_tofirst_atax
                                                 products[i][id_branch + '_ivtr'][0].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                 products[i][id_branch + '_ivtr'][0].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                               }else{
                                                 if(products[i][id_branch + '_ivtr'][k].lots){
                                                   for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                     let _slnhaptrongky = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].inquantity_tofirst;
                                                     let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_btax;
                                                     let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_atax;
                                                     products[i][id_branch + '_ivtr'][k].lots[m].stock_first = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst;   
                                                     
                                                     if(_slnhaptrongky ===0){
                                                       products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_btax;
                                                       products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_atax;                                                              
                                                     }else{
                                                       if(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax ===0){
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                       }else{
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax) + _tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_atax) + _tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                       }
                                                     }
                                                     products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first; 
                                                     products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first;  
                                                     let _slbantrongky = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].outquantity_tofirst;
                                                     let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                     let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                     let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_btax;
                                                     let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_atax;
                                                     products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                     products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                   }
                                                 }
                                                 let slnhaptrongky = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].inquantity_tofirst;
                                                 let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_btax;
                                                 let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_atax;
                                                 products[i][id_branch + '_ivtr'][k].stock_first = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].outquantity_tofirst;   
                                                 
                                                 if(slnhaptrongky ===0){
                                                   products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_btax;
                                                   products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_atax;
                                                 }else{
                                                   if(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax === 0){                                                            
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);                                                            
                                                   }else{
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax) + tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_atax) + tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                   }
                                                 }
                                                 products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].stock_first; 
                                                 products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].stock_first;  
                                                 
                                                 let slbantrongky = products[i][id_branch + '_ivtr'][k].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].outquantity_tofirst;
                                                 let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * slbantrongky;
                                                 let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * slbantrongky;
                                                 let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_btax;
                                                 let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_atax;
                                                 products[i][id_branch + '_ivtr'][k].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                 products[i][id_branch + '_ivtr'][k].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                               }
                                             }                                                                                                         
                                           }
                                          
                                           /*let _length = products[i][id_branch + '_ivtr']?.length;
                                           for(let m=_length-12; m>=0; m--){
                                             let date = new Date(products[i][id_branch + '_ivtr'][m]?.date);
                                             if((date.getMonth() != 0)&&(date.getMonth() != 6)) products[i][id_branch + '_ivtr'][m] = null;
                                           }                                                 
                                           products[i][id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'].filter((e:any)=> e!=null)*/ 
                                           let value:any = {};  
                                           value[id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'];
                                            this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                               .then(()=>{                                                                                                                                                                                                  
                                                 resolve(true);
                                               })                                      
                                       })
                                 }                                         
                             })                                    
                           }
                         
                           Promise.all(promise_products).then(array_products=>{                                                                          
                             if(array_number.length>0){                                      
                               loop_product = true;    
                               array_10 = array_number.splice(0, 1);  
                             }else{                                      
                               resolve(null);
                               clearInterval(setinterval_product);                                      
                             }            
                           })                                   
                     }
                   },10)
               })
               Promise.all(promise_branch).then(()=>{                                       
                 if(array_branch.length>0){                                      
                   loop_branch = true;    
                   id_branch = array_branch.splice(0, 1)[0];  
                 }else{                      
                   clearInterval(setinterval_branch);  
                   console.log('syncInventoryEveryDay_Stock1stDayOfMonth1');       
                   resolve(null);                                      
                 }    
               })  
             }
           },500);             
         }else{
           console.log('syncInventoryEveryDay_Stock1stDayOfMonth2');    
           resolve(null);   
         }
       })
       resolve(null); 
  })   
}
  private syncInventoryEveryDay_Stock1stDayOfMonth_old(){
    return new Promise<any>((resolve, reject) => {        
      let store = this.vhAuth.getStore();         
      //let branchs = this.getlocalBranchs();        
      let branchs = [{...this.getDefaultBranch()}];   
      //console.log('--------------branchs', branchs); 
      this.vhMGDB_auth.getServerDate()
            .then((serverdate:any)=>{              
              //lấy các móc thời gian ngày 1 lúc 0h-0m-0s của các tháng trong khoản thời gian (store.registrationdate + 1) và (serverdate-1)
              let DayArray = this.get1stDayOfMonthArray(store.registrationdate, serverdate);//'2021-02-29T17:00:00.000Z'                   
              //console.log('DayArray', DayArray);
              if(DayArray.length >0){                    
                let promise_branch = new Array();
                for(let l=0; l<branchs.length; l++){
                  promise_branch[l] = new Promise(resolve=>{
                          let id_branch = branchs[l]._id; 
                          let products = this.getlocalDetailProducts(3);
                          //console.log('products', products); 
                          let times = products.length;
                          let array_number = new Array();
                          for(let i=0; i<products.length; i++) array_number.push(i);                        
                          let loop = true; 
                          let array_10 = array_number.splice(0, 10);  
                          let setinterval = setInterval(() => {//mỗi lần kiểm tra và tính toán  thuật toán 60days cho 10 sản phẩm
                            if(loop){
                              loop = false;              
                                  let promise_products = new Array();
                                  //console.log('array_10', array_10); 
                                  for(let i=array_10[0]; i<=array_10[array_10.length-1]; i++){   
                                    promise_products[promise_products.length] = new Promise(resolve=>{  
                                      //console.log(i,'--------0products[i]', products[i]);                    
                                        //Nếu trong product nào đó mà đã có trường inventory thì sẽ được tính toán và thêm vào những tháng gần nhất                    
                                        if(products[i][id_branch + '_ivtr'] !=undefined){   
                                          //console.log(i,'--------1products[i]', products[i]);     
                                          const inventory = products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length -1];  
                                          const length = products[i][id_branch + '_ivtr'].length;                                           
                                          if((new Date(inventory.date)).getTime() < (new Date(DayArray[DayArray.length-1])).getTime()){                                           
                                            for(let k= length; k <DayArray.length; k++){
                                              products[i][id_branch + '_ivtr'][k] = {};
                                              products[i][id_branch + '_ivtr'][k].date = DayArray[k];                                 
                                              products[i][id_branch + '_ivtr'][k].inquantity_tofirst = inventory.inquantity_tofirst;  //tổng SL nhập từ lúc dùng phần mềm đến cuối tháng trước
                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = inventory.pay_tofirst_btax;      //tổng số tiền nhập hàng từ lúc dùng phần mềm đến cuối tháng trước
                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = inventory.pay_tofirst_atax;
                                              products[i][id_branch + '_ivtr'][k].outquantity_tofirst = inventory.outquantity_tofirst;//tổng SL xuất từ lúc dùng phần mềm đến cuối tháng trước
                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = inventory.sales_tofirst_btax;  //tổng số tiền xuất từ lúc dùng phần mềm đến cuối tháng trước
                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = inventory.sales_tofirst_atax;

                                              products[i][id_branch + '_ivtr'][k].stock_first = 0;
                                              products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = 0;
                                              products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = 0;
                                              products[i][id_branch + '_ivtr'][k].profit_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].profit_first_atax = 0;

                                              if(products[i].lots){
                                                products[i][id_branch + '_ivtr'][k].lots = new Array();
                                                for(let m=0; m<products[i].lots.length; m++){    
                                                  products[i][id_branch + '_ivtr'][k].lots[m] = {};
                                                  products[i][id_branch + '_ivtr'][k].lots[m]._id = products[i].lots[m]._id;
                                                }
                                                for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){    
                                                  products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = 0;

                                                  products[i][id_branch + '_ivtr'][k].lots[m].stock_first = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = 0;

                                                }
                                              }
                                            }                                             
                                            
                                            let query1 = {};
                                            let query2 = {};
                                            let promise_query = new Array();
                                            if(products[i].id_subproduct){ 
                                              query1 = {date: {$gte: new Date(inventory.date), $lte: new Date(DayArray[DayArray.length-1])}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}};   
                                              query2 = {date: {$gte: new Date(inventory.date), $lte: new Date(DayArray[DayArray.length-1])}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}};   
                                            }else{                          
                                              query1 = {date: {$gte: new Date(inventory.date), $lte: new Date(DayArray[DayArray.length-1])}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}};
                                              query2 = {date: {$gte: new Date(inventory.date), $lte: new Date(DayArray[DayArray.length-1])}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}};     
                                            }                                       
                                            promise_query[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                                            promise_query[1] = this.getBill_details_byFields(query2, {},{date:1},0);
                                            Promise.all(promise_query)
                                                .then((bill_details:any)=>{ 
                                                  bill_details = bill_details.flat();                                                                                                          
                                                  if(bill_details.length >0){                                                                             
                                                    for(let j=0; j<bill_details.length; j++){                                                                                         
                                                      for(let k= length; k <DayArray.length; k++){                  
                                                        if((new Date(bill_details[j].date)).getTime() < (new Date(products[i][id_branch + '_ivtr'][k].date)).getTime()){                                                   
                                                            if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){                                                     
                                                              if(products[i][id_branch + '_ivtr'][k].lots){
                                                                for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                                  if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;                
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                  }
                                                                }
                                                              }
                                                              products[i][id_branch + '_ivtr'][k].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;               
                                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));

                                                            }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 16)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){                                                       
                                                              if(products[i][id_branch + '_ivtr'][k].lots)
                                                                for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                                  if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                  }
                                                                }
                                                              products[i][id_branch + '_ivtr'][k].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                                                                
                                                            }                                   
                                                        }
                                                      }                                                                                 
                                                    }
                                                  }
                                                    
                                                  for(let k= length; k <DayArray.length; k++){       
                                                    if(products[i][id_branch + '_ivtr'][k].lots){
                                                      for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                        let _slnhaptrongky = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].inquantity_tofirst;
                                                        let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_btax;
                                                        let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_atax;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].stock_first = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst;   
                                                        
                                                        if(_slnhaptrongky ===0){
                                                          products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_btax;
                                                          products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_atax;                                                              
                                                        }else{
                                                          if(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax ===0){
                                                            products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                            products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                          }else{
                                                            products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax) + _tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                            products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_atax) + _tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                          }
                                                        }
                                                        products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first; 
                                                        products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first;  

                                                        let _slbantrongky = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].outquantity_tofirst;
                                                        let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                        let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                        let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_btax;
                                                        let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_atax;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                      }    
                                                    }                                     
                                                    let slnhaptrongky = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].inquantity_tofirst;
                                                    let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_btax;
                                                    let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_atax;
                                                    products[i][id_branch + '_ivtr'][k].stock_first = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].outquantity_tofirst;   
                                                                                                        
                                                    if(slnhaptrongky ===0){
                                                      products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_btax;
                                                      products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_atax;
                                                    }else{
                                                      if(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax === 0){                                                            
                                                        products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                        products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);                                                            
                                                      }else{
                                                        products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax) + tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                        products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_atax) + tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                      }
                                                    }
                                                    products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].stock_first; 
                                                    products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].stock_first;  

                                                    let slbantrongky = products[i][id_branch + '_ivtr'][k].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].outquantity_tofirst;
                                                    let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * slbantrongky;
                                                    let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * slbantrongky;
                                                    let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_btax;
                                                    let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_atax;
                                                    products[i][id_branch + '_ivtr'][k].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                    products[i][id_branch + '_ivtr'][k].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                                  }                                                                     
                                            
                                                  times--;
                                                  //let _product = this.getlocalProduct(products[i]._id);  
                                                  let value:any = {};  
                                                  value[id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'];                                              
                                                  this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                                      .then(()=>{
                                                        //console.log(i, products[i]);                                                       
                                                        resolve(true);
                                                      })
                                                })             
                                          }else{
                                            //console.log(i, null);   
                                            resolve(null); 
                                          }
                           //---------------------------------------------------------------------     
                                        //Nếu trong product nào đó mà chưa có trường inventory thì sẽ được tính toán và thêm vào từ lúc sài phần mềm đến những tháng gần nhất    
                                        }else{//Nếu trong product nào đó mà chưa có trường inventory thì sẽ được tính toán lại và thêm vô                                         
                                          //console.log(i,'--------2products[i]', products[i]); 
                                          let query1 = {};
                                          let query2 = {};
                                          let promise_query = new Array();
                                          if(products[i].id_subproduct){
                                            query1 = { ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}}; 
                                            query2 = { ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}}; 
                                          }else{
                                            query1 = { ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}}; 
                                            query2 = { ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}}; 
                                          } 
                                          
                                          promise_query[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                                          promise_query[1] = this.getBill_details_byFields(query2, {},{date:1},0);
                                          Promise.all(promise_query)
                                                .then((bill_details:any)=>{ 
                                                  bill_details = bill_details.flat();                                                              
                                                  products[i][id_branch] = {};
                                                  products[i][id_branch + '_ivtr'] = new Array();
                                                  for(let k=0; k<DayArray.length; k++){    
                                                    products[i][id_branch + '_ivtr'][k] = {};
                                                    products[i][id_branch + '_ivtr'][k].date = DayArray[k];                                       
                                                    products[i][id_branch + '_ivtr'][k].inquantity_tofirst = 0;
                                                    products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = 0;
                                                    products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = 0;
                                                    products[i][id_branch + '_ivtr'][k].outquantity_tofirst = 0;
                                                    products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = 0;
                                                    products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = 0;

                                                    products[i][id_branch + '_ivtr'][k].stock_first = 0;
                                                    products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = 0;
                                                    products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = 0;
                                                    products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = 0;
                                                    products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = 0;
                                                    products[i][id_branch + '_ivtr'][k].profit_first_btax = 0;
                                                    products[i][id_branch + '_ivtr'][k].profit_first_atax = 0;

                                                    if(products[i].lots){
                                                      products[i][id_branch + '_ivtr'][k].lots = new Array();
                                                      for(let m=0; m<products[i].lots.length; m++){    
                                                        products[i][id_branch + '_ivtr'][k].lots[m] = {};
                                                        products[i][id_branch + '_ivtr'][k].lots[m]._id = products[i].lots[m]._id;
                                                      }
                                                      for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){    
                                                        products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = 0;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = 0;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = 0;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = 0;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = 0;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = 0;

                                                        products[i][id_branch + '_ivtr'][k].lots[m].stock_first = 0;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = 0;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = 0;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = 0;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = 0;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = 0;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = 0;

                                                      }
                                                    }
                                                  }
                                                  if(bill_details.length >0){
                                                    for(let j=0; j<bill_details.length; j++){                                                                                     
                                                      for(let k=0; k<products[i][id_branch + '_ivtr'].length; k++){                   
                                                        if((new Date(bill_details[j].date)).getTime() < (new Date(products[i][id_branch + '_ivtr'][k].date)).getTime()){                                                   
                                                            if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){ 
                                                              if(products[i][id_branch + '_ivtr'][k].lots){
                                                                for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                                  if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;          
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                  } 
                                                                } 
                                                              }                                                  
                                                              products[i][id_branch + '_ivtr'][k].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;          
                                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity  * bill_details[j].ratio * (1 + bill_details[j].tax/100));

                                                            }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 16)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){      
                                                              
                                                              if(products[i][id_branch + '_ivtr'][k].lots){
                                                              
                                                                for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                                  
                                                                  if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                                    
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                                    products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                  }
                                                                }  
                                                              }  
                                                                                                  
                                                              products[i][id_branch + '_ivtr'][k].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                                                                
                                                            }                                   
                                                        }
                                                      }                                                                        
                                                    }
                                                    
                                                    for(let k=0; k<products[i][id_branch + '_ivtr'].length; k++){  
                                                      if(k===0){
                                                        if(products[i][id_branch + '_ivtr'][k].lots)
                                                          for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                            let _slnhaptrongky = products[i][id_branch + '_ivtr'][0].lots[m].inquantity_tofirst;
                                                            let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].pay_tofirst_btax;
                                                            let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].pay_tofirst_atax;
                                                            products[i][id_branch + '_ivtr'][0].lots[m].stock_first = products[i][id_branch + '_ivtr'][0].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][0].lots[m].outquantity_tofirst;   
                                                            
                                                            if(_slnhaptrongky !=0){
                                                              products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                              products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                              products[i][id_branch + '_ivtr'][0].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][0].lots[m].stock_first; 
                                                              products[i][id_branch + '_ivtr'][0].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][0].lots[m].stock_first;  
                                                            }
                                                            let _slbantrongky = products[i][id_branch + '_ivtr'][0].lots[m].outquantity_tofirst;
                                                            let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                            let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                            let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].sales_tofirst_btax;
                                                            let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].sales_tofirst_atax
                                                            products[i][id_branch + '_ivtr'][0].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                            products[i][id_branch + '_ivtr'][0].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                          }
                                                        let slnhaptrongky = products[i][id_branch + '_ivtr'][0].inquantity_tofirst;
                                                        let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][0].pay_tofirst_btax;
                                                        let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][0].pay_tofirst_atax;
                                                        products[i][id_branch + '_ivtr'][0].stock_first = products[i][id_branch + '_ivtr'][0].inquantity_tofirst - products[i][id_branch + '_ivtr'][0].outquantity_tofirst;   
                                                        
                                                        if(slnhaptrongky !=0){
                                                          products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                          products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);
                                                          products[i][id_branch + '_ivtr'][0].cost_stock_first_btax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][0].stock_first; 
                                                          products[i][id_branch + '_ivtr'][0].cost_stock_first_atax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][0].stock_first;  
                                                        }
                                                        let slbantrongky = products[i][id_branch + '_ivtr'][0].outquantity_tofirst;
                                                        let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax * slbantrongky;
                                                        let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax * slbantrongky;
                                                        let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][0].sales_tofirst_btax;
                                                        let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][0].sales_tofirst_atax
                                                        products[i][id_branch + '_ivtr'][0].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                        products[i][id_branch + '_ivtr'][0].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                                      }else{
                                                        if(products[i][id_branch + '_ivtr'][k].lots){
                                                          for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                            let _slnhaptrongky = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].inquantity_tofirst;
                                                            let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_btax;
                                                            let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_atax;
                                                            products[i][id_branch + '_ivtr'][k].lots[m].stock_first = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst;   
                                                            
                                                            if(_slnhaptrongky ===0){
                                                              products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_btax;
                                                              products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_atax;                                                              
                                                            }else{
                                                              if(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax ===0){
                                                                products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                                products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                              }else{
                                                                products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax) + _tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                                products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_atax) + _tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                              }
                                                            }
                                                            products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first; 
                                                            products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first;  
                                                            let _slbantrongky = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].outquantity_tofirst;
                                                            let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                            let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                            let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_btax;
                                                            let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_atax;
                                                            products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                            products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                          }
                                                        }
                                                        let slnhaptrongky = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].inquantity_tofirst;
                                                        let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_btax;
                                                        let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_atax;
                                                        products[i][id_branch + '_ivtr'][k].stock_first = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].outquantity_tofirst;   
                                                        
                                                        if(slnhaptrongky ===0){
                                                          products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_btax;
                                                          products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_atax;
                                                        }else{
                                                          if(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax === 0){                                                            
                                                            products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                            products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);                                                            
                                                          }else{
                                                            products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax) + tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                            products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_atax) + tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                          }
                                                        }
                                                        products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].stock_first; 
                                                        products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].stock_first;  
                                                        
                                                        let slbantrongky = products[i][id_branch + '_ivtr'][k].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].outquantity_tofirst;
                                                        let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * slbantrongky;
                                                        let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * slbantrongky;
                                                        let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_btax;
                                                        let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_atax;
                                                        products[i][id_branch + '_ivtr'][k].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                        products[i][id_branch + '_ivtr'][k].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                                      }
                                                    }                                                                                                         
                                                  }
                                                  //console.log('i2');
                                                  //console.log(i, products[i]);
                                                  //resolve(products[i]);
                                                  times--;
                                                  //let _product = this.getlocalProduct(products[i]._id);  
                                                  let value:any = {};                                        
                                                  value[id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'];   
                                                  //console.log('--------value', value);                                             
                                                  this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                                      .then(()=>{
                                                        //console.log(i, products[i]);                                                     
                                                        resolve(true);
                                                      })
                                              })
                                        }                                         
                                    })                                    
                                  }
                                
                                  Promise.all(promise_products).then(array_products=>{                                                            
                                    if(times <=0){
                                      resolve(l);
                                      clearInterval(setinterval);  
                                    }
                                                          
                                    if(array_number.length>0){                                      
                                      loop = true;    
                                      array_10 = array_number.splice(0, 10);  
                                    }else{                                      
                                      resolve(l);
                                      clearInterval(setinterval);                                      
                                    }            
                                  })                                   
                            }
                          },10)
                  })
                }
                Promise.all(promise_branch).then(array_branch=>{  
                  //console.log('syncInventoryEveryDay_Stock1stDayOfMonth', array_branch);    
                  resolve(null);   
                })                              
              }else{
                //console.log('syncInventoryEveryDay_Stock1stDayOfMonth');    
                resolve(null);   
              }
            })
    })   
  }
 
  /**   
   * Hàm này dùng trong page Tồn kho, giá trị tồn kho NGUYÊN LIỆU (type=3), doanh số, chi phí nhập hàng tại một thời điểm endtime nào đó
   * @example:
   * this.vhQueryCafe.getReportInputOutputInventory_byEndTime_byIDMaterial(endtime, 'all')
        .then((bill_details:any)=>{
          console.log('vhs_bill_details_', bill_details);
        })
   * @param starttime 
   * @param endtime 
   * @param IDsub_or_product : 'all' or id_subproduct or id_product 
   * @param IDbranch : 'all' or id_branch
   * @return Promise Array
   * @Notice bill_type = [1,10,30,2,9,16,31]
   */
   public getReportInputOutputInventory_byEndTime_byIDMaterial(endtime:any, IDsub_or_product:any, IDbranch:string){
     //console.log('endtime', endtime);
     return new Promise<any>((resolve, reject) => {  
       endtime = new Date(endtime);      
       let json:any = {
         docs: new Array(),
         empty: true,
         size:0 
       }         
       let store = this.vhAuth.getStore();  
       let products:any = new Array();   
       if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
       else {
         let product = this.getlocalDetailProduct(IDsub_or_product);            
         products.push(product);
       }
 
       let cash = 0;
       let index:any = null;
       let day:any = null;      
       this.checkAndsyncInventoryOfMaterials(products, IDbranch)
         .then((check)=>{                
             if(check){
               if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
               else {
                 let product = this.getlocalDetailProduct(IDsub_or_product);            
                 products.push(product);
               }
             }
             if(IDbranch==='all'){//ok
               console.log('trường hợp này chưa có hàm, liên hệ anh Huy viết');
               //Để trường hợp IDbranch === 'all' chạy đúng thì phải tổng các giá trị tồn kho của tất cả các chi nhánh lại
               // hoặc là cách tính từng chi nhánh, rồi merge tất cả các chi nhánh lại
               return resolve(json);   
             }else{//ok         
               if(products[0][IDbranch + '_ivtr'] != undefined){
                 for(let k=0; k<products[0][IDbranch + '_ivtr'].length; k++){              
                   if((new Date(products[0][IDbranch + '_ivtr'][k].date)).getTime() > endtime.getTime()){               
                     break;
                   }else{
                     day = new Date(products[0][IDbranch + '_ivtr'][k].date);
                     index = k;                
                   }
                 }                 
               }               
             }        
             if(!day) day = new Date(store.registrationdate);                     
             if(products.length>0){            
               //nhớ kiểm tra có cần thêm sắp xếp asc ko             
               let query1:any = {};
               let query2:any = {};           
               let promise = new Array();
             
               if(IDsub_or_product === 'all'){
                 if(IDbranch === 'all'){//ở trên cho return rồi
                   query1 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}}; 
                   query2 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}};              
                 }else{
                   query1 = {date: {$gte:new Date(day), $lte:new Date(endtime)}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:IDbranch}};             
                   query2 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                 }            
               }else{        
                 if(IDbranch === 'all'){//ở trên cho return rồi                     
                   if(products[0].id_subproduct) {
                     query1 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}};
                     query2 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};
                   }else{
                     query1 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}};
                     query2 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};
                   }
                 }else{                       
                   if(products[0].id_subproduct){
                     query1 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:IDbranch}};
                     query2 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                   }else{
                     query1 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,54,2,9,16,39]}, id_branch: {$eq:IDbranch}};
                     query2 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                   }
                 }               
               }  
               promise[0] = this.getBill_details_byFields(query1, {},{date:1},0);
               promise[1] = this.getBill_details_byFields(query2, {},{date:1},0);
               let query_lastday = {date: {$gte:endtime}, ptype: {$eq:3}};  
               console.log('query_lastday', query_lastday)  
               promise[2] = this.getBill_details_byFields(query_lastday, {},{date:1},1);
               Promise.all(promise)
                     .then((array:any)=>{    
                       console.log('array', array)      
                       let bill_details = [...array[0], ...array[1]];// nhớ check xem cái này chạy đúng ko          
                       let array_lastday = array[2];                  
                       for(let i=0; i<products.length; i++){
                         //console.log(products[i]._id, products[i]);
                 //        if((products[i][IDbranch] != undefined)&&(products[i][IDbranch + '_ivtr'] != undefined)){
                           //console.log('id qua',products[i]._id);
                           let first = {
                             stock_first: 0,
                             cost_stock_first_btax: 0,
                             cost_stock_first_atax: 0                      
                           }
                           let unit = this.getUnit_byRatio(products[i].units, 1);                          
                           let record: any ={
                             id_product: products[i]._id,
                             name: products[i].name,
                             type: products[i].type,
                             img: products[i].img,
                             allow_sell: products[i].allow_sell,                       
                             quantity_branch: products[i].quantity_branch,

                             ratio: unit.ratio,
                             unit: unit.unit,
                             barcode: unit.barcode,                      
                             
                             outquantity: 0,
                             inquantity: 0, 
                             
                             cost_btax: 0,     
                             cost_atax: 0,
                             unit_cost_stock_last_btax: 0,   
                             unit_cost_stock_last_atax: 0,  

                             stock_first: 0,                      
                             cost_stock_first_btax: 0,   
                             cost_stock_first_atax: 0,   

                             stock_last: 0,                          
                             cost_stock_last_btax: 0,   
                             cost_stock_last_atax: 0       
                           }      
                           
                           if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct; 
                           if(products[i].lots) {
                             //record.lots = [...products[i].lots];
                             record.lots = cloneDeep(products[i].lots);
                             for(let m = 0; m<record.lots.length; m++){
                               record.lots[m].outquantity = 0;
                               record.lots[m].inquantity = 0;

                               record.lots[m].cost_btax = 0;
                               record.lots[m].cost_atax = 0;
                               record.lots[m].unit_cost_stock_last_btax = 0;
                               record.lots[m].unit_cost_stock_last_atax = 0;
                               //tồn đầu kỳ
                               record.lots[m].stock_first = 0;
                               record.lots[m].cost_stock_first_btax = 0;
                               record.lots[m].cost_stock_first_atax = 0;
                               //tồn cuối kỳ
                               record.lots[m].stock_last = 0;
                               record.lots[m].cost_stock_last_btax = 0;
                               record.lots[m].cost_stock_last_atax = 0;

                               record.lots[m].first = {};
                               record.lots[m].first.stock_first = 0,
                               record.lots[m].first.cost_stock_first_btax = 0,
                               record.lots[m].first.cost_stock_first_atax = 0
                             }
                           }                                           
                           
                           for(let j=0; j<bill_details.length; j++){ 
                             let is_sub_or_product = false;
                             if(record.id_subproduct) is_sub_or_product = bill_details[j].id_subproduct === record.id_subproduct;
                             else is_sub_or_product = bill_details[j].id_product === record.id_product;                            
                             if(bill_details[j].ptype === 3){  
                               if(is_sub_or_product){  
                                 let date = new Date(bill_details[j].date); 
                                 if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                                   if(record.lots){
                                     for(let m=0; m<record.lots.length; m++){
                                       if(record.lots[m]._id === bill_details[j].id_lotproduct){     
                                         record.lots[m].outquantity = record.lots[m].outquantity + bill_details[j].quantity * bill_details[j].ratio;     
                                       }
                                     }
                                   }
                                   record.outquantity = record.outquantity + bill_details[j].quantity * bill_details[j].ratio;                             

                                 }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 16)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){    
                                   if(record.lots){
                                     for(let m=0; m<record.lots.length; m++){
                                       if(record.lots[m]._id === bill_details[j].id_lotproduct){     
                                         record.lots[m].cost_btax = record.lots[m].cost_btax + bill_details[j].price * bill_details[j].quantity;
                                         record.lots[m].cost_atax = record.lots[m].cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                         record.lots[m].inquantity = record.lots[m].inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                                       }
                                     }
                                   }                         
                                   record.cost_btax = record.cost_btax + bill_details[j].price * bill_details[j].quantity;
                                   record.cost_atax = record.cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                   record.inquantity = record.inquantity + bill_details[j].quantity * bill_details[j].ratio; 

                                 }else if(bill_details[j].bill_type === 9){//bill_type_9 là tồn đầu kỳ, ko xem nó là hàng nhập như báo cáo trước đây
                                   if(record.lots){
                                     for(let m=0; m<record.lots.length; m++){
                                       if(record.lots[m]._id === bill_details[j].id_lotproduct){     
                                         record.lots[m].first.stock_first = record.lots[m].first.stock_first + bill_details[j].quantity * bill_details[j].ratio;
                                         record.lots[m].first.cost_stock_first_btax = record.lots[m].first.cost_stock_first_btax + bill_details[j].price * bill_details[j].quantity;
                                         record.lots[m].first.cost_stock_first_atax = record.lots[m].first.cost_stock_first_atax +  bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);      
                                       }
                                     }
                                   }
                                   first.stock_first = first.stock_first + bill_details[j].quantity * bill_details[j].ratio;
                                   first.cost_stock_first_btax = first.cost_stock_first_btax + bill_details[j].price * bill_details[j].quantity;
                                   first.cost_stock_first_atax = first.cost_stock_first_atax +  bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);   
                                 }                                                        
                               } 
                             }                                    
                           }                  

                           if(record.lots){
                             for(let m=0; m<record.lots.length; m++){                       
                               //Đầu kỳ                                                
                               if(index !=null) record.lots[m].first = {...products[i][IDbranch + '_ivtr'][index].lots[m]};                                   
                               record.lots[m].stock_first = record.lots[m].first.stock_first;//ok    
                               record.lots[m].cost_stock_first_btax = record.lots[m].first.cost_stock_first_btax;
                               record.lots[m].cost_stock_first_atax = record.lots[m].first.cost_stock_first_atax;                         
                             
                               //Đơn giá
                               if((record.lots[m].stock_first + record.lots[m].inquantity) !=0){
                                 record.lots[m].unit_cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals((record.lots[m].cost_stock_first_btax + record.lots[m].cost_btax)/(record.lots[m].stock_first + record.lots[m].inquantity)); 
                                 record.lots[m].unit_cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals((record.lots[m].cost_stock_first_atax + record.lots[m].cost_atax)/(record.lots[m].stock_first + record.lots[m].inquantity)); 
                               }

                               //Cuối kỳ
                               record.lots[m].stock_last = record.lots[m].stock_first + record.lots[m].inquantity - record.lots[m].outquantity;//ok   
                               record.lots[m].cost_stock_last_btax = record.lots[m].unit_cost_stock_last_btax * record.lots[m].stock_last;  
                               record.lots[m].cost_stock_last_atax = record.lots[m].unit_cost_stock_last_atax * record.lots[m].stock_last;                         
                             }
                           }
                           
                           //Đầu kỳ
                           if(index !=null) first = {...products[i][IDbranch + '_ivtr'][index]};                                     
                           record.stock_first = first.stock_first;//ok    
                           record.cost_stock_first_btax = first.cost_stock_first_btax;
                           record.cost_stock_first_atax = first.cost_stock_first_atax;                         
                         
                           //Đơn giá
                           if((record.stock_first + record.inquantity) !=0){
                             record.unit_cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals((record.cost_stock_first_btax + record.cost_btax)/(record.stock_first + record.inquantity)); 
                             record.unit_cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals((record.cost_stock_first_atax + record.cost_atax)/(record.stock_first + record.inquantity)); 
                           }

                           //Cuối kỳ
                           record.stock_last = record.stock_first + record.inquantity - record.outquantity;//ok   
                           record.cost_stock_last_btax = record.unit_cost_stock_last_btax * record.stock_last;  
                           record.cost_stock_last_atax = record.unit_cost_stock_last_atax * record.stock_last;                              

                           //if((record.stock_first !=0)||(record.stock_last !=0)||(record.inquantity !=0)||(record.outquantity !=0)){                      
                           record.cost_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_atax);    
                           record.cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_stock_first_atax);     
                           record.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_stock_last_atax);   

                           record.index = json.size + 1;
                           json.docs.push(record);
                           json.size++;                        
                           json.empty = false;   

                           //Phần dưới này sẽ so sánh nếu sản phẩm tồn kho tính được khác với tồn kho trên sản phẩm thì cập nhật lại tồn kho sản phẩm = tồn kho tính được
                           if(array_lastday.length === 0){
                             let wrong_quantity = false;
                             let value:any = {};                             
                             if(products[i].quantity_branch != undefined){
                               if(products[i].quantity_branch[IDbranch] != undefined){
                                 value = {
                                   quantity_branch: {...products[i].quantity_branch},
                                   quantity: products[i].quantity
                                 };                          
                               }else{
                                 value = {
                                   quantity_branch: {...products[i].quantity_branch},
                                   quantity: 0                              
                                 };
                                 value.quantity_branch[IDbranch] = 0;                          
                                 for(const p in value.quantity_branch){
                                   value.quantity = value.quantity + value.quantity_branch[p];
                                 } 
                                 wrong_quantity = true;                              
                               }
                             }else{
                               value = {
                                 quantity_branch: {},
                                 quantity: 0                              
                               };                          
                               value.quantity_branch[IDbranch] = 0;      
                               wrong_quantity = true;                                                         
                             }

                             if(value.quantity_branch[IDbranch] != record.stock_last){                         
                               value.quantity_branch[IDbranch] = record.stock_last;
                               value.quantity = 0;
                               for(const p in value.quantity_branch){
                                 value.quantity = value.quantity + value.quantity_branch[p];
                               }                  
                               wrong_quantity = true;       
                             }else{
                               let quantity = 0;
                               for(const p in value.quantity_branch){
                                 quantity = quantity + value.quantity_branch[p];
                               }  
                               if(value.quantity != quantity){
                                 value.quantity = quantity;
                                 wrong_quantity = true; 
                               }
                             }

                             if(products[i].lots){                             
                               value.lots = cloneDeep(products[i].lots);
                               for(let k=0; k<value.lots.length; k++){
                                 if(value.lots[k].quantity_branch == undefined){
                                   value.lots[k].quantity_branch = {};
                                   value.lots[k].quantity_branch[IDbranch] = 0;
                                   value.lots[k].quantity = 0;
                                   wrong_quantity = true;
                                 }
                                 if(value.lots[k].quantity_branch[IDbranch] != record.lots[k].stock_last){                                
                                   value.lots[k].quantity_branch[IDbranch] = record.lots[k].stock_last;
                                   value.lots[k].quantity = 0;
                                   for(const p in value.lots[k].quantity_branch){
                                     value.lots[k].quantity = value.lots[k].quantity + value.lots[k].quantity_branch[p];
                                   } 
                                   wrong_quantity = true;                             
                                 }else{
                                   let quantity = 0;
                                   for(const p in value.lots[k].quantity_branch){
                                     quantity = quantity + value.lots[k].quantity_branch[p];
                                   }   
                                   if(value.lots[k].quantity != quantity){
                                     value.lots[k].quantity = quantity;
                                     wrong_quantity = true; 
                                   }
                                 }                            
                               }
                             }                                                     
                             if(wrong_quantity){       
                               console.log('value', value)                                       
                               this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, value);       
                             }

                           }                                  
                       }                  
                       resolve(json);                             
                       console.log('getReportInputOutputInventory_byEndTime_byIDMaterial', json);
                     })                      
             
             }else{
               console.log('server -> products khong ton tai trong CSDL: ');
               resolve(json);           
             }  
           })
     })    
   }
 

    /**   
    * Hàm này dùng trong page Tồn kho, giá trị tồn kho, doanh số, chi phí nhập hàng tại một thời điểm endtime nào đó -> chi tiết của một nguyên liệu nào đó
    * Lấy về chi tiết xuất nhập của 1 nguyên liệu nào đó trong từ 0h ngày 1 đến thời điểm endtime
    * @example:
    * this.vhQueryCafe.getReportInputOutputInventory_Detail_byEndTime_byIDMaterial(endtime, 'UTWXdaU3UDq3xq7aK77p')
        .then((bill_details:any)=>{
          console.log('vhs_bill_details_', bill_details);
        })
    * @param starttime 
    * @param endtime 
    * @param id_sub_or_product 
    * @param IDbranch : 'all' or id_branch
    * @Notice bill_type = [1,3,10,30,38,41,51,2,9,16,31,39]
    */
    public getReportInputOutputInventory_Detail_byEndTime_byIDMaterial(endtime:any, id_sub_or_product:any, IDbranch?:string){
      return new Promise<any>((resolve, reject) => {  
        endtime = new Date(endtime);
        let starttime = new Date(endtime);    
        starttime.setDate(1);
        starttime.setHours(0);
        starttime.setMinutes(0);
        starttime.setSeconds(0); 
        let product = this.getlocalDetailProduct(id_sub_or_product);  
        let json:any = {
          docs: new Array(),
          empty: true,
          size:0,
          outquantity: 0,
          inquantity: 0, 
          revenue_btax: 0,   
          revenue_atax: 0,  
          cost_btax: 0,     
          cost_atax: 0 
        }       
        let query1:any ={};     
        let query2:any ={};        
        let promise = new Array();     
        if((IDbranch==='all')||(IDbranch===undefined)){
          if(product.id_subproduct){
            query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,9,16,39]}};
            query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}};
          }else{
            query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,9,16,39]}};
            query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}};
          } 
        }else{
          if(product.id_subproduct){
            query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,9,16,39]}, id_branch: {$eq:IDbranch}};
            query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
          }else{
            query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,9,16,39]}, id_branch: {$eq:IDbranch}};
            query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
          }        
        } 
        //console.log('query1', query1);
        //console.log('query2', query2);
        promise[0] = this.getBill_details_byFields(query1, {},{date:1},0)
        promise[1] = this.getBill_details_byFields(query2, {},{date:1},0)
        Promise.all(promise).then((array:any)=>{
                let bill_details = array.flat();                          
                for(let j=0; j<bill_details.length; j++){   
                  let bill_detail:any ={
                    id_bill: bill_details[j]?.id_bill,
                    bill_code: bill_details[j]?.bill_code,
                    bill_type: bill_details[j]?.bill_type,
                    date: bill_details[j]?.date,
                    tax: bill_details[j]?.tax,
                    name: product.name,
                    unit: product.unit                  
                  }
                  if(bill_details[j]?.id_cashier) bill_detail.id_cashier = bill_details[j]?.id_cashier;
                  if(bill_details[j]?.id_employee) bill_detail.id_employee = bill_details[j]?.id_employee;
                  if(bill_details[j]?.id_customer) bill_detail.id_customer = bill_details[j]?.id_customer;
                  if(bill_details[j]?.id_supplier) bill_detail.id_supplier = bill_details[j]?.id_supplier;
  
                  if(bill_details[j].ptype === 1){ 
                      bill_detail.price_btax = bill_details[j].price;
                      bill_detail.price_atax = bill_details[j].price * (1 + bill_details[j].tax/100);
                      bill_detail.payment_btax = bill_details[j].price * bill_details[j].quantity;
                      bill_detail.payment_atax = this.vhAlgorithm.roundTo3Decimals(bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                      bill_detail.quantity = bill_details[j]?.quantity * bill_details[j].ratio;                 
                      if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                        bill_detail.type = 'output';
                        json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity;
                        json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                        json.outquantity = json.outquantity + bill_details[j].quantity * bill_details[j].ratio;
                      }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 16)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){ 
                        bill_detail.type = 'input';
                        json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                        json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                        json.inquantity = json.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                      }else if(bill_details[j].bill_type === 9){ 
                        bill_detail.type = 'beginning';
                        json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                        json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                        json.inquantity = json.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                      }                                                                   
                  }           
                  bill_detail.price_atax = this.vhAlgorithm.roundTo3Decimals(bill_detail.price_atax);     
                  bill_detail.payment_atax = this.vhAlgorithm.roundTo3Decimals(bill_detail.payment_atax);                   
                  json.docs.push(bill_detail);
                  json.size++;                        
                  json.empty = false; 
                } 
                console.log('getReportInputOutputInventory_Detail_byEndTime_byIDMaterial');        
                resolve(json);
  
            })
      })
    }

    /**          
   * Hàm này dùng trong page Tồn kho, giá trị tồn kho NGUYÊN LIỆU (type=3), doanh số, chi phí nhập hàng tại một thời điểm endtime nào đó -> chi tiết của một sản phẩm nào đó
   * @example:
   * this.vhQueryCafe.getReportInputOutputInventory_Detail_byEndTime_byIDMaterial(endtime, 'UTWXdaU3UDq3xq7aK77p')
        .then((bill_details:any)=>{
          console.log('vhs_bill_details_', bill_details);
        })
    * @param starttime 
    * @param endtime 
    * @param id_material 
    * @param IDbranch : 'all' or id_branch
    * @Notice bill_type = [1,3,10,30,2,9,16,31]
    */
  private getReportInputOutputInventory_Detail_byEndTime_byIDMaterial_old(endtime:any, id_material:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {  
      let product = this.getlocalProduct(id_material);  
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        outquantity: 0,
        inquantity: 0, 
        revenue_btax: 0,   
        revenue_atax: 0,  
        cost_btax: 0,     
        cost_atax: 0 
      }    
      //let query = {date: {$lte:endtime}, id_product: {$eq:id_material}, bill_type: {$in:[1,3,10,2,9,16]}};
      let query:any;
      if((IDbranch==='all')||(IDbranch===undefined)){
        query = {date: {$lte:endtime}, id_product: {$eq:id_material}, bill_type: {$in:[1,3,10,30,2,9,16,31]}};
      }else{
        query = {date: {$lte:endtime}, id_product: {$eq:id_material}, bill_type: {$in:[1,3,10,30,2,9,16,31]}, id_branch: {$eq:IDbranch}};
      }   
      this.getBill_details_byFields(query, {},{date:1},0)   
        .then((bill_details:any)=>{             
              for(let j=0; j<bill_details.length; j++){   
                let bill_detail:any ={
                  id_bill: bill_details[j]?.id_bill,
                  bill_code: bill_details[j]?.bill_code,
                  bill_type: bill_details[j]?.bill_type,
                  date: bill_details[j]?.date,
                  tax: bill_details[j]?.tax,
                  price_btax: bill_details[j]?.price,
                  price_atax: bill_details[j]?.price * (1 + bill_details[j].tax/100),
                  payment_btax: bill_details[j]?.price * bill_details[j]?.quantity,
                  payment_atax: this.vhAlgorithm.roundTo3Decimals(bill_details[j]?.price * bill_details[j]?.quantity * (1 + bill_details[j].tax/100)),
                  quantity: bill_details[j]?.quantity,

                  name: product.name,
                  unit: product.unit                  
                }
                if(bill_details[j]?.id_cashier) bill_detail.id_cashier = bill_details[j]?.id_cashier;
                if(bill_details[j]?.id_employee) bill_detail.id_employee = bill_details[j]?.id_employee;
                if(bill_details[j]?.id_customer) bill_detail.id_customer = bill_details[j]?.id_customer;
                if(bill_details[j]?.id_supplier) bill_detail.id_supplier = bill_details[j]?.id_supplier;

                if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 30)){
                  bill_detail.type = 'output';
                  json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity;
                  json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                  json.outquantity = json.outquantity + bill_details[j].quantity;
                }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 31)){ 
                  bill_detail.type = 'input';
                  json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                  json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                  json.inquantity = json.inquantity + bill_details[j].quantity; 
                }else if(bill_details[j].bill_type === 9){ 
                  bill_detail.type = 'beginning';
                  json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                  json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                  json.inquantity = json.inquantity + bill_details[j].quantity; 
                }else if(bill_details[j].bill_type === 3){
                  bill_detail.type = 'output';
                  json.outquantity = json.outquantity + bill_details[j].quantity;
                }else if(bill_details[j].bill_type === 16){
                  bill_detail.type = 'input';
                  json.inquantity = json.inquantity + bill_details[j].quantity; 
                }                                                                   
                                                    
                json.docs.push(bill_detail);
                json.size++;                        
                json.empty = false; 
              }                     
              resolve(json);

          })
    })
  }

  /**         
   * Hàm này dùng trong page XUẤT-NHẬP-TỒN NGUYÊN LIỆU (type=3) -> Xuất nhập tồn -> chi tiết
   * @example:
   * this.vhQueryCafe.getReportInputOutputInventory_Detail_byTime_byIDMaterial(starttime , endtime, 'UTWXdaU3UDq3xq7aK77p')
        .then((bill_details:any)=>{
          console.log('vhs_bill_details_', bill_details);
        })
    * @param starttime 
    * @param endtime 
    * @param id_material 
    *  @param IDbranch = 'all' or id_branch
    * @Notice bill_type = [1,3,10,30,2,9,16,31]
    */
  public getReportInputOutputInventory_Detail_byTime_byIDMaterial(starttime:any, endtime:any, id_material:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {  
      let product = this.getlocalProduct(id_material);  
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        outquantity: 0,
        inquantity: 0, 
        revenue_btax: 0,   
        revenue_atax: 0,  
        cost_btax: 0,     
        cost_atax: 0 
      }        
      let query:any;
      if((IDbranch === 'all')||(IDbranch === undefined)){
        query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_material}, bill_type: {$in:[1,3,10,30,2,9,16,31]}};
      }else{
        query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_material}, bill_type: {$in:[1,3,10,30,2,9,16,31]}, id_branch: {$eq:IDbranch}};
      }
      
      this.getBill_details_byFields(query, {},{date:1},0)        
          .then((bill_details:any)=>{                                     
              for(let j=0; j<bill_details.length; j++){   
                let bill_detail:any ={
                  id_bill: bill_details[j]?.id_bill,
                  bill_code: bill_details[j]?.bill_code,
                  bill_type: bill_details[j]?.bill_type,
                  date: bill_details[j]?.date,
                  price_btax: bill_details[j]?.price,
                  price_atax: bill_details[j]?.price * (1 + bill_details[j].tax/100),
                  payment_btax: bill_details[j]?.price * bill_details[j]?.quantity,
                  payment_atax: this.vhAlgorithm.roundTo3Decimals(bill_details[j]?.price * bill_details[j]?.quantity * (1 + bill_details[j].tax/100)),
                  quantity: bill_details[j]?.quantity,

                  name: product.name,
                  unit: product.unit                  
                }
                if(bill_details[j]?.id_cashier) bill_detail.id_cashier = bill_details[j]?.id_cashier;
                if(bill_details[j]?.id_employee) bill_detail.id_employee = bill_details[j]?.id_employee;
                if(bill_details[j]?.id_customer) bill_detail.id_customer = bill_details[j]?.id_customer;
                if(bill_details[j]?.id_supplier) bill_detail.id_supplier = bill_details[j]?.id_supplier;

                if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 30)){
                  bill_detail.type = 'output';
                  json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity;
                  json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                  json.outquantity = json.outquantity + bill_details[j].quantity;
                }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 31)){ 
                  bill_detail.type = 'input';
                  json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                  json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                  json.inquantity = json.inquantity + bill_details[j].quantity; 
                }else if(bill_details[j].bill_type === 9){ 
                  bill_detail.type = 'beginning';
                  json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                  json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                  json.inquantity = json.inquantity + bill_details[j].quantity; 
                }else if(bill_details[j].bill_type === 3){
                  bill_detail.type = 'output';
                  json.outquantity = json.outquantity + bill_details[j].quantity;
                }else if(bill_details[j].bill_type === 16){
                  bill_detail.type = 'input';
                  json.inquantity = json.inquantity + bill_details[j].quantity; 
                }                                                                     
                                                    
                json.docs.push(bill_detail);
                json.size++;                        
                json.empty = false; 
              }         
              resolve(json);

          })
    })
  }
/**   
    * Hàm này dùng trong page XUẤT-NHẬP-TỒN NGUYÊN LIỆU (type=3)-> Xuất nhập hàng
    * @example:
    * this.vhQueryCafe.getReportInputOutput_byTime_byIDMaterial(starttime , endtime, 'UTWXdaU3UDq3xq7aK77p')
        .then((bill_details:any)=>{
          console.log('vhs_bill_details_', bill_details);
        })
    * @param starttime 
    * @param endtime 
    * @param IDsub_or_product : 'all' or id_subproduct or id_product;  
    * @param IDbranch 
    * @return Promise Array
    * @Notice id_product = 'all' or id_product;
    * @Notice IDbranch = 'all' or id_branch;
    * @Notice bill_type = [1,3,10,30,38,41,51,2,16,31,39]
    */
    public getReportInputOutput_byTime_byIDMaterial(starttime:any, endtime:any, IDsub_or_product:string, IDbranch?:string){
      //Cách tính mới, bill_type_9 là tồn đầu kỳ chứ ko xem là nhập, nên trong báo cáo này ko đưa vào
      return new Promise<any>((resolve, reject) => {  
        let products:any = new Array();   
        if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
        else {
          let product = this.getlocalDetailProduct(IDsub_or_product);           
          products.push(product);
        }
        let json:any = {
          docs: new Array(),
          empty: true,
          size:0,
          outquantity: 0,
          inquantity: 0, 
          revenue_btax: 0,   
          revenue_atax: 0,  
          cost_btax: 0,     
          cost_atax: 0 
        }                    
        if(products.length>0){    
          let query1:any = {};   
          let query2:any = {};       
          let promise = new Array();  
          if((IDsub_or_product === 'all')){
            if((IDbranch === 'all')||(IDbranch === undefined)){
              query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,41,51,2,16,39]}}; //bill_type_9 không phải là phiếu nhập 
              query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}}; //bill_type_9 không phải là phiếu nhập               
            }else{
              query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,38,39,41,51,2,16]}, id_branch: {$eq:IDbranch}};//bill_type_9 không phải là phiếu nhập  
              query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};//bill_type_9 không phải là phiếu nhập                   
            }
          }else{
            if((IDbranch === 'all')||(IDbranch === undefined)){              
              if(products[0].id_subproduct){ 
                query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,16,39]}};//ko có bill_type_9  
                query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};//ko có bill_type_9  
              }else{                          
                query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,16,39]}};//ko có bill_type_9  
                query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};//ko có bill_type_9  
              }
            }else{
              if(products[0].id_subproduct){ 
                query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,16,39]}, id_branch: {$eq:IDbranch}};//ko có bill_type_9  
                query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};//ko có bill_type_9      
              }else{
                query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,16,39]}, id_branch: {$eq:IDbranch}};//ko có bill_type_9      
                query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};//ko có bill_type_9       
              } 
            }
          } 
          promise[0] = this.getBill_details_byFields(query1, {},{date:1},0)
          promise[1] = this.getBill_details_byFields(query2, {},{date:1},0)
          Promise.all(promise)
                .then((array:any)=>{            
                    let bill_details = array.flat();                                         
                    for(let i=0; i<products.length; i++){
                      let unit = this.getUnit_byRatio(products[i].units,1);
                      let record: any ={
                        id_product: products[i]._id,
                        name: products[i].name,
                        img: products[i].img,
                        type: products[i].type,

                        ratio: unit.ratio,
                        unit: unit.unit,
                        barcode: unit.barcode,
                      
                        outquantity: 0,
                        inquantity: 0, 
                        revenue_btax: 0,   
                        revenue_atax: 0,  
                        cost_btax: 0,     
                        cost_atax: 0 
                      }
                      if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;  
                      if(products[i].lots) {
                        record.lots = cloneDeep(products[i].lots);
                        for(let m = 0; m<record.lots.length; m++){                
                          record.lots[m].outquantity = 0;
                          record.lots[m].inquantity = 0;
                          record.lots[m].revenue_btax = 0;
                          record.lots[m].revenue_atax = 0;
                          record.lots[m].cost_btax = 0;
                          record.lots[m].cost_atax = 0;       
                        }
                      }  

                      for(let j=0; j<bill_details.length; j++){       
                          let is_sub_or_product = false;
                          if(record.id_subproduct) is_sub_or_product = bill_details[j].id_subproduct === record.id_subproduct;
                          else is_sub_or_product = bill_details[j].id_product === record.id_product;             
                          if(bill_details[j].ptype === 3){
                            if(is_sub_or_product){ 
                              if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                                if(record.lots){
                                  for(let m=0; m<record.lots.length; m++){
                                    if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                      record.lots[m].revenue_btax = record.lots[m].revenue_btax + bill_details[j].price * bill_details[j].quantity;  
                                      record.lots[m].revenue_atax = record.lots[m].revenue_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                      record.lots[m].outquantity = record.lots[m].outquantity + bill_details[j].quantity * bill_details[j].ratio; 
                                    }
                                  }   
                                }  
                                record.revenue_btax = record.revenue_btax + bill_details[j].price * bill_details[j].quantity; 
                                record.revenue_atax = record.revenue_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                record.outquantity = record.outquantity + bill_details[j].quantity * bill_details[j].ratio; 

                                json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity; 
                                json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                                json.outquantity = json.outquantity + bill_details[j].quantity * bill_details[j].ratio;     
                              }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 16)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){ 
                                if(record.lots){
                                  for(let m=0; m<record.lots.length; m++){
                                    if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                      record.lots[m].cost_btax = record.lots[m].cost_btax + bill_details[j].price * bill_details[j].quantity; 
                                      record.lots[m].cost_atax = record.lots[m].cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                      record.lots[m].inquantity = record.lots[m].inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                                    }
                                  }   
                                }  
                                record.cost_btax = record.cost_btax + bill_details[j].price * bill_details[j].quantity;  
                                record.cost_atax = record.cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                record.inquantity = record.inquantity + bill_details[j].quantity * bill_details[j].ratio; 

                                json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity; 
                                json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                                json.inquantity = json.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                              }  
                            }  
                          }                                         
                      }
                      if((record.inquantity !=0)||(record.outquantity !=0)){
                        record.revenue_atax = this.vhAlgorithm.roundTo3Decimals(record.revenue_atax);     
                        record.cost_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_atax);     
                        record.index = json.size + 1;
                        json.docs.push(record);
                        json.size++;                        
                        json.empty = false;   
                      }                                          
                    }
                    console.log('getReportInputOutput_byTime_byIDMaterial', json);
                    resolve(json);   
          })    
        }else{
          console.log('server -> products khong ton tai trong CSDL: ');
          resolve(json);           
        }                  
      })    
    }
  /**         
   * Hàm này dùng trong page XUẤT-NHẬP-TỒN NGUYÊN LIỆU (type=3)-> Xuất nhập hàng
   * @example:
   * this.vhQueryCafe.getReportInputOutput_byTime_byIDMaterial(starttime , endtime, 'UTWXdaU3UDq3xq7aK77p')
        .then((bill_details:any)=>{
          console.log('vhs_bill_details_', bill_details);
        })
    * @param starttime 
    * @param endtime 
    * @param IDmaterial = 'all' or id_material; 
    * @param IDbranch = 'all' or id_branch
    * @return Promise Array
    * @Notice bill_type = [1,3,10,30,2,9,16,31]
    */
  private getReportInputOutput_byTime_byIDMaterial_old(starttime:any, endtime:any, IDmaterial:any, IDbranch?:string){    
    //Cách tính mới, bill_type_9 là tồn đầu kỳ chứ ko xem là nhập, nên trong báo cáo này ko đưa vào
    return new Promise<any>((resolve, reject) => {  
        let products:any = new Array();   
        if(IDmaterial === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalProducts(3), 'name');  
        else {
          let product = this.getlocalProduct(IDmaterial);  
          //console.log('product', product);  
          products.push(product);
        }
        let json:any = {
          docs: new Array(),
          empty: true,
          size:0,
          outquantity: 0,
          inquantity: 0, 
          revenue_btax: 0,   
          revenue_atax: 0,  
          cost_btax: 0,     
          cost_atax: 0 
        }              
        if(products.length>0){            
          let query:any;
          if((IDmaterial === 'all')){
            if((IDbranch === 'all')||(IDbranch === undefined)){
              query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,30,2,16,31]}}; //bill_type_9 không phải là phiếu nhập               
            }else{
              query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,30,2,16,31]}, id_branch: {$eq:IDbranch}}; //bill_type_9 không phải là phiếu nhập                  
            }
          }else{
            if((IDbranch === 'all')||(IDbranch === undefined)){              
              query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:IDmaterial}, bill_type: {$in:[1,3,10,30,2,16,31]}};
            }else{
              query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:IDmaterial}, bill_type: {$in:[1,3,10,30,2,16,31]}, id_branch: {$eq:IDbranch}};         
            }
          }
          
          this.getBill_details_byFields(query, {},{date:1},0)        
            .then((bill_details:any)=>{                             
                for(let i=0; i<products.length; i++){
                  let product: any ={
                    _id: products[i]._id,
                    name: products[i].name,
                    type: products[i].type,
                    unit: products[i].unit,
                    
                    outquantity: 0,
                    inquantity: 0, 
                    revenue_btax: 0,   
                    revenue_atax: 0,  
                    cost_btax: 0,     
                    cost_atax: 0 
                  }
                  for(let j=0; j<bill_details.length; j++){   
                    if(bill_details[j].id_product === products[i]._id){   
                      if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 30)){
                        product.revenue_btax = product.revenue_btax + bill_details[j].price * bill_details[j].quantity; 
                        product.revenue_atax = product.revenue_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                        product.outquantity = product.outquantity + bill_details[j].quantity; 

                        json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity;
                        json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                        json.outquantity = json.outquantity + bill_details[j].quantity;    
                      }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 31)){ 
                        product.cost_btax = product.cost_btax + bill_details[j].price * bill_details[j].quantity; 
                        product.cost_atax = product.cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                        product.inquantity = product.inquantity + bill_details[j].quantity; 

                        json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                        json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                        json.inquantity = json.inquantity + bill_details[j].quantity;  

                      }else if(bill_details[j].bill_type === 3){      
                        product.outquantity = product.outquantity + bill_details[j].quantity;                  
                        json.outquantity = json.outquantity + bill_details[j].quantity;
                      }else if(bill_details[j].bill_type === 16){
                        product.inquantity = product.inquantity + bill_details[j].quantity; 
                        json.inquantity = json.inquantity + bill_details[j].quantity; 
                      }                      
                                                            
                    }                                    
                  }
                  if((product.inquantity !=0)||(product.outquantity !=0)){
                    product.index = json.size + 1;
                    json.docs.push(product);
                    json.size++;                        
                    json.empty = false;   
                  }        
                                  
                }
                resolve(json);   
              })                      
        
        }else{
          console.log('server -> products khong ton tai trong CSDL: ');
          resolve(json);           
        }  
                
    })    
  } 

  /**
    * Hàm này chỉ dùng cho NGUYÊN LIỆU (type=3)
    * Hàm này dùng trong page XUẤT-NHẬP-TỒN NGUYÊN LIỆU -> Xuất nhập hàng -> chi tiết
    * @example:
    * this.vhQueryCafe.getReportInputOutput_Detail_byTime_byIDMaterial(starttime , endtime, 'UTWXdaU3UDq3xq7aK77p','sdfwe23qw245234t3')
        .then((bill_details:any)=>{
          console.log('vhs_bill_details_', bill_details);
        })
    * @param starttime 
    * @param endtime 
    * @param id_sub_or_product: id_subproduct or id_product;
    * @param IDbranch = 'all' or id_branch; 
    * @Notice bill_type = [1,3,10,30,2,9,16,31]
    */
  public getReportInputOutput_Detail_byTime_byIDMaterial(starttime:any, endtime:any, id_sub_or_product:any, IDbranch?:string){    
    //Cách tính mới, bill_type_9 là tồn đầu kỳ chứ ko xem là nhập, nên trong báo cáo này ko đưa vào
    return new Promise<any>((resolve, reject) => {  
      let product = this.getlocalDetailProduct(id_sub_or_product);      
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        outquantity: 0,
        inquantity: 0, 
        revenue_btax: 0,   
        revenue_atax: 0,  
        cost_btax: 0,     
        cost_atax: 0 
      }  
      let query1:any = {};
      let query2:any = {};           
      let promise = new Array();         
      if((IDbranch === 'all')||(IDbranch === undefined)){
        if(product.id_subproduct){ 
          query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,16,31]}}; //bill_type_9 không phải bill nhập
          query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}}; //bill_type_9 không phải bill nhập
        }else{ 
          query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[1,3,10,30,2,16,31]}}; //bill_type_9 không phải bill nhập
          query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}}; //bill_type_9 không phải bill nhập
        }
        
      }else{
        if(product.id_subproduct){ 
          query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[1,3,10,38,41,51,2,16,31]}, id_branch: {$eq:IDbranch}}; //bill_type_9 không phải bill nhập
          query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}}; //bill_type_9 không phải bill nhập
        }else{ 
          query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[1,3,10,30,2,16,31]}, id_branch: {$eq:IDbranch}}; //bill_type_9 không phải bill nhập
          query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}}; //bill_type_9 không phải bill nhập
        }
        
      }    
      promise[promise.length] = this.getBill_details_byFields(query1, {},{date:1},0)
      promise[promise.length] = this.getBill_details_byFields(query2, {},{date:1},0)
      Promise.all(promise)
            .then((array:any)=>{                    
              let bill_details = array.flat();              
              for(let j=0; j<bill_details.length; j++){   
                let bill_detail:any ={
                  id_bill: bill_details[j]?.id_bill,
                  bill_code: bill_details[j]?.bill_code,
                  bill_type: bill_details[j]?.bill_type,
                  date: bill_details[j]?.date,
                  price_btax: bill_details[j]?.price,
                  price_atax: bill_details[j]?.price * (1 + bill_details[j].tax/100),
                  payment_btax: bill_details[j]?.price * bill_details[j]?.quantity,
                  payment_atax: this.vhAlgorithm.roundTo3Decimals(bill_details[j]?.price * bill_details[j]?.quantity * (1 + bill_details[j].tax/100)),
                  quantity: bill_details[j]?.quantity,

                  name: product.name,
                  unit: product.unit                  
                }
                if(bill_details[j]?.id_cashier) bill_detail.id_cashier = bill_details[j]?.id_cashier;
                if(bill_details[j]?.id_employee) bill_detail.id_employee = bill_details[j]?.id_employee;
                if(bill_details[j]?.id_customer) bill_detail.id_customer = bill_details[j]?.id_customer;
                if(bill_details[j]?.id_supplier) bill_detail.id_supplier = bill_details[j]?.id_supplier;

                if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 30)){
                  bill_detail.type = 'output';
                  json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity;
                  json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                  json.outquantity = json.outquantity + bill_details[j].quantity;
                }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 31)){ 
                  bill_detail.type = 'input';
                  json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                  json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                  json.inquantity = json.inquantity + bill_details[j].quantity; 

                }else if(bill_details[j].bill_type === 3){
                  bill_detail.type = 'output';
                  json.outquantity = json.outquantity + bill_details[j].quantity;
                }else if(bill_details[j].bill_type === 16){
                  bill_detail.type = 'input';
                  json.inquantity = json.inquantity + bill_details[j].quantity; 
                }                                                                     
                                                    
                json.docs.push(bill_detail);
                json.size++;                        
                json.empty = false; 
              }         
              resolve(json);

          })
    })
  }

    /**
   * @example:
   * let hour_array: Array<any> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
   * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportRevenue_byHoursOut_hourArray(starttime, endtime, hour_array)
        .then((reportRevenue)=>{
          console.log('reportRevenue', reportRevenue);
          console.log('reportRevenue.docs[0]', reportRevenue.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param hour_array 
   * @param IDbranch : 'all' or id_branch
   */
  public getReportRevenue_byHoursOut_hourArray(starttime:any, endtime:any, hour_array:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                  
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,
          revenue: 0                   
        }                 
        
        let query:any;     
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11]}, id_branch: {$eq:IDbranch}};          
        }
        this.getBills_byFields(query, {},{date:1},0)   
            .then((bills:any)=>{                                          
                if(bills.length >0){ 
                  let data = new Array();
                  for(let h=0; h < hour_array.length; h++){
                    data[h] =  {};           
                    data[h].revenue = 0;                                                                                                                        
                  }
                  for(let j=0; j<bills.length; j++){
                    let bill = {...bills[j]};
                    if(bill.date) {                         
                      let hour = (new Date(bill.date)).getHours();                                                                   
                      for(let h=0; h < hour_array.length; h++){
                        if(hour_array[h]=== hour){                        
                            data[h].revenue = data[h].revenue + Number(bill.payment);  
                            json.revenue = json.revenue + Number(bill.payment);                                                                                            
                        }                                    
                      }                                
                    }                
                  }                                 
                  json.docs = data;
                  json.size = hour_array.length;                        
                  json.empty = false;                                   
                }
                resolve(json);   
            })               
    })    
  }

  /**
   * @example:
   * let day_array: Array<any> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
   * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportRevenue_byDaysOut_dayArray(starttime, endtime, day_array)
        .then((reportRevenue)=>{
          console.log('reportRevenue', reportRevenue);
          console.log('reportRevenue.docs[0]', reportRevenue.docs[0]);
        })
    * @param starttime 
    * @param endtime 
    * @param day_array 
    * @param IDbranch : 'all' or id_branch
    * @notice Doanh thu thì ko có thuế
    */
  public getReportRevenue_byDaysOut_dayArray(starttime:any, endtime:any, day_array:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                  
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,
          revenue: 0                  
        }                
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11]}, id_branch: {$eq:IDbranch}};
        }   
        this.getBills_byFields(query, {},{date:1},0) 
           .then((bills:any)=>{                                         
                if(bills.length >0){ 
                  let data = new Array();
                  for(let d=0; d < day_array.length; d++){
                    data[d] =  {};            
                    data[d].revenue = 0;                                                                                                            
                  }
                  for(let j=0; j<bills.length; j++){
                    let bill = bills[j];
                    if(bill.date) {                         
                      let day = (new Date(bill.date)).getDate();//bill.date.toDate().getDate();                                                                              
                      for(let d=0; d < day_array.length; d++){
                        if(day_array[d]=== day){                        
                            data[d].revenue = data[d].revenue + Number(bill.payment);  
                            json.revenue = json.revenue + Number(bill.payment);                                                                                                                    
                        }                                    
                      }                                
                    }                
                  }                                 
                  json.docs = data;
                  json.size = day_array.length;                        
                  json.empty = false;                                   
                }
                resolve(json);   
            })               
    })    
  } 
  
  /**
   * VhQuerySales: đã check
   * @example:
   * let month_array: Array<any> = [0,1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
   * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportRevenue_byMonthsOut_monthArray(starttime, endtime, month_array)
        .then((reportRevenue)=>{
          console.log('reportRevenue', reportRevenue);
          console.log('reportRevenue.docs[0]', reportRevenue.docs[0]);
        })
    * @param starttime 
    * @param endtime 
    * @param month_array 
    *  @param IDbranch : 'all' or id_branch
    */
  public getReportRevenue_byMonthsOut_monthArray(starttime:any, endtime:any, month_array:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                  
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,
          revenue: 0               
        }         
        //nhớ kiểm tra có cần thêm sắp xếp asc ko                   
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11]}, id_branch: {$eq:IDbranch}};
        }   
        this.getBills_byFields(query, {},{date:1},0)
            .then((bills:any)=>{                                 
                if(bills.length >0){ 
                  let data = new Array();
                  for(let m=0; m < month_array.length; m++){
                    data[m] =  {};    
                    data[m].revenue = 0;                                                                                                               
                  }
                  for(let j=0; j<bills.length; j++){
                    let bill = bills[j];
                    if(bill.date) {                         
                      let month = (new Date(bill.date)).getMonth();                                                                             
                      for(let m=0; m < month_array.length; m++){
                        if(month_array[m]=== month){                        
                            data[m].revenue = data[m].revenue + Number(bill.payment);  
                            json.revenue = json.revenue + Number(bill.payment);                                                                                
                        }                                    
                      }                                
                    }                
                  }                                 
                  json.docs = data;
                  json.size = month_array.length;                        
                  json.empty = false;                                   
                }
                resolve(json);   
            })               
    })    
  } 

     /**   
   * lấy về mảng json.docs(array) doanh thu theo một hoặc tất cả các chi nhánh
   * @example:  
    this.vhQueryCafe.getReportRevenue_byIDbranch(starttime, endtime, 'dfs3fw3tr3g2a1rgmfg2h1')
        .then((reportRevenue)=>{
          console.log('reportRevenue', reportRevenue);
          console.log('reportRevenue.docs[0]', reportRevenue.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param IDbranch : 'all' or id_branch
   * @return : 
   * json = {docs(array), empty(boolean), size(number), revenue(number)}
   * trong đó docs = [{name(string), id_branch(string), revenue(number)}]
   */
  public getReportRevenue_byIDbranch(starttime:any, endtime:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                     
          let json: any={
            docs:  new Array(),
            empty: true,
            size: 0,
            revenue: 0                
          }                  
          let branchs:any = new Array();    
          let query:any;
          if((IDbranch==='all')||(IDbranch===undefined)){
            branchs = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalBranchs(), 'name');  
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11]}};
          }else{
            let branch = this.getlocalBranch(IDbranch);            
            branchs.push(branch);
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11]}, id_branch: {$eq:IDbranch}};
          }     
          
          this.getBills_byFields(query, {},{date:1},0)
              .then((bills:any)=>{                                 
                  if(bills.length >0){ 
                  let data = new Array();              
                  for(let j=0; j<branchs.length; j++){
                    data[j] = {};
                    data[j].id_branch = branchs[j]._id;
                    data[j].name = branchs[j].name;
                    data[j].revenue = 0;
                  }       
                    for(let i=0; i<bills.length; i++){                                                              
                    for(let j=0; j<branchs.length; j++){                     
                      if(branchs[j]._id === bills[i].id_branch){                        
                        data[j].revenue = data[j].revenue + Number(bills[i].payment);  
                        json.revenue = json.revenue + Number(bills[i].payment);
                      }                                    
                    }                                  
                    }                                 
                    json.docs = data;
                    json.size = branchs.length;                        
                    json.empty = false;                                   
                  }
                  resolve(json);   
              })               
      })    
  } 

  
  /**
   * @example:
   * let hour_array: Array<any> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
   * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQueryCafe.getReportSales_byHoursOut_hourArray(starttime, endtime, hour_array)
        .then((reportSales)=>{
          console.log('reportSales', reportSales);
          console.log('reportSales.docs[0]', reportSales.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param hour_array 
   * @param IDbranch : 'all' or id_branch
   */
    public getReportSales_byHoursOut_hourArray(starttime:any, endtime:any, hour_array:any, IDbranch?:string){
      return new Promise<any>((resolve, reject) => {                  
          let json: any={
            docs:  new Array(),
            empty: true,
            size: 0,
            sales_btax: 0,
            sales_atax: 0                 
          }     
          //let query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};
          let query:any;
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};
          } 
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                
                  if(vhbill_details.length>0){                    
                      let data = new Array();
                      for(let h=0; h < hour_array.length; h++){
                        data[h] =  {};            
                        data[h].sales_btax = 0;  
                        data[h].sales_atax = 0;                                                                                                    
                      }
                      for(let j=0; j<vhbill_details.length; j++){
                        let vhbill_detail = {...vhbill_details[j]};
                        if(vhbill_detail.date) {                         
                          let hour = (new Date(vhbill_detail.date)).getHours();                                                                              
                          for(let h=0; h < hour_array.length; h++){
                            if(hour_array[h]=== hour){                        
                              data[h].sales_btax = data[h].sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;  
                              data[h].sales_atax = data[h].sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100); 
                              json.sales_btax = json.sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;
                              json.sales_atax = json.sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100); 
                            }                                    
                          }                                
                        }                
                      }                                 
                      json.docs = data;
                      json.size = hour_array.length;                        
                      json.empty = false;                                   
                  }                
                  resolve(json);   
              })               
      })    
    } 
  
    /**
     * @example:
     * let day_array: Array<any> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
     * let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_byDaysOut_dayArray(starttime, endtime, day_array)
          .then((reportSales)=>{
            console.log('reportSales', reportSales);
            console.log('reportSales.docs[0]', reportSales.docs[0]);
          })
      * @param starttime 
      * @param endtime 
      * @param hour_array 
      * @param IDbranch : 'all' or id_branch
      */
    public getReportSales_byDaysOut_dayArray(starttime:any, endtime:any, day_array:any, IDbranch?:string){
      return new Promise<any>((resolve, reject) => {                  
          let json: any={
            docs:  new Array(),
            empty: true,
            size: 0,
            sales_btax: 0,
            sales_atax: 0                 
          }               
          //let query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};
          let query:any;
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};
          }          
          this.getBill_details_byFields(query, {},{date:1},0)   
              .then((vhbill_details:any)=>{              
                if(vhbill_details.length>0){                       
                    let data = new Array();
                    for(let d=0; d < day_array.length; d++){
                      data[d] =  {};            
                      data[d].sales_btax = 0;  
                      data[d].sales_atax = 0;                                                                                                    
                    }
                    for(let j=0; j<vhbill_details.length; j++){
                      let vhbill_detail = {...vhbill_details[j]};
                      if(vhbill_detail.date) {                         
                        let day = (new Date(vhbill_detail.date)).getDate();                                                                                      
                        for(let d=0; d < day_array.length; d++){
                          if(day_array[d]=== day){ 
                            data[d].sales_btax = data[d].sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;  
                            data[d].sales_atax = data[d].sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity *(1 + vhbill_detail.tax / 100); 
                            json.sales_btax = json.sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;
                            json.sales_atax = json.sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100); 
                          }                                    
                        }                                
                      }                
                    }                                 
                    json.docs = data;
                    json.size = day_array.length;                        
                    json.empty = false;                                   
                  }                
                  resolve(json);   
              })               
      })    
    } 
  
    /**
     * lấy về mảng json.docs(array) doanh số theo 12 tháng trong năm
     * @example:
     * let month_array: Array<any> = [0,1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
     * let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_byMonthsOut_monthArray(starttime, endtime, month_array)
          .then((reportSales)=>{
            console.log('reportSales', reportSales);
            console.log('reportSales.docs[0]', reportSales.docs[0]);
          })
      * @param starttime 
      * @param endtime 
      * @param hour_array 
      * @param IDbranch : 'all' or id_branch
      */
    public getReportSales_byMonthsOut_monthArray(starttime:any, endtime:any, month_array:any, IDbranch?:string){
      return new Promise<any>((resolve, reject) => {                  
          let json: any={
            docs:  new Array(),
            empty: true,
            size: 0,
            sales_btax: 0,
            sales_atax: 0                 
          }         
          //let query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};
          let query:any;
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}, id_branch: {$eq:IDbranch}};         
          }
          this.getBill_details_byFields(query, {},{date:1},0)     
              .then((vhbill_details:any)=>{
                if(vhbill_details.length>0){       
                    let data = new Array();
                    for(let m=0; m < month_array.length; m++){
                      data[m] =  {};            
                      data[m].sales_btax = 0;  
                      data[m].sales_atax = 0;                                                                                                    
                    }
                    for(let j=0; j<vhbill_details.length; j++){
                      let vhbill_detail = vhbill_details[j];
                      if(vhbill_detail.date) {                         
                        let month = (new Date(vhbill_detail.date)).getMonth();                                                                               
                        for(let m=0; m < month_array.length; m++){
                          if(month_array[m]=== month){                                  
                            data[m].sales_btax = data[m].sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;  
                            data[m].sales_atax = data[m].sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity *(1 + vhbill_detail.tax / 100); 
                            json.sales_btax = json.sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;
                            json.sales_atax = json.sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100);
                          }                                                                                                                                     
                          }                                
                      }                
                    }                                 
                    json.docs = data;
                    json.size = month_array.length;                        
                    json.empty = false;                                   
                  }
                  resolve(json);   
              })               
      })    
    } 

 /**
   * lấy về mảng json.docs(array) doanh số theo một hoặc tất cả các chi nhánh
   * @example:
    this.vhQueryCafe.getReportSales_byIDbranch(starttime, endtime, 'fda3s2fd1a3sgghdfg1h')
        .then((reportSales)=>{
          console.log('reportSales', reportSales);
          console.log('reportSales.docs[0]', reportSales.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param IDbranch : 'all' or id_branch
   * @return : 
   * json = {docs(array), empty(boolean), size(number), sales_btax(number), sales_atax(number)}
   * trong đó docs = [{name(string), id_branch(string), sales_btax(number), sales_atax(number)}]
   */
  public getReportSales_byIDbranch(starttime:any, endtime:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                  
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,
          sales_btax: 0,
          sales_atax: 0                 
        }         
        let branchs:any = new Array();    
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
           branchs = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalBranchs(), 'name');  
           query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$eq: 1}};
        }else{
           let branch = this.getlocalBranch(IDbranch);            
           branchs.push(branch);
           query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$eq: 1}, id_branch: {$eq:IDbranch}};  
        }     
       
        this.getBill_details_byFields(query, {},{date:1},0)     
            .then((vhbill_details:any)=>{
              if(vhbill_details.length>0){       
                  let data = new Array();     
                  for(let j=0; j<branchs.length; j++){
                    data[j] = {};
                    data[j].id_branch = branchs[j]._id;
                    data[j].name = branchs[j].name;
                    data[j].sales_btax = 0;
                    data[j].sales_atax = 0;
                  }             
                  for(let i=0; i<vhbill_details.length; i++){
                    let vhbill_detail = vhbill_details[i];                                                                                            
                    for(let j=0; j<branchs.length; j++){                      
                      if(branchs[j]._id=== vhbill_detail.id_branch){   
                         
                        if(vhbill_detail.bill_type === 3){
                          data[j].sales_btax = data[j].sales_btax - Number(vhbill_detail.price) * vhbill_detail.quantity;  
                          data[j].sales_atax = data[j].sales_atax - Number(vhbill_detail.price) * vhbill_detail.quantity *(1 + vhbill_detail.tax / 100); 
                          json.sales_btax = json.sales_btax - Number(vhbill_detail.price) * vhbill_detail.quantity;
                          json.sales_atax = json.sales_atax - Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100);
                        }else{
                          data[j].sales_btax = data[j].sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;  
                          data[j].sales_atax = data[j].sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity *(1 + vhbill_detail.tax / 100); 
                          json.sales_btax = json.sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;
                          json.sales_atax = json.sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100);
                        }                                                                                                                                     
                      }                                    
                    }                                  
                  }                                 
                  json.docs = data;
                  json.size = branchs.length;                        
                  json.empty = false;                                   
              }              
              resolve(json);   
            })               
    })    
  } 



  /**  
   * @Usage Hàm này dùng trong page SẢN PHẨM CÓ DOANH SỐ BÁN GIẢM DẦN
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Products_byTime_DESC(starttime, endtime)
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime    
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, quantity, sales_btax, sales_atax}
   */
  public getReportSales_Products_byTime_DESC(starttime:any, endtime:any){
    return new Promise<any>((resolve, reject) => {   
      let products:any = this.getlocalProducts(); 
      let promise:any;     
      let query:any;   
      query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};
     
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0
      }  

      if(products.length>0){ 
        promise = this.getBill_details_byFields(query, {},{date:1},0); 
        promise.then((vhbill_details:any)=>{          
              if(vhbill_details.length>0){                
                for(let i=0; i<products.length; i++){       
                      let transaction = false;           
                      let product =  {...products[i]};                                   
                      let data:any ={   
                        id_product: product._id,                  
                        name: product.name, 
                        unit: product.unit,
                        barcode: product.barcode,
                        img: product.img,                                   
                        sales_btax: 0,
                        sales_atax: 0,
                        quantity: 0,
                        subs: new Array()
                      }  
                      if(product.subs != undefined)
                        for(let k=0; k<product.subs.length; k++){
                          let sub:any ={
                            id_subproduct: product.subs[k]._id,                    
                            name: product.subs[k]?.name,
                            sales_btax: 0,
                            sales_atax: 0,
                            quantity: 0                          
                          }
                          data.subs.push(sub);
                        }                                  
                          
                      for(let j=0; j<vhbill_details.length; j++){
                        if(products[i]._id ===vhbill_details[j].id_product){
                          transaction = true;                         
                          data.quantity = data.quantity + vhbill_details[j].quantity;
                          data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                          data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                          for(let k=0; k<data.subs.length; k++){
                            if(data.subs[k].id_subproduct === vhbill_details[j].id_subproduct){
                              data.subs[k].quantity = data.subs[k].quantity + vhbill_details[j].quantity;
                              data.subs[k].sales_btax = data.subs[k].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                              data.subs[k].sales_atax = data.subs[k].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                              break;
                            }
                          }                                                     
                        }
                      }
                      if(transaction){
                        json.quantity = json.quantity + data.quantity;
                        json.sales_btax = json.sales_btax + data.sales_btax;
                        json.sales_atax = json.sales_atax + data.sales_atax;
                        data.index = json.size + 1;
                        json.docs.push(data);
                        json.size++;                        
                        json.empty = false; 
                      }                                               
                }
              }                     
              json.docs = this.vhAlgorithm.sortNumberbyDESC(json.docs, 'sales_atax');       
              resolve(json);
            })
      }else resolve(json);      
    })
  }

    /**
   * @Usage Hàm này dùng trong page DANH MỤC CÓ DOANH SỐ BÁN GIẢM DẦN
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQueryCafe.getReportSales_Categorys_byTime_DESC(starttime, endtime)
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, id_category, quantity, sales_btax, sales_atax}
   */
  public getReportSales_Categorys_byTime_DESC(starttime:any, endtime:any){
    return new Promise<any>((resolve, reject) => { 
      let categorys:any = new Array();   
      categorys = this.getlocalCategorys();                      
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0 
      }               
      if(categorys.length>0){       
        let query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1]}};                
        this.getBill_details_byFields(query, {},{date:1},0)                   
          .then((vhbill_details:any)=>{       
                    if(vhbill_details.length>0){
                      for(let i=0; i<vhbill_details.length; i++){
                        let product = this.getlocalProduct(vhbill_details[i].id_product);
                        vhbill_details[i].id_category = product.id_category;
                      }                     
                      for(let i=0; i<categorys.length; i++){                                                        
                        let data:any ={   
                          id_category: categorys[i]._id,                  
                          name: categorys[i].name,                                                             
                          sales_btax: 0,
                          sales_atax: 0,
                          quantity: 0
                        }                                                  
                        for(let j=0; j<vhbill_details.length; j++){                           
                          if(categorys[i]._id ===vhbill_details[j].id_category){                              
                            data.quantity = data.quantity + vhbill_details[j].quantity;
                            data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                            data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                     
                          }
                        }
                        if(data.quantity != 0){
                          json.quantity = json.quantity + data.quantity;
                          json.sales_btax = json.sales_btax + data.sales_btax;
                          json.sales_atax = json.sales_atax + data.sales_atax;
                          data.index = json.size + 1;
                          json.docs.push(data);
                          json.size++;                        
                          json.empty = false; 
                        }                          
                      }
                    }   
                    json.docs = this.vhAlgorithm.sortNumberbyDESC(json.docs, 'sales_atax');                           
                    resolve(json);
                  })
      }else resolve(json);     
    })
  } 

/**   
 * lấy về danh sách sản phẩm đã hết hàng
 * @example:
 * this.vhQueryCafe.getReportMaterials_byOutOfStock()
        .then((products)=>{
          console.log(products);
        })
  * @param IDbranch: 'all' or id_branch;
  */
  public getReportMaterials_byOutOfStock(id_branch:string){
    return new Promise<any>((resolve, reject) => {          
      let products = this.getlocalDetailProducts(3);                              
      let outofstock = new Array();              
      for(let i=0; i<products.length; i++){              
        let unit = this.getUnit_byRatio(products[i].units, 1);                                        
        let record:any ={   
          id_product: products[i]._id,                  
          name: products[i].name, 
          img: products[i].img,   
          unit: unit.unit,
          barcode: unit.barcode,    
          price: unit.price,
          price2: unit.price2,
          price_import: unit.price_import,
          quantity: 0                                   
        }                                                  
        if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;   
        if(products[i].lots) {
          record.lots = new Array();
          for(let m=0; m<products[i].lots.length; m++){  
            let lot:any = {
              _id: products[i].lots[m]._id,
              barcode: products[i].lots[m].barcode,
              date_exp: products[i].lots[m].date_exp,
              date_mfg: products[i].lots[m].date_mfg,
              lot_number: products[i].lots[m].lot_number
            }
            if(products[i].lots[m].quantity_branch[id_branch]) {
              lot.quantity = products[i].lots[m].quantity_branch[id_branch];
              record.lots.push(lot);
            }
          }         
        } 
        if(products[i].quantity_branch[id_branch] !=undefined){
          if(products[i].quantity_branch[id_branch] <= 0){
            record.quantity =products[i].quantity_branch[id_branch];
            outofstock.push(record);
          }            
        }
      }
      console.log('getReportMaterials_byOutOfStock');
      resolve(outofstock);                                   
    })
  } 
  private getReportMaterials_byOutOfStock_old(IDbranch?:any){    
    return new Promise<any>((resolve, reject) => {     
      // this.makeCorrectQuantityMaterials()
      //     .then(()=>{
      //       this.refreshLocalProducts()
      //           .then(()=>{
                  let products = this.getlocalProducts(3);      
                  let branchs = this.getlocalBranchs();                              
                  let outofstock = new Array();                
                  if((IDbranch === 'all')||(IDbranch === undefined)){                                             
                    for(let i=0; i<products.length; i++){  
                      products[i].quantity = 0;
                      products[i].branchs = new Array();
                      for(let j=0; j<branchs.length; j++){  
                        if(products[i].quantity_branch[branchs[j]._id] === undefined){
                          products[i].quantity_branch[branchs[j]._id] = 0;
                        }
                        if(products[i].quantity_branch[branchs[j]._id] <= 0){
                          products[i].quantity = products[i].quantity + products[i].quantity_branch[branchs[j]._id];
                          let branch = {
                            id_branch: branchs[j]._id,
                            name: branchs[j].name,
                            quantity: products[i].quantity_branch[branchs[j]._id]
                          }
                          products[i].branchs.push(branch);  
                        }
                                              
                      } 
                      delete products[i].quantity_branch;
                    }   
                                                              
                    outofstock = products.filter((item:any) => (item.branchs.length >0));
                  }else{        
                    for(let i=0; i<products.length; i++){      
                      products[i].quantity = 0;
                      products[i].branchs = new Array();                     
                      if(products[i].quantity_branch[IDbranch] === undefined){
                        products[i].quantity_branch[IDbranch] = 0;
                      }
                      products[i].quantity = products[i].quantity_branch[IDbranch];

                      let branch = {
                        id_branch: IDbranch,
                        name: this.getlocalBranch(IDbranch).name,
                        quantity: products[i].quantity_branch[IDbranch]
                      }
                      products[i].branchs.push(branch);    
                      delete products[i].quantity_branch;
                    }
                    outofstock = products.filter((item:any) => {                      
                        if(item.quantity <= 0) return <any>true;                     
                    });                   
                  } 
                  resolve(outofstock);    
          //       })
          // })                                
    })
  }
        

  /**  
   * lấy về danh sách sản phẩm sắp hết hàng
   * @example:
   * this.vhQueryCafe.getReportMaterials_byLowInStock()
          .then((products)=>{
            console.log(products);
          })
   * @param IDbranch: 'all' or id_branch;      
   */
  public getReportMaterials_byLowInStock(id_branch:any){
    return new Promise<any>((resolve, reject) => {          
      let products = this.getlocalDetailProducts(3);                             
      let lowinstock = new Array();              
      for(let i=0; i<products.length; i++){                 
        let unit = this.getUnit_byRatio(products[i].units, 1);                                        
        let record:any ={   
          id_product: products[i]._id,                  
          name: products[i].name, 
          img: products[i].img,   
          unit: unit.unit,
          barcode: unit.barcode,    
          price: unit.price,
          price2: unit.price2,
          price_import: unit.price_import,
          quantity: 0                                   
        }                                                  
        if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;   
        if(products[i].lots) {
          record.lots = new Array();
          for(let m=0; m<products[i].lots.length; m++){  
            let lot:any = {
              _id: products[i].lots[m]._id,
              barcode: products[i].lots[m].barcode,
              date_exp: products[i].lots[m].date_exp,
              date_mfg: products[i].lots[m].date_mfg,
              lot_number: products[i].lots[m].lot_number
            }
            if(products[i].lots[m].quantity_branch[id_branch]) {
              lot.quantity = products[i].lots[m].quantity_branch[id_branch];
              record.lots.push(lot);
            }
          }         
        } 
        if(products[i].quantity_branch){
          if(products[i].quantity_branch[id_branch] != undefined){
            if(products[i].quantity_branch[id_branch] <= products[i].warning_number){
              record.quantity =products[i].quantity_branch[id_branch];
              lowinstock.push(record);
            }            
          }
        }else{
          
        }
      }       
      resolve(lowinstock);                                   
    })
  } 
  private getReportMaterials_byLowInStock_old(IDbranch?:any){    
    return new Promise<any>((resolve, reject) => {     
      // this.makeCorrectQuantityMaterials()
      //     .then(()=>{
      //       this.refreshLocalProducts()
      //           .then(()=>{
                  let products = this.getlocalProducts(3);                    
                  let branchs = this.getlocalBranchs();                             
                  let lowinstock = new Array();                
                  if((IDbranch === 'all')||(IDbranch === undefined)){                                        
                    for(let i=0; i<products.length; i++){  
                      products[i].quantity = 0;
                      products[i].branchs = new Array();
                      for(let j=0; j<branchs.length; j++){  
                        if(products[i].quantity_branch[branchs[j]._id] === undefined){
                          products[i].quantity_branch[branchs[j]._id] = 0;
                        }                        
                        
                        if(products[i].quantity_branch[branchs[j]._id] <= products[i].warning_number){
                          products[i].quantity = products[i].quantity + products[i].quantity_branch[branchs[j]._id];
                          let branch = {
                            id_branch: branchs[j]._id,
                            name: branchs[j].name,
                            quantity: products[i].quantity_branch[branchs[j]._id]
                          }
                          products[i].branchs.push(branch);   
                        }
                                               
                      } 
                      delete products[i].quantity_branch;
                    }                        
                    lowinstock = products.filter((item:any) => (item.branchs.length >0));
                  }else{        
                    for(let i=0; i<products.length; i++){      
                      products[i].quantity = 0;
                      products[i].branchs = new Array();                    
                      if(products[i].quantity_branch[IDbranch] === undefined){
                        products[i].quantity_branch[IDbranch] = 0;
                      }
                      products[i].quantity = products[i].quantity_branch[IDbranch];

                      let branch = {
                        id_branch: IDbranch,
                        name: this.getlocalBranch(IDbranch).name,
                        quantity: products[i].quantity_branch[IDbranch]
                      }
                      products[i].branchs.push(branch);    
                      delete products[i].quantity_branch;
                    }                    
                    lowinstock = products.filter((item:any) => {                      
                        if(item.quantity <= item.warning_number) return <any>true;                     
                    });                   
                  }
                  
                  resolve(lowinstock);    
          //       })
          // })                                
    })
  } 

  private makeCorrectQuantityMaterials(){
    return new Promise<any>((resolve, reject) => {      
      let products = this.getlocalProducts(3);        
      let branchs = this.getlocalBranchs();
      let query = {ptype: {$eq:3}, bill_type: {$in:[1,3,10,30,2,9,16,31]}};
        this.getBill_details_byFields(query, {},{date:1},0)      
            .then((bill_details:any)=>{                       
                if((products.length>0)&&(bill_details.length>0)){                     
                  let promise = new Array();             
                  for(let i=0; i<products.length; i++){      
                    let quantity =0;
                    let quantity_branch:any = {};
                    for(let m=0; m<branchs.length; m++){
                      quantity_branch[branchs[m]._id] = 0;                      
                    }
                    for(let j=0; j<bill_details.length; j++){
                      let bill_detail = bill_details[j];
                      if(products[i]._id === bill_detail.id_product){                              
                        if((bill_detail.bill_type ===1)||(bill_detail.bill_type ===3)||(bill_detail.bill_type ===10)||(bill_details[j].bill_type === 30)){
                          quantity = quantity - bill_detail.quantity;
                          if(quantity_branch[bill_detail.id_branch] !=undefined) quantity_branch[bill_detail.id_branch] = quantity_branch[bill_detail.id_branch] - bill_detail.quantity;
                          else quantity_branch[bill_detail.id_branch] = - bill_detail.quantity; 
                        }else if((bill_detail.bill_type ===2)||(bill_detail.bill_type ===9)||(bill_detail.bill_type ===16)||(bill_details[j].bill_type === 31)){
                          quantity = quantity + bill_detail.quantity;
                          if(quantity_branch[bill_detail.id_branch] !=undefined) {
                            quantity_branch[bill_detail.id_branch] = quantity_branch[bill_detail.id_branch] + bill_detail.quantity;                            
                          }
                          else {                            
                            quantity_branch[bill_detail.id_branch] = bill_detail.quantity; 
                          }                          
                        }
                      }        
                    }       
                    let check = false;
                    if(products[i].quantity !=quantity){              
                      check = true;                                                                   
                    }
                    for(const p in products[i].quantity_branch){
                      for(const q in quantity_branch){
                        if(p === q){
                          if(products[i].quantity_branch[p] === quantity_branch[q]){
                            check = true;   
                          }
                        }
                      }
                    }                   
                    if(check){                                                         
                      promise.push(this.updateProduct(products[i]._id, {quantity:quantity, quantity_branch: quantity_branch}));                                
                    }
                  }
                  Promise.all(promise).then(()=>{                    
                    resolve(null);
                  })
                }else resolve(null);              
              })
    })
  }

  /**
 * lấy về 1 bảng báo cáo kiểm kho (report) theo cấu trúc json ở dưới, nếu có cân bằng kho thì lấy về chung luôn
 * @example:
 * this.vhQueryCafe.getReportInventoryTime_byTimes('hNCda0obCvrX6qC3PZ0N')
      .then((reports)=>{
        console.log('getReportInventoryTime_byTimes',reports);          
      })
  * @param id_inventorytime 
  * @return Promise json = {docs(array), empty(boolean), size(number), total_stock(number), realstock, total_inventorynotes(array)}
  * docs(array) --> {id_product(string), id_subproduct(string), lots(array), name(string), img(string), ratio(number), barcode(string), unit(string), stock(number), inventorynotes(array), deviation(number), note(string), balance_quantity(number), balance_cause(string)}
  * inventorynotes(array) --> [{bill_code(string), quantity(number)},{},...]
  */
  public getReportInventoryTime_byTimes(id_inventorytime:any){     
    //inventorytime: đợt kiểm
    //inventorynote: phiếu kiểm
    return new Promise<any>((resolve, reject) => {       
          let inventorytime:any = this.getlocalInventorytime(id_inventorytime);//sau này sẽ bỏ hàm refresh của nó lúc khỏi động         
          let products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
          let id_branch = this.getDefaultBranch()._id;         
          let json:any = {
            balanced: false,
              docs:  new Array(), 
              empty: true,
              size: 0,       
              total_stock: 0, //tổng số lượng kiểm kho theo phần mềm
              total_realstock: 0, // tổng số lượng kiểm kho thực tế
              total_inventorynotes: new Array()
          }    
          if(products.length>0){                
            let bill_details_stock = new Array();
            let bill_details_inventorytime = new Array();
            let bills_inventorytime = new Array();
            let bill_details_3839 = new Array();
            let promise = new Array();
            let query_01 ={};
            let query_02 ={};
            if(products[0][id_branch + '_ivtr'] != undefined){
              query_01 = {date: {$gte:new Date(products[0][id_branch + '_ivtr'][products[0][id_branch + '_ivtr'].length-1].date), $lte:new Date(inventorytime.date)}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,41,51,2,9,16]}, id_branch: {$eq:id_branch}};
              query_02 = {date: {$gte:new Date(products[0][id_branch + '_ivtr'][products[0][id_branch + '_ivtr'].length-1].date), $lte:new Date(inventorytime.date)}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}};
            }else{
              query_01 = {date: {$gte: new Date(this.vhAuth.getStore().registrationdate), $lte:new Date(inventorytime.date)}, ptype: {$eq:3}, bill_type: {$in:[1,3,10,41,51,2,9,16]}, id_branch: {$eq:id_branch}};
              query_02 = {date: {$gte: new Date(this.vhAuth.getStore().registrationdate), $lte:new Date(inventorytime.date)}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}};
            }
            promise[promise.length] = new Promise<any>((resolve, reject)=>{
                          let promise_0 = new Array();
                          promise_0[0] = this.getBill_details_byFields(query_01, {},{date:1},0);     
                          promise_0[1] = this.getBill_details_byFields(query_02, {},{date:1},0);  
                          Promise.all(promise_0)    
                              .then((bill_details:any)=>{   
                                bill_details = bill_details.flat();
                                bill_details_stock = [...bill_details];                                                 
                                resolve(null);
                              })
                            })                   
            let query_1:any = {id_inventorytime: {$eq:id_inventorytime},  bill_type: {$in:[13]}};
            promise[promise.length] = new Promise<any>((resolve, reject)=>{
                        this.getBill_details_byFields(query_1, {},{date:1},0)            
                            .then((bill_details:any)=>{                                 
                              bill_details_inventorytime = [...bill_details];                                    
                              resolve(null);
                            })
                          })  
            let query_2:any = {id_inventorytime: {$eq:id_inventorytime},  bill_type: {$in:[13]}};
            promise[promise.length] = new Promise<any>((resolve, reject)=>{
                        this.getBills_byFields(query_2, {},{date:1},0)                           
                            .then((bills:any)=>{                                 
                              bills_inventorytime = [...bills];                                     
                              resolve(null);
                            })        
                          })    
            let query_3:any = {id_inventorytime: {$eq:id_inventorytime},  bill_type: {$in:[38,39]}};
            promise[promise.length] = new Promise<any>((resolve, reject)=>{
                        this.getBill_details_byFields(query_3, {},{date:1},0)                           
                            .then((bill_details:any)=>{                                 
                              if(bill_details.length>0){
                                json.balanced = true;
                                bill_details_3839 = [...bill_details];      
                              }                                                               
                              resolve(null);
                            })        
                          })        
            Promise.all(promise)
                .then(()=>{                  
                  let total_stock = 0;
                  let total_realstock = 0;
                  let inventorynotes_total = new Array();
                  for(let j=0; j<bills_inventorytime.length; j++){                
                    inventorynotes_total.push({bill_code: bills_inventorytime[j].bill_code, quantity: 0});
                  }

                  for(let i=0; i<products.length; i++){    
                    if(bill_details_inventorytime.filter((item:any)=>{
                      if(item.id_product === products[i]._id){
                        if(item.id_subproduct){
                          if(item.id_subproduct === products[i].id_subproduct) return <any>true;
                        }else{
                          return true;
                        }
                        return false;
                      }
                    }).length > 0){
                      let unit = this.getUnit_byRatio(products[i].units, 1);   
                      let record:any ={    
                        id_product: products[i]._id,  
                        name: products[i].name, 
                        img: products[i].img,  

                        ratio: unit.ratio,
                        unit: unit.unit,
                        barcode: unit.barcode,     
                                            
                        stock: 0,
                        realstock: 0,                        
                        inventorynotes: [],

                        deviation: '--',
                        note: '--',             
                        balance_quantity: '--',         
                        balance_cause: '--'
                      }    
                      if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;                        
                      if(products[i].lots) {
                        record.lots = new Array();
                        for(let m = 0; m<products[i].lots.length; m++){                                  
                          record.lots[m] = {};
                          record.lots[m]._id = products[i].lots[m]._id;   
                          record.lots[m].barcode = products[i].lots[m].barcode;
                          record.lots[m].date_exp = products[i].lots[m].date_exp;
                          record.lots[m].date_mfg = products[i].lots[m].date_mfg;
                          record.lots[m].lot_number = products[i].lots[m].lot_number;                          
                          record.lots[m].stock = 0;   
                          record.lots[m].realstock = 0;                               
                          
                          record.lots[m].inventorynotes = new Array();                            

                          record.lots[m].deviation = '--';        
                          record.lots[m].note = '--';             
                          record.lots[m].balance_quantity = '--';         
                          record.lots[m].balance_cause = '--';                         
                        }

                        record.note = '';             
                        record.balance_quantity = '';         
                        record.balance_cause = '';
                      } 
                      //thêm số lượng sản phẩm đã kiểm cho mỗi record và record.lots
                      for(let j=0; j<bills_inventorytime.length; j++){                                         
                        record.inventorynotes.push({bill_code: bills_inventorytime[j].bill_code, quantity: 0});         
                        if(record.lots) {
                          for(let m = 0; m<record.lots.length; m++){     
                            record.lots[m].inventorynotes.push({bill_code: bills_inventorytime[j].bill_code, quantity: 0});       
                          }
                        }  
                      }     
                      
                      if(products[0][id_branch + '_ivtr'] != undefined){                           
                        if(products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length-1].lots)  {
                          for(let m = 0; m<products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length-1].lots.length; m++){
                            record.lots[m]._id = products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length-1].lots[m]._id;   
                            record.lots[m].stock = products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length-1].lots[m].stock_first;                           
                          }                          
                        }
                        record.stock = products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length-1].stock_first;
                      }
                      
                      for(let j=0; j<bill_details_stock.length; j++){ 
                        let is_sub_or_product = false;
                        if(products[i].id_subproduct) is_sub_or_product = bill_details_stock[j].id_subproduct === products[i].id_subproduct;
                        else is_sub_or_product = bill_details_stock[j].id_product === record.id_product;
                        if(bill_details_stock[j].ptype === 3){  
                          if(is_sub_or_product){  
                            let date = new Date(bill_details_stock[j].date);
                            if((bill_details_stock[j].bill_type === 1)||(bill_details_stock[j].bill_type === 3)||(bill_details_stock[j].bill_type === 10)||(bill_details_stock[j].bill_type === 30)||(bill_details_stock[j].bill_type === 38)||(bill_details_stock[j].bill_type === 41)||(bill_details_stock[j].bill_type === 51)){
                              if(bill_details_stock[j].id_lotproduct){
                                for(let m=0; m<record.lots.length; m++){
                                  if(record.lots[m]._id === bill_details_stock[j].id_lotproduct){      
                                    record.lots[m].stock = record.lots[m].stock - bill_details_stock[j].quantity * bill_details_stock[j].ratio;     
                                  }
                                }
                              }
                              record.stock = record.stock - bill_details_stock[j].quantity * bill_details_stock[j].ratio;                               
                            }else if((bill_details_stock[j].bill_type === 2)||(bill_details_stock[j].bill_type === 9)||(bill_details_stock[j].bill_type === 16)||(bill_details_stock[j].bill_type === 31)||(bill_details_stock[j].bill_type === 39)){ 
                              
                              if(bill_details_stock[j].id_lotproduct){
                                for(let m=0; m<record.lots.length; m++){
                                  if(record.lots[m]._id === bill_details_stock[j].id_lotproduct){      
                                    record.lots[m].stock = record.lots[m].stock + bill_details_stock[j].quantity * bill_details_stock[j].ratio;     
                                  }
                                }
                              }
                              record.stock = record.stock + bill_details_stock[j].quantity * bill_details_stock[j].ratio; 
                            }                                                      
                          } 
                        }                                    
                      }                

                      for(let j=0; j<bill_details_inventorytime.length; j++){
                        let is_sub_or_product = false;
                        if(record.id_subproduct) is_sub_or_product = bill_details_inventorytime[j].id_subproduct === record.id_subproduct;
                        else is_sub_or_product = bill_details_inventorytime[j].id_product === products[i]._id;
                        for(let k=0; k<record.inventorynotes.length; k++){                          
                          if(is_sub_or_product){    
                            if(record.inventorynotes[k].bill_code === bill_details_inventorytime[j].bill_code){
                              if(bill_details_inventorytime[j].id_lotproduct){
                                for(let m=0; m<record.lots.length; m++){
                                  if(record.lots[m]._id === bill_details_inventorytime[j].id_lotproduct){      
                                    record.lots[m].realstock = record.lots[m].realstock + bill_details_inventorytime[j].quantity * bill_details_inventorytime[j].ratio;
                                    record.lots[m].inventorynotes[k].quantity = record.lots[m].inventorynotes[k].quantity +  bill_details_inventorytime[j].quantity * bill_details_inventorytime[j].ratio;
                                  }
                                }
                              }
                        
                              record.realstock = record.realstock + bill_details_inventorytime[j].quantity * bill_details_inventorytime[j].ratio;
                              record.inventorynotes[k].quantity =  record.inventorynotes[k].quantity + bill_details_inventorytime[j].quantity * bill_details_inventorytime[j].ratio;                              
                              //xem lại hàm dưới
                              inventorynotes_total[k].quantity = inventorynotes_total[k].quantity  + bill_details_inventorytime[j].quantity * bill_details_inventorytime[j].ratio
                            }
                          }
                        }
                      }   
                      
                      //tính toán các giá trị deviation, note, balance
                      if(record.lots){
                        for(let m=0; m<record.lots.length; m++){
                          record.lots[m].deviation = record.lots[m].realstock - record.lots[m].stock;
                          if(record.lots[m].deviation > 0) {
                            record.lots[m].note = 'Dư kho';
                            record.note = 'Lệch kho';
                          }else if(record.lots[m].deviation < 0){ 
                            record.lots[m].note = 'Thiếu kho';
                            record.note = 'Lệch kho';
                          }else if(record.lots[m].deviation === 0){
                            record.lots[m].note = 'Đủ kho';
                          }      
                        }
                        if(record.note != 'Lệch kho') record.note = 'Đủ kho'
                        record.deviation = record.realstock - record.stock;
                      }else{
                        record.deviation = record.realstock - record.stock;
                        if(record.deviation > 0) record.note = 'Dư kho';
                        else if(record.deviation < 0) record.note = 'Thiếu kho';
                        else if(record.deviation === 0) record.note = 'Đủ kho';                         
                      }                      
                      
                      for(let j=0; j<bill_details_3839.length; j++){
                        let is_sub_or_product = false;
                        if(record.id_subproduct) is_sub_or_product = bill_details_3839[j].id_subproduct === record.id_subproduct;
                        else is_sub_or_product = bill_details_3839[j].id_product === record.id_product;

                        if(bill_details_3839[j].bill_type === 38){
                          if(is_sub_or_product){
                            if(record.lots){
                              for(let m=0; m<record.lots.length; m++){
                                if(record.lots[m]._id === bill_details_3839[j].id_lotproduct){
                                  record.lots[m].balance_quantity = bill_details_3839[j].quantity * bill_details_3839[j].ratio;     
                                  record.lots[m].balance_cause = 'Xuất hủy';  
                                }
                              }
                            }else{
                              record.balance_quantity = bill_details_3839[j].quantity * bill_details_3839[j].ratio;       
                              record.balance_cause = 'Xuất hủy';
                            }
                          }
                        }else if(bill_details_3839[j].bill_type === 39){
                          if(is_sub_or_product){
                            if(record.lots){
                              for(let m=0; m<record.lots.length; m++){
                                if(record.lots[m]._id === bill_details_3839[j].id_lotproduct){
                                  record.lots[m].balance_quantity = bill_details_3839[j].quantity * bill_details_3839[j].ratio;     
                                  record.lots[m].balance_cause = 'Nhập bù';  
                                }
                              }
                            }else{                              
                              record.balance_quantity = bill_details_3839[j].quantity * bill_details_3839[j].ratio;       
                              record.balance_cause = 'Nhập bù';
                            }
                          }
                        }
                      }
      
                      total_stock = total_stock + record.stock;
                      total_realstock = total_realstock + record.realstock;
                    
                      json.docs.push(record);
                      json.empty = false;
                      json.size++; 
                    }                   
                  }
    
                  json.total_stock =  total_stock; 
                  json.total_realstock = total_realstock;
                  json.total_inventorynotes =  [...inventorynotes_total];       
                  console.log('getReportInventoryTime_byTimes', json);                              
                  resolve(json);
                })                      
          }          
      
    })
  }
  
  /**
   * lấy về 1 bảng báo cáo (report) theo cấu trúc json ở dưới
   * @example:
   * this.vhQueryCafe.getReportInventoryTime_byTimes('hNCda0obCvrX6qC3PZ0N')
        .then((reports)=>{
          console.log('reports',reports);          
        })
   * @param id_inventorytime 
   * @return Promise json = {docs(array), empty(boolean), size(number), total_stock(number), total_inventorynotes(array)}
   * docs(array) --> {id(string), data()(object), stock(number), inventorynotes(array)}
   * inventorynotes(array) --> [{bill_code(string), quantity(number)},{},...]
   */
  private getReportInventoryTime_byTimes_old(id_inventorytime:any){ 
    return new Promise<any>((resolve, reject) => {       
          let inventorytime:any = this.getlocalInventorytime(id_inventorytime);
          let products = this.getlocalProducts(3);
          let json:any = {
            docs: new Array(),
            empty: true, 
            size:0        
          }    
          if(products.length>0){    
            json={
              docs:  new Array(), 
              empty: true,
              size: 0,       
              total_stock: 0,
              total_realstock: 0,
              total_inventorynotes: new Array()
            }    
            let bill_details_stock = new Array();
            let bill_details_inventorytime = new Array();
            let bills_inventorytime = new Array();
            let promise = new Array();
            let query_0 = {date: {$lte:inventorytime.date}, ptype: {$eq:3},  bill_type: {$in:[1,3,10,2,9,16]}};
            promise[0] = this.getBill_details_byFields(query_0, {},{date:1},0)
                              .then((bill_details:any)=>{   
                                bill_details_stock = [...bill_details];                                
                              })
            let query_1:any = {id_inventorytime: {$eq:id_inventorytime},  bill_type: {$in:[13]}};
            promise[1] = this.getBill_details_byFields(query_1, {},{date:1},0)
                              .then((bill_details:any)=>{   
                                bill_details_inventorytime = [...bill_details];
                              })
            let query_2:any = {id_inventorytime: {$eq:id_inventorytime},  bill_type: {$in:[13]}};
            promise[2] = this.getBills_byFields(query_2, {},{date:1},0)                
                            .then((bills:any)=>{   
                              bills_inventorytime = [...bills];
                            })                 
            Promise.all(promise)
                .then(()=>{
                  let total_stock = 0;
                  let total_realstock = 0;
                  let inventorynotes_total = new Array();
                  for(let j=0; j<bills_inventorytime.length; j++){
                    let note1 = {
                      bill_code: bills_inventorytime[j].bill_code, 
                      quantity: 0
                    };        
                    inventorynotes_total.push(note1);
                  }
                  for(let i=0; i<products.length; i++){      
                    if(products[i].type === 3){
                      let stock = 0;
                      for(let j=0; j<bill_details_stock.length; j++){
                        if(products[i]._id === bill_details_stock[j].id_product){          
                          if((bill_details_stock[j].bill_type ===1)||(bill_details_stock[j].bill_type ===3)||(bill_details_stock[j].bill_type ===10)){
                            stock = stock - bill_details_stock[j].quantity;
                          }else if((bill_details_stock[j].bill_type ===2)||(bill_details_stock[j].bill_type ===9)||(bill_details_stock[j].bill_type ===16)){
                            stock = stock + bill_details_stock[j].quantity;
                          }
                        }        
                      }       
                      let inventorynotes = new Array();       
                      let realstock = 0;
                      for(let j=0; j<bills_inventorytime.length; j++){
                        let note2 = {
                          bill_code: bills_inventorytime[j].bill_code, 
                          quantity: 0
                        };
                        inventorynotes.push(note2);           
                      }
                      for(let j=0; j<bill_details_inventorytime.length; j++){
                        for(let k=0; k<inventorynotes.length; k++){
                          if(products[i]._id === bill_details_inventorytime[j].id_product){    
                            if(inventorynotes[k].bill_code === bill_details_inventorytime[j].bill_code){
                              inventorynotes[k].quantity =  bill_details_inventorytime[j].quantity;
                              realstock = realstock + bill_details_inventorytime[j].quantity;
                              inventorynotes_total[k].quantity = inventorynotes_total[k].quantity + bill_details_inventorytime[j].quantity;
                            }
                          }
                        }
                      }
      
                      total_stock = total_stock + stock;
                      total_realstock = total_realstock + realstock;
                      let data ={    
                        _id: products[i]._id,                  
                        data(){
                          let data = products[i];
                          delete products[i]._id;
                          return data;
                        },
                        stock: stock,
                        realstock: realstock,
                        inventorynotes: inventorynotes
                      }
      
                      json.docs.push(data);
                      json.empty = false;
                      json.size++;
                    }
                  }
    
                  json.total_stock =  total_stock; 
                  json.total_realstock = total_realstock;
                  json.total_inventorynotes =  [...inventorynotes_total];                                     
                  resolve(json);
                })                      
          }          
      
    })
  }

  
  /**
   * Tạo cân bằng kho
   * @example:
   * this.vhQueryCafe.createBalanceInventoryTime_byTimes('hNCda0obCvrX6qC3PZ0N')
        .then((bool:any)=>{
          console.log('createBalanceInventoryTime_byTimes',bool);          
        })
  * @param id_inventorytime 
  * @return Promise boolean => true or false
  */
  public createBalanceInventoryTime_byTimes(id_inventorytime:any){
    return new Promise<any>((resolve, reject) => {    
      let inventorytime:any = this.getlocalInventorytime(id_inventorytime);  
      this.deleteBalanceInventoryTime_byTimes(id_inventorytime)
          .then(()=>{          
            this.getReportInventoryTime_byTimes(id_inventorytime)
                .then((json)=>{
                  let promise = new Array();
                  if(json.size >0){                    
                    for(let i=0; i<json.size; i++){
                      let record = {...json.docs[i]};
                      if(record.lots){
                        let promise_lot = new Array();
                        let bill_details_balance = new Array(); //bill_details xuất hủy
                        //let bill_details_i = new Array(); //bill_details thêm bù
                        promise[promise.length] = new Promise(resolve=>{
                          for(let m=0; m<record.lots.length; m++){
                            if(record.lots[m].deviation <0){
                              promise_lot[promise_lot.length] = new Promise(resolve=>{
                                let bill_detail:any = {};
                                bill_detail.id_branch = this.getDefaultBranch()._id;
                                bill_detail.bill_code = this.vhAlgorithm.createBillCode(),//chọn lại thời gian cho đúng với bill_code 
                                bill_detail.bill_type = 38; //xuất hủy kho    
                                bill_detail.tax = 0;        
                                bill_detail.date = new Date(inventorytime.date);//thời gian của đợt kiểm
                                bill_detail.id_inventorytime = id_inventorytime;
                                bill_detail.id_employee = this.vhAuth.getUser()._id;     

                                bill_detail.quantity = - record.lots[m].deviation;
                                bill_detail.ratio = record.ratio;
                                bill_detail.ptype = 3;
                                bill_detail.price = 0;
                                bill_detail.id_product = record.id_product;
                                if(record.id_subproduct) bill_detail.id_subproduct = record.id_subproduct;       
                                bill_detail.id_lotproduct = record.lots[m]._id;                
                            
                                this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill_detail.date), bill_detail)                     
                                    .then((message:any)=>{                                                               
                                        bill_detail.balance_negative_or_positive = 1; //số liệu kiểm thực tế nhỏ hơn số liệu kho trên phần mề); lúc này gọi là cân bằng âm (sẽ xuất hủy đi phần chênh lệch này)
                                        bill_details_balance.push(bill_detail);
                                        //console.log('bill_details_balance1', bill_details_balance);       
                                        resolve(true);
                                    })                        
                              })
                            }else if(record.lots[m].deviation >0){
                              promise_lot[promise_lot.length] = new Promise(resolve=>{
                                let bill_detail:any = {};
                                bill_detail.id_branch = this.getDefaultBranch()._id;
                                bill_detail.bill_code = this.vhAlgorithm.createBillCode(),//chọn lại thời gian cho đúng với bill_code 
                                bill_detail.bill_type = 39; //nhập bù kho    
                                bill_detail.tax = 0;        
                                bill_detail.date = new Date();//thời gian của đợt kiểm
                                bill_detail.id_inventorytime = id_inventorytime;
                                bill_detail.id_employee = this.vhAuth.getUser()._id;     

                                bill_detail.quantity = record.lots[m].deviation;
                                bill_detail.ratio = record.ratio;
                                bill_detail.ptype = 3;
                                bill_detail.price = 0;
                                bill_detail.id_product = record.id_product;
                                if(record.id_subproduct) bill_detail.id_subproduct = record.id_subproduct;                    
                                bill_detail.id_lotproduct = record.lots[m]._id;      

                                this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill_detail.date), bill_detail)                     
                                    .then((message:any)=>{                                                                   
                                        bill_detail.balance_negative_or_positive = 2; //số liệu kiểm thực tế lớn hơn số liệu kho trên phần mề); lúc này gọi là cân bằng dương (sẽ nhập bù thêm vào)
                                        bill_details_balance.push(bill_detail);
                                        //console.log('bill_details_balance2', bill_details_balance);    
                                        resolve(true);   
                                    })                        
                              })
                            }
                            
                          }
                          Promise.all(promise_lot)
                                .then(()=>{
                                  let promise_products = new Array();
                                  let id_branch = this.getDefaultBranch()._id;
                                  for(let i=0; i<bill_details_balance.length; i++){  
                                    //console.log('bill_details_balance3', bill_details_balance);
                                    //theo yêu cầu cân bằng dương hay cân bằng âm mà xóa bỏ đi hoặc thêm bù vào, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                                    if(!bill_details_balance[i].calculated){                                                              
                                      let id_sub_or_product = bill_details_balance[i].id_subproduct?bill_details_balance[i].id_subproduct:bill_details_balance[i].id_product
                                      let product = this.getlocalDetailProduct(id_sub_or_product);  
                                      let quantity_all_bill_details = 0;       
                                      let lots = new Array();
                                      if(bill_details_balance[i].id_lotproduct) lots = product.lots;            
                                      for(let j=0; j<bill_details_balance.length; j++){     
                                        if(!bill_details_balance[j].calculated){                               
                                          if(id_sub_or_product === (bill_details_balance[j].id_subproduct?bill_details_balance[j].id_subproduct:bill_details_balance[j].id_product)){   
                                            if(bill_details_balance[j].balance_negative_or_positive === 1){                                           
                                              quantity_all_bill_details = quantity_all_bill_details - bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                              bill_details_balance[j].calculated = true;
                                              for(let m=0; m<lots.length; m++){
                                                if(lots[m]._id === bill_details_balance[j].id_lotproduct){
                                                  lots[m].quantity = lots[m].quantity - bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                                  lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] - bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                                }
                                              }
                                            }else if(bill_details_balance[j].balance_negative_or_positive === 2){ 
                                              quantity_all_bill_details = quantity_all_bill_details + bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                              bill_details_balance[j].calculated = true;
                                              for(let m=0; m<lots.length; m++){
                                                if(lots[m]._id === bill_details_balance[j].id_lotproduct){
                                                  lots[m].quantity = lots[m].quantity + bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                                  lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] + bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                                }
                                              }
                                            }
                                          }                                        
                                        }                                          
                                      }                                                                                         
                                      let quantity_branch = {...product.quantity_branch};     
                                      quantity_branch[id_branch] = quantity_branch[id_branch] + quantity_all_bill_details;                                 
                                      let quantity = product.quantity + quantity_all_bill_details;                                  
                                      if(lots.length >0){             
                                        promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, lots: lots});       
                                      }                                                                                                                  
                                    }                                                                                             
                                                                  
                                  }  
                                  this.vhQuery.asyncPromiseAll(promise_products)
                                      .then(()=>{  
                                        resolve(null)
                                      })  
                                })
                        })
                      }else{                       
                        if(record.deviation <0){
                          promise[promise.length] = new Promise(resolve=>{
                            let bill_detail:any = {};
                            bill_detail.id_branch = this.getDefaultBranch()._id;
                            bill_detail.bill_code = this.vhAlgorithm.createBillCode(),//chọn lại thời gian cho đúng với bill_code 
                            bill_detail.bill_type = 38; //xuất hủy kho    
                            bill_detail.tax = 0;        
                            bill_detail.date = new Date(inventorytime.date);//thời gian của đợt kiểm
                            bill_detail.id_inventorytime = id_inventorytime;
                            bill_detail.id_employee = this.vhAuth.getUser()._id;     

                            bill_detail.quantity = - record.deviation;
                            bill_detail.ratio = record.ratio;
                            bill_detail.ptype = 3;
                            bill_detail.price = 0;
                            bill_detail.id_product = record.id_product;
                            if(record.id_subproduct) bill_detail.id_subproduct = record.id_subproduct;                       
                        
                            this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill_detail.date), bill_detail)                     
                                .then((message:any)=>{   
                                    //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                         
                                    this.calculateQuantityProduct_DOWN([{...bill_detail}], bill_detail.id_branch)
                                    .then(()=>{
                                      resolve(true);
                                    })     
                                })                        
                          })
                        }else if(record.deviation >0){
                          promise[promise.length] = new Promise(resolve=>{
                            let bill_detail:any = {};
                            bill_detail.id_branch = this.getDefaultBranch()._id;
                            bill_detail.bill_code = this.vhAlgorithm.createBillCode(),//chọn lại thời gian cho đúng với bill_code 
                            bill_detail.bill_type = 39; //nhập bù kho    
                            bill_detail.tax = 0;        
                            bill_detail.date = new Date();//thời gian của đợt kiểm
                            bill_detail.id_inventorytime = id_inventorytime;
                            bill_detail.id_employee = this.vhAuth.getUser()._id;     

                            bill_detail.quantity = record.deviation;
                            bill_detail.ratio = record.ratio;
                            bill_detail.ptype = 3;
                            bill_detail.price = 0;
                            bill_detail.id_product = record.id_product;
                            if(record.id_subproduct) bill_detail.id_subproduct = record.id_subproduct;                    
                        
                            this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill_detail.date), bill_detail)                     
                                .then((message:any)=>{   
                                    //Sau khi nhập, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                         
                                    this.calculateQuantityProduct_UP([{...bill_detail}], bill_detail.id_branch)
                                    .then(()=>{
                                      resolve(true);
                                    })     
                                })                        
                          })
                        }
                      }                     
                    }
                  }
                  Promise.all(promise)
                      .then(()=>{            
                        this.vhMGDB_database.updateDoc('inventorytimes', id_inventorytime, {balanced:true});     
                        resolve(true);                       
                        // this.getReportInventoryTime_byTimes(id_inventorytime)
                        //     .then((reports)=>{
                        //       //console.log('reports',reports);   
                        //       resolve(reports);       
                        //     })
                      })        
                })
          })
    })    
  }

  /**
    * Xóa cân bằng kho
    * @example:
    * this.vhQueryCafe.deleteBalanceInventoryTime_byTimes('hNCda0obCvrX6qC3PZ0N')
        .then((bool:any)=>{
          console.log('deleteBalanceInventoryTime_byTimes',bool);          
        })
  * @param id_inventorytime 
  * @return Promise boolean => true or false
  */
  public deleteBalanceInventoryTime_byTimes(id_inventorytime:any){
    return new Promise<any>((resolve, reject) => {    
      let promise = new Array(); 
        promise[promise.length] = new Promise(resolve=>{
        let query_delete:any = {id_inventorytime: {$eq:id_inventorytime},  bill_type: {$in:[38,39]}};      
        this.getBill_details_byFields(query_delete, {},{date:1},0)                           
            .then((bill_details:any)=>{   
              if(bill_details.length >0){
                let promise_zero = new Array();
                for(let i=0; i<bill_details.length; i++){
                  promise_zero[promise_zero.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill_details[i].date), bill_details[i]._id)
                }    
                Promise.all(promise_zero)
                      .then(()=>{
                        let promise_one = new Array();
                        let bill_details_38 = bill_details.filter((e:any)=>e.bill_type=== 38);                     
                        //Sau khi xóa bill_type_38, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                         
                        promise_one[promise_one.length] = this.calculateQuantityProduct_UP([{...bill_details_38}], this.getDefaultBranch()._id)
                          
                        let bill_details_39 = bill_details.filter((e:any)=>e.bill_type===39);
                        //Sau khi xóa bill_type_39, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                         
                        promise_one[promise_one.length] = this.calculateQuantityProduct_DOWN([{...bill_details_39}], this.getDefaultBranch()._id)
                        Promise.all(promise_one)
                              .then(()=>{   
                                resolve(true);
                              })                      
                      })                            
              }else{
                resolve(true);
              }                      
            }) 
      })    
      Promise.all(promise)
            .then(()=>{     
              this.vhMGDB_database.updateDoc('inventorytimes', id_inventorytime, {balanced:false});
              resolve(true);                             
              // this.getReportInventoryTime_byTimes(id_inventorytime)
              //     .then((reports)=>{                    
              //       resolve(reports);       
              //     })
            })           
    })   
  }

  
  /*****************************************************************************************************
   ******************************* CHƯƠNG TRÌNH BÁN HÀNG CAFE VIETHAS***********************************************
   *****************************************************************************************************/
  /******************************************TÍCH ĐIỂM THEO HÓA ĐƠN*************************************/

/**
 * @example:
 *  let data ={
      name : 'chương trình tích điểm hóa đơn',
      exchange :{
        money : 100000,
        points : 1
      },
      bill_total_minimum :0,
      payment  :{
        enable : true,
        money : 100000,
        points : 1
      },
      include_discount: false,
      include_promotion_product : false,
      include_paid_points : false,
      include_tax : false,
      include_fee : false,
      //id_branch : '5fb6780ca2148e09806c5b01',  //trong hàm đã thêm vào
      earned_points_clear_auto:{
        enable,
        months_of_year: 1
      }
    }
   this.vhQueryCafe.addEarningPointsBill(data)
        .then((earningpoint)=>{
          console.log('addEarningPointsBill', earningpoint);
        },(error:any)=>{
          console.log('error', error);
        })
  * @param data 
  * @return  Promise => obj = {}
  */
  public addEarningPointsBill(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('earning_points_bills', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }  
/**
 * @example:
  let data ={
      name : 'chương trình tích điểm hóa đơn',
      exchange :{
      money : 100000,
      points : 1
      },
      bill_total_minimum :0,
      payment  :{
        enable : true,
        money : 100000,
        points : 1
    },
    include_discount: false,
    include_promotion_product : false,
    include_paid_points : false,
    include_tax : false,
    include_fee : false,
    id_branch : '5fb6780ca2148e09806c5b01'
  }
  * @param id_earning_points_bill 
  * @param data 
  * @return Promise => bool = true or false 
  */
  public updateEarningPointsBill(id_earning_points_bill:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('earning_points_bills', id_earning_points_bill, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
  
  /**
   * @example:
   * this.vhQueryCafe.deleteEarningPointsBill('5fb67fda87c0f21d484cbdf3')
      .then((bool:any)=>{
        console.log('deleteEarningPointsBill', bool);
      })
  * @param id_earning_points_bill 
  * @return Promise => bool = true or false 
  */
  public deleteEarningPointsBill(id_earning_points_bill:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('customer_classs',{id_earning_points_bill:{$eq:id_earning_points_bill}})
          .then((customer_classs:any)=>{       
            for(let i=0; i<customer_classs.length; i++){
              this.vhMGDB_database.updateDoc('customer_classs', customer_classs[i]._id, {id_earning_points_bill:null});
            }       
            this.vhMGDB_database.deleteDoc('earning_points_bills', id_earning_points_bill)
                .then((bool:any)=>{            
                  resolve(bool);
                }, error=>{
                  reject(error)
                })  
          },(error:any)=>{
            reject(error);
          })              
    })
  }

  /**
   * @example
   * this.vhQueryCafe.getEarningPointsBill('5fb67fda87c0f21d484cbdf3')
            .then((earning_points_bill)=>{
              console.log('getEarningPointsBill', earning_points_bills);
            },(error:any)=>{
              reject(error);
            })  
    * @param id_earning_points_bill 
    * @return Promise => obj ={} or null
    */
    public getEarningPointsBill(id_earning_points_bill:string){
      return new Promise((resolve, reject) => {
        this.vhMGDB_database.getDoc('earning_points_bills', id_earning_points_bill)
              .then((earning_points_bill)=>{
                resolve(earning_points_bill);
              }, error=>{
                reject(error);
              })          
      })
    }

  /**
   * @example
   * this.vhQueryCafe.getEarningPointsBills()
            .then((earning_points_bills)=>{
              console.log('getEarningPointsBills', earning_points_bills);
            })
    * @return Promise => array(object) = [{},{},..]
    */
  public getEarningPointsBills(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('earning_points_bills')
              .then((earning_points_bills)=>{              
                resolve(earning_points_bills);
              },(error:any)=>{
                reject(error);
              })          
      }else{
        this.vhMGDB_database.getDocsByFields('earning_points_bills', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((earning_points_bills)=>{              
              resolve(earning_points_bills);
            },(error:any)=>{
              reject(error);
            }) 
      } 
    })
  } 

  /**
 * @example:
 *  let data ={
      name : 'chương trình tích điểm sản phẩm',
      exchange :{
        money : 100000,
        points : 1
      },
      payment  :{
        enable : true,
        money : 100000,
        points : 1
      },
      products:['05ztAR5h3UslYo70Amut','0S8NOcG8wEUYWVo1weHV','0tmbM5SyGe5O1mvuh61l',...],      
      include_promotion_product : false,
      include_paid_points : false,
      //id_branch : '5fb6780ca2148e09806c5b01' //trong hàm đã thêm vào
    }
    this.vhQueryCafe.addEarningPointsProduct(data)
        .then((res)=>{
          console.log('addEarningPointsProduct', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return Promise => object or error
  */
  public addEarningPointsProduct(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('earning_points_products', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example:
  let data ={
    name : 'chương trình tích điểm sản phẩm',
      exchange :{
      money : 100000,
      points : 1
    },
    payment  :{
      enable : true,
      money : 100000,
      points : 1
    },
    include_promotion_product : false,
    include_paid_points : false,
    id_branch : '5fb6780ca2148e09806c5b01'
  }
  * this.vhQueryCafe.updateEarningPointsProduct(id_earning_points_product,data)
        .then((bool:any)=>{
          console.log('updateEarningPointsProduct', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_earning_points_product
  * @param data
  * @return Promise => bool = true or false
  */
  public updateEarningPointsProduct(id_earning_points_product:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('earning_points_products', id_earning_points_product, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example:
 * this.vhQueryCafe.deleteEarningPointsProduct('654QFNMOIYUENC321')
        .then((bool:any)=>{
          console.log('deleteEarningPointsProduct', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_earning_points_product
  * @return Promise => bool = true or false
  */
  public deleteEarningPointsProduct(id_earning_points_product:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('customer_classs',{id_earning_points_product:{$eq:id_earning_points_product}})
          .then((customer_classs:any)=>{       
            for(let i=0; i<customer_classs.length; i++){
              this.vhMGDB_database.updateDoc('customer_classs', customer_classs[i]._id, {id_earning_points_product:null});
            }       
            this.vhMGDB_database.deleteDoc('earning_points_products', id_earning_points_product)
                .then((bool:any)=>{            
                  resolve(bool);
                }, error=>{
                  reject(error)
                })  
          },(error:any)=>{
            reject(error);
          })                     
    })
  }
/**
 * @example:
 * this.vhQueryCafe.getEarningPointsProduct('654QFNMOIYUENC321')
        .then((res)=>{
          console.log('getEarningPointsProduct', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_earning_points_product
  * @return Promise => object or null
  */
  public getEarningPointsProduct(id_earning_points_product:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('earning_points_products', id_earning_points_product)
            .then((earning_points_product)=>{
              resolve(earning_points_product);
            }, error=>{
                reject(error);
            })          
    })
  }
/**
 * @example: 
 * this.vhQueryCafe.getEarningPointsProducts()
        .then((arr)=>{
          console.log('getEarningPointsProducts', arr);
        }, error=>{
          console.log('error', error);
        })
  * @return Promise => Array<object>
  */
  public getEarningPointsProducts(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('earning_points_products')
              .then((earning_points_products)=>{              
                resolve(earning_points_products);
              },(error:any)=>{
                reject(error);
              })          
      }else{
        this.vhMGDB_database.getDocsByFields('earning_points_products', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((earning_points_products)=>{              
              resolve(earning_points_products);
            },(error:any)=>{
              reject(error);
            }) 
      }          
    })
  }

// *Hạng nhân viên --------------------------------------------------------------
/**
 * @example: 
 * this.vhQueryCafe.addEmployeeClass({name : "Gold"})
        .then((res)=>{
          console.log('addEmployeeClass', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return Promise => object or error
  */
  public addEmployeeClass(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('employee_classs', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example: 
 * this.vhQueryCafe.updateEmployeeClass('KNOVIYWKN135468',{id_commission : "321SDWC65DWSVDFS"})
        .then((bool:any)=>{
          console.log('updateEmployeeClass', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_employee_class
  * @param data
  * @return Promise => bool = true or false
  */
  public updateEmployeeClass(id_employee_class:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('employee_classs', id_employee_class, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example: 
 * this.vhQueryCafe.deleteEmployeeClass('KNOVIYWKN135468')
        .then((bool:any)=>{
          console.log('deleteEmployeeClass', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_employee_class
  * @return Promise => bool = true or false
  */
  public deleteEmployeeClass(id_employee_class:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('employee_classs', id_employee_class)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example: 
 * this.vhQueryCafe.getEmployeeClass('KNOVIYWKN135468')
        .then((res)=>{
          console.log('getEmployeeClass', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_employee_class
  * @return Promise => object or null
  */
  public getEmployeeClass(id_employee_class:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('employee_classs', id_employee_class)
            .then((customer_class)=>{
              resolve(customer_class);
            }, error=>{
                reject(error);
            })          
    })
  }
/**
 * @example: 
 * this.vhQueryCafe.getEmployeeClasss()
        .then((array:any)=>{
          console.log('getEmployeeClasss', array);
        }, error=>{
          console.log('error', error);
        })
  * @param id_employee_class
  * @return Promise => Array<object>
  */
  public getEmployeeClasss(){
    return new Promise((resolve, reject) => {   
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('employee_classs')
            .then((employee_classs)=>{              
              resolve(employee_classs);
            },(error:any)=>{
              reject(error);
            })             
      }else{
        this.vhMGDB_database.getDocsByFields('employee_classs', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((employee_classs)=>{              
              resolve(employee_classs);
            },(error:any)=>{
              reject(error);
            }) 
      }                
    })
  }

  /**
   * trong local chưa có
   * @example: 
   * let employee_classs = this.vhQueryCafe.getlocalEmployeeClasss() 
    * @param data
    * @return Array<object>
    */
  public getlocalEmployeeClasss(){

  }
  /**
  * trong local chưa có
  * @example: 
  * let employee_class = this.vhQueryCafe.getlocalEmployeeClass('321987965DOIUEHN') 
  * @param id_employee_class
  * @return object or null
  */
  public getlocalEmployeeClass(id_customer_class:any){

  }

//Phiếu thanh toán ------------------------------------------------------------
/**
 * @example: 
 * let data = {
 * name:"Phiếu thanh toán 100k",
 * value : 100000,
 * point : 1000,
 * id_design_barcode : "",
 * //id_branch :" 316OIUHLKMLSDYW235" //trong hàm đã có thêm vào
 * }
 * this.vhQueryCafe.addCoupon(data)
        .then((res)=>{
          console.log('addCoupon', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return Promise => object or error
  */
  public addCoupon(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('coupons', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
  * @example: 
  * let data = {
  * name:"Phiếu thanh toán 100k",
  * value : 100000,
  * point : 1000,
  * id_design_barcode : "",
  * }
  * this.vhQueryCafe.updateCoupon('FBHYWIBDNIUH1321687',data)
        .then((bool:any)=>{
          console.log('updateCoupon', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @param id_coupon
  * @return Promise => bool = true or false
  */
  public updateCoupon(id_coupon:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('coupons', id_coupon, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
  * @example:  
  * this.vhQueryCafe.deleteCoupon("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteCoupon', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do coupon đã được phát hành, vui lòng xóa đợt phát hành liên quan
  */
  public deleteCoupon(id_coupon:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_release_details', {id_coupon:{$eq:id_coupon}}, {})
          .then((coupon_release_details:any)=>{
            if(coupon_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('coupons', id_coupon)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_coupon: ${id_coupon} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do coupon đã được phát hành, vui lòng xóa đợt phát hành liên quan'})           
          }, error=>{
            reject(error)
          })             
    })
  }
/**
  * @example: 
  *
  * this.vhQueryCafe.getCoupon('FBHYWIBDNIUH1321687')
        .then((res)=>{
          console.log('getCoupon', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_coupon
  * @return Promise => object or null
  */
  public getCoupon(id_coupon:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('coupons', id_coupon)
            .then((coupon)=>{
              resolve(coupon);
            }, error=>{
                reject(error);
            })          
    })
  }
/**
  * @example: 
  * this.vhQueryCafe.getCoupons()
        .then((res)=>{
          console.log('getCoupons', res);
        }, error=>{
          console.log('error', error);
        })
  * @return Promise => Array<object>
  */
  public getCoupons(){
    return new Promise((resolve, reject) => {   
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('coupons')
            .then((coupons)=>{              
              resolve(coupons);
            },(error:any)=>{
              reject(error);
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('coupons', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((coupons)=>{              
              resolve(coupons);
            },(error:any)=>{
              reject(error);
            }) 
      }                  
    })
  }

/**
  * @example:  
  * this.vhQueryCafe.addCouponRelease({name : "Đợt phát hành phiếu thanh toán 100k",id_branch :'OHFNEIOUH6549846'})
        .then((res)=>{
          console.log('addCouponRelease', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return Promise => object or error
  */
  public addCouponRelease(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('coupon_releases', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
  * @example:  
  * this.vhQueryCafe.updateCouponRelease('ANOFIEUPOIUJ49861',{name : "Đợt phát hành phiếu thanh toán 100k"})
        .then((bool:any)=>{
          console.log('updateCouponRelease', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @param id_coupon_release
  * @return Promise => bool = true or false
  */
  public updateCouponRelease(id_coupon_release:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('coupon_releases', id_coupon_release, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
  * @example:  
  * this.vhQueryCafe.deleteCouponRelease("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteCouponRelease', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_release
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do trong đợt phát hành đã có coupon cần phát hành, vui lòng xóa coupon khỏi đợt phát hành
  */
  public deleteCouponRelease(id_coupon_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_release_details', {id_coupon_release:{$eq:id_coupon_release}}, {})
          .then((coupon_release_details:any)=>{
            if(coupon_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('coupon_releases', id_coupon_release)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_coupon_release: ${id_coupon_release} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do trong đợt phát hành đã có coupon cần phát hành, vui lòng xóa coupon khỏi đợt phát hành'})           
          }, error=>{
            reject(error)
          })             
    })
  }
/**
  * @example: 
  *
  * this.vhQueryCafe.getCouponRelease('FBHYWIBDNIUH1321687')
        .then((res)=>{
          console.log('getCouponRelease', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_coupon_release
  * @return Promise => object or null
  */
  public getCouponRelease(id_coupon_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('coupon_releases', id_coupon_release)
            .then((coupon_release)=>{
              resolve(coupon_release);
            }, error=>{
                reject(error);
            })          
    })
  }

  
/**
  * @example: 
  *
  * this.vhQueryCafe.getCouponReleases()
        .then((arr)=>{
          console.log('getCouponReleases', arr);
        }, error=>{
          console.log('error', error);
        })
  * @return Promise => Array< object >
  */
  public getCouponReleases(){
    return new Promise((resolve, reject) => { 
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('coupon_releases')
            .then((coupon_releases)=>{              
              resolve(coupon_releases);
            },(error:any)=>{
              reject(error);
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('coupon_releases', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((coupon_releases)=>{              
              resolve(coupon_releases);
            },(error:any)=>{
              reject(error);
            }) 
      }                    
    })
  }

/**
  * @example: 
  let data = {
    id_coupon : "9841654DOIWSDYW235",
    id_coupon_release :" 316OIUHLKMLSDYW235"
  }
  this.vhQueryCafe.addCouponReleaseDetail(data)
        .then((res)=>{
          console.log('addCouponReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @param id_coupon
  * @return Promise => bool = true or false
  */
  public addCouponReleaseDetail(data:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('coupon_release_details', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
  * @example:  
  * this.vhQueryCafe.deleteCouponReleaseDetail("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteCouponReleaseDetail', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_release_detail
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do coupon_code của đợt phát hành chi tiết này có status !=1 (đã được đổi điểm, hoặc đã sử dụng) 
  */
  public deleteCouponReleaseDetail(id_coupon_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_codes', {id_coupon_release_detail:{$eq:id_coupon_release_detail}}, {})
          .then((coupon_codes:any)=>{
            let check = true;
            for(let i=0; i<coupon_codes.length; i++){
              if(coupon_codes[i].status !=1) check = false;
            }
            if(check){
              for(let i=0; i<coupon_codes.length; i++){
                this.vhMGDB_database._deleteDoc('coupon_codes', coupon_codes[i]._id);
              }
              this.vhMGDB_database._deleteDoc('coupon_release_details', id_coupon_release_detail)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_coupon_release_detail: ${id_coupon_release_detail} thành công`});
                  }, error=>{
                    reject(error)
                  })
            }else resolve({vcode:1, message:'xóa không thành công, do coupon_code của đợt phát hành chi tiết này có status !=1'})            
          })
          .catch((e)=>{
            reject(e);
          })           
    })
  }

  /**
  * @example: 
  *
  * this.vhQueryCafe.getCouponReleaseDetail('FBHYWIBDNIUH1321687')
        .then((res)=>{
          console.log('getCouponReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_coupon_release_detail
  * @return Promise => object or null
  */
  public getCouponReleaseDetail(id_coupon_release_detail:any){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDoc('coupon_release_details', id_coupon_release_detail)
            .then((coupon_release)=>{
              resolve(coupon_release);
            }, error=>{
                reject(error);
            })          
    })
  }

/**
  * hàm này trả về những Coupon Release Detail của đợt coupon đó
  * @example:  
  * this.vhQueryCafe.getCouponRelaseDetail_byIdCouponRelease("9841654DOIWSDYW235")
        .then((array:any)=>{
          console.log('getCouponRelaseDetail_byIdCouponRelease', array);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_release
  * @return Promise => Array<any> = [{id_coupon_relase, id_coupon, coupon_name, coupon_value,  coupon_code_numbers}]
  */
  public getCouponRelaseDetail_byIdCouponRelease(id_coupon_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_release_details', {id_coupon_release:{$eq:id_coupon_release}}, {})
              .then((coupon_release_details)=>{
                resolve(coupon_release_details);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }

/**
  *  hàm này để phát hành 1 coupon_code
  * @example:  
  //truyền vào
  let data = { 
    date_validity: new Date(),
    date_expire : new Date(),
    id_coupon_release_detail :"315KHIUHWNIUHCIYUW3187",
    id_coupon: '9841654DOIWSDYW235'    
  }
  * this.vhQueryCafe.createCouponCode(data)
        .then((coupon_code)=>{
          console.log('createCouponCode', coupon_code);
        }, error=>{
          console.log('error', error);
        }) 
  //trả về
  let data = { 
    _id:'9841654DOIWSDYW235'
    status: 1,
    id_branch,

    date_validity: new Date(),
    date_expire : new Date(),
    id_coupon_release_detail :"315KHIUHWNIUHCIYUW3187",
    id_coupon: '9841654DOIWSDYW235'    
  }
  * @param data
  * @return Promise => Object
  */
  private createCouponCode(data:any){
    return new Promise((resolve,reject) => {
      let _data = {...data};
      _data.id_branch = this.getDefaultBranch()._id;
      _data.status = 1;
      _data.code = this.vhAlgorithm.createCardCode();     
      this.vhMGDB_database.getDocsByFields('coupon_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
          .then((coupon_codes:any)=>{
            if(coupon_codes.length>0){
              _data.code = this.vhAlgorithm.createCardCode();  
              this.vhMGDB_database.getDocsByFields('coupon_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                  .then((coupon_codes:any)=>{
                    if(coupon_codes.length>0){
                      _data.code = this.vhAlgorithm.createCardCode();  
                      this.vhMGDB_database.getDocsByFields('coupon_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                          .then((coupon_codes:any)=>{
                            if(coupon_codes.length>0){
                              reject({error: {message: 'Nói anh Huy xem lại phần tạo mã code tự động, code tạo mới bị trùng'}});
                            }else{
                              this.vhMGDB_database.addDoc('coupon_codes', _data)
                                  .then((coupon_code)=>{
                                    resolve(coupon_code);
                                  }, error=>{
                                    reject(error)
                                  })
                            }
                          }, error=>{
                              reject(error);
                          })     
                    }else{
                      this.vhMGDB_database.addDoc('coupon_codes', _data)
                          .then((coupon_code)=>{
                            resolve(coupon_code);
                          }, error=>{
                            reject(error)
                          })
                    }
                  }, error=>{
                      reject(error);
                  })                 
            }else{
              this.vhMGDB_database.addDoc('coupon_codes', _data)
                  .then((coupon_code)=>{
                    resolve(coupon_code);
                  }, error=>{
                    reject(error)
                  })
            }
          }, error=>{
              reject(error);
          })     
    })
  }
  /**
  *  hàm này để phát hành nhiều coupon_code theo số lượng truyền vào, và tự động cập nhật trường số lượng đã phát hành (quantity_released) tăng lên 
  * trong collection coupon_release_details 
  * @example:  
  //truyền vào
  let data = {
    date_validity: new Date(),
    date_expire : new Date(),
    id_coupon_release_detail :"315KHIUHWNIUHCIYUW3187",
    id_coupon: '9841654DOIWSDYW235'    
  }
  * this.vhQueryCafe.createCouponCodes(data, 10)
        .then((coupon_codes)=>{
          console.log('createCouponCodes', coupon_codes);
        }, error=>{
          console.log('error', error);
        })
  //trả về
  let data = { 
    _id:'9841654DOIWSDYW235'
    status: 1,
    id_branch,

    date_validity: new Date(),
    date_expire : new Date(),
    id_coupon_release_detail :"315KHIUHWNIUHCIYUW3187",
    id_coupon: '9841654DOIWSDYW235'    
  } 
  * @param data
  * @param quantity <=20 : Dev kiểm tra trường quantity nhập vào không được lớn hơn 20
  * @return Promise => Array(object)
  */
  public createCouponCodes(data:any, quantity:number){
    return new Promise((resolve,reject) => {
      if(quantity <=20){
        let promise = new Array();
        for(let i=0; i<quantity; i++){       
          promise[i] = this.createCouponCode(data);
          
        }  
        Promise.all(promise)
                  .then((array:any)=>{
                    array = array.flat();
                    this.vhMGDB_database.getDoc('coupon_release_details', data.id_coupon_release_detail)
                        .then((coupon_release_detail:any)=>{
                          if(coupon_release_detail){
                            if(coupon_release_detail.quantity_released != undefined){
                              let value = {quantity_released: coupon_release_detail.quantity_released + quantity}
                              this.vhMGDB_database.updateDoc('coupon_release_details', coupon_release_detail._id, value)
                                  .then(()=>{
                                    resolve(array);
                                  }, error=>{
                                    reject(error)
                                  })   
                            }else{
                              let value = {quantity_released: quantity}
                              this.vhMGDB_database.updateDoc('coupon_release_details', coupon_release_detail._id, value)
                                  .then(()=>{
                                    resolve(array);
                                  }, error=>{
                                    reject(error)
                                  })
                            }
                          }                     
                        }, error=>{
                            reject(error);
                        })                        
                  })
                  .catch(e=>{
                    reject(e);
                  }) 
      }else reject({warning: 'Dev kiểm tra trường quantity nhập vào không được lớn hơn 20'});     
    })
  }
/**
  * @example:  
  * 
  * this.vhQueryCafe.updateCouponCode('OUHEOIWUYGHIQNIDOUW1359478',{date_expire : new Date()})
        .then((bool:any)=>{
          console.log('updateCouponCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code
  * @param data
  * @return Promise => boolean = true or false
  */
  public updateCouponCode(id_coupon_code:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('coupon_codes', id_coupon_code, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
  * Hàm này chỉ cho phép xóa coupon_code đang ở trạng thái đã phát hành (status ==1),
  * và cập nhật giảm trường số lượng quantity_released bớt 1 trong collection coupon_release_details
  * @example: 
  * this.vhQueryCafe.deleteCouponCode('OUHEOIWUYGHIQNIDOUW1359478'})
        .then((bool:any)=>{
          console.log('deleteCouponCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code
  * @param id_coupon_release_detail      
  * @return Promise => boolean = true or false
  */
  public deleteCouponCode(id_coupon_code:string, id_coupon_release_detail:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('coupon_codes', id_coupon_code)
          .then((bool:any)=>{                 
            if(bool){             
              this.vhMGDB_database.getDoc('coupon_release_details', id_coupon_release_detail)
                  .then((coupon_release_detail:any)=>{
                    if(coupon_release_detail){
                      if(coupon_release_detail.quantity_released != undefined){
                        let value = {quantity_released: coupon_release_detail.quantity_released - 1}
                        this.vhMGDB_database.updateDoc('coupon_release_details', coupon_release_detail._id, value)
                            .then(()=>{
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })   
                      }else{                                
                        let value = {quantity_released: 0}//-1 thì vô lý quá, nên kiểm tra lại sau
                        this.vhMGDB_database.updateDoc('coupon_release_details', coupon_release_detail._id, value)
                            .then(()=>{
                              console.log('Báo anh Huy kiểm tra lại trường hợp này');
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })
                      }
                    }                     
                  }, error=>{
                      reject(error);
                  })                    
            }else{
                resolve(false);
            }                                                         
                  
          }, error=>{
            reject(error)
          })          
    })
  }
/** 
  * hàm này trả về danh sách coupon code đã phát hành theo mỗi đợt
  * @example:  
  * 
  * this.vhQueryCafe.getCouponCodes_byIdCouponReleaseDetail('OUHEOIWUYGHIQNIDOUW1359478'})
        .then((array:any)=>{
          console.log('getCouponCodes_byIdCouponReleaseDetail', array);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_release_detail
  * @return Promise => Array<any> 
  */
  public getCouponCodes_byIdCouponReleaseDetail(id_coupon_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_codes', {id_coupon_release_detail:{$eq:id_coupon_release_detail}}, {})
              .then((coupon_codes)=>{
                resolve(coupon_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }

  /** 
  * hàm này trả về danh sách coupon code đã phát hành theo điều kiện query
  * @example:  
  * this.vhQueryCafe.getCouponCodes_byFields({status:{$eq: 1}}, {}, {}, 0)
        .then((res)=>{
          console.log('getCouponCodes_byFields', res);
        }, error=>{
          console.log('error', error);
        })
  * @param query
  * @param projection
  * @param sort
  * @param limit
  * @return Promise => array(object) = [{},{},..]
  */
  public getCouponCodes_byFields(query: object, projection: object, sort: object, limit: number){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_codes', query,{},sort,limit)
              .then((coupon_codes)=>{
                resolve(coupon_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }
  
/** 
  *  hàm này trả về coupon_code đã phát hành theo trường _id của Coupon_code
  * @example:  
  * 
  * this.vhQueryCafe.getCouponCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getCouponCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getCouponCode(id_coupon_code:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('coupon_codes', id_coupon_code)
            .then((coupon_code)=>{
              resolve(coupon_code);
            }, error=>{
                reject(error);
            })          
    })
  }

  /** 
  *  hàm này trả về coupon_code đã phát hành theo trường code của Coupon_code. 
  * @example:  
  * 
  * this.vhQueryCafe.getCouponCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getCouponCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getCouponCode_byCode(code:any){
    return new Promise((resolve, reject) => {
      let id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.getDocsByFields('coupon_codes', {id_branch:{$eq:id_branch}, code:{$eq:code}})
            .then((coupon_codes:any)=>{
              if(coupon_codes.length>0){
                resolve(coupon_codes[0]);
              }else resolve(null);
              
            }, error=>{
                reject(error);
            })          
    })
  }
  
  /** 
  * hàm này trả về coupon_code đã phát hành theo trường _id của voucher_code.
  * @example:  
  * 
  * this.vhQueryCafe.getCoupon_Code_Name_Release('OUHEDW0512'})
        .then((res)=>{
          console.log('getCoupon_Code_Name_Release', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getCoupon_Code_Name_Release(id_coupon_code:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('coupon_codes', id_coupon_code)
            .then((coupon_code:any)=>{
              if(coupon_code){
                let coupon = cloneDeep(coupon_code);                
                this.vhMGDB_database.getDoc('coupon_release_details', coupon.id_coupon_release_detail)
                    .then((coupon_release_detail:any)=>{
                      if(coupon_release_detail){
                        Promise.all([
                          this.vhMGDB_database.getDoc('coupons', coupon_release_detail.id_coupon),                            
                          this.vhMGDB_database.getDoc('coupon_releases', coupon_release_detail.id_coupon_release)
                        ]).then((array:any)=>{                          
                          if(coupon.status === 1){                  
                            coupon.points = array[0].points;
                          }   
                          coupon.name_coupon = array[0].name;
                          coupon.name_coupon_release = array[1].name;
                          resolve(coupon);
                        })                            
                      }else resolve(null); 
                    },(error:any)=>{                      
                      reject(error);
                    })
            }else resolve(null);            
          }, error=>{
              reject(error);
          })  
      // this.vhMGDB_database.getDoc('coupon_codes', id_coupon_code)
      //       .then((coupon_code:any)=>{
      //         if(coupon_code){
      //           let coupon = cloneDeep(coupon_code);               
      //           this.vhMGDB_database.getDoc('coupon_release_details', coupon_code.id_coupon_release_detail)
      //               .then((coupon_release_detail:any)=>{
      //                 if(coupon_release_detail){
      //                   Promise.all([
      //                     this.vhMGDB_database.getDoc('coupons', coupon_release_detail.id_coupon),                            
      //                     this.vhMGDB_database.getDoc('coupon_releases', coupon_release_detail.id_coupon_release)
      //                   ]).then((array:any)=>{
      //                     coupon.name_coupon = array[0].name;
      //                     coupon.name_coupon_release = array[1].name;
      //                     resolve(coupon);
      //                   })                            
      //                 }else resolve(null); 
      //               },(error:any)=>{                      
      //                 reject(error);
      //               })
      //         }else resolve(null);             
      //       }, error=>{
      //           reject(error);
      //       })          
    })
  }

/** 
  * hàm này trả về coupon đã phát hành theo trường code của coupon_code. dùng trong thanh toán bằng phiếu, đổi điểm lấy coupon,
  * trả về có cả code, name_coupon, name_coupon_release
  * @example:  
  * 
  * this.vhQueryCafe.getCoupon_Code_Name_Release_byCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getCoupon_Code_Name_Release_byCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getCoupon_Code_Name_Release_byCode(code:any){
    return new Promise((resolve, reject) => {
      //let id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.getDocsByFields('coupon_codes', {code:{$eq:code}})
          .then((coupon_codes:any)=>{
            if(coupon_codes.length>0){            
                let coupon = cloneDeep(coupon_codes[0]);               
                this.vhMGDB_database.getDoc('coupon_release_details', coupon.id_coupon_release_detail)
                    .then((coupon_release_detail:any)=>{
                      if(coupon_release_detail){
                        Promise.all([
                          this.vhMGDB_database.getDoc('coupons', coupon_release_detail.id_coupon),                            
                          this.vhMGDB_database.getDoc('coupon_releases', coupon_release_detail.id_coupon_release)
                        ]).then((array:any)=>{                          
                          if(coupon.status === 1){                  
                            coupon.points = array[0].points;
                          }   
                          coupon.name_coupon = array[0].name;
                          coupon.name_coupon_release = array[1].name;
                          resolve(coupon);
                        })                            
                      }else resolve(null); 
                    },(error:any)=>{                      
                      reject(error);
                    })
            }else resolve(null);            
          }, error=>{
              reject(error);
          })     
    })
  }
/** 
  * hàm này để đổi phiếu từ điểm của khách hàng. Đổi thành công tự động tạo lịch sử đổi điểm của khách hàng
  * hàm này đã cập nhật lại trường status, id_customer, date_points_exchanged cho coupon_codes
  * hàm này đã cập nhật lại trường earned_points, id_customer, branch_earned_points cho customers  
  * @example:
  * let array = [{id_coupon_code, points, value},{}...]
  * this.vhQueryCafe.exchangeCouponCode_byEarningPoints([array,'1984QIHBSYGWDIOUHIQFE'], 'INBIFDYWUGUHNI65498', 1000})
        .then((bool:any)=>{
          console.log('exchangeCouponCode_byEarningPoints', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param array_id_coupon_code_and_points_and_value : [{id_coupon_code, points, value}]
  * @param id_customer
  * @param total_points_exchanged: tổng điểm của các phiếu đã quy đổi
  * @return Promise => boolean = true or false
  */
  public exchangeCouponCode_byEarningPoints(array_id_coupon_code_and_points_and_value:any, id_customer:any, total_points_exchanged:any){
    return new Promise((resolve, reject) => {
      let promise_zero:any = new Array();
      for(let i=0; i<array_id_coupon_code_and_points_and_value.length; i++){
        promise_zero[i] = this.vhMGDB_database.getDoc('coupon_codes', array_id_coupon_code_and_points_and_value[i].id_coupon_code);
      }
      promise_zero[promise_zero.length] = this.vhMGDB_database.getDoc('customers', id_customer);
      Promise.all(promise_zero)
            .then((array_zero:any)=>{
              let promise_one:any = new Array();
              for(let i=0; i<array_zero.length -1; i++){
                let value_coupon_code = {
                  status: 3,                  
                  date_points_exchanged: new Date(),
                  points: array_id_coupon_code_and_points_and_value[i].points,
                  value: array_id_coupon_code_and_points_and_value[i].value,
                  id_customer: id_customer
                }
                promise_one[i] = this.vhMGDB_database.updateDoc('coupon_codes', array_zero[i]._id, value_coupon_code);
              }
              let customer:any = array_zero[array_zero.length-1];
              if(customer.earned_points != undefined){
                customer.earned_points = customer.earned_points - total_points_exchanged;
              }else{
                customer.earned_points = 0;
              }
              let branch = this.getDefaultBranch();
              if(customer.branch_earned_points !=undefined){
                if(customer.branch_earned_points[branch._id] !=undefined){
                  customer.branch_earned_points[branch._id] = customer.branch_earned_points[branch._id] -total_points_exchanged;
                }else{
                  customer.branch_earned_points[branch._id] = 0;
                }
              }else{
                customer.branch_earned_points = {};
              }
              let value_customer = {
                earned_points: customer.earned_points,
                branch_earned_points: customer.branch_earned_points    
              }
              promise_one[promise_one.length] = this._updateCustomer(customer._id, value_customer);
              Promise.all(promise_one)
                    .then(()=>{
                      resolve(true);
                    })
            })
    })
  }

// *Voucher --------------------------------------------------------------------
/**
  * @example: 
  * let data = {
        name : "Siêu khuyến mãi",
        id_design_barcode :"316OIUHLKMLSDYW235",
        products: [{
        id_product : "NIDOUHWIOLDNOIU1142748",
        price : 1000000,
        quantity: 1,
        ptype: 1
      }],
        point: 10,
        price_origin: 9300000,
        price: 9200000,
        id_branch: 4zFGhVUAZyj5d09r01xZ
    }
  * this.vhQueryCafe.addVoucher(data)
        .then((res)=>{
          console.log('addVoucher', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return object or error
  */
  public addVoucher(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('vouchers', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
  * @example: 
  * let data = {
        point: 23,
        price_origin: 9400000,
        id_branch: 4zFGhVUAZyj5d09r01xZ
    }
  * this.vhQueryCafe.updateVoucher("fuMS21I6othUm34385WV", data)
        .then((bool:any)=>{
          console.log('updateVoucher', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_voucher
  * @param data
  * @return Promise Boolean => true or false
  */
  public updateVoucher(id_voucher:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('vouchers', id_voucher, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
  * @example:  
  * this.vhQueryCafe.deleteVoucher("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteVoucher', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do voucher đã được phát hành, vui lòng xóa đợt phát hành liên quan
  */
  public deleteVoucher(id_voucher:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('voucher_release_details', {id_voucher:{$eq:id_voucher}}, {})
          .then((voucher_release_details:any)=>{
            if(voucher_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('vouchers', id_voucher)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_voucher: ${id_voucher} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do voucher đã được phát hành, vui lòng xóa đợt phát hành liên quan'})           
          }, error=>{
            reject(error)
          })             
    })
  }
        
/**
  * @example: 
  * this.vhQueryCafe.getVoucher(id_voucher)
        .then((res)=>{
          console.log('addVoucher', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_voucher
  * @return Promise => object or null
  */
  public getVoucher(id_voucher:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('vouchers', id_voucher)
            .then((voucher)=>{
              resolve(voucher);
            }, error=>{
                reject(error);
            })          
    })
  }

/**
  * @example: 
  * this.vhQueryCafe.getVouchers()
        .then((arr)=>{
          console.log('getVouchers', arr);
        }, error=>{
          console.log('error', error);
        })
  * @return Promise => array(object) =[{},{},...]
  */
  public getVouchers(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('vouchers')
            .then((vouchers)=>{              
              resolve(vouchers);
            },(error:any)=>{
              reject(error);
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('vouchers', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((vouchers)=>{              
              resolve(vouchers);
            },(error:any)=>{
              reject(error);
            }) 
      }               
    })
  }

/**
  * @example: 
  * let data = {
        name : "Tháng 6 bùng nổ",
        id_branch: 4zFGhVUAZyj5d09r01xZ
    }
  * this.vhQueryCafe.addVoucherRelease(data)
        .then((res)=>{
          console.log('addVoucherRelease', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return object or error
  */
  public addVoucherRelease(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('voucher_releases', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
  * @example: 
  * let data = {
        name : "Tháng 6 bùng nổ"
    }
  * this.vhQueryCafe.updateVoucherRelease("fuMS21I6othUm34385WV", data)
        .then((bool:any)=>{
          console.log('updateVoucherRelease', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_voucher_release
  * @param data
  * @return Promise Boolean => true or false
  */
  public updateVoucherRelease(id_voucher_release:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('voucher_releases', id_voucher_release, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
  * @example:  
  * this.vhQueryCafe.deleteVoucherRelease("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteVoucherRelease', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_release
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do trong đợt phát hành đã có voucher cần phát hành, vui lòng xóa voucher khỏi đợt phát hành
  */
  public deleteVoucherRelease(id_voucher_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('voucher_release_details', {id_voucher_release:{$eq:id_voucher_release}}, {})
          .then((voucher_release_details:any)=>{
            if(voucher_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('voucher_releases', id_voucher_release)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_voucher_release: ${id_voucher_release} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do trong đợt phát hành đã có voucher cần phát hành, vui lòng xóa voucher khỏi đợt phát hành'})           
          }, error=>{
            reject(error)
          })             
    })
  }
  
  
/**
  * @example: 
  * this.vhQueryCafe.getVoucherRelease("fuMS21I6othUm34385WV")
        .then((res)=>{
          console.log('getVoucherRelease', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_voucher_release
  * @return Promise => object or null
  */
  public getVoucherRelease(id_voucher_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('voucher_releases', id_voucher_release)
            .then((voucher_release)=>{
              resolve(voucher_release);
            }, error=>{
                reject(error);
            })          
    })
  }

/**
  * @example: 
  * this.vhQueryCafe.getVoucherRelases()
        .then((res)=>{
          console.log('getVoucherRelases', res);
        }, error=>{
          console.log('error', error);
        })
  * @return Promise => array(object) =[{},{},...]
  */
  public getVoucherRelases(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('voucher_releases')
            .then((voucher_releases)=>{              
              resolve(voucher_releases);
            },(error:any)=>{
              reject(error);
            })       
      }else{
        this.vhMGDB_database.getDocsByFields('voucher_releases', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((voucher_releases)=>{              
              resolve(voucher_releases);
            },(error:any)=>{
              reject(error);
            }) 
      } 
                
    })
  }

/**
  * @example: 
  * let data = {
        id_voucher : "fuMS21I6othUm34385WV",
        id_voucher_release: "4zFGhVUAZyj5d09r01xZ"
    }
  * this.vhQueryCafe.addVoucherReleaseDetail(data)
        .then((res)=>{
          console.log('addVoucherReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return object or error
  */
  public addVoucherReleaseDetail(data:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('voucher_release_details', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
  * @example:  
  * this.vhQueryCafe.deleteVoucherReleaseDetail("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteVoucherReleaseDetail', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_release_detail
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do voucher_code của đợt phát hành chi tiết này có status !=1 (đã được đổi điểm, hoặc đã sử dụng) 
  */
  public deleteVoucherReleaseDetail(id_voucher_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('voucher_codes', {id_voucher_release_detail:{$eq:id_voucher_release_detail}}, {})
          .then((voucher_codes:any)=>{
            let check = true;
            for(let i=0; i<voucher_codes.length; i++){
              if(voucher_codes[i].status !=1) check = false;
            }
            if(check){
              for(let i=0; i<voucher_codes.length; i++){
                this.vhMGDB_database._deleteDoc('voucher_codes', voucher_codes[i]._id);
              }
              this.vhMGDB_database._deleteDoc('voucher_release_details', id_voucher_release_detail)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_voucher_release_detail: ${id_voucher_release_detail} thành công`});
                  }, error=>{
                    reject(error)
                  })
            }else resolve({vcode:1, message:'xóa không thành công, do voucher_code của đợt phát hành chi tiết này có status !=1'})            
          })
          .catch((e)=>{
            reject(e);
          })           
    })
  }
      
  /**
  * @example: 
  * this.vhQueryCafe.getVoucherReleaseDetail("fuMS21I6othUm34385WV")
        .then((res)=>{
          console.log('getVoucherReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        })
  * @param (id_voucher_release_detail)
  * @return Promise => object or null
  */
  public getVoucherReleaseDetail(id_voucher_release_detail:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('voucher_release_details', (id_voucher_release_detail))
            .then((voucher_release)=>{
              resolve(voucher_release);
            }, error=>{
                reject(error);
            })          
    })
  }

/**
  * @example: 
  * this.vhQueryCafe.getVoucherRelaseDetail_byFields({id_voucher:{$eq: "316OIUHLKMLSDYW235"}}, {}, {}, 0)
        .then((res)=>{
          console.log('getVoucherRelaseDetail_byFields', res);
        }, error=>{
          console.log('error', error);
        })
  * @param query
  * @param projection
  * @param sort
  * @param limit
  * @return Promise => array(object) = [{},{},..]
  */
  public getVoucherRelaseDetail_byFields(query: object, projection: object, sort: object, limit: number){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.getDocsByFields('voucher_release_details', query,{},sort,limit)
          .then((voucher_release_details)=>{              
            resolve(voucher_release_details);
          },(error:any)=>{
            reject(error);
          })                    
    })
  }
  
/**
  *  hàm này để phát hành 1 voucher_code
  * @example:  
  let data = {   
      date_validity: new Date(),
      date_expire: new Date(),    
      id_voucher_release_detail: "fuMS21I6othUm34385WV",
      id_voucher: '9841654DOIWSDYW235'   
  }
  * this.vhQueryCafe.createVoucherCode(data)
        .then((voucher_code)=>{
          console.log('createVoucherCode', voucher_code);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @return Promise => Object
  */
  createVoucherCode(data:any){
    return new Promise((resolve,reject) => {
      let _data = {...data};
      _data.id_branch = this.getDefaultBranch()._id;
      _data.status = 1;
      _data.code = this.vhAlgorithm.createCardCode();  
      this.vhMGDB_database.getDocsByFields('voucher_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
          .then((voucher_codes:any)=>{
            if(voucher_codes.length>0){
              _data.code = this.vhAlgorithm.createCardCode();  
              this.vhMGDB_database.getDocsByFields('voucher_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                  .then((voucher_codes:any)=>{
                    if(voucher_codes.length>0){
                      _data.code = this.vhAlgorithm.createCardCode();  
                      this.vhMGDB_database.getDocsByFields('voucher_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                          .then((voucher_codes:any)=>{
                            if(voucher_codes.length>0){
                              reject({error: {message: 'Nói anh Huy xem lại phần tạo mã code tự động, code tạo mới bị trùng'}});
                            }else{
                              this.vhMGDB_database.addDoc('voucher_codes', _data)
                                  .then((voucher_code)=>{
                                    resolve(voucher_code);
                                  }, error=>{
                                    reject(error)
                                  })
                            }
                          }, error=>{
                              reject(error);
                          })     
                    }else{
                      this.vhMGDB_database.addDoc('voucher_codes', _data)
                          .then((voucher_code)=>{
                            resolve(voucher_code);
                          }, error=>{
                            reject(error)
                          })
                    }
                  }, error=>{
                      reject(error);
                  })                 
            }else{
              this.vhMGDB_database.addDoc('voucher_codes', _data)
                  .then((voucher_code)=>{
                    resolve(voucher_code);
                  }, error=>{
                    reject(error)
                  })
            }
          }, error=>{
              reject(error);
          })     
    })
  }
  

  /**
  *  hàm này để phát hành nhiều voucher_code theo số lượng truyền vào, và tự động cập nhật trường số lượng đã phát hành (quantity_released) tăng lên 
  * trong collection voucher_release_details  
  * @example:  
  let data = {
      date_validity: new Date(),
      date_expire: new Date(),    
      id_voucher_release_detail: "fuMS21I6othUm34385WV",
      id_voucher: '9841654DOIWSDYW235'    
  }
  * this.vhQueryCafe.createVoucherCodes(data, 10)
        .then((voucher_codes)=>{
          console.log('createVoucherCodes', voucher_codes);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @param quantity
  * @return Promise => Array(object)
  */
  public createVoucherCodes(data:any, quantity:number){
    return new Promise((resolve,reject) => {
      let promise = new Array();
      for(let i=0; i<quantity; i++){        
        promise[i] = this.createVoucherCode(data);       
      }    
      Promise.all(promise)
            .then((array:any)=>{
              array = array.flat();             
              this.vhMGDB_database.getDoc('voucher_release_details', data.id_voucher_release_detail)
                  .then((voucher_release_detail:any)=>{
                    if(voucher_release_detail){
                      if(voucher_release_detail.quantity_released != undefined){
                        let value = {quantity_released: voucher_release_detail.quantity_released + quantity}
                        this.vhMGDB_database.updateDoc('voucher_release_details', voucher_release_detail._id, value)
                            .then(()=>{
                              resolve(array);
                            }, error=>{
                              reject(error)
                            })   
                      }else{
                        let value = {quantity_released: quantity}
                        this.vhMGDB_database.updateDoc('voucher_release_details', voucher_release_detail._id, value)
                            .then(()=>{
                              resolve(array);
                            }, error=>{
                              reject(error)
                            })
                      }
                    }                     
                  }, error=>{
                      reject(error);
                  })     
            })
            .catch(e=>{
              reject(e);
            })   
    })
  }
/**
  * @example:  
  * 
  * this.vhQueryCafe.updateVoucherCode('OUHEOIWUYGHIQNIDOUW1359478',{date_expire : new Date()})
        .then((bool:any)=>{
          console.log('updateCouponCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_code
  * @param data
  * @return Promise => boolean = true or false
  */
  public updateVoucherCode(id_voucher_code:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('voucher_codes', id_voucher_code, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
  * Hàm này chỉ cho phép xóa voucher_code đang ở trạng thái đã phát hành (status ==1),
  * và cập nhật giảm trường số lượng quantity_released bớt một trong collection voucher_release_details
  * @example:   
  * this.vhQueryCafe.deleteVoucherCode('BjHxEYPWrB0rPwfj2L9R', 'CBrcRQIL11lwcHBljliW'})
        .then((bool:any)=>{
          console.log('deleteVoucherCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_code
  * @param id_voucher_release_detail      
  * @return Promise => boolean = true or false
  */
  public deleteVoucherCode(id_voucher_code:string, id_voucher_release_detail:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('voucher_codes', id_voucher_code)
          .then((bool:any)=>{                        
            if(bool){     
              this.vhMGDB_database.getDoc('voucher_release_details', id_voucher_release_detail)
                  .then((voucher_release_detail:any)=>{                    
                    if(voucher_release_detail){                      
                      if(voucher_release_detail.quantity_released != undefined){                        
                        let value = {quantity_released: voucher_release_detail.quantity_released - 1}
                        this.vhMGDB_database.updateDoc('voucher_release_details', voucher_release_detail._id, value)
                            .then(()=>{                              
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })   
                      }else{                                
                        let value = {quantity_released: 0}//-1 thì vô lý quá, nên kiểm tra lại sau
                        this.vhMGDB_database.updateDoc('voucher_release_details', voucher_release_detail._id, value)
                            .then(()=>{
                              console.log('Báo anh Huy kiểm tra lại trường hợp này');
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })
                      }
                    }                     
                  }, error=>{
                      reject(error);
                  })                    
            }else{
                resolve(false);
            }     
          }, error=>{
            reject(error)
          })          
    })
  }
/** 
  * hàm này trả về danh sách voucher_codes đã phát hành theo mỗi đợt
  * @example:  
  * this.vhQueryCafe.getVoucherCodes_byIdCouponReleaseDetail('OUHEOIWUYGHIQNIDOUW1359478'})
        .then((array:any)=>{
          console.log('getVoucherCodes_byIdCouponReleaseDetail', array);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_release_detail
  * @return Promise => Array<any> 
  */
  public getVoucherCodes_byIdCouponReleaseDetail(id_voucher_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('voucher_codes', {id_voucher_release_detail:{$eq:id_voucher_release_detail}}, {})
              .then((voucher_codes)=>{
                resolve(voucher_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }
  /** 
  * hàm này trả về danh sách voucher code đã phát hành theo điều kiện query
  * @example:  
  * this.vhQueryCafe.getVoucherCodes_byFields({status:{$eq: 1}}, {}, {}, 0)
        .then((res)=>{
          console.log('getVoucherCodes_byFields', res);
        }, error=>{
          console.log('error', error);
        })
  * @param query
  * @param projection
  * @param sort
  * @param limit
  * @return Promise => array(object) = [{},{},..]
  */
  public getVoucherCodes_byFields(query: object, projection: object, sort: object, limit: number){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('voucher_codes', query,{},sort,limit)
              .then((voucher_codes)=>{
                resolve(voucher_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }
/** 
  *  hàm này trả về voucher code đã phát hành theo trường _id của voucher code. dùng trong trang bán hàng để đổi phiếu
  * @example:  
  * 
  * this.vhQueryCafe.getVoucherCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getVoucherCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getVoucherCode(id_voucher_code:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('voucher_codes', id_voucher_code)
            .then((voucher_code)=>{
              resolve(voucher_code);
            }, error=>{
                reject(error);
            })          
    })
  }

  /** 
  * hàm này trả về voucher code đã phát hành theo trường _id của voucher code.
  * trả về có cả code, name_voucher, name_voucher_release
  * @example:  
  * 
  * this.vhQueryCafe.getVoucher_Code_Name_Release('OUHEDW0512'})
        .then((res)=>{
          console.log('getVoucher_Code_Name_Release', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getVoucher_Code_Name_Release(id_voucher_code:any){
    return new Promise((resolve, reject) => {
          this.vhMGDB_database.getDoc('voucher_codes', id_voucher_code)
              .then((voucher_code:any)=>{
                if(voucher_code){
                  let voucher = cloneDeep(voucher_code);                 
                  this.vhMGDB_database.getDoc('voucher_release_details', voucher.id_voucher_release_detail)
                      .then((voucher_release_detail:any)=>{
                        if(voucher_release_detail){
                          Promise.all([
                            this.vhMGDB_database.getDoc('vouchers', voucher_release_detail.id_voucher),                            
                            this.vhMGDB_database.getDoc('voucher_releases', voucher_release_detail.id_voucher_release)
                          ]).then((array:any)=>{   
                            voucher.units = array[0].units;
                            if(voucher.status === 1){                                
                              voucher.products = array[0].products;
                              voucher.points = array[0].points;
                            }                                                
                            voucher.name_voucher = array[0].name;
                            voucher.name_voucher_release = array[1].name;                                      
                            //thêm thông tin Name, Units, Lots cho sản phẩm trong products             
                            if(voucher.products){                            
                              for(let j=0; j<voucher.products.length; j++){
                                if((voucher.products[j].ptype ===1)||(voucher.products[j].ptype ===2)||(voucher.products[j].ptype ===3)||(voucher.products[j].ptype ===4)){
                                  let id_sub_or_product = voucher.products[j].id_subproduct?voucher.products[j].id_subproduct:voucher.products[j].id_product;
                                  let product = this.getlocalDetailProduct(id_sub_or_product);
                                  voucher.products[j].name = product.name;
                                  voucher.products[j].units = product.units;
                                  if(product.lots) voucher.products[j].lots = product.lots;  
                                  if(voucher.products[j].toppings){
                                    for(let k=0; k<voucher.products[j].toppings.length; k++){
                                      let topping = this.getlocalDetailProduct(voucher.products[j].toppings[k].id_product);
                                      voucher.products[j].toppings[k].name = topping.name;
                                      voucher.products[j].toppings[k].units = topping.units;
                                    }
                                  }
                                }else if(voucher.products[j].ptype ===5){
                                  let product = this.getlocalDetailProduct(voucher.products[j].id_product);
                                  voucher.products[j].name = product.name;
                                  voucher.products[j].units = product.units;
                                  voucher.products[j].combos = product.combos;
                                  for(let m=0; m<voucher.products[j].combos.length; m++){
                                    let _id_sub_or_product = voucher.products[j].combos[m].id_subproduct?voucher.products[j].combos[m].id_subproduct:voucher.products[j].combos[m].id_product;
                                    let _product = this.getlocalDetailProduct(_id_sub_or_product);
                                    voucher.products[j].combos[m].name = _product.name;
                                    voucher.products[j].combos[m].units = _product.units;
                                    if(_product.lots) voucher.products[j].combos[m].lots = _product.lots;
                                    if(voucher.products[j].combos[m].toppings){
                                      for(let k=0; k<voucher.products[j].combos[m].toppings.length; k++){
                                        let topping = this.getlocalDetailProduct(voucher.products[j].combos[m].toppings[k].id_product);
                                        voucher.products[j].combos[m].toppings[k].name = topping.name;
                                        voucher.products[j].combos[m].toppings[k].units = topping.units;
                                      }
                                    }
                                  }
                                }
                              }
                            }                                                  
                            resolve(voucher);
                          })                            
                        }else resolve(null); 
                      },(error:any)=>{                      
                        reject(error);
                      })
                
              }else resolve(null);             
            }, error=>{
                reject(error);
            })   
      // this.vhMGDB_database.getDoc('voucher_codes', id_voucher_code)
      //       .then((voucher_code:any)=>{
      //         if(voucher_code){
      //           let voucher = cloneDeep(voucher_code);               
      //           this.vhMGDB_database.getDoc('voucher_release_details', voucher_code.id_voucher_release_detail)
      //               .then((voucher_release_detail:any)=>{
      //                 if(voucher_release_detail){
      //                   Promise.all([
      //                     this.vhMGDB_database.getDoc('vouchers', voucher_release_detail.id_voucher),                            
      //                     this.vhMGDB_database.getDoc('voucher_releases', voucher_release_detail.id_voucher_release)
      //                   ]).then((array:any)=>{
      //                     voucher.name_voucher = array[0].name;
      //                     voucher.name_voucher_release = array[1].name;
      //                     resolve(voucher);
      //                   })                            
      //                 }else resolve(null); 
      //               },(error:any)=>{                      
      //                 reject(error);
      //               })
      //         }else resolve(null);             
      //       }, error=>{
      //           reject(error);
      //       })          
    })
  }

/** 
  * hàm này trả về voucher đã phát hành theo trường code của voucher_code. dùng trong trang đổi điểm lấy voucher và bán voucher, đổi voucher lấy hàng hóa,
  * trả về có cả code, name_voucher, name_voucher_release
  * @example:  
  * 
  * this.vhQueryCafe.getVoucher_Code_Name_Release_byCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getVoucher_Code_Name_Release_byCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getVoucher_Code_Name_Release_byCode(code:any){
    return new Promise((resolve, reject) => {
      //let id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.getDocsByFields('voucher_codes', {code:{$eq:code}})
            .then((voucher_codes:any)=>{
              if(voucher_codes.length){
                let voucher = cloneDeep(voucher_codes[0]);               
                  this.vhMGDB_database.getDoc('voucher_release_details', voucher.id_voucher_release_detail)
                      .then((voucher_release_detail:any)=>{
                        if(voucher_release_detail){
                          Promise.all([
                            this.vhMGDB_database.getDoc('vouchers', voucher_release_detail.id_voucher),                            
                            this.vhMGDB_database.getDoc('voucher_releases', voucher_release_detail.id_voucher_release)
                          ]).then((array:any)=>{   
                            voucher.units = array[0].units;
                            if(voucher.status === 1){                                
                              voucher.products = array[0].products;
                              voucher.points = array[0].points;
                            }                                                
                            voucher.name_voucher = array[0].name;
                            voucher.name_voucher_release = array[1].name;                                      
                            //thêm thông tin Name, Units, Lots cho sản phẩm trong products             
                            if(voucher.products){                            
                              for(let j=0; j<voucher.products.length; j++){
                                if((voucher.products[j].ptype ===1)||(voucher.products[j].ptype ===2)||(voucher.products[j].ptype ===3)||(voucher.products[j].ptype ===4)){
                                  let id_sub_or_product = voucher.products[j].id_subproduct?voucher.products[j].id_subproduct:voucher.products[j].id_product;
                                  let product = this.getlocalDetailProduct(id_sub_or_product);
                                  voucher.products[j].name = product.name;
                                  voucher.products[j].units = product.units;
                                  if(product.lots) voucher.products[j].lots = product.lots;  
                                  if(voucher.products[j].toppings){
                                    for(let k=0; k<voucher.products[j].toppings.length; k++){
                                      let topping = this.getlocalDetailProduct(voucher.products[j].toppings[k].id_product);
                                      voucher.products[j].toppings[k].name = topping.name;
                                      voucher.products[j].toppings[k].units = topping.units;
                                    }
                                  }
                                }else if(voucher.products[j].ptype ===5){
                                  let product = this.getlocalDetailProduct(voucher.products[j].id_product);
                                  voucher.products[j].name = product.name;
                                  voucher.products[j].units = product.units;
                                  voucher.products[j].combos = product.combos;
                                  for(let m=0; m<voucher.products[j].combos.length; m++){
                                    let _id_sub_or_product = voucher.products[j].combos[m].id_subproduct?voucher.products[j].combos[m].id_subproduct:voucher.products[j].combos[m].id_product;
                                    let _product = this.getlocalDetailProduct(_id_sub_or_product);
                                    voucher.products[j].combos[m].name = _product.name;
                                    voucher.products[j].combos[m].units = _product.units;
                                    if(_product.lots) voucher.products[j].combos[m].lots = _product.lots;
                                    if(voucher.products[j].combos[m].toppings){
                                      for(let k=0; k<voucher.products[j].combos[m].toppings.length; k++){
                                        let topping = this.getlocalDetailProduct(voucher.products[j].combos[m].toppings[k].id_product);
                                        voucher.products[j].combos[m].toppings[k].name = topping.name;
                                        voucher.products[j].combos[m].toppings[k].units = topping.units;
                                      }
                                    }
                                  }
                                }
                              }
                            }     
                                                
                            resolve(voucher);
                          })                            
                        }else resolve(null); 
                      },(error:any)=>{                      
                        reject(error);
                      })
                
              }else resolve(null);             
            }, error=>{
                reject(error);
            })          
    })
  }

/* Hàm này để đổi voucher từ điểm của khách hàng. Đổi thành công tự động tạo lịch sử đổi điểm của khách hàng
  * hàm này đã cập nhật lại trường status, id_customer, date_points_exchanged cho voucher_codes
  * hàm này đã cập nhật lại trường earned_points, id_customer, branch_earned_points cho customers  
  * @example: 
  * let array = [{id_voucher_code, points, products},{}...]
  * this.vhQueryCafe.exchangeVoucherCode_byEarningPoints(array, "fuMS21I6othUm34385WV", 10)
        .then((bool:any)=>{
          console.log('exchangeVoucherCode_byEarningPoints', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param array_id_voucher_code_and_points_and_products
  * @param id_customer
  * @param points
  * @return Promise Boolean => true or false
  */
  public exchangeVoucherCode_byEarningPoints(array_id_voucher_code_and_points_and_products:any, id_customer:any, points:any){
    return new Promise((resolve, reject) => {
      let promise_zero:any = new Array();
      for(let i=0; i<array_id_voucher_code_and_points_and_products.length; i++){
        promise_zero[i] = this.vhMGDB_database.getDoc('voucher_codes', array_id_voucher_code_and_points_and_products[i].id_voucher_code);
      }
      promise_zero[promise_zero.length] = this.vhMGDB_database.getDoc('customers', id_customer);
      Promise.all(promise_zero)
            .then((array:any)=>{
              let promise_one:any = new Array();
              for(let i=0; i<array.length -1; i++){
                let value_voucher_code = {
                  status: 3,                  
                  date_points_exchanged: new Date(),
                  points: array_id_voucher_code_and_points_and_products[i].points,
                  products: array_id_voucher_code_and_points_and_products[i].products,
                  id_customer: id_customer
                }
                promise_one[i] = this.vhMGDB_database.updateDoc('voucher_codes', array[i]._id, value_voucher_code);
              }
              let customer:any = array[array.length-1];
              if(customer.earned_points != undefined){
                customer.earned_points = customer.earned_points - points;
              }else{
                customer.earned_points = 0;
              }
              let branch = this.getDefaultBranch();
              if(customer.branch_earned_points !=undefined){
                if(customer.branch_earned_points[branch._id] !=undefined){
                  customer.branch_earned_points[branch._id] = customer.branch_earned_points[branch._id] -points;
                }else{
                  customer.branch_earned_points[branch._id] = 0;
                }
              }else{
                customer.branch_earned_points = {};
              }
              let value_customer = {
                earned_points: customer.earned_points,
                branch_earned_points: customer.branch_earned_points    
              }
              promise_one[promise_one.length] = this._updateCustomer(customer._id, value_customer);
              Promise.all(promise_one)
                    .then(()=>{
                      resolve(true);
                    })
            })
    })
  }
// *Payment Card ---------------------------------------------------------------
/**  
  * @example:  
  * let data = {
  * name :"Thẻ trả trước",
  * price :1000000,
  * products : [
  *  {
  *    id_product : 'MOIUHWDWIUHG1345674',
  *    price : 100000,
  *    quantity: 5,
  *    quantity_valid : 5,
  *    type : 1
  *  },{
  *    id_product : 'NJIDUEWNBIJUWGHD135',
  *    price : 100000,
  *    quantity: 5,
  *    quantity_valid : 5,
  *    type : 2
  *  }]
  * }
  * this.vhQueryCafe.addPaymentCard(data)
        .then((res)=>{
          console.log('addPaymentCard', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @return Promise => Array<any> 
  */
  public addPaymentCard(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('payment_cards', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**  
* @example:  
* let data = {
* name :"Thẻ trả trước",
* price :1000000,
* products : [
*  {
*    id_product : 'MOIUHWDWIUHG1345674',
*    price : 100000,
*    quantity: 5,
*    quantity_valid : 5,
*    type : 1
*  },{
*    id_product : 'NJIDUEWNBIJUWGHD135',
*    price : 100000,
*    quantity: 5,
*    quantity_valid : 5,
*    type : 2
*  }]
* }
* this.vhQueryCafe.updatePaymentCard(data)
        .then((bool:any)=>{
          console.log('updatePaymentCard', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @param id_payment_card
  * @return Promise => bool = true or false
  */
  public updatePaymentCard(id_payment_card:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('payment_cards', id_payment_card, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
  * @example:  
  * this.vhQueryCafe.deletePaymentCard("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deletePaymentCard', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do payment_card đã được phát hành, vui lòng xóa đợt phát hành liên quan
  */
  public deletePaymentCard(id_payment_card:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('payment_card_release_details', {id_payment_card:{$eq:id_payment_card}}, {})
          .then((payment_card_release_details:any)=>{
            if(payment_card_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('payment_cards', id_payment_card)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_payment_card: ${id_payment_card} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do payment_card đã được phát hành, vui lòng xóa đợt phát hành liên quan'})           
          }, error=>{
            reject(error)
          })             
    })
  }
  
        
/**  
  * @example:
  * this.vhQueryCafe.getPaymentCard('FDNOIUWDHIWH21564DWQ')
        .then((res)=>{
          console.log('getPaymentCard', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card
  * @return Promise => object or null
  */
  public getPaymentCard(id_payment_card:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('payment_cards', id_payment_card)
            .then((payment_card)=>{
              resolve(payment_card);
            }, error=>{
                reject(error);
            })          
    })
  }

/**  
  * @example:
  * this.vhQueryCafe.getPaymentCards()
        .then((res)=>{
          console.log('getPaymentCards', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @return Promise => Array<any> 
  */
  public getPaymentCards(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('payment_cards')
            .then((payment_cards)=>{              
              resolve(payment_cards);
            },(error:any)=>{
              reject(error);
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('payment_cards', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((payment_cards)=>{              
              resolve(payment_cards);
            },(error:any)=>{
              reject(error);
            }) 
      } 
            
    })
  }

/**  
  * @example:
  * this.vhQueryCafe.addPaymentCardRelease({name : "Đợt phát hành thẻ 1", id_branch :"NIOUHDWLJUNBHIU16549"})
        .then((res)=>{
          console.log('addPaymentCardRelease', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @return Promise => object or error
  */
  public addPaymentCardRelease(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('payment_card_releases', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**  
  * @example:
  * this.vhQueryCafe.updatePaymentCardRelease({name : "Đợt phát hành thẻ 1"})
        .then((bool:any)=>{
          console.log('updatePaymentCardRelease', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_release
  * @param data
  * @return Promise => object or error
  */
  public updatePaymentCardRelease(id_payment_card_release:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('payment_card_releases', id_payment_card_release, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
  * @example:  
  * this.vhQueryCafe.deletePaymentCardRelease("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deletePaymentCardRelease', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_release
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do trong đợt phát hành đã có payment_card cần phát hành, vui lòng xóa payment_card khỏi đợt phát hành
  */
  public deletePaymentCardRelease(id_payment_card_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('payment_card_release_details', {id_payment_card_release:{$eq:id_payment_card_release}}, {})
          .then((payment_card_release_details:any)=>{
            if(payment_card_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('payment_card_releases', id_payment_card_release)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_payment_card_release: ${id_payment_card_release} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do trong đợt phát hành đã có payment_card cần phát hành, vui lòng xóa payment_card khỏi đợt phát hành'})           
          }, error=>{
            reject(error)
          })             
    })
  }
  
        
/**  
  * @example:
  * this.vhQueryCafe.getPaymentCardRelease("OIHIDUWNIDOLW123456")
        .then((res)=>{
          console.log('getPaymentCardRelease', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_release
  * @return Promise => object or null
  */
  public getPaymentCardRelease(id_payment_card_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('payment_card_releases', id_payment_card_release)
            .then((payment_card_release)=>{
              resolve(payment_card_release);
            }, error=>{
                reject(error);
            })          
    })
  }
/**  
  * @example:
  * this.vhQueryCafe.getPaymentCardReleases()
        .then((res)=>{
          console.log('getPaymentCardReleases', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @return Promise => Array<any>
  */
  public getPaymentCardReleases(){
    return new Promise((resolve, reject) => { 
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('payment_card_releases')
            .then((payment_card_release)=>{              
              resolve(payment_card_release);
            },(error:any)=>{
              reject(error);
            })          
      }else{
        this.vhMGDB_database.getDocsByFields('payment_card_releases', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((payment_card_releases)=>{              
              resolve(payment_card_releases);
            },(error:any)=>{
              reject(error);
            }) 
      }           
    })
  }

/**  
  * @example:
  * this.vhQueryCafe.addPaymentCardReleaseDetail({id_payment_card : "OIUHFIUWHGGU41698496", id_payment_card_release :"NIOUHDWLJUNBHIU16549"})
        .then((res)=>{
          console.log('addPaymentCardReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @return Promise => object or error
  */
  public addPaymentCardReleaseDetail(data:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('payment_card_release_details', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
  * @example:  
  * this.vhQueryCafe.deletePaymentCardReleaseDetail("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deletePaymentCardReleaseDetail', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_release_detail
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do payment_card_code của đợt phát hành chi tiết này có status !=1 (đã được đổi điểm, hoặc đã sử dụng) 
  */
  public deletePaymentCardReleaseDetail(id_payment_card_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('payment_card_codes', {id_payment_card_release_detail:{$eq:id_payment_card_release_detail}}, {})
          .then((payment_card_codes:any)=>{
            let check = true;
            for(let i=0; i<payment_card_codes.length; i++){
              if(payment_card_codes[i].status !=1) check = false;
            }
            if(check){
              for(let i=0; i<payment_card_codes.length; i++){
                this.vhMGDB_database._deleteDoc('payment_card_codes', payment_card_codes[i]._id);
              }
              this.vhMGDB_database._deleteDoc('payment_card_release_details', id_payment_card_release_detail)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_payment_card_release_detail: ${id_payment_card_release_detail} thành công`});
                  }, error=>{
                    reject(error)
                  })
            }else resolve({vcode:1, message:'xóa không thành công, do payment_card_code của đợt phát hành chi tiết này có status !=1'})            
          })
          .catch((e)=>{
            reject(e);
          })           
    })
  }
      
        
  /**
  * @example: 
  *
  * this.vhQueryCafe.getPaymentCardReleaseDetail('FBHYWIBDNIUH1321687')
        .then((res)=>{
          console.log('getPaymentCardReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_payment_card_release_detail
  * @return Promise => object or null
  */
  public getPaymentCardReleaseDetail(id_payment_card_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('payment_card_release_details', id_payment_card_release_detail)
            .then((payment_card_release_detail)=>{
              resolve(payment_card_release_detail);
            }, error=>{
                reject(error);
            })          
    })
  }

/**
  * @example: 
  * this.vhQueryCafe.getVoucherRelaseDetail_byFields({id_payment_card:{$eq: "316OIUHLKMLSDYW235"}}, {}, {}, 0)
        .then((res)=>{
          console.log('getVoucherRelaseDetail_byFields', res);
        }, error=>{
          console.log('error', error);
        })
  * @param query
  * @param projection
  * @param sort
  * @param limit
  * @return Promise => array(object) = [{},{},..]
  */
  public getPaymentCardRelaseDetail_byFields(query: object, projection: object, sort: object, limit: number){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.getDocsByFields('payment_card_release_details', query,{},sort,limit)
          .then((payment_card_release_details)=>{              
            resolve(payment_card_release_details);
          },(error:any)=>{
            reject(error);
          })                    
    })
  }
  
  
/**
  *  hàm này để phát hành 1 payment_card_code
  * @example:  
  let data = {
    date_validity: new Date(),
    date_expire: new Date(),    
    id_payment_card_release_detail: "fuMS21I6othUm34385WV",
    id_payment_card: '9841654DOIWSDYW235'  
  }
  * this.vhQueryCafe.createPaymentCardCode(data)
        .then((coupon_code)=>{
          console.log('createPaymentCardCode', coupon_code);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @return Promise => Object
  */
  private createPaymentCardCode(data:any){
    return new Promise((resolve,reject) => {
      let _data = {...data};
      _data.id_branch = this.getDefaultBranch()._id;
      _data.status = 1;
      _data.code = this.vhAlgorithm.createCardCode();     
      this.vhMGDB_database.getDocsByFields('payment_card_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
          .then((payment_card_codes:any)=>{
            if(payment_card_codes.length>0){
              _data.code = this.vhAlgorithm.createCardCode();  
              this.vhMGDB_database.getDocsByFields('payment_card_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                  .then((payment_card_codes:any)=>{
                    if(payment_card_codes.length>0){
                      _data.code = this.vhAlgorithm.createCardCode();  
                      this.vhMGDB_database.getDocsByFields('payment_card_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                          .then((payment_card_codes:any)=>{
                            if(payment_card_codes.length>0){
                              reject({error: {message: 'Nói anh Huy xem lại phần tạo mã code tự động, code tạo mới bị trùng'}});
                            }else{
                              this.vhMGDB_database.addDoc('payment_card_codes', _data)
                                  .then((payment_card_code)=>{
                                    resolve(payment_card_code);
                                  }, error=>{
                                    reject(error)
                                  })
                            }
                          }, error=>{
                              reject(error);
                          })     
                    }else{
                      this.vhMGDB_database.addDoc('payment_card_codes', _data)
                          .then((payment_card_code)=>{
                            resolve(payment_card_code);
                          }, error=>{
                            reject(error)
                          })
                    }
                  }, error=>{
                      reject(error);
                  })                 
            }else{
              this.vhMGDB_database.addDoc('payment_card_codes', _data)
                  .then((payment_card_code)=>{
                    resolve(payment_card_code);
                  }, error=>{
                    reject(error)
                  })
            }
          }, error=>{
              reject(error);
          })     
    })
  }
  

  /**
  *  hàm này để phát hành nhiều payment_card_code theo số lượng truyền vào, và tự động cập nhật trường số lượng đã phát hành (quantity_released) tăng lên 
  * trong collection payment_card_release_details 
  * @example:  
  let data = {
      date_validity: new Date(),
      date_expire: new Date(),    
      id_payment_card_release_detail: "fuMS21I6othUm34385WV",
      id_payment_card: '9841654DOIWSDYW235'  
  }
  * this.vhQueryCafe.createPaymentCardCodes(data, 10)
        .then((voucher_codes)=>{
          console.log('createPaymentCardCodes', voucher_codes);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @param quantity
  * @return Promise => Array(object)
  */
  public createPaymentCardCodes(data:any, quantity:number){
    return new Promise((resolve,reject) => {
      let promise = new Array();
      for(let i=0; i<quantity; i++){        
        promise[i] = this.createPaymentCardCode(data);        
      }       
      Promise.all(promise)
            .then((array:any)=>{
              array = array.flat();
              this.vhMGDB_database.getDoc('payment_card_release_details', data.id_payment_card_release_detail)
                  .then((payment_card_release_detail:any)=>{
                    if(payment_card_release_detail){
                      if(payment_card_release_detail.quantity_released != undefined){
                        let value = {quantity_released: payment_card_release_detail.quantity_released + quantity}
                        this.vhMGDB_database.updateDoc('payment_card_release_details', payment_card_release_detail._id, value)
                            .then(()=>{
                              resolve(array);
                            }, error=>{
                              reject(error)
                            })   
                      }else{
                        let value = {quantity_released: quantity}
                        this.vhMGDB_database.updateDoc('payment_card_release_details', payment_card_release_detail._id, value)
                            .then(()=>{
                              resolve(array);
                            }, error=>{
                              reject(error)
                            })
                      }
                    }                     
                  }, error=>{
                      reject(error);
                  })   
            })
            .catch(e=>{
              reject(e);
            })
    })
  }
/**
  * @example:  
  * let data = {
      date_validity: new Date(),
      date_expire: new Date(),
      id_branch: "4zFGhVUAZyj5d09r01xZ"
    }
  * this.vhQueryCafe.updatePaymentCardCode('OUHEOIWUYGHIQNIDOUW1359478',data)
        .then((bool:any)=>{
          console.log('updateCouponCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_code
  * @param data
  * @return Promise => boolean = true or false
  */
  public updatePaymentCardCode(id_payment_card_code:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('payment_card_codes', id_payment_card_code, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
  * Hàm này chỉ cho phép xóa payment_card đang ở trạng thái đã phát hành (status ==1),
  * và cập nhật giảm trường số lượng quantity_released bớt một trong collection payment_card_release_details
  * @example:   
  * this.vhQueryCafe.deletePaymentCardCode('OUHEOIWUYGHIQNIDOUW1359478', 'qKgt3cRPRXtw75JV9URp'})
        .then((bool:any)=>{
          console.log('deletePaymentCardCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_code
  * @param id_payment_card_release_detail      
  * @return Promise => boolean = true or false
  */
  public deletePaymentCardCode(id_payment_card_code:string, id_payment_card_release_detail:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('payment_card_codes', id_payment_card_code)
          .then((bool:any)=>{            
            if(bool){      
              this.vhMGDB_database.getDoc('payment_card_release_details', id_payment_card_release_detail)
                  .then((payment_card_release_detail:any)=>{
                    if(payment_card_release_detail){
                      if(payment_card_release_detail.quantity_released != undefined){
                        let value = {quantity_released: payment_card_release_detail.quantity_released - 1}
                        this.vhMGDB_database.updateDoc('payment_card_release_details', payment_card_release_detail._id, value)
                            .then(()=>{
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })   
                      }else{                                
                        let value = {quantity_released: 0}//-1 thì vô lý quá, nên kiểm tra lại sau
                        this.vhMGDB_database.updateDoc('payment_card_release_details', payment_card_release_detail._id, value)
                            .then(()=>{
                              console.log('Báo anh Huy kiểm tra lại trường hợp này');
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })
                      }
                    }                     
                  }, error=>{
                      reject(error);
                  })                     
            }else{
                resolve(false);
            }  
          }, error=>{
            reject(error)
          })          
    })
  }
/** 
  * hàm này trả về danh sách payment_card_codes đã phát hành theo mỗi đợt
  * @example:  
  * 
  * this.vhQueryCafe.getPaymentCardCodes_byIdPaymentCardReleaseDetail('OUHEOIWUYGHIQNIDOUW1359478'})
        .then((array:any)=>{
          console.log('getPaymentCardCodes_byIdPaymentCardReleaseDetail', array);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_release_detail
  * @return Promise => Array<any> 
  */
  public getPaymentCardCodes_byIdPaymentCardReleaseDetail(id_payment_card_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('payment_card_codes', {id_payment_card_release_detail:{$eq:id_payment_card_release_detail}}, {})
              .then((voucher_codes)=>{
                resolve(voucher_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }  

  /** 
  * hàm này trả về danh sách payment_card code đã phát hành theo điều kiện query
  * @example:  
  * this.vhQueryCafe.getPaymentCardCodes_byFields({status:{$eq: 1}}, {}, {}, 0)
        .then((res)=>{
          console.log('getPaymentCardCodes_byFields', res);
        }, error=>{
          console.log('error', error);
        })
  * @param query
  * @param projection
  * @param sort
  * @param limit
  * @return Promise => array(object) = [{},{},..]
  */
  public getPaymentCardCodes_byFields(query: object, projection: object, sort: object, limit: number){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('payment_card_codes', query,{},sort,limit)
              .then((payment_card_codes)=>{
                resolve(payment_card_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }
/** 
  *  hàm này trả về payment_card_code đã phát hành theo trường _id của payment_card_code. dùng trong trang bán hàng thanh toán bằng payment_card (chỉ lấy được hàng hóa có và còn trong card)
  * @example:  
  * 
  * this.vhQueryCafe.getPaymentCardCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getPaymentCardCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_code: cũng chính là code
  * @return Promise => obj = {} or null
  */
  public getPaymentCardCode(id_payment_card_code:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('payment_card_codes', id_payment_card_code)
            .then((payment_card_code)=>{
              resolve(payment_card_code);
            }, error=>{
                reject(error);
            })          
    })
  }

  
  /** 
  * hàm này trả về payment_card code đã phát hành theo trường _id của payment_card code
  * trả về có cả code, name_payment_card, name_payment_card_release
  * @example:  
  * 
  * this.vhQueryCafe.getPaymentCard_Code_Name_Release('OUHEDW0512'})
        .then((res)=>{
          console.log('getPaymentCard_Code_Name_Release', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getPaymentCard_Code_Name_Release(id_payment_card_code:any){
    return new Promise((resolve, reject) => {
        this.vhMGDB_database.getDoc('payment_card_codes', id_payment_card_code)
            .then((payment_card_code:any)=>{
              if(payment_card_code){
                let payment_card = cloneDeep(payment_card_code);             
                this.vhMGDB_database.getDoc('payment_card_release_details', payment_card.id_payment_card_release_detail)
                    .then((payment_card_release_detail:any)=>{
                      if(payment_card_release_detail){
                        Promise.all([
                          this.vhMGDB_database.getDoc('payment_cards', payment_card_release_detail.id_payment_card),                            
                          this.vhMGDB_database.getDoc('payment_card_releases', payment_card_release_detail.id_payment_card_release)
                        ]).then((array:any)=>{ 
                          payment_card.units = array[0].units;
                          if(payment_card.status === 1){                                
                            payment_card.products = array[0].products;
                            payment_card.points = array[0].points;
                          }                                                
                          payment_card.name_payment_card = array[0].name;
                          payment_card.name_payment_card_release = array[1].name;
                          if(payment_card.products){
                            for(let j=0; j<payment_card.products.length; j++){
                              if((payment_card.products[j].ptype ===1)||(payment_card.products[j].ptype ===2)||(payment_card.products[j].ptype ===3)||(payment_card.products[j].ptype ===4)){
                                let id_sub_or_product = payment_card.products[j].id_subproduct?payment_card.products[j].id_subproduct:payment_card.products[j].id_product;
                                let product = this.getlocalDetailProduct(id_sub_or_product);
                                payment_card.products[j].name = product.name;
                                payment_card.products[j].units = product.units;
                                if(product.lots) payment_card.products[j].lots = product.lots;  
                                if(payment_card.products[j].toppings){
                                  for(let k=0; k<payment_card.products[j].toppings.length; k++){
                                    let topping = this.getlocalDetailProduct(payment_card.products[j].toppings[k].id_product);
                                    payment_card.products[j].toppings[k].name = topping.name;
                                    payment_card.products[j].toppings[k].units = topping.units;
                                  }
                                }
                              }else if(payment_card.products[j].ptype ===5){
                                let product = this.getlocalDetailProduct(payment_card.products[j].id_product);
                                payment_card.products[j].name = product.name;
                                payment_card.products[j].units = product.units;
                                payment_card.products[j].combos = product.combos;
                                for(let m=0; m<payment_card.products[j].combos.length; m++){
                                  let _id_sub_or_product = payment_card.products[j].combos[m].id_subproduct?payment_card.products[j].combos[m].id_subproduct:payment_card.products[j].combos[m].id_product;
                                  let _product = this.getlocalDetailProduct(_id_sub_or_product);
                                  payment_card.products[j].combos[m].name = _product.name;
                                  payment_card.products[j].combos[m].units = _product.units;
                                  if(_product.lots) payment_card.products[j].combos[m].lots = _product.lots;
                                  if(payment_card.products[j].combos[m].toppings){
                                    for(let k=0; k<payment_card.products[j].combos[m].toppings.length; k++){
                                      let topping = this.getlocalDetailProduct(payment_card.products[j].combos[m].toppings[k].id_product);
                                      payment_card.products[j].combos[m].toppings[k].name = topping.name;
                                      payment_card.products[j].combos[m].toppings[k].units = topping.units;
                                    }
                                  }
                                }
                              }
                            }
                          }
                          resolve(payment_card);
                        })                            
                      }else resolve(null); 
                    },(error:any)=>{                      
                      reject(error);
                    })
              }else resolve(null);             
            }, error=>{
                reject(error);
            })   
      // this.vhMGDB_database.getDoc('payment_card_codes', id_payment_card_code)
      //       .then((payment_card_code:any)=>{
      //         if(payment_card_code){
      //           let payment_card = cloneDeep(payment_card_code);               
      //           this.vhMGDB_database.getDoc('payment_card_release_details', payment_card_code.id_payment_card_release_detail)
      //               .then((payment_card_release_detail:any)=>{
      //                 if(payment_card_release_detail){
      //                   Promise.all([
      //                     this.vhMGDB_database.getDoc('payment_cards', payment_card_release_detail.id_payment_card),                            
      //                     this.vhMGDB_database.getDoc('payment_card_releases', payment_card_release_detail.id_payment_card_release)
      //                   ]).then((array:any)=>{
      //                     payment_card.name_payment_card = array[0].name;
      //                     payment_card.name_payment_card_release = array[1].name;
      //                     resolve(payment_card);
      //                   })                            
      //                 }else resolve(null); 
      //               },(error:any)=>{                      
      //                 reject(error);
      //               })
      //         }else resolve(null);             
      //       }, error=>{
      //           reject(error);
      //       })          
    })
  }

  /** 
  * hàm này trả về payment_card đã phát hành theo trường code của payment_card_code. dùng trong trang đổi điểm lấy thẻ payment_card và bán payment_card, đổi payment_card lấy hàng hóa,
  * trả về có cả code, name_payment_card, name_payment_card_release
  * @example:  
  * 
  * this.vhQueryCafe.getPaymentCard_Code_Name_Release_byCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getPaymentCard_Code_Name_Release_byCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getPaymentCard_Code_Name_Release_byCode(code:any){
    return new Promise((resolve, reject) => {
      //let id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.getDocsByFields('payment_card_codes', {code:{$eq:code}})
            .then((payment_card_codes:any)=>{
              if(payment_card_codes.length>0){
                let payment_card = cloneDeep(payment_card_codes[0]);               
                this.vhMGDB_database.getDoc('payment_card_release_details', payment_card.id_payment_card_release_detail)
                    .then((payment_card_release_detail:any)=>{
                      if(payment_card_release_detail){
                        Promise.all([
                          this.vhMGDB_database.getDoc('payment_cards', payment_card_release_detail.id_payment_card),                            
                          this.vhMGDB_database.getDoc('payment_card_releases', payment_card_release_detail.id_payment_card_release)
                        ]).then((array:any)=>{ 
                          payment_card.units = array[0].units;
                          if(payment_card.status === 1){                                
                            payment_card.products = array[0].products;
                            payment_card.points = array[0].points;
                          }                                                
                          payment_card.name_payment_card = array[0].name;
                          payment_card.name_payment_card_release = array[1].name;
                          if(payment_card.products){
                            for(let j=0; j<payment_card.products.length; j++){
                              if((payment_card.products[j].ptype ===1)||(payment_card.products[j].ptype ===2)||(payment_card.products[j].ptype ===3)||(payment_card.products[j].ptype ===4)){
                                let id_sub_or_product = payment_card.products[j].id_subproduct?payment_card.products[j].id_subproduct:payment_card.products[j].id_product;
                                let product = this.getlocalDetailProduct(id_sub_or_product);
                                payment_card.products[j].name = product.name;
                                payment_card.products[j].units = product.units;
                                if(product.lots) payment_card.products[j].lots = product.lots;  
                                if(payment_card.products[j].toppings){
                                  for(let k=0; k<payment_card.products[j].toppings.length; k++){
                                    let topping = this.getlocalDetailProduct(payment_card.products[j].toppings[k].id_product);
                                    payment_card.products[j].toppings[k].name = topping.name;
                                    payment_card.products[j].toppings[k].units = topping.units;
                                  }
                                }
                  
                              }else if(payment_card.products[j].ptype ===5){
                                let product = this.getlocalDetailProduct(payment_card.products[j].id_product);
                                payment_card.products[j].name = product.name;
                                payment_card.products[j].units = product.units;
                                payment_card.products[j].combos = product.combos;
                                for(let m=0; m<payment_card.products[j].combos.length; m++){
                                  let _id_sub_or_product = payment_card.products[j].combos[m].id_subproduct?payment_card.products[j].combos[m].id_subproduct:payment_card.products[j].combos[m].id_product;
                                  let _product = this.getlocalDetailProduct(_id_sub_or_product);
                                  payment_card.products[j].combos[m].name = _product.name;
                                  payment_card.products[j].combos[m].units = _product.units;
                                  if(_product.lots) payment_card.products[j].combos[m].lots = _product.lots;
                                }
                              }
                            }
                          }
                          resolve(payment_card);
                        })                            
                      }else resolve(null); 
                    },(error:any)=>{                      
                      reject(error);
                    })
              }else resolve(null);             
            }, error=>{
                reject(error);
            })          
    })
  }

  
/* Hàm này để đổi payment_card từ điểm của khách hàng. Đổi thành công tự động tạo lịch sử đổi điểm của khách hàng
  * hàm này đã cập nhật lại trường status, id_customer, date_points_exchanged cho payment_cards
  * hàm này đã cập nhật lại trường earned_points, id_customer, branch_earned_points cho customers  
  * @example: 
  * let array = [{id_payment_code, points, products},{}...]
  * this.vhQueryCafe.exchangePaymentCardCode_byEarningPoints(array, "fuMS21I6othUm34385WV", 10)
        .then((bool:any)=>{
          console.log('exchangePaymentCardCode_byEarningPoints', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param array_id_payment_card_code_and_points_and_products
  * @param id_customer
  * @param points
  * @return Promise Boolean => true or false
  */
  public exchangePaymentCardCode_byEarningPoints(array_id_payment_card_code_and_points_and_products:any, id_customer:any, points:any){
    //console.log('---array_id_payment_card_code_and_points_and_products', array_id_payment_card_code_and_points_and_products);
    return new Promise((resolve, reject) => {
      let promise_zero:any = new Array();
      for(let i=0; i<array_id_payment_card_code_and_points_and_products.length; i++){
        promise_zero[i] = this.vhMGDB_database.getDoc('payment_card_codes', array_id_payment_card_code_and_points_and_products[i].id_payment_card_code);
      }
      promise_zero[promise_zero.length] = this.vhMGDB_database.getDoc('customers', id_customer);
      Promise.all(promise_zero)
            .then((array:any)=>{
              let promise_one:any = new Array();
              for(let i=0; i<array.length -1; i++){
                let value_payment_card_code = {
                  status: 3,                  
                  date_points_exchanged: new Date(),
                  points: array_id_payment_card_code_and_points_and_products[i].points,
                  products: array_id_payment_card_code_and_points_and_products[i].products,
                  id_customer: id_customer
                }
                  //status 2 hoặc 3 phải cập nhật trường outquantity = 0       
                for(let j=0; j<value_payment_card_code.products.length; j++){
                  value_payment_card_code.products[j].outquantity = 0;                                        
                }
                promise_one[i] = this.vhMGDB_database.updateDoc('payment_card_codes', array[i]._id, value_payment_card_code);
              }
              let customer:any = array[array.length-1];
              if(customer.earned_points != undefined){
                customer.earned_points = customer.earned_points - points;
              }else{
                customer.earned_points = 0;
              }
              let branch = this.getDefaultBranch();
              if(customer.branch_earned_points !=undefined){
                if(customer.branch_earned_points[branch._id] !=undefined){
                  customer.branch_earned_points[branch._id] = customer.branch_earned_points[branch._id] -points;
                }else{
                  customer.branch_earned_points[branch._id] = 0;
                }
              }else{
                customer.branch_earned_points = {};
              }
              let value_customer = {
                earned_points: customer.earned_points,
                branch_earned_points: customer.branch_earned_points    
              }
              promise_one[promise_one.length] = this._updateCustomer(customer._id, value_customer);
              Promise.all(promise_one)
                    .then(()=>{
                      resolve(true);
                    })
            })
    })
  }

/**
  * không cần hàm này vì khi tạo phiếu bill_type51 đã được cập nhật
  * hàm này dùng để cập nhật số lượng sản phẩm trong Payment Card khi đổi thẻ
  * @example:
  * this.vhQueryCafe.getPaymentCardCode_byCode("ONHDIWUHIODUWN","NDPIUWUHIOUYEW",{quantity_valid: 0})
        .then((res)=>{
          console.log('getPaymentCardCode_byCode', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_payment_card
  * @param id_comboproduct
  * @param data
  * @return Promise object or null
  */
  public updateComboPaymentCard(id_payment_card:any, id_comboproduct:any, data:any){//chưa có code
  }


/**
  * Hàm này MÁY ĐANG DÙNG PHẦN MỀM sẽ mở kết nối với tất cả các thiết bị giao tiếp RS232 đã khai báo trong Cài đặt/Cấu hình/Bảng LED hiển thị giá
  * @example:
  *  this.vhQueryCafe.connectDisplayLEDScreens();
  */
  public connectDisplayLEDScreens(){
    let displayLEDs:any = this.vhDisplayLEDService.getlocalDisplayLEDs(); 
    console.log('displayLEDs', displayLEDs);
    for(let i=0; i<displayLEDs.length; i++){
      if(displayLEDs[i].enable)
      this.vhDisplayLEDService.openPort(displayLEDs[i].port, displayLEDs[i].baundrate)
          .then((t: any) => {                      
            this.vhDisplayLEDService.updateLocalDisplayLEDs(displayLEDs[i]._id, {connected:true});
            console.log('ket noi thanh cong', displayLEDs[i].port);
          })
          .catch((f: any) => {           
            console.log('ket noi that bai', displayLEDs[i].port);
          });
    }
    
  }

/**
  * Hàm này MÁY ĐANG DÙNG PHẦN MỀM sẽ đóng kết nối với tất cả các thiết bị giao tiếp RS232 đã khai báo trong Cài đặt/Cấu hình/Bảng LED hiển thị giá
  * @example:
  *  this.vhQueryCafe.connectDisplayLEDScreens();
  */
  public disconnectDisplayLEDScreens(){
    let displayLEDs:any = this.vhDisplayLEDService.getlocalDisplayLEDs(); 
    for(let i=0; i<displayLEDs.length; i++){
      if(displayLEDs[i].connected)
      this.vhDisplayLEDService.closePort()
          .then((t: any) => {           
            this.vhDisplayLEDService.updateLocalDisplayLEDs(displayLEDs[i]._id, {connected:false});        
          })
          .catch((f: any) => {            
          });
    }
  }

/**
  * Hàm này PHẦN MỀM sẽ gửi bill và bill_details xuống bảng LED hiển thị giá để hiển thị giá trị lên.
  * Lưu ý bắt sự kiện giá trị tổng hóa đơn (total) thay đổi và gọi lại hàm này.
  * @example:
  *  this.vhQueryCafe.writeBill_BillDetails_toDisplayLEDScreens(bill, bill_details);
  */
  public writeBill_BillDetails_toDisplayLEDScreens(bill:any, bill_details:any){
    //console.log('----bill', bill);
    //console.log('----bill_details', bill_details);
    //if((bill.total === undefined)||(bill.total === null)) return null;
    let displayLEDs:any = this.vhDisplayLEDService.getlocalDisplayLEDs();      
    for(let i=0; i<displayLEDs.length; i++){
      //-------------------LED 7 đoạn - 1 hàng 8 LED--------------------------------------
      if(displayLEDs[i].connected && displayLEDs[i].enable)
      if(displayLEDs[i].type_display_model === 1){//LED 7 đoạn - 1 hàng 8 LED
        if(displayLEDs[i].type_display_mode === 1){//Chi tiết hóa đơn                
          let str = bill.total + '';
          let str8 = str;
          str8 = this.vhAlgorithm.changeMoneyToDotMoney(str8, 20);   
          for(let k=1; k<=8; k++){
            if(k>str.length) str8 = ' ' + str8;
          }
          if(str.length >= 7) str8 = str8.slice(0, 10);
          else if(str.length >= 4) str8 = str8.slice(0, 9);
          this.vhDisplayLEDService.writeLine(str8)
              .then(() => {})
              .catch((err) => {});        
        }else if(displayLEDs[i].type_display_mode === 2){//Chi tiết hóa đơn & tổng tiền          
          let str = bill.total + '';
          let str8 = str;
          str8 = this.vhAlgorithm.changeMoneyToDotMoney(str8, 20);   
          for(let k=1; k<=8; k++){
            if(k>str.length) str8 = ' ' + str8;
          }
          if(str.length >= 7) str8 = str8.slice(0, 10);
          else if(str.length >= 4) str8 = str8.slice(0, 9);
          this.vhDisplayLEDService.writeLine(str8)
              .then(() => {})
              .catch((err) => {});          
        }else if(displayLEDs[i].type_display_mode === 3){//Tổng tiền  
          let str = bill.total + '';
          let str8 = str;
          str8 = this.vhAlgorithm.changeMoneyToDotMoney(str8, 20);   
          for(let k=1; k<=8; k++){
            if(k>str.length) str8 = ' ' + str8;
          }
          if(str.length >= 7) str8 = str8.slice(0, 10);
          else if(str.length >= 4) str8 = str8.slice(0, 9);
          this.vhDisplayLEDService.writeLine(str8)
              .then(() => {})
              .catch((err) => {});   
            // let str = bill.total + '';
            // str = str.slice(0, 8);
            // let str8 = str;
            // for(let k=1; k<=8; k++){
            //   if(k>str.length) str8 = ' ' + str8;
            // }
            // if(str.length >=7){
            //   str8 = str8.slice(0, 5)  + '.' + str8.slice(5) ;
            //   str8 = str8.slice(0, 2)  + '.' + str8.slice(2) ;
            // }else if(str.length >=4){
            //   str8 = str8.slice(0, 5)  + '.' + str8.slice(5) ;
            // }
            // str8 = str8.slice(0, 10);
            // this.vhDisplayLEDService.writeLine(str8)
            //     .then(() => {})
            //     .catch((err) => {});          
        }
        //-----------------LED ma trận - 2 hàng 20 cột-----------------------------------
      }else if(displayLEDs[i].type_display_model === 2){//LED ma trận - 2 hàng 20 cột
        if(displayLEDs[i].type_display_mode === 1){//Chi tiết hóa đơn          
          if(bill_details.length >0){
            let name1 = 'San Pham1';
            let name2 = 'San Pham2';
            let price1 = '0';
            let price2 = '0';
            if(bill_details[0].name) name1 = bill_details[0].name;
            name1 = this.vhAlgorithm.changeAlias(name1);
            name1 = name1.slice(0, 9);
            if(bill_details[1].name) name2 = bill_details[1].name;
            name2 = this.vhAlgorithm.changeAlias(name2);
            name2 = name2.slice(0, 9);
            if(bill_details[0].price) price1 = bill_details[0].price + '';
            if(bill_details[1].price) price2 = bill_details[1].price + '';            
          
            price1 = this.vhAlgorithm.changeMoneyToDotMoney(price1, 10);
            price2 = this.vhAlgorithm.changeMoneyToDotMoney(price2, 10);

            if(bill_details.length === 1){
              let str1 = name1 + ' ' + price1;
              let str_blank = '                    ';
              this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                  .then(() => {
                    this.vhDisplayLEDService.writeLineAtPos(str1, 0)
                        .then(() => {})
                        .catch((err) => {});   
                  })
                .catch((err) => {});   
                
            }else if(bill_details.length >= 2){
              let str1 = name1 + ' ' + price1;
              let str2 = name2 + ' ' + price2;
              let str_blank = '                    ';
              this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});     
            }              
          }               
        }else if(displayLEDs[i].type_display_mode === 2){//Chi tiết hóa đơn & tổng tiền         
          if(bill_details.length >0){
            let name1 = 'San Pham1';           
            let price1 = '0';         
            if(bill_details[0].name) name1 = bill_details[0].name;
            name1 = this.vhAlgorithm.changeAlias(name1);
            name1 = name1.slice(0, 9);
            if(bill_details[0].price) price1 = bill_details[0].price + '';
            price1 = this.vhAlgorithm.changeMoneyToDotMoney(price1, 10);
            let str1 = name1 + ' ' + price1;

            let str2 = bill.total + '';
            str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 10);    
            if(str2.length >=10) str2 = 'Tong tien:' + str2;
            else str2 = 'Tong tien: ' + str2;               
            str2 = str2.slice(0, 20);

            let str_blank = '                    ';
            this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});               
          }else{
            let str2 = bill.total + '';
            str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 10); 
            if(str2.length >=10) str2 = 'Tong tien:' + str2;
            else str2 = 'Tong tien: ' + str2;                 
            str2 = str2.slice(0, 20);
            let str_blank = '                    ';
            this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(' ', str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});       
          }                            
        }else if(displayLEDs[i].type_display_mode === 3){//Tổng tiền                
          let str1 = 'Tong tien:';           
          let str2 = bill.total + '';
          str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 20);                  
          let str_blank = '                    ';
          this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
              .then(() => {
                this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                    .then(() => {})
                    .catch((err) => {}); 
              })
              .catch((err) => {});             
        }
        //-------------------------------VFD-2100-------------------------------------
      }else if(displayLEDs[i].type_display_model === 3){//VFD-2100
        if(displayLEDs[i].type_display_mode === 1){//Chi tiết hóa đơn          
          if(bill_details.length >0){
            let name1 = 'San Pham1';
            let name2 = 'San Pham2';
            let price1 = '0';
            let price2 = '0';
            if(bill_details[0].name) name1 = bill_details[0].name;
            name1 = this.vhAlgorithm.changeAlias(name1);
            name1 = name1.slice(0, 9);
            if(bill_details[1].name) name2 = bill_details[1].name;
            name2 = this.vhAlgorithm.changeAlias(name2);
            name2 = name2.slice(0, 9);
            if(bill_details[0].price) price1 = bill_details[0].price + '';
            if(bill_details[1].price) price2 = bill_details[1].price + '';            
          
            price1 = this.vhAlgorithm.changeMoneyToDotMoney(price1, 10);
            price2 = this.vhAlgorithm.changeMoneyToDotMoney(price2, 10);

            if(bill_details.length === 1){
              let str1 = name1 + ' ' + price1;
              let str_blank = '                    ';
              this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                  .then(() => {
                    this.vhDisplayLEDService.writeLineAtPos(str1, 0)
                        .then(() => {})
                        .catch((err) => {});   
                  })
                .catch((err) => {});   
                
            }else if(bill_details.length >= 2){
              let str1 = name1 + ' ' + price1;
              let str2 = name2 + ' ' + price2;
              let str_blank = '                    ';
              this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});     
            }              
          }               
        }else if(displayLEDs[i].type_display_mode === 2){//Chi tiết hóa đơn & tổng tiền         
          if(bill_details.length >0){
            let name1 = 'San Pham1';           
            let price1 = '0';         
            if(bill_details[0].name) name1 = bill_details[0].name;
            name1 = this.vhAlgorithm.changeAlias(name1);
            name1 = name1.slice(0, 9);
            if(bill_details[0].price) price1 = bill_details[0].price + '';
            price1 = this.vhAlgorithm.changeMoneyToDotMoney(price1, 10);
            let str1 = name1 + ' ' + price1;

            let str2 = bill.total + '';
            str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 10);    
            if(str2.length >=10) str2 = 'Tong tien:' + str2;
            else str2 = 'Tong tien: ' + str2;               
            str2 = str2.slice(0, 20);

            let str_blank = '                    ';
            this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});               
          }else{
            let str2 = bill.total + '';
            str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 10); 
            if(str2.length >=10) str2 = 'Tong tien:' + str2;
            else str2 = 'Tong tien: ' + str2;                 
            str2 = str2.slice(0, 20);
            let str_blank = '                    ';
            this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(' ', str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});       
          }                            
        }else if(displayLEDs[i].type_display_mode === 3){//Tổng tiền                
          let str1 = 'Tong tien:';           
          let str2 = bill.total + '';
          str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 20);                  
          let str_blank = '                    ';
          this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
              .then(() => {
                this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                    .then(() => {})
                    .catch((err) => {}); 
              })
              .catch((err) => {});             
        }
      }
    }
  }  

  /**
   * vhQueryCafe
   * @param bill_details 
   * @returns 
   */
  private changeBillDetails_withPromotions_toRaw(bill_details:any){//xem bỏ id_category trong bill_detail
    console.log('changeBillDetails_withPromotions_toRaw_before', bill_details);
    let _bill_details = cloneDeep(bill_details);

    //Kiểm tra trường hợp bill_detail là sản phẩm con mà thiếu id_subproduct
    for(let i=0; i<bill_details.length; i++){
      if(bill_details[i].id_product){
        if(!bill_details[i].id_subproduct){
          let product = this.getlocalDetailProduct(bill_details[i].id_product);
          if(!product){
            console.log('bill_detail thiếu id_subproduct');
            return null;
          }
        }
      }    
    }

    //Đổi bill_detail (voucher) thành bill_detail mà database lưu trữ
    let bill_details_voucher = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if(_bill_details[i].vtype===1){       
        for(let j=0; j<_bill_details[i].products.length; j++){
          let bill_detail = {..._bill_details[i], ..._bill_details[i].products[j]};         
          delete bill_detail.products;
          bill_details_voucher.push(bill_detail);
        }
        _bill_details[i] = null;
      }
    }
    _bill_details = _bill_details.filter((e:any)=>e!=null);
    for(let i=0; i<bill_details_voucher.length; i++){
      _bill_details.push(bill_details_voucher[i]);
    }

    //Đổi bill_detail (payment_card) thành bill_detail mà database lưu trữ
    let bill_details_payment_card = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if(_bill_details[i].pctype===1){       
        for(let j=0; j<_bill_details[i].products.length; j++){
          let bill_detail = {..._bill_details[i], ..._bill_details[i].products[j]};         
          delete bill_detail.products;
          bill_details_payment_card.push(bill_detail);
        }
        _bill_details[i] = null;
      }
    }
    _bill_details = _bill_details.filter((e:any)=>e!=null);
    for(let i=0; i<bill_details_payment_card.length; i++){
      _bill_details.push(bill_details_payment_card[i]);
    }

    //Đổi bill_detail (khuyến mãi 1,2,3,4,5) thành bill_detail mà database lưu trữ
    let bill_details_promotion = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if((_bill_details[i].pmtype===1)||(_bill_details[i].pmtype===2)||(_bill_details[i].pmtype===3)||(_bill_details[i].pmtype===4)||(_bill_details[i].pmtype===5)){       
        for(let j=0; j<_bill_details[i].products.length; j++){
          let bill_detail = {..._bill_details[i], ..._bill_details[i].products[j]};         
          delete bill_detail.products;
          bill_details_promotion.push(bill_detail);
        }
        _bill_details[i] = null;
      }
    }
    _bill_details = _bill_details.filter((e:any)=>e!=null);
    for(let i=0; i<bill_details_promotion.length; i++){
      _bill_details.push(bill_details_promotion[i]);
    }
    //Đổi bill_detail (khuyến mãi 6,7) thành bill_detail mà database lưu trữ
    bill_details_promotion = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if((_bill_details[i].pmtype===6)||(_bill_details[i].pmtype===7)){       
        for(let j=0; j<_bill_details[i].products_gift.length; j++){
          //if(_bill_details[i].products_gift[j].chose){
            let bill_detail = {..._bill_details[i], ..._bill_details[i].products_gift[j]};         
            delete bill_detail.products_gift;
            bill_details_promotion.push(bill_detail);
          //}          
        }
        _bill_details[i] = null;
      }
    }
    _bill_details = _bill_details.filter((e:any)=>e!=null);
    for(let i=0; i<bill_details_promotion.length; i++){
      _bill_details.push(bill_details_promotion[i]);
    }


    //Đổi bill_detail (sản phẩm con) thành bill_detail mà database lưu trữ
    /*for(let i=0; i<_bill_details.length; i++){
      if(_bill_details[i].id_subproduct){
        _bill_details[i].id_subs_group = _bill_details[i].id_product;
        _bill_details[i].id_product =  _bill_details[i].id_subproduct;
        delete _bill_details[i].id_subproduct;
      }
    }*/
    //Đổi bill_detail (có combo) thành bill_detail mà database lưu trư
    let bill_details_combo = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if(_bill_details[i].ptype ===5){
        let bill_detail_ID = this.vhAlgorithm.ObjectId();//bill_detail_ID này, chỉ fw sài khi tách 1 bill_detail ra thành một hoặc nhiều bill_detail
        let id_combos_group = _bill_details[i].id_product;
        let factor_combo = 1;
        if(_bill_details[i].price_origin) factor_combo = this.vhAlgorithm.roundTo3Decimals(_bill_details[i].price/_bill_details[i].price_origin);
        let combos_group = {
          earning_points_product: _bill_details[i].earning_points_product,
          price: _bill_details[i].price,
          price_origin: _bill_details[i].price_origin,
          ptype: _bill_details[i].ptype,
          quantity: _bill_details[i].quantity,
          //tax: _bill_details[i].tax,
          ratio: _bill_details[i].ratio,
          //unit:  _bill_details[i].unit,       
        }
        delete _bill_details[i].id_product;
        delete _bill_details[i].earning_points_product;
        delete _bill_details[i].price;
        delete _bill_details[i].price_origin;
        delete _bill_details[i].ptype;
        delete _bill_details[i].quantity;
        //delete _bill_details[i].tax;
        delete _bill_details[i].ratio;
        //delete _bill_details[i].unit;//nếu frontend lỡ có thì cho xóa luôn
        for(let j=0; j<_bill_details[i].combos.length; j++){
          let bill_detail = {..._bill_details[i], ..._bill_details[i].combos[j]};
          bill_detail.quantity = bill_detail.quantity * combos_group.quantity * combos_group.ratio; //do luôn tại combo ko có 2 đơn vị nên ko đưa vào cũng đc
          bill_detail.price_origin =  bill_detail.price;
          if(factor_combo !=1) bill_detail.price =  Math.round(bill_detail.price * factor_combo*100)/100;
          bill_detail.cbtype = 5;
          delete bill_detail.combos;
          bill_detail.id_combos_group = id_combos_group;
          bill_detail.combos_group = {...combos_group};
          bill_detail.bill_detail_ID = bill_detail_ID;
          bill_details_combo.push(bill_detail);
        }
        _bill_details[i] = null;
      }
    }
   
    _bill_details = _bill_details.filter((e:any)=>e!=null);
    for(let i=0; i<bill_details_combo.length; i++){
      _bill_details.push(bill_details_combo[i]);
    }
    console.log('changeBillDetails_withPromotions_toRaw_after', _bill_details);
    return _bill_details;
  }

  private changeBillDetails_withRaw_toPromotions(bill_details:any){
    console.log('-----changeBillDetails_withRaw_toPromotions_before', bill_details);
    let _bill_details = cloneDeep(bill_details);    

    //Đổi nhiều bill_detail là thành phần của 1 nhóm topping nào đó => thành 1 bill_detail mà có 1 nhóm topping
/*    let bill_details_topping = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if((_bill_details[i].id_topping_group)&&(!_bill_details[i].chose)){
        //Tạo bill_detail mà chưa có nhóm topping
        let bill_detail = {..._bill_details[i]};
        delete bill_detail.id_product;
        delete bill_detail.price;
        delete bill_detail.ptype;
        delete bill_detail.quantity;
        delete bill_detail.ratio;
        delete bill_detail.unit;
        bill_detail = {...bill_detail, ..._bill_details[i].combos_group};
        delete bill_detail.combos_group;      
        bill_detail.id_product = bill_detail.id_combos_group;        
        delete bill_detail.id_combos_group;
        let combos = new Array();
        for(let j=0; j<_bill_details.length; j++){//Nhóm các các combo có cùng bill_detail_ID lại
          let bill_detail_J = {..._bill_details[j]};
          if(_bill_details[i].bill_detail_ID === bill_detail_J.bill_detail_ID){
          /////  if(_bill_details[i].id_combos_group === bill_detail_J.id_combos_group){//Kiểm tra này sài đc thì bỏ bill_detail_ID
            _bill_details[j].chose  = true;
            
            let combo:any = {
              id_product: bill_detail_J.id_product,
              price: bill_detail_J.price,
              ptype: bill_detail_J.ptype,
              quantity: bill_detail_J.quantity/(bill_detail_J.combos_group.quantity * bill_detail_J.combos_group.ratio),
              ratio: bill_detail_J.ratio
              //unit: bill_detail_J.unit
            }
            if(bill_detail_J.price_origin) combo.price = bill_detail_J.price_origin; //trong reportSales_combo ko có dòng này, vì chỉ xem thôi
            if(bill_detail_J.id_subproduct){
              combo.id_subproduct = bill_detail_J.id_subproduct;         
              //delete bill_detail_J.id_subproduct;                  
            }
            if(bill_detail_J.id_lotproduct){
              combo.id_lotproduct = bill_detail_J.id_lotproduct;         
              //delete bill_detail_J.id_lotproduct;     
              
            }
            combos.push(combo);
          }
        }
        bill_detail.combos = [...combos];//map combos vào bill_detail
        delete bill_detail.id_subproduct;
        delete bill_detail.id_lotproduct;
        bill_details_combo.push(bill_detail);//trong 1 hóa đơn sẽ có nhiều bill_detail (có combo)

      }
    }
    _bill_details = _bill_details.filter((e:any)=>!e.chose);
    for(let i=0; i<bill_details_topping.length; i++){
      _bill_details.push(bill_details_topping[i]);
    }
*/

    //Đổi nhiều bill_detail là thành phần của 1 combos nào đó => thành 1 bill_detail mà có 1 combos
    let bill_details_combo = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if((_bill_details[i].id_combos_group)&&(!_bill_details[i].chose)){
        //Tạo bill_detail mà chưa có combos
        let bill_detail = {..._bill_details[i]};
        //bill_detail.bill_detail_combo_ID = _bill_details[i]._id;
        bill_detail._id = _bill_details[i].bill_detail_ID;
        delete bill_detail.id_product;
        delete bill_detail.price;
        delete bill_detail.ptype;
        delete bill_detail.quantity;
        delete bill_detail.ratio;
        delete bill_detail.unit;
        bill_detail = {...bill_detail, ..._bill_details[i].combos_group};
        delete bill_detail.combos_group;      
        bill_detail.id_product = bill_detail.id_combos_group;        
        delete bill_detail.id_combos_group;
        let combos = new Array();
        for(let j=0; j<_bill_details.length; j++){//Nhóm các các combo có cùng bill_detail_ID lại
          let bill_detail_J = {..._bill_details[j]};
          if(_bill_details[i].bill_detail_ID === bill_detail_J.bill_detail_ID){
          /////  if(_bill_details[i].id_combos_group === bill_detail_J.id_combos_group){//Kiểm tra này sài đc thì bỏ bill_detail_ID
            _bill_details[j].chose  = true;           
            let combo:any = {
              id_product: bill_detail_J.id_product,
              price: bill_detail_J.price,
              ptype: bill_detail_J.ptype,
              quantity: bill_detail_J.quantity/(bill_detail_J.combos_group.quantity * bill_detail_J.combos_group.ratio),
              ratio: bill_detail_J.ratio
              //unit: bill_detail_J.unit
            }
            if(bill_detail_J.price_origin) combo.price = bill_detail_J.price_origin; //trong reportSales_combo ko có dòng này, vì chỉ xem thôi
            if(bill_detail_J.id_subproduct){
              combo.id_subproduct = bill_detail_J.id_subproduct;         
              //delete bill_detail_J.id_subproduct;                  
            }
            if(bill_detail_J.id_lotproduct){
              combo.id_lotproduct = bill_detail_J.id_lotproduct;         
              //delete bill_detail_J.id_lotproduct;                  
            }
            combos.push(combo);
          }
        }
        
        bill_detail.combos = [...combos];//map combos vào bill_detail
        delete bill_detail.id_subproduct;
        delete bill_detail.id_lotproduct;
        bill_details_combo.push(bill_detail);//trong 1 hóa đơn sẽ có nhiều bill_detail (có combo)

      }
    }
    _bill_details = _bill_details.filter((e:any)=>!e.chose);
    for(let i=0; i<bill_details_combo.length; i++){
      _bill_details.push(bill_details_combo[i]);
    }


    //Đổi bill_detail (khuyến mãi) thành bill_detail mà front_end làm việc
    let products_promotions = new Array();
    for(let i=0; i<_bill_details.length; i++){     
      let products_promotion = new Array();
      let bill_detail_promotion = null; 
        if((_bill_details[i].pmtype) && (!_bill_details[i].chose)){
          for(let j=i; j<_bill_details.length; j++){             
              if((_bill_details[j].pmtype) && (!_bill_details[j].chose)){              
                if(_bill_details[j].id_promotion ===_bill_details[i].id_promotion){                          
                    let product:any = {
                      earning_points_product: _bill_details[j]?.earning_points_product,
                      //id_category: _bill_details[j]?.id_category,
                      id_product: _bill_details[j].id_product,
                      price: _bill_details[j].price,
                      price_origin:_bill_details[j].price_origin,
                      ptype: _bill_details[j].ptype,
                      quantity: _bill_details[j].quantity,
                      ratio: _bill_details[j].ratio,
                      //unit: _bill_details[j].unit
                    }        
                    if(_bill_details[j].combos) product.combos = _bill_details[j].combos;
                    if(_bill_details[j].id_subproduct) product.id_subproduct = _bill_details[j].id_subproduct;
                    if(_bill_details[j].id_lotproduct) product.id_lotproduct = _bill_details[j].id_lotproduct;//mới
                    if(_bill_details[j].toppings) product.toppings = _bill_details[j].toppings;
                    if(_bill_details[j].properties) product.properties = _bill_details[j].properties;
                    products_promotion.push(product);
                    if(!bill_detail_promotion){
                        bill_detail_promotion = {..._bill_details[j]};
                        delete bill_detail_promotion.earning_points_product;
                        //delete bill_detail_promotion.id_category;
                        delete bill_detail_promotion.id_product;
                        delete bill_detail_promotion.price;
                        delete bill_detail_promotion.price_origin;
                        delete bill_detail_promotion.ptype;
                        delete bill_detail_promotion.quantity;
                        delete bill_detail_promotion.ratio;
                        delete bill_detail_promotion.unit;
                        delete bill_detail_promotion.combos;
                        if(bill_detail_promotion.id_subproduct) delete bill_detail_promotion.id_subproduct;
                        if(bill_detail_promotion.id_lotproduct) delete bill_detail_promotion.id_lotproduct;//mới
                        delete bill_detail_promotion.toppings;
                        delete bill_detail_promotion.properties;
                    }
                    _bill_details[j].chose = true;
                }           
              } 
          }
          if(bill_detail_promotion){
            if((bill_detail_promotion.pmtype===1)||(bill_detail_promotion.pmtype===2)||(bill_detail_promotion.pmtype===3)||(bill_detail_promotion.pmtype===4)||(bill_detail_promotion.pmtype===5)){
              bill_detail_promotion.products = [...products_promotion];
            }else if((bill_detail_promotion.pmtype===6)||(bill_detail_promotion.pmtype===7)){
              bill_detail_promotion.products_gift = [...products_promotion];
            }          
            products_promotions.push(bill_detail_promotion);          
          }
        }
    }   
    for(let i=0; i<products_promotions.length; i++){
      _bill_details.push(products_promotions[i]);        
    }        
    _bill_details = _bill_details.filter((e:any)=>e.chose!=true);

    //Đổi bill_detail (voucher) thành bill_detail mà front_end làm việc
    let products_vouchers = new Array();
    for(let i=0; i<_bill_details.length; i++){     
      let products_voucher = new Array();
      let bill_detail_voucher = null; 
        if((_bill_details[i].vtype===1) && (!_bill_details[i].chose)){
          for(let j=i; j<_bill_details.length; j++){             
              if((_bill_details[j].vtype ===1) && (!_bill_details[j].chose)){              
                if(_bill_details[j].id_voucher ===_bill_details[i].id_voucher){                          
                    let product:any = {
                      earning_points_product: _bill_details[j]?.earning_points_product,
                      id_category: _bill_details[j]?.id_category,
                      id_product: _bill_details[j].id_product,
                      price: _bill_details[j].price,
                      price_origin:_bill_details[j].price_origin,
                      ptype: _bill_details[j].ptype,
                      quantity: _bill_details[j].quantity,
                      ratio: _bill_details[j].ratio,
                      //unit: _bill_details[j].unit
                      //id_voucher: _bill_details[j].id_voucher,
                      //id_voucher_code: _bill_details[j].id_voucher_code
                    }        
                    if(_bill_details[j].combos) product.combos = _bill_details[j].combos;
                    if(_bill_details[j].id_subproduct) product.id_subproduct = _bill_details[j].id_subproduct;
                    if(_bill_details[j].id_lotproduct) product.id_lotproduct = _bill_details[j].id_lotproduct;//mới
                    products_voucher.push(product);
                    if(!bill_detail_voucher){
                      bill_detail_voucher = {..._bill_details[j]};
                        delete bill_detail_voucher.earning_points_product;
                        delete bill_detail_voucher.id_category;
                        delete bill_detail_voucher.id_product;
                        delete bill_detail_voucher.price;
                        delete bill_detail_voucher.price_origin;
                        delete bill_detail_voucher.ptype;
                        delete bill_detail_voucher.quantity;
                        delete bill_detail_voucher.ratio;
                        delete bill_detail_voucher.unit;
                        delete bill_detail_voucher.combos;
                        if(bill_detail_voucher.id_subproduct) delete bill_detail_voucher.id_subproduct;
                        if(bill_detail_voucher.id_lotproduct) delete bill_detail_voucher.id_lotproduct;//mới
                    }
                    _bill_details[j].chose = true;
                }           
              } 
          }
          
          if(bill_detail_voucher){            
            bill_detail_voucher.products = [...products_voucher];              
            products_vouchers.push(bill_detail_voucher);          
          }
        }
    }   
    for(let i=0; i<products_vouchers.length; i++){
      _bill_details.push(products_vouchers[i]);        
    }        
    _bill_details = _bill_details.filter((e:any)=>e.chose!=true);

    //Đổi bill_detail (payment_card) thành bill_detail mà front_end làm việc
    let products_payment_cards = new Array();
    for(let i=0; i<_bill_details.length; i++){     
      let products_payment_card = new Array();
      let bill_detail_payment_card = null; 
        if((_bill_details[i].pctype===1) && (!_bill_details[i].chose)){
          for(let j=i; j<_bill_details.length; j++){             
              if((_bill_details[j].pctype ===1) && (!_bill_details[j].chose)){              
                if(_bill_details[j].id_payment_card ===_bill_details[i].id_payment_card){                          
                    let product:any = {
                      earning_points_product: _bill_details[j]?.earning_points_product,
                      id_category: _bill_details[j]?.id_category,
                      id_product: _bill_details[j].id_product,
                      price: _bill_details[j].price,
                      price_origin:_bill_details[j].price_origin,
                      ptype: _bill_details[j].ptype,
                      quantity: _bill_details[j].quantity,
                      ratio: _bill_details[j].ratio,
                      outquantity: _bill_details[j].outquantity,
                      restquantity: _bill_details[j].restquantity
                      //unit: _bill_details[j].unit
                      //id_voucher: _bill_details[j].id_voucher,
                      //id_voucher_code: _bill_details[j].id_voucher_code
                    }        
                    if(_bill_details[j].combos) product.combos = _bill_details[j].combos;
                    if(_bill_details[j].id_subproduct) product.id_subproduct = _bill_details[j].id_subproduct;
                    if(_bill_details[j].id_lotproduct) product.id_lotproduct = _bill_details[j].id_lotproduct;//mới
                    products_payment_card.push(product);
                    if(!bill_detail_payment_card){
                      bill_detail_payment_card = {..._bill_details[j]};
                        delete bill_detail_payment_card.earning_points_product;
                        delete bill_detail_payment_card.id_category;
                        delete bill_detail_payment_card.id_product;
                        delete bill_detail_payment_card.price;
                        delete bill_detail_payment_card.price_origin;
                        delete bill_detail_payment_card.ptype;
                        delete bill_detail_payment_card.quantity;
                        delete bill_detail_payment_card.ratio;
                        delete bill_detail_payment_card.outquantity;
                        delete bill_detail_payment_card.restquantity;
                        delete bill_detail_payment_card.unit;
                        delete bill_detail_payment_card.combos;
                        if(bill_detail_payment_card.id_subproduct) delete bill_detail_payment_card.id_subproduct;
                        if(bill_detail_payment_card.id_lotproduct) delete bill_detail_payment_card.id_lotproduct;//mới
                    }
                    _bill_details[j].chose = true;
                }           
              } 
          }
          
          if(bill_detail_payment_card){            
            bill_detail_payment_card.products = [...products_payment_card];              
            products_payment_cards.push(bill_detail_payment_card);          
          }
        }
    }   
    for(let i=0; i<products_payment_cards.length; i++){
      _bill_details.push(products_payment_cards[i]);        
    }        
    _bill_details = _bill_details.filter((e:any)=>e.chose!=true);

    console.log('-----changeBillDetails_withRaw_toPromotions_after', _bill_details);
    return _bill_details;
  }

/**
 * @example:
 * this.vhQueryCafe.getBillDetails_withName({name:'promition 1'})
        .then((bill_details:any)=>{
          console.log('getBillDetails_withName', bill_details);
        },(error:any)=>{
          console.log('error', error);
        })
  * @param bill_details 
  * @return  Promise => array = [{},{},...]
  * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
  */
  private changeBillDetails_withPromotionNameUnitsLots(bill_details:any){
    console.log('-----changeBillDetails_withPromotionNameUnitsLots_before', bill_details);
    let _bill_details = cloneDeep(bill_details);   
    return new Promise((resolve, reject) => {
      let promise = new Array();
      for(let i=0; i<_bill_details.length; i++){
        if(_bill_details[i].id_promotion){    
          promise[promise.length] = new Promise((resolve, reject)=>{
            this.vhMGDB_database.getDoc('promotions', _bill_details[i].id_promotion)
                .then((promotion:any)=>{
                  if(promotion){
                    _bill_details[i].name = promotion.name;
                  }
                  resolve(null);
                },(error:any)=>{
                  reject(error);
                })
          })            
        }
      }
      Promise.all(promise)
          .then(()=>{                        
            for(let i=0; i<_bill_details.length; i++){
              if((_bill_details[i].pmtype)){
                if(_bill_details[i].products){
                  for(let j=0; j<_bill_details[i].products.length; j++){
                    if((_bill_details[i].products[j].ptype ===1)||(_bill_details[i].products[j].ptype ===2)||(_bill_details[i].products[j].ptype ===3)||(_bill_details[i].products[j].ptype ===4)){
                      let id_sub_or_product = _bill_details[i].products[j].id_subproduct?_bill_details[i].products[j].id_subproduct:_bill_details[i].products[j].id_product;
                      let product = this.getlocalDetailProduct(id_sub_or_product);
                      _bill_details[i].products[j].name = product.name;
                      _bill_details[i].products[j].units = product.units;                      
                      if(product.lots) _bill_details[i].products[j].lots = product.lots;  
                      //if(product.toppings) _bill_details[i].products[j].toppings = product.toppings;  
                      if(_bill_details[i].products[j].toppings){
                        for(let k=0; k<_bill_details[i].products[j].toppings.length; k++){
                          let topping = this.getlocalDetailProduct(_bill_details[i].products[j].toppings[k].id_product);
                          _bill_details[i].products[j].toppings[k].name = topping.name;
                          _bill_details[i].products[j].toppings[k].units = topping.units;
                        }
                      }
                    }else if(_bill_details[i].products[j].ptype ===5){
                      let product = this.getlocalDetailProduct(_bill_details[i].products[j].id_product);
                      _bill_details[i].products[j].name = product.name;
                      _bill_details[i].products[j].units = product.units;                      
                      for(let m=0; m<_bill_details[i].products[j].combos.length; m++){
                        let _id_sub_or_product = _bill_details[i].products[j].combos[m].id_subproduct?_bill_details[i].products[j].combos[m].id_subproduct:_bill_details[i].products[j].combos[m].id_product;
                        let _product = this.getlocalDetailProduct(_id_sub_or_product);
                        _bill_details[i].products[j].combos[m].name = _product.name;
                        _bill_details[i].products[j].combos[m].units = _product.units;                        
                        if(_product.lots) _bill_details[i].products[j].combos[m].lots = _product.lots;
                        //if(_product.toppings) _bill_details[i].products[j].combos[m].toppings = _product.toppings;
                        if(_bill_details[i].products[j].combos[m].toppings){
                          for(let k=0; k<_bill_details[i].products[j].combos[m].toppings.length; k++){
                            let topping = this.getlocalDetailProduct(_bill_details[i].products[j].combos[m].toppings[k].id_product);
                            _bill_details[i].products[j].combos[m].toppings[k].name = topping.name;
                            _bill_details[i].products[j].combos[m].toppings[k].units = topping.units;
                          }
                        }
                      }
                    }
                  }
                }
                if(_bill_details[i].products_gift){
                  for(let j=0; j<_bill_details[i].products_gift.length; j++){
                    if((_bill_details[i].products_gift[j].ptype ===1)||(_bill_details[i].products_gift[j].ptype ===2)||(_bill_details[i].products_gift[j].ptype ===3)||(_bill_details[i].products_gift[j].ptype ===4)){
                      let id_sub_or_product = _bill_details[i].products_gift[j].id_subproduct?_bill_details[i].products_gift[j].id_subproduct:_bill_details[i].products_gift[j].id_product;
                      let product = this.getlocalDetailProduct(id_sub_or_product);
                      _bill_details[i].products_gift[j].name = product.name;
                      _bill_details[i].products_gift[j].units = product.units;                      
                      if(product.lots) _bill_details[i].products_gift[j].lots = product.lots;
                      //if(product.toppings) _bill_details[i].products_gift[j].toppings = product.toppings;
                      if(_bill_details[i].products_gift[j].toppings){
                        for(let k=0; k<_bill_details[i].products_gift[j].toppings.length; k++){
                          let topping = this.getlocalDetailProduct(_bill_details[i].products_gift[j].toppings[k].id_product);
                          _bill_details[i].products_gift[j].toppings[k].name = topping.name;
                          _bill_details[i].products_gift[j].toppings[k].units = topping.units;
                        }
                      }
                    }else if(_bill_details[i].products_gift[j].ptype ===5){
                      let product = this.getlocalDetailProduct(_bill_details[i].products_gift[j].id_product);
                      _bill_details[i].products_gift[j].name = product.name;
                      _bill_details[i].products_gift[j].units = product.units;                     
                      for(let m=0; m<_bill_details[i].products_gift[j].combos.length; m++){
                        let _id_sub_or_product = _bill_details[i].products_gift[j].combos[m].id_subproduct?_bill_details[i].products_gift[j].combos[m].id_subproduct:_bill_details[i].products_gift[j].combos[m].id_product;
                        let _product = this.getlocalDetailProduct(_id_sub_or_product);
                        _bill_details[i].products_gift[j].combos[m].name = _product.name;
                        _bill_details[i].products_gift[j].combos[m].units = _product.units;
                        if(_product.lots) _bill_details[i].products_gift[j].combos[m].lots = _product.lots;
                        //if(_product.toppings) _bill_details[i].products_gift[j].combos[m].toppings = _product.toppings;
                        if(_bill_details[i].products_gift[j].combos[m].toppings){
                          for(let k=0; k<_bill_details[i].products_gift[j].combos[m].toppings.length; k++){
                            let topping = this.getlocalDetailProduct(_bill_details[i].products_gift[j].combos[m].toppings[k].id_product);
                            _bill_details[i].products_gift[j].combos[m].toppings[k].name = topping.name;
                            _bill_details[i].products_gift[j].combos[m].toppings[k].units = topping.units;
                          }
                        }
                      }
                    }
                  }
                }
              }else{              
                if((_bill_details[i].ptype ===1)||(_bill_details[i].ptype ===2)||(_bill_details[i].ptype ===3)||(_bill_details[i].ptype ===4)||(_bill_details[i].ptype ===6)){
                  let id_sub_or_product = _bill_details[i].id_subproduct?_bill_details[i].id_subproduct:_bill_details[i].id_product;                
                  let product = this.getlocalDetailProduct(id_sub_or_product);
                  _bill_details[i].name = product.name;
                  _bill_details[i].units = product.units;                  
                  if(product.lots) _bill_details[i].lots = product.lots;  
                  //if(product.toppings) _bill_details[i].toppings = product.toppings;  
                  if(_bill_details[i].toppings){
                    for(let k=0; k<_bill_details[i].toppings.length; k++){
                      let topping = this.getlocalDetailProduct(_bill_details[i].toppings[k].id_product);
                      _bill_details[i].toppings[k].name = topping.name;
                      _bill_details[i].toppings[k].units = topping.units;
                    }
                  }
                }else if(_bill_details[i].ptype ===5){
                  let product = this.getlocalDetailProduct(_bill_details[i].id_product);
                  _bill_details[i].name = product.name;
                  _bill_details[i].units = product.units;                 
                  for(let j=0; j<_bill_details[i].combos.length; j++){
                    if((_bill_details[i].combos[j].ptype ===1)||(_bill_details[i].combos[j].ptype ===2)||(_bill_details[i].combos[j].ptype ===3)||(_bill_details[i].combos[j].ptype ===4)){
                      let _id_sub_or_product = _bill_details[i].combos[j].id_subproduct?_bill_details[i].combos[j].id_subproduct:_bill_details[i].combos[j].id_product;
                      let _product = this.getlocalDetailProduct(_id_sub_or_product);
                      _bill_details[i].combos[j].name = _product.name;
                      _bill_details[i].combos[j].units = _product.units;                      
                      if(_product.lots) _bill_details[i].combos[j].lots = _product.lots;  
                      if(_product.toppings) _bill_details[i].combos[j].toppings = _product.toppings;  
                      if(_bill_details[i].combos[j].toppings){
                        for(let k=0; k<_bill_details[i].combos[j].toppings.length; k++){
                          let topping = this.getlocalDetailProduct(_bill_details[i].combos[j].toppings[k].id_product);
                          _bill_details[i].combos[j].toppings[k].name = topping.name;
                          _bill_details[i].combos[j].toppings[k].units = topping.units;
                        }
                      }
                    }
                  }
                }               
                
              }
            }
            console.log('-----changeBillDetails_withPromotionNameUnitsLots_after', _bill_details);
            resolve(_bill_details);

          }) 
          .catch((e)=>{
            reject(e);
          })    

    })
  }

  /**
   * vhQueryCafe
  * @example:
  * let _bill_details = this.vhQueryCafe.changeBillDetails_withNameUnitsLots(bill_details);      
  * @param bill_details 
  * @return  Promise => array = [{},{},...]
  * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
  */
  private changeBillDetails_withNameUnitsLots(bill_details:any){    
    console.log('-----changeBillDetails_withNameUnitsLots_before', bill_details);
    let _bill_details = cloneDeep(bill_details);
    for(let i=0; i<_bill_details.length; i++){
      if((_bill_details[i].pmtype)){
        if(_bill_details[i].products){
          for(let j=0; j<_bill_details[i].products.length; j++){
            if((_bill_details[i].products[j].ptype ===1)||(_bill_details[i].products[j].ptype ===2)||(_bill_details[i].products[j].ptype ===3)||(_bill_details[i].products[j].ptype ===4)){
              let id_sub_or_product = _bill_details[i].products[j].id_subproduct?_bill_details[i].products[j].id_subproduct:_bill_details[i].products[j].id_product;
              let product = this.getlocalDetailProduct(id_sub_or_product);
              _bill_details[i].products[j].name = product.name;
              _bill_details[i].products[j].units = product.units;
              if(product.lots) _bill_details[i].products[j].lots = product.lots;  
              //if(product.toppings) _bill_details[i].products[j].toppings = product.toppings;  
              if(_bill_details[i].products[j].toppings){
                for(let k=0; k<_bill_details[i].products[j].toppings.length; k++){
                  let topping = this.getlocalDetailProduct(_bill_details[i].products[j].toppings[k].id_product);
                  _bill_details[i].products[j].toppings[k].name = topping.name;
                  _bill_details[i].products[j].toppings[k].units = topping.units;
                }
              }

            }else if(_bill_details[i].products[j].ptype ===5){
              let product = this.getlocalDetailProduct(_bill_details[i].products[j].id_product);
              _bill_details[i].products[j].name = product.name;
              _bill_details[i].products[j].units = product.units;
              for(let m=0; m<_bill_details[i].products[j].combos.length; m++){
                let _id_sub_or_product = _bill_details[i].products[j].combos[m].id_subproduct?_bill_details[i].products[j].combos[m].id_subproduct:_bill_details[i].products[j].combos[m].id_product;
                let _product = this.getlocalDetailProduct(_id_sub_or_product);
                _bill_details[i].products[j].combos[m].name = _product.name;
                _bill_details[i].products[j].combos[m].units = _product.units;
                if(_product.lots) _bill_details[i].products[j].combos[m].lots = _product.lots;
                //if(_product.toppings) _bill_details[i].products[j].combos[m].toppings = _product.toppings;
                if(_bill_details[i].products[j].combos[m].toppings){
                  for(let k=0; k<_bill_details[i].products[j].combos[m].toppings.length; k++){
                    let topping = this.getlocalDetailProduct(_bill_details[i].products[j].combos[m].toppings[k].id_product);
                    _bill_details[i].products[j].combos[m].toppings[k].name = topping.name;
                    _bill_details[i].products[j].combos[m].toppings[k].units = topping.units;
                  }
                }
              }
            }
          }
        }
        if(_bill_details[i].products_gift){
          for(let j=0; j<_bill_details[i].products_gift.length; j++){
            if((_bill_details[i].products_gift[j].ptype ===1)||(_bill_details[i].products_gift[j].ptype ===2)||(_bill_details[i].products_gift[j].ptype ===3)||(_bill_details[i].products_gift[j].ptype ===4)){
              let id_sub_or_product = _bill_details[i].products_gift[j].id_subproduct?_bill_details[i].products_gift[j].id_subproduct:_bill_details[i].products_gift[j].id_product;
              let product = this.getlocalDetailProduct(id_sub_or_product);
              _bill_details[i].products_gift[j].name = product.name;
              _bill_details[i].products_gift[j].units = product.units;
              if(product.lots) _bill_details[i].products_gift[j].lots = product.lots;
              //if(product.toppings) _bill_details[i].products_gift[j].toppings = product.toppings;
              if(_bill_details[i].products_gift[j].toppings){
                for(let k=0; k<_bill_details[i].products_gift[j].toppings.length; k++){
                  let topping = this.getlocalDetailProduct(_bill_details[i].products_gift[j].toppings[k].id_product);
                  _bill_details[i].products_gift[j].toppings[k].name = topping.name;
                  _bill_details[i].products_gift[j].toppings[k].units = topping.units;
                }
              }

            }else if(_bill_details[i].products_gift[j].ptype ===5){
              let product = this.getlocalDetailProduct(_bill_details[i].products_gift[j].id_product)
              _bill_details[i].products_gift[j].name = product.name;
              _bill_details[i].products_gift[j].units = product.units;
              for(let m=0; m<_bill_details[i].products_gift[j].combos.length; m++){                
                let _id_sub_or_product = _bill_details[i].products_gift[j].combos[m].id_subproduct?_bill_details[i].products_gift[j].combos[m].id_subproduct:_bill_details[i].products_gift[j].combos[m].id_product;
                let _product = this.getlocalDetailProduct(_id_sub_or_product);               
                _bill_details[i].products_gift[j].combos[m].name = _product.name;
                _bill_details[i].products_gift[j].combos[m].units = _product.units;
                if(_product.lots) _bill_details[i].products_gift[j].combos[m].lots = _product.lots;
                //if(_product.toppings) _bill_details[i].products_gift[j].combos[m].toppings = _product.toppings;
                if(_bill_details[i].products_gift[j].combos[m].toppings){
                  for(let k=0; k<_bill_details[i].products_gift[j].combos[m].toppings.length; k++){
                    let topping = this.getlocalDetailProduct(_bill_details[i].products_gift[j].combos[m].toppings[k].id_product);
                    _bill_details[i].products_gift[j].combos[m].toppings[k].name = topping.name;
                    _bill_details[i].products_gift[j].combos[m].toppings[k].units = topping.units;
                  }
                }
              }
            }
          }
        }
      }else{              
        if((_bill_details[i].ptype ===1)||(_bill_details[i].ptype ===2)||(_bill_details[i].ptype ===3)||(_bill_details[i].ptype ===4)||(_bill_details[i].ptype ===6)){
          let id_sub_or_product = _bill_details[i].id_subproduct?_bill_details[i].id_subproduct:_bill_details[i].id_product;
          let product = this.getlocalDetailProduct(id_sub_or_product);
          _bill_details[i].name = product.name;
          _bill_details[i].units = product.units;
          if(product.lots) _bill_details[i].lots = product.lots;  
          //if(product.toppings) _bill_details[i].toppings = product.toppings;  
          if(_bill_details[i].toppings){
            for(let k=0; k<_bill_details[i].toppings.length; k++){
              let topping = this.getlocalDetailProduct(_bill_details[i].toppings[k].id_product);
              _bill_details[i].toppings[k].name = topping.name;
              _bill_details[i].toppings[k].units = topping.units;
            }
          }

        }else if(_bill_details[i].ptype ===5){
          let product =  this.getlocalDetailProduct(_bill_details[i].id_product);
          _bill_details[i].name = product.name;
          _bill_details[i].units = product.units;
          for(let j=0; j<_bill_details[i].combos.length; j++){
            if((_bill_details[i].combos[j].ptype ===1)||_bill_details[i].combos[j].ptype ===2){
              let _id_sub_or_product = _bill_details[i].combos[j].id_subproduct?_bill_details[i].combos[j].id_subproduct:_bill_details[i].combos[j].id_product;
              let _product = this.getlocalDetailProduct(_id_sub_or_product);
              _bill_details[i].combos[j].name = _product.name;
              _bill_details[i].combos[j].units = _product.units;
              if(_product.lots) _bill_details[i].combos[j].lots = _product.lots;  
              //if(_product.toppings) _bill_details[i].combos[j].toppings = _product.toppings;  
              if(_bill_details[i].combos[j].toppings){
                for(let k=0; k<_bill_details[i].combos[j].toppings.length; k++){
                  let topping = this.getlocalDetailProduct(_bill_details[i].combos[j].toppings[k].id_product);
                  _bill_details[i].combos[j].toppings[k].name = topping.name;
                  _bill_details[i].combos[j].toppings[k].units = topping.units;
                }
              }
            }
          }
        }               
        
      }

      if((_bill_details[i].vtype === 1)||(_bill_details[i].pctype === 1)){//voucher hoặc payment_card
        if(_bill_details[i].products){
          for(let j=0; j<_bill_details[i].products.length; j++){
            if((_bill_details[i].products[j].ptype ===1)||(_bill_details[i].products[j].ptype ===2)||(_bill_details[i].products[j].ptype ===3)||(_bill_details[i].products[j].ptype ===4)){
              let id_sub_or_product = _bill_details[i].products[j].id_subproduct?_bill_details[i].products[j].id_subproduct:_bill_details[i].products[j].id_product;
              let product = this.getlocalDetailProduct(id_sub_or_product);
              _bill_details[i].products[j].name = product.name;
              _bill_details[i].products[j].units = product.units;
              if(product.lots) _bill_details[i].products[j].lots = product.lots;  
              //if(product.toppings) _bill_details[i].products[j].toppings = product.toppings; 
              if(_bill_details[i].products[j].toppings){
                for(let k=0; k<_bill_details[i].products[j].toppings.length; k++){
                  let topping = this.getlocalDetailProduct(_bill_details[i].products[j].toppings[k].id_product);
                  _bill_details[i].products[j].toppings[k].name = topping.name;
                  _bill_details[i].products[j].toppings[k].units = topping.units;
                }
              }

            }else if(_bill_details[i].products[j].ptype ===5){
              let product = this.getlocalDetailProduct(_bill_details[i].products[j].id_product);
              _bill_details[i].products[j].name = product.name;
              _bill_details[i].products[j].units = product.units;
              for(let m=0; m<_bill_details[i].products[j].combos.length; m++){
                let _id_sub_or_product = _bill_details[i].products[j].combos[m].id_subproduct?_bill_details[i].products[j].combos[m].id_subproduct:_bill_details[i].products[j].combos[m].id_product;
                let _product = this.getlocalDetailProduct(_id_sub_or_product);
                _bill_details[i].products[j].combos[m].name = _product.name;
                _bill_details[i].products[j].combos[m].units = _product.units;
                if(_product.lots) _bill_details[i].products[j].combos[m].lots = _product.lots;
                //if(_product.toppings) _bill_details[i].products[j].combos[m].toppings = _product.toppings;
                if(_bill_details[i].products[j].combos[m].toppings){
                  for(let k=0; k<_bill_details[i].products[j].combos[m].toppings.length; k++){
                    let topping = this.getlocalDetailProduct(_bill_details[i].products[j].combos[m].toppings[k].id_product);
                    _bill_details[i].products[j].combos[m].toppings[k].name = topping.name;
                    _bill_details[i].products[j].combos[m].toppings[k].units = topping.units;
                  }
                }
              }
            }
          }
        }
      }
    }
    console.log('-----changeBillDetails_withNameUnitsLots_after', _bill_details);
    return cloneDeep(_bill_details);
  }    
  
  /**
 * Hàm này đổi mảng Bill_Details sang mảng Bill_Details có chương trình khuyến mãi (nếu có)
 * @example:
 * let date = new Date();
 * this.vhQueryCafe.changeBillDetails_withPromotions(bill_details, date)
        .then((bill_details_promotions)=>{
          console.log('bill_details_promotions', res);
          bill_details = [...bill_details_promotions];
        }, error=>{
          console.log('error', error);
        })
  * @param bill_details 
  * @param date : thơi gian tạo hóa đơn
  * @return  Oject => obj = {bill_details_pmtype_0to6: Array, bill_details_pmtype_7: Array}}; (bill_details_pmtype_0 là bill_details ko có khuyến mãi)
  */
  public changeBillDetails_withPromotions(bill_details:any, date:any){
    return new Promise((resolve, reject) => {
      console.log('-----changeBillDetails_withPromotions_before', cloneDeep(bill_details));
        date = new Date(date);
        this.getPromotions_byDate(date)
            .then((promotions:any)=>{                                    
              let promotions_SEVEN = promotions.filter((e:any)=>(e.type===7)&&(e.status));
              let promotions_SIX = promotions.filter((e:any)=>(e.type===6)&&(e.status));
              promotions = promotions.filter((e:any)=>(e.type<=5)&&(e.status));
              let arrayTotal = new Array();
              promotions = this.vhAlgorithm.sortNumberbyASC(promotions, 'type');
              for(let m=0; m<promotions.length; m++){              
                  promotions.push(promotions[0]);           
                  promotions.splice(0,1);            
                  let array = new Array();
                  let _bill_details = [...this.destroyBillDetails_withPromotions(bill_details)];
                  for(let i=0; i<promotions.length; i++){
                    if(promotions[i].type ===1){//giảm giá khi mua sản phẩm
                      let group = new Array();
                      if(promotions[i].promotion_all_products){//tất cả sản phẩm đều giảm giá
                        for(let k=0; k<_bill_details.length; k++){
                          let bill_detail = {..._bill_details[k]};
                          if(bill_detail.price === bill_detail.price_origin){                            
                            bill_detail.price = bill_detail.price - promotions[i].price_reduce;
                            group.push(bill_detail); 
                            _bill_details[k].delete = true;          
                          }
                        }                        
                        if(group.length){
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }
                          array.push(record);
                          //_bill_details = [];
                        }
                      }else{
                        for(let j=0; j<promotions[i].products.length; j++){                         
                          for(let k=0; k<_bill_details.length; k++){                                            
                              if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                                if(promotions[i].products[j].id_subproduct){
                                  if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){
                                    if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                      if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                        let bill_detail = {..._bill_details[k]};
                                        if(bill_detail.price === bill_detail.price_origin){     
                                          bill_detail.price =  bill_detail.price - promotions[i].products[j].price_reduce;
                                          group.push(bill_detail);
                                          _bill_details.splice(k,1);
                                          break;
                                          //_bill_details[k].delete = true;  
                                        }       
                                      }
                                      
                                    }                             
                                  }
                                }else{                                  
                                  if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                    if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                      let bill_detail = {..._bill_details[k]};
                                      if(bill_detail.price === bill_detail.price_origin){     
                                        bill_detail.price =  bill_detail.price - promotions[i].products[j].price_reduce;
                                        group.push(bill_detail);
                                        //_bill_details[k].delete = true;         
                                        _bill_details.splice(k,1);
                                        break;
                                      }
                                    }                                    
                                  }                                       
                                }
                              }
                            
                          }
                        }
                        if(group.length){
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }     
                          array.push(record);                          
                        }                                                      
                      }        
                    }else if(promotions[i].type ===2){//giảm % khi mua sản phẩm
                      let group = new Array();
                      if(promotions[i].promotion_all_products){//tất cả sản phẩm đều giảm giá
                        for(let k=0; k<_bill_details.length; k++){
                          let bill_detail = {..._bill_details[k]};
                          if(bill_detail.price === bill_detail.price_origin){                            
                            bill_detail.price = bill_detail.price - bill_detail.price * promotions[i].percent_reduce / 100;
                            group.push(bill_detail);       
                            _bill_details[k].delete = true; 
                          }    
                        }   
                        if(group.length){       
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }
                          array.push(record);
                          //_bill_details = [];
                        }
                      }else{
                        for(let j=0; j<promotions[i].products.length; j++){
                          for(let k=0; k<_bill_details.length; k++){
                            if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                              if(promotions[i].products[j].id_subproduct){
                                if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){
                                  if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                    if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                      let bill_detail = {..._bill_details[k]};
                                      if(bill_detail.price === bill_detail.price_origin){                            
                                        bill_detail.price =  bill_detail.price - bill_detail.price * promotions[i].products[j].percent_reduce / 100;
                                        group.push(bill_detail);
                                        _bill_details.splice(k,1);
                                        break;
                                      }
                                    }                                   
                                  }                              
                                }
                              }else{
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    let bill_detail = {..._bill_details[k]};
                                    if(bill_detail.price === bill_detail.price_origin){                            
                                      bill_detail.price =  bill_detail.price - bill_detail.price * promotions[i].products[j].percent_reduce / 100;
                                      group.push(bill_detail);
                                      _bill_details.splice(k,1);
                                      break;
                                    }
                                  }                                  
                                }                            
                              }
                            }
                          }
                        }        
                        if(group.length){        
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }
                          array.push(record);
                        }
                      }  
                    }else if(promotions[i].type ===3){//Sản phẩm đồng giá                      
                      let group = new Array();
                      if(promotions[i].promotion_all_products){//tất cả sản phẩm đều giảm giá
                        for(let k=0; k<_bill_details.length; k++){
                          let bill_detail = {..._bill_details[k]};
                          if(bill_detail.price === bill_detail.price_origin){                            
                            bill_detail.price = promotions[i].price_same;
                            group.push(bill_detail); 
                            _bill_details[k].delete = true; 
                          }          
                        }
                        if(group.length){       
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }
                          array.push(record);
                          //_bill_details = [];
                        }
                      }else{
                        for(let j=0; j<promotions[i].products.length; j++){
                          for(let k=0; k<_bill_details.length; k++){
                            if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                              if(promotions[i].products[j].id_subproduct){
                                if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                                  
                                  if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                    if(_bill_details[k].quantity >= promotions[i].products[j].quantity){                                            
                                      let bill_detail = {..._bill_details[k]};
                                      if(bill_detail.price === bill_detail.price_origin){      
                                        bill_detail.price =  promotions[i].products[j].price_same;
                                        group.push(bill_detail);
                                        _bill_details.splice(k,1);
                                        break;
                                      }
                                    }
                                    
                                  }                              
                                }
                              }else{                                
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){                                    
                                    let bill_detail = {..._bill_details[k]};
                                    if(bill_detail.price === bill_detail.price_origin){       
                                      bill_detail.price =  promotions[i].products[j].price_same;
                                      group.push(bill_detail);
                                      _bill_details.splice(k,1);
                                      break;
                                    }
                                  }
                                  
                                }                            
                              }
                            }
                          }
                        }
                        if(group.length){
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }
                          array.push(record);
                        }
                      }   
                    }else if(promotions[i].type ===4){//giảm giá khi mua nhiều sản phẩm
                      let group = new Array();
                      let factor = 1000000000;
                      for(let j=0; j<promotions[i].products.length; j++){//lấy hệ số thưởng
                        for(let k=0; k<_bill_details.length; k++){
                          if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                            if(promotions[i].products[j].id_subproduct){
                              if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    if(_bill_details[k].price === _bill_details[k].price_origin){       
                                      if(Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity) < factor) factor = Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity);             
                                      break;
                                    }
                                  }
                                }
                              }
                            }else{
                              if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                  if(_bill_details[k].price === _bill_details[k].price_origin){ 
                                    if(Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity) < factor) factor = Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity);             
                                    break;
                                  }
                                }
                              }
                            }                              
                          }
                        }
                      }
                      //console.log('factor', factor);
                      for(let j=0; j<promotions[i].products.length; j++){//chọn ra những sản phẩm nào được KM(4) đưa vô 1 nhóm
                        for(let k=0; k<_bill_details.length; k++){
                          if(_bill_details[k].id_product === promotions[i].products[j].id_product){ 
                            if(promotions[i].products[j].id_subproduct){
                              if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    let bill_detail = {..._bill_details[k]};
                                    if(bill_detail.price === bill_detail.price_origin){       
                                      let quantity =  factor * promotions[i].products[j].quantity;
                                      bill_detail.price = bill_detail.price - promotions[i].products[j].price_reduce;
                                      bill_detail.quantity = quantity;
                                      group.push(bill_detail);             
                                      break;
                                    }
                                  }
                                }
                              }
                            }else{
                              if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                  let bill_detail = {..._bill_details[k]};
                                  if(bill_detail.price === bill_detail.price_origin){       
                                    let quantity =  factor * promotions[i].products[j].quantity;
                                    bill_detail.price = bill_detail.price - promotions[i].products[j].price_reduce;
                                    bill_detail.quantity = quantity;
                                    group.push(bill_detail);             
                                    break;
                                  }
                                }
                              }
                            }                                                 
                          }
                        }
                      }
                      //console.log('group2', group);        
                      if(group.length === promotions[i].products.length){//kiểm tra lượng sản phẩm khách mua có thỏa mãn KM(4) ko
                        for(let j=0; j<promotions[i].products.length; j++){
                          for(let k=0; k<_bill_details.length; k++){
                            if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                              if(promotions[i].products[j].id_subproduct){
                                if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                  if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                    if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                      if(_bill_details[k].price === _bill_details[k].price_origin){       
                                        let quantity =  factor * promotions[i].products[j].quantity;               
                                        _bill_details[k].quantity = _bill_details[k].quantity - quantity;
                                        if(_bill_details[k].quantity===0) _bill_details.splice(k,1);
                                        break;
                                      }
                                    }
                                  }
                                }
                              }else{
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                      if(_bill_details[k].price === _bill_details[k].price_origin){       
                                      let quantity =  factor * promotions[i].products[j].quantity;               
                                      _bill_details[k].quantity = _bill_details[k].quantity - quantity;
                                      if(_bill_details[k].quantity===0) _bill_details.splice(k,1);
                                      break;
                                    }
                                  }
                                }
                              }                                                    
                            }
                          }
                        }

                        let record = {
                          id_promotion: promotions[i]._id,
                          name: promotions[i].name,
                          pmtype: promotions[i].type,
                          products: [...group]
                        }
                        array.push(record);
                      }    
                    
                    }else if(promotions[i].type ===5){//giảm % khi mua nhiều sản phẩm
                      let group = new Array();
                      let factor = 1000000000;                 
                      for(let j=0; j<promotions[i].products.length; j++){//lấy hệ số thưởng
                        for(let k=0; k<_bill_details.length; k++){
                          if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                            if(promotions[i].products[j].id_subproduct){
                              if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    if(_bill_details[k].price === _bill_details[k].price_origin){       
                                      if(Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity) < factor) factor = Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity);             
                                      break;
                                    }
                                  }
                                }
                              }
                            }else{
                              if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                  if(_bill_details[k].price === _bill_details[k].price_origin){       
                                    if(Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity) < factor) factor = Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity);             
                                    break;
                                  }
                                }
                              }
                            }                              
                          }
                        }
                      }

                      //console.log('factor', factor);                 
                      for(let j=0; j<promotions[i].products.length; j++){//chọn ra những sản phẩm nào được KM(5) đưa vô 1 nhóm
                        for(let k=0; k<_bill_details.length; k++){
                          if(_bill_details[k].id_product === promotions[i].products[j].id_product){ 
                            if(promotions[i].products[j].id_subproduct){
                              if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    let bill_detail = {..._bill_details[k]};
                                    if(bill_detail.price === bill_detail.price_origin){       
                                      let quantity =  factor * promotions[i].products[j].quantity;
                                      bill_detail.price = bill_detail.price - bill_detail.price * promotions[i].products[j].percent_reduce / 100;
                                      bill_detail.quantity = quantity;
                                      group.push(bill_detail);             
                                      break;
                                    }
                                  }
                                }
                              }
                            }else{
                              if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                  let bill_detail = {..._bill_details[k]};
                                  if(bill_detail.price === bill_detail.price_origin){       
                                    let quantity =  factor * promotions[i].products[j].quantity;
                                    bill_detail.price = bill_detail.price - bill_detail.price * promotions[i].products[j].percent_reduce / 100;
                                    bill_detail.quantity = quantity;
                                    group.push(bill_detail);             
                                    break;
                                  }
                                }
                              }
                            }                                                 
                          }
                        }
                      }


                      //console.log('group2', group);        
                      if(group.length === promotions[i].products.length){                    
                        for(let j=0; j<promotions[i].products.length; j++){
                          for(let k=0; k<_bill_details.length; k++){
                            if((_bill_details[k].id_product === promotions[i].products[j].id_product)&&(_bill_details[k].quantity >= promotions[i].products[j].quantity)){
                              if(promotions[i].products[j].id_subproduct){
                                if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                  if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                    if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                      if(_bill_details[k].price === _bill_details[k].price_origin){       
                                        let quantity =  factor * promotions[i].products[j].quantity;               
                                        _bill_details[k].quantity = _bill_details[k].quantity - quantity;
                                        if(_bill_details[k].quantity===0) _bill_details.splice(k,1);
                                        break;
                                      }
                                    }
                                  }
                                }
                              }else{
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    if(_bill_details[k].price === _bill_details[k].price_origin){       
                                      let quantity =  factor * promotions[i].products[j].quantity;               
                                      _bill_details[k].quantity = _bill_details[k].quantity - quantity;
                                      if(_bill_details[k].quantity===0) _bill_details.splice(k,1);
                                      break;
                                    }
                                  }
                                }
                              }                                                    
                            }
                          }
                        }

                        let record = {
                          id_promotion: promotions[i]._id,
                          name: promotions[i].name,
                          pmtype: promotions[i].type,
                          products: [...group]
                        }
                        array.push(record);
                      }    
                    }

                    _bill_details = _bill_details.filter((e:any)=>e.delete!=true);
                  }
                  for(let i=0; i<array.length; i++){
                    _bill_details.push(array[i]);
                  }
                  arrayTotal.push({bill_details: [..._bill_details], total: this.sumBill_Details(_bill_details)});                
              }

              //Tách riêng trường hợp khuyến mãi 6
              let bill_details_SIX = [...this.destroyBillDetails_withPromotions(bill_details)];
              let array_SIX = new Array();
              for(let i=0; i<promotions_SIX.length; i++){//tặng quà khi mua nhiều sản phẩm
                if(promotions_SIX[i].type ===6){
                  let group = new Array();
                  let factor = 1000000000;
                  for(let j=0; j<promotions_SIX[i].products.length; j++){//lấy hệ số thưởng
                    for(let k=0; k<bill_details_SIX.length; k++){
                      if(bill_details_SIX[k].id_product === promotions_SIX[i].products[j].id_product){
                        if(promotions_SIX[i].products[j].id_subproduct){
                          if(bill_details_SIX[k].id_subproduct === promotions_SIX[i].products[j].id_subproduct){                            
                            if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                              if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                                if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                  if(Math.floor(bill_details_SIX[k].quantity/promotions_SIX[i].products[j].quantity) < factor) factor = Math.floor(bill_details_SIX[k].quantity/promotions_SIX[i].products[j].quantity);             
                                  break;
                                }
                              }
                            }
                          }
                        }else{
                          if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                            if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                              if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                if(Math.floor(bill_details_SIX[k].quantity/promotions_SIX[i].products[j].quantity) < factor) factor = Math.floor(bill_details_SIX[k].quantity/promotions_SIX[i].products[j].quantity);             
                                break;
                              }
                            }
                          }
                        }                              
                      }
                    }
                  }                   
                  for(let j=0; j<promotions_SIX[i].products.length; j++){//chọn ra những sản phẩm nào được KM(6) đưa vô 1 nhóm
                    for(let k=0; k<bill_details_SIX.length; k++){
                      if(bill_details_SIX[k].id_product === promotions_SIX[i].products[j].id_product){ 
                        if(promotions_SIX[i].products[j].id_subproduct){
                          if(bill_details_SIX[k].id_subproduct === promotions_SIX[i].products[j].id_subproduct){                            
                            if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                              if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                                if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                  let bill_detail = {...bill_details_SIX[k]};
                                  let quantity =  factor * promotions_SIX[i].products[j].quantity;                               
                                  bill_detail.quantity = quantity;
                                  group.push(bill_detail);             
                                  break;
                                }
                              }
                            }
                          }
                        }else{
                          if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                            if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                              if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                let bill_detail = {...bill_details_SIX[k]};
                                let quantity =  factor * promotions_SIX[i].products[j].quantity;                              
                                bill_detail.quantity = quantity;
                                group.push(bill_detail);             
                              break;
                              }
                            }
                          }
                        }                                                 
                      }
                    }
                  }


                  //console.log('group6', group);        
                  if(group.length === promotions_SIX[i].products.length){//Nhóm lại những sản phẩm khách mua được tặng quà                   
                    for(let j=0; j<promotions_SIX[i].products.length; j++){
                      for(let k=0; k<bill_details_SIX.length; k++){
                        if(bill_details_SIX[k].id_product === promotions_SIX[i].products[j].id_product){
                          if(promotions_SIX[i].products[j].id_subproduct){
                            if(bill_details_SIX[k].id_subproduct === promotions_SIX[i].products[j].id_subproduct){                            
                              if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                                if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                                  if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                    let quantity =  factor * promotions_SIX[i].products[j].quantity;               
                                    bill_details_SIX[k].quantity = bill_details_SIX[k].quantity - quantity;
                                    if(bill_details_SIX[k].quantity===0) bill_details_SIX.splice(k,1);
                                    break;
                                  }
                                }
                              }
                            }
                          }else{
                            if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                              if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                                if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                  let quantity =  factor * promotions_SIX[i].products[j].quantity;               
                                  bill_details_SIX[k].quantity = bill_details_SIX[k].quantity - quantity;
                                  if(bill_details_SIX[k].quantity===0) bill_details_SIX.splice(k,1);
                                  break;
                                }
                              }
                            }
                          }                                                    
                        }
                      }
                    }

                    let products_gift = new Array();
                    for(let j=0; j<promotions_SIX[i].products_gift.length; j++){//Lấy ra những quà tặng khách có thể đc mua hoặc đc tặng
                      let product_gift:any = {};   
                      let id_sub_or_product = promotions_SIX[i].products_gift[j].id_subproduct?promotions_SIX[i].products_gift[j].id_subproduct:promotions_SIX[i].products_gift[j].id_product;                    
                      let product = this.getlocalDetailProduct(id_sub_or_product);
                      let unit = this.getUnit_byRatio(product.units, promotions_SIX[i].products_gift[j].ratio);
                      product_gift = {
                        ...promotions_SIX[i].products_gift[j],
                        earning_points_product:0,
                        id_category : product?.id_category,                         
                        ptype : product?.type,                  
                        name: product.name,
                        price_origin : unit.price, //tạm lấy giá lẻ, kiểm tra bộ chọn là giá sỉ hay giá lẻ đưa vào cho đúng
                        choose: false
                      }   
                      product_gift.quantity = product_gift.quantity * factor;    
                      if(product.id_subproduct) product_gift.id_subproduct = product.id_subproduct;
                      if(product.lots) product_gift.lots = product.lots;
                      products_gift.push(product_gift);
                    }
                    /*if(promotions_SIX[i].promotions_maximum <= products_gift.length){
                      for(let j=0; j<promotions_SIX[i].promotions_maximum; j++){
                        products_gift[j].choose = true;
                      }
                    }*/
                  
                    let record = {
                      id_promotion: promotions_SIX[i]._id,
                      name: promotions_SIX[i].name,
                      pmtype: promotions_SIX[i].type,
                      products: [...group],
                      promotions_maximum: promotions_SIX[i].promotions_maximum,
                      products_gift: [...products_gift]
                    }
                    array_SIX.push(record);
                    //console.log('array_SIX', array_SIX);      
                  } 
                }
              }

              //Tách riêng trường hợp khuyến mãi 7
              //let bill_details_SEVEN = [...this.destroyBillDetails_withPromotions(bill_details)];
              //console.log('bill_details_SEVEN', bill_details_SEVEN);
              let array_SEVEN = new Array();
              for(let i=0; i<promotions_SEVEN.length; i++){//tặng quà khi mua nhiều sản phẩm
                if(promotions_SEVEN[i].type ===7){
                    let products_gift = new Array();
                    for(let j=0; j<promotions_SEVEN[i].products_gift.length; j++){//Lấy ra những quà tặng khách có thể đc mua hoặc đc tặng                     
                      let product_gift:any = {};          
                      let id_sub_or_product = promotions_SEVEN[i].products_gift[j].id_subproduct?promotions_SEVEN[i].products_gift[j].id_subproduct:promotions_SEVEN[i].products_gift[j].id_product;            
                      let product = this.getlocalDetailProduct(id_sub_or_product);
                      let unit = this.getUnit_byRatio(product.units, promotions_SEVEN[i].products_gift[j].ratio);                     
                      product_gift = {
                        ...promotions_SEVEN[i].products_gift[j],
                        earning_points_product:0,
                        id_category : product?.id_category,                         
                        ptype : product?.type,  
                        name: product.name,
                        price_origin : unit.price, //tạm lấy giá lẻ, kiểm tra bộ chọn là giá sỉ hay giá lẻ đưa vào cho đúng
                        choose: false
                      }
                        
                      if(product.id_subproduct) product_gift.id_subproduct = product.id_subproduct;
                      if(product.lots) product_gift.lots = product.lots;
                      products_gift.push(product_gift);
                    }
                    if(promotions_SEVEN[i].promotions_maximum <= products_gift.length){
                      for(let j=0; j<promotions_SEVEN[i].promotions_maximum; j++){
                        products_gift[j].choose = false;
                      }
                    }                    
                  
                    let record = {
                      id_promotion: promotions_SEVEN[i]._id,
                      name: promotions_SEVEN[i].name,
                      pmtype: promotions_SEVEN[i].type,
                      promotions_maximum: promotions_SEVEN[i].promotions_maximum,
                      total_bill_value: promotions_SEVEN[i].total_bill_value,
                      products_gift: [...products_gift]
                    }
                    array_SEVEN.push(record);
                    //console.log('array_SEVEN', array_SEVEN);
                } 
              }
              

              
              let bill_details_OUT = new Array();
              if(arrayTotal.length){
                arrayTotal = this.vhAlgorithm.sortNumberbyASC(arrayTotal, 'total');
                //console.log('arrayTotal', arrayTotal);                
                bill_details_OUT = cloneDeep(arrayTotal[0].bill_details);//lấy phần tử 0, vì có total hóa đơn nhỏ nhất                
              }else{               
                bill_details_OUT = [...this.destroyBillDetails_withPromotions(`bill_details`)];               
              }
              
              if(array_SIX.length){
                for(let i=0; i<array_SIX.length; i++){
                  bill_details_OUT.push(array_SIX[i]);
                }
              }             
              
              bill_details_OUT = this.changeBillDetails_withNameUnitsLots(bill_details_OUT);
              array_SEVEN = this.changeBillDetails_withNameUnitsLots(array_SEVEN);
              console.log('-----changeBillDetails_withPromotions_after', {bill_details_pmtype_0to6: bill_details_OUT, bill_details_pmtype_7:  array_SEVEN});           
              resolve({bill_details_pmtype_0to6: bill_details_OUT, bill_details_pmtype_7:  array_SEVEN});
            
          }, error=>{
            console.log('error', error);
            reject(error);
          })
    })
  }

    /**
  * Hàm này đổi mảng Bill_Details có chương trình khuyến mãi (nếu có) sang mảng Bill_Details thường
  * @example:
  * bill_details = this.vhQueryCafe.destroyBillDetails_withPromotions(bill_details_promotions)      
  * @param bill_details 
  * @return  Array => array = [{},{},..]
  */
  public destroyBillDetails_withPromotions(bill_details:any){
    bill_details = cloneDeep(bill_details);
    let array = new Array();
    //destroy các bill_details có khuyến mãi 1->6
    for(let i=0; i<bill_details.length; i++){
      if((bill_details[i].pmtype ===1)||(bill_details[i].pmtype ===2)||(bill_details[i].pmtype ===3)||(bill_details[i].pmtype ===4)||(bill_details[i].pmtype ===5)){
        for(let j=0; j<bill_details[i].products.length; j++){
          let bill_detail:any = {...bill_details[i].products[j]};
          bill_detail.price = bill_detail.price_origin;
          array.push(bill_detail);
        }      
      }else if((bill_details[i].pmtype ===6)||(bill_details[i].pmtype ===7)){
        //ko cần lấy bill_detail này
      }else{
        array.push({...bill_details[i]});
      }
    }
    //gom các bill_details giống nhau lại
    for(let i=0; i<array.length; i++){           
      if(!array[i].check){
        for(let j=i+1; j<array.length; j++){
          if(!array[j].check) 
            if(array[i].id_product === array[j].id_product){
              if(array[i].id_subproduct){
                if(array[i].id_subproduct === array[j].id_subproduct){  
                  if(array[i].id_lotproduct){
                    if(array[i].id_lotproduct === array[j].id_lotproduct){
                      if(array[i].ratio === array[j].ratio){
                        //if((array[i].price === array[i].price_origin)&&(array[j].price === array[j].price_origin)){
                        if(array[i].price === array[j].price){
                          array[i].quantity = array[i].quantity + array[j].quantity;
                          array[j].check = true;
                        }
                      }
                    }
                  }else{
                    if(array[i].ratio === array[j].ratio){
                      if(array[i].price === array[j].price){
                        array[i].quantity = array[i].quantity + array[j].quantity;
                        array[j].check = true;
                      }
                    }
                  }
                }
              }else{
                if(array[i].id_lotproduct){
                  if(array[i].id_lotproduct === array[j].id_lotproduct){
                    if(array[i].ratio === array[j].ratio){
                      if(array[i].price === array[j].price){
                        array[i].quantity = array[i].quantity + array[j].quantity;
                        array[j].check = true;
                      }
                    }
                  }
                }else{
                  if(array[i].ratio === array[j].ratio){
                    if(array[i].price === array[j].price){
                      array[i].quantity = array[i].quantity + array[j].quantity;
                      array[j].check = true;
                    }
                  }
                }                
              }             
            }
        }
      }
          
    }
    array = array.filter((e:any)=>e.check!=true);
    //console.log('destroyBillDetails_withPromotions', array);
    return cloneDeep(array);
  }

  private sumBill_Details(bill_details:any){    
    let total = 0;
    for(let i=0; i<bill_details.length; i++){
      if((bill_details[i].pmtype ===1)||(bill_details[i].pmtype ===2)||(bill_details[i].pmtype ===3)||(bill_details[i].pmtype ===4)||(bill_details[i].pmtype ===5)||(bill_details[i].pmtype ===6)){
        for(let j=0; j<bill_details[i].products.length; j++){
          total+= bill_details[i].products[j].price * bill_details[i].products[j].quantity * bill_details[i].products[j].ratio;
        }      
      }else{
        total+= bill_details[i].price * bill_details[i].quantity;
      }
    }
    return total;
  }

     /** 
 * hàm này trả về danh sách chương trình khuyến mãi diễn ra tại thời điểm tạo hóa đơn => mỗi lần chỉnh lại thời gian tạo hóa đơn phải gọi hàm này
 * @example:  
 * let date = new Date();
 * this.vhQueryCafe.getPromotions_byDate(date)
        .then((res)=>{
          console.log('getPromotions_byDate', res);
        }, error=>{
          console.log('error', error);
        })
  * @param date : thơi gian tạo hóa đơn
  * @return Promise => array(object) = [{},{},..]
  */
  private getPromotions_byDate(date: any){
    return new Promise((resolve, reject) => {
      date = new Date(date);
      let promise = new Array();
      let query = {id_branch:{$eq: this.getDefaultBranch()._id}, date_end:{$gte:date}};  
      this.vhMGDB_database.getDocsByFields('promotions', query)
              .then((promotions:any)=>{               
                promotions = promotions.filter((e:any)=>(new Date(e.date_start)).getTime()<=date.getTime());           
                this.promotions = [...promotions];
                resolve(promotions);
              })
              .catch((e)=>{
                reject(e);
              })
              
    })
  }

  /**
   * Hàm này tạo bill_code theo số thứ tự (trong ngày) của từng loại bill_type
   * @example:
   * this.vhQueryCafe.createBillCode(new Date(), 7)
        .then((bill_code)=>{
          console.log('createBillCode', bill_code);
        })
   *  @param billdate 
   *  @param bill_type 
   */
  public createBillCode(billdate:any, bill_type:number){//các bill_type trong hàm đang dùng của sales nhớ đổi lại của cafe
    return new Promise((resolve, reject) => { 
      // let startdate = new Date(billdate);
      // let enddate = new Date(billdate);     
      // startdate.setHours(0);
      // startdate.setMinutes(0);
      // startdate.setSeconds(0);   
      // enddate.setHours(23);
      // enddate.setMinutes(59);
      // enddate.setSeconds(59);   
      let date = new Date(billdate);         
      let ddmmyy = 
            (date.getDate().toString().length == 1
                ? "0" + date.getDate().toString()
                : date.getDate().toString())
            +
            ((date.getMonth() + 1).toString().length == 1
                ? "0" + (date.getMonth() + 1).toString()
                : (date.getMonth() + 1).toString()) 
            +
            date.getFullYear().toString().slice(2);   
      let code_bill_type = "XX";
      if(bill_type === 1) code_bill_type = 'A';
      else if(bill_type === 2) code_bill_type = 'B';
      else if(bill_type === 3) code_bill_type = 'C'; //import from customer
      else if(bill_type === 5) code_bill_type = 'D';
      else if(bill_type === 6) code_bill_type = 'E';
      else if((bill_type === 7)||(bill_type === 11)) code_bill_type = 'F';
      else if((bill_type === 8)||(bill_type === 12)) code_bill_type = 'G';            
      else if(bill_type === 9) code_bill_type = 'H';
      else if(bill_type === 10) code_bill_type = 'I'; //export to supplier            
      else if(bill_type === 13) code_bill_type = 'J';// note temporaty
      else if(bill_type === 14) code_bill_type = 'K'; //note finish
      else if(bill_type === 15) code_bill_type = 'L';
      else if(bill_type === 16) code_bill_type = 'M';
      else if((bill_type === 18)||(bill_type === 19)||(bill_type === 20)||(bill_type === 21)) code_bill_type = 'N';
      else if(bill_type === 29) code_bill_type = 'O'; //29,30,31 cùng bill_code           
      else if(bill_type === 32) code_bill_type = 'P'; //32,33,34 cùng bill_code
      else if(bill_type === 36) code_bill_type = 'Q'; //Đặt mua hàng
      else if(bill_type === 38) code_bill_type = 'R'; //balance export
      else if(bill_type === 39) code_bill_type = 'S'; //balance import
      else if(bill_type === 40) code_bill_type = 'T';
      else if(bill_type === 41) code_bill_type = 'U';
      else if(bill_type === 42) code_bill_type = 'TV'; // Đặt mua voucher
      else if(bill_type === 43) code_bill_type = 'UV'; // Đặt đổi voucher lấy sản phẩm
      else if(bill_type === 50) code_bill_type = 'V';
      else if(bill_type === 51) code_bill_type = 'W';
      else if(bill_type === 52) code_bill_type = 'VC'; // Đặt mua payment_card
      else if(bill_type === 53) code_bill_type = 'WC'; // Đặt đổi payment_card lấy sản phẩm
      let query:any= {};   
      if((bill_type === 7)||(bill_type === 11)){
        query = {id_branch:{$eq: this.getDefaultBranch()._id}, bill_type:{$in: [7,11]}, bill_code:{$gte:ddmmyy + code_bill_type + '000', $lte:ddmmyy + code_bill_type + '9999'}};      
      }else if((bill_type === 8)||(bill_type === 12)){
        query = {id_branch:{$eq: this.getDefaultBranch()._id}, bill_type:{$in: [8,12]}, bill_code:{$gte:ddmmyy + code_bill_type + '000', $lte:ddmmyy + code_bill_type + '9999'}}; 
      }else if((bill_type === 18)||(bill_type === 19)||(bill_type === 20)||(bill_type === 21)){
        query = {id_branch:{$eq: this.getDefaultBranch()._id}, bill_type:{$in: [18,19,20,21]}, bill_code:{$gte:ddmmyy + code_bill_type + '000', $lte:ddmmyy + code_bill_type + '9999'}}; 
      }else{     
        query = {id_branch:{$eq: this.getDefaultBranch()._id}, bill_type:{$eq: bill_type}, bill_code:{$gte:ddmmyy + code_bill_type + '000', $lte:ddmmyy + code_bill_type + '9999'}};      
      }
      this.getBills_byFields(query, {}, {bill_code:-1}, 1)
          .then((bills:any)=>{          
                
            let ordinal:any = '001'; 
            if(bills.length){
              //console.log('bills[0]', bills[0]);
              let bill_code = bills[0].bill_code;
              ordinal = Number(bill_code.slice(7)) + 1;
              if(isNaN(ordinal)) ordinal = '001';
              else if(ordinal<10) ordinal = '00' + ordinal;
              else if(ordinal<100) ordinal = '0' + ordinal;              
            }else{          
              ordinal = '001';       
            }
                            
            let soHD = ddmmyy + code_bill_type + ordinal;
            //console.log('soHD.toUpperCase()', soHD.toUpperCase());     
            resolve(soHD.toUpperCase());  
          },(error:any)=>{
            reject(error);
          })
          .catch((e)=>{
            reject(e);
          })  
    })
  }

  
/**
 * Hàm này cập nhật lại giá nhập, dùng trong trường hợp createbill_billdetail và updatebill_billdetail với bill_type2
 * @example
    this.vhQueryCafe.calculateUpdateImportPrice(bill_details,'SzyEYNN39Mq90NkzUFpz')
        .then(()=>{
          console.log("success");
        })
  */
  private calculateUpdateImportPrice(bill_details:any, id_branch:any){
    return new Promise((resolve, reject) => {       
      bill_details = cloneDeep(bill_details);      
      let promise_products = new Array();
      for(let i=0; i<bill_details.length; i++){  
        if(bill_details[i].ptype ===3){ 
          if(!bill_details[i].duplicated){    
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product;            
            for(let j=i+1; j<bill_details.length-1; j++){           
              if(!bill_details[j].duplicated){                               
                if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){  
                  if(bill_details[i].ratio === bill_details[j].ratio){                                            
                    bill_details[i].duplicated = true;                       
                  }
                }                                        
              }                                                      
            }   
          }
        }
      }
      bill_details = bill_details.filter((e:any)=>(e.duplicated!=true)&&(e.ptype === 3));
      //console.log('bill_details', bill_details);
      for(let i=0; i<bill_details.length; i++){         
        if(!bill_details[i].calculated){    
          let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product;     
          let product = this.getlocalDetailProduct(id_sub_or_product);         
          for(let j=0; j<bill_details.length; j++){           
            if(!bill_details[j].calculated){                               
              if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){  
                if(bill_details[j].price_origin){
                  if(bill_details[j].price_origin != bill_details[j].price){
                    for(let k=0; k<product.units.length; k++){  
                      if(product.units[k].ratio === bill_details[j].ratio){
                        if(product.units[k].price_import != bill_details[j].price){//điệu kiện này, nếu price_import đã cập nhật ở hàm createbill_billdetail thì ham updatebill_billdetail sẽ ko cập nhật lại
                          product.units[k].price_import = bill_details[j].price;
                          product.willupdate = true;
                        }
                      }
                    }
                  }
                }
                bill_details[j].calculated = true;    
              }                                        
            }                                                      
          }   
          if(product.willupdate){
            //console.log('product', product)
            promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{units: product.units});      
          }
        }        
      }

      this.vhQuery.asyncPromiseAll(promise_products)
          .then(()=>{  
            resolve(null)
          })  
    })
  }

  /**
    * @example
      this.vhQueryCafe.calculateQuantityProduct_UP(bill_details,'SzyEYNN39Mq90NkzUFpz')
          .then(()=>{
            console.log("success");
          })
    */
  private calculateQuantityProduct_UP(bill_details:any, id_branch:any){
    return new Promise((resolve, reject) => {          
      bill_details = cloneDeep(bill_details); 
      let promise_products = new Array();
      for(let i=0; i<bill_details.length; i++){  
        //console.log(i, bill_details[i]);
        //tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
        if(bill_details[i].ptype ===3){ 
          if(!bill_details[i].calculated){                                                              
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product
            let product = this.getlocalDetailProduct(id_sub_or_product);  
            let quantity_all_bill_details = 0;       
            let lots = new Array();
            if(bill_details[i].id_lotproduct) lots = product.lots;            
            for(let j=0; j<bill_details.length; j++){     
              if(!bill_details[j].calculated){                               
                if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){                                              
                  quantity_all_bill_details = quantity_all_bill_details + bill_details[j].quantity * bill_details[j].ratio;
                  bill_details[j].calculated = true;
                  for(let m=0; m<lots.length; m++){
                    if(lots[m]._id === bill_details[j].id_lotproduct){
                      lots[m].quantity = lots[m].quantity + bill_details[j].quantity * bill_details[j].ratio;
                      lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] + bill_details[j].quantity * bill_details[j].ratio;
                    }
                  }
                }                                        
              }                                          
            }                                                                                         
            let quantity_branch = {...product.quantity_branch};     
            quantity_branch[id_branch] = quantity_branch[id_branch] + quantity_all_bill_details;                                 
            let quantity = product.quantity + quantity_all_bill_details;                                  
            if(lots.length >0){             
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, lots: lots});       
            }else{                 
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch});                                                                                                                      
            }                                                                                
          }                                                                                             
        }else{
          promise_products[promise_products.length] = new Promise<any>((resolve)=>{resolve(null);});
        }                              
      }  
      this.vhQuery.asyncPromiseAll(promise_products)
          .then(()=>{  
            resolve(null)
          })  
    })
  }

  /**
    * @example
      this.vhQueryCafe.calculateQuantityProduct_UP_9(bill_details,'SzyEYNN39Mq90NkzUFpz')
          .then(()=>{
            console.log("success");
          })
    */
  private calculateQuantityProduct_UP_9(bill_details:any, id_branch:any){
    return new Promise((resolve, reject) => {          
      bill_details = cloneDeep(bill_details);  
      let promise_products = new Array();
      for(let i=0; i<bill_details.length; i++){  
        //console.log(i, bill_details[i]);
        //tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
        if(bill_details[i].ptype ===3){ 
          if(!bill_details[i].calculated){                                                              
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product
            let product = this.getlocalDetailProduct(id_sub_or_product);  
            let quantity_all_bill_details = 0;       
            let lots = new Array();
            if(bill_details[i].id_lotproduct) lots = product.lots;            
            for(let j=0; j<bill_details.length; j++){     
              if(!bill_details[j].calculated){                               
                if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){                                              
                  quantity_all_bill_details = quantity_all_bill_details + bill_details[j].quantity * bill_details[j].ratio;
                  bill_details[j].calculated = true;
                  for(let m=0; m<lots.length; m++){
                    if(lots[m]._id === bill_details[j].id_lotproduct){
                      lots[m].quantity = lots[m].quantity + bill_details[j].quantity * bill_details[j].ratio;
                      lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] + bill_details[j].quantity * bill_details[j].ratio;
                    }
                  }
                }                                        
              }                                          
            }                                                                                         
            let quantity_branch = {...product.quantity_branch};     
            quantity_branch[id_branch] = quantity_branch[id_branch] + quantity_all_bill_details;                                 
            let quantity = product.quantity + quantity_all_bill_details;  
            //nếu có thay đổi tồn đầu kỳ thì xóa inventory, sau đó khi phần mềm restart lại sẽ tính mới lại giá trị này   
            let value:any = {};
      value[id_branch + '_ivtr'] = null;			 
            if(lots.length >0){             
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, lots: lots, ...value});       
            }else{                 
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, ...value});                                                                                                                      
            }                                                                                
          }                                                                                             
        }else{
          promise_products[promise_products.length] = new Promise<any>((resolve)=>{resolve(null);});
        }                              
      }  
      this.vhQuery.asyncPromiseAll(promise_products)
          .then(()=>{  
            resolve(null)
          })  
    })
  }

  /**
    * @example
      this.vhQueryCafe.calculateQuantityProduct_DOWN(bill_details,'SzyEYNN39Mq90NkzUFpz')
          .then(()=>{
            console.log("success");
          })
    */
  private calculateQuantityProduct_DOWN(bill_details:any, id_branch:any){
    return new Promise((resolve, reject) => {             
      bill_details = cloneDeep(bill_details);  
      let promise_products = new Array();
      for(let i=0; i<bill_details.length; i++){  
        //console.log(i, bill_details[i]);
        //giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
        if(bill_details[i].ptype ===3){ 
          if(!bill_details[i].calculated){                                                              
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product
            let product = this.getlocalDetailProduct(id_sub_or_product);  
            let quantity_all_bill_details = 0;       
            let lots = new Array();
            if(bill_details[i].id_lotproduct) lots = product.lots;            
            for(let j=0; j<bill_details.length; j++){     
              if(!bill_details[j].calculated){                               
                if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){                                              
                  quantity_all_bill_details = quantity_all_bill_details + bill_details[j].quantity * bill_details[j].ratio;
                  bill_details[j].calculated = true;
                  for(let m=0; m<lots.length; m++){
                    if(lots[m]._id === bill_details[j].id_lotproduct){
                      lots[m].quantity = lots[m].quantity - bill_details[j].quantity * bill_details[j].ratio;
                      lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] - bill_details[j].quantity * bill_details[j].ratio;
                    }
                  }
                }                                        
              }                                          
            }                                                                                         
            let quantity_branch = {...product.quantity_branch};     
            quantity_branch[id_branch] = quantity_branch[id_branch] - quantity_all_bill_details;                                 
            let quantity = product.quantity - quantity_all_bill_details;                                  
            if(lots.length >0){             
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, lots: lots});       
            }else{                 
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch});                                                                                                                      
            }                                                                                
          }                                                                                             
        }else{
          promise_products[promise_products.length] = new Promise<any>((resolve)=>{resolve(null);});
        }                              
      }  
      this.vhQuery.asyncPromiseAll(promise_products)
          .then(()=>{  
            resolve(null)
          })  
    })
  }

    /**
    * @example
      this.vhQueryCafe.calculateQuantityProduct_DOWN(bill_details,'SzyEYNN39Mq90NkzUFpz')
          .then(()=>{
            console.log("success");
          })
    */
  private calculateQuantityProduct_DOWN_9(bill_details:any, id_branch:any){
    return new Promise((resolve, reject) => {          
      bill_details = cloneDeep(bill_details); 
      let promise_products = new Array();
      for(let i=0; i<bill_details.length; i++){  
        //console.log(i, bill_details[i]);
        //giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
        if(bill_details[i].ptype ===3){ 
          if(!bill_details[i].calculated){                                                              
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product
            let product = this.getlocalDetailProduct(id_sub_or_product);  
            let quantity_all_bill_details = 0;       
            let lots = new Array();
            if(bill_details[i].id_lotproduct) lots = product.lots;            
            for(let j=0; j<bill_details.length; j++){     
              if(!bill_details[j].calculated){                               
                if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){                                              
                  quantity_all_bill_details = quantity_all_bill_details + bill_details[j].quantity * bill_details[j].ratio;
                  bill_details[j].calculated = true;
                  for(let m=0; m<lots.length; m++){
                    if(lots[m]._id === bill_details[j].id_lotproduct){
                      lots[m].quantity = lots[m].quantity - bill_details[j].quantity * bill_details[j].ratio;
                      lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] - bill_details[j].quantity * bill_details[j].ratio;
                    }
                  }
                }                                        
              }                                          
            }                                                                                         
            let quantity_branch = {...product.quantity_branch};     
            quantity_branch[id_branch] = quantity_branch[id_branch] - quantity_all_bill_details;                                 
            let quantity = product.quantity - quantity_all_bill_details;   
            
            //nếu có thay đổi tồn đầu kỳ thì xóa inventory, sau đó khi phần mềm restart lại sẽ tính mới lại giá trị này   
            let value:any = {};
            value[id_branch + '_ivtr'] = null;
            if(lots.length >0){             
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, lots: lots,...value});       
            }else{                 
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, ...value});                                                                                                                      
            }                                                                                
          }                                                                                             
        }else{
          promise_products[promise_products.length] = new Promise<any>((resolve)=>{resolve(null);});
        }                              
      }  
      this.vhQuery.asyncPromiseAll(promise_products)
          .then(()=>{  
            resolve(null)
          })  
    })
  }

   
   /** 
 * hàm này trả về danh sách chương trình khuyến mãi diễn ra từ thời gian fromTime đến thời gian toTime
 * @example:  
 * let fromTime = new Date();
 * let toTime = new Date('2020-07-01T05:24:00');
 * this.vhQueryCafe.getPromotions_fromTime_toTime(fromTime, toTime, 'all')
        .then((res)=>{
          console.log('getPromotions_fromTime_toTime', res);
        }, error=>{
          console.log('error', error);
        })
  * @param fromTime
  * @param toTime
  * @param type: 'all' or 1->8
  * @return Promise => array(object) = [{},{},..]
  */
  public getPromotions_fromTime_toTime(fromTime: any, toTime: any, type:any){
    return new Promise((resolve, reject) => {
      let promise = new Array();
      let query1, query2, query3;
      if(type === 'all'){
        query1 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_start:{$gte:fromTime, $lte:toTime}};
        query2 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_end:{$gte:fromTime, $lte:toTime}};
        query3 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_end:{$gte:toTime}};
      }else{
        query1 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_start:{$gte:fromTime, $lte:toTime}, type:{$eq: type}};
        query2 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_end:{$gte:fromTime, $lte:toTime}, type:{$eq: type}};
        query3 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_end:{$gte:toTime}, type:{$eq: type}};
      }
      
      promise[0] = this.vhMGDB_database.getDocsByFields('promotions', query1);
      promise[1] = this.vhMGDB_database.getDocsByFields('promotions', query2);
      promise[2] = this.vhMGDB_database.getDocsByFields('promotions', query3);
      Promise.all(promise)
              .then((array:any)=>{                   
                for(let i=0; i<array[0].length; i++){
                  for(let j=0; j<array[1].length; j++){
                    if(array[0][i]._id === array[1][j]._id){
                      array[1].splice(j, 1); 
                      break;
                    }
                  }
                }              
                array[2] = array[2].filter((e:any)=>(new Date(e.date_start)).getTime()<=fromTime.getTime());               
                for(let i=0; i<array[0].length; i++){
                  for(let j=0; j<array[2].length; j++){
                    if(array[0][i]._id === array[2][j]._id){
                      array[2].splice(j, 1); 
                      break;
                    }
                  }
                }
                array = array.flat();   
                //console.log('array', array);
                resolve(array);
              })
              .catch((e)=>{
                reject(e);
              })
              
    })
  }
      

}
 
 @Injectable()
 export class VhQueryCare{
   constructor(
   ) {}
 
   public startLocalStorage(){
     return new Promise<any>((resolve) => {
       resolve(null);          
     })
   }
   //public getOldMessages(limit:number){
   //  return this.vhMGDB_database.getDocsByFields('vhmessages',{},{},{date:1},limit);
   //}   
 
   /**
    * Hàm này trả về nội dung chat giữa nhân viên AppCare và Chater trên các App,
    * sau khi hàm connectChatStore hoàn thành việc tạo kết nối giữa AppCare và Chater
    * lưu ý: phải chạy hàm connectChatStore trước
    * Lưu ý: hàm này trả về tối đa 100 message trước đó
    * @example:
    this.VhQueryCare.callbackMessagesFromChatStores()
                       .subscribe((data)=> {                         
                         data.docs.forEach(doc => {
                           console.log(doc);                          
                         });
                       },(error:any) => {
                         console.log(error);
                       })
    * @return callback
    */
     public callbackMessagesFromChatStores() {
       return Observable.create((observer:any) => {
         observer.next();
       })        
     }                    
                      
     public removeAllCallback(){                        
       //this.socket.disconnect();
       //this.socket.removeAllListeners(); 
     } 
                     
     public connect(){   
       //this.socket.connect();    
     } 
                     
     /**
      * Hàm này trả về (Realtime) danh sách những store đã đưa ra cầu hỏi và đang chờ AppCare trở lời
      * @example:
      this.VhQueryCare.callbackChatStoreList()
           .subscribe((array)=> {   
             console.log('array', array);                              
             array.forEach(json => {
               json.docs.forEach(doc => {
                 console.log('doc', doc);   
                 console.log(doc.data());   
               })                                   
             })        
           })
       * @param callback 
       * @return callback Array JSONs => array = [json{}, json{},...]; json = {database, size, empty, docs[]}; json.docs = [{id, data()},{},...]
       */
     public callbackChatStoreList(){                        
       return Observable.create((observer:any) => {
         this.callbackChatStore(()=>{
           this.getchatStoreList().then((json:any)=>{                                           
             observer.next(json);
           })
         })      
       });
     }                      
                      
                     
     private callbackChatStore(callback:any){    
       callback();  
     } 
                     
     private getchatStoreList():any{    
       return new Promise((resolve, reject) => {     
         resolve({});
       })
     } 
                     
     /**
      * Nhân viên AppCare dùng hàm này chọn Store cần chat, thì Store này sẽ đc đưa vào getMyChatStore, và nhân viên khác ko chọn đc nữa
      * @example:
       this.VhQueryCare.selectChatStore("2rVieBQTubQ2hjUnpwU4w7qSlD83")
           .then((result)=>{
             console.log(result);
           })
       *  @param id_store 
       * @return Promise Boolean => true or false
       */
     public selectChatStore(id_store:any){//(database: any, sid: any, value:any){    
       return new Promise((resolve, reject) => {   
         resolve(true);           
       })
     }   
   
     /**
      * Nhân viên Appcare dùng hàm này thì Store này sẽ đc đưa ra khỏi getMyChatStore, và nhân viên khác chọn để Chat đc
      * @example:
       this.VhQueryCare.unselectChatStore("2rVieBQTubQ2hjUnpwU4w7qSlD83")
           .then((result)=>{
             console.log(result);
           })
       * @param id_store 
       * @return Promise Boolean => true or false
       */
     public unselectChatStore(id_store:any){    
       return new Promise((resolve, reject) => {   
         resolve(true);           
       })    
     }
   
     /**
      * Sau khi hỗ trợ khách hàng xong, dùng hàm này   
      * @example:
       this.VhQueryCare.finishChatStore("2rVieBQTubQ2hjUnpwU4w7qSlD83")
           .then((result)=>{
             console.log(result);
           })
       * @param id_store 
       * @return Promise Boolean => true or false
       */
       public finishChatStore(id_store:any){  
         return new Promise((resolve, reject) => {      
           resolve(true);              
         }) 
         
       }
                     
       /**
        * sau khi chạy hàm connectChatStore, nội dung chat của Store có id la sid, sẽ được trả về qua  hàm callbackMessagesFromChatStores
        * @example: 
           this.VhQueryCare.connectChatStore('2rVieBQTubQ2hjUnpwU4w7qSlD83');
         * @param id_store 
         * @return void
         */ 
       public connectChatStore(id_store:any){
         
       }
                     
       /**
        * sau khi chạy hàm connectChatStore, hàm này gửi tin nhắn và tiếp tục chat với store có id là sid
        * @example: 
           this.VhQueryCare.sendMessageToChatStore('2rVieBQTubQ2hjUnpwU4w7qSlD83', 'Xin chao ban');
         * @param id_store 
         * @param message
         * @return void 
         */
       public sendMessageToChatStore(id_store:any, message:any){
         
       }
     
       public sendImageToChatStore(id_store:any, image:any){
         
       }
                     
                  
                     
                     
 }
 
 
 
 @Injectable()
 export class VhQueryCloudCam{  
   private utoken: any = null;
   private cameras: any = new Array();
   private cloudcams: any = new Array();
   private rooms: any = new Array();
   private mainboards: any = new Array();
   private functions: any = new Array();
   private components: any = new Array();
   private icons: any = new Array();
   private appsettingstations: any = new Array();  
   private scripts: any = new Array();
   private script_details: any = new Array();
   private logs: any = new Array();
   private hwinfo: any = {};
 
   private subjectcameras = new Subject<any>();
   private subjectappsettingstations = new Subject<any>();
   private subjectrooms = new Subject<any>();
   private subjectmainboards = new Subject<any>();
   private subjectfunctions = new Subject<any>();
   private subjecticons = new Subject<any>();
   private subjectcomponents = new Subject<any>();   
 
   constructor(
     private vhMGDB_auth: VhMGDB_auth, 
     private vhMGDB_f3rdclouds: VhMGDB_f3rdclouds, 
     private vhMGDB_clouds: VhMGDB_clouds,     
     private vhMGDB_database: VhMGDB_database,
     private vhMGDB_socketMongoDB: VhMGDB_socketMongoDB,
     
     private vhQuery:VhQuery,
      private vhAuth: VhAuth, 
      private vhAlgorithm:VhAlgorithm) {
     Device.getId().then((info:any)=>{
       let local_hwinfo = this.vhAuth.localStorageGET('hwinfo');
       if((local_hwinfo != null)&&(local_hwinfo != undefined)){
         this.hwinfo = local_hwinfo;       
       }else{
        this.hwinfo = {uuid: info.identifier};     
         this.vhAuth.localStorageSET('hwinfo',this.hwinfo);        
       }           
     });  
   } 
 
   /**
  * @example:
   this.VhQuerySmhome.syncCollections().then((bool:any)=>{
       if(bool){
         do something...
       }
   })
   * @returns Promise bool = true or false
   */
   syncCollections(){    
     return new Promise((resolve, reject)=>{      
       this.initSyncCollections();
       this.callbackCollectionInsert().subscribe();
       this.callbackCollectionUpdate().subscribe();
       this.callbackCollectionDelete().subscribe();
       this.getEUtokenfromDatabase();
       setTimeout(() => {
         resolve(true);
       }, 5000);
     })    
   }
 
   private initSyncCollections(){      
     let colname_array = new Array(); colname_array[0] = 'rooms'; colname_array[1] = 'mainboards'; 
     colname_array[2] = 'components'; colname_array[3] = 'icons'; colname_array[4] = 'functions'; colname_array[5] = 'vhemployees'; colname_array[6] = 'appsettingstations';     
     return this.vhMGDB_socketMongoDB.initSyncCollections(colname_array,{},"");  
   }
 
       /**
    * @example:
    * this.vhQuerySmhome.closeSyncCollections();
    * disconnect collections synchronization in the APP
    * @returns void
    */
   public closeSyncCollections(){
     // this.callbackcollections.unsubscribe();
     this.vhMGDB_socketMongoDB.closeSyncCollections();
   }
   
   /**
    * vhQuerySmhome
    * @returns 
    */
   private callbackCollectionInsert(){    
     return new Observable((observer:any) => {    
       this.vhMGDB_socketMongoDB.callbackCollectionInsert().subscribe((data:any)=>{  
         if(data.colname === 'vhemployees') data.colname = 'employees';
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
 
         if(data.colname === 'cameras'){
           if(!this.getlocalCamera(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.cameras.push(obj); 
             this.publishObservableEventCameras();    
             observer.next(data.colname);       
           }                  
         }else if(data.colname === 'rooms'){
           if(!this.getlocalRoom(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.rooms.push(obj); 
             this.publishObservableEventRooms();    
             observer.next(data.colname);       
           }            
         }else if(data.colname === 'mainboards'){
           if(!this.getlocalMainboard(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.mainboards.push(obj); 
             this.publishObservableEventMainboards();    
             observer.next(data.colname);       
           }   
         }else if(data.colname === 'components'){
           if(!this.getlocalComponent(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.components.push(obj); 
             this.publishObservableEventComponents();    
             observer.next(data.colname);       
           }             
         }else if(data.colname === 'icons'){
           if(!this.getlocalIcon(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.icons.push(obj); 
             this.publishObservableEventIcons();    
             observer.next(data.colname);       
           } 
         }else if(data.colname === 'functions'){
           if(!this.getlocalFunction(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.functions.push(obj); 
             this.publishObservableEventFunctions();    
             observer.next(data.colname);       
           } 
         }else if(data.colname === 'employees'){          
           let obj = {...data.data}; obj._id = data._id;
           this.vhAuth.insertlocalEmployeeFromSyncCollection(obj);         
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);                 
         }else if(data.colname === 'appsettingstations'){         
           if(!this.getLocalAppSettingStation(data._id)){         
             if(data.data.uuid === this.hwinfo.uuid){   
               let obj = {...data.data}; obj._id = data._id;
               delete obj.uuid;
               this.appsettingstations.push(obj);   
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);               
             }            
           }                               
         }
         //console.log('inserted', data.colname);
       })
     })
   }
 
   /**
    * vhQuerySmhome
    * @returns 
    */
   private callbackCollectionUpdate(){    
     return new Observable((observer:any) => {          
       this.vhMGDB_socketMongoDB.callbackCollectionUpdate().subscribe((data:any)=>{ 
         if(data.colname === 'vhemployees') data.colname = 'employees';
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
         if(data.colname === 'cameras'){
           for(let i=0; i<this.cameras.length; i++){
             if(this.cameras[i]._id === data._id){
               this.cameras[i] = {...this.cameras[i], ...data.data};     
               this.publishObservableEventCameras();  
               observer.next(data.colname);         
               break;
             }
           }  
         }else if(data.colname === 'rooms'){
           for(let i=0; i<this.rooms.length; i++){
             if(this.rooms[i]._id === data._id){
               this.rooms[i] = {...this.rooms[i], ...data.data};     
               this.publishObservableEventRooms();  
               observer.next(data.colname);         
               break;
             }
           }       
         }else if(data.colname === 'mainboards'){
           for(let i=0; i<this.mainboards.length; i++){
             if(this.mainboards[i]._id === data._id){
               this.mainboards[i] = {...this.mainboards[i], ...data.data};     
               this.publishObservableEventMainboards();  
               observer.next(data.colname);         
               break;
             }
           } 
         }else if(data.colname === 'components'){
           for(let i=0; i<this.components.length; i++){
             if(this.rooms[i]._id === data._id){
               this.rooms[i] = {...this.components[i], ...data.data};     
               this.publishObservableEventComponents();  
               observer.next(data.colname);         
               break;
             }
           }   
         }else if(data.colname === 'icons'){
           for(let i=0; i<this.icons.length; i++){
             if(this.icons[i]._id === data._id){
               this.icons[i] = {...this.icons[i], ...data.data};     
               this.publishObservableEventIcons();  
               observer.next(data.colname);         
               break;
             }
           }           
         }else if(data.colname === 'functions'){
           for(let i=0; i<this.icons.functions; i++){
             if(this.functions[i]._id === data._id){
               this.functions[i] = {...this.functions[i], ...data.data};     
               this.publishObservableEventFunctions();  
               observer.next(data.colname);         
               break;
             }
           }      
         }else if(data.colname === 'employees'){          
           this.vhAuth.updateLocalEmployeeFromSyncCollection(data._id, data.data);    
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);
         }else if(data.colname === 'appsettingstations'){
           for(let i=0; i<this.appsettingstations.length; i++){
             if(this.appsettingstations[i]._id === data._id){
               this.appsettingstations[i] = {...this.appsettingstations[i], ...data.data};   
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);               
               break;
             }
           }    
         }    
         //console.log('this.products', this.products);
         //console.log('updated', data.colname);
       })
     })
   }
  /**
   * vhQuerySmhome
   * @returns 
   */
   private callbackCollectionDelete(){
     return new Observable((observer:any) => {    
       this.vhMGDB_socketMongoDB.callbackCollectionDelete().subscribe((data:any)=>{       
         if(data.colname === 'vhemployees') data.colname = 'employees';    
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
         if(data.colname === 'cameras'){
           for(let i=0; i<this.cameras.length; i++){
             if(this.cameras[i]._id === data._id){
               this.cameras.splice(i, 1);       
               this.publishObservableEventCameras();  
               observer.next(data.colname);                        
               break;
             }
           }   
         }else if(data.colname === 'rooms'){
           for(let i=0; i<this.rooms.length; i++){
             if(this.rooms[i]._id === data._id){
               this.rooms.splice(i, 1);       
               this.publishObservableEventRooms();  
               observer.next(data.colname);                        
               break;
             }
           }          
         }else if(data.colname === 'mainboards'){
           for(let i=0; i<this.mainboards.length; i++){
             if(this.mainboards[i]._id === data._id){
               this.mainboards.splice(i, 1);       
               this.publishObservableEventMainboards();  
               observer.next(data.colname);                        
               break;
             }
           }    
         }else if(data.colname === 'components'){
           for(let i=0; i<this.components.length; i++){
             if(this.components[i]._id === data._id){
               this.components.splice(i, 1);       
               this.publishObservableEventComponents();  
               observer.next(data.colname);                        
               break;
             }
           }   
         }else if(data.colname === 'icons'){
           for(let i=0; i<this.icons.length; i++){
             if(this.icons[i]._id === data._id){
               this.icons.splice(i, 1);       
               this.publishObservableEventIcons();  
               observer.next(data.colname);                        
               break;
             }
           }        
         }else if(data.colname === 'functions'){
           for(let i=0; i<this.functions.length; i++){
             if(this.functions[i]._id === data._id){
               this.functions.splice(i, 1);       
               this.publishObservableEventFunctions();  
               observer.next(data.colname);                        
               break;
             }
           }        
         }else if(data.colname === 'employees'){
           this.vhAuth.deleteLocalEmployeeFromSyncCollection(data._id);    
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);    
         }else if(data.colname === 'appsettingstations'){
           for(let i=0; i<this.appsettingstations.length; i++){
             if(this.appsettingstations[i]._id === data._id){
               this.appsettingstations.splice(i, 1); 
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);                
               break;
             }
           }   
         }
         console.log('deleted', data.colname);           
       })
     })
   }
   
   /**
    * vhQuerySmhome
    * @returns 
    */
   public startLocalStorage(){
     return new Promise<any>((resolve) => {
       let promise = new Array();  
       //promise[0] = this.vhAuth.refreshLocalEmployees();
       promise[0] = this.vhAuth.refreshLocalMyPermission();  
       promise[1] = this.refreshLocalCloudCams();
       promise[2] = this.getEUtokenfromDatabase();
       //promise[3] = this.refreshLocalCameras();     
       //promise[4] = this.refreshLocalComponents();
       //promise[5] = this.refreshLocalFunctions();
       //promise[6] = this.refreshLocalIcons();  
       //promise[7] = this.refreshLocalMainboards();             
       this.vhQuery.asyncPromiseAll(promise).then(()=>{resolve(null)});               
     })
   }
 
   /**
    * lấy về recordserverURL, APP gửi recordserverURL cho Cloudcam Box, Box dùng kiểm recordedfile với RecordServer và upload recordedfile chưa có lên RecordServer
    * lấy về clientRTSPURL cộng với rtspID nhận từ Cloudcam Box, APP sẽ đăng ký camera này lên Clouds, nếu thành công sẽ nhận đc licensecam
    * lấy về serverRTSPURL, APP gửi serverRTSPURL cho Cloudcam Box, Box dùng send video của từng camera  lên RTSP Server
    * lấy về _id truyền vô hàm addCloudCamBoxByEndUser để đăng ký camera này lên Clouds
    * mỗi lần đăng ký một camera lên Clouds là dùng hàm getCloudCamServer() để lấy thông tin đăng ký lại
    * @returns Promise Object => obj = {clientRTSPURL, serverRTSPURL, _id}
    */
   public getCloudCamServer(){
     return this.vhMGDB_f3rdclouds.getCloudCamServer();
   }
 
  //vhQueryCloudCam
   public createPaymentVnpay(amount:number, bankCode:string, data:any, backHref:string, fee:object, fee_details:object):any {    
     //return new Promise<any>((resolve, reject) => {   
       const orderType = "billpayment";  
       const orderDescription = "thanh toan";         
       const language = "vn";    
       let payment = {
         projectName: this.vhMGDB_auth.getProjectName(),
         sid: this.vhMGDB_auth.getDatabase(),
         data: data
       }
       this.vhMGDB_f3rdclouds.createPaymentVnpay(amount, bankCode, orderType, orderDescription, language, payment, backHref, fee, fee_details)
           .then((response:any)=>{           
             window.location = response.data; 
             //resolve(response);
           },(error:any)=>{
             console.log('error', error);
           })
     //}) 
   }
 
 /**
  * @example:
    * this.vhQueryCloudCam.getDiscountFromCode('VIETHAS')
           .then((discount)=>{
             console.log('getDiscountFromCode', discount);
           },(error:any)=>{
             console.log('error', error);
           })
  * @returns 
  */
   public getDiscountFromCode(code:string):any {    
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_f3rdclouds.getDiscountFromCode(code)
           .then((discountcodes:any)=>{             
             if(discountcodes.size > 0){
               resolve(discountcodes.docs[0].data().discount);              
             }else{
               resolve(0);       
             }             
           },(error:any)=>{
             console.error(error);
             reject(error);
           })     
     })
   }
 
 /**
  * @example:
    * this.vhQueryCloudCam.getPriceList_Records()
           .then((pricelist)=>{
             console.log('getPriceList_Records', pricelist);
           },(error:any)=>{
             console.log('error', error);
           })
  * @returns 
  */
   public getPriceList_Records():any {    
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_clouds.getPriceList_Records()
           .then((pricelist_storages:any)=>{    
             let pricelist = new Array();     
             if(pricelist_storages.size > 0){
               pricelist_storages.forEach((element:any) => {
                 pricelist.push(element.data());
                 pricelist[pricelist.length-1]._id = element.id;
               });
             }   
             pricelist = this.vhAlgorithm.sortNumberbyASC(pricelist, 'month');
             resolve(pricelist)        
           },(error:any)=>{
             console.error(error);
             reject(error);
           })     
     })
   }
 
 /**
  * @example:
    * this.vhQueryCloudCam.getPriceList_Detectors()
           .then((pricelist)=>{
             console.log('getPriceList_Detectors', pricelist);
           },(error:any)=>{
             console.log('error', error);
           })
  * @returns 
  */
   public getPriceList_Detectors():any {    
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_clouds.getPriceList_Detectors()
           .then((pricelist_detectors:any)=>{            
             let pricelist = new Array();     
             if(pricelist_detectors.size > 0){
               pricelist_detectors.forEach((element:any) => {
                 pricelist.push(element.data());
                 pricelist[pricelist.length-1]._id = element.id;
               });
             }   
             pricelist = this.vhAlgorithm.sortNumberbyASC(pricelist, 'month');
             resolve(pricelist)     
           },(error:any)=>{
             console.error(error);
             reject(error);
           })   
     })
   }
   
   /**
  * @example:
    * this.vhQueryCloudCam.getPriceList_rLPRs()
           .then((pricelist_detectors)=>{
             console.log('getPriceList_rLPRs', pricelist_detectors);
           },(error:any)=>{
             console.log('error', error);
           })
  * @returns 
  */
   public getPriceList_rLPRs():any {    
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_clouds.getPriceList_rLPRs()
           .then((pricelist_rLPRs:any)=>{            
             let pricelist = new Array();     
             if(pricelist_rLPRs.size > 0){
               pricelist_rLPRs.forEach((element:any) => {
                 pricelist.push(element.data());
                 pricelist[pricelist.length-1]._id = element.id;
               });
             }   
             pricelist = this.vhAlgorithm.sortNumberbyASC(pricelist, 'month');
             resolve(pricelist)     
           },(error:any)=>{
             console.error(error);
             reject(error);
           })   
     })
   }
 
    /**
  * @example:
    * this.vhQueryCloudCam.getPriceList_cLPRs()
           .then((getPriceList_cLPRs)=>{
             console.log('getPriceList_cLPRs', getPriceList_cLPRs);
           },(error:any)=>{
             console.log('error', error);
           })
  * @returns 
  */
   public getPriceList_cLPRs():any {    
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_clouds.getPriceList_cLPRs()
           .then((pricelist_cLPRs:any)=>{            
             let pricelist = new Array();     
             if(pricelist_cLPRs.size > 0){
               pricelist_cLPRs.forEach((element:any) => {
                 pricelist.push(element.data());
                 pricelist[pricelist.length-1]._id = element.id;
               });
             }   
             pricelist = this.vhAlgorithm.sortNumberbyASC(pricelist, 'month');
             resolve(pricelist)     
           },(error:any)=>{
             console.error(error);
             reject(error);
           })   
     })
   }
   
   private publishObservableEventCameras() {
     this.subjectcameras.next(this.cameras);
   }  
 
   private observableLocalCameras():Subject<any> {      
     return this.subjectcameras; 
   }
   
  /**
    * @example:
    * this.observableCamera = this.vhQueryCloudCam.getObservableLocalCameras().subscribe((localCameras:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableCamera.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalCameras(){   
    return new Observable((observer:any) => {    
     this.observableLocalCameras().subscribe((cameras) => {   
       observer.next(cameras);
     })
     this.publishObservableEventCameras();
    })
   }
         
 
   /**
    * @example: 
    * let wallet = this.vhQueryCloudCam.getlocalCamera('5fb6780ca2148e09806c5b01');
    * @param id_camera 
    * @return Object => obj = {} or null
    */
   public getlocalCamera(id_camera:any){
     for(let i=0; i<this.cameras.length; i++){
       if(this.cameras[i]._id === id_camera){
         return this.cameras[i];
         break;
       }
     } 
     return null; 
   }
      
 
   /**
    * @example: 
    * let wallets = this.vhQueryCloudCam.getlocalCameras();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalCameras(){    
     return this.cameras;
   }
   
    /**
    * @example:
    * this.vhQueryCloudCam.refreshLocalCameras()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalCamera(), getlocalCameras() trong localstorage
    * @return Promise => null
    */
   public refreshLocalCameras():any{
     return new Promise((resolve) => { 
       this.getCameras()
           .then(()=>{resolve(null)})       
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.createLicenseCam()
         .then((licensecam)=>{
           console.log('licensecam', licensecam);
         })
   * @return Promise => licensecam
   */
   public createLicenseCam(){  
     return new Promise((resolve, reject) => {
       // this.vhMGDB_clouds.createLicenseCam({})
       //     .then((licensecam:any)=>{            
       //       resolve(licensecam)        
       //     },(error:any)=>{
       //       console.error(error);
       //       reject(error);
       //     })            
     })
   }
  
   /**
    * @example:
    * this.vhQueryCloudCam.addCamera({name:'camera 2', url:'rtsp://admin:admin@115.78.100.57:1020/av_stream/ch0', licensecam:'pTqOFsJEndPrg7AImFxV'})
           .then((camera)=>{
             console.log('addCamera', camera);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    * Trường hợp không thành công:
    * code = 0 : licensecam không đúng
    * code = 1 : licensecam đã và đang được sử dụng
    */
   public addCamera(data:any){
     //let _data = {...data};
     //if(_data.licensecam === undefined) _data.licensecam = _data.licensekey;
     //delete _data.licensekey;
     return new Promise((resolve, reject) => {
       // this.vhMGDB_clouds.checkLicenseAddCam(data)
       //     .then((result:any)=>{            
       //       if((result.code === 4)||(result.code === 5)){
       //         this.vhMGDB_database.addDoc('cameras', {...data, camliveURL:result.camliveURL, camplaybackURL:result.camplaybackURL})
       //             .then((camera)=>{
       //               resolve(camera);
       //             },(error:any)=>{
       //               console.error(error);
       //               reject({code:0});
       //             })    
       //       }else reject(result);            
       //     },(error:any)=>{
       //       console.error(error);
       //       reject({code:0});
       //     })            
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.updateCamera('5fb6780ca2148e09806c5b01', {name:camera 3})
           .then((bool:any)=>{
             console.log('updateCamera', bool);
           })
    * @param id_camera 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateCamera(id_camera:string, data:any){    
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.getDoc('cameras', id_camera)
           .then((camera:any)=>{            
             // if(camera){
             //   let _data = {...data};
             //   _data.licensecam = camera.licensecam;
             //   this.vhMGDB_clouds.checkLicenseUpdateCam(_data)
             //       .then((result:any)=>{                                
             //         if(result.code === 3){        
             //           this.vhMGDB_database.updateDoc('cameras', id_camera, _data)
             //               .then((bool:any)=>{            
             //                 resolve(bool);
             //               }, error=>{
             //                 reject(error)
             //               })   
             //         }                   
             //       },(error:any)=>{
             //         reject(error);
             //       })      
             // }
           }, error=>{
             reject(error)
           })               
     }) 
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.deleteCamera('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteCamera', bool);
         })
    * @param id_camera 
    * @return Promise => bool = true or false 
    */
   public deleteCamera(id_camera:string){
     return new Promise((resolve, reject) => {
       // this.vhMGDB_database.getDoc('cameras', id_camera)
       //     .then((camera:any)=>{            
       //      if(camera){            
       //       this.vhMGDB_clouds.checkLicenseDeleteCam(camera.licensecam)
       //           .then((result:any)=>{                 
       //               this.vhMGDB_database.deleteDoc('cameras', id_camera)
       //                   .then((bool:any)=>{            
       //                     resolve(bool);
       //                   }, error=>{
       //                     reject(error)
       //                   })                     
       //           },(error:any)=>{
       //             reject(error);
       //           })        
       //      }
       //     }, error=>{
       //       reject(error)
       //     })                   
               
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getCamera('5fb67fda87c0f21d484cbdf3')
             .then((camera)=>{
               console.log('getCamera', camera);
             })
    * @param id_camera 
    * @return Promise => obj ={} or null
    */
   public getCamera(id_camera:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('cameras', id_camera)
             .then((camera)=>{
               resolve(camera);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getCameras()
             .then((cameras)=>{
               console.log('getCameras', cameras);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getCameras(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('cameras')
             .then((cameras)=>{
               this.cameras = new Array();
               this.cameras = cameras;
               resolve(cameras);
             },(error:any)=>{
               reject(error);
             })          
     })
   } 
 
 /**
  * @example
  * this.vhQueryCloudCam.getFee_detailsByFields({date:{$gte:starttime, $lte:endtime}}, {}, {date:1},0)
           .then((fee_details)=>{
             console.log('getFee_detailsByFields', fee_details);
           })
   * @return Promise => array(object) = [{},{},..]
   */
   private getFee_detailsByFields(query: any, projection?:object, sort?:any, limit?:number){//hàm này Huy dùng cho viết hàm báo cáo
     return new Promise((resolve, reject) => {         
       //query.database = {uid:{$eq: this.vhMGDB_auth.getDatabase()}};dfasdf
       this.vhMGDB_database.getDocsByFields_onRootCollectionsFirebase('fee_details', query, {}, sort, limit)
           .then((fee_details:any)=>{                      
             resolve(fee_details);
           }, error=>{
             reject(error)
           })    
     })
   } 
 
 /**
  * @example
  * this.vhQueryCloudCam.getFeesByFields({date:{$gte:starttime, $lte:endtime}}, {}, {date:1},0)
           .then((fees)=>{
             console.log('getFees', fees);
           })
   * @return Promise => array(object) = [{},{},..]
   */
   public getFeesByFields(query: any, projection?:object, sort?:any, limit?:number){
     return new Promise((resolve, reject) => {         
       query.database = {database: {$eq: this.vhMGDB_auth.getDatabase()}};
       this.vhMGDB_database.getDocsByFields_onRootCollectionsFirebase('fees', query, {}, sort, limit)
           .then((fees:any)=>{                      
             resolve(fees);
           }, error=>{
             reject(error)
           })    
     })
   } 
   
   /**
    * @example
    * this.vhQueryCloudCam.getFee(id_fee)
             .then((fee)=>{
               console.log('getFee', fee);
             })
    * @return Promise => obj ={} or null
    */
   public getFee(id_fee:string){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDoc_onRootCollectionsFirebase('fees', id_fee)
             .then((fee)=>{              
               resolve(fee);
             },(error:any)=>{
               reject(error);
             })          
     })
   } 
 
   /**
  * @example
  * this.vhQueryCloudCam.getFee_Details(id_fee:string)
           .then((fee_details)=>{
             console.log('getFee_Details', fee_details);
           })
   * @return Promise => array(object) = [{},{},..]
   */
   public getFee_Details(id_fee:string){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocsByFields_onRootCollectionsFirebase('fee_details', {id_fee:{$eq:id_fee}}, {}, {},0)
             .then((fee_details)=>{              
               resolve(fee_details);
             },(error:any)=>{
               reject(error);
             })          
     })
   } 
 
   /**
    * this.vhQueryCloudCam.importUtoken('fasofu9afu0aw9etuf9wierrq973r89y239t82yewfuifw7ewfyuw9')
    * @param utoken 
    * @return Void
    */
   public importUtoken(utoken:string){    
     this.vhMGDB_f3rdclouds.importUtoken(utoken);   
   }
 
   public getLocalEUtoken(){    
     return  this.vhMGDB_f3rdclouds.getLocalEUtoken();   
   }
 
   private getEUtokenfromDatabase(){
     return new Promise<any>((resolve, reject) => {     
       this.vhMGDB_f3rdclouds.getEUtokenfromDatabase().then(()=>{resolve(null)})
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.checkExpiredUtoken()
         .then((bool:any)=>{
           if(bool){
             do something....
           }
         })
    * @param utoken 
    * @returns Promise => true or false
    */
   public checkExpiredUtoken(){
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_f3rdclouds.checkExpiredUtoken()
           .then((response)=>{
             if(response.vcode === 0){                  
               resolve(true);                            
             }else{
               console.log(response.message);
               resolve(false);                    
             }            
       })  
     })
   }
 
   /**
    * @example: 
    * let cloudcam = this.vhQueryCloudCam.getlocalCloudCam('5fb6780ca2148e09806c5b01');
    * @param licensecam 
    * @return Object => obj = {} or null
    */
    public getlocalCloudCam(licensecam:any){
     for(let i=0; i<this.cloudcams.length; i++){
       if(this.cloudcams[i].licensecam === licensecam){
         return this.cloudcams[i];        
       }
     } 
     return null; 
   }
      
 
   /**
    * @example: 
    * let cloudcams = this.vhQueryCloudCam.getlocalCloudCams();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalCloudCams(){    
     return this.cloudcams;
   }
   
    /**
    * @example:
    * this.vhQueryCloudCam.refreshLocalCloudCams()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalCloudCam(), getlocalCloudCams() trong localstorage
    * @return Promise => null
    */
   public refreshLocalCloudCams():any{
     return new Promise((resolve) => { 
       this.getCloudCamsByEndUser()
           .then(()=>{resolve(null)})       
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.changeCloudCamEnableCLPRbyEndUser('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableCLPRbyEndUser', bool);
           })
    * @param licensecam 
    * @param cLPR_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableCLPRbyEndUser(licensecam:string, cLPR_enable:boolean){    
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableCLPRbyEndUser(licensecam, cLPR_enable)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })           
     }
 
    /**
    * @example:
    * this.vhQueryCloudCam.changeCloudCamEnableRLPRbyEndUser('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableRLPRbyEndUser', bool);
           })
    * @param licensecam 
    * @param rLPR_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableRLPRbyEndUser(licensecam:string, rLPR_enable:boolean){    
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableRLPRbyEndUser(licensecam, rLPR_enable)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })     
     }
 
   /**
    * @example:
    * this.vhQueryCloudCam.changeCloudCamEnableDetectorByEndUser('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableDetectorByEndUser', bool);
           })
    * @param licensecam 
    * @param detector_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableDetectorByEndUser(licensecam:string, detector_enable:boolean){   
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableDetectorByEndUser(licensecam, detector_enable)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })     
     }
 
   /**
    * @example:
    * this.vhQueryCloudCam.changeCloudCamEnableRecordByEndUser('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableRecordByEndUser', bool);
           })
    * @param licensecam 
    * @param record_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableRecordByEndUser(licensecam:string, record_enable:boolean){     
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableRecordByEndUser(licensecam, record_enable)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })                 
     }
 
     /**
    * @example:
    * this.vhQueryCloudCam.changeCloudCamEnableActiveByEndUser('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableActiveByEndUser', bool);
           })
    * @param licensecam 
    * @param active 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableActiveByEndUser(licensecam:string, active:boolean){     
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableActiveByEndUser(licensecam, active)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })                 
     }
 
   /**
    * @example:
    * this.vhQueryCloudCam.changeCloudCamURLbyEndUser('5fb6780ca2148e09806c5b01', 'rtsp://freja.hiof.no:1935/rtplive/definst/hessdalen03.stream', 'udp')
           .then((bool:any)=>{
             console.log('changeCloudCamURLbyEndUser', bool);
           })
    * @param licensecam
    * @param url 
    * @return Promise => bool = true or false 
    */
   public changeCloudCamURLbyEndUser(licensecam:string, url:string){  
     return new Promise((resolve) => {
       this.vhMGDB_f3rdclouds.changeCloudCamURLbyEndUser(licensecam, url)
             .then((cloudcam:any)=>{
               if(cloudcam.vcode === 0){                  
                 resolve(true);                            
               }else{
                 //console.log(cloudcam.message);
                 resolve(false);                    
               }                    
             })          
     })    
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.addCloudCamByEndUser('rtsp://freja.hiof.no:1935/rtplive/definst/hessdalen03.stream', {name:camera 3})
           .then((cloudcam:any)=>{
             console.log('addCloudCamByEndUser', cloudcam);
           })
    * @param url       
    * @param data 
    * @return Promise => {} or null 
    */
   public addCloudCamByEndUser(url:string, data:object){          
     return new Promise((resolve) => {
       this.vhMGDB_f3rdclouds.addCloudCamByEndUser(url, data)
             .then((cloudcam:any)=>{
               if(cloudcam.vcode === 0){                  
                 resolve(cloudcam.data);                            
               }else{
                 //console.log(cloudcam.message);
                 resolve(null);                    
               }
                   
             })          
     })  
   }
 
   /**
  * @example:
  * this.vhQueryCloudCam.addCloudCamBoxByEndUser('rtsp://127.0.0.1:20306/hessdalen03.stream', {name:camera 3}, 'jlsdjfoasi09asf0u90')
         .then((cloudcam:any)=>{
           console.log('addCloudCamBoxByEndUser', cloudcam);
         })
   * @param url     
   * @param data 
   * @return Promise => {} or null 
   */
   public addCloudCamBoxByEndUser(url:string, data:object, id_cloudcamserver:string){          
     return new Promise((resolve) => {
       this.vhMGDB_f3rdclouds.addCloudCamBoxByEndUser(url, data, id_cloudcamserver)
             .then((cloudcam:any)=>{
               if(cloudcam.vcode === 0){                  
                 resolve(cloudcam.data);                            
               }else{
                 //console.log(cloudcam.message);
                 resolve(null);                    
               }
                   
             })          
     })  
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.updateCloudCamDataByEndUser('5fb6780ca2148e09806c5b01', {name:'camera 3'})
           .then((bool:any)=>{
             console.log('updateCloudCamDataByEndUser', bool);
           })
    * @param licensecam 
    * @param data 
    * @return Promise => bool = true or false 
    */
     public updateCloudCamDataByEndUser(licensecam:string, data:object){       
         return new Promise((resolve) => {
           this.vhMGDB_f3rdclouds.updateCloudCamDataByEndUser(licensecam, data)
                 .then((cloudcam:any)=>{                  
                   if(cloudcam.vcode === 0){                                                
                     resolve(true);                            
                   }else{
                     //console.log(cloudcam.message);
                     resolve(false);                    
                   }                      
                 })          
         })                
     }
 
   /**
    * @example:
    * this.vhQueryCloudCam.deleteCloudCamByEndUser('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteCloudCamByEndUser', bool);
         })
    * @param licensecam 
    * @return Promise => bool = true or false 
    */
     public deleteCloudCamByEndUser(licensecam:string){
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.deleteCloudCamByEndUser(licensecam)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })
     }
 
   /**
    * @example
    * this.vhQueryCloudCam.getCloudCamByEndUser('5fb67fda87c0f21d484cbdf3')
             .then((cloudcam:any)=>{
               console.log('getCloudCamByEndUser', cloudcam);
             })
    * @param licensecam:string 
    * @return Promise => obj ={} or null
    */
     public getCloudCamByEndUser(licensecam:string){
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.getCloudCamByEndUser(licensecam)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(cloudcam.data);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(null);                    
                 }
                    
               })          
       })
     }
 
   /**
    * @example
    * this.vhQueryCloudCam.getCloudCamsByEndUser()
             .then((cloudcams)=>{
               console.log('getCloudCamsByEndUser', cloudcams);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getCloudCamsByEndUser(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_f3rdclouds.getCloudCamsByEndUser()
             .then((cloudcams)=>{
               if(cloudcams.vcode === 0){
                 this.cloudcams = cloudcams.data;                              
               }else{
                 console.log(cloudcams.message);
                 this.cloudcams = new Array();                   
               }
               resolve(this.cloudcams);                          
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   /**
    * 
    * @param licensecam 
    * @param camplaybackURL 
    * @param starttime 
    * @param endtime 
    * @return Promise => array(string) = [,,..]
    */
   public getPlaybackListCamByEndUser(licensecam:string, camplaybackURL:string, starttime:any, endtime:any){
     return new Promise((resolve, reject) => {
       this.vhMGDB_f3rdclouds.getPlaybackListCambyEndUser(licensecam, camplaybackURL, starttime, endtime)
         .then((playbacklist:any)=>{
           if(playbacklist.vcode === 0){           
             resolve(playbacklist.data);                             
           }else{
             console.log(playbacklist);           
             resolve([]);                  
           }    
         },(error:any)=>{         
           reject(error);
         }) 
     })       
   }
 
   private publishObservableEventRooms() {
     this.subjectrooms.next(this.rooms);
   }  
 
   private observableLocalRooms():Subject<any> {      
     return this.subjectrooms; 
   }
   
  /**
    * @example:
    * this.observableRoom = this.vhQueryCloudCam.getObservableLocalRooms().subscribe((localRooms:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableRoom.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalRooms(){   
    return new Observable((observer:any) => {    
     this.observableLocalRooms().subscribe((rooms) => {   
       observer.next(rooms);
     })
     this.publishObservableEventRooms();
    })
   }
 
 
   /**
    * @example: 
    * let wallet = this.vhQueryCloudCam.getlocalRoom('5fb6780ca2148e09806c5b01');
    * @param id_room 
    * @return Object => obj = {} or null
    */
   public getlocalRoom(id_room:any){
     for(let i=0; i<this.rooms.length; i++){
       if(this.rooms[i]._id === id_room){
         return this.rooms[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryCloudCam.getlocalRooms();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalRooms(){    
     return this.rooms;
   }
   
    /**
    * @example:
    * this.vhQueryCloudCam.refreshLocalRooms()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalRoom(), getlocalRooms() trong localstorage
    * @return Promise => null
    */
   public refreshLocalRooms():any{
     return new Promise((resolve) => { 
       this.getRooms()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryCloudCam.addRoom({name:'camera 2', quantity:20, price:200000})
           .then((room)=>{
             console.log('addRoom', room);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addRoom(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('rooms', data)
           .then((room)=>{
             resolve(room);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.updateRoom('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateRoom', bool);
           })
    * @param id_room 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateRoom(id_room:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('rooms', id_room, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.deleteRoom('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteRoom', bool);
         })
    * @param id_room 
    * @return Promise => bool = true or false 
    */
   public deleteRoom(id_room:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('rooms', id_room)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getRoom('5fb67fda87c0f21d484cbdf3')
             .then((room)=>{
               console.log('getRoom', room);
             })
    * @param id_room 
    * @return Promise => obj ={} or null
    */
   public getRoom(id_room:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('rooms', id_room)
             .then((room)=>{
               resolve(room);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getRooms()
             .then((rooms)=>{
               console.log('getRooms', rooms);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getRooms(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('rooms')
             .then((rooms)=>{
               this.rooms = new Array();
               this.rooms = rooms;
               resolve(rooms);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
   /**
    * @example: 
    * let log = this.vhQueryCloudCam.getlocalLog('5fb6780ca2148e09806c5b01');
    * @param id_log 
    * @return Object => obj = {} or null
    */
   public getlocalLog(id_log:any){
     for(let i=0; i<this.logs.length; i++){
       if(this.logs[i]._id === id_log){
         return this.logs[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let logs = this.vhQueryCloudCam.getlocalLogs(); 
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalLogs(){    
     return this.logs;
   }
   
   /**
    * @example:
    * this.vhQueryCloudCam.refreshLocalLogs()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalLog(), getlocalLogs() trong localstorage
    * @return Promise => null
    */
   public refreshLocalLogs():any{
     return new Promise((resolve) => { 
       this.getLogs()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryCloudCam.addLog({name:'camera 2', quantity:20, price:200000})
           .then((log)=>{
             console.log('addLog', log);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addLog(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('logs', data)
           .then((log)=>{
             resolve(log);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.updateLog('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateLog', bool);
           })
    * @param id_log 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateLog(id_log:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('logs', id_log, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.deleteLog('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteLog', bool);
         })
    * @param id_log 
    * @return Promise => bool = true or false 
    */
   public deleteLog(id_log:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('logs', id_log)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getLog('5fb67fda87c0f21d484cbdf3')
             .then((log)=>{
               console.log('getLog', log);
             })
    * @param id_log 
    * @return Promise => obj ={} or null
    */
   public getLog(id_log:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('logs', id_log)
             .then((log)=>{
               resolve(log);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getLogs()
             .then((logs)=>{
               console.log('getLogs', logs);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getLogs(){
     return new Promise((resolve, reject) => {
       this.logs = new Array();
       this.vhMGDB_database.getDocs('logs')
             .then((logs)=>{
               this.logs = logs;
               resolve(logs);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   private publishObservableEventMainboards() {
     this.subjectmainboards.next(this.mainboards);
   }  
 
   private observableLocalMainboards():Subject<any> {      
     return this.subjectmainboards; 
   }
   
  /**
    * @example:
    * this.observableMainboard = this.vhQueryCloudCam.observableLocalMainboards().subscribe((localMainboards:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableMainboard.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalMainboards(){   
    return new Observable((observer:any) => {    
     this.observableLocalMainboards().subscribe((mainboards) => {   
       observer.next(mainboards);
     })
     this.publishObservableEventMainboards();
    })
   }
 
   /**
    * @example: 
    * let wallet = this.vhQueryCloudCam.getlocalMainboard('5fb6780ca2148e09806c5b01');
    * @param id_mainboard 
    * @return Object => obj = {} or null
    */
   public getlocalMainboard(id_mainboard:any){
     for(let i=0; i<this.mainboards.length; i++){
       if(this.mainboards[i]._id === id_mainboard){
         return this.mainboards[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryCloudCam.getlocalMainboards();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalMainboards(){    
     return this.mainboards;
   }
   
    /**
    * @example:
    * this.vhQueryCloudCam.refreshLocalMainboards()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalMainboard(), getlocalMainboards() trong localstorage
    * @return Promise => null
    */
   public refreshLocalMainboards():any{
     return new Promise((resolve) => { 
       this.getMainboards()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryCloudCam.addMainboard({name:'camera 2', quantity:20, price:200000})
           .then((mainboard)=>{
             console.log('addMainboard', mainboard);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addMainboard(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('mainboards', data)
           .then((mainboard)=>{
             resolve(mainboard);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.updateMainboard('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateMainboard', bool);
           })
    * @param id_mainboard 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateMainboard(id_mainboard:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('mainboards', id_mainboard, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.deleteMainboard('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteMainboard', bool);
         })
    * @param id_mainboard 
    * @return Promise => bool = true or false 
    */
   public deleteMainboard(id_mainboard:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('mainboards', id_mainboard)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getMainboard('5fb67fda87c0f21d484cbdf3')
             .then((mainboard)=>{
               console.log('getMainboard', mainboard);
             })
    * @param id_mainboard 
    * @return Promise => obj ={} or null
    */
   public getMainboard(id_mainboard:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('mainboards', id_mainboard)
             .then((mainboard)=>{
               resolve(mainboard);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getMainboards()
             .then((mainboards)=>{
               console.log('getMainboards', mainboards);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getMainboards(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('mainboards')
             .then((mainboards)=>{
               this.mainboards = new Array();
               this.mainboards = mainboards;
               resolve(mainboards);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   private publishObservableEventFunctions() {
     this.subjectfunctions.next(this.functions);
   }  
 
   private observableLocalFunctions():Subject<any> {      
     return this.subjectfunctions; 
   }
   
  /**
    * @example:
    * this.observableFunction = this.vhQueryCloudCam.getObservableLocalFunctions().subscribe((localFunctions:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableFunction.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalFunctions(){   
    return new Observable((observer:any) => {    
     this.observableLocalFunctions().subscribe((functions) => {   
       observer.next(functions);
     })
     this.publishObservableEventFunctions();
    })
   }
 
   
   /**
    * @example: 
    * let wallet = this.vhQueryCloudCam.getlocalFunction('5fb6780ca2148e09806c5b01');
    * @param id_function 
    * @return Object => obj = {} or null
    */
   public getlocalFunction(id_function:any){
     for(let i=0; i<this.functions.length; i++){
       if(this.functions[i]._id === id_function){
         return this.functions[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryCloudCam.getlocalFunctions();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalFunctions(){    
     return this.functions;
   }
   
    /**
    * @example:
    * this.vhQueryCloudCam.refreshLocalFunctions()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalFunction(), getlocalFunctions() trong localstorage
    * @return Promise => null
    */
   public refreshLocalFunctions():any{
     return new Promise((resolve) => { 
       this.getFunctions()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryCloudCam.addFunction({name:'camera 2', quantity:20, price:200000})
           .then((func)=>{
             console.log('addFunction', func);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addFunction(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('functions', data)
           .then((func)=>{
             resolve(func);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.updateFunction('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateFunction', bool);
           })
    * @param id_function 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateFunction(id_function:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('functions', id_function, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.deleteFunction('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteFunction', bool);
         })
    * @param id_function 
    * @return Promise => bool = true or false 
    */
   public deleteFunction(id_function:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('functions', id_function)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getFunction('5fb67fda87c0f21d484cbdf3')
             .then((func)=>{
               console.log('getFunction', func);
             })
    * @param id_function 
    * @return Promise => obj ={} or null
    */
   public getFunction(id_function:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('functions', id_function)
             .then((func)=>{
               resolve(func);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getFunctions()
             .then((functions)=>{
               console.log('getFunctions', functions);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getFunctions(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('functions')
             .then((functions)=>{
               this.functions = new Array();
               this.functions = functions;
               resolve(functions);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   private publishObservableEventComponents() {
     this.subjectcomponents.next(this.components);
   }  
 
   private observableLocalComponents():Subject<any> {      
     return this.subjectcomponents; 
   }
   
  /**
    * @example:
    * this.observableFunction = this.vhQueryCloudCam.getObservableLocalFunctions().subscribe((localFunctions:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableFunction.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalComponents(){   
    return new Observable((observer:any) => {    
     this.observableLocalComponents().subscribe((components) => {   
       observer.next(components);
     })
     this.publishObservableEventComponents();
    })
   }
   
   /**
    * @example: 
    * let wallet = this.vhQueryCloudCam.getlocalComponent('5fb6780ca2148e09806c5b01');
    * @param id_component 
    * @return Object => obj = {} or null
    */
   public getlocalComponent(id_component:any){
     for(let i=0; i<this.components.length; i++){
       if(this.components[i]._id === id_component){
         return this.components[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryCloudCam.getlocalComponents();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalComponents(){    
     return this.components;
   }
   
    /**
    * @example:
    * this.vhQueryCloudCam.refreshLocalComponents()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalComponent(), getlocalComponents() trong localstorage
    * @return Promise => null
    */
   public refreshLocalComponents():any{
     return new Promise((resolve) => { 
       this.getComponents()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryCloudCam.addComponent({name:'camera 2', quantity:20, price:200000})
           .then((component)=>{
             console.log('addComponent', component);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addComponent(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('components', data)
           .then((component)=>{
             resolve(component);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.updateComponent('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateComponent', bool);
           })
    * @param id_component 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateComponent(id_component:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('components', id_component, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.deleteComponent('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteComponent', bool);
         })
    * @param id_component 
    * @return Promise => bool = true or false 
    */
   public deleteComponent(id_component:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('components', id_component)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getComponent('5fb67fda87c0f21d484cbdf3')
             .then((component)=>{
               console.log('getComponent', component);
             })
    * @param id_component 
    * @return Promise => obj ={} or null
    */
   public getComponent(id_component:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('components', id_component)
             .then((component)=>{
               resolve(component);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getComponents()
             .then((components)=>{
               console.log('getComponents', components);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getComponents(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('components')
             .then((components)=>{
               this.components = new Array();
               this.components = components;
               resolve(components);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   private publishObservableEventIcons() {
     this.subjecticons.next(this.icons);
   }  
 
   private observableLocalIcons():Subject<any> {      
     return this.subjecticons; 
   }
   
  /**
    * @example:
    * this.observableIcon = this.vhQueryCloudCam.getObservableLocalIcons().subscribe((localIcons:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableIcon.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalIcons(){   
    return new Observable((observer:any) => {    
     this.observableLocalIcons().subscribe((icons) => {   
       observer.next(icons);
     })
     this.publishObservableEventIcons();
    })
   }
 
    /**
    * @example: 
    * let wallet = this.vhQueryCloudCam.getlocalIcon('5fb6780ca2148e09806c5b01');
    * @param id_icon 
    * @return Object => obj = {} or null
    */
   public getlocalIcon(id_icon:any){
     for(let i=0; i<this.icons.length; i++){
       if(this.icons[i]._id === id_icon){
         return this.icons[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryCloudCam.getlocalIcons();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalIcons(){    
     return this.icons;
   }
   
    /**
    * @example:
    * this.vhQueryCloudCam.refreshLocalIcons()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalIcon(), getlocalIcons() trong localstorage
    * @return Promise => null
    */
   public refreshLocalIcons():any{
     return new Promise((resolve) => { 
       this.getIcons()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryCloudCam.addIcon({name:'camera 2', quantity:20, price:200000})
           .then((icon)=>{
             console.log('addIcon', icon);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addIcon(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('icons', data)
           .then((icon)=>{
             resolve(icon);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.updateIcon('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateIcon', bool);
           })
    * @param id_icon 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateIcon(id_icon:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('icons', id_icon, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.deleteIcon('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteIcon', bool);
         })
    * @param id_icon 
    * @return Promise => bool = true or false 
    */
   public deleteIcon(id_icon:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('icons', id_icon)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getIcon('5fb67fda87c0f21d484cbdf3')
             .then((icon)=>{
               console.log('getIcon', icon);
             })
    * @param id_icon 
    * @return Promise => obj ={} or null
    */
   public getIcon(id_icon:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('icons', id_icon)
             .then((icon)=>{
               resolve(icon);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getIcons()
             .then((icons)=>{
               console.log('getIcons', icons);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getIcons(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('icons')
             .then((icons)=>{
               this.icons = new Array();
               this.icons = icons;
               resolve(icons);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
    
   private publishObservableEventAppSettingNameStations() {
     this.subjectappsettingstations.next();
   }  
 
   private observableLocalAppSettingNameStations():Subject<any> {      
     return this.subjectappsettingstations; 
   }
   
    /**
    * @example:
    * this.observableAppSetting = this.vhQueryCloudCam.getObservableLocalAppSettingNameStations().subscribe((localAppSettings:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableAppSetting.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalAppSettingNameStations(){   
    return new Observable((observer:any) => {    
     this.observableLocalAppSettingNameStations().subscribe(() => {   
       let list = new Array();
       for(let i =0; i<this.appsettingstations.length; i++){
         list.push(this.appsettingstations[i].appsetting_name);
       }     
       observer.next(list);
     })
     this.publishObservableEventAppSettingNameStations();
    })
   }
   
   /**
   *@example:
     this.vhQueryCloudCam.getLocalAppSettingNameStations()
         .then((list)=>{
             console.log(list);
           })  
   * @return object => list of appsetting_names
   */
  public getLocalAppSettingNameStations(){  
   let list = new Array();
   for(let i =0; i<this.appsettingstations.length; i++){
     list.push(this.appsettingstations[i].appsetting_name);
   }
   return list;     
 }
 
 /**
  * @example:
   let appsetting = this.vhQueryCloudCam.getLocalAppSettingNameStation('info_header_footer_bill');
   console.log(appsetting);
  * @param appsetting_name   
  * @return object => {title:'title',name:'name', quantity: 10}
  */
 public getLocalAppSettingNameStation(appsetting_name:any){  
   let obj:any = {};   
   for(let i =0; i<this.appsettingstations.length; i++){
     if(this.appsettingstations[i].appsetting_name === appsetting_name){
       obj = {...this.appsettingstations[i]};
       delete obj._id;
       delete obj.appsetting_name;   
       break;   
     }        
   }
   return obj;
 }
 
  /**
    * @example: 
    * let appsetting = this.vhQueryCloudCam.getLocalAppSettingStation('5fb6780ca2148e09806c5b01');
    * @param id_appsetting 
    * @return Object => obj = {} or null
    */
   private getLocalAppSettingStation(id_appsetting:any){
     for(let i=0; i<this.appsettingstations.length; i++){
       if(this.appsettingstations[i]._id === id_appsetting){
         return this.appsettingstations[i];      
       }
     } 
     return null;        
   }
 
     /**
  * Hàm này refresh giá trị mới nhất cho hàm getLocalAppSettingNameStations(), getLocalAppSettingNameStation() trong localstorage
  * @return Promise => null
  */
 public refreshLocalAppSettingNameStations():any{
   return new Promise((resolve, reject) => { 
     // this.getAppSettingStations().then(()=>{resolve(null)})   
     resolve(null)   
   })
 }
 
 /**
  * @example
  * this.vhQueryCloudCam.getAppSettingStations()
           .then((settings)=>{
             console.log('getAppSettings', settings);
           })
   * @return Promise => array(object) = [{},{},..]
   */
 private getAppSettingStations():any{
   return new Promise((resolve, reject) => {      
     this.vhMGDB_database.getDocsByFields('appsettingstations',{uuid: {$eq: this.hwinfo.uuid}},{},{},0)
           .then((appsettingstations:any)=>{
             if(appsettingstations.length>0){      
               this.appsettingstations = appsettingstations;  
             }
             resolve(null);
           },(error:any)=>{
             reject(error);
           })          
   })  
 }
 
 /**
  * @example:
   this.vhQueryCloudCam.updateAppSettingNameStation('info_header_footer_bill',{title:'title',name:'name'})
       .then((bool:any)=>{
         console.log(bool);
       })       
  * @param appsetting_name 
  * @param value 
  * @format value = {title:'title',name:'name'} 
  * @return Promise Boolean => bool = true or false 
  */ 
 public updateAppSettingNameStation(appsetting_name:any, value:any) {
   return new Promise((resolve,reject) => {    
     this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid: {$eq: this.hwinfo.uuid}},{},{},0)
         .then((appsettingstations:any)=>{
              if(appsettingstations.length>0){               
               this.vhMGDB_database.updateDoc('appsettingstations', appsettingstations[0]._id, value)
                   .then((bool:any)=>{
                     resolve(bool);                   
                   }, error=>{
                     reject(error)
                   })     
              }else{
                let obj:any = {...value};
                obj.appsetting_name = appsetting_name;               
                obj.uuid = this.hwinfo.uuid;
                this.vhMGDB_database.addDoc('appsettingstations',obj)
                     .then(()=>{
                       resolve(true);
                     }, error=>{
                       reject(error)
                     }) 
              }
         })              
   })  
 }
  
 
 /**
  * @example
  * this.vhQueryCloudCam.deleteAppSettingNameStation('info_header_footer_bill')
       .then((bool:any)=>{
         console.log(bool); 
       })
  * @param appsetting_name 
  * @return Promise Boolean => bool = true or false 
  */
 public deleteAppSettingNameStation(appsetting_name:any) {
   return new Promise((resolve, reject) => {
     this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid:{$eq:this.hwinfo.uuid}},{},{},0)
         .then((appsettingstations:any)=>{
             if(appsettingstations.length>0){               
               this.vhMGDB_database.deleteDoc('appsettingstations', appsettingstations[0]._id)
                   .then((bool:any)=>{            
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   })              
             }else resolve(false);
           })            
   })     
 }
 
   
    /**
    * @example: 
    * let wallet = this.vhQueryCloudCam.getlocalScript('5fb6780ca2148e09806c5b01');
    * @param id_script 
    * @return Object => obj = {} or null
    */
   public getlocalScript(id_script:any){
     for(let i=0; i<this.scripts.length; i++){
       if(this.scripts[i]._id === id_script){
         return this.scripts[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryCloudCam.getlocalScripts();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalScripts(){    
     return this.scripts;
   }
   
    /**
    * @example:
    * this.vhQueryCloudCam.refreshLocalScripts()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalScript(), getlocalScripts() trong localstorage
    * @return Promise => null
    */
   public refreshLocalScripts():any{
     return new Promise((resolve) => { 
       this.getScripts()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryCloudCam.addScript({name:'camera 2', quantity:20, price:200000})
           .then((script)=>{
             console.log('addScript', script);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addScript(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('scripts', data)
           .then((script)=>{
             resolve(script);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.updateScript('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateScript', bool);
           })
    * @param id_script 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateScript(id_script:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('scripts', id_script, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.deleteScript('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteScript', bool);
         })
    * @param id_script 
    * @return Promise => bool = true or false 
    */
   public deleteScript(id_script:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('scripts', id_script)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getScript('5fb67fda87c0f21d484cbdf3')
             .then((script)=>{
               console.log('getScript', script);
             })
    * @param id_script 
    * @return Promise => obj ={} or null
    */
   public getScript(id_script:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('scripts', id_script)
             .then((script)=>{
               resolve(script);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getScripts()
             .then((scripts)=>{
               console.log('getScripts', scripts);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getScripts(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('scripts')
             .then((scripts)=>{
               this.scripts = new Array();
               this.scripts = scripts;
               resolve(scripts);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
    /**
    * @example: 
    * let wallet = this.vhQueryCloudCam.getlocalScript_detail('5fb6780ca2148e09806c5b01');
    * @param id_script_detail 
    * @return Object => obj = {} or null
    */
   public getlocalScript_detail(id_script_detail:any){
     for(let i=0; i<this.script_details.length; i++){
       if(this.script_details[i]._id === id_script_detail){
         return this.script_details[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryCloudCam.getlocalScript_details();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalScript_details(){    
     return this.script_details;
   }
   
    /**
    * @example:
    * this.vhQueryCloudCam.refreshLocalScript_details()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalScript_detail(), getlocalScript_details() trong localstorage
    * @return Promise => null
    */
   public refreshLocalScript_details():any{
     return new Promise((resolve) => { 
       this.getScript_details()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryCloudCam.addScript_detail({name:'camera 2', quantity:20, price:200000})
           .then((script_detail)=>{
             console.log('addScript_detail', script_detail);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addScript_detail(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('script_details', data)
           .then((script_detail)=>{
             resolve(script_detail);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.updateScript_detail('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateScript_detail', bool);
           })
    * @param id_script_detail 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateScript_detail(id_script_detail:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('script_details', id_script_detail, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryCloudCam.deleteScript_detail('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteScript_detail', bool);
         })
    * @param id_script_detail 
    * @return Promise => bool = true or false 
    */
   public deleteScript_detail(id_script_detail:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('script_details', id_script_detail)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getScript_detail('5fb67fda87c0f21d484cbdf3')
             .then((script_detail)=>{
               console.log('getScript_detail', script_detail);
             })
    * @param id_script_detail 
    * @return Promise => obj ={} or null
    */
   public getScript_detail(id_script_detail:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('script_details', id_script_detail)
             .then((script_detail)=>{
               resolve(script_detail);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCloudCam.getScript_details()
             .then((script_details)=>{
               console.log('getScript_details', script_details);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getScript_details(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('script_details')
             .then((script_details)=>{
               this.script_details = new Array();
               this.script_details = script_details;
               resolve(script_details);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
  
 
 
 }
 
 @Injectable()
 export class VhQueryClouds{  
   private designs: any = new Array();
   private cameras: any = new Array();
   private cloudcams: any = new Array();
   private rooms: any = new Array();
   private mainboards: any = new Array();
   private functions: any = new Array();
   private components: any = new Array();
   private icons: any = new Array();
   private appsettingstations: any = new Array();  
   private scripts: any = new Array();
   private script_details: any = new Array();
   private logs: any = new Array();
   private hwinfo: any = {};
 
   private subjectcameras = new Subject<any>();
   private subjectappsettingstations = new Subject<any>();
   private subjectrooms = new Subject<any>();
   private subjectmainboards = new Subject<any>();
   private subjectfunctions = new Subject<any>();
   private subjecticons = new Subject<any>();
   private subjectcomponents = new Subject<any>();   
 
   constructor(
     
     private vhMGDB_auth: VhMGDB_auth, 
     private vhMGDB_socketMongoDB: VhMGDB_socketMongoDB, 
     private vhMGDB_clouds: VhMGDB_clouds, 
     private vhMGDB_database: VhMGDB_database, 
     
     
     private vhQuery:VhQuery, private vhAuth: VhAuth, private vhAlgorithm:VhAlgorithm) {
     Device.getId().then((info:any)=>{
       let local_hwinfo = this.vhAuth.localStorageGET('hwinfo');
       if((local_hwinfo != null)&&(local_hwinfo != undefined)){
         this.hwinfo = local_hwinfo;       
       }else{
        this.hwinfo = {uuid: info.identifier};     
         this.vhAuth.localStorageSET('hwinfo',this.hwinfo);        
       }           
     });    
   } 
 
   /**
  * @example:
   this.vhQueryClouds.syncCollections().then((bool:any)=>{
       if(bool){
         do something...
       }
   })
   * @returns Promise bool = true or false
   */
   syncCollections(){    
     return new Promise((resolve, reject)=>{      
       this.initSyncCollections();
       this.callbackCollectionInsert().subscribe();
       this.callbackCollectionUpdate().subscribe();
       this.callbackCollectionDelete().subscribe();  
       this.getUtokenByUser();     
       setTimeout(() => {
         resolve(true);
       }, 3000);
     })    
   }
 
   private initSyncCollections(){      
     let colname_array = new Array(); colname_array[0] = 'rooms'; colname_array[1] = 'mainboards'; 
     colname_array[2] = 'components'; colname_array[3] = 'icons'; colname_array[4] = 'functions'; colname_array[5] = 'vhemployees'; colname_array[6] = 'appsettingstations';     
     return this.vhMGDB_socketMongoDB.initSyncCollections(colname_array,{},"");  
   }
 
       /**
    * @example:
    * this.vhQueryClouds.closeSyncCollections();
    * disconnect collections synchronization in the APP
    * @returns void
    */
   public closeSyncCollections(){
     // this.callbackcollections.unsubscribe();
     this.vhMGDB_socketMongoDB.closeSyncCollections();
   }
   /**
    * vhQueryClouds
    * @returns 
    */
   private callbackCollectionInsert(){    
     return new Observable((observer:any) => {    
       this.vhMGDB_socketMongoDB.callbackCollectionInsert().subscribe((data:any)=>{  
         if(data.colname === 'vhemployees') data.colname = 'employees';
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
 
         if(data.colname === 'cameras'){
           if(!this.getlocalCamera(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.cameras.push(obj); 
             this.publishObservableEventCameras();    
             observer.next(data.colname);       
           }                  
         }else if(data.colname === 'rooms'){
           if(!this.getlocalRoom(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.rooms.push(obj); 
             this.publishObservableEventRooms();    
             observer.next(data.colname);       
           }            
         }else if(data.colname === 'mainboards'){
           if(!this.getlocalMainboard(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.mainboards.push(obj); 
             this.publishObservableEventMainboards();    
             observer.next(data.colname);       
           }   
         }else if(data.colname === 'components'){
           if(!this.getlocalComponent(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.components.push(obj); 
             this.publishObservableEventComponents();    
             observer.next(data.colname);       
           }             
         }else if(data.colname === 'icons'){
           if(!this.getlocalIcon(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.icons.push(obj); 
             this.publishObservableEventIcons();    
             observer.next(data.colname);       
           } 
         }else if(data.colname === 'functions'){
           if(!this.getlocalFunction(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.functions.push(obj); 
             this.publishObservableEventFunctions();    
             observer.next(data.colname);       
           } 
         }else if(data.colname === 'employees'){          
           let obj = {...data.data}; obj._id = data._id;
           this.vhAuth.insertlocalEmployeeFromSyncCollection(obj);         
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);                 
         }else if(data.colname === 'appsettingstations'){         
           if(!this.getLocalAppSettingStation(data._id)){         
             if(data.data.uuid === this.hwinfo.uuid){   
               let obj = {...data.data}; obj._id = data._id;
               delete obj.uuid;
               this.appsettingstations.push(obj);   
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);               
             }            
           }                               
         }
         //console.log('inserted', data.colname);
       })
     })
   }
 
   /**
    * vhQueryClouds
    * @returns 
    */
   private callbackCollectionUpdate(){    
     return new Observable((observer:any) => {          
       this.vhMGDB_socketMongoDB.callbackCollectionUpdate().subscribe((data:any)=>{ 
         if(data.colname === 'vhemployees') data.colname = 'employees';
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
         if(data.colname === 'cameras'){
           for(let i=0; i<this.cameras.length; i++){
             if(this.cameras[i]._id === data._id){
               this.cameras[i] = {...this.cameras[i], ...data.data};     
               this.publishObservableEventCameras();  
               observer.next(data.colname);         
               break;
             }
           }  
         }else if(data.colname === 'rooms'){
           for(let i=0; i<this.rooms.length; i++){
             if(this.rooms[i]._id === data._id){
               this.rooms[i] = {...this.rooms[i], ...data.data};     
               this.publishObservableEventRooms();  
               observer.next(data.colname);         
               break;
             }
           }       
         }else if(data.colname === 'mainboards'){
           for(let i=0; i<this.mainboards.length; i++){
             if(this.mainboards[i]._id === data._id){
               this.mainboards[i] = {...this.mainboards[i], ...data.data};     
               this.publishObservableEventMainboards();  
               observer.next(data.colname);         
               break;
             }
           } 
         }else if(data.colname === 'components'){
           for(let i=0; i<this.components.length; i++){
             if(this.rooms[i]._id === data._id){
               this.rooms[i] = {...this.components[i], ...data.data};     
               this.publishObservableEventComponents();  
               observer.next(data.colname);         
               break;
             }
           }   
         }else if(data.colname === 'icons'){
           for(let i=0; i<this.icons.length; i++){
             if(this.icons[i]._id === data._id){
               this.icons[i] = {...this.icons[i], ...data.data};     
               this.publishObservableEventIcons();  
               observer.next(data.colname);         
               break;
             }
           }           
         }else if(data.colname === 'functions'){
           for(let i=0; i<this.icons.functions; i++){
             if(this.functions[i]._id === data._id){
               this.functions[i] = {...this.functions[i], ...data.data};     
               this.publishObservableEventFunctions();  
               observer.next(data.colname);         
               break;
             }
           }      
         }else if(data.colname === 'employees'){          
           this.vhAuth.updateLocalEmployeeFromSyncCollection(data._id, data.data);    
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);
         }else if(data.colname === 'appsettingstations'){
           for(let i=0; i<this.appsettingstations.length; i++){
             if(this.appsettingstations[i]._id === data._id){
               this.appsettingstations[i] = {...this.appsettingstations[i], ...data.data};   
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);               
               break;
             }
           }    
         }    
         //console.log('this.products', this.products);
         //console.log('updated', data.colname);
       })
     })
   }
  
   /**
    * vhQueryClouds
    * @returns 
    */
   private callbackCollectionDelete(){
     return new Observable((observer:any) => {    
       this.vhMGDB_socketMongoDB.callbackCollectionDelete().subscribe((data:any)=>{       
         if(data.colname === 'vhemployees') data.colname = 'employees';    
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
         if(data.colname === 'cameras'){
           for(let i=0; i<this.cameras.length; i++){
             if(this.cameras[i]._id === data._id){
               this.cameras.splice(i, 1);       
               this.publishObservableEventCameras();  
               observer.next(data.colname);                        
               break;
             }
           }   
         }else if(data.colname === 'rooms'){
           for(let i=0; i<this.rooms.length; i++){
             if(this.rooms[i]._id === data._id){
               this.rooms.splice(i, 1);       
               this.publishObservableEventRooms();  
               observer.next(data.colname);                        
               break;
             }
           }          
         }else if(data.colname === 'mainboards'){
           for(let i=0; i<this.mainboards.length; i++){
             if(this.mainboards[i]._id === data._id){
               this.mainboards.splice(i, 1);       
               this.publishObservableEventMainboards();  
               observer.next(data.colname);                        
               break;
             }
           }    
         }else if(data.colname === 'components'){
           for(let i=0; i<this.components.length; i++){
             if(this.components[i]._id === data._id){
               this.components.splice(i, 1);       
               this.publishObservableEventComponents();  
               observer.next(data.colname);                        
               break;
             }
           }   
         }else if(data.colname === 'icons'){
           for(let i=0; i<this.icons.length; i++){
             if(this.icons[i]._id === data._id){
               this.icons.splice(i, 1);       
               this.publishObservableEventIcons();  
               observer.next(data.colname);                        
               break;
             }
           }        
         }else if(data.colname === 'functions'){
           for(let i=0; i<this.functions.length; i++){
             if(this.functions[i]._id === data._id){
               this.functions.splice(i, 1);       
               this.publishObservableEventFunctions();  
               observer.next(data.colname);                        
               break;
             }
           }        
         }else if(data.colname === 'employees'){
           this.vhAuth.deleteLocalEmployeeFromSyncCollection(data._id);    
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);    
         }else if(data.colname === 'appsettingstations'){
           for(let i=0; i<this.appsettingstations.length; i++){
             if(this.appsettingstations[i]._id === data._id){
               this.appsettingstations.splice(i, 1); 
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);                
               break;
             }
           }   
         }
         console.log('deleted', data.colname);           
       })
     })
   }
   /**
    * vhQueryClouds
    * @returns 
    */
   public startLocalStorage(){
     return new Promise<any>((resolve) => {
       let promise = new Array();
       promise[0] = this.vhAuth.refreshLocalMyPermission();  
       promise[1] = this.refreshLocalCloudCams();            
       this.vhQuery.asyncPromiseAll(promise).then(()=>{resolve(null)});               
     })
   }
  //vhQueryClouds
   public createPaymentVnpay(amount:number, bankCode:string, data:any, backHref:string, fee:object, fee_details:object):any {   
       const orderType = "billpayment";  
       const orderDescription = "thanh toan";         
       const language = "vn";    
       let payment = {
         projectName: this.vhMGDB_auth.getProjectName(),
         sid: this.vhMGDB_auth.getDatabase(),
         data: data
       }
       this.vhMGDB_clouds.createPaymentVnpay(amount, bankCode, orderType, orderDescription, language, payment, backHref, fee, fee_details)
           .then((response:any)=>{           
             window.location = response.data;            
           },(error:any)=>{
             console.log('error', error);
           })   
   }
 
 /**
  * @example:
    * this.vhQueryClouds.getDiscountFromCode('VIETHAS')
           .then((discount)=>{
             console.log('getDiscountFromCode', discount);
           },(error:any)=>{
             console.log('error', error);
           })
  * @returns 
  */
   public getDiscountFromCode(code:string):any {    
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_clouds.getDiscountFromCode(code)
           .then((discountcodes:any)=>{             
             if(discountcodes.size > 0){
               resolve(discountcodes.docs[0].data().discount);              
             }else{
               resolve(0);       
             }             
           },(error:any)=>{
             console.error(error);
             reject(error);
           })     
     })
   }
 
 /**
  * @example:
    * this.vhQueryClouds.getPriceList_Records()
           .then((pricelist)=>{
             console.log('getPriceList_Records', pricelist);
           },(error:any)=>{
             console.log('error', error);
           })
  * @returns 
  */
   public getPriceList_Records():any {    
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_clouds.getPriceList_Records()
           .then((pricelist_storages:any)=>{    
             let pricelist = new Array();     
             if(pricelist_storages.size > 0){
               pricelist_storages.forEach((element:any) => {
                 pricelist.push(element.data());
                 pricelist[pricelist.length-1]._id = element.id;
               });
             }   
             pricelist = this.vhAlgorithm.sortNumberbyASC(pricelist, 'month');
             resolve(pricelist)        
           },(error:any)=>{
             console.error(error);
             reject(error);
           })     
     })
   }
 
 /**
  * @example:
    * this.vhQueryClouds.getPriceList_Detectors()
           .then((pricelist)=>{
             console.log('getPriceList_Detectors', pricelist);
           },(error:any)=>{
             console.log('error', error);
           })
  * @returns 
  */
   public getPriceList_Detectors():any {    
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_clouds.getPriceList_Detectors()
           .then((pricelist_detectors:any)=>{            
             let pricelist = new Array();     
             if(pricelist_detectors.size > 0){
               pricelist_detectors.forEach((element:any) => {
                 pricelist.push(element.data());
                 pricelist[pricelist.length-1]._id = element.id;
               });
             }   
             pricelist = this.vhAlgorithm.sortNumberbyASC(pricelist, 'month');
             resolve(pricelist)     
           },(error:any)=>{
             console.error(error);
             reject(error);
           })   
     })
   }
   
   /**
  * @example:
    * this.vhQueryClouds.getPriceList_rLPRs()
           .then((pricelist_detectors)=>{
             console.log('getPriceList_rLPRs', pricelist_detectors);
           },(error:any)=>{
             console.log('error', error);
           })
  * @returns 
  */
   public getPriceList_rLPRs():any {    
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_clouds.getPriceList_rLPRs()
           .then((pricelist_rLPRs:any)=>{            
             let pricelist = new Array();     
             if(pricelist_rLPRs.size > 0){
               pricelist_rLPRs.forEach((element:any) => {
                 pricelist.push(element.data());
                 pricelist[pricelist.length-1]._id = element.id;
               });
             }   
             pricelist = this.vhAlgorithm.sortNumberbyASC(pricelist, 'month');
             resolve(pricelist)     
           },(error:any)=>{
             console.error(error);
             reject(error);
           })   
     })
   }
 
    /**
  * @example:
    * this.vhQueryClouds.getPriceList_cLPRs()
           .then((getPriceList_cLPRs)=>{
             console.log('getPriceList_cLPRs', getPriceList_cLPRs);
           },(error:any)=>{
             console.log('error', error);
           })
  * @returns 
  */
   public getPriceList_cLPRs():any {    
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_clouds.getPriceList_cLPRs()
           .then((pricelist_cLPRs:any)=>{            
             let pricelist = new Array();     
             if(pricelist_cLPRs.size > 0){
               pricelist_cLPRs.forEach((element:any) => {
                 pricelist.push(element.data());
                 pricelist[pricelist.length-1]._id = element.id;
               });
             }   
             pricelist = this.vhAlgorithm.sortNumberbyASC(pricelist, 'month');
             resolve(pricelist)     
           },(error:any)=>{
             console.error(error);
             reject(error);
           })   
     })
   }
   
   private publishObservableEventCameras() {
     this.subjectcameras.next(this.cameras);
   }  
 
   private observableLocalCameras():Subject<any> {      
     return this.subjectcameras; 
   }
   
  /**
    * @example:
    * this.observableCamera = this.vhQueryClouds.getObservableLocalCameras().subscribe((localCameras:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableCamera.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalCameras(){   
    return new Observable((observer:any) => {    
     this.observableLocalCameras().subscribe((cameras) => {   
       observer.next(cameras);
     })
     this.publishObservableEventCameras();
    })
   }
         
 
   /**
    * @example: 
    * let wallet = this.vhQueryClouds.getlocalCamera('5fb6780ca2148e09806c5b01');
    * @param id_camera 
    * @return Object => obj = {} or null
    */
   public getlocalCamera(id_camera:any){
     for(let i=0; i<this.cameras.length; i++){
       if(this.cameras[i]._id === id_camera){
         return this.cameras[i];
         break;
       }
     } 
     return null; 
   }
      
 
   /**
    * @example: 
    * let wallets = this.vhQueryClouds.getlocalCameras();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalCameras(){    
     return this.cameras;
   }
   
    /**
    * @example:
    * this.vhQueryClouds.refreshLocalCameras()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalCamera(), getlocalCameras() trong localstorage
    * @return Promise => null
    */
   public refreshLocalCameras():any{
     return new Promise((resolve) => { 
       this.getCameras()
           .then(()=>{resolve(null)})       
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.createLicenseCam()
         .then((licensecam)=>{
           console.log('licensecam', licensecam);
         })
   * @return Promise => licensecam
   */
   public createLicenseCam(){  
     return new Promise((resolve, reject) => {
       // this.vhMGDB_clouds.createLicenseCam({})
       //     .then((licensecam:any)=>{            
       //       resolve(licensecam)        
       //     },(error:any)=>{
       //       console.error(error);
       //       reject(error);
       //     })            
     })
   }
  
   /**
    * @example:
    * this.vhQueryClouds.addCamera({name:'camera 2', url:'rtsp://admin:admin@115.78.100.57:1020/av_stream/ch0', licensecam:'pTqOFsJEndPrg7AImFxV'})
           .then((camera)=>{
             console.log('addCamera', camera);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    * Trường hợp không thành công:
    * code = 0 : licensecam không đúng
    * code = 1 : licensecam đã và đang được sử dụng
    */
   public addCamera(data:any){
     //let _data = {...data};
     //if(_data.licensecam === undefined) _data.licensecam = _data.licensekey;
     //delete _data.licensekey;
     return new Promise((resolve, reject) => {
       // this.vhMGDB_clouds.checkLicenseAddCam(data)
       //     .then((result:any)=>{            
       //       if((result.code === 4)||(result.code === 5)){
       //         this.vhMGDB_database.addDoc('cameras', {...data, camliveURL:result.camliveURL, camplaybackURL:result.camplaybackURL})
       //             .then((camera)=>{
       //               resolve(camera);
       //             },(error:any)=>{
       //               console.error(error);
       //               reject({code:0});
       //             })    
       //       }else reject(result);            
       //     },(error:any)=>{
       //       console.error(error);
       //       reject({code:0});
       //     })            
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.updateCamera('5fb6780ca2148e09806c5b01', {name:camera 3})
           .then((bool:any)=>{
             console.log('updateCamera', bool);
           })
    * @param id_camera 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateCamera(id_camera:string, data:any){    
     return new Promise((resolve, reject) => {
       // this.vhMGDB_database.getDoc('cameras', id_camera)
       //     .then((camera:any)=>{            
       //       if(camera){
       //         let _data = {...data};
       //         _data.licensecam = camera.licensecam;
       //         this.vhMGDB_clouds.checkLicenseUpdateCam(_data)
       //             .then((result:any)=>{                                
       //               if(result.code === 3){        
       //                 this.vhMGDB_database.updateDoc('cameras', id_camera, _data)
       //                     .then((bool:any)=>{            
       //                       resolve(bool);
       //                     }, error=>{
       //                       reject(error)
       //                     })   
       //               }                   
       //             },(error:any)=>{
       //               reject(error);
       //             })      
       //       }
       //     }, error=>{
       //       reject(error)
       //     })               
     }) 
   }
 
   /**
    * @example:
    * this.vhQueryClouds.deleteCamera('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteCamera', bool);
         })
    * @param id_camera 
    * @return Promise => bool = true or false 
    */
   public deleteCamera(id_camera:string){
     return new Promise((resolve, reject) => {
       // this.vhMGDB_database.getDoc('cameras', id_camera)
       //     .then((camera:any)=>{            
       //      if(camera){            
       //       this.vhMGDB_clouds.checkLicenseDeleteCam(camera.licensecam)
       //           .then((result:any)=>{                 
       //               this.vhMGDB_database.deleteDoc('cameras', id_camera)
       //                   .then((bool:any)=>{            
       //                     resolve(bool);
       //                   }, error=>{
       //                     reject(error)
       //                   })                     
       //           },(error:any)=>{
       //             reject(error);
       //           })        
       //      }
       //     }, error=>{
       //       reject(error)
       //     })                   
               
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getCamera('5fb67fda87c0f21d484cbdf3')
             .then((camera)=>{
               console.log('getCamera', camera);
             })
    * @param id_camera 
    * @return Promise => obj ={} or null
    */
   public getCamera(id_camera:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('cameras', id_camera)
             .then((camera)=>{
               resolve(camera);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getCameras()
             .then((cameras)=>{
               console.log('getCameras', cameras);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getCameras(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('cameras')
             .then((cameras)=>{
               this.cameras = new Array();
               this.cameras = cameras;
               resolve(cameras);
             },(error:any)=>{
               reject(error);
             })          
     })
   }  
 
   /**
    * @example: 
    * let cloudcam = this.vhQueryClouds.getlocalCloudCam('5fb6780ca2148e09806c5b01');
    * @param licensecam 
    * @return Object => obj = {} or null
    */
    public getlocalCloudCam(licensecam:any){
     for(let i=0; i<this.cloudcams.length; i++){
       if(this.cloudcams[i].licensecam === licensecam){
         return this.cloudcams[i];        
       }
     } 
     return null; 
   }
      
 
   /**
    * @example: 
    * let cloudcams = this.vhQueryClouds.getlocalCloudCams();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalCloudCams(){    
     return this.cloudcams;
   }
   
    /**
    * @example:
    * this.vhQueryClouds.refreshLocalCloudCams()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalCloudCam(), getlocalCloudCams() trong localstorage
    * @return Promise => null
    */
   public refreshLocalCloudCams():any{
     return new Promise((resolve) => { 
       this.getCloudCamsbyUser()
           .then(()=>{resolve(null)})       
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.changeCloudCamEnableCLPRbyUser('5fb6780ca2148e09806c5b01', false,'fgsdge5etw45tw34w3w34t3)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableCLPRbyUser', bool);
           })
    * @param licensecam 
    * @param cLPR_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableCLPRbyUser(licensecam:string, cLPR_enable:boolean, eutoken:string){    
       return new Promise((resolve) => {
         this.vhMGDB_clouds.changeCloudCamEnableCLPRbyUser(licensecam, cLPR_enable, eutoken)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })           
     }
 
    /**
    * @example:
    * this.vhQueryClouds.changeCloudCamEnableRLPRbyUser('5fb6780ca2148e09806c5b01', false,'fgsdge5etw45tw34w3w34t3)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableRLPRbyUser', bool);
           })
    * @param licensecam 
    * @param rLPR_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableRLPRbyUser(licensecam:string, rLPR_enable:boolean, eutoken:string){    
       return new Promise((resolve) => {
         this.vhMGDB_clouds.changeCloudCamEnableRLPRbyUser(licensecam, rLPR_enable, eutoken)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })     
     }
 
   /**
    * @example:
    * this.vhQueryClouds.changeCloudCamEnableDetectorByUser('5fb6780ca2148e09806c5b01', false,'fgsdge5etw45tw34w3w34t3)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableDetectorByUser', bool);
           })
    * @param licensecam 
    * @param detector_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableDetectorByUser(licensecam:string, detector_enable:boolean, eutoken:string){   
       return new Promise((resolve) => {
         this.vhMGDB_clouds.changeCloudCamEnableDetectorByUser(licensecam, detector_enable, eutoken)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })     
     }
 
   /**
    * @example:
    * this.vhQueryClouds.changeCloudCamEnableRecordByUser('5fb6780ca2148e09806c5b01', false,'fgsdge5etw45tw34w3w34t3)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableRecordByUser', bool);
           })
    * @param licensecam 
    * @param record_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableRecordByUser(licensecam:string, record_enable:boolean, eutoken:string){     
       return new Promise((resolve) => {
         this.vhMGDB_clouds.changeCloudCamEnableRecordByUser(licensecam, record_enable, eutoken)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })                 
     }
 
     /**
    * @example:
    * this.vhQueryClouds.changeCloudCamEnableActiveByUser('5fb6780ca2148e09806c5b01', false,'fgsdge5etw45tw34w3w34t3)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableActiveByUser', bool);
           })
    * @param licensecam 
    * @param active 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableActiveByUser(licensecam:string, active:boolean, eutoken:string){     
       return new Promise((resolve) => {
         this.vhMGDB_clouds.changeCloudCamEnableActiveByUser(licensecam, active, eutoken)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })                 
     }
 
   /**
    * @example:
    * this.vhQueryClouds.changeCloudCamURLbyUser('5fb6780ca2148e09806c5b01', 'rtsp://freja.hiof.no:1935/rtplive/definst/hessdalen03.stream','udp', 'fgsdge5etw45tw34w3w34t3)
           .then((bool:any)=>{
             console.log('changeCloudCamURLbyUser', bool);
           })
    * @param licensecam 
    * @param url 
    * @return Promise => bool = true or false 
    */
   public changeCloudCamURLbyUser(licensecam:string, url:string, eutoken:string){  
     return new Promise((resolve) => {
       this.vhMGDB_clouds.changeCloudCamURLbyUser(licensecam, url, eutoken)
             .then((cloudcam:any)=>{
               if(cloudcam.vcode === 0){                  
                 resolve(true);                            
               }else{
                 //console.log(cloudcam.message);
                 resolve(false);                    
               }                    
             })          
     })    
   }
 
 /**
  * @example:
  * this.vhQueryClouds.addCloudCamByUser('rtsp://freja.hiof.no:1935/rtplive/definst/hessdalen03.stream', 'udp', {name:camera 3},'fgsdge5etw45tw34w3w34t3')
         .then((cloudcam:any)=>{
           console.log('addCloudCamByUser', cloudcam);
         })
   * @param url       
   * @param data 
   * @param eutoken
   * @return Promise => {} or null 
   */
 public addCloudCamByUser(url:string, data:object, eutoken:string){          
   return new Promise((resolve) => {
     this.vhMGDB_clouds.addCloudCamByUser(url, data, eutoken)
           .then((cloudcam:any)=>{
             if(cloudcam.vcode === 0){                  
               resolve(cloudcam.data);                            
             }else{
               //console.log(cloudcam.message);
               resolve(null);                    
             }
                 
           })          
   })        
 }
 
   /**
    * @example:
    * this.vhQueryClouds.updateCloudCamDataByUser('5fb6780ca2148e09806c5b01', {name:'camera 3'},'fgsdge5etw45tw34w3w34t3)
           .then((bool:any)=>{
             console.log('updateCloudCamDataByUser', bool);
           })
    * @param licensecam 
    * @param data 
    * @return Promise => bool = true or false 
    */
     public updateCloudCamDataByUser(licensecam:string, data:object, eutoken:string){       
         return new Promise((resolve) => {
           this.vhMGDB_clouds.updateCloudCamDataByUser(licensecam, data, eutoken)
                 .then((cloudcam:any)=>{                  
                   if(cloudcam.vcode === 0){                                                
                     resolve(true);                            
                   }else{
                     //console.log(cloudcam.message);
                     resolve(false);                    
                   }                      
                 })          
         })                
     }
 
    /**
    * @example:
    * this.vhQueryClouds.createEUtokenByUser()
           .then((bool:any)=>{
             console.log('createEUtokenByUser', bool);
           })
 
    * @return String => eutoken = 'fgsdge5etw45tw34w3w34t3'
    */
     public createEUtokenByUser(){
       return new Promise((resolve) => {
         this.vhMGDB_clouds.createEUtokenByUser()
               .then((token)=>{
                 if(token.vcode === 0){                  
                   resolve(token.eutoken);                            
                 }else{
                   console.log(token.message);
                   resolve(false);                    
                 }
                     
               })          
       })
     }
 
     /**
    * @example:
    * this.vhQueryClouds.getUtokenByUser()
           .then((eutoken)=>{
             console.log('getUtokenByUser', eutoken);
           })
 
    * @return String => eutoken = 'fgsdge5etw45tw34w3w34t3'
    */
     public getUtokenByUser(){
       return new Promise((resolve) => {
         this.vhMGDB_clouds.getUtokenByUser()
               .then((token)=>{
                 if(token.vcode === 0){                          
                   resolve(token.utoken);                            
                 }else{
                   console.log(token.message);
                   resolve(false);                    
                 }
                     
               })          
       })
     }
 
   /**
    * @example:
    * this.vhQueryClouds.deleteCloudCamByUser('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteCloudCam', bool);
         })
    * @param licensecam 
    * @return Promise => bool = true or false 
    */
     public deleteCloudCamByUser(licensecam:string){
       return new Promise((resolve) => {
         this.vhMGDB_clouds.deleteCloudCamByUser(licensecam)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })
     }
 
   /**
    * @example
    * this.vhQueryClouds.getCloudCamByUser('5fb67fda87c0f21d484cbdf3')
             .then((cloudcam:any)=>{
               console.log('getCloudCamByUser', cloudcam);
             })
    * @param licensecam:string 
    * @return Promise => obj ={} or null
    */
     public getCloudCamByUser(licensecam:string){
       return new Promise((resolve) => {
         this.vhMGDB_clouds.getCloudCamByUser(licensecam)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(cloudcam.data);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(null);                    
                 }
                    
               })          
       })
     }
 
   /**
    * @example
    * this.vhQueryClouds.getCloudCamsbyUser()
             .then((cloudcams)=>{
               console.log('getCloudCams', cloudcams);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getCloudCamsbyUser(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_clouds.getCloudCamsByUser()
             .then((cloudcams)=>{
               if(cloudcams.vcode === 0){
                 this.cloudcams = cloudcams.data;                              
               }else{
                 console.log(cloudcams.message);
                 this.cloudcams = new Array();                   
               }
               resolve(this.cloudcams);                          
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   /**
    * 
    * @param licensecam 
    * @param starttime 
    * @param endtime 
    * @return Promise => array(string) = [,,..]
    */
   public getPlaybackListCamByUser(licensecam:string, camplaybackURL:string, starttime:any, endtime:any, eutoken:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_clouds.getPlaybackListCamByUser(licensecam, camplaybackURL, starttime, endtime, eutoken)
         .then((playbacklist:any)=>{
           if(playbacklist.vcode === 0){           
             resolve(playbacklist.data);                             
           }else{
             console.log(playbacklist.message);
             resolve([]);                  
           }    
         },(error:any)=>{         
           reject(error);
         }) 
     })       
   }
 
   private publishObservableEventRooms() {
     this.subjectrooms.next(this.rooms);
   }  
 
   private observableLocalRooms():Subject<any> {      
     return this.subjectrooms; 
   }
   
  /**
    * @example:
    * this.observableRoom = this.vhQueryClouds.getObservableLocalRooms().subscribe((localRooms:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableRoom.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalRooms(){   
    return new Observable((observer:any) => {    
     this.observableLocalRooms().subscribe((rooms) => {   
       observer.next(rooms);
     })
     this.publishObservableEventRooms();
    })
   }
 
 
   /**
    * @example: 
    * let wallet = this.vhQueryClouds.getlocalRoom('5fb6780ca2148e09806c5b01');
    * @param id_room 
    * @return Object => obj = {} or null
    */
   public getlocalRoom(id_room:any){
     for(let i=0; i<this.rooms.length; i++){
       if(this.rooms[i]._id === id_room){
         return this.rooms[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryClouds.getlocalRooms();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalRooms(){    
     return this.rooms;
   }
   
    /**
    * @example:
    * this.vhQueryClouds.refreshLocalRooms()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalRoom(), getlocalRooms() trong localstorage
    * @return Promise => null
    */
   public refreshLocalRooms():any{
     return new Promise((resolve) => { 
       this.getRooms()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryClouds.addRoom({name:'camera 2', quantity:20, price:200000})
           .then((room)=>{
             console.log('addRoom', room);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addRoom(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('rooms', data)
           .then((room)=>{
             resolve(room);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.updateRoom('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateRoom', bool);
           })
    * @param id_room 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateRoom(id_room:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('rooms', id_room, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.deleteRoom('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteRoom', bool);
         })
    * @param id_room 
    * @return Promise => bool = true or false 
    */
   public deleteRoom(id_room:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('rooms', id_room)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getRoom('5fb67fda87c0f21d484cbdf3')
             .then((room)=>{
               console.log('getRoom', room);
             })
    * @param id_room 
    * @return Promise => obj ={} or null
    */
   public getRoom(id_room:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('rooms', id_room)
             .then((room)=>{
               resolve(room);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getRooms()
             .then((rooms)=>{
               console.log('getRooms', rooms);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getRooms(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('rooms')
             .then((rooms)=>{
               this.rooms = new Array();
               this.rooms = rooms;
               resolve(rooms);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
   /**
    * @example: 
    * let log = this.vhQueryClouds.getlocalLog('5fb6780ca2148e09806c5b01');
    * @param id_log 
    * @return Object => obj = {} or null
    */
   public getlocalLog(id_log:any){
     for(let i=0; i<this.logs.length; i++){
       if(this.logs[i]._id === id_log){
         return this.logs[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let logs = this.vhQueryClouds.getlocalLogs(); 
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalLogs(){    
     return this.logs;
   }
   
   /**
    * @example:
    * this.vhQueryClouds.refreshLocalLogs()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalLog(), getlocalLogs() trong localstorage
    * @return Promise => null
    */
   public refreshLocalLogs():any{
     return new Promise((resolve) => { 
       this.getLogs()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryClouds.addLog({name:'camera 2', quantity:20, price:200000})
           .then((log)=>{
             console.log('addLog', log);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addLog(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('logs', data)
           .then((log)=>{
             resolve(log);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.updateLog('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateLog', bool);
           })
    * @param id_log 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateLog(id_log:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('logs', id_log, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.deleteLog('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteLog', bool);
         })
    * @param id_log 
    * @return Promise => bool = true or false 
    */
   public deleteLog(id_log:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('logs', id_log)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getLog('5fb67fda87c0f21d484cbdf3')
             .then((log)=>{
               console.log('getLog', log);
             })
    * @param id_log 
    * @return Promise => obj ={} or null
    */
   public getLog(id_log:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('logs', id_log)
             .then((log)=>{
               resolve(log);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getLogs()
             .then((logs)=>{
               console.log('getLogs', logs);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getLogs(){
     return new Promise((resolve, reject) => {
       this.logs = new Array();
       this.vhMGDB_database.getDocs('logs')
             .then((logs)=>{
               this.logs = logs;
               resolve(logs);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   private publishObservableEventMainboards() {
     this.subjectmainboards.next(this.mainboards);
   }  
 
   private observableLocalMainboards():Subject<any> {      
     return this.subjectmainboards; 
   }
   
  /**
    * @example:
    * this.observableMainboard = this.vhQueryClouds.observableLocalMainboards().subscribe((localMainboards:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableMainboard.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalMainboards(){   
    return new Observable((observer:any) => {    
     this.observableLocalMainboards().subscribe((mainboards) => {   
       observer.next(mainboards);
     })
     this.publishObservableEventMainboards();
    })
   }
 
   /**
    * @example: 
    * let wallet = this.vhQueryClouds.getlocalMainboard('5fb6780ca2148e09806c5b01');
    * @param id_mainboard 
    * @return Object => obj = {} or null
    */
   public getlocalMainboard(id_mainboard:any){
     for(let i=0; i<this.mainboards.length; i++){
       if(this.mainboards[i]._id === id_mainboard){
         return this.mainboards[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryClouds.getlocalMainboards();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalMainboards(){    
     return this.mainboards;
   }
   
    /**
    * @example:
    * this.vhQueryClouds.refreshLocalMainboards()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalMainboard(), getlocalMainboards() trong localstorage
    * @return Promise => null
    */
   public refreshLocalMainboards():any{
     return new Promise((resolve) => { 
       this.getMainboards()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryClouds.addMainboard({name:'camera 2', quantity:20, price:200000})
           .then((mainboard)=>{
             console.log('addMainboard', mainboard);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addMainboard(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('mainboards', data)
           .then((mainboard)=>{
             resolve(mainboard);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.updateMainboard('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateMainboard', bool);
           })
    * @param id_mainboard 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateMainboard(id_mainboard:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('mainboards', id_mainboard, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.deleteMainboard('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteMainboard', bool);
         })
    * @param id_mainboard 
    * @return Promise => bool = true or false 
    */
   public deleteMainboard(id_mainboard:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('mainboards', id_mainboard)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getMainboard('5fb67fda87c0f21d484cbdf3')
             .then((mainboard)=>{
               console.log('getMainboard', mainboard);
             })
    * @param id_mainboard 
    * @return Promise => obj ={} or null
    */
   public getMainboard(id_mainboard:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('mainboards', id_mainboard)
             .then((mainboard)=>{
               resolve(mainboard);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getMainboards()
             .then((mainboards)=>{
               console.log('getMainboards', mainboards);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getMainboards(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('mainboards')
             .then((mainboards)=>{
               this.mainboards = new Array();
               this.mainboards = mainboards;
               resolve(mainboards);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   private publishObservableEventFunctions() {
     this.subjectfunctions.next(this.functions);
   }  
 
   private observableLocalFunctions():Subject<any> {      
     return this.subjectfunctions; 
   }
   
  /**
    * @example:
    * this.observableFunction = this.vhQueryClouds.getObservableLocalFunctions().subscribe((localFunctions:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableFunction.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalFunctions(){   
    return new Observable((observer:any) => {    
     this.observableLocalFunctions().subscribe((functions) => {   
       observer.next(functions);
     })
     this.publishObservableEventFunctions();
    })
   }
 
   
   /**
    * @example: 
    * let wallet = this.vhQueryClouds.getlocalFunction('5fb6780ca2148e09806c5b01');
    * @param id_function 
    * @return Object => obj = {} or null
    */
   public getlocalFunction(id_function:any){
     for(let i=0; i<this.functions.length; i++){
       if(this.functions[i]._id === id_function){
         return this.functions[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryClouds.getlocalFunctions();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalFunctions(){    
     return this.functions;
   }
   
    /**
    * @example:
    * this.vhQueryClouds.refreshLocalFunctions()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalFunction(), getlocalFunctions() trong localstorage
    * @return Promise => null
    */
   public refreshLocalFunctions():any{
     return new Promise((resolve) => { 
       this.getFunctions()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryClouds.addFunction({name:'camera 2', quantity:20, price:200000})
           .then((func)=>{
             console.log('addFunction', func);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addFunction(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('functions', data)
           .then((func)=>{
             resolve(func);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.updateFunction('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateFunction', bool);
           })
    * @param id_function 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateFunction(id_function:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('functions', id_function, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.deleteFunction('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteFunction', bool);
         })
    * @param id_function 
    * @return Promise => bool = true or false 
    */
   public deleteFunction(id_function:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('functions', id_function)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getFunction('5fb67fda87c0f21d484cbdf3')
             .then((func)=>{
               console.log('getFunction', func);
             })
    * @param id_function 
    * @return Promise => obj ={} or null
    */
   public getFunction(id_function:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('functions', id_function)
             .then((func)=>{
               resolve(func);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getFunctions()
             .then((functions)=>{
               console.log('getFunctions', functions);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getFunctions(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('functions')
             .then((functions)=>{
               this.functions = new Array();
               this.functions = functions;
               resolve(functions);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   private publishObservableEventComponents() {
     this.subjectcomponents.next(this.components);
   }  
 
   private observableLocalComponents():Subject<any> {      
     return this.subjectcomponents; 
   }
   
  /**
    * @example:
    * this.observableFunction = this.vhQueryClouds.getObservableLocalFunctions().subscribe((localFunctions:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableFunction.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalComponents(){   
    return new Observable((observer:any) => {    
     this.observableLocalComponents().subscribe((components) => {   
       observer.next(components);
     })
     this.publishObservableEventComponents();
    })
   }
   
   /**
    * @example: 
    * let wallet = this.vhQueryClouds.getlocalComponent('5fb6780ca2148e09806c5b01');
    * @param id_component 
    * @return Object => obj = {} or null
    */
   public getlocalComponent(id_component:any){
     for(let i=0; i<this.components.length; i++){
       if(this.components[i]._id === id_component){
         return this.components[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryClouds.getlocalComponents();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalComponents(){    
     return this.components;
   }
   
    /**
    * @example:
    * this.vhQueryClouds.refreshLocalComponents()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalComponent(), getlocalComponents() trong localstorage
    * @return Promise => null
    */
   public refreshLocalComponents():any{
     return new Promise((resolve) => { 
       this.getComponents()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryClouds.addComponent({name:'camera 2', quantity:20, price:200000})
           .then((component)=>{
             console.log('addComponent', component);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addComponent(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('components', data)
           .then((component)=>{
             resolve(component);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.updateComponent('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateComponent', bool);
           })
    * @param id_component 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateComponent(id_component:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('components', id_component, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.deleteComponent('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteComponent', bool);
         })
    * @param id_component 
    * @return Promise => bool = true or false 
    */
   public deleteComponent(id_component:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('components', id_component)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getComponent('5fb67fda87c0f21d484cbdf3')
             .then((component)=>{
               console.log('getComponent', component);
             })
    * @param id_component 
    * @return Promise => obj ={} or null
    */
   public getComponent(id_component:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('components', id_component)
             .then((component)=>{
               resolve(component);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getComponents()
             .then((components)=>{
               console.log('getComponents', components);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getComponents(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('components')
             .then((components)=>{
               this.components = new Array();
               this.components = components;
               resolve(components);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   private publishObservableEventIcons() {
     this.subjecticons.next(this.icons);
   }  
 
   private observableLocalIcons():Subject<any> {      
     return this.subjecticons; 
   }
   
  /**
    * @example:
    * this.observableIcon = this.vhQueryClouds.getObservableLocalIcons().subscribe((localIcons:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableIcon.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalIcons(){   
    return new Observable((observer:any) => {    
     this.observableLocalIcons().subscribe((icons) => {   
       observer.next(icons);
     })
     this.publishObservableEventIcons();
    })
   }
 
    /**
    * @example: 
    * let wallet = this.vhQueryClouds.getlocalIcon('5fb6780ca2148e09806c5b01');
    * @param id_icon 
    * @return Object => obj = {} or null
    */
   public getlocalIcon(id_icon:any){
     for(let i=0; i<this.icons.length; i++){
       if(this.icons[i]._id === id_icon){
         return this.icons[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryClouds.getlocalIcons();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalIcons(){    
     return this.icons;
   }
   
    /**
    * @example:
    * this.vhQueryClouds.refreshLocalIcons()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalIcon(), getlocalIcons() trong localstorage
    * @return Promise => null
    */
   public refreshLocalIcons():any{
     return new Promise((resolve) => { 
       this.getIcons()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryClouds.addIcon({name:'camera 2', quantity:20, price:200000})
           .then((icon)=>{
             console.log('addIcon', icon);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addIcon(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('icons', data)
           .then((icon)=>{
             resolve(icon);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.updateIcon('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateIcon', bool);
           })
    * @param id_icon 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateIcon(id_icon:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('icons', id_icon, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.deleteIcon('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteIcon', bool);
         })
    * @param id_icon 
    * @return Promise => bool = true or false 
    */
   public deleteIcon(id_icon:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('icons', id_icon)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getIcon('5fb67fda87c0f21d484cbdf3')
             .then((icon)=>{
               console.log('getIcon', icon);
             })
    * @param id_icon 
    * @return Promise => obj ={} or null
    */
   public getIcon(id_icon:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('icons', id_icon)
             .then((icon)=>{
               resolve(icon);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getIcons()
             .then((icons)=>{
               console.log('getIcons', icons);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getIcons(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('icons')
             .then((icons)=>{
               this.icons = new Array();
               this.icons = icons;
               resolve(icons);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
    
   private publishObservableEventAppSettingNameStations() {
     this.subjectappsettingstations.next();
   }  
 
   private observableLocalAppSettingNameStations():Subject<any> {      
     return this.subjectappsettingstations; 
   }
   
    /**
    * @example:
    * this.observableAppSetting = this.vhQueryClouds.getObservableLocalAppSettingNameStations().subscribe((localAppSettings:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableAppSetting.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalAppSettingNameStations(){   
    return new Observable((observer:any) => {    
     this.observableLocalAppSettingNameStations().subscribe(() => {   
       let list = new Array();
       for(let i =0; i<this.appsettingstations.length; i++){
         list.push(this.appsettingstations[i].appsetting_name);
       }     
       observer.next(list);
     })
     this.publishObservableEventAppSettingNameStations();
    })
   }
   
   /**
   *@example:
     this.vhQueryClouds.getLocalAppSettingNameStations()
         .then((list)=>{
             console.log(list);
           })  
   * @return object => list of appsetting_names
   */
  public getLocalAppSettingNameStations(){  
   let list = new Array();
   for(let i =0; i<this.appsettingstations.length; i++){
     list.push(this.appsettingstations[i].appsetting_name);
   }
   return list;     
 }
 
 /**
  * @example:
   let appsetting = this.vhQueryClouds.getLocalAppSettingNameStation('info_header_footer_bill');
   console.log(appsetting);
  * @param appsetting_name   
  * @return object => {title:'title',name:'name', quantity: 10}
  */
 public getLocalAppSettingNameStation(appsetting_name:any){  
   let obj:any = {};   
   for(let i =0; i<this.appsettingstations.length; i++){
     if(this.appsettingstations[i].appsetting_name === appsetting_name){
       obj = {...this.appsettingstations[i]};
       delete obj._id;
       delete obj.appsetting_name;   
       break;   
     }        
   }
   return obj;
 }
 
  /**
    * @example: 
    * let appsetting = this.vhQueryClouds.getLocalAppSettingStation('5fb6780ca2148e09806c5b01');
    * @param id_appsetting 
    * @return Object => obj = {} or null
    */
   private getLocalAppSettingStation(id_appsetting:any){
     for(let i=0; i<this.appsettingstations.length; i++){
       if(this.appsettingstations[i]._id === id_appsetting){
         return this.appsettingstations[i];      
       }
     } 
     return null;        
   }
 
     /**
  * Hàm này refresh giá trị mới nhất cho hàm getLocalAppSettingNameStations(), getLocalAppSettingNameStation() trong localstorage
  * @return Promise => null
  */
 public refreshLocalAppSettingNameStations():any{
   return new Promise((resolve, reject) => { 
     // this.getAppSettingStations().then(()=>{resolve(null)})   
     resolve(null)   
   })
 }
 
 /**
  * @example
  * this.vhQueryClouds.getAppSettingStations()
           .then((settings)=>{
             console.log('getAppSettings', settings);
           })
   * @return Promise => array(object) = [{},{},..]
   */
 private getAppSettingStations():any{
   return new Promise((resolve, reject) => {      
     this.vhMGDB_database.getDocsByFields('appsettingstations',{uuid: {$eq: this.hwinfo.uuid}},{},{},0)
           .then((appsettingstations:any)=>{
             if(appsettingstations.length>0){      
               this.appsettingstations = appsettingstations;  
             }
             resolve(null);
           },(error:any)=>{
             reject(error);
           })          
   })  
 }
 
 /**
  * @example:
   this.vhQueryClouds.updateAppSettingNameStation('info_header_footer_bill',{title:'title',name:'name'})
       .then((bool:any)=>{
         console.log(bool);
       })       
  * @param appsetting_name 
  * @param value 
  * @format value = {title:'title',name:'name'} 
  * @return Promise Boolean => bool = true or false 
  */ 
 public updateAppSettingNameStation(appsetting_name:any, value:any) {
   return new Promise((resolve,reject) => {    
     this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid: {$eq: this.hwinfo.uuid}},{},{},0)
         .then((appsettingstations:any)=>{
              if(appsettingstations.length>0){               
               this.vhMGDB_database.updateDoc('appsettingstations', appsettingstations[0]._id, value)
                   .then((bool:any)=>{
                     resolve(bool);                   
                   }, error=>{
                     reject(error)
                   })     
              }else{
                let obj:any = {...value};
                obj.appsetting_name = appsetting_name;               
                obj.uuid = this.hwinfo.uuid;
                this.vhMGDB_database.addDoc('appsettingstations',obj)
                     .then(()=>{
                       resolve(true);
                     }, error=>{
                       reject(error)
                     }) 
              }
         })              
   })  
 }
  
 
 /**
  * @example
  * this.vhQueryClouds.deleteAppSettingNameStation('info_header_footer_bill')
       .then((bool:any)=>{
         console.log(bool); 
       })
  * @param appsetting_name 
  * @return Promise Boolean => bool = true or false 
  */
 public deleteAppSettingNameStation(appsetting_name:any) {
   return new Promise((resolve, reject) => {
     this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid:{$eq:this.hwinfo.uuid}},{},{},0)
         .then((appsettingstations:any)=>{
             if(appsettingstations.length>0){               
               this.vhMGDB_database.deleteDoc('appsettingstations', appsettingstations[0]._id)
                   .then((bool:any)=>{            
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   })              
             }else resolve(false);
           })            
   })     
 }
 
   
    /**
    * @example: 
    * let wallet = this.vhQueryClouds.getlocalScript('5fb6780ca2148e09806c5b01');
    * @param id_script 
    * @return Object => obj = {} or null
    */
   public getlocalScript(id_script:any){
     for(let i=0; i<this.scripts.length; i++){
       if(this.scripts[i]._id === id_script){
         return this.scripts[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryClouds.getlocalScripts();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalScripts(){    
     return this.scripts;
   }
   
    /**
    * @example:
    * this.vhQueryClouds.refreshLocalScripts()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalScript(), getlocalScripts() trong localstorage
    * @return Promise => null
    */
   public refreshLocalScripts():any{
     return new Promise((resolve) => { 
       this.getScripts()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryClouds.addScript({name:'camera 2', quantity:20, price:200000})
           .then((script)=>{
             console.log('addScript', script);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addScript(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('scripts', data)
           .then((script)=>{
             resolve(script);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.updateScript('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateScript', bool);
           })
    * @param id_script 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateScript(id_script:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('scripts', id_script, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.deleteScript('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteScript', bool);
         })
    * @param id_script 
    * @return Promise => bool = true or false 
    */
   public deleteScript(id_script:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('scripts', id_script)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getScript('5fb67fda87c0f21d484cbdf3')
             .then((script)=>{
               console.log('getScript', script);
             })
    * @param id_script 
    * @return Promise => obj ={} or null
    */
   public getScript(id_script:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('scripts', id_script)
             .then((script)=>{
               resolve(script);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getScripts()
             .then((scripts)=>{
               console.log('getScripts', scripts);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getScripts(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('scripts')
             .then((scripts)=>{
               this.scripts = new Array();
               this.scripts = scripts;
               resolve(scripts);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
    /**
    * @example: 
    * let wallet = this.vhQueryClouds.getlocalScript_detail('5fb6780ca2148e09806c5b01');
    * @param id_script_detail 
    * @return Object => obj = {} or null
    */
   public getlocalScript_detail(id_script_detail:any){
     for(let i=0; i<this.script_details.length; i++){
       if(this.script_details[i]._id === id_script_detail){
         return this.script_details[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQueryClouds.getlocalScript_details();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalScript_details(){    
     return this.script_details;
   }
   
    /**
    * @example:
    * this.vhQueryClouds.refreshLocalScript_details()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalScript_detail(), getlocalScript_details() trong localstorage
    * @return Promise => null
    */
   public refreshLocalScript_details():any{
     return new Promise((resolve) => { 
       this.getScript_details()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQueryClouds.addScript_detail({name:'camera 2', quantity:20, price:200000})
           .then((script_detail)=>{
             console.log('addScript_detail', script_detail);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addScript_detail(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('script_details', data)
           .then((script_detail)=>{
             resolve(script_detail);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.updateScript_detail('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateScript_detail', bool);
           })
    * @param id_script_detail 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateScript_detail(id_script_detail:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('script_details', id_script_detail, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryClouds.deleteScript_detail('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteScript_detail', bool);
         })
    * @param id_script_detail 
    * @return Promise => bool = true or false 
    */
   public deleteScript_detail(id_script_detail:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('script_details', id_script_detail)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getScript_detail('5fb67fda87c0f21d484cbdf3')
             .then((script_detail)=>{
               console.log('getScript_detail', script_detail);
             })
    * @param id_script_detail 
    * @return Promise => obj ={} or null
    */
   public getScript_detail(id_script_detail:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('script_details', id_script_detail)
             .then((script_detail)=>{
               resolve(script_detail);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryClouds.getScript_details()
             .then((script_details)=>{
               console.log('getScript_details', script_details);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getScript_details(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('script_details')
             .then((script_details)=>{
               this.script_details = new Array();
               this.script_details = script_details;
               resolve(script_details);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 }
 
 @Injectable()
 export class VhEcommerce{  
    private productlisttiktoks: any = new Array();
    private shoplisttiktok: any = new Array();

    private productlistshopees: any = new Array();
    private shoplistshopee: any = new Array();
  
    private lazadapricecomparinglist: any = new Array();
    private tikipricecomparinglist: any = new Array();
    private sendopricecomparinglist: any = new Array();
    private shopeepricecomparinglist: any = new Array();
    private tiktokpricecomparinglist: any = new Array();
 
   private callbacklazadapricecomparing: Subscription = new Subscription();
 
   
   constructor(
      private vhMGDB_auth: VhMGDB_auth,
      private vhMGDB_socketMongoDB: VhMGDB_socketMongoDB,
      private vhMGDB_database: VhMGDB_database,
      private vhMGDB_shopee: VhMGDB_shopee,
      private vhMGDB_tiktok: VhMGDB_tiktok
    ) {} 

//TIKTOK
/**
  * @example:
  * let backHref = http://localhost:4200/dashboard/overview';
    this.vhEcommerce.signInTiktok(id_branch, backHref).then((bool:any)=>{
        if(bool){
          console.log('bool', bool)
        }
    })
  * @returns Promise => true or false
  */
  signInTiktok(id_branch:string, backHref:string){
    return new Promise((resolve, reject) => {        
      this.vhMGDB_tiktok.signIn(id_branch, backHref)
          .then((bool:any)=>{                
            resolve(bool);     
          },(error:any)=>{
            reject(error);
          })    
    })
  } 
  
  /**
  * @example:
   this.vhEcommerce.signOutTiktok('938476838whsofis').then((bool:any)=>{
       if(bool){
         console.log('bool', bool)
       }
   })
   * @param id_shop 
   * @returns Promise => true or false
   */
   public signOutTiktok(id_shop:string){
     return new Promise((resolve, reject)=>{   
       this.vhMGDB_tiktok.signOut(id_shop)
                   .then((result:any)=>{                                
                     if(result.vcode === 0){   
                       for(let i=0; i<this.shoplisttiktok.length;i++){
                         if(this.shoplisttiktok[i]._id === id_shop){
                           this.shoplisttiktok.splice(i,1);
                           break;
                         }
                       }                             
                       for(let i=0; i<this.productlisttiktoks.length;i++){
                         if(this.productlisttiktoks[i]._id === id_shop){
                           this.productlisttiktoks.splice(i,1);
                           break;
                         }
                       }   
                       resolve(true)
                     }else{
                       //console.log(result.message);
                       reject(false);
                     }                   
                   },(error:any)=>{
                     reject(error);
                   })      
     })    
   } 
 
 /**
  * @example:
  * let id_branch = this.vhQuerySales.getDefaultBranch()._id; 
  * this.vhEcommerce.getProductListTiktok(id_branch).then(()=>{
         do something...
        },(error:any)=>{         
        })
  * @returns 
  */
   private getProductListTiktok(id_branch:string, shop_id:string){
     return new Promise((resolve, reject)=>{       
       this.vhMGDB_tiktok.getShop(id_branch, shop_id)
           .then((result_zero:any)=>{                                   
             if(result_zero.vcode === 0){          
               this.shoplisttiktok = [...result_zero.data];  
               this.productlisttiktoks = [...result_zero.data];      
               let promise = new Array();             
               //console.log('this.productlisttiktok', this.productlisttiktok);
               for(let i=0; i<this.productlisttiktoks.length; i++){
                 promise[i] = new Promise((resolve, reject)=>{                   
                   this.vhMGDB_tiktok.getProductList(this.productlisttiktoks[i].shop_cipher, this.productlisttiktoks[i].app_key, this.productlisttiktoks[i].access_token)//hàm này lấy về 1 lần và đã có chi tiết luôn rồi
                       .then((result_one:any)=>{ 
                         this.productlisttiktoks[i].productlist = result_one;    
                         resolve(null)                                                                   
                       },(error:any)=>{
                         console.log(error);
                         reject(error);
                       })                    
                 })              
               } 
               Promise.all(promise).then(()=>{    
                 console.log('productlisttiktoks', this.productlisttiktoks);                               
                 resolve(null);
               })
             }else{
               console.log(result_zero.msg);
               reject(result_zero.msg);
             }                   
           },(error:any)=>{
             reject(error);
           })     
     })   
   }

   private getProductListTiktoks(id_branch:string){
     return new Promise((resolve, reject)=>{       
       this.vhMGDB_tiktok.getShopList(id_branch)
           .then((result_zero:any)=>{                                
             if(result_zero.vcode === 0){          
               this.shoplisttiktok = [...result_zero.data];  
               this.productlisttiktoks = [...result_zero.data];      
               let promise = new Array();             
               //console.log('this.productlisttiktok', this.productlisttiktok);
               for(let i=0; i<this.productlisttiktoks.length; i++){
                 promise[i] = new Promise((resolve, reject)=>{                   
                   this.vhMGDB_tiktok.getProductList(this.productlisttiktoks[i].shop_cipher, this.productlisttiktoks[i].app_key, this.productlisttiktoks[i].access_token)//hàm này lấy về 1 lần và đã có chi tiết luôn rồi
                       .then((result_one:any)=>{ 
                         this.productlisttiktoks[i].productlist = result_one;    
                         resolve(null)                                                                   
                       },(error:any)=>{
                         console.log(error);
                         reject(error);
                       })                    
                 })              
               } 
               Promise.all(promise).then(()=>{    
                 console.log('productlisttiktoks', this.productlisttiktoks);                               
                 resolve(null);
               })
             }else{
               console.log(result_zero.msg);
               reject(result_zero.msg);
             }                   
           },(error:any)=>{
             reject(error);
           })     
     })   
   }

  /**
  * @example: 
  * let productlistlazada = this.vhEcommerce.getlocalProductListTiktok('ư0e4tuiwe98rhvqw9vtqw9t7rq987r9qvwn98et98');
  * @param id_shop 
  * @returns Promise => Array
  */
   public getlocalProductListTiktok(id_shop:any){          
     for(let i=0; i<this.productlisttiktoks.length; i++){
       if(this.productlisttiktoks[i]._id === id_shop){            
         return cloneDeep(this.productlisttiktoks[i].productlist);           
       }
     }
     return []; 
   }

/**
  * @example:
  * let id_branch = this.vhQuerySales.getDefaultBranch()._id; 
  * this.vhEcommerce.refreshLocalProductListTiktok(id_branch)
         .then(()=>{
           do something.....
         })
  * Hàm này refresh giá trị mới nhất cho hàm getProductListTiktok() trong localstorage
  * @return Promise => null
  */
   public refreshLocalProductListTiktok(id_branch:string, shop_id?:string):any{
     return new Promise((resolve, reject) => { 
       if((shop_id!='')&&(shop_id!=undefined)){
         this.getProductListTiktok(id_branch, shop_id)
             .then(()=>{resolve(null)});         
       }else{
         this.getProductListTiktoks(id_branch)
             .then(()=>{resolve(null)});     
       }
       
     })
   }
 
   /**
    * let localshoplisttiktok = this.vhEcommerce.getlocalShopListTiktok();
    * @returns 
    */
    public getlocalShopListTiktok(){            
     return this.shoplisttiktok;          
   }

   /**
    * Cập nhật giá
    * @example:
    * this.vhEcommerce.updatePriceTiktok(shop_cipher, app_key, access_token, product_id, json, id_shop).then((order)=>{
          do something...
          },(error:any)=>{         
          })
    * @param shop_cipher 
    * @param app_key 
    * @param access_token 
    * @param product_id 
    * @param json
    * @param id_shop 
    * @returns 
    */
  updatePriceTiktok(shop_cipher:string, app_key:string, access_token:string, product_id:string, json:any, id_shop:string){
    return new Promise((resolve, reject) => {        
      this.vhMGDB_tiktok.updatePriceTiktok(shop_cipher, app_key, access_token, product_id, json)
          .then((product:any)=>{         
              for(let i=0; i<this.productlisttiktoks.length; i++){
                if(this.productlisttiktoks[i]._id === id_shop){
                  for(let j=0; j<this.productlisttiktoks[i].productlist.length; j++){
                    if(this.productlisttiktoks[i].productlist[j].id == product_id) this.productlisttiktoks[i].productlist[j] = product;
                  }
                }                  
              }
              resolve(product); 
          },(error:any)=>{
            reject(error);
          })    
    })
  }

    /**
     * Cập nhật tồn kho
    * @example:
    * this.vhEcommerce.updateStockTiktok(shop_cipher, app_key, access_token, product_id, json, id_shop).then((order)=>{
          do something...
          },(error:any)=>{         
          })
    * @param shop_cipher 
    * @param app_key 
    * @param access_token 
    * @param product_id 
    * @param json 
    * @param id_shop 
    * @returns 
    */
  updateStockTiktok(shop_cipher:string, app_key:string, access_token:string, product_id:string, json:any, id_shop:string){
    return new Promise((resolve, reject) => {        
      this.vhMGDB_tiktok.updateStockTiktok(shop_cipher, app_key, access_token, product_id, json)
          .then((product:any)=>{  
            for(let i=0; i<this.productlisttiktoks.length; i++){
              if(this.productlisttiktoks[i]._id === id_shop){
                for(let j=0; j<this.productlisttiktoks[i].productlist.length; j++){
                  if(this.productlisttiktoks[i].productlist[j].id == product_id) this.productlisttiktoks[i].productlist[j] = product;
                }
              }                  
            }              
            resolve(product);     
          },(error:any)=>{
            reject(error);
          })    
    })
  }

  /**
   * Lấy số lượng tồn kho
    * @example:
    * this.vhEcommerce.searchInventoryTiktok(shop_cipher, app_key, access_token, json).then((order)=>{
          do something...
          },(error:any)=>{         
          })
    * @param shop_cipher 
    * @param app_key 
    * @param access_token 
    * @param json 
    * @returns 
    */
  searchInventoryTiktok(shop_cipher:string, app_key:string, access_token:string, json:any){
    return new Promise((resolve, reject) => {        
      this.vhMGDB_tiktok.searchInventoryTiktok(shop_cipher, app_key, access_token, json)
          .then((data:any)=>{                
            resolve(data);     
          },(error:any)=>{
            reject(error);
          })    
    })
  }

   /**
    * Lấy về giao dịch sao kê
    * @example:
    * this.vhEcommerce.getOrderStatementTransactionsTiktok(shop_cipher, app_key, access_token, order_id).then((order)=>{
          do something...
          },(error:any)=>{         
          })
    * @param shop_cipher 
    * @param app_key 
    * @param access_token 
    * @param order_id 
    * @returns 
    */
  getOrderStatementTransactionsTiktok(shop_cipher:string, app_key:string, access_token:string, order_id:string){
    return new Promise((resolve, reject) => {        
      this.vhMGDB_tiktok.getOrderStatementTransactionsTiktok(shop_cipher, app_key, access_token, order_id)
          .then((order:any)=>{                
            resolve(order);     
          },(error:any)=>{
            reject(error);
          })    
    })
  }  

   /**
    * @example:
    *let time_from = new Date('2021-10-28');
    * let time_to = new Date('2021-10-30');
    * this.vhEcommerce.getSalesOrderListTiktok(time_from, time_to, shop_cipher, app_key, access_token, id_shop)
         .then((result)=>{
             console.log('result', result);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param time_from 
    * @param time_to 
    * @param shop_cipher 
    * @param app_key 
    * @param access_token 
    * @param id_shop 
    * @returns 
    */        
   public getSalesOrderListTiktok(time_from:any, time_to:any, shop_cipher:string, app_key:string, access_token:string, id_shop:string){
     time_from = new Date(time_from);
     time_to = new Date(time_to);
     return new Promise((resolve, reject) => { 
       let promise_zero = new Promise((resolve, reject)=>{        
         this.vhMGDB_tiktok.getOrderList(Math.floor(time_from.getTime()/1000), Math.floor(time_to.getTime()/1000), shop_cipher, app_key, access_token)
             .then((response_one:any)=>{                       
               this.productlisttiktoks.forEach((item:any) => {
                 if(item._id === id_shop){
                   item.salesorderdetaillist = response_one;
                 }
               })                            
               resolve(response_one);
             },(error:any)=>{                   
               reject(error);
             })         
       })
       let promise_one = new Promise((resolve, reject)=>{
         let query = {create_time: {$gte:new Date(time_from), $lte: new Date(time_to)}};
         this.vhMGDB_database.getDocsByFields(id_shop, query, {},{},0)
             .then((salesorderlist:any)=>{             
               resolve(salesorderlist);               
             })
             .catch(e=>{
              console.log(e);
              reject(e)
             })
       })   
       
       Promise.all([promise_zero, promise_one]).then((array:any)=>{      
         let newArray = array[0].filter((item:any)=>{
           let bool = true;
           array[1].forEach((item_one:any) => {                                   
             if(item.id.toString() === item_one._id){             
               bool = false;
             }            
           })          
           return bool;
         })         
         //Tạo 1 bản sao của bill này trong database viethas
         newArray.forEach((item:any) => {          
           this.vhMGDB_database.addDocbyID(id_shop.toString(), item.id.toString(), {create_time: new Date(item.create_time*1000)});               
         })
         for(let i=0; i<array[0].length; i++){
           for(let j=0; j<array[1].length; j++){
             if(array[0][i].id === array[1][j]._id){                   
               let _item = {...array[1][j]}; delete _item._id; delete _item.create_time; //lưu ý create_time trong db viethas và db tiktok có kiểu khác nhau nên xóa đi khi chập 2 cái lại, nhằm tránh xung đột kiểu dữ liệu        
               array[0][i] = {...array[0][i], ..._item};                       
             }    
           }
         }            
         console.log('salesorderdetaillist', array[0]);    
         resolve(array[0]);        
       })
     })
   }
 
   /**
  * Hàm này lấy về chi tiết của một hóa đơn
  * @example
  * this.vhEcommerce.getSalesOrderDetailTiktok('14424213387', '403754acaafc4564a16c19faa32d73c8', 'gsdr3454u54w34tfq')
         .then((salesorderdetail)=>{
           console.log('getSalesOrderDetailTiktok', salesorderdetail);
         },(error:any)=>{
           console.log('error', error);
         })
  * @param id 
  * @param shop_cipher 
  * @param app_key 
  * @param access_token 
  * @param id_shop 
  * @returns Promise => obj ={} or null
  */
  public getSalesOrderDetailTiktok(id:string, shop_cipher:string, app_key:string, access_token:string, id_shop:any){
    return new Promise((resolve, reject)=>{         
      let promise_zero = this.vhMGDB_tiktok.getOrders([id], shop_cipher, app_key, access_token);
      let promise_one = this.vhMGDB_database.getDoc(id_shop, id);
      Promise.all([promise_zero, promise_one]).then((array:any)=>{              
        if(array[0].length>0){
          if(!array[1]){
            this.vhMGDB_database.addDocbyID(id_shop, array[0].id, {create_time: new Date(array[0].create_time*1000)});  
          }               
          resolve(array[0][0]);
        }else resolve(null);
        
      })       
    })
  }

  /**
  * Hàm này lấy về mảng các đơn hàng (salesorder) được lưu trong database viethas (ko phải database tiktok)
  * @example
  * this.vhEcommerce.getSalesOrderTiktok_fromViethas( ['14424213387','14424273835'], '403754acaafc4564a16c19faa32d73c8')
       .then((array:any)=>{
         console.log('array', array);
       },(error:any)=>{
         console.log('error', error);
       })
   * @param ids : là mảng các id của các order
   * @param id_shop 
   * @returns Promise => Array(object or null)
   */
   public getSalesOrderTiktok_fromViethas(ids:any, id_shop:string){
     return new Promise((resolve, reject) => {      
       let promise = new Array();
       for(let i=0; i<ids.length; i++){
         promise[i] = this.vhMGDB_database.getDoc(id_shop, ids[i]);
       }
       Promise.all(promise).then(array=>{  
         resolve(array);              
       })      
     })    
   }
 
   /**
  * Hàm này cập nhật các đơn hàng (salesorder) được lưu trong database viethas (ko phải database tiktok), lưu ý các order_sn đc lấy từ tiktok server về
  * @example:
  * this.vhEcommerce.updateSalesOrderTiktok('5fb67fda87c0f21d484cbdf3', 'gsdfgsdg4345324534t3w', {check:true})
       .then((bool:any)=>{
         console.log('updateSalesOrderTiktok', bool);
       }, error=>{
         reject(error)
       })
   * @param id_shop 
   * @param id 
   * @param data 
   * @return Promise => bool = true or false
   */
   public updateSalesOrderTiktok(id_shop:string, id:string, data:object){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.updateDoc(id_shop, id, data)
           .then((bool:any)=>{
             if(bool){              
               this.productlisttiktoks.forEach((item_zero:any) => {
                 if(item_zero._id === id_shop){
                   item_zero.salesorderdetaillist.forEach((item_one:any) => {
                     if(item_one.id === id){   
                       item_one = {...item_one, ...data};  
                     }
                   })  
                 }
               })                           
             }                   
             resolve(bool);     
           }, error=>{
             reject(error)
           })
     })   
   }
 
   /**
    * Hàm này cập nhật các đơn hàng (salesorder) được lưu trong database viethas (ko phải database tiktok), lưu ý các order_sn đc import từ file ngoài vào (excel, csv...)
    * @example:
    * this.vhEcommerce.updateSalesOrderTiktok_byFile(['144242133871', '14424213387'], {check:true}, 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdG9yZUlkIjoiNTczNjciLCJVc2VyTmFtZSI6IiIsIlN0b3JlU3RhdHVzIjoiMiIsIlNob3BUeXBlIjoiMCIsIlN0b3JlTGV2ZWwiOiIzIiwiZXhwIjoxNjMzODE3MzIwLCJpc3MiOiI1NzM2NyIsImF1ZCI6IjU3MzY3In0.9S18n7EuG7XxbZVm9kjUBozJVjx2_EZRNAn38wBUaDs', '403754acaafc4564a16c19faa32d73c8')
           .then((array:any)=>{
             console.log('updateSalesOrderTiktok_byFile', array);
           }, error=>{
             console.log(error)
           })
     * @param ids : là mảng các id của các order
     * @param data
     * @param access_token 
     * @param id_shop 
     * @return Promise => Array(bool) = [true or false,,...]
     */
   public updateSalesOrderTiktok_byFile(ids:any, data:object, shop_cipher: string, app_key:string, access_token:string, id_shop:string){//hàm này sẽ sửa lại vì 1 request có thể lấy về đc nhiều orders
     return new Promise((resolve, reject) => {  
       let promise = new Array();
       for(let i=0; i<ids.length; i++){
         promise[i] = new Promise(resolve=>{
           this.vhMGDB_tiktok.getOrders(ids[i], shop_cipher, app_key, access_token)
               .then((salesorderdetail)=>{
                 if(salesorderdetail){
                   this.vhMGDB_database.getDoc(id_shop, ids[i])
                       .then((salesorder)=>{
                         if(salesorder){
                           this.vhMGDB_database.updateDoc(id_shop, ids[i], data)
                               .then((bool:any)=>{
                                 resolve(bool);
                               }, ()=>{
                                 resolve(false);
                               })
                         }else{
                           this.vhMGDB_database.addDocbyID(id_shop, ids[i], data)
                               .then(()=>{
                                 resolve(true);
                               })
                         }                   
                       })
                   
                 }else{
                   resolve(false)
                 }            
               }, ()=>{
                 //reject(error)
                 resolve(false)
               })     
         })
       }
       Promise.all(promise).then(array=>{
         resolve(array)
       })
     })   
   }


  /**
    * Tạo liên kết sản phẩm trên phần mềm quản lý bán hàng sales viethas và sản phẩm trên sàn tiktok
  * @example:
  * let product = this.vhQuerySales.getlocalDetailProduct(id_sub_or_product);     
  * let id_branch = this.vhQuerySales.getDefaultBranch()._id;   
  * this.vhEcommerce.addMergeTiktokProduct_skus(product,'tf3452345234', [{},{}], 'hjhjrtyur56u53')
         .then((bool:any)=>{
           console.log('addMergeTiktokProduct_skus', bool);
         }, error=>{
           console.log('error', error);
         })
   * @param product : sản phẩm detailproduct trên phần mềm bán hàng 
   * @param id : trường id (cha) trong sản phẩm tiktok      
   * @param skusArray : [{id,..},{id,..}]
   * @param id_shop 
   * @return Promise => boolean true or false
   */
   public addMergeTiktokProduct_skus(product:any, id:string, skusArray:any, id_shop:string, id_branch:string){
     //console.log('product', product);
     return new Promise((resolve, reject) => {      
         //let id_branch = this.getDefaultBranch()._id;     
         //let product = this.getlocalProduct(id_product);   
         let obj = {
           id: id,
           id_shop: id_shop,
           skus: [...skusArray]
         };
         if(product[id_branch] != undefined){
           if(product[id_branch].tiktoks === undefined) product[id_branch].tiktoks = new Array();             
         }else{
           product[id_branch]={};
           product[id_branch].tiktoks = new Array();
         }       
         let exist = false;
         //trường hợp đã có liên kết với sản phẩm trên sàn rồi, và muốn thêm liên kết với sản phẩm khác cùng loại
         for(let i=0; i<product[id_branch].tiktoks.length; i++){
           if((product[id_branch].tiktoks[i].id === id)&&(product[id_branch].tiktoks[i].id_shop === id_shop)){
             if(product[id_branch].tiktoks[i].skus != undefined){
               product[id_branch].tiktoks[i].skus = [...product[id_branch].tiktoks[i].skus,...skusArray];         
             }else{
               product[id_branch].tiktoks[i].skus = [...skusArray];     
             } 
             let value:any = {}; 
             value[id_branch] = product[id_branch];                                                  
             this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
                 .then(()=>{                   
                   resolve(true);
                 }, error=>{
                   reject(error)
                 })  
             exist = true;    
             break;                
           }
         }
         //trường hợp trước đây chưa có liên kết với sản phẩm trên sàn, giờ tạo liên kết
         if(!exist){
           product[id_branch].tiktoks.push(obj);
           let value:any = {}; 
           value[id_branch] = product[id_branch];                                        
           this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
               .then(()=>{                   
                 resolve(true);
               }, error=>{
                 reject(error)
               })   
         }                             
     })
   } 
   /**
  * @example:
  * let product = this.vhQuerySales.getlocalProduct(id_product);         
  * let id_branch = this.vhQuerySales.getDefaultBranch()._id;   
  * this.vhEcommerce.updateMergeTiktokProduct('5fb6780ca2148e09806c5b01', '435f34tf34f3243fdf', {hidden:true}, 'jfaosidfu9we87f9w')
           .then((bool:any)=>{
             console.log('updateMergeTiktokProduct', bool);
           }, error=>{
             console.log('error', error);
           })
  * @param product : sản phẩm detailproduct trên phần mềm bán hàng
  * @param id: trường id (cha) trong sản phẩm tiki
  * @param data : {hidden:true}
  * @returns Promise => bool = true or false
  */
   public updateMergeTiktokProduct(product:any, id:string, data:any, id_shop:string, id_branch:string){//cái này dùng cho sendo
     return new Promise((resolve, reject) => {        
       if(product[id_branch] === undefined) return resolve(false);
       if(product[id_branch].tiktoks === undefined) return resolve(false);       
       let exist = false;      
       for(let i=0; i<product[id_branch].tiktoks.length; i++){
         if((product[id_branch].tiktoks[i].id === id)&&(product[id_branch].tiktoks[i].id_shop === id_shop)){
           product[id_branch].tiktoks[i] = {...product[id_branch].tiktoks[i],...data};
           let value:any = {}; 
           value[id_branch] = product[id_branch];    
           this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
               .then((bool:any)=>{                      
                 resolve(bool);
               }, error=>{
                 reject(error)
               })  
           exist = true;    
           break;
         }                 
       } 
       if(!exist) resolve(false);                      
                                             
     })
   }  
 
   /**
    *  @example:
    * let product = this.vhQuerySales.getlocalProduct(id_product);  
    * let id_branch = this.vhQuerySales.getDefaultBranch()._id;   
    * this.vhEcommerce.updateMergeTiktokProduct_skus('5fb6780ca2148e09806c5b01', '435f34tf34f3243fdf', '13123135654', {xyz:true}, 'jfaosidfu9we87f9w')
             .then((bool:any)=>{
               console.log('updateMergeTiktokProduct_skus', bool);
             }, error=>{
               console.log('error', error);
             })
   * @param product : sản phẩm detailproduct trên phần mềm bán hàng
   * @param id 
   * @param sku_id : là trường id trong skus
   * @param data : object => data = {xyz:true}
   * @param id_shop 
   * @returns Promise => bool = true or false
   */
   public updateMergeTiktokProduct_skus(product:any, id:number, sku_id:number, data:any, id_shop:string, id_branch:string){
     return new Promise((resolve, reject) => {            
         if(product[id_branch] === undefined) return resolve(false);
         if(product[id_branch].tiktoks === undefined) return resolve(false);        
         let exist = false;
         for(let i=0; i<product[id_branch].tiktoks.length; i++){           
           if((product[id_branch].tiktoks[i].item_id === id)&&(product[id_branch].tiktoks[i].id_shop === id_shop)){
             //console.log('model_id',model_id);
             //console.log('product[id_branch].tiktoks[i]', product[id_branch].tiktoks[i]);
             if(product[id_branch].tiktoks[i].skus != undefined)
               for(let j=0; j<product[id_branch].tiktoks[i].skus.length; j++){
                 if(product[id_branch].tiktoks[i].skus[j].id === sku_id){
                   product[id_branch].tiktoks[i].skus[j] = {...product[id_branch].tiktoks[i].skus[j],...data};
                   let value:any = {}; 
                   value[id_branch] = product[id_branch];    
                   this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
                       .then((bool:any)=>{                      
                         resolve(bool);
                       }, error=>{
                         reject(error)
                       })  
                   exist = true;    
                   break;
                 }                  
               }  
           }
         } 
         if(!exist) resolve(false);                                                          
     })
   }  
 
   /**
    * @example:
    * let product = this.vhQuerySales.getlocalProduct(id_product);  
    * let id_branch = this.vhQuerySales.getDefaultBranch()._id; 
    * this.vhEcommerce.deleteMergeTiktokProduct_skus('5fb67fda87c0f21d484cbdf3', 'gsdfgsdg4345324534t3w', 'sdfgsdfgererasds3563')
         .then((bool:any)=>{
           console.log('deleteMergeTiktokProduct_skus', bool);
         }, error=>{
           reject(error)
         })
     * @param product : sản phẩm detailproduct trên phần mềm bán hàng
     * @param id 
     * @param sku_id:  là trường id trong skus
     * @param id_shop  
     * @return Promise => bool = true or false
     */
   public deleteMergeTiktokProduct_skus(product:any, id:string, sku_id:number, id_shop:string, id_branch:string){
     return new Promise((resolve, reject) => {                            
       if(product[id_branch] === undefined) return resolve(false);
       if(product[id_branch].tiktoks === undefined) return resolve(false);        
       let exist = false;       
       for(let i=0; i<product[id_branch].tiktoks.length; i++){    
         if((product[id_branch].tiktoks[i].id === id)&&(product[id_branch].tiktoks[i].id_shop === id_shop)){      
           if(product[id_branch].tiktoks[i].skus != undefined){
             for(let j=0; j<product[id_branch].tiktoks[i].skus.length; j++){           
               if(product[id_branch].tiktoks[i].skus[j].id === sku_id){          
                 product[id_branch].tiktoks[i].skus.splice(j,1);                   
                 let value:any = {}; 
                 value[id_branch] = product[id_branch];                        
                 this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
                     .then((bool:any)=>{
                       resolve(bool);
                     }, error=>{
                       reject(error)
                     }) 
                 exist = true;    
                 break;
               }
             }
             if(product[id_branch].tiktoks[i].skus.length === 0){
               product[id_branch].tiktoks.splice(i,1);                 
               let value:any = {}; 
               value[id_branch] = product[id_branch];                       
               this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
                   .then((bool:any)=>{
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   }) 
               exist = true;                 
             }
           }
         }
       }
       if(!exist) resolve(false);                 
     })
   }








//SHOPEE 
 /**
    * @notice : lấy thông tin vận đơn (mã code người gửi , mã code người nhận, địa chỉ người nhận...)
    * @example:
       let order_sn = '2112156RC1JN5Y';
       let access_token = '98efa569a4731bb67a8f76fed8808d66';
       let shop_id = '894793475932';
       this.vhEcommerce.getShippingDocumentShopee( order_sn, access_token, shop_id).then((result)=>{
           console.log('result', result);
         },(error:any)=>{
           console.log('error', error);
         })
   * @param order_sn 
   * @param access_token 
   * @param shop_id 
   * @returns Promise
   */
   public getShippingDocumentShopee(order_sn:string, access_token:string, shop_id:string){
     return new Promise((resolve, reject)=>{   
       this.vhMGDB_shopee.getShippingDocumentShopee(order_sn, access_token, Number(shop_id))
                   .then((result:any)=>{    
                     resolve(result);                          
                   },(error:any)=>{
                     reject(error);
                   })      
     })    
   }
 
  /**
    * @notice : Lấy địa chỉ + thời gian lấy hàng
    * @example:
       let order_sn = '2112156RC1JN5Y';
       let access_token = '98efa569a4731bb67a8f76fed8808d66';
       let shop_id = '894793475932';
       this.vhEcommerce.getShippingParameterShopee( order_sn, access_token, shop_id).then((result)=>{
           console.log('result', result);
         },(error:any)=>{
           console.log('error', error);
         })
   * @param order_sn 
   * @param access_token 
   * @param shop_id 
   * @returns Promise
   */
   public getShippingParameterShopee(order_sn:string, access_token:string, shop_id:string){
     return new Promise((resolve, reject)=>{   
       this.vhMGDB_shopee.getShippingParameterShopee(order_sn, access_token, Number(shop_id))
                   .then((result:any)=>{    
                     resolve(result);                          
                   },(error:any)=>{
                     reject(error);
                   })      
     })    
   }
 
   /**
    * @notice : Xác nhận đã đóng gói xong
    * @example:
    *  let json = {
         order_sn: "2112156RC1JN5Y",
         pickup: {
           address_id: 51363234,
           pickup_time_id: "1639731600"
         }
       }
       let access_token = '98efa569a4731bb67a8f76fed8808d66'
       let shop_id = '894793475932';
       this.vhEcommerce.confirmShippingByJSONShopee( json, access_token, shop_id).then((result)=>{
           console.log('result', result);
         },(error:any)=>{
           console.log('error', error);
         })
   * @param json 
   * @param access_token 
   * @param shop_id 
   * @returns Promise
   */
   public confirmShippingByJSONShopee(json:any, access_token:string, shop_id:string){
     return new Promise((resolve, reject)=>{   
       this.vhMGDB_shopee.confirmShippingByJSONShopee(json, access_token, Number(shop_id))
                   .then((result:any)=>{                                             
                     resolve(result);                     
                   },(error:any)=>{
                     reject(error);
                   })      
     })    
   }
 
 
     /**
      * @example:
      * this.vhEcommerce.observableLazadaPriceComparing('5fb6780ca2148e09806c5b01')      
           .subscribe((data)=> {                       
                     console.log('observableLazadaPriceComparing', data);                         
           },(error:any) => {
             console.log(error);
           }) 
      * @param id_branch   
      * @returns Observable =>
      */
     public observableLazadaPriceComparing(id_branch:string){  
       return new Observable((observer:any) => {          
         this.callbacklazadapricecomparing = this.vhMGDB_socketMongoDB.initSyncLazadaPriceComparing(id_branch).subscribe((change:any)=>{             
           if (change.type === "added") {                                                  
             let data = {            
               _id: change.doc.id,
               ...this.vhMGDB_auth.cvtDataFB2MG(change.doc.data())
             };
             this.lazadapricecomparinglist.push(data);               
                     
           }else if (change.type === "modified") {                               
               let data = {               
                 _id: change.doc.id,
                 ...this.vhMGDB_auth.cvtDataFB2MG(change.doc.data())
               };       
               for(let i=0; i<this.lazadapricecomparinglist.length; i++){
                 if(this.lazadapricecomparinglist[i]._id === data._id){
                   this.lazadapricecomparinglist[i] = {...this.lazadapricecomparinglist[i], ...data};                   
                   break;
                 }
               }
                           
           }else if (change.type === "removed") {                               
               let data = {              
                 _id: change.doc.id                                  
               };
               for(let i=0; i<this.lazadapricecomparinglist.length; i++){
                 if(this.lazadapricecomparinglist[i]._id === data._id){
                   this.lazadapricecomparinglist.splice(i,1);
                   break;
                 }
               }
           }     
           observer.next(true);  
         })
       })
       
     }  
   
     /**
      * @example:
      * this.vhEcommerce.closeLazadaPriceComparing();
      * disconnect LazadaPriceComparing in the APP
      * @returns void
      */
     public closeLazadaPriceComparing(){
       this.callbacklazadapricecomparing.unsubscribe();
       this.vhMGDB_socketMongoDB.closeLazadaPriceComparing();
     }
   
     /**
      * let lazadapricecomparinglist = this.vhEcommerce.getLocalLazadaPriceComparing();
      * @returns Array
      */
     public getLocalLazadaPriceComparing(){
       return cloneDeep(this.lazadapricecomparinglist);
     }
 
     /**
      * @example:
      * this.vhEcommerce.restartEcommercePriceComparingMACHINE('5fb6780ca2148e09806c5b01')
             .then((bool:any)=>{
               console.log('restartEcommercePriceComparingMACHINE', bool);
             }, error=>{
               console.log('error', error);
             })
       * @param id_billdetail 
       * @param data 
       * @return Promise => bool = true or false
     */
     public restartEcommercePriceComparingMACHINE(){
       return new Promise((resolve, reject) => {
         this.vhMGDB_database.restartEcommercePriceComparingMACHINE()
             .then((bool:any)=>{
               resolve(bool);
             }, error=>{
               reject(error)
             })         
       })
     }
   
       
   /**
    * Lấy về tất cả các shops lazada, sendo, tiki, shopee, dùng trong cấu hình gian hàng
    * @example:
   this.vhEcommerce.getAllShops(id_branch).then((shops)=>{
       if(shops.length>0){
         console.log('shops', shops)
       }
   })
     * @param id_branch 
     * @returns Promise Array
     */
   public getAllShops(id_branch:string){
     return new Promise((resolve, reject)=>{   
       this.vhMGDB_database.getDocsByFields('ecommerces', {id_branch:{$eq:id_branch}},{},{},0)
           .then((ecommerces:any)=>{                      
             resolve(ecommerces);         
           }, error=>{
             reject(error)
           })                        
     })    
   }
 
   /**
    * Hàm này dùng update thông tin cho các shop
    * this.vhEcommerce.updateShop('5fb6780ca2148e09806c5b01', {name:lazadashop, id_customer: 'soidfja9wfhwa'})
           .then((bool:any)=>{
             console.log(bool);
           }, error=>{
             console.log(error);
           })        
    * @param id_shop 
    * @param data 
    * @return Promise => bool = true or false
    */
     public updateShop(id_shop:string, data:object){//nhớ bỏ comment lazada, sendo, tiki khi chuyển qua thư viện này
       return new Promise((resolve, reject) => {   
         this.vhMGDB_database.getDoc('ecommerces', id_shop)
             .then((shop:any)=>{
               //console.log('shop', shop);
               if(shop){
                 let _data = {};
                 if(shop.data != undefined){
                   _data = {...shop.data, ...data};
                 }else{
                   _data = {...data};
                 }
                 this.vhMGDB_database.updateDoc('ecommerces', id_shop,{data:_data})
                     .then((bool:any)=>{  
                       for(let i=0; i<this.shoplistshopee.length; i++){
                         if(this.shoplistshopee[i]._id === id_shop){
                           this.shoplistshopee[i].data = _data;
                           break;
                         }
                       }  
                       for(let i=0; i<this.shoplisttiktok.length; i++){
                         if(this.shoplisttiktok[i]._id === id_shop){
                           this.shoplisttiktok[i].data = _data;
                           break;
                         }
                       }                  
                       // for(let i=0; i<this.shoplistlazada.length; i++){
                       //   if(this.shoplistlazada[i]._id === id_shop){
                       //     this.shoplistlazada[i].data = _data;
                       //     break;
                       //   }
                       // }
                       // for(let i=0; i<this.shoplistsendo.length; i++){
                       //   if(this.shoplistsendo[i]._id === id_shop){
                       //     this.shoplistsendo[i].data = _data;
                       //     break;
                       //   }
                       // }
                       // for(let i=0; i<this.shoplisttiki.length; i++){
                       //   if(this.shoplisttiki[i]._id === id_shop){
                       //     this.shoplisttiki[i].data = _data;
                       //     break;
                       //   }
                       // }
                       resolve(bool);
                     }, error=>{
                       reject(error);
                     })  
               }else{
                 resolve(false);
               }
             })
       })
     }
 
   /**
    * @example:
    * let backHref = http://localhost:4200/dashboard/overview';
     this.vhEcommerce.signInShopee(id_branch, backHref).then((bool:any)=>{
         if(bool){
           console.log('bool', bool)
         }
     })
    * @returns Promise => true or false
    */
     public signInShopee(id_branch:string, backHref?:any){
       return new Promise((resolve, reject)=>{           
         this.vhMGDB_shopee.signIn(id_branch, backHref)
                     .then((bool:any)=>{                               
                       resolve(bool);     
                     },(error:any)=>{
                       reject(error);
                     })      
       })    
     }
 
 /**
  * @example:
   this.vhEcommerce.signOutShopee('938476838whsofis').then((bool:any)=>{
       if(bool){
         console.log('bool', bool)
       }
   })
   * @param id_shop 
   * @returns Promise => true or false
   */
   public signOutShopee(id_shop:string){
     return new Promise((resolve, reject)=>{   
       this.vhMGDB_shopee.signOut(id_shop)
                   .then((result:any)=>{                                
                     if(result.vcode === 0){   
                       for(let i=0; i<this.shoplistshopee.length;i++){
                         if(this.shoplistshopee[i]._id === id_shop){
                           this.shoplistshopee.splice(i,1);
                           break;
                         }
                       }                             
                       for(let i=0; i<this.productlistshopees.length;i++){
                         if(this.productlistshopees[i]._id === id_shop){
                           this.productlistshopees.splice(i,1);
                           break;
                         }
                       }   
                       resolve(true)
                     }else{
                       //console.log(result.message);
                       reject(false);
                     }                   
                   },(error:any)=>{
                     reject(error);
                   })      
     })    
   } 
 
 /**
  * @example:
  * let id_branch = this.vhQuerySales.getDefaultBranch()._id; 
  * this.vhEcommerce.refreshLocalProductListShopee(id_branch)
         .then(()=>{
           do something.....
         })
  * Hàm này refresh giá trị mới nhất cho hàm getProductListShopee() trong localstorage
  * @return Promise => null
  */
   public refreshLocalProductListShopee(id_branch:string, shop_id?:string):any{
     return new Promise((resolve, reject) => { 
       if((shop_id!='')&&(shop_id!=undefined)){
         this.getProductListShopee(id_branch, shop_id)
             .then(()=>{resolve(null)});         
       }else{
         this.getProductListShopees(id_branch)
             .then(()=>{resolve(null)});     
       }
       
     })
   }
 
   /**
    * let localshoplistshopee = this.vhEcommerce.getlocalShopListShopee();
    * @returns 
    */
    public getlocalShopListShopee(){            
     return this.shoplistshopee;          
   }
 
 /**
  * @example:
  * let id_branch = this.vhQuerySales.getDefaultBranch()._id; 
  * this.vhEcommerce.getProductListShopee(id_branch).then(()=>{
         do something...
        },(error:any)=>{         
        })
  * @returns 
  */
   private getProductListShopee(id_branch:string, shop_id:string){
     return new Promise((resolve, reject)=>{       
       this.vhMGDB_shopee.getShop(id_branch, shop_id)
           .then((result_zero:any)=>{        
             //console.log('shopshopee', result_zero);                              
             if(result_zero.vcode === 0){          
               this.shoplistshopee = [...result_zero.data];  
               this.productlistshopees = [...result_zero.data];      
               let promise = new Array();             
               //console.log('this.productlistshopee', this.productlistshopee);
               for(let i=0; i<this.productlistshopees.length; i++){
                 promise[i] = new Promise((resolve, reject)=>{                   
                   this.vhMGDB_shopee.getProductList(this.productlistshopees[i].access_token, Number(this.productlistshopees[i]._id))//hàm này lấy về 1 lần và đã có chi tiết luôn rồi
                       .then((result_one:any)=>{ 
                         this.productlistshopees[i].productlist = result_one;    
                         resolve(null)                                                                   
                       },(error:any)=>{
                         console.log(error);
                         reject(error);
                       })                    
                 })              
               } 
               Promise.all(promise).then(()=>{    
                 console.log('productlistshopees', this.productlistshopees);                               
                 resolve(null);
               })
             }else{
               console.log(result_zero.message);
               reject(result_zero.message);
             }                   
           },(error:any)=>{
             reject(error);
           })     
     })   
   }
 
   private getProductListShopees(id_branch:string){
     return new Promise((resolve, reject)=>{       
       this.vhMGDB_shopee.getShopList(id_branch)
           .then((result_zero:any)=>{                                
             if(result_zero.vcode === 0){          
               this.shoplistshopee = [...result_zero.data];  
               this.productlistshopees = [...result_zero.data];      
               let promise = new Array();             
               //console.log('this.productlistshopee', this.productlistshopee);
               for(let i=0; i<this.productlistshopees.length; i++){
                 promise[i] = new Promise((resolve, reject)=>{                   
                   this.vhMGDB_shopee.getProductList(this.productlistshopees[i].access_token, Number(this.productlistshopees[i]._id))//hàm này lấy về 1 lần và đã có chi tiết luôn rồi
                       .then((result_one:any)=>{ 
                         this.productlistshopees[i].productlist = result_one;    
                         resolve(null)                                                                   
                       },(error:any)=>{
                         console.log(error);
                         reject(error);
                       })                    
                 })              
               } 
               Promise.all(promise).then(()=>{    
                 console.log('productlistshopees', this.productlistshopees);                               
                 resolve(null);
               })
             }else{
               console.log(result_zero.message);
               reject(result_zero.message);
             }                   
           },(error:any)=>{
             reject(error);
           })     
     })   
   }
 
   /**
  * @example: 
  * let productlistlazada = this.vhEcommerce.getlocalProductListShopee('ư0e4tuiwe98rhvqw9vtqw9t7rq987r9qvwn98et98');
  * @param id_shop 
  * @returns Promise => Array
  */
   public getlocalProductListShopee(id_shop:any){          
     for(let i=0; i<this.productlistshopees.length; i++){
       if(this.productlistshopees[i]._id === id_shop){            
         return cloneDeep(this.productlistshopees[i].productlist);           
       }
     }
     return []; 
   }
 
   /**
     * @example:
       this.vhEcommerce.getProductByItem_idShopee(access_token, product_id, id_shop).then((productshopee)=>{             
             console.log('productshopee', productshopee);             
       })
     * @returns Promise => object ={} or null
     */
     public getProductByItem_idShopee(access_token:string, item_id:number, id_shop:string){
       return new Promise((resolve, reject)=>{   
         this.vhMGDB_shopee.getProductByItem_id(access_token, item_id, Number(id_shop))
             .then((result:any)=>{   
                console.log('result', result);                                          
                if(result.vcode === 0){               
                  for(let i=0; i<this.productlistshopees.length;i++){
                    if(this.productlistshopees[i]._id == id_shop){
                      for(let j=0; j<this.productlistshopees[i].productlist.length;j++){
                        if(this.productlistshopees[i].productlist[j].item_id == item_id){
                          this.productlistshopees[i].productlist[j] = {...this.productlistshopees[i].productlist[j], ...result.data};
                          break;
                        }
                      }
                    }
                  }               
                  resolve(result.data);                                          
                }else{
                  console.log(result.message);
                  resolve(null);
                }                   
             },(error:any)=>{
               reject(error);
             })      
       })    
     }
   /**
    * @example:
    *let time_from = new Date('2021-10-28');
     let time_to = new Date('2021-10-30');
     let access_token = '4675cdb029b82eccb4a2a7e00b766a10';
     let id_shop = '29976825';
     this.vhEcommerce.getSalesOrderListShopee(time_from, time_to, access_token, id_shop)
         .then((result)=>{
             console.log('result', result);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param created_after 
    * @param created_before 
    * @param access_token 
    * @returns 
    */
   public getSalesOrderListShopee(time_from:any, time_to:any, access_token:string, id_shop:string){
     time_from = new Date(time_from);
     time_to = new Date(time_to);
     return new Promise((resolve, reject) => { 
       let promise_zero = new Promise((resolve, reject)=>{        
         this.vhMGDB_shopee.getOrderList(Math.floor(time_from.getTime()/1000), Math.floor(time_to.getTime()/1000), access_token, Number(id_shop))
             .then((response_one:any)=>{                        
               this.productlistshopees.forEach((item:any) => {
                 if(item._id === id_shop){
                   item.salesorderdetaillist = response_one;
                 }
               })                            
               resolve(response_one);
             },(error:any)=>{                   
               reject(error);
             })         
       })
       
       let promise_one = new Promise((resolve, reject)=>{
         let query = {create_time: {$gte:new Date(time_from), $lte: new Date(time_to)}};
         this.vhMGDB_database.getDocsByFields(id_shop, query, {},{},0)
             .then((salesorderlist:any)=>{                 
               resolve(salesorderlist);               
             })
       })   
 
       Promise.all([promise_zero, promise_one]).then((array:any)=>{           
         let newArray = array[0].filter((item:any)=>{
           let bool = true;
           array[1].forEach((item_one:any) => {                          
             if(item.order_sn.toString() === item_one._id){             
               bool = false;
             }            
           })          
           return bool;
         })           
         //Tạo 1 bản sao của bill này trong database viethas
         newArray.forEach((item:any) => {             
           this.vhMGDB_database.addDocbyID(id_shop.toString(), item.order_sn.toString(), {create_time: new Date(item.create_time*1000)});               
         })
         for(let i=0; i<array[0].length; i++){
           for(let j=0; j<array[1].length; j++){
             if(array[0][i].order_sn === array[1][j]._id){                   
               let _item = {...array[1][j]}; delete _item._id; delete _item.create_time; //lưu ý create_time trong db viethas và db shopee có kiểu khác nhau nên xóa đi khi chập 2 cái lại, nhằm tránh xung đột kiểu dữ liệu        
               array[0][i] = {...array[0][i], ..._item};                       
             }    
           }
         }            
         console.log('salesorderdetaillist', array[0]);    
         resolve(array[0]);        
       })
     })
   }
 
   /**
  * Hàm này lấy về chi tiết của một hóa đơn
  * @example
  * this.vhEcommerce.getSalesOrderDetailShopee('14424213387', '403754acaafc4564a16c19faa32d73c8', 'gsdr3454u54w34tfq')
         .then((salesorderdetail)=>{
           console.log('getSalesOrderDetailShopee', salesorderdetail);
         },(error:any)=>{
           console.log('error', error);
         })
  * @param order_sn 
  * @param access_token 
  * @param id_shop 
  * @returns Promise => obj ={} or null
  */
   public getSalesOrderDetailShopee(order_sn:string, access_token:string, id_shop:any){
     return new Promise((resolve, reject)=>{         
       let promise_zero = this.vhMGDB_shopee.getOrders(order_sn, access_token, id_shop);
       let promise_one = this.vhMGDB_database.getDoc(id_shop, order_sn);
       Promise.all([promise_zero, promise_one]).then((array:any)=>{              
         if(array[0].length>0){
           if(!array[1]){
             this.vhMGDB_database.addDocbyID(id_shop, array[0].order_sn, {create_time: new Date(array[0].create_time*1000)});  
           }               
           resolve(array[0][0]);
         }else resolve(null);
         
       })       
     })
   }
 
 /**
  * Hàm này lấy về tracking_number của một hóa đơn khi đơn chuyển sang trạng thái chờ lấy hàng
  * @example
  * this.vhEcommerce.getTrackingNumberShopee('14424213387', '403754acaafc4564a16c19faa32d73c8', 'gsdr3454u54w34tfq')
         .then((result)=>{
           console.log('getTrackingNumberShopee', result);
         },(error:any)=>{
           console.log('error', error);
         })
  * @param order_sn 
  * @param access_token 
  * @param id_shop 
  * @returns Promise => obj ={}
  */
   public getTrackingNumberShopee(order_sn:string, access_token:string, id_shop:any){
     return new Promise((resolve, reject)=>{         
       let promise_zero = this.vhMGDB_shopee.getTrackingNumber(order_sn, access_token, id_shop);
       let promise_one = this.vhMGDB_database.getDoc(id_shop, order_sn);
       Promise.all([promise_zero, promise_one]).then((array:any)=>{            
           if(array[1]){
             this.vhMGDB_database.updateDoc(id_shop, order_sn, {tracking_number: array[0].tracking_number});  
           }            
           resolve(array[0]);        
       },(error:any)=>{
         reject(error);
       })       
     })
   }
 
   /**
    * Tạo liên kết sản phẩm trên phần mềm quản lý bán hàng sales viethas và sản phẩm trên sàn shopee
  * @example:
  * let product = this.vhQuerySales.getlocalDetailProduct(id_sub_or_product);     
  * let id_branch = this.vhQuerySales.getDefaultBranch()._id;   
  * this.vhEcommerce.addMergeShopeesProduct_model(product,'tf3452345234', [{},{}], 'hjhjrtyur56u53')
         .then((bool:any)=>{
           console.log('addMergeShopeesProduct_model', bool);
         }, error=>{
           console.log('error', error);
         })
   * @param product : sản phẩm detailproduct trên phần mềm bán hàng 
   * @param item_id : trường item_id trong sản phẩm shopee      
   * @param modelArray : [{SkuId1,..},{SkuId2,..}]
   * @param id_shop 
   * @return Promise => boolean true or false
   */
   public addMergeShopeesProduct_model(product:any, item_id:string, modelArray:any, id_shop:string, id_branch:string){
     //console.log('product', product);
     return new Promise((resolve, reject) => {      
         //let id_branch = this.getDefaultBranch()._id;     
         //let product = this.getlocalProduct(id_product);   
         let obj = {
           item_id: item_id,
           id_shop: id_shop,
           model: [...modelArray]
         };
         if(product[id_branch] != undefined){
           if(product[id_branch].shopees === undefined) product[id_branch].shopees = new Array();             
         }else{
           product[id_branch]={};
           product[id_branch].shopees = new Array();
         }       
         let exist = false;
         //trường hợp đã có liên kết với sản phẩm trên sàn rồi, và muốn thêm liên kết với sản phẩm khác cùng loại
         for(let i=0; i<product[id_branch].shopees.length; i++){
           if((product[id_branch].shopees[i].item_id === item_id)&&(product[id_branch].shopees[i].id_shop === id_shop)){
             if(product[id_branch].shopees[i].model != undefined){
               product[id_branch].shopees[i].model = [...product[id_branch].shopees[i].model,...modelArray];         
             }else{
               product[id_branch].shopees[i].model = [...modelArray];     
             } 
             let value:any = {}; 
             value[id_branch] = product[id_branch];                                                  
             this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
                 .then(()=>{                   
                   resolve(true);
                 }, error=>{
                   reject(error)
                 })  
             exist = true;    
             break;                
           }
         }
         //trường hợp trước đây chưa có liên kết với sản phẩm trên sàn, giờ tạo liên kết
         if(!exist){
           product[id_branch].shopees.push(obj);
           let value:any = {}; 
           value[id_branch] = product[id_branch];                                        
           this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
               .then(()=>{                   
                 resolve(true);
               }, error=>{
                 reject(error)
               })   
         }                             
     })
   } 
   /**
  * @example:
  * let product = this.vhQuerySales.getlocalProduct(id_product);         
  * let id_branch = this.vhQuerySales.getDefaultBranch()._id;   
  * this.vhEcommerce.updateMergeShopeesProduct('5fb6780ca2148e09806c5b01', '435f34tf34f3243fdf', {hidden:true}, 'jfaosidfu9we87f9w')
           .then((bool:any)=>{
             console.log('updateMergeShopeesProduct', bool);
           }, error=>{
             console.log('error', error);
           })
  * @param product : sản phẩm detailproduct trên phần mềm bán hàng
  * @param item_id: trường item_id trong sản phẩm lazada
  * @param SkuId: trường SkuId trong sản phẩm lazada
  * @param data : {hidden:true}
  * @returns Promise => bool = true or false
  */
   public updateMergeShopeesProduct(product:any, item_id:string, data:any, id_shop:string, id_branch:string){//cái này dùng cho sendo
     return new Promise((resolve, reject) => {        
       if(product[id_branch] === undefined) return resolve(false);
       if(product[id_branch].shopees === undefined) return resolve(false);       
       let exist = false;      
       for(let i=0; i<product[id_branch].shopees.length; i++){
         if((product[id_branch].shopees[i].item_id === item_id)&&(product[id_branch].shopees[i].id_shop === id_shop)){
           product[id_branch].shopees[i] = {...product[id_branch].shopees[i],...data};
           let value:any = {}; 
           value[id_branch] = product[id_branch];    
           this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
               .then((bool:any)=>{                      
                 resolve(bool);
               }, error=>{
                 reject(error)
               })  
           exist = true;    
           break;
         }                 
       } 
       if(!exist) resolve(false);                      
                                             
     })
   }  
 
   /**
    *  @example:
    * let product = this.vhQuerySales.getlocalProduct(id_product);  
    * let id_branch = this.vhQuerySales.getDefaultBranch()._id;   
    * this.vhEcommerce.updateMergeShopeesProduct_model('5fb6780ca2148e09806c5b01', '435f34tf34f3243fdf', '13123135654', {xyz:true}, 'jfaosidfu9we87f9w')
             .then((bool:any)=>{
               console.log('updateMergeShopeesProduct_model', bool);
             }, error=>{
               console.log('error', error);
             })
   * @param product : sản phẩm detailproduct trên phần mềm bán hàng
   * @param item_id 
   * @param model_id : khác null, nếu null dùng hàm updateMergeShopeesProduct
   * @param data : object => data = {xyz:true}
   * @param id_shop 
   * @returns Promise => bool = true or false
   */
   public updateMergeShopeesProduct_model(product:any, item_id:number, model_id:number, data:any, id_shop:string, id_branch:string){
     return new Promise((resolve, reject) => {            
         if(product[id_branch] === undefined) return resolve(false);
         if(product[id_branch].shopees === undefined) return resolve(false);        
         let exist = false;
         for(let i=0; i<product[id_branch].shopees.length; i++){           
           if((product[id_branch].shopees[i].item_id === item_id)&&(product[id_branch].shopees[i].id_shop === id_shop)){
             //console.log('model_id',model_id);
             //console.log('product[id_branch].shopees[i]', product[id_branch].shopees[i]);
             if(product[id_branch].shopees[i].model != undefined)
               for(let j=0; j<product[id_branch].shopees[i].model.length; j++){
                 if(product[id_branch].shopees[i].model[j].model_id === model_id){
                   product[id_branch].shopees[i].model[j] = {...product[id_branch].shopees[i].model[j],...data};
                   let value:any = {}; 
                   value[id_branch] = product[id_branch];    
                   this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
                       .then((bool:any)=>{                      
                         resolve(bool);
                       }, error=>{
                         reject(error)
                       })  
                   exist = true;    
                   break;
                 }                  
               }  
           }
         } 
         if(!exist) resolve(false);                                                          
     })
   }  
 
   /**
    * @example:
    * let product = this.vhQuerySales.getlocalProduct(id_product);  
    * let id_branch = this.vhQuerySales.getDefaultBranch()._id; 
    * this.vhEcommerce.deleteMergeShopeeProduct_model('5fb67fda87c0f21d484cbdf3', 'gsdfgsdg4345324534t3w', 'sdfgsdfgererasds3563')
         .then((bool:any)=>{
           console.log('deleteMergeShopeeProduct_model', bool);
         }, error=>{
           reject(error)
         })
     * @param product : sản phẩm detailproduct trên phần mềm bán hàng
     * @param item_id 
     * @param model_id
     * @param id_shop  
     * @return Promise => bool = true or false
     */
   public deleteMergeShopeeProduct_model(product:any, item_id:number, model_id:number, id_shop:string, id_branch:string){
     return new Promise((resolve, reject) => {                            
       if(product[id_branch] === undefined) return resolve(false);
       if(product[id_branch].shopees === undefined) return resolve(false);        
       let exist = false;       
       for(let i=0; i<product[id_branch].shopees.length; i++){    
         if((product[id_branch].shopees[i].item_id === item_id)&&(product[id_branch].shopees[i].id_shop === id_shop)){      
           if(product[id_branch].shopees[i].model != undefined){
             for(let j=0; j<product[id_branch].shopees[i].model.length; j++){           
               if(product[id_branch].shopees[i].model[j].model_id === model_id){          
                 product[id_branch].shopees[i].model.splice(j,1);                   
                 let value:any = {}; 
                 value[id_branch] = product[id_branch];                        
                 this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
                     .then((bool:any)=>{
                       resolve(bool);
                     }, error=>{
                       reject(error)
                     }) 
                 exist = true;    
                 break;
               }
             }
             if(product[id_branch].shopees[i].model.length === 0){
               product[id_branch].shopees.splice(i,1);                 
               let value:any = {}; 
               value[id_branch] = product[id_branch];                       
               this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
                   .then((bool:any)=>{
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   }) 
               exist = true;                 
             }
           }
         }
       }
       if(!exist) resolve(false);                 
     })
   }
 
   /**
    * @notic : hàm này không thể cập nhật vô getlocalProductListShopee, do đó sau khi dùng hàm updateProductInfoByJSONshopee xong thì dùng thêm hàm getProductByIdShopee 
    * với các sản phẩm vừa cập nhật, lúc đó những gì vừa thay đổi mới đc cập nhật vô getlocalProductListShopee
    * @example:
    *  let json = {
         item_id : 3883480181,
         weight : 0.1
       }
       let access_token = '98efa569a4731bb67a8f76fed8808d66'
       let shop_id = '894793475932';
       this.vhEcommerce.updateProductInfoByJSONshopee( json, access_token).then((result)=>{
           console.log('result', result);
         },(error:any)=>{
           console.log('error', error);
         })
   * @param json 
   * @param access_token 
   * @param shop_id 
   * @returns 
   */
   public updateProductInfoByJSONshopee(json:any, access_token:string, shop_id:string){
     return new Promise((resolve, reject)=>{   
       this.vhMGDB_shopee.updateProductInfoByJSONshopee(json, access_token, Number(shop_id))
                   .then((result:any)=>{                                             
                     if(result.vcode === 0){                                
                         resolve(result.data);                                          
                     }else{
                       console.log(result.message);
                       resolve(null);
                     }                   
                   },(error:any)=>{
                     reject(error);
                   })      
     })    
   }
 
   /**
    * @notic : hàm này không thể cập nhật vô getlocalProductListShopee, do đó sau khi dùng hàm updateProductStockByJSONshopee xong thì dùng thêm hàm getProductByIdShopee
    * với các sản phẩm vừa cập nhật, lúc đó những gì vừa thay đổi mới đc cập nhật vô getlocalProductListShopee
    * @example:
    *  let json = {
         item_id: 4109868889,
         stock_list: [{
           model_id : 0,
           normal_stock : 48
         }]
       }
       let access_token = '98efa569a4731bb67a8f76fed8808d66'
       let shop_id = '894793475932';
       this.vhEcommerce.updateProductStockByJSONshopee( json, access_token).then((result)=>{
           console.log('result', result);
         },(error:any)=>{
           console.log('error', error);
         })
   * @param json 
   * @param access_token 
   * @param shop_id 
   * @returns 
   */
   public updateProductStockByJSONshopee(json:any, access_token:string, shop_id:string){
     return new Promise((resolve, reject)=>{   
       this.vhMGDB_shopee.updateProductStockByJSONshopee(json, access_token, Number(shop_id))
                   .then((result:any)=>{                                             
                     if(result.vcode === 0){                                
                         resolve(result.data);                                          
                     }else{
                       console.log(result.message);
                       resolve(null);
                     }                   
                   },(error:any)=>{
                     reject(error);
                   })      
     })    
   }
 
   /**
    * @notic : hàm này không thể cập nhật vô getlocalProductListShopee, do đó sau khi dùng hàm updateProductPriceByJSONshopee xong thì dùng thêm hàm getProductByIdShopee 
    * với các sản phẩm vừa cập nhật, lúc đó những gì vừa thay đổi mới đc cập nhật vô getlocalProductListShopee
    * @example:
    *  let json = {
           item_id: 9157723000,
           price_list: [{
             model_id : 75539801030,
             original_price : 7200000
           }]
         }
       let access_token = '98efa569a4731bb67a8f76fed8808d66'
       let shop_id = '894793475932';
       this.vhEcommerce.updateProductPriceByJSONshopee( json, access_token).then((result)=>{
           console.log('result', result);
         },(error:any)=>{
           console.log('error', error);
         })
   * @param json 
   * @param access_token 
   * @param shop_id 
   * @returns 
   */
   public updateProductPriceByJSONshopee(json:any, access_token:string, shop_id:string){
     return new Promise((resolve, reject)=>{   
       this.vhMGDB_shopee.updateProductPriceByJSONshopee(json, access_token, Number(shop_id))
                   .then((result:any)=>{                                             
                     if(result.vcode === 0){                                
                         resolve(result.data);                                          
                     }else{
                       console.log(result.message);
                       resolve(null);
                     }                   
                   },(error:any)=>{
                     reject(error);
                   })      
     })    
   }
 
   
 /**
  * Hàm này lấy về mảng các đơn hàng (salesorder) được lưu trong database viethas (ko phải database shopee)
  * @example
  * this.vhEcommerce.getSalesOrderShopee_fromViethas( ['14424213387','14424273835'], '403754acaafc4564a16c19faa32d73c8')
       .then((array:any)=>{
         console.log('array', array);
       },(error:any)=>{
         console.log('error', error);
       })
   * @param order_snArray 
   * @param id_shop 
   * @returns Promise => Array(object or null)
   */
   public getSalesOrderShopee_fromViethas(order_snArray:any, id_shop:string){
     return new Promise((resolve, reject) => {      
       let promise = new Array();
       for(let i=0; i<order_snArray.length; i++){
         promise[i] = this.vhMGDB_database.getDoc(id_shop, order_snArray[i]);
       }
       Promise.all(promise).then(array=>{  
         resolve(array);              
       })      
     })    
   }
 
   /**
  * Hàm này cập nhật các đơn hàng (salesorder) được lưu trong database viethas (ko phải database shopee), lưu ý các order_sn đc lấy từ shopee server về
  * @example:
  * this.vhEcommerce.updateSalesOrderShopee('5fb67fda87c0f21d484cbdf3', 'gsdfgsdg4345324534t3w', {check:true})
       .then((bool:any)=>{
         console.log('updateSalesOrderShopee', bool);
       }, error=>{
         reject(error)
       })
   * @param id_shop 
   * @param order_sn 
   * @param data 
   * @return Promise => bool = true or false
   */
   public updateSalesOrderShopee(id_shop:string, order_sn:string, data:object){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.updateDoc(id_shop, order_sn, data)
           .then((bool:any)=>{
             if(bool){              
               this.productlistshopees.forEach((item_zero:any) => {
                 if(item_zero._id === id_shop){
                   item_zero.salesorderdetaillist.forEach((item_one:any) => {
                     if(item_one.order_sn === order_sn){   
                       item_one = {...item_one, ...data};  
                     }
                   })  
                 }
               })                           
             }                   
             resolve(bool);     
           }, error=>{
             reject(error)
           })
     })   
   }
 
   /**
    * Hàm này cập nhật các đơn hàng (salesorder) được lưu trong database viethas (ko phải database shopee), lưu ý các order_sn đc import từ file ngoài vào (excel, csv...)
    * @example:
    * this.vhEcommerce.updateSalesOrderShopee_byFile(['144242133871', '14424213387'], {check:true}, 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdG9yZUlkIjoiNTczNjciLCJVc2VyTmFtZSI6IiIsIlN0b3JlU3RhdHVzIjoiMiIsIlNob3BUeXBlIjoiMCIsIlN0b3JlTGV2ZWwiOiIzIiwiZXhwIjoxNjMzODE3MzIwLCJpc3MiOiI1NzM2NyIsImF1ZCI6IjU3MzY3In0.9S18n7EuG7XxbZVm9kjUBozJVjx2_EZRNAn38wBUaDs', '403754acaafc4564a16c19faa32d73c8')
           .then((array:any)=>{
             console.log('updateSalesOrderShopee_byFile', array);
           }, error=>{
             console.log(error)
           })
     * @param order_snArray 
     * @param data
     * @param access_token 
     * @param id_shop 
     * @return Promise => Array(bool) = [true or false,,...]
     */
   public updateSalesOrderShopee_byFile(order_snArray:any, data:object, access_token:string, id_shop:string){//hàm này sẽ sửa lại vì 1 request có thể lấy về đc nhiều orders
     return new Promise((resolve, reject) => {  
       let promise = new Array();
       for(let i=0; i<order_snArray.length; i++){
         promise[i] = new Promise(resolve=>{
           this.vhMGDB_shopee.getOrders(order_snArray[i], access_token, Number(id_shop))
               .then((salesorderdetail)=>{
                 if(salesorderdetail){
                   this.vhMGDB_database.getDoc(id_shop, order_snArray[i])
                       .then((salesorder)=>{
                         if(salesorder){
                           this.vhMGDB_database.updateDoc(id_shop, order_snArray[i], data)
                               .then((bool:any)=>{
                                 resolve(bool);
                               }, ()=>{
                                 resolve(false);
                               })
                         }else{
                           this.vhMGDB_database.addDocbyID(id_shop, order_snArray[i], data)
                               .then(()=>{
                                 resolve(true);
                               })
                         }                   
                       })
                   
                 }else{
                   resolve(false)
                 }            
               }, ()=>{
                 //reject(error)
                 resolve(false)
               })     
         })
       }
       Promise.all(promise).then(array=>{
         resolve(array)
       })
     })   
   }

   /**
    * Hàm này lấy về chi tiết thanh toán của hóa đơn
    * @param order_sn: id của hóa đơn shopee
    * @param access_token 
    * @param id_shop 
    */
    public getEscrowShopee(order_sn:any, access_token:string, shop_id:number){
      return new Promise((resolve, reject)=>{   
       this.vhMGDB_shopee.getEscrow(order_sn, access_token, Number(shop_id))
                   .then((payment:any)=>{                                                                           
                      resolve(payment);                                                            
                   },(error:any)=>{
                     reject(error);
                   })      
     })    
   }
 
 }
 
/*
 let access_token = this.vhAlgorithm.localStorageGET(this.getProjectName() + '_' + this.vhMGDB_auth.getDatabase() + '_autoweb_design_enduser');
  if(!access_token) return resolve({vcode:11, msg: 'not logged in'});    
    let auth = {dbstorage: this.vhAuth.getDBstorage(), projectname: this.getProjectName(), projectname_build: 'vhdevweb'};   
    let body = {db: this.vhMGDB_auth.getDatabase(), id_subproject, hosting, cloning_options, auth};   
    const options = {       
      headers: {          
        Authorization: 'Bearer ' + access_token
      }
    };
*/
@Injectable()
export class VhEinvoice{
  constructor(
    private vhAlgorithm: VhAlgorithm,
    private vhMGDB_auth: VhMGDB_auth,
   ){}

  /**
   * Hàm đăng nhập vào M-invoice để lấy token
   * @example
   * this.vhEinvoice.signin_byMinvoice(taxcode, username, password)
          .then((data)=>{    
            //-----------your code here-----------                      
          },(error:any)=>{
              console.log('error', error)
          })
   * @param taxcode 
   * @param username 
   * @param password 
   * @returns Promise => obj
   * {"code": "00", "message": "Thành công", "ok": true, "token": "O87316arj5......."}
   * {"code": "99", "message": "Tên đăng nhập hoặc mật khẩu không đúng", "ok": false, "error": "Tên đăng nhập hoặc mật khẩu không đúng"}
   */
  public signin_byMinvoice(taxcode:string, username:string, password:string){
    return new Promise<any>((resolve, reject)=>{         
      let body = {username, password, ma_dvcs: 'VP'}; 
      axios.post(`https://${taxcode}.minvoice.app/api/Account/Login`, {...body})
            .then((response:any)=> {        
              resolve(response.data);                             
            })
            .catch((e:any)=> {                    
              reject(e.response.data);
            })
    })
  }

/**
 * Hàm lấy về danh sách các ký tự hóa đơn đẵ đăng ký với thuế
 * @example
 * this.vhEinvoice.getTypeInvoiceSeries_byMinvoice(taxcode, token, Type)
        .then(()=>{    
          //-----------your code here-----------                      
        },(error:any)=>{
            console.log('error', error)
        })
  * @param taxcode 
  * @param token 
  * @param Type 
  * Ý nghĩa Type:
  * 1: Hóa đơn giá trị gia tăng
  * 2: Hóa đơn bán hàng
  * 5: Tem vé thẻ
  * 6: Phiếu xuất kho (Kiêm vận chuyển nội bộ, gửi bán đại lý)
  * @returns Promise => obj
  * {"code": "00", "message": “Thành công”, "ok": true, "data": [{"id": "3a08d649-2284-2577-7b7d-91a284f25eb3", "quanlykyhieu68_id": "6252b95a-b64e-4ccf-b76b-ac812ae1efc0", "khhdon": "6C23NYY", "value": "6C23NYY", "invoiceForm": "6", "invoiceYear": 23, "number": null, "orders": null, "invoiceTypeName": "Phiếu xuất kho kiêm vận chuyển nội bộ"}]
  * {"code": "3", "message": "Token hết hạn hoặc không đúng vui lòng kiểm tra lại!", "error": "Token hết hạn hoặc không đúng vui lòng kiểm tra lại!",	"ok": false}
  */
  public getTypeInvoiceSeries_byMinvoice(taxcode:string, token: string, Type?:number){
    return new Promise<any>((resolve, reject)=>{   
      const options = {       
        //params: { Type },
        headers: {          
          Authorization: 'Bearer ' + token
        }
      };
      axios.get(`https://${taxcode}.minvoice.app/api/Invoice68/GetTypeInvoiceSeries`, options)
          .then((response:any)=> {                        
            resolve(response.data);     
          })
          .catch((e:any)=> {                          
            reject(e.response.data);
          });
    })
  }

   /**
 * Xem in hoá đơn thông qua id của hoá đơn và keyApi tích hợp từ đối tác
 * @example
 * this.vhEinvoice.getPrintInvoice_byMinvoice(taxcode, token, params)
        .then(()=>{    
          //-----------your code here-----------                      
        },(error:any)=>{
            console.log('error', error)
        })
  * @param taxcode 
  * @param token 
  * @param params: 
  * Ý nghĩa params:
  * {id: '3a06a343-ff4d-21cd-fe31-2c5a0824636f'} : Xem in hoá đơn thông qua id của hoá đơn
  * id: ID hóa đơn do M-Invoice trả về
  * {keyApi: '720rv2222Q'} : Xem in hoá đơn thông qua thông qua keyApi tích hợp từ đối tác
  * keyApi: Key tích hợp từ đối tác truyền sang
  * @returns Promise => {"code": "00",	"message": "Thành công"}
  */
  public getPrintInvoice_byMinvoice(taxcode:string, token: string, params:any){
    return new Promise<any>((resolve, reject)=>{   
      let options = {       
        params,
        headers: {          
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token
        },
        responseType: 'blob' as const  // Quan trọng để nhận dạng dữ liệu file
      };
      axios.get(`https://${taxcode}.minvoice.app/api/InvoiceApi78/PrintInvoice`, options)
          .then((response:any)=> {                        
            resolve(response.data);     
          })
          .catch((e:any)=> {                          
            reject(e.response.data);
          });
    })
  }

/**
 * Hàm tra cứu mã số thuế
 * @example
 * this.vhEinvoice.searchTaxCodeV2_byMinvoice(tax)
        .then(()=>{    
          //-----------your code here-----------                      
        },(error:any)=>{
            console.log('error', error)
        })
  * @param tax 
  * @returns Promise => obj
  */
  public searchTaxCodeV2_byMinvoice(tax:string){
    return new Promise<any>((resolve, reject)=>{   
      const options = {       
        params: { tax }
      };
      axios.get(`https://mst.minvoice.com.vn/api/System/SearchTaxCodeV2`, options)
          .then((response:any)=> {                        
            resolve(response.data);     
          })
          .catch((e:any)=> {                          
            reject(e.response.data);
          });
    })
  }

  /**
 * Lấy thông tin hoá đơn thông qua id hóa đơn hoặc keyApi tích hợp từ đối tác
 * @example
 * this.vhEinvoice.getInfoInvoice_byMinvoice(taxcode, token, params)
        .then(()=>{    
          //-----------your code here-----------                      
        },(error:any)=>{
            console.log('error', error)
        })
  * @param taxcode 
  * @param token 
  * @param params: 
  * Ý nghĩa params:
  * {number: 2, seri: '1C22TMX'} : Lấy thông tin hoá đơn thông qua Ký hiệu và Số hoá đơn 
  * seri: Ký hiệu hóa đơn theo nghị định 123 cần lấy thông tin ('1C22TMX')
  * number: Số hóa đơn cần lấy thông tin (1,2,3...)
  * {id: '3a06a343-ff4d-21cd-fe31-2c5a0824636f'} : Lấy thông tin hoá đơn thông qua id tích hợp từ đối tác
  * id: ID hóa đơn do M-Invoice trả về
  * {keyApi: '720rv2222Q'} : Lấy thông tin hoá đơn thông qua keyApi tích hợp từ đối tác
  * keyApi: Key tích hợp từ đối tác truyền sang
  * @returns Promise => {"code": "00",	"message": "Thành công"}
  */
  public getInfoInvoice_byMinvoice(taxcode:string, token: string, params:any){
    return new Promise<any>((resolve, reject)=>{   
      const options = {       
        params,
        headers: {          
          Authorization: 'Bearer ' + token
        }
      };
      axios.get(`https://${taxcode}.minvoice.app/api/InvoiceApi78/GetInfoInvoice`, options)
          .then((response:any)=> {                        
            resolve(response.data);     
          })
          .catch((e:any)=> {                          
            reject(e.response.data);
          });
    })
  }

/**
 * Hàm lấy file xml thông qua id của hoá đơn
 * @example
 * this.vhEinvoice.exportXml_byMinvoice(taxcode, token, params)
        .then(()=>{    
          //-----------your code here-----------                      
        },(error:any)=>{
            console.log('error', error)
        })
  * @param taxcode 
  * @param token 
  * @param params: 
  * Ý nghĩa params:
  * {id: '3a06a343-ff4d-21cd-fe31-2c5a0824636f'} : Lấy thông tin hoá đơn thông qua id tích hợp từ đối tác
  * id: ID hóa đơn do M-Invoice trả về
  * @returns Promise => {"code": "00",	"message": "Thành công"}
  */
   public exportXml_byMinvoice(taxcode:string, token: string, params:any){
    return new Promise<any>((resolve, reject)=>{   
      const options = {       
        params,
        headers: {          
          Authorization: 'Bearer ' + token
        }
      };
      axios.get(`https://${taxcode}.minvoice.app/api/InvoiceApi78/ExportXml`, options)
          .then((response:any)=> {                        
            resolve(response.data);     
          })
          .catch((e:any)=> {                          
            reject(e.response.data);
          });
    })
  }

  /**
   * Hàm lấy thông tin hóa đơn từ ngày - đến ngày và ký hiệu
   * @example
   * this.vhEinvoice.getInvoices_byMinvoice(taxcode, token, query)
          .then((data)=>{    
            //-----------your code here-----------                      
          },(error:any)=>{
              console.log('error', error)
          })
   * @param taxcode 
   * @param editmode 
   * @param query: {
            "tuNgay": "2024-01-01",
            "denngay": "2024-01-29",
            "khieu": "1K24TDN",
            "start": 0,
            "count": 20,
            "coChiTiet": true
          } 
   * @returns Promise => {"code": "00",	"message": null,	"ok": true,	"total": 4, "data": [{},{}...]}
   */
  public getInvoices_byMinvoice(taxcode:string, token:string, query:any){
    return new Promise<any>((resolve, reject)=>{         
      const options = {       
        headers: {          
          Authorization: 'Bearer ' + token
        }
      };
      let body = {query};       
      axios.post(`https://${taxcode}.minvoice.app/api/InvoiceApi78/GetInvoices`, {...body}, options)
            .then((response:any)=> {        
              resolve(response.data);                             
            })
            .catch((e:any)=> {                    
              reject(e.response.data);
            })
    })
  }

  /**
   * Hàm Thêm mới, sửa, xóa hóa đơn Chờ ký
   * @example
   * this.vhEinvoice.saveInvoice_noSign_byMinvoice(taxcode, token, editmode, data)
          .then((data)=>{    
            //-----------your code here-----------                      
          },(error:any)=>{
              console.log('error', error)
          })
   * @param taxcode 
   * @param token 
   * @param editmode 
   * @param data 
   * @returns Promise => {code, message, ok, data}
   * {code: "00",	message: null,	ok: true,	data: {}} //Gửi CQT thành công
   * {code: "88", error: "Trùng key tích hợp", message: "Trùng key tích hợp", ok: false} //Hóa đơn này đã được gửi trước đây
   * {code: "29442", message: "Delete invoice error because the number invoice is sequential", ok: false, error: "Delete invoice error because the number invoice is sequential"}}
   */
  public saveInvoice_noSign_byMinvoice(taxcode:string, token: string, editmode:number, data:any){
    return new Promise<any>((resolve, reject)=>{         
      const options = {       
        headers: {          
          Authorization: 'Bearer ' + token
        }
      };
      let body = {editmode, data};       
      axios.post(`https://${taxcode}.minvoice.app/api/InvoiceApi78/Save`, {...body}, options)
            .then((response:any)=> {        
              resolve(response.data);                             
            })
            .catch((e:any)=> {                    
              reject(e.response.data);
            })
    })
  }
 
    /**
     * Hàm Thêm mới, sửa, xóa hóa đơn Chờ ký
     * @example
     * this.vhEinvoice.saveInvoice_Sign_byMinvoice(taxcode, token, editmode, data)
            .then((data)=>{    
              //-----------your code here-----------                      
            },(error:any)=>{
                console.log('error', error)
            })
    * @param taxcode
    * @param token 
    * @param editmode 
    * @param data 
    * @returns Promise => {"code": "00",	"message": null,	"ok": true,	"data": {}}
    * {code: "29442", message: "Delete invoice error because the number invoice is sequential", ok: false, error: "Delete invoice error because the number invoice is sequential"}}
    */
  public saveInvoice_Sign_byMinvoice(taxcode:string, token: string, editmode:number, data:any){
    return new Promise<any>((resolve, reject)=>{         
      const options = {       
        headers: {          
          Authorization: 'Bearer ' + token
        }
      };
      let body = {editmode, data};       
      axios.post(`https://${taxcode}.minvoice.app/api/InvoiceApi78/SaveSign`, {...body}, options)
            .then((response:any)=> {        
              resolve(response.data);                             
            })
            .catch((e:any)=> {                    
              reject(e.response.data);
            })
    })
  }

  /**
   * Hàm ký hóa đơn
   * @example
   * this.vhEinvoice.signInvoice_byMinvoice(taxcode, token, editmode, data)
          .then((data)=>{    
            //-----------your code here-----------                      
          },(error:any)=>{
              console.log('error', error)
          })
   * @param taxcode 
   * @param token 
   * @param hoadon68_id : "5fc578a6-1ca1-46f9-ab4f-6a0de4b54c32"
   * @returns Promise => {"code": "00",	"message": null,	"ok": true,	"data": {}}
   * {code: "00",	message: null,	ok: true,	data: {}} //Gửi thành công
   */
  public signInvoice_byMinvoice(taxcode:string, token: string, hoadon68_id:string){
    return new Promise<any>((resolve, reject)=>{         
      const options = {       
        headers: {          
          Authorization: 'Bearer ' + token
        }
      };
      let body = {hoadon68_id};       
      axios.post(`https://${taxcode}.minvoice.app/api/InvoiceApi78/Sign`, {...body}, options)
            .then((response:any)=> {        
              resolve(response.data);                             
            })
            .catch((e:any)=> {                    
              reject(e.response.data);
            })
    })
  }
 
  /**
   * Hàm hủy hóa đơn
   * @example
   * this.vhEinvoice.deleteInvoice_byMinvoice(taxcode, token, inv_InvoiceAuth_id, ngayvb, ghi_chu)
          .then((data)=>{    
            //-----------your code here-----------                      
          },(error:any)=>{
              console.log('error', error)
          })
   * @param taxcode 
   * @param token 
   * @param inv_InvoiceAuth_id : "26da72ec-a3c4-49d0-90de-2d6a9fb2bdab"
   * @param ngayvb : "2022-09-11" 
   * @param ghi_chu : "Sai thông tin tổng tiền hóa đơn, chưa gửi cho khách hàng"
   * @returns Promise => {"code": "00",	"message": "Thành công"}
   */
  public deleteInvoice_byMinvoice(taxcode:string, token: string, inv_InvoiceAuth_id:string, ngayvb:string, ghi_chu:string){
    return new Promise<any>((resolve, reject)=>{         
      const options = {       
        headers: {          
          Authorization: 'Bearer ' + token
        }
      };
      let body = {inv_InvoiceAuth_id, ngayvb, ghi_chu};       
      axios.post(`https://${taxcode}.minvoice.app/api/InvoiceApi78/HuyHoaDon`, {...body}, options)
            .then((response:any)=> {        
              resolve(response.data);                             
            })
            .catch((e:any)=> {                    
              reject(e.response.data);
            })
    })
  }

  /**
   * Hàm điều chỉnh hóa đơn
   * @example
   * this.vhEinvoice.updateInvoice_byMinvoice(taxcode, token, inv_InvoiceAuth_id, inv_invoiceIssuedDate, data)
          .then((data)=>{    
            //-----------your code here-----------                      
          },(error:any)=>{
              console.log('error', error)
          })
   * @param taxcode 
   * @param token 
   * @param inv_InvoiceAuth_id : "26da72ec-a3c4-49d0-90de-2d6a9fb2bdab"
   * @param inv_invoiceIssuedDate : "2022-09-11"
   * @param data
   * @returns Promise => {"code": "00",	"message": "Thành công"}
   */
  public updateInvoice_byMinvoice(taxcode:string, token: string, inv_InvoiceAuth_id:string, inv_invoiceIssuedDate:string, data:any){
    return new Promise<any>((resolve, reject)=>{         
      const options = {       
        headers: {          
          Authorization: 'Bearer ' + token
        }
      };
      let body = {inv_InvoiceAuth_id, inv_invoiceIssuedDate, data};       
      axios.post(`https://${taxcode}.minvoice.app/api/InvoiceApi78/DieuChinh`, {...body}, options)
            .then((response:any)=> {        
              resolve(response.data);                             
            })
            .catch((e:any)=> {                    
              reject(e.response.data);
            })
    })
  }

  /**
   * Hàm thay thế hóa đơn
   * @example
   * this.vhEinvoice.replaceInvoice_byMinvoice(taxcode, token, data)
          .then((data)=>{    
            //-----------your code here-----------                      
          },(error:any)=>{
              console.log('error', error)
          })
   * @param taxcode 
   * @param token 
   * @param data
   * @returns Promise => {"code": "00",	"message": "Thành công"}
   */
  public replaceInvoice_byMinvoice(taxcode:string, token: string, data:any){
    return new Promise<any>((resolve, reject)=>{         
      const options = {       
        headers: {          
          Authorization: 'Bearer ' + token
        }
      };
      let body = {data};       
      axios.post(`https://${taxcode}.minvoice.app/api/InvoiceApi78/ThayThe`, {...body}, options)
            .then((response:any)=> {        
              resolve(response.data);                             
            })
            .catch((e:any)=> {                    
              reject(e.response.data);
            })
    })
  }


}


 @Injectable()
 export class VhQuerySales{    
 
  private paymentIOS = false;

  private restriction_main_package:any = null;
  private restriction_ecommerce_package:any = null;
  private restriction_facebook_package:any = null;
  private restriction_warranty_package:any = null;
  
  private productlistsendo: any = new Array();
  private shoplistsendo: any = new Array();
  
  private productlistlazada: any = new Array();
  private shoplistlazada: any = new Array();

  private productlisttikis: any = new Array();
  private shoplisttiki: any = new Array();

  private products: any = new Array();
  private detailproducts: any = new Array();
  private rawproducts: any = new Array();
  private customers: any = new Array();
  private suppliers: any = new Array();
  private wallets: any = new Array();
  private taxs: any = new Array();
  private categorys: any = new Array();
  private inventorytimes: any = new Array();
  private warrantys: any = new Array();
  private discount_bills: any = new Array();
  private discount_saless: any = new Array();
  private customer_classs: any = new Array();
  private commissions: any = new Array();
  private deliverys: any = new Array();
  private addresss: any = new Array();
  private incoming_groups: any = new Array();
  private spending_groups: any = new Array();
  private branchs: any = new Array();
  private promotions: any = new Array();
  private print_pages: any = new Array();
  private printers: any = new Array();
  private hwinfo: any = {};
  private appsettingstations: any = new Array();
  private appsettingbranchs: any = new Array();
  
  private subjectwallets = new Subject<any>();
  private subjectappsettingstations = new Subject<any>();
  private subjectappsettingbranchs = new Subject<any>();
  private subjectbranchs = new Subject<any>();
  private subjectcategorys = new Subject<any>();
  private subjectcustomers = new Subject<any>();
  private subjectinventorytimes = new Subject<any>();
  private subjectprinters = new Subject<any>();
  private subjectproducts = new Subject<any>();
  private subjectpromotions = new Subject<any>();
  private subjectsuppliers = new Subject<any>();
  private subjecttaxs = new Subject<any>();
  private subjectwarrantys = new Subject<any>(); 
  private subjectdiscount_bills = new Subject<any>(); 
  private subjectcustomer_classs = new Subject<any>(); 

  private callbacksyncopeningbill:Subscription = new Subscription();
  private listbill_bybilltype:any= new Array();
  private callback1syncbilltype:Subscription = new Subscription();
  private callback2syncbilltype:Subscription = new Subscription();
  private sync_code:any =  Math.random().toString(36).substr(2, 10).toUpperCase();

  private colname_array = new Array();

  constructor(
    //private cps: Check_Parameters_Sales,
    
    private vhEinvoice: VhEinvoice, 
    private vhMGDB_auth: VhMGDB_auth, 
    private vhMGDB_rootdatabase: VhMGDB_rootdatabase, 
    private vhMGDB_database: VhMGDB_database, 
    private vhMGDB_socketMongoDB: VhMGDB_socketMongoDB, 
    private vhMGDB_tiki: VhMGDB_tiki, 
    private vhMGDB_sendo: VhMGDB_sendo,
    private vhMGDB_lazada: VhMGDB_lazada,
    private vhMGDB_socketFacebook: VhMGDB_socketFacebook,      
    private vhMGDB_paymentVNPAY: VhMGDB_paymentVNPAY, 
    
    private vhQuery:VhQuery, 
    private vhAuth: VhAuth, 
    private vhAlgorithm:VhAlgorithm, 
    private vhDisplayLEDService :VhDisplayLEDService, 
    private iap2: InAppPurchase2,
    private platform: Platform
    ) {    
  
    Device.getId().then((info:any)=>{       
      let local_hwinfo = this.vhAuth.localStorageGET('hwinfo');
      if((local_hwinfo != null)&&(local_hwinfo != undefined)){
        this.hwinfo = local_hwinfo;        
      }else{
        this.hwinfo = {uuid: info.identifier};    
        this.vhAuth.localStorageSET('hwinfo',this.hwinfo);        
      }           
    });   
    //this.syncCollection();   
  }

  public fix_loi_kieu_du_lieu_barcode(){
    return new Promise((resolve, reject) => {
      let products = this.getlocalProducts(3);
      let promise = [];
      for(let i=0; i<products.length; i++){
        if(products[i].manysize === false){          
            let units = products[i].units;
            let exist = false;
            for(let j=0; j<units.length; j++){
              if(typeof units[j].barcode === 'number'){
                units[j].barcode = units[j].barcode + '';
                exist = true;                
              }
            }             
            if(exist) {
              //console.log('--------product_name', products[i].name);
              promise[promise.length] = this.vhMGDB_database.updateDoc('products', products[i]._id, {units:units})                
            }
        }
      }    
      Promise.all(promise).then(()=>{              
              resolve(null);
            }, error=>{
              console.log('error', error);
              reject(error);
            })          
    })
  }

  /**
   * this.vhQuerySales.fix_mot_lan_duy_nhat_inventory_null()
          .then(()=>{
            console.log('fix_mot_lan_duy_nhat_inventory_null');
          }, error=>{
            console.log(error);
          })
   */
  public fix_mot_lan_duy_nhat_inventory_null(){
    return new Promise((resolve, reject) => {
      let products = this.getlocalDetailProducts(3);
      let id_branch = this.getDefaultBranch()._id;     
      let promise = [];
      for(let i=0; i<products.length; i++){
		  if(products[i][id_branch + '_ivtr'] != undefined){
			let val:any = {};
			val[id_branch + '_ivtr'] = null;             
			promise[promise.length] = this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, val)     
		  }       
      }    
      Promise.all(promise).then(()=>{              
              resolve(null);
            }, error=>{
              console.log('error', error);
              reject(error);
            })          
    })
  }

/**
* Hàm trả về năm của billdate
* @param billdate 
* @returns 
*/
  private getYear(billdate:any){
   return (new Date(billdate)).getFullYear();
  }

  /**
   * Hàm trả về mảng (năm), gồm những năm từ năm tạo shop (thời điểm khách dùng phần mềm) đến năm hiện tại
   * @returns 
   */
  private getYearsArray(){
   let startyear = (new Date(this.vhAuth.getStore()?.registrationdate)).getFullYear();
   let endyear = (new Date()).getFullYear(); 
   let arr_years = new Array();
   arr_years.push(startyear);
   while(arr_years[arr_years.length-1] <endyear){
     arr_years.push(arr_years[arr_years.length-1] + 1);
   }
   return arr_years;
  }
  /**
   * Hảm trả về mảng năm liên tiếp tương ứng trường date có trong tham số query truyền vào
   * @param query 
   * @returns 
   */
  private getYearsArray_fromQuery(query:any){
   let vals = new Array();
   let query_years = new Array();
   for(const p in query){
     if(p=='date'){
       for(const q in query[p]){         
         vals.push(query[p][q].getFullYear());                      
       }
     }
   }
   //loại bỏ những phần tử có giá trị trùng nhau trong mảng
   vals = [...new Set(vals)];
   if(vals.length == 0){
     query_years = this.getYearsArray();
   }else if(vals.length == 1){
     query_years.push(vals[0]);
   }else if(vals.length == 2){
     //sắp xếp tăng dần
     vals = vals.sort((n1:any, n2:any) => {
       if (n1 > n2) return 1;
       return -1;
     });
     //tạo mạng những năm liên tiếp
     for (let i = vals[0]; i <= vals[1]; i++) {
       query_years.push(i);
     }
   }
   //console.log('query_years', query_years)
   return query_years;
  }

  
/**
 * Hàm này lấy về các trường trong phạm vi quản lý bán hàng trong cài đặt
  * @example:
  * let branch_management_scope = this.vhQuerySales.getBranch_Management_Scope();        
  * @return Object = {product_scope, employee_scope, customer_scope, supplier_scope, sales_program_scope}
  *  => true áp dụng cho toàn chi nhánh, false áp dụng riêng cho từng chi nhánh
  */
  public getBranch_Management_Scope(){    
    if(this.vhAuth.getStore().branch_management_scope != undefined){
      let branch_management_scope = {...this.vhAuth.getStore().branch_management_scope};
      if(branch_management_scope.product_scope === undefined) branch_management_scope.product_scope = true;
      if(branch_management_scope.employee_scope === undefined) branch_management_scope.employee_scope = true;
      if(branch_management_scope.customer_scope === undefined) branch_management_scope.customer_scope = true;
      if(branch_management_scope.supplier_scope === undefined) branch_management_scope.supplier_scope = true;
      if(branch_management_scope.sales_program_scope === undefined) branch_management_scope.sales_program_scope = true;
      return branch_management_scope;
    }else{
      return {product_scope:true, employee_scope:true, customer_scope: true, supplier_scope:true, sales_program_scope:true}
    }
  }

  /**
   * Hàm này cấp nhật lại các trường trong phạm vi quản lý bán hàng trong cài đặt
   * @example:
   * this.vhQuerySales.updateBranch_Management_Scope({product_scope:1, employee_scope:1, customer_scope:1, supplier_scope:1, sales_program_scope:2})
          .then(()=>{
            console.log('updateBranch_Management_Scope');
          }, error=>{
            reject(error);
          })
   * @param value = {product_scope, employee_scope, customer_scope, supplier_scope, sales_program_scope}
   * true áp dụng cho toàn chi nhánh, false áp dụng riêng cho từng chi nhánh
   * @return Promise => udefined/error
   */
  public updateBranch_Management_Scope(value:any){    
    return new Promise((resolve, reject) => {
      let branch_management_scope:any = this.getBranch_Management_Scope();        
      for(const q in value){                   
        branch_management_scope[q] = value[q];            
      }     
      this.vhMGDB_database.updateDoc_onRootCollectionsFirebase('stores', this.vhMGDB_auth.getDatabase(), {branch_management_scope})
            .then(()=>{        
              this.vhMGDB_auth.setStore({branch_management_scope})                    
              resolve(undefined);  
            }, error=>{
              reject(error);
            })
    })
  }

  /**
   * @description: hàm này lấy về những hạn chế của gói main_package trong localstorage
   * @example
   * let restriction_main_package = this.vhQuerySales.getLocalRestrictionMainPackage();         
   * @return Object => obj ={} or null
   */
    public getLocalRestrictionMainPackage(){
      let id_branch = this.getDefaultBranch()._id;
      this.restriction_main_package = {...this.vhAuth.getStore()[id_branch]['main_package_expire']}
      delete this.restriction_main_package.id_restriction;    
      delete this.restriction_main_package.id_package;
      delete this.restriction_main_package.id_licenseKEY;
      return this.restriction_main_package;
    }


  /**
   * @description: hàm này lấy về những hạn chế của gói ecommerce_package trong localstorage
   * @example
   * let restriction_ecommerce_package = this.vhQuerySales.getLocalRestrictionEcommercePackage();         
   * @return Object => obj ={} or null
   */
    public getLocalRestrictionEcommercePackage(){
      return this.restriction_ecommerce_package;
    }
 

  /**
   * @description: hàm này lấy về những hạn chế của gói facebook_package trong localstorage
   * @example
   * let restriction_facebook_package = this.vhQuerySales.getLocalRestrictionFacebookPackage();         
   * @return Object => obj ={} or null
   */
    public getLocalRestrictionFacebookPackage(){
      return this.restriction_facebook_package;
    }


  /**
   * @description: hàm này lấy về những hạn chế của gói warranty_package trong localstorage
   * @example
   * let restriction_warranty_package = this.vhQuerySales.getLocalRestrictionWarrantyPackage();         
   * @return Object => obj ={} or null
   */
    public getLocalRestrictionWarrantyPackage(){
      return this.restriction_warranty_package;
    }

/**
 * Hàm callback BÌNH LUẬN trên fanpage có id là id_fanpage
 * @example:
 * this.vhQuerySales.observableWebhookFeedFacebook('102622138931525').subscribe((entry:any) => {          
      console.log('entry', entry);
    })       
  
  ngOnDestroy(){
    this.vhQuerySales.unsubscribeWebhookFeedFacebook('102622138931525');  
  }
  * @returns Observerble (Object) => obj = {id, time, changes}
  */
  public observableWebhookFeedFacebook(id_fanpage:string){   
    return new Observable((observer:any) => {    
      this.vhMGDB_socketFacebook.observableWebhookFeed(id_fanpage).subscribe((messages) => {   
        observer.next(messages);
      })      
    })
  }

  /**
   * hàm disable calback BÌNH LUẬN
   * @example:
   * this.vhQuerySales.unsubscribeWebhookFeedFacebook('102622138931525');       
  */
  public unsubscribeWebhookFeedFacebook(id_fanpage:string){ 
    this.vhMGDB_socketFacebook.unsubscribeWebhookFeed(id_fanpage);
  }

  /**
 * Hàm callback TIN NHẮN trên fanpage có id là id_fanpage
 * @example:
 * this.vhQuerySales.observableWebhookMessagesFacebook('102622138931525').subscribe((entry:any) => {          
      console.log('entry', entry);
    })       
  
  ngOnDestroy(){
    this.vhQuerySales.unsubscribeWebhookMessagesFacebook('102622138931525');   
  }
  * @returns Observerble (Object) => obj = {id, time, messaging}
  */
  public observableWebhookMessagesFacebook(id_fanpage:string){   
    return new Observable((observer:any) => {    
      this.vhMGDB_socketFacebook.observableWebhookMessages(id_fanpage).subscribe((messages) => {   
        observer.next(messages);
      })      
    })
  }

  /**
   * hàm disable calback TÍN NHẮN
   * @example:
   * this.vhQuerySales.unsubscribeWebhookMessagesFacebook('102622138931525');       
  */
  public unsubscribeWebhookMessagesFacebook(id_fanpage:string){ 
    this.vhMGDB_socketFacebook.unsubscribeWebhookMessages(id_fanpage);
  }

/**------------------------TIKI Ecommerce-------------------------- */
/**
 * @example:
 * this.vhQuerySales.GetShippingStampForDropshipTiki('243842207, 'B6', access_token).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
 * @param code :string
 * @param access_token :string
 * @returns Promise
 */
  public GetShippingStampForDropshipTiki(code:string, size:string, access_token:string){
    return new Promise((resolve, reject)=>{      
      this.vhMGDB_tiki.GetShippingStampForDropshipTiki(code, size, access_token)
                  .then((result:any)=>{                                    
                      resolve(result);                        
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }

 /**
 * @example:
 * this.vhQuerySales.getSellerInventoriesForConfirmationTiki(access_token).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
 * @param access_token :string
 * @returns Promise
 */
  public getSellerInventoriesForConfirmationTiki(access_token:string){
    return new Promise((resolve, reject)=>{      
      this.vhMGDB_tiki.getSellerInventoriesForConfirmationTiki(access_token)
                  .then((result:any)=>{                                    
                      resolve(result);                        
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }

 /**
 * @example:
 * this.vhQuerySales.getExpectedPickupTimesTiki(access_token).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
 * @param access_token :string
 * @returns Promise
 */
  public getExpectedPickupTimesTiki(access_token:string){
    return new Promise((resolve, reject)=>{      
      this.vhMGDB_tiki.getExpectedPickupTimesTiki(access_token)
                  .then((result:any)=>{                                    
                      resolve(result);                        
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }

/**
 * @example:
 * let json = {
          confirmation_status: 'seller_confirmed',
          seller_inventory_id: 237188,
          expected_pickup_time: '2021-12-10 09:00:00
        }
 * this.vhQuerySales.ConfirmEnoughStockForDropShippingByJSONTiki(code, json, access_token).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
 * @param code :string
 * @param json :object
 * @param access_token :string
 * @returns Promise
 */
  public ConfirmEnoughStockForDropShippingByJSONTiki(code:string, json:any, access_token:string){
    return new Promise((resolve, reject)=>{      
      this.vhMGDB_tiki.ConfirmEnoughStockForDropShippingByJSONTiki(code, json, access_token)
                  .then((result:any)=>{                                    
                      resolve(result);                        
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }


/**
 * Hàm này lấy về mảng các đơn hàng (salesorder) được lưu trong database viethas (ko phải database tiki)
 * @example
 * this.vhQuerySales.getSalesOrderTiki_fromViethas( ['14424213387','14424273835'], '403754acaafc4564a16c19faa32d73c8')
      .then((array:any)=>{
        console.log('array', array);
      },(error:any)=>{
        console.log('error', error);
      })
  * @param codeArray 
  * @param id_shop 
  * @returns Promise => Array(object or null)
  */
  public getSalesOrderTiki_fromViethas(codeArray:any, id_shop:string){
    return new Promise((resolve, reject) => {      
      let promise = new Array();
      for(let i=0; i<codeArray.length; i++){
        promise[i] = this.vhMGDB_database.getDoc(id_shop, codeArray[i]);
      }
      Promise.all(promise).then(array=>{  
        resolve(array);              
      })      
    })    
  }

  /**
 * Hàm này cập nhật các đơn hàng (salesorder) được lưu trong database viethas (ko phải database tiki), lưu ý các id đc lấy từ lazada server về
 * @example:
 * this.vhQuerySales.updateSalesOrderTiki('5fb67fda87c0f21d484cbdf3', 'gsdfgsdg4345324534t3w', {check:true})
      .then((bool:any)=>{
        console.log('updateSalesOrderTiki', bool);
      }, error=>{
        reject(error)
      })
  * @param id_shop 
  * @param code 
  * @param data 
  * @return Promise => bool = true or false
  */
  public updateSalesOrderTiki(id_shop:string, code:string, data:object){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.updateDoc(id_shop, code, data)
          .then((bool:any)=>{
            if(bool){
              this.productlistlazada.forEach((item_zero:any) => {
                if(item_zero._id === id_shop){
                  item_zero.salesorderdetaillist.forEach((item_one:any) => {
                    if(item_one.code === code){   
                      item_one = {...item_one, ...data};  
                    }
                  })  
                }
              })                           
            }                   
            resolve(bool);     
          }, error=>{
            reject(error)
          })
    })   
  }

  /**
   * Hàm này cập nhật các đơn hàng (salesorder) được lưu trong database viethas (ko phải database tiki), lưu ý các order_id đc import từ file ngoài vào (excel, csv...)
   * @example:
   * this.vhQuerySales.updateSalesOrderTiki_byFile(['144242133871', '14424213387'], {check:true}, 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdG9yZUlkIjoiNTczNjciLCJVc2VyTmFtZSI6IiIsIlN0b3JlU3RhdHVzIjoiMiIsIlNob3BUeXBlIjoiMCIsIlN0b3JlTGV2ZWwiOiIzIiwiZXhwIjoxNjMzODE3MzIwLCJpc3MiOiI1NzM2NyIsImF1ZCI6IjU3MzY3In0.9S18n7EuG7XxbZVm9kjUBozJVjx2_EZRNAn38wBUaDs', '403754acaafc4564a16c19faa32d73c8')
          .then((array:any)=>{
            console.log('updateSalesOrderTiki_byFile', array);
          }, error=>{
            console.log(error)
          })
    * @param codeArray 
    * @param data
    * @param token 
    * @param id_shop 
    * @return Promise => Array(bool) = [true or false,,...]
    */
  public updateSalesOrderTiki_byFile(codeArray:any, data:object, token:string, id_shop:string){//hàm này sẽ sửa lại vì 1 request có thể lấy về đc nhiều orders
    return new Promise((resolve, reject) => {  
      let promise = new Array();
      for(let i=0; i<codeArray.length; i++){
        promise[i] = new Promise(resolve=>{
          this.vhMGDB_tiki.getOrders(codeArray[i], token)
              .then((salesorderdetail)=>{
                if(salesorderdetail){
                  this.vhMGDB_database.getDoc(id_shop, codeArray[i])
                      .then((salesorder)=>{
                        if(salesorder){
                          this.vhMGDB_database.updateDoc(id_shop, codeArray[i], data)
                              .then((bool:any)=>{
                                resolve(bool);
                              }, ()=>{
                                resolve(false);
                              })
                        }else{
                          this.vhMGDB_database.addDocbyID(id_shop, codeArray[i], data)
                              .then(()=>{
                                resolve(true);
                              })
                        }                   
                      })
                  
                }else{
                  resolve(false)
                }            
              }, ()=>{
                //reject(error)
                resolve(false)
              })     
        })
      }
      Promise.all(promise).then(array=>{
        resolve(array)
      })
    })   
  }
/**
 * @notic : hàm này không thể cập nhật vô getlocalProductListTiki, do đó sau khi dùng hàm updateProductByJSONTiki xong thì dùng thêm hàm getProductByIdTiki 
 * với các sản phẩm vừa cập nhật, lúc đó những gì vừa thay đổi mới đc cập nhật vô getlocalProductListTiki
 * @example:
 * let json = {
    "product_id" : "51509850",
    "quantity":123
  }
  let json = {
    "product_id" : "51509850",
    "price": 16000000
  }
   let access_token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdG9yZUlkIjoiODUyMjU5IiwiVXNlck5hbWUiOiIiLCJTdG9yZVN0YXR1cyI6IjIiLCJTaG9wVHlwZSI6IjEiLCJTdG9yZUxldmVsIjoiMCIsImV4cCI6MTYzMDAxMzM1NCwiaXNzIjoiODUyMjU5IiwiYXVkIjoiODUyMjU5In0.CYoBo-4tMOFrQXBZyw4ZvxKz0YOPU9IsWoRjIQtslis'
    this.vhQuerySales.updateProductByJSONTiki( json, access_token).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
 * @param json 
 * @param access_token 
 * @returns 
 */
  public updateProductByJSONTiki(json:any, access_token:string){
    return new Promise((resolve, reject)=>{   
      this.vhMGDB_tiki.updateProductByJSON(json, access_token)
                  .then((result:any)=>{                                             
                    if(result.vcode === 0){                                
                        resolve(result.data);                                          
                    }else{
                      console.log(result.message);
                      resolve(null);
                    }                   
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }

/**
  * Cập nhập hàng loạt sản phẩm
  * @example:
  * let json ={
                data: [
                    {
                        product_id: 112059614,
                        status: 3
                    }
                ]
              }
    let access_token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdG9yZUlkIjoiODUyMjU5IiwiVXNlck5hbWUiOiIiLCJTdG9yZVN0YXR1cyI6IjIiLCJTaG9wVHlwZSI6IjEiLCJTdG9yZUxldmVsIjoiMCIsImV4cCI6MTYzMDAxMzM1NCwiaXNzIjoiODUyMjU5IiwiYXVkIjoiODUyMjU5In0.CYoBo-4tMOFrQXBZyw4ZvxKz0YOPU9IsWoRjIQtslis'
      this.vhQuerySales.updateProductsByJSONTiki( json, access_token).then((result)=>{
          console.log('result', result);
        },(error:any)=>{
          console.log('error', error);
        })
  * @param json 
  * @param access_token 
  * @returns 
  */
  public updateProductsByJSONTiki(json:any, access_token:string){
    return new Promise((resolve, reject)=>{   
      this.vhMGDB_tiki.updateProductsByJSON(json, access_token)
                  .then((result:any)=>{                                             
                    if(result.vcode === 0){                                
                        resolve(result.data);                                          
                    }else{
                      console.log(result.message);
                      resolve(null);
                    }                   
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }
  /**
   * @example:
   *let created_from_date = new Date('2021-01-25');
    let created_to_date = new Date('2021-06-30');
    let access_token = '50000601506bKRvdjv16d01472hspFZdjp3qWxFJdNhveuVAezlxvCMt08WkxBrr';
    let id_shop = '100035896';
    this.vhQuerySales.getSalesOrderListTiki( created_from_date, created_to_date, access_token, id_shop)
        .then((result)=>{
            console.log('result', result);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param created_from_date 
   * @param created_to_date 
   * @param access_token 
   * @param id_shop 
   * @returns 
   */
    public getSalesOrderListTiki(created_from_date:any, created_to_date:any, access_token:string, id_shop:string){
      return new Promise((resolve, reject) => { 
        let promise_zero = new Promise((resolve, reject)=>{        
          this.vhMGDB_tiki.getOrderList(vhDate(new Date(created_from_date),'YYYY-MM-dd HH:mm:ss'), vhDate(new Date(created_to_date),'YYYY-MM-dd HH:mm:ss'), access_token)
              .then((response_one:any)=>{                      
                this.productlisttikis.forEach((item:any) => {
                  if(item._id === id_shop){
                    item.salesorderdetaillist = response_one;
                  }
                })              
                resolve(response_one);
              },(error:any)=>{                   
                reject(error);
              })         
        })        
        let promise_one = new Promise((resolve, reject)=>{
          let query = {created_at: {$gte:new Date(created_from_date), $lte: new Date(created_to_date)}};
          this.vhMGDB_database.getDocsByFields(id_shop, query, {},{},0)
              .then((salesorderlist:any)=>{                 
                resolve(salesorderlist);               
              })
        })   
  
        Promise.all([promise_zero, promise_one]).then((array:any)=>{   
          let newArray = array[0].filter((item:any)=>{
            let bool = true;            
            array[1].forEach((item_one:any) => {                          
              if(item.code.toString() === item_one._id){             
                bool = false;
              }            
            })          
            return bool;
          })           
          //Tạo 1 bản sao của bill này trong database viethas, ban đầu chỉ có 1 trường order_date_time_stamp
          newArray.forEach((item:any) => {             
            this.vhMGDB_database.addDocbyID(id_shop.toString(), item.code.toString(), {created_at: new Date(item.created_at)});               
          })
          for(let i=0; i<array[0].length; i++){
            for(let j=0; j<array[1].length; j++){
              if(array[0][i].code === array[1][j]._id){                   
                let _item = {...array[1][j]}; delete _item._id; delete _item.created_at; //lưu ý created_at trong db viethas và db tiki có kiểu khác nhau nên xóa đi khi chập 2 cái lại, nhằm tránh xung đột kiểu dữ liệu               
                array[0][i] = {...array[0][i], ..._item};                       
              }    
            }
          }         
  
          resolve(array[0]);        
        })
      })
    }

/**
 * Hàm này lấy về chi tiết của một hóa đơn
 * @example
 * this.vhQuerySales.getSalesOrderDetailTiki('14424213387', '403754acaafc4564a16c19faa32d73c8', 'gsdr3454u54w34tfq')
        .then((salesorderdetail)=>{
          console.log('salesorderdetail', salesorderdetail);
        },(error:any)=>{
          console.log('error', error);
        })
 * @param order_id 
 * @param access_token 
 * @param id_shop 
 * @returns Promise => obj ={} or null
 */
  public getSalesOrderDetailTiki(code:string, access_token:string, id_shop:any){
    return new Promise((resolve, reject)=>{         
      let promise_zero = this.vhMGDB_tiki.getOrders(code, access_token);
      let promise_one = this.vhMGDB_database.getDoc(id_shop, code);
      Promise.all([promise_zero, promise_one]).then((array:any)=>{
        if(array[0].length>0){
          if(!array[1]){
            this.vhMGDB_database.addDocbyID(id_shop, array[0].code, {created_at: new Date(array[0].created_at)});  
          }  
          resolve(array[0][0]);
        }else resolve(null);
        
      })       
    })
  }

/**
 * @example: 
 * let productlisttiki = this.vhQuerySales.getlocalProductListTiki('ư0e4tuiwe98rhvqw9vtqw9t7rq987r9qvwn98et98');
 * @param id_shop 
 * @returns 
 */
  public getlocalProductListTiki(id_shop:any){          
    for(let i=0; i<this.productlisttikis.length; i++){
      if(this.productlisttikis[i]._id === id_shop){            
        return cloneDeep(this.productlisttikis[i].productlist);           
      }
    }
    return []; 
  }
  
   /**
   * @example:
   * this.vhQuerySales.refreshLocalProductListTikis()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalProductListTiki() trong localstorage
   * @return Promise => null
   */
    public refreshLocalProductListTikis(shop_id?:string):any{
      return new Promise((resolve, reject) => { 
        if((shop_id!='')&&(shop_id!=undefined)){
          this.getProductListTiki(shop_id)
              .then(()=>{resolve(null)});   
        }else{
          this.getProductListTikis()
            .then(()=>{resolve(null)});   
        }
          
      })
    } 
  
  /**
    * @example:
      this.vhQuerySales.getProductListTikis().then((list)=>{             
            console.log('list', list);             
      })
    * @returns Promise => array =[{},{},...]
    */
    private getProductListTiki(shop_id:string){
      return new Promise((resolve, reject)=>{       
        let id_branch = this.getDefaultBranch()._id;  
        this.vhMGDB_tiki.getShop(id_branch, shop_id)
            .then((result_zero:any)=>{       
              console.log('shoptiki', result_zero);                           
              if(result_zero.vcode === 0){          
                this.shoplisttiki = [...result_zero.data];  
                this.productlisttikis = [...result_zero.data];      
                let promise_zero = new Array();             
                for(let i=0; i<this.productlisttikis.length; i++){
                  promise_zero[i] = new Promise((resolve, reject)=>{    
                          let promise_one = new Array();       
                          for(let j=0; j<this.productlisttikis[i].product_page_total; j++){
                            promise_one[j] = new Promise((resolve, reject)=>{    
                              let product_page_number:any = j+1;  
                              this.vhMGDB_tiki.getProductPage(this.productlisttikis[i].access_token, product_page_number)
                                  .then((result_one:any)=>{                                         
                                    if(result_one.vcode === 0){                                                               
                                      resolve(result_one.data)
                                    }else{
                                      //console.log(result_one.message);
                                      reject(result_one.message);
                                    }                                                 
                                  },(error:any)=>{
                                    reject(error);
                                  })   
                            })
                          }   
                          Promise.all(promise_one).then((array:any)=>{           
                            this.productlisttikis[i].productlist = array.flat();                    
                            resolve(null);
                          })              
                  })              
                } 
                Promise.all(promise_zero).then(()=>{       
                  console.log('productlisttikis', this.productlisttikis);                                       
                  resolve(null);
                })
              }else{
                console.log(result_zero.message);
                reject(result_zero.message);
              }                   
            },(error:any)=>{
              reject(error);
            })     
      })    
    }

    private getProductListTikis(){
      return new Promise((resolve, reject)=>{       
        let id_branch = this.getDefaultBranch()._id;  
        this.vhMGDB_tiki.getShopList(id_branch)
            .then((result_zero:any)=>{                                 
              if(result_zero.vcode === 0){          
                this.shoplisttiki = [...result_zero.data];  
                this.productlisttikis = [...result_zero.data];      
                let promise_zero = new Array();             
                for(let i=0; i<this.productlisttikis.length; i++){
                  promise_zero[i] = new Promise((resolve, reject)=>{    
                          let promise_one = new Array();       
                          for(let j=0; j<this.productlisttikis[i].product_page_total; j++){
                            promise_one[j] = new Promise((resolve, reject)=>{    
                              let product_page_number:any = j+1;  
                              this.vhMGDB_tiki.getProductPage(this.productlisttikis[i].access_token, product_page_number)
                                  .then((result_one:any)=>{                                         
                                    if(result_one.vcode === 0){                                                               
                                      resolve(result_one.data)
                                    }else{
                                      //console.log(result_one.message);
                                      reject(result_one.message);
                                    }                                                 
                                  },(error:any)=>{
                                    reject(error);
                                  })   
                            })
                          }   
                          Promise.all(promise_one).then((array:any)=>{           
                            this.productlisttikis[i].productlist = array.flat();                    
                            resolve(null);
                          })              
                  })              
                } 
                Promise.all(promise_zero).then(()=>{       
                  console.log('productlisttikis', this.productlisttikis);                                       
                  resolve(null);
                })
              }else{
                console.log(result_zero.message);
                reject(result_zero.message);
              }                   
            },(error:any)=>{
              reject(error);
            })     
      })    
    }

   /**
    * @example:
      this.vhQuerySales.getProductByIdTiki(access_token, product_id, id_shop).then((producttiki)=>{             
            console.log('producttiki', producttiki);             
      })
    * @returns Promise => object ={} or null
    */
    public getProductByIdTiki(access_token:string, product_id:string, id_shop:string){
      return new Promise((resolve, reject)=>{   
        this.vhMGDB_tiki.getProductByIdTiki(access_token, product_id)
            .then((result:any)=>{                                             
              if(result.vcode === 0){               
                for(let i=0; i<this.productlisttikis.length;i++){
                  if(this.productlisttikis[i]._id === id_shop){
                    for(let j=0; j<this.productlisttikis[i].productlist.length;j++){
                      if(this.productlisttikis[i].productlist[j].product_id === product_id){
                        this.productlisttikis[i].productlist[j] = {...this.productlisttikis[i].productlist[j], ...result.data};
                        break;
                      }
                    }
                  }
                }               
                resolve(result.data);                                          
              }else{
                console.log(result.message);
                resolve(null);
              }                   
            },(error:any)=>{
              reject(error);
            })      
      })    
    }

   /**
    * @example:
      this.vhQuerySales.getHiddenProductListTiki(access_token).then((list)=>{             
            console.log('list', list);             
      })
    * @returns Promise => array =[{},{},...]
    */
    public getHiddenProductListTiki(access_token:string){
      return new Promise((resolve, reject)=>{   
        this.vhMGDB_tiki.getHiddenProductList(access_token)
            .then((result:any)=>{                                             
              if(result.vcode === 0){                                
                  resolve(result.data);                                          
              }else{
                console.log(result.message);
                resolve([]);
              }                   
            },(error:any)=>{
              reject(error);
            })      
      })    
    }
  
    /**
   * let localshoplisttiki = this.vhQuerySales.getlocalShopListTiki();
   * @returns 
   */
      public getlocalShopListTiki(){            
      return this.shoplisttiki;          
    }
  
    /**
     * @example:
      this.vhQuerySales.getShopListTiki().then((array:any)=>{             
            console.log('array', array);             
      })
    * @returns Promise => array =[{},{},...]
    */
    private getShopListTiki(){
      return new Promise((resolve, reject)=>{   
        let id_branch = this.getDefaultBranch()._id; 
        this.vhMGDB_tiki.getShopList(id_branch)
              .then((result:any)=>{                                
                if(result.vcode === 0){     
                  this.shoplisttiki = result.data;   
                  resolve(result.data)
                }else{
                  console.log(result.message);
                  reject(result.message);
                }                   
              },(error:any)=>{
                reject(error);
              })      
      })    
    }   
  
    /**
     * @example:
      let backHref = http://localhost:4200/dashboard/overview';
      this.vhQuerySales.signInTiki(backHref).then((bool:any)=>{
          if(bool){
            console.log('bool', bool)
          }
      })
     * @returns Promise => true or false
     */
    public signInTiki(backHref?:any){
      return new Promise((resolve, reject)=>{   
        let id_branch = this.getDefaultBranch()._id; 
        this.vhMGDB_tiki.signIn(id_branch, backHref)
                    .then((bool:any)=>{                                                          
                      resolve(bool);     
                    },(error:any)=>{
                      reject(error);
                    })      
      })    
    }
  
/**
 * @example:
  this.vhQuerySales.signOutTiki('938476838whsofis').then((bool:any)=>{
      if(bool){
        console.log('bool', bool)
      }
  })
  * @param id_shop 
  * @returns Promise => true or false
  */
  public signOutTiki(id_shop:string){
    return new Promise((resolve, reject)=>{   
      this.vhMGDB_tiki.signOut(id_shop)
                  .then((result:any)=>{                                
                    if(result.vcode === 0){   
                      for(let i=0; i<this.shoplisttiki.length;i++){
                        if(this.shoplisttiki[i]._id === id_shop){
                          this.shoplisttiki.splice(i,1);
                          break;
                        }
                      }                             
                      for(let i=0; i<this.productlisttikis.length;i++){
                        if(this.productlisttikis[i]._id === id_shop){
                          this.productlisttikis.splice(i,1);
                          break;
                        }
                      }   
                      resolve(true)
                    }else{
                      console.log(result.message);
                      reject(false);
                    }                   
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }        
  
/**
 * Tạo liên kết sản phẩm trên phần mềm quản lý bán hàng sales viethas và sản phẩm trên sàn tiki
 * @example:
 * this.vhQuerySales.addMergeTikiProduct('5fb6780ca2148e09806c5b01','tf3452345234', ['tf3452345234','35twtw45y3g6'], 'hjhjrtyur56u53')
        .then((bool:any)=>{
          console.log('addMergeTikiProduct', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_sub_or_product 
  * @param product_idArray      
  * @param id_shop 
  * @return Promise => boolean true or false
  */
public addMergeTikiProduct(id_sub_or_product:string, product_idArray:any, id_shop:string){
  return new Promise((resolve, reject) => {      
      let id_branch = this.getDefaultBranch()._id;     
      let product = this.getlocalDetailProduct(id_sub_or_product);   
      if(product[id_branch] != undefined){
        if(product[id_branch].tikis === undefined) product[id_branch].tikis = new Array();             
      }else{
        product[id_branch]={};
        product[id_branch].tikis = new Array();
      }  
      let objArray = new Array();
      for(let i=0; i<product_idArray.length; i++){
          let obj = {
            product_id: product_idArray[i],
            id_shop: id_shop
          };
               
          let exist = false;
          for(let j=0; j<product[id_branch].tikis.length; j++){
            if((product[id_branch].tikis[j].product_id === product_idArray[i])&&(product[id_branch].tikis[j].id_shop === id_shop)){          
              exist = true;    
              break;                
            }
          }
          if(!exist){           
            objArray.push(obj);      
          }  
      }     
      if(objArray.length >0){
        product[id_branch].tikis = [...product[id_branch].tikis, ...objArray];  
        let value:any = {}; 
        value[id_branch] = product[id_branch];                                        
        this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
            .then(()=>{                   
              resolve(true);
            }, error=>{
              reject(error)
            })  
      }else{
        resolve(false);
      }                
  })
} 

/**
 * @example:
   * this.vhQuerySales.updateMergeTikiProduct('5fb6780ca2148e09806c5b01', '435f34tf34f3243fdf', {xyz:true}, 'jfaosidfu9we87f9w')
          .then((bool:any)=>{
            console.log('updateMergeTikiProduct', bool);
          }, error=>{
            console.log('error', error);
          })
 * @param id_sub_or_product 
 * @param product_id: trường id trong sản phẩm tiki
 * @param SkuId: trường SkuId trong sản phẩm tiki
 * @param data : {xyz:true}
 * @returns Promise => bool = true or false
 */
  public updateMergeTikiProduct(id_sub_or_product:string, product_id:number, data:any, id_shop:string){//cái này dùng cho sendo
    return new Promise((resolve, reject) => {    
      let product = this.getlocalDetailProduct(id_sub_or_product);         
      let id_branch = this.getDefaultBranch()._id;     
      if(product[id_branch] === undefined) return resolve(false);
      if(product[id_branch].tikis === undefined) return resolve(false);       
      let exist = false;      
      for(let i=0; i<product[id_branch].tikis.length; i++){
        if((product[id_branch].tikis[i].product_id === product_id)&&(product[id_branch].tikis[i].id_shop === id_shop)){
          product[id_branch].tikis[i] = {...product[id_branch].tikis[i],...data};
          let value:any = {}; 
          value[id_branch] = product[id_branch];    
          this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
              .then((bool:any)=>{                      
                resolve(bool);
              }, error=>{
                reject(error)
              })  
          exist = true;    
          break;
        }                 
      } 
      if(!exist) resolve(false);                      
                                            
    })
  }  
/**
 * 
 * @param product_id : trường id trong sản phẩm Tiki 
 * @param hidden 
 * @param id_shop 
 * @returns 
 */
  public updateMergeTikiProduct_hidden(product_id:number, hidden:boolean, id_shop:string){
    return new Promise((resolve, reject) => {  
      let id_branch = this.getDefaultBranch()._id;   
      let products = this.getlocalDetailProducts();
      let product = null;
      for(let i=0; i<products.length; i++){
        if((products[i][id_branch] != undefined)&&(products[i][id_branch].tikis != undefined)){
          for(let j=0; j<products[i][id_branch].tikis.length; j++){
            if((products[i][id_branch].tikis[j].product_id === product_id)&&(products[i][id_branch].tikis[j].id_shop === id_shop)){
              product = products[i];
              break;
            }
          }
        }
      }  
      if(!product) return resolve(false);      
      
      if(product[id_branch] === undefined) return resolve(false);
      if(product[id_branch].tikis === undefined) return resolve(false);       
      let exist = false;      
      for(let i=0; i<product[id_branch].tikis.length; i++){
        if((product[id_branch].tikis[i].product_id === product_id)&&(product[id_branch].tikis[i].id_shop === id_shop)){
  
          for(let m=0; m<this.productlisttikis.length; m++){
            if(this.productlisttikis[m]._id === id_shop){                      
              for(let n=0; n<this.productlisttikis[m].productlist.length; n++){
                if(this.productlisttikis[m].productlist[n].product_id === product_id){  
                  this.productlisttikis[m].productlist[n].hidden = hidden;     
                  break;  
                }
              }
            }
          }
  
          product[id_branch].tikis[i].hidden = hidden;
          let value:any = {}; 
          value[id_branch] = product[id_branch];    
          this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
              .then((bool:any)=>{                      
                resolve(bool);
              }, error=>{
                reject(error)
              })  
          exist = true;    
          break;
        }                 
      } 
      if(!exist) resolve(false);                      
                                            
    })
  } 
  

  /**
 * @example:
 * this.vhQuerySales.deleteMergeTikiProduct('5fb67fda87c0f21d484cbdf3', 'gsdfgsdg4345324534t3w', 'sdfgsdfgererasds3563')
      .then((bool:any)=>{
        console.log('deleteMergeTikiProduct', bool);
      }, error=>{
        reject(error)
      })
  * @param id_sub_or_product 
  * @param product_id : trường id trong sản phẩm tiki
  * @param id_shop  
  * @return Promise => bool = true or false
  */
public deleteMergeTikiProduct(id_sub_or_product:string, product_id:number, id_shop:string){
  return new Promise((resolve, reject) => {     
    let product:any = this.getlocalDetailProduct(id_sub_or_product); 
    let id_branch = this.getDefaultBranch()._id;                           
    if(product[id_branch] === undefined) return resolve(false);
    if(product[id_branch].tikis === undefined) return resolve(false);        
    let exist = false;       
    for(let i=0; i<product[id_branch].tikis.length; i++){    
      if((product[id_branch].tikis[i].product_id === product_id)&&(product[id_branch].tikis[i].id_shop === id_shop)){      
        product[id_branch].tikis.splice(i,1);                          
        let value:any = {}; 
        value[id_branch] = product[id_branch];                       
        this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
            .then((bool:any)=>{
              resolve(bool);
            }, error=>{
              reject(error)
            })      
        exist = true;
        break;
      }
    }
    if(!exist) resolve(false);                 
  })
}

/**----------------------LAZADA ECOMMERCE--------------- */
/**
 * @example:
 * let xml = `<Request>
    <Product>
      <Skus>
        <Sku>                       
          <ItemId>383144083</ItemId>
          <SkuId>647304827</SkuId>
          <SellerSku>ThietBiBaoDongChongTromHongNgoaiHT1AS</SellerSku>
          <price>268000</price>
        </Sku>
      </Skus>
    </Product>
  </Request>`;
   let access_token = '50000601506bKRvdjv16d01472hspFZdjp3qWxFJdNhveuVAezlxvCMt08WkxBrr'
    this.vhQuerySales.updateProductByXMLLazada( xml, access_token).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
 * @param payload 
 * @param access_token 
 * @returns Bool => true or false 
 */
  public updateProductByXMLLazada(xml:any, access_token:string){
    return new Promise((resolve, reject)=>{ 
      let payload = xml;  
      this.vhMGDB_lazada.updateProductByXMLLazada(payload, access_token)
                  .then((result:any)=>{                                             
                    if(result.vcode === 0){                                
                        resolve(result.data);                                          
                    }else{
                      console.log(result.message);
                      resolve(false);
                    }                   
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  } 
/**
 * @example:
 * this.vhQuerySales.setStatusPackedLazada( order_item_ids, access_token).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
 * @param order_item_ids : array
 * @param access_token :string
 * @returns Promise
 */
  public setStatusPackedLazada(order_item_ids: any, access_token:string){
    return new Promise((resolve, reject)=>{      
      this.vhMGDB_lazada.setStatusPackedLazada(order_item_ids, access_token)
                  .then((result:any)=>{                                    
                      resolve(result);                        
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  } 

  /**
 * @example:
 * this.vhQuerySales.setStatusReadyToShipLazada( order_item_ids, access_token).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
 * @param order_item_ids : array
 * @param access_token :string
 * @returns Promise
 */
  public setStatusReadyToShipLazada(order_item_ids: any, tracking_number:string, access_token:string){
    return new Promise((resolve, reject)=>{      
      this.vhMGDB_lazada.setStatusReadyToShipLazada(order_item_ids, tracking_number, access_token)
                  .then((result:any)=>{                                    
                      resolve(result);                        
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  } 

  /**
 * @example: 
 * let productlistlazada = this.vhQuerySales.getlocalProductListLazada('ư0e4tuiwe98rhvqw9vtqw9t7rq987r9qvwn98et98');
 * @param id_shop 
 * @returns Promise => Array
 */
  public getlocalProductListLazada(id_shop:any){          
    for(let i=0; i<this.productlistlazada.length; i++){
      if(this.productlistlazada[i]._id === id_shop){            
        return cloneDeep(this.productlistlazada[i].productlist);           
      }
    }
    return []; 
  }

 /**
 * @example:
 * this.vhQuerySales.refreshLocalProductListLazadas()
        .then(()=>{
          do something.....
        })
 * Hàm này refresh giá trị mới nhất cho hàm getlocalProductListLazada() trong localstorage
 * @return Promise => null
 */
  public refreshLocalProductListLazadas(shop_id?:string):any{
    return new Promise((resolve, reject) => { 
      if((shop_id!='')&&(shop_id!=undefined)){
        this.getProductListLazada(shop_id)
           .then(()=>{resolve(null)});   
      }else{
        this.getProductListLazadas()
           .then(()=>{resolve(null)});    
      }
        
    })
  } 

/**
  * @example:
    this.vhQuerySales.getProductListLazadas().then((list)=>{             
          console.log('list', list);             
    })
  * @returns Promise => array =[{},{},...]
  */
private getProductListLazada(shop_id:string){   
  return new Promise((resolve, reject)=>{  
    let id_branch = this.getDefaultBranch()._id;        
    this.vhMGDB_lazada.getShop(id_branch, shop_id)
        .then((result_zero:any)=>{      
          console.log('shoplazada', result_zero);                           
          if(result_zero.vcode === 0){          
            this.shoplistlazada = [...result_zero.data];  
            this.productlistlazada = [...result_zero.data];      
            let promise = new Array();             
            for(let i=0; i<this.productlistlazada.length; i++){
              promise[i] = new Promise((resolve, reject)=>{                   
                this.vhMGDB_lazada.getProducts(this.productlistlazada[i].access_token)//hàm này lấy về 1 lần và đã có chi tiết luôn rồi
                    .then((result_one:any)=>{ 
                      this.productlistlazada[i].productlist = result_one;    
                      resolve(null)                                                                   
                    },(error:any)=>{
                      reject(error);
                    })                    
              })              
            } 
            Promise.all(promise).then(()=>{    
              console.log('productlistlazadas', this.productlistlazada);                               
              resolve(null);
            })
          }else{
            console.log(result_zero.message);
            reject(result_zero.message);
          }                   
        },(error:any)=>{
          reject(error);
        })     
  })    
}

private getProductListLazadas(){   
  return new Promise((resolve, reject)=>{  
    let id_branch = this.getDefaultBranch()._id;        
    this.vhMGDB_lazada.getShopList(id_branch)
        .then((result_zero:any)=>{                                
          if(result_zero.vcode === 0){          
            this.shoplistlazada = [...result_zero.data];  
            this.productlistlazada = [...result_zero.data];      
            let promise = new Array();             
            for(let i=0; i<this.productlistlazada.length; i++){
              promise[i] = new Promise((resolve, reject)=>{                   
                this.vhMGDB_lazada.getProducts(this.productlistlazada[i].access_token)//hàm này lấy về 1 lần và đã có chi tiết luôn rồi
                    .then((result_one:any)=>{ 
                      this.productlistlazada[i].productlist = result_one;    
                      resolve(null)                                                                   
                    },(error:any)=>{
                      reject(error);
                    })                    
              })              
            } 
            Promise.all(promise).then(()=>{    
              console.log('productlistlazadas', this.productlistlazada);                               
              resolve(null);
            })
          }else{
            console.log(result_zero.message);
            reject(result_zero.message);
          }                   
        },(error:any)=>{
          reject(error);
        })     
  })    
}

  /**
 * @example:
 * this.vhQuerySales.getProductDetailLazada(['13857630'], 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdG9yZUlkIjoiNTczNjciLCJVc2VyTmFtZSI6IiIsIlN0b3JlU3RhdHVzIjoiMiIsIlNob3BUeXBlIjoiMCIsIlN0b3JlTGV2ZWwiOiIzIiwiZXhwIjoxNjMzNjU1ODMxLCJpc3MiOiI1NzM2NyIsImF1ZCI6IjU3MzY3In0.qM6gqpf3758JrSsTL2JlDOoD-TFS1VVaGkL6ixaI_lw', '403754acaafc4564a16c19faa32d73c8').then((productdetail)=>{
          console.log('productdetail', productdetail);
       },(error:any)=>{         
       })
 * @param item_idArray 
 * @param access_token 
 * @param id_shop 
 * @returns 
 */
public getProductDetailLazada(item_idArray:any, access_token:string, id_shop:any){
  return new Promise((resolve, reject)=>{     
    let promise = [];
    for(let i=0; i<item_idArray.length; i++){
      promise[i] = this.vhMGDB_lazada.getProductItem(item_idArray[i], access_token)          
    }     
    Promise.all(promise).then((productdetails:any)=>{     
      for(let i=0; i<this.productlistlazada.length; i++){
        if(this.productlistlazada[i]._id === id_shop){
          for(let m=0; m<productdetails.length; m++){
            for(let n=0; n<this.productlistlazada[i].productlist.length; n++){
              if(productdetails[m].item_id === this.productlistlazada[i].productlist[n].item_id){
                this.productlistlazada[i].productlist[n] = {...this.productlistlazada[i].productlist[n],...productdetails[m]};                
                break;
              }
            }
          }  
        }
      }     
      resolve(productdetails);
    })
     
  })
}

/**
 * let localshoplistlazada = this.vhQuerySales.getlocalShopListLazada();
 * @returns 
 */
public getlocalShopListLazada(){            
  return this.shoplistlazada;          
}

/**
 * @example:
  this.vhQuerySales.getShopListLazada().then((array:any)=>{             
        console.log('array', array);             
  })
* @returns Promise => array =[{},{},...]
*/
private getShopListLazada(){
  return new Promise((resolve, reject)=>{ 
    let id_branch = this.getDefaultBranch()._id;     
    this.vhMGDB_lazada.getShopList(id_branch)
          .then((result:any)=>{                                
            if(result.vcode === 0){     
              this.shoplistlazada = result.data;   
              resolve(result.data)
            }else{
              console.log(result.message);
              reject(result.message);
            }                   
          },(error:any)=>{
            reject(error);
          })      
  })    
}   

/**
 * @example:
  let backHref = http://localhost:4200/dashboard/overview';
  this.vhQuerySales.signInLazada(backHref).then((bool:any)=>{
      if(bool){
        console.log('bool', bool)
      }
  })
  * @returns Promise => true or false
  */
public signInLazada(backHref?:any){
  return new Promise((resolve, reject)=>{   
    let id_branch = this.getDefaultBranch()._id; 
    this.vhMGDB_lazada.signIn(id_branch, backHref)
                .then((bool:any)=>{                                                          
                  resolve(bool);     
                },(error:any)=>{
                  reject(error);
                })      
  })    
}

/**
 * @example:
this.vhQuerySales.signOutLazada('938476838whsofis').then((bool:any)=>{
    if(bool){
      console.log('bool', bool)
    }
})
* @param id_shop 
* @returns Promise => true or false
*/
public signOutLazada(id_shop:string){
  return new Promise((resolve, reject)=>{   
    this.vhMGDB_lazada.signOut(id_shop)
                .then((result:any)=>{                                
                  if(result.vcode === 0){  
                    for(let i=0; i<this.shoplistlazada.length;i++){
                      if(this.shoplistlazada[i]._id === id_shop){
                        this.shoplistlazada.splice(i,1);
                        break;
                      }
                    }                             
                    for(let i=0; i<this.productlistlazada.length;i++){
                      if(this.productlistlazada[i]._id === id_shop){
                        this.productlistlazada.splice(i,1);
                        break;
                      }
                    }         
                    resolve(true)
                  }else{
                    console.log(result.message);
                    reject(false);
                  }                   
                },(error:any)=>{
                  reject(error);
                })      
  })    
}


/**
 * Tạo liên kết sản phẩm trên phần mềm quản lý bán hàng sales viethas và sản phẩm trên sàn lazada
 * @example:
 * this.vhQuerySales.addMergeLazadasProduct_skus('5fb6780ca2148e09806c5b01','tf3452345234', [{},{}], 'hjhjrtyur56u53')
        .then((bool:any)=>{
          console.log('addMergeLazadasProduct_skus', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_sub_or_product 
  * @param item_id      
  * @param skuArray : [{SkuId1,..},{SkuId2,..}]
  * @param id_shop 
  * @return Promise => boolean true or false
  */
public addMergeLazadasProduct_skus(id_sub_or_product:string, item_id:string, skuArray:any, id_shop:string){
  return new Promise((resolve, reject) => {      
      let id_branch = this.getDefaultBranch()._id;     
      let product = this.getlocalDetailProduct(id_sub_or_product);   
      let obj = {
        item_id: item_id,
        id_shop: id_shop,
        skus: [...skuArray]
      };
      if(product[id_branch] != undefined){
        if(product[id_branch].lazadas === undefined) product[id_branch].lazadas = new Array();             
      }else{
        product[id_branch]={};
        product[id_branch].lazadas = new Array();
      }       
      let exist = false;
      for(let i=0; i<product[id_branch].lazadas.length; i++){
        if((product[id_branch].lazadas[i].item_id === item_id)&&(product[id_branch].lazadas[i].id_shop === id_shop)){
          if(product[id_branch].lazadas[i].skus != undefined){
            product[id_branch].lazadas[i].skus = [...product[id_branch].lazadas[i].skus,...skuArray];         
          }else{
            product[id_branch].lazadas[i].skus = [...skuArray];     
          } 
          let value:any = {}; 
          value[id_branch] = product[id_branch];                                        
          this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
              .then(()=>{                   
                resolve(true);
              }, error=>{
                reject(error)
              })  
          exist = true;    
          break;                
        }
      }
      if(!exist){
        product[id_branch].lazadas.push(obj);
        let value:any = {}; 
        value[id_branch] = product[id_branch];                                        
        this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
            .then(()=>{                   
              resolve(true);
            }, error=>{
              reject(error)
            })   
      }                             
  })
} 

/**
 * @example:
   * this.vhQuerySales.updateMergeLazadasProduct('5fb6780ca2148e09806c5b01', '435f34tf34f3243fdf', {xyz:true}, 'jfaosidfu9we87f9w')
          .then((bool:any)=>{
            console.log('updateMergeLazadasProduct', bool);
          }, error=>{
            console.log('error', error);
          })
 * @param id_sub_or_product 
 * @param item_id: trường item_id trong sản phẩm lazada
 * @param SkuId: trường SkuId trong sản phẩm lazada
 * @param data : {xyz:true}
 * @returns Promise => bool = true or false
 */
public updateMergeLazadasProduct(id_sub_or_product:string, item_id:string, data:any, id_shop:string){//cái này dùng cho sendo
  return new Promise((resolve, reject) => {    
    let product = this.getlocalDetailProduct(id_sub_or_product);         
    let id_branch = this.getDefaultBranch()._id;     
    if(product[id_branch] === undefined) return resolve(false);
    if(product[id_branch].lazadas === undefined) return resolve(false);       
    let exist = false;      
    for(let i=0; i<product[id_branch].lazadas.length; i++){
      if((product[id_branch].lazadas[i].item_id === item_id)&&(product[id_branch].lazadas[i].id_shop === id_shop)){
        product[id_branch].lazadas[i] = {...product[id_branch].lazadas[i],...data};
        let value:any = {}; 
        value[id_branch] = product[id_branch];    
        this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
            .then((bool:any)=>{                      
              resolve(bool);
            }, error=>{
              reject(error)
            })  
        exist = true;    
        break;
      }                 
    } 
    if(!exist) resolve(false);                      
                                          
  })
}  

/**
 * 
 */
public updateMergeLazadasProduct_hidden(item_id:string, hidden:boolean, id_shop:string){
  return new Promise((resolve, reject) => {  
    let id_branch = this.getDefaultBranch()._id;   
    let products = this.getlocalDetailProducts();
    let product = null;
    for(let i=0; i<products.length; i++){
      if((products[i][id_branch] != undefined)&&(products[i][id_branch].lazadas != undefined)){
        for(let j=0; j<products[i][id_branch].lazadas.length; j++){
          if((products[i][id_branch].lazadas[j].item_id === item_id)&&(products[i][id_branch].lazadas[j].id_shop === id_shop)){
            product = products[i];
            break;
          }
        }
      }
    }  
    if(!product) return resolve(false);      
    
    if(product[id_branch] === undefined) return resolve(false);
    if(product[id_branch].lazadas === undefined) return resolve(false);       
    let exist = false;      
    for(let i=0; i<product[id_branch].lazadas.length; i++){
      if((product[id_branch].lazadas[i].item_id === item_id)&&(product[id_branch].lazadas[i].id_shop === id_shop)){

        for(let m=0; m<this.productlistlazada.length; m++){
          if(this.productlistlazada[m]._id === id_shop){                      
            for(let n=0; n<this.productlistlazada[m].productlist.length; n++){
              if(this.productlistlazada[m].productlist[n].item_id === item_id){  
                this.productlistlazada[m].productlist[n].hidden = hidden;     
                break;  
              }
            }
          }
        }

        product[id_branch].lazadas[i].hidden = hidden;
        let value:any = {}; 
        value[id_branch] = product[id_branch];    
        this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
            .then((bool:any)=>{                      
              resolve(bool);
            }, error=>{
              reject(error)
            })  
        exist = true;    
        break;
      }                 
    } 
    if(!exist) resolve(false);                      
                                          
  })
} 


/**
 *  @example:
 * this.vhQuerySales.updateMergeLazadasProduct_skus('5fb6780ca2148e09806c5b01', '435f34tf34f3243fdf', '13123135654', {hidden:true}, 'jfaosidfu9we87f9w')
          .then((bool:any)=>{
            console.log('updateMergeLazadasProduct', bool);
          }, error=>{
            console.log('error', error);
          })
 * @param id_sub_or_product 
 * @param item_id : trường item_id trong sản phẩm lazada
 * @param SkuId : trường SkuId trong sản phẩm lazada
 * @param data : object => data = {hidden:true}
 * @param id_shop 
 * @returns Promise => bool = true or false
 */
public updateMergeLazadasProduct_skus(id_sub_or_product:string, item_id:string, SkuId:string, data:any, id_shop:string){
  return new Promise((resolve, reject) => {    
      let product = this.getlocalDetailProduct(id_sub_or_product);         
      let id_branch = this.getDefaultBranch()._id;     
      if(product[id_branch] === undefined) return resolve(false);
      if(product[id_branch].lazadas === undefined) return resolve(false);        
      let exist = false;
      for(let i=0; i<product[id_branch].lazadas.length; i++){           
        if((product[id_branch].lazadas[i].item_id === item_id)&&(product[id_branch].lazadas[i].id_shop === id_shop)){
          if(product[id_branch].lazadas[i].skus != undefined)
            for(let j=0; j<product[id_branch].lazadas[i].skus.length; j++){
              if(product[id_branch].lazadas[i].skus[j].SkuId === SkuId){
                product[id_branch].lazadas[i].skus[j] = {...product[id_branch].lazadas[i].skus[j],...data};
                let value:any = {}; 
                value[id_branch] = product[id_branch];    
                this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
                    .then((bool:any)=>{                      
                      resolve(bool);
                    }, error=>{
                      reject(error)
                    })  
                exist = true;    
                break;
              }                  
            }  
        }
      } 
      if(!exist) resolve(false);                                                          
  })
}  

/**
 * @example:
 * this.vhQuerySales.deleteMergeLazadaProduct('5fb67fda87c0f21d484cbdf3', 'gsdfgsdg4345324534t3w', 'sdfgsdfgererasds3563')
      .then((bool:any)=>{
        console.log('deleteMergeLazadaProduct', bool);
      }, error=>{
        reject(error)
      })
  * @param id_sub_or_product 
  * @param item_id : trường item_id trong sản phẩm lazada
  * @param SkuId : trường SkuId trong sản phẩm lazada
  * @param id_shop  
  * @return Promise => bool = true or false
  */
public deleteMergeLazadaProduct_skus(id_sub_or_product:string, item_id:number, SkuId:number, id_shop:string){
  return new Promise((resolve, reject) => {     
    let product:any = this.getlocalDetailProduct(id_sub_or_product); 
    let id_branch = this.getDefaultBranch()._id;                           
    if(product[id_branch] === undefined) return resolve(false);
    if(product[id_branch].lazadas === undefined) return resolve(false);        
    let exist = false;       
    for(let i=0; i<product[id_branch].lazadas.length; i++){    
      if((product[id_branch].lazadas[i].item_id === item_id)&&(product[id_branch].lazadas[i].id_shop === id_shop)){      
        if(product[id_branch].lazadas[i].skus != undefined){
          for(let j=0; j<product[id_branch].lazadas[i].skus.length; j++){           
            if(product[id_branch].lazadas[i].skus[j].SkuId === SkuId){          
              product[id_branch].lazadas[i].skus.splice(j,1);                   
              let value:any = {}; 
              value[id_branch] = product[id_branch];                        
              this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
                  .then((bool:any)=>{
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  }) 
              exist = true;    
              break;
            }
          }
          if(product[id_branch].lazadas[i].skus.length === 0){
            product[id_branch].lazadas.splice(i,1);                 
            let value:any = {}; 
            value[id_branch] = product[id_branch];                       
            this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
                .then((bool:any)=>{
                  resolve(bool);
                }, error=>{
                  reject(error)
                }) 
            exist = true;                 
          }
        }
      }
    }
    if(!exist) resolve(false);                 
  })
}
   
  /**
   * @example:
   *let created_after = new Date('2021-01-25');
    let created_before = new Date('2021-06-30');
    let access_token = '50000601506bKRvdjv16d01472hspFZdjp3qWxFJdNhveuVAezlxvCMt08WkxBrr';
    let id_shop = '100035896';
    this.vhQuerySales.getSalesOrderListLazada( created_after.toISOString(), created_before.toISOString(), access_token, id_shop)
        .then((result)=>{
            console.log('result', result);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param created_after 
   * @param created_before 
   * @param access_token 
   * @returns 
   */
  //hàm này sẽ bỏ
  private getSalesOrderListLazada(created_after:string, created_before:string, access_token:string, id_shop:string){
    return new Promise((resolve, reject) => { 
      let promise_zero = new Promise((resolve, reject)=>{        
        this.vhMGDB_lazada.getOrders(created_after, created_before, access_token)
            .then((response_one:any)=>{                        
              this.productlistlazada.forEach((item:any) => {
                if(item._id === id_shop){
                  item.salesorderdetaillist = response_one;
                }
              })              
              resolve(response_one);
            },(error:any)=>{                   
              reject(error);
            })         
      })
      
      let promise_one = new Promise((resolve, reject)=>{
        let query = {created_at: {$gte:new Date(created_after), $lte: new Date(created_before)}};
        this.vhMGDB_database.getDocsByFields(id_shop, query, {},{},0)
            .then((salesorderlist:any)=>{   
              resolve(salesorderlist);               
            })
      })   

      Promise.all([promise_zero, promise_one]).then((array:any)=>{   
        let newArray = array[0].filter((item:any)=>{
          let bool = true;
          array[1].forEach((item_one:any) => {                          
            if(item.order_id.toString() === item_one._id){             
              bool = false;
            }            
          })          
          return bool;
        })       
        //Tạo 1 bản sao của bill này trong database viethas, ban đầu chỉ có 1 trường order_date_time_stamp
        newArray.forEach((item:any) => {             
          this.vhMGDB_database.addDocbyID(id_shop.toString(), item.order_id.toString(), {created_at: new Date(item.created_at)});               
        })
        for(let i=0; i<array[0].length; i++){
          for(let j=0; j<array[1].length; j++){
            if(array[0][i].order_id === array[1][j]._id){                   
              let _item = {...array[1][j]}; delete _item._id;       
              array[0][i] = {...array[0][i], ..._item};                       
            }    
          }
        }     
        // array[0].forEach((item_zero:any) => { 
        //   array[1].forEach((item_one:any) => {                          
        //     if(item_zero.order_id === item_one._id){   
        //       let _item_one = {...item_one}; delete _item_one._id;       
        //       item_zero = {...item_zero, ..._item_one};             
        //     }            
        //   })          
        // })    
        console.log('salesorderdetaillist', array[0]);    
        resolve(array[0]);        
      })
    })
  }

   /**
   * @example:
   *let created_after = new Date('2021-01-25');
    let created_before = new Date('2021-06-30');
    let access_token = '50000601506bKRvdjv16d01472hspFZdjp3qWxFJdNhveuVAezlxvCMt08WkxBrr';
    let id_shop = '100035896';
    this.vhQuerySales.getSalesOrderDetailListLazada( created_after.toISOString(), created_before.toISOString(), access_token, id_shop)
        .then((result)=>{
            console.log('result', result);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param created_after 
   * @param created_before 
   * @param access_token 
   * @returns 
   */
  public getSalesOrderDetailListLazada(created_after:string, created_before:string, access_token:string, id_shop:string){
    return new Promise((resolve, reject) => { 
      let promise_zero = new Promise((resolve, reject)=>{        
        this.vhMGDB_lazada.getOrdersDetail(created_after, created_before, access_token)
            .then((result:any)=>{                                                 
              this.productlistlazada.forEach((item:any) => {
                if(item._id === id_shop){
                  item.salesorderdetaillist = result;
                }
              })     
              resolve(result);                         
            },(error:any)=>{                   
              reject(error);
            })         
      })
      
      let promise_one = new Promise((resolve, reject)=>{
        let query = {created_at: {$gte:new Date(created_after), $lte: new Date(created_before)}};
        this.vhMGDB_database.getDocsByFields(id_shop, query, {},{},0)
            .then((salesorderlist:any)=>{                 
              resolve(salesorderlist);               
            })
      })   

      Promise.all([promise_zero, promise_one]).then((array:any)=>{   
        let newArray = array[0].filter((item:any)=>{
          let bool = true;
          array[1].forEach((item_one:any) => {                          
            if(item.order_id.toString() === item_one._id){             
              bool = false;
            }            
          })          
          return bool;
        })                    
        //Tạo 1 bản sao của bill này trong database viethas, ban đầu chỉ có 1 trường created_at
        newArray.forEach((item:any) => {    
          this.vhMGDB_database.addDocbyID(id_shop.toString(), item.order_id.toString(), {created_at: new Date(item.order_items[0].created_at)});               
        })
      
        for(let i=0; i<array[0].length; i++){
          delete array[0][i].order_number;
          for(let j=0; j<array[1].length; j++){
            if(String(array[0][i].order_id) === array[1][j]._id){                 
              let _item = {...array[1][j]}; delete _item._id; delete _item.created_at; //lưu ý created_at trong db viethas và db lazada có kiểu khác nhau nên xóa đi khi chập 2 cái lại, nhằm tránh xung đột kiểu dữ liệu                       
              array[0][i] = {...array[0][i], ..._item};  
              break;
            }
          }
        }
        console.log('salesorderdetaillist', array[0]);    
        resolve(array[0]);        
      })
    })
  }

  /**
 * Hàm này lấy về chi tiết của một hóa đơn
 * @example
 * this.vhQuerySales.getSalesOrderDetailLazada('14424213387', '403754acaafc4564a16c19faa32d73c8', 'gsdr3454u54w34tfq')
        .then((salesorderdetail)=>{
          console.log('salesorderdetail', salesorderdetail);
        },(error:any)=>{
          console.log('error', error);
        })
 * @param order_id 
 * @param access_token 
 * @param id_shop 
 * @returns Promise => obj ={} or null
 */
  public getSalesOrderDetailLazada(order_id:string, access_token:string, id_shop:any){
    return new Promise((resolve, reject)=>{         
      let promise_zero = this.vhMGDB_lazada.getOrderDetail(order_id, access_token);
      let promise_one = this.vhMGDB_database.getDoc(id_shop, order_id);
      Promise.all([promise_zero, promise_one]).then((array:any)=>{
        if(array[0]){
          if(!array[1]){
            this.vhMGDB_database.addDocbyID(id_shop, array[0].order_id, {created_at: new Date(array[0].sales_order.created_at)});  
          }         
        }
        resolve(array[0]);
      })       
    })
  }

   /**
   * Hàm này lấy về mảng các đơn hàng (salesorder) được lưu trong database viethas (ko phải database sendo)
   * @example
   * this.vhQuerySales.getSalesOrderLazada_fromViethas( ['14424213387','14424273835'], '403754acaafc4564a16c19faa32d73c8')
        .then((array:any)=>{
          console.log('array', array);
        },(error:any)=>{
          console.log('error', error);
        })
   * @param order_idArray 
   * @param id_shop 
   * @returns Promise => Array(object or null)
   */
  public getSalesOrderLazada_fromViethas(order_idArray:any, id_shop:string){
    return new Promise((resolve, reject) => {      
      let promise = new Array();
      for(let i=0; i<order_idArray.length; i++){
        promise[i] = this.vhMGDB_database.getDoc(id_shop, order_idArray[i]);
      }
      Promise.all(promise).then(array=>{  
        resolve(array);      
        //resolve(array.filter((item:any)=> item !=null));
      })      
    })    
  }

  /**
   * @example:
   * let order_date_from = new Date('2021-01-1');
    let order_date_to = new Date('2021-06-30');
    let id_shop = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9';
    this.vhQuerySales.getSalesOrderDetailListLazada_fromViethas( order_date_from, order_date_to, id_shop).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
    * @param order_date_from 
    * @param order_date_to 
    * @param id_shop 
    * @returns Promise Array
    */
  public getSalesOrderDetailListLazada_fromViethas(order_date_from:string, order_date_to:string, id_shop:string){
    return new Promise((resolve, reject)=>{
      let query = {order_date_time_stamp: {$gte:new Date(order_date_from), $lte: new Date(order_date_to)}};
      this.vhMGDB_database.getDocsByFields(id_shop, query, {},{order_date_time_stamp:1},0)
          .then((salesorderlist:any)=>{   
            resolve(salesorderlist);               
          })
    })
  }
/**
 * Hàm này cập nhật các đơn hàng (salesorder) được lưu trong database viethas (ko phải database lazada), lưu ý các order_id đc lấy từ lazada server về
 * @example:
 * this.vhQuerySales.updateSalesOrderLazada('5fb67fda87c0f21d484cbdf3', 'gsdfgsdg4345324534t3w', {check:true})
      .then((bool:any)=>{
        console.log('updateSalesOrderLazada', bool);
      }, error=>{
        reject(error)
      })
  * @param id_shop 
  * @param order_id 
  * @param data 
  * @return Promise => bool = true or false
  */
  public updateSalesOrderLazada(id_shop:string, order_id:string, data:object){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.updateDoc(id_shop, order_id, data)
          .then((bool:any)=>{
            if(bool){
              this.productlistlazada.forEach((item_zero:any) => {
                if(item_zero._id === id_shop){
                  item_zero.salesorderdetaillist.forEach((item_one:any) => {
                    if(item_one.order_id === order_id){   
                      item_one = {...item_one, ...data};  
                    }
                  })  
                }
              })                           
            }                   
            resolve(bool);     
          }, error=>{
            reject(error)
          })
    })   
  }

  /**
   * Hàm này cập nhật các đơn hàng (salesorder) được lưu trong database viethas (ko phải database lazada), lưu ý các order_id đc import từ file ngoài vào (excel, csv...)
   * @example:
   * this.vhQuerySales.updateSalesOrderLazada_byFile(['144242133871', '14424213387'], {check:true}, 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdG9yZUlkIjoiNTczNjciLCJVc2VyTmFtZSI6IiIsIlN0b3JlU3RhdHVzIjoiMiIsIlNob3BUeXBlIjoiMCIsIlN0b3JlTGV2ZWwiOiIzIiwiZXhwIjoxNjMzODE3MzIwLCJpc3MiOiI1NzM2NyIsImF1ZCI6IjU3MzY3In0.9S18n7EuG7XxbZVm9kjUBozJVjx2_EZRNAn38wBUaDs', '403754acaafc4564a16c19faa32d73c8')
          .then((array:any)=>{
            console.log('updateSalesOrderLazada_byFile', array);
          }, error=>{
            console.log(error)
          })
    * @param order_idArray 
    * @param data
    * @param token 
    * @param id_shop 
    * @return Promise => Array(bool) = [true or false,,...]
    */
  public updateSalesOrderLazada_byFile(order_idArray:any, data:object, token:string, id_shop:string){
    return new Promise((resolve, reject) => {  
      let promise = new Array();
      for(let i=0; i<order_idArray.length; i++){
        promise[i] = new Promise(resolve=>{
          this.vhMGDB_lazada.getOrderDetail(order_idArray[i], token)
              .then((salesorderdetail)=>{
                if(salesorderdetail){
                  this.vhMGDB_database.getDoc(id_shop, order_idArray[i])
                      .then((salesorder)=>{
                        if(salesorder){
                          this.vhMGDB_database.updateDoc(id_shop, order_idArray[i], data)
                              .then((bool:any)=>{
                                resolve(bool);
                              }, ()=>{
                                resolve(false);
                              })
                        }else{
                          this.vhMGDB_database.addDocbyID(id_shop, order_idArray[i], data)
                              .then(()=>{
                                resolve(true);
                              })
                        }                   
                      })
                  
                }else{
                  resolve(false)
                }            
              }, ()=>{
                //reject(error)
                resolve(false)
              })     
        })
      }
      Promise.all(promise).then(array=>{
        resolve(array)
      })
    })   
  }


  /**
   * Hàm truy vấn thông tin chi tiết giao dịch của người bán trong phạm vi ngày cụ thể
   * @example:
   * this.vhQuerySales.getTransactionDetailsLazada(json, access_token)
          .then((array)=>{

          }, error=>{
            reject(error)
          })
   * @param json : {start_time, end_time, limit, offset, trade_order_id, trade_order_line_id, trans_type}
   * @param access_token 
   * @returns Promise => Array
   */
  getTransactionDetailsLazada(json:any, access_token:string){
     return new Promise((resolve, reject) => {
        this.vhMGDB_lazada.getTransactionDetails(json, access_token)
                    .then((data:any)=>{                                         
                      resolve(data);
                    },(error:any)=>{                   
                      reject(error);
                    })    
     })
    
  }

  /**
   * Hàm này lấy về khách hàng đã được gán cho mỗi shop(id_shop) trước đây, nếu trước đây chưa gán thì lấy về giá trị null
   * @example:
   * this.vhQuerySales.getShopPartner('5fb67fda87c0f21d484cbdf3')
          .then((customer)=>{
            console.log('getShopPartner', customer);
          }, error=>{
            reject(error)
          })
   * @param id_shop 
   * @returns Promise => object(customer) or null
   */
  public getShopPartner(id_shop:string){
    return new Promise((resolve, reject) => {
     this.getBills_byFields({id_shop:{$eq:id_shop}},{},{},1)
          .then((bills:any)=>{                      
            if(bills.length===0){              
              resolve(null);
            }else{
              resolve(this.getlocalCustomer(bills[0].id_customer));             
            }
          }, error=>{
            reject(error)
          })             
    })
  }

  /**
   * Hàm này dùng update thông tin cho các shop
   * this.vhQuerySales.updateShop('5fb6780ca2148e09806c5b01', {name:lazadashop, id_customer: 'soidfja9wfhwa'})
          .then((bool:any)=>{
            console.log(bool);
          }, error=>{
            console.log(error);
          })        
   * @param id_shop 
   * @param data 
   * @return Promise => bool = true or false
   */
  public updateShop(id_shop:string, data:object){
    return new Promise((resolve, reject) => {   
      this.vhMGDB_database.getDoc('ecommerces', id_shop)
          .then((shop:any)=>{
            //console.log('shop', shop);
            if(shop){
              let _data = {};
              if(shop.data != undefined){
                _data = {...shop.data, ...data};
              }else{
                _data = {...data};
              }
              this.vhMGDB_database.updateDoc('ecommerces', id_shop,{data:_data})
                  .then((bool:any)=>{                    
                    for(let i=0; i<this.shoplistlazada.length; i++){
                      if(this.shoplistlazada[i]._id === id_shop){
                        this.shoplistlazada[i].data = _data;
                        break;
                      }
                    }
                    for(let i=0; i<this.shoplistsendo.length; i++){
                      if(this.shoplistsendo[i]._id === id_shop){
                        this.shoplistsendo[i].data = _data;
                        break;
                      }
                    }
                    for(let i=0; i<this.shoplisttiki.length; i++){
                      if(this.shoplisttiki[i]._id === id_shop){
                        this.shoplisttiki[i].data = _data;
                        break;
                      }
                    }
                    resolve(bool);
                  }, error=>{
                    reject(error);
                  })  
            }else{
              resolve(false);
            }
          })
    })
  }
/*-----------------SENDO ECOMMERCE---------------*/
/**
 * @example:
 * let json = [{
        "id": 48431726,
        "stock_quantity" : 69,
        "Field_Mask": [
            "quantity"
        ],
        "variants": []
    }]
   let token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdG9yZUlkIjoiODUyMjU5IiwiVXNlck5hbWUiOiIiLCJTdG9yZVN0YXR1cyI6IjIiLCJTaG9wVHlwZSI6IjEiLCJTdG9yZUxldmVsIjoiMCIsImV4cCI6MTYzMDAxMzM1NCwiaXNzIjoiODUyMjU5IiwiYXVkIjoiODUyMjU5In0.CYoBo-4tMOFrQXBZyw4ZvxKz0YOPU9IsWoRjIQtslis'
    this.vhQuerySales.updateByJSONSendo( json, token).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
 * @param json 
 * @param token 
 * @returns 
 */
  public updateByJSONSendo(json:any, token:string){
    return new Promise((resolve, reject)=>{   
      this.vhMGDB_sendo.updateByJSONSendo(json, token)
                  .then((result:any)=>{                                             
                    if(result.vcode === 0){                                
                        resolve(result.data);                                          
                    }else{
                      console.log(result.message);
                      resolve(null);
                    }                   
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }

  /**
   * @example:
   * this.vhQuerySales.updateOrderStatusSendo(order_number, order_status, cancel_order_reason, token)
          .then((bool:any)=>{
            console.log(bool);
          }, error=>{
            console.log(error);
          })   
   * @param order_number 
   * @param order_status 
   * @param cancel_order_reason 
   * @param token 
   * @returns Promise => bool = true or false
   */
  public updateOrderStatusSendo(order_number:string, order_status:number, cancel_order_reason: string, token:string){
    return new Promise((resolve, reject)=>{   
      this.vhMGDB_sendo.updateOrderStatusSendo(order_number, order_status, cancel_order_reason, token)
                  .then((bool:any)=>{                                             
                    resolve(bool);                
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }
  
  /**
   * @example:
   * let order_date_from = new Date('2021-01-1');
    let order_date_to = new Date('2021-06-30');
    let token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdG9yZUlkIjoiODUyMjU5IiwiVXNlck5hbWUiOiIiLCJTdG9yZVN0YXR1cyI6IjIiLCJTaG9wVHlwZSI6IjEiLCJTdG9yZUxldmVsIjoiMCIsImV4cCI6MTYzMDAxMzM1NCwiaXNzIjoiODUyMjU5IiwiYXVkIjoiODUyMjU5In0.CYoBo-4tMOFrQXBZyw4ZvxKz0YOPU9IsWoRjIQtslis'
    let id_shop = '403754acaafc4564a16c19faa32d73c8';
    this.vhQuerySales.getSalesOrderDetailListSendo( order_date_from.toISOString(), order_date_to.toISOString(), token, id_shop).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
   * @param order_date_from 
   * @param order_date_to 
   * @param token 
   * @returns Promise Array
   */
  public getSalesOrderDetailListSendo(order_date_from:string, order_date_to:string, token:string, id_shop:string){
    return new Promise((resolve, reject) => { 
      let promise_zero = new Promise((resolve, reject)=>{
        this.vhMGDB_sendo.getSalesOrderPageTokensSendo(order_date_from, order_date_to, token)
          .then((response_zero)=>{                     
              let page_tokens = response_zero;
              this.vhMGDB_sendo.getSalesOrderDetailPages(order_date_from, order_date_to, page_tokens, token)
                  .then((response_one:any)=>{                        
                    this.productlistsendo.forEach((item:any) => {
                      if(item._id === id_shop){
                        item.salesorderdetaillist = response_one;
                      }
                    })              
                    resolve(response_one);
                  },(error:any)=>{                   
                    reject(error);
                  })   
          },(error:any)=>{           
            reject(error);
          })
      })     
      let promise_one = new Promise((resolve, reject)=>{
        let query = {order_date_time_stamp: {$gte:new Date(order_date_from), $lte: new Date(order_date_to)}};
        this.vhMGDB_database.getDocsByFields(id_shop, query)
            .then((salesorderlist:any)=>{   
              resolve(salesorderlist);               
            })
      })   

      Promise.all([promise_zero, promise_one]).then((array:any)=>{         
        let newArray = array[0].filter((item:any)=>{
          let bool = true;
          array[1].forEach((item_one:any) => {                          
            if(item.sales_order.order_number === item_one._id){             
              bool = false;
            }            
          })          
          return bool;
        })          
        //Tạo 1 bản sao của bill này trong database viethas, ban đầu chỉ có 1 trường order_date_time_stamp
        let offset = new Date().getTimezoneOffset();// múi giờ đơn vị phút, ví dụ vn là -420
        newArray.forEach((item:any) => {           
          this.vhMGDB_database.addDocbyID(id_shop, item.sales_order.order_number, {order_date_time_stamp: new Date((item.sales_order.order_date_time_stamp + offset*60) *1000)});               
        })
        for(let i=0; i<array[0].length; i++){
          for(let j=0; j<array[1].length; j++){
            if(array[0][i].sales_order.order_number === array[1][j]._id){                   
              let _item = {...array[1][j]}; delete _item._id; delete _item.order_date_time_stamp; //lưu ý order_date_time_stamp trong db viethas và db sendo có kiểu khác nhau nên xóa đi khi chập 2 cái lại, nhằm tránh xung đột kiểu dữ liệu                 
              array[0][i].sales_order = {...array[0][i].sales_order, ..._item};                       
            }    
          }
        }    
        // array[0].forEach((item_zero:any) => { 
        //   array[1].forEach((item_one:any) => {                          
        //     if(item_zero.sales_order.order_number === item_one._id){   
        //       let _item_one = {...item_one}; delete _item_one._id;  delete _item_one.order_date_time_stamp;       
        //       item_zero.sales_order = {...item_zero.sales_order, ..._item_one};             
        //     }            
        //   })          
        // })        
        resolve(array[0]);        
      })
    })
  }

  /**
   * Hàm này lấy về chi tiết của một hóa đơn
   * @param order_number 
   * @param token 
   * @param id_shop 
   * @returns Promise => obj ={} or null
   */
  public getSalesOrderDetailSendo(order_number:any, token:string, id_shop:any){
    return new Promise((resolve, reject)=>{    
      let promise_zero = this.vhMGDB_sendo.getSalesOrderDetail(order_number, token);
      let promise_one = this.vhMGDB_database.getDoc(id_shop, order_number);
      Promise.all([promise_zero, promise_one]).then((array:any)=>{
        if(array[0]){
          let offset = new Date().getTimezoneOffset();// múi giờ đơn vị phút, ví dụ vn là -420
          if(!array[1]){
            this.vhMGDB_database.addDocbyID(id_shop, array[0].sales_order.order_number, {order_date_time_stamp: new Date((array[0].sales_order.order_date_time_stamp + offset *60) *1000)});  
          }         
        }
        resolve(array[0]);
      })       
    })
  }

  /**
   * Hàm này lấy về mảng các đơn hàng (salesorder) được lưu trong database viethas (ko phải database sendo)
   * @example
   * this.vhQuerySales.getSalesOrderListSendo_fromViethas( ['14424213387','14424273835'], '403754acaafc4564a16c19faa32d73c8')
        .then((array:any)=>{
          console.log('array', array);
        },(error:any)=>{
          console.log('error', error);
        })
   * @param order_numberArray 
   * @param id_shop 
   * @returns Promise => Array(object or null)
   */
  public getSalesOrderSendo_fromViethas(order_numberArray:any, id_shop:string){
    return new Promise((resolve, reject) => {      
      let promise = new Array();
      for(let i=0; i<order_numberArray.length; i++){
        promise[i] = this.vhMGDB_database.getDoc(id_shop, order_numberArray[i]);
      }
      Promise.all(promise).then(array=>{  
        resolve(array);      
        //resolve(array.filter((item:any)=> item !=null));
      })      
    })    
  }

  /**
   * @example:
   * let order_date_from = new Date('2021-01-1');
    let order_date_to = new Date('2021-06-30');
    let id_shop = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9';
    this.vhQuerySales.getSalesOrderDetailListSendo_fromViethas( order_date_from, order_date_to, id_shop).then((result)=>{
        console.log('result', result);
      },(error:any)=>{
        console.log('error', error);
      })
   * @param order_date_from 
   * @param order_date_to 
   * @param id_shop 
   * @returns Promise Array
   */
  public getSalesOrderDetailListSendo_fromViethas(order_date_from:string, order_date_to:string, id_shop:string){
    return new Promise((resolve, reject)=>{
      let query = {order_date_time_stamp: {$gte:new Date(order_date_from), $lte: new Date(order_date_to)}};
      this.vhMGDB_database.getDocsByFields(id_shop, query, {},{order_date_time_stamp:1},0)
          .then((salesorderlist:any)=>{   
            resolve(salesorderlist);               
          })
    })
  }
/**
 * Hàm này cập nhật các đơn hàng (salesorder) được lưu trong database viethas (ko phải database sendo), lưu ý các order_number đc lấy từ sendo server về
 * @example:
 * this.vhQuerySales.updateSalesOrderSendo('5fb67fda87c0f21d484cbdf3', 'gsdfgsdg4345324534t3w', {check:true})
      .then((bool:any)=>{
        console.log('updateSalesOrderSendo', bool);
      }, error=>{
        reject(error)
      })
  * @param id_shop 
  * @param order_number 
  * @param data 
  * @return Promise => bool = true or false
  */
  public updateSalesOrderSendo(id_shop:string, order_number:string, data:object){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.updateDoc(id_shop, order_number, data)
          .then((bool:any)=>{
            if(bool){
              this.productlistsendo.forEach((item_zero:any) => {
                if(item_zero._id === id_shop){
                  item_zero.salesorderdetaillist.forEach((item_one:any) => {
                    if(item_one.sales_order.order_number === order_number){   
                      item_one.sales_order = {...item_one.sales_order, ...data};  
                    }
                  })  
                }
              })                           
            }                   
            resolve(bool);     
          }, error=>{
            reject(error)
          })
    })   
  }

  /**
   * Hàm này cập nhật các đơn hàng (salesorder) được lưu trong database viethas (ko phải database sendo), lưu ý các order_number đc import từ file ngoài vào (excel, csv...)
   * @example:
   * this.vhQuerySales.updateSalesOrderListSendo_byFile(['144242133871', '14424213387'], {check:true}, 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdG9yZUlkIjoiNTczNjciLCJVc2VyTmFtZSI6IiIsIlN0b3JlU3RhdHVzIjoiMiIsIlNob3BUeXBlIjoiMCIsIlN0b3JlTGV2ZWwiOiIzIiwiZXhwIjoxNjMzODE3MzIwLCJpc3MiOiI1NzM2NyIsImF1ZCI6IjU3MzY3In0.9S18n7EuG7XxbZVm9kjUBozJVjx2_EZRNAn38wBUaDs', '403754acaafc4564a16c19faa32d73c8')
          .then((array:any)=>{
            console.log('updateSalesOrderListSendo_byFile', array);
          }, error=>{
            console.log(error)
          })
   * @param order_numberArray 
   * @param data
   * @param token 
   * @param id_shop 
   * @return Promise => Array(bool) = [true or false,,...]
   */
  public updateSalesOrderSendo_byFile(order_numberArray:any, data:object, token:string, id_shop:string){
    return new Promise((resolve, reject) => {  
      let promise = new Array();
      for(let i=0; i<order_numberArray.length; i++){
        promise[i] = new Promise(resolve=>{
          this.vhMGDB_sendo.getSalesOrderDetail(order_numberArray[i], token)
              .then((salesorderdetail)=>{
                if(salesorderdetail){
                  this.vhMGDB_database.getDoc(id_shop, order_numberArray[i])
                      .then((salesorder)=>{
                        if(salesorder){
                          this.vhMGDB_database.updateDoc(id_shop, order_numberArray[i], data)
                              .then((bool:any)=>{
                                resolve(bool);
                              }, ()=>{
                                resolve(false);
                              })
                        }else{
                          this.vhMGDB_database.addDocbyID(id_shop, order_numberArray[i], data)
                              .then(()=>{
                                resolve(true);
                              })
                        }                   
                      })
                  
                }else{
                  resolve(false)
                }            
              }, ()=>{
                //reject(error)
                resolve(false)
              })     
        })
      }
      Promise.all(promise).then(array=>{
        resolve(array)
      })
    })   
  }

  /**
   * let localshoplistsendo = this.vhQuerySales.getlocalShopListSendo();
   * @returns 
   */
  public getlocalShopListSendo(){            
    return this.shoplistsendo;          
  }

/**
 * @example: 
 * let productlistsendo = this.vhQuerySales.getlocalProductListSendo('ư0e4tuiwe98rhvqw9vtqw9t7rq987r9qvwn98et98');
 * @param status 
 * @returns 
 */
 public getlocalProductListSendo(id_shop:any){          
  for(let i=0; i<this.productlistsendo.length; i++){
    if(this.productlistsendo[i]._id === id_shop){            
      return cloneDeep(this.productlistsendo[i].productlist);           
    }
  }
  return []; 
}

 /**
 * @example:
 * this.vhQuerySales.refreshLocalProductListSendo()
        .then(()=>{
          do something.....
        })
 * Hàm này refresh giá trị mới nhất cho hàm getProductListSendo() trong localstorage
 * @return Promise => null
 */
  public refreshLocalProductListSendo(shop_id?:string):any{
    return new Promise((resolve, reject) => { 
      if((shop_id!='')&&(shop_id!=undefined)){
        this.getProductListSendo(shop_id)
            .then(()=>{resolve(null)});     
      }else{
        this.getProductListSendos()
            .then(()=>{resolve(null)});     
      }
      
    })
  }

/**
 * @example:
 * this.vhQuerySales.getProductListSendo().then(()=>{
        do something...
       },(error:any)=>{         
       })
 * @returns 
 */
/*private getProductListSendo(){
  return new Promise((resolve, reject)=>{  
    let id_branch = this.getDefaultBranch()._id;     
    this.vhMGDB_sendo.getShopList(id_branch)
        .then((result_zero:any)=>{    
          //console.log('shoplist', result_zero);                            
          if(result_zero.vcode === 0){                   
            this.shoplistsendo = [...result_zero.data];    
            this.productlistsendo = [...result_zero.data];    
            let promise = new Array();             
            for(let i=0; i<this.productlistsendo.length; i++){
              promise[i] = new Promise((resolve, reject)=>{ 
                let settimeout = setTimeout(() => {
                  this.vhMGDB_sendo.getProductPage(this.productlistsendo[i].page_tokens, this.productlistsendo[i].token)
                      .then((result_one:any)=>{                      
                        this.productlistsendo[i].productlist = result_one;
                        resolve(result_one);
                      })
                  clearTimeout(settimeout);  
                }, 1000*i);   
              })              
            } 
            Promise.all(promise).then(()=>{     
              console.log('productlistsendo', this.productlistsendo);                  
              resolve(null);
            })
          }else{
            console.log('lỗi:',result_zero.message);
            reject(result_zero.message);
          }                   
        },(error:any)=>{
          reject(error);
        })     
  })    
}*/

private getProductListSendo(shop_id:string){
  return new Promise((resolve, reject)=>{  
    let id_branch = this.getDefaultBranch()._id;     
    this.vhMGDB_sendo.getShop(id_branch, shop_id)
        .then((result_zero:any)=>{    
          console.log('shopsendo', result_zero);                            
          if(result_zero.vcode === 0){                   
            this.shoplistsendo = [...result_zero.data];    
            this.productlistsendo = [...result_zero.data];    
            let promise = new Array();             
            for(let i=0; i<this.productlistsendo.length; i++){
              promise[i] = new Promise((resolve, reject)=>{ 
                //let settimeout = setTimeout(() => {
                  this.vhMGDB_sendo.getProductListSendo(this.productlistsendo[i].token)
                      .then((result_one:any)=>{                      
                        this.productlistsendo[i].productlist = result_one;
                        resolve(result_one);
                      })
                  //clearTimeout(settimeout);  
                //}, 1000*i);   
              })              
            } 
            Promise.all(promise).then(()=>{     
              console.log('productlistsendo', this.productlistsendo);                  
              resolve(null);
            })
          }else{
            console.log('lỗi:',result_zero.message);
            reject(result_zero.message);
          }                   
        },(error:any)=>{
          reject(error);
        })     
  })    
}

private getProductListSendos(){
  return new Promise((resolve, reject)=>{  
    let id_branch = this.getDefaultBranch()._id;     
    this.vhMGDB_sendo.getShopList(id_branch)
        .then((result_zero:any)=>{    
          console.log('shoplist', result_zero);                            
          if(result_zero.vcode === 0){                   
            this.shoplistsendo = [...result_zero.data];    
            this.productlistsendo = [...result_zero.data];    
            let promise = new Array();             
            for(let i=0; i<this.productlistsendo.length; i++){
              promise[i] = new Promise((resolve, reject)=>{ 
                //let settimeout = setTimeout(() => {
                  this.vhMGDB_sendo.getProductListSendo(this.productlistsendo[i].token)
                      .then((result_one:any)=>{                      
                        this.productlistsendo[i].productlist = result_one;
                        resolve(result_one);
                      })
                  //clearTimeout(settimeout);  
                //}, 1000*i);   
              })              
            } 
            Promise.all(promise).then(()=>{     
              console.log('productlistsendo', this.productlistsendo);                  
              resolve(null);
            })
          }else{
            console.log('lỗi:',result_zero.message);
            reject(result_zero.message);
          }                   
        },(error:any)=>{
          reject(error);
        })     
  })    
}

/**
 * @example:
 * this.vhQuerySales.getProductDetailSendo(['13857630'], 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTdG9yZUlkIjoiNTczNjciLCJVc2VyTmFtZSI6IiIsIlN0b3JlU3RhdHVzIjoiMiIsIlNob3BUeXBlIjoiMCIsIlN0b3JlTGV2ZWwiOiIzIiwiZXhwIjoxNjMzNjU1ODMxLCJpc3MiOiI1NzM2NyIsImF1ZCI6IjU3MzY3In0.qM6gqpf3758JrSsTL2JlDOoD-TFS1VVaGkL6ixaI_lw', '403754acaafc4564a16c19faa32d73c8').then((productdetail)=>{
          console.log('productdetail', productdetail);
       },(error:any)=>{         
       })
 * @param idArray 
 * @param token 
 * @returns Promise
 */
public getProductDetailSendo(idArray:any, token:string, id_shop:any){  
  return new Promise((resolve, reject)=>{     
    let promise = [];
    for(let i=0; i<idArray.length; i++){
      promise[i] = this.vhMGDB_sendo.getProductDetail(idArray[i], token)          
    } 
    Promise.all(promise).then((productdetails:any)=>{     
      for(let i=0; i<this.productlistsendo.length; i++){
        if(this.productlistsendo[i]._id === id_shop){
          for(let m=0; m<productdetails.length; m++){
            for(let n=0; n<this.productlistsendo[i].productlist.length; n++){
              if(productdetails[m].id === this.productlistsendo[i].productlist[n].id){
                this.productlistsendo[i].productlist[n] = {...this.productlistsendo[i].productlist[n],...productdetails[m]};                
                break;
              }
            }
          }  
        }
      }     
      resolve(productdetails);
    })
     
  })
}

/**
 * @example:
 * this.vhQuerySales.signInSendo('09384tni0qw8t9q90g', '938476838whsofis', {name: sendo 1}).then((obj)=>{
        if(obj){
          console.log('obj', obj)
        }
    })
  * @param shop_key 
  * @param secret_key 
  * @param data 
  * @returns Promise => obj or null
  */
  public signInSendo(shop_key:string, secret_key:string, data:object){//vì login trực tiếp từ APP nên ko cần backHref
    return new Promise((resolve, reject)=>{   
      let id_branch = this.getDefaultBranch()._id; 
      this.vhMGDB_sendo.signIn(shop_key, secret_key, data, id_branch)
                  .then((result:any)=>{                                
                    if(result.vcode === 0){  
                      this.shoplistsendo.push(result.data);  
                      //console.log('getlocalShopListSendo()', this.shoplistsendo);
                      resolve(result.data);                                
                    }else{
                      console.log(result.message);
                      resolve(null);
                    }                   
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }

/**
 * @example:
  this.vhQuerySales.signOutSendo('938476838whsofis').then((bool:any)=>{
      if(bool){
        console.log('bool', bool)
      }
  })
  * @param id_shop 
  * @returns Promise => true or false
  */
  public signOutSendo(id_shop:string){
    return new Promise((resolve, reject)=>{   
      this.vhMGDB_sendo.signOut(id_shop)
                  .then((result:any)=>{                                
                    if(result.vcode === 0){    
                      for(let i=0; i<this.shoplistsendo.length;i++){
                        if(this.shoplistsendo[i]._id === id_shop){
                          this.shoplistsendo.splice(i,1);
                          break;
                        }
                      }                             
                      for(let i=0; i<this.productlistsendo.length;i++){
                        if(this.productlistsendo[i]._id === id_shop){
                          this.productlistsendo.splice(i,1);
                          break;
                        }
                      }            
                      resolve(true)
                    }else{
                      console.log(result.message);
                      reject(false);
                    }                   
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }

  /**
   * @example:
    this.vhQuerySales.getShopListSendo().then((array:any)=>{             
          console.log('array', array);             
    })
  * @returns Promise => array =[{},{},...]
  */
  private getShopListSendo(){
    return new Promise((resolve, reject)=>{   
      let id_branch = this.getDefaultBranch()._id; 
      this.vhMGDB_sendo.getShopList(id_branch)
                  .then((result:any)=>{                                
                    if(result.vcode === 0){     
                      //this.shoplistsendo = result.data;
                      this.shoplistsendo.push(result.data);   
                      resolve(result.data)
                    }else{
                      console.log(result.message);
                      reject(result.message);
                    }                   
                  },(error:any)=>{
                    reject(error);
                  })      
    })    
  }          

  /**
   * @example:
   * this.vhQuerySales.createMergeSendosProduct('5fb6780ca2148e09806c5b01',['48284964','48284965', '48284966'], '870909t87t098thiuahn')
          .then((sendosproduct)=>{
            console.log('createMergeSendosProduct', sendosproduct);
          }, error=>{
            console.log('error', error);
          })
   * @param id_product 
   * @param sendoproductArray 
   * @param id_shop 
   * @return Promise => array = [{},{},..]
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  // public createMergeSendosProduct(id_product:string, sendoproductArray:any){
  //   return new Promise((resolve, reject) => {      
  //     let id_branch = this.getDefaultBranch()._id; 
  //     //let id_shop = sendoproductArray[0].id_shop;
  //     let sendos = [...sendoproductArray];    
  //     let bool = false;
  //     let product:any;
  //     let number = 0;           
  //     let setinterval = setInterval(() => {
  //         number++;
  //         product = this.getlocalProduct(id_product);
  //         if(product){
  //           bool = true;
  //           if(product[id_branch] != undefined){
  //             if(product[id_branch].sendos === undefined) product[id_branch].sendos = new Array();             
  //           }else{
  //             product[id_branch]={};
  //             product[id_branch].sendos = new Array();
  //           }             
  //           product[id_branch].sendos = [...product[id_branch].sendos,...sendos];  
  //           let value:any = {}; 
  //           value[id_branch] = product[id_branch];                                        
  //           this.vhMGDB_database.updateDoc('products', id_product, {...value})
  //               .then(()=>{                 
                  
  //                 resolve(sendos);
  //               }, error=>{
  //                 reject(error)
  //               })      
  //         }             
  //         if((bool===true)||(number ===50)) clearInterval(setinterval);             
  //     }, 100);                       
  //   })
  // }  
/**
 * @example:
   * this.vhQuerySales.updateMergeSendosProduct('5fb6780ca2148e09806c5b01', '13123135654', {quantity:400})
          .then((bool:any)=>{
            console.log('updateProduct', bool);
          }, error=>{
            console.log('error', error);
          })
 * @param id_product 
 * @param id: trường id trong sản phẩm sendo
 * @param variant_attribute_hash: trường variant_attribute_hash trong sản phẩm sendo
 * @param data 
 * @returns Promise =>  true or false
 */
  // public updateMergeSendosProduct(id_product:any, id:any, variant_attribute_hash:any, data:any){
  //   return new Promise((resolve, reject) => {    
  //     let product = this.getlocalProduct(id_product);         
  //     let id_branch = this.getDefaultBranch()._id;     
  //     if((product[id_branch] != undefined)&&(product[id_branch].sendos != undefined)){    
  //       //let obj = product[id_branch];      
  //       for(let i=0; i<product[id_branch].sendos.length; i++){
  //         if((product[id_branch].sendos[i].id === id)&&(product[id_branch].sendos[i].variant_attribute_hash === variant_attribute_hash)){
  //           product[id_branch].sendos[i] = {...product[id_branch].sendos[i],...data};
  //           let value:any = {}; 
  //           value[id_branch] = product[id_branch];    
  //           this.vhMGDB_database.updateDoc('products', id_product, {...value})
  //               .then((bool:any)=>{                      
  //                 resolve(bool);
  //               }, error=>{
  //                 reject(error)
  //               })  
  //           break;
  //         }else resolve(false);                   
  //       }                   
  //     }else resolve(false);                                           
  //   })
  // }  

  /**
   * @example:
   * this.vhQuerySales.deleteMergeSendoProduct('5fb67fda87c0f21d484cbdf3', 'gsdfgsdg4345324534t3w', 'jhiy87685765r575345re')
        .then((bool:any)=>{
          console.log('deleteMergeSendoProduct', bool);
        }, error=>{
          reject(error)
        })
   * @param id_product 
   * @param id: trường id trong sản phẩm sendo
   * @param variant_attribute_hash: trường variant_attribute_hash trong sản phẩm sendo     
   * @return Promise => bool = true or false
   */
  // public deleteMergeSendoProduct(id_product:any, id:any, variant_attribute_hash:any){
  //   return new Promise((resolve, reject) => {     
  //     let product:any = this.getlocalProduct(id_product); 
  //     let id_branch = this.getDefaultBranch()._id;                           
  //       if((product[id_branch] != undefined)&&(product[id_branch].sendos != undefined)){    
  //         for(let i=0; i<product[id_branch].sendos.length; i++){
  //           if((product[id_branch].sendos[i].id === id)&&(product[id_branch].sendos[i].variant_attribute_hash === variant_attribute_hash)){
  //             product[id_branch].sendos.splice(i,1);   
  //             let value:any = {}; 
  //             value[id_branch] = product[id_branch];                       
  //             this.vhMGDB_database.updateDoc('products', product._id, {...value})
  //                 .then((bool:any)=>{
  //                   resolve(bool);
  //                 }, error=>{
  //                   reject(error)
  //                 }) 
  //             break;
  //           }else resolve(false);
  //         } 
  //       }else{
  //         resolve(false)
  //       }                 
  //   })
  // }

/**
 * Tạo liên kết sản phẩm trên phần mềm quản lý bán hàng sales viethas và sản phẩm trên sàn sendo
 * @example:
 * this.vhQuerySales.addMergeSendoProduct_variants('5fb6780ca2148e09806c5b01','tf3452345234', [{},{}], 'hjhjrtyur56u53')
        .then((bool:any)=>{
          console.log('addMergeSendoProduct_variants', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_sub_or_product 
  * @param id      
  * @param skuArray : [{variant_attribute_hash,..},{variant_attribute_hash,..}]
  * @param id_shop 
  * @return Promise => boolean true or false
  */
public addMergeSendoProduct_variants(id_sub_or_product:string, id:string, variantArray:any, id_shop:string){
  return new Promise((resolve, reject) => {      
      let id_branch = this.getDefaultBranch()._id;     
      let product = this.getlocalDetailProduct(id_sub_or_product);   
      let obj = {
        id: id,
        id_shop: id_shop,
        variants: [...variantArray]
      };
      if(product[id_branch] != undefined){
        if(product[id_branch].sendos === undefined) product[id_branch].sendos = new Array();             
      }else{
        product[id_branch]={};
        product[id_branch].sendos = new Array();
      }       
      let exist = false;
      for(let i=0; i<product[id_branch].sendos.length; i++){
        if((product[id_branch].sendos[i].id === id)&&(product[id_branch].sendos[i].id_shop === id_shop)){
          if(product[id_branch].sendos[i].variants != undefined){
            product[id_branch].sendos[i].variants = [...product[id_branch].sendos[i].variants,...variantArray];         
          }else{
            product[id_branch].sendos[i].variants = [...variantArray];     
          } 
          let value:any = {}; 
          value[id_branch] = product[id_branch];                                        
          this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
              .then(()=>{                   
                resolve(true);
              }, error=>{
                reject(error)
              })  
          exist = true;    
          break;                
        }
      }
      if(!exist){
        product[id_branch].sendos.push(obj);
        let value:any = {}; 
        value[id_branch] = product[id_branch];                                        
        this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
            .then(()=>{                   
              resolve(true);
            }, error=>{
              reject(error)
            })   
      }                             
  })
} 

/**
 * @example:
   * this.vhQuerySales.updateMergeSendoProduct('5fb6780ca2148e09806c5b01', '435f34tf34f3243fdf', {hidden:true}, 'jfaosidfu9we87f9w')
          .then((bool:any)=>{
            console.log('updateMergeSendoProduct', bool);
          }, error=>{
            console.log('error', error);
          })
 * @param id_sub_or_product 
 * @param id: trường id trong sản phẩm sendo
 * @param data : {hidden:true}
 * @param id_shop

 * @returns Promise => bool = true or false
 */
public updateMergeSendoProduct(id_sub_or_product:string, id:string, data:any, id_shop:string){//cái này dùng cho sendo
  return new Promise((resolve, reject) => {    
    let product = this.getlocalDetailProduct(id_sub_or_product);         
    let id_branch = this.getDefaultBranch()._id;     
    if(product[id_branch] === undefined) return resolve(false);
    if(product[id_branch].sendos === undefined) return resolve(false);       
    let exist = false;      
    for(let i=0; i<product[id_branch].sendos.length; i++){
      if((product[id_branch].sendos[i].id === id)&&(product[id_branch].sendos[i].id_shop === id_shop)){
        product[id_branch].sendos[i] = {...product[id_branch].sendos[i],...data};
        let value:any = {}; 
        value[id_branch] = product[id_branch];    
        this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
            .then((bool:any)=>{                      
              resolve(bool);
            }, error=>{
              reject(error)
            })  
        exist = true;    
        break;
      }                 
    } 
    if(!exist) resolve(false);                      
                                          
  })
}  

/**
 * Lưu ý: 
 *  - trong sản phẩm sendo, tạm ẩn sản phẩm cha thì sản phẩm con ẩn theo luôn
 *  - hàm updateMergeSendoProduct_hidden trả về true thì sản phẩm trong database và trong database có thêm trường hidden 
 * @example:
   * this.vhQuerySales.updateMergeSendoProduct_hidden('435f34tf34f3243fdf', {hidden:true}, 'jfaosidfu9we87f9w')
          .then((bool:any)=>{
            console.log('updateMergeSendoProduct_hidden', bool);
          }, error=>{
            console.log('error', error);
          })
 * @param id: trường id trong sản phẩm sendo
 * @param hidden : {hidden:true}
 * @param id_shop
 * @returns Promise => bool = true or false
 */
public updateMergeSendoProduct_hidden(id:string, hidden:boolean, id_shop:string){//cái này dùng cho sendo
  return new Promise((resolve, reject) => {  
    let id_branch = this.getDefaultBranch()._id;   
    let products = this.getlocalDetailProducts();
    let product = null;
    for(let i=0; i<products.length; i++){
      if((products[i][id_branch] != undefined)&&(products[i][id_branch].sendos != undefined)){
        for(let j=0; j<products[i][id_branch].sendos.length; j++){
          if((products[i][id_branch].sendos[j].id === id)&&(products[i][id_branch].sendos[j].id_shop === id_shop)){
            product = products[i];
            break;
          }
        }
      }
    }  
    if(!product) return resolve(false);      
    
    if(product[id_branch] === undefined) return resolve(false);
    if(product[id_branch].sendos === undefined) return resolve(false);       
    let exist = false;      
    for(let i=0; i<product[id_branch].sendos.length; i++){
      if((product[id_branch].sendos[i].id === id)&&(product[id_branch].sendos[i].id_shop === id_shop)){

        for(let m=0; m<this.productlistlazada.length; m++){
          if(this.productlistlazada[m]._id === id_shop){                      
            for(let n=0; n<this.productlistlazada[m].productlist.length; n++){
              if(this.productlistlazada[m].productlist[n].id === id){  
                this.productlistlazada[m].productlist[n].hidden = hidden;     
                break;  
              }
            }
          }
        }

        product[id_branch].sendos[i].hidden = hidden;
        let value:any = {}; 
        value[id_branch] = product[id_branch];    
        this.vhMGDB_database.updateDoc('products', product.id_subproduct?product.id_subproduct:product._id, {...value})
            .then((bool:any)=>{                      
              resolve(bool);
            }, error=>{
              reject(error)
            })  
        exist = true;    
        break;
      }                 
    } 
    if(!exist) resolve(false);                      
                                          
  })
} 

/**
 *  @example:
 * this.vhQuerySales.updateMergeSendoProduct_variants('5fb6780ca2148e09806c5b01', '435f34tf34f3243fdf', '13123135654', {abc:true}, 'jfaosidfu9we87f9w')
          .then((bool:any)=>{
            console.log('updateMergeSendoProduct_variants', bool);
          }, error=>{
            console.log('error', error);
          })
 * @param id_sub_or_product 
 * @param id : id của sản phẩm sàn sendo
 * @param variant_attribute_hash 
 * @param data : object => data = {abc:true}
 * @param id_shop 
 * @returns Promise => bool = true or false
 */
public updateMergeSendoProduct_variants(id_sub_or_product:string, id:string, variant_attribute_hash:string, data:any, id_shop:string){
  return new Promise((resolve, reject) => {    
      let product = this.getlocalDetailProduct(id_sub_or_product);         
      let id_branch = this.getDefaultBranch()._id;     
      if(product[id_branch] === undefined) return resolve(false);
      if(product[id_branch].sendos === undefined) return resolve(false);        
      let exist = false;
      for(let i=0; i<product[id_branch].sendos.length; i++){           
        if((product[id_branch].sendos[i].id === id)&&(product[id_branch].sendos[i].id_shop === id_shop)){
          if(product[id_branch].sendos[i].variants != undefined)
            for(let j=0; j<product[id_branch].sendos[i].variants.length; j++){
              if(product[id_branch].sendos[i].variants[j].variant_attribute_hash === variant_attribute_hash){
                product[id_branch].sendos[i].variants[j] = {...product[id_branch].sendos[i].variants[j],...data};
                let value:any = {}; 
                value[id_branch] = product[id_branch];    
                this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
                    .then((bool:any)=>{                      
                      resolve(bool);
                    }, error=>{
                      reject(error)
                    })  
                exist = true;    
                break;
              }                  
            }  
        }
      } 
      if(!exist) resolve(false);                                                          
  })
}  

/**
 * @example:
 * this.vhQuerySales.deleteMergeSendoProduct_variants('5fb67fda87c0f21d484cbdf3', 'gsdfgsdg4345324534t3w', 'sdfgsdfgererasds3563')
      .then((bool:any)=>{
        console.log('deleteMergeSendoProduct_variants', bool);
      }, error=>{
        reject(error)
      })
  * @param id_sub_or_product 
  * @param id 
  * @param variant_attribute_hash
  * @param id_shop  
  * @return Promise => bool = true or false
  */
public deleteMergeSendoProduct_variants(id_sub_or_product:string, id:string, variant_attribute_hash:string, id_shop:string){
  return new Promise((resolve, reject) => {     
      let product:any = this.getlocalDetailProduct(id_sub_or_product); 
      let id_branch = this.getDefaultBranch()._id;                           
      if(product[id_branch] === undefined) return resolve(false);
      if(product[id_branch].sendos === undefined) return resolve(false);        
      let exist = false;     
      for(let i=0; i<product[id_branch].sendos.length; i++){    
        if((product[id_branch].sendos[i].id === id)&&(product[id_branch].sendos[i].id_shop === id_shop)){
          if(product[id_branch].sendos[i].variants != undefined){
            for(let j=0; j<product[id_branch].sendos[i].variants.length; j++){
              if(product[id_branch].sendos[i].variants[j].variant_attribute_hash === variant_attribute_hash){
                product[id_branch].sendos[i].variants.splice(j,1);                   
                let value:any = {}; 
                value[id_branch] = product[id_branch];                       
                this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
                    .then((bool:any)=>{
                      resolve(bool);
                    }, error=>{
                      reject(error)
                    }) 
                exist = true;    
                break;
              }
            }
            if(product[id_branch].sendos[i].variants.length === 0){
              product[id_branch].sendos.splice(i,1);                 
              let value:any = {}; 
              value[id_branch] = product[id_branch];                       
              this.vhMGDB_database.updateDoc('products', id_sub_or_product, {...value})
                  .then((bool:any)=>{
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  }) 
              exist = true;                 
            }
          }
        }
      }
      if(!exist) resolve(false);                 
  })
}

public getReportSales_Sendo(starttime:any, endtime:any, IDproduct:any, type?:any, IDbranch?:string){

} 



   /**
   * @example:
    this.vhQuerySales.syncCollections_Mobile().then((bool:any)=>{
        if(bool){
          do something...
        }
    })
   * @returns Promise bool = true or false
   */
    public syncCollections_Mobile(){  
      return new Promise((resolve, reject)=>{       
        let promise_zero = new Array();      
        promise_zero[promise_zero.length] = this.getLocalLiveIndexDB();    
        Promise.all(promise_zero)
          .then(()=>{     
            let promise_one = new Array();    
            this.initSyncCollections();
            promise_one[promise_one.length] = this.callbackCollectionInsert();        
            promise_one[promise_one.length] = this.callbackCollectionUpdate();
            promise_one[promise_one.length] = this.callbackCollectionDelete();             
            Promise.all(promise_one)
                  .then(()=>{                                
                    let promise_two = new Array();               
                    promise_two[promise_two.length] = this.vhAuth.refreshLocalMyPermission();  
                    promise_two[promise_two.length] = this.refreshLocalDeliverys(); 
                    promise_two[promise_two.length] = this.refreshLocalAddresss();         
                    promise_two[promise_two.length] = this.checkExpireBranch_Sales();   
                    promise_two[promise_two.length] = this.refreshLocalPrintPages(); 
                    Promise.all(promise_two).then(()=>{
                        this.syncCashBookEveryDay_Stock1stDayOfMonth()
                            .then(()=>{
                                this.syncInventoryEveryDay_Stock1stDayOfMonth()
                                    .then(()=>{
                                        //console.log('finished syncCollections_Mobile');
                                        resolve(true);                  
                                    })                
                              })                  
                    })
                  }) 
          })           
        })    
    }

    /**
   * @example:
    this.vhQuerySales.syncCollections_Sales365_Mobile().then((bool:any)=>{
        if(bool){
          do something...
        }
    })
   * @returns Promise bool = true or false
   */
    public syncCollections_Sales365_Mobile(){  
     return new Promise((resolve, reject)=>{    
      let promise_zero = new Array();      
      promise_zero[promise_zero.length] = this.getLocalLiveIndexDB();    
      Promise.all(promise_zero)
        .then(()=>{       
          let promise_one = new Array();    
          this.initSyncCollections();
          promise_one[promise_one.length] = this.callbackCollectionInsert();        
          promise_one[promise_one.length] = this.callbackCollectionUpdate();
          promise_one[promise_one.length] = this.callbackCollectionDelete();              
          Promise.all(promise_one)
                .then(()=>{                                
                  let promise_two = new Array();               
                  promise_two[promise_two.length] = this.vhAuth.refreshLocalMyPermission();  
                  promise_two[promise_two.length] = this.refreshLocalDeliverys(); 
                  promise_two[promise_two.length] = this.refreshLocalAddresss();     
                  promise_two[promise_two.length] = this.checkExpireBranch_Sales365();     
                  promise_two[promise_two.length] = this.refreshLocalPrintPages(); 
                  Promise.all(promise_two).then(()=>{
                        this.syncCashBookEveryDay_Stock1stDayOfMonth()
                            .then(()=>{
                                this.syncInventoryEveryDay_Stock1stDayOfMonth()
                                    .then(()=>{
                                        //console.log('finished syncCollections_Mobile');
                                        resolve(true);                  
                                    })                
                              })                  
                  })
                })    
        })        
      })    
   }

  /**
   * @example:
    this.vhQuerySales.syncCollections_Desktop().then((bool:any)=>{
        if(bool){
          do something...
        }
    })
   * @returns Promise bool = true or false
   */
  public syncCollections_Desktop(){        
    return new Promise((resolve, reject)=>{    
      let promise_zero = new Array();      
      promise_zero[promise_zero.length] = this.getLocalLiveIndexDB();    
      Promise.all(promise_zero)
         .then(()=>{          
            let promise_one = new Array();           
            this.initSyncCollections();
            promise_one[promise_one.length] = this.callbackCollectionInsert();    
            promise_one[promise_one.length] = this.callbackCollectionUpdate();
            promise_one[promise_one.length] = this.callbackCollectionDelete();     
            //Ở đây lấy các chi nhánh về rồi, vậy sau này nên bỏ initsync branchs     
            //promise_one[promise_one.length] = this.getBranchs();
            Promise.all(promise_one)
                  .then(()=>{                                             
                      let promise_two = new Array();                          
                      promise_two[promise_two.length] = this.vhAuth.refreshLocalMyPermission();  
                      promise_two[promise_two.length] = this.refreshLocalDeliverys(); 
                      promise_two[promise_two.length] = this.refreshLocalAddresss();         
                      promise_two[promise_two.length] = this.checkExpireBranch_Sales();  
                      promise_two[promise_two.length] = this.refreshLocalPrintPages();        
                      promise_two[promise_two.length] = this.vhDisplayLEDService.refreshLocalDisplayLEDs_byEnable();                    
                      Promise.all(promise_two).then(()=>{
                        this.syncCashBookEveryDay_Stock1stDayOfMonth()
                              .then(()=>{
                                this.syncInventoryEveryDay_Stock1stDayOfMonth()
                                    .then(()=>{
                                      //console.log('finished syncCollections_Desktop');
                                      resolve(true);                  
                                    })                
                              })                  
                      })               
                  }) 
          })              
    })    
  }

  /**
   * @example:
    this.vhQuerySales.syncCollections_Sales365_Desktop().then((bool:any)=>{
        if(bool){
          do something...
        }
    })
   * @returns Promise bool = true or false
   */
   public syncCollections_Sales365_Desktop(){     
   return new Promise((resolve, reject)=>{      
      let promise_zero = new Array();      
      promise_zero[promise_zero.length] = this.getLocalLiveIndexDB();    
      Promise.all(promise_zero)
         .then(()=>{    
          let promise_one = new Array();      
          this.initSyncCollections();   
          promise_one[promise_one.length] = this.callbackCollectionInsert();    
          promise_one[promise_one.length] = this.callbackCollectionUpdate();
          promise_one[promise_one.length] = this.callbackCollectionDelete();             
          //Ở đây lấy các chi nhánh về rồi, vậy sau này nên bỏ initsync branchs     
          //promise_one[promise_one.length] = this.getBranchs();
          Promise.all(promise_one)
                .then(()=>{                                             
                    let promise_two = new Array();                          
                    promise_two[promise_two.length] = this.vhAuth.refreshLocalMyPermission();  
                    promise_two[promise_two.length] = this.refreshLocalDeliverys(); 
                    promise_two[promise_two.length] = this.refreshLocalAddresss();          
                    promise_two[promise_two.length] = this.checkExpireBranch_Sales365();  
                    promise_two[promise_two.length] = this.refreshLocalPrintPages();        
                    promise_two[promise_two.length] = this.vhDisplayLEDService.refreshLocalDisplayLEDs_byEnable();                    
                    Promise.all(promise_two).then(()=>{
                      this.syncCashBookEveryDay_Stock1stDayOfMonth()
                            .then(()=>{
                              this.syncInventoryEveryDay_Stock1stDayOfMonth()
                                  .then(()=>{
                                      //console.log('finished syncCollections_Desktop');
                                      resolve(true);                  
                                  })                
                            })                  
                    })               
                })   
      })            
   })    
 }

  private async getLocalLiveIndexDB1(){
    getLiveAllCustomers().subscribe(data => {
      this.customers = data;
      this.publishObservableEventCustomers();
      // for(let i=0; i<data.length; i++){
      //   let exists = false;
      //   for(let j=0; j<this.customers.length; j++){
      //     if(data[i]._id === this.customers[j]._id){
      //       exists = true;
      //       this.customers[i] = data[j];
      //       break;
      //     }
      //   }
      //   if(!exists){
      //     this.customers.push(data[i]);
      //   }
      // }       
      console.log('this.customers', data)
    });
 }

 /**
  * vhQuerySales
  * Hàm này lấy về tất cả các collections mà firebase lưu trong cache ứng dụng, dữ liệu trong cache này dùng ko mất phí
  * @returns 
  */
 private async getLocalLiveIndexDB(){
  return new Promise((resolve, reject)=>{
    let promise_zero = new Array();
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('products')
            .then((products:any)=>{
              //this.products = products;
              if(products.length){
                let updatedAt = 1609434000000;
                products.forEach((product:any) => {
                  //console.log("-product", product); 
                  this.syncRaw_Detail_ProductInsert(product);
                  if(product.updatedAt != undefined){
                    if(product.updatedAt > updatedAt) updatedAt = product.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'products', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'products', syncAll: true});
              }     
              //console.log("products", products);      
              // console.log("this.products", this.products);         
              // console.log("this.rawproducts", this.rawproducts);   
              resolve(null);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('customers')
            .then((customers)=>{
              this.customers = customers;
              if(this.customers.length){
                let updatedAt = 1609434000000;
                this.customers.forEach((customer:any) => {
                  if(customer.updatedAt != undefined){
                    if(customer.updatedAt > updatedAt) updatedAt = customer.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'customers', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'customers', syncAll: true});
              }     
              //console.log("this.customers", customers);          
              resolve(customers);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('suppliers')
            .then((suppliers)=>{
              this.suppliers = suppliers;
              if(this.suppliers.length){
                let updatedAt = 1609434000000;
                this.suppliers.forEach((supplier:any) => {
                  if(supplier.updatedAt != undefined){
                    if(supplier.updatedAt > updatedAt) updatedAt = supplier.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'suppliers', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'suppliers', syncAll: true});
              }     
              //console.log("this.suppliers", suppliers);          
              resolve(suppliers);
            },(error:any)=>{
              reject(error);
            })            
    })
     promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('categorys')
            .then((categorys)=>{
              this.categorys = categorys;
              if(this.categorys.length){
                let updatedAt = 1609434000000;
                this.categorys.forEach((category:any) => {
                  if(category.updatedAt != undefined){
                    if(category.updatedAt > updatedAt) updatedAt = category.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'categorys', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'categorys', syncAll: true});
              }     
              //console.log("this.categorys", categorys);          
              resolve(categorys);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('wallets')
            .then((wallets)=>{
              this.wallets = wallets;
              if(this.wallets.length){
                let updatedAt = 1609434000000;
                this.wallets.forEach((wallet:any) => {
                  if(wallet.updatedAt != undefined){
                    if(wallet.updatedAt > updatedAt) updatedAt = wallet.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'wallets', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'wallets', syncAll: true});
              }     
              //console.log("this.wallets", wallets);          
              resolve(wallets);
            },(error:any)=>{
              reject(error);
            })            
    })
         promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('taxs')
            .then((taxs)=>{
              this.taxs = taxs;
              if(this.taxs.length){
                let updatedAt = 1609434000000;
                this.taxs.forEach((tax:any) => {
                  if(tax.updatedAt != undefined){
                    if(tax.updatedAt > updatedAt) updatedAt = tax.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'taxs', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'taxs', syncAll: true});
              }     
              //console.log("this.taxs", taxs);          
              resolve(taxs);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('vhemployees')
            .then((employees:any)=>{
              if(employees.length){
                let updatedAt = 1609434000000;
                employees.forEach((employee:any) => {
                  this.vhAuth.insertlocalEmployeeFromSyncCollection(employee);   
                  if(employee.updatedAt != undefined){
                    if(employee.updatedAt > updatedAt) updatedAt = employee.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'vhemployees', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'vhemployees', syncAll: true});
              }     
              //console.log("vhemployees", employees);          
              resolve(employees);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('printers')
            .then((printers)=>{
              this.printers = printers;
              if(this.printers.length){
                let updatedAt = 1609434000000;
                this.printers.forEach((printer:any) => {
                  if(printer.updatedAt != undefined){
                    if(printer.updatedAt > updatedAt) updatedAt = printer.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'printers', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'printers', syncAll: true});
              }     
              //console.log("this.printers", printers);          
              resolve(printers);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('appsettingstations')
            .then((appsettingstations)=>{
              this.appsettingstations = appsettingstations;
              if(this.appsettingstations.length){
                let updatedAt = 1609434000000;
                this.appsettingstations.forEach((appsettingstation:any) => {
                  if(appsettingstation.updatedAt != undefined){
                    if(appsettingstation.updatedAt > updatedAt) updatedAt = appsettingstation.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'appsettingstations', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'appsettingstations', syncAll: true});
              }     
              //console.log("this.appsettingstations", appsettingstations);          
              resolve(appsettingstations);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('appsettingbranchs')
            .then((appsettingbranchs)=>{
              this.appsettingbranchs = appsettingbranchs;
              if(this.appsettingbranchs.length){
                let updatedAt = 1609434000000;
                this.appsettingbranchs.forEach((appsettingbranch:any) => {
                  if(appsettingbranch.updatedAt != undefined){
                    if(appsettingbranch.updatedAt > updatedAt) updatedAt = appsettingbranch.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'appsettingbranchs', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'appsettingbranchs', syncAll: true});
              }     
              //console.log("this.appsettingbranchs", appsettingbranchs);          
              resolve(appsettingbranchs);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('discount_bills')
            .then((discount_bills)=>{
              this.discount_bills = discount_bills;
              if(this.discount_bills.length){
                let updatedAt = 1609434000000;
                this.discount_bills.forEach((discount_bill:any) => {
                  if(discount_bill.updatedAt != undefined){
                    if(discount_bill.updatedAt > updatedAt) updatedAt = discount_bill.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'discount_bills', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'discount_bills', syncAll: true});
              }     
              //console.log("this.discount_bills", discount_bills);          
              resolve(discount_bills);
            },(error:any)=>{
              reject(error);
            })            
    })
    promise_zero[promise_zero.length] = new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs_fromCache('customer_classs')
            .then((customer_classs)=>{
              this.customer_classs = customer_classs;
              if(this.customer_classs.length){
                let updatedAt = 1609434000000;
                this.customer_classs.forEach((customer_class:any) => {
                  if(customer_class.updatedAt != undefined){
                    if(customer_class.updatedAt > updatedAt) updatedAt = customer_class.updatedAt;
                  }                 
                }); 
                this.colname_array.push({colname: 'customer_classs', updatedAt: updatedAt, syncAll: false});
              }else{
                this.colname_array.push({colname: 'customer_classs', syncAll: true});
              }     
              //console.log("this.customer_classs", customer_classs);          
              resolve(customer_classs);
            },(error:any)=>{
              reject(error);
            })            
    })
    Promise.all(promise_zero)
          .then(arr=>{
            resolve(null);
          })
  })
 }

  
  private checkExpireBranch_Sales(){    
    return new Promise((resolve, reject)=>{    
      let branch = this.getDefaultBranch();      
      if(branch){
        let id_branch = this.getDefaultBranch()._id;
        this.vhMGDB_auth.checkExpireBranch_Sales(id_branch)
            .then(()=>{
              //console.log('success checkExpireBranch_Sales');
              resolve(true);
            }, error=>{
              //console.log('no success checkExpireBranch_Sales');
              reject(error);
            })
      } 
    })
  }

    private checkExpireBranch_Sales365(){    
    return new Promise((resolve, reject)=>{    
      let branch = this.getDefaultBranch();      
      if(branch){
        let id_branch = this.getDefaultBranch()._id;
        this.vhMGDB_auth.checkExpireBranch_Sales365(id_branch)
            .then(()=>{
              resolve(true);
            }, error=>{
              reject(error);
            })
      } 
    })
  }
  
  private initSyncCollections(){  
    // this.categorys = new Array();
    // this.printers = new Array();   
    // this.suppliers = new Array();
    //this.customers = new Array();
    // this.wallets = new Array();     
    // this.taxs = new Array();
    // this.appsettingbranchs = new Array();
    // this.appsettingstations = new Array();
    // this.discount_bills = new Array();  
    // this.customer_classs = new Array();  
  //  this.products = new Array();
    //this.vhAuth.clearLocalEmployeeFromSyncCollection();
    //let colname_array = new Array(); 
    //this.colname_array.push({colname: 'categorys', updatedAt: 1609434000000});
    //this.colname_array.push({colname: 'printers', updatedAt: 1609434000000});
    //this.colname_array.push({colname: 'suppliers', updatedAt: 1609434000000});
    // this.colname_array.push({colname: 'wallets', updatedAt: 1609434000000});
    // this.colname_array.push({colname: 'taxs', updatedAt: 1609434000000});
    // this.colname_array.push({colname: 'vhemployees', updatedAt: 1609434000000});
    // this.colname_array.push({colname: 'appsettingstations', updatedAt: 1609434000000});
    // this.colname_array.push({colname: 'appsettingbranchs', updatedAt: 1609434000000});
    // this.colname_array.push({colname: 'discount_bills', updatedAt: 1609434000000});
    // this.colname_array.push({colname: 'customer_classs', updatedAt: 1609434000000});
  //  this.colname_array.push({colname: 'products', updatedAt: 1609434000000});

    // colname_array[0] = 'categorys'; colname_array[1] = 'printers'; colname_array[2] = 'suppliers'; colname_array[3] = 'customers'; 
    // colname_array[4] = 'wallets'; colname_array[5] = 'taxs'; colname_array[6] = 'vhemployees'; 
    // colname_array[7] = 'appsettingstations'; colname_array[8] = 'appsettingbranchs'; 
    // colname_array[9] = 'discount_bills'; colname_array[10] = 'customer_classs';  colname_array[11] = 'products'; 
    this.vhMGDB_socketMongoDB.initSyncCollections(this.colname_array,this.getBranch_Management_Scope(),this.getDefaultBranch()._id);  
  }

      /**
   * @example:
   * this.vhQuerySales.closeSyncCollections();
   * disconnect collections synchronization in the APP
   * @returns void
   */
  public closeSyncCollections(){
     // this.callbackcollections.unsubscribe();
     this.vhMGDB_socketMongoDB.closeSyncCollections();
     this.productlistsendo = [];
     this.shoplistsendo = [];      
     this.productlistlazada = [];
     this.shoplistlazada = [];    
     this.productlisttikis = [];
     this.shoplisttiki = [];    
     this.products = [];
     this.detailproducts = [];
     this.rawproducts = [];
     this.customers = [];
     this.suppliers = [];
     this.wallets = [];
     this.taxs = [];
     this.categorys = [];
     this.inventorytimes = [];
     this.warrantys = [];
     this.discount_bills = [];
     this.discount_saless = [];
     this.customer_classs = [];
     this.commissions = [];
     this.deliverys = [];
     this.addresss = [];
     this.incoming_groups = [];
     this.spending_groups = [];
     this.branchs = [];
     this.promotions = [];     
  }

  /**
   * Khi lấy obj từ database về, hàm syncRaw_Detail_ProductInsert sẽ đồng bộ obj vào 3 loại local rawproducts, detailproducts và products
   * (3 loại dữ liệu local đc fw sử dụng để tính toán hoặc trả về cho frontend khi cần), dùng cho type =3
   * @example:
   * this.vhQuerySales.syncRaw_Detail_ProductInsert(obj);  
   * @param obj 
   */
  private syncRaw_Detail_ProductInsert(obj:any){
    //let obj = {...data.data}; obj._id = data._id;                      
    //Đồng bộ dữ liệu product mới từ database đến rawproducts ở local - RAW
    let exists = false;
    let change_delete_hidden = false;
    for(let i=0; i<this.rawproducts.length; i++){
      if(obj._id === this.rawproducts[i]._id){
        exists = true;
        //if(obj.delete_hidden !== this.rawproducts[i].delete_hidden) change_delete_hidden = true;
        this.syncRaw_Detail_ProductUpdate(obj)
        break;
      }
    }
    //if(change_delete_hidden) this.syncRaw_Detail_ProductUpdate(obj)
    if(!exists) {
      this.rawproducts.push(obj);                   
      //Đồng bộ dữ liệu product mới từ database đến detailproducts ở local - DETAIL    
      //Nếu obj là con thì đi tìm trong rawproducts có cha nào ko ráp vào        
      if(obj.id_subs_group){
        for(let i=0; i<this.rawproducts.length; i++){  
          if(obj.id_subs_group === this.rawproducts[i]._id){                         
            let product = {...obj, ...this.rawproducts[i]};//cha chép đè lên con (obj là con)    
            if(kindOf(obj.delete_hidden) != undefined) product.delete_hidden = obj.delete_hidden;        
            product.id_subproduct = obj._id;
            product.name = this.rawproducts[i].name + ' (' + obj.name +')';
            delete product.id_subs_group;
            delete product.manysize;
            this.detailproducts.push(product);            
          }
          
        }
      }else{//Nếu obj là cha thì đi tìm trong rawproducts có con nào ko ráp vào  
        if(obj.manysize){               
          for(let i=0; i<this.rawproducts.length; i++){
            if(obj._id === this.rawproducts[i]?.id_subs_group){
              let product = {...this.rawproducts[i], ...obj};//cha chép đè lên con (obj là cha)
              if(kindOf(this.rawproducts[i].delete_hidden)  != undefined) product.delete_hidden = this.rawproducts[i].delete_hidden;
              product.id_subproduct = this.rawproducts[i]._id;
              product.name = obj.name + ' (' + this.rawproducts[i].name +')';
              delete product.id_subs_group;
              delete product.manysize;
              this.detailproducts.push(product);
            }
          }
        }else{
          this.detailproducts.push(obj);                   
        }
      }
      //Đồng bộ dữ liệu product mới từ database đến products ở local - PRODUCTS            
      if(obj.id_subs_group){                    
        for(let i=0; i<this.products.length; i++){  
          if(this.products[i]._id === obj.id_subs_group){
            let sub:any = {
              _id: obj._id,
              name: obj.name,                     
              quantity: obj.quantity,
              quantity_branch: obj.quantity_branch,
              warning_number: obj.warning_number,
              item_code: obj.item_code,              
              allow_sell: obj.allow_sell,
              selling: obj.selling,
              units: obj.units,
              delete_hidden: obj.delete_hidden,
              //ratio_default: obj.ratio_default,
              manylot: obj.manylot
            }                      
            if(sub.manylot){     
              sub.days_import_warning = obj.days_import_warning; // Số ngày HSD còn lại được phép nhập hàng
              sub.days_exp_warning = obj.days_exp_warning; // Số ngày HSD còn lại được cảnh báo            
              sub.lots = obj.lots;              
            }
            this.products[i].subs.push(sub);                      
            for(const p in sub.quantity_branch){
              let exists = false;
              for(const q in this.products[i].quantity_branch){
                if(p===q) exists = true;
              }
              if(exists){
                this.products[i].quantity_branch[p] = this.products[i].quantity_branch[p] + sub.quantity_branch[p];
              }else{
                this.products[i].quantity_branch[p] = sub.quantity_branch[p];
              }
              this.products[i].quantity = this.products[i].quantity + sub.quantity_branch[p];
            }
          }
        }          
      }else{
        if(obj.manysize){              
          let subs = new Array();
          let quantity = 0;
          let quantity_branch:any = {};
          for(let i=0; i<this.rawproducts.length; i++){
            if(obj._id === this.rawproducts[i]?.id_subs_group){                 
              let sub:any = {
                _id: this.rawproducts[i]._id,
                name: this.rawproducts[i].name,                
                quantity: this.rawproducts[i].quantity,
                quantity_branch: this.rawproducts[i].quantity_branch,
                warning_number: this.rawproducts[i].warning_number,
                item_code: this.rawproducts[i].item_code,                
                allow_sell: this.rawproducts[i].allow_sell,
                selling: this.rawproducts[i].selling,
                units: this.rawproducts[i].units,
                delete_hidden: this.rawproducts[i].delete_hidden,
                //ratio_default: this.rawproducts[i].ratio_default,                   
                manylot: this.rawproducts[i].manylot
              }
              if(sub.manylot){     
                sub.days_import_warning = this.rawproducts[i].days_import_warning; // Số ngày HSD còn lại được phép nhập hàng
                sub.days_exp_warning = this.rawproducts[i].days_exp_warning; // Số ngày HSD còn lại được cảnh báo            
                sub.lots = this.rawproducts[i].lots;              
              }
              for(const p in sub.quantity_branch){
                let exists = false;
                for(const q in quantity_branch){
                  if(p===q) exists = true;
                }
                if(exists){
                  quantity_branch[p] = quantity_branch[p] + sub.quantity_branch[p];
                }else{
                  quantity_branch[p] = sub.quantity_branch[p];
                }
                quantity = quantity + sub.quantity_branch[p];
              }
              subs.push(sub);
            }
          }
          let _product = {...obj};
          _product.subs = subs;
          _product.quantity = quantity;
          _product.quantity_branch = {...quantity_branch};
          //_product.type = 3;
          this.products.push(_product);   
        }else{
          this.products.push(obj);                   
        }
      }                              
    }
  }

  /**
   * vhQuerySales
   * @param obj 
   */
  private syncRaw_Detail_ProductUpdate(obj:any){    
    //Đồng bộ dữ liệu product sửa từ database đến rawproducts ở local - RAW
    let exists = false;
    for(let i=0; i<this.rawproducts.length; i++){
      if(obj._id === this.rawproducts[i]._id){
        this.rawproducts[i] = {...obj};
        exists = true;
        break;
      }
    }
    if(exists){                   
        //Cập nhật dữ liệu product sửa từ database đến detailproducts ở local - DETAIL           
        //Nếu obj là con thì đi tìm trong rawproducts có cha nào ko ráp vào        
        if(obj.id_subs_group){
          for(let i=0; i<this.rawproducts.length; i++){  
            if(obj.id_subs_group === this.rawproducts[i]._id){
              let _detailproduct = {...obj, ...this.rawproducts[i]};//cha chép đè lên con (obj là con)
              if(kindOf(obj.delete_hidden) != undefined) _detailproduct.delete_hidden = obj.delete_hidden;
              _detailproduct.id_subproduct = obj._id;
              _detailproduct.name = this.rawproducts[i].name + ' (' + obj.name +')';
              delete _detailproduct.id_subs_group;
              delete _detailproduct.manysize;                    
              for(let j=0; j<this.detailproducts.length; j++){
                if(_detailproduct.id_subproduct === this.detailproducts[j].id_subproduct){
                  this.detailproducts[j] = {..._detailproduct};
                  break;
                }
              }
            }
          }
        }else{
          if(obj.manysize){//Nếu obj là cha thì đi tìm trong rawproducts có con nào ko ráp vào                                      
            for(let i=0; i<this.rawproducts.length; i++){
              if(obj._id === this.rawproducts[i]?.id_subs_group){
                //tạo lại các _detailproduct
                let _detailproduct = {...this.rawproducts[i], ...obj}; //cha chép đè lên con (obj là cha)
                if(kindOf(this.rawproducts[i].delete_hidden) != undefined) _detailproduct.delete_hidden = this.rawproducts[i].delete_hidden;
                _detailproduct.id_subproduct = this.rawproducts[i]._id;
                _detailproduct.name = obj.name + ' (' + this.rawproducts[i].name +')';
                delete _detailproduct.id_subs_group;
                delete _detailproduct.manysize;                      
                //chép đè _detailproduct lên các detailproduct của nó trong detailproducts
                for(let j=0; j<this.detailproducts.length; j++){
                  if(_detailproduct.id_subproduct === this.detailproducts[j].id_subproduct){                          
                    this.detailproducts[j] = {..._detailproduct};
                    break;
                  }
                }
              }
            }
          }else{
            for(let i=0; i<this.detailproducts.length; i++){
              if(obj._id === this.detailproducts[i]._id){
                this.detailproducts[i] = {...this.detailproducts[i], ...obj};     
                break;
              }
            }    
          }                   
        }                            
        //Cập nhật dữ liệu product sửa từ database đến products ở local - PRODUCTS            
        if(obj.id_subs_group){                 
          for(let i=0; i<this.products.length; i++){  
            if(this.products[i]._id === obj.id_subs_group){                   
              for(let j=0; j<this.products[i].subs.length; j++){ 
                if(this.products[i].subs[j]._id === obj._id){
                  let sub_old = {...this.products[i].subs[j]};
                  for(const p in this.products[i].quantity_branch){
                    let exists = false;
                    for(const q in sub_old.quantity_branch){
                      if(p===q) exists = true;
                    }
                    if(exists){
                      this.products[i].quantity_branch[p] = this.products[i].quantity_branch[p] - sub_old.quantity_branch[p];
                    }else{
                      this.products[i].quantity_branch[p] = - sub_old.quantity_branch[p];
                    }
                    this.products[i].quantity = this.products[i].quantity - sub_old.quantity_branch[p];
                  }

                  let sub_new:any = {
                    _id: obj._id,
                    name: obj.name,
                    //barcode: obj.barcode,                
                    //price: obj.price,
                    //price2: obj.price2,
                    //price_import: obj.price_import,
                    quantity: obj.quantity,
                    quantity_branch: obj.quantity_branch,
                    warning_number: obj.warning_number,
                    item_code: obj.item_code,                    
                    allow_sell: obj.allow_sell,
                    selling: obj.selling,
                    units: obj.units,
                    delete_hidden: obj.delete_hidden,
                    manylot: obj.manylot
                  }
                  if(sub_new.manylot){     
                    sub_new.days_import_warning = obj.days_import_warning; // Số ngày HSD còn lại được phép nhập hàng
                    sub_new.days_exp_warning = obj.days_exp_warning; // Số ngày HSD còn lại được cảnh báo            
                    sub_new.lots = obj.lots;              
                  }
                  this.products[i].subs[j] = {...sub_new};
                  for(const p in this.products[i].quantity_branch){
                    let exists = false;
                    for(const q in sub_new.quantity_branch){
                      if(p===q) exists = true;
                    }
                    if(exists){
                      this.products[i].quantity_branch[p] = this.products[i].quantity_branch[p] + sub_new.quantity_branch[p];
                    }else{
                      this.products[i].quantity_branch[p] = sub_new.quantity_branch[p];
                    }
                    this.products[i].quantity = this.products[i].quantity + sub_new.quantity_branch[p];
                  }
                }
              } 
              
              
            }
          }
        }else{
          for(let i=0; i<this.products.length; i++){
            if(this.products[i]._id === obj._id){                  
              this.products[i] = {...this.products[i], ...obj}
            }
          }   
        }                                        
    }        
  }
  
/**
 * vhQuerySales
 * @returns 
 */
  private callbackCollectionInsert(){        
    return new Promise((resolve, reject) => {      
      let colname_counts = 0;
      this.vhMGDB_socketMongoDB.callbackCollectionInsert().subscribe((array_Addeds:any)=>{                      
            for(let i=0; i<array_Addeds.length; i++){
              let data = array_Addeds[i];
              let obj = {...data.data}; obj._id = data._id;
              if(data.colname === 'categorys'){         
                if(!this.getlocalCategory(data._id)){                  
                  this.categorys.push(obj);      
                }else{
                  for(let n=0; n<this.categorys.length; n++){
                    if(this.categorys[n]._id === data._id){
                      this.categorys[n] = obj;
                      break;
                    }
                  } 
                }                            
              }else if(data.colname === 'products'){                     
                this.syncRaw_Detail_ProductInsert(obj);                 
              }else if(data.colname === 'suppliers'){   
                delete data.name_keywords;
                delete data.phone_keywords;       
                if(!this.getlocalSupplier(data._id)){                  
                  this.suppliers.push(obj);       
                }else{
                  for(let n=0; n<this.suppliers.length; n++){
                    if(this.suppliers[n]._id === data._id){
                      this.suppliers[n] = obj;
                      break;
                    }
                  } 
                }                                            
              }else if(data.colname === 'customers'){ 
                delete data.name_keywords;
                delete data.phone_keywords;        
                if(!this.getlocalCustomer(data._id)){                 
                  this.customers.push(obj);                         
                }else{
                  for(let n=0; n<this.customers.length; n++){
                    if(this.customers[n]._id === data._id){
                      this.customers[n] = obj;
                      break;
                    }
                  } 
                }  
                // insertCustomer(data._id, data.data);
                // console.log('insertCustomer', data.data)                                     
              }else if(data.colname === 'wallets'){         
                if(!this.getlocalWallet(data._id)){
                  this.wallets.push(obj);     
                }else{
                  for(let n=0; n<this.wallets.length; n++){
                    if(this.wallets[n]._id === data._id){
                      this.wallets[n] = obj;
                      break;
                    }
                  } 
                }    
              }else if(data.colname === 'branchs'){          
                // if(!this.getlocalBranch(data._id)){
          
                //   this.branchs.push(obj);   
                //   this.publishObservableEventBranchs();       
                //   observer.next(data.colname);    
                // }                                 
              }else if(data.colname === 'taxs'){          
                if(!this.getlocalTax(data._id)){
                  this.taxs.push(obj);             
                }else{
                  for(let n=0; n<this.taxs.length; n++){
                    if(this.taxs[n]._id === data._id){
                      this.taxs[n] = obj;
                      break;
                    }
                  } 
                }                                  
              }else if(data.colname === 'vhemployees'){  
                this.vhAuth.insertlocalEmployeeFromSyncCollection(obj);         
                //this.vhAuth.publishObservableEventEmployees();
                //observer.next(data.colname);                 
              }else if(data.colname === 'promotions'){          
                // if(!this.getlocalPromotion(data._id)){          
                //   this.promotions.push(obj);   
                //   this.publishObservableEventPromotions();      
                //   observer.next(data.colname);    
                // }                                                          
              }else if(data.colname === 'inventorytimes'){          
                if(!this.getlocalInventorytime(data._id)){  
                  this.inventorytimes.push(obj);   
                  //this.publishObservableEventInventorytimes();
                  //observer.next(data.colname); 
                } 
              }else if(data.colname === 'appsettingbranchs'){//Nhớ xử lý chỗ chọn chi nhánh, bị lỗi lỗi cả 2 chi nhánh cũ và mới                  
                if(!this.getLocalAppSettingBranch(data._id)){            
                  if(data.data.id_branch === this.getDefaultBranch()._id){
                    this.appsettingbranchs.push(obj);                         
                  }              
                }else{
                  if(data.data.id_branch === this.getDefaultBranch()._id){
                    for(let n=0; n<this.appsettingbranchs.length; n++){
                      if(this.appsettingbranchs[n]._id === data._id){
                        this.appsettingbranchs[n] = obj;
                        break;
                      }
                    } 
                  }                 
                }                          
              }else if(data.colname === 'appsettingstations'){                   
                if(!this.getLocalAppSettingStation(data._id)){            
                  if(data.data.uuid === this.hwinfo.uuid){
                    delete obj.uuid;
                    this.appsettingstations.push(obj);                 
                  }              
                }else{
                  if(data.data.uuid === this.hwinfo.uuid){
                    for(let n=0; n<this.appsettingstations.length; n++){
                      if(this.appsettingstations[n]._id === data._id){
                        delete obj.uuid;
                        this.appsettingstations[n] = obj;
                        break;
                      }
                    }
                  }                   
                }                                 
              }else if(data.colname === 'printers'){        
                if(!this.getlocalPrinter(data._id)){
                  if(data.data.uuid === this.hwinfo.uuid){    
                    delete obj.uuid;
                    this.printers.push(obj); 
                  }              
                }else{
                  if(data.data.uuid === this.hwinfo.uuid){    
                    for(let n=0; n<this.printers.length; n++){
                      if(this.printers[n]._id === data._id){
                        delete obj.uuid;
                        this.printers[n] = obj;
                        break;
                      }
                    }
                  }                   
                }   
              }else if(data.colname === 'warrantys'){         
                  // if(!this.getlocalWarranty(data._id)){
            
                  //   this.warrantys.push(obj);   
                  //   this.publishObservableEventWarrantys(); 
                  //   observer.next(data.colname);       
                  // }     
              }else if(data.colname === 'discount_bills'){         
                  if(!this.getlocalDiscount_bill(data._id)){    
                    this.discount_bills.push(obj);        
                  }else{
                    for(let n=0; n<this.discount_bills.length; n++){
                      if(this.discount_bills[n]._id === data._id){
                        this.discount_bills[n] = obj;
                        break;
                      }
                    } 
                  }     
              }else if(data.colname === 'customer_classs'){         
                  if(!this.getlocalCustomerClass(data._id)){    
                    this.customer_classs.push(obj);        
                  }else{
                    for(let n=0; n<this.customer_classs.length; n++){
                      if(this.customer_classs[n]._id === data._id){
                        this.customer_classs[n] = obj;
                        break;
                      }
                    } 
                  }     
              }

            }
            if(array_Addeds.length){
              if(array_Addeds[0].colname === 'categorys') this.publishObservableEventCategorys();
              if(array_Addeds[0].colname === 'printers') this.publishObservableEventPrinters();
              if(array_Addeds[0].colname === 'suppliers') this.publishObservableEventSuppliers();
              if(array_Addeds[0].colname === 'customers') this.publishObservableEventCustomers();
              if(array_Addeds[0].colname === 'wallets') this.publishObservableEventWallets();
              if(array_Addeds[0].colname === 'taxs') this.publishObservableEventTaxs();
              if(array_Addeds[0].colname === 'vhemployees') this.vhAuth.publishObservableEventEmployees();
              if(array_Addeds[0].colname === 'appsettingbranchs') this.publishObservableEventAppSettingNameBranchs();
              if(array_Addeds[0].colname === 'appsettingstations') this.publishObservableEventAppSettingNameStations();              
              if(array_Addeds[0].colname === 'discount_bills') this.publishObservableEventDiscount_bills();
              if(array_Addeds[0].colname === 'customer_classs') this.publishObservableEventCustomerClasss();     
              if(array_Addeds[0].colname === 'products') this.publishObservableEventProducts();                   
            }         
            //console.log('this.colname_array.length', this.colname_array.length);     
            if(++colname_counts === this.colname_array.length)  resolve(null);
            //console.log('colname_counts', colname_counts);
           
      })
     
    })
  }

  /**
   * vhQuerySales
   * @returns 
   */
  private callbackCollectionUpdate(){    
    //return new Observable((observer:any) => {    
    return new Promise((resolve, reject) => {            
      this.vhMGDB_socketMongoDB.callbackCollectionUpdate().subscribe((array_Modifieds:any)=>{ 
        for(let i=0; i<array_Modifieds.length; i++){
          let data = array_Modifieds[i];
          // if(data.colname === 'vhemployees') data.colname = 'employees';
          // else if(data.colname === 'branchs') data.colname = 'branchs';
          // else if(data.colname === 'printers') data.colname = 'printers';
          // else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
          if(data.colname === 'categorys'){
            for(let i=0; i<this.categorys.length; i++){
              if(this.categorys[i]._id === data._id){
                this.categorys[i] = {...this.categorys[i], ...data.data};     
                //this.publishObservableEventCategorys();  
                //observer.next(data.colname);         
                break;
              }
            }            
          }else if(data.colname === 'products'){
             let obj = {...data.data}; obj._id = data._id;        
             this.syncRaw_Detail_ProductUpdate(obj);
          }else if(data.colname === 'suppliers'){
            delete data.name_keywords;
            delete data.phone_keywords;
            for(let i=0; i<this.suppliers.length; i++){
              if(this.suppliers[i]._id === data._id){
                this.suppliers[i] = {...this.suppliers[i], ...data.data};     
                //this.publishObservableEventSuppliers();   
                //observer.next(data.colname);         
                break;
              }
            }          
          }else if(data.colname === 'customers'){
            delete data.name_keywords;
            delete data.phone_keywords;
            for(let i=0; i<this.customers.length; i++){
              if(this.customers[i]._id === data._id){
                console.log('updateCustomeri', this.customers[i])      
                this.customers[i] = {...this.customers[i], ...data.data};    
                //this.publishObservableEventCustomers();   
                //observer.next(data.colname);           
                break;
              }
            }   
            // updateCustomer(data._id, data.data);
            console.log('updateCustomer', data.data)      
          }else if(data.colname === 'wallets'){
            for(let i=0; i<this.wallets.length; i++){
              if(this.wallets[i]._id === data._id){
                this.wallets[i] = {...this.wallets[i], ...data.data};          
                //this.publishObservableEventWallets();
                //observer.next(data.colname);        
                break;
              }
            }              
          }else if(data.colname === 'branchs'){
            for(let i=0; i<this.branchs.length; i++){
              if(this.branchs[i]._id === data._id){
                this.branchs[i] = {...this.branchs[i], ...data.data};  
                //this.publishObservableEventBranchs();       
                //observer.next(data.colname);                
                break;
              }
            }          
          }else if(data.colname === 'taxs'){
            for(let i=0; i<this.taxs.length; i++){
              if(this.taxs[i]._id === data._id){
                this.taxs[i] = {...this.taxs[i], ...data.data};  
                //this.publishObservableEventTaxs();   
                //observer.next(data.colname);             
                break;
              }
            }          
          }else if(data.colname === 'vhemployees'){         
            this.vhAuth.updateLocalEmployeeFromSyncCollection(data._id, data.data);               
          }else if(data.colname === 'promotions'){
            // for(let i=0; i<this.promotions.length; i++){
            //   if(this.promotions[i]._id === data._id){
            //     this.promotions[i] = {...this.promotions[i], ...data.data};  
            //     this.publishObservableEventPromotions();      
            //     observer.next(data.colname);                
            //     break;
            //   }
            // }         
          }else if(data.colname === 'inventorytimes'){
            for(let i=0; i<this.inventorytimes.length; i++){
              if(this.inventorytimes[i]._id === data._id){
                this.inventorytimes[i] = {...this.inventorytimes[i], ...data.data};    
                //this.publishObservableEventInventorytimes();
                //observer.next(data.colname);           
                break;
              }
            }     
          }else if(data.colname === 'appsettingbranchs'){
            for(let i=0; i<this.appsettingbranchs.length; i++){
              if(this.appsettingbranchs[i]._id === data._id){
                this.appsettingbranchs[i] = {...this.appsettingbranchs[i], ...data.data};                 
                //this.publishObservableEventAppSettingNameBranchs(); 
                //observer.next(data.colname);               
                break;
              }
            }     
          }else if(data.colname === 'appsettingstations'){
            for(let i=0; i<this.appsettingstations.length; i++){
              if(this.appsettingstations[i]._id === data._id){
                this.appsettingstations[i] = {...this.appsettingstations[i], ...data.data};               
                //this.publishObservableEventAppSettingNameStations(); 
                //observer.next(data.colname);               
                break;
              }
            }         
          }else if(data.colname === 'printers'){
            for(let i=0; i<this.printers.length; i++){
              if(this.printers[i]._id === data._id){
                this.printers[i] = {...this.printers[i], ...data.data};           
                //this.publishObservableEventPrinters();   
                //observer.next(data.colname);   
                break;
              }
            }         
          }else if(data.colname === 'warrantys'){
            for(let i=0; i<this.warrantys.length; i++){
              if(this.warrantys[i]._id === data._id){
                this.warrantys[i] = {...this.warrantys[i], ...data.data};       
                //this.publishObservableEventWarrantys(); 
                //observer.next(data.colname);         
                break;
              }
            }          
          }else if(data.colname === 'discount_bills'){
            for(let i=0; i<this.discount_bills.length; i++){
              if(this.discount_bills[i]._id === data._id){
                this.discount_bills[i] = {...this.discount_bills[i], ...data.data};       
                //this.publishObservableEventDiscount_bills(); 
                //observer.next(data.colname);         
                break;
              }
            }          
          }else if(data.colname === 'customer_classs'){
            for(let i=0; i<this.customer_classs.length; i++){
              if(this.customer_classs[i]._id === data._id){
                this.customer_classs[i] = {...this.customer_classs[i], ...data.data};       
                //this.publishObservableEventCustomerClasss(); 
                //observer.next(data.colname);         
                break;
              }
            }          
          }       
          //console.log('updated', data.colname, data);
          //console.log('-------this.rawproducts_in', this.rawproducts);        
          //console.log('-------this.products_in', this.products);
          //console.log('-------this.detailproducts_in', this.detailproducts); 
        }
        if(array_Modifieds.length){
          if(array_Modifieds[0].colname === 'categorys') this.publishObservableEventCategorys();
          if(array_Modifieds[0].colname === 'printers') this.publishObservableEventPrinters();
          if(array_Modifieds[0].colname === 'suppliers') this.publishObservableEventSuppliers();
          if(array_Modifieds[0].colname === 'customers') this.publishObservableEventCustomers();
          if(array_Modifieds[0].colname === 'wallets') this.publishObservableEventWallets();
          if(array_Modifieds[0].colname === 'taxs') this.publishObservableEventTaxs();
          if(array_Modifieds[0].colname === 'vhemployees') this.vhAuth.publishObservableEventEmployees();
          if(array_Modifieds[0].colname === 'appsettingbranchs') this.publishObservableEventAppSettingNameBranchs();
          if(array_Modifieds[0].colname === 'appsettingstations') this.publishObservableEventAppSettingNameStations();              
          if(array_Modifieds[0].colname === 'discount_bills') this.publishObservableEventDiscount_bills();
          if(array_Modifieds[0].colname === 'customer_classs') this.publishObservableEventCustomerClasss();     
          if(array_Modifieds[0].colname === 'products') this.publishObservableEventProducts();        
        }                 
      })
      resolve(null);
    })
  }

  /**
   * vhQuerySales
   * @returns 
   */
  private callbackCollectionDelete(){
    //return new Observable((observer:any) => {  
    return new Promise((resolve, reject) => {       
      this.vhMGDB_socketMongoDB.callbackCollectionDelete().subscribe((array_Removeds:any)=>{  
        for(let i=0; i<array_Removeds.length; i++){
          let data = array_Removeds[i];    
          //if(data.colname === 'vhemployees') data.colname = 'employees';
          if(data.colname === 'categorys'){
            for(let i=0; i<this.categorys.length; i++){
              if(this.categorys[i]._id === data._id){
                this.categorys.splice(i, 1);       
                //this.publishObservableEventCategorys();  
                //observer.next(data.colname);                        
                break;
              }
            }         
          }else if(data.colname === 'products'){
           //xóa khỏi PRODUCTS
            for(let i=0; i<this.products.length; i++){// hình như chỗ này phải bổ đi thì phải, nhớ kiểm tra
              if(this.products[i]._id === data._id){
                this.products.splice(i, 1);                             
                break;
              }
            }       
            //xóa khỏi rawproducts 
            for(let k=0; k<this.rawproducts.length; k++){
              if(this.rawproducts[k]._id === data._id){           
                this.rawproducts.splice(k, 1);                 
                break;
              }
            } 
           //xóa khỏi PRODUCTS.SUBS
           outerLoop: // Đặt tên cho vòng lặp ngoài
           for(let i=0; i<this.products.length; i++){  
             if(this.products[i].subs){                 
               for(let j=0; j<this.products[i].subs.length; j++){ 
                 if(this.products[i].subs[j]._id === data._id){
                   let sub_old = {...this.products[i].subs[j]};                       
                   for(const p in this.products[i].quantity_branch){
                     let exists = false;
                     for(const q in sub_old.quantity_branch){
                       if(p===q) exists = true;
                     }
                     if(exists){
                       this.products[i].quantity_branch[p] = this.products[i].quantity_branch[p] - sub_old.quantity_branch[p];
                     }else{
                       this.products[i].quantity_branch[p] = - sub_old.quantity_branch[p];
                     }
                     this.products[i].quantity = this.products[i].quantity - sub_old.quantity_branch[p];
                   }
                   this.products[i].subs.splice(j, 1);        
                   break outerLoop;             
                 }
               }  
             }     
           }

            //Xóa khỏi DETAILPRODUCT
            for(let i=0; i<this.detailproducts.length; i++){ 
              if(this.detailproducts[i]?.id_subproduct === data._id) {
                this.detailproducts.splice(i, 1); 
                break;
              }
              if(this.detailproducts[i]._id === data._id) {
                this.detailproducts.splice(i, 1); 
                break;
              }
            }                
          }else if(data.colname === 'suppliers'){
            for(let i=0; i<this.suppliers.length; i++){
              if(this.suppliers[i]._id === data._id){
                this.suppliers.splice(i, 1);    
                //this.publishObservableEventSuppliers();   
                //observer.next(data.colname);            
                break;
              }
            }          
          }else if(data.colname === 'customers'){
            for(let i=0; i<this.customers.length; i++){
              if(this.customers[i]._id === data._id){
                this.customers.splice(i, 1);
                //this.publishObservableEventCustomers();   
                //observer.next(data.colname);                          
                break;
              }
            } 
            //deleteCustomer(data._id);
            //console.log('deleteCustomer', data._id)               
          }else if(data.colname === 'wallets'){
            for(let i=0; i<this.wallets.length; i++){
              if(this.wallets[i]._id === data._id){
                this.wallets.splice(i, 1);   
                //this.publishObservableEventWallets();
                //observer.next(data.colname);                      
                break;
              }
            }             
          }else if(data.colname === 'branchs'){
            for(let i=0; i<this.branchs.length; i++){
              if(this.branchs[i]._id === data._id){
                this.branchs.splice(i, 1);     
                //this.publishObservableEventBranchs();       
                //observer.next(data.colname);                  
                break;
              }
            }          
          }else if(data.colname === 'taxs'){
            for(let i=0; i<this.taxs.length; i++){
              if(this.taxs[i]._id === data._id){
                this.taxs.splice(i, 1);   
                //this.publishObservableEventTaxs();   
                //observer.next(data.colname);              
                break;
              }
            }         
          }else if(data.colname === 'vhemployees'){
            this.vhAuth.deleteLocalEmployeeFromSyncCollection(data._id);    
            //this.vhAuth.publishObservableEventEmployees();
            //observer.next(data.colname);                
          }else if(data.colname === 'promotions'){
            // for(let i=0; i<this.promotions.length; i++){
            //   if(this.promotions[i]._id === data._id){
            //     this.promotions.splice(i, 1);           
            //     this.publishObservableEventPromotions();   
            //     observer.next(data.colname);         
            //     break;
            //   }
            // }             
          }else if(data.colname === 'inventorytimes'){
            for(let i=0; i<this.inventorytimes.length; i++){
              if(this.inventorytimes[i]._id === data._id){
                this.inventorytimes.splice(i, 1);     
                //this.publishObservableEventInventorytimes();
               // observer.next(data.colname);             
                break;
              }
            }  
          }else if(data.colname === 'appsettingbranchs'){
            for(let i=0; i<this.appsettingbranchs.length; i++){
              if(this.appsettingbranchs[i]._id === data._id){
                this.appsettingbranchs.splice(i, 1);               
                //this.publishObservableEventAppSettingNameBranchs(); 
                //observer.next(data.colname);                
                break;
              }
            }          
          }else if(data.colname === 'appsettingstations'){
            for(let i=0; i<this.appsettingstations.length; i++){
              if(this.appsettingstations[i]._id === data._id){
                this.appsettingstations.splice(i, 1);               
                //this.publishObservableEventAppSettingNameStations(); 
               // observer.next(data.colname);                
                break;
              }
            }                   
          }else if(data.colname === 'printers'){
            for(let i=0; i<this.printers.length; i++){
              if(this.printers[i]._id === data._id){
                this.printers.splice(i, 1);             
                //this.publishObservableEventPrinters();   
                //observer.next(data.colname);   
                break;
              }
            }           
          }else if(data.colname === 'warrantys'){
            for(let i=0; i<this.warrantys.length; i++){
              if(this.warrantys[i]._id === data._id){
                this.warrantys.splice(i, 1);       
                //this.publishObservableEventWarrantys(); 
                //observer.next(data.colname);            
                break;
              }
            }                   
          }else if(data.colname === 'discount_bills'){
            for(let i=0; i<this.discount_bills.length; i++){
              if(this.discount_bills[i]._id === data._id){
                this.discount_bills.splice(i, 1);       
                //this.publishObservableEventDiscount_bills(); 
                //observer.next(data.colname);            
                break;
              }
            }                   
          }else if(data.colname === 'customer_classs'){
            for(let i=0; i<this.customer_classs.length; i++){
              if(this.customer_classs[i]._id === data._id){
                this.customer_classs.splice(i, 1);       
                //this.publishObservableEventCustomerClasss(); 
                //observer.next(data.colname);            
                break;
              }
            }                   
          }                
          console.log('deleted', data.colname);  
        }
        if(array_Removeds.length){
          if(array_Removeds[0].colname === 'categorys') this.publishObservableEventCategorys();
          if(array_Removeds[0].colname === 'printers') this.publishObservableEventPrinters();
          if(array_Removeds[0].colname === 'suppliers') this.publishObservableEventSuppliers();
          if(array_Removeds[0].colname === 'customers') this.publishObservableEventCustomers();
          if(array_Removeds[0].colname === 'wallets') this.publishObservableEventWallets();
          if(array_Removeds[0].colname === 'taxs') this.publishObservableEventTaxs();
          if(array_Removeds[0].colname === 'vhemployees') this.vhAuth.publishObservableEventEmployees();
          if(array_Removeds[0].colname === 'appsettingbranchs') this.publishObservableEventAppSettingNameBranchs();
          if(array_Removeds[0].colname === 'appsettingstations') this.publishObservableEventAppSettingNameStations();              
          if(array_Removeds[0].colname === 'discount_bills') this.publishObservableEventDiscount_bills();
          if(array_Removeds[0].colname === 'customer_classs') this.publishObservableEventCustomerClasss();     
          if(array_Removeds[0].colname === 'products') this.publishObservableEventProducts();        
        }              
      })
      resolve(null);
    })
  }

  /**
   * vhQuerySales
   */
  public initChatToAppCare(){          
    return this.vhMGDB_socketMongoDB.initChat('vhmessages',{});  
  }

  /**
   * vhQuerySales
   * @returns 
   */
  public listeningChatToAppCare_Insert(){
    return new Observable((observer:any) => {    
      this.vhMGDB_socketMongoDB.callbackChatInsert().subscribe((data:any)=>{      
        observer.next(data);
      })
    })
  }

  /**
   * vhQuerySales
   * @returns 
   */
  public listeningChatToAppCare_Update(){
    return new Observable((observer:any) => {    
      this.vhMGDB_socketMongoDB.callbackChatUpdate().subscribe((data:any)=>{          
        observer.next(data);
      })
    })
  }

  /**
   * vhQuerySales
   * @param limit 
   * @returns 
   */
  public getOldMessages(limit:number){
    return this.vhMGDB_database.getDocsByFields('vhmessages',{},{},{date:1},limit);
  }

  /**
   * @example:
   this.vhQuerySales.sendMessageToAppCare('hello' ).then((res:any) => {      
   });
   * @param message 
   */
  public sendMessageToAppCare(message:any) {	  
    //console.log(this.getLocalAppSetting_Branch('store_info'));
    return new Promise((resolve, reject) => {      
      let data:any = {
        msg: message,
        date: new Date(),
        //sid: this.firebaseAuth.getSID(),
        avatar: this.getLocalAppSettingNameStation('store_info').img,
        email: this.getLocalAppSettingNameStation('store_info').email,
        company: this.getLocalAppSettingNameStation('store_info').company,
        align: 'left'
      };// nên dùng store_info
      //if(typeof(this.firebaseAuth.getUser().img) != 'undefined') data.avatar = this.firebaseAuth.getUser().img;
      this.vhMGDB_database.addDoc('vhmessages', data)
          .then((message)=>{
            //console.log('addDoc', message);
            resolve(message);
          },(error:any)=>{
            //console.log('error', error);
            reject(error)
          })
      
      this.vhMGDB_socketMongoDB.saytoAppCareFirebase();      

                 
    })
  }

  /**
   * @example:
   this.vhQuerySales.sendMessageToAppCare('hello' ).then((res:any) => {      
   });
   * @param message 
   */
  public sendImageToAppCare(image:string) {	  
    //console.log(this.getLocalAppSetting_Branch('store_info'));
    return new Promise((resolve, reject) => {      
      let data:any = {
        img: image,
        date: new Date(),
        //sid: this.firebaseAuth.getSID(),
        avatar: this.getLocalAppSettingNameStation('store_info').img,
        email: this.getLocalAppSettingNameStation('store_info').email,
        company: this.getLocalAppSettingNameStation('store_info').company,
        align: 'left'
      };// nên dùng store_info
      //if(typeof(this.firebaseAuth.getUser().img) != 'undefined') data.avatar = this.firebaseAuth.getUser().img;
      this.vhMGDB_database.addDoc('vhmessages', data)
          .then((message)=>{
            //console.log('addDoc', message);
            resolve(message);
          },(error:any)=>{
            //console.log('error', error);
            reject(error)
          })
                 
    })
  }

  /**
   * Hàm này chạy sau hàm đăng nhập hoặc xác thực đăng nhập vào phần mềm
   */
  public startLocalStorage(){     
    return new Promise<any>((resolve) => {     
      let promise = new Array();  
      //promise[0] = this.vhAuth.refreshLocalEmployees();
      //  promise[0] = this.vhAuth.refreshLocalMyPermission();  
      //promise[2] = this.refreshLocalCategorys();
      //promise[3] = this.refreshLocalProducts();   
      //promise[4] = this.refreshLocalCustomers();
      //promise[5] = this.refreshLocalSuppliers();
      //promise[6] = this.refreshLocalWallets();
      //  promise[1] = this.refreshLocalDeliverys(); 
      //  promise[2] = this.refreshLocalAddresss();                                             
      //promise[9] = this.refreshLocalBranchs();
      //promise[10] = this.refreshLocalInventorytimes();
      //promise[11] = this.refreshLocalWarrantys();
      //promise[12] = this.refreshLocalPrinters();
      //promise[13] = this.refreshLocalPromotions();
      //promise[14] = this.refreshLocalAppSettings_Branch();
      //promise[15] = this.refreshLocalTaxs();                     
      this.vhQuery.asyncPromiseAll(promise).then(()=>{resolve(null)});         
    })
  }
  
  public initPurchase(){
    this.platform.ready().then(()=>{
      this.iap2.verbosity = this.iap2.DEBUG;
      this.initPaymentOnAPPStore('in_vhsales_3days', 3); 
      this.initPaymentOnAPPStore('in_vhsales_30days', 30);
      this.initPaymentOnAPPStore('in_vhsales_90days', 90);
      this.initPaymentOnAPPStore('in_vhsales_180days', 180); 
      this.initPaymentOnAPPStore('in_vhsales_365days', 365);        
      this.iap2.refresh();
    })    
  }

  private initPaymentOnAPPStore(moneyID: any, duration:any) {    
    this.iap2.register({
      id: moneyID,
      alias: moneyID,
      type: this.iap2.CONSUMABLE
      //type: this.iap2.NON_RENEWING_SUBSCRIPTION
    });
    this.registerHandlersForPurchase(moneyID, duration);    
  }

  private registerHandlersForPurchase(moneyID:any, duration:any) {    
    this.iap2.when(moneyID).updated((payment:IAPProduct)=> {      
      //console.log('Updated1' + JSON.stringify(payment));
      //alert('updated1');          
    });
    this.iap2.when(moneyID).registered((payment: IAPProduct) => { 
      console.log('Registered1: ' + JSON.stringify(payment));     
      //alert('Registered1');   
    });
    this.iap2.when(moneyID).owned((payment: IAPProduct) => {
      console.log('owned1: ' + JSON.stringify(payment));
      //alert('owned1');  
    });
    this.iap2.when(moneyID).approved((payment: IAPProduct) => {
      console.log('approved1: ' + JSON.stringify(payment));      
      payment.verify();
      this.vhMGDB_auth.createSubscribedTime(moneyID, duration)
          .then(()=>{})
      //alert('approved1');   
    });
    this.iap2.when(moneyID).refunded((payment: IAPProduct) => {
      console.log('refunded1: ' + JSON.stringify(payment));
      //alert('refunded1');  
    });
    this.iap2.when(moneyID).expired((payment: IAPProduct) => {
      console.log('expired1: ' + JSON.stringify(payment));
      //alert('expired1');  
    });
    this.iap2.when(moneyID).verified((payment: IAPProduct) => {
      console.log('verified1: ' + JSON.stringify(payment));      
      payment.finish();
      //alert('verified1');  
    });
  } 

  public paymentOnAPPStore(moneyID: any) {
    try {     
      this.iap2.order(moneyID)
          .then((p:any) => {
            console.log('Purchase Succesful1' + JSON.stringify(p));           
          }).catch((e:any) => {
            console.log('Error Ordering From Store1' + e);
          });
    } catch (err) {
      console.log('Error Ordering1 ' + JSON.stringify(err));
    }
  }

  public refreshPurchase(){
    this.iap2.refresh();
  }

  private publishObservableEventProducts() {
    this.subjectproducts.next();
  }  

  private observableLocalProducts():Subject<any> {      
    return this.subjectproducts; 
  }
  
  /**
   * @example:
   * this.observableProducts = this.vhQuerySales.getObservableLocalProducts(1).subscribe((localProducts:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableProducts.unsubscribe();    
    }
   * @param type = 1 là sản phẩm, = 2 là dịch vụ, giá trị khác là cả hai
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalProducts(type?:any){       
   return new Observable((observer:any) => {    
    this.observableLocalProducts().subscribe(() => {   
      observer.next(this.getlocalProducts(type));
    })
    this.publishObservableEventProducts();
   })
  }  

  private getlocalProductAndCombos(id_product:any){
    let _products:any = new Array();
    for(let i=0; i<this.products.length; i++){
      if(this.products[i]._id === id_product){      
        _products.push({...this.products[i]});         
      }
      if(this.products[i].combos != undefined)
        for(let j=0; j<this.products[i].combos.length; j++){
          if(this.products[i].combos[j].id_product === id_product){
            _products.push({...this.products[i]});
            break;
          }
        }          
    }
    return _products;
  }

  

  /**
   * @example: 
   * let product = this.vhQuerySales.getlocalProduct('5fb6780ca2148e09806c5b01');
   * @param id_product 
   * @return Object => obj = {} or null
   */ 
  public getlocalProduct(id_product:any){     
    for(let i=0; i<this.products.length; i++){
      if(this.products[i]._id === id_product){   
        let _product:any = {...this.products[i]};
        if(_product.type === 5){      
          if(_product.combos){//sau này tạo combo có hàm mới sẽ bỏ điều kiện này
            for(let j=0; j<_product.combos.length; j++){
              let _id_sub_or_product = _product.combos[j].id_subproduct?_product.combos[j].id_subproduct:_product.combos[j].id_product;
              let __product = this.getlocalDetailProduct(_id_sub_or_product);
              if(__product){
                let _unit = this.getUnit_byRatio(__product.units, _product.combos[j].ratio);
                _product.combos[j].name = __product.name;                  
                _product.combos[j].units = __product.units;     
                //_product.combos[j].unit = _unit.unit;      
                if(__product.lots) _product.combos[j].lots = __product.lots;   
              }       
            }    
          }            
        }          
        return _product;
      }
    }
    return null; 
  }

  /**
   * @example
   * let products = this.vhQuerySales.getlocalProducts(); 
   * @param 
   * type = 3 là sản phẩm,
   * type = 2 là dịch vụ, = 5 là combo,
   * type = 23 là dịch vụ và sản phẩm, 
   * type = 35 là sản phẩm và combo
   * type = 235 là dịch vụ, sản phẩm và combo
   * giá trị khác là cả 3
   * @return Array(object) => array = [{},{},...]
   */
 
  public getlocalProducts(type?:any){          
    let _products = new Array();    
    for(let i=0; i<this.products.length; i++){
      if((type===2)||(type===3)||(type===5)||(type===6)){
        if(this.products[i].type === type) _products.push({...this.products[i]});    
      }else if(type===23){
        if((this.products[i].type === 2)||(this.products[i].type === 3)) _products.push({...this.products[i]});
      }else if(type===35){
        if((this.products[i].type === 3)||(this.products[i].type === 5)) _products.push({...this.products[i]});
      }else if(type===235){
        if((this.products[i].type === 2)||(this.products[i].type === 3)||(this.products[i].type === 5)) _products.push({...this.products[i]});
      }else if(type===2356){
        if((this.products[i].type === 2)||(this.products[i].type === 3)||(this.products[i].type === 5)||(this.products[i].type === 6)) _products.push({...this.products[i]});
      }else if(type===26){
        if((this.products[i].type === 2)||(this.products[i].type === 6)) _products.push({...this.products[i]});
      }else{
        _products.push({...this.products[i]});
      }
    }       
    for(let i=0; i<_products.length; i++){      
      if(_products[i].type === 5){      
        if(_products[i].combos){//sau này tạo combo có hàm mới sẽ bỏ điều kiện này
          for(let j=0; j<_products[i].combos.length; j++){
            let _id_sub_or_product = _products[i].combos[j].id_subproduct?_products[i].combos[j].id_subproduct:_products[i].combos[j].id_product;
            let _product = this.getlocalDetailProduct(_id_sub_or_product);
            if(_product){
              let _unit = this.getUnit_byRatio(_product.units, _products[i].combos[j].ratio);
              _products[i].combos[j].name = _product.name;                  
              _products[i].combos[j].units = _product.units;     
              //_products[i].combos[j].unit = _unit.unit;          
              if(_product.lots) _products[i].combos[j].lots = _product.lots;   
            }             
          }    
        }            
      }
    }          
    return _products;
  }
  
  /**
   * Hàm này lấy về tất cả detailproducts theo type của sản phẩm
   * @example
   * let detailproducts = this.vhQuerySales.getlocalDetailProducts(); 
   * @param 
   * type = 2 là sản phẩm,
   * type = 3 là dịch vụ, = 5 là combo,
   * type = 23 là dịch vụ và sản phẩm, 
   * type = 35 là sản phẩm và combo
   * type = 235 là dịch vụ, sản phẩm và combo
   * giá trị khác là cả 3
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalDetailProducts(type?:any){        
    let _detailproducts = new Array();    
    for(let i=0; i<this.detailproducts.length; i++){
      if((type===2)||(type===3)||(type===5)||(type===6)){
        if(this.detailproducts[i].type === type) _detailproducts.push({...this.detailproducts[i]});    
      }else if(type===23){
        if((this.detailproducts[i].type === 2)||(this.detailproducts[i].type === 3)) _detailproducts.push({...this.detailproducts[i]});
      }else if(type===35){
        if((this.detailproducts[i].type === 3)||(this.detailproducts[i].type === 5)) _detailproducts.push({...this.detailproducts[i]});
      }else if(type===235){
        if((this.detailproducts[i].type === 2)||(this.detailproducts[i].type === 3)||(this.detailproducts[i].type === 5)) _detailproducts.push({...this.detailproducts[i]});
      }else if(type===2356){
        if((this.detailproducts[i].type === 2)||(this.detailproducts[i].type === 3)||(this.detailproducts[i].type === 5)||(this.detailproducts[i].type === 6)) _detailproducts.push({...this.detailproducts[i]});
      }else if(type===26){
        if((this.detailproducts[i].type === 2)||(this.detailproducts[i].type === 6)) _detailproducts.push({...this.detailproducts[i]});
      }else{
        _detailproducts.push({...this.detailproducts[i]});
      }
    }   
    _detailproducts = this.vhAlgorithm.sortVietnamesebyASC(_detailproducts, 'name');
    for(let i=0; i<_detailproducts.length; i++){      
      if(_detailproducts[i].type === 5){      
        if(_detailproducts[i].combos){//sau này tạo combo có hàm mới sẽ bỏ điều kiện này
          for(let j=0; j<_detailproducts[i].combos.length; j++){
            let _id_sub_or_product = _detailproducts[i].combos[j].id_subproduct?_detailproducts[i].combos[j].id_subproduct:_detailproducts[i].combos[j].id_product;
            let _product = this.getlocalDetailProduct(_id_sub_or_product);
            if(_product){           
              _detailproducts[i].combos[j].name = _product.name;                  
              _detailproducts[i].combos[j].units = _product.units;            
              if(_product.lots) _detailproducts[i].combos[j].lots = _product.lots; 
            }       
          }    
        }            
      }
    }  
    //console.log('------_detailproducts', _detailproducts);
    return cloneDeep(_detailproducts);   
    //return _detailproducts;
  }

  /**
   * Hàm này lấy về 1 detailproduct theo tham số truyền vào, hoặc là id_product hoặc cả id_subproduct
   * @example
   * let id_sub_or_product = id_subproduct?id_subproduct:id_product;
   * let detailproduct = this.vhQuerySales.getlocalDetailProduct('ETxNu8exrvGtXFjkIhnc'); 
   * @param id_sub_or_product : id_subproduct hoặc id_product
   * @return Object => obj = {}  hoặc null
   */
   public getlocalDetailProduct(id_sub_or_product:string){    
    //console.log('-----------hello getlocalDetailProduct');   
    let _detailproduct = null;
    for(let i=0; i<this.detailproducts.length; i++){
      if(this.detailproducts[i].id_subproduct === id_sub_or_product){
        _detailproduct = {...this.detailproducts[i]}
        break;        
      }else if(this.detailproducts[i]._id === id_sub_or_product){
        if(!this.detailproducts[i].id_subproduct){
          _detailproduct = {...this.detailproducts[i]};
          break;    
        }else{
          console.log('Kiểm tra lại, đối tượng truyền vào hàm thiếu id_subproduct');
        }   
      }
    } 
    if(_detailproduct) {
      if(_detailproduct.type === 5){      
        if(_detailproduct.combos){//sau này tạo combo có hàm mới sẽ bỏ điều kiện này
          for(let j=0; j<_detailproduct.combos.length; j++){
            let _id_sub_or_product = _detailproduct.combos[j].id_subproduct?_detailproduct.combos[j].id_subproduct:_detailproduct.combos[j].id_product;
            let __product = this.getlocalDetailProduct(_id_sub_or_product);
            if(__product){
              //let _unit = this.getUnit_byRatio(__product.units, _detailproduct.combos[j].ratio);
              _detailproduct.combos[j].name = __product.name;                  
              _detailproduct.combos[j].units = __product.units;     
              //_detailproduct.combos[j].unit = _unit.unit;    
              if(__product.lots) _detailproduct.combos[j].lots = __product.lots; 
            }         
          }    
        }            
      }
      //return _detailproduct;
      return cloneDeep(_detailproduct); 
    }
    return null;
  }

/**
 * @example:
 * this.vhQuerySales.getlocalDetailProduct_Async('ETxNu8exrvGtXFjkIhnc')
        .then((detailproduct)=>{
        }, error=>{
          console.log('error', error);
        })
  * @param id_sub_or_product : object
  * @return Promise => object or null
  */
  private getlocalDetailProduct_Async(id_sub_or_product:string):Promise<any>{   
    return new Promise((resolve, reject) => {
      (async () => {
        try { 
          let _detailproduct = null;
          for(let i=0; i<this.detailproducts.length; i++){
            if(this.detailproducts[i].id_subproduct === id_sub_or_product){
              _detailproduct = {...this.detailproducts[i]}
              break;        
            }else if(this.detailproducts[i]._id === id_sub_or_product){
              if(!this.detailproducts[i].id_subproduct){
                _detailproduct = {...this.detailproducts[i]};
                break;    
              }else{
                console.log('Kiểm tra lại, đối tượng truyền vào hàm thiếu id_subproduct');
              }   
            }
          } 
          if(!_detailproduct) _detailproduct = await this.getDetailProduct(id_sub_or_product)
          if(_detailproduct) {
            if(_detailproduct.type === 5){      
              if(_detailproduct.combos){//sau này tạo combo có hàm mới sẽ bỏ điều kiện này
                for(let j=0; j<_detailproduct.combos.length; j++){
                  let _id_sub_or_product = _detailproduct.combos[j].id_subproduct?_detailproduct.combos[j].id_subproduct:_detailproduct.combos[j].id_product;
                  let __product = await this.getlocalDetailProduct_Async(_id_sub_or_product);
                  if(__product){
                    //let _unit = this.getUnit_byRatio(__product.units, _detailproduct.combos[j].ratio);
                    _detailproduct.combos[j].name = __product.name;                  
                    _detailproduct.combos[j].units = __product.units;     
                    //_detailproduct.combos[j].unit = _unit.unit;    
                    if(__product.lots) _detailproduct.combos[j].lots = __product.lots; 
                  }         
                }    
              }            
            }
          }
          //console.log('getlocalDetailProduct_Async', id_sub_or_product, _detailproduct);   
          resolve(_detailproduct);
        } catch (err) {
          console.error('❌ Lỗi trong getlocalDetailProduct_Async:', err);
          reject(err); // ✅ đừng quên reject nếu có lỗi
        }
      })();
    })
  }

  /**
   * Hàm kiểm tra và đồng bộ các sản phẩm trong bill_details (chi tiết hóa đơn), đảm bảo sản phẩm trong bill_detail đã tồn tại trong local
   * @example:
   * this.vhQuerySales.syncBillDetails_Products(array)
          .then(()=>{
          }, error=>{
            console.log('error', error);
          })
   * @param bill_details : Array
   * @return Promise => null
   * Luu ý: chỉ có 2 trường hợp, hoặc là sync thành công, hoặc là báo lỗi error
   */
  private syncBillDetails_Products(bill_details: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // Mảng chứa các promise cần thực hiện (tức là các sản phẩm cần tải về)
      let promise = new Array();
      // Duyệt qua từng dòng chi tiết trong bill_details
      for (let i = 0; i < bill_details.length; i++) {
        // Gán cờ kiểm tra xem sản phẩm đã tồn tại chưa
        let exist = false;
        // Lấy ra id của subproduct hoặc product (tùy theo cấu trúc dữ liệu)
        let id_sub_or_product = bill_details[i]?.id_subproduct
          ? bill_details[i]?.id_subproduct
          : bill_details[i].id_product;
        // Kiểm tra xem sản phẩm này đã có trong this.detailproducts chưa
        for (let j = 0; j < this.detailproducts.length; j++) {
          if (this.detailproducts[j]._id == id_sub_or_product) {
            exist = true;
            break; // nếu tìm thấy rồi thì dừng
          }
        }
        // Nếu chưa có trong danh sách => cần đồng bộ
        if (!exist) {
          console.log('syncBillDetails_Products', id_sub_or_product);
          // Gọi hàm getDetailProduct để lấy dữ liệu và lưu vào danh sách detailproducts
          promise[promise.length] = this.getDetailProduct(id_sub_or_product);
        }
      }

      // Khi tất cả các promise tải dữ liệu xong
      Promise.all(promise)
        .then(() => {
          // ✅ Đồng bộ xong hết
          resolve(null);
        })
        .catch(e => {
          // ❌ Nếu có lỗi trong quá trình tải
          reject(e);
        });
    });
  }

    /**
   * Hàm kiểm tra và đồng bộ các khách hàng trong bill_details (chi tiết hóa đơn), đảm bảo khách hàng trong bill_detail đã tồn tại trong local
   * @example:
   * this.vhQuerySales.syncBillDetails_Customers(array)
          .then(()=>{
          }, error=>{
            console.log('error', error);
          })
   * @param bill_details : Array
   * @return Promise => null
   * Luu ý: chỉ có 2 trường hợp, hoặc là sync thành công, hoặc là báo lỗi error
   */
  private syncBillDetails_Customers(bill_details: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // Mảng chứa các promise cần thực hiện (tức là các khách hàng cần tải về)
      let promise = new Array();
      // Duyệt qua từng dòng chi tiết trong bill_details
      for (let i = 0; i < bill_details.length; i++) {
        if(bill_details[i].id_customer){
          // Gán cờ kiểm tra xem khách hàng đã tồn tại chưa
          let exist = false;
          // Lấy ra id của subproduct hoặc product (tùy theo cấu trúc dữ liệu)
          let id_customer = bill_details[i].id_customer
          // Kiểm tra xem khách hàng này đã có trong this.customers chưa
          for (let j = 0; j < this.customers.length; j++) {
            if (this.customers[j]._id == id_customer) {
              exist = true;
              break; // nếu tìm thấy rồi thì dừng
            }
          }
          // Nếu chưa có trong danh sách => cần đồng bộ
          if (!exist) {
            //console.log('syncBillDetails_Customers', id_customer);
            // Gọi hàm getCustomer để lấy dữ liệu và lưu vào danh sách customers
            promise[promise.length] = this.getCustomer(id_customer);
          }
        }        
      }

      // Khi tất cả các promise tải dữ liệu xong
      Promise.all(promise)
        .then(() => {
          // ✅ Đồng bộ xong hết
          resolve(null);
        })
        .catch(e => {
          // ❌ Nếu có lỗi trong quá trình tải
          reject(e);
        });
    });
  }

   /**
   * Hàm kiểm tra và đồng bộ các nhà cung cấp trong bill_details (chi tiết hóa đơn), đảm bảo nhà cung cấp trong bill_detail đã tồn tại trong local
   * @example:
   * this.vhQuerySales.syncBillDetails_Suppliers(array)
          .then(()=>{
          }, error=>{
            console.log('error', error);
          })
   * @param bill_details : Array
   * @return Promise => null
   * Luu ý: chỉ có 2 trường hợp, hoặc là sync thành công, hoặc là báo lỗi error
   */
  private syncBillDetails_Suppliers(bill_details: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // Mảng chứa các promise cần thực hiện (tức là các nhà cung cấp cần tải về)
      let promise = new Array();
      // Duyệt qua từng dòng chi tiết trong bill_details
      for (let i = 0; i < bill_details.length; i++) {
        if(bill_details[i].id_supplier){
          // Gán cờ kiểm tra xem nhà cung cấp đã tồn tại chưa
          let exist = false;
          // Lấy ra id của supplier
          let id_supplier = bill_details[i]?.id_supplier
          // Kiểm tra xem nhà cung cấp này đã có trong this.suppliers chưa
          for (let j = 0; j < this.suppliers.length; j++) {
            if (this.suppliers[j]._id == id_supplier) {
              exist = true;
              break; // nếu tìm thấy rồi thì dừng
            }
          }
          // Nếu chưa có trong danh sách => cần đồng bộ
          if (!exist) {
            console.log('syncBillDetails_Suppliers', id_supplier);
            // Gọi hàm getSupplier để lấy dữ liệu và lưu vào danh sách suppliers
            promise[promise.length] = this.getSupplier(id_supplier);
          }
        }
      }

      // Khi tất cả các promise tải dữ liệu xong
      Promise.all(promise)
        .then(() => {
          // ✅ Đồng bộ xong hết
          resolve(null);
        })
        .catch(e => {
          // ❌ Nếu có lỗi trong quá trình tải
          reject(e);
        });
    });
  }

   /**
   * Hàm kiểm tra và đồng bộ các sản phẩm trong bill_details (chi tiết hóa đơn), đảm bảo nhân viên trong bill_detail đã tồn tại trong local
   * @example:
   * this.vhQuerySales.syncBillDetails_Employees(array)
          .then(()=>{
          }, error=>{
            console.log('error', error);
          })
   * @param bill_details : Array
   * @return Promise => null
   * Luu ý: chỉ có 2 trường hợp, hoặc là sync thành công, hoặc là báo lỗi error
   */
  private syncBillDetails_Employees(bill_details: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // Mảng chứa các promise cần thực hiện (tức là các nhân viên cần tải về)
      let promise = new Array();
      // Duyệt qua từng dòng chi tiết trong bill_details
      for (let i = 0; i < bill_details.length; i++) {
        if(bill_details[i].id_employee){
          // Gán cờ kiểm tra xem nhân viên đã tồn tại chưa
          let exist = false;
          // Lấy ra id của employee
          let id_employee = bill_details[i]?.id_employee
          // Kiểm tra xem nhân viên này đã có trong this.employees chưa
          let employees = this.vhAuth.getlocalEmployees();
          for (let j = 0; j < employees.length; j++) {
            if (employees[j]._id == id_employee) {
              exist = true;
              break; // nếu tìm thấy rồi thì dừng
            }
          }
          // Nếu chưa có trong danh sách => cần đồng bộ
          if (!exist) {          
            // Gọi hàm getEmployee để lấy dữ liệu và lưu vào danh sách employees
            promise[promise.length] = this.vhAuth.getEmployee(id_employee);
          }
        }
      }

      // Khi tất cả các promise tải dữ liệu xong
      Promise.all(promise)
        .then(() => {
          // ✅ Đồng bộ xong hết
          resolve(null);
        })
        .catch(e => {
          // ❌ Nếu có lỗi trong quá trình tải
          reject(e);
        });
    });
  }
  

  /**
   * Hàm này tìm, kiểm tra barcode bất kỳ có tồn tại không, nếu có thì trả về 1 detailproduct, nếu ko thì trả về null
   * Hàm này dùng trong 2 trường hợp:
   * - Tìm kiếm sản phẩm có mã là barcode (dùng máy quét tìm sản phẩm đưa vào bill_detail)
   * - Kiểm tra xem đã tồn tại sản phẩm có mã là barcode chưa (khi thêm, sửa sản phẩm)
   * @example
   * let detailproduct = this.vhQuerySales.getlocalDetailProduct_byBarcode('121212'); 
   * @param barcode
   * @return Object => obj = [{},{},...] hoặc null
   */
  public getlocalDetailProduct_byBarcode(barcode:string){
    if((barcode ===null)||(barcode ==='')||(barcode ===undefined)) return null;
    let detailproducts = this.getlocalDetailProducts();
    for(let i=0; i<this.detailproducts.length; i++){
      //kiểm tra barcode ở ĐVT, nếu trùng thì return về và ngừng tìm
      if(this.detailproducts[i].units){
        for(let j=0; j<this.detailproducts[i].units.length; j++){
          if(this.detailproducts[i].units[j].barcode === barcode){
            //let unit = {...this.detailproducts[i].units[j]};
           // delete unit.barcode;
            //return {...detailproducts[i], ...unit};
            return {...cloneDeep(this.detailproducts[i]), ratio: this.detailproducts[i].units[j].ratio};
          }
        }
      }

      if(this.detailproducts[i].lots){
        for(let j=0; j<this.detailproducts[i].lots.length; j++){
          if(this.detailproducts[i].lots[j].barcode === barcode){
            //let lot = {...this.detailproducts[i].lots[j]};
            //delete lot.barcode;
            return {...cloneDeep(this.detailproducts[i]), id_lotproduct: this.detailproducts[i].lots[j]._id};
          }
        }
      }
      //kiểm tra barcode ở sản phẩm nếu trùng thì return về và ngừng tìm
      // if(detailproducts[i].barcode === barcode){
      //   return detailproducts[i]
      // }     
    }
    //Nếu đã tìm barcode ở tất cả trên từng tree của sản phẩm rồi mà ko có thì trả về null
    return null;
  }
   /**
   * @example:
   * this.vhQuerySales.refreshLocalProducts()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalProduct(), getlocalProducts() trong localstorage
   * @return Promise => null
   */
  public refreshLocalProducts():any{
    return new Promise((resolve, reject) => { 
      //this.getProducts()
      //    .then(()=>{resolve(null)})   
      resolve(null)    
    })
  }



  /**
   * Hàm này dùng để đồng bộ dữ liệu ẩn (delete_hidden = true) từ database về local
   * @example:
   * this.vhQuerySales.refreshLocalProducts_Delete_Hidden(3)
        .then(()=>{
          do something.....
        })
  * Hàm này refresh giá trị mới nhất cho hàm getlocalProduct(), getlocalProducts() trong localstorage
  * @param type
  * @return Promise => null
  */
  public refreshLocalProducts_Delete_Hidden(type:any):any{
    return new Promise((resolve, reject) => { 
      if(this.getBranch_Management_Scope().product_scope){
        this.vhMGDB_database.getDocsByFields('products', {delete_hidden:{$eq:true}, type:{$eq:type}})
            .then((rawproducts:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `rawproducts` trong bộ nhớ local
              for(let i=0; i<rawproducts.length; i++){
                this.syncRaw_Detail_ProductInsert(rawproducts[i]);
              }
              resolve(null);
            }, error=>{
              reject(error)
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('products', {id_branch:{$eq: this.getDefaultBranch()._id},delete_hidden:{$eq:true}, type:{$eq:type}})
            .then((rawproducts:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `rawproducts` trong bộ nhớ local
              for(let i=0; i<rawproducts.length; i++){
                this.syncRaw_Detail_ProductInsert(rawproducts[i]);
              }
              resolve(null);
            }, error=>{
              reject(error)
            })  
      }    
    })
  }
  /**
   * @example:
   * this.vhQuerySales.addProduct({name:'camera 2', quantity:20, price:200000})
          .then((product)=>{
            console.log('addProduct', product);
          }, error=>{
            console.log('error', error);
          })
   * @param data : object
   * @return Promise => object = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addProduct(data:any){
    return new Promise((resolve, reject) => {          
      if(!data.manysize) {
        if(data?.type === 3) {  
          data.quantity = 0; data.quantity_branch = {};
          this.branchs.forEach((element:any) => {
            data.quantity_branch[element._id] = 0;
          }); 
        }
      }     
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('products', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.addProducts([{name:'camera 2', quantity:20, price:200000},{},...])
          .then((products)=>{
            console.log('addProducts', products);
          }, error=>{
            console.log('error', error);
          })
   * @param data : array(object)
   * @return Promise => array = [{},{},...]
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addProducts(data_array:any){
      return new Promise((resolve, reject) => {
        let promise = new Array();
        for(let i=0; i<data_array.length; i++){
          if(data_array[i]?.type === 3) {
            data_array[i].quantity = 0; data_array[i].quantity_branch = {};           
            this.branchs.forEach((element:any) => {
              data_array[i].quantity_branch[element._id] = 0;
            }); 
          }     
          promise[i] = new Promise(resolve=>{
            data_array[i].id_branch = this.getDefaultBranch()._id;
            this.vhMGDB_database.addDoc('products', data_array[i])
                .then((obj)=>{
                  resolve(obj);
                }, ()=>{                 
                  resolve(null);
                }) 
          })                       
        }
        Promise.all(promise).then((array:any)=>{
          let _array = array.filter((item:any)=> (item != null))
          resolve(_array);
        })                 
      })
    }

  /**
   * @example:
   * this.vhQuerySales.updateProduct('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateProduct', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_product 
   * @param data 
   * @return Promise => bool = true or false
   */
  public updateProduct(id_product:string, value:any){    
    return new Promise((resolve, reject) => {
      let product = this.getlocalProduct(id_product);          
      if(product.type ===3){
        if(checkSales_updateProduct_Type3(id_product, value)) return; 
      }else if(product.type ===2){
        if(checkSales_updateProduct_Type2(id_product, value)) return;     
      }else if(product.type ===5){
        if(checkSales_updateProduct_Type5(id_product, value)) return;   
      } 

      this.vhMGDB_database.updateDoc('products', id_product, value)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })     
    })
  }

  private updateProduct_fw(id_product:string, value:any){    
    return new Promise((resolve, reject) => {
      let product = this.getlocalProduct(id_product);          
      if(product.type ===3){
        if(checkSales_updateProduct_Type3_fw(id_product, value)) return;    
      }else if(product.type ===2){
        if(checkSales_updateProduct_Type2(id_product, value)) return;     
      }else if(product.type ===5){
        if(checkSales_updateProduct_Type5(id_product, value)) return;   
      }          
      this.vhMGDB_database.updateDoc('products', id_product, value)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })     
    })
  }
 
/**
 * @example:
 * this.vhQuerySales.deleteProduct('5fb67fda87c0f21d484cbdf3')
      .then((rsp)=>{
          if(rsp.vcode === 0){
              //-----------your code 0-----------            
          }else if(rsp.vcode === 1){
              //-----------your code 1-----------
          }else if(rsp.vcode === 2){
              //-----------your code 2-----------
          }             
      }, error=>{
        reject(error)
      })
  * @param id_product 
  *  @return Observable object => rsp = {vcode, message}
  * vcode == 0: xóa thành công
  * vcode == 1: Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác
  * vcode == 2: Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn
  * vcode == 3: Bạn không thể xóa, bạn phải xóa các thuộc tính của sản phẩm trước
  */
  public deleteProduct(id_product:string){  //kiểm tra trong các chương trình bán hàng nữa
    //console.log('id_product', id_product);
    return new Promise((resolve, reject) => {
      let product = this.getlocalProduct(id_product);
      //console.log('product', product);
      if(product.type === 3){
        if(product.subs?.length){
          console.log('Bạn không thể xóa, bạn phải xóa các thuộc tính của sản phẩm trước')
          return resolve({vcode:3, message: 'Bạn không thể xóa, bạn phải xóa các thuộc tính của sản phẩm trước'});
        }else{
          for(let i=0; i<this.products.length; i++){        
            if(this.products[i].combos?.length)
              for(let j=0; j<this.products[i].combos.length; j++){
                if(this.products[i].combos[j].id_product === id_product){
                  console.log('Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác')
                  return resolve({vcode:1, message: 'Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác'});
                }
              }                        
          }     
        }

        this.getBill_details_byID({id_product:{$eq:id_product}}, {}, 1)
            .then((vhbill_details:any)=>{                      
              if(vhbill_details.length===0){         
                this.vhMGDB_database.deleteDoc('products', id_product)
                    .then(()=>{                       
                        resolve({vcode:0, message: 'success'});                           
                    }, error=>{
                      reject(error)
                    }) 
              }else {
                console.log('Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn')
                resolve({vcode:2, message: 'Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn'});            
              }
            }, error=>{
              reject(error)
            })   

      }else if(product.type === 2){        
        for(let i=0; i<this.products.length; i++){        
          if(this.products[i].combos?.length)
            for(let j=0; j<this.products[i].combos.length; j++){
              if(this.products[i].combos[j].id_product === id_product){
                console.log('Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác')
                return resolve({vcode:1, message: 'Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm combo khác'});
              }
            }                        
        }             
        this.getBill_details_byID({id_product:{$eq:id_product}}, {}, 1)
            .then((vhbill_details:any)=>{                      
              if(vhbill_details.length===0){         
                this.vhMGDB_database.deleteDoc('products', id_product)
                    .then(()=>{                       
                        resolve({vcode:0, message: 'success'});                           
                    }, error=>{
                      reject(error)
                    }) 
              }else {
                console.log('Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn')
                resolve({vcode:2, message: 'Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn'});            
              }
            }, error=>{
              reject(error)
            }) 
      }else if(product.type === 5){
        this.getBill_details_byID({id_combos_group:{$eq:id_product}}, {}, 1)
            .then((vhbill_details:any)=>{                      
              if(vhbill_details.length===0){         
                this.vhMGDB_database.deleteDoc('products', id_product)
                    .then(()=>{                       
                        resolve({vcode:0, message: 'success'});                           
                    }, error=>{
                      reject(error)
                    }) 
              }else {
                console.log('Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn')
                resolve({vcode:2, message: 'Bạn không thể xóa, vì sản phẩm này đã phát sinh hóa đơn'});            
              }
            }, error=>{
              reject(error)
            }) 
      }else if(product.type === 6){                   
        this.getBill_details_byID({id_product:{$eq:id_product}}, {}, 1)
            .then((vhbill_details:any)=>{                      
              if(vhbill_details.length===0){         
                this.vhMGDB_database.deleteDoc('products', id_product)
                    .then(()=>{                       
                        resolve({vcode:0, message: 'success'});                           
                    }, error=>{
                      reject(error)
                    }) 
              }else {
                console.log('Bạn không thể xóa, vì dịch vụ này đã phát sinh hóa đơn')
                resolve({vcode:2, message: 'Bạn không thể xóa, vì dịch vụ này đã phát sinh hóa đơn'});            
              }
            }, error=>{
              reject(error)
            }) 
      }
    
    })      
  }

  /**
   * @example
   * this.vhQuerySales.getProduct('5fb67fda87c0f21d484cbdf3')
            .then((product)=>{
              console.log('getProduct', product);
            })
   * @param id_product 
   * @return null or object
   */
  private getProduct(id_product:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('products', id_product)
            .then((product)=>{
              resolve(product);
            })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getProducts()
            .then((response)=>{
              console.log('getDoc', response);
            })
   * @return array(object) = [{},{},..]
   */
  private getProducts(){
    return new Promise((resolve, reject) => {
      if(this.getBranch_Management_Scope().product_scope){
        this.vhMGDB_database.getDocs('products')
            .then((response)=>{
              this.products = response;
              resolve(response);
            }, error=>{
              reject(error)
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('products', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((products)=>{              
              resolve(products);
            },(error:any)=>{
              reject(error);
            }) 
      } 
           
        
    })
  }

  /**
   * Hàm lấy chi tiết sản phẩm dựa vào id sản phẩm hoặc id sản phẩm con
   * @example
   * this.vhQuerySales.getDetailProduct('5fb67fda87c0f21d484cbdf3')
            .then((product)=>{
              console.log('getDetailProduct', product);
            })
   * @param id_product 
   * @return null or object
   */
private getDetailProduct(id_sub_or_product: string) {
  return new Promise((resolve) => {
    // Gọi đến database để lấy thông tin sản phẩm/subproduct dựa vào id truyền vào
    this.vhMGDB_database.getDoc('products', id_sub_or_product)
      .then((subproduct: any) => {        
        // Nếu tìm thấy sản phẩm/subproduct
        if (subproduct) {
          // Đồng bộ thông tin lấy được vào danh sách `detailproducts` trong bộ nhớ local
          this.syncRaw_Detail_ProductInsert(subproduct);
          // Thử tìm lại sản phẩm chi tiết từ local (bộ nhớ tạm)
          let detailproduct = this.getlocalDetailProduct(id_sub_or_product);
          // Nếu tìm được trong local, trả kết quả ngay
          if (detailproduct) return resolve(detailproduct);
          // Nếu sản phẩm có thuộc nhóm sản phẩm cha (gợi ý rằng đây là subproduct)
          if (subproduct.id_subs_group) {
            // Gọi tiếp đến database để lấy sản phẩm cha
            this.vhMGDB_database.getDoc('products', subproduct.id_subs_group)
              .then((product: any) => {
                // Nếu tìm thấy sản phẩm cha
                if (product) {
                  // (Có thể là thừa) Đồng bộ lại thông tin subproduct vào local
                  this.syncRaw_Detail_ProductInsert(subproduct);
                  // Nếu sản phẩm cha có thuộc tính `manysize` (tức là có nhiều size hoặc phân loại)
                  if (product.manysize) {
                    // Gộp thông tin sản phẩm cha và con lại
                    let _detailproduct = { ...subproduct, ...product };
                    // Lưu lại id của subproduct
                    _detailproduct.id_subproduct = subproduct._id;
                    // Ghép tên cha và con để tạo tên đầy đủ
                    _detailproduct.name = product.name + ' (' + subproduct.name + ')';
                    // Xoá các thuộc tính không còn cần thiết sau khi ghép
                    delete _detailproduct.id_subs_group;
                    delete _detailproduct.manysize;
                    // Trả về sản phẩm đã ghép
                    resolve(_detailproduct);
                  } else {
                    // Nếu không phải sản phẩm manysize => không hợp lệ
                    resolve(null);
                  }
                } else {
                  // Không tìm thấy sản phẩm cha
                  resolve(null);
                }
              });

          } else {
            // Nếu không có `id_subs_group` → subproduct là sản phẩm độc lập → trả về luôn
            resolve(subproduct);
          }
        } else {
          // Không tìm thấy sản phẩm/subproduct ban đầu
          resolve(null);
        }
      });
  });
}    

  /**
   * @example:
   * this.vhQuerySales.addCombosProduct('5fb6780ca2148e',[{id_product:'rtw554b5634573456', id_subproduct: 'gty3456ygw454287', quantity:2, price: 20000, type: 1},{},..])
          .then((combos)=>{
            console.log('addCombosProduct', combos);
          }, error=>{
            console.log('error', error);
          })
   * @param id_product
   * @param dataArray
   * @return Promise => object = [{id_product, name, price},{},...] hoặc null
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là null
   */
  public addCombosProduct(id_product:any, dataArray:any){    
    for(let i=0; i<dataArray.length; i++){   //xóa khi nhân viên sửa xong
      delete dataArray[i]?.name;
    }
    //console.log('dataArray', dataArray)// xóa khi nhân viên sửa xong
    return new Promise((resolve, reject) => {         
        let combos = new Array();
        for(let i=0; i<dataArray.length; i++){        
          combos[i] = {...dataArray[i], _id:this.vhAlgorithm.ObjectId()};   
        }      
        let bool = false;
        let product:any;
        let number = 0;        
        let setinterval = setInterval(() => {
            number++;
            product = this.getlocalProduct(id_product);
            if(product){
              //console.log('product', product)        
              bool = true;
              if(product.combos === undefined)  product.combos = new Array();               
              for(let i=0; i<product.combos.length; i++){ 
                delete product.combos[i]?.name; delete product.combos[i]?.img;                
              }             
              let _combos = [...product.combos, ...combos];                                    
              this.vhMGDB_database.updateDoc('products', id_product, {combos:_combos})
                  .then(()=>{                 
                    for(let i=0; i<combos.length; i++){        
                      let _product = this.getlocalProduct(combos[i].id_product)
                      combos[i].name = _product.name;                        
                      combos[i].img = _product.img;                         
                      if(combos[i].id_subproduct !=undefined){
                        for(let j=0; j<_product.subs.length;j++){
                          if(combos[i].id_subproduct === _product.subs[j]._id) {
                            combos[i].name = combos[i].name + '(' + _product.subs[j].name + ')';
                            break;
                          }                
                        }              
                      }
                    } 
                    resolve(combos);
                  }, ()=>{   
                    reject(null);                       
                  })               
            }       
            if((bool===true)||(number ===20)) clearInterval(setinterval);         
        }, 100);                      
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateComboProduct('5fb6780ca2148e', 'rtw554b5634573456', {name:'Cơm chiên (nhỏ)', quantity: 2, price: 20000})
          .then((bool:any)=>{
            console.log('updateCombo', bool);
          }, error=>{
            console.log('error', error);
          })
    * @param id_product 
    * @param data 
    * @return Promise => bool = true or false
    */
    public updateComboProduct(id_product:string, id_comboproduct:string, data:any){
      //console.log('updateComboProduct', data);//nhân viên sửa xong sẽ xóa
      delete data?.name; delete data?.quantity;// nhân viên sửa xong sẽ xóa
      return new Promise((resolve, reject) => {
        let product:any = this.getlocalProduct(id_product);          
        if(product.combos != undefined){
          product.combos.forEach((item:any) => {
            delete item?.name; delete item?.img; 
          });
          for(let i=0; i<product.combos.length; i++){            
            if(product.combos[i]._id === id_comboproduct){              
              product.combos[i] = {...product.combos[i],...data};              
              this.vhMGDB_database.updateDoc('products', product._id, {combos: product.combos})
                  .then((bool:any)=>{
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })   
              break;
            }
          }   
        }                    
      })
    }      
    

  /**
    * hàm này tạo product và thêm subs vào product (lần đầu)
    * Lưu ý: trong product, subProductArray không có các trường quantity, quantity_branch và subs
   * @example:
   * @case 1: manysize (false)
   * let product = {
        allow_sell: true,
        brand: "OEM",
        tax: 0,
        id_category: "vTr90aYfhDqSCyuRh4DR",
        img: "image link",
        manysize: false,
        name: "test ko sub 3",
        selling: true,
        type: 1,
        warning_number: 3,
        item_code: '',
        units:[{
          barcode: "3103",
          price: 3100,
          price2: 3101,
          price_import: 3102,
          ratio: 1,
          unit: "Cái"
        }]      
   * }
   * @case 2: manysize (true)
   * let product = {
        allow_sell: true,
        brand: "OEM",
        tax: 0,
        id_category: "vTr90aYfhDqSCyuRh4DR",
        img: "image link",
        manysize: true,
        name: "test sub 4",
        selling: true,
        type: 3,
        warning_number: 3,
        item_code: '',
        units:[{          
          ratio: 1,
          unit: "Cái"
        },{
          barcode: "4203",
          price: 4200,
          price2: 4101,
          price_import: 4202,
          ratio: 10,
          unit: "Hộp"
        }]      
     }
     let subProductArray = [{
        barcode: "43004",
        name: "Lớn",
        price: 43000,
        price2: 43002,
        price_import: 43001,
        warning_number: 43003,
        item_code: ''
     }]
   * this.vhQuerySales.addProductAndSubsProduct(product,subProductArray)
          .then(()=>{
            console.log('addProductAndSubsProduct');
          }, error=>{
            console.log('error', error);
          })
   * @param product 
   * @param subProductArray 
   * @return Promise => null hoặc error
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công trả về null (resolve), hoặc là thất bại trả về error (reject)
   */
  public addProductAndSubsProduct(product:any, subProductArray:any){    
    //var f1 = require('./check-parameters-sales');
    
    //const check_addProductAndSubsProduct = require('./check-parameters-sales');
    
    
    //nhớ check thêm trùng barcode
   // check lại hàm convert khách trên server
    return new Promise((resolve, reject) => {  
      if(checkSales_addProductAndSubsProduct(product, subProductArray)) return;

      // if(product.manysize){        
      //   delete product.type;        
      // }else{      
      //   delete product.subs;
      if(!product.manysize){ 
        if(product.manylot){
          for(let j=0; j<product.lots.length; j++){
            product.lots[j]._id = this.vhAlgorithm.ObjectId();
            product.lots[j].quantity = 0;
            product.lots[j].quantity_branch = {};
            this.branchs.forEach((e:any) => {
              product.lots[j].quantity_branch[e._id] = 0;
            }); 
          } 
        } 
      }
      this.addProduct(product)
          .then((_product:any)=>{                 
            let promise = new Array();
            for(let i=0; i<subProductArray.length; i++){ 
              //sau này sẽ xem lại giá trị nào bên dưới ko cần thì bỏ đi
              subProductArray[i].id_branch = this.getDefaultBranch()._id;
              subProductArray[i].id_subs_group = _product._id;    
              subProductArray[i].type = 3;
              subProductArray[i].quantity = 0;    
              subProductArray[i].quantity_branch = {};    
              this.branchs.forEach((e:any) => {
                subProductArray[i].quantity_branch[e._id] = 0;
              }); 
              if(subProductArray[i].manylot){
                for(let j=0; j<subProductArray[i].lots.length; j++){
                  subProductArray[i].lots[j]._id = this.vhAlgorithm.ObjectId();
                  subProductArray[i].lots[j].quantity = 0;
                  subProductArray[i].lots[j].quantity_branch = {};
                  this.branchs.forEach((e:any) => {
                    subProductArray[i].lots[j].quantity_branch[e._id] = 0;
                  }); 
                } 
              }             
              promise[i] = this.vhMGDB_database.addDoc('products', subProductArray[i]);
            }    
            Promise.all(promise).then(()=>{              
              resolve(null);
            }, error=>{
              console.log('error', error);
              reject(error);
            })              
          }, error=>{
            console.log('error', error);
            reject(error);
          })
      
    })    
  }

  /**
   * Hàm này cập nhật lại những thay đổi trong sub (cỡ) của sản phẩm
   * @example:
   * this.vhQuerySales.updateSubProduct('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateSubProduct', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_product 
   * @param id_subproduct       
   * @param data 
   * @return Promise => bool = true or false
   */
  public updateSubProduct(id_subproduct:string, value:any){
    return new Promise((resolve, reject) => {  
      if(checkSales_updateSubProduct(id_subproduct, value)) return;      
      let product = this.getlocalDetailProduct(id_subproduct);    
      if(product){
        if(value.lots){
          for(let i=0; i<value.lots.length; i++){
            for(let j=0; j<product.lots.length; j++){ 
              if(value.lots[i]._id === product.lots[j]._id){
                value.lots[i] = {...product.lots[i], ...value.lots[j]};
              }
            }
          }
        }        
        this.vhMGDB_database.updateDoc('products', id_subproduct, value)
            .then((bool:any)=>{
              resolve(bool);
            }, error=>{
              reject(error)
            })     
      }                 
    })
  }

  /**
    * Hàm này thêm Sub vào Product
   * @example:
   * let subProduct ={
        allow_sell: true,
        manylot: true,
        name: "Lớn",
        selling: true,
        type: 3,
        warning_number: 5,
        item_code: '',
        units:[{
          barcode: "384807544448",
          default: true,
          price: 70000,
          price2: 60000,
          price_import: 50000,
          ratio: 1,
          unit: "Cái"
        }],
        days_exp_warning: 30,
        days_import_warning: 60,
        lots:[{
          _id: "tgwOaMDVmQaHfaL8FD02SMl9"
          barcode: "337953449785"
          date_exp: 'October 7, 2022 at 11:59:59 PM UTC+7'
          date_mfg: 'March 1, 2022 at 12:00:00 AM UTC+7'
          hidden: false
          lot_number: "lo1101"
        }]
     }
   * this.vhQuerySales.addSubProduct('5fb6780ca2148e09806c5b01',{price:0, name:'small'})
          .then((subproduct)=>{
            console.log('addSubProduct', subproduct);
          }, error=>{
            console.log('error', error);
          })
   * @param id_product 
   * @param subProduct 
   * @return Promise => null hoặc error
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công trả về null (resolve), hoặc là thất bại trả về error (reject)
   */
  public addSubProduct(id_product:string, subProduct:any){
    return new Promise((resolve, reject) => {               
      if(checkSales_addSubProduct(id_product, subProduct)) return;
      //sau này sẽ xem lại giá trị nào bên dưới ko cần thì bỏ đi
      subProduct.id_branch = this.getDefaultBranch()._id;
      subProduct.id_subs_group = id_product;    
      subProduct.type = 3;
      subProduct.quantity = 0;    
      subProduct.quantity_branch = {};    
      this.branchs.forEach((e:any) => {
        subProduct.quantity_branch[e._id] = 0;
      }); 
      if(subProduct.manylot){
        for(let j=0; j<subProduct.lots.length; j++){
          subProduct.lots[j]._id = this.vhAlgorithm.ObjectId();
          subProduct.lots[j].quantity = 0;
          subProduct.lots[j].quantity_branch = {};
          this.branchs.forEach((e:any) => {
            subProduct.lots[j].quantity_branch[e._id] = 0;
          }); 
        } 
      }    
      this.vhMGDB_database.addDoc('products', subProduct)
          .then(()=>{              
            resolve(null);
          }, error=>{
            console.log('error', error);
            reject(error);
          })              
              
    })
  }
/**
  * Hàm này thêm Lot vào Product
  * @example:
  * let lot:{          
      barcode: "337953449785",
      date_exp: new Date('October 7, 2022 at 11:59:59 PM UTC+7'),
      date_mfg: new Date('March 1, 2022 at 12:00:00 AM UTC+7'),
      hidden: false,
      lot_number: "lo1101"
    }
  * this.vhQuerySales.addLotProduct('5fb6780ca2148e09806c5b01',lot)
          .then(()=>{
            console.log('addLotProduct');
          }, error=>{
            console.log('error', error);
          })
   * @param id_sub_or_product 
   * @param lot 
   * @return Promise => newlot (lot có _id) hoặc error
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công trả về newlot (resolve), hoặc là thất bại trả về error (reject)
   */
  public addLotProduct(id_sub_or_product:string, lot:any){
    return new Promise((resolve, reject) => {      
      let product = this.getlocalDetailProduct(id_sub_or_product); 
      let _lot = cloneDeep(lot);     
      if(product){
        if(product.lots){        
          _lot._id = this.vhAlgorithm.ObjectId();            
          _lot.quantity = 0;
          _lot.quantity_branch = {};       
          this.branchs.forEach((e:any) => {
            _lot.quantity_branch[e._id] = 0;
          });     
        }
        product.lots.push(_lot);        
        let data_branch:any = {};       
        this.branchs.forEach((e:any) => {          
          data_branch[e._id + '_ivtr'] = null;
        });         
        this.vhMGDB_database.updateDoc('products', id_sub_or_product,  {lots:[...product.lots], ...data_branch})
            .then(()=>{
              resolve(_lot);
            }, error=>{
              reject(error)
            })               
      }    
    }) 
  }

  /**
 * @example:
 * this.vhQuerySales.deleteLotProduct('5fb67fda87c0f21d484cbdf3', 'NdbCy50cz5nNQyFVtITS')
       .then((rsp)=>{
          if(rsp.vcode === 0){
              //-----------your code 0-----------            
          }else if(rsp.vcode === 1){
              //-----------your code 1-----------
          }else if(rsp.vcode === 2){
              //-----------your code 2-----------
          }     
      }, error=>{
        reject(error)
      })
  * @param id_sub_or_product   
  * @param id_lotproduct       
  * @return Promise object => rsp = {vcode, message}
  * vcode == 0: xóa thành công
  * vcode == 1: Bạn không thể xóa, vì lô sản phẩm này không tồn tại
  * vcode == 2: Bạn không thể xóa, vì lô sản phẩm này đã phát sinh hóa đơn
  */ 
  public deleteLotProduct(id_sub_or_product:string, id_lotproduct:string){
    return new Promise((resolve, reject) => {      
      let product = this.getlocalDetailProduct(id_sub_or_product);    
      let exists = false;  
      if(product){
        if(product.lots){        
          for(let i=0; i<product.lots.length; i++){
            if(product.lots[i]._id === id_lotproduct){
              product.lots.splice(i, 1); exists = true;
              break;
            }
          }   
        }               
      } 
     
      if(exists){
       this.getBill_details_byFields({id_lotproduct:{$eq:id_lotproduct}},{},{},1)
            .then((vhbill_details:any)=>{                      
              if(vhbill_details.length===0){ 
                let data_branch:any = {};       
                this.branchs.forEach((e:any) => {          
                  data_branch[e._id + '_ivtr'] = null;
                }); 
                this.vhMGDB_database.updateDoc('products', id_sub_or_product,  {lots:[...product.lots], ...data_branch})
                    .then(()=>{
                      resolve({vcode:0, message: 'success'}); 
                    }, error=>{
                      reject(error)
                    })            
              }else {
                console.log('Bạn không thể xóa, vì lô sản phẩm này đã phát sinh hóa đơn')
                resolve({vcode:2, message: 'Bạn không thể xóa, vì lô sản phẩm này đã phát sinh hóa đơn'});       
              }
            }, error=>{
              reject(error)
            })  
      }else{
        console.log('Bạn không thể xóa, vì lô sản phẩm này không tồn tại')
        resolve({vcode:1, message: 'Bạn không thể xóa, vì lô sản phẩm này không tồn tại'});    
      } 
    }) 
  }

  /**
   * this.vhQuerySales.updateLotProduct('5fb6780ca2148e09806c5b01','56s46ww54HFG3H265', {barcode: '13464160156465'})
          .then((bool:any)=>{
            console.log('updateLotProduct', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_sub_or_product 
   * @param id_lotproduct 
   * @param value 
   * @return Promise => bool = true or false
   */
  public updateLotProduct(id_sub_or_product:string, id_lotproduct:string, value:any){
    return new Promise((resolve, reject) => {
      let product = this.getlocalDetailProduct(id_sub_or_product);    
      //let exists = false;  
      if(product){
        if(product.lots){        
          for(let i=0; i<product.lots.length; i++){
            if(product.lots[i]._id === id_lotproduct){          
              for(const p in value){
                product.lots[i][p] = value[p]
              }
              this.vhMGDB_database.updateDoc('products', id_sub_or_product,  {lots:[...product.lots]})
                  .then(()=>{
                    resolve(true);
                  }, error=>{
                    reject(error)
                  })   
              break;           
            }
          }   
        }               
      } 
    })
  }

  /**
  * Hàm này thêm Subs vào Product
  * @example:
  * this.vhQuerySales.addSubsProduct('5fb6780ca2148e09806c5b01',[{price:0, name:'small'},{},...])
        .then((subproducts)=>{
          console.log('addSubsProduct', subproducts);
        }, error=>{
          console.log('error', error);
        })
  * @param id_product 
  * @param subProductArray 
  * @return Promise => null hoặc error
  * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công trả về null (resolve), hoặc là thất bại trả về error (reject)
  */
  private addSubsProduct(id_product:any, subProductArray:any){
    return new Promise((resolve, reject) => {       
      let promise = new Array();
      for(let i=0; i<subProductArray.length; i++){ 
        //sau này sẽ xem lại giá trị nào bên dưới ko cần thì bỏ đi
        subProductArray[i].id_branch = this.getDefaultBranch()._id;
        subProductArray[i].id_subs_group = id_product;    
        subProductArray[i].type = 3;
        subProductArray[i].quantity = 0;    
        subProductArray[i].quantity_branch = {};    
        this.branchs.forEach((e:any) => {
          subProductArray[i].quantity_branch[e._id] = 0;
        }); 
        if(subProductArray[i].manylot){
          for(let j=0; j<subProductArray[i].lots.length; j++){
            subProductArray[i].lots[j]._id = this.vhAlgorithm.ObjectId();
          } 
        }    
        promise[i] = this.vhMGDB_database.addDoc('products', subProductArray[i]);
      }    
      Promise.all(promise).then(()=>{              
        resolve(null);
      }, error=>{
        console.log('error', error);
        reject(error);
      })              
              
    })
  }

/**
 * @example:
 * this.vhQuerySales.deleteSubProduct('5fb67fda87c0f21d484cbdf3')
       .then((rsp)=>{
          if(rsp.vcode === 0){
              //-----------your code 0-----------            
          }else if(rsp.vcode === 1){
              //-----------your code 1-----------
          }else if(rsp.vcode === 2){
              //-----------your code 2-----------
          }     
      }, error=>{
        reject(error)
      })
  * @param id_subproduct      
  * @return Promise object => rsp = {vcode, message}
  * vcode == 0: xóa thành công
  * vcode == 1: Bạn không thể xóa, vì sản phẩm con này đang liên kết với sản phẩm combo khác
  * vcode == 2: Bạn không thể xóa, vì sản phẩm con này đã phát sinh hóa đơn
  */  
  public deleteSubProduct(id_subproduct:string){  
    return new Promise((resolve, reject) => {
      let IDproducts = new Array();
      for(let i=0; i<this.products.length; i++){        
        if(this.products[i].combos){
          for(let j=0; j<this.products[i].combos.length; j++){
            if(this.products[i].combos[j].id_subproduct === id_subproduct){
              console.log('Bạn không thể xóa, vì sản phẩm con này đang liên kết với sản phẩm combo khác');
              return resolve({vcode:1, message: 'Bạn không thể xóa, vì sản phẩm con này đang liên kết với sản phẩm combo khác'});
            }
          }         
        } 
      }     
      this.getBill_details_byID({id_subproduct:{$eq:id_subproduct}}, {}, 1)
          .then((vhbill_details:any)=>{                      
            if(vhbill_details.length===0){              
              this.vhMGDB_database.deleteDoc('products', id_subproduct)  
                  .then(()=>{                   
                    resolve({vcode:0, message: 'success'});                           
                  }, error=>{
                    reject(error)
                  }) 
            }else {
              console.log('Bạn không thể xóa, vì sản phẩm con này đã phát sinh hóa đơn')
              resolve({vcode:2, message: 'Bạn không thể xóa, vì sản phẩm con này đã phát sinh hóa đơn'});       
            }
          }, error=>{
            reject(error)
          })    
    })
  }

  private publishObservableEventCustomers() {
    this.subjectcustomers.next(this.customers);
  }  

  private observableLocalCustomers():Subject<any> {      
    return this.subjectcustomers; 
  }
  
   /**
   * @example:
   * this.observableCustomer = this.vhQuerySales.getObservableLocalCustomers().subscribe((localCustomers:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableCustomer.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalCustomers(){   
   return new Observable((observer:any) => {    
    this.observableLocalCustomers().subscribe((customers) => {   
      observer.next(customers);
    })
    this.publishObservableEventCustomers();
   })
  }

  /**
   * @example: 
   * let customer = this.vhQuerySales.getlocalCustomer('5fb6780ca2148e09806c5b01');
   * @param id_customer 
   * @return Object => obj = {} or null
   */
  public getlocalCustomer(id_customer:any){
    for(let i=0; i<this.customers.length; i++){
      if(this.customers[i]._id === id_customer){
        return this.customers[i];
        break;
      }
    } 
    return null; 
  }

  /**
   * @example: 
   * this.vhQuerySales.getlocalCustomer_Async('ETxNu8exrvGtXFjkIhnc')
          .then((customer)=>{
          }, error=>{
            console.log('error', error);
          })
   * @param id_customer 
   * @return Object => obj = {} or null
   */
    private getlocalCustomer_Async(id_customer:string):Promise<any>{   
      return new Promise((resolve, reject) => {
        (async () => {
          try{
            for(let i=0; i<this.customers.length; i++){
              if(this.customers[i]._id === id_customer){
                return resolve(this.customers[i]);
              }
            } 
            let _customer = await this.getCustomer(id_customer);
            resolve(_customer)
          } catch (err) {
            console.error('❌ Lỗi getlocalCustomer_Async:', err);
            reject(err);
          }  
        })();
      })
    }
  /**
   * @example: 
   * let customers = this.vhQuerySales.getlocalCustomers();
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalCustomers(){    
    return cloneDeep(this.customers);
  }
  
  /**
   * @example:
   * this.vhQuerySales.refreshLocalCustomers()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalCustomer(), getlocalCustomers() trong localstorage
   * @return Promise => null
   */
  public refreshLocalCustomers():any{
    return new Promise((resolve) => { 
      // this.getCustomers()
      //     .then(()=>{resolve(null)})      
      resolve(null) 
    })
  }

    /**
   * Hàm này dùng để đồng bộ dữ liệu ẩn (delete_hidden = true) từ database về local
   * @example:
   * this.vhQuerySales.refreshLocalCustomers_Delete_Hidden()
        .then(()=>{
          do something.....
        })
  * Hàm này refresh giá trị mới nhất cho hàm getlocalCustomer(), getlocalCustomers() trong localstorage
  * @param type
  * @return Promise => null
  */
  public refreshLocalCustomers_Delete_Hidden():any{
    return new Promise((resolve, reject) => { 
      if(this.getBranch_Management_Scope().product_scope){
        this.vhMGDB_database.getDocsByFields('customers', {delete_hidden:{$eq:true}})
            .then((customers:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `customers` trong bộ nhớ local
              for(let i=0; i<customers.length; i++){
                delete customers[i].name_keywords;
                delete customers[i].phone_keywords;        
                if(!this.getlocalCustomer(customers[i]._id)){
                  this.customers.push(customers[i]);      
                }   
              }              
              resolve(null);
            }, error=>{
              reject(error)
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('customers', {id_branch:{$eq: this.getDefaultBranch()._id},delete_hidden:{$eq:true}})
            .then((customers:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `customers` trong bộ nhớ local
              for(let i=0; i<customers.length; i++){
                delete customers[i].name_keywords;
                delete customers[i].phone_keywords;        
                if(!this.getlocalCustomer(customers[i]._id)){
                  this.customers.push(customers[i]);      
                }   
              }              
              resolve(null);
            }, error=>{
              reject(error)
            })  
      }    
    })
  }

  /**
   * @example:
   * this.vhQuerySales.addCustomer({name:'Khách hàng 1', address: 'HCM'})
          .then((rsp)=>{
            if(rsp.vcode == 0){
              //addCustomer thành công
            }else if(rsp.vcode == 0){
              //This phone number is already in use with another customer
            }
          },(error:any)=>{
            console.log('error', error);
          })
   * @param data: Có cả 3 trường countryCode, phone và phoneNumber
   * @return Promise => rsp ={vcode, msg, data(obj)}
   * vcode = 0: 'success'
   * vcode = 1: 'This phone number is already in use with another customer'
   */
  public addCustomer(data:any){
    return new Promise((resolve, reject) => {
      //Thời điểm tạo Khách hàng
      data.updated_at = new Date();
      //Setting trong phần mềm sẽ thay thế biến này
      let unique_phone_number = true;
      // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
      if (!(data.countryCode && data.phone && data.phoneNumber)) {
        // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
        return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
      } 
      if(data.name) {
        data.name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(data.name)).toLowerCase());
      }
      if(data.phone) {
        data.phone_keywords = this.vhAlgorithm.getSequentialSubstrings(data.phone,6)
      }
      if(unique_phone_number){     
        this.vhMGDB_database.getDocsByFields('customers', {phoneNumber:{$eq:data.phoneNumber}}, {})
            .then((customers:any)=>{
              if(customers.length == 0){
                this.vhMGDB_database.addDoc('customers', data)
                    .then((customer:any)=>{
                      resolve({vcode:0, msg: 'success', data: customer}); 
                    },(error:any)=>{
                      reject(error);
                    })   
              }else{
                resolve({vcode:1, msg: 'This phone number is already in use with another customer'}); 
              }
          },error=>{
            reject(error);
          })              
      }else{
        this.vhMGDB_database.addDoc('customers', data)
            .then((customer:any)=>{
              resolve({vcode:0, msg: 'success', data: customer}); 
            },(error:any)=>{
              reject(error);
            }) 
      }             
    })
  }

  /**
   * @example:
   * this.vhQuerySales.addCustomers([{name:'Khách hàng 1', address: 'HCM'},{},...])
        .then((rsp)=>{
          if(rsp.vcode == 0){
            //addCustomers thành công
          }else if(rsp.vcode == 0){
            //Phone numbers in the list are duplicated
          }
        },(error:any)=>{
          console.log('error', error);
        })
  * @param data : array(object), Có cả 3 trường countryCode, phone và phoneNumber
  * @return  Promise => {vcode, msg, data(array)}
  * vcode = 0: 'success'
  * vcode = 1: 'Phone numbers in the list are duplicated'
  */
  public addCustomers(arr_data:any){
    return new Promise((resolve, reject) => {
      //Setting trong phần mềm sẽ thay thế biến này
      let unique_phone_number = true;
      for(let i=0; i<arr_data.length; i++){  
        // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
        if (!(arr_data[i].countryCode && arr_data[i].phone && arr_data[i].phoneNumber)) {
          // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
          return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
        }
        //Thời điểm tạo khách hàng
        arr_data[i].updated_at = new Date();
        //Tạo keywords cho name và phone
        if(arr_data[i].name) {
          arr_data[i].name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(arr_data[i].name)).toLowerCase());
        }
        if(arr_data[i].phone) {
          arr_data[i].phone_keywords = this.vhAlgorithm.getSequentialSubstrings(arr_data[i].phone,6)
        }
      }

      if(unique_phone_number){
        for(let i=0; i<arr_data.length; i++){
          //check các sô trong arr_data trùng nhau
          for(let j=i+1; j<arr_data.length; j++){
            if(arr_data[j].phoneNumber == arr_data[i].phoneNumber) return resolve({vcode:1, msg: 'Phone numbers in the list are duplicated'}); 
          }
        }
        let promise = new Array();
        for(let i=0; i<arr_data.length; i++){
          promise[i] = new Promise(resolve=>{
            this.vhMGDB_database.getDocsByFields('customers', {phoneNumber:{$eq:arr_data[i].phoneNumber}}, {})
                .then((customers:any)=>{
                  if(customers.length == 0){
                    this.vhMGDB_database.addDoc('customers', arr_data[i])
                        .then((customer:any)=>{
                          resolve(customer); 
                        },(error:any)=>{
                          resolve(null);
                        })   
                  }else{
                    resolve(null); 
                  }                            
                },error=>{
                  reject(error);
                }) 
          })
        } 
        Promise.all(promise).then((array:any)=>{
          let _array = array.filter((item:any)=> (item != null))
          resolve({vcode:0, msg: 'success', data: _array});       
        })   
      }else{
        let promise = new Array();
        for(let i=0; i<arr_data.length; i++){         
          promise[i] = new Promise(resolve=>{
            arr_data[i].id_branch = this.getDefaultBranch()._id;
            this.vhMGDB_database.addDoc('customers', arr_data[i])
                .then((customer)=>{
                  resolve(customer);
                }, (error)=>{                 
                  resolve(null);
                }) 
          })                       
        }
        Promise.all(promise).then((array:any)=>{
          let _array = array.filter((item:any)=> (item != null))
          resolve({vcode:0, msg: 'success', data: _array});       
        })   
      }
                    
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updatePCustomer('5fb6780ca2148e09806c5b01', {name: Nguyễn Thị Nở})
          .then((rsp)=>{
            if(rsp.vcode == 0){
              //updatePCustomer thành công
            }else if(rsp.vcode == 0){
              //This phone number is already in use with another customer
            }
          },(error:any)=>{
            console.log('error', error);
          })
    * @param id_customer 
    * @param value : Nếu value hoặc có cả 3 trường countryCode, phone, phoneNumber hoặc ko có
    * @return  Promise => {vcode, msg, data(true/false)}
    * vcode = 0: 'success'
    * vcode = 1: 'This phone number is already in use with another customer'
    */
  public updateCustomer(id_customer:string, value:any){
    return new Promise((resolve, reject) => {
      value.updated_at = new Date();
      //Setting trong phần mềm sẽ thay thế biến này
      let unique_phone_number = true; 
      // Nếu ít nhất một trong ba trường countryCode, phone hoặc phoneNumber có giá trị
      if (value.countryCode || value.phone || value.phoneNumber) {
        // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
        if (!(value.countryCode && value.phone && value.phoneNumber)) {
          // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
          return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
        }
      }      
      if(value.name) {
        value.name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(value.name)).toLowerCase());
      }
      if(value.phone) {
        value.phone_keywords = this.vhAlgorithm.getSequentialSubstrings(value.phone,6)
      }
      if(value.phoneNumber && unique_phone_number){
        this.vhMGDB_database.getDocsByFields('customers', {phoneNumber:{$eq:value.phoneNumber}}, {})
            .then((customers:any)=>{
              if(customers.length == 0){
                this._updateCustomer(id_customer, value)
                    .then((bool:any)=>{
                      resolve({vcode:0, msg: 'success', data: bool}); 
                    }, error=>{
                      reject(error)
                    }) 
              }else{
                if(customers[0]._id == id_customer){
                  this._updateCustomer(id_customer, value)
                      .then((bool:any)=>{
                        resolve({vcode:0, msg: 'success', data: bool}); 
                      }, error=>{
                        reject(error)
                      }) 
                }else{
                  resolve({vcode:1, msg: 'This phone number is already in use with another customer'}); 
                }
              }
            },error=>{
              reject(error);
            })     
      }else{
        this._updateCustomer(id_customer, value)
            .then((bool:any)=>{
              resolve({vcode:0, msg: 'success', data: bool}); 
            }, error=>{
              reject(error)
            }) 
      }        
    })
  }

  private _updateCustomer(id_customer:string, value:any){
    return new Promise((resolve, reject) => {
      value.updated_at = new Date();
      this.vhMGDB_database.updateDoc('customers', id_customer, value)
          .then((bool:any)=>{
            resolve(bool); 
          }, error=>{
            reject(error)
          }) 
    })    
  }
  /**
   * @example:
   * this.vhQuerySales.deleteCustomer('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteCustomer', bool);
        })
   * @param id_customer 
   * @return Promise => bool = true or false
   */
  public deleteCustomer(id_customer:string){   
    return new Promise((resolve, reject) => {
     this.getBills_byFields({id_customer:{$eq:id_customer}},{},{},1)       
         .then((bills:any)=>{                      
           if(bills.length===0){              
             this.vhMGDB_database.deleteDoc('customers', id_customer)
                 .then((bool:any)=>{            
                   resolve(bool);
                 }, error=>{
                   reject(error)
                 })    
           }else resolve(false);
         }, error=>{
           reject(error)
         })             
    })
  }

  /**
   * @example
   * this.vhQuerySales.getCustomer('5fb67fda87c0f21d484cbdf3')
            .then((customer)=>{
              console.log('getCustomer', customer);
            })
   * @param id_customer 
   * @return Promise => obj = {} or null
   */
  public getCustomer(id_customer:string){
    return new Promise((resolve, reject) => {
      if(this.getBranch_Management_Scope().customer_scope){
        this.vhMGDB_database.getDoc('customers', id_customer)
            .then((customer:any)=>{
              if(customer){
                let exist = false;
                for(let i=0; i<this.customers.length; i++){
                  if(this.customers[i]._id == id_customer){
                    exist = true;                    
                    break;
                  }
                }
                if(!exist) this.customers.push(customer);
              }
              resolve(customer);
            },(error:any)=>{
              reject(error);
            })         
      }else{
        // this.vhMGDB_database.getDocsByFields('customers', {id_branch:{$eq: this.getDefaultBranch()._id}})
        //     .then((customers)=>{              
        //       resolve(customers);
        //     },(error:any)=>{
        //       reject(error);
        //     }) 
        this.vhMGDB_database.getDoc('customers', id_customer)
            .then((customer:any)=>{
              resolve(customer);
            },(error:any)=>{
              reject(error);
            }) 
      } 
                  
    })
  }

  /**
   * @example
   * this.vhQuerySales.getCustomers()
            .then((customers)=>{
              console.log('getCustomers', customers);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getCustomers(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('customers')
            .then((customers)=>{
              this.customers = customers;
              resolve(customers);
            },(error:any)=>{
              reject(error);
            })            
    })
  }

  /**
   * Hàm này dùng để xóa hoặc đặt lại điểm mới cho khách hàng
   * @example:
   * this.vhQuerySales.updateCustomer_byPoints('5fb6780ca2148e09806c5b01', 1000)
          .then((bool:any)=>{
            console.log('updateCustomer_byPoints', bool);
          })
   * @param _id 
   * @param points 
   * @return Promise => bool = true or false
   */
  public updateCustomer_byPoints(_id:string, points:number){
    return new Promise((resolve,reject) => {
      let customer = this.getlocalCustomer(_id);
      if(customer.earned_points != undefined){
        customer.earned_points = points;
      }else{
        customer.earned_points = points;
      }
      let branch = this.getDefaultBranch();
      if(customer.branch_earned_points !=undefined){
        if(customer.branch_earned_points[branch._id] !=undefined){
          customer.branch_earned_points[branch._id] = points;
        }else{
          customer.branch_earned_points[branch._id] = points;
        }
      }else{
        customer.branch_earned_points = {};
        customer.branch_earned_points[branch._id] = points;
      }
      let value_customer = {
        earned_points: customer.earned_points,
        branch_earned_points: customer.branch_earned_points    
      }
      //promise_one[promise_one.length] = this._updateCustomer(customer._id, value_customer);
      this._updateCustomer(_id, {...value_customer})
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * Hàm này thêm điểm mới kiếm được vào quỹ điểm khách hàng đang có
   * points = points(tích được trên bill) - point (sử dụng thanh toán trên bill)
   * @example:
   * this.vhQuerySales.updateCustomer_byEarnedPoints('5fb6780ca2148e09806c5b01', 200)
          .then((bool:any)=>{
            console.log('updateCustomer_byEarnedPoints', bool);
          })
   * @param _id 
   * @param points 
   * @return Promise => bool = true or false
   */
  public updateCustomer_byEarnedPoints(_id:string, points:number){
    return new Promise((resolve,reject) => {
      let customer = this.getlocalCustomer(_id);
      if(customer.earned_points != undefined){
        customer.earned_points = customer.earned_points + points;
      }else{
        customer.earned_points = points;
      }
      let branch = this.getDefaultBranch();
      if(customer.branch_earned_points !=undefined){
        if(customer.branch_earned_points[branch._id] !=undefined){
          customer.branch_earned_points[branch._id] = customer.branch_earned_points[branch._id] + points;
        }else{
          customer.branch_earned_points[branch._id] = points;
        }
      }else{
        customer.branch_earned_points = {};
        customer.branch_earned_points[branch._id] = points;
      }
      let value_customer = {
        earned_points: customer.earned_points,
        branch_earned_points: customer.branch_earned_points    
      }
      //promise_one[promise_one.length] = this._updateCustomer(customer._id, value_customer);
      this._updateCustomer(_id, {...value_customer})
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }


  /**
   * Hàm này trả về điểm của khách hàng theo phạm vị chương trình bán hàng là toàn chi nhánh hay là từng chi nhánh
   * @example: 
   * let customer = this.vhQuerySales.getlocalCustomer_byPoints('5fb6780ca2148e09806c5b01');
   * @param id_customer 
   * @return Object => obj = {} or null
   */
    public getlocalCustomerPoints(id_customer:any){     
      let branch = this.getDefaultBranch(); 
      for(let i=0; i<this.customers.length; i++){
        if(this.customers[i]._id === id_customer){
          if(this.getBranch_Management_Scope().sales_program_scope){
            if(this.customers[i].earned_points != undefined){
              return this.customers[i].earned_points;
            }else{
              return 0;
            }
          }else{
            if(this.customers[i].branch_earned_points !=undefined){
              if(this.customers[i].branch_earned_points[branch._id] !=undefined){
                return this.customers[i].branch_earned_points[branch._id];
              }else{
                return 0;
              }
            }else{
              return 0;
            }
          }         
          break;
        }
      }       
    }

    /**
    * Hàm tìm kiếm tên chủ sở hữu và số điện thoại, nghĩa là nhập 1 chuỗi tên (2 từ trở lên) hoặc chuỗi số (6 ký tự trở lên) hàm sẽ
    * trả về những chủ sở hữu có tên hoặc số điện thoại tương ứng với keyword tìm kiếm
    *  @example:
    * this.vhQuerySales.searchKeyword_NamePhone({'customers, '925354'})
          .then((rsp)=>{
            console.log('searchKeyword_NamePhone', rsp);
          },(error:any)=>{
            console.log('error', error);
          })
    * @param name_or_phone 
    * @param countryCode 
    * @returns Promise = > {vcode, msg, data(array)}
    */
    public searchKeyword_NamePhone(colname:string, name_or_phone:string, countryCode?:string){
      return new Promise((resolve, reject) => {
        //Bỏ dấu và chuyển sang chuỗi các ký tự thường
        name_or_phone = (this.vhAlgorithm.changeAlias_withCharacter(name_or_phone)).toLowerCase();
        //Chuẩn hóa chuỗi, nếu có nhiều hơn 1 khoảng trống liên tiếp thì chỉ giữ lại 1 khoảng trống, bỏ cả khoảng trống đầu và cuối chuỗi
        name_or_phone = this.vhAlgorithm.normalizeSpaces(name_or_phone);
        //Nếu chuỗi số (các ký tự trong chuôi là số)
        if(this.vhAlgorithm.isNumericString(this.vhAlgorithm.removeAllSpaces(name_or_phone))){
          let keyword = this.vhAlgorithm.removeAllSpaces(name_or_phone);
          let query = {phone_keywords:{$array_contains:keyword}}
          this.vhMGDB_database.getDocsByFields(colname, query, {}, {}, 20)
              .then((rsp:any)=>{
                  //console.log('searchList_Keyword', rsp);
                  if(rsp.vcode ==0){
                    for(let i=0; i<rsp.data?.length; i++){
                      delete rsp.data[i].name_keywords;
                      delete rsp.data[i].phone_keywords;
                    }
                  }
                  resolve(rsp)
                },error=>{
                  reject(error)
                })
        }else{//Nếu chuỗi ký tự (trong chuỗi có chữ)
          let keywords = name_or_phone.split(" ");
          if(keywords.length >= 2){
            let keyword = name_or_phone;
            let query = {name_keywords:{$array_contains:keyword}}
            this.vhMGDB_database.getDocsByFields(colname, query, {}, {}, 20)
                .then((rsp:any)=>{
                    //console.log('searchList_Keyword', rsp);
                    if(rsp.vcode ==0){
                      for(let i=0; i<rsp.data?.length; i++){
                        delete rsp.data[i].name_keywords;
                        delete rsp.data[i].phone_keywords;
                      }
                    }
                    resolve(rsp)
                  },error=>{
                    reject(error)
                  })
          }
        }
      })
    }

  private publishObservableEventSuppliers() {
    this.subjectsuppliers.next(this.suppliers);
  }  

  private observableLocalSuppliers():Subject<any> {      
    return this.subjectsuppliers; 
  }
  
   /**
   * @example:
   * this.observableSuppliers = this.vhQuerySales.getObservableLocalSuppliers().subscribe((localSuppliers:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableSuppliers.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalSuppliers(){   
   return new Observable((observer:any) => {    
    this.observableLocalSuppliers().subscribe((suppliers) => {   
      observer.next([...suppliers]);
    })
    this.publishObservableEventSuppliers();
   })
  }


   /**
   * @example: 
   * let supplier = this.vhQuerySales.getlocalSupplier('5fb6780ca2148e09806c5b01');
   * @param id_supplier 
   * @return Object => obj = {} or null
   */
  public getlocalSupplier(id_supplier:any){
    for(let i=0; i<this.suppliers.length; i++){
      if(this.suppliers[i]._id === id_supplier){
        return this.suppliers[i];
        break;
      }
    } 
    return null; 
  }

   /**
   * @example: 
   * this.vhQuerySales.getlocalSupplier_Async('ETxNu8exrvGtXFjkIhnc')
          .then((customer)=>{
          }, error=>{
            console.log('error', error);
          })
   * @param id_supplier
   * @return Object => obj = {} or null
   */
    private getlocalSupplier_Async(id_supplier:string):Promise<any>{   
      return new Promise((resolve, reject) => {
        (async () => {
          try{
            for(let i=0; i<this.suppliers.length; i++){
              if(this.suppliers[i]._id === id_supplier){
                return resolve(this.suppliers[i]);
              }
            } 
            let _supplier = await this.getCustomer(id_supplier);
            resolve(_supplier)
          } catch (err) {
            console.error('❌ Lỗi getlocalSupplier_Async:', err);
            reject(err);
          }  
        })();
      })
    }
  /**
   * @example: 
   * let suppliers = this.vhQuerySales.getlocalWallets();
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalSuppliers(){    
    return [...this.suppliers];
  }
  
   /**
   * this.vhQuerySales.refreshLocalSuppliers()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalSupplier(), getlocalSuppliers() trong localstorage
   * @return Promise => null
   */
  public refreshLocalSuppliers():any{
    return new Promise((resolve) => { 
      // this.getSuppliers()
      //     .then(()=>{resolve(null)})   
      resolve(null)    
    })
  }

    /**
   * Hàm này dùng để đồng bộ dữ liệu ẩn (delete_hidden = true) từ database về local
   * @example:
   * this.vhQuerySales.refreshLocalSuppliers_Delete_Hidden()
        .then(()=>{
          do something.....
        })
  * Hàm này refresh giá trị mới nhất cho hàm getlocalSupplier(), getlocalSuppliers() trong localstorage
  * @param type
  * @return Promise => null
  */
  public refreshLocalSuppliers_Delete_Hidden():any{
    return new Promise((resolve, reject) => { 
      if(this.getBranch_Management_Scope().product_scope){
        this.vhMGDB_database.getDocsByFields('suppliers', {delete_hidden:{$eq:true}})
            .then((suppliers:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `suppliers` trong bộ nhớ local
              for(let i=0; i<suppliers.length; i++){
                delete suppliers[i].name_keywords;
                delete suppliers[i].phone_keywords;        
                if(!this.getlocalSupplier(suppliers[i]._id)){
                  this.suppliers.push(suppliers[i]);      
                }   
              }              
              resolve(null);
            }, error=>{
              reject(error)
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('suppliers', {id_branch:{$eq: this.getDefaultBranch()._id},delete_hidden:{$eq:true}})
            .then((suppliers:any)=>{
              // Đồng bộ thông tin lấy được vào danh sách `suppliers` trong bộ nhớ local
              for(let i=0; i<suppliers.length; i++){
                delete suppliers[i].name_keywords;
                delete suppliers[i].phone_keywords;        
                if(!this.getlocalSupplier(suppliers[i]._id)){
                  this.suppliers.push(suppliers[i]);      
                }   
              }              
              resolve(null);
            }, error=>{
              reject(error)
            })  
      }    
    })
  }

  /**
   * @example:
   * this.vhQuerySales.addSupplier({name:'Nhà cung cấp 1', address: 'HCM'})
          .then((rsp)=>{
            if(rsp.vcode == 0){
              //addSupplier thành công
            }else if(rsp.vcode == 0){
              //This phone number is already in use with another customer
            }
          },(error:any)=>{
            console.log('error', error);
          })
   * @param data: Có cả 3 trường countryCode, phone và phoneNumber
   * @return Promise => rsp ={vcode, msg, data(obj)}
   * vcode = 0: 'success'
   * vcode = 1: 'This phone number is already in use with another supplier'
   */
  public addSupplier(data:any){
    return new Promise((resolve, reject) => {
      //Thời điểm tạo nhà cung cấp
      data.updated_at = new Date();
      //Setting trong phần mềm sẽ thay thế biến này
      let unique_phone_number = true;
      // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
      if (!(data.countryCode && data.phone && data.phoneNumber)) {
        // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
        return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
      }
      data.id_branch = this.getDefaultBranch()._id;
      if(data.name) {
        data.name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(data.name)).toLowerCase());
      }
      if(data.phone) {
        data.phone_keywords = this.vhAlgorithm.getSequentialSubstrings(data.phone,6)
      }
      if(unique_phone_number){     
        this.vhMGDB_database.getDocsByFields('suppliers', {phoneNumber:{$eq:data.phoneNumber}}, {})
            .then((suppliers:any)=>{
              if(suppliers.length == 0){
                this.vhMGDB_database.addDoc('suppliers', data)
                    .then((supplier:any)=>{
                      resolve({vcode:0, msg: 'success', data: supplier}); 
                    },(error:any)=>{
                      reject(error);
                    })   
              }else{
                resolve({vcode:1, msg: 'This phone number is already in use with another supplier'}); 
              }
          },error=>{
            reject(error);
          })              
      }else{
        this.vhMGDB_database.addDoc('suppliers', data)
            .then((supplier:any)=>{
              resolve({vcode:0, msg: 'success', data: supplier}); 
            },(error:any)=>{
              reject(error);
            })   
      }         
    })
  }

    /**
     * @example:
     * this.vhQuerySales.addSuppliers([{name:'Nhà cung cấp 1', address: 'HCM'},{},...])
          .then((rsp)=>{
            if(rsp.vcode == 0){
              //addSuppliers thành công
            }else if(rsp.vcode == 0){
              //Phone numbers in the list are duplicated
            }
          },(error:any)=>{
            console.log('error', error);
          })
    * @param data: array(object), Có cả 3 trường countryCode, phone và phoneNumber
    * @return  Promise => {vcode, msg, data(array)}
    * vcode = 0: 'success'
    * vcode = 1: 'Phone numbers in the list are duplicated'
    */
    public addSuppliers(arr_data:any){
      return new Promise((resolve, reject) => {
        //Setting trong phần mềm sẽ thay thế biến này
        let unique_phone_number = true;
        for(let i=0; i<arr_data.length; i++){  
          // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
          if (!(arr_data[i].countryCode && arr_data[i].phone && arr_data[i].phoneNumber)) {
            // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
            return reject('3 trường countryCode, phone, phoneNumber luôn luôn có');
          }
          //Thời điểm tạo nhà cung cấp
          arr_data[i].updated_at = new Date();
          if(arr_data[i].name) {
            arr_data[i].name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(arr_data[i].name)).toLowerCase());
          }
          if(arr_data[i].phone) {
            arr_data[i].phone_keywords = this.vhAlgorithm.getSequentialSubstrings(arr_data[i].phone,6)
          }
        }
        if(unique_phone_number){
          for(let i=0; i<arr_data.length; i++){
            //check các sô trong arr_data trùng nhau
            for(let j=i+1; j<arr_data.length; j++){
              if(arr_data[j].phoneNumber == arr_data[i].phoneNumber) return resolve({vcode:1, msg: 'Phone numbers in the list are duplicated'}); 
            }
          }
          let promise = new Array();
          for(let i=0; i<arr_data.length; i++){
            promise[i] = new Promise(resolve=>{
              this.vhMGDB_database.getDocsByFields('suppliers', {phoneNumber:{$eq:arr_data[i].phoneNumber}}, {})
                  .then((suppliers:any)=>{
                    if(suppliers.length == 0){
                      this.vhMGDB_database.addDoc('suppliers', arr_data[i])
                          .then((supplier:any)=>{
                            resolve(supplier); 
                          },(error:any)=>{
                            resolve(null);
                          })   
                    }else{
                      resolve(null); 
                    }                            
                  },error=>{
                    reject(error);
                  }) 
            })
          } 
          Promise.all(promise).then((array:any)=>{
            let _array = array.filter((item:any)=> (item != null))
            resolve({vcode:0, msg: 'success', data: _array});       
          })   
        }else{
          let promise = new Array();
          for(let i=0; i<arr_data.length; i++){         
            promise[i] = new Promise(resolve=>{
              arr_data[i].id_branch = this.getDefaultBranch()._id;
              this.vhMGDB_database.addDoc('suppliers', arr_data[i])
                  .then((supplier)=>{
                    resolve(supplier);
                  }, (error)=>{                 
                    resolve(null);
                  }) 
            })                       
          }
          Promise.all(promise).then((array:any)=>{
            let _array = array.filter((item:any)=> (item != null))
            resolve({vcode:0, msg: 'success', data: _array});       
          })   
        }
                      
      })
    }

  /**
   * @example:
   * this.vhQuerySales.updateSupplier('5fb6780ca2148e09806c5b01', {name: Nguyễn Thị Nở})
          .then((rsp)=>{
            if(rsp.vcode == 0){
              //updateSupplier thành công
            }else if(rsp.vcode == 0){
              //This phone number is already in use with another customer
            }
          },(error:any)=>{
            console.log('error', error);
          })
    * @param id_customer 
    * @param value : Nếu value hoặc có cả 3 trường countryCode, phone, phoneNumber hoặc ko có
    * @return  Promise => {vcode, msg, data(true/false)}
    * vcode = 0: 'success'
    * vcode = 1: 'This phone number is already in use with another supplier'
    */
  public updateSupplier(id_supplier:string, value:any){
    return new Promise((resolve,reject) => {
      value.updated_at = new Date();
       //Setting trong phần mềm sẽ thay thế biến này
       let unique_phone_number = true;
      // Nếu ít nhất một trong ba trường countryCode, phone hoặc phoneNumber có giá trị
      if (value.countryCode || value.phone || value.phoneNumber) {
        // Kiểm tra xem cả ba trường có đồng thời tồn tại hay không
        if (!(value.countryCode && value.phone && value.phoneNumber)) {
          // Nếu thiếu bất kỳ trường nào trong 3 trường, trả về lỗi
          return reject('3 trường countryCode, phone, phoneNumber luôn đi chung với nhau');
        }
      }
      if(value.name) {
        value.name_keywords = this.vhAlgorithm.getWordSubstrings((this.vhAlgorithm.changeAlias_withCharacter(value.name)).toLowerCase());
      }
      if(value.phone) {
        value.phone_keywords = this.vhAlgorithm.getSequentialSubstrings(value.phone,6)
      }
      if(value.phoneNumber && unique_phone_number){
        this.vhMGDB_database.getDocsByFields('suppliers', {phoneNumber:{$eq:value.phoneNumber}}, {})
            .then((suppliers:any)=>{
              if(suppliers.length == 0){
                this._updateSupplier( id_supplier, value)
                    .then((bool:any)=>{
                      resolve({vcode:0, msg: 'success', data: bool}); 
                    }, error=>{
                      reject(error)
                    }) 
              }else{
                if(suppliers[0]._id == id_supplier){
                  this._updateSupplier( id_supplier, value)
                      .then((bool:any)=>{
                        resolve({vcode:0, msg: 'success', data: bool}); 
                      }, error=>{
                        reject(error)
                      }) 
                }else{
                  resolve({vcode:1, msg: 'This phone number is already in use with another supplier'}); 
                }
              }
            },error=>{
              reject(error);
            })     
      }else{
        this._updateSupplier( id_supplier, value)
            .then((bool:any)=>{
              resolve({vcode:0, msg: 'success', data: bool}); 
            }, error=>{
              reject(error)
            }) 
      }
               
    })
  }

  private _updateSupplier(id_supplier:string, value:any){
    return new Promise((resolve, reject) => {
      value.updated_at = new Date();
      this.vhMGDB_database.updateDoc('suppliers', id_supplier, value)
          .then((bool:any)=>{
            resolve(bool); 
          }, error=>{
            reject(error)
          }) 
    })    
  }

  /**
   * @example:
   * this.vhQuerySales.deleteSupplier('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteSupplier', bool);
        })
   * @param id_supplier 
   * @return Promise => bool = true or false 
   */
  public deleteSupplier(id_supplier:string){   
    return new Promise((resolve, reject) => {
     this.getBills_byFields({id_supplier:{$eq:id_supplier}},{},{},1)
          .then((bills:any)=>{                      
            if(bills.length===0){              
              this.vhMGDB_database.deleteDoc('suppliers', id_supplier)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })    
            }else resolve(false);
          }, error=>{
            reject(error)
          })             
    })
  }

  /**
   * @example
   * this.vhQuerySales.getSupplier('5fb67fda87c0f21d484cbdf3')
            .then((supplier)=>{
              console.log('getSupplier', supplier);
            })
   * @param id_supplier 
   * @return Promise => obj ={} or null
   */
  public getSupplier(id_supplier:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('suppliers', id_supplier)
            .then((supplier)=>{
              if(supplier){
                let exist = false;
                for(let i=0; i<this.suppliers.length; i++){
                  if(this.suppliers[i]._id == id_supplier){
                    exist = true;                    
                    break;
                  }
                }
                if(!exist) this.suppliers.push(supplier);
              }
              resolve(supplier);
            })          
    }) 
  }

  /**
   * @example
   * this.vhQuerySales.getSuppliers()
            .then((suppliers)=>{
              console.log('getSuppliers', suppliers);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  private getSuppliers(){
    return new Promise((resolve, reject) => {     
      if(this.getBranch_Management_Scope().supplier_scope){
        this.vhMGDB_database.getDocs('suppliers')
            .then((suppliers)=>{
              this.suppliers = suppliers;
              resolve(suppliers);
            },(error:any)=>{
              reject(error);
            })           
      }else{
        this.vhMGDB_database.getDocsByFields('suppliers', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((suppliers)=>{              
              resolve(suppliers);
            },(error:any)=>{
              reject(error);
            }) 
      }                 
    })
  }

  private publishObservableEventWallets() {
    this.subjectwallets.next(this.wallets);
  }  

  private observableLocalWallets():Subject<any> {      
    return this.subjectwallets; 
  }

  /**
   * @example:
   * Lấy danh sách tài khoản thanh toán
    getDataWallets() {      
      this.observableWallets = this.vhQuerySales.getObservableLocalWallets().subscribe((localwallets:any) => {                       
          let data = localwallets.filter((item:any) => item._id != 'id_cash' && item.id_branch == this.vhQuerySales.getDefaultBranch()._id);
          if (this.keySearch) {
            this.list_wallet = this.vhAlgorithm.searchList(
              this.keySearch,
              data,
              ["name", "bank_name", "number"]
            );
          } else {
            this.list_wallet = data;
          }
          this.sortData(this.sortby);
      })       
    }    
    ngOnInit(): void {
      this.getDataWallets();
    }
    ngOnDestroy(){
      this.observableWallets.unsubscribe();    
    }
   * @returns 
   */
  public getObservableLocalWallets(){   
   return new Observable((observer:any) => {    
    this.observableLocalWallets().subscribe((wallets) => {   
      observer.next(wallets);
    })
    this.publishObservableEventWallets();
   })
  }


  /**
   * @example: 
   * let wallet = this.vhQuerySales.getlocalWallet('5fb6780ca2148e09806c5b01');
   * @param id_wallet 
   * @return Object => obj = {} or null
   */
  public getlocalWallet(id_wallet:any){
    for(let i=0; i<this.wallets.length; i++){
      if(this.wallets[i]._id === id_wallet){
        return this.wallets[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let wallets = this.vhQuerySales.getlocalWallets();
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalWallets(){    
    return [...this.wallets];
  }
  
   /**
   * @example:
   * this.vhQuerySales.refreshLocalWallets()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalWallet(), getlocalWallets() trong localstorage
   * @return Promise => null
   */
  public refreshLocalWallets():any{
    return new Promise((resolve) => { 
      // this.getWallets()
      //     .then(()=>{resolve(null)})   
      resolve(null)    
    })
  }
  /**
   * @example:
   * this.vhQuerySales.addWallet({name:'camera 2', quantity:20, price:200000})
          .then((wallet)=>{
            console.log('addWallet', wallet);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addWallet(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('wallets', data)
          .then((wallet)=>{
            resolve(wallet);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateWallet('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateWallet', bool);
          })
   * @param id_wallet 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateWallet(id_wallet:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('wallets', id_wallet, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteWallet('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteWallet', bool);
        })
   * @param id_wallet 
   * @return Promise => bool = true or false 
   */
  public deleteWallet(id_wallet:string){
    return new Promise((resolve, reject) => {
     this.getBills_byFields({id_wallet:{$eq:id_wallet}},{},{},1)
         .then((bills:any)=>{                      
           if(bills.length===0){              
             this.vhMGDB_database.deleteDoc('wallets', id_wallet)
                 .then((bool:any)=>{            
                   resolve(bool);
                 }, error=>{
                   reject(error)
                 })    
           }else resolve(false);
         }, error=>{
           reject(error)
         })             
    })
  }

  /**
   * @example
   * this.vhQuerySales.getWallet('5fb67fda87c0f21d484cbdf3')
            .then((wallet)=>{
              console.log('getWallet', wallet);
            })
   * @param id_wallet 
   * @return Promise => obj ={} or null
   */
  public getWallet(id_wallet:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('wallets', id_wallet)
            .then((wallet)=>{
              resolve(wallet);
            })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getWallets()
            .then((wallets)=>{
              console.log('getWallets', wallets);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getWallets(){
    return new Promise((resolve, reject) => {
      this.wallets = new Array();
      this.vhMGDB_database.getDocs('wallets')
            .then((wallets)=>{
              this.wallets = wallets;
              resolve(wallets);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  private publishObservableEventTaxs() {
    this.subjecttaxs.next(this.taxs);
  }  

  private observableLocalTaxs():Subject<any> {      
    return this.subjecttaxs; 
  }
  
 /**
   * @example:
   * this.observableTaxs = this.vhQuerySales.getObservableLocalTaxs().subscribe((localTaxs:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableTaxs.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalTaxs(){   
   return new Observable((observer:any) => {    
    this.observableLocalTaxs().subscribe((taxs) => {   
      observer.next(taxs);
    })
    this.publishObservableEventTaxs();
   })
  }

  /**
   * @example: 
   * let tax = this.vhQuerySales.getlocalTax('5fb6780ca2148e09806c5b01');
   * @param id_tax 
   * @return Object => obj = {} or null
   */
  public getlocalTax(id_tax:any){
    for(let i=0; i<this.taxs.length; i++){
      if(this.taxs[i]._id === id_tax){
        return this.taxs[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let taxs = this.vhQuerySales.getlocalTaxs(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalTaxs(){    
    return this.taxs;
  }
  
  /**
   * @example:
   * this.vhQuerySales.refreshLocalTaxs()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalTax(), getlocalTaxs() trong localstorage
   * @return Promise => null
   */
  public refreshLocalTaxs():any{
    return new Promise((resolve) => { 
      // this.getTaxs()
      //     .then(()=>{resolve(null)})      
      resolve(null) 
    })
  }
  /**
   * @example:
   * this.vhQuerySales.addTax({name:'camera 2', quantity:20, price:200000})
          .then((tax)=>{
            console.log('addTax', tax);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addTax(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('taxs', data)
          .then((tax)=>{
            resolve(tax);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateTax('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateTax', bool);
          })
   * @param id_tax 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateTax(id_tax:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('taxs', id_tax, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteTax('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteTax', bool);
        })
   * @param id_tax 
   * @return Promise => bool = true or false 
   */
  public deleteTax(id_tax:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('taxs', id_tax)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getTax('5fb67fda87c0f21d484cbdf3')
            .then((tax)=>{
              console.log('getTax', tax);
            })
   * @param id_tax 
   * @return Promise => obj ={} or null
   */
  public getTax(id_tax:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('taxs', id_tax)
            .then((tax)=>{
              resolve(tax);
            })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getTaxs()
            .then((taxs)=>{
              console.log('getTaxs', taxs);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getTaxs(){
    return new Promise((resolve, reject) => {
      this.taxs = new Array();
      this.vhMGDB_database.getDocs('taxs')
            .then((taxs)=>{
              this.taxs = taxs;
              resolve(taxs);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  private publishObservableEventCategorys() {
    this.subjectcategorys.next();
  }  

  private observableLocalCategorys():Subject<any> {      
    return this.subjectcategorys; 
  }
  /**
   * @example:
   * this.observableCategorys = this.vhQuerySales.getObservableLocalCategorys(1).subscribe((localCategorys:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableCategorys.unsubscribe();    
    }
   * @param type = 1 là danh mục sản phẩm, = 2 là danh mục dịch vụ, giá trị khác là cả hai 
   * @returns Observable (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalCategorys(type?:any){   
   return new Observable((observer:any) => {    
    this.observableLocalCategorys().subscribe(() => {   
      observer.next(this.getlocalCategorys(type));
    })
    this.publishObservableEventCategorys();
   })
  }


  /**
   * @example: 
   * let category = this.vhQuerySales.getlocalCategory('5fb6780ca2148e09806c5b01');
   * @param id_category 
   * @return Object => obj = {} or null
   */
  public getlocalCategory(id_category:any){
    for(let i=0; i<this.categorys.length; i++){
      if(this.categorys[i]._id === id_category){
        return {...this.categorys[i]};
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let categorys = this.vhQuerySales.getlocalCategorys(23);
   * @param type = 3 là danh mục sản phẩm, = 2 là danh mục dịch vụ, = 5 là combos, = 23 là sản phẩm và dịch vụ, giá trị khác là cả ba
   * @return Array(object) => array = [{},{},...]
   */  
  public getlocalCategorys(type?:any){     
    let categorys = new Array();
    if((type===1)||(type===3)||(type===5)){
      this.categorys.forEach((element:any) => {
        if(element.type === type) categorys.push({...element});
      });        
    }else if(type===23){
      this.categorys.forEach((element:any) => {
        if((element.type === 2)||(element.type === 3)) categorys.push({...element});
      });        
    }else{
      this.categorys.forEach((element:any) => {
        categorys.push({...element});
      });        
    }
    return categorys;      
  }
  
  /**
   * @example:
   * this.vhQuerySales.refreshLocalCategory()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalCategory(), getlocalCategorys() trong localstorage
   * @return Promise => null
   */
  public refreshLocalCategorys():any{
    return new Promise((resolve) => { 
      // this.getCategorys()
      //     .then(()=>{resolve(null)}) 
      resolve(null)      
    })
  }
  /**
   * @example:
   * this.vhQuerySales.addCategory({name:'Danh mục 1'})
          .then((category)=>{
            console.log('addCategory', category);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addCategory(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('categorys', data)
          .then((category)=>{
            resolve(category);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.addCategorys([{name:'Danh mục 1'},{},...])
          .then((categorys)=>{
            console.log('addCategorys', categorys);
          }, error=>{
            console.log('error', error);
          })
   * @param data : array(object)
   * @return Promise => array = [{},{},...]
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addCategorys(data_array:any){
      return new Promise((resolve, reject) => {
        let promise = new Array();
        for(let i=0; i<data_array.length; i++){         
          promise[i] = new Promise(resolve=>{
            data_array[i].id_branch = this.getDefaultBranch()._id;
            this.vhMGDB_database.addDoc('categorys', data_array[i])
                .then((category)=>{
                  resolve(category);
                }, ()=>{                 
                  resolve(null);
                }) 
          })                       
        }
        Promise.all(promise).then((array:any)=>{
          let _array = array.filter((item:any)=> (item != null))
          resolve(_array);
        })                 
      })
    }

  /**
   * @example:
   * this.vhQuerySales.updateCategory('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateCategory', bool);
          })
   * @param id_category 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateCategory(id_category:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('categorys', id_category, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteCategory('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteCategory', bool);
        })
   * @param id_category 
   * @return Promise => bool = true or false 
   */
  public deleteCategory(id_category:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('products', {id_category:{$eq:id_category}},{},{},1)
          .then((products:any)=>{                      
            if(products.length===0){              
              this.vhMGDB_database.deleteDoc('categorys', id_category)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })    
            }else resolve(false);
          }, error=>{
            reject(error)
          })             
    })
  }

  /**
   * @example
   * this.vhQuerySales.getCategory('5fb67fda87c0f21d484cbdf3')
            .then((category)=>{
              console.log('getCategory', category);
            })
   * @param id_category 
   * @return Promise => obj ={} or null
   */
  public getCategory(id_category:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('categorys', id_category)
            .then((category)=>{
              resolve(category);
            })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getCategorys()
            .then((categorys)=>{
              console.log('getCategorys', categorys);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  private getCategorys(){
    return new Promise((resolve, reject) => {    
      if(this.getBranch_Management_Scope().product_scope){
        this.vhMGDB_database.getDocs('categorys')
            .then((categorys)=>{
              this.categorys = categorys;
              resolve(categorys);
            },(error:any)=>{
              reject(error);
            })          
      }else{
        this.vhMGDB_database.getDocsByFields('categorys', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((categorys)=>{              
              resolve(categorys);
            },(error:any)=>{
              reject(error);
            }) 
      } 
                
    })
  }

  private publishObservableEventInventorytimes() {
    this.subjectinventorytimes.next(this.inventorytimes);
  }  

  private observableLocalInventorytimes():Subject<any> {      
    return this.subjectinventorytimes; 
  }
  
    /**
   * @example:
   * this.observableInventorytime = this.vhQuerySales.getObservableLocalInventorytimes().subscribe((localInventorytimes:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableInventorytime.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalInventorytimes(){   
   return new Observable((observer:any) => {    
    this.observableLocalInventorytimes().subscribe((inventorytimes) => {   
      observer.next(inventorytimes);
    })
    this.publishObservableEventInventorytimes();
   })
  }

  /**
   * @example: 
   * let inventorytime = this.vhQuerySales.getlocalInventorytime('5fb6780ca2148e09806c5b01');
   * @param id_inventorytime 
   * @return Object => obj = {} or null
   */
  public getlocalInventorytime(id_inventorytime:any){
    for(let i=0; i<this.inventorytimes.length; i++){
      if(this.inventorytimes[i]._id === id_inventorytime){
        return this.inventorytimes[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let inventorytimes = this.vhQuerySales.getlocalInventorytimes(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalInventorytimes(){    
    return this.inventorytimes;
  }
  
  /**
   * @example:
   * this.vhQuerySales.refreshLocalTaxs()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalInventorytime(), getlocalInventorytimes() trong localstorage
   * @return Promise => null
   */
  public refreshLocalInventorytimes():any{
    return new Promise((resolve) => { 
      // this.getInventorytimes()
      //     .then(()=>{resolve(null)})   
      resolve(null)    
    })
  }
  /**
   * @example:
   * this.vhQuerySales.addInventorytime({name:'camera 2', quantity:20, price:200000})
          .then((inventorytime)=>{
            console.log('addInventorytime', inventorytime);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addInventorytime(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      data.balanced = false;
      this.vhMGDB_database.addDoc('inventorytimes', data)
          .then((inventorytime)=>{
            resolve(inventorytime);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateInventorytime('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateInventorytime', bool);
          })
   * @param id_inventorytime 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateInventorytime(id_inventorytime:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('inventorytimes', id_inventorytime, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteInventorytime('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteInventorytime', bool);
        })
   * @param id_inventorytime 
   * @return Promise => bool = true or false 
   */
  public deleteInventorytime(id_inventorytime:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('inventorytimes', id_inventorytime)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getInventorytime('5fb67fda87c0f21d484cbdf3')
            .then((inventorytime)=>{
              console.log('getInventorytime', inventorytime);
            })
   * @param id_inventorytime 
   * @return Promise => obj ={} or null
   */
  public getInventorytime(id_inventorytime:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('inventorytimes', id_inventorytime)
            .then((inventorytime)=>{
              resolve(inventorytime);
            })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getInventorytimes()
            .then((inventorytimes)=>{
              console.log('getInventorytimes', inventorytimes);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getInventorytimes(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().product_scope){
        this.vhMGDB_database.getDocs('inventorytimes')
            .then((inventorytimes)=>{
              this.inventorytimes = inventorytimes;
              resolve(inventorytimes);
            },(error:any)=>{
              reject(error);
            })         
      }else{
        this.vhMGDB_database.getDocsByFields('inventorytimes', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((inventorytimes)=>{              
              resolve(inventorytimes);
            },(error:any)=>{
              reject(error);
            }) 
      } 
              
    })
  }

  private publishObservableEventWarrantys() {
    this.subjectwarrantys.next(this.warrantys);
  }  

  private observableLocalWarrantys():Subject<any> {      
    return this.subjectwarrantys; 
  }
  
   /**
   * @example:
   * this.observableWarrantys = this.vhQuerySales.getObservableLocalWarrantys().subscribe((localWarrantys:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableWarrantys.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  private getObservableLocalWarrantys(){   
   return new Observable((observer:any) => {    
    this.observableLocalWarrantys().subscribe((warrantys) => {   
      observer.next(warrantys);
    })
    this.publishObservableEventWarrantys();
   })
  }

  /**
   * @example: 
   * let warranty = this.vhQuerySales.getlocalWarranty('5fb6780ca2148e09806c5b01');
   * @param id_warranty 
   * @return Object => obj = {} or null
   */
  private getlocalWarranty(id_warranty:any){
    for(let i=0; i<this.warrantys.length; i++){
      if(this.warrantys[i]._id === id_warranty){
        return this.warrantys[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let warrantys = this.vhQuerySales.getlocalWarrantys(); 
   * @return Array(object) => array = [{},{},...]
   */
  private getlocalWarrantys(){    
    return this.warrantys;
  }
  
  /**
   * @example:
   * this.vhQuerySales.refreshLocalWarrantys()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalWarranty(), getlocalWarrantys() trong localstorage
   * @return Promise => null
   */
  private refreshLocalWarrantys():any{
    return new Promise((resolve) => { 
      // this.getWarrantys()
      //     .then(()=>{resolve(null)})    
      resolve(null)   
    })
  }
  /**
   * @example:
   * this.vhQuerySales.addWarranty({name:'camera 2', quantity:20, price:200000})
          .then((warranty)=>{
            console.log('addWarranty', warranty);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addWarranty(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('warrantys', data)
          .then((warranty)=>{
            resolve(warranty);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateWarranty('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateWarranty', bool);
          })
   * @param id_warranty 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateWarranty(id_warranty:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('warrantys', id_warranty, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteWarranty('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteWarranty', bool);
        })
   * @param id_warranty 
   * @return Promise => bool = true or false 
   */
  public deleteWarranty(id_warranty:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('warrantys', id_warranty)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getWarranty('5fb67fda87c0f21d484cbdf3')
            .then((warranty)=>{
              console.log('getWarranty', warranty);
            })
   * @param id_warranty 
   * @return Promise => obj ={} or null
   */
  public getWarranty(id_warranty:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('warrantys', id_warranty)
            .then((warranty)=>{
              resolve(warranty);
            })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getWarrantys_byFields({id_bill:{$eq:'49Lsd2SqPGlqUylJATxg'}}, {}, {}, 0)
            .then((warrantys)=>{
              console.log('getWarrantys_byFields', warrantys);
            })
    * @param query 
    * @param projection 
    * @param sort 
    * @param limit 
    * @return Promise => array(object) = [{},{},..]
    */
  public getWarrantys_byFields(query: any, projection?: object, sort?: any, limit?: number){
    return new Promise((resolve, reject) => { 
      if(projection ===undefined) projection = {};
      if(sort ===undefined) sort = {};
      if(limit ===undefined) limit = 0;
      this.vhMGDB_database.getDocsByFields('warrantys', query, projection, sort, limit)
          .then((warrantys)=>{              
            resolve(warrantys);
          },(error:any)=>{
            reject(error);
          })                    
    })
  } 

    
  /**
   * @example
   * this.vhQuerySales.getWarrantys()
            .then((warrantys)=>{
              console.log('getWarrantys', warrantys);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  private getWarrantys(){
    return new Promise((resolve, reject) => {
      this.warrantys = new Array();
      this.vhMGDB_database.getDocs('warrantys')
            .then((warrantys)=>{
              this.warrantys = warrantys;
              resolve(warrantys);
            },(error:any)=>{
              reject(error);
            })          
    })
  }










/**
 * vhQuerySales
 */
  private publishObservableEventCustomerClasss() {
    this.subjectcustomer_classs.next(this.customer_classs);
  }  
/**
 * 
 */
  private observableLocalCustomerClasss():Subject<any> {      
    return this.subjectcustomer_classs; 
  }
  
   /**
   * @example:
   * this.observableCustomerClasss = this.vhQuerySales.getObservableLocalCustomerClasss().subscribe((localCustomer_classs:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableCustomerClasss.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  private getObservableLocalCustomerClasss(){//chưa cần sài đến public   
   return new Observable((observer:any) => {    
    this.observableLocalCustomerClasss().subscribe((customer_classs) => {   
      observer.next(customer_classs);
    })
    this.publishObservableEventCustomerClasss();
   })
  }

  /**
   * @example: 
   * let customer_class = this.vhQuerySales.getlocalCustomerClass('5fb6780ca2148e09806c5b01');
   * @param id_customer_class
   * @return Object => obj = {} or null
   */
  public getlocalCustomerClass(id_customer_class:any){
    for(let i=0; i<this.customer_classs.length; i++){
      if(this.customer_classs[i]._id === id_customer_class){    
        return cloneDeep(this.customer_classs[i]);             
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let customer_classs = this.vhQuerySales.getlocalCustomerClasss(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalCustomerClasss(){      
    return cloneDeep(this.customer_classs);       
  }  

  /**
   * @example:
   * this.vhQuerySales.addCustomerClass({name:'camera 2', quantity:20, price:200000})
          .then((customer_class)=>{
            console.log('addCustomerClass', customer_class);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addCustomerClass(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('customer_classs', data)
          .then((customer_class)=>{
            resolve(customer_class);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateCustomerClass('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateCustomerClass', bool);
          })
   * @param id_customer_class
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateCustomerClass(id_customer_class:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('customer_classs', id_customer_class, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteCustomerClass('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteCustomerClass', bool);
        })
   * @param id_customer_class 
   * @return Promise => bool = true or false 
   */
  public deleteCustomerClass(id_customer_class:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('customers',{id_customer_class:{$eq:id_customer_class}})
          .then((customers:any)=>{       
            for(let i=0; i<customers.length; i++){
              this._updateCustomer(customers[i]._id, {id_customer_class:null});
            }       
            this.vhMGDB_database.deleteDoc('customer_classs', id_customer_class)
                .then((bool:any)=>{            
                  resolve(bool);
                }, error=>{
                  reject(error)
                })  
          },(error:any)=>{
            reject(error);
          })     
               
    })
  }

/**
 * vhQuerySales
 */
  private publishObservableEventDiscount_bills() {
    this.subjectdiscount_bills.next(this.discount_bills);
  }  
/**
 * vhQuerySales
 */
  private observableLocalDiscount_bills():Subject<any> {      
    return this.subjectdiscount_bills; 
  }
  
   /**
   * @example:
   * this.observableDiscount_bills = this.vhQuerySales.getObservableLocalDiscount_bills().subscribe((localDiscount_bills:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableDiscount_bills.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  private getObservableLocalDiscount_bills(){//chưa cần sài đến public   
   return new Observable((observer:any) => {    
    this.observableLocalDiscount_bills().subscribe((discount_bills) => {   
      observer.next(discount_bills);
    })
    this.publishObservableEventDiscount_bills();
   })
  }

  /**
   * @example: 
   * let discount_bill = this.vhQuerySales.getlocalDiscount_bill('5fb6780ca2148e09806c5b01');
   * @param id_discount_bill
   * @return Object => obj = {} or null
   */
  public getlocalDiscount_bill(id_discount_bill:any){
    for(let i=0; i<this.discount_bills.length; i++){
      if(this.discount_bills[i]._id === id_discount_bill){    
        return cloneDeep(this.discount_bills[i]);             
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let discount_bills = this.vhQuerySales.getlocalDiscount_bills(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalDiscount_bills(){      
    return cloneDeep(this.discount_bills);       
  }  

  /**
   * @example:
   * this.vhQuerySales.addDiscount_bill({name:'camera 2', quantity:20, price:200000})
          .then((discount_bill)=>{
            console.log('addDiscount_bill', discount_bill);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addDiscount_bill(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('discount_bills', data)
          .then((discount_bill)=>{
            resolve(discount_bill);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateDiscount_bill('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateDiscount_bill', bool);
          })
   * @param id_discount_bill
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateDiscount_bill(id_discount_bill:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('discount_bills', id_discount_bill, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteDiscount_bill('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteDiscount_bill', bool);
        })
   * @param id_discount_bill 
   * @return Promise => bool = true or false 
   */
  public deleteDiscount_bill(id_discount_bill:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('discount_bills', id_discount_bill)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }




  /**
   * @example:
   * this.vhQuerySales.addDiscount_sales({name:'camera 2', quantity:20, price:200000})
          .then((discount_saless)=>{
            console.log('addDiscount_sales', discount_sales);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addDiscount_sales(data:any){
      return new Promise((resolve, reject) => {
        data.id_branch = this.getDefaultBranch()._id;
        this.vhMGDB_database.addDoc('discount_saless', data)
            .then((discount_sales)=>{
              resolve(discount_sales);
            },(error:any)=>{
              reject(error);
            })         
      })
    }
  
    /**
     * @example:
     * this.vhQuerySales.updateDiscount_sales('5fb6780ca2148e09806c5b01', {quantity:400})
            .then((bool:any)=>{
              console.log('updateDiscount_sales', bool);
            })
      * @param id_discount_sales
      * @param data 
      * @return Promise => bool = true or false 
      */
    public updateDiscount_sales(id_discount_sales:string, data:object){
      return new Promise((resolve,reject) => {
        this.vhMGDB_database.updateDoc('discount_saless', id_discount_sales, data)
            .then((bool:any)=>{
              resolve(bool);
            }, error=>{
              reject(error)
            })          
      })
    }
  
    /**
     * @example:
     * this.vhQuerySales.deleteDiscount_sales('5fb67fda87c0f21d484cbdf3')
          .then((bool:any)=>{
            console.log('deleteDiscount_sales', bool);
          })
      * @param id_discount_sales
      * @return Promise => bool = true or false 
      */
    public deleteDiscount_sales(id_discount_sales:string){
      return new Promise((resolve, reject) => {
        this.vhMGDB_database.deleteDoc('discount_saless', id_discount_sales)
            .then((bool:any)=>{            
              resolve(bool);
            }, error=>{
              reject(error)
            })          
      })
    }
  
    /**
     * @example
     * this.vhQuerySales.getDiscount_sales('5fb67fda87c0f21d484cbdf3')
              .then((discount_sales)=>{
                console.log('getDiscount_sales', discount_sales);
              })
      * @param id_discount_sales
      * @return Promise => obj ={} or null
      */
    public getDiscount_sales(id_discount_sales:string){
      return new Promise((resolve) => {
        this.vhMGDB_database.getDoc('discount_saless', id_discount_sales)
              .then((discount_sales)=>{
                resolve(discount_sales);
              })          
      })
    }
  
    /**
     * @example
     * this.vhQuerySales.getDiscount_saless()
              .then((discount_saless)=>{
                console.log('getDiscount_saless', discount_saless);
              })
      * @return Promise => array(object) = [{},{},..]
      */
    public getDiscount_saless(){
      return new Promise((resolve, reject) => {
        if(this.getBranch_Management_Scope().sales_program_scope){
          this.vhMGDB_database.getDocs('discount_saless')
              .then((discount_saless)=>{
                this.discount_saless = discount_saless;
                resolve(discount_saless);
              },(error:any)=>{
                reject(error);
              })          
        }else{
          this.vhMGDB_database.getDocsByFields('discount_saless', {id_branch:{$eq: this.getDefaultBranch()._id}})
              .then((discount_saless)=>{              
                resolve(discount_saless);
              },(error:any)=>{
                reject(error);
              }) 
        }                  
      })
    }


    /**
   * @example:
   * this.vhQuerySales.addCommission({name:'camera 2', quantity:20, price:200000})
          .then((commissions)=>{
            console.log('addCommission', commissions);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addCommission(data:any){
      return new Promise((resolve, reject) => {
        data.id_branch = this.getDefaultBranch()._id;
        this.vhMGDB_database.addDoc('commissions', data)
            .then((commission)=>{
              resolve(commission);
            },(error:any)=>{
              reject(error);
            })         
      })
    }
  
    /**
     * @example:
     * this.vhQuerySales.updateCommission('5fb6780ca2148e09806c5b01', {quantity:400})
            .then((bool:any)=>{
              console.log('updateCommission', bool);
            })
      * @param id_commission
      * @param data 
      * @return Promise => bool = true or false 
      */
    public updateCommission(id_commission:string, data:object){
      return new Promise((resolve,reject) => {
        this.vhMGDB_database.updateDoc('commissions', id_commission, data)
            .then((bool:any)=>{
              resolve(bool);
            }, error=>{
              reject(error)
            })          
      })
    }
  
    /**
     * @example:
     * this.vhQuerySales.deleteCommission('5fb67fda87c0f21d484cbdf3')
          .then((bool:any)=>{
            console.log('deleteCommission', bool);
          })
      * @param id_commission 
      * @return Promise => bool = true or false 
      */
    public deleteCommission(id_commission:string){
      return new Promise((resolve, reject) => {
        this.vhMGDB_database.deleteDoc('commissions', id_commission)
            .then((bool:any)=>{            
              resolve(bool);
            }, error=>{
              reject(error)
            })          
      })
    }
  
    /**
     * @example
     * this.vhQuerySales.getCommission('5fb67fda87c0f21d484cbdf3')
              .then((commission)=>{
                console.log('getCommission', commission);
              })
      * @param id_commission
      * @return Promise => obj ={} or null
      */
    public getCommission(id_commission:string){
      return new Promise((resolve) => {
        this.vhMGDB_database.getDoc('commissions', id_commission)
              .then((commission)=>{
                resolve(commission);
              })          
      })
    }
  
    /**
     * @example
     * this.vhQuerySales.getCommissions()
              .then((commissions)=>{
                console.log('getCommissions', commissions);
              })
      * @return Promise => array(object) = [{},{},..]
      */
    public getCommissions(){
      return new Promise((resolve, reject) => {
        if(this.getBranch_Management_Scope().sales_program_scope){
          this.vhMGDB_database.getDocs('commissions')
              .then((commissions)=>{
                this.commissions = commissions;
                resolve(commissions);
              },(error:any)=>{
                reject(error);
              })           
        }else{
          this.vhMGDB_database.getDocsByFields('commissions', {id_branch:{$eq: this.getDefaultBranch()._id}})
              .then((commissions)=>{              
                resolve(commissions);
              },(error:any)=>{
                reject(error);
              }) 
        }                
      })
    }

  /**
   * @example: 
   * let delivery = this.vhQuerySales.getlocalDelivery('5fb6780ca2148e09806c5b01');
   * @param id_delivery 
   * @return Object => obj = {} or null
   */
  public getlocalDelivery(id_delivery:any){
    for(let i=0; i<this.deliverys.length; i++){
      if(this.deliverys[i]._id === id_delivery){
        return this.deliverys[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let deliverys = this.vhQuerySales.getlocalDeliverys(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalDeliverys(){    
    return this.deliverys;
  }
  
  /**
   * @example:
   * this.vhQuerySales.refreshLocalDeliverys()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalDelivery(), getlocalDeliverys() trong localstorage
   * @return Promise => null
   */
  public refreshLocalDeliverys():any{
    return new Promise((resolve) => { 
      this.getDeliverys()
          .then(()=>{resolve(null)})       
    })
  }
  /**
   * @example:
   * this.vhQuerySales.addDelivery({name:'camera 2', quantity:20, price:200000})
          .then((delivery)=>{
            console.log('addDelivery', delivery);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addDelivery(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('deliverys', data)
          .then((delivery)=>{
            resolve(delivery);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateDelivery('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateDelivery', bool);
          })
   * @param id_delivery 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateDelivery(id_delivery:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('deliverys', id_delivery, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteDelivery('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteDelivery', bool);
        })
   * @param id_delivery 
   * @return Promise => bool = true or false 
   */
  public deleteDelivery(id_delivery:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('deliverys', id_delivery)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getDelivery('5fb67fda87c0f21d484cbdf3')
            .then((delivery)=>{
              console.log('getDelivery', delivery);
            })
   * @param id_delivery 
   * @return Promise => obj ={} or null
   */
  public getDelivery(id_delivery:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('deliverys', id_delivery)
            .then((delivery)=>{
              resolve(delivery);
            })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getDeliverys()
            .then((deliverys)=>{
              console.log('getDeliverys', deliverys);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getDeliverys(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('deliverys')
            .then((deliverys)=>{
              this.deliverys = deliverys;
              resolve(deliverys);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  
  /**
   * @example:
   * this.vhQuerySales.addAdss({name:name: 'Quảng cáo 1'})
          .then((ads)=>{
            console.log('addAdss', ads);
          }, error=>{
            console.log('error', error);
          })
   * @param data 
   * @return Promise => object = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addAdss(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('adss', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateAds('5fb6780ca2148e09806c5b01', {name: 'Quảng cáo 1'})
          .then((bool:any)=>{
            console.log('updateAds', bool);
          }, error=>{
            console.log('error', error);
          })
    * @param id_ads 
    * @param data 
    * @return Promise => bool = true or false
    */
  public updateAds(id_ads:string, data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.updateDoc('adss', id_ads, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteAds('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteAds', bool);
        }, error=>{
          reject(error)
        })
    * @param id_ads 
    * @return Promise => bool = true or false
    */
  public deleteAds(id_ads:string){   
    return new Promise((resolve, reject) => {                 
        this.vhMGDB_database.deleteDoc('adss', id_ads)
            .then((bool:any)=>{            
              resolve(bool);
            }, error=>{
              reject(error)
            })    
                    
    })
  }

  /**
   * @example
   * this.vhQuerySales.getAds('5fb67fda87c0f21d484cbdf3')
            .then((ads)=>{
              console.log('getAds', ads);
            })
    * @param id_ads 
    * @return false or object
    */
  public getAds(id_ads:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('adss', id_ads)
            .then((ads)=>{
              resolve(ads);
            })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getAdss()
          .then((adss)=>{
            console.log('getAdss', adss);
          })
    * @return array(object) = [{},{},..]
    */
  public getAdss(){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDocs('adss')
            .then((adss)=>{                
              resolve(adss);
            })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getAdss_byFields({quantity:{$gte:10}}, {}, {}, 0)
            .then((adss)=>{
              console.log('getAdss_byFields', adss);
            })
    * @param query 
    * @param projection 
    * @param sort 
    * @param limit 
    * @return Promise => array(object) = [{},{},..]
    */
  public getAdss_byFields(query: any, projection?: object, sort?: any, limit?: number){
    return new Promise((resolve, reject) => { 
      if(projection ===undefined) projection = {};
      if(sort ===undefined) sort = {};
      if(limit ===undefined) limit = 0;
      this.vhMGDB_database.getDocsByFields('adss', query, projection, sort, limit)
          .then((adss)=>{              
            resolve(adss);
          },(error:any)=>{
            reject(error);
          })                    
    })
  } 

  /**
   * @example: 
   * let address = this.vhQuerySales.getlocalAddress('5fb6780ca2148e09806c5b01');
   * @param id_address 
   * @return Object => obj = {} or null
   */
  public getlocalAddress(id_address:any){
    for(let i=0; i<this.addresss.length; i++){
      if(this.addresss[i]._id === id_address){
        return this.addresss[i];
        break;
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let addresss = this.vhQuerySales.getlocalAddresss(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalAddresss(){    
    return this.addresss;
  } 
  
  /**
   * @example:
   * this.vhQuerySales.refreshLocalAddresss()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalAddress(), getlocalAddresss() trong localstorage
   * @return Promise => null
   */
  public refreshLocalAddresss():any{
    return new Promise((resolve) => { 
      this.getAddresss()
          .then(()=>{resolve(null)})       
    })
  }
  /**
   * @example:
   * this.vhQuerySales.addAddress({name:'camera 2', quantity:20, price:200000})
          .then((address)=>{
            console.log('addAddress', address);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addAddress(data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('addresss', data)
          .then((address)=>{
            resolve(address);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateAddress('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateAddress', bool);
          })
   * @param id_address 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateAddress(id_address:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('addresss', id_address, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteAddress('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteAddress', bool);
        })
   * @param id_address 
   * @return Promise => bool = true or false 
   */
  public deleteAddress(id_address:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('addresss', id_address)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getAddress('5fb67fda87c0f21d484cbdf3')
            .then((address)=>{
              console.log('getAddress', address);
            })
   * @param id_address 
   * @return Promise => obj ={} or null
   */
  public getAddress(id_address:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('addresss', id_address)
            .then((address)=>{
              resolve(address);
            })          
    })
  }

  /**
   * @example:
   * let ahamoveURL = this.vhQuerySales.getShippingAhamoveURL();
   * @returns String
   */
  public getShippingAhamoveURL(){
    return this.vhMGDB_auth.getShippingCloudURL() + 'ahamove';
  }

   /**
   * @example:
   * let ghtkURL = this.vhQuerySales.getShippingGHTKURL();
   * @returns String
   */
  public getShippingGHTKURL(){
    return this.vhMGDB_auth.getShippingCloudURL() + 'ghtk';
  }

  /**
   * @example
   * this.vhQuerySales.getAddresss()
            .then((addresss)=>{
              console.log('getAddresss', addresss);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getAddresss(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('addresss')
            .then((addresss)=>{
              this.addresss = addresss;
              resolve(addresss);
            },(error:any)=>{
              reject(error);
            })          
    })
  } 

  /**
   * @example: 
   * let incoming_group = this.vhQuerySales.getlocalIncoming_group('5fb6780ca2148e09806c5b01');
   * @param id_incoming_group
   * @return Object => obj = {} or null
   */
   public getlocalIncoming_group(id_incoming_group:any){
    for(let i=0; i<this.incoming_groups.length; i++){
      if(this.incoming_groups[i]._id === id_incoming_group){
        return {...this.incoming_groups[i]};
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let incoming_groups = this.vhQuerySales.getlocalIncoming_groups(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalIncoming_groups(){    
    return [...this.incoming_groups];
  } 
  
  /**
   * @example:
   * this.vhQuerySales.refreshLocalIncoming_groups()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalIncoming_group(), getlocalIncoming_groups() trong localstorage
   * @return Promise => null
   */
  public refreshLocalIncoming_groups():any{
    return new Promise((resolve) => { 
      this.getIncoming_groups()
          .then(()=>{resolve(null)})       
    })
  }
  /**
   * Tạo thêm nhóm thu khác
   * @example:
   * this.vhQuerySales.addIncoming_group({name:'camera 2', quantity:20, price:200000})
          .then((incoming_group)=>{
            console.log('addIncoming_group', incoming_group);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addIncoming_group(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('incoming_groups', data)
          .then((incoming_group)=>{
            resolve(incoming_group);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateIncoming_group('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateIncoming_group', bool);
          })
   * @param id_incoming_group 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateIncoming_group(id_incoming_group:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('incoming_groups', id_incoming_group, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteIncoming_group('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteIncoming_group', bool);
        })
   * @param id_incoming_group 
   * @return Promise => bool = true or false 
   */
  public deleteIncoming_group(id_incoming_group:string){
    return new Promise((resolve, reject) => {
     this.getBills_byFields({id_incoming_group:{$eq:id_incoming_group}},{},{},1)      
         .then((bills:any)=>{                      
           if(bills.length===0){
             this.vhMGDB_database.deleteDoc('incoming_groups', id_incoming_group)
                 .then((bool:any)=>{            
                   resolve(bool);
                 }, error=>{
                   reject(error)
                 }) 
           }else resolve(false);
         }, error=>{
           reject(error)
         })                 
    })  
  }

  /**
   * @example
   * this.vhQuerySales.getIncoming_groups()
            .then((incoming_groups)=>{
              console.log('getIncoming_groups', incoming_groups);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getIncoming_groups(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('incoming_groups')
            .then((incoming_groups)=>{
              this.incoming_groups = incoming_groups;             
              this.incoming_groups = this.vhAlgorithm.sortVietnamesebyASC(this.incoming_groups, 'name');                
              resolve(this.incoming_groups);
            },(error:any)=>{
              reject(error);
            })          
    })
  }
  
  /**
   * @example: 
   * let spending_group = this.vhQuerySales.getlocalSpending_group('5fb6780ca2148e09806c5b01');
   * @param id_spending_group 
   * @return Object => obj = {} or null
   */
   public getlocalSpending_group(id_spending_group:any){
    for(let i=0; i<this.spending_groups.length; i++){
      if(this.spending_groups[i]._id === id_spending_group){
        return {...this.spending_groups[i]};
      }
    } 
    return null; 
  }
  /**
   * @example: 
   * let spending_groups = this.vhQuerySales.getlocalSpending_groups(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalSpending_groups(){    
    return [...this.spending_groups];
  } 
  
  /**
   * @example:
   * this.vhQuerySales.refreshLocalSpending_groups()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm refreshLocalSpending_group(), refreshLocalSpending_groups() trong localstorage
   * @return Promise => null
   */
  public refreshLocalSpending_groups():any{
    return new Promise((resolve) => { 
      this.getSpending_groups()
          .then(()=>{resolve(null)})       
    })
  }
  /**
   * Tạo thêm nhóm chi khác
   * @example:
   * this.vhQuerySales.addSpending_group({name:'camera 2', quantity:20, price:200000})
          .then((spending_groups)=>{
            console.log('addSpending_group', spending_groups);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addSpending_group(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('spending_groups', data)
          .then((spending_group)=>{
            resolve(spending_group);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updateSpending_group('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateSpending_group', bool);
          })
   * @param id_spending_group 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateSpending_group(id_spending_group:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('spending_groups', id_spending_group, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteSpending_group('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteSpending_group', bool);
        })
   * @param id_spending_group 
   * @return Promise => bool = true or false 
   */
  public deleteSpending_group(id_spending_group:string){
    return new Promise((resolve, reject) => {
     this.getBills_byFields({id_spending_group:{$eq:id_spending_group}},{},{},1)
         .then((bills:any)=>{                      
           if(bills.length===0){
             this.vhMGDB_database.deleteDoc('spending_groups', id_spending_group)
                 .then((bool:any)=>{            
                   resolve(bool);
                 }, error=>{
                   reject(error)
                 }) 
           }else resolve(false);
         }, error=>{
           reject(error)
         })                 
    })  
  }

  /**
   * @example
   * this.vhQuerySales.getSpending_groups()
            .then((spending_groups)=>{
              console.log('getSpending_groups', spending_groups);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getSpending_groups(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('spending_groups')
            .then((spending_groups)=>{
              this.spending_groups = spending_groups;             
              this.spending_groups = this.vhAlgorithm.sortVietnamesebyASC(this.spending_groups, 'name');                
              resolve(this.spending_groups);
            },(error:any)=>{
              reject(error);
            })          
    })
  } 


/**
 * @example:
 * this.vhQuerySales.updateDebtAtBeginningCustomer('5fb6780ca2148e09806c5b01', '56345gy34t12tf12', 2000000)
        .then((bool:any)=>{
          console.log('updateDebtAtBeginningCustomer', bool);
        })
  * @param id_customer 
  * @param id_branch 
  * @param debt_beginning 
  * @return Promise => bool = true or false 
  */
  public updateDebtAtBeginningCustomer(id_customer:string, id_branch:string, debt_beginning:number){
    return new Promise((resolve, reject) => {
      let customer = this.getlocalCustomer(id_customer);
      let value:any = {};
      if(customer[id_branch] != undefined){        
        value[id_branch] = customer[id_branch];       
      }else{ 
        value[id_branch] = {};        
      }
      value[id_branch].debt_beginning = debt_beginning;     
      this._updateCustomer(id_customer, {...value})
            .then((bool:any)=>{
              resolve(bool);
            },(error:any)=>{             
              reject(error);
            })  
    })
  }

/**
 * @example
 * this.vhQuerySales.getDebtAtBeginningCustomers_byIDcustomer()
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningCustomers_byIDcustomer', debtatbeginnings);
          })
  * @param id_customer 
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningCustomers_byIDcustomer(id_customer:string){
    return new Promise((resolve, reject) => {     
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_customers', {id_customer:{$eq:id_customer}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }

/**
 * @example
 * this.vhQuerySales.getDebtAtBeginningCustomers_byIDbranch()
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningCustomers_byIDbranch', debtatbeginnings);
          })
  * @param id_customer 
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningCustomers_byIDbranch(id_branch:string){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_customers', {id_branch:{$eq:id_branch}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }

  /**
 * @example
 * this.vhQuerySales.getDebtAtBeginningCustomers_byIDcustomer_byIDbranch('3546235ytrhdghyw465', 'i5455234trgxi8675eg')
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningCustomers_byIDcustomer_byIDbranch', debtatbeginnings);
          })
  * @param id_customer 
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningCustomers_byIDcustomer_byIDbranch(id_customer:string, id_branch:string){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_customers', {id_customer:{$eq:id_customer}, id_branch:{$eq:id_branch}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }

/**
 * Hàm lấy về những khách hàng có công nợ đầu kỳ
 * @example
 * this.vhQuerySales.getDebtAtBeginningCustomers()
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningCustomers', debtatbeginnings);
          })
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningCustomers(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().customer_scope){
        this.vhMGDB_database.getDocs('debt_at_beginning_customers')
            .then((debtatbeginnings)=>{                
              resolve(debtatbeginnings);
            },(error:any)=>{
              reject(error);
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('debt_at_beginning_customers', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((debt_at_beginning_customers)=>{              
              resolve(debt_at_beginning_customers);
            },(error:any)=>{
              reject(error);
            }) 
      } 
              
    })
  }

  /**
 * @example:
 * this.vhQuerySales.updateDebtAtBeginningSupplier('5fb6780ca2148e09806c5b01', '56345gy34t12tf12', 2000000)
        .then((bool:any)=>{
          console.log('updateDebtAtBeginningSupplier', bool);
        })
  * @param id_supplier 
  * @param id_branch 
  * @param debt_beginning 
  * @return Promise => bool = true or false 
  */
  public updateDebtAtBeginningSupplier(id_supplier:string, id_branch:string, debt_beginning:number){
    return new Promise((resolve, reject) => {
      let supplier = this.getlocalSupplier(id_supplier);
      let value:any = {};
      if(supplier[id_branch] != undefined){        
        value[id_branch] = supplier[id_branch];       
      }else{ 
        value[id_branch] = {};        
      }
      value[id_branch].debt_beginning = debt_beginning;     
      this._updateSupplier( id_supplier, {...value})
            .then((bool:any)=>{
              resolve(bool);
            },(error:any)=>{             
              reject(error);
            })  
    })
  }

/**
 * @example
 * this.vhQuerySales.getDebtAtBeginningSuppliers_byIDsupplier()
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningSuppliers_byIDsupplier', debtatbeginnings);
          })
  * @param id_supplier 
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningSuppliers_byIDsupplier(id_supplier:string){
    return new Promise((resolve, reject) => {     
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_suppliers', {id_supplier:{$eq:id_supplier}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }

/**
 * @example
 * this.vhQuerySales.getDebtAtBeginningSuppliers_byIDbranch('sdafsdfaw564655ybr')
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningSuppliers_byIDbranch', debtatbeginnings);
          })
  * @param id_branch         
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningSuppliers_byIDbranch(id_branch:string){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_suppliers', {id_branch:{$eq:id_branch}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }

  /**
 * @example
 * this.vhQuerySales.getDebtAtBeginningSuppliers_byIDsupplier_byIDbranch('4ye5r6tyhdfdfaenm', '576dfgbdshdmiret3')
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningSuppliers_byIDsupplier_byIDbranch', debtatbeginnings);
          })
  * @param id_supplier         
  * @param id_branch         
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningSuppliers_byIDsupplier_byIDbranch(id_supplier:string, id_branch:string){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocsByFields('debt_at_beginning_suppliers', {id_supplier:{$eq:id_supplier}, id_branch:{$eq:id_branch}}, {})
          .then((debtatbeginnings)=>{
            resolve(debtatbeginnings);
          })
          .catch((e)=>{
            reject(e);
          })            
    })
  }

  /**
 * @example
 * this.vhQuerySales.getDebtAtBeginningSuppliers()
          .then((debtatbeginnings)=>{
            console.log('getDebtAtBeginningSuppliers', debtatbeginnings);
          })
  * @return Promise => array(object) = [{},{},..]
  */
  private getDebtAtBeginningSuppliers(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().supplier_scope){
        this.vhMGDB_database.getDocs('debt_at_beginning_suppliers')
            .then((debtatbeginnings)=>{                
              resolve(debtatbeginnings);
            },(error:any)=>{
              reject(error);
            })           
      }else{
        this.vhMGDB_database.getDocsByFields('debt_at_beginning_suppliers', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((debt_at_beginning_suppliers)=>{              
              resolve(debt_at_beginning_suppliers);
            },(error:any)=>{
              reject(error);
            }) 
      } 
               
    })
  }
  
  public setDefaultBranch(id_branch:any){      
    for(let i=0; i<this.branchs.length; i++){
      if(this.branchs[i]._id === id_branch){                      
        localStorage.setItem(this.vhMGDB_auth.getProjectName() + '_default_branch', JSON.stringify(this.branchs[i]));            
        break;
      }
    }     
  }  
  
  public getDefaultBranch():any{        
  //  if(this.branchs.length == 0) return null;  
    if(localStorage.getItem(this.vhMGDB_auth.getProjectName() + '_default_branch')){
      return JSON.parse(<any>localStorage.getItem(this.vhMGDB_auth.getProjectName() + '_default_branch'));
    }else{
      return null;
    }
  }

  public clearDefaultBranch(){   
    localStorage.setItem(this.vhMGDB_auth.getProjectName() + '_default_branch', <any>null);        
  }  

  public isChains(){
    if(this.branchs.length == 0) return null;
    else if(this.branchs.length == 1) return false;
    else return true;
  }

  private publishObservableEventBranchs() {
    this.subjectbranchs.next(this.branchs);
  }  

  private observableLocalBranchs():Subject<any> {      
    return this.subjectbranchs; 
  }
  
  /**
   * @example:
   * this.observableBranch = this.vhQuerySales.getObservableLocalBranchs().subscribe((localBranchs:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observableBranch.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalBranchs(){   
   return new Observable((observer:any) => {    
    this.observableLocalBranchs().subscribe((branchs) => {   
      observer.next(branchs);
    })
    this.publishObservableEventBranchs();
   })
  }

  /**
   * @example: 
   * let branch = this.vhQuerySales.getlocalBranch('5fb6780ca2148e09806c5b01');
   * @param id_branch 
   * @return Object => obj = {} or null
   */
  public getlocalBranch(id_branch:any){
    for(let i=0; i<this.branchs.length; i++){
      if(this.branchs[i]._id === id_branch){
        return this.branchs[i];       
      }
    } 
    return null;        
  }
  /**
   * @example: 
   * let branchs = this.vhQuerySales.getlocalBranchs(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalBranchs(){    
    let branchs = new Array();
    this.branchs.forEach((element:any) => {
      branchs.push({...element});
    });        
    return branchs; 
  } 
  
  /**
   * @example:
   * this.vhQuerySales.refreshLocalBranchs()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalBranch(), getlocalBranchs() trong localstorage
   * @return Promise => null
   */
  public refreshLocalBranchs():any{
    return new Promise((resolve) => { 
      this.getBranchs()
           .then(()=>{resolve(null)})       
      //resolve(null)
    })
  }
  /**
   * @example:
   * this.vhQuerySales.addBranch({name:'Chi nhánh 2'})
          .then((branch)=>{
            console.log('addBranch', branch);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addBranch(data:any){
      return new Promise((resolve, reject) => {
       if(!this.vhAuth.getStore().isDeveloper) {
         console.log('Vui lòng liên hệ A Huy để tạo chi nhánh mới');
         return reject({error:'Vui lòng liên hệ A Huy để tạo chi nhánh mới'});
       }
        this.vhMGDB_auth.getServerDate()
          .then((serverdate:any)=>{           
            let database = this.vhMGDB_auth.getDatabase();
            data.activate = true;
            this.vhMGDB_database.addDoc('branchs', data)
                .then((branch:any)=>{   
                    let promise_zero = new Array();    
                    let products = this.getlocalDetailProducts(3);

                    let obj = {...branch, opentime:'8h:00 AM', closetime:'10h:00 PM', img:'', tax_number:''};              
                    obj.appsetting_name = 'store_info';
                    obj.id_branch = branch._id;     
                    delete obj._id;

                    promise_zero[promise_zero.length] = this.vhMGDB_database.addDoc('appsettingbranchs',obj);                   
                    //Phần từ đây xuống dưới, update ở fronend đỡ, vài bữa giao cho server làm, vì số lượng sản phẩm nhiều, sợ frontend chạy ko nỗi
                    for(let i=0; i<products.length; i++){
                      let data_branch:any = {};
                      data_branch[branch._id + '_ivtr'] = null;

                      let quantity_branch:any = {};   
                      quantity_branch = {...products[i].quantity_branch};
                      quantity_branch[branch._id] = 0;
                    
                      if(products[i].lots){
                        let lots = cloneDeep(products[i].lots);
                        for(let m=0; m<products[i].lots.length; m++){  
                          lots[m].quantity_branch[branch._id] = 0;                                 
                        }  
                        promise_zero[promise_zero.length] = this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {quantity_branch, ...data_branch, lots})
                        //promise_zero[promise_zero.length] = this.updateProduct_fw(products[i]._id, {quantity_branch, ...data_branch, lots});      
                      }else{
                        promise_zero[promise_zero.length] = this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {quantity_branch, ...data_branch})
                        //promise_zero[promise_zero.length] = this.updateProduct_fw(products[i]._id, {quantity_branch, ...data_branch});     
                      }       
                    }
                    let main_id_branch = this.getDefaultBranch()._id;
                    let value_store:any = {};
                    value_store[branch._id] = cloneDeep(this.vhAuth.getStore()[main_id_branch]);
                    let expire_date =  new Date(serverdate);
                    expire_date.setDate(expire_date.getDate() + 1);                                                                                                                                                                              
                    value_store[branch._id]['main_package_expire']['expire_date'] = expire_date;  
                    
                    promise_zero[promise_zero.length] =  this.vhMGDB_rootdatabase.updateDoc('stores', database, {...value_store});
                    Promise.all(promise_zero)
                        .then(()=>{         
                            this.branchs.push(branch);   
                            this.publishObservableEventBranchs();                                                                                            
                            resolve(branch);
                          }).
                          catch((e)=>{
                            reject(e);     
                          })                        
                },(error:any)=>{
                  reject(error);
                })     
          }).
          catch((e)=>{
            reject(e);     
          })             
      })
    }   
  /**
   * @example:
   * this.vhQuerySales.updateBranch('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updateBranch', bool);
          })
   * @param id_branch 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updateBranch(id_branch:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('branchs', id_branch, data)
          .then((bool:any)=>{
             if(bool){
               for(let i=0; i<this.branchs.length; i++){
                 if(this.branchs[i]._id === id_branch){
                   this.branchs[i] = {...this.branchs[i],...data};
                   break;
                 }
               } 
             }
             resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteBranch('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteBranch', bool);
        })
   * @param id_branch 
   * @return Promise => bool = true or false 
   */
  public deleteBranch(id_branch:string){
    return new Promise((resolve, reject) => {
       let promise = new Array();
       promise[0] = this.vhMGDB_database.getDocsByFields('wallets', {id_branch:{$eq:id_branch}},{},{},1);
       promise[1] = this.getBills_byFields({id_branch:{$eq:id_branch}},{},{},1)
       promise[2] = this.getBills_byFields({id_branch_receive:{$eq:id_branch}},{},{},1)
       Promise.all(promise)
            .then((array:any)=>{                      
              if((array[0].length===0)&&(array[1].length===0)&&(array[2].length===0)){              
                this.vhMGDB_database.deleteDoc('branchs', id_branch)
                    .then((bool:any)=>{            
                      resolve(bool);
                    }, error=>{
                      reject(error)
                    })    
              }else resolve(false);
            }, error=>{
              reject(error)
            })             
      })   
  }

  /**
   * @example
   * this.vhQuerySales.getBranch('5fb67fda87c0f21d484cbdf3')
            .then((branch)=>{
              console.log('getBranch', branch);
            })
   * @param id_branch 
   * @return Promise => obj ={} or null
   */
  private getBranch(id_branch:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('branchs', id_branch)
            .then((branch)=>{
              resolve(branch);
            })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getBranchs()
            .then((branchs)=>{
              console.log('getBranchs', branchs);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  private getBranchs(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('branchs')
            .then((branchs)=>{
              this.branchs = branchs;
              resolve(branchs);
            },(error:any)=>{
              reject(error);
            })          
    })
  }

  private publishObservableEventPrinters() {
    this.subjectprinters.next(this.printers);
  }  

  private observableLocalPrinters():Subject<any> {      
    return this.subjectprinters; 
  }
  
   /**
   * @example:
   * this.observablePrinter = this.vhQuerySales.getObservableLocalPrinters().subscribe((localPrinters:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observablePrinter.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalPrinters(){   
   return new Observable((observer:any) => {    
    this.observableLocalPrinters().subscribe((printers) => {   
      observer.next(printers);
    })
    this.publishObservableEventPrinters();
   })
  }  

/**
   * @example: 
   * let printer = this.vhQuerySales.getlocalPrinter('5fb6780ca2148e09806c5b01');
   * @param id_printer 
   * @return Object => obj = {} or null
   */
  public getlocalPrinter(id_printer:any){
    for(let i=0; i<this.printers.length; i++){
      if(this.printers[i]._id === id_printer){
        return this.printers[i];
        break;
      }
    }
    return null; 
  }
  /**
   * @example
   * let printers = this.vhQuerySales.getlocalPrinters(); 
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalPrinters(){    
    return this.printers;
  }

   /**
   * @example:
   * this.vhQuerySales.refreshLocalPrinters()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalPrinter(), getlocalPrinters() trong localstorage
   * @return Promise => null
   */
  public refreshLocalPrinters():any{
    return new Promise((resolve, reject) => { 
      // this.getPrinters()
      //     .then(()=>{resolve(null)})       
      resolve(null)
    })
  }
  /**
   * @example:
   * this.vhQuerySales.addPrinter({name:'camera 2', quantity:20, price:200000})
          .then((printer)=>{
            console.log('addPrinter', printer);
          }, error=>{
            console.log('error', error);
          })
   * @param data 
   * Promise => object = {} Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addPrinter(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      let obj:any = {...data};
      obj.uuid = this.hwinfo.uuid;
      this.vhMGDB_database.addDoc('printers', obj)
          .then((printer)=>{
            resolve(printer);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updatePrinter('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updatePrinter', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_printer 
   * @param data 
   * @return Promise => bool = true or false
   */
  public updatePrinter(id_printer:string, data:object){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.updateDoc('printers', id_printer, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deletePrinter('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deletePrinter', bool);
        })
   * @param id_printer 
   * @return Promise => bool = true or false
   */
  public deletePrinter(id_printer:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('printers', id_printer)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getPrinter('5fb67fda87c0f21d484cbdf3')
            .then((printer)=>{
              console.log('getPrinter', printer);
            })
   * @param id_printer 
   * @return false or object
   */
  public getPrinter(id_printer:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('printers', id_printer)
            .then((printer:any)=>{
              if(printer) delete printer?.uuid;
              resolve(printer);
            }, error=>{
              reject(error)
            })         
    })
  }

  /**
   * @example
   * this.vhQuerySales.getPrinters()
            .then((printers)=>{
              console.log('getDoc', printers);
            })
   * @return array(object) = [{},{},..]
   */
  public getPrinters(){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDocsByFields('printers',{uuid: {$eq: this.hwinfo.uuid}},{},{},0)
            .then((printers:any)=>{
              this.printers = new Array();
              if(printers.length>0){
                printers.forEach((element:any) => {
                  delete element?.uuid;
                  this.printers.push(element);
                });
              }              
              resolve(this.printers);
            })          
    })
  }

  
   /**
   * @example:
   * this.vhQuerySales.refreshLocalPrintPages()
          .then(()=>{
            do something.....
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalPrintPage(), getlocalPrintPages() trong localstorage
   * @return Promise => null
   */
    private refreshLocalPrintPages():any{
      return new Promise((resolve, reject) => { 
        this.getPrintPages()
            .then(()=>{resolve(null)})       
        resolve(null)
      })
    }

  /**
   * @example: 
   * let print_page = this.vhQuerySales.getLocalPrintPage('page_desktop_sales');
   * @param print_page_type 
   * @return Object => obj = {} or null
   */
   public getLocalPrintPage(print_page_type:string){
    for(let i=0; i<this.print_pages.length; i++){
      if(this.print_pages[i].print_page_type === print_page_type){
        return this.print_pages[i];       
      }
    }                 
    return null; 
  }



    /**
   * @example: 
   * let pagesize = this.vhQuerySales.getLocalDefaultPageSize('page_desktop_sales');
   * @param print_page_type 
   * @return Object => obj = {} or null
   */
    public getLocalDefaultPageSize(print_page_type:string){
    for(let i=0; i<this.print_pages.length; i++){
      if(this.print_pages[i].print_page_type === print_page_type){
        for(let j=0; j<this.print_pages[i]['print_sizes'].length; j++){
          if(this.print_pages[i]['print_sizes'][j]._id === this.print_pages[i].print_size_default){
            return this.print_pages[i]['print_sizes'][j];            
          }
        }        
      }
    }                 
    return null; 
  }
  /**
   * @example:
   * this.vhQuerySales.addPrintPage('page_desktop_sales', {name:'camera 2', quantity:20, price:200000})
          .then((print_page)=>{
            console.log('addPrintPage', print_page);
          }, error=>{
            console.log('error', error);
          })
   * @param data 
   * Promise => object = {} Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
    public addPrintPage(print_page_type:string, data:any){
      return new Promise((resolve, reject) => {        
        let obj:any = {...data};
        obj.id_branch = this.getDefaultBranch()._id;
        obj.uuid = this.hwinfo.uuid;
        let query = {id_branch:{$eq:obj.id_branch}, uuid:{$eq:obj.uuid}, print_page_type:{$eq:print_page_type}};        
        this.vhMGDB_database.getDocsByFields('print_pages', query, {})
            .then((print_pages:any)=>{
              if(print_pages.length===0){
                this.vhMGDB_database.addDoc('print_pages', obj)
                    .then((print_page)=>{
                      this.print_pages.push(print_page);
                      resolve(print_page);
                    }, error=>{
                      reject(error)
                    })
              }          
            },(error:any)=>{              
              reject(error)
            })
                  
      })
    }

    /**
   * @example:
   * this.vhQuerySales.updatePrintPage('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updatePrintPage', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_print_page
   * @param data 
   * @return Promise => bool = true or false
   */
  public updatePrintPage(id_print_page:string, data:object){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.updateDoc('print_pages', id_print_page, data)
          .then((bool:any)=>{
            if(bool){
              for(let i=0; i<this.print_pages.length; i++){
                if(this.print_pages[i]._id === id_print_page){
                  this.print_pages[i] = {...this.print_pages[i], ...data};
                  break;
                }
              }
            }
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deletePrintPage('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deletePrintPage', bool);
        })
   * @param id_print_page 
   * @return Promise => bool = true or false
   */
  public deletePrintPage(id_print_page:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('print_pages', id_print_page)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getPrintPages()
            .then((print_pages)=>{
              console.log('getPrintPages', print_pages);
            })
   * @return array(object) = [{},{},..]
   */
    public getPrintPages(){
      return new Promise((resolve) => {
        this.vhMGDB_database.getDocsByFields('print_pages',{id_branch:{$eq:this.getDefaultBranch()._id}, uuid: {$eq: this.hwinfo.uuid}},{},{},0)
              .then((print_pages:any)=>{
                this.print_pages = new Array();
                if(print_pages.length>0){
                  print_pages.forEach((e:any) => {
                    delete e?.uuid;
                    delete e?.id_branch;
                    this.print_pages.push(e);
                  });
                }              
                resolve(this.print_pages);
              })          
      })
    }

/**
  * Hàm này dùng để thực hiện trừ hàng hóa trong nhiều Payment_Card
  * Hàm chạy ổn định anh sẽ thêm phần trừ số lượng hàng hóa đã sử dụng trong payment_card_code
  * @example
      let bill = {
          bill_type: 51,
          id_employee: '2rVieBQTubQ2hjUnpwU4w7qSlD83',
          id_branch: 'ADGNX9HFzffJ59yRtqNd',
          id_customer: 'cus001',
          id_wallet: 'wallet001',
          note: '',
          date: new Date(),
          bill_code: 'L46K0502'
      }
      
      let bill_details =[{     
        id_payment_card: '7Q5BZVRlyySrhShngMDv',
        id_payment_card_code: '33cTgnd2xZo3OW9tsu1d',
        pctype: 1,          
        products:[{
            id_product:'9tg6UxzK26DDVEVHsvq5',
            quantity: 5,
            outquantity: xem cách tính bên dưới,
            restquantity: xem cách tính bên dưới,
            price: 0, //vì đổi thẻ lấy hàng, nên price luôn luôn là 0
            ptype: 1,           
            ratio:1				
          },{
            id_product:'jUqd5bE6y2JhX0aCd5TF',
            quantity: 1,
            outquantity: xem cách tính bên dưới,
            restquantity: xem cách tính bên dưới,
            price: 0,
            ptype: 2,            
            ratio:1	
          },{
            id_product,
            quantity,
            outquantity: xem cách tính bên dưới,
            restquantity: xem cách tính bên dưới,
            price 0,
            ptype: 1,           
            ratio:1	
      }]	           
      this.vhQuerySales.createBill_Billdetail_51(bill, bill_details)
          .then((bill:any)=>{
              console.log(bill._id);
          },(error:any)=>{
              console.log('error ', error);
          })
  * @param bill
  * @param bill_details
  * @returns Promise => object = {} or null;
  * @notice :
  * outquantity (của bill_detail) = outquantity (của thẻ) + quantity (của bill_detail);
  * restquantity (của bill_detail) = quantity (của thẻ) - outquantity (của bill_detail);
  */
private createBill_Billdetail_51(bill:any, _bill_details:any):any{//ĐỔI PAYMENT_CARD
  let bill_details = this.changeBillDetails_withPromotions_toRaw(_bill_details);
  if(!bill_details) return null;  
  return new Promise((resolve, reject) => {  
    //let bill_details_new = new Array();
    this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
    bill.sync_code = this.sync_code;

    bill.date = new Date();
    bill.bill_type = 51;       
    //bill.bill_code = this.vhAlgorithm.createBillCode(bill?.date);
    this.createBillCode(bill.date, bill.bill_type)
        .then((bill_code)=>{
            bill.bill_code = bill_code;
            this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(bill.date), bill)
                .then((bill_get:any) => {     
                  if(bill_get){                     
                      let promise_zero = new Array();
                      for(let i=0; i<bill_details.length; i++){
                        let data = {...bill_details[i]};
                        data.id_bill = bill_get._id;
                        //---------------NEW-----------------
                        if(bill.bill_code) data.bill_code = bill.bill_code;
                        if(bill.date) data.date = bill.date;
                        //if(typeof bill.tax == 'number') data.tax = bill.tax;
                        data.bill_type = 51;
                        if(bill.id_cashier) data.id_cashier = bill.id_cashier;
                        if(bill.id_employee) data.id_employee = bill.id_employee;                 
                        if(bill.id_customer) data.id_customer = bill.id_customer;              
                        if(bill.id_branch) data.id_branch = bill.id_branch;
                        //-----------------------------------
                        //Tạo phiếu bill_details_new       
                        promise_zero[promise_zero.length] =  this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);              
                        // promise_zero[promise_zero.length] = new Promise(resolve=>{
                        //   this.getBill_details_byFields({id_payment_card_code:{$eq:data.id_payment_card_code}, bill_type:{$eq:50}},{},{},0)
                        //       .then((bill_details_50:any)=>{                           
                        //             if(bill_details_50.length >0){
                        //               data.tax = bill_details_50[0].tax;                               
                        //             }else{
                        //               data.tax = 0;
                        //             }
                        //             this.vhMGDB_database.addDoc('vhs_bill_details_', data)
                        //                 .then(()=>{resolve(null)})
                        //       })
                        // })           
                      }                                 
                      this.vhQuery.asyncPromiseAll(promise_zero)
                          .then(()=>{                    
                            if(bill.bill_type === 51){//phiếu đổi payment_card                     
                              let promise_one = new Array();                      
                              for(let i=0; i<_bill_details.length; i++){
                                promise_one[i] = new Promise((resolve, reject)=>{
                                this.getPaymentCardCode(_bill_details[i].id_payment_card_code)
                                    .then((payment_card_code:any)=>{                                 
                                      for(let j=0; j<_bill_details[i].products.length; j++){
                                        for(let k=0; k<payment_card_code.products.length; k++){
                                          if(payment_card_code.products[k].id_product === _bill_details[i].products[j].id_product){// nhớ khởi động giá trị outquantity
                                            if(payment_card_code.products[k].id_subproduct){
                                              if(payment_card_code.products[k].id_subproduct === _bill_details[i].products[j].id_subproduct){                                        
                                                payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity + _bill_details[i].products[j].quantity;   
                                              }
                                            }else{                                      
                                              payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity + _bill_details[i].products[j].quantity;   
                                            }                                                                     
                                          }
                                        }                                 
                                      }
                                      this.updatePaymentCardCode(payment_card_code._id, {products: payment_card_code.products, date_used : bill.date, status: 4})                              
                                          .then(()=>{                                    
                                            resolve(null)
                                          }) 
                                    })
                                })                          
                              }
                              //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại   
                              promise_one[promise_one.length] = this.calculateQuantityProduct_DOWN(bill_details, bill.id_branch);    
                              Promise.all(promise_one)                      
                                    .then(()=>{  
                                      resolve(bill_get)
                                    }) 

                            } 
                          })
                  }
                })
        })
  })
}
/**
* Hàm này dùng để thực hiện đổi voucher lấy hàng hóa
* @example
    let bill = {
        bill_type: 41,
        id_employee: '2rVieBQTubQ2hjUnpwU4w7qSlD83',
        id_branch: '2rVieBQTubQ2hjUnpwU4w7qSlD83',
        id_customer: 'cus001',
        id_wallet: 'wallet001',
        note: '',
        date: new Date(),
        bill_code: ''
    }
    let bill_details =[{     
        id_voucher: 'voucher006',
        id_voucher_code: 'MHRD9N0531',
        vtype: 1,
        products:[{
            id_product:'9tg6UxzK26DDVEVHsvq5',
            quantity: 5,
            price: 0, //vì đổi voucher lấy hàng, nên price luôn luôn là 0
            ptype: 3,
            unit: 'cái',
            ratio:1				
          },{
            id_product:'jUqd5bE6y2JhX0aCd5TF',
            quantity: 1,
            price: 0,
            ptype: 2,
            unit: 'cái',
            ratio:1	
          },{
            id_product,
            quantity,
            price,
            ptype: 5// bây giờ phần mềm chưa dùng voucher có combo
            combos:[{
                id_product,
                quantity,
                price: 0, //vì đổi voucher lấy hàng, nên price luôn luôn là 0
                ptype: 3,
                unit: 'cái',
                ratio:1	
            },{
                id_product,
                quantity,
                price: 0,
                ptype: 2,
                unit: 'cái',
                ratio:1					          
        }]	        
    }]	       
    this.vhQuerySales.createBill_Billdetail_41(bill, bill_details)
        .then((bill:any)=>{
            console.log(bill._id);
        },(error:any)=>{
            console.log('error ', error);
        })
* @param bill
* @param bill_details
* @returns Promise => object = {} or null
*/
  private createBill_Billdetail_41(bill:any, bill_details:any):any{//ĐỔI VOUCHER   
    bill_details = this.changeBillDetails_withPromotions_toRaw(bill_details);
    if(!bill_details) return null;   
    return new Promise((resolve, reject) => {  
      this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
      bill.sync_code = this.sync_code;
      bill.date = new Date();
      bill.bill_type = 41;       
      //bill.bill_code = this.vhAlgorithm.createBillCode(bill?.date);
      this.createBillCode(bill.date, bill.bill_type)
          .then((bill_code)=>{
            bill.bill_code = bill_code;
            this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(bill.date), bill)
                .then((bill_get:any) => {     
                  if(bill_get){                       
                      //let bill_details_new = new Array();
                      let promise_zero = new Array();
                      for(let i=0; i<bill_details.length; i++){
                        let data = {...bill_details[i]};
                        data.id_bill = bill_get._id;
                        //---------------NEW-----------------
                        if(bill.bill_code) data.bill_code = bill.bill_code;
                        if(bill.date) data.date = bill.date;
                        if(typeof bill.tax == 'number') data.tax = bill.tax;
                        data.bill_type = 41;                
                        if(bill.id_cashier) data.id_cashier = bill.id_cashier;
                        if(bill.id_employee) data.id_employee = bill.id_employee;                 
                        if(bill.id_customer) data.id_customer = bill.id_customer;              
                        if(bill.id_branch) data.id_branch = bill.id_branch;
                        //-----------------------------------
                        //Tạo phiếu bill_billdetails   
                        promise_zero[promise_zero.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);
                        // promise_zero[promise_zero.length] = new Promise(resolve=>{
                        //   this.getBill_details_byFields({id_voucher_code:{$eq:data.id_voucher_code}, bill_type:{$eq:40}},{},{},0)
                        //       .then((bill_details_40:any)=>{
                        //             if(bill_details_40.length >0){
                        //               data.tax = bill_details_40[0].tax;                               
                        //             }else{
                        //               data.tax = 0;
                        //             }
                        //             this.vhMGDB_database.addDoc('vhs_bill_details_', data)
                        //             .then(()=>{resolve(null)})
                        //       })
                        //   })

                      }                                                 
                      this.vhQuery.asyncPromiseAll(promise_zero)
                          .then(()=>{
                            if(bill.bill_type === 41){//phiếu đổi voucher 
                                let promise_one = new Array();
                                for(let i=0; i<bill_details.length; i++){//dùng bill_details trước khi change mới đúng
                                  promise_one[promise_one.length] = this.updateVoucherCode(bill_details[i].id_voucher_code,{date_used : bill.date, status: 4, id_bill: bill_get._id, id_customer_used: bill.id_customer});                             
                                }                
                                //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                               
                                promise_one[promise_one.length] = this.calculateQuantityProduct_DOWN(bill_details, bill.id_branch);                       
                                this.vhQuery.asyncPromiseAll(promise_one)
                                    .then(()=>{  
                                      resolve(bill_get)
                                    })                       
                            } 
                          })
                  }else resolve(null);
                },(error)=>{
                  reject(error);
                })
          })
    })
  }

   /**
    * * Hàm này dùng cho những bill nào được tao ra thêm bill_detail vào và lưu lên database luôn
   * @example
    let bill ={       
      id_employee: '2rVieBQTubQ2hjUnpwU4w7qSlD83',
      id_cashier: '2rVieBQTubQ2hjUnpwU4w7qSlD83',
      id_customer: 'cus001',
      total: 10000000,
      bill_type: 1,
      tax_value: 0,
      fee: 0,
      date: new Date()
    }
    let bill_details =[{
      id_product: 'pro006',
      price: 10000000,
      quantity: 1
    },{
      id_product: 'pro007',
      price: 12000000,
      quantity: 1
    }]
    this.vhQuerySales.createBill_Billdetail(bill, bill_details)
        .then((bill:any)=>{
          console.log(bill._id);
        },(error:any)=>{
          console.log('error ', error);
        })
   * @param bill 
   * @param bill_details 
   * @return Promise => object = {} or null
   */
  public createBill_Billdetail(bill:any, bill_details:any):any{ 
    console.log('s_createBill_Billdetail', bill, bill_details)
    let _bill_details = cloneDeep(bill_details);
    if((bill.bill_type != 40)&&(bill.bill_type != 42)&&(bill.bill_type != 43)&&(bill.bill_type != 50)&&(bill.bill_type != 52)&&(bill.bill_type != 53)){
      bill_details = this.changeBillDetails_withPromotions_toRaw(bill_details);
      if(!bill_details) return null;    
    }    
    //Nếu bill không có trường date thi Promise ko chạy, Dev sẽ biết mà fix lỗi truyền lại giá trị
    if(!bill.date) {console.log(); return null;}
    return new Promise((resolve, reject) => {         
      this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
      bill.sync_code = this.sync_code;       
      this.createBillCode(bill.date, bill.bill_type)
          .then((bill_code)=>{
            //console.log('bill_code', bill_code);
            bill.bill_code = bill_code;//this.vhAlgorithm.createBillCode(bill?.date);
            if(bill.bill_type == 1) bill.cqt_status = 1; 
            this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(bill.date), bill)
                .then((bill_get:any) => {     
                  if(bill_get){                          
                      let promise = new Array();
                      for(let i=0; i<bill_details.length; i++){
                        let data = bill_details[i];
                        //console.log(i, data);
                        data.id_bill = bill_get._id;
                        //---------------NEW-----------------
                        if(bill.bill_code) data.bill_code = bill.bill_code;
                        if(bill.date) data.date = bill.date;
                        if(typeof bill.tax == 'number') data.tax = bill.tax;
                        if(typeof bill.bill_type == 'number') data.bill_type = bill.bill_type;
                        if(bill.id_cashier) data.id_cashier = bill.id_cashier;
                        if(bill.id_employee) data.id_employee = bill.id_employee;
                        if(bill.id_supplier) data.id_supplier = bill.id_supplier;
                        if(bill.id_customer) data.id_customer = bill.id_customer;
                        if(bill.id_inventorytime) data.id_inventorytime = bill.id_inventorytime;
                        if(bill.id_branch) data.id_branch = bill.id_branch;
                        //-----------------------------------
                        //Tạo phiếu bill_billdetails
                        promise[i] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data)                  
                      }                                   
                      this.vhQuery.asyncPromiseAll(promise)
                          .then((message:any)=>{                                                   
                            //Tạo các bill_type này làm giảm quantity trong products
                            if((bill.bill_type === 1)||(bill.bill_type === 10)||(bill.bill_type === 15)||(bill.bill_type === 30)||(bill.bill_type === 38)){  
                              //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                         
                              this.calculateQuantityProduct_DOWN(bill_details, bill.id_branch)
                                  .then(()=>{
                                    resolve(bill_get);
                                  })
                            //Các bill_type này làm tăng quantity trong products  
                            }else if(bill.bill_type === 2){   
                              this.calculateQuantityProduct_UP(bill_details, bill.id_branch)
                                  .then(()=>{                                   
                                    this.calculateUpdateImportPrice(bill_details, bill.id_branch)
                                        .then(()=>{
                                          resolve(bill_get);
                                        })
                                  })                            
                            //Các bill_type này làm tăng quantity trong products  
                            }else if((bill.bill_type === 3)||(bill.bill_type === 31)){
                              //Sau khi nhập, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại
                              this.calculateQuantityProduct_UP(bill_details, bill.id_branch)
                                  .then(()=>{                                   
                                    resolve(bill_get);
                                  })                                  
                            //Các bill_type này làm tăng quantity trong products  
                            }else if(bill.bill_type === 9){
                              //Sau khi tạo đơn tồn đầu kỳ, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại
                              this.calculateQuantityProduct_UP_9(bill_details, bill.id_branch)
                                  .then(()=>{
                                    resolve(bill_get);
                                  })                            
                            //Các bill_type này không làm thay đổi quantity trong products                                         
                            }else if((bill.bill_type === 5)||(bill.bill_type === 6)||(bill.bill_type === 13)||(bill.bill_type === 14)||(bill.bill_type === 16)
                                  ||(bill.bill_type === 18)||(bill.bill_type === 19)||(bill.bill_type === 20)||(bill.bill_type === 21)||(bill.bill_type === 29)
                                  ){
                              resolve(bill_get)
                            }else if(bill.bill_type === 40){//bán voucher     
                              let promise_40 = new Array();                                    
                              for(let i=0; i<bill_details.length; i++){                        
                                //cập nhật lại trạng thái thẻ
                                let _products = [...bill_details[i].products];
                                promise_40[promise_40.length] = this.updateVoucherCode(bill_details[i].id_voucher_code, {products: _products, date_sold : bill.date, status: 2, id_customer: bill.id_customer});                             
                              }   
                              Promise.all(promise_40)
                                    .then(()=>{
                                      resolve(bill_get);
                                    })  
                            }else if(bill.bill_type === 41){//đổi voucher                            
                              let promise_41 = new Array();
                              for(let i=0; i<bill_details.length; i++){
                                promise_41[promise_41.length] = this.updateVoucherCode(bill_details[i].id_voucher_code,{date_used : bill.date, status: 4, id_bill: bill_get._id, id_customer_used: bill.id_customer});                             
                              }                
                              //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                               
                              promise_41[promise_41.length] = this.calculateQuantityProduct_DOWN(bill_details, bill.id_branch);                       
                              this.vhQuery.asyncPromiseAll(promise_41)
                                  .then(()=>{  
                                    resolve(bill_get)
                                  })                                                                      
                            }else if(bill.bill_type === 50){//bán thẻ trả trước    
                              let promise_50 = new Array();                                             
                              for(let i=0; i<bill_details.length; i++){                          
                                let _products = [...bill_details[i].products];
                                for(let j=0; j<_products.length; j++){
                                  _products[j].outquantity = 0;                            
                                }
                                //cập nhật lại trạng thái thẻ
                                promise_50[promise_50.length] =  this.updatePaymentCardCode(bill_details[i].id_payment_card_code, {products: _products, date_sold : bill.date, status: 2, id_customer: bill.id_customer});                              
                              }
                              Promise.all(promise_50)
                                    .then(()=>{
                                      resolve(bill_get);
                                    })   
                            }else if(bill.bill_type === 51){//đổi thẻ trả trước         
                              let promise_51 = new Array();                      
                              for(let i=0; i<_bill_details.length; i++){
                                promise_51[i] = new Promise((resolve, reject)=>{
                                  this.getPaymentCardCode(_bill_details[i].id_payment_card_code)
                                      .then((payment_card_code:any)=>{                                 
                                        for(let j=0; j<_bill_details[i].products.length; j++){
                                          for(let k=0; k<payment_card_code.products.length; k++){
                                            if(payment_card_code.products[k].id_product === _bill_details[i].products[j].id_product){// nhớ khởi động giá trị outquantity
                                              if(payment_card_code.products[k].id_subproduct){
                                                if(payment_card_code.products[k].id_subproduct === _bill_details[i].products[j].id_subproduct){                                        
                                                  payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity + _bill_details[i].products[j].quantity;   
                                                }
                                              }else{                                      
                                                payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity + _bill_details[i].products[j].quantity;   
                                              }                                                                     
                                            }
                                          }                                 
                                        }
                                        this.updatePaymentCardCode(payment_card_code._id, {products: payment_card_code.products, date_used : bill.date, status: 4})                              
                                            .then(()=>{                                    
                                              resolve(null)
                                            }) 
                                      })
                                })                          
                              }
                              //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại   
                              promise_51[promise_51.length] = this.calculateQuantityProduct_DOWN(bill_details, bill.id_branch);    
                              Promise.all(promise_51)                      
                                    .then(()=>{  
                                      resolve(bill_get)
                                    }) 
                            }      
                          })                          
                  }else reject({message: 'Invoice creation failed'});
                },
                (error:any) => {
                  reject(error);
                })  
          })
           
    })
  }

  /**
   * @example:
   * this.vhQuerySales.createBill_Detail({})
          .then((vhbill_detail)=>{
            console.log('vhQuerySales', vhbill_detail);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */ 
  public createBill_Detail(data:any):any {//đang dùng      
    return new Promise((resolve, reject) => {
      if(data.id_bill){
        this.getBill(data.id_bill)
            .then((bill:any)=>{
                let _data = data;           
                if(bill.bill_code) _data.bill_code = bill.bill_code;               
                if(bill.date) _data.date = bill.date;           
                if(bill.id_branch) _data.id_branch = bill.id_branch;         
                if(typeof bill.bill_type == 'number') _data.bill_type = bill.bill_type;
                this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), _data)
                    .then((vhbill_detail)=>{                      
                      resolve(vhbill_detail);
                    },(error:any)=>{
                      reject(error);
                    })                    
            },(error:any)=>{
            console.log('error', error);
            })
      }else{
        console.log('error', 'không tồn tại id_bill trong data');
      } 
            
    })
  }  

  /**
   * @example:
   * this.vhQuerySales.updateBill_Detail('5fb6780ca2148e09806c5b01', {name:'Khuyến mãi 12/12'})
          .then((bool:any)=>{
            console.log('updateBill_Detail', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_bill 
   * @param data 
   * @return Promise => bool = true or false
   */
   public updateBill_Detail(id_bill_detail:string, value:object){   
    return new Promise((resolve, reject) => {   
       let arr_years = this.getYearsArray();
       this.vhMGDB_database.updateDoc('vhs_bill_details_' + arr_years[arr_years.length-1], id_bill_detail, value)
           .then((obj1:any) => {    
               if(obj1) return resolve(obj1);   
               if(arr_years.length == 1) return resolve(obj1);          
               this.vhMGDB_database.updateDoc('vhs_bill_details_' + arr_years[arr_years.length-2], id_bill_detail, value)
                   .then((obj2:any) => {    
                     if(obj2) return resolve(obj2);   
                     if(arr_years.length == 2) return resolve(obj2);       
                     let promise = new Array();
                     for(let i=0; i<arr_years.length-2;i++){
                       promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + arr_years[i], id_bill_detail, value);
                     }  
                     Promise.all(promise)
                           .then((array)=>{
                             array = array.filter((e:any)=>e!=false);
                             if(array.length == 0) resolve(false);     
                             else if(array.length == 1) resolve(array[0]);  
                             else{
                               reject(`Lỗi nghiêm trọng, id_bill_detail ${id_bill_detail} tồn tại trên nhiều collection, báo anh Huy trường hợp này gấp!`);
                             } 
                           })                       
                   },(error:any) => {
                     reject(error);
                   }) 
             },(error:any) => {
               reject(error);
             })      
    })
  }

  /**
   * @example:
   * this.vhQuerySales.deleteBill_Detail('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteBill_Detail', bool);
        })
   * @param id_bill_detail 
   * @return Promise => bool = true or false 
   */
  public deleteBill_Detail(id_bill_detail:any) {
   return new Promise((resolve, reject) => {  
     let arr_years = this.getYearsArray();
     let promise = new Array();
     for(let i=0; i<arr_years.length;i++){
       promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + arr_years[i], id_bill_detail);
     }  
     Promise.all(promise)
           .then(()=>{
             resolve(true);     
           }) 
   })
 } 

 
/**
 * Hàm này chỉ áp dụng cho bill_type 1,5 và bill_detail có ptype 5
 * @example:
 * this.vhQuerySales.deleteBill_Detail_ptype_5('5fb67fda87c0f21d484cbdf3')
      .then((bool:any)=>{
        console.log('deleteBill_Detail', bool);
      })
  * @param id_bill_detail 
  * @return Promise => bool = true or false 
  */
  public deleteBill_Detail_ptype_5(id_bill_detail:any){
    return new Promise((resolve, reject) => {
      let query = {bill_detail_ID:{$eq:id_bill_detail}};
      this.getBill_details_byFields(query, {}, {}, 0)
          .then((bill_details:any)=>{
            if(bill_details.length >0){   
              let promise = new Array();                
              for(let i=0; i<bill_details.length; i++){  
                promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill_details[i].date), bill_details[i]._id);                    
              }
              Promise.all(promise)
                    .then((array:any)=>{
                      resolve(array[0]);  
                    })
            }else{
              console.log('error', {error: 'id_bill_detail truyền vào không tồn tại'});
              resolve(false);  
            }  
          }, error=>{
            console.log('error', error);
            resolve(false);  
          })          
    })
  }

    

  /**
   * hàm này chỉ dùng cho trường hợp chuyển trạng thái (bill_type) của biên nhận bảo hành (chưa xử lý 18, đang xử lý 19, hoàn thành 20, đã giao khách 21)
   * @example
    this.vhQuerySales.changeStateWarranty_Bill_Billdetail('SzyEYNN39Mq90NkzUFpz', 21)
        .then(()=>{
          console.log("success");
        })
   * @param id_bill 
   * @return Promise => bool = true or false 
   */
  public changeStateWarranty_Bill_Billdetail(id_bill:any, bill_type:any):any { 
    return new Promise((resolve, reject) => {           
        this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
        let promise_0 = this.getBill(id_bill);
        let promise_1 = this.getBill_details_byID({id_bill:{$eq:id_bill}});
        Promise.all([promise_0, promise_1])
            .then((array:any)=>{          
             let bill = array[0];   
              if((bill.bill_type === 18)||(bill.bill_type === 19)||(bill.bill_type === 20)||(bill.bill_type === 21)){                 
                  let promise = new Array();      
                  for(let i=0; i<array[1].length; i++){                       
                    promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(bill.date), array[1][i]._id, {bill_type:bill_type});                   
                  }    
                  
                  promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, {bill_type:bill_type, sync_code: this.sync_code});                        
                  Promise.all(promise)
                        .then(()=>{  
                          resolve(true);                                                                                      
                        })           
              }
        })      
    })  
  }   

    /**
   * @example
   * this.vhQuerySales.changeBill_toInvoice_byMinvoice(id_bill,invoiceSeries)       
          .then((rsp)=>{    
            //-----------your code here-----------                      
          },(error:any)=>{
              console.log('error', error)
          })
   * @param id_bill 
   * @param invoiceSeries   
   * @returns Promise => {vcode, msg, data(array)}
   */
  public changeBill_toInvoice_byMinvoice(id_bill:string, invoiceSeries: string):Promise<any>{
    return new Promise<any>((resolve, reject) => {  
      (async () => {
        try{ 
          let invoices = new Array(); 
          // Khởi tạo mảng Promise
          const promises = [
            this.getBill(id_bill),
            this.getBill_details_byID({ id_bill: { $eq: id_bill } })
          ];
          // Sử dụng await để lấy kết quả từ Promise.all()
          const [bill, bill_details] = await Promise.all(promises).catch((err) => {
            console.error('❌ Lỗi trong quá trình lấy dữ liệu:', err);
            throw new Error('Không thể lấy dữ liệu hóa đơn');
          }) as [any, any[]];
          let invoice:any = {
            inv_invoiceSeries: invoiceSeries,
            inv_invoiceIssuedDate: this.vhAlgorithm.formatDateToString(new Date()),
            inv_currencyCode: "VND",
            inv_exchangeRate: 1,
            //inv_buyerDisplayName: "",
            // inv_buyerLegalName: "",
            // inv_buyerTaxCode: "",
            //inv_buyerAddressLine: "",
            inv_discountAmount: 0,
            inv_TotalAmountWithoutVat: bill.total,
            inv_vatAmount: bill.total*bill.tax/100,          
            inv_TotalAmount: bill.total*(1 + bill.tax/100),
            key_api: id_bill
          }
          if(bill.id_customer == "id_retail"){
            if(bill.retail_name) invoice.inv_buyerDisplayName = bill.retail_name;
            if(bill.retail_address) invoice.inv_buyerAddressLine = bill.retail_address;
          }else{
            let customer = await this.getlocalCustomer_Async(bill.id_customer);  
            if(customer?.isBusiness ){
              if(customer.taxcode) invoice.inv_buyerTaxCode = customer.taxcode;
              if(customer.name) invoice.inv_buyerLegalName = customer.name;
              if(customer.address) invoice.inv_buyerAddressLine = customer.address;
              if(bill.retail_name) invoice.inv_buyerDisplayName = bill.retail_name;
            }else{
              if(customer.name) invoice.inv_buyerDisplayName = customer.name;
              if(customer.address) invoice.inv_buyerAddressLine = customer.address;
            }
          }
          let invoice_details = new Array();
          for(let i=0; i<bill_details.length; i++){
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product;
            let product:any = await this.getlocalDetailProduct_Async(id_sub_or_product)
            let invoice_detail = {
              tchat: 1,
              stt_rec0: i+1,
              inv_itemCode: bill_details[i]._id,
              inv_itemName: product.name,
              inv_unitCode: this.getUnit_byRatio(product.units, bill_details[i].ratio)?.unit,//nhớ đổi về ratio 1
              inv_quantity:  bill_details[i].quantity,
              inv_unitPrice: bill_details[i].price,
              inv_discountPercentage: (bill_details[i].price_origin - bill_details[i].price)/bill_details[i].price_origin,
              inv_discountAmount: bill_details[i].price_origin - bill_details[i].price,
              inv_TotalAmountWithoutVat: bill_details[i].price *  bill_details[i].quantity,
              ma_thue: bill_details[i].tax,
              inv_vatAmount: bill_details[i].quantity*bill_details[i].price*bill_details[i].tax/100,
              inv_TotalAmount: bill_details[i].quantity*bill_details[i].price*(1 +  bill_details[i].tax/100)
            }

            invoice_details.push(invoice_detail)
          }
          
          invoices = [{...invoice, details:[{data:invoice_details}]}];
          console.log('data', invoices); 
          resolve({vcode: 0, msg: 'success', data: invoices});                      
        } catch (err) {
          console.error('❌ Lỗi saveInvoice_noSign_byMinvoice:', err);
          reject(err);
        }  
      })()       
    })
  }

/**
 * @example
 * this.vhQuerySales.changeTiktok_toInvoice_byMinvoice(order,invoiceSeries)       
        .then((rsp)=>{    
          //-----------your code here-----------                      
        },(error:any)=>{
            console.log('error', error)
        })
  * @param order : hóa đơn lấy từ tiktok về 
  * @param invoiceSeries : ký hiệu hóa đơn   
  * @returns Promise => {vcode, msg, data(array)}
  */  
private changeTiktok_toInvoice_byMinvoice(order:any, invoiceSeries: string){   
  return new Promise((resolve, reject) => {     
    try{
      //Tách phần chi tiết hóa đơn của tiktok ra, và gom những chi tiết hóa đơn giống nhau lại
      let order_details:any = [...order.line_items];
      for(let i=0; i<order_details.length; i++) if(order_details[i].quantity == undefined) order_details[i].quantity = 1;;
      for(let i=0; i<order_details.length; i++){
        if(order_details[i]){
          let quantity = order_details[i].quantity;
          for(let j=i+1; j<order_details.length; j++){
            if(order_details[i].sku_id === order_details[j].sku_id){
              if((order_details[i].original_price === order_details[j].original_price)||(order_details[i].sale_price === order_details[j].sale_price)
                ||(order_details[i].seller_discount === order_details[j].seller_discount)||(order_details[i].platform_discount === order_details[j].platform_discount)){
                quantity = quantity + order_details[j].quantity;
                  order_details[j] = null;
              }
            }
          }
          order_details[i].quantity = quantity;
        }
      }
      order_details = order_details.filter((e:any)=>e!=null);
      /**------------Tạo hóa đơn thuế----------------- */
      let invoice:any = {
        inv_invoiceSeries: invoiceSeries,
        inv_invoiceIssuedDate: this.vhAlgorithm.formatDateToString(new Date()),
        inv_currencyCode: "VND",
        inv_exchangeRate: 1,
        inv_discountAmount: 0,            
        inv_vatAmount: 0,          
        inv_TotalAmountWithoutVat: 0,
        inv_TotalAmount: 0,
        key_api: order.id
      }

      invoice.inv_buyerDisplayName = "Người mua không lấy hóa đơn";     
      // invoice.inv_buyerLegalName = order.xxxx;           
      // invoice.inv_buyerTaxCode = order.yyyy;     
      // invoice.inv_buyerAddressLine = order.recipient_address[0].full_address;            
      // invoice.inv_buyerEmail = order.buyer_email;

      /**------------Tạo chi tiết hóa đơn thuế----------------- */
      let invoice_details = new Array();
      for(let i=0; i<order_details.length; i++){
        let invoice_detail = {
          tchat: 1,
          stt_rec0: i+1,
          inv_itemCode: order_details[i].id,
          inv_itemName: order_details[i].product_name,
          inv_unitCode: 'Cái',
          inv_quantity:  order_details[i].quantity,
          inv_unitPrice: order_details[i].sale_price,//Giá bán sản phẩm trên sàn tiktok
          ma_thue: order.payment.tax,
          inv_discountPercentage: 0,
          inv_discountAmount: 0,
          inv_TotalAmountWithoutVat: 0,         
          inv_vatAmount: 0,
          inv_TotalAmount: 0
        }
        //Trợ giá (chiết khấu) của nhà bán hàng và sàn tiktok trên mỗi chi tiết hóa đơn (sản phẩm x số lượng)
        invoice_detail.inv_discountAmount = order_details[i].seller_discount + order_details[i].platform_discount;
        //Giá cuối (đã trừ trợ giá) của chi tiết hóa đơn
        invoice_detail.inv_TotalAmountWithoutVat = order_details[i].sale_price*order_details[i].quantity - invoice_detail.inv_discountAmount;
        //Trợ giá (chiết khấu) tính theo %
        invoice_detail.inv_discountPercentage = invoice_detail.inv_discountPercentage / (order_details[i].sale_price*order_details[i].quantity);      
        //Thuế VAT được tính theo chi tiết hóa đơn
        invoice_detail.inv_vatAmount = invoice_detail.inv_TotalAmountWithoutVat*order.payment.tax/100;
        //Tổng giá trị hàng hóa kê khai theo chi tiết hóa đơn
        invoice_detail.inv_TotalAmount = invoice_detail.inv_TotalAmountWithoutVat + invoice_detail.inv_vatAmount;
        invoice_details.push(invoice_detail)
      }
      /**--------------Tính chi phí vận chuyển, nếu có thì sinh ra một chi tiết hóa đơn "Phí vận chuyển" -----*/
      //Phí ship người mua phải trả
      let shipping_paid_by_buyer = 0;
      //Phí ship người của được trở giá (người bán + tiktok)
      let shipping_discount = 0;
      if(order.shipping_fee >0){
        shipping_discount = order.shipping_fee_seller_discount + order.shipping_fee_platform_discount + order.shipping_fee_cofunded_discount;
        shipping_paid_by_buyer = order.shipping_fee - shipping_discount;
      }
      if(shipping_paid_by_buyer > 0){
        let data = {
          tchat: 1,
          stt_rec0: invoice_details.length + 1,
          inv_itemCode: this.vhAlgorithm.ObjectId(),
          inv_itemName: 'Phí vận chuyển',
          inv_unitCode: 'Lần',
          inv_quantity:  1,
          inv_unitPrice: order.shipping_fee,
          inv_discountPercentage: 0,
          inv_discountAmount: shipping_discount,
          inv_TotalAmountWithoutVat: shipping_paid_by_buyer,
          ma_thue: order.payment.tax,
          inv_vatAmount: shipping_paid_by_buyer*order.payment.tax/100,
          inv_TotalAmount: 0,
        }
        data.inv_discountPercentage = data.inv_discountAmount / (data.inv_unitPrice * data.inv_quantity);
        data.inv_TotalAmount = data.inv_TotalAmountWithoutVat + data.inv_vatAmount;
      }    

      /**---------------Tính giá trị còn lại cho hóa đơn thuế ------------------*/
      for(let i=0; i<order_details.length; i++){
        if(order_details[i].tchat == 1){
          invoice.inv_discountAmount += order_details[i].inv_discountAmount;   
          invoice.inv_vatAmount += order_details[i].inv_vatAmount;  
          invoice.inv_TotalAmountWithoutVat += order_details[i].inv_TotalAmountWithoutVat;  
          invoice.inv_TotalAmount += order_details[i].inv_TotalAmount;  
        }else if(order_details[i].tchat == 2){                
        }else if(order_details[i].tchat == 3){           
        }        
      }   
      //Hóa đơn điện tử thuế gồm 2 phần hóa đơn + chi tiết hóa đơn
      let invoices = [{...invoice, details:[{data:invoice_details}]}];
      console.log('invoices', invoices); 
      resolve({vcode: 0, msg: 'success', data: invoices});                      
    } catch (err) {
      console.error('❌ Lỗi changeTiktok_toInvoice_byMinvoice:', err);
      reject(err);
    }        
  })
}

   private changeTiktok_toInvoice_byMinvoice1(order:any, invoiceSeries: string){
      let invoice:any = {
        inv_invoiceSeries: invoiceSeries,
        inv_invoiceIssuedDate: this.vhAlgorithm.formatDateToString(new Date()),
        inv_currencyCode: "VND",
        inv_exchangeRate: 1,
        //inv_buyerDisplayName: "",
        // inv_buyerLegalName: "",
        // inv_buyerTaxCode: "",
        //inv_buyerAddressLine: "",

        inv_discountAmount: 0,            
        inv_vatAmount: 0,          
        inv_TotalAmountWithoutVat: 0,
        inv_TotalAmount: 0,
        key_api: order.id
      }

      invoice.tax_buyerDisplayName = "Người mua không lấy hóa đơn";     
      // invoice.tax_buyerLegalName = order.buyer_email;           
      // invoice.tax_buyerTaxCode = order.buyer_email;     
      // invoice.tax_buyerAddressLine = order.recipient_address[0].full_address;            
      // invoice.tax_buyerEmail = order.buyer_email;

      let order_details:any = [...order.line_items];
      for(let i=0; i<order_details.length; i++){
        if(order_details[i]){
          if(order_details[i].quantity == undefined) order_details[i].quantity = 1;
          let quantity = order_details[i].quantity;
          for(let j=i+1; j<order_details.length; j++){
            if(order_details[i].sku_id === order_details[j].sku_id){
              if((order_details[i].original_price === order_details[j].original_price)||(order_details[i].sale_price === order_details[j].sale_price)||(order_details[i].seller_discount === order_details[j].seller_discount)){
                quantity = quantity + order_details[j].quantity;
                  order_details[j] = null;
              }
            }
          }
          order_details[i].quantity = quantity;
        }
      }
      order_details = order_details.filter((e:any)=>e!=null);

      let invoice_details = new Array();
      for(let i=0; i<order_details.length; i++){
        let invoice_detail = {
          tchat: 1,
          stt_rec0: i+1,
          inv_itemCode: order_details[i].id,
          inv_itemName: order_details[i].product_name,
          inv_unitCode: 'Cái',
          inv_quantity:  order_details[i].quantity,
          inv_unitPrice: order_details[i].sale_price,
          inv_discountPercentage: 0,
          inv_discountAmount: 0,
          inv_TotalAmountWithoutVat: order_details[i].sale_price*order_details[i].quantity,
          ma_thue: order.payment.tax,
          inv_vatAmount: order_details[i].sale_price*order_details[i].quantity*order.payment.tax/100,
          inv_TotalAmount: order_details[i].sale_price*order_details[i].quantity* (1 + order.payment.tax/100),
        }

        invoice_details.push(invoice_detail)
      }
      //Tính chiết khấu thương mại
      let total_discount = 0;
      for(let i=0; i<order_details.length; i++){
        if(order_details[i].platform_discount != 0) total_discount += order_details[i].platform_discount;
        if(order_details[i].seller_discount != 0) total_discount += order_details[i].seller_discount;
      }
      if(total_discount > 0){
        let data = {
          tchat: 3,
          stt_rec0: invoice_details.length + 1,
          inv_itemCode: 'DÙNG HÀM TẠO RA',
          inv_itemName: 'Chiết khấu thương mại',
          inv_unitCode: 'Phần',
          inv_quantity:  1,
          inv_unitPrice: total_discount,
          inv_discountPercentage: 0,
          inv_discountAmount: 0,
          inv_TotalAmountWithoutVat: total_discount,
          ma_thue: order.payment.tax,
          inv_vatAmount: total_discount*order.payment.tax/100,
          inv_TotalAmount: total_discount* (1 + order.payment.tax/100),
        }
      }
      //Nếu người mau trả phí shipping thì chiết khấu thương mại giảm xuống
      if(invoice.payment.shipping_fee) total_discount -= invoice.payment.shipping_fee;
      

      //Tính giá trị còn lại cho invoice
      for(let i=0; i<order_details.length; i++){
        if(order_details[i].tchat == 1){
          invoice.inv_vatAmount += order_details[i].inv_vatAmount;  
          invoice.inv_TotalAmountWithoutVat += order_details[i].inv_TotalAmountWithoutVat;  
          invoice.inv_TotalAmount += order_details[i].inv_TotalAmount;  
        }else if(order_details[i].tchat == 2){
                
        }else if(order_details[i].tchat == 3){
          invoice.inv_discountAmount += order_details[i].inv_TotalAmountWithoutVat;        
          invoice.inv_vatAmount -= order_details[i].inv_vatAmount;  
          invoice.inv_TotalAmountWithoutVat -= order_details[i].inv_TotalAmountWithoutVat;  
          invoice.inv_TotalAmount -= order_details[i].inv_TotalAmount;             
        }
        
      }         

   }

  /**
   * hàm này chỉ dùng cho trường hợp bill_type 5->1, 29->3031, 36->1, 42->40, 43->41, 52->50, 53->51
   * @example
    this.vhQuerySales.saveBill_Billdetail('SzyEYNN39Mq90NkzUFpz')
        .then(()=>{
          console.log("success");
        })
   * @param id_bill 
   * @param newbill_type
   * @return Promise => undefined     
   */
  public saveBill_Billdetail(id_bill:any, newbill_type:number):any {       
    console.log('s_saveBill_Billdetail', id_bill, newbill_type) 
    //Nghiệp vụ nhà hàng chọn món là dùng hàm createbill_detail tạo bill_detail luôn, nên khi nào tính tiền mới dùng đến hàm này (hàm này ko thể bỏ đc) 
    //Nghiệp vụ bán hàng khác là chọn sản phẩm xong la dùng hàm updateBill_Billdetail để lưu bill_detail đó cùng với bill lại, ko là mất dữ liệu đã chọn đó
    if(!newbill_type) newbill_type = 1;
    return new Promise((resolve, reject) => {           
        this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
        let promise_0 = this.getBill(id_bill);
        let promise_1 = this.getBill_details_byID({id_bill:{$eq:id_bill}});
        Promise.all([promise_0, promise_1])
            .then((array:any)=>{   
              //console.log('array', array); 
              let billdate = array[0].date;     
              this.createBillCode(array[0].date, newbill_type)
                  .then((bill_code)=>{                                        
                      if((array[0].bill_type === 5)||(array[0].bill_type === 36)){                 
                          let promise = new Array();      
                          for(let i=0; i<array[1].length; i++){                               
                            let value_bill_detail ={
                              bill_code: bill_code, 
                              bill_type: newbill_type
                            }
                            promise[i] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id, value_bill_detail);                   
                          }    
                          let value_bill:any ={
                            bill_code: bill_code, 
                            bill_type: newbill_type,
                            sync_code: this.sync_code
                          }
                          if(newbill_type == 1) value_bill.cqt_status = 1;
                          promise[array[1].length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, value_bill);                        
                          Promise.all(promise)
                                .then(()=>{  
                                  //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                                  this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch)
                                        .then(()=>{
                                          resolve(undefined);
                                        })                                                                                       
                                })
                                
                      }else if(array[0].bill_type === 29){//sinh ra 2 bill_type 30(chi nhánh A xuất đến chi nhánh B) và 31(chi nhánh B nhận từ chi nhánh A), vẫn giữ bill_code của 29
                        let promise = new Array();             
                        promise[promise.length] = new Promise((resolve, reject)=>{
                            let promise_30 = new Array();                                        
                            promise_30[promise_30.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, {bill_type:30});
          
                            for(let i=0; i<array[1].length; i++){                             
                              promise_30[promise_30.length]  = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id, {bill_type:30});                  
                            }
                            promise_30[promise_30.length]  = this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch);
                                    
                            this.vhQuery.asyncPromiseAll(promise_30)
                                .then(()=>{                        
                                  resolve(null);                            
                                }) 
                        })
                        promise[promise.length] = new Promise((resolve, reject)=>{                   
                            let _bill_31 = {...array[0]}; //kiểm tra và xóa các giá trị ko cần thiết
                            delete _bill_31._id;   
                            delete _bill_31?.id_branch_receive;
                            _bill_31.bill_type = 31;             
                            _bill_31.id_branch = array[0].id_branch_receive;   
                            _bill_31.id_branch_send = array[0].id_branch;      
                            _bill_31.id_employee = this.vhAuth.getUser()._id; 
                            this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(billdate), _bill_31)             
                                .then((response:any)=>{    
                                  let promise_31 = new Array();                     
                                  for(let i=0; i<array[1].length; i++){
                                    let data = {...array[1][i]};
                                    delete data._id;   
                                    data.id_bill = response._id;                        
                                    data.id_branch = array[0].id_branch_receive;                                   
                                    data.bill_type = 31;                          
                                    data.id_employee = _bill_31.id_employee;                                       
                                    //-----------------------------------
                                    promise_31[promise_31.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(billdate), data);                  
                                  }
                                  promise_31[promise_31.length] = this.calculateQuantityProduct_UP(array[1],_bill_31.id_branch);
                                    
                                  this.vhQuery.asyncPromiseAll(promise_31)
                                      .then(()=>{                        
                                        resolve(null);                            
                                      })  
                                },(error:any)=>{
                                  console.log('error', error);
                                })
                        })
          
                        this.vhQuery.asyncPromiseAll(promise)
                            .then(()=>{                              
                              resolve(undefined)
                            })  
                      }else if(array[0].bill_type === 42){
                        let promise = new Array();                              
                        for(let i=0; i<array[1].length; i++){                                  
                          let value_voucher_code = {
                            products: array[1][i].products, 
                            date_sold : array[0].date, 
                            status: 2, 
                            id_customer: array[0].id_customer
                          }                     
                          promise[promise.length] = this.updateVoucherCode(array[1][i].id_voucher_code, value_voucher_code);    
                          let value_bill_detail ={
                            bill_code: bill_code, 
                            bill_type: newbill_type
                          }
                          promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id, value_bill_detail);         
                        }     
                        let value_bill ={
                          bill_code: bill_code, 
                          bill_type: newbill_type, 
                          sync_code: this.sync_code
                        }                       
                        promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, value_bill);                        
                        Promise.all(promise)
                              .then(()=>{  
                                resolve(undefined);                                                                                   
                              })
                      }else if(array[0].bill_type === 43){
                        let promise = new Array();      
                        for(let i=0; i<array[1].length; i++){                                   
                          let value_voucher_code = {                            
                            date_used : array[0].date, 
                            status: 4, 
                            id_customer: array[0].id_customer
                          }
                          promise[promise.length] = this.updateVoucherCode(array[1][i].id_voucher_code, value_voucher_code);                         
                          promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id);         
                        }  
                        
                        let bill_details = this.changeBillDetails_withPromotions_toRaw(array[1]);
                        for(let i=0; i<bill_details.length; i++){       
                          let bill_detail = {...bill_details[i]};                    
                          bill_detail.bill_code = bill_code;
                          bill_detail.bill_type = newbill_type;
                          delete bill_detail._id;
                          promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(billdate), bill_detail);
                        }
                        let value_bill ={
                          bill_code: bill_code, 
                          bill_type: newbill_type, 
                          sync_code: this.sync_code
                        }                       
                        promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, value_bill);                        
                        Promise.all(promise)
                              .then(()=>{  
                                //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                                this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch)
                                .then(()=>{
                                  resolve(undefined);
                                })                                                                                                     
                              })                      
                      }else if(array[0].bill_type === 52){
                        let promise = new Array();      
                        for(let i=0; i<array[1].length; i++){           
                          let _products = array[1][i].products;
                          for(let j=0; j<_products.length; j++){
                            _products[j].outquantity = 0;//giá trị này chỉ đc set khi bán thành công                            
                          }
                          let value_payment_card_code = {                            
                            products: _products, 
                            date_sold : array[0].date, 
                            status: 2, 
                            id_customer: array[0].id_customer
                          }
                          promise[promise.length] = this.updatePaymentCardCode(array[1][i].id_payment_card_code, value_payment_card_code);    
                          let value_bill_detail ={
                            bill_code: bill_code, 
                            bill_type: newbill_type
                          }
                          promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id, value_bill_detail);         
                        }     
                        let value_bill ={
                          bill_code: bill_code, 
                          bill_type: newbill_type, 
                          sync_code: this.sync_code
                        }                       
                        promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, value_bill);                        
                        Promise.all(promise)
                              .then(()=>{  
                                //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                                this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch)
                                      .then(()=>{
                                        resolve(undefined);
                                      })                                                                                       
                              })
                      }else if(array[0].bill_type === 53){
                        let promise = new Array();      
                        for(let i=0; i<array[1].length; i++){                            
                          let value_payment_card_code = {                                     
                            date_used : array[0].date, 
                            status: 4, 
                            id_customer: array[0].id_customer
                          }
                          promise[promise.length] = this.updatePaymentCardCode(array[1][i].id_payment_card_code, value_payment_card_code);    
                          promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id);                                 
                        }     
                        let bill_details = this.changeBillDetails_withPromotions_toRaw(array[1]);
                        for(let i=0; i<bill_details.length; i++){       
                          let bill_detail = {...bill_details[i]};                    
                          bill_detail.bill_code = bill_code;
                          bill_detail.bill_type = newbill_type;
                          delete bill_detail._id;
                          promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(billdate), bill_detail);
                        }

                        let value_bill ={
                          bill_code: bill_code, 
                          bill_type: newbill_type, 
                          sync_code: this.sync_code
                        }                       
                        promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(billdate), id_bill, value_bill);                        
                        Promise.all(promise)
                              .then(()=>{  
                                //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                                this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch)
                                      .then(()=>{
                                        resolve(undefined);
                                      })                                                                                       
                              })
                      }
                  })
        })      
    })  
  } 

  /**
   * hàm này chỉ dùng cho trường hợp bill_type 29->30 và 31
   * @example
    this.vhQuerySales.saveBill_Billdetail_3031('SzyEYNN39Mq90NkzUFpz')
        .then(()=>{
          console.log("success");
        })
   * @param id_bill 
   */
 private saveBill_Billdetail_3031(id_bill:any):any { 
   return new Promise((resolve, reject) => {   
      this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
      //lấy giá trị lúc tạo bill_type = 29
      let promise_0 = this.getBill(id_bill);
      let promise_1 = this.getBill_details_byID({id_bill:{$eq:id_bill}});
      Promise.all([promise_0, promise_1])
          .then((array:any)=>{     
            let billdate = array[0].date;              
            if(array[0].bill_type === 29){     
              let promise = new Array();             
              let promise_30 = new Array();                                                    
              let _bill_30 = {...array[0]};              
              _bill_30.bill_type = 30;                           
           
              promise[promise.length] = new Promise(resolve =>{
                this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(billdate), _bill_30)
                    .then((response:any)=>{
                      for(let i=0; i<array[1].length; i++){
                        let data = {...array[1][i]};
                        data.id_bill = response._id;
                        //---------------NEW-----------------
                        if(array[0].bill_code) data.bill_code = array[0].bill_code;
                        if(array[0].date)      data.date = array[0].date;
                        if(array[0].id_branch) data.id_branch = array[0].id_branch;                

                        if(typeof array[0].tax == 'number') data.tax = array[0].tax;             
                        data.bill_type = 30;
                        if(array[0].id_cashier) data.id_cashier = array[0].id_cashier;
                        if(array[0].id_employee) data.id_employee = array[0].id_employee;
                        if(array[0].id_supplier) data.id_supplier = array[0].id_supplier;
                        if(array[0].id_customer) data.id_customer = array[0].id_customer;
                        if(array[0].id_inventorytime) data.id_inventorytime = array[0].id_inventorytime;                   
                        //-----------------------------------
                        promise_30[promise_30.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(billdate), data);                  
                      }
                      promise_30[promise_30.length] = this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch);
                      this.vhQuery.asyncPromiseAll(promise_30)     
                          .then(()=>{
                            resolve(null);
                          })          
                    })
              })

              let promise_31 = new Array();       
              let _bill_31 = {... array[0]}; 
              _bill_31.bill_type = 31;       
              _bill_31.id_branch_send = array[0].id_branch; 
              _bill_31.id_branch = array[0].id_branch_receive;   
              delete _bill_31?.id_branch_receive;                        
              
              promise[promise.length] = new Promise(resolve =>{
                this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(billdate), _bill_31)             
                    .then((response:any)=>{
                      for(let i=0; i<array[1].length; i++){
                        let data = {...array[1][i]};
                        data.id_bill = response._id;
                        //---------------NEW-----------------
                        if(_bill_31.bill_code) data.bill_code = _bill_31.bill_code;
                        if(_bill_31.date) data.date = _bill_31.date;
                        if(_bill_31.id_branch) data.id_branch = _bill_31.id_branch;
                        if(_bill_31.id_branch_send) data.id_branch = _bill_31.id_branch_send;
                          
                        if(typeof _bill_31.tax == 'number') data.tax = _bill_31.tax;                     
                        data.bill_type = 31;
                        if(_bill_31.id_cashier) data.id_cashier = _bill_31.id_cashier;
                        if(_bill_31.id_employee) data.id_employee = _bill_31.id_employee;
                        if(_bill_31.id_supplier) data.id_supplier = _bill_31.id_supplier;
                        if(_bill_31.id_customer) data.id_customer = _bill_31.id_customer;
                        if(_bill_31.id_inventorytime) data.id_inventorytime = _bill_31.id_inventorytime;                   
                        //-----------------------------------
                        promise_31[promise_31.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(billdate), data);                  
                      }
                      promise_31[promise_31.length] = this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch);
                      this.vhQuery.asyncPromiseAll(promise_31)     
                            .then(()=>{
                              resolve(null);
                            })                        
                    })
              })
              this.vhQuery.asyncPromiseAll(promise)
                  .then(()=>{     
                    //Xóa bill_type 29 đi
                    let promise_one = new Array();        
                    promise_one[promise_one.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(billdate), id_bill);  
                    for(let i=0; i<array[1].length; i++){
                      promise_one[promise_one.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(billdate), array[1][i]._id); 
                    }                                                         
                    this.vhQuery.asyncPromiseAll(promise_one)
                        .then(()=>{          
                          resolve(true);                 
                        })                                      
                  })      
            }
          })
    })
  }

/**
 * Hàm này cập nhật lại giá nhập, dùng trong trường hợp createbill_billdetail và updatebill_billdetail với bill_type2
 * @example
    this.vhQuerySales.calculateUpdateImportPrice(bill_details,'SzyEYNN39Mq90NkzUFpz')
        .then(()=>{
          console.log("success");
        })
  */
  private calculateUpdateImportPrice(bill_details:any, id_branch:any){
    return new Promise((resolve, reject) => {           
      bill_details = cloneDeep(bill_details);   
      let promise_products = new Array();
      for(let i=0; i<bill_details.length; i++){  
        if(bill_details[i].ptype ===3){ 
          if(!bill_details[i].duplicated){    
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product;            
            for(let j=i+1; j<bill_details.length-1; j++){           
              if(!bill_details[j].duplicated){                               
                if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){  
                  if(bill_details[i].ratio === bill_details[j].ratio){                                            
                    bill_details[i].duplicated = true;                       
                  }
                }                                        
              }                                                      
            }   
          }
        }
      }
      bill_details = bill_details.filter((e:any)=>(e.duplicated!=true)&&(e.ptype === 3));
      //console.log('bill_details', bill_details);
      for(let i=0; i<bill_details.length; i++){         
        if(!bill_details[i].calculated){    
          let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product;     
          let product = this.getlocalDetailProduct(id_sub_or_product);         
          for(let j=0; j<bill_details.length; j++){           
            if(!bill_details[j].calculated){                               
              if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){  
                if(bill_details[j].price_origin){
                  if(bill_details[j].price_origin != bill_details[j].price){
                    for(let k=0; k<product.units.length; k++){  
                      if(product.units[k].ratio === bill_details[j].ratio){
                        if(product.units[k].price_import != bill_details[j].price){//điệu kiện này, nếu price_import đã cập nhật ở hàm createbill_billdetail thì ham updatebill_billdetail sẽ ko cập nhật lại
                          product.units[k].price_import = bill_details[j].price;
                          product.willupdate = true;
                        }
                      }
                    }
                  }
                }
                bill_details[j].calculated = true;    
              }                                        
            }                                                      
          }   
          if(product.willupdate){
            //console.log('product', product)
            promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{units: product.units});      
          }
        }        
      }

      this.vhQuery.asyncPromiseAll(promise_products)
          .then(()=>{  
            resolve(null)
          })  
    })
  }

  /**
   * @example
      this.vhQuerySales.calculateQuantityProduct_UP(bill_details,'SzyEYNN39Mq90NkzUFpz')
          .then(()=>{
            console.log("success");
          })
   */
  private calculateQuantityProduct_UP(bill_details:any, id_branch:any){
    return new Promise((resolve, reject) => {        
      bill_details = cloneDeep(bill_details);   
      let promise_products = new Array();
      for(let i=0; i<bill_details.length; i++){  
        //console.log(i, bill_details[i]);
        //tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
        if(bill_details[i].ptype ===3){ 
          if(!bill_details[i].calculated){                                                              
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product
            let product = this.getlocalDetailProduct(id_sub_or_product);  
            let quantity_all_bill_details = 0;       
            let lots = new Array();
            if(bill_details[i].id_lotproduct) lots = product.lots;            
            for(let j=0; j<bill_details.length; j++){     
              if(!bill_details[j].calculated){                               
                if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){                                              
                  quantity_all_bill_details = quantity_all_bill_details + bill_details[j].quantity * bill_details[j].ratio;
                  bill_details[j].calculated = true;
                  for(let m=0; m<lots.length; m++){
                    if(lots[m]._id === bill_details[j].id_lotproduct){
                      lots[m].quantity = lots[m].quantity + bill_details[j].quantity * bill_details[j].ratio;
                      lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] + bill_details[j].quantity * bill_details[j].ratio;
                    }
                  }
                }                                        
              }                                          
            }                                                                                         
            let quantity_branch = {...product.quantity_branch};     
            quantity_branch[id_branch] = quantity_branch[id_branch] + quantity_all_bill_details;                                 
            let quantity = product.quantity + quantity_all_bill_details;                                  
            if(lots.length >0){             
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, lots: lots});       
            }else{                 
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch});                                                                                                                      
            }                                                                                
          }                                                                                             
        }else{
          promise_products[promise_products.length] = new Promise<any>((resolve)=>{resolve(null);});
        }                              
      }  
      this.vhQuery.asyncPromiseAll(promise_products)
          .then(()=>{  
            resolve(null)
          })  
    })
  }

  /**
   * @example
      this.vhQuerySales.calculateQuantityProduct_UP_9(bill_details,'SzyEYNN39Mq90NkzUFpz')
          .then(()=>{
            console.log("success");
          })
   */
  private calculateQuantityProduct_UP_9(bill_details:any, id_branch:any){
    return new Promise((resolve, reject) => {           
      bill_details = cloneDeep(bill_details);  
      let promise_products = new Array();
      for(let i=0; i<bill_details.length; i++){  
        //console.log(i, bill_details[i]);
        //tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
        if(bill_details[i].ptype ===3){ 
          if(!bill_details[i].calculated){                                                              
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product
            let product = this.getlocalDetailProduct(id_sub_or_product);  
            let quantity_all_bill_details = 0;       
            let lots = new Array();
            if(bill_details[i].id_lotproduct) lots = product.lots;            
            for(let j=0; j<bill_details.length; j++){     
              if(!bill_details[j].calculated){                               
                if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){                                              
                  quantity_all_bill_details = quantity_all_bill_details + bill_details[j].quantity * bill_details[j].ratio;
                  bill_details[j].calculated = true;
                  for(let m=0; m<lots.length; m++){
                    if(lots[m]._id === bill_details[j].id_lotproduct){
                      lots[m].quantity = lots[m].quantity + bill_details[j].quantity * bill_details[j].ratio;
                      lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] + bill_details[j].quantity * bill_details[j].ratio;
                    }
                  }
                }                                        
              }                                          
            }                                                                                         
            let quantity_branch = {...product.quantity_branch};     
            quantity_branch[id_branch] = quantity_branch[id_branch] + quantity_all_bill_details;                                 
            let quantity = product.quantity + quantity_all_bill_details;  
            //nếu có thay đổi tồn đầu kỳ thì xóa inventory, sau đó khi phần mềm restart lại sẽ tính mới lại giá trị này   
            let value:any = {};
			value[id_branch + '_ivtr'] = null;			
            if(lots.length >0){             
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, lots: lots, ...value});       
            }else{                 
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, ...value});                                                                                                                      
            }                                                                                
          }                                                                                             
        }else{
          promise_products[promise_products.length] = new Promise<any>((resolve)=>{resolve(null);});
        }                              
      }  
      this.vhQuery.asyncPromiseAll(promise_products)
          .then(()=>{  
            resolve(null)
          })  
    })
  }

  /**
   * @example
      this.vhQuerySales.calculateQuantityProduct_DOWN(bill_details,'SzyEYNN39Mq90NkzUFpz')
          .then(()=>{
            console.log("success");
          })
   */
  private calculateQuantityProduct_DOWN(bill_details:any, id_branch:any){
    return new Promise((resolve, reject) => {          
      bill_details = cloneDeep(bill_details);      
      let promise_products = new Array();
      for(let i=0; i<bill_details.length; i++){  
        //console.log(i, bill_details[i]);
        //giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
        if(bill_details[i].ptype ===3){ 
          if(!bill_details[i].calculated){                                                              
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product
            let product = this.getlocalDetailProduct(id_sub_or_product);  
            let quantity_all_bill_details = 0;       
            let lots = new Array();
            if(bill_details[i].id_lotproduct) lots = product.lots;            
            for(let j=0; j<bill_details.length; j++){     
              if(!bill_details[j].calculated){                               
                if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){                                              
                  quantity_all_bill_details = quantity_all_bill_details + bill_details[j].quantity * bill_details[j].ratio;
                  bill_details[j].calculated = true;
                  for(let m=0; m<lots.length; m++){
                    if(lots[m]._id === bill_details[j].id_lotproduct){
                      lots[m].quantity = lots[m].quantity - bill_details[j].quantity * bill_details[j].ratio;
                      lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] - bill_details[j].quantity * bill_details[j].ratio;
                    }
                  }
                }                                        
              }                                          
            }                                                                                         
            let quantity_branch = {...product.quantity_branch};     
            quantity_branch[id_branch] = quantity_branch[id_branch] - quantity_all_bill_details;                                 
            let quantity = product.quantity - quantity_all_bill_details;                                  
            if(lots.length >0){             
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, lots: lots});       
            }else{                 
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch});                                                                                                                      
            }                                                                                
          }                                                                                             
        }else{
          promise_products[promise_products.length] = new Promise<any>((resolve)=>{resolve(null);});
        }                              
      }  
      this.vhQuery.asyncPromiseAll(promise_products)
          .then(()=>{  
            resolve(null)
          })  
    })
  }

    /**
   * @example
      this.vhQuerySales.calculateQuantityProduct_DOWN(bill_details,'SzyEYNN39Mq90NkzUFpz')
          .then(()=>{
            console.log("success");
          })
   */
  private calculateQuantityProduct_DOWN_9(bill_details:any, id_branch:any){
    return new Promise((resolve, reject) => {           
      bill_details = cloneDeep(bill_details); 
      let promise_products = new Array();
      for(let i=0; i<bill_details.length; i++){  
        //console.log(i, bill_details[i]);
        //giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
        if(bill_details[i].ptype ===3){ 
          if(!bill_details[i].calculated){                                                              
            let id_sub_or_product = bill_details[i].id_subproduct?bill_details[i].id_subproduct:bill_details[i].id_product
            let product = this.getlocalDetailProduct(id_sub_or_product);  
            let quantity_all_bill_details = 0;       
            let lots = new Array();
            if(bill_details[i].id_lotproduct) lots = product.lots;            
            for(let j=0; j<bill_details.length; j++){     
              if(!bill_details[j].calculated){                               
                if(id_sub_or_product === (bill_details[j].id_subproduct?bill_details[j].id_subproduct:bill_details[j].id_product)){                                              
                  quantity_all_bill_details = quantity_all_bill_details + bill_details[j].quantity * bill_details[j].ratio;
                  bill_details[j].calculated = true;
                  for(let m=0; m<lots.length; m++){
                    if(lots[m]._id === bill_details[j].id_lotproduct){
                      lots[m].quantity = lots[m].quantity - bill_details[j].quantity * bill_details[j].ratio;
                      lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] - bill_details[j].quantity * bill_details[j].ratio;
                    }
                  }
                }                                        
              }                                          
            }                                                                                         
            let quantity_branch = {...product.quantity_branch};     
            quantity_branch[id_branch] = quantity_branch[id_branch] - quantity_all_bill_details;                                 
            let quantity = product.quantity - quantity_all_bill_details;   
            
            //nếu có thay đổi tồn đầu kỳ thì xóa inventory, sau đó khi phần mềm restart lại sẽ tính mới lại giá trị này   
            let value:any = {};
            value[id_branch + '_ivtr'] = null;
            if(lots.length >0){             
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, lots: lots,...value});       
            }else{                 
              promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, ...value});                                                                                                                      
            }                                                                                
          }                                                                                             
        }else{
          promise_products[promise_products.length] = new Promise<any>((resolve)=>{resolve(null);});
        }                              
      }  
      this.vhQuery.asyncPromiseAll(promise_products)
          .then(()=>{  
            resolve(null)
          })  
    })
  }
  /**
   * hàm này chỉ dùng cho trường hợp bill đã lưu rồi mà muốn sửa, bill_type trước khi sửa và sau khi sửa phải giống nhau
   * Lưu ý: trương bill_type (trong bill), trước và sau khi cập nhật phải cùng giá trị
   * @example
    this.vhQuerySales.updateBill_Billdetail('SzyEYNN39Mq90NkzUFpz',{},[{},{},...])
        .then(()=>{
          console.log("success");
        })
   * @param id_bill 
   * @param bill (bill phải đủ các field) 
   * @param bill_details (bill_details phải đủ các field) 
   * @returns 
   */
  public updateBill_Billdetail(id_bill:any, bill:any, bill_details:any):any {
    console.log('s_updateBill_Billdetail', id_bill, bill)
    // đã làm theo ý tưởng mới, không lưu tồn đầu kỳ bill_type_9 trong sản phẩm product       
    //Kiểm tra lại trương hợp 2 bill cùng mở, nhưng bill lưu trước bill lưu sau    
    if((bill.bill_type != 40)&&(bill.bill_type != 42)&&(bill.bill_type != 43)&&(bill.bill_type != 50)&&(bill.bill_type != 52)&&(bill.bill_type != 53)){
      bill_details = this.changeBillDetails_withPromotions_toRaw(bill_details);      
      if(!bill_details) return null;              
    }   
    //Nếu bill không có trường date thi Promise ko chạy, Dev sẽ biết mà fix lỗi truyền lại giá trị (bắt buộc bill phải có trường date)
    if(!bill.date) {console.log(); return null;}
    return new Promise((resolve, reject) => { 
       this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
       bill.sync_code = this.sync_code;
       let bill_code:any = this.vhAlgorithm.createBillCode(bill.date);
       let delete_Bill_Billdetail = new Promise<any>((resolve)=>{
         let promise_0 = this.vhMGDB_database.getDoc('vhs_bills_' + this.getYear(bill.date), id_bill);
         let promise_1 = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + this.getYear(bill.date), {id_bill:{$eq:id_bill}},{},{},0);
         let promise_2 =  this.createBillCode(bill.date, bill.bill_type);
         this.vhQuery.asyncPromiseAll([promise_0, promise_1, promise_2])
             .then((array:any)=>{                   
               if(array[0].bill_type === bill.bill_type) bill_code = array[0].bill_code;           
               else bill_code = array[2];                   
               //Xóa các bill_type này làm tăng quantity trong products  
               if ((array[0].bill_type === 1)||(array[0].bill_type === 10)||(array[0].bill_type === 15)||(array[0].bill_type === 38)){
                   let promise = new Array();        
                   for(let i=0; i<array[1].length; i++){
                     promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), array[1][i]._id); 
                   }   
                   promise[promise.length] = this.calculateQuantityProduct_UP(array[1],array[0].id_branch);                                    
                   this.vhQuery.asyncPromiseAll(promise)
                       .then(()=>{          
                         resolve(array);                     
                       })                
               //Xóa các bill_type này làm giảm quantity trong products        
               }else if((array[0].bill_type === 2) || (array[0].bill_type === 3)||(array[0].bill_type === 39)){
                   let promise = new Array();        
                   for(let i=0; i<array[1].length; i++){
                     promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), array[1][i]._id); 
                   }
                   promise[promise.length] = this.calculateQuantityProduct_DOWN(array[1],array[0].id_branch);                                    
                   this.vhQuery.asyncPromiseAll(promise)
                       .then(()=>{          
                         resolve(array);                     
                       })                                 
               //Xóa các bill_type này làm giảm quantity trong products        
               }else if(array[0].bill_type === 9){                    
                 let promise = new Array();        
                 for(let i=0; i<array[1].length; i++){
                   promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), array[1][i]._id); 
                 }
                 promise[promise.length] = this.calculateQuantityProduct_DOWN_9(array[1],array[0].id_branch);                                    
                 this.vhQuery.asyncPromiseAll(promise)
                     .then(()=>{          
                       resolve(array);                     
                     })                                                        
               //những bill_type này ko làm thay đổi quantity trong products                            
               }else if((array[0].bill_type === 5)||(array[0].bill_type === 6)||(array[0].bill_type === 13)||(array[0].bill_type === 14)||(array[0].bill_type === 16)
                         ||(array[0].bill_type === 18)||(array[0].bill_type === 19)||(array[0].bill_type === 20)||(array[0].bill_type === 21)||(array[0].bill_type === 29)||(array[0].bill_type === 36)){
                 let promise = new Array();  
                 let _ids = new Array();         
                 for(let i=0; i<array[1].length; i++){
                   //promise[i] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), array[1][i]._id); 
                   _ids.push(array[1][i]._id)
                 }      
                if(_ids.length > 0) promise[promise.length] = this.vhMGDB_database.deleteDocs('vhs_bill_details_' + this.getYear(bill.date), _ids); 
                 this.vhQuery.asyncPromiseAll(promise)
                     .then(()=>{  
                        console.log('s_updateBill_Billdetail_1', array)
                        resolve(array);                         
                     }) 
               }else if((array[0].bill_type === 40)||(array[0].bill_type === 42)||(array[0].bill_type === 43)
                         ||(array[0].bill_type === 50)||(array[0].bill_type === 52)||(array[0].bill_type === 53)){
                 let promise = new Array();        
                 for(let i=0; i<array[1].length; i++){
                   promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), array[1][i]._id); 
                 }               
                 this.vhQuery.asyncPromiseAll(promise)
                     .then(()=>{  
                       resolve(array);                         
                     }) 
               }else if(bill.bill_type === 41){              
                 console.log('Nói anh Huy viết hàm trường hợp bill_type 41');
               }else if(bill.bill_type === 51){              
                 console.log('Nói anh Huy viết hàm trường hợp bill_type 51');
               }else{
                 reject('Lưu không thành công, vui lòng kiểm tra lại.')
               }              
             })
       });             
       
       //this.ordinaryQuery.async_waiting_newPromiseAll(delete_Bill_Billdetail).then((array:any)=>{
       delete_Bill_Billdetail.then((array:any)=>{           
         //Xuất các bill_type này làm giảm quantity trong products  
         if((bill.bill_type === 1)||(bill.bill_type === 10)||(bill.bill_type === 15)||(array[0].bill_type === 38)){              
             let promise = new Array();                                                    
             let _bill = {...bill}; 
             _bill.bill_code = bill_code;        
             _bill.id_branch = array[0].id_branch;   
             if(!_bill.date) _bill.date = array[0].date;//xem lại giá trị này lấy thời gian lúc tính tiền sẽ hợp lý hơn                                            
             //test xong xóa hàm này 
             //_bill.date = array[0].date;            
             if(bill.bill_type == 1) bill.cqt_status = 1;
             delete _bill._id;
             promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, _bill);

             let dataList = new Array();
             for(let i=0; i<bill_details.length; i++){
               let data = {...bill_details[i]};
               data.id_bill = id_bill;
               //---------------NEW-----------------
               data.bill_code = bill_code;                  
               if(array[0].id_branch) data.id_branch = array[0].id_branch;//xem lại giá trị này
               if(array[0].date) data.date = array[0].date;//xem lại giá trị này lấy thời gian lúc tính tiền sẽ hợp lý hơn
               if(bill.date) data.date = bill.date;

               if(typeof bill.tax == 'number') data.tax = bill.tax;
               if(typeof bill.bill_type == 'number') data.bill_type = bill.bill_type;
               if(bill.id_cashier) data.id_cashier = bill.id_cashier;
               if(bill.id_employee) data.id_employee = bill.id_employee;
               if(bill.id_supplier) data.id_supplier = bill.id_supplier;
               if(bill.id_customer) data.id_customer = bill.id_customer;
               if(bill.id_inventorytime) data.id_inventorytime = bill.id_inventorytime;                  
               //-----------------------------------
               //promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);       
               delete data._id;
               dataList.push(data)           
             }
             if(dataList.length >0) promise[promise.length] = this.vhMGDB_database.addDocs('vhs_bill_details_' + this.getYear(bill.date), dataList);     
             promise[promise.length] = this.calculateQuantityProduct_DOWN(bill_details,bill.id_branch);
             this.vhQuery.asyncPromiseAll(promise)
                 .then(()=>{          
                   console.log('s_updateBill_Billdetail_2', id_bill)
                   resolve(id_bill);                                          
                 })  
         //Nhập các bill_type này làm tăng quantity trong products           
         }else if((bill.bill_type === 2)||(array[0].bill_type === 3)||(array[0].bill_type === 39)){
           let promise = new Array();                                                    
           let _bill = {...bill}; 
           _bill.bill_code = bill_code;     
           _bill.id_branch = array[0].id_branch;   
           if(!_bill.date) _bill.date = array[0].date;                                         

           promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, _bill);

           for(let i=0; i<bill_details.length; i++){
             let data = {...bill_details[i]};
             data.id_bill = id_bill;
             //---------------NEW-----------------
             data.bill_code = bill_code;                 
             if(array[0].id_branch) data.id_branch = array[0].id_branch;
             if(array[0].date) data.date = array[0].date;
             if(bill.date) data.date = bill.date;

             if(typeof bill.tax == 'number') data.tax = bill.tax;
             if(typeof bill.bill_type == 'number') data.bill_type = bill.bill_type;
             if(bill.id_cashier) data.id_cashier = bill.id_cashier;
             if(bill.id_employee) data.id_employee = bill.id_employee;
             if(bill.id_supplier) data.id_supplier = bill.id_supplier;
             if(bill.id_customer) data.id_customer = bill.id_customer;
             if(bill.id_inventorytime) data.id_inventorytime = bill.id_inventorytime;                 
             //-----------------------------------
             promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);                  
           }       
           promise[promise.length] = this.calculateQuantityProduct_UP(bill_details,bill.id_branch);        
           this.vhQuery.asyncPromiseAll(promise)
               .then(()=>{          
                 this.calculateUpdateImportPrice(bill_details, bill.id_branch)
                       .then(()=>{
                         resolve(id_bill);
                       })                 
               })          
         //Nhập các bill_type này làm tăng quantity trong products           
         }else if(bill.bill_type === 9){
           let promise = new Array();                                                    
           let _bill = {...bill}; 
           _bill.bill_code = bill_code;     
           _bill.id_branch = array[0].id_branch;   
           if(!_bill.date) _bill.date = array[0].date;                                         

           promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, _bill);              
           for(let i=0; i<bill_details.length; i++){
             let data = {...bill_details[i]};
             data.id_bill = id_bill;
             //---------------NEW-----------------
             data.bill_code = bill_code;                 
             if(array[0].id_branch) data.id_branch = array[0].id_branch;
             if(array[0].date) data.date = array[0].date;
             if(bill.date) data.date = bill.date;

             if(typeof bill.tax == 'number') data.tax = bill.tax;
             if(typeof bill.bill_type == 'number') data.bill_type = bill.bill_type;
             if(bill.id_cashier) data.id_cashier = bill.id_cashier;
             if(bill.id_employee) data.id_employee = bill.id_employee;
             if(bill.id_supplier) data.id_supplier = bill.id_supplier;
             if(bill.id_customer) data.id_customer = bill.id_customer;
             if(bill.id_inventorytime) data.id_inventorytime = bill.id_inventorytime;                 
             //-----------------------------------
             promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);                              
           }               
           promise[promise.length] = this.calculateQuantityProduct_UP_9(bill_details,bill.id_branch);
           this.vhQuery.asyncPromiseAll(promise)
               .then(()=>{          
                 resolve(id_bill);                                      
               })                       
         //những bill_type này ko làm thay đổi quantity trong products          
         }else if((bill.bill_type === 5)||(bill.bill_type === 6)||(bill.bill_type === 13)||(bill.bill_type === 14)||(bill.bill_type === 16)
               ||(bill.bill_type === 18)||(bill.bill_type === 19)||(bill.bill_type === 20)||(bill.bill_type === 21)||(bill.bill_type === 29)||(bill.bill_type === 36)
               ||(bill.bill_type === 40)||(bill.bill_type === 42)||(bill.bill_type === 43)||(bill.bill_type === 50)||(bill.bill_type === 52)||(bill.bill_type === 53)){
             let promise = new Array();                                                    
             let _bill = {...bill}; 
             _bill.bill_code = bill_code;      
             _bill.id_branch = array[0].id_branch;      
             if(!_bill.date) _bill.date = array[0].date;                                           
           
             promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, _bill);

             for(let i=0; i<bill_details.length; i++){
               let data = {...bill_details[i]};
               data.id_bill = id_bill;
               //---------------NEW-----------------
               data.bill_code = bill_code;                 
               if(array[0].id_branch) data.id_branch = array[0].id_branch;
               if(array[0].date) data.date = array[0].date;
               if(bill.date) data.date = bill.date;

               if(typeof bill.tax == 'number') data.tax = bill.tax;
               if(typeof bill.bill_type == 'number') data.bill_type = bill.bill_type;
               if(bill.id_cashier) data.id_cashier = bill.id_cashier;
               if(bill.id_employee) data.id_employee = bill.id_employee;
               if(bill.id_supplier) data.id_supplier = bill.id_supplier;
               if(bill.id_customer) data.id_customer = bill.id_customer;
               if(bill.id_inventorytime) data.id_inventorytime = bill.id_inventorytime;                 
               //-----------------------------------
               promise[promise.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);                  
             } 

             this.vhQuery.asyncPromiseAll(promise)
                 .then(()=>{  
                   resolve(id_bill);                
                 })  
         //xuất các bill_type này làm giảm quantity trong products       
         }else if(bill.bill_type === 3031){//sinh ra 2 bill_type 30(chi nhánh A xuất đến chi nhánh B) và 31(chi nhánh B nhận từ chi nhánh A)
           let promise = new Array();             
           promise[promise.length] = new Promise((resolve, reject)=>{
               let promise_30 = new Array();       
               //lấy giá trị lúc tạo bill_type = 29                                             
               let _bill_30 = {...array[0]};            
               delete _bill_30._id;   
               _bill_30.bill_type = 30;                
                                   
               promise_30[promise_30.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, {bill_type:30});

               for(let i=0; i<array[1].length; i++){
                 let data = {...array[1][i]};
                 delete data._id;                  
                 data.bill_type = 30;               
                 promise_30[promise_30.length]  = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);                  
               }
               promise_30[promise_30.length]  = this.calculateQuantityProduct_DOWN(array[1],_bill_30.id_branch);
                       
               this.vhQuery.asyncPromiseAll(promise_30)
                   .then(()=>{                        
                     resolve(null);                            
                   }) 
           })
           promise[promise.length] = new Promise((resolve, reject)=>{                   
               let _bill_31 = {...array[0]}; //kiểm tra và xóa các giá trị ko cần thiết
               delete _bill_31._id;   
               delete _bill_31?.id_branch_receive;
               _bill_31.bill_type = 31;             
               _bill_31.id_branch = array[0].id_branch_receive;   
               _bill_31.id_branch_send = array[0].id_branch;      
               _bill_31.id_employee = this.vhAuth.getUser()._id; 
               this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(bill.date), _bill_31)             
                   .then((response:any)=>{    
                     let promise_31 = new Array();                     
                     for(let i=0; i<array[1].length; i++){
                       let data = {...array[1][i]};
                       delete data._id;   
                       data.id_bill = response._id;                        
                       data.id_branch = array[0].id_branch_receive;                                   
                       data.bill_type = 31;                          
                       data.id_employee = _bill_31.id_employee;                                       
                       //-----------------------------------
                       promise_31[promise_31.length] = this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill.date), data);                  
                     }
                     promise_31[promise_31.length] = this.calculateQuantityProduct_UP(array[1],_bill_31.id_branch);
                       
                     this.vhQuery.asyncPromiseAll(promise_31)
                         .then(()=>{                        
                           resolve(null);                            
                         })  
                   },(error:any)=>{
                     console.log('error', error);
                   })
           })

           this.vhQuery.asyncPromiseAll(promise)
               .then(()=>{                              
                 resolve(id_bill)
               })      
         }else if(bill.bill_type === 41){              
           console.log('Nói anh Huy viết hàm trường hợp bill_type 41');
         }else if(bill.bill_type === 51){              
           console.log('Nói anh Huy viết hàm trường hợp bill_type 51');
         }     

       },error=>reject(error))                    
    })         
  }

  /**
   * VhQuerySales:
   * Lưu ý: xóa tất cả các bill_type(từ 1 đến 28, 40, 41, 50, 51) đều dùng hàm này, chưa có xóa bill_type 30 và 31 
   * @example
   this.vhQuerySales.deleteBill_Billdetail('RcECbNgU9BdYQo37s30p')
        .then((bool:any)=>{
          if(bool){
            console.log('success');
          }else{
            console.log('no success');
          }          
        },(error:any)=>{
          console.log('error ', error);
        })   
   * @param id_bill 
   * @return Promise => null or orror
   */
   public deleteBill_Billdetail(id_bill:any):any {         
    return new Promise((resolve, reject) => {    
        let promise_0 = this.getBill(id_bill);        
        let promise_1 = this.getBill_details_byID({id_bill:{$eq:id_bill}});
        let promise_2 = this.vhMGDB_database.getDocsByFields('coupon_codes', {id_bill:{$eq:id_bill}},{},{},0); 
        let promise_3 = this.vhMGDB_database.getDocsByFields('voucher_codes', {id_bill:{$eq:id_bill}},{},{},0);  //không dùng sẽ bỏ đi
        let promise_4 = this.vhMGDB_database.getDocsByFields('payment_card_codes', {id_bill:{$eq:id_bill}},{},{},0); //không dùng sẽ bỏ đi       
        this.vhQuery.asyncPromiseAll([promise_0, promise_1, promise_2, promise_3, promise_4])
            .then((array:any)=>{         
              let promise = new Array();    
              let bill = {...array[0]};
              let bill_details = [...array[1]];
              let display_bill_details = this.changeBillDetails_withRaw_toPromotions(array[1]);     
              if(bill){    
        //XÓA BILL và BILL_DETAILS              
                //xóa bill_type(bán hàng) này làm tăng quantity trong products, và vẫn giữ bill lại nhưng chuyển trang thái 4 
                if(bill.bill_type === 1){                                   
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);
             
                  //Xóa liên kết ở shop TMĐT
                  if((bill.id_shop != undefined)&&(bill.order_number_ecommerce != undefined)){                      
                    this.vhMGDB_database.updateDoc(bill.id_shop, bill.order_number_ecommerce, {id_bill_delivered_goods:null});             
                  }
                  
                  for(let i=0; i<array[2].length; i++){
                    this.vhMGDB_database.updateDoc('coupon_codes', array[2][i]._id, {id_bill:null, date_used: null, status:3}); 
                  }
                  Promise.all(promise)
                        .then(()=>{
                          //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                          this.calculateQuantityProduct_UP(bill_details,bill.id_branch)
                              .then(()=>{
                                resolve(true);
                              })  
                        })                    
                //xóa bill_type(nhập hàng) này làm giảm quantity trong products, và vẫn giữ bill lại nhưng chuyển trang thái 22     
                }else if(bill.bill_type === 2){      
                  /*            
                  for(let i=0; i<bill_details.length; i++){  
                    promise[i] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id,{bill_type: 22});                     
                  }  
                  promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, {bill_type:22});
                  */
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);
                  Promise.all(promise)
                          .then(()=>{
                            //Sau khi xóa, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                            this.calculateQuantityProduct_DOWN(bill_details,bill.id_branch)
                                .then(()=>{
                                  resolve(true);
                                }) 
                          })     
                //xóa bill_type(khách trả hàng) này làm giảm quantity trong products, và vẫn giữ bill lại nhưng chuyển trang thái 23     
                }else if(bill.bill_type === 3){      
                  /*            
                  for(let i=0; i<bill_details.length; i++){  
                    promise[i] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id,{bill_type: 23});                   
                  } 
                  promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, {bill_type:23});
                  */
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);
                 
                  //Xóa liên kết ở shop TMĐT
                  if((bill.id_shop != undefined)&&(bill.order_number_ecommerce != undefined)){      
                    this.vhMGDB_database.updateDoc(bill.id_shop, bill.order_number_ecommerce, {id_bill_received_goods:null});          
                  }
                  Promise.all(promise)
                          .then(()=>{
                            //Sau khi xóa, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                            this.calculateQuantityProduct_DOWN(bill_details,bill.id_branch)
                                .then(()=>{
                                  resolve(true);
                                }) 
                          })     
                //xóa bill_type(trả lại NCC) này làm tăng quantity trong products, và vẫn giữ bill lại nhưng chuyển trang thái 24    
                }else if(bill.bill_type === 10){       
                  /*           
                  for(let i=0; i<bill_details.length; i++){  
                    promise[i] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id,{bill_type: 24});                    
                  } 
                  promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, {bill_type:24}); 
                  */  
                 
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);  
                  Promise.all(promise)
                        .then(()=>{
                          //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                          this.calculateQuantityProduct_UP(bill_details,bill.id_branch)
                              .then(()=>{
                                resolve(true);
                              })  
                        })                        
                //xóa bill_type(xuất hóa đơn bảo hành) này làm tăng quantity trong products, và vẫn giữ bill lại nhưng chuyển trang thái 17    
                }else if(bill.bill_type === 15){              
                  /*    
                  for(let i=0; i<bill_details.length; i++){  
                    promise[i] = this.vhMGDB_database.updateDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id,{bill_type: 17});                      
                  }      
                  promise[promise.length] = this.vhMGDB_database.updateDoc('vhs_bills_' + this.getYear(bill.date), id_bill, {bill_type:17}); 
                  */ 
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);
                  Promise.all(promise)
                        .then(()=>{
                          //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                          this.calculateQuantityProduct_UP(bill_details,bill.id_branch)
                              .then(()=>{
                                resolve(true);
                              })  
                        })    
                //Xóa bill_type(tồn đầu kỳ) này làm giảm quantity trong products, và bill bị xóa luôn    
                }else if(bill.bill_type === 9){                          
                    for(let i=0; i<bill_details.length; i++){
                      promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                    }                                               
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);            
                    Promise.all(promise)
                          .then(()=>{
                            //Sau khi xóa, giảm số lượng kho xuống 
                            this.calculateQuantityProduct_DOWN_9(bill_details,bill.id_branch)
                                .then(()=>{
                                  resolve(true);
                                })  
                          })     
                //xóa những bill_type này ko làm thay đổi quantity trong products         
                }else if ((bill.bill_type === 5)||(bill.bill_type === 6)||(bill.bill_type === 13)||(bill.bill_type === 14)
                          ||(bill.bill_type === 16)||(bill.bill_type === 18)||(bill.bill_type === 19)
                          ||(bill.bill_type === 20)||(bill.bill_type === 21)||(bill.bill_type === 29)
                          ){                          
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }                                               
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);                          
                  Promise.all(promise)
                        .then(()=>{
                          resolve(true);
                        })  
                //xóa bill_type này, vẫn giữ bill lại nhưng chuyển trang thái khác    
                }else if((bill.bill_type === 7)||(bill.bill_type === 8)||(bill.bill_type === 11)||(bill.bill_type === 12)){               
                  return reject({message: 'Loại bill_type ' + bill.bill_type + 'này không phát sinh bill_detail dùng hàm deleteBill xóa'});                
                }else if (bill.bill_type === 40){//phiếu bán voucher   
                      //Kiểm tra xem có voucher nào được sử dụng đổi hàng hàng chưa, nếu sử dụng rồi thì không xóa được                         
                      let promise_bill_details = new Array();
                      for(let i=0; i<bill_details.length; i++){                              
                        promise_bill_details[i] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + this.getYear(bill.date), {id_voucher_code: {$eq:bill_details[i].id_voucher_code}, bill_type: {$eq:41}})           
                      }
                      this.vhQuery.asyncPromiseAll(promise_bill_details)
                          .then((array:any)=>{  
                            array = array.filter((e:any)=>e.length >0);                                          
                            if(array.length >0){      
                              console.log({error:'Voucher đã được sử dụng đổi hàng hóa nên không xóa được'});  
                              return resolve(false);
                            }else{                              
                              for(let i=0; i<bill_details.length; i++){
                                promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                              }                                               
                              promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                              this.vhQuery.asyncPromiseAll(promise)
                                  .then(()=>{   
                                    let promise_updatevouchers = new Array();
                                    for(let i=0; i<bill_details.length; i++){                 
                                      promise_updatevouchers[i] = this.vhMGDB_database.updateDoc('voucher_codes', bill_details[i].id_voucher_code, {date_sold:null, status:1, id_customer: null})           
                                    }
                                    this.vhQuery.asyncPromiseAll(promise_updatevouchers)
                                        .then(()=>{  
                                          return resolve(true)
                                        })    
                                  }) 
                            }
                          })    
                //xóa bill_type(xuất hóa đơn hủy hàng hóa) này làm tăng quantity trong products    
                }else if(bill.bill_type === 38){              
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);
                  Promise.all(promise)
                        .then(()=>{
                          //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                          this.calculateQuantityProduct_UP(bill_details,bill.id_branch)
                              .then(()=>{
                                resolve(true);
                              })  
                        }) 
                }else if (bill.bill_type === 40){//phiếu bán voucher   
                  //Kiểm tra xem có voucher nào được sử dụng đổi hàng hàng chưa, nếu sử dụng rồi thì không xóa được                         
                  let promise_bill_details = new Array();
                  for(let i=0; i<bill_details.length; i++){                              
                    promise_bill_details[i] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + this.getYear(bill.date), {id_voucher_code: {$eq:bill_details[i].id_voucher_code}, bill_type: {$eq:41}})           
                  }
                  this.vhQuery.asyncPromiseAll(promise_bill_details)
                      .then((array:any)=>{  
                        array = array.filter((e:any)=>e.length >0);                                          
                        if(array.length >0){      
                          console.log({error:'Voucher đã được sử dụng đổi hàng hóa nên không xóa được'});  
                          return resolve(false);
                        }else{                              
                          for(let i=0; i<bill_details.length; i++){
                            promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                          }                                               
                          promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                          this.vhQuery.asyncPromiseAll(promise)
                              .then(()=>{   
                                let promise_updatevouchers = new Array();
                                for(let i=0; i<bill_details.length; i++){                 
                                  promise_updatevouchers[i] = this.vhMGDB_database.updateDoc('voucher_codes', bill_details[i].id_voucher_code, {date_sold:null, status:1, id_customer: null})           
                                }
                                this.vhQuery.asyncPromiseAll(promise_updatevouchers)
                                    .then(()=>{  
                                      return resolve(true)
                                    })    
                              }) 
                        }
                      })      
                }else if (bill.bill_type === 41){//phiếu đổi voucher
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }                                               
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);     
                  Promise.all(promise)
                        .then(()=>{
                          let promise_one = new Array();
                          //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                          promise_one[promise_one.length] = this.calculateQuantityProduct_UP(bill_details,bill.id_branch);
                                                  
                          //trả voucher về trạng thái đã bán 2 hoặc đã đổi từ điểm 3    
                          promise_one[promise_one.length] = new Promise((resolve, reject)=>{
                            this.vhMGDB_database.getDoc('voucher_codes', bill_details[0].id_voucher_code)
                                .then((voucher_code:any)=>{
                                  if(voucher_code){
                                    let value:any = {
                                      date_used: null
                                    }
                                    if(voucher_code.date_sold) value.status= 2;                                                                    
                                    else value.status= 3; 
                                    this.vhMGDB_database.updateDoc('voucher_codes', bill_details[0].id_voucher_code, value)
                                        .then(()=>{
                                          resolve(null)
                                        })
                                  }
                                })
                          })                        
                          this.vhQuery.asyncPromiseAll(promise_one)
                              .then(()=>{
                                resolve(true)}) 
                              }) 
                }else if (bill.bill_type === 42){//phiếu đặt mua voucher   
                  //Kiểm tra xem có voucher nào đã được mua, hoặc được sử dụng đổi hàng hàng chưa, nếu rồi thì không xóa được                         
                  let promise_bill_details = new Array();
                  for(let i=0; i<bill_details.length; i++){                              
                    promise_bill_details[i] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + this.getYear(bill.date), {id_voucher_code: {$eq:bill_details[i].id_voucher_code}, bill_type: {$eq:[40,41]}})           
                  }
                  this.vhQuery.asyncPromiseAll(promise_bill_details)
                      .then((array:any)=>{  
                        array = array.filter((e:any)=>e.length >0);                                                   
                        if(array.length >0){      
                          console.log({error:'Voucher đã được sử dụng đổi hàng hóa nên không xóa được'});  
                          return resolve(false);
                        }else{                              
                          for(let i=0; i<bill_details.length; i++){
                            promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                          }                                               
                          promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                          this.vhQuery.asyncPromiseAll(promise)
                              .then(()=>{   
                                let promise_updatevouchers = new Array();
                                for(let i=0; i<bill_details.length; i++){                
                                  promise_updatevouchers[i] = this.vhMGDB_database.deleteDoc('voucher_codes', bill_details[i].id_voucher_code)           
                                }
                                this.vhQuery.asyncPromiseAll(promise_updatevouchers)
                                    .then(()=>{  
                                      return resolve(true)
                                    })    
                              }) 
                        }
                      })              
                }else if (bill.bill_type === 43){//phiếu đặt đổi voucher lấy hàng hóa
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }                                               
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);     
                  Promise.all(promise)
                        .then(()=>{
                          let promise_one = new Array();
                          //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                          //promise_one[promise_one.length] = this.calculateQuantityProduct_UP(bill_details,bill.id_branch);
                                                  
                          //trả voucher về trạng thái đã bán 2 hoặc đã đổi từ điểm 3    
                          promise_one[promise_one.length] = new Promise((resolve, reject)=>{
                            this.vhMGDB_database.getDoc('voucher_codes', bill_details[0].id_voucher_code)
                                .then((voucher_code:any)=>{
                                  if(voucher_code){
                                    let value:any = {
                                      date_used: null
                                    }
                                    if(voucher_code.date_sold) value.status= 2;                                                                    
                                    else value.status= 3; 
                                    this.vhMGDB_database.updateDoc('voucher_codes', bill_details[0].id_voucher_code, value)
                                        .then(()=>{
                                          resolve(null)
                                        })
                                  }
                                })
                          })                        
                          this.vhQuery.asyncPromiseAll(promise_one)
                              .then(()=>{
                                resolve(true)}) 
                              }) 
                }else if (bill.bill_type === 50){//phiếu bán payment_card
                  //Kiểm tra xem có payment_card nào được sử dụng đổi hàng hàng chưa, nếu sử dụng rồi thì không xóa được    
                  let promise_bill_details = new Array();
                  for(let i=0; i<bill_details.length; i++){                 
                    promise_bill_details[i] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + this.getYear(bill.date), {id_payment_card_code: {$eq:bill_details[i].id_payment_card_code}, bill_type: {$eq:51}});       
                  }
                  this.vhQuery.asyncPromiseAll(promise_bill_details)
                      .then((array:any)=>{                            
                        array = array.filter((e:any)=>e.length >0);
                        if(array.length >0){                                  
                          console.log({error:'payment_card đã được sử dụng đổi hàng hóa nên không xóa được'})                  
                          return resolve(false);
                        }else{
                          for(let i=0; i<bill_details.length; i++){
                            promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                          }                                               
                          promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                          this.vhQuery.asyncPromiseAll(promise)
                              .then(()=>{   
                                let promise_updatepaymentcards = new Array();
                                for(let i=0; i<bill_details.length; i++){                 
                                  promise_updatepaymentcards[i] = this.vhMGDB_database.updateDoc('payment_card_codes', bill_details[i].id_payment_card_code, {date_sold:null, status:1, id_customer: null})           
                                }
                                this.vhQuery.asyncPromiseAll(promise_updatepaymentcards)
                                    .then(()=>{  
                                      return resolve(true)
                                    })    
                              }) 
                        }
                      })   
                  
                }else if (bill.bill_type === 51){//phiếu đổi payment_card
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }                                               
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                  Promise.all(promise)
                        .then(()=>{
                          let promise_one = new Array();                      
                          for(let i=0; i<display_bill_details.length; i++){
                            promise_one[promise_one.length] = new Promise((resolve, reject)=>{
                              this.getPaymentCardCode(display_bill_details[i].id_payment_card_code)
                                  .then((payment_card_code:any)=>{                                 
                                    for(let j=0; j<display_bill_details[i].products.length; j++){
                                      for(let k=0; k<payment_card_code.products.length; k++){
                                        if(payment_card_code.products[k].id_product === display_bill_details[i].products[j].id_product){
                                          if(payment_card_code.products[k].id_subproduct){
                                            if(payment_card_code.products[k].id_subproduct === display_bill_details[i].products[j].id_subproduct){                                        
                                              payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity - display_bill_details[i].products[j].quantity;   
                                            }
                                          }else{                                      
                                            payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity - display_bill_details[i].products[j].quantity;   
                                          }                                                                     
                                        }
                                      }                                 
                                    }

                                    let value:any = {
                                      products: payment_card_code.products                            
                                    }                        
                                    
                                    let check_firstbill = true;
                                    for(let j=0; j<payment_card_code.products.length; j++){
                                      if(payment_card_code.products[j].outquantity > 0) check_firstbill = false;
                                    }
                                    
                                    if(check_firstbill){
                                      value.date_used = null;
                                      if(payment_card_code.date_sold) value.status= 2;                                                                    
                                      else value.status= 3; 
                                    }
                                    this.updatePaymentCardCode(payment_card_code._id, {value})                              
                                        .then(()=>{                                    
                                          resolve(null)
                                        }) 
                                  })
                            })                          
                          }       
                          //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                          promise_one[promise_one.length] = this.calculateQuantityProduct_UP(bill_details,bill.id_branch);               
                          Promise.all(promise_one)
                                .then(()=>{
                                  resolve(true);
                                }) 
                        })
                }else if (bill.bill_type === 52){//phiếu đặt mua payment_card
                  //Kiểm tra xem có payment_card nào đã được mua, hoặc  được sử dụng đổi hàng hàng chưa, nếu rồi thì không xóa được    
                  let promise_bill_details = new Array();
                  for(let i=0; i<bill_details.length; i++){                 
                    promise_bill_details[i] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + this.getYear(bill.date), {id_payment_card_code: {$eq:bill_details[i].id_payment_card_code}, bill_type: {$eq:[50,51]}});       
                  }
                  this.vhQuery.asyncPromiseAll(promise_bill_details)
                      .then((array:any)=>{                          
                        array = array.filter((e:any)=>e.length >0);
                        if(array.length >0){                                  
                          console.log({error:'payment_card đã được sử dụng đổi hàng hóa nên không xóa được'})                  
                          return resolve(false);
                        }else{
                          for(let i=0; i<bill_details.length; i++){
                            promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                          }                                               
                          promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                          this.vhQuery.asyncPromiseAll(promise)
                              .then(()=>{   
                                let promise_updatepaymentcards = new Array();
                                for(let i=0; i<bill_details.length; i++){                 
                                  promise_updatepaymentcards[i] = this.vhMGDB_database.deleteDoc('payment_card_codes', bill_details[i].id_payment_card_code)           
                                }
                                this.vhQuery.asyncPromiseAll(promise_updatepaymentcards)
                                    .then(()=>{  
                                      return resolve(true)
                                    })    
                              }) 
                        }
                      })   
                }else if (bill.bill_type === 53){//phiếu đặt đổi payment_card lấy hàng hóa
                  for(let i=0; i<bill_details.length; i++){
                    promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill.date), bill_details[i]._id); 
                  }                                               
                  promise[promise.length] = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill); 
                  Promise.all(promise)
                        .then(()=>{
                          let promise_one = new Array();                      
                          for(let i=0; i<display_bill_details.length; i++){
                            promise_one[promise_one.length] = new Promise((resolve, reject)=>{
                              this.getPaymentCardCode(display_bill_details[i].id_payment_card_code)
                                  .then((payment_card_code:any)=>{                                 
                                    for(let j=0; j<display_bill_details[i].products.length; j++){
                                      for(let k=0; k<payment_card_code.products.length; k++){
                                        if(payment_card_code.products[k].id_product === display_bill_details[i].products[j].id_product){
                                          if(payment_card_code.products[k].id_subproduct){
                                            if(payment_card_code.products[k].id_subproduct === display_bill_details[i].products[j].id_subproduct){                                        
                                              payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity - display_bill_details[i].products[j].quantity;   
                                            }
                                          }else{                                      
                                            payment_card_code.products[k].outquantity = payment_card_code.products[k].outquantity - display_bill_details[i].products[j].quantity;   
                                          }                                                                     
                                        }
                                      }                                 
                                    }

                                    let value:any = {
                                      products: payment_card_code.products                            
                                    }                        
                                    
                                    let check_firstbill = true;
                                    for(let j=0; j<payment_card_code.products.length; j++){
                                      if(payment_card_code.products[j].outquantity > 0) check_firstbill = false;
                                    }
                                    
                                    if(check_firstbill){
                                      value.date_used = null;
                                      if(payment_card_code.date_sold) value.status= 2;                                                                    
                                      else value.status= 3; 
                                    }
                                    this.updatePaymentCardCode(payment_card_code._id, {value})                              
                                        .then(()=>{                                    
                                          resolve(null)
                                        }) 
                                  })
                            })                          
                          }       
                          //Sau khi xóa, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                          //promise_one[promise_one.length] = this.calculateQuantityProduct_UP(bill_details,bill.id_branch);               
                          Promise.all(promise_one)
                                .then(()=>{
                                  resolve(true);
                                }) 
                        })
                }else{
                  return reject({message: 'Loại bill_type ' + bill.bill_type + ' này không thể xóa hoặc liên hệ anh Huy sửa hàm'});
                }
              }else return reject({message: 'id_bill ' + id_bill + ' không tồn tại'});                      
  
        },(error:any)=>{
          console.log('error', error);
          reject(error);
        })         
    })
  }
  

  /**
   * Hàm lấy về các có kèm chương trình khuyến mãi
   * @example
   this.vhQuerySales.getBill_details_byId_bill('RcECbNgU9BdYQo37s30p')
        .then((bill_details:any)=>{
          console.log('getBill_details_byId_bill', bill_details);
        },(error:any)=>{
          console.log('error ', error);
        })   
   * @param id_bill 
   * @return Promise => array / orror
   */
  public getBill_details_byId_bill(id_bill:any):any {
    return new Promise((resolve, reject) => { 
      let promise = new Array();
      promise[0] = this.getBill(id_bill);  
      promise[1] = this.getBill_details_byID({id_bill:{$eq:id_bill}});     
      Promise.all(promise)
          .then((array:any) => {
            let bill = {...array[0]};
            let bill_details = [...array[1]];
            if((bill.bill_type != 40)&&(bill.bill_type != 42)&&(bill.bill_type != 43)&&(bill.bill_type != 50)&&(bill.bill_type != 52)&&(bill.bill_type != 53)){
              bill_details = this.changeBillDetails_withRaw_toPromotions(bill_details);
            }            
            if(bill.bill_type ===40){//phiếu bán voucher              
              let array_bill_details_voucher = new Array();                                                 
              for(let i=0; i<bill_details.length; i++){                                  
                let data = {...bill_details[i]}; 
                delete data?.bill_code;                
                delete data?.date;
                delete data?.tax;
                delete data?.bill_type;                  
                delete data?.id_cashier;
                delete data?.id_employee;
                delete data?.id_supplier;
                delete data?.id_customer;                  
                delete data?.id_inventorytime;   
                delete data?.id_branch;                 
                array_bill_details_voucher.push(data);                     
              };  
              resolve(array_bill_details_voucher);          
            }else if(bill.bill_type ===41){//phiếu đổi voucher              
                  let array_bill_details_voucher = new Array();                                                 
                  for(let i=0; i<bill_details.length; i++){                                  
                    let data = {...bill_details[i]}; 
                    delete data?.bill_code;                
                    delete data?.date;
                    delete data?.tax;
                    delete data?.bill_type;                  
                    delete data?.id_cashier;
                    delete data?.id_employee;
                    delete data?.id_supplier;
                    delete data?.id_customer;                  
                    delete data?.id_inventorytime;   
                    delete data?.id_branch;                 
                    array_bill_details_voucher.push(data);                     
                  };  
                  let promise_voucher = new Array();
                  for(let i=0; i<array_bill_details_voucher.length; i++){  
                    promise_voucher[promise_voucher.length] = new Promise(resolve=>{
                      this.getVoucher_Code_Name_Release(array_bill_details_voucher[i].id_voucher_code)               
                          .then((voucher:any)=>{
                            //array_bill_details_voucher[i].name = voucher.name_voucher_release + ' (' + voucher.name_voucher + ')';
                            array_bill_details_voucher[i].name_voucher = voucher.name_voucher
                            array_bill_details_voucher[i].name_voucher_release = voucher.name_voucher_release
                            resolve(null);
                          })
                    })
                  }
    
                  Promise.all(promise_voucher)
                      .then(()=>{
                        array_bill_details_voucher = this.changeBillDetails_withNameUnitsLots(array_bill_details_voucher);                    
                        resolve(array_bill_details_voucher);
                      })                    
            }else if(bill.bill_type ===50){//phiếu bán payment_card                  
              let array_bill_details_payment_card = new Array();                                                 
              for(let i=0; i<bill_details.length; i++){                                  
                let data = {...bill_details[i]}; 
                delete data?.bill_code;                
                delete data?.date;
                delete data?.tax;
                delete data?.bill_type;                  
                delete data?.id_cashier;
                delete data?.id_employee;
                delete data?.id_supplier;
                delete data?.id_customer;                  
                delete data?.id_inventorytime;   
                delete data?.id_branch;                 
                array_bill_details_payment_card.push(data);                     
              };  
              resolve(array_bill_details_payment_card);
            }else if(bill.bill_type === 51){//phiếu đổi payment_card                  
                  let array_bill_details_payment_card = new Array();                                                 
                  for(let i=0; i<bill_details.length; i++){                                  
                    let data = {...bill_details[i]}; 
                    delete data?.bill_code;                
                    delete data?.date;
                    delete data?.tax;
                    delete data?.bill_type;                  
                    delete data?.id_cashier;
                    delete data?.id_employee;
                    delete data?.id_supplier;
                    delete data?.id_customer;                  
                    delete data?.id_inventorytime;   
                    delete data?.id_branch;                 
                    array_bill_details_payment_card.push(data);                     
                  };  
                  let promise_payment_card = new Array();
                  for(let i=0; i<array_bill_details_payment_card.length; i++){  
                    promise_payment_card[promise_payment_card.length] = new Promise(resolve=>{
                      this.getPaymentCard_Code_Name_Release(array_bill_details_payment_card[i].id_payment_card_code)               
                          .then((payment_card:any)=>{                        
                            array_bill_details_payment_card[i].name_payment_card = payment_card.name_payment_card
                            array_bill_details_payment_card[i].name_payment_card_release = payment_card.name_payment_card_release
                            resolve(null);
                          })
                    })
                  }
    
                  Promise.all(promise_payment_card)
                      .then(()=>{
                        array_bill_details_payment_card = this.changeBillDetails_withNameUnitsLots(array_bill_details_payment_card);                   
                        resolve(array_bill_details_payment_card);
                      })
    
            }else{              
              let array_bill_details_product = new Array();
              if(bill_details.length > 0){                                       
                for(let i=0; i<bill_details.length; i++){                                  
                  let data = {...bill_details[i]}; 
                  delete data?.bill_code;                
                  delete data?.date;
                  delete data?.tax;
                  delete data?.bill_type;                  
                  delete data?.id_cashier;
                  delete data?.id_employee;
                  delete data?.id_supplier;
                  delete data?.id_customer;                  
                  delete data?.id_inventorytime;   
                  delete data?.id_branch;                 
                  array_bill_details_product.push(data);                     
                };                                                 
              }   
              //resolve(array_bill_details_product); 
              this.changeBillDetails_withPromotionNameUnitsLots(array_bill_details_product)
                  .then((array:any)=>{
                    resolve(array); 
                  },(error:any)=>{
                    console.log('error', error);
                  })
            }              
          },
          (error:any) => {
            reject(error);
          }) 
    })
  }


/** 
  * @example:
  * this.vhQuerySales.getBill_details_byID({id_bill:{$eq:id_bill}, bill_type:{$eq:5}}, {},{date:1},0)
        .then((bill_details)=>{
          console.log('bill_details', bill_details);
        })
  * @param query : trong query phải có query id_bill or id_product or id_subproduct....
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
  private getBill_details_byID(query: any, sort?:object, limit?:number) {
   return new Promise((resolve, reject) => { 
     let arr_years = this.getYearsArray();
     this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + arr_years[arr_years.length-1], query, {}, sort, limit)
         .then((bill_details1:any) => {    
             if(bill_details1.length) return resolve(bill_details1);   
             if(arr_years.length == 1) return resolve(bill_details1);          
             this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + arr_years[arr_years.length-2], query,{}, sort,limit)
                 .then((bill_details2:any) => {    
                   if(bill_details2.length) return resolve(bill_details2);   
                   if(arr_years.length == 2) return resolve(bill_details2);       
                   let promise = new Array();
                   for(let i=0; i<arr_years.length-2;i++){
                     promise[promise.length] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + arr_years[i], query, {}, sort,limit)
                   }  
                   Promise.all(promise)
                         .then((array:any)=>{      
                           let bill_details = array.flat();     
                           resolve(bill_details);                       
                         })                       
                 },(error:any) => {
                   reject(error);
                 }) 
           },(error:any) => {
             reject(error);
           }) 
     })
   }  

    /** 
  * @example:
  * let time = new Date();
  * time.setDate(time.getDate()-7);
  * this.vhQuerySales.getBill_details_byFields({date:{$gte:time}, {bill_type:{$eq:5}}, {},{date:1},0)
        .then((bill_details)=>{
          console.log('getBill_details_byFields', bill_details);
        })
  * @param query trong query phải có date
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
  private getBill_details_byFields(query: any, projection?:object, sort?:object, limit?:number) {
   return new Promise((resolve, reject) => { 
    let years_query = this.getYearsArray_fromQuery(query);
    let promise = new Array();
    for(let i=0; i<years_query.length; i++){
      promise[promise.length] = this.vhMGDB_database.getDocsByFields('vhs_bill_details_' + years_query[i], query, {}, sort, limit);
    }  
    Promise.all(promise)
        .then((array:any)=>{
          let bill_details = array.flat();  
          let promise_zero = new Array();  
          promise_zero[promise_zero.length] = this.syncBillDetails_Products(bill_details)               
          promise_zero[promise_zero.length] = this.syncBillDetails_Customers(bill_details)
          promise_zero[promise_zero.length] = this.syncBillDetails_Suppliers(bill_details)
          promise_zero[promise_zero.length] = this.syncBillDetails_Employees(bill_details)
          Promise.all(promise_zero)
                .then(()=>{
                      resolve(bill_details);
                    }, error=>{
                      reject(error);
                    })
        },error=>{
          reject(error);
        })       
     })
   } 
 

  /**
   * Hàm này tạo bill_code theo số thứ tự (trong ngày) của từng loại bill_type
   * @example:
   * this.vhQuerySales.createBillCode(new Date(), 7)
        .then((bill_code)=>{
          console.log('createBillCode', bill_code);
        })
   *  @param billdate 
   *  @param bill_type 
   */
  public createBillCode(billdate:any, bill_type:number){    
    return new Promise((resolve, reject) => {       
      let date = new Date(billdate);        
      let ddmmyy = 
            (date.getDate().toString().length == 1
                ? "0" + date.getDate().toString()
                : date.getDate().toString())
            +
            ((date.getMonth() + 1).toString().length == 1
                ? "0" + (date.getMonth() + 1).toString()
                : (date.getMonth() + 1).toString()) 
            +
            date.getFullYear().toString().slice(2);   
      let code_bill_type = "XX";       
      if(bill_type === 1) code_bill_type = 'A';
      else if(bill_type === 2) code_bill_type = 'B';
      else if(bill_type === 3) code_bill_type = 'C'; //import from customer
      else if(bill_type === 5) code_bill_type = 'D';
      else if(bill_type === 6) code_bill_type = 'E';
      else if((bill_type === 7)||(bill_type === 11)) code_bill_type = 'F';
      else if((bill_type === 8)||(bill_type === 12)) code_bill_type = 'G';            
      else if(bill_type === 9) code_bill_type = 'H';
      else if(bill_type === 10) code_bill_type = 'I'; //export to supplier            
      else if(bill_type === 13) code_bill_type = 'J';// note temporaty
      else if(bill_type === 14) code_bill_type = 'K'; //note finish
      else if(bill_type === 15) code_bill_type = 'L';
      else if(bill_type === 16) code_bill_type = 'M';
      else if((bill_type === 18)||(bill_type === 19)||(bill_type === 20)||(bill_type === 21)) code_bill_type = 'N';
      else if(bill_type === 29) code_bill_type = 'O'; //29,30,31 cùng bill_code           
      else if(bill_type === 32) code_bill_type = 'P'; //32,33,34 cùng bill_code
      else if(bill_type === 36) code_bill_type = 'Q'; //Đặt mua hàng
      else if(bill_type === 38) code_bill_type = 'R'; //balance export
      else if(bill_type === 39) code_bill_type = 'S'; //balance import
      else if(bill_type === 40) code_bill_type = 'T';
      else if(bill_type === 41) code_bill_type = 'U';
      else if(bill_type === 42) code_bill_type = 'TV'; // Đặt mua voucher
      else if(bill_type === 43) code_bill_type = 'UV'; // Đặt đổi voucher lấy sản phẩm
      else if(bill_type === 50) code_bill_type = 'V';
      else if(bill_type === 51) code_bill_type = 'W';
      else if(bill_type === 52) code_bill_type = 'VC'; // Đặt mua payment_card
      else if(bill_type === 53) code_bill_type = 'WC'; // Đặt đổi payment_card lấy sản phẩm
      let query:any= {};   
      if((bill_type === 7)||(bill_type === 11)){
        query = {id_branch:{$eq: this.getDefaultBranch()._id}, bill_type:{$in: [7,11]}, bill_code:{$gte:ddmmyy + code_bill_type + '000', $lte:ddmmyy + code_bill_type + '9999'}};      
      }else if((bill_type === 8)||(bill_type === 12)){
        query = {id_branch:{$eq: this.getDefaultBranch()._id}, bill_type:{$in: [8,12]}, bill_code:{$gte:ddmmyy + code_bill_type + '000', $lte:ddmmyy + code_bill_type + '9999'}}; 
      }else if((bill_type === 18)||(bill_type === 19)||(bill_type === 20)||(bill_type === 21)){
        query = {id_branch:{$eq: this.getDefaultBranch()._id}, bill_type:{$in: [18,19,20,21]}, bill_code:{$gte:ddmmyy + code_bill_type + '000', $lte:ddmmyy + code_bill_type + '9999'}}; 
      }else{     
        query = {id_branch:{$eq: this.getDefaultBranch()._id}, bill_type:{$eq: bill_type}, bill_code:{$gte:ddmmyy + code_bill_type + '000', $lte:ddmmyy + code_bill_type + '9999'}};      
      }
      this.getBills_byFields(query, {}, {bill_code:-1}, 1)
          .then((bills:any)=>{                          
            let ordinal:any = '001'; 
            if(bills.length){
               let bill_code = bills[0].bill_code;
               if((bill_type === 42)||(bill_type === 43)||(bill_type === 52)||(bill_type === 53)){
                 ordinal = Number(bill_code.slice(8)) + 1;
               }else{
                 ordinal = Number(bill_code.slice(7)) + 1;
               }
               if(isNaN(ordinal)) ordinal = '001';
               else if(ordinal<10) ordinal = '00' + ordinal;
               else if(ordinal<100) ordinal = '0' + ordinal;      
                      
            }else{          
              ordinal = '001';       
            }
                            
            let soHD = ddmmyy + code_bill_type + ordinal;
            //console.log('soHD.toUpperCase()', soHD.toUpperCase());     
            resolve(soHD.toUpperCase());  
          },(error:any)=>{
            reject(error);
          })
          .catch((e)=>{
            reject(e);
          })  
    })
  }   
 
  /**
   * @example:
   * this.vhQuerySales.getBill('5fb67fda87c0f21d484cbdf3')
        .then((bill)=>{
          console.log('getBill', bill);
        })
   *  @param id_bill 
   */
  public getBill(id_bill:any) {
    return new Promise((resolve, reject) => { 
     let arr_years = this.getYearsArray();
     this.vhMGDB_database.getDoc('vhs_bills_' + arr_years[arr_years.length-1], id_bill)
         .then((obj1:any) => {    
             if(obj1) return resolve(obj1);   
             if(arr_years.length == 1) return resolve(obj1);          
             this.vhMGDB_database.getDoc('vhs_bills_' + arr_years[arr_years.length-2], id_bill)
                 .then((obj2:any) => {    
                   if(obj2) return resolve(obj2);   
                   if(arr_years.length == 2) return resolve(obj2);       
                   let promise = new Array();
                   for(let i=0; i<arr_years.length-2;i++){
                     promise[promise.length] = this.vhMGDB_database.getDoc('vhs_bills_' + arr_years[i], id_bill);
                   }  
                   Promise.all(promise)
                         .then((array)=>{
                           array = array.filter((e:any)=>e!=null);
                           if(array.length == 0) resolve(null);     
                           else if(array.length == 1) resolve(array[0]);  
                           else{
                             reject(`Lỗi nghiêm trọng, id_bill ${id_bill} tồn tại trên nhiều collection, báo anh Huy trường hợp này gấp!`);
                           } 
                         })                       
                 },(error:any) => {
                   reject(error);
                 }) 
           },(error:any) => {
             reject(error);
           }) 
    })
  } 


/** 
  * @example:
  * let time = new Date();
  * time.setDate(time.getDate()-7);
  * this.vhQuerySales.getBills_byFields({date:{$gte:time}, {bill_type:{$eq:5}}, {},{date:1},0)
        .then((bills)=>{
          console.log('getBills', bills);
        })
  * @param query
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
  public getBills_byFields(query: any, projection?:object, sort?:object, limit?:number) {
    return new Promise((resolve, reject) => { 
     let years_query = this.getYearsArray_fromQuery(query);
     let promise = new Array();
     for(let i=0; i<years_query.length; i++){
       promise[promise.length] = this.vhMGDB_database.getDocsByFields('vhs_bills_' + years_query[i], query, {}, sort, limit);
     }
   
     Promise.all(promise)
           .then((array:any)=>{
             let bills = array.flat();       
             resolve(bills);
             //console.log('getBills_byFields', bills);
           },error=>{
             reject(error);
           })       
    })
  } 

  /**
   * @example:
   * this.vhQuerySales.createBill({name:'Cuối tuần vui vẻ', type:2, active:true, date_start:new Date(), date_end: new Date()})
          .then((bill)=>{
            console.log('createBill', bill);
          },(error:any)=>{
            console.log('error', error);
          })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    * @notice : hàm này chỉ dùng tạo những bill_type mà không có phát sinh bill_detail
    */
  public createBill(data:any){    
    return new Promise((resolve, reject) => {
      this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
      data.sync_code = this.sync_code;
      this.vhMGDB_database.addDoc('vhs_bills_' + this.getYear(data.date), data)
          .then((bill)=>{
            resolve(bill);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
 * @example:
 * this.vhQuerySales.updateBill('5fb6780ca2148e09806c5b01', {name:'Khuyến mãi 12/12'})
        .then((bool:any)=>{
          console.log('updateBill', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_bill 
  * @param bill 
  * @return Promise => bool = true or false
  * @notice : hàm này chỉ dùng cập nhật những bill_type mà không có phát sinh bill_detail
  * @notice : trường hợp bill.bill_type == 3334, thì hàm sẽ xóa bill có bill_type 32 đồng thời tạo 2 bill mới có bill_type là 33 và 34
  */
  public updateBill(id_bill:string, bill:any){        
    return new Promise((resolve, reject) => {   
      this.sync_code = Math.random().toString(36).substr(2, 10).toUpperCase();
      bill.sync_code = this.sync_code;  
      this.getBill(id_bill)
         .then((_bill:any)=>{   
           if(bill?.bill_type === '3334'){           
             if(_bill.bill_type === 32){                       
                 let promise = new Array();        
                 promise[0] = this.vhMGDB_database.updateDoc('vhs_bills_' +  this.getYear(_bill.date), id_bill, {bill_type:33, sync_code: this.sync_code});
                 let _bill_34 = {...bill}; 
                 delete _bill_34?.id_branch_receive;
                 _bill_34.bill_type = 34;
                 _bill_34.bill_code = _bill.bill_code;
                 _bill_34.id_branch = _bill.id_branch_receive;   
                 _bill_34.id_branch_send = _bill.id_branch;  
                 _bill_34.date = _bill.date;                
                 promise[1] = this.vhMGDB_database.addDoc('vhs_bills_' +  this.getYear(_bill.date), _bill_34);  
                 Promise.all(promise)
                       .then(() => { 
                         resolve(true);
                       })
                       .catch(e => { 
                         reject(e)
                       })
                   
             }else{
               reject('Lưu không thành công, vui lòng kiểm tra lại.')
             }
           }else{
             this.vhMGDB_database.updateDoc('vhs_bills_' +  this.getYear(_bill.date), id_bill, bill)
               .then((bool:any)=>{
                 resolve(bool);
               }, error=>{
                 reject(error)
               }) 
           }
         })   
    })
  }     

  /**
   * @example:
   * this.vhQuerySales.deleteBill('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deleteBill', bool);
        })
    * @param id_bill_detail 
    * @return Promise => bool = true or false 
    * @notice : hàm này chỉ dùng xóa những bill_type (7,8,11,12) mà không có phát sinh bill_detail
    */
  public deleteBill(id_bill:any){
    return new Promise((resolve, reject) => {
      this.getBill(id_bill)
          .then((bill:any)=>{              
            if(bill){
              let promise:any;  
              //xóa bill_type(thu khác), vẫn giữ bill lại nhưng chuyển trang thái 25  
              if(bill.bill_type === 7){
                promise = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);                     
              //xóa bill_type(chi khác), vẫn giữ bill lại nhưng chuyển trang thái 26  
              }else if(bill.bill_type === 8){
                promise = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);             
              //xóa bill_type(thu công nợ KH), vẫn giữ bill lại nhưng chuyển trang thái 27                     
              }else if(bill.bill_type === 11){ 
                promise = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);           
              //xóa bill_type(chi công nợ NCC), vẫn giữ bill lại nhưng chuyển trang thái 28               
              }else if(bill.bill_type === 12){  
                promise = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);                      
              }else if(bill.bill_type === 32){
                promise = this.vhMGDB_database.deleteDoc('vhs_bills_' + this.getYear(bill.date), id_bill);                                   
              }                 
              promise.then((bool:any)=>resolve(bool))
            }else reject({message: id_bill + ' no exist'});    
          })           
    })
  }

 /**
  * Hàm này dùng để đồng bộ hóa đơn đang mở ở 2 giao diện hoặc 2 thiết bị khác nhau
  * @example:
  * this.vhQuerySales.observableSyncOpeningBill('5fb6780ca2148e09806c5b01', 5)      
      .subscribe((rsp)=> {  
            if(rsp.vcode === 0){
              //-----------your code 0-----------
              let bill = rsp.data;
              console.log('observableSyncOpeningBill', bill);           
            }else if(rsp.vcode === 1){
                //-----------your code 1-----------
            }else if(rsp.vcode === 2){
                //-----------your code 2-----------
            }                                         
      },(error:any) => {
        console.log(error);
      }) 
  * @param id_bill   
  * @param bill_type
  * @returns Observable => bill hoặc null; 
  * @return Observable object => rsp = {vcode, message, data}
  * vcode == 0: repaired bill by another device
  * vcode == 1: changed bill_type by another device
  * vcode == 2: deleted bill by unknown device
  * @notice : nhớ đóng closeSyncOpeningBill() khi thoát trang hiện tại this.vhQueryCafe.closeSyncOpeningBill();
  */
  public observableSyncOpeningBill(id_bill:string, bill_type:number){  
    return new Observable((observer:any) => {   
      let count = 0;       
      let arr_years = this.getYearsArray();
      this.callbacksyncopeningbill = this.vhMGDB_socketMongoDB.initSyncOpeningBill('vhs_bills_' + arr_years[arr_years.length-1], id_bill).subscribe((doc:any)=>{                    
          if(doc.exists) {              
              if(doc.data().sync_code != this.sync_code){               
                if(doc.data().bill_type === bill_type){              
                  if(count++){
                    let bill = {                         
                      ...this.vhMGDB_auth.cvtDataFB2MG(doc.data()),
                      _id: doc.id
                    };                            
                    
                    observer.next({vcode:0, message:'repaired bill by another device', data: bill}); 
                  }                                  
                }else{        
                           
                  observer.next({vcode:1, message:'changed bill_type by another device'}); 
                }      
              }else{
                count++;
              }           
          }else{     
            if(arr_years.length >= 2){
              this.closeSyncOpeningBill();
              this.callbacksyncopeningbill = this.vhMGDB_socketMongoDB.initSyncOpeningBill('vhs_bills_' + arr_years[arr_years.length-1], id_bill).subscribe((doc:any)=>{                    
                if(doc.exists) {              
                    if(doc.data().sync_code != this.sync_code){               
                      if(doc.data().bill_type === bill_type){              
                        if(count++){
                          let bill = {                         
                            ...this.vhMGDB_auth.cvtDataFB2MG(doc.data()),
                            _id: doc.id
                          };                            
                          
                          observer.next({vcode:0, message:'repaired bill by another device', data: bill}); 
                        }                                  
                      }else{        
                                 
                        observer.next({vcode:1, message:'changed bill_type by another device'}); 
                      }      
                    }else{
                      count++;
                    }           
                }else{ 
                                           
                  observer.next({vcode:2, message:'deleted bill by unknown device'}); 
                }
              })
            }else{
                                       
              observer.next({vcode:2, message:'deleted bill by unknown device'}); 
            }             
          }       
      })
    })        
  }    

  /**
   * @example:
   * this.vhQuerySales.closeSyncOpeningBill();
   * @returns void
   */
  public closeSyncOpeningBill(){
    this.callbacksyncopeningbill.unsubscribe();
    this.vhMGDB_socketMongoDB.closeSyncOpeningBill();
  }
  
/**
  * Hàm callback, mỗi lần callback trả về danh sách hóa đơn mới nhất
  * @example:
  * this.vhQuerySales.observableSyncBillType('5fb6780ca2148e09806c5b01', 5)      
      .subscribe((listbill_bybilltype)=> {                       
                console.log('observableSyncBillType', listbill_bybilltype);                         
      },(error:any) => {
        console.log(error);
      }) 
  * @param id_branch   
  *  @param bill_type
  * @returns Observable => array
  */
  public observableSyncBillType(id_branch:string, bill_type:number){  
    return new Observable((observer:any) => {  
      bill_type = 5;
      let arr_years = this.getYearsArray();        
      this.callback1syncbilltype = this.vhMGDB_socketMongoDB.init1SyncBillType(id_branch, 'vhs_bills_' + arr_years[arr_years.length-1], bill_type).subscribe((change:any)=>{             
        if (change.type === "added") {                                                  
          let data = {            
            _id: change.doc.id,
            ...this.vhMGDB_auth.cvtDataFB2MG(change.doc.data())
          };
          this.listbill_bybilltype.push(data);               
                  
        }else if (change.type === "modified") {                               
            let data = {               
              _id: change.doc.id,
              ...this.vhMGDB_auth.cvtDataFB2MG(change.doc.data())
            };       
            for(let i=0; i<this.listbill_bybilltype.length; i++){
              if(this.listbill_bybilltype[i]._id === data._id){
                this.listbill_bybilltype[i] = {...this.listbill_bybilltype[i], ...data};                   
                break;
              }
            }
                        
        }else if (change.type === "removed") {                               
            let data = {              
              _id: change.doc.id                                  
            };
            for(let i=0; i<this.listbill_bybilltype.length; i++){
              if(this.listbill_bybilltype[i]._id === data._id){
                this.listbill_bybilltype.splice(i,1);
                break;
              }
            }
        }     
        observer.next(this.listbill_bybilltype);  
      })
      if(arr_years.length >=2)
      this.callback2syncbilltype = this.vhMGDB_socketMongoDB.init2SyncBillType(id_branch, 'vhs_bills_' + arr_years[arr_years.length-2], bill_type).subscribe((change:any)=>{             
        if (change.type === "added") {                                                  
          let data = {            
            _id: change.doc.id,
            ...this.vhMGDB_auth.cvtDataFB2MG(change.doc.data())
          };
          this.listbill_bybilltype.push(data);               
                  
        }else if (change.type === "modified") {                               
            let data = {               
              _id: change.doc.id,
              ...this.vhMGDB_auth.cvtDataFB2MG(change.doc.data())
            };       
            for(let i=0; i<this.listbill_bybilltype.length; i++){
              if(this.listbill_bybilltype[i]._id === data._id){
                this.listbill_bybilltype[i] = {...this.listbill_bybilltype[i], ...data};                   
                break;
              }
            }
                        
        }else if (change.type === "removed") {                               
            let data = {              
              _id: change.doc.id                                  
            };
            for(let i=0; i<this.listbill_bybilltype.length; i++){
              if(this.listbill_bybilltype[i]._id === data._id){
                this.listbill_bybilltype.splice(i,1);
                break;
              }
            }
        }     
        observer.next(this.listbill_bybilltype);  
      })
    })    
  }  

  /**
   * Hàm đóng Observable của observableSyncBillType(), mỗi lần thoát trang, thoát component nên gọi hàm này
   * @example:
   * this.vhQuerySales.closeSyncBillType();
   * @returns void
   */
    public closeSyncBillType(){
      this.listbill_bybilltype = new Array();
      this.callback1syncbilltype.unsubscribe();
      this.callback2syncbilltype.unsubscribe();
      this.vhMGDB_socketMongoDB.closeSyncBillType();
    }

   /**
    * @example:
    * this.vhQuerySales.createPaymentVnpay(10000, 'Thanh toan hoa don so A7TG2004, vao luc: 2021-11-19 13:11:27', 'o0wEpPDhR8QiGDkp2hLG', 'http://localhost:4200/')
    * @param amount 
    * @param orderDescription (lưu ý chữ không dấu)
    * @param id_payment : id của hóa đơn khách hàng cần thanh toán
    * @param backHref : lấy link mà chạy khởi động lại trang, link này gán trong nút back của trang trả về
    * @Return Promise => void
    */
    private createPaymentVnpay(amount:number, orderDescription:string, id_payment:string, backHref:string):any {   
      return new Promise((resolve, reject) => {         
        this.vhMGDB_paymentVNPAY.createPaymentVnpay(amount, orderDescription, id_payment, <any>null)
            .then((response:any)=>{              
              window.location = response.data;              
            },(error:any)=>{
              console.log('error', error);
            })   
      })
    }

    /**
    * @example:
    * this.vhQuerySales.createPaymentVnpay_web(10000, 'Thanh toan hoa don so A7TG2004, vao luc: 2021-11-19 13:11:27', 'o0wEpPDhR8QiGDkp2hLG', 'http://localhost:4200/')
    * @param amount 
    * @param orderDescription (lưu ý chữ không dấu)
    * @param id_payment : id của hóa đơn khách hàng cần thanh toán
    * @param backHref : lấy link mà chạy khởi động lại trang, link này gán trong nút back của trang trả về
    * @Return Void
    */
    public createPaymentVnpay_web(amount:number, orderDescription:string, id_payment:string, backHref:string):any {   
      return new Promise((resolve, reject) => {         
        this.vhMGDB_paymentVNPAY.createPaymentVnpay(amount, orderDescription, id_payment, backHref)
            .then((response:any)=>{             
              window.location = response.data;              
            },(error:any)=>{
              console.log('error', error);
            })   
      })
    }

    /**
    * @example:
    * this.vhQuerySales.createPaymentVnpay_soft(10000, 'Thanh toan hoa don so A7TG2004, vao luc: 2021-11-19 13:11:27', 'o0wEpPDhR8QiGDkp2hLG')
          .then((payment_url)=>{
              //Hiện loading chờ ở đây
              setTimeout(() => {
                //Sau 15s đóng loading lại và refresh trang lại                
                window.location = backHref; 
              }, 15000);         
              //Đồng thời mở 1 browser trong 1 window mới vơi ulr là payment_url cho khách hàng thanh toán           
          },(error:any)=>{
            console.log('error', error);
          })
    * @param amount 
    * @param orderDescription (lưu ý chữ không dấu)
    * @param id_payment : id của hóa đơn khách hàng cần thanh toán
    * @Return Promise => payment_url
    */
    public createPaymentVnpay_soft(amount:number, orderDescription:string, id_payment:string):any {   
      return new Promise((resolve, reject) => {         
        this.vhMGDB_paymentVNPAY.createPaymentVnpay(amount, orderDescription, id_payment, <any>null)
            .then((response:any)=>{               
              //window.open(response.data,"_blank","fullscreen=yes");               
              resolve(response.data)        
            },(error:any)=>{
              console.log('error', error);
            })   
      })
    }

  /**
    * @example:
    * this.vhQuerySales.createPaymentVnpay_app(10000, 'Thanh toan hoa don so A7TG2004, vao luc: 2021-11-19 13:11:27', 'o0wEpPDhR8QiGDkp2hLG')
          .then((payment_url)=>{
              //Dùng thư viện chạy browser trong app vơi ulr là payment_url cho khách hàng thanh toán                         
          },(error:any)=>{
            console.log('error', error);
          })
    * @param amount 
    * @param orderDescription (lưu ý chữ không dấu)
    * @param id_payment : id của hóa đơn khách hàng cần thanh toán
    * @Return payment_url
    */
    public createPaymentVnpay_app(amount:number, orderDescription:string, id_payment:string):any {   
      return new Promise((resolve, reject) => {         
        this.vhMGDB_paymentVNPAY.createPaymentVnpay(amount, orderDescription, id_payment, <any>null)
            .then((response:any)=>{            
              //window.location = response.data;   
              resolve(response.data)         
            },(error:any)=>{
              console.log('error', error);
            })   
      })
    }

       /**
    * @example:
    * this.vhQuerySales.createPaymentVnpay_Mobile(10000, 'Thanh toan hoa don so A7TG2004, vao luc: 2021-11-19 13:11:27', 'o0wEpPDhR8QiGDkp2hLG', 'http://localhost:4200/')
          .then(link=>{
            //Nếu Desktop chạy luôn link này: window.location = response.data; 
            // Nếu Mobile chạy luôn link này trong tag frame html
          },(error:any)=>{
            console.log('error', error);
          }) 
    * @param platform : "mobile"/"desktop" 
    * @param amount 
    * @param orderDescription (lưu ý chữ không dấu)
    * @param id_payment : id của hóa đơn khách hàng cần thanh toán
    * @param backHref : lấy link mà chạy khởi động lại trang 
    * @Return Promise => trả về link thanh toán vnpay
    */
    private createPaymentVnpay_Mobile(amount:number, orderDescription:string, id_payment:string, backHref:string, platform:string):any {        
      return new Promise((resolve, reject) => {  
        this.vhMGDB_paymentVNPAY.createPaymentVnpay(amount, orderDescription, id_payment, backHref)
            .then((response:any)=>{           
              //window.location = response.data; 
              resolve(response.data);
            },(error:any)=>{
              console.log('error', error);
              reject(error)
            })   
      })
    }

   /**
    * Hàm này dùng trong trường hợp dùng iFrame chạy ulr của vnpay, hoặc có nhiều thanh toán như vnpay, momo... cho khách chọn trước khi thanh toán
    * @example:
    * this.vhQuerySales.createPaymentVnpay_iFrame(10000, 'Thanh toan hoa don so A7TG2004', 'o0wEpPDhR8QiGDkp2hLG', 'http://localhost:4200/')
          .then(link=>{
            //Nếu Desktop chạy luôn link này: window.location = response.data; 
            // Nếu Mobile chạy link link này trong tag frame html
          },(error:any)=>{
            console.log('error', error);
          }) 
    * @param amount 
    * @param orderDescription (lưu ý chữ không dấu)
    * @param id_payment : id của hóa đơn khách hàng cần thanh toán
    * @param backHref : lấy link mà chạy khởi động lại trang 
    * @Return Promise => trả về link thanh toán vnpay
    */
    private createPaymentVnpay_iFrame(amount:number, orderDescription:string, id_payment:string, backHref:string):any {//hàm này test lại trên mobile nếu vnpay ko load đc trong app thì bỏ        
      return new Promise((resolve, reject) => {  
        this.vhMGDB_paymentVNPAY.Create_Payment_Url_Vnpay_iFrame(amount, orderDescription, id_payment, backHref)
            .then((response:any)=>{  
              //console.log('createPaymentVnpay_iFrame', response.data);         
              //window.location = response.data; 
              resolve(response.data);
            },(error:any)=>{
              //console.log('error', error);
              reject(error)
            })   
      })
    }

    /**
   * @example:
   * let data = {   
      date: new Date(),        
      payment_type: 5, //1 lưu (khách đã thanh toán cho vnpay); 5 lưu tạm (khách chưa thanh toán vnpay), hệ thống sẽ tự động xóa những payment này hoặc trên giao diện hiện ra cho khách tự xóa
      payment: 990.000,
      tax: 0,
      total: 990.000      
     }
   * this.vhQuerySales.createPayment(data)
          .then((payment)=>{
            console.log('createPayment', payment);
          },(error:any)=>{
            console.log('error', error);
          })
    * payment = {
          _id, 
          payment_code, 
          id_store, 

          date
          payment_type, 
          payment, 
          tax, 
          total          
      }      
    * @param payment : object 
    * @return  Promise => payment = {} / error
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    * @notice : hàm này chỉ dùng tạo những bill_type mà không có phát sinh bill_detail
    */
    public createPayment(data:any){    
      return new Promise((resolve, reject) => {
        data.payment_code = this.vhAlgorithm.createPaymentCode(data?.date);
        data.id_store = this.vhMGDB_auth.getDatabase();
        this.vhMGDB_rootdatabase.addDoc('payments', data)
            .then((payment)=>{
              resolve(payment);
            },(error:any)=>{
              reject(error);
            })         
      })
    }

/**
 * @example:
 * this.vhQuerySales.updatePayment('5fb6780ca2148e09806c5b01', {total:990000})
        .then((response)=>{
          console.log('updatePayment', response);
        }, error=>{
          console.log('error', error);
        })
  * @param id_payment 
  * @param value 
  * @return Promise => response = undefined / error
  */
  public updatePayment(id_payment:string, value:any){        
    return new Promise((resolve, reject) => {  
      this.vhMGDB_rootdatabase.updateDoc('payments', id_payment, value)
        .then((response)=>{
          resolve(response);       
        }, error=>{
          reject(error);  
        })     
    })
  }  

  /**
   * @example:
   * this.vhQuerySales.deletePayment('5fb67fda87c0f21d484cbdf3')
        .then((response)=>{
          console.log('deletePayment', response);
        }, error=>{
          console.log(error, error);
        }) 
    * @param id_payment 
    * @return Promise => response = undefined / error
    */
  public deletePayment(id_payment:any){
    return new Promise((resolve, reject) => {
      let query = {id_payment:{$eq:id_payment}};
      this.vhMGDB_rootdatabase.getDocsByFields('payment_details', query, {}, {}, 0)
          .then((payment_details:any)=>{
            if(payment_details.length >0){
              for(let i=0; i<payment_details.length; i++){
                this.vhMGDB_rootdatabase.deleteDoc('payment_details', payment_details[i]._id);
              }
            }            
          }, error=>{
            console.log(error, error);
          })
      this.vhMGDB_rootdatabase.deleteDoc('payments', id_payment)
          .then((response)=>{
            resolve(response);          
          }, error=>{
            console.log(error, error);
          })              
    })
  }

   /**
  * @example:
  * let time = new Date();
  * time.setDate(time.getDate()-7);
  * this.vhQuerySales.getPayments({payment_type:{$eq:5}}, {},{},0)
        .then((payments)=>{
          console.log('getPayments', payments);
        })
  * @param query
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
  public getPayments(query: any, projection?:object, sort?:object, limit?:number) {//sửa lại hàm này vì chỉ có 1 store thôi
    return new Promise((resolve, reject) => { 
      query.id_store = {$eq:this.vhMGDB_auth.getDatabase()}
      this.vhMGDB_rootdatabase.getDocsByFields('payments', query, {}, sort, limit)
          .then((bills)=>{
            resolve(bills);
          }, error=>{
            console.log(error, error);
          })       
    })
  } 

  /**
   * @example:
   * this.vhQuerySales.getPayment('5fb67fda87c0f21d484cbdf3')
        .then((payment)=>{
          console.log('getPayment', payment);
        })
   *  @param id_payment 
   *  @return Promise => payment ={} or null / error
   */
    public getPayment(id_payment:any) {
      return new Promise((resolve, reject) => { 
        this.vhMGDB_rootdatabase.getDoc('payments', id_payment)
            .then((response:any) => {              
                resolve(response);
              },
              (error:any) => {
                reject(error);
              }) 
      })
    } 

  
  /**
   * @example:    
    let payment_detail_main = {      
      id_branch: 'AEUWSWZXA4iHv8BmCNz2', //khách chọn
      id_payment: '5D4XGdZ2q5XLnOUa0mMx', //payment._id     
      id_restriction: 'main_package_advanced', //package.id_restriction
      id_package: 'main_package_advanced_1month', //có được khi khách chọn gói để mua
      package_type: 1,  //gói chinh, gói tmđt hay gói facebook...                                                                                               
      day: 31, //package.day,                                                                                           
      tax: 0, package.tax,                               
      price: 99000, package.price,
      quantity: 1, //khách chọn                        
      payment_detail_type: 1, //1: gói gia hạng mới, 2: gói nâng cấp, 3: gói kéo dài thêm thời gian                           
    }
    this.vhQuerySales.createPayment_Detail({})
        .then((payment_detail)=>{
          console.log('createPayment_Detail', payment_detail);
        },(error:any)=>{
          console.log('error', error);
        })
    payment_detail = {
        _id, 
        id_store,
        payment_type,
        activating,
        invalid,
        date,
      
        id_branch,
        id_payment,
        id_restriction,
        id_package,
        package_type,
        payment_type,
        payment_detail_type,        
        day,
        tax,
        price,
        quantity        
    }      
   * @param data 
   * @return  Promise => response = {} / error
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */ 
    public createPayment_Detail(data:any):any {      
      return new Promise((resolve, reject) => {
        if((data.id_payment != undefined) && (data.id_payment != null)){
          this.vhMGDB_rootdatabase.getDoc('payments', data.id_payment)
              .then((payment:any)=>{
                  let _data = data;     
                  _data.activating = false;  
                  _data.invalid = false;       
                  _data.date = payment.date;    
                  if(payment.id_store) _data.id_store = payment.id_store;  
                  if(typeof payment.payment_type == 'number') _data.payment_type = payment.payment_type;                                
                  
                  this.vhMGDB_rootdatabase.addDoc('payment_details', _data)
                      .then((payment_detail)=>{                      
                        resolve(payment_detail);
                      },(error:any)=>{
                        reject(error);
                      })   
                  
              },(error:any)=>{
              console.log('error', error);
              })
        }else{
          console.log('error', 'không tồn tại id_bill trong data');
        } 
              
      })
    }  
  
    /**
     * @example:
     * this.vhQuerySales.updatePayment_Detail('5fb6780ca2148e09806c5b01', {name:'Khuyến mãi 12/12'})
            .then((response)=>{
              console.log('updatePayment_Detail', response);          
            },(error:any)=>{
              reject(error);
            }) 
      * @param id_payment_detail 
      * @param value 
      * @return Promise => response = undefined / error
      */
    public updatePayment_Detail(id_payment_detail:string, value:object){    
      return new Promise((resolve, reject) => {
        this.vhMGDB_rootdatabase.updateDoc('payment_details', id_payment_detail, value)
            .then((response)=>{
              resolve(response);
            },(error:any)=>{
              reject(error);
            })         
      })
    }

  /**
  * @example:
  * let time = new Date();
  * time.setDate(time.getDate()-7);
  * this.vhQuerySales.getPayment_details({id_payment:{$eq:'5fb67fda87c0f21d484cbdf3'}}, {},{},0)
        .then((payment_details)=>{
          console.log('getPayment_details', payment_details);
        })
  * @param query
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return Promise Array => array = [{},{},...] / error 
  */
  public getPayment_details(query: any, projection?:object, sort?:object, limit?:number) {//sửa lại hàm này vì chỉ có 1 store thôi
    return new Promise((resolve, reject) => { 
      query.id_store = {$eq:this.vhMGDB_auth.getDatabase()}
      this.vhMGDB_rootdatabase.getDocsByFields('payment_details', query, {}, sort, limit)
          .then((payment_details)=>{
            resolve(payment_details);
          }, error=>{
            console.log(error, error);
          })       
    })
  }

  /**
   * @example:
   * this.vhQuerySales.getPayment_detail('5fb67fda87c0f21d484cbdf3')
        .then((payment_detail)=>{
          console.log('getPayment_detail', payment_detail);
        })
   *  @param id_payment_detail 
   *  @return Promise => payment_detail ={} or null / error
   */
    public getPayment_detail(id_payment_detail:any) {
      return new Promise((resolve, reject) => { 
        this.vhMGDB_rootdatabase.getDoc('payment_details', id_payment_detail)
            .then((response:any) => {              
                resolve(response);
              },
              (error:any) => {
                reject(error);
              }) 
      })
    }
  
  /**
   * @example:
   * this.vhQuerySales.deletePayment_Detail('5fb67fda87c0f21d484cbdf3')
        .then((response)=>{
          console.log('deletePayment_Detail', response);
        },(error:any)=>{
          reject(error);
        })
    * @param id_payment_detail 
    * @return Promise => Promise => response = undefined / error
    */
  public deletePayment_Detail(id_payment_detail:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_rootdatabase.deleteDoc('payment_details', id_payment_detail)
          .then((bool:any)=>{            
            resolve(bool);
          },(error:any)=>{
            reject(error);
          })          
    })
  }

 /**
 * @example:
 * this.vhQuerySales.getPackage('5fb67fda87c0f21d484cbdf3')
       .then((package)=>{
         console.log('getPackage', package);
       })
 *  @param id_package 
 *  @return Promise => package ={} or null / error
 */
 public getPackage(id_package:any) {
   return new Promise((resolve, reject) => { 
     this.vhMGDB_rootdatabase.getDoc('packages', id_package)
         .then((response:any) => {              
             resolve(response);
           },
           (error:any) => {
             reject(error);
           }) 
   })
 }


/**
* @example:
* this.vhQuerySales.extendLicenseValidaty_byLicenseKEY('5fb6780ca2148e09806c5b01', '674fd94a9ace7267deb685fd')
       .then((response)=>{
         console.log('extendLicenseValidaty_byLicenseKEY', response);
       }, error=>{
         console.log('error', error);
       })
 * @param id_branch 
 * @param id_licenseKEY 
 * @return Promise => response = {vcode, msg}
 * vcode = 0: gia hạn thành công
 * vcode = 1: id_licenseKEY không thuộc về Store
 * vcode = 2: id_licenseKEY đã được kích hoạt trước đây
 * vcode = 3: id_licenseKEY đã bị vô hiệu hóa trước đây
 * vcode = 4: id_licenseKEY không kích hoạt được do khác loại gói đang dùng
 */
 public extendLicenseValidaty_byLicenseKEY(id_branch:string, id_licenseKEY:string){       
   return new Promise((resolve, reject) => {       
     this.vhMGDB_rootdatabase.getDoc('licenseKEYs', id_licenseKEY)
         .then((licenseKEY:any) => {   
             if(licenseKEY){
               if(licenseKEY?.id_store != this.vhMGDB_auth.getStore()._id) return reject({error:`${id_licenseKEY} không thuộc shop`});  
               this.vhMGDB_auth.extendLicenseValidaty_byLicenseKEY_byShop(id_branch, id_licenseKEY)
                   .then((rsp)=>{
                     resolve(rsp);             
                   }, error=>{                      
                     reject(error);
                   })
             }else reject({error:`${id_licenseKEY} không tìm thấy licenseKEY`});                          
           },
           (error:any) => {
             reject(error);
           }) 
       
   })
 } 
 
 /**
 * @example:
 * let time = new Date();
 * time.setDate(time.getDate()-7);
 * this.vhQuerySales.getLicenseKEYs({payment_type:{$eq:5}}, {},{},0)
       .then((payments)=>{
         console.log('getLicenseKEYs', payments);
       })
 * @param query
 * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
 * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
 * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
 * @return — Array -> array = [{},{},...] 
 */
 public getLicenseKEYs(query: any, projection?:object, sort?:object, limit?:number) {
   return new Promise((resolve, reject) => {       
     if(!this.vhMGDB_auth.getStore()._id) reject('bạn chưa đăng nhập');
     query.id_store = {$eq:this.vhMGDB_auth.getStore()._id} ;
     this.vhMGDB_rootdatabase.getDocsByFields('licenseKEYs', query, {}, sort, limit)
         .then((bills)=>{
           resolve(bills);
         }, error=>{
           console.log(error, error);
         })       
   })
 }

  /**
 * Lấy về danh sách các ngân hàng (kèm logo) mà vietqr hỗ trợ tạo mã QR
 * @example:
 * this.vhQuerySales.vietqr_getBanks()
        .then((rsp:any)=>{
          if(rsp.vcode === 0){            
          }
        }, error=>{
          console.log(error)
        })
  * @returns Promise => rsp ={vcode, msg, data(array)} / error
  * vcode == 0: success
  */
  public vietqr_getBanks(){
    return new Promise((resolve, reject) => {  
      axios.get('https://api.vietqr.io/v2/banks')
          .then((response:any)=> {                        
            if(response.data.code == '00')  resolve({vcode:0, msg:response.data.desc, data: response.data.data});
            else resolve({code:1, msg:response.data.desc, data: null});
          })
          .catch((e:any)=> {                          
            reject(e.response.data);
          });
    })
  }
 /**
  * Tạo mã QR cho Shop quét thanh toán vào tài khoản ngân hàng đã đăng ký Casso
  * @example:
  * this.vhQuerySales.vietqr_generateQR('0909925354', 'LE DUC HUY', '970422', 'compact2', '674fd94a9ace7267deb685fd', 99000)
         .then((rsp:any)=>{
           if(rsp.vcode === 0){            
           }
         }, error=>{
           console.log(error)
         })
   * @param accountNo: số tài khoản ngân hàng
   * @param accountName: tên chủ tài khoản
   * @param acqId: mã bin của ngân hàng (lấy từ hàm vietqr_getBanks())
   * @param template: compact2, compact, qr_only, print
   + compact2:	540x640	Bao gồm : Mã QR, các logo , thông tin chuyển khoản
   + compact:	540x540	QR kèm logo VietQR, Napas, ngân hàng
   + qr_only:	480x480	Trả về ảnh QR đơn giản, chỉ bao gồm QR
   + print:	600x776	Bao gồm : Mã QR, các logo và đầy đủ thông tin chuyển khoản
   * @param id_bill: _id của đơn hàng
   * @param amount: tổng tiền khách phải thanh toán
   * @returns Promise => rsp ={vcode, msg, data(img_base64)} / error
   * vcode == 0: success
   */
   public vietqr_generateQR(accountNo:string, accountName:string, acqId:string, template:string, id_payment:string, amount:number){
     return new Promise((resolve, reject) => {       
       let data = {
         accountNo,
         accountName,
         acqId,
         template,
         format: "text",
         amount,
       }      

       let projectname_code = "-1"; //ko phải là mã của dự án nào cả
       if(this.vhMGDB_auth.getProjectName()  === 'vhsales') projectname_code = "2";
       else if(this.vhMGDB_auth.getProjectName()  === 'bvhsales') projectname_code = "3";
       else if(this.vhMGDB_auth.getProjectName()  === 'vhcafe') projectname_code = "4";
       //let addInfo = btoa(this.vhMGDB_auth.getProjectName() + "||" + "payer_store" + "||" + id_payment);
       //"2" là dự án vhsales
       let addInfo = projectname_code + "|" + "PS" + "|" + id_payment; //project + "|" + "payer_store" + "|" + id_payment
       //Lấy mảng ký tự gồm những ký tự mà không tồn tại trong chuỗi addInfo
       const allChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"; //mở rộng sẽ làm thêm cho sô '0123456789'
       let missingChars = allChars.split("").filter(char => !addInfo.includes(char));
       let lowerCaseMap = new Map();
       // Đếm số lần xuất hiện của mỗi ký tự (không phân biệt hoa/thường)
       for (let char of missingChars) {
           let lowerChar = char.toLowerCase();
           lowerCaseMap.set(lowerChar, (lowerCaseMap.get(lowerChar) || 0) + 1);
       }
       // Chỉ giữ lại những phần tử xuất hiện từ 2 lần trở lên (không phân biệt hoa/thường)
       missingChars =  missingChars.filter(char => lowerCaseMap.get(char.toLowerCase()) > 1);
       //Xóa tất cả các ký thường chỉ giữ lại ký tự hoa và sô
       missingChars = missingChars.filter(char => char >= 'A' && char <= 'Z');
       //missingChars phải có ít nhất 2 phần tử mới làm thuật toán đc, đó làm mã hóa ký tự "|" và đánh dấu các chuỗi thương
       if(missingChars.length <2) return reject({vcode:1, msg:'no success'})
       //Thay thế tất cả ký tự '|' thành ký tự số missingChars[0]
       addInfo = addInfo.replace(/\|/g, missingChars[1]);     
       //Thêm 1 ký tự vào trước và sau các chuỗi ký tự thường hoặc vừa số vưa chữ thường nắm trong chuỗi cha addInfo
       addInfo = addInfo.replace(/([a-z0-9]*[a-z]+[a-z0-9]*)/g, missingChars[0] + '$&' + missingChars[0]);
       //Đổi các ký tự trong chuỗi addInfo sang chữ hoa
       //addInfo = addInfo.toUpperCase();
       //Thêm vào đầu chuỗi addInfo 1 ký tự số
       addInfo = missingChars[1] + addInfo;
       //Thêm vào đầu chuỗi addInfo 1 ký tự số
       addInfo = missingChars[0] + addInfo;  
       //if(this.vhAuth.getDBstorage() === 'mongo'){        
         axios.post('https://api.vietqr.io/v2/generate', {...data, addInfo})
             .then((response:any)=> {      
               if(response.data.code == '00')  resolve({vcode:0, msg:response.data.desc, data: response.data.data.qrDataURL});
               else resolve({code:1, msg:response.data.desc, data: null});
             })
             .catch((e:any)=> {                          
               reject(e.response.data);
             });
       //}     
     })
   }

   


  private publishObservableEventPromotions() {
    this.subjectpromotions.next(this.promotions);
  }  

  private observableLocalPromotions():Subject<any> {      
    return this.subjectpromotions; 
  }
  
   /**
   * @example:
   * this.observablePromotion = this.vhQuerySales.getObservableLocalPromotions().subscribe((localPromotions:any) => {          
        do something... 
     })       
    
    ngOnDestroy(){
      this.observablePromotion.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  private getObservableLocalPromotions(){   
   return new Observable((observer:any) => {    
    this.observableLocalPromotions().subscribe((promotions) => {   
      observer.next(promotions);
    })
    this.publishObservableEventPromotions();
   })
  }
  
   /**
   * @example: 
   * let promotion = this.vhQuerySales.getlocalPromotion('5fb6780ca2148e09806c5b01');
   * @param id_promotion 
   * @return Object => obj = {} or null
   */
  public getlocalPromotion(id_promotion:any){
    // for(let i=0; i<this.promotions.length; i++){
    //   if(this.promotions[i]._id === id_promotion){
    //     return this.promotions[i];
    //     break;
    //   }
    // } 
    return null; 
  }


   /**
   * @example: 
   * let promotions = this.vhQuerySales.getlocalPromotions();
   * @return Array(object) => array = [{},{},...]
   */
  public getlocalPromotions(){
    return [];//this.promotions;
  }

   /**
   * @example:
   * let date = new Date();
   * this.vhQuerySales.refreshLocalPromotions(date)
          .then(()=>{
            do something.....
          }, error=>{
            console.log('error', error);
          })
   * Hàm này refresh giá trị mới nhất cho hàm getlocalPromotion(), getlocalPromotions() trong localstorage
   * @return Promise => null
   */
  private refreshLocalPromotions(date:any):any{
     return new Promise((resolve, reject) => {    
      this.getPromotions_byDate(date)
          .then(()=>{            
            resolve(null)
          }, error=>{
            console.log('error', error);
            reject(error);
          })      
    })
  }

  /**
   * @example:
   * this.vhQuerySales.addPromotion({name:'Cuối tuần vui vẻ', type:2, active:true, date_start:new Date(), date_end: new Date()})
          .then((promotion)=>{
            console.log('addPromotion', promotion);
          },(error:any)=>{
            console.log('error', error);
          })
   * @param colname 
   * @param data 
   * @return  Promise => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addPromotion(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('promotions', data)
          .then((promotion)=>{
            resolve(promotion);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updatePromotion('5fb6780ca2148e09806c5b01', {name:'Khuyến mãi 12/12'})
          .then((bool:any)=>{
            console.log('updatePromotion', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_promotion 
   * @param data 
   * @return Promise => bool = true or false
   */
  public updatePromotion(id_promotion:string, data:object){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.updateDoc('promotions', id_promotion, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })         
    })
  }
  

  /**
   * @example:
   * this.vhQuerySales.deletePromotion('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deletePromotion', bool);
        })
   * @param id_promotion 
   * @return Promise => bool = true or false 
   */
  public deletePromotion(id_promotion:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('promotions', id_promotion)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getPromotion('5fb67fda87c0f21d484cbdf3')
            .then((promotion)=>{
              console.log('getPromotion', promotion);
            })
   * @param id_promotion 
   * @return false or object
   */
  public getPromotion(id_promotion:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('promotions', id_promotion)
            .then((promotion)=>{
              resolve(promotion);
            })          
    })
  }
  
  /**
   * @example
   * this.vhQuerySales.getPromotions()
            .then((response)=>{
              console.log('getPromotions', response);
            })
   * @return array(object) = [{},{},..]
   */
  private getPromotions(){
    return new Promise((resolve, reject) => {
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('promotions')
            .then((response)=>{
                this.promotions = response;
                resolve(response);
              },(error:any)=>{
                reject(error);
              })          
      }else{
        this.vhMGDB_database.getDocsByFields('promotions', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((promotions)=>{              
              resolve(promotions);
            },(error:any)=>{
              reject(error);
            }) 
      } 
            
    })
  } 
  
   /** 
 * hàm này trả về danh sách chương trình khuyến mãi diễn ra từ thời gian fromTime đến thời gian toTime
 * @example:  
 * let fromTime = new Date();
 * let toTime = new Date('2020-07-01T05:24:00');
 * this.vhQuerySales.getPromotions_fromTime_toTime(fromTime, toTime, 'all')
        .then((res)=>{
          console.log('getPromotions_fromTime_toTime', res);
        }, error=>{
          console.log('error', error);
        })
  * @param fromTime
  * @param toTime
  * @param type: 'all' or 1->8
  * @return Promise => array(object) = [{},{},..]
  */
  public getPromotions_fromTime_toTime(fromTime: any, toTime: any, type:any){
    return new Promise((resolve, reject) => {
      let promise = new Array();
      let query1, query2, query3;
      if(type === 'all'){
        query1 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_start:{$gte:fromTime, $lte:toTime}};
        query2 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_end:{$gte:fromTime, $lte:toTime}};
        query3 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_end:{$gte:toTime}};
      }else{
        query1 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_start:{$gte:fromTime, $lte:toTime}, type:{$eq: type}};
        query2 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_end:{$gte:fromTime, $lte:toTime}, type:{$eq: type}};
        query3 = {id_branch:{$eq: this.getDefaultBranch()._id}, date_end:{$gte:toTime}, type:{$eq: type}};
      }
      
      promise[0] = this.vhMGDB_database.getDocsByFields('promotions', query1);
      promise[1] = this.vhMGDB_database.getDocsByFields('promotions', query2);
      promise[2] = this.vhMGDB_database.getDocsByFields('promotions', query3);
      Promise.all(promise)
              .then((array:any)=>{                   
                for(let i=0; i<array[0].length; i++){
                  for(let j=0; j<array[1].length; j++){
                    if(array[0][i]._id === array[1][j]._id){
                      array[1].splice(j, 1); 
                      break;
                    }
                  }
                }              
                array[2] = array[2].filter((e:any)=>(new Date(e.date_start)).getTime()<=fromTime.getTime());               
                for(let i=0; i<array[0].length; i++){
                  for(let j=0; j<array[2].length; j++){
                    if(array[0][i]._id === array[2][j]._id){
                      array[2].splice(j, 1); 
                      break;
                    }
                  }
                }
                array = array.flat();   
                //console.log('array', array);
                resolve(array);
              })
              .catch((e)=>{
                reject(e);
              })
              
    })
  }

   /** 
 * hàm này trả về danh sách chương trình khuyến mãi diễn ra tại thời điểm tạo hóa đơn => mỗi lần chỉnh lại thời gian tạo hóa đơn phải gọi hàm này
 * @example:  
 * let date = new Date();
 * this.vhQuerySales.getPromotions_byDate(date)
        .then((res)=>{
          console.log('getPromotions_byDate', res);
        }, error=>{
          console.log('error', error);
        })
  * @param date : thơi gian tạo hóa đơn
  * @return Promise => array(object) = [{},{},..]
  */
  private getPromotions_byDate(date: any){
    return new Promise((resolve, reject) => {
      date = new Date(date);
      let promise = new Array();
      let query = {id_branch:{$eq: this.getDefaultBranch()._id}, date_end:{$gte:date}};  
      this.vhMGDB_database.getDocsByFields('promotions', query)
              .then((promotions:any)=>{               
                promotions = promotions.filter((e:any)=>(new Date(e.date_start)).getTime()<=date.getTime());           
                this.promotions = [...promotions];
                resolve(promotions);
              })
              .catch((e)=>{
                reject(e);
              })
              
    })
  }

  
/**
 * Hàm này lấy về tất cả các chương trình khuyến mãi mà có id_product tham gia
 * @example:
 * let date = new Date();
 * this.vhQuerySales.getPromotions_byIDproduct_byDate(id_product, date)
        .then((promotions)=>{
          console.log('getPromotions_byIDproduct_byDate', promotions);
        }, error=>{
          console.log('error', error);
        })
  * @param id_product 
  * @param date : thơi gian tạo hóa đơn
  * @return  Array => array = [{},{},..]
  */
  private getPromotions_byIDproduct_byDate(id_product:any, date:any){  //public checkProduct_withPromotions(id_product:any, date){  
    return new Promise((resolve, reject) => {
        date = new Date(date);
        this.getPromotions_byDate(date)
            .then((promotions:any)=>{   
              let array = new Array();
              for(let i=0; i<promotions.length; i++){
                if((promotions[i].type ===1)||(promotions[i].type ===2)||(promotions[i].type ===3)){
                  let group = new Array();
                  if(promotions[i].promotion_all_products){//tất cả sản phẩm đều giảm giá
                    array.push(promotions[i]);                    
                  }else{
                    for(let j=0; j<promotions[i].products.length; j++){                      
                        if(id_product === promotions[i].products[j].id_product){
                          array.push(promotions[i]);     
                          break;
                        }                     
                    }                 
                  }   
                }     
                if((promotions[i].type ===4)||(promotions[i].type ===5)||(promotions[i].type ===6)){
                  for(let j=0; j<promotions[i].products.length; j++){                   
                    if(id_product === promotions[i].products[j].id_product){
                      array.push(promotions[i]);     
                      break;
                    }
                  
                  }
                }

              }
              resolve(array);
            }, error=>{
              console.log('error', error);
              reject(error);
            })
    })
  }

/**
 * Hàm này đổi mảng Bill_Details sang mảng Bill_Details có chương trình khuyến mãi (nếu có)
 * @example:
 * let date = new Date();
 * this.vhQuerySales.changeBillDetails_withPromotions(bill_details, date)
        .then((bill_details_promotions)=>{
          console.log('bill_details_promotions', res);
          bill_details = [...bill_details_promotions];
        }, error=>{
          console.log('error', error);
        })
  * @param bill_details 
  * @param date : thơi gian tạo hóa đơn
  * @return  Oject => obj = {bill_details_pmtype_0to6: Array, bill_details_pmtype_7: Array}}; (bill_details_pmtype_0 là bill_details ko có khuyến mãi)
  */
  public changeBillDetails_withPromotions(bill_details:any, date:any){  
    return new Promise((resolve, reject) => {
      console.log('-----changeBillDetails_withPromotions_before', cloneDeep(bill_details));
        date = new Date(date);
        this.getPromotions_byDate(date)
            .then((promotions:any)=>{                                    
              console.log('promotions', promotions);
              let promotions_SEVEN = promotions.filter((e:any)=>(e.type===7)&&(e.status));
              let promotions_SIX = promotions.filter((e:any)=>(e.type===6)&&(e.status));
              promotions = promotions.filter((e:any)=>(e.type<=5)&&(e.status));
              let arrayTotal = new Array();
              promotions = this.vhAlgorithm.sortNumberbyASC(promotions, 'type');
              for(let m=0; m<promotions.length; m++){              
                  promotions.push(promotions[0]);           
                  promotions.splice(0,1);            
                  let array = new Array();
                  let _bill_details = [...this.destroyBillDetails_withPromotions(bill_details)];
                  for(let i=0; i<promotions.length; i++){
                    if(promotions[i].type ===1){//giảm giá khi mua sản phẩm
                      let group = new Array();
                      if(promotions[i].promotion_all_products){//tất cả sản phẩm đều giảm giá
                        for(let k=0; k<_bill_details.length; k++){
                          let bill_detail = {..._bill_details[k]};
                          if(bill_detail.price === bill_detail.price_origin){                            
                            bill_detail.price = bill_detail.price - promotions[i].price_reduce;
                            group.push(bill_detail); 
                            _bill_details[k].delete = true;          
                          }
                        }                        
                        if(group.length){
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }
                          array.push(record);
                          //_bill_details = [];
                        }
                      }else{
                        for(let j=0; j<promotions[i].products.length; j++){
                          for(let k=0; k<_bill_details.length; k++){                                            
                              if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                                if(promotions[i].products[j].id_subproduct){
                                  if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){
                                    if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                      if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                        let bill_detail = {..._bill_details[k]};
                                        if(bill_detail.price === bill_detail.price_origin){     
                                          bill_detail.price =  bill_detail.price - promotions[i].products[j].price_reduce;
                                          group.push(bill_detail);
                                          _bill_details.splice(k,1);
                                          break;
                                          //_bill_details[k].delete = true;  
                                        }       
                                      }
                                      
                                    }                             
                                  }
                                }else{
                                  if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                    if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                      let bill_detail = {..._bill_details[k]};
                                      if(bill_detail.price === bill_detail.price_origin){     
                                        bill_detail.price =  bill_detail.price - promotions[i].products[j].price_reduce;
                                        group.push(bill_detail);
                                        //_bill_details[k].delete = true;         
                                        _bill_details.splice(k,1);
                                        break;
                                      }
                                    }
                                    
                                  }                            
                                }
                              }
                            
                          }
                        }
                        if(group.length){
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }     
                          array.push(record);
                        }                                                      
                      }        
                    }else if(promotions[i].type ===2){//giảm % khi mua sản phẩm
                      let group = new Array();
                      if(promotions[i].promotion_all_products){//tất cả sản phẩm đều giảm giá
                        for(let k=0; k<_bill_details.length; k++){
                          let bill_detail = {..._bill_details[k]};
                          if(bill_detail.price === bill_detail.price_origin){                            
                            bill_detail.price = bill_detail.price - bill_detail.price * promotions[i].percent_reduce / 100;
                            group.push(bill_detail);       
                            _bill_details[k].delete = true; 
                          }    
                        }   
                        if(group.length){       
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }
                          array.push(record);
                          //_bill_details = [];
                        }
                      }else{
                        for(let j=0; j<promotions[i].products.length; j++){
                          for(let k=0; k<_bill_details.length; k++){
                            if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                              if(promotions[i].products[j].id_subproduct){
                                if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){
                                  if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                    if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                      let bill_detail = {..._bill_details[k]};
                                      if(bill_detail.price === bill_detail.price_origin){                            
                                        bill_detail.price =  bill_detail.price - bill_detail.price * promotions[i].products[j].percent_reduce / 100;
                                        group.push(bill_detail);
                                        _bill_details.splice(k,1);
                                        break;
                                      }
                                    }                                   
                                  }                              
                                }
                              }else{
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    let bill_detail = {..._bill_details[k]};
                                    if(bill_detail.price === bill_detail.price_origin){                            
                                      bill_detail.price =  bill_detail.price - bill_detail.price * promotions[i].products[j].percent_reduce / 100;
                                      group.push(bill_detail);
                                      _bill_details.splice(k,1);
                                      break;
                                    }
                                  }                                  
                                }                            
                              }
                            }
                          }
                        }        
                        if(group.length){        
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }
                          array.push(record);
                        }
                      }  
                    }else if(promotions[i].type ===3){//Sản phẩm đồng giá                      
                      let group = new Array();
                      if(promotions[i].promotion_all_products){//tất cả sản phẩm đều giảm giá
                        for(let k=0; k<_bill_details.length; k++){
                          let bill_detail = {..._bill_details[k]};
                          if(bill_detail.price === bill_detail.price_origin){                            
                            bill_detail.price = promotions[i].price_same;
                            group.push(bill_detail); 
                            _bill_details[k].delete = true; 
                          }          
                        }
                        if(group.length){       
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }
                          array.push(record);
                          //_bill_details = [];
                        }
                      }else{
                        for(let j=0; j<promotions[i].products.length; j++){
                          for(let k=0; k<_bill_details.length; k++){
                            if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                              if(promotions[i].products[j].id_subproduct){
                                if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                                  
                                  if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                    if(_bill_details[k].quantity >= promotions[i].products[j].quantity){                                            
                                      let bill_detail = {..._bill_details[k]};
                                      if(bill_detail.price === bill_detail.price_origin){      
                                        bill_detail.price =  promotions[i].products[j].price_same;
                                        group.push(bill_detail);
                                        _bill_details.splice(k,1);
                                        break;
                                      }
                                    }
                                   
                                  }                              
                                }
                              }else{                                
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){                                    
                                    let bill_detail = {..._bill_details[k]};
                                    if(bill_detail.price === bill_detail.price_origin){       
                                      bill_detail.price =  promotions[i].products[j].price_same;
                                      group.push(bill_detail);
                                      _bill_details.splice(k,1);
                                      break;
                                    }
                                  }
                                 
                                }                            
                              }
                            }
                          }
                        }
                        if(group.length){
                          let record = {
                            id_promotion: promotions[i]._id,
                            name: promotions[i].name,
                            pmtype: promotions[i].type,
                            products: [...group]
                          }
                          array.push(record);
                        }
                      }   
                    }else if(promotions[i].type ===4){//giảm giá khi mua nhiều sản phẩm
                      let group = new Array();
                      let factor = 1000000000;
                      for(let j=0; j<promotions[i].products.length; j++){//lấy hệ số thưởng
                        for(let k=0; k<_bill_details.length; k++){
                          if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                            if(promotions[i].products[j].id_subproduct){
                              if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    if(_bill_details[k].price === _bill_details[k].price_origin){       
                                      if(Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity) < factor) factor = Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity);             
                                      break;
                                    }
                                  }
                                }
                              }
                            }else{
                              if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                  if(_bill_details[k].price === _bill_details[k].price_origin){ 
                                    if(Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity) < factor) factor = Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity);             
                                    break;
                                  }
                                }
                              }
                            }                              
                          }
                        }
                      }
                      //console.log('factor', factor);
                      for(let j=0; j<promotions[i].products.length; j++){//chọn ra những sản phẩm nào được KM(4) đưa vô 1 nhóm
                        for(let k=0; k<_bill_details.length; k++){
                          if(_bill_details[k].id_product === promotions[i].products[j].id_product){ 
                            if(promotions[i].products[j].id_subproduct){
                              if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    let bill_detail = {..._bill_details[k]};
                                    if(bill_detail.price === bill_detail.price_origin){       
                                      let quantity =  factor * promotions[i].products[j].quantity;
                                      bill_detail.price = bill_detail.price - promotions[i].products[j].price_reduce;
                                      bill_detail.quantity = quantity;
                                      group.push(bill_detail);             
                                      break;
                                    }
                                  }
                                }
                              }
                            }else{
                              if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                  let bill_detail = {..._bill_details[k]};
                                  if(bill_detail.price === bill_detail.price_origin){       
                                    let quantity =  factor * promotions[i].products[j].quantity;
                                    bill_detail.price = bill_detail.price - promotions[i].products[j].price_reduce;
                                    bill_detail.quantity = quantity;
                                    group.push(bill_detail);             
                                    break;
                                  }
                                }
                              }
                            }                                                 
                          }
                        }
                      }
                      //console.log('group2', group);        
                      if(group.length === promotions[i].products.length){//kiểm tra lượng sản phẩm khách mua có thỏa mãn KM(4) ko
                        for(let j=0; j<promotions[i].products.length; j++){
                          for(let k=0; k<_bill_details.length; k++){
                            if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                              if(promotions[i].products[j].id_subproduct){
                                if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                  if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                    if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                      if(_bill_details[k].price === _bill_details[k].price_origin){       
                                        let quantity =  factor * promotions[i].products[j].quantity;               
                                        _bill_details[k].quantity = _bill_details[k].quantity - quantity;
                                        if(_bill_details[k].quantity===0) _bill_details.splice(k,1);
                                        break;
                                      }
                                    }
                                  }
                                }
                              }else{
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                      if(_bill_details[k].price === _bill_details[k].price_origin){       
                                      let quantity =  factor * promotions[i].products[j].quantity;               
                                      _bill_details[k].quantity = _bill_details[k].quantity - quantity;
                                      if(_bill_details[k].quantity===0) _bill_details.splice(k,1);
                                      break;
                                    }
                                  }
                                }
                              }                                                    
                            }
                          }
                        }

                        let record = {
                          id_promotion: promotions[i]._id,
                          name: promotions[i].name,
                          pmtype: promotions[i].type,
                          products: [...group]
                        }
                        array.push(record);
                      }    
                    
                    }else if(promotions[i].type ===5){//giảm % khi mua nhiều sản phẩm
                      let group = new Array();
                      let factor = 1000000000;                 
                      for(let j=0; j<promotions[i].products.length; j++){//lấy hệ số thưởng
                        for(let k=0; k<_bill_details.length; k++){
                          if(_bill_details[k].id_product === promotions[i].products[j].id_product){
                            if(promotions[i].products[j].id_subproduct){
                              if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    if(_bill_details[k].price === _bill_details[k].price_origin){       
                                      if(Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity) < factor) factor = Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity);             
                                      break;
                                    }
                                  }
                                }
                              }
                            }else{
                              if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                  if(_bill_details[k].price === _bill_details[k].price_origin){       
                                    if(Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity) < factor) factor = Math.floor(_bill_details[k].quantity/promotions[i].products[j].quantity);             
                                    break;
                                  }
                                }
                              }
                            }                              
                          }
                        }
                      }

                      //console.log('factor', factor);                 
                      for(let j=0; j<promotions[i].products.length; j++){//chọn ra những sản phẩm nào được KM(5) đưa vô 1 nhóm
                        for(let k=0; k<_bill_details.length; k++){
                          if(_bill_details[k].id_product === promotions[i].products[j].id_product){ 
                            if(promotions[i].products[j].id_subproduct){
                              if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    let bill_detail = {..._bill_details[k]};
                                    if(bill_detail.price === bill_detail.price_origin){       
                                      let quantity =  factor * promotions[i].products[j].quantity;
                                      bill_detail.price = bill_detail.price - bill_detail.price * promotions[i].products[j].percent_reduce / 100;
                                      bill_detail.quantity = quantity;
                                      group.push(bill_detail);             
                                      break;
                                    }
                                  }
                                }
                              }
                            }else{
                              if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                  let bill_detail = {..._bill_details[k]};
                                  if(bill_detail.price === bill_detail.price_origin){       
                                    let quantity =  factor * promotions[i].products[j].quantity;
                                    bill_detail.price = bill_detail.price - bill_detail.price * promotions[i].products[j].percent_reduce / 100;
                                    bill_detail.quantity = quantity;
                                    group.push(bill_detail);             
                                    break;
                                  }
                                }
                              }
                            }                                                 
                          }
                        }
                      }


                      //console.log('group2', group);        
                      if(group.length === promotions[i].products.length){                    
                        for(let j=0; j<promotions[i].products.length; j++){
                          for(let k=0; k<_bill_details.length; k++){
                            if((_bill_details[k].id_product === promotions[i].products[j].id_product)&&(_bill_details[k].quantity >= promotions[i].products[j].quantity)){
                              if(promotions[i].products[j].id_subproduct){
                                if(_bill_details[k].id_subproduct === promotions[i].products[j].id_subproduct){                            
                                  if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                    if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                      if(_bill_details[k].price === _bill_details[k].price_origin){       
                                        let quantity =  factor * promotions[i].products[j].quantity;               
                                        _bill_details[k].quantity = _bill_details[k].quantity - quantity;
                                        if(_bill_details[k].quantity===0) _bill_details.splice(k,1);
                                        break;
                                      }
                                    }
                                  }
                                }
                              }else{
                                if(_bill_details[k].ratio === promotions[i].products[j].ratio){
                                  if(_bill_details[k].quantity >= promotions[i].products[j].quantity){
                                    if(_bill_details[k].price === _bill_details[k].price_origin){       
                                      let quantity =  factor * promotions[i].products[j].quantity;               
                                      _bill_details[k].quantity = _bill_details[k].quantity - quantity;
                                      if(_bill_details[k].quantity===0) _bill_details.splice(k,1);
                                      break;
                                    }
                                  }
                                }
                              }                                                    
                            }
                          }
                        }

                        let record = {
                          id_promotion: promotions[i]._id,
                          name: promotions[i].name,
                          pmtype: promotions[i].type,
                          products: [...group]
                        }
                        array.push(record);
                      }    
                    }

                    _bill_details = _bill_details.filter((e:any)=>e.delete!=true);
                  }
                  for(let i=0; i<array.length; i++){
                    _bill_details.push(array[i]);
                  }
                  arrayTotal.push({bill_details: [..._bill_details], total: this.sumBill_Details(_bill_details)});                
              }

              //Tách riêng trường hợp khuyến mãi 6
              let bill_details_SIX = [...this.destroyBillDetails_withPromotions(bill_details)];
              let array_SIX = new Array();
              for(let i=0; i<promotions_SIX.length; i++){//tặng quà khi mua nhiều sản phẩm
                if(promotions_SIX[i].type ===6){
                  let group = new Array();
                  let factor = 1000000000;
                  for(let j=0; j<promotions_SIX[i].products.length; j++){//lấy hệ số thưởng
                    for(let k=0; k<bill_details_SIX.length; k++){
                      if(bill_details_SIX[k].id_product === promotions_SIX[i].products[j].id_product){
                        if(promotions_SIX[i].products[j].id_subproduct){
                          if(bill_details_SIX[k].id_subproduct === promotions_SIX[i].products[j].id_subproduct){                            
                            if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                              if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                                if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                  if(Math.floor(bill_details_SIX[k].quantity/promotions_SIX[i].products[j].quantity) < factor) factor = Math.floor(bill_details_SIX[k].quantity/promotions_SIX[i].products[j].quantity);             
                                  break;
                                }
                              }
                            }
                          }
                        }else{
                          if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                            if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                              if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                if(Math.floor(bill_details_SIX[k].quantity/promotions_SIX[i].products[j].quantity) < factor) factor = Math.floor(bill_details_SIX[k].quantity/promotions_SIX[i].products[j].quantity);             
                                break;
                              }
                            }
                          }
                        }                              
                      }
                    }
                  }                  
                  for(let j=0; j<promotions_SIX[i].products.length; j++){//chọn ra những sản phẩm nào được KM(6) đưa vô 1 nhóm
                    for(let k=0; k<bill_details_SIX.length; k++){
                      if(bill_details_SIX[k].id_product === promotions_SIX[i].products[j].id_product){ 
                        if(promotions_SIX[i].products[j].id_subproduct){
                          if(bill_details_SIX[k].id_subproduct === promotions_SIX[i].products[j].id_subproduct){                            
                            if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                              if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                                if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                  let bill_detail = {...bill_details_SIX[k]};
                                  let quantity =  factor * promotions_SIX[i].products[j].quantity;                               
                                  bill_detail.quantity = quantity;
                                  group.push(bill_detail);             
                                  break;
                                }
                              }
                            }
                          }
                        }else{
                          if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                            if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                              if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                let bill_detail = {...bill_details_SIX[k]};
                                let quantity =  factor * promotions_SIX[i].products[j].quantity;                              
                                bill_detail.quantity = quantity;
                                group.push(bill_detail);             
                              break;
                              }
                            }
                          }
                        }                                                 
                      }
                    }
                  }


                  //console.log('group6', group);        
                  if(group.length === promotions_SIX[i].products.length){//Nhóm lại những sản phẩm khách mua được tặng quà                   
                    for(let j=0; j<promotions_SIX[i].products.length; j++){
                      for(let k=0; k<bill_details_SIX.length; k++){
                        if(bill_details_SIX[k].id_product === promotions_SIX[i].products[j].id_product){
                          if(promotions_SIX[i].products[j].id_subproduct){
                            if(bill_details_SIX[k].id_subproduct === promotions_SIX[i].products[j].id_subproduct){                            
                              if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                                if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                                  if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                    let quantity =  factor * promotions_SIX[i].products[j].quantity;               
                                    bill_details_SIX[k].quantity = bill_details_SIX[k].quantity - quantity;
                                    if(bill_details_SIX[k].quantity===0) bill_details_SIX.splice(k,1);
                                    break;
                                  }
                                }
                              }
                            }
                          }else{
                            if(bill_details_SIX[k].ratio === promotions_SIX[i].products[j].ratio){
                              if(bill_details_SIX[k].quantity >= promotions_SIX[i].products[j].quantity){
                                if(bill_details_SIX[k].price === bill_details_SIX[k].price_origin){    
                                  let quantity =  factor * promotions_SIX[i].products[j].quantity;               
                                  bill_details_SIX[k].quantity = bill_details_SIX[k].quantity - quantity;
                                  if(bill_details_SIX[k].quantity===0) bill_details_SIX.splice(k,1);
                                  break;
                                }
                              }
                            }
                          }                                                    
                        }
                      }
                    }

                    let products_gift = new Array();
                    for(let j=0; j<promotions_SIX[i].products_gift.length; j++){//Lấy ra những quà tặng khách có thể đc mua hoặc đc tặng
                      let product_gift:any = {};   
                      let id_sub_or_product = promotions_SIX[i].products_gift[j].id_subproduct?promotions_SIX[i].products_gift[j].id_subproduct:promotions_SIX[i].products_gift[j].id_product;                    
                      let product = this.getlocalDetailProduct(id_sub_or_product);
                      let unit = this.getUnit_byRatio(product.units, promotions_SIX[i].products_gift[j].ratio);
                      product_gift = {
                        ...promotions_SIX[i].products_gift[j],
                        earning_points_product:0,
                        id_category : product?.id_category,                         
                        ptype : product?.type,                  
                        name: product.name,
                        price_origin : unit.price, //tạm lấy giá lẻ, kiểm tra bộ chọn là giá sỉ hay giá lẻ đưa vào cho đúng
                        choose: false
                      }   
                      product_gift.quantity = product_gift.quantity * factor;    
                      if(product.id_subproduct) product_gift.id_subproduct = product.id_subproduct;
                      if(product.lots) product_gift.lots = product.lots;
                      products_gift.push(product_gift);
                    }
                    /*if(promotions_SIX[i].promotions_maximum <= products_gift.length){
                      for(let j=0; j<promotions_SIX[i].promotions_maximum; j++){
                        products_gift[j].choose = true;
                      }
                    }*/
                  
                    let record = {
                      id_promotion: promotions_SIX[i]._id,
                      name: promotions_SIX[i].name,
                      pmtype: promotions_SIX[i].type,
                      products: [...group],
                      promotions_maximum: promotions_SIX[i].promotions_maximum,
                      products_gift: [...products_gift]
                    }
                    array_SIX.push(record);
                    //console.log('array_SIX', array_SIX);      
                  } 
                }
              }

              //Tách riêng trường hợp khuyến mãi 7
              //let bill_details_SEVEN = [...this.destroyBillDetails_withPromotions(bill_details)];
              //console.log('bill_details_SEVEN', bill_details_SEVEN);
              let array_SEVEN = new Array();
              for(let i=0; i<promotions_SEVEN.length; i++){//tặng quà khi mua nhiều sản phẩm
                if(promotions_SEVEN[i].type ===7){
                    let products_gift = new Array();
                    for(let j=0; j<promotions_SEVEN[i].products_gift.length; j++){//Lấy ra những quà tặng khách có thể đc mua hoặc đc tặng                     
                      let product_gift:any = {};          
                      let id_sub_or_product = promotions_SEVEN[i].products_gift[j].id_subproduct?promotions_SEVEN[i].products_gift[j].id_subproduct:promotions_SEVEN[i].products_gift[j].id_product;            
                      let product = this.getlocalDetailProduct(id_sub_or_product);
                      let unit = this.getUnit_byRatio(product.units, promotions_SEVEN[i].products_gift[j].ratio);                     
                      product_gift = {
                        ...promotions_SEVEN[i].products_gift[j],
                        earning_points_product:0,
                        id_category : product?.id_category,                         
                        ptype : product?.type,  
                        name: product.name,
                        price_origin : unit.price, //tạm lấy giá lẻ, kiểm tra bộ chọn là giá sỉ hay giá lẻ đưa vào cho đúng
                        choose: false
                      }
                       
                      if(product.id_subproduct) product_gift.id_subproduct = product.id_subproduct;
                      if(product.lots) product_gift.lots = product.lots;
                      products_gift.push(product_gift);
                    }
                    if(promotions_SEVEN[i].promotions_maximum <= products_gift.length){
                      for(let j=0; j<promotions_SEVEN[i].promotions_maximum; j++){
                        products_gift[j].choose = false;
                      }
                    }                    
                  
                    let record = {
                      id_promotion: promotions_SEVEN[i]._id,
                      name: promotions_SEVEN[i].name,
                      pmtype: promotions_SEVEN[i].type,
                      promotions_maximum: promotions_SEVEN[i].promotions_maximum,
                      total_bill_value: promotions_SEVEN[i].total_bill_value,
                      products_gift: [...products_gift]
                    }
                    array_SEVEN.push(record);
                    //console.log('array_SEVEN', array_SEVEN);
                } 
              }
              

              
              let bill_details_OUT = new Array();
              if(arrayTotal.length){
                arrayTotal = this.vhAlgorithm.sortNumberbyASC(arrayTotal, 'total');
                //console.log('arrayTotal', arrayTotal);                
                bill_details_OUT = cloneDeep(arrayTotal[0].bill_details);//lấy phần tử 0, vì có total hóa đơn nhỏ nhất                
              }else{               
                bill_details_OUT = [...this.destroyBillDetails_withPromotions(bill_details)];               
              }
              
              if(array_SIX.length){
                for(let i=0; i<array_SIX.length; i++){
                  bill_details_OUT.push(array_SIX[i]);
                }
              }             
             
              bill_details_OUT = this.changeBillDetails_withNameUnitsLots(bill_details_OUT);
              array_SEVEN = this.changeBillDetails_withNameUnitsLots(array_SEVEN);
              console.log('-----changeBillDetails_withPromotions_after', {bill_details_pmtype_0to6: bill_details_OUT, bill_details_pmtype_7:  array_SEVEN});           
              resolve({bill_details_pmtype_0to6: bill_details_OUT, bill_details_pmtype_7:  array_SEVEN});
            
          }, error=>{
            console.log('error', error);
            reject(error);
          })
    })
  }

    /**
  * Hàm này đổi mảng Bill_Details có chương trình khuyến mãi (nếu có) sang mảng Bill_Details thường
  * @example:
  * bill_details = this.vhQuerySales.destroyBillDetails_withPromotions(bill_details_promotions)      
  * @param bill_details 
  * @return  Array => array = [{},{},..]
  */
  public destroyBillDetails_withPromotions(bill_details:any){
    bill_details = cloneDeep(bill_details);
    let array = new Array();
    //destroy các bill_details có khuyến mãi 1->6
    for(let i=0; i<bill_details.length; i++){
      if((bill_details[i].pmtype ===1)||(bill_details[i].pmtype ===2)||(bill_details[i].pmtype ===3)||(bill_details[i].pmtype ===4)||(bill_details[i].pmtype ===5)){
        for(let j=0; j<bill_details[i].products.length; j++){
          let bill_detail:any = {...bill_details[i].products[j]};
          bill_detail.price = bill_detail.price_origin;
          array.push(bill_detail);
        }      
      }else if((bill_details[i].pmtype ===6)||(bill_details[i].pmtype ===7)){
        //ko cần lấy bill_detail này
      }else{
        array.push({...bill_details[i]});
      }
    }
    //gom các bill_details giống nhau lại
    for(let i=0; i<array.length; i++){           
      if(!array[i].check){
        for(let j=i+1; j<array.length; j++){
          if(!array[j].check) 
            if(array[i].id_product === array[j].id_product){
              if(array[i].id_subproduct){
                if(array[i].id_subproduct === array[j].id_subproduct){  
                  if(array[i].id_lotproduct){
                    if(array[i].id_lotproduct === array[j].id_lotproduct){
                      if(array[i].ratio === array[j].ratio){
                        //if((array[i].price === array[i].price_origin)&&(array[j].price === array[j].price_origin)){
                        if(array[i].price === array[j].price){
                          array[i].quantity = array[i].quantity + array[j].quantity;
                          array[j].check = true;
                        }
                      }
                    }
                  }else{
                    if(array[i].ratio === array[j].ratio){
                      if(array[i].price === array[j].price){
                        array[i].quantity = array[i].quantity + array[j].quantity;
                        array[j].check = true;
                      }
                    }
                  }
                }
              }else{
                if(array[i].id_lotproduct){
                  if(array[i].id_lotproduct === array[j].id_lotproduct){
                    if(array[i].ratio === array[j].ratio){
                      if(array[i].price === array[j].price){
                        array[i].quantity = array[i].quantity + array[j].quantity;
                        array[j].check = true;
                      }
                    }
                  }
                }else{
                  if(array[i].ratio === array[j].ratio){
                    if(array[i].price === array[j].price){
                      array[i].quantity = array[i].quantity + array[j].quantity;
                      array[j].check = true;
                    }
                  }
                }                
              }             
            }
        }
      }
          
    }
    array = array.filter((e:any)=>e.check!=true);
    return cloneDeep(array);
  }

  private sumBill_Details(bill_details:any){    
    let total = 0;
    for(let i=0; i<bill_details.length; i++){
      if((bill_details[i].pmtype ===1)||(bill_details[i].pmtype ===2)||(bill_details[i].pmtype ===3)||(bill_details[i].pmtype ===4)||(bill_details[i].pmtype ===5)||(bill_details[i].pmtype ===6)){
        for(let j=0; j<bill_details[i].products.length; j++){
          total+= bill_details[i].products[j].price * bill_details[i].products[j].quantity * bill_details[i].products[j].ratio;
        }      
      }else{
        total+= bill_details[i].price * bill_details[i].quantity;
      }
    }
    return total;
  }

  /**
   * vhQuerySales
   * @param bill_details 
   * @returns 
   */
  private changeBillDetails_withPromotions_toRaw(bill_details:any){//xem bỏ id_category trong bill_detail
    console.log('changeBillDetails_withPromotions_toRaw_before', bill_details);    
    let _bill_details = cloneDeep(bill_details);
    //Kiểm tra trường hợp bill_detail là sản phẩm con mà thiếu id_subproduct
    for(let i=0; i<bill_details.length; i++){
      if(bill_details[i].id_product){
        if(!bill_details[i].id_subproduct){
          let product = this.getlocalDetailProduct(bill_details[i].id_product);
          if(!product){
            console.log('bill_detail thiếu id_subproduct');
            return null;
          }
        }
      }    
    }

    //Đổi bill_detail (voucher) thành bill_detail mà database lưu trữ
    let bill_details_voucher = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if(_bill_details[i].vtype===1){       
        for(let j=0; j<_bill_details[i].products.length; j++){
          let bill_detail = {..._bill_details[i], ..._bill_details[i].products[j]};         
          delete bill_detail.products;
          bill_details_voucher.push(bill_detail);
        }
        _bill_details[i] = null;
      }
    }
    _bill_details = _bill_details.filter((e:any)=>e!=null);
    for(let i=0; i<bill_details_voucher.length; i++){
      _bill_details.push(bill_details_voucher[i]);
    }

    //Đổi bill_detail (payment_card) thành bill_detail mà database lưu trữ
    let bill_details_payment_card = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if(_bill_details[i].pctype===1){       
        for(let j=0; j<_bill_details[i].products.length; j++){
          let bill_detail = {..._bill_details[i], ..._bill_details[i].products[j]};         
          delete bill_detail.products;
          bill_details_payment_card.push(bill_detail);
        }
        _bill_details[i] = null;
      }
    }
    _bill_details = _bill_details.filter((e:any)=>e!=null);
    for(let i=0; i<bill_details_payment_card.length; i++){
      _bill_details.push(bill_details_payment_card[i]);
    }

    //Đổi bill_detail (khuyến mãi 1,2,3,4,5) thành bill_detail mà database lưu trữ
    let bill_details_promotion = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if((_bill_details[i].pmtype===1)||(_bill_details[i].pmtype===2)||(_bill_details[i].pmtype===3)||(_bill_details[i].pmtype===4)||(_bill_details[i].pmtype===5)){       
        for(let j=0; j<_bill_details[i].products.length; j++){
          let bill_detail = {..._bill_details[i], ..._bill_details[i].products[j]};         
          delete bill_detail.products;
          bill_details_promotion.push(bill_detail);
        }
        _bill_details[i] = null;
      }
    }
    _bill_details = _bill_details.filter((e:any)=>e!=null);
    for(let i=0; i<bill_details_promotion.length; i++){
      _bill_details.push(bill_details_promotion[i]);
    }
    //Đổi bill_detail (khuyến mãi 6,7) thành bill_detail mà database lưu trữ
    bill_details_promotion = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if((_bill_details[i].pmtype===6)||(_bill_details[i].pmtype===7)){       
        for(let j=0; j<_bill_details[i].products_gift.length; j++){
          //if(_bill_details[i].products_gift[j].chose){
            let bill_detail = {..._bill_details[i], ..._bill_details[i].products_gift[j]};         
            delete bill_detail.products_gift;
            bill_details_promotion.push(bill_detail);
          //}          
        }
        _bill_details[i] = null;
      }
    }
    _bill_details = _bill_details.filter((e:any)=>e!=null);
    for(let i=0; i<bill_details_promotion.length; i++){
      _bill_details.push(bill_details_promotion[i]);
    }


    //Đổi bill_detail (sản phẩm con) thành bill_detail mà database lưu trữ
    /*for(let i=0; i<_bill_details.length; i++){
      if(_bill_details[i].id_subproduct){
        _bill_details[i].id_subs_group = _bill_details[i].id_product;
        _bill_details[i].id_product =  _bill_details[i].id_subproduct;
        delete _bill_details[i].id_subproduct;
      }
    }*/
    //Đổi bill_detail (có combo) thành bill_detail mà database lưu trư
    let bill_details_combo = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if(_bill_details[i].ptype ===5){
        let bill_detail_ID = this.vhAlgorithm.ObjectId();//bill_detail_ID này, chỉ fw sài khi tách 1 bill_detail ra thành một hoặc nhiều bill_detail
        let id_combos_group = _bill_details[i].id_product;
        let factor_combo = 1;
        if(_bill_details[i].price_origin) factor_combo = this.vhAlgorithm.roundTo3Decimals(_bill_details[i].price/_bill_details[i].price_origin);
        let combos_group = {
          earning_points_product: _bill_details[i].earning_points_product,
          price: _bill_details[i].price,
          price_origin: _bill_details[i].price_origin,
          ptype: _bill_details[i].ptype,
          quantity: _bill_details[i].quantity,
          //tax: _bill_details[i].tax,
          ratio: _bill_details[i].ratio,
          //unit:  _bill_details[i].unit,       
        }
        delete _bill_details[i].id_product;
        delete _bill_details[i].earning_points_product;
        delete _bill_details[i].price;
        delete _bill_details[i].price_origin;
        delete _bill_details[i].ptype;
        delete _bill_details[i].quantity;
        //delete _bill_details[i].tax;
        delete _bill_details[i].ratio;
        //delete _bill_details[i].unit;//nếu frontend lỡ có thì cho xóa luôn
        for(let j=0; j<_bill_details[i].combos.length; j++){
          let bill_detail = {..._bill_details[i], ..._bill_details[i].combos[j]};
          bill_detail.quantity = bill_detail.quantity * combos_group.quantity * combos_group.ratio; //do luôn tại combo ko có 2 đơn vị nên ko đưa vào cũng đc
          bill_detail.price_origin =  bill_detail.price;
          if(factor_combo !=1) bill_detail.price =  Math.round(bill_detail.price * factor_combo*100)/100;
          bill_detail.cbtype = 5;
          delete bill_detail.combos;
          bill_detail.id_combos_group = id_combos_group;
          bill_detail.combos_group = {...combos_group};
          bill_detail.bill_detail_ID = bill_detail_ID;
          bill_details_combo.push(bill_detail);
        }
        _bill_details[i] = null;
      }
    }
   
    _bill_details = _bill_details.filter((e:any)=>e!=null);
    for(let i=0; i<bill_details_combo.length; i++){
      _bill_details.push(bill_details_combo[i]);
    }
    console.log('changeBillDetails_withPromotions_toRaw_after', _bill_details);
    return _bill_details;
  }

  /**
   * vhQuerySales
   * @param bill_details 
   * @returns 
   */
  private changeBillDetails_withRaw_toPromotions(bill_details:any){//Đổi các bill_detail thành các bill_detail mà front_end làm việc
    console.log('-----changeBillDetails_withRaw_toPromotions_before', bill_details);
    let _bill_details = cloneDeep(bill_details);
    //Đổi nhiều bill_detail là thành phần của 1 combos nào đó => thành 1 bill_detail mà có 1 combos
    let bill_details_combo = new Array();
    for(let i=0; i<_bill_details.length; i++){
      if((_bill_details[i].id_combos_group)&&(!_bill_details[i].chose)){
        //Tạo bill_detail mà chưa có combos
        let bill_detail = {..._bill_details[i]};
        delete bill_detail.id_product;
        delete bill_detail.price;
        delete bill_detail.ptype;
        delete bill_detail.quantity;
        delete bill_detail.ratio;
        delete bill_detail.unit;
        bill_detail = {...bill_detail, ..._bill_details[i].combos_group};
        delete bill_detail.combos_group;      
        bill_detail.id_product = bill_detail.id_combos_group;        
        delete bill_detail.id_combos_group;
        let combos = new Array();
        for(let j=0; j<_bill_details.length; j++){//Nhóm các các combo có cùng bill_detail_ID lại
          let bill_detail_J = {..._bill_details[j]};
          if(_bill_details[i].bill_detail_ID === bill_detail_J.bill_detail_ID){
          /////  if(_bill_details[i].id_combos_group === bill_detail_J.id_combos_group){//Kiểm tra này sài đc thì bỏ bill_detail_ID
            _bill_details[j].chose  = true;
           
            let combo:any = {
              id_product: bill_detail_J.id_product,
              price: bill_detail_J.price,
              ptype: bill_detail_J.ptype,
              quantity: bill_detail_J.quantity/(bill_detail_J.combos_group.quantity * bill_detail_J.combos_group.ratio),
              ratio: bill_detail_J.ratio
              //unit: bill_detail_J.unit
            }
            if(bill_detail_J.price_origin) combo.price = bill_detail_J.price_origin; //trong reportSales_combo ko có dòng này, vì chỉ xem thôi
            if(bill_detail_J.id_subproduct){
              combo.id_subproduct = bill_detail_J.id_subproduct;         
              //delete bill_detail_J.id_subproduct;                  
            }
            if(bill_detail_J.id_lotproduct){
              combo.id_lotproduct = bill_detail_J.id_lotproduct;         
              //delete bill_detail_J.id_lotproduct;     
             
            }
            combos.push(combo);
          }
        }
        bill_detail.combos = [...combos];//map combos vào bill_detail
        delete bill_detail.id_subproduct;
        delete bill_detail.id_lotproduct;
        bill_details_combo.push(bill_detail);//trong 1 hóa đơn sẽ có nhiều bill_detail (có combo)

      }
    }
    _bill_details = _bill_details.filter((e:any)=>!e.chose);
    for(let i=0; i<bill_details_combo.length; i++){
      _bill_details.push(bill_details_combo[i]);
    }


    //Đổi bill_detail (khuyến mãi) thành bill_detail mà front_end làm việc
    let products_promotions = new Array();
    for(let i=0; i<_bill_details.length; i++){     
      let products_promotion = new Array();
      let bill_detail_promotion = null; 
        if((_bill_details[i].pmtype) && (!_bill_details[i].chose)){
          for(let j=i; j<_bill_details.length; j++){             
              if((_bill_details[j].pmtype) && (!_bill_details[j].chose)){              
                if(_bill_details[j].id_promotion ===_bill_details[i].id_promotion){                          
                    let product:any = {
                      earning_points_product: _bill_details[j]?.earning_points_product,
                      id_category: _bill_details[j]?.id_category,
                      id_product: _bill_details[j].id_product,
                      price: _bill_details[j].price,
                      price_origin:_bill_details[j].price_origin,
                      ptype: _bill_details[j].ptype,
                      quantity: _bill_details[j].quantity,
                      ratio: _bill_details[j].ratio,
                      //unit: _bill_details[j].unit
                    }        
                    if(_bill_details[j].combos) product.combos = _bill_details[j].combos;
                    if(_bill_details[j].id_subproduct) product.id_subproduct = _bill_details[j].id_subproduct;
                    if(_bill_details[j].id_lotproduct) product.id_lotproduct = _bill_details[j].id_lotproduct;//mới
                    products_promotion.push(product);
                    if(!bill_detail_promotion){
                        bill_detail_promotion = {..._bill_details[j]};
                        delete bill_detail_promotion.earning_points_product;
                        delete bill_detail_promotion.id_category;
                        delete bill_detail_promotion.id_product;
                        delete bill_detail_promotion.price;
                        delete bill_detail_promotion.price_origin;
                        delete bill_detail_promotion.ptype;
                        delete bill_detail_promotion.quantity;
                        delete bill_detail_promotion.ratio;
                        delete bill_detail_promotion.unit;
                        delete bill_detail_promotion.combos;
                        if(bill_detail_promotion.id_subproduct) delete bill_detail_promotion.id_subproduct;
                        if(bill_detail_promotion.id_lotproduct) delete bill_detail_promotion.id_lotproduct;//mới
                    }
                    _bill_details[j].chose = true;
                }           
              } 
          }
          if(bill_detail_promotion){
            if((bill_detail_promotion.pmtype===1)||(bill_detail_promotion.pmtype===2)||(bill_detail_promotion.pmtype===3)||(bill_detail_promotion.pmtype===4)||(bill_detail_promotion.pmtype===5)){
              bill_detail_promotion.products = [...products_promotion];
            }else if((bill_detail_promotion.pmtype===6)||(bill_detail_promotion.pmtype===7)){
              bill_detail_promotion.products_gift = [...products_promotion];
            }          
            products_promotions.push(bill_detail_promotion);          
          }
        }
    }   
    for(let i=0; i<products_promotions.length; i++){
      _bill_details.push(products_promotions[i]);        
    }        
    _bill_details = _bill_details.filter((e:any)=>e.chose!=true);

    //Đổi bill_detail (voucher) thành bill_detail mà front_end làm việc
    let products_vouchers = new Array();
    for(let i=0; i<_bill_details.length; i++){     
      let products_voucher = new Array();
      let bill_detail_voucher = null; 
        if((_bill_details[i].vtype===1) && (!_bill_details[i].chose)){
          for(let j=i; j<_bill_details.length; j++){             
              if((_bill_details[j].vtype ===1) && (!_bill_details[j].chose)){              
                if(_bill_details[j].id_voucher ===_bill_details[i].id_voucher){                          
                    let product:any = {
                      earning_points_product: _bill_details[j]?.earning_points_product,
                      id_category: _bill_details[j]?.id_category,
                      id_product: _bill_details[j].id_product,
                      price: _bill_details[j].price,
                      price_origin:_bill_details[j].price_origin,
                      ptype: _bill_details[j].ptype,
                      quantity: _bill_details[j].quantity,
                      ratio: _bill_details[j].ratio,
                      //unit: _bill_details[j].unit
                      //id_voucher: _bill_details[j].id_voucher,
                      //id_voucher_code: _bill_details[j].id_voucher_code
                    }        
                    if(_bill_details[j].combos) product.combos = _bill_details[j].combos;
                    if(_bill_details[j].id_subproduct) product.id_subproduct = _bill_details[j].id_subproduct;
                    if(_bill_details[j].id_lotproduct) product.id_lotproduct = _bill_details[j].id_lotproduct;//mới
                    products_voucher.push(product);
                    if(!bill_detail_voucher){
                      bill_detail_voucher = {..._bill_details[j]};
                        delete bill_detail_voucher.earning_points_product;
                        delete bill_detail_voucher.id_category;
                        delete bill_detail_voucher.id_product;
                        delete bill_detail_voucher.price;
                        delete bill_detail_voucher.price_origin;
                        delete bill_detail_voucher.ptype;
                        delete bill_detail_voucher.quantity;
                        delete bill_detail_voucher.ratio;
                        delete bill_detail_voucher.unit;
                        delete bill_detail_voucher.combos;
                        if(bill_detail_voucher.id_subproduct) delete bill_detail_voucher.id_subproduct;
                        if(bill_detail_voucher.id_lotproduct) delete bill_detail_voucher.id_lotproduct;//mới
                    }
                    _bill_details[j].chose = true;
                }           
              } 
          }
          
          if(bill_detail_voucher){            
            bill_detail_voucher.products = [...products_voucher];              
            products_vouchers.push(bill_detail_voucher);          
          }
        }
    }   
    for(let i=0; i<products_vouchers.length; i++){
      _bill_details.push(products_vouchers[i]);        
    }        
    _bill_details = _bill_details.filter((e:any)=>e.chose!=true);

    //Đổi bill_detail (payment_card) thành bill_detail mà front_end làm việc
    let products_payment_cards = new Array();
    for(let i=0; i<_bill_details.length; i++){     
      let products_payment_card = new Array();
      let bill_detail_payment_card = null; 
        if((_bill_details[i].pctype===1) && (!_bill_details[i].chose)){
          for(let j=i; j<_bill_details.length; j++){             
              if((_bill_details[j].pctype ===1) && (!_bill_details[j].chose)){              
                if(_bill_details[j].id_payment_card ===_bill_details[i].id_payment_card){                          
                    let product:any = {
                      earning_points_product: _bill_details[j]?.earning_points_product,
                      id_category: _bill_details[j]?.id_category,
                      id_product: _bill_details[j].id_product,
                      price: _bill_details[j].price,
                      price_origin:_bill_details[j].price_origin,
                      ptype: _bill_details[j].ptype,
                      quantity: _bill_details[j].quantity,
                      ratio: _bill_details[j].ratio,
                      outquantity: _bill_details[j].outquantity,
                      restquantity: _bill_details[j].restquantity
                      //unit: _bill_details[j].unit
                      //id_voucher: _bill_details[j].id_voucher,
                      //id_voucher_code: _bill_details[j].id_voucher_code
                    }        
                    if(_bill_details[j].combos) product.combos = _bill_details[j].combos;
                    if(_bill_details[j].id_subproduct) product.id_subproduct = _bill_details[j].id_subproduct;
                    if(_bill_details[j].id_lotproduct) product.id_lotproduct = _bill_details[j].id_lotproduct;//mới
                    products_payment_card.push(product);
                    if(!bill_detail_payment_card){
                      bill_detail_payment_card = {..._bill_details[j]};
                        delete bill_detail_payment_card.earning_points_product;
                        delete bill_detail_payment_card.id_category;
                        delete bill_detail_payment_card.id_product;
                        delete bill_detail_payment_card.price;
                        delete bill_detail_payment_card.price_origin;
                        delete bill_detail_payment_card.ptype;
                        delete bill_detail_payment_card.quantity;
                        delete bill_detail_payment_card.ratio;
                        delete bill_detail_payment_card.outquantity;
                        delete bill_detail_payment_card.restquantity;
                        delete bill_detail_payment_card.unit;
                        delete bill_detail_payment_card.combos;
                        if(bill_detail_payment_card.id_subproduct) delete bill_detail_payment_card.id_subproduct;
                        if(bill_detail_payment_card.id_lotproduct) delete bill_detail_payment_card.id_lotproduct;//mới
                    }
                    _bill_details[j].chose = true;
                }           
              } 
          }
          
          if(bill_detail_payment_card){            
            bill_detail_payment_card.products = [...products_payment_card];              
            products_payment_cards.push(bill_detail_payment_card);          
          }
        }
    }   
    for(let i=0; i<products_payment_cards.length; i++){
      _bill_details.push(products_payment_cards[i]);        
    }        
    _bill_details = _bill_details.filter((e:any)=>e.chose!=true);

    console.log('-----changeBillDetails_withRaw_toPromotions_after', _bill_details);
    return _bill_details;
  }

/**
 * @example:
 * this.vhQuerySales.getBillDetails_withName({name:'promition 1'})
        .then((bill_details:any)=>{
          console.log('getBillDetails_withName', bill_details);
        },(error:any)=>{
          console.log('error', error);
        })
  * @param bill_details 
  * @return  Promise => array = [{},{},...]
  * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
  */
  private changeBillDetails_withPromotionNameUnitsLots(bill_details:any){
    console.log('-----changeBillDetails_withPromotionNameUnitsLots_before', bill_details);
    let _bill_details = cloneDeep(bill_details); 
    return new Promise((resolve, reject) => {
      let promise = new Array();
      for(let i=0; i<_bill_details.length; i++){
        if(_bill_details[i].id_promotion){    
          promise[promise.length] = new Promise((resolve, reject)=>{
            this.vhMGDB_database.getDoc('promotions', _bill_details[i].id_promotion)
                .then((promotion:any)=>{
                  if(promotion){
                    _bill_details[i].name = promotion.name;
                  }
                  resolve(null);
                },(error:any)=>{
                  reject(error);
                })
          })            
        }
      }
      Promise.all(promise)
          .then(()=>{                        
            for(let i=0; i<_bill_details.length; i++){
              if((_bill_details[i].pmtype)){
                if(_bill_details[i].products){
                  for(let j=0; j<_bill_details[i].products.length; j++){
                    if((_bill_details[i].products[j].ptype ===3)||_bill_details[i].products[j].ptype ===2){
                      let id_sub_or_product = _bill_details[i].products[j].id_subproduct?_bill_details[i].products[j].id_subproduct:_bill_details[i].products[j].id_product;
                      let product = this.getlocalDetailProduct(id_sub_or_product);
                      _bill_details[i].products[j].name = product.name;
                      _bill_details[i].products[j].units = product.units;                      
                      if(product.lots) _bill_details[i].products[j].lots = product.lots;  

                    }else if(_bill_details[i].products[j].ptype ===5){
                      let product = this.getlocalDetailProduct(_bill_details[i].products[j].id_product);
                      _bill_details[i].products[j].name = product.name;
                      _bill_details[i].products[j].units = product.units;                      
                      for(let m=0; m<_bill_details[i].products[j].combos.length; m++){
                        let _id_sub_or_product = _bill_details[i].products[j].combos[m].id_subproduct?_bill_details[i].products[j].combos[m].id_subproduct:_bill_details[i].products[j].combos[m].id_product;
                        let _product = this.getlocalDetailProduct(_id_sub_or_product);
                        _bill_details[i].products[j].combos[m].name = _product.name;
                        _bill_details[i].products[j].combos[m].units = _product.units;                        
                        if(_product.lots) _bill_details[i].products[j].combos[m].lots = _product.lots;
                      }
                    }
                  }
                }
                if(_bill_details[i].products_gift){
                  for(let j=0; j<_bill_details[i].products_gift.length; j++){
                    if((_bill_details[i].products_gift[j].ptype ===3)||(_bill_details[i].products_gift[j].ptype ===2)){
                      let id_sub_or_product = _bill_details[i].products_gift[j].id_subproduct?_bill_details[i].products_gift[j].id_subproduct:_bill_details[i].products_gift[j].id_product;
                      let product = this.getlocalDetailProduct(id_sub_or_product);
                      _bill_details[i].products_gift[j].name = product.name;
                      _bill_details[i].products_gift[j].units = product.units;                      
                      if(product.lots) _bill_details[i].products_gift[j].lots = product.lots;

                    }else if(_bill_details[i].products_gift[j].ptype ===5){
                      let product = this.getlocalDetailProduct(_bill_details[i].products_gift[j].id_product);
                      _bill_details[i].products_gift[j].name = product.name;
                      _bill_details[i].products_gift[j].units = product.units;                     
                      for(let m=0; m<_bill_details[i].products_gift[j].combos.length; m++){
                        let _id_sub_or_product = _bill_details[i].products_gift[j].combos[m].id_subproduct?_bill_details[i].products_gift[j].combos[m].id_subproduct:_bill_details[i].products_gift[j].combos[m].id_product;
                        let _product = this.getlocalDetailProduct(_id_sub_or_product);
                        _bill_details[i].products_gift[j].combos[m].name = _product.name;
                        _bill_details[i].products_gift[j].combos[m].units = _product.units;
                        if(_product.lots) _bill_details[i].products_gift[j].combos[m].lots = _product.lots;
                      }
                    }
                  }
                }
              }else{              
                if((_bill_details[i].ptype ===3)||(_bill_details[i].ptype ===2)||(_bill_details[i].ptype ===6)){
                  let id_sub_or_product = _bill_details[i].id_subproduct?_bill_details[i].id_subproduct:_bill_details[i].id_product;                 
                  let product = this.getlocalDetailProduct(id_sub_or_product);
                  _bill_details[i].name = product.name;
                  _bill_details[i].units = product.units;                  
                  if(product.lots) _bill_details[i].lots = product.lots;  

                }else if(_bill_details[i].ptype ===5){
                  let product = this.getlocalDetailProduct(_bill_details[i].id_product);
                  _bill_details[i].name = product.name;
                  _bill_details[i].units = product.units;                 
                  for(let j=0; j<_bill_details[i].combos.length; j++){
                    if((_bill_details[i].combos[j].ptype ===3)||_bill_details[i].combos[j].ptype ===2){
                      let _id_sub_or_product = _bill_details[i].combos[j].id_subproduct?_bill_details[i].combos[j].id_subproduct:_bill_details[i].combos[j].id_product;
                      let _product = this.getlocalDetailProduct(_id_sub_or_product);
                      _bill_details[i].combos[j].name = _product.name;
                      _bill_details[i].combos[j].units = _product.units;                      
                      if(_product.lots) _bill_details[i].combos[j].lots = _product.lots;  
                    }
                  }
                }               
                
              }
            }
            console.log('-----changeBillDetails_withPromotionNameUnitsLots_after', _bill_details);
            resolve(_bill_details);

          }) 
          .catch((e)=>{
            reject(e);
          })    

    })
  }

  /**
  * @example:
  * let _bill_details = this.vhQuerySales.changeBillDetails_withNameUnitsLots(bill_details);      
  * @param bill_details 
  * @return  Promise => array = [{},{},...]
  * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
  */
  private changeBillDetails_withNameUnitsLots(bill_details:any){
    console.log('-----changeBillDetails_withNameUnitsLots_before', bill_details);
    let _bill_details = cloneDeep(bill_details);
    for(let i=0; i<_bill_details.length; i++){
      if((_bill_details[i].pmtype)){
        if(_bill_details[i].products){
          for(let j=0; j<_bill_details[i].products.length; j++){
            if((_bill_details[i].products[j].ptype ===3)||(_bill_details[i].products[j].ptype ===2)){
              let id_sub_or_product = _bill_details[i].products[j].id_subproduct?_bill_details[i].products[j].id_subproduct:_bill_details[i].products[j].id_product;
              let product = this.getlocalDetailProduct(id_sub_or_product);
              _bill_details[i].products[j].name = product.name;
              _bill_details[i].products[j].units = product.units;
              if(product.lots) _bill_details[i].products[j].lots = product.lots;  

            }else if(_bill_details[i].products[j].ptype ===5){
              let product = this.getlocalDetailProduct(_bill_details[i].products[j].id_product);
              _bill_details[i].products[j].name = product.name;
              _bill_details[i].products[j].units = product.units;
              for(let m=0; m<_bill_details[i].products[j].combos.length; m++){
                let _id_sub_or_product = _bill_details[i].products[j].combos[m].id_subproduct?_bill_details[i].products[j].combos[m].id_subproduct:_bill_details[i].products[j].combos[m].id_product;
                let _product = this.getlocalDetailProduct(_id_sub_or_product);
                _bill_details[i].products[j].combos[m].name = _product.name;
                _bill_details[i].products[j].combos[m].units = _product.units;
                if(_product.lots) _bill_details[i].products[j].combos[m].lots = _product.lots;
              }
            }
          }
        }
        if(_bill_details[i].products_gift){
          for(let j=0; j<_bill_details[i].products_gift.length; j++){
            if((_bill_details[i].products_gift[j].ptype ===3)||(_bill_details[i].products_gift[j].ptype ===2)){
              let id_sub_or_product = _bill_details[i].products_gift[j].id_subproduct?_bill_details[i].products_gift[j].id_subproduct:_bill_details[i].products_gift[j].id_product;
              let product = this.getlocalDetailProduct(id_sub_or_product);
              _bill_details[i].products_gift[j].name = product.name;
              _bill_details[i].products_gift[j].units = product.units;
              if(product.lots) _bill_details[i].products_gift[j].lots = product.lots;

            }else if(_bill_details[i].products_gift[j].ptype ===5){
              let product = this.getlocalDetailProduct(_bill_details[i].products_gift[j].id_product)
              _bill_details[i].products_gift[j].name = product.name;
              _bill_details[i].products_gift[j].units = product.units;
              for(let m=0; m<_bill_details[i].products_gift[j].combos.length; m++){
                let _id_sub_or_product = _bill_details[i].products_gift[j].combos[m].id_subproduct?_bill_details[i].products_gift[j].combos[m].id_subproduct:_bill_details[i].products_gift[j].combos[m].id_product;
                let _product = this.getlocalDetailProduct(_id_sub_or_product);
                _bill_details[i].products_gift[j].combos[m].name = _product.name;
                _bill_details[i].products_gift[j].combos[m].units = _product.units;
                if(_product.lots) _bill_details[i].products_gift[j].combos[m].lots = _product.lots;
              }
            }
          }
        }
      }else{              
        if((_bill_details[i].ptype ===3)||(_bill_details[i].ptype ===2)||(_bill_details[i].ptype ===6)){
          let id_sub_or_product = _bill_details[i].id_subproduct?_bill_details[i].id_subproduct:_bill_details[i].id_product;
          let product = this.getlocalDetailProduct(id_sub_or_product);
          _bill_details[i].name = product.name;
          _bill_details[i].units = product.units;
          if(product.lots) _bill_details[i].lots = product.lots;  

        }else if(_bill_details[i].ptype ===5){
          let product =  this.getlocalDetailProduct(_bill_details[i].id_product);
          _bill_details[i].name = product.name;
          _bill_details[i].units = product.units;
          for(let j=0; j<_bill_details[i].combos.length; j++){
            if((_bill_details[i].combos[j].ptype ===3)||_bill_details[i].combos[j].ptype ===2){
              let _id_sub_or_product = _bill_details[i].combos[j].id_subproduct?_bill_details[i].combos[j].id_subproduct:_bill_details[i].combos[j].id_product;
              let _product = this.getlocalDetailProduct(_id_sub_or_product);
              _bill_details[i].combos[j].name = _product.name;
              _bill_details[i].combos[j].units = _product.units;
              if(_product.lots) _bill_details[i].combos[j].lots = _product.lots;  
            }
          }
        }               
        
      }

      if((_bill_details[i].vtype === 1)||(_bill_details[i].pctype === 1)){//voucher hoặc payment_card
        if(_bill_details[i].products){
          for(let j=0; j<_bill_details[i].products.length; j++){
            if((_bill_details[i].products[j].ptype ===3)||_bill_details[i].products[j].ptype ===2){
              let id_sub_or_product = _bill_details[i].products[j].id_subproduct?_bill_details[i].products[j].id_subproduct:_bill_details[i].products[j].id_product;
              let product = this.getlocalDetailProduct(id_sub_or_product);
              _bill_details[i].products[j].name = product.name;
              _bill_details[i].products[j].units = product.units;
              if(product.lots) _bill_details[i].products[j].lots = product.lots;  

            }else if(_bill_details[i].products[j].ptype ===5){
              let product = this.getlocalDetailProduct(_bill_details[i].products[j].id_product);
              _bill_details[i].products[j].name = product.name;
              _bill_details[i].products[j].units = product.units;
              for(let m=0; m<_bill_details[i].products[j].combos.length; m++){
                let _id_sub_or_product = _bill_details[i].products[j].combos[m].id_subproduct?_bill_details[i].products[j].combos[m].id_subproduct:_bill_details[i].products[j].combos[m].id_product;
                let _product = this.getlocalDetailProduct(_id_sub_or_product);
                _bill_details[i].products[j].combos[m].name = _product.name;
                _bill_details[i].products[j].combos[m].units = _product.units;
                if(_product.lots) _bill_details[i].products[j].combos[m].lots = _product.lots;
              }
            }
          }
        }
      }
    }
    console.log('-----changeBillDetails_withNameUnitsLots_after', _bill_details);
    return cloneDeep(_bill_details);
  }

  /**
   * Hàm này lấy về 1 unit của sản phẩm theo ratio truyền vào
   * @example
   * let unit = this.vhQuerySales.getUnit_byRatio(1); 
   * @param units
   * @param ratio
   * @return Object => obj = {} hoặc null
   */
  public getUnit_byRatio(units:any, ratio:number){
    for(let i=0; i<units.length; i++){
      if(units[i].ratio === ratio){
        return units[i];        
      }
    }
    let unit = {
      unit: '--',
      ratio: ratio,
      barcode: '',
      price: 0,
      price2: 0,
      price_import: 0
    }
    return unit;
  }


/**
 * @example:
 * this.vhQuerySales.addPromotion_detail({name:'promition 1'})
        .then((promotion_details)=>{
          console.log('promotion_details', promotion_details);
        },(error:any)=>{
          console.log('error', error);
        })
  * @param colname 
  * @param data 
  * @return  Promise => obj = {}
  * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
  */
  public addPromotion_detail(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('promotion_details', data)
          .then((promotion_detail)=>{
            resolve(promotion_detail);
          },(error:any)=>{
            reject(error);
          })         
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updatePromotion_detail('5fb6780ca2148e09806c5b01', {name:'promoiton 2'})
          .then((bool:any)=>{
            console.log('updatePromotion_detail', bool);
          })
   * @param id_promotion 
   * @param data 
   * @return Promise => bool = true or false 
   */
  public updatePromotion_detail(id_promotion:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('promotion_details', id_promotion, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

  /**
   * @example:
   * this.vhQuerySales.id_promotion_detail('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('id_promotion_detail', bool);
        })
   * @param id_promotion_detail 
   * @return Promise => bool = true or false 
   */
  public deletePromotion_detail(id_promotion_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('promotion_details', id_promotion_detail)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
 
  /**
   * @example
   * this.vhQuerySales.getPromotion_detail('5fb67fda87c0f21d484cbdf3')
            .then((promotion)=>{
              console.log('getPromotion_detail', promotion);
            })
   * @param id_promotion 
   * @return false or object
   */
  public getPromotion_detail(id_promotion:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('promotion_details', id_promotion)
            .then((promotion)=>{
              resolve(promotion);
            })          
    })
  }

  /**
   * @example
   * this.vhQuerySales.getPromotion_details()
            .then((response)=>{
              console.log('getPromotion_details', response);
            })
   * @return array(object) = [{},{},..]
   */
  public getPromotion_details(){
    return new Promise((resolve, reject) => {
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('promotion_details')
            .then((response)=>{              
                resolve(response);
              },(error:any)=>{
                reject(error);
              })          
      }else{
        this.vhMGDB_database.getDocsByFields('promotion_details', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((promotion_details)=>{              
              resolve(promotion_details);
            },(error:any)=>{
              reject(error);
            }) 
      }               
    })
  } 
  
  

  //Promotions and promotion_details
  /**
   * @example
    let promotion ={       
      name: "Chuong Trinh Giam Gia 10",
      date_start: new Date(),
      date_end: new Date()         
    }
    let promotion_details =[{
      barcode: '01435438426',
      id_product: 'pro001',
      id_sub_product: 'pro00105',
      new_price: 10000,
      type: 1
    },{
      barcode: '0989070707786',
      id_product: 'pro002',
      id_sub_product: 'pro00201',
      new_price: 20000,
      type: 2
    }]
    this.vhQuerySales.addPromotion_Promotiondetail(promotion, promotion_details)
        .then((bill:any)=>{
          console.log(bill._id);
        },(error:any)=>{
          console.log('error ', error);
        })
   * @param promotion 
   * @param promotion_details   
   *  Promise Object => obj = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
  public addPromotion_Promotiondetail(promotion:any, promotion_details:any):any{       
     return new Promise((resolve, reject) => {    
      this.vhMGDB_database.addDoc('promotions', promotion)
          .then((promotion_get:any)=>{            
            let promise = new Array();
            for(let i=0; i<promotion_details.length; i++){
              let data = promotion_details[i];
              data.id_promotion = promotion_get._id;
              promise[i] = this.vhMGDB_database.addDoc('promotion_details', data)                  
            }
            Promise.all(promise)
                  .then(() => { 
                    resolve(promotion_get);
                  })
                  .catch(error => { 
                    reject(error)
                  })
          },(error:any)=>{
            reject(error);
          })           
    })
  }

  /**
   * @example:
   * this.vhQuerySales.updatePromotion_Promotiondetail('5fb6780ca2148e09806c5b01', {quantity:400})
          .then((bool:any)=>{
            console.log('updatePromotion_Promotiondetail', bool);
          }, error=>{
            console.log('error', error);
          })
   * @param id_promotion 
   * @param promotion 
   * @param promotion_details  
   * @return Promise => bool = true or false
   */
  public updatePromotion_Promotiondetail(id_promotion:any, promotion:any, promotion_details:any):any {    
     return new Promise((resolve, reject) => { 
      this.vhMGDB_database.getDocsByFields('promotion_details', {id_promotion:{$eq:id_promotion}},{},{},0)
          .then((promotion_details_get:any)=>{  
            let promise = new Array();        
            for(let i=0; i<promotion_details_get.length; i++){
              promise[i] = this.vhMGDB_database.deleteDoc('promotion_details', promotion_details_get[i]._id);             
            }   
            let data = {...promotion};                                                        
            promise[promotion_details_get.length] = this.vhMGDB_database.updateDoc('promotions', id_promotion, data);

            for(let i=0; i<promotion_details.length; i++){
              let data_2 = promotion_details[i];
              data_2.id_promotion = id_promotion;
              promise[i+promotion_details_get.length+1] = this.vhMGDB_database.addDoc('promotion_details', data_2);                  
            }
            Promise.all(promise)
              .then(() => { 
                resolve(true);
              })
              .catch(error => { 
                reject(error)
              })

          }) 
          .catch(()=>{
            resolve(false);
          })                 
    })  
  }

  /**
   * @example:
   * this.vhQuerySales.deletePromotion_Promotiondetail('5fb67fda87c0f21d484cbdf3')
        .then((bool:any)=>{
          console.log('deletePromotion_Promotiondetail', bool);
        })
   * @param id_promotion 
   * @return Promise => bool = true or false 
   */
  public deletePromotion_Promotiondetail(id_promotion:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('promotion_details', {id_promotion:{$eq:id_promotion}},{},{},0)
            .then((promotion_details:any)=>{
              let promise = new Array();        
              for(let i=0; i<promotion_details.length; i++){
                promise[i] = this.vhMGDB_database.deleteDoc('promotion_details', promotion_details[i]._id);             
              }                                                                                              
              promise[promotion_details.length] = this.vhMGDB_database.deleteDoc('promotions', id_promotion);
              Promise.all(promise)
                    .then(() => { 
                      resolve(true);
                    })
                    .catch(error => { 
                      reject(error)
                    })
              
            }) 
            .catch(()=>{
              resolve(false);
            })   
    })
  }

  /**
   * @example
   * this.vhQuerySales.getPromotion_details_byId_promotion()
            .then((promotion_details)=>{
              console.log('promotion_details', promotion_details);
            })
   * @return array(object) = [{},{},..]
   */
  public getPromotion_details_byId_promotion(id_promotion:any){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDocsByFields('promotion_details', {id_promotion:{$eq:id_promotion}},{},{},0)
              .then((promotion_details:any)=>{
                resolve(promotion_details);
              }) 
              .catch(()=>{
                resolve(false);
              })
    })  
  }


  /**
   * 
   * @param starttime 
   * @param endtime 
   * @param array_IDproduct 
   * @return Promise Array => array.length == 0 hợp lệ, được phép tạo promotion;  array.length > 0 không hợp lệ, không được phép tạo promotion
   */
  public checkNewPromotion(starttime:any, endtime:any, array_IDproduct:any){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.getDocs('promotions')
          .then((promotions:any)=>{            
            let array_promotion_id = new Array();
            let duplicates = new Array;
            if(promotions.length > 0){
              for(let i=0; i<promotions.length; i++){                
                if(new Date(starttime) < new Date(promotions[i].date_start)){
                  if(new Date(endtime) >= new Date(promotions[i].date_start)){
                    array_promotion_id.push(promotions[i]._id);                                       
                  }                  
                }else if ((new Date(starttime) >= new Date(promotions[i].date_start))&&(new Date(starttime) <= new Date(promotions[i].date_end))){
                  array_promotion_id.push(promotions[i]._id);                                     
                }
              }
              
              if(array_promotion_id.length >0){
                this.vhMGDB_database.getDocsByFields('promotion_details', {id_promotion:{$in:array_promotion_id}},{},{},0)
                    .then((promotion_details:any)=>{                                        
                      if(promotion_details.length){                      
                        for(let i=0; i<array_IDproduct.length; i++){
                          for(let j=0; j<promotion_details.length; j++){
                            if(array_IDproduct[i] === promotion_details[j].id_product){
                              duplicates.push(array_IDproduct[i]);
                              break;
                            }
                          }
                        }                        
                        resolve(duplicates);
                      }else resolve(duplicates);  
                    }) 
                    .catch((e)=>{
                      reject(e);
                    })                
              }else resolve(duplicates);  
            }else resolve(duplicates);
          },(error:any)=>{
            console.log('error', error);
          })      
    })
  }

  /**
   * 
   * @param starttime 
   * @param endtime 
   * @param array_IDproduct 
   * @param id_promotion 
   * @return Promise Array => array.length == 0 hợp lệ, được phép cập nhật promotion;  array.length > 0 không hợp lệ, không được phép cập nhật promotion
   */
  public checkOldPromotion(starttime:any, endtime:any, array_IDproduct:any, id_promotion: any){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.getDocs('promotions')
          .then((promotions:any)=>{  
            let array_promotion_id = new Array();
            let duplicates = new Array;
            if(promotions.length>0){
              for(let i=0; i<promotions.length; i++){
                if(new Date(starttime) < new Date(promotions[i].date_start)){
                  if(new Date(endtime) >= new Date(promotions[i].date_start)){
                    if(promotions[i]._id != id_promotion) array_promotion_id.push(promotions[i]._id);                                       
                  }                  
                }else if ((new Date(starttime) >= new Date(promotions[i].date_start))&&(new Date(starttime) <= new Date(promotions[i].date_end))){
                  if(promotions[i]._id != id_promotion) array_promotion_id.push(promotions[i]._id);                                     
                }
              }
              
              if(array_promotion_id.length >0){
                this.vhMGDB_database.getDocsByFields('promotion_details', {id_promotion:{$in:array_promotion_id}},{},{},0)
                    .then((promotion_details:any)=>{   
                      if(promotion_details.length>0){                      
                        for(let i=0; i<array_IDproduct.length; i++){
                          for(let j=0; j<promotion_details.length; j++){
                            if(array_IDproduct[i] === promotion_details[j].id_product){
                              duplicates.push(array_IDproduct[i]);
                              break;
                            }
                          }
                        }
                        resolve(duplicates);
                      }else resolve(duplicates);  
                    },(error:any)=>{
                      console.log('error', error);
                    })                
              }else resolve(duplicates);  
            }else resolve(duplicates); 
          })   
     
    })
  }

  private publishObservableEventAppSettingNameStations() {
    this.subjectappsettingstations.next();
  }  

  private observableLocalAppSettingNameStations():Subject<any> {      
    return this.subjectappsettingstations; 
  }
  
  /**
   * Các hàm AppSettingNameStations thêm, xóa, sửa thông tin (dạng object) riêng giữa các thiết bi, như: thông tin máy in
   * @example:
   * this.observableAppSetting = this.vhQuerySales.getObservableLocalAppSettingNameStations().subscribe(() => {          
        let info_header_footer_bill = this.vhQuerySales.getLocalAppSettingNameStation('info_header_footer_bill');
        console.log(info_header_footer_bill);
     })       
    
    ngOnDestroy(){
      this.observableAppSetting.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalAppSettingNameStations(){   
   return new Observable((observer:any) => {    
    this.observableLocalAppSettingNameStations().subscribe(() => {   
      let list = new Array();
      for(let i =0; i<this.appsettingstations.length; i++){
        list.push(this.appsettingstations[i].appsetting_name);
      }     
      observer.next(list);
    })
    this.publishObservableEventAppSettingNameStations();
   })
  }
  
  /**
  *@example:
    this.vhQuerySales.getLocalAppSettingNameStations()
        .then((list)=>{
            console.log(list);
          })  
  * @return object => list of appsetting_names
  */
 public getLocalAppSettingNameStations(){  
  let list = new Array();
  for(let i =0; i<this.appsettingstations.length; i++){
    list.push(this.appsettingstations[i].appsetting_name);
  }
  return list;     
}

/**
 * @example:
  let appsetting = this.vhQuerySales.getLocalAppSettingNameStation('info_header_footer_bill'); //printer_config_selling_page
  console.log(appsetting);
 * @param appsetting_name   
 * @return object => {title:'title',name:'name', quantity: 10}
 */
public getLocalAppSettingNameStation(appsetting_name:any){  
  let obj:any = {};   
  for(let i =0; i<this.appsettingstations.length; i++){
    if(this.appsettingstations[i].appsetting_name === appsetting_name){
      obj = {...this.appsettingstations[i]};
      delete obj._id;
      delete obj.appsetting_name;   
      break;   
    }        
  }
  return obj;
}

 /**
   * @example: 
   * let appsetting = this.vhQuerySales.getLocalAppSettingStation('5fb6780ca2148e09806c5b01');
   * @param id_appsetting 
   * @return Object => obj = {} or null
   */
  private getLocalAppSettingStation(id_appsetting:any){
    for(let i=0; i<this.appsettingstations.length; i++){
      if(this.appsettingstations[i]._id === id_appsetting){
        return this.appsettingstations[i];      
      }
    } 
    return null;        
  }

    /**
 * Hàm này refresh giá trị mới nhất cho hàm getLocalAppSettingNameStations(), getLocalAppSettingNameStation() trong localstorage
 * @return Promise => null
 */
public refreshLocalAppSettingNameStations():any{
  return new Promise((resolve, reject) => { 
    // this.getAppSettingStations().then(()=>{resolve(null)})   
    resolve(null)   
  })
}

/**
 * @example
 * this.vhQuerySales.getAppSettingStations()
          .then((settings)=>{
            console.log('getAppSettings', settings);
          })
  * @return Promise => array(object) = [{},{},..]
  */
private getAppSettingStations():any{  
  return new Promise((resolve, reject) => {      
    this.vhMGDB_database.getDocsByFields('appsettingstations',{uuid: {$eq: this.hwinfo.uuid}},{},{},0)
          .then((appsettingstations:any)=>{
            if(appsettingstations.length>0){      
              this.appsettingstations = appsettingstations;  
            }
            resolve(null);
          },(error:any)=>{
            reject(error);
          })          
  })  
}

/**
 * @example:
  this.vhQuerySales.updateAppSettingNameStation('info_header_footer_bill',{title:'title',name:'name'})
      .then((bool:any)=>{
        console.log(bool);
      })       
 * @param appsetting_name 
 * @param value 
 * @format value = {title:'title',name:'name'} 
 * @return Promise Boolean => bool = true or false 
 */ 
public updateAppSettingNameStation(appsetting_name:any, value:any) {
  return new Promise((resolve,reject) => {    
    this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid: {$eq: this.hwinfo.uuid}},{},{},0)
        .then((appsettingstations:any)=>{
             if(appsettingstations.length>0){               
              this.vhMGDB_database.updateDoc('appsettingstations', appsettingstations[0]._id, value)
                  .then((bool:any)=>{
                    resolve(bool);                   
                  }, error=>{
                    reject(error)
                  })     
             }else{
               let obj:any = {...value};
               obj.appsetting_name = appsetting_name;               
               obj.uuid = this.hwinfo.uuid;
               this.vhMGDB_database.addDoc('appsettingstations',obj)
                    .then(()=>{
                      resolve(true);
                    }, error=>{
                      reject(error)
                    }) 
             }
        })              
  })  
}
 

/**
 * @example
 * this.vhQuerySales.deleteAppSettingNameStation('info_header_footer_bill')
      .then((bool:any)=>{
        console.log(bool); 
      })
 * @param appsetting_name 
 * @return Promise Boolean => bool = true or false 
 */
public deleteAppSettingNameStation(appsetting_name:any) {
  return new Promise((resolve, reject) => {
    this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid:{$eq:this.hwinfo.uuid}},{},{},0)
        .then((appsettingstations:any)=>{
            if(appsettingstations.length>0){               
              this.vhMGDB_database.deleteDoc('appsettingstations', appsettingstations[0]._id)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })              
            }else resolve(false);
          })            
  })     
}
   
private publishObservableEventAppSettingNameBranchs() {
  this.subjectappsettingbranchs.next();
}  

private observableLocalAppSettingNameBranchs():Subject<any> {      
  return this.subjectappsettingbranchs; 
}
  
  /**
   * Các hàm AppSettingNameBranchs thêm, xóa, sửa thông tin (dạng object) riêng giữa các chi nhánh, như: thông tin cửa hang
   * @example:
   * this.observableAppSettingName = this.vhQuerySales.getObservableLocalAppSettingNameBranchs().subscribe(() => {          
        let store_info = this.vhQuerySales.getLocalAppSettingNameBranch('store_info');
        console.log(store_info);
    })    
    ngOnDestroy(){
      this.observableAppSettingName.unsubscribe();    
    }
   * @returns Observerble (Array) => Array(object) => array = [{},{},...]
   */
  public getObservableLocalAppSettingNameBranchs(){   
   return new Observable((observer:any) => {    
    this.observableLocalAppSettingNameBranchs().subscribe(() => {   
      let list = new Array();
      for(let i =0; i<this.appsettingbranchs.length; i++){
        list.push(this.appsettingbranchs[i].appsetting_name);
      }     
      observer.next(list);
    })
    this.publishObservableEventAppSettingNameBranchs();
   })
  }
  
  /**
  *@example:
    this.vhQuerySales.getLocalAppSettingNameBranchs()
        .then((list)=>{
            console.log(list);
          })  
  * @return object => list of appsetting_names
  */
 public getLocalAppSettingNameBranchs(){  
  let list = new Array();
  for(let i =0; i<this.appsettingbranchs.length; i++){
    list.push(this.appsettingbranchs[i].appsetting_name);
  }
  return list;     
}

/**
 * @example:
  let appsetting = this.vhQuerySales.getLocalAppSettingNameBranch('info_header_footer_bill');
  console.log(appsetting);
 * @param appsetting_name   
 * @return object => {title:'title',name:'name', quantity: 10}
 */
public getLocalAppSettingNameBranch(appsetting_name:any){  
  let obj:any = {}; 
  for(let i =0; i<this.appsettingbranchs.length; i++){
    if(this.appsettingbranchs[i].appsetting_name === appsetting_name){      
      obj = {...this.appsettingbranchs[i]};
      delete obj._id;
      delete obj.appsetting_name;   
      delete obj.id_branch;     
      break;   
    }        
  }
  return obj;
}

 /**
   * @example: 
   * let appsetting = this.vhQuerySales.getLocalAppSettingBranch('5fb6780ca2148e09806c5b01');
   * @param id_appsetting 
   * @return Object => obj = {} or null
   */
  private getLocalAppSettingBranch(id_appsetting:any){  
    for(let i=0; i<this.appsettingbranchs.length; i++){
      if(this.appsettingbranchs[i]._id == id_appsetting){      
        return this.appsettingbranchs[i];      
      }
    } 
    return null;        
  }

/**
 * @example:
  this.vhQuerySales.updateAppSettingNameBranch('permission_branch',{display_promotion_selling_price:true})
      .then((bool:any)=>{
        console.log(bool);
      })       
 * @param appsetting_name 
 * @param value 
 * @format value = {title:'title',name:'name'} 
 * @return Promise Boolean => bool = true or false 
 */ 
public updateAppSettingNameBranch(appsetting_name:any, value:any) {
  return new Promise((resolve,reject) => {    
    this.vhMGDB_database.getDocsByFields('appsettingbranchs',{appsetting_name:{$eq:appsetting_name}, id_branch: {$eq: this.getDefaultBranch()._id}},{},{},1)
        .then((appsettingbranchs:any)=>{
             if(appsettingbranchs.length>0){               
              this.vhMGDB_database.updateDoc('appsettingbranchs', appsettingbranchs[0]._id, value)
                  .then((bool:any)=>{
                    resolve(bool);                   
                  }, error=>{
                    reject(error)
                  })     
             }else{
               let obj:any = {...value};
               obj.appsetting_name = appsetting_name;               
               obj.id_branch = this.getDefaultBranch()._id;
               this.vhMGDB_database.addDoc('appsettingbranchs',obj)
                    .then(()=>{
                      resolve(true);
                    }, error=>{
                      reject(error)
                    }) 
             }
        })              
  })  
}
 

/**
 * @example
 * this.vhQuerySales.deleteAppSettingNameBranch('info_header_footer_bill')
      .then((bool:any)=>{
        console.log(bool); 
      })
 * @param appsetting_name 
 * @return Promise Boolean => bool = true or false 
 */
public deleteAppSettingNameBranch(appsetting_name:any) {
  return new Promise((resolve, reject) => {
    this.vhMGDB_database.getDocsByFields('appsettingbranchs',{appsetting_name:{$eq:appsetting_name}, id_branch:{$eq:this.getDefaultBranch()._id}},{},{},0)
        .then((appsettingbranchs:any)=>{
            if(appsettingbranchs.length>0){               
              this.vhMGDB_database.deleteDoc('appsettingbranchs', appsettingbranchs[0]._id)
                  .then((bool:any)=>{            
                    resolve(bool);
                  }, error=>{
                    reject(error)
                  })              
            }else resolve(false);
          })            
  })     
}

  /**
   * @Usage Hàm này dùng trong page DOANH SỐ DANH MỤC (layer 1) -> Chọn TẤT CẢ hoặc MỘT danh mục
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportSales_Categorys_byCategorys(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDcategory = 'all' or id_category
   * @param IDbranch : 'all' or id_branch
   * @param type = 2 là dịch vụ, = 3 là sản phẩm, giá trị khác là cả hai
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, id_category, quantity, sales_btax, sales_atax}
   */  

  public getReportSales_Categorys_byCategorys(starttime:any, endtime:any, IDcategory:any, type?:any, IDbranch?:string){//hàm này chỉ dành cho sản phẩm và dịch vụ      
    if(IDcategory === 'all') type = 23;
    else{
      type = this.getlocalCategory(IDcategory).type;
    }
    //console.log('_type', type); 
    return new Promise<any>((resolve, reject) => {      
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0
      }  
          
        let categorys:any = new Array();   
        let query:any; 
        let promise = new Array();
        if(IDcategory === 'all') {
          categorys = this.getlocalCategorys(type);    
        }else{
          categorys.push(this.getlocalCategory(IDcategory));    
        }
        let _bill_type = [1,3,15,41,51]
       
        if(IDcategory === 'all') {                 
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:_bill_type}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};           
          }
        }else{                 
          if((IDbranch==='all')||(IDbranch===undefined)){        
            query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:type}, bill_type: {$in:_bill_type}};         
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:type}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};         
          }
        }     
         
      if(categorys.length>0){   
        this.getBill_details_byFields(query, {},{date:1},0)
            .then((vhbill_details:any)=>{                          
              if(vhbill_details.length>0){                
                 for(let i=0; i<categorys.length; i++){       
                       let transaction = false;           
                       let category =  {...categorys[i]};                                   
                       let data:any ={   
                         id_category: category._id,  
                         name: category.name,                                                           
                         sales_btax: 0,
                         sales_atax: 0,
                         quantity: 0
                       }                            
                       for(let j=0; j<vhbill_details.length; j++){
                         let _id_category = this.getlocalDetailProduct(vhbill_details[j].id_subproduct?vhbill_details[j].id_subproduct:vhbill_details[j].id_product).id_category;
                         //console.log('_id_category', _id_category);  
                         if(vhbill_details[j].bill_type == 3){            
                                 if((type === 2)||(type === 3)){                                                          
                                   if(categorys[i]._id ===_id_category){
                                     transaction = true;                                
                                     data.quantity = data.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                                     data.sales_btax = data.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                                     data.sales_atax = data.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                                   }                                         
                                 }else if(type === 23){
                                   if(vhbill_details[j].ptype === 3){                                                                                                                
                                     if(categorys[i].type === 3){
                                       if(categorys[i]._id ===_id_category){
                                         transaction = true                         
                                         data.quantity = data.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                                         data.sales_btax = data.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                                         data.sales_atax = data.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                       }
                                     }                                                                                                       
                                   }else if(vhbill_details[j].ptype === 2){
                                       if(categorys[i]._id ===_id_category){
                                         transaction = true                         
                                         data.quantity = data.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                                         data.sales_btax = data.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                                         data.sales_atax = data.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                 
                                       }                                                               
                                   }
                                 }
                         
                         }else{
                                 if((type === 2)||(type === 3)){                                                          
                                   if(categorys[i]._id === _id_category){
                                     transaction = true;                                
                                     data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                     data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                     data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                                   }                                    
                                 }else if(type === 23){
                                     if(vhbill_details[j].ptype === 3){           
                                         if(categorys[i]._id === _id_category){
                                           transaction = true                         
                                           data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                           data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                           data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                         }                                                                                                                                               
                                     }else if(vhbill_details[j].ptype === 2){
                                         if(categorys[i]._id === _id_category){
                                           transaction = true                         
                                           data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                           data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                           data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                 
                                         }                                                               
                                     }                                          
                                 }
                         }
                       }
                       //console.log('---------------data', data);
                       if(transaction){
                         /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                         data.sales_atax = this.vhAlgorithm.roundTo3Decimals(data.sales_atax);
                         // if(data.subs != undefined)
                         //   data.subs.forEach((item:any) => {
                         //     item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                         //   });
                         // if(data.combos != undefined)  
                         //   data.combos.forEach((item:any) => {
                         //     item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                         //   });
                         json.quantity = json.quantity + data.quantity;
                         json.sales_btax = json.sales_btax + data.sales_btax;
                         json.sales_atax = json.sales_atax + data.sales_atax;
                         data.index = json.size + 1;
                         json.docs.push(data);
                         json.size++;                        
                         json.empty = false; 
                       }                                               
                 }
              }    
              console.log('getReportSales_Categorys_byCategorys', json);                     
              resolve(json);
            })
      }else resolve(json);      
    })
  }

  /**
   * @Usage Hàm này dùng trong page DOANH SỐ DANH MỤC (layer 2) -> Chọn TẤT CẢ hoặc MỘT sản phẩm -> Chọn một danh mục trong list hiện ra
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportSales_Categorys_byProducts(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param id_category
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, id_product, name, barcode, unit, img, quantity, sales_btax, sales_atax}
   */ 
  public getReportSales_Categorys_byProducts(starttime:any, endtime:any, id_category:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0 
        }   
                    
        let type = this.getlocalCategory(id_category).type;       
        let query:any;            
        let promise = new Array();
        let _bill_type = [1,3,15,41,51]
           
        if((IDbranch==='all')||(IDbranch===undefined)){        
          query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq: type}, bill_type: {$in:_bill_type}};         
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq: type}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};         
        }    
                 
        this.getBill_details_byFields(query, {},{date:1},0)
            .then((vhbill_details:any)=>{                
              if(vhbill_details.length>0){       
                let products:any = this.getlocalDetailProducts().filter((item:any)=>{
                  if(item.id_category === id_category) return <any>true;
                })            
                for(let i=0; i<products.length; i++){       
                      let transaction = false;           
                      let product =  {...products[i]};    
                      let unit = this.getUnit_byRatio(product.units, 1);                                        
                      let record:any ={   
                        id_product: product._id,                  
                        name: product.name, 
                        unit: unit.unit,
                        barcode: unit.barcode,
                        img: product.img,                                   
                        sales_btax: 0,
                        sales_atax: 0,
                        quantity: 0                                   
                      }                                                  
                      if(product.id_subproduct) record.id_subproduct = product.id_subproduct;   
                      if(products[i].lots) {
                        record.lots = cloneDeep(products[i].lots);
                        for(let m = 0; m<record.lots.length; m++){
                          record.lots[m].quantity = 0;
                          record.lots[m].sales_btax = 0;
                          record.lots[m].sales_atax = 0;
                        }
                      }          
                      for(let j=0; j<vhbill_details.length; j++){
                        let is_sub_or_product = false;
                        if(record.id_subproduct) is_sub_or_product = vhbill_details[j].id_subproduct === record.id_subproduct;
                        else is_sub_or_product = vhbill_details[j].id_product === record.id_product;
                        if(vhbill_details[j].bill_type == 3){             
                          if(is_sub_or_product){                                            
                            transaction = true     
                            if(record.lots){
                              for(let m=0; m<record.lots.length; m++){
                                if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                  record.lots[m].quantity =   record.lots[m].quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                                  record.lots[m].sales_btax = record.lots[m].sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                                  record.lots[m].sales_atax = record.lots[m].sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                                }
                              }   
                            }                       
                            record.quantity = record.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                            record.sales_btax = record.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                            record.sales_atax = record.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                            
                          }                                              
                        }else{
                          if(is_sub_or_product){                                              
                            transaction = true   
                            if(record.lots){
                              for(let m=0; m<record.lots.length; m++){
                                if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                  record.lots[m].quantity =   record.lots[m].quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                  record.lots[m].sales_btax = record.lots[m].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  record.lots[m].sales_atax = record.lots[m].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                                }
                              }   
                            }                         
                            record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                            record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                            record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                              
                            
                          }
                        }       
                      }
                      if(transaction){
                        /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                        record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);
                        if(record.subs != undefined)
                        record.subs.forEach((item:any) => {
                            item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                          });
                        if(record.combos != undefined)  
                          record.combos.forEach((item:any) => {
                            item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                          });
                        json.quantity = json.quantity + record.quantity;
                        json.sales_btax = json.sales_btax + record.sales_btax;
                        json.sales_atax = json.sales_atax + record.sales_atax;
                        record.index = json.size + 1;
                        json.docs.push(record);
                        json.size++;                        
                        json.empty = false; 
                      }                                               
                }
              }    
              console.log('getReportSales_Categorys_byProducts', json);                     
              resolve(json);
            })
    })
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ DANH MỤC (layer 3) ->  Chọn TẤT CẢ hoặc MỘT danh mục -> Chọn một danh mục trong list hiện ra -> Chọn một sản phẩm trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_Categorys_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_sub_or_product 
  * @param IDbranch : 'all' or id_branch 
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman}
  */
   public getReportSales_Categorys_byProduct(starttime:any, endtime:any, id_sub_or_product:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      (async () => {
        try{
          let json:any = {
            docs: new Array(),
            empty: true,
            size:0,
            sales_btax: 0,   
            sales_atax: 0,  
            quantity: 0
          }               
          let product = await this.getlocalDetailProduct_Async(id_sub_or_product);  
          let query:any;            
          let promise = new Array();
          let _bill_type = [1,3,15,41,51]  

          if((IDbranch==='all')||(IDbranch===undefined)){
            if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:_bill_type}};
            else                      query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:_bill_type}};
          }else{
            if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};    
            else                      query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};        
          }   
        
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                           
                if(vhbill_details.length>0){    
                  for(let i=0; i<vhbill_details.length; i++){                         
                      let transaction = false;
                      let unit = this.getUnit_byRatio(product.units, 1); 
                      let record:any ={   
                        id_product: product._id,                  
                        name: product.name,                         
                        img: product.img,        

                        ratio: unit.ratio,
                        unit: unit.unit,
                        barcode: unit.barcode,
                        
                        bill_code: vhbill_details[i].bill_code,
                        bill_type:  vhbill_details[i].bill_type,
                        id_bill: vhbill_details[i].id_bill,
                        date: vhbill_details[i].date,
                        tax: vhbill_details[i].tax,
                        salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                        customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                      }  
                      if(vhbill_details[i].id_subproduct) record.id_subproduct = vhbill_details[i].id_subproduct;                      
                      if(vhbill_details[i].id_lotproduct){
                        record.id_lotproduct = vhbill_details[i].id_lotproduct; 
                        record.lots = new Array;
                        for(let m = 0; m<product.lots.length; m++){
                          if(product.lots[m]._id === record.id_lotproduct) {
                            record.lots.push(product.lots[m]);
                            break;
                          }
                        }
                      }                        

                      if(vhbill_details[i].bill_type == 3){  
                        transaction = true;
                        record.quantity = - vhbill_details[i].quantity * vhbill_details[i].ratio;                    
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;   
                      }else{
                        transaction = true;
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                      
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;  
                      }
                      
                      if(transaction){
                        record.sales_btax = record.price * record.quantity;
                        record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                        record.index = json.size + 1;                   
                        json.docs.push(record);
                        json.size++;
                        json.empty = false;
                        json.quantity = json.quantity + record.quantity;
                        json.sales_btax = json.sales_btax + record.price * record.quantity;
                        json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                      }                                                                              
                  }                                 
                }           
                console.log('getReportSales_Categorys_byProduct', json);      
                resolve(json);                
              })
        } catch (err) {
          console.error('❌ Lỗi getReportSales_Categorys_byProduct:', err);
          reject(err);
        }  
      })();        
    })      
  }
  /**
   * @Usage Hàm này dùng trong page DOANH SỐ SẢN PHẨM & DỊCH VỤ (layer 1) -> Chọn TẤT CẢ hoặc MỘT sản phẩm, dịch vụ
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportSales_Products_byProducts(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDsub_or_product : 'all'/id_subproduct/id_product
   * @param type = 3 là sản phẩm, = 2 là dịch vụ, = 23 là sản phẩm và dịch vụ
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, quantity, sales_btax, sales_atax}
   */    
  public getReportSales_Products_byProducts(starttime:any, endtime:any, IDsub_or_product:any, type:number, IDbranch?:string){
    //Doanh số COMBO sẽ có hàm khác
    return new Promise<any>((resolve, reject) => {    
      (async () => {
        try{
          let json: any={
            docs:  new Array(),
            empty: true,
            size: 0, 
            sales_btax: 0,   
            sales_atax: 0,
            quantity: 0
          }     
          let product:any = null;
          if(IDsub_or_product != 'all') product = await this.getlocalDetailProduct_Async(IDsub_or_product); 
          let query:any;              
          let _bill_type = [1,3,15]; //40,50 voucher, thẻ trả trước ko phải sản phẩm, và có hàm riêng    
          if(IDsub_or_product === 'all') {            
            if((IDbranch==='all')||(IDbranch===undefined)){
              query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:_bill_type}};
            }else{
              query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};           
            }
          }else{              
            if((IDbranch==='all')||(IDbranch===undefined)){        
              if(product.id_subproduct){
                query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:_bill_type}};
              }else{
                query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:_bill_type}};
              }
            }else{   
              if(product.id_subproduct){      
                query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};
              }else{
                query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};
              }
            }
          }                 
            //console.log('---------products', products);   
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{                     
                if(vhbill_details.length>0){      
                  let products:any = new Array();
                  if(IDsub_or_product === 'all') {
                    products = this.getlocalDetailProducts(type);      
                  }else{
                    products.push(this.getlocalDetailProduct(IDsub_or_product));       
                  }                  
                  for(let i=0; i<products.length; i++){       
                    let transaction = false;                                      
                    let unit = this.getUnit_byRatio(products[i].units, 1);                                  
                    let record:any ={   
                      id_product: products[i]._id,                  
                      name: products[i].name, 
                      img: products[i].img, 

                      ratio: unit.ratio,
                      unit: unit.unit,
                      barcode: unit.barcode,
                                                        
                      sales_btax: 0,
                      sales_atax: 0,
                      quantity: 0
                    } 
                    if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;     
                    if(products[i].lots) {
                      record.lots = cloneDeep(products[i].lots);
                      for(let m = 0; m<record.lots.length; m++){
                        record.lots[m].quantity = 0;
                        record.lots[m].sales_btax = 0;
                        record.lots[m].sales_atax = 0;
                      }
                    }                        
                    for(let j=0; j<vhbill_details.length; j++){
                      let is_sub_or_product = false;
                      if(record.id_subproduct) is_sub_or_product = vhbill_details[j].id_subproduct === record.id_subproduct;
                      else is_sub_or_product = vhbill_details[j].id_product === record.id_product;
                      if(vhbill_details[j].bill_type == 3){                            
                        if(is_sub_or_product){                                    
                          transaction = true     
                          if(record.lots){
                            for(let m=0; m<record.lots.length; m++){
                              if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                record.lots[m].quantity =   record.lots[m].quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                                record.lots[m].sales_btax = record.lots[m].sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                                record.lots[m].sales_atax = record.lots[m].sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                              }
                            }   
                          }                     
                          record.quantity = record.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                          record.sales_btax = record.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                          record.sales_atax = record.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                      
                        }                                      
                      }else{
                        if(is_sub_or_product){                                  
                          transaction = true    
                          if(record.lots){
                            for(let m=0; m<record.lots.length; m++){
                              if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                record.lots[m].quantity =   record.lots[m].quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                record.lots[m].sales_btax = record.lots[m].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                record.lots[m].sales_atax = record.lots[m].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                              }
                            }   
                          }                      
                          record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                          record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                          record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                        
                        }
                      }
                    }
                    if(transaction){
                      /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                      record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);
                      if(record.subs != undefined)
                      record.subs.forEach((item:any) => {
                          item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                        });
                      if(record.combos != undefined)  
                      record.combos.forEach((item:any) => {
                          item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                        });
                      json.quantity = json.quantity + record.quantity;
                      json.sales_btax = json.sales_btax + record.sales_btax;
                      json.sales_atax = json.sales_atax + record.sales_atax;
                      record.index = json.size + 1;
                      json.docs.push(record);
                      json.size++;                        
                      json.empty = false; 
                    }                                               
                  }
                }    
                console.log('getReportSales_Products_byProducts', json);                     
                resolve(json);
              }) 
        }catch (err) {
          console.error('❌ Lỗi getReportSales_Products_byProduct:', err);
          reject(err);
        }  
      })();  
            
    })
  }

  /**
 * VhQuerySales
  * @Usage Hàm này dùng trong page DOANH SỐ SẢN PHẨM (layer 2) -> Chọn TẤT CẢ hoặc MỘT sản phẩm -> Chọn MỘT sản phẩm trong list
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_Products_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_sub_or_product : id_subproduct or id_product 
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman}
  */  
  public getReportSales_Products_byProduct(starttime:any, endtime:any, id_sub_or_product:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      (async () => {
        try{
            let json:any = {
              docs: new Array(),
              empty: true,
              size:0,
              sales_btax: 0,   
              sales_atax: 0,  
              quantity: 0
            }       
            let product = await this.getlocalDetailProduct_Async(id_sub_or_product);        
            let query:any;            
            let promise = new Array();
            let _bill_type = [1,3,15];     
              if((IDbranch==='all')||(IDbranch===undefined)){
                if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:_bill_type}};
                else                      query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:_bill_type}};
              }else{
                if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}}; 
                else                      query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};        
              } 
            this.getBill_details_byFields(query, {},{date:1},0)
                .then((vhbill_details:any)=>{                
                  if(vhbill_details.length>0){      
                    for(let i=0; i<vhbill_details.length; i++){                        
                      let transaction = false;                       
                      let unit = this.getUnit_byRatio(product.units, 1);   
                      let record:any ={   
                        id_product: product._id,                  
                        name: product.name, 
                        img: product.img,  

                        ratio: unit.ratio,
                        unit: unit.unit,
                        barcode: unit.barcode,                            
                        
                        bill_code: vhbill_details[i].bill_code,
                        bill_type:  vhbill_details[i].bill_type,
                        id_bill: vhbill_details[i].id_bill,
                        date: vhbill_details[i].date,
                        tax: vhbill_details[i].tax,
                        salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                        customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                      } 
                      if(vhbill_details[i].id_subproduct) record.id_subproduct = vhbill_details[i].id_subproduct;                      
                      if(vhbill_details[i].id_lotproduct){
                        record.id_lotproduct = vhbill_details[i].id_lotproduct; 
                        record.lots = new Array;
                        for(let m = 0; m<product.lots.length; m++){
                          if(product.lots[m]._id === record.id_lotproduct) {
                            record.lots.push(product.lots[m]);
                            break;
                          }
                        }
                      } 
                        
                      if(vhbill_details[i].bill_type == 3){  
                        transaction = true;
                        record.quantity = - vhbill_details[i].quantity * vhbill_details[i].ratio;                      
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;   
                      }else{
                        transaction = true;
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                     
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;   
                      }              
                      if(transaction){
                        record.sales_btax = record.price * record.quantity; 
                        record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                        record.index = json.size + 1;                   
                        json.docs.push(record);
                        json.size++;
                        json.empty = false;
                        json.quantity = json.quantity + record.quantity; 
                        json.sales_btax = json.sales_btax + record.price * record.quantity; 
                        json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                      }                                                                                
                    }                                 
                  } 
                  console.log('getReportSales_Products_byProduct', json)
                  resolve(json);
                }) 
        } catch (err) {
          console.error('❌ Lỗi getReportSales_Products_byProduct:', err);
          reject(err);
        }  
      })();      
    })      
  }

  
   /**
   * VhQuerySales
   * @Usage Hàm này dùng trong page DOANH SỐ COMBO (layer 1) -> Chọn TẤT CẢ hoặc MỘT combo
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportSales_Combos_byProducts(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDproduct : 'all'/id_product (của combo)
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, quantity, sales_btax, sales_atax}
   */    
    public getReportSales_Combos_byProducts(starttime:any, endtime:any, IDproduct:any, IDbranch?:string){
      //Doanh số COMBO sẽ có hàm khác
      return new Promise<any>((resolve, reject) => {    
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0
        }         
         
        let query:any; 
        let promise = new Array();            
        
        let _bill_type = [1,3,15,41,51];    
        if(IDproduct === 'all') {            
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, cbtype: {$eq:5}, bill_type: {$in:_bill_type}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, cbtype: {$eq:5}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};           
          }
        }else{              
          if((IDbranch==='all')||(IDbranch===undefined)){        
              query = {date: {$gte:starttime, $lte:endtime}, id_combos_group: {$eq:IDproduct}, bill_type: {$in:_bill_type}};         
          }else{  
              query = {date: {$gte:starttime, $lte:endtime}, id_combos_group: {$eq:IDproduct}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};
          }
        }           

        this.getBill_details_byFields(query, {},{date:1},0)
            .then((vhbill_details:any)=>{    
              let products:any = new Array(); 
              if(IDproduct === 'all') {
                products = this.getlocalDetailProducts(5);      
              }else{
                products.push(this.getlocalDetailProduct(IDproduct));       
              }
              //console.log('bill_details', vhbill_details);      
              //Đổi nhiều bill_detail là thành phần của 1 combos nào đó gom thành 1 bill_detail mà có 1 combos
              let bill_details_combo = new Array();
              for(let i=0; i<vhbill_details.length; i++){
                if((vhbill_details[i].id_combos_group)&&(!vhbill_details[i].chose)){
                  //Tạo bill_detail mà chưa có combos
                  let bill_detail = {...vhbill_details[i]};
                  delete bill_detail.id_product;
                  delete bill_detail.price;
                  delete bill_detail.ptype;
                  delete bill_detail.quantity;
                  delete bill_detail.ratio;
                  delete bill_detail.unit;
                  bill_detail = {...bill_detail, ...vhbill_details[i].combos_group};
                  delete bill_detail.combos_group;      
                  bill_detail.id_product = bill_detail.id_combos_group;        
                  delete bill_detail.id_combos_group;
                  let combos = new Array();
                  for(let j=0; j<vhbill_details.length; j++){
                    let bill_detail_J = {...vhbill_details[j]};                               
                      if(vhbill_details[i].bill_detail_ID === bill_detail_J.bill_detail_ID){
                        vhbill_details[j].chose  = true;                    
                      let combo:any = {
                        id_product: bill_detail_J.id_product,
                        price: bill_detail_J.price,
                        ptype: bill_detail_J.ptype,
                        quantity: bill_detail_J.quantity/(bill_detail_J.combos_group.quantity * bill_detail_J.combos_group.ratio),//kiểm tra chỗ này có nhân với ratio ko
                        ratio: bill_detail_J.ratio,                      
                      }
                      if(bill_detail_J.id_subproduct){
                        combo.id_subproduct = bill_detail_J.id_subproduct;                                  
                      }
                      if(bill_detail_J.id_lotproduct){
                        combo.id_lotproduct = bill_detail_J.id_lotproduct;                        
                      }
                      combos.push(combo);
                    }
                  }
                  bill_detail.combos = [...combos];//map combos vào bill_detail
                  delete bill_detail.id_subproduct;
                  delete bill_detail.id_lotproduct;
                  bill_details_combo.push(bill_detail);//trong 1 hóa đơn sẽ có nhiều bill_detail (có combo)
                }
              }
              vhbill_details = vhbill_details.filter((e:any)=>!e.chose);
              for(let i=0; i<bill_details_combo.length; i++){
                vhbill_details.push(bill_details_combo[i]);
              }
              //let vhbill_details = this.changeBillDetails_withRaw_toPromotions(bill_details);                
              if(vhbill_details.length>0){                        
                for(let i=0; i<products.length; i++){       
                  let transaction = false;                                      
                  let unit = this.getUnit_byRatio(products[i].units, 1);                                  
                  let record:any ={   
                    id_product: products[i]._id,                  
                    name: products[i].name, 
                    img: products[i].img, 
                    type: products[i].type, 

                    ratio: unit.ratio,
                    unit: unit.unit,
                    barcode: unit.barcode,
                                                      
                    sales_btax: 0,
                    sales_atax: 0,
                    quantity: 0
                  } 
                  // if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;     
                  // if(products[i].lots) {
                  //   record.lots = cloneDeep(products[i].lots);
                  //   for(let m = 0; m<record.lots.length; m++){
                  //     record.lots[m].quantity = 0;
                  //     record.lots[m].sales_btax = 0;
                  //     record.lots[m].sales_atax = 0;
                  //   }
                  // }                         
                  for(let j=0; j<vhbill_details.length; j++){
                    // let is_sub_or_product = false;
                    // if(record.id_subproduct) is_sub_or_product = vhbill_details[j].id_subproduct === record.id_subproduct;
                    // else is_sub_or_product = vhbill_details[j].id_product === record.id_product;
                    if(vhbill_details[j].bill_type == 3){                            
                      if(record.id_product === vhbill_details[j].id_product){                                    
                        transaction = true     
                        // if(record.lots){
                        //   for(let m=0; m<record.lots.length; m++){
                        //     if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                        //       record.lots[m].quantity =   record.lots[m].quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                        //       record.lots[m].sales_btax = record.lots[m].sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                        //       record.lots[m].sales_atax = record.lots[m].sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                        //     }
                        //   }   
                        // }                     
                        record.quantity = record.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                        record.sales_btax = record.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                        record.sales_atax = record.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                    
                      }                                      
                    }else{
                      if(record.id_product === vhbill_details[j].id_product){                                  
                        transaction = true    
                        // if(record.lots){
                        //   for(let m=0; m<record.lots.length; m++){
                        //     if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                        //       record.lots[m].quantity =   record.lots[m].quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                        //       record.lots[m].sales_btax = record.lots[m].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                        //       record.lots[m].sales_atax = record.lots[m].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                        //     }
                        //   }   
                        // }                      
                        record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                        record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                        record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                      
                      }
                    }
                  }
                  if(transaction){
                    /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                    record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);
                    if(record.subs != undefined)
                    record.subs.forEach((item:any) => {
                        item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                      });
                    if(record.combos != undefined)  
                    record.combos.forEach((item:any) => {
                        item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                      });
                    json.quantity = json.quantity + record.quantity;
                    json.sales_btax = json.sales_btax + record.sales_btax;
                    json.sales_atax = json.sales_atax + record.sales_atax;
                    record.index = json.size + 1;
                    json.docs.push(record);
                    json.size++;                        
                    json.empty = false; 
                  }                                               
                }
              }    
              console.log('getReportSales_Combos_byProducts', json);                     
              resolve(json);
            })    
      })
    }

  /**
  * VhQuerySales
  * @Usage Hàm này dùng trong page DOANH SỐ COMBO (layer 2) -> Chọn TẤT CẢ hoặc MỘT combo -> Chọn MỘT combo trong list
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_Combos_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_product
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman}
  */  
  public getReportSales_Combos_byProduct(starttime:any, endtime:any, id_product:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      (async () => {
        try{
          let json:any = {
            docs: new Array(),
            empty: true,
            size:0,
            sales_btax: 0,   
            sales_atax: 0,  
            quantity: 0
          }      
          let product = await this.getlocalDetailProduct_Async(id_product);         
          let query:any;            
          let promise = new Array();
          let _bill_type = [1,3,15,41,51]     
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, id_combos_group: {$eq:id_product}, bill_type: {$in:_bill_type}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, id_combos_group: {$eq:id_product}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};        
          }    
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((vhbill_details:any)=>{   
                  let bill_details_combo = new Array();
                    for(let i=0; i<vhbill_details.length; i++){
                      if((vhbill_details[i].id_combos_group)&&(!vhbill_details[i].chose)){
                        //Tạo bill_detail mà chưa có combos
                        let bill_detail = {...vhbill_details[i]};
                        delete bill_detail.id_product;
                        delete bill_detail.price;
                        delete bill_detail.ptype;
                        delete bill_detail.quantity;
                        delete bill_detail.ratio;
                        delete bill_detail.unit;
                        bill_detail = {...bill_detail, ...vhbill_details[i].combos_group};
                        delete bill_detail.combos_group;      
                        bill_detail.id_product = bill_detail.id_combos_group;        
                        delete bill_detail.id_combos_group;
                        let combos = new Array();
                        for(let j=0; j<vhbill_details.length; j++){
                          let bill_detail_J = {...vhbill_details[j]};                               
                            if(vhbill_details[i].bill_detail_ID === bill_detail_J.bill_detail_ID){
                              vhbill_details[j].chose  = true;                    
                            let combo:any = {
                              id_product: bill_detail_J.id_product,
                              price: bill_detail_J.price,
                              ptype: bill_detail_J.ptype,
                              quantity: bill_detail_J.quantity/(bill_detail_J.combos_group.quantity * bill_detail_J.combos_group.ratio),//kiểm tra chỗ này có nhân với ratio ko
                              ratio: bill_detail_J.ratio,                      
                            }
                            if(bill_detail_J.id_subproduct){
                              combo.id_subproduct = bill_detail_J.id_subproduct;                                  
                            }
                            if(bill_detail_J.id_lotproduct){
                              combo.id_lotproduct = bill_detail_J.id_lotproduct;                        
                            }
                            combos.push(combo);
                          }
                        }
                        bill_detail.combos = [...combos];//map combos vào bill_detail
                        delete bill_detail.id_subproduct;
                        delete bill_detail.id_lotproduct;
                        bill_details_combo.push(bill_detail);//trong 1 hóa đơn sẽ có nhiều bill_detail (có combo)
                      }
                    }
                    vhbill_details = vhbill_details.filter((e:any)=>!e.chose);
                    for(let i=0; i<bill_details_combo.length; i++){
                      vhbill_details.push(bill_details_combo[i]);
                    }             
                    if(vhbill_details.length>0){      
                      for(let i=0; i<vhbill_details.length; i++){                        
                        let transaction = false;                       
                        let unit = this.getUnit_byRatio(product.units, 1);   
                        let record:any ={   
                          id_product: product._id,                  
                          name: product.name, 
                          img: product.img,  

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                            
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        } 
                        // if(vhbill_details[i].id_subproduct) record.id_subproduct = vhbill_details[i].id_subproduct;                      
                        // if(vhbill_details[i].id_lotproduct){
                        //   record.id_lotproduct = vhbill_details[i].id_lotproduct; 
                        //   record.lots = new Array;
                        //   for(let m = 0; m<product.lots.length; m++){
                        //     if(product.lots[m]._id === record.id_lotproduct) {
                        //       record.lots.push(product.lots[m]);
                        //       break;
                        //     }
                        //   }
                        // } 
                          
                        if(vhbill_details[i].bill_type == 3){  
                          transaction = true;
                          record.quantity = - vhbill_details[i].quantity * vhbill_details[i].ratio;                         
                          record.price = vhbill_details[i].price/vhbill_details[i].ratio;   
                        }else{
                          transaction = true;
                          record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                      
                          record.price = vhbill_details[i].price/vhbill_details[i].ratio;   
                        }              
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    } 
                    console.log('getReportSales_Combos_byProduct', json)
                    resolve(json);
                  })    
        } catch (err) {
          console.error('❌ Lỗi getReportSales_Combos_byProduct:', err);
          reject(err);
        }  
      })();   
    })      
  }
    /**
   * @Usage Hàm này dùng trong page DOANH SỐ VOUCHER (layer 1) -> Chọn TẤT CẢ hoặc MỘT voucher
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportSales_Vouchers_byVouchers(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDvoucher : 'all'/id_voucher
   * @param vtype = 1 là voucher
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, quantity, sales_btax, sales_atax}
   */
  public getReportSales_Vouchers_byVouchers(starttime:any, endtime:any, IDvoucher:any, vtype:number, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {    
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0
      }            

      let vouchers:any = new Array();          
      let query:any; 
      let promise = new Array();    
     
      if(IDvoucher === 'all') {        
        promise[promise.length] = new Promise(resolve=>{
          this.vhMGDB_database.getDocs('vouchers')
                .then((_vouchers:any)=>{    
                  if(_vouchers.length) vouchers = [..._vouchers];                            
                  resolve(null);              
                })  
          })    
      }else{
        promise[promise.length] = new Promise(resolve=>{ 
          this.vhMGDB_database.getDoc('vouchers', IDvoucher)
                .then((voucher)=>{
                  if(voucher) vouchers.push(voucher);                    
                  resolve(null);                  
                }) 
          }) 
      }
  
      if(IDvoucher === 'all') {            
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$eq:40}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$eq:40}, id_branch: {$eq:IDbranch}};           
        }
      }else{              
        if((IDbranch==='all')||(IDbranch===undefined)){        
          query = {date: {$gte:starttime, $lte:endtime}, id_voucher: {$eq:IDvoucher}, bill_type: {$eq:40}};
        }else{   
          query = {date: {$gte:starttime, $lte:endtime}, id_voucher: {$eq:IDvoucher}, bill_type: {$eq:40}, id_branch: {$eq:IDbranch}};
        }
      }           
      Promise.all(promise)
            .then(()=>{
              if(vouchers.length>0){       
                //console.log('---------vouchers', vouchers);   
                this.getBill_details_byFields(query, {},{date:1},0)
                    .then((vhbill_details:any)=>{           
                      //console.log('---------vhbill_details', vhbill_details);            
                      if(vhbill_details.length>0){                        
                                for(let i=0; i<vouchers.length; i++){       
                                      let transaction = false;                                      
                                      let unit = this.getUnit_byRatio(vouchers[i].units, 1);                                  
                                      let record:any ={   
                                        id_voucher: vouchers[i]._id,    
                                        vtype:vouchers[i].type,
                                        
                                        name: vouchers[i].name, 
                                        img: vouchers[i].img, 

                                        ratio: unit.ratio,
                                        unit: unit.unit,
                                        barcode: unit.barcode,
                                                                          
                                        sales_btax: 0,
                                        sales_atax: 0,
                                        quantity: 0
                                      } 
                                                        
                                      for(let j=0; j<vhbill_details.length; j++){                               
                                        if(vhbill_details[j].bill_type == 40){                            
                                          if(vhbill_details[j].id_voucher === vouchers[i]._id){                                    
                                            transaction = true                                               
                                            record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                            record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                            record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                        
                                          }                                      
                                        }
                                      }
                                      if(transaction){
                                        /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                        record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);
                                        if(record.subs != undefined)
                                        record.subs.forEach((item:any) => {
                                            item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                          });
                                        if(record.combos != undefined)  
                                        record.combos.forEach((item:any) => {
                                            item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                          });
                                        json.quantity = json.quantity + record.quantity;
                                        json.sales_btax = json.sales_btax + record.sales_btax;
                                        json.sales_atax = json.sales_atax + record.sales_atax;
                                        record.index = json.size + 1;
                                        json.docs.push(record);
                                        json.size++;                        
                                        json.empty = false; 
                                      }                                               
                              }
                      }    
                      console.log('getReportSales_Vouchers_byVouchers', json);                     
                      resolve(json);
                    })
              }else resolve(json);   
      })   
    })
  }

  
    /**
   * @Usage Hàm này dùng trong page DOANH SỐ PAYMENT_CARD (layer 1) -> Chọn TẤT CẢ hoặc MỘT payment_card
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportSales_PaymentCards_byPaymentCards(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDpayment_card : 'all'/id_payment_card
   * @param pctype = 1 là payment_card
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, quantity, sales_btax, sales_atax}
   */
  public getReportSales_PaymentCards_byPaymentCards(starttime:any, endtime:any, IDpayment_card:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {    
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0
      }            

      let payment_cards:any = new Array();          
      let query:any; 
      let promise = new Array();    
      
      if(IDpayment_card === 'all') {        
        promise[promise.length] = new Promise(resolve=>{
          this.vhMGDB_database.getDocs('payment_cards')
                .then((_payment_cards:any)=>{    
                  if(_payment_cards.length) payment_cards = [..._payment_cards];                            
                  resolve(null);              
                })  
          })    
      }else{
        promise[promise.length] = new Promise(resolve=>{ 
          this.vhMGDB_database.getDoc('payment_cards', IDpayment_card)
                .then((_payment_card)=>{
                  if(_payment_card) payment_cards.push(_payment_card);                    
                  resolve(null);                  
                }) 
          }) 
      }
  
      if(IDpayment_card === 'all') {            
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$eq:50}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$eq:50}, id_branch: {$eq:IDbranch}};           
        }
      }else{              
        if((IDbranch==='all')||(IDbranch===undefined)){        
          query = {date: {$gte:starttime, $lte:endtime}, id_payment_card: {$eq:IDpayment_card}, bill_type: {$eq:50}};
        }else{   
          query = {date: {$gte:starttime, $lte:endtime}, id_payment_card: {$eq:IDpayment_card}, bill_type: {$eq:50}, id_branch: {$eq:IDbranch}};
        }
      }           
      Promise.all(promise)
            .then(()=>{
              if(payment_cards.length>0){       
                //console.log('---------payment_cards', payment_cards);   
                this.getBill_details_byFields(query, {},{date:1},0)
                    .then((vhbill_details:any)=>{                     
                      if(vhbill_details.length>0){                        
                                for(let i=0; i<payment_cards.length; i++){       
                                      let transaction = false;                                      
                                      let unit = this.getUnit_byRatio(payment_cards[i].units, 1);                                  
                                      let record:any ={   
                                        id_payment_card: payment_cards[i]._id,    
                                        pctype: payment_cards[i].type,

                                        name: payment_cards[i].name, 
                                        img: payment_cards[i].img,                                         

                                        ratio: unit.ratio,
                                        unit: unit.unit,
                                        barcode: unit.barcode,
                                                                          
                                        sales_btax: 0,
                                        sales_atax: 0,
                                        quantity: 0
                                      } 
                                                        
                                      for(let j=0; j<vhbill_details.length; j++){                               
                                        if(vhbill_details[j].bill_type == 50){                            
                                          if(vhbill_details[j].id_payment_card === payment_cards[i]._id){                                    
                                            transaction = true                                               
                                            record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                            record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                            record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);
                                        
                                          }                                      
                                        }
                                      }
                                      if(transaction){
                                        /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                        record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);
                                        if(record.subs != undefined)
                                        record.subs.forEach((item:any) => {
                                            item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                          });
                                        if(record.combos != undefined)  
                                        record.combos.forEach((item:any) => {
                                            item.sales_atax = this.vhAlgorithm.roundTo3Decimals(item.sales_atax);
                                          });
                                        json.quantity = json.quantity + record.quantity;
                                        json.sales_btax = json.sales_btax + record.sales_btax;
                                        json.sales_atax = json.sales_atax + record.sales_atax;
                                        record.index = json.size + 1;
                                        json.docs.push(record);
                                        json.size++;                        
                                        json.empty = false; 
                                      }                                               
                              }
                      }    
                      console.log('getReportSales_PaymentCards_byPaymentCards', json);                     
                      resolve(json);
                    })
              }else resolve(json);   
      })   
    })
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ VOUCHER (layer 2) -> Chọn TẤT CẢ hoặc MỘT voucher -> Chọn MỘT sản phẩm trong list
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_Vouchers_byVoucher(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_voucher
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman}
  */ 
  public getReportSales_Vouchers_byVoucher(starttime:any, endtime:any, id_voucher:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }      
      //let voucher = this.getlocalDetailProduct(id_voucher);  
        this.vhMGDB_database.getDoc('vouchers', id_voucher)
              .then((voucher:any)=>{
                if(voucher){
                  let query:any;  
                  if((IDbranch==='all')||(IDbranch===undefined)){
                    query = {date: {$gte:starttime, $lte:endtime}, id_voucher: {$eq:id_voucher}, bill_type: {$eq:40}};
                  }else{
                    query = {date: {$gte:starttime, $lte:endtime}, id_voucher: {$eq:id_voucher}, bill_type:  {$eq:40}, id_branch: {$eq:IDbranch}};        
                  }     
                  this.getBill_details_byFields(query, {},{date:1},0)
                      .then((vhbill_details:any)=>{                
                            if(vhbill_details.length>0){      
                              for(let i=0; i<vhbill_details.length; i++){                        
                                let transaction = false;                       
                                let unit = this.getUnit_byRatio(voucher.units, 1);   
                                let record:any ={   
                                  id_voucher: voucher._id,   
                                  vtype: voucher.type,

                                  name: voucher.name, 
                                  img: voucher.img,  
            
                                  ratio: unit.ratio,
                                  unit: unit.unit,
                                  barcode: unit.barcode,                            
                                  
                                  bill_code: vhbill_details[i].bill_code,
                                  bill_type:  vhbill_details[i].bill_type,
                                  id_bill: vhbill_details[i].id_bill,
                                  date: vhbill_details[i].date,
                                  tax: vhbill_details[i].tax,
                                  salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                                  customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                                } 
                                
                                if(vhbill_details[i].bill_type == 40){  
                                  transaction = true;
                                  record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                      
                                  record.price = vhbill_details[i].price/vhbill_details[i].ratio;   
                                }             
                                if(transaction){
                                  record.sales_btax = record.price * record.quantity; 
                                  record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                                  record.index = json.size + 1;                   
                                  json.docs.push(record);
                                  json.size++;
                                  json.empty = false;
                                  json.quantity = json.quantity + record.quantity; 
                                  json.sales_btax = json.sales_btax + record.price * record.quantity; 
                                  json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                                }                                                                                
                              }                                 
                            } 
                            console.log('getReportSales_Vouchers_byVoucher', json)
                            resolve(json);
                          })      
                }                          
              }) 
         
      
    })      
  }
/**
  * @Usage Hàm này dùng trong page DOANH SỐ PAYMENT_CARD (layer 2) -> Chọn TẤT CẢ hoặc MỘT payment_card -> Chọn MỘT payment_card trong list
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_PaymentCards_byPaymentCard(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_payment_card
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman}
  */ 
  public getReportSales_PaymentCards_byPaymentCard(starttime:any, endtime:any, id_payment_card:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }      
      //let voucher = this.getlocalDetailProduct(id_payment_card);  
        this.vhMGDB_database.getDoc('payment_cards', id_payment_card)
              .then((payment_card:any)=>{
                if(payment_card){
                  let query:any;  
                  if((IDbranch==='all')||(IDbranch===undefined)){
                    query = {date: {$gte:starttime, $lte:endtime}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq:50}};
                  }else{
                    query = {date: {$gte:starttime, $lte:endtime}, id_payment_card: {$eq:id_payment_card}, bill_type:  {$eq:50}, id_branch: {$eq:IDbranch}};        
                  }     
                  this.getBill_details_byFields(query, {},{date:1},0)
                      .then((vhbill_details:any)=>{                
                            if(vhbill_details.length>0){      
                              for(let i=0; i<vhbill_details.length; i++){                        
                                let transaction = false;                       
                                let unit = this.getUnit_byRatio(payment_card.units, 1);   
                                let record:any ={   
                                  id_payment_card: payment_card._id, 
                                  pctype: payment_card.type,

                                  name: payment_card.name, 
                                  img: payment_card.img,  
            
                                  ratio: unit.ratio,
                                  unit: unit.unit,
                                  barcode: unit.barcode,                            
                                  
                                  bill_code: vhbill_details[i].bill_code,
                                  bill_type:  vhbill_details[i].bill_type,
                                  id_bill: vhbill_details[i].id_bill,
                                  date: vhbill_details[i].date,
                                  tax: vhbill_details[i].tax,
                                  salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                                  customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                                } 
                                
                                if(vhbill_details[i].bill_type == 50){  
                                  transaction = true;
                                  record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                      
                                  record.price = vhbill_details[i].price;   
                                }             
                                if(transaction){
                                  record.sales_btax = record.price * record.quantity; 
                                  record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                                  record.index = json.size + 1;                   
                                  json.docs.push(record);
                                  json.size++;
                                  json.empty = false;
                                  json.quantity = json.quantity + record.quantity; 
                                  json.sales_btax = json.sales_btax + record.price * record.quantity; 
                                  json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                                }                                                                                
                              }                                 
                            } 
                            console.log('getReportSales_PaymentCards_byPaymentCard', json)
                            resolve(json);
                          })      
                }                          
              }) 
         
      
    })      
  }

  /**
   * @Usage : Hàm này lấy về tiền chiết khấu trên tổng giá trị hàng hóa bán ra của mỗi đơn hàng theo khách mua hàng
   * @example :
   * let discount = this.vhQuerySales.getDiscount_bill_byCustomer(43000000, '7YLcm0cFKLu2KaQQ8cyv');
   * @param total_price : Tổng giá
   * @param id_customer 
   * @returns Object or null  => obj = {discount}, discount là số tiền đc chiết khấu,
   * trả về null nghĩa là khách hàng này không có chiết khấu theo hóa đơn
   */
  public getDiscount_bill_byCustomer(total_price: number, id_customer:any){      
    let customer = this.getlocalCustomer(id_customer);
    let discount_bills:any = this.getlocalDiscount_bills();
    let customer_classs:any = this.getlocalCustomerClasss();
    let data = null;

    for(let j=0; j<customer_classs.length; j++){     
      if(customer_classs[j]._id === customer.id_customer_class){     
        if((customer_classs[j].id_discount_bill != undefined)&&(customer_classs[j].id_discount_bill != null)){   
              for(let k=0; k<discount_bills.length; k++){
                if(discount_bills[k]._id === customer_classs[j].id_discount_bill){  
                  data = {
                    discount: 0          
                    //type: discount_bills[k].type
                  };  
                  if(discount_bills[k].method === 1){//theo từng mức
                    if(((discount_bills[k].level5.sales != 0)||(discount_bills[k].level5.discount != 0)) && (total_price >= discount_bills[k].level5.sales)){                                      
                      if(discount_bills[k].type === 1) {              
                        data.discount = data.discount + (discount_bills[k].level2.sales - discount_bills[k].level1.sales) * discount_bills[k].level1.discount/100;
                        data.discount = data.discount + (discount_bills[k].level3.sales - discount_bills[k].level2.sales) * discount_bills[k].level2.discount/100;
                        data.discount = data.discount + (discount_bills[k].level4.sales - discount_bills[k].level3.sales) * discount_bills[k].level3.discount/100;
                        data.discount = data.discount + (discount_bills[k].level5.sales - discount_bills[k].level4.sales) * discount_bills[k].level4.discount/100;
                        data.discount = data.discount + (total_price - discount_bills[k].level5.sales) * discount_bills[k].level5.discount/100;
                      }else if(discount_bills[k].type === 2) {
                        data.discount =                 discount_bills[k].level1.discount; 
                        data.discount = data.discount + discount_bills[k].level2.discount; 
                        data.discount = data.discount + discount_bills[k].level3.discount; 
                        data.discount = data.discount + discount_bills[k].level4.discount; 
                        data.discount = data.discount + discount_bills[k].level5.discount; 
                      }
                    }else if(((discount_bills[k].level4.sales != 0)||(discount_bills[k].level4.discount != 0)) && (total_price >= discount_bills[k].level4.sales)){                                      
                      if(discount_bills[k].type === 1) {              
                        data.discount = data.discount + (discount_bills[k].level2.sales - discount_bills[k].level1.sales) * discount_bills[k].level1.discount/100;
                        data.discount = data.discount + (discount_bills[k].level3.sales - discount_bills[k].level2.sales) * discount_bills[k].level2.discount/100;
                        data.discount = data.discount + (discount_bills[k].level4.sales - discount_bills[k].level3.sales) * discount_bills[k].level3.discount/100;                    
                        data.discount = data.discount + (total_price - discount_bills[k].level4.sales) * discount_bills[k].level4.discount/100;
                      }else if(discount_bills[k].type === 2) {
                        data.discount =                 discount_bills[k].level1.discount; 
                        data.discount = data.discount + discount_bills[k].level2.discount; 
                        data.discount = data.discount + discount_bills[k].level3.discount; 
                        data.discount = data.discount + discount_bills[k].level4.discount; 

                      }
                    }else if(((discount_bills[k].level3.sales != 0)||(discount_bills[k].level3.discount != 0)) && (total_price >= discount_bills[k].level3.sales)){                                      
                      if(discount_bills[k].type === 1) {              
                        data.discount = data.discount + (discount_bills[k].level2.sales - discount_bills[k].level1.sales) * discount_bills[k].level1.discount/100;
                        data.discount = data.discount + (discount_bills[k].level3.sales - discount_bills[k].level2.sales) * discount_bills[k].level2.discount/100;                                                 
                        data.discount = data.discount + (total_price - discount_bills[k].level3.sales) * discount_bills[k].level3.discount/100;
                      }else if(discount_bills[k].type === 2) {
                        data.discount =                 discount_bills[k].level1.discount; 
                        data.discount = data.discount + discount_bills[k].level2.discount; 
                        data.discount = data.discount + discount_bills[k].level3.discount;                           
                      }
                    }else if(((discount_bills[k].level2.sales != 0)||(discount_bills[k].level2.discount != 0)) && (total_price >= discount_bills[k].level2.sales)){                                      
                      if(discount_bills[k].type === 1) {              
                        data.discount = data.discount + (discount_bills[k].level2.sales - discount_bills[k].level1.sales) * discount_bills[k].level1.discount/100;                                                
                        data.discount = data.discount + (total_price - discount_bills[k].level2.sales) * discount_bills[k].level2.discount/100;
                      }else if(discount_bills[k].type === 2) {
                        data.discount =                 discount_bills[k].level1.discount; 
                        data.discount = data.discount + discount_bills[k].level2.discount;                                   
                      }
                    }else if(((discount_bills[k].level1.sales != 0)||(discount_bills[k].level1.discount != 0)) && (total_price >= discount_bills[k].level1.sales)){                                      
                      if(discount_bills[k].type === 1) {                                                                                        
                        data.discount = data.discount + (total_price - discount_bills[k].level1.sales) * discount_bills[k].level1.discount/100;
                      }else if(discount_bills[k].type === 2) {
                        data.discount =                      discount_bills[k].level1.discount;                                                               
                      }
                    }                                    
                    
                  }else if(discount_bills[k].method === 2){//theo mức cuối
                    if(((discount_bills[k].level5.sales != 0)||(discount_bills[k].level5.discount != 0)) && (total_price >= discount_bills[k].level5.sales)){                                   
                      if(discount_bills[k].type === 1) data.discount = total_price * discount_bills[k].level5.discount/100;
                      else if(discount_bills[k].type === 2) data.discount = discount_bills[k].level5.discount;                                      
                    
                    }else if(((discount_bills[k].level4.sales != 0)||(discount_bills[k].level4.discount != 0)) && (total_price >= discount_bills[k].level4.sales)){                                     
                      if(discount_bills[k].type === 1) data.discount = total_price * discount_bills[k].level4.discount/100;
                      else if(discount_bills[k].type === 2) data.discount = discount_bills[k].level4.discount;    

                    }else if(((discount_bills[k].level3.sales != 0)||(discount_bills[k].level3.discount != 0))&& (total_price >= discount_bills[k].level3.sales)){                                     
                      if(discount_bills[k].type === 1) data.discount = total_price * discount_bills[k].level3.discount/100;
                      else if(discount_bills[k].type === 2) data.discount = discount_bills[k].level3.discount;    

                    }else if(((discount_bills[k].level2.sales != 0)||(discount_bills[k].level2.discount != 0)) && (total_price >= discount_bills[k].level2.sales)){                                   
                      if(discount_bills[k].type === 1) data.discount = total_price * discount_bills[k].level2.discount/100;
                      else if(discount_bills[k].type === 2) data.discount = discount_bills[k].level2.discount;    

                    }else if(((discount_bills[k].level1.sales != 0)||(discount_bills[k].level1.discount != 0)) && (total_price >= discount_bills[k].level1.sales)){                                    
                      if(discount_bills[k].type === 1) data.discount = total_price * discount_bills[k].level1.discount/100;
                      else if(discount_bills[k].type === 2) data.discount = discount_bills[k].level1.discount;    
                    }
                  }       
                  break; 
                }      
              }
            }
          }
        }
    return data;//{type(% or money),discount}
  }
  /** 
   * @Usage :Hàm này dùng trong page CHIẾT KHẤU KHÁCH HÀNG -> Chọn TẤT CẢ hoặc MỘT khách hàng
   * @notice : Mỗi công thức chiết khấu có 5 mức (level1, level2, level3, level4, level5), giá trị doanh số (sales) level sau phải lơn hơn level trước
   * type : 1 chiết khấu %, 2 chiết khấu tiền
   * method : 1 phương pháp tính theo từng mức, 2 phương pháp tính theo mức cuối
   * usage: 1 chiết khấu trên hóa đơn, 2 chiết khấu trên doanh số
   * @example :
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportDiscount_sales_Customers(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((discounts)=>{
            console.log('discounts', discounts);
            console.log('discounts.docs[0]', discounts.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDcustomer : 'all' or id_customer
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, img, discount_name,sales_btax, discount_btax, sales_atax, discount_atax}
   */
  public getReportDiscount_sales_Customers(starttime:any, endtime:any, IDcustomer:any, IDbranch?:string){     
    return new Promise<any>((resolve, reject) => { 
      let customers:any = new Array();   
      if(IDcustomer === 'all') customers = this.getlocalCustomers()   
      else {
        let customer = this.getlocalCustomer(IDcustomer);          
        customers.push(customer);      
      }             
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        discount_btax: 0,
        discount_atax: 0
        //quantity: 0 
      }               
      if(customers.length>0){                                
        let query:any;
        if(IDcustomer === 'all'){        
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,41,51]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,41,51]}, id_branch: {$eq:IDbranch}};          
          }
        }else{
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:[1,3,15,41,51]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:[1,3,15,41,51]}, id_branch: {$eq:IDbranch}};            
          }
          
        }        
      
        let promise1 =  this.vhMGDB_database.getDocsByFields('discount_saless', {}, {},{},0);            
        let promise2 =  this.getBill_details_byFields(query, {},{date:1},0);
        let promise3 =  this.vhMGDB_database.getDocsByFields('customer_classs',  {}, {},{},0); 
        Promise.all([promise1, promise2, promise3])
                .then((array:any)=>{                              
                    let discounts = array[0];
                    let vhbill_details = array[1];
                    let customer_classs = array[2];
                    if(vhbill_details.length>0){                                                 
                      for(let i=0; i<customers.length; i++){   
                        let transaction = false;                                                                 
                        let data:any ={   
                          id_customer: customers[i]._id,                  
                          name: customers[i].name,                          
                          img: customers[i]?.img,                                   
                          sales_btax: 0,
                          sales_atax: 0,
                          quantity: 0,
                          discount_btax: 0,
                          discount_atax: 0,
                          discount_name: ''
                        }  
                        //Tính doanh số cho mỗi khách hàng                                                                     
                        for(let j=0; j<vhbill_details.length; j++){                           
                          if(customers[i]._id ===vhbill_details[j].id_customer){  
                            transaction = true;  
                            if(vhbill_details[j].bill_type == 3){                                                                                                     
                              data.quantity = data.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                              data.sales_btax = data.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                              data.sales_atax = data.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                            }else{                                                                                                   
                              data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                              data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                              data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                            }              
                          }
                        }
                        //Tính chiết khấu trên doanh số cho mỗi khách hàng
                        if(transaction){
                          if((customers[i].id_customer_class != undefined)&&(customers[i].id_customer_class != null)){        
                            for(let j=0; j<customer_classs.length; j++){     
                              if(customer_classs[j]._id === customers[i].id_customer_class){     
                                if((customer_classs[j].id_discount_sales != undefined)&&(customer_classs[j].id_discount_sales != null)){   
                                      for(let k=0; k<discounts.length; k++){                                
                                        if(discounts[k]._id === customer_classs[j].id_discount_sales){     
                                          data.discount_name = discounts[k].name;                                              
                                            //Tính cho gia trị trước thuế
                                            if(discounts[k].method === 1){//theo từng mức
                                              if(((discounts[k].level5.sales != 0)||(discounts[k].level5.discount != 0)) && (data.sales_btax >= discounts[k].level5.sales)){                                      
                                                if(discounts[k].type === 1) {                                        
                                                  //data.discount_btax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                  data.discount_btax = data.discount_btax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                  data.discount_btax = data.discount_btax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                                  data.discount_btax = data.discount_btax + (discounts[k].level4.sales - discounts[k].level3.sales) * discounts[k].level3.discount/100;
                                                  data.discount_btax = data.discount_btax + (discounts[k].level5.sales - discounts[k].level4.sales) * discounts[k].level4.discount/100;
                                                  data.discount_btax = data.discount_btax + (data.sales_btax - discounts[k].level5.sales) * discounts[k].level5.discount/100;
                                                }else if(discounts[k].type === 2) {
                                                  data.discount_btax =                      discounts[k].level1.discount; 
                                                  data.discount_btax = data.discount_btax + discounts[k].level2.discount; 
                                                  data.discount_btax = data.discount_btax + discounts[k].level3.discount; 
                                                  data.discount_btax = data.discount_btax + discounts[k].level4.discount; 
                                                  data.discount_btax = data.discount_btax + discounts[k].level5.discount; 
                                                }
                                              }else if(((discounts[k].level4.sales != 0)||(discounts[k].level4.discount != 0)) && (data.sales_btax >= discounts[k].level4.sales)){                                      
                                                if(discounts[k].type === 1) {                                         
                                                  //data.discount_btax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                  data.discount_btax = data.discount_btax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                  data.discount_btax = data.discount_btax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                                  data.discount_btax = data.discount_btax + (discounts[k].level4.sales - discounts[k].level3.sales) * discounts[k].level3.discount/100;                    
                                                  data.discount_btax = data.discount_btax + (data.sales_btax - discounts[k].level4.sales) * discounts[k].level4.discount/100;
                                                }else if(discounts[k].type === 2) {
                                                  data.discount_btax =                      discounts[k].level1.discount; 
                                                  data.discount_btax = data.discount_btax + discounts[k].level2.discount; 
                                                  data.discount_btax = data.discount_btax + discounts[k].level3.discount; 
                                                  data.discount_btax = data.discount_btax + discounts[k].level4.discount; 
                                    
                                                }
                                              }else if(((discounts[k].level3.sales != 0)||(discounts[k].level3.discount != 0)) && (data.sales_btax >= discounts[k].level3.sales)){                                      
                                                if(discounts[k].type === 1) {                                        
                                                  //data.discount_btax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                  data.discount_btax = data.discount_btax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                  data.discount_btax = data.discount_btax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;                                                 
                                                  data.discount_btax = data.discount_btax + (data.sales_btax - discounts[k].level3.sales) * discounts[k].level3.discount/100;
                                                }else if(discounts[k].type === 2) {
                                                  data.discount_btax =                      discounts[k].level1.discount; 
                                                  data.discount_btax = data.discount_btax + discounts[k].level2.discount; 
                                                  data.discount_btax = data.discount_btax + discounts[k].level3.discount;                           
                                                }
                                              }else if(((discounts[k].level2.sales != 0)||(discounts[k].level2.discount != 0)) && (data.sales_btax >= discounts[k].level2.sales)){                                      
                                                if(discounts[k].type === 1) {                                       
                                                  //data.discount_btax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                  data.discount_btax = data.discount_btax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;                                                
                                                  data.discount_btax = data.discount_btax + (data.sales_btax - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                                }else if(discounts[k].type === 2) {
                                                  data.discount_btax =                      discounts[k].level1.discount; 
                                                  data.discount_btax = data.discount_btax + discounts[k].level2.discount;                                   
                                                }
                                              }else if(((discounts[k].level1.sales != 0)||(discounts[k].level1.discount != 0)) && (data.sales_btax >= discounts[k].level1.sales)){                                      
                                                if(discounts[k].type === 1) {                                        
                                                  //data.discount_btax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;                                                                            
                                                  data.discount_btax = data.discount_btax + (data.sales_btax - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                }else if(discounts[k].type === 2) {
                                                  data.discount_btax =                      discounts[k].level1.discount;                                                               
                                                }
                                              }                                    
                                              
                                            }else if(discounts[k].method === 2){//theo mức cuối
                                              if(((discounts[k].level5.sales != 0)||(discounts[k].level5.discount != 0)) && (data.sales_btax >= discounts[k].level5.sales)){                                   
                                                if(discounts[k].type === 1) data.discount_btax = data.sales_btax * discounts[k].level5.discount/100;
                                                else if(discounts[k].type === 2) data.discount_btax = discounts[k].level5.discount;                                      
                                              
                                              }else if(((discounts[k].level4.sales != 0)||(discounts[k].level4.discount != 0)) && (data.sales_btax >= discounts[k].level4.sales)){                                     
                                                if(discounts[k].type === 1) data.discount_btax = data.sales_btax * discounts[k].level4.discount/100;
                                                else if(discounts[k].type === 2) data.discount_btax = discounts[k].level4.discount;    
        
                                              }else if(((discounts[k].level3.sales != 0)||(discounts[k].level3.discount != 0))&& (data.sales_btax >= discounts[k].level3.sales)){                                     
                                                if(discounts[k].type === 1) data.discount_btax = data.sales_btax * discounts[k].level3.discount/100;
                                                else if(discounts[k].type === 2) data.discount_btax = discounts[k].level3.discount;    
        
                                              }else if(((discounts[k].level2.sales != 0)||(discounts[k].level2.discount != 0)) && (data.sales_btax >= discounts[k].level2.sales)){                                   
                                                if(discounts[k].type === 1) data.discount_btax = data.sales_btax * discounts[k].level2.discount/100;
                                                else if(discounts[k].type === 2) data.discount_btax = discounts[k].level2.discount;    
        
                                              }else if(((discounts[k].level1.sales != 0)||(discounts[k].level1.discount != 0)) && (data.sales_btax >= discounts[k].level1.sales)){                                    
                                                if(discounts[k].type === 1) data.discount_btax = data.sales_btax * discounts[k].level1.discount/100;
                                                else if(discounts[k].type === 2) data.discount_btax = discounts[k].level1.discount;    
                                              }
                                            }
                                            //Tính cho gia trị sau thuế
                                            if(discounts[k].method === 1){//theo từng mức
                                              if(((discounts[k].level5.sales != 0)||(discounts[k].level5.discount != 0)) && (data.sales_atax >= discounts[k].level5.sales)){                                      
                                                if(discounts[k].type === 1) {
                                                  //data.discount_atax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                  data.discount_atax = data.discount_atax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                  data.discount_atax = data.discount_atax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                                  data.discount_atax = data.discount_atax + (discounts[k].level4.sales - discounts[k].level3.sales) * discounts[k].level3.discount/100;
                                                  data.discount_atax = data.discount_atax + (discounts[k].level5.sales - discounts[k].level4.sales) * discounts[k].level4.discount/100;
                                                  data.discount_atax = data.discount_atax + (data.sales_atax - discounts[k].level5.sales) * discounts[k].level5.discount/100;
                                                }else if(discounts[k].type === 2) {
                                                  data.discount_atax =                      discounts[k].level1.discount; 
                                                  data.discount_atax = data.discount_atax + discounts[k].level2.discount; 
                                                  data.discount_atax = data.discount_atax + discounts[k].level3.discount; 
                                                  data.discount_atax = data.discount_atax + discounts[k].level4.discount; 
                                                  data.discount_atax = data.discount_atax + discounts[k].level5.discount; 
                                                }
                                              }else if(((discounts[k].level4.sales != 0)||(discounts[k].level4.discount != 0)) && (data.sales_atax >= discounts[k].level4.sales)){                                      
                                                if(discounts[k].type === 1) {
                                                  //data.discount_atax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                  data.discount_atax = data.discount_atax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                  data.discount_atax = data.discount_atax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                                  data.discount_atax = data.discount_atax + (discounts[k].level4.sales - discounts[k].level3.sales) * discounts[k].level3.discount/100;                    
                                                  data.discount_atax = data.discount_atax + (data.sales_atax - discounts[k].level4.sales) * discounts[k].level4.discount/100;
                                                }else if(discounts[k].type === 2) {
                                                  data.discount_atax =                      discounts[k].level1.discount; 
                                                  data.discount_atax = data.discount_atax + discounts[k].level2.discount; 
                                                  data.discount_atax = data.discount_atax + discounts[k].level3.discount; 
                                                  data.discount_atax = data.discount_atax + discounts[k].level4.discount; 
                                    
                                                }
                                              }else if(((discounts[k].level3.sales != 0)||(discounts[k].level3.discount != 0)) && (data.sales_atax >= discounts[k].level3.sales)){                                      
                                                if(discounts[k].type === 1) {
                                                  //data.discount_atax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                  data.discount_atax = data.discount_atax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                  data.discount_atax = data.discount_atax + (discounts[k].level3.sales - discounts[k].level2.sales) * discounts[k].level2.discount/100;                                                 
                                                  data.discount_atax = data.discount_atax + (data.sales_atax - discounts[k].level3.sales) * discounts[k].level3.discount/100;
                                                }else if(discounts[k].type === 2) {
                                                  data.discount_atax =                      discounts[k].level1.discount; 
                                                  data.discount_atax = data.discount_atax + discounts[k].level2.discount; 
                                                  data.discount_atax = data.discount_atax + discounts[k].level3.discount;                           
                                                }
                                              }else if(((discounts[k].level2.sales != 0)||(discounts[k].level2.discount != 0)) && (data.sales_atax >= discounts[k].level2.sales)){                                      
                                                if(discounts[k].type === 1) {
                                                  //data.discount_atax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;
                                                  data.discount_atax = data.discount_atax + (discounts[k].level2.sales - discounts[k].level1.sales) * discounts[k].level1.discount/100;                                                
                                                  data.discount_atax = data.discount_atax + (data.sales_atax - discounts[k].level2.sales) * discounts[k].level2.discount/100;
                                                }else if(discounts[k].type === 2) {
                                                  data.discount_atax =                      discounts[k].level1.discount; 
                                                  data.discount_atax = data.discount_atax + discounts[k].level2.discount;                                   
                                                }
                                              }else if(((discounts[k].level1.sales != 0)||(discounts[k].level1.discount != 0)) && (data.sales_atax >= discounts[k].level1.sales)){                                      
                                                if(discounts[k].type === 1) {
                                                  //data.discount_atax =                      discounts[k].level1.sales * discounts[k].level1.discount/100;                                                                            
                                                  data.discount_atax = data.discount_atax + (data.sales_atax - discounts[k].level1.sales) * discounts[k].level1.discount/100;
                                                }else if(discounts[k].type === 2) {
                                                  data.discount_atax =                      discounts[k].level1.discount;                                                               
                                                }
                                              }  
                                            }else if(discounts[k].method === 2){//theo mức cuối
                                              if(((discounts[k].level5.sales != 0)||(discounts[k].level5.discount != 0)) && (data.sales_atax >= discounts[k].level5.sales)){
                                                if(discounts[k].type === 1) data.discount_atax = data.sales_atax * discounts[k].level5.discount/100;
                                                else if(discounts[k].type === 2) data.discount_atax = discounts[k].level5.discount;                                      
                                              
                                              }else if(((discounts[k].level4.sales != 0)||(discounts[k].level4.discount != 0)) && (data.sales_atax >= discounts[k].level4.sales)){
                                                if(discounts[k].type === 1) data.discount_atax = data.sales_atax * discounts[k].level4.discount/100;
                                                else if(discounts[k].type === 2) data.discount_atax = discounts[k].level4.discount;    
        
                                              }else if(((discounts[k].level3.sales != 0)||(discounts[k].level3.discount != 0)) && (data.sales_atax >= discounts[k].level3.sales)){
                                                if(discounts[k].type === 1) data.discount_atax = data.sales_atax * discounts[k].level3.discount/100;
                                                else if(discounts[k].type === 2) data.discount_atax = discounts[k].level3.discount;    
        
                                              }else if(((discounts[k].level2.sales != 0)||(discounts[k].level2.discount != 0)) && (data.sales_atax >= discounts[k].level2.sales)){
                                                if(discounts[k].type === 1) data.discount_atax = data.sales_atax * discounts[k].level2.discount/100;
                                                else if(discounts[k].type === 2) data.discount_atax = discounts[k].level2.discount;    
        
                                              }else if(((discounts[k].level1.sales != 0)||(discounts[k].level1.discount != 0)) && (data.sales_atax >= discounts[k].level1.sales)){
                                                if(discounts[k].type === 1) data.discount_atax = data.sales_atax * discounts[k].level1.discount/100;
                                                else if(discounts[k].type === 2) data.discount_atax = discounts[k].level1.discount;    
                                              }
                                            }
                                            json.sales_btax = json.sales_btax + data.sales_btax;
                                            json.sales_atax = json.sales_atax + data.sales_atax;
                                            json.discount_btax = json.discount_btax + data.discount_btax;
                                            json.discount_atax = json.discount_atax + data.discount_atax;
                                            data.index = json.size + 1;
                                            json.docs.push(data);
                                            json.size++;                        
                                            json.empty = false;
                                            break;
                                        }
                                      }                           
                              
                                }
                              }
                            }        
                          }                       
                        }                          
                      }                      
                    }          
                    console.log('getReportDiscount_Customers', json);             
                    resolve(json);
              })
      }else resolve(json);     
    })
  }

  /** 
   * @Usage :Hàm này dùng trong page HOA HỒNG hạng NHÂN VIÊN -> Chọn TẤT CẢ hoặc MỘT nhân viên
   * @notice : Mỗi công thức chiết khấu có 5 mức (level1, level2, level3, level4, level5), giá trị doanh số (sales) level sau phải lơn hơn level trước
   * type : 1 chiết khấu %, 2 chiết khấu tiền
   * method : 1 phương pháp tính theo từng mức, 2 phương pháp tính theo mức cuối
   * @example :
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportCommission_Employees(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((commissions)=>{
            console.log('commissions', commissions);
            console.log('commissions.docs[0]', commissions.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDemployee : 'all' or id_employee
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, img, commission_name, sales_btax, commission_btax, sales_atax, commission_atax}
   */
  public getReportCommission_Employees(starttime:any, endtime:any, IDemployee:any, IDbranch?:string){   
    return new Promise<any>((resolve, reject) => { 
      let employees:any = new Array();   
      if(IDemployee === 'all') employees = this.vhAuth.getlocalEmployees()   
      else {
        let employee = this.vhAuth.getlocalEmployee(IDemployee);          
        employees.push(employee);      
      }             
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        commission_btax: 0,
        commission_atax: 0
        //quantity: 0 
      }               
      if(employees.length>0){                                
        let query:any;
        if(IDemployee === 'all'){        
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15]}, id_branch: {$eq:IDbranch}};          
          }
        }else{
          if((IDbranch==='all')||(IDbranch===undefined)){
            query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:IDemployee}, bill_type: {$in:[1,3,15]}};
          }else{
            query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:IDemployee}, bill_type: {$in:[1,3,15]}, id_branch: {$eq:IDbranch}};            
          }
          
        }        
        let promise1 =  this.vhMGDB_database.getDocsByFields('commissions', {}, {},{},0);            
        let promise2 =  this.getBill_details_byFields(query, {},{date:1},0);
        let promise3 =  this.vhMGDB_database.getDocsByFields('employee_classs', {}, {},{},0);      
        Promise.all([promise1, promise2, promise3])
                .then((array:any)=>{                                
                    let commissions = array[0];
                    let vhbill_details = array[1];  
                    let employee_classs = array[2];                        
                    if(vhbill_details.length>0){                                                 
                      for(let i=0; i<employees.length; i++){   
                        let transaction = false;                                                     
                        let data:any ={   
                          id_employee: employees[i]._id,                  
                          name: employees[i].name,                                                             
                          sales_btax: 0,
                          sales_atax: 0,
                          quantity: 0,
                          commission_btax: 0,
                          commission_atax: 0,
                          commission_name: ''
                        }                             
                        //Tính doanh số cho mỗi nhân viên                     
                        for(let j=0; j<vhbill_details.length; j++){                           
                          if(employees[i]._id ===vhbill_details[j].id_employee){  
                            transaction = true;  
                            if(vhbill_details[j].bill_type == 3){                                                                                             
                              data.quantity = data.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                              data.sales_btax = data.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                              data.sales_atax = data.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                                    
                            }else{                                                                                                   
                              data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                              data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                              data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                            }              
                          }
                        }
                        //Tính hoa hồng trên doanh số cho mỗi nhân viên
                        if(transaction){
                          if((employees[i].id_employee_class != undefined)&&(employees[i].id_employee_class != null)){
                            for(let j=0; j<employee_classs.length; j++){     
                              if(employee_classs[j]._id === employees[i].id_employee_class){     
                                if((employee_classs[j].id_commission != undefined)&&(employee_classs[j].id_commission != null)){   
                                    for(let k=0; k<commissions.length; k++){
                                      if(commissions[k]._id === employee_classs[j].id_commission){     
                                        data.commission_name = commissions[k].name;                             
                                          //Tính cho gia trị trước thuế
                                          if(commissions[k].method === 1){//theo từng mức
                                            if(((commissions[k].level5.sales != 0)||(commissions[k].level5.commission != 0)) && (data.sales_btax >= commissions[k].level5.sales)){                                      
                                              if(commissions[k].type === 1) {
                                                //data.commission_btax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                data.commission_btax = data.commission_btax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                data.commission_btax = data.commission_btax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                                data.commission_btax = data.commission_btax + (commissions[k].level4.sales - commissions[k].level3.sales) * commissions[k].level3.commission/100;
                                                data.commission_btax = data.commission_btax + (commissions[k].level5.sales - commissions[k].level4.sales) * commissions[k].level4.commission/100;
                                                data.commission_btax = data.commission_btax + (data.sales_btax - commissions[k].level5.sales) * commissions[k].level5.commission/100;
                                              }else if(commissions[k].type === 2) {
                                                data.commission_btax =                      commissions[k].level1.commission; 
                                                data.commission_btax = data.commission_btax + commissions[k].level2.commission; 
                                                data.commission_btax = data.commission_btax + commissions[k].level3.commission; 
                                                data.commission_btax = data.commission_btax + commissions[k].level4.commission; 
                                                data.commission_btax = data.commission_btax + commissions[k].level5.commission; 
                                              }
                                            }else if(((commissions[k].level4.sales != 0)||(commissions[k].level4.commission != 0)) && (data.sales_btax >= commissions[k].level4.sales)){                                      
                                              if(commissions[k].type === 1) {
                                                //data.commission_btax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                data.commission_btax = data.commission_btax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                data.commission_btax = data.commission_btax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                                data.commission_btax = data.commission_btax + (commissions[k].level4.sales - commissions[k].level3.sales) * commissions[k].level3.commission/100;                    
                                                data.commission_btax = data.commission_btax + (data.sales_btax - commissions[k].level4.sales) * commissions[k].level4.commission/100;
                                              }else if(commissions[k].type === 2) {
                                                data.commission_btax =                      commissions[k].level1.commission; 
                                                data.commission_btax = data.commission_btax + commissions[k].level2.commission; 
                                                data.commission_btax = data.commission_btax + commissions[k].level3.commission; 
                                                data.commission_btax = data.commission_btax + commissions[k].level4.commission; 
                                  
                                              }
                                            }else if(((commissions[k].level3.sales != 0)||(commissions[k].level3.commission != 0)) && (data.sales_btax >= commissions[k].level3.sales)){                                      
                                              if(commissions[k].type === 1) {
                                                //data.commission_btax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                data.commission_btax = data.commission_btax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                data.commission_btax = data.commission_btax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;                                                 
                                                data.commission_btax = data.commission_btax + (data.sales_btax - commissions[k].level3.sales) * commissions[k].level3.commission/100;
                                              }else if(commissions[k].type === 2) {
                                                data.commission_btax =                      commissions[k].level1.commission; 
                                                data.commission_btax = data.commission_btax + commissions[k].level2.commission; 
                                                data.commission_btax = data.commission_btax + commissions[k].level3.commission;                           
                                              }
                                            }else if(((commissions[k].level2.sales != 0)||(commissions[k].level2.commission != 0)) && (data.sales_btax >= commissions[k].level2.sales)){                                      
                                              if(commissions[k].type === 1) {
                                                //data.commission_btax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                data.commission_btax = data.commission_btax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;                                                
                                                data.commission_btax = data.commission_btax + (data.sales_btax - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                              }else if(commissions[k].type === 2) {
                                                data.commission_btax =                      commissions[k].level1.commission; 
                                                data.commission_btax = data.commission_btax + commissions[k].level2.commission;                                   
                                              }
                                            }else if(((commissions[k].level1.sales != 0)||(commissions[k].level1.commission != 0)) && (data.sales_btax >= commissions[k].level1.sales)){                                      
                                              if(commissions[k].type === 1) {
                                                //data.commission_btax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;                                                                            
                                                data.commission_btax = data.commission_btax + (data.sales_btax - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                              }else if(commissions[k].type === 2) {
                                                data.commission_btax =                      commissions[k].level1.commission;                                                               
                                              }
                                            }                                    
                                            
                                          }else if(commissions[k].method === 2){//theo mức cuối                                    
                                            if(((commissions[k].level5.sales != 0)||(commissions[k].level5.commission != 0)) && (data.sales_btax >= commissions[k].level5.sales)){                                   
                                              if(commissions[k].type === 1) data.commission_btax = data.sales_btax * commissions[k].level5.commission/100;
                                              else if(commissions[k].type === 2) data.commission_btax = commissions[k].level5.commission;                                      
                                            
                                            }else if(((commissions[k].level4.sales != 0)||(commissions[k].level4.commission != 0)) && (data.sales_btax >= commissions[k].level4.sales)){                                     
                                              if(commissions[k].type === 1) data.commission_btax = data.sales_btax * commissions[k].level4.commission/100;
                                              else if(commissions[k].type === 2) data.commission_btax = commissions[k].level4.commission;    

                                            }else if(((commissions[k].level3.sales != 0)||(commissions[k].level3.commission != 0))&& (data.sales_btax >= commissions[k].level3.sales)){                                     
                                              if(commissions[k].type === 1) data.commission_btax = data.sales_btax * commissions[k].level3.commission/100;
                                              else if(commissions[k].type === 2) data.commission_btax = commissions[k].level3.commission;    

                                            }else if(((commissions[k].level2.sales != 0)||(commissions[k].level2.commission != 0)) && (data.sales_btax >= commissions[k].level2.sales)){                                   
                                              if(commissions[k].type === 1) data.commission_btax = data.sales_btax * commissions[k].level2.commission/100;
                                              else if(commissions[k].type === 2) data.commission_btax = commissions[k].level2.commission;    

                                            }else if(((commissions[k].level1.sales != 0)||(commissions[k].level1.commission != 0)) && (data.sales_btax >= commissions[k].level1.sales)){                                    
                                              if(commissions[k].type === 1) data.commission_btax = data.sales_btax * commissions[k].level1.commission/100;
                                              else if(commissions[k].type === 2) data.commission_btax = commissions[k].level1.commission;    
                                            }                                    
                                          }


                                          //Tính cho gia trị sau thuế
                                          if(commissions[k].method === 1){//theo từng mức
                                            if(((commissions[k].level5.sales != 0)||(commissions[k].level5.commission != 0)) && (data.sales_atax >= commissions[k].level5.sales)){                                      
                                              if(commissions[k].type === 1) {
                                                //data.commission_atax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                data.commission_atax = data.commission_atax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                data.commission_atax = data.commission_atax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                                data.commission_atax = data.commission_atax + (commissions[k].level4.sales - commissions[k].level3.sales) * commissions[k].level3.commission/100;
                                                data.commission_atax = data.commission_atax + (commissions[k].level5.sales - commissions[k].level4.sales) * commissions[k].level4.commission/100;
                                                data.commission_atax = data.commission_atax + (data.sales_atax - commissions[k].level5.sales) * commissions[k].level5.commission/100;
                                              }else if(commissions[k].type === 2) {
                                                data.commission_atax =                      commissions[k].level1.commission; 
                                                data.commission_atax = data.commission_atax + commissions[k].level2.commission; 
                                                data.commission_atax = data.commission_atax + commissions[k].level3.commission; 
                                                data.commission_atax = data.commission_atax + commissions[k].level4.commission; 
                                                data.commission_atax = data.commission_atax + commissions[k].level5.commission; 
                                              }
                                            }else if(((commissions[k].level4.sales != 0)||(commissions[k].level4.commission != 0)) && (data.sales_atax >= commissions[k].level4.sales)){                                      
                                              if(commissions[k].type === 1) {
                                                //data.commission_atax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                data.commission_atax = data.commission_atax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                data.commission_atax = data.commission_atax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                                data.commission_atax = data.commission_atax + (commissions[k].level4.sales - commissions[k].level3.sales) * commissions[k].level3.commission/100;                    
                                                data.commission_atax = data.commission_atax + (data.sales_atax - commissions[k].level4.sales) * commissions[k].level4.commission/100;
                                              }else if(commissions[k].type === 2) {
                                                data.commission_atax =                      commissions[k].level1.commission; 
                                                data.commission_atax = data.commission_atax + commissions[k].level2.commission; 
                                                data.commission_atax = data.commission_atax + commissions[k].level3.commission; 
                                                data.commission_atax = data.commission_atax + commissions[k].level4.commission; 
                                  
                                              }
                                            }else if(((commissions[k].level3.sales != 0)||(commissions[k].level3.commission != 0)) && (data.sales_atax >= commissions[k].level3.sales)){                                      
                                              if(commissions[k].type === 1) {
                                                //data.commission_atax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                data.commission_atax = data.commission_atax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                                data.commission_atax = data.commission_atax + (commissions[k].level3.sales - commissions[k].level2.sales) * commissions[k].level2.commission/100;                                                 
                                                data.commission_atax = data.commission_atax + (data.sales_atax - commissions[k].level3.sales) * commissions[k].level3.commission/100;
                                              }else if(commissions[k].type === 2) {
                                                data.commission_atax =                      commissions[k].level1.commission; 
                                                data.commission_atax = data.commission_atax + commissions[k].level2.commission; 
                                                data.commission_atax = data.commission_atax + commissions[k].level3.commission;                           
                                              }
                                            }else if(((commissions[k].level2.sales != 0)||(commissions[k].level2.commission != 0)) && (data.sales_atax >= commissions[k].level2.sales)){                                      
                                              if(commissions[k].type === 1) {
                                                //data.commission_atax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;
                                                data.commission_atax = data.commission_atax + (commissions[k].level2.sales - commissions[k].level1.sales) * commissions[k].level1.commission/100;                                                
                                                data.commission_atax = data.commission_atax + (data.sales_atax - commissions[k].level2.sales) * commissions[k].level2.commission/100;
                                              }else if(commissions[k].type === 2) {
                                                data.commission_atax =                      commissions[k].level1.commission; 
                                                data.commission_atax = data.commission_atax + commissions[k].level2.commission;                                   
                                              }
                                            }else if(((commissions[k].level1.sales != 0)||(commissions[k].level1.commission != 0)) && (data.sales_atax >= commissions[k].level1.sales)){                                      
                                              if(commissions[k].type === 1) {
                                                //data.commission_atax =                      commissions[k].level1.sales * commissions[k].level1.commission/100;                                                                            
                                                data.commission_atax = data.commission_atax + (data.sales_atax - commissions[k].level1.sales) * commissions[k].level1.commission/100;
                                              }else if(commissions[k].type === 2) {
                                                data.commission_atax =                      commissions[k].level1.commission;                                                               
                                              }
                                            }  
                                          }else if(commissions[k].method === 2){//theo mức cuối
                                            if(((commissions[k].level5.sales != 0)||(commissions[k].level5.commission != 0)) && (data.sales_atax >= commissions[k].level5.sales)){
                                              if(commissions[k].type === 1) data.commission_atax = data.sales_atax * commissions[k].level5.commission/100;
                                              else if(commissions[k].type === 2) data.commission_atax = commissions[k].level5.commission;                                      
                                            
                                            }else if(((commissions[k].level4.sales != 0)||(commissions[k].level4.commission != 0)) && (data.sales_atax >= commissions[k].level4.sales)){
                                              if(commissions[k].type === 1) data.commission_atax = data.sales_atax * commissions[k].level4.commission/100;
                                              else if(commissions[k].type === 2) data.commission_atax = commissions[k].level4.commission;    

                                            }else if(((commissions[k].level3.sales != 0)||(commissions[k].level3.commission != 0)) && (data.sales_atax >= commissions[k].level3.sales)){
                                              if(commissions[k].type === 1) data.commission_atax = data.sales_atax * commissions[k].level3.commission/100;
                                              else if(commissions[k].type === 2) data.commission_atax = commissions[k].level3.commission;    

                                            }else if(((commissions[k].level2.sales != 0)||(commissions[k].level2.commission != 0)) && (data.sales_atax >= commissions[k].level2.sales)){
                                              if(commissions[k].type === 1) data.commission_atax = data.sales_atax * commissions[k].level2.commission/100;
                                              else if(commissions[k].type === 2) data.commission_atax = commissions[k].level2.commission;    

                                            }else if(((commissions[k].level1.sales != 0)||(commissions[k].level1.commission != 0)) && (data.sales_atax >= commissions[k].level1.sales)){
                                              if(commissions[k].type === 1) data.commission_atax = data.sales_atax * commissions[k].level1.commission/100;
                                              else if(commissions[k].type === 2) data.commission_atax = commissions[k].level1.commission;    
                                            }
                                          }
                                          json.sales_btax = json.sales_btax + data.sales_btax;
                                          json.sales_atax = json.sales_atax + data.sales_atax;
                                          json.commission_btax = json.commission_btax + data.commission_btax;
                                          json.commission_atax = json.commission_atax + data.commission_atax;
                                          data.index = json.size + 1;
                                          json.docs.push(data);
                                          json.size++;                        
                                          json.empty = false;
                                          break;
                                      }
                                    }        
                                  }
                                }
                              }                   
                          } 
                    
                        }                          
                      }                      
                    }          
                    console.log('getReportCommission_Employees', json);             
                    resolve(json);
                  })
      }else resolve(json);     
    })
  }
  
  /**
   * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 1) -> Chọn TẤT CẢ hoặc MỘT khách hàng
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportSales_Customers_byCustomers(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDcustomer : 'all' or id_customer
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, img, id_customer, quantity, sales_btax, sales_atax}
   */
  public getReportSales_Customers_byCustomers(starttime:any, endtime:any, IDcustomer:any, IDbranch?:string){   
    return new Promise<any>((resolve, reject) => {                   
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0 
      }                                              
      let query:any;
      if(IDcustomer === 'all'){        
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}, id_branch: {$eq:IDbranch}};          
        }
      }else{
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:[1,3,15,40,50]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:[1,3,15,40,50]}, id_branch: {$eq:IDbranch}};            
        }
        
      }        
      this.getBill_details_byFields(query, {},{date:1},0)
          .then((vhbill_details:any)=>{                     
            if(vhbill_details.length>0){  
              let customers:any = new Array();   
              if(IDcustomer === 'all') customers = this.getlocalCustomers()   
              else {
                let customer = this.getlocalCustomer(IDcustomer);          
                customers.push(customer);      
              }                                                
              for(let i=0; i<customers.length; i++){   
                let transaction = false;                                                                 
                let data:any ={   
                  id_customer: customers[i]._id,                  
                  name: customers[i].name,                          
                  img: customers[i]?.img,                                   
                  sales_btax: 0,
                  sales_atax: 0,
                  quantity: 0
                }                                                                       
                for(let j=0; j<vhbill_details.length; j++){                           
                  if(customers[i]._id ===vhbill_details[j].id_customer){  
                    transaction = true;  
                    if(vhbill_details[j].bill_type == 3){                              
                      if((vhbill_details[j].ptype ===3)||(vhbill_details[j].ptype ===2)){
                        data.quantity = data.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                        data.sales_btax = data.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                        data.sales_atax = data.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                      }
                    }else{
                      if((vhbill_details[j].ptype ===3)||(vhbill_details[j].ptype ===2)||(vhbill_details[j].vtype ===1)||(vhbill_details[j].pctype ===1)){
                        data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                        data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                        data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);  
                      }
                    }              
                  }
                }
                if(transaction){
                  json.quantity = json.quantity + data.quantity;
                  json.sales_btax = json.sales_btax + data.sales_btax;
                  json.sales_atax = json.sales_atax + data.sales_atax;
                  data.index = json.size + 1;
                  json.docs.push(data);
                  json.size++;                        
                  json.empty = false; 
                }                          
              }                      
            }          
            console.log('getReportSales_Customers_byCustomers');             
            resolve(json);
          })  
    })
  }
  /**
   * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 2) -> Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một khách hàng trong list hiện ra
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00'); 
      this.vhQuerySales.getReportSales_Customers_byProducts_Vouchers_PaymentCards(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param id_customer
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_product, ptype, hoặc id_voucher, vtype, hoặc id_payment_card, pctype, index, name, barcode, unit, img, id_customer, quantity, sales_btax, sales_atax}
   */
   public getReportSales_Customers_byProducts_Vouchers_PaymentCards(starttime:any, endtime:any, id_customer:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                                        
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, bill_type: {$in:[1,3,15,40,50]}};
        }else{
          query = query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, bill_type: {$in:[1,3,15,40,50]}, id_branch: {$eq:IDbranch}};          
        }   
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0 
        }                    
        //if(products.length>0){ 
          let vouchers = new Array();
          let payment_cards = new Array();     
          let promise = new Array();
          promise[0] = this.vhMGDB_database.getDocs('vouchers');
          promise[1] = this.vhMGDB_database.getDocs('payment_cards');
          Promise.all(promise)
                .then((array:any)=>{              
                  vouchers = [...array[0]];
                  payment_cards = [...array[1]];     
                  this.getBill_details_byFields(query, {},{date:1},0)
                      .then((vhbill_details:any)=>{                                 
                        if(vhbill_details.length>0){  
                            let products:any = this.getlocalDetailProducts(23);                   
                            for(let i=0; i<products.length; i++){       
                                let transaction = false;                                        
                                let unit = this.getUnit_byRatio(products[i].units, 1);                             
                                let record:any ={   
                                  id_product: products[i]._id,              
                                  name: products[i].name,
                                  img: products[i].img,
                                  ptype: products[i].type,     

                                  ratio: unit.ratio,
                                  unit: unit.unit,
                                  barcode: unit.barcode,       
                                
                                //  id_customer:id_customer,                                            
                                  sales_btax: 0,
                                  sales_atax: 0,
                                  quantity: 0                        
                                }      
                                if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct; 
                                if(products[i].lots) {
                                  record.lots = cloneDeep(products[i].lots);
                                  for(let m = 0; m<record.lots.length; m++){
                                    record.lots[m].quantity = 0;
                                    record.lots[m].sales_btax = 0;
                                    record.lots[m].sales_atax = 0;
                                  }
                                }                   
                                for(let j=0; j<vhbill_details.length; j++){ 
                                  let is_sub_or_product = false;
                                  if(record.id_subproduct) is_sub_or_product = vhbill_details[j]?.id_subproduct === record.id_subproduct;
                                  else is_sub_or_product = vhbill_details[j].id_product === record.id_product;   
                                  if(vhbill_details[j].bill_type == 3){                                                         
                                    if(is_sub_or_product){                                        
                                      transaction = true         
                                      if(record.lots){
                                        for(let m=0; m<record.lots.length; m++){
                                          if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                            record.lots[m].quantity =   record.lots[m].quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                                            record.lots[m].sales_btax = record.lots[m].sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                                            record.lots[m].sales_atax = record.lots[m].sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                                          }
                                        }    
                                      }                              
                                      record.quantity = record.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                                      record.sales_btax = record.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                                      record.sales_atax = record.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                           
                                    }                                 
                                  }else{                                                             
                                    if(is_sub_or_product){                                          
                                      transaction = true         
                                      if(record.lots){
                                        for(let m=0; m<record.lots.length; m++){
                                          if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                            record.lots[m].quantity =   record.lots[m].quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                            record.lots[m].sales_btax = record.lots[m].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                            record.lots[m].sales_atax = record.lots[m].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                                          }
                                        } 
                                      }                                 
                                      record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                      record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                      record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                       
                                    }                                     
                                  }
                                }
                                if(transaction){
                                  /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                  record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                  json.quantity = json.quantity + record.quantity;
                                  json.sales_btax = json.sales_btax + record.sales_btax;
                                  json.sales_atax = json.sales_atax + record.sales_atax;
                                  record.index = json.size + 1;
                                  json.docs.push(record);
                                  json.size++;                        
                                  json.empty = false; 
                                }                                               
                            }
                            for(let i=0; i<vouchers.length; i++){   
                              let transaction = false;                         
                              let unit = this.getUnit_byRatio(vouchers[i].units, 1);                             
                              let record:any ={           
                                id_voucher: vouchers[i]._id,                                                  
                                name: vouchers[i].name,
                                img: vouchers[i].img,  
                                vtype: vouchers[i].type, 
  
                                ratio: unit.ratio,
                                unit: unit.unit,
                                barcode: unit.barcode,  
  
                                sales_btax: 0,
                                sales_atax: 0,
                                quantity: 0                        
                              }   
                              for(let j=0; j<vhbill_details.length; j++){      
                                if(record.id_voucher ===vhbill_details[j]?.id_voucher){
                                  transaction = true;    
                                  record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                  record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                                }
                              } 
                              if(transaction){                        
                                /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                json.quantity = json.quantity + record.quantity;
                                json.sales_btax = json.sales_btax + record.sales_btax;
                                json.sales_atax = json.sales_atax + record.sales_atax;
                                record.index = json.size + 1;
                                json.docs.push(record);
                                json.size++;                        
                                json.empty = false; 
                              } 
                            }
                            for(let i=0; i<payment_cards.length; i++){   
                              let transaction = false;                         
                              let unit = this.getUnit_byRatio(payment_cards[i].units, 1);                             
                              let record:any ={           
                                id_payment_card: payment_cards[i]._id,                                                  
                                name: payment_cards[i].name,
                                img: payment_cards[i].img,  
                                pctype: payment_cards[i].type, 
  
                                ratio: unit.ratio,
                                unit: unit.unit,
                                barcode: unit.barcode,  
  
                                sales_btax: 0,
                                sales_atax: 0,
                                quantity: 0                        
                              }    
                              for(let j=0; j<vhbill_details.length; j++){      
                                if(record.id_payment_card ===vhbill_details[j]?.id_payment_card){
                                  transaction = true;    
                                  record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                  record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                  record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                                }             
                              }
                              if(transaction){                        
                                /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                json.quantity = json.quantity + record.quantity;
                                json.sales_btax = json.sales_btax + record.sales_btax;
                                json.sales_atax = json.sales_atax + record.sales_atax;
                                record.index = json.size + 1;
                                json.docs.push(record);
                                json.size++;                        
                                json.empty = false; 
                              } 
                            }
                        }                
                        console.log('getReportSales_Customers_byProducts_Vouchers_PaymentCards', json);                         
                        resolve(json);
                      })
              })  
        //}else resolve(json);                  
    })
  }

  
  /**
  * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 3) ->  Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một khách hàng trong list hiện ra -> Chọn một voucher trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_Customers_byVoucher(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_customer 
  * @param id_voucher:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_voucher, vtype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Customers_byVoucher(starttime:any, endtime:any, id_customer:string, id_voucher:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('vouchers', id_voucher)
          .then((voucher:any)=>{
            if(voucher){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(voucher.units, 1);           
                        let record:any ={   
                          id_voucher: voucher._id,    
                          vtype: voucher.type,                    
                          name: voucher.name, 
                          img: voucher.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Customers_byVoucher', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 3) ->  Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một khách hàng trong list hiện ra -> Chọn một payment_card trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_Customers_byPaymentCard(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_customer 
  * @param id_payment_card:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_payment_card, pctype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Customers_byPaymentCard(starttime:any, endtime:any, id_customer:string, id_payment_card:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('payment_cards', id_payment_card)
          .then((payment_card:any)=>{
            if(payment_card){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(payment_card.units, 1);           
                        let record:any ={   
                          id_payment_card: payment_card._id,  
                          pctype: payment_card.type,      

                          name: payment_card.name, 
                          img: payment_card.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Customers_byPaymentCard', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }

  /**
   * @Usage Hàm này dùng trong phân tích số liệu từ doanh số bán hàng trên mỗi sàn TMĐT 3 THÁNG, 3 TUẦN gần nhất
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportSales_Customers_byProducts_Analytics(starttime, endtime, '9879657432', 'shopee', '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param id_customer
   * @param id_shop
   * @param ecommerce: 'shopee'/'lazada'/'tiki'/'sendo'
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, id_product, name, barcode, unit, img, id_customer, quantity, sales_btax, sales_atax}
   */
  public getReportSales_Customers_byProducts_Analytics(starttime:any, endtime:any, id_customer:string, id_shop:string, ecommerce:string, IDbranch:string){
    return new Promise<any>((resolve, reject) => { 
      let query:any;
      if((IDbranch==='all')||(IDbranch===undefined)){
        query = query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, bill_type: {$in:[1,3,15,41,51]}};
      }else{
        query = query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, bill_type: {$in:[1,3,15,41,51]}, id_branch: {$eq:IDbranch}};          
      }   
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0 
      }                    
      this.getBill_details_byFields(query, {},{date:1},0)
          .then((vhbill_details:any)=>{                         
            if(vhbill_details.length>0){               
                let products:any = this.getlocalDetailProducts(3);      
                products = products.filter((item:any) => (item.allow_sell === true));     
                products = products.filter((item:any) => {
                  if((item[IDbranch] != undefined)&&(item.allow_sell === true)){
                    if(ecommerce === 'shopee')
                    if(item[IDbranch].shopees != undefined){
                      if(item[IDbranch].shopees.length !=undefined){
                        for(let i=0; i<item[IDbranch].shopees.length; i++){
                          if(item[IDbranch].shopees[i].id_shop === id_shop) return true;
                        }
                      }
                    }
                    if(ecommerce === 'tiki')
                    if(item[IDbranch].tikis != undefined){
                      if(item[IDbranch].tikis.length !=undefined){
                        for(let i=0; i<item[IDbranch].tikis.length; i++){
                          if(item[IDbranch].tikis[i].id_shop === id_shop) return true;
                        }
                      }
                    }

                    if(ecommerce === 'lazada')
                    if(item[IDbranch].lazadas != undefined){
                      if(item[IDbranch].lazadas.length !=undefined){
                        for(let i=0; i<item[IDbranch].lazadas.length; i++){
                          if(item[IDbranch].lazadas[i].id_shop === id_shop) return true;
                        }
                      }
                    }
                    if(ecommerce === 'sendo')
                    if(item[IDbranch].sendos != undefined){
                      if(item[IDbranch].sendos.length !=undefined){
                        for(let i=0; i<item[IDbranch].sendos.length; i++){
                          if(item[IDbranch].sendos[i].id_shop === id_shop) return true;
                        }
                      }
                    }
                  }          
                  return false;
                });  
                for(let i=0; i<products.length; i++){       
                    let transaction = false;                                 
                    let unit = this.getUnit_byRatio(products[i].units, 1);                                       
                    let record:any ={   
                      id_product: products[i]._id,              
                      name: products[i].name,
                      img: products[i].img, 
                      type: products[i].type,   

                      ratio: unit.ratio,
                      unit: unit.unit,
                      barcode: unit.barcode,     
          
                      id_customer:id_customer,                     
                      sales_btax: 0,
                      sales_atax: 0,
                      quantity: 0                        
                    }                                       
                    if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;  

                    for(let j=0; j<vhbill_details.length; j++){   
                      let is_sub_or_product = false;
                      if(record.id_subproduct) is_sub_or_product = vhbill_details[j].id_subproduct === record.id_subproduct;
                      else is_sub_or_product = vhbill_details[j].id_product === record.id_product; 
                      if(vhbill_details[j].bill_type == 3){                        
                        if(is_sub_or_product){
                          transaction = true                         
                          record.quantity = record.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                          record.sales_btax = record.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                          record.sales_atax = record.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                 
                        }                                
                      }else{                           
                        if(is_sub_or_product){
                          transaction = true                         
                          record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                          record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                          record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                 
                        }                             
                      }
                    }
                    //if(transaction){
                      /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                      record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                      json.quantity = json.quantity + record.quantity;
                      json.sales_btax = json.sales_btax + record.sales_btax;
                      json.sales_atax = json.sales_atax + record.sales_atax;
                      record.index = json.size + 1;
                      json.docs.push(record);
                      json.size++;                        
                      json.empty = false; 
                    //}                                               
                }
            }                
            console.log('getReportSales_Customers_byProducts_Analytics');                         
            resolve(json);
          })
    })
  }
  /**
  * @Usage Hàm này dùng trong page DOANH SỐ KHÁCH HÀNG (layer 3) ->  Chọn TẤT CẢ hoặc MỘT khách hàng -> Chọn một khách hàng trong list hiện ra -> Chọn một sản phẩm trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_Customers_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]);
        })
  * @param starttime 
  * @param endtime 
  * @param id_customer 
  * @param id_sub_or_product 
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, barcode, unit, img, date, quantity, price, tax, id_bill, id_product, salesman, customer}
  */
    public getReportSales_Customers_byProduct(starttime:any, endtime:any, id_customer:any, id_sub_or_product:any, IDbranch?:string):Promise<any>{
      return new Promise<any>((resolve, reject) => {     
        (async () => {
          try{
            let product = await this.getlocalDetailProduct_Async(id_sub_or_product);  
            let type = product.type;    
            let json:any = {
              docs: new Array(),
              empty: true,
              size:0,
              sales_btax: 0,   
              sales_atax: 0,  
              quantity: 0
            }                       
            let query:any;            
            let promise = new Array();
            let _bill_type = [1,3,15];
      
            if((IDbranch==='all')||(IDbranch===undefined)){
              if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in:_bill_type}};
              else query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_product: {$eq:product._id}, bill_type: {$in:_bill_type}};
            }else{
              if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};       
              else query = {date: {$gte:starttime, $lte:endtime}, id_customer: {$eq:id_customer}, id_product: {$eq:product._id}, bill_type: {$in:_bill_type}, id_branch: {$eq:IDbranch}};        
            }   
            
            this.getBill_details_byFields(query, {},{date:1},0)
                .then((vhbill_details:any)=>{                   
                      if(vhbill_details.length>0){    
                        for(let i=0; i<vhbill_details.length; i++){        
                            let transaction = false;                       
                            let unit = this.getUnit_byRatio(product.units, 1);   
                            let record:any ={   
                              id_product: product._id,                  
                              name: product.name, 
                              img: product.img, 
      
                              ratio: unit.ratio,
                              unit: unit.unit,
                              barcode: unit.barcode,                            
                              
                              bill_code: vhbill_details[i].bill_code,
                              bill_type:  vhbill_details[i].bill_type,
                              id_bill: vhbill_details[i].id_bill,
                              date: vhbill_details[i].date,
                              tax: vhbill_details[i].tax,
                              salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                              customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                            }  
                            if(vhbill_details[i].id_subproduct) record.id_subproduct = vhbill_details[i].id_subproduct;                      
                            if(vhbill_details[i].id_lotproduct){
                              record.id_lotproduct = vhbill_details[i].id_lotproduct; 
                              record.lots = new Array;
                              for(let m = 0; m<product.lots.length; m++){
                                if(product.lots[m]._id === record.id_lotproduct) {
                                  record.lots.push(product.lots[m]);
                                  break;
                                }
                              }
                            }    
      
                            if(vhbill_details[i].bill_type == 3){  
                              transaction = true;                                                                                                                                            
                              record.quantity = - vhbill_details[i].quantity * vhbill_details[i].ratio;                     
                              record.price = vhbill_details[i].price/vhbill_details[i].ratio;                             
                            }else{
                              transaction = true;                                                                                                                                    
                              record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                     
                              record.price = vhbill_details[i].price/vhbill_details[i].ratio;  
                            }
                            
                            if(transaction){
                              record.sales_btax = record.price * record.quantity;
                              record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                              record.index = json.size + 1;                   
                              json.docs.push(record);
                              json.size++;
                              json.empty = false;
                              json.quantity = json.quantity + record.quantity;
                              json.sales_btax = json.sales_btax + record.price * record.quantity;
                              json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                            }                                                                                
                        }                                 
                      }           
                      console.log('getReportSales_Customers_byProduct', json);      
                      resolve(json);         
                })   
          } catch (err) {
            console.error('❌ Lỗi trong getReportSales_Customers_byProduct:', err);
            reject(err); // ✅ đừng quên reject nếu có lỗi
          }  
        })();     
      })      
    }

  /**
   * @Usage Hàm này dùng trong page DOANH SỐ NHÂN VIÊN (layer 1) -> Chọn TẤT CẢ hoặc MỘT nhân viên
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportSales_Employees_byEmployees(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param IDemployee = 'all' or id_employee
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={index, name, img, id_employee, quantity, sales_btax, sales_atax}
   */  
  public getReportSales_Employees_byEmployees(starttime:any, endtime:any, IDemployee:any, IDbranch?:string){   
    return new Promise<any>((resolve, reject) => {                  
      let json: any={
        docs:  new Array(),
        empty: true,
        size: 0, 
        sales_btax: 0,   
        sales_atax: 0,
        quantity: 0 
      }                                              
      let query:any;
      if(IDemployee === 'all'){        
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}, id_branch: {$eq:IDbranch}};          
        }
      }else{
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:IDemployee}, bill_type: {$in:[1,3,15,40,50]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:IDemployee}, bill_type: {$in:[1,3,15,40,50]}, id_branch: {$eq:IDbranch}};            
        }          
      }        
      this.getBill_details_byFields(query, {},{date:1},0)
          .then((vhbill_details:any)=>{                     
                  if(vhbill_details.length>0){       
                    let employees:any = new Array();   
                    if(IDemployee === 'all') employees = this.vhAuth.getlocalEmployees();   
                    else {       
                      employees.push(this.vhAuth.getlocalEmployee(IDemployee));      
                    }                                            
                    for(let i=0; i<employees.length; i++){   
                      let transaction = false;                                                     
                      let data:any ={   
                        id_employee: employees[i]._id,                  
                        name: employees[i].name,                                                             
                        sales_btax: 0,
                        sales_atax: 0,
                        quantity: 0
                      }                                                  
                      for(let j=0; j<vhbill_details.length; j++){                           
                        if(employees[i]._id ===vhbill_details[j].id_employee){  
                          transaction = true;  
                          if(vhbill_details[j].bill_type == 3){    
                            if((vhbill_details[j].ptype ===3)||(vhbill_details[j].ptype ===2)){                                
                              data.quantity = data.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                              data.sales_btax = data.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                              data.sales_atax = data.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100); 
                            }                   
                          }else{
                            if((vhbill_details[j].ptype ===3)||(vhbill_details[j].ptype ===2)||(vhbill_details[j].vtype ===1)||(vhbill_details[j].pctype ===1)){
                              data.quantity = data.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                              data.sales_btax = data.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                              data.sales_atax = data.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100); 
                            }                   
                          }              
                        }
                      }
                      if(transaction){
                        json.quantity = json.quantity + data.quantity;
                        json.sales_btax = json.sales_btax + data.sales_btax;
                        json.sales_atax = json.sales_atax + data.sales_atax;
                        data.index = json.size + 1;
                        json.docs.push(data);
                        json.size++;                        
                        json.empty = false; 
                      }                          
                    }                      
                  }          
                  console.log('getReportSales_Employees_byEmployees');             
                  resolve(json);
                })  
    })
  }
   /**
   * @Usage Hàm này dùng trong page DOANH SỐ NHÂN VIÊN (layer 2) -> Chọn TẤT CẢ hoặc MỘT nhân viên -> Chọn một nhân viên trong list hiện ra
   * Hàm đã bao gồm doanh số bán voucher và payment_card
   * @example
   *  let endtime = new Date();
      let starttime = new Date('2020-07-01T05:24:00');
      this.vhQuerySales.getReportSales_Employees_byProducts_Vouchers_PaymentCards(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
          .then((reportsales)=>{
            console.log('reportsales', reportsales);
            console.log('reportsales.docs[0]', reportsales.docs[0]);
          })
   * @param starttime 
   * @param endtime 
   * @param id_employee
   * @param IDbranch : 'all' or id_branch
   * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_product, ptype, hoặc id_voucher, vtype, hoặc id_payment_card, pctype, index, name, barcode, unit, img, id_employee, quantity, sales_btax, sales_atax}
   */
  public getReportSales_Employees_byProducts_Vouchers_PaymentCards(starttime:any, endtime:any, id_employee:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                                             
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, bill_type: {$in:[1,3,15,40,50]}};
        }else{
          query = query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, bill_type: {$in:[1,3,15,40,50]}, id_branch: {$eq:IDbranch}};          
        }   
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0, 
          sales_btax: 0,   
          sales_atax: 0,
          quantity: 0 
        }                    

        let vouchers = new Array();
        let payment_cards = new Array();     
        let promise = new Array();
        promise[0] = this.vhMGDB_database.getDocs('vouchers');
        promise[1] = this.vhMGDB_database.getDocs('payment_cards');
        Promise.all(promise)
              .then((array:any)=>{              
                vouchers = [...array[0]];
                payment_cards = [...array[1]];               
                this.getBill_details_byFields(query, {},{date:1},0)
                    .then((vhbill_details:any)=>{                                                    
                      if(vhbill_details.length>0){     
                          let products:any = this.getlocalDetailProducts(23);               
                          for(let i=0; i<products.length; i++){       
                              let transaction = false;                         
                              let unit = this.getUnit_byRatio(products[i].units, 1);                             
                              let record:any ={          
                                id_product: products[i]._id,                                               
                                name: products[i].name,
                                img: products[i].img,
                                ptype: products[i].type,      

                                ratio: unit.ratio,
                                unit: unit.unit,
                                barcode: unit.barcode,  

                                sales_btax: 0,
                                sales_atax: 0,
                                quantity: 0                        
                              }                          
                              
                              if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct; 
                              if(products[i].lots) {
                                record.lots = cloneDeep(products[i].lots);
                                for(let m = 0; m<record.lots.length; m++){
                                  record.lots[m].quantity = 0;
                                  record.lots[m].sales_btax = 0;
                                  record.lots[m].sales_atax = 0;
                                }
                              }           

                              for(let j=0; j<vhbill_details.length; j++){                                                     
                                  let is_sub_or_product = false;
                                  if(record.id_subproduct) is_sub_or_product = vhbill_details[j]?.id_subproduct === record.id_subproduct;
                                  else is_sub_or_product = vhbill_details[j].id_product === record.id_product;
                                  if(vhbill_details[j].bill_type == 3){                       
                                    if(is_sub_or_product){                                      
                                      transaction = true         
                                      if(record.lots){
                                        for(let m=0; m<record.lots.length; m++){
                                          if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                            record.lots[m].quantity =   record.lots[m].quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                                            record.lots[m].sales_btax = record.lots[m].sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                                            record.lots[m].sales_atax = record.lots[m].sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                                          }
                                        }   
                                      }                               
                                      record.quantity = record.quantity - vhbill_details[j].quantity * vhbill_details[j].ratio;
                                      record.sales_btax = record.sales_btax - vhbill_details[j].price * vhbill_details[j].quantity;
                                      record.sales_atax = record.sales_atax - vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                    
                                    }
                                  }else{
                                    if(is_sub_or_product){                                     
                                      transaction = true         
                                      if(record.lots){
                                        for(let m=0; m<record.lots.length; m++){
                                          if(record.lots[m]._id === vhbill_details[j].id_lotproduct){                                           
                                            record.lots[m].quantity =   record.lots[m].quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                            record.lots[m].sales_btax = record.lots[m].sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                            record.lots[m].sales_atax = record.lots[m].sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);    
                                          }
                                        }   
                                      }                               
                                      record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                      record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                      record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                    
                                    }
                                  }
                                }                              
                                                  
                              if(transaction){                        
                                /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                                record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                                json.quantity = json.quantity + record.quantity;
                                json.sales_btax = json.sales_btax + record.sales_btax;
                                json.sales_atax = json.sales_atax + record.sales_atax;
                                record.index = json.size + 1;
                                json.docs.push(record);
                                json.size++;                        
                                json.empty = false; 
                              } 
                                                                          
                          }
                          for(let i=0; i<vouchers.length; i++){   
                            let transaction = false;                         
                            let unit = this.getUnit_byRatio(vouchers[i].units, 1);                             
                            let record:any ={           
                              id_voucher: vouchers[i]._id,                                                  
                              name: vouchers[i].name,
                              img: vouchers[i].img,  
                              vtype: vouchers[i].type, 

                              ratio: unit.ratio,
                              unit: unit.unit,
                              barcode: unit.barcode,  

                              sales_btax: 0,
                              sales_atax: 0,
                              quantity: 0                        
                            }   
                            for(let j=0; j<vhbill_details.length; j++){      
                              if(record.id_voucher ===vhbill_details[j]?.id_voucher){
                                transaction = true;    
                                record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                              }
                            } 
                            if(transaction){                        
                              /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                              record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                              json.quantity = json.quantity + record.quantity;
                              json.sales_btax = json.sales_btax + record.sales_btax;
                              json.sales_atax = json.sales_atax + record.sales_atax;
                              record.index = json.size + 1;
                              json.docs.push(record);
                              json.size++;                        
                              json.empty = false; 
                            } 
                          }
                          for(let i=0; i<payment_cards.length; i++){   
                            let transaction = false;                         
                            let unit = this.getUnit_byRatio(payment_cards[i].units, 1);                             
                            let record:any ={           
                              id_payment_card: payment_cards[i]._id,                                                  
                              name: payment_cards[i].name,
                              img: payment_cards[i].img,  
                              pctype: payment_cards[i].type, 

                              ratio: unit.ratio,
                              unit: unit.unit,
                              barcode: unit.barcode,  

                              sales_btax: 0,
                              sales_atax: 0,
                              quantity: 0                        
                            }    
                            for(let j=0; j<vhbill_details.length; j++){      
                              if(record.id_payment_card ===vhbill_details[j]?.id_payment_card){
                                transaction = true;    
                                record.quantity = record.quantity + vhbill_details[j].quantity * vhbill_details[j].ratio;
                                record.sales_btax = record.sales_btax + vhbill_details[j].price * vhbill_details[j].quantity;
                                record.sales_atax = record.sales_atax + vhbill_details[j].price * vhbill_details[j].quantity * (1 + vhbill_details[j].tax / 100);                                                                                                                   
                              }             
                            }
                            if(transaction){                        
                              /**xóa số 0.000000000001 thập nhâp tự sinh ra */
                              record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);                                                        
                              json.quantity = json.quantity + record.quantity;
                              json.sales_btax = json.sales_btax + record.sales_btax;
                              json.sales_atax = json.sales_atax + record.sales_atax;
                              record.index = json.size + 1;
                              json.docs.push(record);
                              json.size++;                        
                              json.empty = false; 
                            } 
                          }
                      }                           
                      console.log('getReportSales_Employees_byProducts', json);                         
                      resolve(json);
                    })
          },(error:any)=>{
            reject(error);
          }) 
    })
  }
/**
  * @Usage Hàm này dùng trong page DOANH SỐ NHÂN VIÊN (layer 3) ->  Chọn TẤT CẢ hoặc MỘT nhân viên -> Chọn một nhân viên trong list hiện ra -> Chọn một sản phẩm trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_Employees_byProduct(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_employee 
  * @param id_sub_or_product : id_subproduct or id_product
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_product, type, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Employees_byProduct(starttime:any, endtime:any, id_employee:string, id_sub_or_product:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => { 
      (async () => {
        try{
            let product = await this.getlocalDetailProduct_Async(id_sub_or_product);  
            let json:any = {
              docs: new Array(),
              empty: true,
              size:0,
              sales_btax: 0,   
              sales_atax: 0,  
              quantity: 0
            }                       
            let query:any;            
            let promise = new Array();
            let _bill_type = [1,3,15]      
              if((IDbranch==='all')||(IDbranch===undefined)){
                if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in: [1,3,15]}};
                else              query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_product: {$eq:product._id}, bill_type: {$in: [1,3,15]}};
              }else{
                if(product.id_subproduct) query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_subproduct: {$eq:product.id_subproduct}, bill_type: {$in: [1,3,15]}, id_branch: {$eq:IDbranch}};        
                else              query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_product: {$eq:product._id}, bill_type: {$in: [1,3,15]}, id_branch: {$eq:IDbranch}};     
              }     
            this.getBill_details_byFields(query, {},{date:1},0)
                .then((vhbill_details:any)=>{                
                  if(vhbill_details.length>0){    
                    for(let i=0; i<vhbill_details.length; i++){    
                      let transaction = false;                              
                      let unit = this.getUnit_byRatio(product.units, 1);           
                      let record:any ={   
                        id_product: product._id,    
                        ptype: product.type,      

                        name: product.name, 
                        img: product.img,   

                        ratio: unit.ratio,
                        unit: unit.unit,
                        barcode: unit.barcode,                         
                        
                        bill_code: vhbill_details[i].bill_code,
                        bill_type:  vhbill_details[i].bill_type,
                        id_bill: vhbill_details[i].id_bill,
                        date: vhbill_details[i].date,
                        tax: vhbill_details[i].tax,
                        salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                        customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                      }  
                      if(vhbill_details[i].id_subproduct) record.id_subproduct = vhbill_details[i].id_subproduct;                      
                      if(vhbill_details[i].id_lotproduct){
                        record.id_lotproduct = vhbill_details[i].id_lotproduct; 
                        record.lots = new Array;
                        for(let m = 0; m<product.lots.length; m++){
                          if(product.lots[m]._id === record.id_lotproduct) {
                            record.lots.push(product.lots[m]);
                            break;
                          }
                        }
                      }    

                      if(vhbill_details[i].bill_type == 3){ 
                        transaction = true;               
                        record.quantity = - vhbill_details[i].quantity * vhbill_details[i].ratio;                        
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;                
                      }else{   
                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      }
                      
                      if(transaction){
                        record.sales_btax = record.price * record.quantity;
                        record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                        record.index = json.size + 1;                   
                        json.docs.push(record);
                        json.size++;
                        json.empty = false;
                        json.quantity = json.quantity + record.quantity;
                        json.sales_btax = json.sales_btax + record.price * record.quantity;
                        json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                      }                                                                                
                    }                                 
                  }           
                  console.log('getReportSales_Employees_byProduct', json);      
                  resolve(json);
                })   
          } catch (err) {
            console.error('❌ Lỗi getReportSales_Employees_byProduct:', err);
            reject(err);
          }  
      })();        
    })      
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ NHÂN VIÊN (layer 3) ->  Chọn TẤT CẢ hoặc MỘT nhân viên -> Chọn một nhân viên trong list hiện ra -> Chọn một voucher trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_Employees_byVoucher(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_employee 
  * @param id_voucher:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_voucher, vtype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Employees_byVoucher(starttime:any, endtime:any, id_employee:string, id_voucher:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_voucher: {$eq:id_voucher}, bill_type: {$eq: 40}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('vouchers', id_voucher)
          .then((voucher:any)=>{
            if(voucher){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(voucher.units, 1);           
                        let record:any ={   
                          id_voucher: voucher._id,    
                          vtype: voucher.type,                    
                          name: voucher.name, 
                          img: voucher.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Employees_byVoucher', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }

  /**
  * @Usage Hàm này dùng trong page DOANH SỐ NHÂN VIÊN (layer 3) ->  Chọn TẤT CẢ hoặc MỘT nhân viên -> Chọn một nhân viên trong list hiện ra -> Chọn một payment_card trong list tiếp theo hiện ra
  * @example:
  * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_Employees_byPaymentCard(starttime, endtime, '7YLcm0cFKLu2KaQQ8cyv')
        .then((reportsales)=>{
          console.log('reportsales', reportsales);
          console.log('reportsales.docs[0]', reportsales.docs[0]); 
        })
  * @param starttime 
  * @param endtime 
  * @param id_employee 
  * @param id_payment_card:
  * @param IDbranch : 'all' or id_branch
  * @return Promise JSON(array) => json.docs = [obj, obj, obj....]; obj ={id_payment_card, pctype, index, name, barcode, unit, img, date, quantity, price, tax, id_bill, salesman, customer}
  */ 
  public getReportSales_Employees_byPaymentCard(starttime:any, endtime:any, id_employee:string, id_payment_card:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {     
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        sales_btax: 0,   
        sales_atax: 0,  
        quantity: 0
      }                       
      let query:any;            
      let promise = new Array();    
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, id_employee: {$eq:id_employee}, id_payment_card: {$eq:id_payment_card}, bill_type: {$eq: 50}, id_branch: {$eq:IDbranch}};     
        }     

      this.vhMGDB_database.getDoc('payment_cards', id_payment_card)
          .then((payment_card:any)=>{
            if(payment_card){        
              this.getBill_details_byFields(query, {},{date:1},0)
                  .then((vhbill_details:any)=>{                
                    if(vhbill_details.length>0){    
                      for(let i=0; i<vhbill_details.length; i++){    
                        let transaction = false;                              
                        let unit = this.getUnit_byRatio(payment_card.units, 1);           
                        let record:any ={   
                          id_payment_card: payment_card._id,  
                          pctype: payment_card.type,      

                          name: payment_card.name, 
                          img: payment_card.img,   

                          ratio: unit.ratio,
                          unit: unit.unit,
                          barcode: unit.barcode,                         
                          
                          bill_code: vhbill_details[i].bill_code,
                          bill_type:  vhbill_details[i].bill_type,
                          id_bill: vhbill_details[i].id_bill,
                          date: vhbill_details[i].date,
                          tax: vhbill_details[i].tax,
                          salesman: this.vhAuth.getlocalEmployee(vhbill_details[i].id_employee)?.name,   
                          customer: this.getlocalCustomer(vhbill_details[i].id_customer).name                                                
                        }  

                        transaction = true;                  
                        record.quantity = vhbill_details[i].quantity * vhbill_details[i].ratio;                   
                        record.price = vhbill_details[i].price/vhbill_details[i].ratio;         
                      
                        if(transaction){
                          record.sales_btax = record.price * record.quantity;
                          record.sales_atax = record.price * record.quantity * (1 + record.tax / 100);
                          record.index = json.size + 1;                   
                          json.docs.push(record);
                          json.size++;
                          json.empty = false;
                          json.quantity = json.quantity + record.quantity;
                          json.sales_btax = json.sales_btax + record.price * record.quantity;
                          json.sales_atax = json.sales_atax + record.price * record.quantity * (1 + Number(record.tax) / 100);  
                        }                                                                                
                      }                                 
                    }           
                    console.log('getReportSales_Employees_byPaymentCard', json);      
                    resolve(json);
              })   
            }else{
              resolve(json);
            }  
            
          }, error=>{
              reject(error);
          })       
    })      
  }

  /**
   * VhQuerySales: đã check
   * Hàm này dùng trong page XUẤT-NHẬP-TRẢ -> tất cả các trường hợp
   * @example:
   * let starttime = new Date('2020-12-10T05:24:00');
     let endtime = new Date();    
    this.vhQuerySales.getReportInputOutputReturns_byTime_byIDProduct_byBillTypeArray(starttime, endtime, 'all', 1, [1])
        .then((products)=>{
          console.log('products', products);
        })
   * @param starttime 
   * @param endtime 
   * @param IDsub_or_product : 'all' or id_subproduct or id_product
   * @param IDbranch : 'all' or id_branch
   * @param ptype 
   * @param array_bill_type 
   * @return Promise Array
   * @Notice id_product = 'all' or id_product; ptype = 3(product) or 2(service);  array_bill_type = [bill_type]; [1,10,15,30,38,41,51,2,3,9,31,39]
   */ 
  public getReportInputOutputReturns_byTime_byIDProduct_byBillTypeArray(starttime:any, endtime:any, IDsub_or_product:string, ptype:any, array_bill_type:any, IDbranch?:string){
    console.log('array_bill_type', array_bill_type, ptype);
    return new Promise<any>((resolve, reject) => {  
        let products:any = new Array();           
        if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(ptype), 'name');   
        else {
          let product = this.getlocalDetailProduct(IDsub_or_product);           ;  
          products.push(product);           
        }       
        let json:any = {
          docs: new Array(),
          empty: true,
          size:0,
          quantity: 0,
          pay_btax: 0,
          pay_atax: 0
        }              
        if(products.length>0){          
          let promise = new Array();                  
          let query1:any = {};
          let query2:any = {};
          let array_bill_type1 = new Array();
          let array_bill_type2 = new Array();
          for(let i=0; i<array_bill_type.length; i++){
            if(i<=9) array_bill_type1.push(array_bill_type[i]);
            else array_bill_type2.push(array_bill_type[i]);
          }
          if(IDsub_or_product === 'all'){
            if((IDbranch === 'all')||(IDbranch === undefined)){
              query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:ptype}, bill_type: {$in:array_bill_type1}};   
              query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:ptype}, bill_type: {$in:array_bill_type2}};              
            }else{
              query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:ptype}, bill_type: {$in:array_bill_type1}, id_branch: {$eq:IDbranch}}; 
              query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:ptype}, bill_type: {$in:array_bill_type2}, id_branch: {$eq:IDbranch}}; 
            }
          }else{
            if((IDbranch === 'all')||(IDbranch === undefined)){
              if(products[0].id_subproduct) {
                query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type1}};      
                query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type2}};      
              }else{
                query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type1}};  
                query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type2}};  
              }         
            }else{
              if(products[0].id_subproduct){
                query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type1}, id_branch: {$eq:IDbranch}};
                query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type2}, id_branch: {$eq:IDbranch}};
              }else{
                query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type1}, id_branch: {$eq:IDbranch}};
                query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:array_bill_type2}, id_branch: {$eq:IDbranch}};
              }
            }
          }      
          
          if(array_bill_type.length<=10){
            promise[promise.length] = this.getBill_details_byFields(query1, {},{date:1},0);
          }else{
            promise[promise.length] = this.getBill_details_byFields(query1, {},{date:1},0)
            promise[promise.length] = this.getBill_details_byFields(query2, {},{date:1},0)
          }

          Promise.all(promise)
              .then((array:any)=>{            
                let bill_details = array.flat();                           
                for(let i=0; i<products.length; i++){
                  let unit = this.getUnit_byRatio(products[i].units, 1);                 
                  let record: any ={
                    id_product: products[i]._id,              
                    name: products[i].name,
                    img: products[i].img,  
                    type: products[i].type,

                    ratio: unit.ratio,
                    unit: unit.unit,
                    barcode: unit.barcode,               

                    quantity: 0,
                    pay_btax: 0,
                    pay_atax: 0
                  }
                  if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;       
                  if(products[i].lots) {
                    record.lots = cloneDeep(products[i].lots);
                    for(let m = 0; m<record.lots.length; m++){
                      record.lots[m].quantity = 0;
                      record.lots[m].pay_btax = 0;
                      record.lots[m].pay_atax = 0;
                    } 
                  }              
                 
                  for(let j=0; j<bill_details.length; j++){   
                    let is_sub_or_product = false;
                    if(record.id_subproduct) is_sub_or_product = bill_details[j].id_subproduct === record.id_subproduct;
                    else is_sub_or_product = bill_details[j].id_product === record.id_product;
                    //if(bill_details[j].ptype === 1){
                    if(is_sub_or_product){       
                      if(record.lots){
                        for(let m=0; m<record.lots.length; m++){
                          if(record.lots[m]._id === bill_details[j].id_lotproduct){    
                            record.lots[m].pay_btax = record.lots[m].pay_btax + bill_details[j].price * bill_details[j].quantity; 
                            record.lots[m].pay_atax = record.lots[m].pay_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                            record.lots[m].quantity = record.lots[m].quantity + bill_details[j].quantity * bill_details[j].ratio;                       
                          }
                        }   
                      }                  
                      record.pay_btax = record.pay_btax + bill_details[j].price * bill_details[j].quantity;  
                      record.pay_atax = record.pay_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                      record.quantity = record.quantity + bill_details[j].quantity * bill_details[j].ratio; 
                      
                      json.pay_btax = json.pay_btax + bill_details[j].price  * bill_details[j].quantity; 
                      json.pay_atax = json.pay_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                      json.quantity = json.quantity + bill_details[j].quantity * bill_details[j].ratio;                                        
                    }   
                    //} 
                  }                    
                  record.pay_atax = this.vhAlgorithm.roundTo3Decimals(record.pay_atax);   
                  json.pay_atax = this.vhAlgorithm.roundTo3Decimals(json.pay_atax);   
                  json.docs.push(record);
                  json.size++;                        
                  json.empty = false;                               
                }
                console.log('getReportInputOutputReturns_byTime_byIDProduct_byBillTypeArray', json);
                resolve(json);   
              })                      
        
        }else{
          console.log('server -> products khong ton tai trong CSDL: ');
          resolve(json);           
        }  
                
    })    
  }

  /**   
   * Hàm này dùng trong page XUẤT-NHẬP-TRẢ -> tất cả các trường hợp -> chi tiết
   * @example:
   *  this.vhQuerySales.getReportInputOutputReturns_Detail_byTime_byIDProduct_byBillTypeArray(time['startTime'], time['endTime'], 'UTWXdaU3UDq3xq7aK77p', [1])
        .then((bill_details:any)=>{
          console.log('bill_details', bill_details);
        })
   * @param starttime 
   * @param endtime 
   * @param id_sub_or_product :id_subproduct or id_product
   * @param array_bill_type 
   * @param IDbranch 
   * @return Promise Array
   * @Notice array_bill_type = [bill_type]; [1,10,15,30,38,41,51,2,3,9,31,39]
   */
  public getReportInputOutputReturns_Detail_byTime_byIDProduct_byBillTypeArray(starttime:any, endtime:any, id_sub_or_product:any,array_bill_type:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {  
      let product = this.getlocalDetailProduct(id_sub_or_product);  
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        quantity: 0,
        pay_btax: 0,
        pay_atax: 0
      }   
      let promise = new Array();                  
      let query1:any = {};
      let query2:any = {};
      let array_bill_type1 = new Array();
      let array_bill_type2 = new Array();
      for(let i=0; i<array_bill_type.length; i++){
        if(i<=9) array_bill_type1.push(array_bill_type[i]);
        else array_bill_type2.push(array_bill_type[i]);
      }         
      if((IDbranch==='all')||(IDbranch===undefined)){
        if(product.id_subproduct){
          query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:array_bill_type1}};
          query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:array_bill_type2}};
        }else{
          query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:array_bill_type1}};
          query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:array_bill_type2}};
        }
      }else{
        if(product.id_subproduct){
           query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:array_bill_type1}, id_branch: {$eq:IDbranch}};
           query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:array_bill_type2}, id_branch: {$eq:IDbranch}};
        }else {
          query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:array_bill_type1}, id_branch: {$eq:IDbranch}};
          query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:array_bill_type2}, id_branch: {$eq:IDbranch}};
        }
      }
       
      if(array_bill_type.length<=10){
        promise[promise.length] = this.getBill_details_byFields(query1, {},{date:1},0);
      }else{
        promise[promise.length] = this.getBill_details_byFields(query1, {},{date:1},0)
        promise[promise.length] = this.getBill_details_byFields(query2, {},{date:1},0)
      }

      Promise.all(promise)
            .then((array:any)=>{  
              let bill_details = array.flat();   
              let unit = this.getUnit_byRatio(product.units, 1);              
              for(let j=0; j<bill_details.length; j++){   
                let record:any ={                              
                  id_product: product._id,              
                  name: product.name,
                  img: product.type,  
  
                  ratio: unit.ratio,
                  unit: unit.unit,
                  barcode: unit.barcode,    
                }  
                if(product.id_subproduct) record.id_subproduct = product.id_subproduct;  
                if(bill_details[j].id_lotproduct){
                  record.id_lotproduct = bill_details[j].id_lotproduct; 
                  record.lots = new Array;
                  for(let m = 0; m<product.lots.length; m++){
                    if(product.lots[m]._id === record.id_lotproduct) {
                      record.lots.push(product.lots[m]);
                      break;
                    }
                  }
                }   
              
                if(bill_details[j]?.id_bill) record.id_bill = bill_details[j]?.id_bill;
                if(bill_details[j]?.bill_code) record.bill_code = bill_details[j]?.bill_code;
                if(bill_details[j]?.bill_type) record.bill_type = bill_details[j]?.bill_type;
                if(bill_details[j]?.date) record.date = bill_details[j]?.date;

                if(bill_details[j]?.id_cashier) record.id_cashier = bill_details[j]?.id_cashier;
                if(bill_details[j]?.id_employee) record.id_employee = bill_details[j]?.id_employee;
                if(bill_details[j]?.id_customer) record.id_customer = bill_details[j]?.id_customer;
                if(bill_details[j]?.id_supplier) record.id_supplier = bill_details[j]?.id_supplier;
               
                record.price_btax = bill_details[j].price;
                record.price_atax = bill_details[j].price * (1 + bill_details[j].tax/100);
                record.pay_btax = bill_details[j].price * bill_details[j].quantity;
                record.pay_atax = this.vhAlgorithm.roundTo3Decimals(bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                record.quantity = bill_details[j].quantity * bill_details[j].ratio;

                json.quantity = json.quantity + bill_details[j].quantity * bill_details[j].ratio;
                json.pay_btax = json.pay_btax + bill_details[j].price  * bill_details[j].quantity;
                json.pay_atax = json.pay_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
          
                record.price_atax = this.vhAlgorithm.roundTo3Decimals(record.price_atax);     
                record.pay_atax = this.vhAlgorithm.roundTo3Decimals(record.pay_atax);   
                json.pay_atax = this.vhAlgorithm.roundTo3Decimals(json.pay_atax); 
                
                record.index = json.size + 1;
                json.docs.push(record);
                json.size++;                        
                json.empty = false;                 
                              
              } 
              console.log('getReportInputOutputReturns_Detail_byTime_byIDProduct_byBillTypeArray', json);        
              resolve(json);
          })
    })
  }

  /**  
   * Hàm này dùng trong page XUẤT-NHẬP-TỒN -> Xuất nhập tồn
   * @example:
   * this.vhQuerySales.getReportInputOutputInventory_byTime_byIDProduct(starttime , endtime, 'all', 'tj1iYodbVoShwtEetACx')
        .then((json)=>{
          console.log('json', json);
        })
   * @param starttime 
   * @param endtime 
   * @param IDsub_or_product: 'all' or id_subproduct or id_product;  
   * @param IDbranch: 'all' or id_branch; 
   * @return Promise Array   * 
   * @Notice bill_type = [1,10,15,30,38,41,51,2,3,9,31,39]
   */
  public getReportInputOutputInventory_byTime_byIDProduct(starttime:any, endtime:any, IDsub_or_product:any, IDbranch:any){
    return new Promise<any>((resolve, reject) => {  
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        outquantity: 0,
        inquantity: 0, 
        revenue_btax: 0,   
        revenue_atax: 0,  
        cost_btax: 0,     
        cost_atax: 0,
        
        stock_first: 0,   
        stock_last: 0,   
        cost_stock_first_btax: 0,   
        cost_stock_first_atax: 0,                          
        cost_stock_last_btax: 0,   
        cost_stock_last_atax: 0  
      }    
      let store = this.vhAuth.getStore();  
      let products:any = new Array();   
      if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
      else {
        let product = this.getlocalDetailProduct(IDsub_or_product);            
        products.push(product);
      } 
      let query:any;
      let cash = 0;
      let index:any = null;
      let day:any = null; //day là ngày đầu tháng của tháng starttime     
      let index1 = null;
      let index2 = null;      
      this.checkAndsyncInventoryOfProducts(products, IDbranch)
          .then((check)=>{                 
              if(check){
                if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
                else {
                  let product = this.getlocalDetailProduct(IDsub_or_product);            
                  products.push(product);
                }
              }
              if((IDbranch==='all')||(IDbranch===undefined)){//ok
                console.log('trường hợp này chưa có hàm, liên hệ anh Huy viết');
                return  resolve(json);   
              }else{//ok         
                if(products[0][IDbranch + '_ivtr'] != undefined){
                  for(let k=0; k<products[0][IDbranch + '_ivtr'].length; k++){              
                    if((new Date(products[0][IDbranch + '_ivtr'][k].date)).getTime() > starttime.getTime()){               
                      break;
                    }else{
                      day = new Date(products[0][IDbranch + '_ivtr'][k].date);
                      index = k; 
                      index1 = k;               
                    }
                  }    
                  for(let k=0; k<products[0][IDbranch + '_ivtr'].length; k++){              
                    if((new Date(products[0][IDbranch + '_ivtr'][k].date)).getTime() > endtime.getTime()){               
                      break;
                    }else{                
                      index2 = k;                
                    }
                  }             
                }               
              }    
              if(!day) day = new Date(store.registrationdate);                     
              if(products.length>0){           
                //nhớ kiểm tra có cần thêm sắp xếp asc ko  
                let query1:any = {};
                let query2:any = {};           
                let promise = new Array();     
                if(IDsub_or_product === 'all'){
                  if((IDbranch === 'all')||(IDbranch === undefined)){
                    query1 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};   
                    query2 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}};        
                  }else{
                    query1 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:IDbranch}};
                    query2 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                  }            
                }else{         
                    if((IDbranch === 'all')||(IDbranch === undefined)){                 
                      if(products[0].id_subproduct){ 
                        query1 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};
                        query2 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};
                      }else{                      
                        query1 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};
                        query2 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};
                      }
                    }else{                
                      if(products[0].id_subproduct){
                        query1 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:IDbranch}};
                        query2 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                      }else{
                        query1 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:IDbranch}};
                        query2 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                      }
                    }         
                }  
                promise[0] = this.getBill_details_byFields(query1, {},{date:1},0)
                promise[1] = this.getBill_details_byFields(query2, {},{date:1},0)
                Promise.all(promise)
                    .then((array:any)=>{           
                        let bill_details = array.flat();                         
                        for(let i=0; i<products.length; i++){
                          //if((products[i][IDbranch] != undefined)&&(products[i][IDbranch + '_ivtr'] != undefined)){
                            let first = {
                              stock_first: 0,
                              cost_stock_first_btax: 0,
                              cost_stock_first_atax: 0                    
                            }                    
                            let unit = this.getUnit_byRatio(products[i].units,1);                 
                            let record: any ={                   
                              id_product:  products[i]._id,
                              name: products[i].name,
                              img: products[i].img,
                              type: products[i].type,

                              ratio: unit.ratio,
                              unit: unit.unit,
                              barcode: unit.barcode,
                              
                              outquantity: 0,
                              inquantity: 0, 
                              revenue_btax: 0,   
                              revenue_atax: 0,  
                              cost_btax: 0,     
                              cost_atax: 0 
                            }
                            if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;  
                            if(products[i].lots) {
                              record.lots = cloneDeep(products[i].lots); 
                              for(let m = 0; m<record.lots.length; m++){                       
                                record.lots[m].outquantity = 0;
                                record.lots[m].inquantity = 0;
                                record.lots[m].revenue_btax = 0;
                                record.lots[m].revenue_atax = 0;
                                record.lots[m].cost_btax = 0;
                                record.lots[m].cost_atax = 0;                      

                                record.lots[m].soluongra_dauky = 0;
                                record.lots[m].soluongvao_dauky = 0;
                                record.lots[m].tientra_dauky_btax = 0;
                                record.lots[m].tientra_dauky_atax = 0;
                                record.lots[m].soluongvao_cuoiky = 0;
                                record.lots[m].tientra_cuoiky_btax = 0;
                                record.lots[m].tientra_cuoiky_atax = 0;
                                
                                record.lots[m].first ={
                                  stock_first: 0,
                                  stock_last: 0,
                                  cost_stock_first_btax: 0,
                                  cost_stock_first_atax: 0
                                }
                                record.lots[m].cost_stock_last_btax = 0;   
                                record.lots[m].cost_stock_last_atax = 0;                    
                              }
                            }   

                            record.stock_first = 0;   
                            record.stock_last = 0;   
                            record.cost_stock_first_btax = 0;   
                            record.cost_stock_first_atax = 0;                          
                            record.cost_stock_last_btax = 0;   
                            record.cost_stock_last_atax = 0;       
                            
                            //các biến tiếng việt này là khoản thời gian từ day đến startime
                            let soluongra_dauky = 0;
                            let soluongvao_dauky = 0;
                            let tientra_dauky_btax = 0;
                            let tientra_dauky_atax = 0;
                            let soluongvao_cuoiky = 0;
                            let tientra_cuoiky_btax = 0;
                            let tientra_cuoiky_atax = 0;                  
                          
                            for(let j=0; j<bill_details.length; j++){ 
                              let is_sub_or_product = false;
                              if(record.id_subproduct) is_sub_or_product = bill_details[j].id_subproduct === record.id_subproduct;
                              else is_sub_or_product = bill_details[j].id_product === record.id_product;
                              if(bill_details[j].ptype === 3){  
                                if(is_sub_or_product){  
                                  let date = new Date(bill_details[j].date);   
                                  if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                                    if(date >= new Date(starttime)){      
                                      //XUẤT 
                                      if(record.lots){
                                        for(let m=0; m<record.lots.length; m++){
                                          if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                            record.lots[m].revenue_btax = record.lots[m].revenue_btax + bill_details[j].price * bill_details[j].quantity;  
                                            record.lots[m].revenue_atax = record.lots[m].revenue_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                            record.lots[m].outquantity = record.lots[m].outquantity + bill_details[j].quantity * bill_details[j].ratio; 
                                          }
                                        }   
                                      }                                
                                      record.revenue_btax = record.revenue_btax + bill_details[j].price * bill_details[j].quantity;  
                                      record.revenue_atax = record.revenue_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                      record.outquantity = record.outquantity + bill_details[j].quantity * bill_details[j].ratio; 

                                      json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity; 
                                      json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                                      json.outquantity = json.outquantity + bill_details[j].quantity * bill_details[j].ratio;                                  
                                    }else{
                                      if(record.lots){
                                        for(let m=0; m<record.lots.length; m++){
                                          if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                            record.lots[m].soluongra_dauky = record.lots[m].soluongra_dauky + bill_details[j].quantity * bill_details[j].ratio; 
                                          }
                                        }   
                                      } 
                                      soluongra_dauky = soluongra_dauky + bill_details[j].quantity * bill_details[j].ratio;                          
                                    }
                                                                    
                                  }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){ 
                                    if(date >= new Date(starttime)){  
                                      //NHẬP  
                                      if(record.lots){
                                        for(let m=0; m<record.lots.length; m++){
                                          if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                            record.lots[m].cost_btax = record.lots[m].cost_btax + bill_details[j].price * bill_details[j].quantity; 
                                            record.lots[m].cost_atax = record.lots[m].cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                            record.lots[m].inquantity = record.lots[m].inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                                          }
                                        }   
                                      }                      
                                      record.cost_btax = record.cost_btax + bill_details[j].price * bill_details[j].quantity; 
                                      record.cost_atax = record.cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                      record.inquantity = record.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                                    
                                      json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity; 
                                      json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                                      json.inquantity = json.inquantity + bill_details[j].quantity * bill_details[j].ratio; 

                                    }else{
                                      if(record.lots){
                                        for(let m=0; m<record.lots.length; m++){
                                          if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                            record.lots[m].soluongvao_dauky = record.lots[m].soluongvao_dauky + bill_details[j].quantity * bill_details[j].ratio; 
                                            record.lots[m].tientra_dauky_btax = record.lots[m].tientra_dauky_btax + bill_details[j].price * bill_details[j].quantity; 
                                            record.lots[m].tientra_dauky_atax = this.vhAlgorithm.roundTo3Decimals(record.lots[m].tientra_dauky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                          }
                                        }   
                                      } 
                                      soluongvao_dauky = soluongvao_dauky + bill_details[j].quantity * bill_details[j].ratio; 
                                      tientra_dauky_btax = tientra_dauky_btax + bill_details[j].price * bill_details[j].quantity; 
                                      tientra_dauky_atax = this.vhAlgorithm.roundTo3Decimals(tientra_dauky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                    }
                                    if(record.lots){
                                      for(let m=0; m<record.lots.length; m++){
                                        if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                          record.lots[m].soluongvao_cuoiky = record.lots[m].soluongvao_cuoiky + bill_details[j].quantity * bill_details[j].ratio; 
                                          record.lots[m].tientra_cuoiky_btax = record.lots[m].tientra_cuoiky_btax + bill_details[j].price * bill_details[j].quantity; 
                                          record.lots[m].tientra_cuoiky_atax = this.vhAlgorithm.roundTo3Decimals(record.lots[m].tientra_cuoiky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                        }
                                      }   
                                    } 
                                    soluongvao_cuoiky = soluongvao_cuoiky + bill_details[j].quantity * bill_details[j].ratio; 
                                    tientra_cuoiky_btax = tientra_cuoiky_btax + bill_details[j].price * bill_details[j].quantity; 
                                    tientra_cuoiky_atax = this.vhAlgorithm.roundTo3Decimals(tientra_cuoiky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                  
                                  }else if(bill_details[j].bill_type === 9){//bill_type_9 là tồn đầu kỳ, ko xem nó là hàng nhập như báo cáo trước đây
                                    if(record.lots){
                                      for(let m=0; m<record.lots.length; m++){
                                        if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                          record.lots[m].first.stock_first = record.lots[m].first.stock_first + bill_details[j].quantity * bill_details[j].ratio; 
                                          record.lots[m].first.cost_stock_first_btax = record.lots[m].first.cost_stock_first_btax + bill_details[j].price * bill_details[j].quantity; 
                                          record.lots[m].first.cost_stock_first_atax = record.lots[m].first.cost_stock_first_atax +  bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);   
                                        }
                                      }   
                                    } 
                                    first.stock_first = first.stock_first + bill_details[j].quantity * bill_details[j].ratio; 
                                    first.cost_stock_first_btax = first.cost_stock_first_btax + bill_details[j].price * bill_details[j].quantity; 
                                    first.cost_stock_first_atax = first.cost_stock_first_atax +  bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);   
                                                          
                                  }                                                        
                                } 
                              }                                    
                            }

                            if(record.lots){
                              for(let m=0; m<record.lots.length; m++){                       
                                record.lots[m].stock_first = record.lots[m].first.stock_first + record.lots[m].soluongvao_dauky - record.lots[m].soluongra_dauky;//ok                               
                                record.lots[m].stock_last = record.lots[m].stock_first + record.lots[m].inquantity - record.lots[m].outquantity;//ok
                              
                                if(index !=null) record.lots[m].first = {...products[i][IDbranch + '_ivtr'][index].lots[m]};     
                                        
                                record.lots[m].stock_first = record.lots[m].first.stock_first + record.lots[m].soluongvao_dauky - record.lots[m].soluongra_dauky;//ok                               
                                record.lots[m].stock_last = record.lots[m].stock_first + record.lots[m].inquantity - record.lots[m].outquantity;//ok
                                if((record.lots[m].first.stock_first + record.lots[m].soluongvao_dauky)!=0){
                                  record.lots[m].cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(((record.lots[m].first.cost_stock_first_btax + record.lots[m].tientra_dauky_btax)/(record.lots[m].first.stock_first + record.lots[m].soluongvao_dauky)) * record.lots[m].stock_first);
                                  record.lots[m].cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(((record.lots[m].first.cost_stock_first_atax + record.lots[m].tientra_dauky_atax)/(record.lots[m].first.stock_first + record.lots[m].soluongvao_dauky)) * record.lots[m].stock_first);
                                }
            
                                if((record.lots[m].first.stock_first + record.lots[m].soluongvao_cuoiky)!=0){
                                  record.lots[m].cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals(((record.lots[m].first.cost_stock_first_btax + record.lots[m].tientra_cuoiky_btax)/(record.lots[m].first.stock_first + record.lots[m].soluongvao_cuoiky)) * record.lots[m].stock_last);
                                  record.lots[m].cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(((record.lots[m].first.cost_stock_first_atax + record.lots[m].tientra_cuoiky_atax)/(record.lots[m].first.stock_first + record.lots[m].soluongvao_cuoiky)) * record.lots[m].stock_last);
                                }
                              
                              }   
                            } 
                          
                            if(index !=null) first = {...products[i][IDbranch + '_ivtr'][index]};     
                                        
                            record.stock_first = first.stock_first + soluongvao_dauky - soluongra_dauky;//ok                               
                            record.stock_last = record.stock_first + record.inquantity - record.outquantity;//ok
                            if((first.stock_first + soluongvao_dauky)!=0){
                              record.cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_btax + tientra_dauky_btax)/(first.stock_first + soluongvao_dauky)) * record.stock_first);
                              record.cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_atax + tientra_dauky_atax)/(first.stock_first + soluongvao_dauky)) * record.stock_first);
                            }

                            if((first.stock_first + soluongvao_cuoiky)!=0){
                              record.cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_btax + tientra_cuoiky_btax)/(first.stock_first + soluongvao_cuoiky)) * record.stock_last);
                              record.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_atax + tientra_cuoiky_atax)/(first.stock_first + soluongvao_cuoiky)) * record.stock_last);
                            }
                            //if(soluongvao_dauky!=0) product.cost_stock_first_btax = (tientra_dauky_btax/soluongvao_dauky) * product.stock_first;//ok 
                            //if(soluongvao_dauky!=0) product.cost_stock_first_atax = (tientra_dauky_atax/soluongvao_dauky) * product.stock_first;//ok 
                            //if(soluongvao_cuoiky!=0) product.cost_stock_last_btax = (tientra_cuoiky_btax/soluongvao_cuoiky) * product.stock_last;  
                            //if(soluongvao_cuoiky!=0) product.cost_stock_last_atax = (tientra_cuoiky_atax/soluongvao_cuoiky) * product.stock_last; 

                            json.stock_first = json.stock_first + record.stock_first;
                            json.stock_last = json.stock_last + record.stock_last;
                            json.cost_stock_first_btax = json.cost_stock_first_btax + record.cost_stock_first_btax;
                            json.cost_stock_first_atax = json.cost_stock_first_atax + record.cost_stock_first_atax;
                            json.cost_stock_last_btax = json.cost_stock_last_btax + record.cost_stock_last_btax;
                            json.cost_stock_last_atax = json.cost_stock_last_atax + record.cost_stock_last_atax;

                            if((record.stock_first !=0)||(record.stock_last !=0)||(record.inquantity !=0)||(record.outquantity !=0)){
                              record.revenue_atax = this.vhAlgorithm.roundTo3Decimals(record.revenue_atax);     
                              record.cost_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_atax);    
                              record.cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_stock_first_atax);     
                              record.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_stock_last_atax);   

                              record.index = json.size + 1;
                              json.docs.push(record);
                              json.size++;                        
                              json.empty = false;   
                            }  
                          //}                                        
                        }
                        resolve(json);                                 
                        console.log('getReportInputOutputInventory_byTime_byIDProduct', json);
                      })                      
              
              }else{
                console.log('server -> products khong ton tai trong CSDL: ');
                resolve(json);           
              }  
          })
    })    
  }

  private makeCorrectStock1stDayOfMonth(index1:number, index2:number, products:any, bill_details:any, id_branch:string){
     console.log('makeCorrectStock1stDayOfMonth');
    return new Promise<any>((resolve, reject) => {  
                        let promise_products = new Array();     
                        for(let i=0; i<products.length; i++){                                     
                          if(products[i][id_branch + '_ivtr'] != undefined){   
                              const inventory = products[i][id_branch + '_ivtr'][index1];                                                                       
                              for(let k= index1+1; k <= index2; k++){                                              
                                products[i][id_branch + '_ivtr'][k].inquantity_tofirst = inventory.inquantity_tofirst;
                                products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = inventory.pay_tofirst_btax;
                                products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = inventory.pay_tofirst_atax;
                                products[i][id_branch + '_ivtr'][k].outquantity_tofirst = inventory.outquantity_tofirst;
                                products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = inventory.sales_tofirst_btax;
                                products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = inventory.sales_tofirst_atax;

                                products[i][id_branch + '_ivtr'][k].stock_first = 0;
                                products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = 0;
                                products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = 0;
                                products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = 0;
                                products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = 0;
                                products[i][id_branch + '_ivtr'][k].profit_first_btax = 0;
                                products[i][id_branch + '_ivtr'][k].profit_first_atax = 0;
                              }                                         
                                                                                                         
                              if(bill_details.length >0){        
                                //console.log('bill_details1', bill_details);                          
                                for(let j=0; j<bill_details.length; j++){ 
                                  if(bill_details[j].ptype === 3){  
                                    if(bill_details[j].id_product === products[i]._id){                                                     
                                      for(let k= index1+1; k <=index2; k++){                  
                                        if((new Date(bill_details[j].date)).getTime() < (new Date(products[i][id_branch + '_ivtr'][k].date)).getTime()){                                                   
                                            if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)){                                                     
                                              products[i][id_branch + '_ivtr'][k].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].outquantity_tofirst + bill_details[j].quantity;               
                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));

                                            }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 31)){                                                       
                                              products[i][id_branch + '_ivtr'][k].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].inquantity_tofirst + bill_details[j].quantity;
                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_atax =this.vhAlgorithm.roundTo3Decimals( products[i][id_branch + '_ivtr'][k].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                                                
                                            }                                   
                                        }
                                      }                                                                                              
                                    } 
                                  }                                    
                                }
                              }
                                
                              for(let k= index1+1; k <=index2; k++){                                                
                                let slnhaptrongky = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].inquantity_tofirst;
                                let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_btax;
                                let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_atax;
                                products[i][id_branch + '_ivtr'][k].stock_first = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].outquantity_tofirst;   
                                
                                if((products[i][id_branch + '_ivtr'][k-1].stock_first + slnhaptrongky) !=0){
                                  products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax + tongtiennhaptrongky_btax)/(products[i][id_branch + '_ivtr'][k-1].stock_first + slnhaptrongky));
                                  products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((products[i][id_branch + '_ivtr'][k-1].cost_stock_first_atax + tongtiennhaptrongky_atax)/(products[i][id_branch + '_ivtr'][k-1].stock_first + slnhaptrongky));
                                  products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].stock_first; 
                                  products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].stock_first;  
                                }
                                let slbantrongky = products[i][id_branch + '_ivtr'][k].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].outquantity_tofirst;
                                let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * slbantrongky;
                                let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * slbantrongky;
                                let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_btax;
                                let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_atax;
                                products[i][id_branch + '_ivtr'][k].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                products[i][id_branch + '_ivtr'][k].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                              }                         
                              
                              let _product = this.getlocalProduct(products[i]._id);  
                              for(let k= index1+1; k <=index2; k++){     
                                if((_product[id_branch + '_ivtr'][k].inquantity_tofirst != products[i][id_branch + '_ivtr'][k].inquantity_tofirst)||
                                (_product[id_branch + '_ivtr'][k].pay_tofirst_btax != products[i][id_branch + '_ivtr'][k].pay_tofirst_btax)||
                                (_product[id_branch + '_ivtr'][k].pay_tofirst_atax != products[i][id_branch + '_ivtr'][k].pay_tofirst_atax)||
                                (_product[id_branch + '_ivtr'][k].outquantity_tofirst != products[i][id_branch + '_ivtr'][k].outquantity_tofirst)||
                                (_product[id_branch + '_ivtr'][k].sales_tofirst_btax != products[i][id_branch + '_ivtr'][k].sales_tofirst_btax)||
                                (_product[id_branch + '_ivtr'][k].sales_tofirst_atax != products[i][id_branch + '_ivtr'][k].sales_tofirst_atax)||
                                (_product[id_branch + '_ivtr'][k].stock_first != products[i][id_branch + '_ivtr'][k].stock_first)||
                                (_product[id_branch + '_ivtr'][k].unit_cost_stock_first_btax != products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax)||
                                (_product[id_branch + '_ivtr'][k].unit_cost_stock_first_atax != products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax)||
                                (_product[id_branch + '_ivtr'][k].cost_stock_first_btax != products[i][id_branch + '_ivtr'][k].cost_stock_first_btax)||
                                (_product[id_branch + '_ivtr'][k].cost_stock_first_atax != products[i][id_branch + '_ivtr'][k].cost_stock_first_atax)||
                                (_product[id_branch + '_ivtr'][k].profit_first_btax != products[i][id_branch + '_ivtr'][k].profit_first_btax)||
                                (_product[id_branch + '_ivtr'][k].profit_first_atax != products[i][id_branch + '_ivtr'][k].profit_first_atax)
                                    ){
                                    //console.log('k', k);
                                    //console.log('_product', _product);
                                    //console.log('products[i]', products[i]);
                                    promise_products[promise_products.length] = new Promise((resolve, reject)=>{
                                      resolve(null);
                                    })
                                    }else{
                                    promise_products[promise_products.length] = new Promise((resolve, reject)=>{
                                      resolve(null);
                                    })
                                    }
                              }
                              // let value:any = {};                                        
                              // if(_product[id_branch] != undefined){
                              //   value[id_branch] = _product[id_branch];
                              //   value[id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'];
                              // }else{
                              //   value[id_branch] = products[i][id_branch];
                              // }              

                              // this.vhMGDB_database.updateDoc('products', products[i]._id, {...value})
                              //     .then(()=>{
                              //       console.log(i, products[i]);                                                       
                              //       resolve(true);
                              //     })                                      
                          }
                        }
                        Promise.all(promise_products)
                               .then(()=>{
                                 console.log('makeCorrectStock1stDayOfMonth');
                                resolve(true);
                               }) 
    })
  }

  /**   
   * Hàm này dùng trong page Tồn kho, giá trị tồn kho, doanh số, chi phí nhập hàng tại một thời điểm endtime nào đó
   * @example:
   * this.vhQuerySales.getReportInputOutputInventory_byEndTime_byIDProduct_allRecords(endtime, 'all')
        .then((bill_details:any)=>{
          console.log('bill_details', bill_details);
        })
   * @param starttime 
   * @param endtime 
   * @param IDproduct : 'all' or id_product 
   * @param IDbranch : 'all' or id_branch
   * @return Promise Array
   * @Notice id_product = 'all' or id_product;
   * @Notice bill_type = [1,10,15,30,2,3,9,31]
   */
  //hàm này sẽ sửa lại lấy dữ liệu theo thuật toan mới
  private getReportInputOutputInventory_byEndTime_byIDProduct_allRecords(endtime:any, IDproduct:any, IDbranch?:string){   
    return new Promise<any>((resolve, reject) => {  
        let products:any = new Array();   
        if(IDproduct === 'all'){ 
          products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalProducts(3), 'name');  
        }else {
          let product = this.getlocalProduct(IDproduct);            
          products.push(product);
        }
        let json:any = {
          docs: new Array(),
          empty: true,
          size:0,
          outquantity: 0,
          inquantity: 0, 
          revenue_btax: 0,   
          revenue_atax: 0,  
          cost_btax: 0,     
          cost_atax: 0,          
          
          stock_last: 0,                                      
          cost_stock_last_btax: 0,   
          cost_stock_last_atax: 0  
        }    
    
        if(products.length>0){    
          let query:any;          
          if(IDproduct === 'all'){          
            if((IDbranch==='all')||(IDbranch===undefined)){
              //query = {date: {$lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,30,2,3,9,31]}};
              query = {date: {$lte:endtime}, bill_type: {$in:[1,10,15,30,2,3,9,31]}};
            }else{
              query = {date: {$lte:endtime}, bill_type: {$in:[1,10,15,30,2,3,9,31]}, id_branch: {$eq:IDbranch}};
              //query = {date: {$lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,30,2,3,9,31]}, id_branch: {$eq:IDbranch}};
            }
          }else{          
            if((IDbranch==='all')||(IDbranch===undefined)){
              query = {date: {$lte:endtime}, id_product: {$eq:IDproduct}, bill_type: {$in:[1,10,15,30,2,3,9,31]}};
              //query = {date: {$lte:endtime}, ptype: {$eq:3}, id_product: {$eq:IDproduct}, bill_type: {$in:[1,10,15,30,2,3,9,31]}};
            }else{
              query = {date: {$lte:endtime}, id_product: {$eq:IDproduct}, bill_type: {$in:[1,10,15,30,2,3,9,31]}, id_branch: {$eq:IDbranch}};
              //query = {date: {$lte:endtime}, ptype: {$eq:3}, id_product: {$eq:IDproduct}, bill_type: {$in:[1,10,15,30,2,3,9,31]}, id_branch: {$eq:IDbranch}};
            }
          }       
          //nhớ kiểm tra có cần thêm sắp xếp asc ko            
          this.getBill_details_byFields(query, {},{date:1},0)
              .then((bill_details:any)=>{                  
                for(let i=0; i<products.length; i++){
                  let product: any ={
                    _id: products[i]._id,
                    name: products[i].name,
                    type: products[i].type,
                    unit: products[i].unit,
                    img: products[i].img,
                    allow_sell: products[i].allow_sell,
                    barcode: products[i].barcode,
                    price: products[i].price,

                    outquantity: 0,
                    inquantity: 0, 
                    revenue_btax: 0,   
                    revenue_atax: 0,  
                    cost_btax: 0,     
                    cost_atax: 0 
                  }
                  product.stock_last = 0;                                      
                  product.cost_stock_last_btax = 0;   
                  product.cost_stock_last_atax = 0;     
                  
                  product.unit_cost_stock_last_btax = 0;   
                  product.unit_cost_stock_last_atax = 0;  
                  
                  for(let j=0; j<bill_details.length; j++){ 
                    if(bill_details[j].ptype === 3){   
                      if(bill_details[j].id_product === products[i]._id){ 
                        if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)){
                          product.revenue_btax = product.revenue_btax + bill_details[j].price * bill_details[j].quantity; 
                          product.revenue_atax = product.revenue_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                          product.outquantity = product.outquantity + bill_details[j].quantity; 

                          json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity;
                          json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                          json.outquantity = json.outquantity + bill_details[j].quantity;  
                        }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 31)){ 
                          product.cost_btax = product.cost_btax + bill_details[j].price * bill_details[j].quantity; 
                          product.cost_atax = product.cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                          product.inquantity = product.inquantity + bill_details[j].quantity; 

                          json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                          json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                          json.inquantity = json.inquantity + bill_details[j].quantity;   
                        }
                      }
                    }                                                                       
                                                  
                  }


                                                
                  product.stock_last = product.inquantity - product.outquantity;   
                  if(product.inquantity !=0) product.unit_cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals(product.cost_btax/product.inquantity);  
                  if(product.inquantity !=0) product.unit_cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(product.cost_atax/product.inquantity);               
                  product.cost_stock_last_btax = product.unit_cost_stock_last_btax * product.stock_last;  
                  product.cost_stock_last_atax = product.unit_cost_stock_last_atax * product.stock_last; 
                  
                  json.stock_last = json.stock_last + product.stock_last;                  
                  json.cost_stock_last_btax = json.cost_stock_last_btax + product.cost_stock_last_btax;
                  json.cost_stock_last_atax = json.cost_stock_last_atax + product.cost_stock_last_atax;

                  //if((product.inquantity !=0)||(product.outquantity !=0)){
                    product.revenue_atax = this.vhAlgorithm.roundTo3Decimals(product.revenue_atax);     
                    product.cost_atax = this.vhAlgorithm.roundTo3Decimals(product.cost_atax);                     
                    product.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(product.cost_stock_last_atax);  
                    product.unit_cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(product.unit_cost_stock_last_atax);  

                    json.revenue_atax = this.vhAlgorithm.roundTo3Decimals(json.revenue_atax);     
                    json.cost_atax = this.vhAlgorithm.roundTo3Decimals(json.cost_atax);                     
                    json.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(json.cost_stock_last_atax);  

                    json.index = json.size + 1;
                    json.docs.push(product);
                    json.size++;                        
                    json.empty = false;   
                  //}        
                                  
                }
                console.log('getReportInputOutputInventory_byEndTime_byIDProduct_allRecords');
                resolve(json);   
              })                      
        
        }else{
          console.log('server -> products khong ton tai trong CSDL: ');          
          resolve(json);           
        }  
                
    })    
  }

  /**   
   * Hàm này dùng trong page Tồn kho, giá trị tồn kho, doanh số, chi phí nhập hàng tại một thời điểm endtime nào đó
   * @example:
   * this.vhQuerySales.getReportInputOutputInventory_byEndTime_byIDProduct(endtime, IDsub_or_product, IDbranch)
        .then((bill_details:any)=>{
          console.log('bill_details', bill_details);
        })
   * @param starttime 
   * @param endtime 
   * @param IDsub_or_product : 'all' or id_subproduct or id_product 
   * @param IDbranch : 'all' or id_branch
   * @return Promise Array
   * @Notice bill_type = [1,10,15,30,2,3,9,31]
   */
  public getReportInputOutputInventory_byEndTime_byIDProduct(endtime:any, IDsub_or_product:any, IDbranch:string){
    //console.log('endtime', endtime);
    return new Promise<any>((resolve, reject) => {  
        endtime = new Date(endtime);      
        let json:any = {
          docs: new Array(),
          empty: true,
          size:0 
        }         
        let store = this.vhAuth.getStore();  
        let products:any = new Array();   
        if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
        else {
          let product = this.getlocalDetailProduct(IDsub_or_product);            
          products.push(product);
        }

        let cash = 0;
        let index:any = null;
        let day:any = null;   
       //Hàm này kiểm tra các detailproducts (type=3) nào đã thỏa mãn 60days mà chưa có ký sinh inventory trong sản phẩm thì sẽ gọi hàm
      this.checkAndsyncInventoryOfProducts(products, IDbranch)
          .then((check)=>{                              
             //nếu check ==true thì sẽ get lại products mới, vi inventory đã đc reset tính toán lại giá trị mới
              if(check){
                if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
                else {
                  let product = this.getlocalDetailProduct(IDsub_or_product);            
                  products.push(product);
                }
              }
              if(IDbranch==='all'){
                console.log('trường hợp này chưa có hàm, liên hệ anh Huy viết');
                //Để trường hợp IDbranch === 'all' chạy đúng thì phải tổng các giá trị tồn kho của tất cả các chi nhánh lại
                // hoặc là cách tính từng chi nhánh, rồi merge tất cả các chi nhánh lại
                return resolve(json);   
              }else{         
                if(products[0][IDbranch + '_ivtr'] != undefined){
                  for(let k=0; k<products[0][IDbranch + '_ivtr'].length; k++){              
                    if((new Date(products[0][IDbranch + '_ivtr'][k].date)).getTime() > endtime.getTime()){               
                      break;
                    }else{
                      day = new Date(products[0][IDbranch + '_ivtr'][k].date);
                      index = k;                
                    }
                  }                 
                }             
              }   
                
              if(!day) day = new Date(store.registrationdate);           
              if(products.length>0){           
                //nhớ kiểm tra có cần thêm sắp xếp asc ko             
                let query1:any = {};
                let query2:any = {};           
                let promise = new Array();
              
                if(IDsub_or_product === 'all'){
                  if(IDbranch === 'all'){//ở trên cho return rồi
                    query1 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}}; 
                    query2 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}};              
                  }else{
                    //Do có 12 loại bill_type mà firebase chỉ cho query tối đa 10, do đó dùng 2 query1 và query2 
                    query1 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:IDbranch}};             
                    query2 = {date: {$gte:day, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                  }            
                }else{        
                  if(IDbranch === 'all'){//ở trên cho return rồi                     
                    if(products[0].id_subproduct) {
                      query1 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};
                      query2 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};
                    }else{
                      query1 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};
                      query2 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};
                    }
                  }else{                       
                    if(products[0].id_subproduct){
                      query1 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9]}, id_branch: {$eq:IDbranch}};
                      query2 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                    }else{
                      query1 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9]}, id_branch: {$eq:IDbranch}};
                      query2 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                    }
                  }               
                }  
              
                promise[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                promise[1] = this.getBill_details_byFields(query2, {},{date:1},0);
                let query_lastday = {date: {$gte:endtime}, ptype: {$eq:3}};  
                promise[2] = this.getBill_details_byFields(query_lastday, {},{date:1},1);
                Promise.all(promise)
                      .then((array:any)=>{        
                         let bill_details = [...array[0], ...array[1]];// nhớ check xem cái này chạy đúng ko     
                         //Biến array_lastday dùng để xác định sau thời điểm xem báo cáo có phát sinh hóa đơn ko, nếu ko có hóa đơn (array_lastday.length === 0) 
                         // thì sẽ tận dụng dữ liệu đã lấy về ở trên để kiểm tra và tính toán lại quantity và quantity_branch     
                         let array_lastday = array[2];                  
                         for(let i=0; i<products.length; i++){                          
                            let first = {
                              stock_first: 0,
                              cost_stock_first_btax: 0,
                              cost_stock_first_atax: 0                      
                            }
                            let unit = this.getUnit_byRatio(products[i].units, 1);                          
                            let record: any ={
                              id_product: products[i]._id,
                              name: products[i].name,
                              type: products[i].type,
                              img: products[i].img,
                              allow_sell: products[i].allow_sell,                       
                              quantity_branch: products[i].quantity_branch,

                              ratio: unit.ratio,
                              unit: unit.unit,
                              barcode: unit.barcode,                      
                              
                              outquantity: 0,
                              inquantity: 0, 
                              
                              cost_btax: 0,     
                              cost_atax: 0,
                              unit_cost_stock_last_btax: 0,   
                              unit_cost_stock_last_atax: 0,  

                              stock_first: 0,                      
                              cost_stock_first_btax: 0,   
                              cost_stock_first_atax: 0,   

                              stock_last: 0,                          
                              cost_stock_last_btax: 0,   
                              cost_stock_last_atax: 0       
                            }      
                            
                            if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct; 
                            if(products[i].lots) {
                              //record.lots = [...products[i].lots];
                              record.lots = cloneDeep(products[i].lots);
                              for(let m = 0; m<record.lots.length; m++){
                                record.lots[m].outquantity = 0;
                                record.lots[m].inquantity = 0;

                                record.lots[m].cost_btax = 0;
                                record.lots[m].cost_atax = 0;
                                record.lots[m].unit_cost_stock_last_btax = 0;
                                record.lots[m].unit_cost_stock_last_atax = 0;
                                //tồn đầu kỳ
                                record.lots[m].stock_first = 0;
                                record.lots[m].cost_stock_first_btax = 0;
                                record.lots[m].cost_stock_first_atax = 0;
                                //tồn cuối kỳ
                                record.lots[m].stock_last = 0;
                                record.lots[m].cost_stock_last_btax = 0;
                                record.lots[m].cost_stock_last_atax = 0;

                                record.lots[m].first = {};
                                record.lots[m].first.stock_first = 0,
                                record.lots[m].first.cost_stock_first_btax = 0,
                                record.lots[m].first.cost_stock_first_atax = 0
                              }
                            }                                           
                           
                            for(let j=0; j<bill_details.length; j++){ 
                              let is_sub_or_product = false;
                              if(record.id_subproduct) is_sub_or_product = bill_details[j].id_subproduct === record.id_subproduct;
                              else is_sub_or_product = bill_details[j].id_product === record.id_product;                            
                              if(bill_details[j].ptype === 3){  
                                if(is_sub_or_product){  
                                  let date = new Date(bill_details[j].date);   
                                  if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                                    if(record.lots){
                                      for(let m=0; m<record.lots.length; m++){
                                        if(record.lots[m]._id === bill_details[j].id_lotproduct){     
                                          record.lots[m].outquantity = record.lots[m].outquantity + bill_details[j].quantity * bill_details[j].ratio;     
                                        }
                                      }
                                    }
                                    record.outquantity = record.outquantity + bill_details[j].quantity * bill_details[j].ratio;                             

                                  }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){    
                                    if(record.lots){
                                      for(let m=0; m<record.lots.length; m++){
                                        if(record.lots[m]._id === bill_details[j].id_lotproduct){     
                                          record.lots[m].cost_btax = record.lots[m].cost_btax + bill_details[j].price * bill_details[j].quantity;
                                          record.lots[m].cost_atax = record.lots[m].cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                          record.lots[m].inquantity = record.lots[m].inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                                        }
                                      }
                                    }                         
                                    record.cost_btax = record.cost_btax + bill_details[j].price * bill_details[j].quantity;
                                    record.cost_atax = record.cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                    record.inquantity = record.inquantity + bill_details[j].quantity * bill_details[j].ratio; 

                                  }else if(bill_details[j].bill_type === 9){//bill_type_9 là tồn đầu kỳ, ko xem nó là hàng nhập như báo cáo trước đây
                                    if(record.lots){
                                      for(let m=0; m<record.lots.length; m++){
                                        if(record.lots[m]._id === bill_details[j].id_lotproduct){     
                                          record.lots[m].first.stock_first = record.lots[m].first.stock_first + bill_details[j].quantity * bill_details[j].ratio;
                                          record.lots[m].first.cost_stock_first_btax = record.lots[m].first.cost_stock_first_btax + bill_details[j].price * bill_details[j].quantity;
                                          record.lots[m].first.cost_stock_first_atax = record.lots[m].first.cost_stock_first_atax +  bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);      
                                        }
                                      }
                                    }
                                    first.stock_first = first.stock_first + bill_details[j].quantity * bill_details[j].ratio;
                                    first.cost_stock_first_btax = first.cost_stock_first_btax + bill_details[j].price * bill_details[j].quantity;
                                    first.cost_stock_first_atax = first.cost_stock_first_atax +  bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);   
                                  }                                                        
                                } 
                              }                                    
                            }                                               
                            if(record.lots){
                              for(let m=0; m<record.lots.length; m++){                       
                                //Đầu kỳ                                                
                                if(index !=null) record.lots[m].first = {...products[i][IDbranch + '_ivtr'][index].lots[m]};                                   
                                record.lots[m].stock_first = record.lots[m].first.stock_first;//ok    
                                record.lots[m].cost_stock_first_btax = record.lots[m].first.cost_stock_first_btax;
                                record.lots[m].cost_stock_first_atax = record.lots[m].first.cost_stock_first_atax;                         
                              
                                //Đơn giá
                                if((record.lots[m].stock_first + record.lots[m].inquantity) !=0){
                                  record.lots[m].unit_cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals((record.lots[m].cost_stock_first_btax + record.lots[m].cost_btax)/(record.lots[m].stock_first + record.lots[m].inquantity)); 
                                  record.lots[m].unit_cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals((record.lots[m].cost_stock_first_atax + record.lots[m].cost_atax)/(record.lots[m].stock_first + record.lots[m].inquantity)); 
                                }

                                //Cuối kỳ
                                record.lots[m].stock_last = record.lots[m].stock_first + record.lots[m].inquantity - record.lots[m].outquantity;//ok   
                                record.lots[m].cost_stock_last_btax = record.lots[m].unit_cost_stock_last_btax * record.lots[m].stock_last;  
                                record.lots[m].cost_stock_last_atax = record.lots[m].unit_cost_stock_last_atax * record.lots[m].stock_last;                         
                              }
                            }
                            
                           //Đầu kỳ                    
                           if(index !=null) first = {...products[i][IDbranch + '_ivtr'][index]};                                                             
                           record.stock_first = first.stock_first;//ok    
                           record.cost_stock_first_btax = first.cost_stock_first_btax;
                           record.cost_stock_first_atax = first.cost_stock_first_atax;                                                     
                           //Đơn giá
                           if((record.stock_first + record.inquantity) !=0){
                             record.unit_cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals((record.cost_stock_first_btax + record.cost_btax)/(record.stock_first + record.inquantity)); 
                             record.unit_cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals((record.cost_stock_first_atax + record.cost_atax)/(record.stock_first + record.inquantity)); 
                           }                            
                           //Cuối kỳ
                           record.stock_last = record.stock_first + record.inquantity - record.outquantity;//ok   
                           record.cost_stock_last_btax = record.unit_cost_stock_last_btax * record.stock_last;  
                           record.cost_stock_last_atax = record.unit_cost_stock_last_atax * record.stock_last;                                        
                           //if((record.stock_first !=0)||(record.stock_last !=0)||(record.inquantity !=0)||(record.outquantity !=0)){                      
                           record.cost_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_atax);    
                           record.cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_stock_first_atax);     
                           record.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_stock_last_atax);   

                           record.index = json.size + 1;
                           json.docs.push(record);
                           json.size++;                        
                           json.empty = false;   
                           
                           
                           //Phần dưới này sẽ so sánh nếu sản phẩm tồn kho tính được khác với tồn kho trên sản phẩm thì cập nhật lại tồn kho sản phẩm = tồn kho tính được
                           if(array_lastday.length === 0){//nếu (array_lastday.length === 0) => lastday là thời điểm hiện tại
                              let wrong_quantity = false;
                              let value:any = {};                               
                              if(products[i].quantity_branch != undefined){
                                if(products[i].quantity_branch[IDbranch] != undefined){
                                  value = {
                                    quantity_branch: {...products[i].quantity_branch},
                                    quantity: products[i].quantity
                                  };                                                       
                                }else{
                                  value = {
                                    quantity_branch: {...products[i].quantity_branch},
                                    quantity: 0                              
                                  };
                                  value.quantity_branch[IDbranch] = 0;                          
                                  for(const p in value.quantity_branch){
                                    value.quantity = value.quantity + value.quantity_branch[p];
                                  } 
                                  wrong_quantity = true;                                   
                                }
                              }else{
                                value = {
                                  quantity_branch: {},
                                  quantity: 0                              
                                };                          
                                value.quantity_branch[IDbranch] = 0;      
                                wrong_quantity = true;                                                               
                              }

                              if(value.quantity_branch[IDbranch] != record.stock_last){                         
                                value.quantity_branch[IDbranch] = record.stock_last;
                                value.quantity = 0;
                                for(const p in value.quantity_branch){
                                  value.quantity = value.quantity + value.quantity_branch[p];
                                }                                                   
                                wrong_quantity = true;       
                              }else{
                                let quantity = 0;
                                for(const p in value.quantity_branch){
                                  quantity = quantity + value.quantity_branch[p];
                                }  
                                if(value.quantity != quantity){
                                  value.quantity = quantity;
                                  wrong_quantity = true; 
                                }                                 
                              }

                             if(products[i].lots){                             
                               value.lots = cloneDeep(products[i].lots);
                               for(let k=0; k<value.lots.length; k++){
                                 if(value.lots[k].quantity_branch == undefined){
                                   value.lots[k].quantity_branch = {};
                                   value.lots[k].quantity_branch[IDbranch] = 0;
                                   value.lots[k].quantity = 0;
                                   wrong_quantity = true;
                                 }
                                 if(value.lots[k].quantity_branch[IDbranch] != record.lots[k].stock_last){                                
                                   value.lots[k].quantity_branch[IDbranch] = record.lots[k].stock_last;
                                   value.lots[k].quantity = 0;
                                   for(const p in value.lots[k].quantity_branch){
                                     value.lots[k].quantity = value.lots[k].quantity + value.lots[k].quantity_branch[p];
                                   } 
                                   wrong_quantity = true;                             
                                 }else{
                                   let quantity = 0;
                                   for(const p in value.lots[k].quantity_branch){
                                     quantity = quantity + value.lots[k].quantity_branch[p];
                                   }   
                                   if(value.lots[k].quantity != quantity){
                                     value.lots[k].quantity = quantity;
                                     wrong_quantity = true; 
                                   }
                                 }                            
                               }
                             }            
                             //Nếu số lượng trường quantity, quantity_branch sai với thực tế, sẽ được tính toán và cập nhật lại            
                             if(wrong_quantity){                                                      
                               this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, value);       
                             } 
                           }                                  
                        }                  
                        resolve(json);                             
                        console.log('getReportInputOutputInventory_byEndTime_byIDProduct', json);
                      })                      
              
              }else{
                console.log('server -> products khong ton tai trong CSDL: ');
                resolve(json);           
              }  
               
          })           
    })    
  }

  /**
   * Hàm này kiểm tra các detailproducts (type=3) nào đã thỏa mãn 60days mà chưa có ký sinh inventory trong sản phẩm thì sẽ gọi hàm
   * syncInventoryEveryDay_Stock1stDayOfMonth để tính lại
   * @example:
   * this.vhQuerySales.checkAndsyncInventoryOfProducts(endtime, 'all')
        .then(()=>{
          
        })
   */
  private checkAndsyncInventoryOfProducts(detailproducts:any, IDbranch:string){
    return new Promise<any>((resolve, reject) => {  
      if(IDbranch!='all'){
        let counts = 0;
        for(let i=0; i<detailproducts.length; i++){
          if(detailproducts[i][IDbranch + '_ivtr'] == undefined){
            counts++;
          }
        }
        if((counts >0)&&(counts <detailproducts.length)){
          this.syncInventoryEveryDay_Stock1stDayOfMonth()
              .then(()=>{            
                  resolve(true);                  
              })   
        }else{
          resolve(false);   
        }
      }else{
        resolve(false); 
      }
    })
  }
  

    /**   
    * Hàm này dùng trong page Tồn kho, giá trị tồn kho, doanh số, chi phí nhập hàng tại một thời điểm endtime nào đó -> chi tiết của một sản phẩm nào đó
    * Lấy về chi tiết xuất nhập của 1 sản phẩm nào đó trong từ 0h ngày 1 đến thời điểm endtime
    * @example:
    * this.vhQuerySales.getReportInputOutputInventory_Detail_byEndTime_byIDProduct(endtime, 'UTWXdaU3UDq3xq7aK77p')
        .then((bill_details:any)=>{
          console.log('bill_details', bill_details);
        })
    * @param starttime 
    * @param endtime 
    * @param id_sub_or_product 
    * @param IDbranch : 'all' or id_branch
    * @Notice bill_type = [1,10,15,30,38,41,51,2,3,9,31,39]
    */
  public getReportInputOutputInventory_Detail_byEndTime_byIDProduct(endtime:any, id_sub_or_product:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {  
      endtime = new Date(endtime);
      let starttime = new Date(endtime);    
      starttime.setDate(1);
      starttime.setHours(0);
      starttime.setMinutes(0);
      starttime.setSeconds(0); 
      let product = this.getlocalDetailProduct(id_sub_or_product);  
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        outquantity: 0,
        inquantity: 0, 
        revenue_btax: 0,   
        revenue_atax: 0,  
        cost_btax: 0,     
        cost_atax: 0 
      }       
      let query1:any ={};     
      let query2:any ={};        
      let promise = new Array();     
      if((IDbranch==='all')||(IDbranch===undefined)){
        if(product.id_subproduct){
          query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};
          query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}};
        }else{
          query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};
          query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}};
        } 
      }else{
        if(product.id_subproduct){
          query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:IDbranch}};
          query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
        }else{
          query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:IDbranch}};
          query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
        }        
      } 
      //console.log('------product', product);
      //console.log('query1', query1);
      //console.log('query2', query2);
      promise[0] = this.getBill_details_byFields(query1, {},{date:1},0)
      promise[1] = this.getBill_details_byFields(query2, {},{date:1},0)
      Promise.all(promise).then((array:any)=>{
              let bill_details = array.flat();                                   
              for(let j=0; j<bill_details.length; j++){   
                let bill_detail:any ={
                  id_bill: bill_details[j]?.id_bill,
                  bill_code: bill_details[j]?.bill_code,
                  bill_type: bill_details[j]?.bill_type,
                  date: bill_details[j]?.date,
                  tax: bill_details[j]?.tax,
                  name: product.name,
                  unit: product.unit                  
                }
                if(bill_details[j]?.id_cashier) bill_detail.id_cashier = bill_details[j]?.id_cashier;
                if(bill_details[j]?.id_employee) bill_detail.id_employee = bill_details[j]?.id_employee;
                if(bill_details[j]?.id_customer) bill_detail.id_customer = bill_details[j]?.id_customer;
                if(bill_details[j]?.id_supplier) bill_detail.id_supplier = bill_details[j]?.id_supplier;

                if(bill_details[j].ptype === 3){ 
                    bill_detail.price_btax = bill_details[j].price;
                    bill_detail.price_atax = bill_details[j].price * (1 + bill_details[j].tax/100);
                    bill_detail.payment_btax = bill_details[j].price * bill_details[j].quantity;
                    bill_detail.payment_atax = this.vhAlgorithm.roundTo3Decimals(bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                    bill_detail.quantity = bill_details[j]?.quantity * bill_details[j].ratio;                 
                    if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                      bill_detail.type = 'output';
                      json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity;
                      json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                      json.outquantity = json.outquantity + bill_details[j].quantity * bill_details[j].ratio;
                    }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){ 
                      bill_detail.type = 'input';
                      json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                      json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                      json.inquantity = json.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                    }else if(bill_details[j].bill_type === 9){ 
                      bill_detail.type = 'beginning';
                      json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                      json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                      json.inquantity = json.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                    }                                                                   
                }           
                bill_detail.price_atax = this.vhAlgorithm.roundTo3Decimals(bill_detail.price_atax);     
                bill_detail.payment_atax = this.vhAlgorithm.roundTo3Decimals(bill_detail.payment_atax);                   
                json.docs.push(bill_detail);
                json.size++;                        
                json.empty = false; 
              } 
              console.log('getReportInputOutputInventory_Detail_byEndTime_byIDProduct');        
              resolve(json);

          })
    })
  }

  /**   
    * Hàm này dùng trong page XUẤT-NHẬP-TỒN -> Xuất nhập tồn -> chi tiết
    * @example:
    * this.vhQuerySales.getReportInputOutputInventory_Detail_byTime_byIDProduct(starttime , endtime, 'UTWXdaU3UDq3xq7aK77p')
        .then((bill_details:any)=>{
          console.log('bill_details', bill_details);
        })
    * @param starttime 
    * @param endtime 
    * @param id_sub_or_product 
    * @param IDbranch 
    * @Notice bill_type = [1,10,15,30,38,41,51,2,3,9,31,39]
    */
  public getReportInputOutputInventory_Detail_byTime_byIDProduct(starttime:any, endtime:any, id_sub_or_product:string, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {  
      let product = this.getlocalDetailProduct(id_sub_or_product);        
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        outquantity: 0,
        inquantity: 0, 
        revenue_btax: 0,   
        revenue_atax: 0,  
        cost_btax: 0,     
        cost_atax: 0 
      }    
      let query1:any = {};
      let query2:any = {};           
      let promise = new Array();     
      let IDproducts = new Array();       
      if((IDbranch === 'all')||(IDbranch === undefined)){
        if(product.id_subproduct){
           query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};
           query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}};
        }else{                     
           query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};
           query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}};
        }
      }else{
        if(product.id_subproduct){
          query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:IDbranch}};
          query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
        }else{
          query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:IDbranch}};
          query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
        }
      }
      promise[promise.length] = this.getBill_details_byFields(query1, {},{date:1},0);
      promise[promise.length] = this.getBill_details_byFields(query2, {},{date:1},0);
      Promise.all(promise)
          .then((array:any)=>{   
            let bill_details = array.flat();                               
            for(let j=0; j<bill_details.length; j++){   
              let unit = this.getUnit_byRatio(product.units, 3);  
              let record:any ={
                id_bill: bill_details[j]?.id_bill,
                bill_code: bill_details[j]?.bill_code,
                bill_type: bill_details[j]?.bill_type,
                date: bill_details[j]?.date,
                
                id_product: product._id,                  
                name: product.name, 
                img: product.img,                
             
                ratio: unit.ratio,
                unit: unit.unit,
                barcode: unit.barcode,                    
              }
              if(bill_details[j].id_subproduct) record.id_subproduct = bill_details[j].id_subproduct;                      
              if(bill_details[j].id_lotproduct){
                record.id_lotproduct = bill_details[j].id_lotproduct; 
                record.lots = new Array;
                for(let m = 0; m<product.lots.length; m++){
                  if(product.lots[m]._id === record.id_lotproduct) {
                    record.lots.push(product.lots[m]);
                    break;
                  }
                }
              }    
              
              if(bill_details[j]?.id_cashier) record.id_cashier = bill_details[j]?.id_cashier;
              if(bill_details[j]?.id_employee) record.id_employee = bill_details[j]?.id_employee;
              if(bill_details[j]?.id_customer) record.id_customer = bill_details[j]?.id_customer;
              if(bill_details[j]?.id_supplier) record.id_supplier = bill_details[j]?.id_supplier;

              if(bill_details[j].ptype === 3){
                record.price_btax = bill_details[j]?.price;
                record.price_atax = bill_details[j]?.price * (1 + bill_details[j].tax/100);
                record.payment_btax = bill_details[j]?.price * bill_details[j]?.quantity;
                record.payment_atax = this.vhAlgorithm.roundTo3Decimals(bill_details[j]?.price * bill_details[j]?.quantity * (1 + bill_details[j].tax/100));
                record.quantity = bill_details[j]?.quantity * bill_details[j].ratio;

                if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                  record.type = 'output';
                  json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity;
                  json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                  json.outquantity = json.outquantity + bill_details[j].quantity * bill_details[j].ratio;
                }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){ 
                  record.type = 'input';
                  json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                  json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                  json.inquantity = json.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                }else if(bill_details[j].bill_type === 9){ 
                  record.type = 'beginning';
                  json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                  json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                  json.inquantity = json.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                }                                                                   
              }    
              record.price_atax = this.vhAlgorithm.roundTo3Decimals(record.price_atax);     
              record.payment_atax = this.vhAlgorithm.roundTo3Decimals(record.payment_atax);                                     
              json.docs.push(record);
              json.size++;                        
              json.empty = false; 
            }    
            console.log('getReportInputOutputInventory_Detail_byTime_byIDProduct', json);    
            resolve(json);
      })
    })
  }

  /**   
    * Hàm này dùng trong page XUẤT-NHẬP-TỒN -> Xuất nhập hàng
    * @example:
    * this.vhQuerySales.getReportInputOutput_byTime_byIDProduct(starttime , endtime, 'UTWXdaU3UDq3xq7aK77p')
        .then((bill_details:any)=>{
          console.log('bill_details', bill_details);
        })
    * @param starttime 
    * @param endtime 
    * @param IDsub_or_product : 'all' or id_subproduct or id_product;  
    * @param IDbranch 
    * @return Promise Array
    * @Notice id_product = 'all' or id_product;
    * @Notice IDbranch = 'all' or id_branch;
    * @Notice bill_type = [1,10,15,38,41,51,2,3,39] //xem có đưa 9 vào ko
    */
  public getReportInputOutput_byTime_byIDProduct(starttime:any, endtime:any, IDsub_or_product:string, IDbranch?:string){
    //Cách tính mới, bill_type_9 là tồn đầu kỳ chứ ko xem là nhập, nên trong báo cáo này ko đưa vào
    return new Promise<any>((resolve, reject) => {  
      let products:any = new Array();   
      if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
      else {
        let product = this.getlocalDetailProduct(IDsub_or_product);           
        products.push(product);
      }
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        outquantity: 0,
        inquantity: 0, 
        revenue_btax: 0,   
        revenue_atax: 0,  
        cost_btax: 0,     
        cost_atax: 0 
      }                    
      if(products.length>0){    
        let query1:any = {};   
        let query2:any = {};       
        let promise = new Array();  
        if((IDsub_or_product === 'all')){
          if((IDbranch === 'all')||(IDbranch === undefined)){
            query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,39,41,51,2,3]}}; //bill_type_9 không phải là phiếu nhập 
            query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}}; //bill_type_9 không phải là phiếu nhập               
          }else{
            query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,39,41,51,2,3]}, id_branch: {$eq:IDbranch}};//bill_type_9 không phải là phiếu nhập  
            query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};//bill_type_9 không phải là phiếu nhập                   
          }
        }else{
          if((IDbranch === 'all')||(IDbranch === undefined)){              
            if(products[0].id_subproduct){ 
              query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,39,41,51,2,3]}};//ko có bill_type_9  
              query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};//ko có bill_type_9  
            }else{                          
              query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,39,41,51,2,3]}};//ko có bill_type_9  
              query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};//ko có bill_type_9  
            }
          }else{
            if(products[0].id_subproduct){ 
              query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,39,41,51,2,3]}, id_branch: {$eq:IDbranch}};//ko có bill_type_9  
              query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};//ko có bill_type_9      
            }else{
              query1 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,39,41,51,2,3]}, id_branch: {$eq:IDbranch}};//ko có bill_type_9      
              query2 = {date: {$gte:starttime, $lte:endtime}, ptype: {$eq:3}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};//ko có bill_type_9       
            } 
          }
        } 
        promise[0] = this.getBill_details_byFields(query1, {},{date:1},0)
        promise[1] = this.getBill_details_byFields(query2, {},{date:1},0)
        Promise.all(promise)
              .then((array:any)=>{            
                  let bill_details = array.flat();                                         
                  for(let i=0; i<products.length; i++){
                    let unit = this.getUnit_byRatio(products[i].units,1);
                    let record: any ={
                      id_product: products[i]._id,
                      name: products[i].name,
                      img: products[i].img,
                      type: products[i].type,

                      ratio: unit.ratio,
                      unit: unit.unit,
                      barcode: unit.barcode,
                    
                      outquantity: 0,
                      inquantity: 0, 
                      revenue_btax: 0,   
                      revenue_atax: 0,  
                      cost_btax: 0,     
                      cost_atax: 0 
                    }
                    if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;  
                    if(products[i].lots) {
                      record.lots = cloneDeep(products[i].lots);
                      for(let m = 0; m<record.lots.length; m++){                
                        record.lots[m].outquantity = 0;
                        record.lots[m].inquantity = 0;
                        record.lots[m].revenue_btax = 0;
                        record.lots[m].revenue_atax = 0;
                        record.lots[m].cost_btax = 0;
                        record.lots[m].cost_atax = 0;       
                      }
                    }  

                    for(let j=0; j<bill_details.length; j++){        
                        let is_sub_or_product = false;
                        if(record.id_subproduct) is_sub_or_product = bill_details[j].id_subproduct === record.id_subproduct;
                        else is_sub_or_product = bill_details[j].id_product === record.id_product;             
                        if(bill_details[j].ptype === 3){
                          if(is_sub_or_product){ 
                            if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                              if(record.lots){
                                for(let m=0; m<record.lots.length; m++){
                                  if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                    record.lots[m].revenue_btax = record.lots[m].revenue_btax + bill_details[j].price * bill_details[j].quantity;  
                                    record.lots[m].revenue_atax = record.lots[m].revenue_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                    record.lots[m].outquantity = record.lots[m].outquantity + bill_details[j].quantity * bill_details[j].ratio; 
                                  }
                                }   
                              }  
                              record.revenue_btax = record.revenue_btax + bill_details[j].price * bill_details[j].quantity; 
                              record.revenue_atax = record.revenue_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                              record.outquantity = record.outquantity + bill_details[j].quantity * bill_details[j].ratio; 

                              json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity; 
                              json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                              json.outquantity = json.outquantity + bill_details[j].quantity * bill_details[j].ratio;     
                            }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){ 
                              if(record.lots){
                                for(let m=0; m<record.lots.length; m++){
                                  if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                                    record.lots[m].cost_btax = record.lots[m].cost_btax + bill_details[j].price * bill_details[j].quantity; 
                                    record.lots[m].cost_atax = record.lots[m].cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                    record.lots[m].inquantity = record.lots[m].inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                                  }
                                }   
                              }  
                              record.cost_btax = record.cost_btax + bill_details[j].price * bill_details[j].quantity;  
                              record.cost_atax = record.cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                              record.inquantity = record.inquantity + bill_details[j].quantity * bill_details[j].ratio; 

                              json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity; 
                              json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                              json.inquantity = json.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                            }  
                          }  
                        }                                         
                    }
                    if((record.inquantity !=0)||(record.outquantity !=0)){
                      record.revenue_atax = this.vhAlgorithm.roundTo3Decimals(record.revenue_atax);     
                      record.cost_atax = this.vhAlgorithm.roundTo3Decimals(record.cost_atax);     
                      record.index = json.size + 1;
                      json.docs.push(record);
                      json.size++;                        
                      json.empty = false;   
                    }                                          
                  }
                  console.log('getReportInputOutput_byTime_byIDProduct', json);
                  resolve(json);   
        })    
      }else{
        console.log('server -> products khong ton tai trong CSDL: ');
        resolve(json);           
      }                  
    })    
  } 

  /**   
    * Hàm này dùng trong page XUẤT-NHẬP-TỒN -> Xuất nhập hàng -> chi tiết
    * @example:
    * this.vhQuerySales.getReportInputOutput_Detail_byTime_byIDProduct(starttime , endtime, 'UTWXdaU3UDq3xq7aK77p')
        .then((bill_details:any)=>{
          console.log('bill_details', bill_details);
        })
    * @param starttime 
    * @param endtime 
    * @param id_sub_or_product: id_subproduct or id_product 
    * @param IDbranch: 'all' or id_branch;
    * @Notice bill_type = [1,10,15,38,41,51,2,3,9,39]
    */
  public getReportInputOutput_Detail_byTime_byIDProduct(starttime:any, endtime:any, id_sub_or_product:string, IDbranch?:string){
    //Cách tính mới, bill_type_9 là tồn đầu kỳ chứ ko xem là nhập, nên trong báo cáo này ko đưa vào
    return new Promise<any>((resolve, reject) => {  
      let product = this.getlocalDetailProduct(id_sub_or_product);  
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,
        outquantity: 0,
        inquantity: 0, 
        revenue_btax: 0,   
        revenue_atax: 0,  
        cost_btax: 0,     
        cost_atax: 0 
      }  
      let query1:any = {};
      let query2:any = {};           
      let promise = new Array();      
        if((IDbranch === 'all')||(IDbranch === undefined)){
          if(product.id_subproduct){ 
            query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,39]}};//không dùng bill_type_9
            query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}};//không dùng bill_type_9
          }else{                      
            query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,39]}};//không dùng bill_type_9
            query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}};//không dùng bill_type_9
          }
        }else{
          if(product.id_subproduct){ 
            query1 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,39]}, id_branch: {$eq:IDbranch}};//không dùng bill_type_9
            query2 = {date: {$gte:starttime, $lte:endtime}, id_subproduct: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};//không dùng bill_type_9
          }else{
            query1 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,39]}, id_branch: {$eq:IDbranch}};//không dùng bill_type_9
            query2 = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_sub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};//không dùng bill_type_9
          }
        }
        
        promise[promise.length] = this.getBill_details_byFields(query1, {},{date:1},0)
        promise[promise.length] = this.getBill_details_byFields(query2, {},{date:1},0)
        Promise.all(promise)
             .then((array:any)=>{                    
                let bill_details = array.flat();                    
                for(let j=0; j<bill_details.length; j++){  
                  let unit = this.getUnit_byRatio(product.units,3); 
                  let record:any ={
                    id_bill: bill_details[j]?.id_bill,
                    bill_code: bill_details[j]?.bill_code,
                    bill_type: bill_details[j]?.bill_type,
                    date: bill_details[j]?.date,
                    // price_btax: bill_details[j]?.price,
                    // price_atax: bill_details[j]?.price * (1 + bill_details[j].tax/100),
                    // payment_btax: bill_details[j]?.price * bill_details[j]?.quantity,
                    // payment_atax: bill_details[j]?.price * bill_details[j]?.quantity * (1 + bill_details[j].tax/100),
                    // quantity: bill_details[j]?.quantity,
                  
                    id_product: product._id,
                    name: product.name,
                    img: product.img,
                    type: product.type,    
                    
                    ratio: unit.ratio,
                    unit: unit.unit,
                    barcode: unit.barcode,
                  }
                  if(bill_details[j].id_subproduct) record.id_subproduct = bill_details[j].id_subproduct;  
                  if(bill_details[j].id_lotproduct){
                    record.id_lotproduct = bill_details[j].id_lotproduct; 
                    record.lots = new Array;
                    for(let m = 0; m<product.lots.length; m++){
                      if(product.lots[m]._id === record.id_lotproduct) {
                        record.lots.push(product.lots[m]);
                        break;
                      }
                    }
                  }    
                  
                  if(bill_details[j]?.id_cashier) record.id_cashier = bill_details[j]?.id_cashier;
                  if(bill_details[j]?.id_employee) record.id_employee = bill_details[j]?.id_employee;
                  if(bill_details[j]?.id_customer) record.id_customer = bill_details[j]?.id_customer;
                  if(bill_details[j]?.id_supplier) record.id_supplier = bill_details[j]?.id_supplier;

                  if(bill_details[j].ptype === 3){
                    if(record.lots){
                      for(let m=0; m<record.lots.length; m++){
                        if(record.lots[m]._id === bill_details[j].id_lotproduct){                          
                          record.lots[m].price_btax = bill_details[j]?.price;
                          record.lots[m].price_atax = bill_details[j]?.price * (1 + bill_details[j].tax/100);
                          record.lots[m].payment_btax = bill_details[j]?.price * bill_details[j]?.quantity;
                          record.lots[m].payment_atax = this.vhAlgorithm.roundTo3Decimals(bill_details[j]?.price * bill_details[j]?.quantity * (1 + bill_details[j].tax/100));
                          record.lots[m].quantity = bill_details[j]?.quantity * bill_details[j]?.ratio; 
                        }
                      }   
                    }  
                    record.price_btax = bill_details[j]?.price;
                    record.price_atax = bill_details[j]?.price * (1 + bill_details[j].tax/100);
                    record.payment_btax = bill_details[j]?.price * bill_details[j]?.quantity;
                    record.payment_atax = this.vhAlgorithm.roundTo3Decimals(bill_details[j]?.price * bill_details[j]?.quantity * (1 + bill_details[j].tax/100));
                    record.quantity = bill_details[j]?.quantity * bill_details[j].ratio;
                    if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                      record.type = 'output';
                      json.revenue_btax = json.revenue_btax + bill_details[j].price  * bill_details[j].quantity;
                      json.revenue_atax = json.revenue_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                      json.outquantity = json.outquantity + bill_details[j].quantity * bill_details[j].ratio;
                    }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){ 
                      record.type = 'input';
                      json.cost_btax = json.cost_btax + bill_details[j].price  * bill_details[j].quantity;
                      json.cost_atax = json.cost_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                      json.inquantity = json.inquantity + bill_details[j].quantity * bill_details[j].ratio; 
                    } 
                  }            
                  record.price_atax = this.vhAlgorithm.roundTo3Decimals(record.price_atax);     
                  record.payment_atax = this.vhAlgorithm.roundTo3Decimals(record.payment_atax);                         
                  json.docs.push(record);
                  json.size++;                        
                  json.empty = false; 
                }         
                console.log('getReportInputOutput_Detail_byTime_byIDProduct', json);
                resolve(json);
          })
    })
  }

  /**  
   * Hàm này dùng trong page LỢI NHUẬN HÀNG HÓA
   * @example:
   * this.vhQuerySales.getReportProfit_byTime_byIDProduct(starttime , endtime, 'all',  'tj1iYodbVoShwtEetACx')
        .then((json)=>{
          console.log('json', json);
        })
   * @param starttime 
   * @param endtime 
   * @param IDsub_or_product: 'all' or id_subproduct or id_product;  
   * @param IDbranch: 'all' or id_branch; 
   * @return Promise Array   * 
   * @Notice bill_type = [1,10,15,30,38,41,51,2,3,9,31,39]
   */
  public getReportProfit_byTime_byIDProduct(starttime:any, endtime:any, IDsub_or_product:any, IDbranch:any){
    return new Promise<any>((resolve, reject) => {  
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0,

        outquantity_sales: 0, //Số lượng trong kỳ tất cả hàng hóa đã bán (đã trừ hàng khách trả lại)           
        sales_btax: 0, //Doanh số trong kỳ tất cả hàng hóa đã bán (đã trừ hàng khách trả lại)   
        sales_atax: 0,  
        
        profit_sales_btax: 0, //lợi nhuận trong kỳ của doanh số tất cả hàng đã bán (đã trừ hàng khách trả lại)    
        profit_sales_atax: 0,
        cost_outstock_sales_btax: 0, //giá vốn tất cả hàng hóa bán ra (đã trừ hàng khách trả lại)        
        cost_outstock_sales_atax: 0,
        return_on_sales_btax: 0, //tỷ xuất lợi nhuận trên doanh số tổng (đã trừ hàng khách trả lại)    
        return_on_sales_atax: 0

      }    
      let store = this.vhAuth.getStore();  
      let products:any = new Array();   
      if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
      else {
        let product = this.getlocalDetailProduct(IDsub_or_product);            
        products.push(product);
      }
          //console.log('products', products);   
      //let query:any;
      let cash = 0;
      let index:any = null;
      let day:any = null;            
    
      this.checkAndsyncInventoryOfProducts(products, IDbranch)
          .then((check)=>{                  
              if(check){
                if(IDsub_or_product === 'all') products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
                else {
                  let product = this.getlocalDetailProduct(IDsub_or_product);            
                  products.push(product);
                }
              }
              if((IDbranch==='all')||(IDbranch===undefined)){//ok
                console.log('trường hợp này chưa có hàm, liên hệ anh Huy viết');
                return resolve(json);      
              }else{//ok         
                if(products[0][IDbranch + '_ivtr'] != undefined){
                  for(let k=0; k<products[0][IDbranch + '_ivtr'].length; k++){
                    if((new Date(products[0][IDbranch + '_ivtr'][k].date)).getTime() > starttime.getTime()){
                      break;
                    }else{
                      day = new Date(products[0][IDbranch + '_ivtr'][k].date);
                      index = k;                
                    }
                  }                 
                }     
                // if(day){
                //   let check = false;
                //   for(let i=0; i<products.length; i++){
                //     if((products[i][IDbranch] != undefined)&&(products[i][IDbranch + '_ivtr'] != undefined)){
                //     }else{                
                //       check = true;
                //     }
                //   }            
                //   if(check) {
                //     console.log('Vui lòng đồng bộ kho để lấy về dữ liệu mới nhất4');
                //     return resolve(json);
                //   }
                // }           
              }    
              if(!day) day = new Date(store.registrationdate);                     
              if(products.length>0){           
                //nhớ kiểm tra có cần thêm sắp xếp asc ko  
                let query1:any = {};
                let query2:any = {};           
                let promise = new Array();   
                if(IDsub_or_product === 'all'){
                  if((IDbranch === 'all')||(IDbranch === undefined)){
                    query1 = {date: {$gte:day, $lte:endtime}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};    
                    query2 = {date: {$gte:day, $lte:endtime}, bill_type: {$in:[30,31]}};              
                  }else{
                    query1 = {date: {$gte:day, $lte:endtime}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:IDbranch}};
                    query2 = {date: {$gte:day, $lte:endtime}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                  }            
                }else{           
                  if((IDbranch === 'all')||(IDbranch === undefined)){              
                    if(products[0].id_subproduct){
                      query1 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};
                      query2 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};
                    }else{                          
                      query1 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}};
                      query2 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}};
                    } 
                  }else{              
                    if(products[0].id_subproduct){
                      query1 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:IDbranch}};
                      query2 = {date: {$gte:day, $lte:endtime}, id_subproduct: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                    }else{
                      query1 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:IDbranch}};
                      query2 = {date: {$gte:day, $lte:endtime}, id_product: {$eq:IDsub_or_product}, bill_type: {$in:[30,31]}, id_branch: {$eq:IDbranch}};
                    }
                  }                   
                }
                promise[0] = this.getBill_details_byFields(query1, {},{date:1},0)
                promise[1] = this.getBill_details_byFields(query2, {},{date:1},0)
                Promise.all(promise)
                    .then((array:any)=>{            
                      let bill_details = array.flat();  
                        for(let i=0; i<products.length; i++){
                          //if((products[i][IDbranch] != undefined)&&(products[i][IDbranch + '_ivtr'] != undefined)){
                            let first = {
                              stock_first: 0,
                              cost_stock_first_btax: 0,
                              cost_stock_first_atax: 0                      
                            }
                            let unit = this.getUnit_byRatio(products[i].units,1); 
                            let record: any ={
                              //_id: products[i]._id,
                              id_product: products[i]._id,
                              name: products[i].name,
                              type: products[i].type,
                              img: products[i].img,   
                              
                              ratio: unit.ratio,
                              unit: unit.unit,
                              barcode: unit.barcode,

                              outquantity_sales: 0, //Số lượng trong kỳ hàng đã bán (đã trừ hàng khách trả lại)   
                              sales_btax: 0, //Doanh số trong kỳ hàng đã bán (đã trừ hàng khách trả lại)   
                              sales_atax: 0,  
                              profit_sales_btax: 0, // lợi nhuận trong kỳ của doanh số hàng đã bán (đã trừ hàng khách trả lại)    
                              profit_sales_atax: 0, 
                              cost_outstock_sales_btax: 0, //giá vốn hàng hóa bán ra (đã trừ hàng khách trả lại)       
                              cost_outstock_sales_atax: 0, 
                              return_on_sales_btax: 0, //tỷ xuất lợi nhuận trên doanh số (đã trừ hàng khách trả lại)    
                              return_on_sales_atax: 0
                            }
                            if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct; 
                            record.outquantity = 0;
                            record.inquantity = 0; 

                            record.stock_first = 0;//tồn kho đầu ky   
                            record.stock_last = 0; // tồn kho cuối kỳ  
                            record.cost_stock_first_btax = 0; //giá trị tôn kho đầu kỳ   
                            record.cost_stock_first_atax = 0;                          
                            record.cost_stock_last_btax = 0; //giá trị tôn kho cuối kỳ  
                            record.cost_stock_last_atax = 0;       

                            record.cost_stock_average_btax = 0; //giá trị mua vào trung bình   
                            record.cost_stock_average_atax = 0;                    
                            
                            
                            let soluongra_dauky = 0; // số lượng xuất trong kỳ từ đầu tháng (cùng tháng với starttime) đến thời điểm starttime
                            let soluongvao_dauky = 0;// số lượng nhập trong kỳ từ đầu tháng (cùng tháng với starttime) đến thời điểm starttime
                            let tientra_dauky_btax = 0; //tiền nhập hàng trong kỳ từ đầu tháng (cùng tháng với starttime) đến thời điểm starttime
                            let tientra_dauky_atax = 0;//số lượng xuất trong kỳ từ thời điểm starttime đến thời điểm endtime
                            let soluongvao_cuoiky = 0;
                            let tientra_cuoiky_btax = 0;//tiền nhập hàng trong kỳ từ thời điểm starttime đến thời điểm endtime
                            let tientra_cuoiky_atax = 0;                  
                            
                            for(let j=0; j<bill_details.length; j++){ 
                              let is_sub_or_product = false;
                              if(record.id_subproduct) is_sub_or_product = bill_details[j].id_subproduct === record.id_subproduct;
                              else is_sub_or_product = bill_details[j].id_product === products[i]._id;
                              if(bill_details[j].ptype === 3){  
                                if(is_sub_or_product){  
                                  let date = new Date(bill_details[j].date);   
                                  if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                                    if(date >= new Date(starttime)){      
                                      record.sales_btax = record.sales_btax + bill_details[j].price * bill_details[j].quantity;  
                                      record.sales_atax = record.sales_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                      record.outquantity_sales = record.outquantity_sales + bill_details[j].quantity * bill_details[j].ratio;  

                                      record.outquantity = record.outquantity + bill_details[j].quantity * bill_details[j].ratio;  

                                      json.sales_btax = json.sales_btax + bill_details[j].price  * bill_details[j].quantity; 
                                      json.sales_atax = json.sales_atax + bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                                      json.outquantity_sales = json.outquantity_sales + bill_details[j].quantity;  

                                    }else{
                                      soluongra_dauky = soluongra_dauky + bill_details[j].quantity * bill_details[j].ratio;                           
                                    }
                                  }else if(bill_details[j].bill_type === 3){//khách trả hàng 
                                    if(date >= new Date(starttime)){     
                                      //6 dòng dưới giảm doanh số và số lương bởi hàng trả về
                                      record.sales_btax = record.sales_btax - bill_details[j].price * bill_details[j].quantity;  
                                      record.sales_atax = record.sales_atax - bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                                      record.outquantity_sales = record.outquantity_sales - bill_details[j].quantity * bill_details[j].ratio; 

                                      json.sales_btax = json.sales_btax - bill_details[j].price  * bill_details[j].quantity; 
                                      json.sales_atax = json.sales_atax - bill_details[j].price  * bill_details[j].quantity * (1 + bill_details[j].tax / 100);       
                                      json.outquantity_sales = json.outquantity_sales - bill_details[j].quantity * bill_details[j].ratio;   

                                      record.inquantity = record.inquantity + bill_details[j].quantity * bill_details[j].ratio; 

                                    }else{
                                      soluongvao_dauky = soluongvao_dauky + bill_details[j].quantity * bill_details[j].ratio; 
                                      tientra_dauky_btax = tientra_dauky_btax + bill_details[j].price * bill_details[j].quantity; 
                                      tientra_dauky_atax = this.vhAlgorithm.roundTo3Decimals(tientra_dauky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                    }
                                    soluongvao_cuoiky = soluongvao_cuoiky + bill_details[j].quantity * bill_details[j].ratio; 
                                    tientra_cuoiky_btax = tientra_cuoiky_btax + bill_details[j].price * bill_details[j].quantity; 
                                    tientra_cuoiky_atax = this.vhAlgorithm.roundTo3Decimals(tientra_cuoiky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                        
                                  }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){ 
                                    if(date >= new Date(starttime)){          

                                      record.inquantity = record.inquantity + bill_details[j].quantity * bill_details[j].ratio;  

                                    }else{
                                      soluongvao_dauky = soluongvao_dauky + bill_details[j].quantity * bill_details[j].ratio; 
                                      tientra_dauky_btax = tientra_dauky_btax + bill_details[j].price * bill_details[j].quantity; 
                                      tientra_dauky_atax = this.vhAlgorithm.roundTo3Decimals(tientra_dauky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                    }
                                    soluongvao_cuoiky = soluongvao_cuoiky + bill_details[j].quantity * bill_details[j].ratio; 
                                    tientra_cuoiky_btax = tientra_cuoiky_btax + bill_details[j].price * bill_details[j].quantity; 
                                    tientra_cuoiky_atax = this.vhAlgorithm.roundTo3Decimals(tientra_cuoiky_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                      
                                  }                                                        
                                } 
                              }                                    
                            }
            //                                                  (first of product) ************************************************ (last of product)
            //******************************************************************************************************************************************************** time(past, present, future)
            //                    * (first)                                        * (starttime)                                  * (endtime)     
            //                    ************************************************** (dauky)
            //                    ************************************************************************************************* (cuoiky)   
                            
                            if(index !=null) first = {...products[i][IDbranch + '_ivtr'][index]};                  
                            record.stock_first = first.stock_first + soluongvao_dauky - soluongra_dauky;//số lượng tồn kho tại thời điểm starttime                               
                            record.stock_last = record.stock_first + record.inquantity - record.outquantity;//số lượng tồn kho tại thời điểm endtime   
                            //giá trị tồn kho tại thời điểm starttime 
                            if((first.stock_first + soluongvao_dauky)!=0){
                              record.cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_btax + tientra_dauky_btax)/(first.stock_first + soluongvao_dauky)) * record.stock_first);
                              record.cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_atax + tientra_dauky_atax)/(first.stock_first + soluongvao_dauky)) * record.stock_first);
                            }

                            //giá trị tồn kho tại thời điểm endtime 
                            if((first.stock_first + soluongvao_cuoiky)!=0){
                              record.cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_btax + tientra_cuoiky_btax)/(first.stock_first + soluongvao_cuoiky)) * record.stock_last);
                              record.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_atax + tientra_cuoiky_atax)/(first.stock_first + soluongvao_cuoiky)) * record.stock_last);
                            }

                            if(first.stock_first > 0){//tại thời điểm first nếu âm kho thì không tính giá trị trung bình được
                              //đơn giá trung bình mua vào
                              record.cost_stock_average_btax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_btax + tientra_cuoiky_btax)/(first.stock_first + soluongvao_cuoiky)));
                              record.cost_stock_average_atax = this.vhAlgorithm.roundTo3Decimals(((first.cost_stock_first_atax + tientra_cuoiky_atax)/(first.stock_first + soluongvao_cuoiky)));
                            }else{
                              if(soluongvao_cuoiky!=0){
                                record.cost_stock_average_btax = this.vhAlgorithm.roundTo3Decimals(tientra_cuoiky_btax/soluongvao_cuoiky); //đơn giá trung bình mua vào
                                record.cost_stock_average_atax = this.vhAlgorithm.roundTo3Decimals(tientra_cuoiky_atax/soluongvao_cuoiky);                   
                              }
                            }
                            record.cost_outstock_sales_btax = record.cost_stock_average_btax * record.outquantity_sales;//giá vốn hàng bán ra
                            record.cost_outstock_sales_atax = record.cost_stock_average_atax * record.outquantity_sales;
                            record.profit_sales_btax = record.sales_btax - record.cost_stock_average_btax * record.outquantity_sales; //lợi nhuận bán ra
                            record.profit_sales_atax = record.sales_atax - record.cost_stock_average_atax * record.outquantity_sales;
                            
                            
                            if(record.sales_btax != 0){
                              record.return_on_sales_btax = record.profit_sales_btax / record.sales_btax;
                            }else{
                              if(record.profit_sales_btax > 0) record.return_on_sales_btax = Infinity;
                              else if(record.profit_sales_btax < 0) record.return_on_sales_btax = - Infinity;
                              else if(record.profit_sales_btax === 0) record.return_on_sales_btax = 0;
                            }
                            if(record.sales_atax != 0){
                              record.return_on_sales_atax = record.profit_sales_atax / record.sales_atax;
                            }else{
                              if(record.profit_sales_atax > 0) record.return_on_sales_atax = Infinity;
                              else if(record.profit_sales_atax < 0) record.return_on_sales_atax = - Infinity;
                              else if(record.profit_sales_atax ==0) record.return_on_sales_atax = 0;
                            }

                            json.profit_sales_btax = json.profit_sales_btax + record.profit_sales_btax;
                            json.profit_sales_atax = json.profit_sales_atax + record.profit_sales_atax;

                            json.cost_outstock_sales_btax = json.cost_outstock_sales_btax + record.cost_outstock_sales_btax;
                            json.cost_outstock_sales_atax = json.cost_outstock_sales_atax + record.cost_outstock_sales_atax;

                            if(json.sales_btax != 0){
                              json.return_on_sales_btax = json.profit_sales_btax / json.sales_btax;
                            }
                            if(json.sales_atax != 0){
                              json.return_on_sales_atax = json.profit_sales_atax / json.sales_atax;
                            }

                            record.sales_atax = this.vhAlgorithm.roundTo3Decimals(record.sales_atax);     
                            record.profit_sales_atax = this.vhAlgorithm.roundTo3Decimals(record.profit_sales_atax);      
                            record.return_on_sales_atax = this.vhAlgorithm.roundTo3Decimals(record.return_on_sales_atax);                       
                            record.index = json.size + 1;
                            if(record.outquantity > 0) {
                              let _product ={
                                _id: record._id,
                                name: record.name,
                                type: record.type,
                                unit: record.unit,               
          
                                outquantity_sales: record.outquantity_sales, //Số lượng trong kỳ hàng đãn bán (đã trừ hàng khách trả lại)   
                                sales_btax: record.sales_btax, //Doanh số trong kỳ hàng đã bán (đã trừ hàng khách trả lại)   
                                sales_atax: record.sales_atax,  
                                profit_sales_btax: record.profit_sales_btax, // lợi nhuận trong kỳ của doanh số hàng đã bán (đã trừ hàng khách trả lại)    
                                profit_sales_atax: record.profit_sales_atax, 
                                cost_outstock_sales_btax: record.cost_outstock_sales_btax, //giá vốn hàng hóa bán ra (đã trừ hàng khách trả lại)       
                                cost_outstock_sales_atax: record.cost_outstock_sales_atax, 
                                return_on_sales_btax: record.return_on_sales_btax, //tỷ xuất lợi nhuận trên doanh số (đã trừ hàng khách trả lại)    
                                return_on_sales_atax: record.return_on_sales_atax
                              }
                              json.docs.push(_product);
                              json.size++;                        
                              json.empty = false;   
                            }     
                          //}              
                        }
                        resolve(json);                      
                        console.log('getReportProfit_byTime_byIDProduct', json);
                      })                      
              
              }else{
                console.log('server -> products khong ton tai trong CSDL: ');
                resolve(json);           
              }     
          })             
    })    
                                                  
  }



  public syncInventoryEveryDay_StockBeginning(){//cho chạy vài bữa rồi gán trường synced vào billtype 9
    return new Promise<any>((resolve, reject) => {  
        let products = this.getlocalProducts(3);
        //console.log(products, products);      
        let branchs = this.getlocalBranchs();       
        let promise_branch = new Array();
        for(let l=0; l<branchs.length; l++){
          promise_branch[l] = new Promise(resolve=>{
            let id_branch = branchs[l]._id;  
            let query = {bill_type: {$eq:9}, id_branch: {$eq:id_branch}};                                          
            this.getBill_details_byFields(query, {},{date:1},0)
                .then((bill_details:any)=>{                   
                    //console.log('bill_details', bill_details);   
                    let promise_products = new Array();                                  
                    if(bill_details.length >0){  
                      for(let i=0; i<products.length; i++){
                        let stock_beginning = 0; let cost_stock_beginning_btax = 0; let cost_stock_beginning_atax = 0; 
                        let unit_cost_stock_beginning_btax = 0; let unit_cost_stock_beginning_atax = 0;
                        for(let j=0; j<bill_details.length; j++){
                          if(bill_details[j].ptype ===3){
                            if(bill_details[j].id_product === products[i]._id){
                              stock_beginning = stock_beginning + bill_details[j].quantity;
                              cost_stock_beginning_btax = cost_stock_beginning_btax + bill_details[j].price * bill_details[j].quantity;
                              cost_stock_beginning_atax = this.vhAlgorithm.roundTo3Decimals(cost_stock_beginning_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                            }
                          }
                        }
                        if(stock_beginning !=0){
                          unit_cost_stock_beginning_btax = this.vhAlgorithm.roundTo3Decimals(cost_stock_beginning_btax/stock_beginning);
                          unit_cost_stock_beginning_atax = this.vhAlgorithm.roundTo3Decimals(cost_stock_beginning_atax/stock_beginning);
                          let value:any = {};
                          if(products[i][id_branch] != undefined){                                  
                            value[id_branch] = products[i][id_branch];                                 
                          }else{                                  
                            value[id_branch] = {};                                  
                          }
                          value[id_branch].stock_beginning = stock_beginning;
                          value[id_branch].unit_cost_stock_beginning_btax = unit_cost_stock_beginning_btax;
                          value[id_branch].unit_cost_stock_beginning_atax = unit_cost_stock_beginning_atax;
                          value[id_branch].cost_stock_beginning_btax = cost_stock_beginning_btax;
                          value[id_branch].cost_stock_beginning_atax = cost_stock_beginning_atax;

                          promise_products.push(this.vhMGDB_database.updateDoc('products', products[i]._id, {...value}));
                                                              
                        }

                      }
                    }
                    Promise.all(promise_products).then(()=>{
                      resolve(null);
                    })
                }) 
          })                
        }         
        Promise.all(promise_branch).then(()=>{
          resolve(null);
        })
    })
  }
 
 /**
 * Hàm này kiểm tra, tính toán tồn kho cho sản phẩm theo thuật toán 60days lúc khởi động Desktop hoặc Mobile:
 * + Nếu sản phẩm nào mà tháng gần nhất chưa tính thì hàm sẽ tính
 * + Nếu sản phẩm mới thêm vào thì hàm sẽ tính
 * vhQuerySales
 * @returns 
 */
private syncInventoryEveryDay_Stock1stDayOfMonth(){
   return new Promise<any>((resolve, reject) => {        
     let store = this.vhAuth.getStore();         
     //let branchs = this.getlocalBranchs();        
     let branchs = [{...this.getDefaultBranch()}];   
     this.vhMGDB_auth.getServerDate()
        .then((serverdate:any)=>{              
          //lấy các móc thời gian ngày 1 lúc 0h-0m-0s của các tháng trong khoản thời gian (store.registrationdate + 1) và (serverdate-1)
          let array60Days = this.get1stDayOfMonthArray(store.registrationdate, serverdate);//'2021-02-29T17:00:00.000Z'   
          let arrayNew60Days = this.get1stDayOfMonthArray(store.registrationdate, serverdate);     
          for(let m=arrayNew60Days.length-12; m>=0; m--){               
            //if((arrayNew60Days[m].getMonth() != 0)&&(arrayNew60Days[m].getMonth() != 6)) arrayNew60Days[m] = null;
          }           
          arrayNew60Days = arrayNew60Days.filter((e:any)=> e!=null);
          //console.log('---01 array60Days', array60Days);  
          //console.log('---02 arrayNew60Days', arrayNew60Days);   
          //Nếu không thỏa 60days sẽ ko tính inventory
          if(array60Days.length >0){                 
            let products = this.getlocalDetailProducts(3);           
            
            //for(let l=0; l<branchs.length; l++){
            let array_branch = new Array();
            for(let i=0; i<branchs.length; i++) array_branch.push(branchs[i]._id);    
            if(array_branch.length === 0) resolve(null); 
            let id_branch:any = array_branch.splice(0, 1)[0];               
            let loop_branch = true;
            let setinterval_branch = setInterval(async () => {
              if(loop_branch){
                loop_branch = false;               
                let query1 = {};
                let query2 = {};
                let counts_null = 0;
                let counts_nonull = 0;
                let bill_details_all:any = null;
                /*---------------------------------------------------------------------------------*/                                  
                /*Kiểm tra:
                  - trường date (products[m][id_branch + '_ivtr'][n].date) có tồn tại ko
                  - hoặc lý do nào đó mà giá trị trường date ko đúng giá trị chuẩn
                  - hoặc một phần tử nào đó trong mảng products[m][id_branch + '_ivtr'] không tồn tại trong array60Days
                  Nếu xảy ra thì gán bằng null để phần mềm cập nhật lại
                  Ghi chú: đoạn code này lọc bớt các trường hợp không thỏa mãn sẽ cho products[m][id_branch + '_ivtr'] = null, để phần code dưới đơn giản hơn dễ hiểu hơn
                */
                for(let m=0; m<products.length; m++){                        
                  if(products[m][id_branch + '_ivtr'] != undefined){
                    for(let n=0; n<products[m][id_branch + '_ivtr'].length; n++){   
                      let exist = false;                
                      for(let o =0;  o<array60Days.length; o++){  
                        if((new Date(products[m][id_branch + '_ivtr'][n].date)).getTime() == (new Date(array60Days[o])).getTime()){  
                          exist = true;
                          break;
                        }
                      }
                      if(!exist) {
                        console.log('Báo anh Huy hàm syncInventoryEveryDay_Stock1stDayOfMonth có lỗi 01');
                        products[m][id_branch + '_ivtr'] = null;
                        break;
                      }
                    }
                  }
                }
                
                /*------------------------------------------------------------------------------*/
                //Xác định 2 thời điểm quan trọng để getBill_details() về sẳn, (1) thời điểm đầu tháng mà product chưa có trường inventory, (2) thời điểm đầu tháng mà đã có trường inventory
                for(let m=0; m<products.length; m++){                        
                  if(products[m][id_branch + '_ivtr'] != undefined){
                    if((new Date(products[m][id_branch + '_ivtr'][products[m][id_branch + '_ivtr'].length -1].date)).getTime() < (new Date(array60Days[array60Days.length-1])).getTime()){   
                      counts_nonull++;
                    } 
                  }else{
                    counts_null++;
                  }
                }                 
                /*-----------------------------------------------------------------------------*/    
                //Nếu tất cả hoặc lượng lớn sản phẩm có trường (id_branch + '_ivtr') bằng null thì lấy về tất cả bill_detail (bill_details_all) 1 lần giúp việc tính toán nhanh hơn
                //Nếu chỉ có vài sản phẩm có trường (id_branch + '_ivtr') bằng null thì sau này tính toán đến sản phẩm nào lấy về bill_detail của sản phẩm đó để tính       
                if(((counts_nonull !=0)&&(counts_nonull === products.length))||(counts_nonull>=50)){                       
                  let promise_zero = new Array();               
                  query1 = {date: {$gte: new Date(array60Days[array60Days.length-2]), $lt: new Date(array60Days[array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:id_branch}};   
                  query2 = {date: {$gte: new Date(array60Days[array60Days.length-2]), $lt: new Date(array60Days[array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}};   
                    
                  //Lấy về các bill_details của các tháng (chưa đc tính 60days) tiếp theo                                  
                  promise_zero[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                  promise_zero[1] = this.getBill_details_byFields(query2, {},{date:1},0);
                  await new Promise(resolve=>{                    
                    Promise.all(promise_zero)
                          .then((bill_details:any)=>{                               
                             bill_details_all = bill_details.flat();                                                   
                             resolve(null);
                          })
                  })                    
                }                                  
                let promise_branch = new Array();
                promise_branch[0] = new Promise(resolve=>{                                              
                    //let times = products.length;
                    let array_number = new Array();
                    for(let i=0; i<products.length; i++) array_number.push(i);                        
                    let loop_product = true; 
                    let array_10 = array_number.splice(0, 1);  
                    let setinterval_product = setInterval(() => {//mỗi lần kiểm tra và tính toán  thuật toán 60days cho 10 sản phẩm
                      if(loop_product){
                        loop_product = false;              
                            let promise_products = new Array();
                            //console.log('array_10', array_10); 
                            for(let i=array_10[0]; i<=array_10[array_10.length-1]; i++){   
                              promise_products[promise_products.length] = new Promise(resolve=>{                                      
                                  //Nếu trong product nào đó mà đã có trường inventory thì sẽ được tính toán và thêm vào những tháng gần nhất                    
                                  if(products[i][id_branch + '_ivtr'] != undefined){   
                                     //if(products[i]._id === 'LKJq7SCBYlbl2KErEKi3') 
                                     //console.log('---11', i, products[i][id_branch + '_ivtr']);  
                                     //inventory của tháng gần nhất đã tính theo 60days   
                                     const inventory = products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length -1];      
                                     //Kiểm tra trong inventory có tháng tiếp nào cần phải tính 60days ko, nếu có thì phải tính                                    
                                     if((new Date(inventory.date)).getTime() < (new Date(array60Days[array60Days.length-1])).getTime()){     
                                       let _array60Days = [...array60Days]; 
                                       //Tính lại và chỉ lấy các phần tử đầu của mảng _array60Days giống với tất cả các phẩn tử đang có trong mảng products[i][id_branch + '_ivtr']
                                       //Tìm vị trí cuối cùng của mảng products[i][id_branch + '_ivtr'] là vị trí nào trong mảng _array60Days
                                       let vitri = 0; 
                                       for (let m = 0; m < _array60Days.length; m++) {
                                        const currentDay = new Date(_array60Days[m]).getTime();
                                        const inventoryDay = new Date(inventory.date).getTime();                                      
                                        vitri++;                                      
                                        // Nếu ngày trùng khớp với ngày tồn kho thì dừng vòng lặp
                                        if (currentDay === inventoryDay) break;                                      
                                        // Kiểm tra xem ngày đó có tồn tại trong danh sách tồn kho chi nhánh không
                                        const hasData = products[i][id_branch + '_ivtr'].some((item:any) => {
                                          return new Date(item.date).getTime() === currentDay;
                                        });                                      
                                        // Nếu không tồn tại, loại bỏ ngày đó và giảm lại vị trí
                                        if (!hasData) {
                                          _array60Days[m] = null;
                                          vitri--;
                                        }
                                       }
                                       _array60Days = _array60Days.filter((e:any)=> e!=null);
                                       if(vitri>0){  
                                         //khởi tạo giá trị ban đầu (mặc định) cho inventory của các tháng tiếp theo mà thỏa 60days                                     
                                         for(let k= vitri; k <_array60Days.length; k++){
                                           products[i][id_branch + '_ivtr'][k] = {};
                                           products[i][id_branch + '_ivtr'][k].date = _array60Days[k];                                 
                                           products[i][id_branch + '_ivtr'][k].inquantity_tofirst = inventory.inquantity_tofirst;  //tổng SL nhập từ lúc dùng phần mềm đến cuối tháng trước
                                           products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = inventory.pay_tofirst_btax;      //tổng số tiền nhập hàng từ lúc dùng phần mềm đến cuối tháng trước
                                           products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = inventory.pay_tofirst_atax;
                                           products[i][id_branch + '_ivtr'][k].outquantity_tofirst = inventory.outquantity_tofirst;//tổng SL xuất từ lúc dùng phần mềm đến cuối tháng trước
                                           products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = inventory.sales_tofirst_btax;  //tổng số tiền xuất từ lúc dùng phần mềm đến cuối tháng trước
                                           products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = inventory.sales_tofirst_atax;

                                           products[i][id_branch + '_ivtr'][k].stock_first = 0;
                                           products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = 0;
                                           products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = 0;
                                           products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = 0;
                                           products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = 0;
                                           products[i][id_branch + '_ivtr'][k].profit_first_btax = 0;
                                           products[i][id_branch + '_ivtr'][k].profit_first_atax = 0;

                                           if(products[i].lots){
                                             products[i][id_branch + '_ivtr'][k].lots = new Array();
                                             for(let m=0; m<products[i].lots.length; m++){    
                                               products[i][id_branch + '_ivtr'][k].lots[m] = {};
                                               products[i][id_branch + '_ivtr'][k].lots[m]._id = products[i].lots[m]._id;

                                               products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = 0;

                                               products[i][id_branch + '_ivtr'][k].lots[m].stock_first = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = 0;

                                               //Nạp các giá của tháng trước vào tháng này, sau đó dựa vào bill_details để tính lại nó
                                               //Có kiểm tra qua _id, phòng trường hợp vị trí các lot này bị thay đổi thay đổi trong mảng lots
                                               for(let n=0; n<inventory.lots.length; n++){    
                                                 if(products[i][id_branch + '_ivtr'][k].lots[m]._id === inventory.lots[n]._id){
                                                   products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = inventory.lots[n].inquantity_tofirst;  //tổng SL nhập từ lúc dùng phần mềm đến cuối tháng trước
                                                   products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = inventory.lots[n].pay_tofirst_btax;      //tổng số tiền nhập hàng từ lúc dùng phần mềm đến cuối tháng trước
                                                   products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = inventory.lots[n].pay_tofirst_atax;
                                                   products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = inventory.lots[n].outquantity_tofirst;//tổng SL xuất từ lúc dùng phần mềm đến cuối tháng trước
                                                   products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = inventory.lots[n].sales_tofirst_btax;  //tổng số tiền xuất từ lúc dùng phần mềm đến cuối tháng trước
                                                   products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = inventory.lots[n].sales_tofirst_atax;
                                                 }
                                               }
                                             }                                                
                                           }
                                         }  
                                         
                                         let promise_one = new Array();                                
                                           //Nếu bill_details_all có dữ liệu và chỉ tháng gần nhất chưa cập nhật 60days thôi, còn nhiều tháng chưa cập nhật 60days thì get dữ liệu từng sản phẩm một về tính toán        
                                           if(bill_details_all && (_array60Days.length ==  vitri + 1)){                                       
                                             promise_one[0] = new Promise(resolve=>{
                                               let _bill_details = new Array();
                                               if(products[i].id_subproduct){  
                                                 _bill_details = bill_details_all.filter((e:any)=>e.id_subproduct === products[i].id_subproduct);
                                               }else{
                                                 _bill_details = bill_details_all.filter((e:any)=>e.id_product === products[i]._id);
                                               }                                                                                      
                                               resolve(_bill_details);                                           
                                             })
                                           }else{                                                                            
                                             if(products[i].id_subproduct){                                             
                                               query1 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}};   
                                               query2 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}};   
                                             }else{                                                       
                                               query1 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}};
                                               query2 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}};     
                                             }                                               
                                             //Lấy về các bill_details của các tháng (chưa đc tính 60days) tiếp theo                                  
                                             promise_one[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                                             promise_one[1] = this.getBill_details_byFields(query2, {},{date:1},0);                                         
                                           }
                                         Promise.all(promise_one)
                                             .then((bill_details:any)=>{                                                                          
                                               bill_details = bill_details.flat();                                                                                                                                                 
                                               if(bill_details.length >0){                                                                             
                                                 for(let j=0; j<bill_details.length; j++){                                                                                         
                                                   for(let k= vitri; k <_array60Days.length; k++){                  
                                                     if((new Date(bill_details[j].date)).getTime() < (new Date(products[i][id_branch + '_ivtr'][k].date)).getTime()){                                                   
                                                         if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){                                                     
                                                           if(products[i][id_branch + '_ivtr'][k].lots){
                                                             for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                               if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;                
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                               }
                                                             }
                                                           }
                                                           products[i][id_branch + '_ivtr'][k].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;               
                                                           products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                           products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));

                                                         }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){                                                       
                                                           if(products[i][id_branch + '_ivtr'][k].lots)
                                                             for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                               if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                               }
                                                             }
                                                           products[i][id_branch + '_ivtr'][k].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                           products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                           products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                                                             
                                                         }                                   
                                                     }
                                                   }                                                                                 
                                                 }
                                               }
                                                 
                                               for(let k= vitri; k <_array60Days.length; k++){       
                                                 if(products[i][id_branch + '_ivtr'][k].lots){
                                                   for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                     let _slnhaptrongky = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].inquantity_tofirst;
                                                     let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_btax;
                                                     let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_atax;
                                                     products[i][id_branch + '_ivtr'][k].lots[m].stock_first = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst;   
                                                     
                                                     if(_slnhaptrongky ===0){
                                                       products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_btax;
                                                       products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_atax;                                                              
                                                     }else{
                                                       if(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax ===0){
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                       }else{
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax) + _tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_atax) + _tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                       }
                                                     }
                                                     products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first; 
                                                     products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first;  

                                                     let _slbantrongky = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].outquantity_tofirst;
                                                     let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                     let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                     let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_btax;
                                                     let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_atax;
                                                     products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                     products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                   }    
                                                 }                                     
                                                 let slnhaptrongky = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].inquantity_tofirst;
                                                 let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_btax;
                                                 let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_atax;
                                                 products[i][id_branch + '_ivtr'][k].stock_first = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].outquantity_tofirst;   
                                                                                                     
                                                 if(slnhaptrongky ===0){
                                                   products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_btax;
                                                   products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_atax;
                                                 }else{
                                                   if(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax === 0){                                                            
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);                                                           
                                                   }else{
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax) + tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_atax) + tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                   }
                                                 }
                                                 products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].stock_first; 
                                                 products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].stock_first;  

                                                 let slbantrongky = products[i][id_branch + '_ivtr'][k].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].outquantity_tofirst;
                                                 let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * slbantrongky;
                                                 let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * slbantrongky;
                                                 let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_btax;
                                                 let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_atax;
                                                 products[i][id_branch + '_ivtr'][k].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                 products[i][id_branch + '_ivtr'][k].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                               }       
                                 
                                               /*let _length = products[i][id_branch + '_ivtr']?.length;
                                               for(let m=_length-12; m>=0; m--){
                                                 let date = new Date(products[i][id_branch + '_ivtr'][m]?.date);
                                                 if((date.getMonth() != 0)&&(date.getMonth() != 6)) products[i][id_branch + '_ivtr'][m] = null;
                                               }                                                
                                               products[i][id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'].filter((e:any)=> e!=null);*/                                              
                                               let value:any = {};  
											                         value[id_branch + '_ivtr'] = products[i][id_branch + '_ivtr']; 
                                               
                                               //cập nhật việc ký sinh tồn kho mới cho các tháng tiếp theo thỏa mãn 60days                                          
                                               this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                                   .then(()=>{                                                                                                                                                 
                                                     resolve(true);
                                                   })
                                             })  
                                       }else{
                                         //kiểm lại lại vt=0 là vô lý
                                         console.log(products[i]._id, 'có vt=0 là vô lý') ;                                    
                                         resolve(null); 
                                       }              
                                    }else{//các tháng đã thỏa 60days rồi ko cần tính nữa   
                                      //Đoạn code dưới này khi nào cần chạy thì bật lên vì rất khó xảy ra (xảy ra khi có người tác động vào dữ liệu), mà chạy hoài thì mỗi lần khởi động 
                                      //phần mềm tốn tài nguyên máy. Sau mỗi tháng cập nhật lại 60days cũng đã kiểm tra vụ này và sai dữ liệu sẽ bị cập nhật null để tính lại ở lần khởi động sau
                                      /*
                                      //Các tháng đã thỏa 60days rồi mà số phần tử trong  products[i][id_branch + '_ivtr'] và trong arrayNew60Days không khớp nhau về length và vị trí
                                      //thì dữ liệu này có thể đã bị sai do nhiều nguyên nhân (hoặc có người tác động vào dữ liệu), nên xóa đi để phần mềm tính toán lại ở lần chạy lại phần mềm tới.                       
                                      for(let n=0; n<arrayNew60Days.length; n++){   
                                        if((new Date(arrayNew60Days[n])).getTime() != (new Date(products[i][id_branch + '_ivtr'][n].date)).getTime()){  
                                          products[i][id_branch + '_ivtr'] = null;
                                          let value:any = {};  
                                          value[id_branch + '_ivtr'] = null;                                          
                                          //cập nhật null cho dữ liệu 60days, để lần khởi động tới giá trị này sẽ đc tính toán lại                                          
                                          this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                          break;
                                        }                                                  
                                      }*/           
                                     
                                      //Đoạn code này cũng giải quyết đc vấn đề trên, nhưng ít tốn tài nguyên máy khi khởi động phần mềm hơn
                                      if(products[i][id_branch + '_ivtr'].length != arrayNew60Days.length){
                                        products[i][id_branch + '_ivtr'] = null;
                                        let value:any = {};  
                                        value[id_branch + '_ivtr'] = null;                                          
                                        //cập nhật null cho dữ liệu 60days, để lần khởi động tới giá trị này sẽ đc tính toán lại                                          
                                        this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                            .then(()=>{                                                                                                                                                 
                                              resolve(null);
                                            })
                                      }else{
                                        resolve(null);
                                      }                                         
                                    }
                              //---------------------------------------------------------------------     
                                  //Nếu trong product nào đó mà chưa có trường inventory thì sẽ được tính toán và thêm vào từ lúc sài phần mềm đến những tháng gần nhất    
                                  }else{//Nếu trong product nào đó mà chưa có trường inventory thì sẽ được tính toán lại và thêm vô    
                                      //console.log('---21', i, products[i][id_branch + '_ivtr']);                                      
                                      let promise_two = new Array();
                                      if(products[i].id_subproduct){                        
                                        query1 = { ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}}; 
                                        query2 = { ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}}; 
                                      }else{                                        
                                        query1 = { ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}}; 
                                        query2 = { ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}}; 
                                      }                                        
                                      promise_two[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                                      promise_two[1] = this.getBill_details_byFields(query2, {},{date:1},0);
                                      Promise.all(promise_two)
                                          .then((bill_details:any)=>{                                             
                                            bill_details = bill_details.flat();                                            
                                            products[i][id_branch + '_ivtr'] = new Array();
                                            for(let k=0; k<array60Days.length; k++){    
                                              products[i][id_branch + '_ivtr'][k] = {};
                                              products[i][id_branch + '_ivtr'][k].date = array60Days[k];                                       
                                              products[i][id_branch + '_ivtr'][k].inquantity_tofirst = 0;
                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = 0;
                                              products[i][id_branch + '_ivtr'][k].outquantity_tofirst = 0;
                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = 0;

                                              products[i][id_branch + '_ivtr'][k].stock_first = 0;
                                              products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = 0;
                                              products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = 0;
                                              products[i][id_branch + '_ivtr'][k].profit_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].profit_first_atax = 0;

                                              if(products[i].lots){
                                                products[i][id_branch + '_ivtr'][k].lots = new Array();
                                                for(let m=0; m<products[i].lots.length; m++){    
                                                  products[i][id_branch + '_ivtr'][k].lots[m] = {};
                                                  products[i][id_branch + '_ivtr'][k].lots[m]._id = products[i].lots[m]._id;
                                                }
                                                for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){    
                                                  products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = 0;

                                                  products[i][id_branch + '_ivtr'][k].lots[m].stock_first = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = 0;

                                                }
                                              }
                                            }
                                            if(bill_details.length >0){
                                              for(let j=0; j<bill_details.length; j++){                                                                                     
                                                for(let k=0; k<products[i][id_branch + '_ivtr'].length; k++){                   
                                                  if((new Date(bill_details[j].date)).getTime() < (new Date(products[i][id_branch + '_ivtr'][k].date)).getTime()){                                                   
                                                      if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){ 
                                                        if(products[i][id_branch + '_ivtr'][k].lots){
                                                          for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                            if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                              products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;          
                                                              products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                              products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                            } 
                                                          } 
                                                        }                                                  
                                                        products[i][id_branch + '_ivtr'][k].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;          
                                                        products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                        products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity  * bill_details[j].ratio * (1 + bill_details[j].tax/100));
                                                      
                                                      }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){      
                                                        
                                                        if(products[i][id_branch + '_ivtr'][k].lots){
                                                        
                                                          for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                            
                                                            if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                              
                                                              products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                              products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                              products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                            }
                                                          }  
                                                        }  
                                                                                            
                                                        products[i][id_branch + '_ivtr'][k].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                        products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                        products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                                                          
                                                      }                                   
                                                  }
                                                }                                                                        
                                              }
                                              
                                              for(let k=0; k<products[i][id_branch + '_ivtr'].length; k++){  
                                                if(k===0){
                                                  if(products[i][id_branch + '_ivtr'][k].lots)
                                                    for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                      let _slnhaptrongky = products[i][id_branch + '_ivtr'][0].lots[m].inquantity_tofirst;
                                                      let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].pay_tofirst_btax;
                                                      let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].pay_tofirst_atax;
                                                      products[i][id_branch + '_ivtr'][0].lots[m].stock_first = products[i][id_branch + '_ivtr'][0].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][0].lots[m].outquantity_tofirst;   
                                                      
                                                      if(_slnhaptrongky !=0){
                                                        products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                        products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                        products[i][id_branch + '_ivtr'][0].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][0].lots[m].stock_first; 
                                                        products[i][id_branch + '_ivtr'][0].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][0].lots[m].stock_first;  
                                                      }
                                                      let _slbantrongky = products[i][id_branch + '_ivtr'][0].lots[m].outquantity_tofirst;
                                                      let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                      let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                      let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].sales_tofirst_btax;
                                                      let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].sales_tofirst_atax
                                                      products[i][id_branch + '_ivtr'][0].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                      products[i][id_branch + '_ivtr'][0].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                    }
                                                  let slnhaptrongky = products[i][id_branch + '_ivtr'][0].inquantity_tofirst;
                                                  let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][0].pay_tofirst_btax;
                                                  let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][0].pay_tofirst_atax;
                                                  products[i][id_branch + '_ivtr'][0].stock_first = products[i][id_branch + '_ivtr'][0].inquantity_tofirst - products[i][id_branch + '_ivtr'][0].outquantity_tofirst;   
                                                  
                                                  if(slnhaptrongky !=0){
                                                    products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                    products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);
                                                    products[i][id_branch + '_ivtr'][0].cost_stock_first_btax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][0].stock_first; 
                                                    products[i][id_branch + '_ivtr'][0].cost_stock_first_atax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][0].stock_first;  
                                                  }
                                                  let slbantrongky = products[i][id_branch + '_ivtr'][0].outquantity_tofirst;
                                                  let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax * slbantrongky;
                                                  let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax * slbantrongky;
                                                  let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][0].sales_tofirst_btax;
                                                  let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][0].sales_tofirst_atax
                                                  products[i][id_branch + '_ivtr'][0].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                  products[i][id_branch + '_ivtr'][0].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                                }else{
                                                  if(products[i][id_branch + '_ivtr'][k].lots){
                                                    for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                      let _slnhaptrongky = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].inquantity_tofirst;
                                                      let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_btax;
                                                      let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_atax;
                                                      products[i][id_branch + '_ivtr'][k].lots[m].stock_first = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst;   
                                                      
                                                      if(_slnhaptrongky ===0){
                                                        products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_btax;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_atax;                                                              
                                                      }else{
                                                        if(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax ===0){
                                                          products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                          products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                        }else{
                                                          products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax) + _tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                          products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_atax) + _tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                        }
                                                      }
                                                      products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first; 
                                                      products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first;  
                                                      let _slbantrongky = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].outquantity_tofirst;
                                                      let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                      let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                      let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_btax;
                                                      let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_atax;
                                                      products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                      products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                    }
                                                  }
                                                  let slnhaptrongky = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].inquantity_tofirst;
                                                  let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_btax;
                                                  let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_atax;
                                                  products[i][id_branch + '_ivtr'][k].stock_first = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].outquantity_tofirst;   
                                                  
                                                  if(slnhaptrongky ===0){
                                                    products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_btax;
                                                    products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_atax;
                                                  }else{
                                                    if(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax === 0){                                                            
                                                      products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                      products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);                                                            
                                                    }else{
                                                      products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax) + tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                      products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_atax) + tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                    }
                                                  }
                                                  products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].stock_first; 
                                                  products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].stock_first;  
                                                  
                                                  let slbantrongky = products[i][id_branch + '_ivtr'][k].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].outquantity_tofirst;
                                                  let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * slbantrongky;
                                                  let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * slbantrongky;
                                                  let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_btax;
                                                  let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_atax;
                                                  products[i][id_branch + '_ivtr'][k].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                  products[i][id_branch + '_ivtr'][k].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                                }
                                              }                                                                                                         
                                            }
                                           
                                            /*let _length = products[i][id_branch + '_ivtr']?.length;
                                            for(let m=_length-12; m>=0; m--){
                                              let date = new Date(products[i][id_branch + '_ivtr'][m]?.date);
                                              if((date.getMonth() != 0)&&(date.getMonth() != 6)) products[i][id_branch + '_ivtr'][m] = null;
                                            }                                                
                                            products[i][id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'].filter((e:any)=> e!=null)*/  
                                            let value:any = {};  
											                      value[id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'];
                                             this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                                .then(()=>{                                                                                                                                                                                                  
                                                  resolve(true);
                                                })                                      
                                        })
                                  }                                         
                              })                                    
                            }
                          
                            Promise.all(promise_products).then(array_products=>{                                                                          
                              if(array_number.length>0){                                      
                                loop_product = true;    
                                array_10 = array_number.splice(0, 1);  
                              }else{                                      
                                resolve(null);
                                clearInterval(setinterval_product);                                      
                              }            
                            })                                   
                      }
                    },10)
                })
                Promise.all(promise_branch).then(()=>{                                       
                  if(array_branch.length>0){                                      
                    loop_branch = true;    
                    id_branch = array_branch.splice(0, 1)[0];  
                  }else{                      
                    clearInterval(setinterval_branch);  
                    console.log('syncInventoryEveryDay_Stock1stDayOfMonth1');       
                    resolve(null);                                      
                  }    
                })  
              }
            },500);             
          }else{
            console.log('syncInventoryEveryDay_Stock1stDayOfMonth2');    
            resolve(null);   
          }
        })
        resolve(null); 
   })   
 }

 private syncInventoryEveryDay_Stock1stDayOfMonth_old(){
   return new Promise<any>((resolve, reject) => {        
     let store = this.vhAuth.getStore();         
     //let branchs = this.getlocalBranchs();        
     let branchs = [{...this.getDefaultBranch()}];   
     this.vhMGDB_auth.getServerDate()
        .then((serverdate:any)=>{              
          //lấy các móc thời gian ngày 1 lúc 0h-0m-0s của các tháng trong khoản thời gian (store.registrationdate + 1) và (serverdate-1)
          let array60Days = this.get1stDayOfMonthArray(store.registrationdate, serverdate);//'2021-02-29T17:00:00.000Z'   
          let arrayNew60Days = this.get1stDayOfMonthArray(store.registrationdate, serverdate);     
          for(let m=arrayNew60Days.length-12; m>=0; m--){               
            if((arrayNew60Days[m].getMonth() != 0)&&(arrayNew60Days[m].getMonth() != 6)) arrayNew60Days[m] = null;
          }           
          arrayNew60Days = arrayNew60Days.filter((e:any)=> e!=null);
          //console.log('---01 array60Days', array60Days);  
          //console.log('---02 arrayNew60Days', arrayNew60Days);   
          //Nếu không thỏa 60days sẽ ko tính inventory
          if(array60Days.length >0){                 
            let products = this.getlocalDetailProducts(3);           
            
            //for(let l=0; l<branchs.length; l++){
            let array_branch = new Array();
            for(let i=0; i<branchs.length; i++) array_branch.push(branchs[i]._id);    
            if(array_branch.length === 0) resolve(null); 
            let id_branch:any = array_branch.splice(0, 1)[0];               
            let loop_branch = true;
            let setinterval_branch = setInterval(async () => {
              if(loop_branch){
                loop_branch = false;               
                let query1 = {};
                let query2 = {};
                let counts_null = 0;
                let counts_nonull = 0;
                let bill_details_all:any = null;
                /*---------------------------------------------------------------------------------*/                                  
                /*Kiểm tra:
                  - trường date (products[m][id_branch + '_ivtr'][n].date) có tồn tại ko
                  - hoặc lý do nào đó mà giá trị trường date ko đúng giá trị chuẩn
                  - hoặc một phần tử nào đó trong mảng products[m][id_branch + '_ivtr'] không tồn tại trong array60Days
                  Nếu xảy ra thì gán bằng null để phần mềm cập nhật lại
                  Ghi chú: đoạn code này lọc bớt các trường hợp không thỏa mãn sẽ cho products[m][id_branch + '_ivtr'] = null, để phần code dưới đơn giản hơn dễ hiểu hơn
                */
                for(let m=0; m<products.length; m++){                        
                  if(products[m][id_branch + '_ivtr'] != undefined){
                    for(let n=0; n<products[m][id_branch + '_ivtr'].length; n++){   
                      let exist = false;                
                      for(let o =0;  o<array60Days.length; o++){  
                        if((new Date(products[m][id_branch + '_ivtr'][n].date)).getTime() == (new Date(array60Days[o])).getTime()){  
                          exist = true;
                          break;
                        }
                      }
                      if(!exist) {
                        console.log('Báo anh Huy hàm syncInventoryEveryDay_Stock1stDayOfMonth có lỗi 01');
                        products[m][id_branch + '_ivtr'] = null;
                        break;
                      }
                    }
                  }
                }
                
                /*------------------------------------------------------------------------------*/
                //Xác định 2 thời điểm quan trọng để getBill_details() về sẳn, (1) thời điểm đầu tháng mà product chưa có trường inventory, (2) thời điểm đầu tháng mà đã có trường inventory
                for(let m=0; m<products.length; m++){                        
                  if(products[m][id_branch + '_ivtr'] != undefined){
                    if((new Date(products[m][id_branch + '_ivtr'][products[m][id_branch + '_ivtr'].length -1].date)).getTime() < (new Date(array60Days[array60Days.length-1])).getTime()){   
                      counts_nonull++;
                    } 
                  }else{
                    counts_null++;
                  }
                }                 
                /*-----------------------------------------------------------------------------*/    
                //Nếu tất cả hoặc lượng lớn sản phẩm có trường (id_branch + '_ivtr') bằng null thì lấy về tất cả bill_detail (bill_details_all) 1 lần giúp việc tính toán nhanh hơn
                //Nếu chỉ có vài sản phẩm có trường (id_branch + '_ivtr') bằng null thì sau này tính toán đến sản phẩm nào lấy về bill_detail của sản phẩm đó để tính       
                if(((counts_nonull !=0)&&(counts_nonull === products.length))||(counts_nonull>=50)){                       
                  let promise_zero = new Array();               
                  query1 = {date: {$gte: new Date(array60Days[array60Days.length-2]), $lt: new Date(array60Days[array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:id_branch}};   
                  query2 = {date: {$gte: new Date(array60Days[array60Days.length-2]), $lt: new Date(array60Days[array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}};   
                    
                  //Lấy về các bill_details của các tháng (chưa đc tính 60days) tiếp theo                                  
                  promise_zero[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                  promise_zero[1] = this.getBill_details_byFields(query2, {},{date:1},0);
                  await new Promise(resolve=>{                    
                    Promise.all(promise_zero)
                          .then((bill_details:any)=>{                               
                             bill_details_all = bill_details.flat();                                                   
                             resolve(null);
                          })
                  })                    
                }                                  
                let promise_branch = new Array();
                promise_branch[0] = new Promise(resolve=>{                                              
                    //let times = products.length;
                    let array_number = new Array();
                    for(let i=0; i<products.length; i++) array_number.push(i);                        
                    let loop_product = true; 
                    let array_10 = array_number.splice(0, 1);  
                    let setinterval_product = setInterval(() => {//mỗi lần kiểm tra và tính toán  thuật toán 60days cho 10 sản phẩm
                      if(loop_product){
                        loop_product = false;              
                            let promise_products = new Array();
                            //console.log('array_10', array_10); 
                            for(let i=array_10[0]; i<=array_10[array_10.length-1]; i++){   
                              promise_products[promise_products.length] = new Promise(resolve=>{                                      
                                  //Nếu trong product nào đó mà đã có trường inventory thì sẽ được tính toán và thêm vào những tháng gần nhất                    
                                  if(products[i][id_branch + '_ivtr'] != undefined){   
                                     //if(products[i]._id === 'LKJq7SCBYlbl2KErEKi3') 
                                     //console.log('---11', i, products[i][id_branch + '_ivtr']);  
                                     //inventory của tháng gần nhất đã tính theo 60days   
                                     const inventory = products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length -1];      
                                     //Kiểm tra trong inventory có tháng tiếp nào cần phải tính 60days ko, nếu có thì phải tính                                    
                                     if((new Date(inventory.date)).getTime() < (new Date(array60Days[array60Days.length-1])).getTime()){     
                                       let _array60Days = [...array60Days]; 
                                       //Tính lại và chỉ lấy các phần tử đầu của mảng _array60Days giống với tất cả các phẩn tử đang có trong mảng products[i][id_branch + '_ivtr']
                                       //Tìm vị trí cuối cùng của mảng products[i][id_branch + '_ivtr'] là vị trí nào trong mảng _array60Days
                                       let vitri = 0; 
                                       for (let m = 0; m < _array60Days.length; m++) {
                                        const currentDay = new Date(_array60Days[m]).getTime();
                                        const inventoryDay = new Date(inventory.date).getTime();                                      
                                        vitri++;                                      
                                        // Nếu ngày trùng khớp với ngày tồn kho thì dừng vòng lặp
                                        if (currentDay === inventoryDay) break;                                      
                                        // Kiểm tra xem ngày đó có tồn tại trong danh sách tồn kho chi nhánh không
                                        const hasData = products[i][id_branch + '_ivtr'].some((item:any) => {
                                          return new Date(item.date).getTime() === currentDay;
                                        });                                      
                                        // Nếu không tồn tại, loại bỏ ngày đó và giảm lại vị trí
                                        if (!hasData) {
                                          _array60Days[m] = null;
                                          vitri--;
                                        }
                                       }
                                       _array60Days = _array60Days.filter((e:any)=> e!=null);
                                       if(vitri>0){  
                                         //khởi tạo giá trị ban đầu (mặc định) cho inventory của các tháng tiếp theo mà thỏa 60days                                     
                                         for(let k= vitri; k <_array60Days.length; k++){
                                           products[i][id_branch + '_ivtr'][k] = {};
                                           products[i][id_branch + '_ivtr'][k].date = _array60Days[k];                                 
                                           products[i][id_branch + '_ivtr'][k].inquantity_tofirst = inventory.inquantity_tofirst;  //tổng SL nhập từ lúc dùng phần mềm đến cuối tháng trước
                                           products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = inventory.pay_tofirst_btax;      //tổng số tiền nhập hàng từ lúc dùng phần mềm đến cuối tháng trước
                                           products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = inventory.pay_tofirst_atax;
                                           products[i][id_branch + '_ivtr'][k].outquantity_tofirst = inventory.outquantity_tofirst;//tổng SL xuất từ lúc dùng phần mềm đến cuối tháng trước
                                           products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = inventory.sales_tofirst_btax;  //tổng số tiền xuất từ lúc dùng phần mềm đến cuối tháng trước
                                           products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = inventory.sales_tofirst_atax;

                                           products[i][id_branch + '_ivtr'][k].stock_first = 0;
                                           products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = 0;
                                           products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = 0;
                                           products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = 0;
                                           products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = 0;
                                           products[i][id_branch + '_ivtr'][k].profit_first_btax = 0;
                                           products[i][id_branch + '_ivtr'][k].profit_first_atax = 0;

                                           if(products[i].lots){
                                             products[i][id_branch + '_ivtr'][k].lots = new Array();
                                             for(let m=0; m<products[i].lots.length; m++){    
                                               products[i][id_branch + '_ivtr'][k].lots[m] = {};
                                               products[i][id_branch + '_ivtr'][k].lots[m]._id = products[i].lots[m]._id;

                                               products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = 0;

                                               products[i][id_branch + '_ivtr'][k].lots[m].stock_first = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = 0;
                                               products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = 0;

                                               //Nạp các giá của tháng trước vào tháng này, sau đó dựa vào bill_details để tính lại nó
                                               //Có kiểm tra qua _id, phòng trường hợp vị trí các lot này bị thay đổi thay đổi trong mảng lots
                                               for(let n=0; n<inventory.lots.length; n++){    
                                                 if(products[i][id_branch + '_ivtr'][k].lots[m]._id === inventory.lots[n]._id){
                                                   products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = inventory.lots[n].inquantity_tofirst;  //tổng SL nhập từ lúc dùng phần mềm đến cuối tháng trước
                                                   products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = inventory.lots[n].pay_tofirst_btax;      //tổng số tiền nhập hàng từ lúc dùng phần mềm đến cuối tháng trước
                                                   products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = inventory.lots[n].pay_tofirst_atax;
                                                   products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = inventory.lots[n].outquantity_tofirst;//tổng SL xuất từ lúc dùng phần mềm đến cuối tháng trước
                                                   products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = inventory.lots[n].sales_tofirst_btax;  //tổng số tiền xuất từ lúc dùng phần mềm đến cuối tháng trước
                                                   products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = inventory.lots[n].sales_tofirst_atax;
                                                 }
                                               }
                                             }                                                
                                           }
                                         }  
                                         
                                         let promise_one = new Array();                                
                                           //Nếu bill_details_all có dữ liệu và chỉ tháng gần nhất chưa cập nhật 60days thôi, còn nhiều tháng chưa cập nhật 60days thì get dữ liệu từng sản phẩm một về tính toán        
                                           if(bill_details_all && (_array60Days.length ==  vitri + 1)){                                       
                                             promise_one[0] = new Promise(resolve=>{
                                               let _bill_details = new Array();
                                               if(products[i].id_subproduct){  
                                                 _bill_details = bill_details_all.filter((e:any)=>e.id_subproduct === products[i].id_subproduct);
                                               }else{
                                                 _bill_details = bill_details_all.filter((e:any)=>e.id_product === products[i]._id);
                                               }                                                                                      
                                               resolve(_bill_details);                                           
                                             })
                                           }else{                                                                            
                                             if(products[i].id_subproduct){                                             
                                               query1 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}};   
                                               query2 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}};   
                                             }else{                                                       
                                               query1 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}};
                                               query2 = {date: {$gte: new Date(inventory.date), $lt: new Date(_array60Days[_array60Days.length-1])}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}};     
                                             }                                               
                                             //Lấy về các bill_details của các tháng (chưa đc tính 60days) tiếp theo                                  
                                             promise_one[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                                             promise_one[1] = this.getBill_details_byFields(query2, {},{date:1},0);                                         
                                           }
                                         Promise.all(promise_one)
                                             .then((bill_details:any)=>{                                                                          
                                               bill_details = bill_details.flat();                                                                                                                                                 
                                               if(bill_details.length >0){                                                                             
                                                 for(let j=0; j<bill_details.length; j++){                                                                                         
                                                   for(let k= vitri; k <_array60Days.length; k++){                  
                                                     if((new Date(bill_details[j].date)).getTime() < (new Date(products[i][id_branch + '_ivtr'][k].date)).getTime()){                                                   
                                                         if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){                                                     
                                                           if(products[i][id_branch + '_ivtr'][k].lots){
                                                             for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                               if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;                
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                               }
                                                             }
                                                           }
                                                           products[i][id_branch + '_ivtr'][k].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;               
                                                           products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                           products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));

                                                         }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){                                                       
                                                           if(products[i][id_branch + '_ivtr'][k].lots)
                                                             for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                               if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                                 products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                               }
                                                             }
                                                           products[i][id_branch + '_ivtr'][k].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                           products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                           products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                                                             
                                                         }                                   
                                                     }
                                                   }                                                                                 
                                                 }
                                               }
                                                 
                                               for(let k= vitri; k <_array60Days.length; k++){       
                                                 if(products[i][id_branch + '_ivtr'][k].lots){
                                                   for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                     let _slnhaptrongky = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].inquantity_tofirst;
                                                     let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_btax;
                                                     let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_atax;
                                                     products[i][id_branch + '_ivtr'][k].lots[m].stock_first = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst;   
                                                     
                                                     if(_slnhaptrongky ===0){
                                                       products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_btax;
                                                       products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_atax;                                                              
                                                     }else{
                                                       if(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax ===0){
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                       }else{
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax) + _tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                         products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_atax) + _tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                       }
                                                     }
                                                     products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first; 
                                                     products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first;  

                                                     let _slbantrongky = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].outquantity_tofirst;
                                                     let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                     let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                     let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_btax;
                                                     let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_atax;
                                                     products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                     products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                   }    
                                                 }                                     
                                                 let slnhaptrongky = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].inquantity_tofirst;
                                                 let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_btax;
                                                 let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_atax;
                                                 products[i][id_branch + '_ivtr'][k].stock_first = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].outquantity_tofirst;   
                                                                                                     
                                                 if(slnhaptrongky ===0){
                                                   products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_btax;
                                                   products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_atax;
                                                 }else{
                                                   if(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax === 0){                                                            
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);                                                           
                                                   }else{
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax) + tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                     products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_atax) + tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                   }
                                                 }
                                                 products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].stock_first; 
                                                 products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].stock_first;  

                                                 let slbantrongky = products[i][id_branch + '_ivtr'][k].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].outquantity_tofirst;
                                                 let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * slbantrongky;
                                                 let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * slbantrongky;
                                                 let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_btax;
                                                 let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_atax;
                                                 products[i][id_branch + '_ivtr'][k].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                 products[i][id_branch + '_ivtr'][k].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                               }       
                                 
                                               /*let _length = products[i][id_branch + '_ivtr']?.length;
                                               for(let m=_length-12; m>=0; m--){
                                                 let date = new Date(products[i][id_branch + '_ivtr'][m]?.date);
                                                 if((date.getMonth() != 0)&&(date.getMonth() != 6)) products[i][id_branch + '_ivtr'][m] = null;
                                               }                                                
                                               products[i][id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'].filter((e:any)=> e!=null);*/                                              
                                               let value:any = {};  
											                         value[id_branch + '_ivtr'] = products[i][id_branch + '_ivtr']; 
                                               
                                               //cập nhật việc ký sinh tồn kho mới cho các tháng tiếp theo thỏa mãn 60days                                          
                                               this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                                   .then(()=>{                                                                                                                                                 
                                                     resolve(true);
                                                   })
                                             })  
                                       }else{
                                         //kiểm lại lại vt=0 là vô lý
                                         console.log(products[i]._id, 'có vt=0 là vô lý') ;                                    
                                         resolve(null); 
                                       }              
                                    }else{//các tháng đã thỏa 60days rồi ko cần tính nữa   
                                      //Đoạn code dưới này khi nào cần chạy thì bật lên vì rất khó xảy ra (xảy ra khi có người tác động vào dữ liệu), mà chạy hoài thì mỗi lần khởi động 
                                      //phần mềm tốn tài nguyên máy. Sau mỗi tháng cập nhật lại 60days cũng đã kiểm tra vụ này và sai dữ liệu sẽ bị cập nhật null để tính lại ở lần khởi động sau
                                      /*
                                      //Các tháng đã thỏa 60days rồi mà số phần tử trong  products[i][id_branch + '_ivtr'] và trong arrayNew60Days không khớp nhau về length và vị trí
                                      //thì dữ liệu này có thể đã bị sai do nhiều nguyên nhân (hoặc có người tác động vào dữ liệu), nên xóa đi để phần mềm tính toán lại ở lần chạy lại phần mềm tới.                       
                                      for(let n=0; n<arrayNew60Days.length; n++){   
                                        if((new Date(arrayNew60Days[n])).getTime() != (new Date(products[i][id_branch + '_ivtr'][n].date)).getTime()){  
                                          products[i][id_branch + '_ivtr'] = null;
                                          let value:any = {};  
                                          value[id_branch + '_ivtr'] = null;                                          
                                          //cập nhật null cho dữ liệu 60days, để lần khởi động tới giá trị này sẽ đc tính toán lại                                          
                                          this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                          break;
                                        }                                                  
                                      }*/           
                                     
                                      //Đoạn code này cũng giải quyết đc vấn đề trên, nhưng ít tốn tài nguyên máy khi khởi động phần mềm hơn
                                      if(products[i][id_branch + '_ivtr'].length != arrayNew60Days.length){
                                        products[i][id_branch + '_ivtr'] = null;
                                        let value:any = {};  
                                        value[id_branch + '_ivtr'] = null;                                          
                                        //cập nhật null cho dữ liệu 60days, để lần khởi động tới giá trị này sẽ đc tính toán lại                                          
                                        this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                            .then(()=>{                                                                                                                                                 
                                              resolve(null);
                                            })
                                      }else{
                                        resolve(null);
                                      }                                         
                                    }
                              //---------------------------------------------------------------------     
                                  //Nếu trong product nào đó mà chưa có trường inventory thì sẽ được tính toán và thêm vào từ lúc sài phần mềm đến những tháng gần nhất    
                                  }else{//Nếu trong product nào đó mà chưa có trường inventory thì sẽ được tính toán lại và thêm vô    
                                      //console.log('---21', i, products[i][id_branch + '_ivtr']);                                      
                                      let promise_two = new Array();
                                      if(products[i].id_subproduct){                        
                                        query1 = { ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}}; 
                                        query2 = { ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_subproduct: {$eq: products[i].id_subproduct}}; 
                                      }else{                                        
                                        query1 = { ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}}; 
                                        query2 = { ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}, id_product: {$eq: products[i]._id}}; 
                                      }                                        
                                      promise_two[0] = this.getBill_details_byFields(query1, {},{date:1},0);
                                      promise_two[1] = this.getBill_details_byFields(query2, {},{date:1},0);
                                      Promise.all(promise_two)
                                          .then((bill_details:any)=>{                                             
                                            bill_details = bill_details.flat();                                            
                                            products[i][id_branch + '_ivtr'] = new Array();
                                            for(let k=0; k<array60Days.length; k++){    
                                              products[i][id_branch + '_ivtr'][k] = {};
                                              products[i][id_branch + '_ivtr'][k].date = array60Days[k];                                       
                                              products[i][id_branch + '_ivtr'][k].inquantity_tofirst = 0;
                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = 0;
                                              products[i][id_branch + '_ivtr'][k].outquantity_tofirst = 0;
                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = 0;

                                              products[i][id_branch + '_ivtr'][k].stock_first = 0;
                                              products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = 0;
                                              products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = 0;
                                              products[i][id_branch + '_ivtr'][k].profit_first_btax = 0;
                                              products[i][id_branch + '_ivtr'][k].profit_first_atax = 0;

                                              if(products[i].lots){
                                                products[i][id_branch + '_ivtr'][k].lots = new Array();
                                                for(let m=0; m<products[i].lots.length; m++){    
                                                  products[i][id_branch + '_ivtr'][k].lots[m] = {};
                                                  products[i][id_branch + '_ivtr'][k].lots[m]._id = products[i].lots[m]._id;
                                                }
                                                for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){    
                                                  products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = 0;

                                                  products[i][id_branch + '_ivtr'][k].lots[m].stock_first = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = 0;
                                                  products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = 0;

                                                }
                                              }
                                            }
                                            if(bill_details.length >0){
                                              for(let j=0; j<bill_details.length; j++){                                                                                     
                                                for(let k=0; k<products[i][id_branch + '_ivtr'].length; k++){                   
                                                  if((new Date(bill_details[j].date)).getTime() < (new Date(products[i][id_branch + '_ivtr'][k].date)).getTime()){                                                   
                                                      if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){ 
                                                        if(products[i][id_branch + '_ivtr'][k].lots){
                                                          for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                            if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                              products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;          
                                                              products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                              products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                            } 
                                                          } 
                                                        }                                                  
                                                        products[i][id_branch + '_ivtr'][k].outquantity_tofirst = products[i][id_branch + '_ivtr'][k].outquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;          
                                                        products[i][id_branch + '_ivtr'][k].sales_tofirst_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                        products[i][id_branch + '_ivtr'][k].sales_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].sales_tofirst_atax + bill_details[j].price * bill_details[j].quantity  * bill_details[j].ratio * (1 + bill_details[j].tax/100));
                                                      
                                                      }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 9)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){      
                                                        
                                                        if(products[i][id_branch + '_ivtr'][k].lots){
                                                        
                                                          for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                            
                                                            if(products[i][id_branch + '_ivtr'][k].lots[m]._id === bill_details[j].id_lotproduct){
                                                              
                                                              products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                              products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                              products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                            }
                                                          }  
                                                        }  
                                                                                            
                                                        products[i][id_branch + '_ivtr'][k].inquantity_tofirst = products[i][id_branch + '_ivtr'][k].inquantity_tofirst + bill_details[j].quantity * bill_details[j].ratio;
                                                        products[i][id_branch + '_ivtr'][k].pay_tofirst_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax + bill_details[j].price * bill_details[j].quantity;
                                                        products[i][id_branch + '_ivtr'][k].pay_tofirst_atax = this.vhAlgorithm.roundTo3Decimals(products[i][id_branch + '_ivtr'][k].pay_tofirst_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax/100));
                                                                                                          
                                                      }                                   
                                                  }
                                                }                                                                        
                                              }
                                              
                                              for(let k=0; k<products[i][id_branch + '_ivtr'].length; k++){  
                                                if(k===0){
                                                  if(products[i][id_branch + '_ivtr'][k].lots)
                                                    for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                      let _slnhaptrongky = products[i][id_branch + '_ivtr'][0].lots[m].inquantity_tofirst;
                                                      let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].pay_tofirst_btax;
                                                      let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].pay_tofirst_atax;
                                                      products[i][id_branch + '_ivtr'][0].lots[m].stock_first = products[i][id_branch + '_ivtr'][0].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][0].lots[m].outquantity_tofirst;   
                                                      
                                                      if(_slnhaptrongky !=0){
                                                        products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                        products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                        products[i][id_branch + '_ivtr'][0].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][0].lots[m].stock_first; 
                                                        products[i][id_branch + '_ivtr'][0].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][0].lots[m].stock_first;  
                                                      }
                                                      let _slbantrongky = products[i][id_branch + '_ivtr'][0].lots[m].outquantity_tofirst;
                                                      let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                      let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                      let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][0].lots[m].sales_tofirst_btax;
                                                      let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][0].lots[m].sales_tofirst_atax
                                                      products[i][id_branch + '_ivtr'][0].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                      products[i][id_branch + '_ivtr'][0].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                    }
                                                  let slnhaptrongky = products[i][id_branch + '_ivtr'][0].inquantity_tofirst;
                                                  let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][0].pay_tofirst_btax;
                                                  let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][0].pay_tofirst_atax;
                                                  products[i][id_branch + '_ivtr'][0].stock_first = products[i][id_branch + '_ivtr'][0].inquantity_tofirst - products[i][id_branch + '_ivtr'][0].outquantity_tofirst;   
                                                  
                                                  if(slnhaptrongky !=0){
                                                    products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                    products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);
                                                    products[i][id_branch + '_ivtr'][0].cost_stock_first_btax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][0].stock_first; 
                                                    products[i][id_branch + '_ivtr'][0].cost_stock_first_atax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][0].stock_first;  
                                                  }
                                                  let slbantrongky = products[i][id_branch + '_ivtr'][0].outquantity_tofirst;
                                                  let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_btax * slbantrongky;
                                                  let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][0].unit_cost_stock_first_atax * slbantrongky;
                                                  let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][0].sales_tofirst_btax;
                                                  let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][0].sales_tofirst_atax
                                                  products[i][id_branch + '_ivtr'][0].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                  products[i][id_branch + '_ivtr'][0].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                                }else{
                                                  if(products[i][id_branch + '_ivtr'][k].lots){
                                                    for(let m=0; m<products[i][id_branch + '_ivtr'][k].lots.length; m++){   
                                                      let _slnhaptrongky = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].inquantity_tofirst;
                                                      let _tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_btax;
                                                      let _tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].pay_tofirst_atax;
                                                      products[i][id_branch + '_ivtr'][k].lots[m].stock_first = products[i][id_branch + '_ivtr'][k].lots[m].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst;   
                                                      
                                                      if(_slnhaptrongky ===0){
                                                        products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_btax;
                                                        products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].lots[m].unit_cost_stock_first_atax;                                                              
                                                      }else{
                                                        if(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax ===0){
                                                          products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_btax/_slnhaptrongky);
                                                          products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(_tongtiennhaptrongky_atax/_slnhaptrongky);
                                                        }else{
                                                          products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_btax) + _tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                          products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].cost_stock_first_atax) + _tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].lots[m].stock_first) + _slnhaptrongky));
                                                        }
                                                      }
                                                      products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first; 
                                                      products[i][id_branch + '_ivtr'][k].lots[m].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].lots[m].stock_first;  
                                                      let _slbantrongky = products[i][id_branch + '_ivtr'][k].lots[m].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].lots[m].outquantity_tofirst;
                                                      let _tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_btax * _slbantrongky;
                                                      let _tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].unit_cost_stock_first_atax * _slbantrongky;
                                                      let _doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_btax;
                                                      let _doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].lots[m].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].lots[m].sales_tofirst_atax;
                                                      products[i][id_branch + '_ivtr'][k].lots[m].profit_first_btax = _doanhsotrongky_btax - _tonggiavonbantrongky_btax;
                                                      products[i][id_branch + '_ivtr'][k].lots[m].profit_first_atax = _doanhsotrongky_atax - _tonggiavonbantrongky_atax;
                                                    }
                                                  }
                                                  let slnhaptrongky = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].inquantity_tofirst;
                                                  let tongtiennhaptrongky_btax = products[i][id_branch + '_ivtr'][k].pay_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_btax;
                                                  let tongtiennhaptrongky_atax = products[i][id_branch + '_ivtr'][k].pay_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].pay_tofirst_atax;
                                                  products[i][id_branch + '_ivtr'][k].stock_first = products[i][id_branch + '_ivtr'][k].inquantity_tofirst - products[i][id_branch + '_ivtr'][k].outquantity_tofirst;   
                                                  
                                                  if(slnhaptrongky ===0){
                                                    products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_btax;
                                                    products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = products[i][id_branch + '_ivtr'][k-1].unit_cost_stock_first_atax;
                                                  }else{
                                                    if(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax === 0){                                                            
                                                      products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_btax/slnhaptrongky);
                                                      products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(tongtiennhaptrongky_atax/slnhaptrongky);                                                            
                                                    }else{
                                                      products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_btax) + tongtiennhaptrongky_btax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                      products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((Math.abs(products[i][id_branch + '_ivtr'][k-1].cost_stock_first_atax) + tongtiennhaptrongky_atax)/(Math.abs(products[i][id_branch + '_ivtr'][k-1].stock_first) + slnhaptrongky));
                                                    }
                                                  }
                                                  products[i][id_branch + '_ivtr'][k].cost_stock_first_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * products[i][id_branch + '_ivtr'][k].stock_first; 
                                                  products[i][id_branch + '_ivtr'][k].cost_stock_first_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * products[i][id_branch + '_ivtr'][k].stock_first;  
                                                  
                                                  let slbantrongky = products[i][id_branch + '_ivtr'][k].outquantity_tofirst - products[i][id_branch + '_ivtr'][k-1].outquantity_tofirst;
                                                  let tonggiavonbantrongky_btax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_btax * slbantrongky;
                                                  let tonggiavonbantrongky_atax = products[i][id_branch + '_ivtr'][k].unit_cost_stock_first_atax * slbantrongky;
                                                  let doanhsotrongky_btax = products[i][id_branch + '_ivtr'][k].sales_tofirst_btax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_btax;
                                                  let doanhsotrongky_atax = products[i][id_branch + '_ivtr'][k].sales_tofirst_atax - products[i][id_branch + '_ivtr'][k-1].sales_tofirst_atax;
                                                  products[i][id_branch + '_ivtr'][k].profit_first_btax = doanhsotrongky_btax - tonggiavonbantrongky_btax;
                                                  products[i][id_branch + '_ivtr'][k].profit_first_atax = doanhsotrongky_atax - tonggiavonbantrongky_atax;
                                                }
                                              }                                                                                                         
                                            }
                                           
                                            /*let _length = products[i][id_branch + '_ivtr']?.length;
                                            for(let m=_length-12; m>=0; m--){
                                              let date = new Date(products[i][id_branch + '_ivtr'][m]?.date);
                                              if((date.getMonth() != 0)&&(date.getMonth() != 6)) products[i][id_branch + '_ivtr'][m] = null;
                                            }                                                
                                            products[i][id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'].filter((e:any)=> e!=null)*/  
                                            let value:any = {};  
											                      value[id_branch + '_ivtr'] = products[i][id_branch + '_ivtr'];
                                             this.vhMGDB_database.updateDoc('products', products[i].id_subproduct?products[i].id_subproduct:products[i]._id, {...value})
                                                .then(()=>{                                                                                                                                                                                                  
                                                  resolve(true);
                                                })                                      
                                        })
                                  }                                         
                              })                                    
                            }
                          
                            Promise.all(promise_products).then(array_products=>{                                                                          
                              if(array_number.length>0){                                      
                                loop_product = true;    
                                array_10 = array_number.splice(0, 1);  
                              }else{                                      
                                resolve(null);
                                clearInterval(setinterval_product);                                      
                              }            
                            })                                   
                      }
                    },10)
                })
                Promise.all(promise_branch).then(()=>{                                       
                  if(array_branch.length>0){                                      
                    loop_branch = true;    
                    id_branch = array_branch.splice(0, 1)[0];  
                  }else{                      
                    clearInterval(setinterval_branch);  
                    console.log('syncInventoryEveryDay_Stock1stDayOfMonth1');       
                    resolve(null);                                      
                  }    
                })  
              }
            },500);             
          }else{
            console.log('syncInventoryEveryDay_Stock1stDayOfMonth2');    
            resolve(null);   
          }
        })
        resolve(null); 
   })   
 }





/**
* this.vhQuerySales.xoaduthuatronglots()
     .then((bool:any)=>{
         console.log('xoaduthuatronglots', bool);
     },(error:any)=>{
       console.log(error);
     })
*/
public xoaduthuatronglots(){
 return new Promise<any>((resolve, reject) => {  
   let products:any = new Array();   
   products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name'); 
   let promise = new Array();
   for(let i=0; i<products.length; i++){
     if(products[i].manylot){       
       if(products[i].lots) {
         let _lots = cloneDeep(products[i].lots);
         let lots = new Array();
         for(let m = 0; m<products[i].lots.length; m++){
           lots[m] = {};
           lots[m]._id = _lots[m]._id;
           lots[m].barcode = _lots[m].barcode;
           lots[m].date_exp = _lots[m].date_exp;
           lots[m].date_mfg = _lots[m].date_mfg;
           lots[m].hidden = _lots[m].hidden;
           lots[m].lot_number = _lots[m].lot_number;
           lots[m].quantity = _lots[m].quantity;
           lots[m].quantity_branch = _lots[m].quantity_branch;
         }
         if(lots.length>0) promise[promise.length] = this.updateProduct_fw(products[i]._id, {lots})
       }   
     }else{
       console.log('----------koxoa', products[i]);
     }
   }
   Promise.all(promise).then(()=>{    
     console.log('xoaduthuatronglots finished');                
     resolve(true);                                                 
   })
 })
}     

/**
* this.vhQuerySales.xoainventory30to60()
     .then((bool:any)=>{
         console.log('xoainventory30to60', bool);
     },(error:any)=>{
       console.log(error);
     })
*/
public xoainventory30to60(){
 return new Promise<any>((resolve, reject) => {  
   let id_branch = this.getDefaultBranch()._id;     
   let products = this.getlocalDetailProducts(3);    
   let promise = new Array();
   for(let i=0; i<products.length; i++){
      if(products[i][id_branch + '_ivtr'] != undefined) {          
        let data_branch:any = {};
        data_branch[id_branch + '_ivtr'] = null;
        promise[promise.length] = this.updateProduct_fw(products[i]._id, data_branch)
      }
    }
   Promise.all(promise).then(()=>{    
     console.log('xoainventory30to60 finished');                
     resolve(true);                                                 
   })
 })
}
/**
  * Trong quá trình THÊM-XÓA-SỬA có thể xảy ra lỗi bill, bill_detail
  * Hàm này giúp đồng bộ lại dữ liệu và sửa các bill, bill_detail bị lỗi đó
  * @example:
    * this.vhQuerySales.makeCorrectQuantityProducts_byShop()
          .then((bool:any)=>{
            console.log('makeCorrectQuantityProducts_byShop', bool);
          },(error:any)=>{
            console.log(error);
          })
  * @returns 
  */
  public makeCorrectQuantityProducts_byShop(){   
    /**
     * Hàm này get về tất cả dữ liệu từ lúc dùng phần mềm đến tương lại của chi nhánh hiện hữu (default) (với tất cả bill_type liên quan đến xuất,nhập, tồn đầu kỳ [1,10,15,38,41,51,2,3,9,39,30,31]),
     * hàm sẽ tính toán lại, nếu giá trị tồn khác với giá trị tồn tồn trong sản phẩm (trường quantity, quantity_branch) thì sẽ:
     * + Ghi giá trị tồn mới vào sản phẩm
     * + xóa trường inventory trong sản phẩm, sau khi phần mềm khởi động lại, phần mềm sẽ tự động khôi phục lại trường này với giá trị mới (giá trị đúng)
     * */ 
    return new Promise<any>((resolve, reject) => {  
      console.log('makeCorrectQuantityProducts_byShop');
      return resolve(true); 
      let enable_update = true;
        let id_branch = this.getDefaultBranch()._id;             
        let store = this.vhAuth.getStore();  
        let products:any = new Array();   
        products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');        
        //Đoạn code này chỉ cho phep mỗi ngày hàm makeCorrectQuantityProducts_byShop chỉ truy vấn dữ liệu đúng 1 lần,
        //muốn chạy nhiều lần thì xóa giá trị _date_make_correct_quantity_products_byshop trong localstorage của trình duyệt
        let make_correct_quantity_enable = false;
        let date_today = new Date();                  
        date_today.setHours(0);
        date_today.setMinutes(0);
        date_today.setSeconds(0);    
        date_today.setMilliseconds(0);            
        let local_date_make_correct_quantity = this.vhAuth.localStorageGET(id_branch + '_date_make_correct_quantity_products_byshop');          
        if(local_date_make_correct_quantity != null){
          if(local_date_make_correct_quantity != date_today.getTime()){
            make_correct_quantity_enable = true;      
            this.vhAuth.localStorageSET(id_branch + '_date_make_correct_quantity_products_byshop',date_today.getTime());   
          }
        }else{         
          make_correct_quantity_enable = true;  
          this.vhAuth.localStorageSET(id_branch + '_date_make_correct_quantity_products_byshop',date_today.getTime());   
               
        }  
      if(make_correct_quantity_enable){
      //if(true){    
        if(products.length>0){//nhớ kiểm tra có cần thêm sắp xếp asc ko           
          let query1:any ={};  
          let query2:any ={};            
          let promise = new Array();          
         
          query1 = {ptype: {$eq:3}, bill_type: {$in:[1,10,15,38,41,51,2,3,9,39]}, id_branch: {$eq:id_branch}};
          query2 = {bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}};
          promise[0] = this.getBill_details_byFields(query1, {},{date:1},0)        
          promise[1] = this.getBill_details_byFields(query2, {},{date:1},0)     
          Promise.all(promise).then((array:any)=>{            
                  let bill_details = array.flat();                   
                  let promise_products = new Array();      
                  for(let j=0; j<bill_details.length; j++){ 
                    if(bill_details[j].ratio === undefined) console.log('-----------------bill_detail ko có ratio, báo anh Huy nha', bill_details[j]);
                  }          
                  for(let i=0; i<products.length; i++){
                    let unit = this.getUnit_byRatio(products[i].units, 1);                        
                  
                    let record: any ={
                      id_product: products[i]._id,                  
                      name: products[i].name, 
                      img: products[i].img, 
                      type: products[i].type, 

                      ratio: unit.ratio,
                      unit: unit.unit,
                      barcode: unit.barcode,
                                            
                      outquantity: 0,
                      inquantity: 0, 
                      stock_first: 0, 
                      stock_last: 0                      
                    }
                    if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;     
                    if(products[i].lots) {
                      record.lots = [...cloneDeep(products[i].lots)];
                      for(let m = 0; m<record.lots.length; m++){
                        record.lots[m].outquantity = 0;
                        record.lots[m].inquantity = 0;
                        record.lots[m].stock_first = 0;
                        record.lots[m].stock_last = 0;
                      }
                    }        

                    for(let j=0; j<bill_details.length; j++){ 
                      
                      let is_sub_or_product = false;
                      if(products[i].id_subproduct) is_sub_or_product = bill_details[j].id_subproduct === record.id_subproduct;
                      else is_sub_or_product = bill_details[j].id_product === record.id_product;    

                      if(is_sub_or_product){                          
                        if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)||(bill_details[j].bill_type === 38)||(bill_details[j].bill_type === 41)||(bill_details[j].bill_type === 51)){
                          if(record.lots){
                            for(let m=0; m<record.lots.length; m++){
                              if(record.lots[m]._id === bill_details[j].id_lotproduct){                        
                                record.lots[m].outquantity = record.lots[m].outquantity + bill_details[j].quantity * bill_details[j].ratio;                                     
                              }
                            }   
                          }    
                          record.outquantity = record.outquantity + bill_details[j].quantity * bill_details[j].ratio;   

                        }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 31)||(bill_details[j].bill_type === 39)){                             
                          if(record.lots){
                            for(let m=0; m<record.lots.length; m++){
                              if(record.lots[m]._id === bill_details[j].id_lotproduct){                        
                                record.lots[m].inquantity = record.lots[m].inquantity + bill_details[j].quantity * bill_details[j].ratio;                                     
                              }
                            }   
                          } 
                          record.inquantity = record.inquantity + bill_details[j].quantity * bill_details[j].ratio;  

                        }else if(bill_details[j].bill_type === 9){//bill_type_9 là tồn đầu kỳ, ko xem nó là hàng nhập như báo cáo trước đây
                          if(record.lots){
                            for(let m=0; m<record.lots.length; m++){
                              if(record.lots[m]._id === bill_details[j].id_lotproduct){                        
                                record.lots[m].stock_first = record.lots[m].stock_first + bill_details[j].quantity * bill_details[j].ratio;                                     
                              }
                            }   
                          } 
                          record.stock_first = record.stock_first + bill_details[j].quantity * bill_details[j].ratio; 

                        }                                                        
                      }                                                                       
                    }                    
                   
                    if(record.lots){
                      for(let m=0; m<record.lots.length; m++){                                              
                        record.lots[m].stock_last = record.lots[m].stock_first + record.lots[m].inquantity - record.lots[m].outquantity;//ok                 
                      }   
                    } 
                    //record.stock_first = first.stock_first;//ok                               
                    record.stock_last = record.stock_first + record.inquantity - record.outquantity;//ok       

                   //  if(record.id_product === '1sSk4hWrD0eV0sIbbbWx'){
                   //    console.log('stock_first', record.stock_first);
                   //    console.log('inquantity', record.inquantity);
                   //    console.log('outquantity', record.outquantity);
                   //    console.log('stock_last',  record.stock_last);
                   //  }

                    if(products[i]?.quantity_branch[id_branch] !==undefined){
                      let check = false;
                      if(products[i].quantity_branch[id_branch] !=record.stock_last) check = true;
                      if(record.lots){
                        for(let m=0; m<record.lots.length; m++){   
                          if(products[i].lots[m]._id === record.lots[m]._id){
                            if(products[i].lots[m].quantity_branch[id_branch] !=record.lots[m].stock_last) check = true;     
                          }else{
                            console.log('Lỗi hàm makeCorrectQuantityProducts_byShop, báo anh Huy trường hợp này')
                          }            
                        }   
                      }  
                      
                      if(check){                       
                        //xóa inventory của chi nhánh id_branch, sau đó hàm syncCashBookEveryDay_Stock1stDayOfMonth sẽ cập nhật lại lúc khởi động
                        let data_branch:any = {};
                        data_branch[id_branch + '_ivtr'] = null;

                        let quantity_branch:any = {};   
                        quantity_branch = {...products[i].quantity_branch};
                        quantity_branch[id_branch] = record.stock_last;

                        let quantity = 0;
                        for(const p in quantity_branch){
                          quantity = quantity + quantity_branch[p];                          
                        } 
                        if(record.lots){
                          let lots = [...cloneDeep(products[i].lots)];
                          for(let m=0; m<record.lots.length; m++){   
                            if(lots[m]._id === record.lots[m]._id){
                              lots[m].quantity_branch[id_branch] = record.lots[m].stock_last;
                              lots[m].quantity = 0;
                              for(const p in lots[m].quantity_branch){
                                lots[m].quantity = lots[m].quantity + lots[m].quantity_branch[p];                          
                              }                               
                            }else{
                              console.log('Lỗi hàm makeCorrectQuantityProducts_byShop, báo anh Huy trường hợp này')
                            }            
                          }  
                          if(isNaN(quantity)){
                            this.writeLog_ErrorOfFunction('makeCorrectQuantityProducts_byShop', 'Lỗi quantity bị NaN', record)
                          }else{
                            console.log('cập nhật product', products[i]);
                            promise.push(this.updateProduct_fw(products[i]._id, {quantity, quantity_branch, ...data_branch, lots}));  
                          }                              
                        }else{
                          if(isNaN(quantity)){
                            this.writeLog_ErrorOfFunction('makeCorrectQuantityProducts_byShop', 'Lỗi quantity bị NaN', record)
                          }else{
                            console.log('cập nhật product', products[i]);
                            promise.push(this.updateProduct_fw(products[i]._id, {quantity, quantity_branch, ...data_branch}));  
                          }                             
                        }                                                                                                  
                      }else{
                        promise.push(null);
                      }
                    }else{                                         
                        //xóa inventory của chi nhánh id_branch, sau đó hàm syncCashBookEveryDay_Stock1stDayOfMonth sẽ cập nhật lại lúc khởi động
                        let data_branch:any = {};
                        data_branch[id_branch + '_ivtr'] = null;

                        let quantity_branch:any = {};   
                        quantity_branch = {...products[i].quantity_branch};
                        quantity_branch[id_branch] = 0;
                        let quantity = 0;
                        for(const p in quantity_branch){
                          quantity = quantity + quantity_branch[p];                          
                        } 
                        if(record.lots){
                          let lots = [...cloneDeep(products[i].lots)];
                          for(let m=0; m<record.lots.length; m++){                               
                            lots[m].quantity_branch[id_branch] = 0;
                            lots[m].quantity = 0;
                            for(const p in lots[m].quantity_branch){
                              lots[m].quantity = 0;                          
                            }                   
                          }
                          if(isNaN(quantity)){
                            this.writeLog_ErrorOfFunction('makeCorrectQuantityProducts_byShop', 'Lỗi quantity bị NaN', record)
                          }else{
                            console.log('cập nhật product', products[i]);
                            promise.push(this.updateProduct_fw(products[i]._id, {quantity, quantity_branch, ...data_branch, lots})); 
                          }                         
                        }else{
                          if(isNaN(quantity)){
                            this.writeLog_ErrorOfFunction('makeCorrectQuantityProducts_byShop', 'Lỗi quantity bị NaN', record)
                          }else{
                            console.log('cập nhật product', products[i]);
                            promise.push(this.updateProduct_fw(products[i]._id, {quantity, quantity_branch, ...data_branch}));  
                          }                             
                        }                    
                      
                    }                             
                  }

                  Promise.all(promise).then(()=>{    
                    console.log('finished');                
                    resolve(true);                                                 
                  })
                  
                })                              
        }else{
          console.log('server -> products khong ton tai trong CSDL: ');
          resolve(null);           
        } 
      }else{
        resolve(true);        
      }                 
    })    
  }

  private only_onetimes_writeerrorlog = true;
  private writeLog_ErrorOfFunction(function_name:string, note: string, data?:any){
    let obj = {
      date: new Date(),
      function_name,
      note,
      data,
      database: this.vhMGDB_auth.getDatabase(),   
      type: 1 //error of function
    }
    if(this.only_onetimes_writeerrorlog){
      this.only_onetimes_writeerrorlog = false;
      this.vhMGDB_rootdatabase.addDoc('error_logs', obj)
              .then((response)=>{
                console.log('writeLog_ErrorOfFunction succeeded', response);
              },(error:any)=>{
                console.log('error', error);
              })
    }
  }

  /**  
   * Hàm này dùng động bộ dữ liệu theo thuật toán 60day
   * @example:
   * this.vhQuerySales.makeCorrectQuantityProducts_60days()
        .then((json)=>{
          console.log('json', json);
        })
   * @param starttime 
   * @param endtime 
   * @param IDproduct: 'all' or id_product;  
   * @param IDbranch: 'all' or id_branch; 
   * @return Promise Array   * 
   * @Notice bill_type = [1,10,15,30,2,3,9,31]
   */

  public makeCorrectQuantityProducts_60days(){    
    return new Promise<any>((resolve, reject) => {  
      console.log('makeCorrectQuantityProducts_60days');
      return resolve(true); 
      let id_branch = this.getDefaultBranch()._id;
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0 
      }    
        let store = this.vhAuth.getStore();  
        let products:any = new Array();   
        products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalProducts(3), 'name');        
        //console.log('products', products);   
    let query:any;
    let cash = 0;
    let index:any = null;
    let day:any = null;     
    

    if(products[0][id_branch + '_ivtr'] != undefined){
      index = products[0][id_branch + '_ivtr'].length -1;     
      day = new Date(products[0][id_branch + '_ivtr'][index].date);    
    }
        
    if(!day) day = new Date(store.registrationdate);                     
        if(products.length>0){           
          //nhớ kiểm tra có cần thêm sắp xếp asc ko  
          let query:any;            
          let promise = new Array();
          let _ptype = [1,5];      
         
          query = {date: {$gte:day}, bill_type: {$in:[1,10,15,30,2,3,9,31]}, id_branch: {$eq:id_branch}};
          promise[0] = this.getBill_details_byFields(query, {},{date:1},0)        
         
          Promise.all(promise).then((array:any)=>{            
              let bill_details = array.flat();  
              //console.log('bill_details', bill_details);      
              let promise_products = new Array();                
                  for(let i=0; i<products.length; i++){
                    let first = {
                      stock_first: 0,
                      cost_stock_first_btax: 0,
                      cost_stock_first_atax: 0,
                      unit_cost_stock_first_btax: 0,
                      unit_cost_stock_first_atax: 0,
                
                      inquantity_tofirst: 0,
                      outquantity_tofirst: 0,
                      pay_tofirst_btax: 0,
                      pay_tofirst_atax: 0,
                      profit_first_btax: 0,
                      profit_first_atax: 0,
                      sales_tofirst_btax: 0,
                      sales_tofirst_atax: 0   
                    }
                    let product: any ={
                      _id: products[i]._id,
                      name: products[i].name,
                      type: products[i].type,
                      unit: products[i].unit,
                      
                      outquantity: 0,
                      inquantity: 0, 
                      revenue_btax: 0,   
                      revenue_atax: 0,  
                      cost_btax: 0,     
                      cost_atax: 0 
                    }

                    product.stock_first = 0;   
                    product.stock_last = 0;   
                    product.cost_stock_first_btax = 0;   
                    product.cost_stock_first_atax = 0;                          
                    product.cost_stock_last_btax = 0;   
                    product.cost_stock_last_atax = 0;                                 
                    
                    for(let j=0; j<bill_details.length; j++){ 
                      if(bill_details[j].ptype === 3){  
                        if(bill_details[j].id_product === products[i]._id){  
                          let date = new Date(bill_details[j].date);   
                          if((bill_details[j].bill_type === 1)||(bill_details[j].bill_type === 10)||(bill_details[j].bill_type === 15)||(bill_details[j].bill_type === 30)){
                              product.outquantity = product.outquantity + bill_details[j].quantity;                             

                          }else if((bill_details[j].bill_type === 2)||(bill_details[j].bill_type === 3)||(bill_details[j].bill_type === 31)){                             
                              product.cost_btax = product.cost_btax + bill_details[j].price * bill_details[j].quantity; 
                              product.cost_atax = product.cost_atax + bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);  
                              product.inquantity = product.inquantity + bill_details[j].quantity; 

                          }else if(bill_details[j].bill_type === 9){//bill_type_9 là tồn đầu kỳ, ko xem nó là hàng nhập như báo cáo trước đây
                            first.stock_first = first.stock_first + bill_details[j].quantity;
                            first.cost_stock_first_btax = first.cost_stock_first_btax + bill_details[j].price * bill_details[j].quantity;
                            first.cost_stock_first_atax = first.cost_stock_first_atax +  bill_details[j].price * bill_details[j].quantity * (1 + bill_details[j].tax / 100);   
                          }                                                        
                        } 
                      }                                    
                    }
                   
                    if(index !=null) first = {...products[i][id_branch + '_ivtr'][index]};                                     
                    product.stock_first = first.stock_first;//ok                               
                    product.stock_last = product.stock_first + product.inquantity - product.outquantity;//ok                 
                   
                    if(products[i].quantity_branch[id_branch] !=undefined){
                      if(products[i].quantity_branch[id_branch] !=product.stock_last){        
                        let quantity_branch:any = {};   
                        quantity_branch = {...products[i].quantity_branch};
                        quantity_branch[id_branch] = product.stock_last;
                        promise.push(this.updateProduct(products[i]._id, {quantity_branch: quantity_branch}));   
                        //break;                                                                  
                      }
                    }
                    if(first.stock_first!=0){
                      product.cost_stock_first_btax = this.vhAlgorithm.roundTo3Decimals((first.cost_stock_first_btax/first.stock_first) * product.stock_first);
                      product.cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals((first.cost_stock_first_atax/first.stock_first) * product.stock_first);
                    }

                    if(first.stock_first!=0){
                      product.cost_stock_last_btax = this.vhAlgorithm.roundTo3Decimals((first.cost_stock_first_btax/first.stock_first) * product.stock_last);
                      product.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals((first.cost_stock_first_atax/first.stock_first) * product.stock_last);
                    }                

                    if((product.stock_first !=0)||(product.stock_last !=0)||(product.inquantity !=0)||(product.outquantity !=0)){                      
                      product.cost_atax = this.vhAlgorithm.roundTo3Decimals(product.cost_atax);    
                      product.cost_stock_first_atax = this.vhAlgorithm.roundTo3Decimals(product.cost_stock_first_atax);     
                      product.cost_stock_last_atax = this.vhAlgorithm.roundTo3Decimals(product.cost_stock_last_atax);   

                      product.index = json.size + 1;
                      json.docs.push(product);
                      json.size++;                        
                      json.empty = false;   
                    }        
                                    
                  }

                  Promise.all(promise).then(()=>{    
                    console.log('finished');                
                    resolve(json);                             
                    console.log('makeCorrectQuantityProducts_60days', json);
                  })

                  
                })                      
        
        }else{
          console.log('server -> products khong ton tai trong CSDL: ');
          resolve(json);           
        }  
                
    })    
  }

/**
 * @example:
   * this.vhQuerySales.makeCorrectQuantityProducts()
        .then((bool:any)=>{
          console.log('makeCorrectQuantityProducts', bool);
        })
 * @returns 
 */
  public makeCorrectQuantityProducts(){    
    return new Promise<any>((resolve, reject) => {    
      console.log('makeCorrectQuantityProducts');
      return resolve(true);   
      let products = this.getlocalProducts(3);      
      let id_branch = this.getDefaultBranch()._id;
      let query = {ptype: {$eq:3}, id_branch: {$eq:id_branch}, bill_type: {$in:[1,10,15,30,2,3,9,31]}};
      this.getBill_details_byFields(query, {},{date:1},0)      
            .then((bill_details:any)=>{                       
                if((products.length>0)&&(bill_details.length>0)){                     
                  let promise = new Array();             
                  for(let i=0; i<products.length; i++){      
                    let quantity =0;
                    let quantity_branch:any = {};                   
                    quantity_branch[id_branch] = 0;                       
                    for(let j=0; j<bill_details.length; j++){
                      let bill_detail = bill_details[j];
                      if(products[i]._id === bill_detail.id_product){                              
                        if((bill_detail.bill_type ===1)||(bill_detail.bill_type ===10)||(bill_detail.bill_type ===15)||(bill_details[j].bill_type === 30)){
                          quantity = quantity - bill_detail.quantity;
                          quantity_branch[id_branch] = quantity_branch[id_branch] - bill_detail.quantity;                        
                        }else if((bill_detail.bill_type ===2)||(bill_detail.bill_type ===3)||(bill_detail.bill_type ===9)||(bill_details[j].bill_type === 31)){
                          quantity = quantity + bill_detail.quantity;
                          quantity_branch[id_branch] = quantity_branch[id_branch] + bill_detail.quantity;                                   
                        }
                      }        
                    }    
                    // if(quantity_branch[id_branch] !=quantity){                   
                    //   console.log('khác quantity', products[i]); 
                    //   console.log('quantity', quantity); 
                    //   console.log('quantity_branch[id_branch]', quantity_branch[id_branch]);                                                                     
                    // }   
                    if(products[i].quantity_branch[id_branch] !=undefined){
                      if(products[i].quantity_branch[id_branch] !=quantity_branch[id_branch]){                         
                        // console.log('khác 1 quantity_branch', products[i]);   
                        // console.log('products[i].quantity_branch[id_branch]', products[i].quantity_branch[id_branch]);   
                        // console.log('quantity_branch[id_branch]', quantity_branch[id_branch]);    
                        //promise.push(this.updateProduct(products[i]._id, {quantity_branch: quantity_branch}));                                                                               
                      }
                    }else{
                      //if(products[i].quantity !=0)  console.log('khác quantity', products[i]);  
                      //console.log('khác quantity', products[i]);      
                    }

                    //let check_quantity = false;
                    // if(products[i].quantity !=quantity){              
                    //   check_quantity = true;   
                    //   console.log('khác quantity', products[i]);                                                                     
                    // }

                    // let check_quantity_branch = false;
                    // if(products[i].quantity_branch[id_branch] !=undefined)
                    //   if(products[i].quantity_branch[id_branch] !=quantity_branch[id_branch]){              
                    //     check_quantity_branch = true;      
                    //     console.log('khác quantity_branch', products[i]);                                                                         
                    //   }
                    
                         
                    //if(check){      
                      //console.log('products[i]', products[i]);     
                   //   promise.push(new Promise(resolve=>{resolve(null)}));                                              
                //      promise.push(this.updateProduct(products[i]._id, {quantity_branch: quantity_branch}));                                
                    //}
                  }
                  Promise.all(promise).then(()=>{    
                    console.log('finished');                
                    resolve(null);
                  })
                }else resolve(null);              
              })
    })
  }
  //Có thể bỏ hàm này vì làm cho nhiều chi nhánh vừa khó vừa ko cần thiết
  private makeCorrectQuantityProductsManyBranch(){    
    return new Promise<any>((resolve, reject) => {      
       console.log('makeCorrectQuantityProductsManyBranch');
      let products = this.getlocalProducts(3);        
      let branchs = this.getlocalBranchs();
      let query = {ptype: {$eq:3}, bill_type: {$in:[1,10,15,30,2,3,9,31]}};
      this.getBill_details_byFields(query, {},{date:1},0)      
            .then((bill_details:any)=>{                       
                if((products.length>0)&&(bill_details.length>0)){                     
                  let promise = new Array();             
                  for(let i=0; i<products.length; i++){      
                    let quantity =0;
                    let quantity_branch:any = {};
                    for(let m=0; m<branchs.length; m++){
                      quantity_branch[branchs[m]._id] = 0;                      
                    }
                    for(let j=0; j<bill_details.length; j++){
                      let bill_detail = bill_details[j];
                      if(products[i]._id === bill_detail.id_product){                              
                        if((bill_detail.bill_type ===1)||(bill_detail.bill_type ===10)||(bill_detail.bill_type ===15)||(bill_details[j].bill_type === 30)){
                          quantity = quantity - bill_detail.quantity;
                          if(quantity_branch[bill_detail.id_branch] !=undefined) quantity_branch[bill_detail.id_branch] = quantity_branch[bill_detail.id_branch] - bill_detail.quantity;
                          else quantity_branch[bill_detail.id_branch] = - bill_detail.quantity; 
                        }else if((bill_detail.bill_type ===2)||(bill_detail.bill_type ===3)||(bill_detail.bill_type ===9)||(bill_details[j].bill_type === 31)){
                          quantity = quantity + bill_detail.quantity;
                          if(quantity_branch[bill_detail.id_branch] !=undefined) {
                            quantity_branch[bill_detail.id_branch] = quantity_branch[bill_detail.id_branch] + bill_detail.quantity;                            
                          }
                          else {                            
                            quantity_branch[bill_detail.id_branch] = bill_detail.quantity; 
                          }                          
                        }
                      }        
                    }       
                    let check = false;
                    if(products[i].quantity !=quantity){              
                      check = true;                                                                   
                    }
                    for(const p in products[i].quantity_branch){
                      for(const q in quantity_branch){
                        if(p === q){
                          if(products[i].quantity_branch[p] === quantity_branch[q]){
                            check = true;   
                          }
                        }
                      }
                    }                   
                    if(check){      
                      console.log('products[i]', products[i]);     
                      promise.push(new Promise(resolve=>{resolve(null)}));                                              
                      //promise.push(this.updateProduct(products[i]._id, {quantity:quantity, quantity_branch: quantity_branch}));                                
                    }
                  }
                  Promise.all(promise).then(()=>{                    
                    resolve(null);
                  })
                }else resolve(null);              
              })
    })
  }

    /**
   * VhQuerySales
   * lấy về danh sách sản phẩm sắp hết hàng theo chi nhánh
   * @example:
   * this.vhQuerySales.getReportProducts_byLowInStock()
          .then((products)=>{
            console.log(products);
          })
   * @param id_branch   
   */
  public getReportProducts_byLowInStock(id_branch:any){
    return new Promise<any>((resolve, reject) => {          
      let products = this.getlocalDetailProducts(3);                             
      let lowinstock = new Array();              
      for(let i=0; i<products.length; i++){                 
        let unit = this.getUnit_byRatio(products[i].units, 1);                                        
        let record:any ={   
          id_product: products[i]._id,                  
          name: products[i].name, 
          img: products[i].img,   
          unit: unit.unit,
          barcode: unit.barcode,    
          price: unit.price,
          price2: unit.price2,
          price_import: unit.price_import,
          quantity: 0                                   
        }                                                  
        if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;   
        if(products[i].lots) {
          record.lots = new Array();
          for(let m=0; m<products[i].lots.length; m++){  
            let lot:any = {
              _id: products[i].lots[m]._id,
              barcode: products[i].lots[m].barcode,
              date_exp: products[i].lots[m].date_exp,
              date_mfg: products[i].lots[m].date_mfg,
              lot_number: products[i].lots[m].lot_number
            }
            if(products[i].lots[m].quantity_branch[id_branch]) {
              lot.quantity = products[i].lots[m].quantity_branch[id_branch];
              record.lots.push(lot);
            }
          }         
        } 
        if(products[i].quantity_branch){
          if(products[i].quantity_branch[id_branch] != undefined){
            if(products[i].quantity_branch[id_branch] <= products[i].warning_number){
              record.quantity =products[i].quantity_branch[id_branch];
              lowinstock.push(record);
            }            
          }
        }else{
          //console.log('--------------------products[i]', products[i]);     
        }
      }      
      resolve(lowinstock);                                   
    })
  } 

  /**
   * VhQuerySales:
   * lấy về danh sách sản phẩm đã hết hàng theo chi nhánh
   * @example:
   * this.vhQuerySales.getReportProducts_byOutOfStock()
          .then((products)=>{
            console.log(products);
          })
   * @param id_branch
   */
  public getReportProducts_byOutOfStock(id_branch:string){
    return new Promise<any>((resolve, reject) => {          
      let products = this.getlocalDetailProducts(3);                              
      let outofstock = new Array();              
      for(let i=0; i<products.length; i++){              
        let unit = this.getUnit_byRatio(products[i].units, 1);                                        
        let record:any ={   
          id_product: products[i]._id,                  
          name: products[i].name, 
          img: products[i].img,   
          unit: unit.unit,
          barcode: unit.barcode,    
          price: unit.price,
          price2: unit.price2,
          price_import: unit.price_import,
          quantity: 0                                   
        }                                                  
        if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;   
        if(products[i].lots) {
          record.lots = new Array();
          for(let m=0; m<products[i].lots.length; m++){  
            let lot:any = {
              _id: products[i].lots[m]._id,
              barcode: products[i].lots[m].barcode,
              date_exp: products[i].lots[m].date_exp,
              date_mfg: products[i].lots[m].date_mfg,
              lot_number: products[i].lots[m].lot_number
            }
            if(products[i].lots[m].quantity_branch[id_branch]) {
              lot.quantity = products[i].lots[m].quantity_branch[id_branch];
              record.lots.push(lot);
            }
          }         
        } 
        if(products[i].quantity_branch[id_branch] !=undefined){
          if(products[i].quantity_branch[id_branch] <= 0){
            record.quantity =products[i].quantity_branch[id_branch];
            outofstock.push(record);
          }            
        }
      }
      console.log('getReportProducts_byOutOfStock');
      resolve(outofstock);                                   
    })
  }  

  /**
   * VhQuerySales: đã check
   * @example:
   * let hour_array: Array<any> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
   * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportRevenue_byHoursOut_hourArray(starttime, endtime, hour_array)
        .then((reportRevenue)=>{
          console.log('reportRevenue', reportRevenue);
          console.log('reportRevenue.docs[0]', reportRevenue.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param hour_array 
   * @param IDbranch : 'all' or id_branch
   */
  public getReportRevenue_byHoursOut_hourArray(starttime:any, endtime:any, hour_array:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                  
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,
          revenue: 0                
        }            
        let query:any;     
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11,15,34,40,50]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11,15,34,40,50]}, id_branch: {$eq:IDbranch}};          
        }
        this.getBills_byFields(query, {},{date:1},0) 
            .then((bills:any)=>{                                       
                if(bills.length >0){ 
                  let data = new Array();
                  for(let h=0; h < hour_array.length; h++){
                    data[h] =  {};           
                    data[h].revenue = 0;                                                                                                      
                  }
                  for(let j=0; j<bills.length; j++){
                    let bill = {...bills[j]};
                    if(bill.date) {                         
                      let hour = (new Date(bill.date)).getHours();                                                                   
                      for(let h=0; h < hour_array.length; h++){
                        if(hour_array[h]=== hour){                        
                          data[h].revenue = data[h].revenue + Number(bill.payment);  
                          json.revenue = json.revenue + Number(bill.payment);
                        }                                    
                      }                                
                    }                
                  }                                 
                  json.docs = data;
                  json.size = hour_array.length;                        
                  json.empty = false;                                   
                }
                resolve(json);   
            })               
    })    
  }

  /**
   * VhQuerySales: đã check
   * @example:
   * let day_array: Array<any> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
   * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportRevenue_byDaysOut_dayArray(starttime, endtime, day_array)
        .then((reportRevenue)=>{
          console.log('reportRevenue', reportRevenue);
          console.log('reportRevenue.docs[0]', reportRevenue.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param day_array 
   * @param IDbranch : 'all' or id_branch
   * @notice Doanh thu thì ko có thuế
   */
  public getReportRevenue_byDaysOut_dayArray(starttime:any, endtime:any, day_array:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                  
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,
          revenue: 0                 
        }         
        //nhớ kiểm tra có cần thêm sắp xếp asc ko  
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11,15,34,40,50]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11,15,34,40,50]}, id_branch: {$eq:IDbranch}};
        }  
        this.getBills_byFields(query, {},{date:1},0)      
            .then((bills:any)=>{                                         
                if(bills.length >0){ 
                  let data = new Array();
                  for(let d=0; d < day_array.length; d++){
                    data[d] =  {};            
                    data[d].revenue = 0;                                                                                                    
                  }
                  for(let j=0; j<bills.length; j++){
                    let bill = bills[j];
                    if(bill.date) {                         
                      let day = (new Date(bill.date)).getDate();//bill.date.toDate().getDate();                                                                              
                      for(let d=0; d < day_array.length; d++){
                        if(day_array[d]=== day){                        
                          data[d].revenue = data[d].revenue + Number(bill.payment);  
                          json.revenue = json.revenue + Number(bill.payment);
                        }                                    
                      }                                
                    }                
                  }                                 
                  json.docs = data;
                  json.size = day_array.length;                        
                  json.empty = false;                                   
                }
                resolve(json);   
            })               
    })    
  } 
  
  /**
   * VhQuerySales: đã check
   * @example:
   * let month_array: Array<any> = [0,1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
   * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportRevenue_byMonthsOut_monthArray(starttime, endtime, month_array)
        .then((reportRevenue)=>{
          console.log('reportRevenue', reportRevenue);
          console.log('reportRevenue.docs[0]', reportRevenue.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param month_array 
   * @param IDbranch : 'all' or id_branch
   */
  public getReportRevenue_byMonthsOut_monthArray(starttime:any, endtime:any, month_array:any, IDbranch?:string){
   return new Promise<any>((resolve, reject) => {                  
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,
          revenue: 0                
        }         
        //nhớ kiểm tra có cần thêm sắp xếp asc ko      
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11,15,34,40,50]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11,15,34,40,50]}, id_branch: {$eq:IDbranch}};
        }     
        this.getBills_byFields(query, {},{date:1},0)
            .then((bills:any)=>{                                 
                if(bills.length >0){ 
                  let data = new Array();
                  for(let m=0; m < month_array.length; m++){
                    data[m] =  {};    
                    data[m].revenue = 0;                                                                                                                     
                  }
                  for(let j=0; j<bills.length; j++){
                    let bill = bills[j];
                    if(bill.date) {                         
                      let month = (new Date(bill.date)).getMonth();                                                                             
                      for(let m=0; m < month_array.length; m++){
                        if(month_array[m]=== month){                        
                          data[m].revenue = data[m].revenue + Number(bill.payment);  
                          json.revenue = json.revenue + Number(bill.payment);
                        }                                    
                      }                                
                    }                
                  }                                 
                  json.docs = data;
                  json.size = month_array.length;                        
                  json.empty = false;                                   
                }
                resolve(json);   
            })               
    })    
  } 

   /**   
   * lấy về mảng json.docs(array) doanh thu theo một hoặc tất cả các chi nhánh
   * @example:  
    this.vhQuerySales.getReportRevenue_byIDbranch(starttime, endtime, 'dfs3fw3tr3g2a1rgmfg2h1')
        .then((reportRevenue)=>{
          console.log('reportRevenue', reportRevenue);
          console.log('reportRevenue.docs[0]', reportRevenue.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param IDbranch : 'all' or id_branch
   * @return : 
   * json = {docs(array), empty(boolean), size(number), revenue(number)}
   * trong đó docs = [{name(string), id_branch(string), revenue(number)}]
   */
  public getReportRevenue_byIDbranch(starttime:any, endtime:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                     
         let json: any={
           docs:  new Array(),
           empty: true,
           size: 0,
           revenue: 0                
         }                  
         let branchs:any = new Array();    
         let query:any;
         if((IDbranch==='all')||(IDbranch===undefined)){
            branchs = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalBranchs(), 'name');  
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11,15,34,40,50]}};
         }else{
            let branch = this.getlocalBranch(IDbranch);            
            branchs.push(branch);
            query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,7,10,11,15,34,40,50]}, id_branch: {$eq:IDbranch}};
         }     
         this.getBills_byFields(query, {},{date:1},0)
             .then((bills:any)=>{                                 
                 if(bills.length >0){ 
                  let data = new Array();              
                  for(let j=0; j<branchs.length; j++){
                    data[j] = {};
                    data[j].id_branch = branchs[j]._id;
                    data[j].name = branchs[j].name;
                    data[j].revenue = 0;
                  }       
                   for(let i=0; i<bills.length; i++){                                                              
                    for(let j=0; j<branchs.length; j++){                     
                      if(branchs[j]._id === bills[i].id_branch){                        
                        data[j].revenue = data[j].revenue + Number(bills[i].payment);  
                        json.revenue = json.revenue + Number(bills[i].payment);
                      }                                    
                    }                                  
                   }                                 
                   json.docs = data;
                   json.size = branchs.length;                        
                   json.empty = false;                                   
                 }
                 resolve(json);   
             })               
     })    
  } 
  
  /**
   * Báo cáo doanh số giờ
   * @example:
   * let hour_array: Array<any> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
   * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_byHoursOut_hourArray(starttime, endtime, hour_array)
        .then((reportSales)=>{
          console.log('reportSales', reportSales);
          console.log('reportSales.docs[0]', reportSales.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param hour_array 
   * @param IDbranch : 'all' or id_branch
   */
  public getReportSales_byHoursOut_hourArray(starttime:any, endtime:any, hour_array:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                  
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,
          sales_btax: 0,
          sales_atax: 0                 
        }         
        //nhớ kiểm tra có cần thêm sắp xếp asc ko    
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}, id_branch: {$eq:IDbranch}};
        } 
        
        this.getBill_details_byFields(query, {},{date:1},0)
            .then((vhbill_details:any)=>{                
                if(vhbill_details.length>0){                    
                    let data = new Array();
                    for(let h=0; h < hour_array.length; h++){
                      data[h] =  {};            
                      data[h].sales_btax = 0;  
                      data[h].sales_atax = 0;                                                                                                    
                    }
                    for(let j=0; j<vhbill_details.length; j++){
                      let vhbill_detail = {...vhbill_details[j]};
                      if(vhbill_detail.date) {                         
                        let hour = (new Date(vhbill_detail.date)).getHours();                                                                              
                        for(let h=0; h < hour_array.length; h++){
                          if(hour_array[h]=== hour){             
                            if(vhbill_detail.bill_type === 3){
                              data[h].sales_btax = data[h].sales_btax - Number(vhbill_detail.price) * vhbill_detail.quantity; 
                              data[h].sales_atax = data[h].sales_atax - Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100); 
                              json.sales_btax = json.sales_btax - Number(vhbill_detail.price) * vhbill_detail.quantity;
                              json.sales_atax = json.sales_atax - Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100);  
                            }else{
                              data[h].sales_btax = data[h].sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;  
                              data[h].sales_atax = data[h].sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100); 
                              json.sales_btax = json.sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;
                              json.sales_atax = json.sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100); 
                            }                                                                                                                             
                          }                                    
                        }                                
                      }                
                    }                                 
                    json.docs = data;
                    json.size = hour_array.length;                        
                    json.empty = false;                                   
                }                
                resolve(json);   
            })               
    })    
  }   

  /**
   * Báo cáo doanh số ngày
   * @example:
   * let day_array: Array<any> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
   * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_byDaysOut_dayArray(starttime, endtime, day_array)
        .then((reportSales)=>{
          console.log('reportSales', reportSales);
          console.log('reportSales.docs[0]', reportSales.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param hour_array 
   * @param IDbranch : 'all' or id_branch
   */
  public getReportSales_byDaysOut_dayArray(starttime:any, endtime:any, day_array:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                  
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,
          sales_btax: 0,
          sales_atax: 0                 
        }               
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}, id_branch: {$eq:IDbranch}};
        }
        
        this.getBill_details_byFields(query, {},{date:1},0)   
            .then((vhbill_details:any)=>{              
              if(vhbill_details.length>0){                       
                  let data = new Array();
                  for(let d=0; d < day_array.length; d++){
                    data[d] =  {};            
                    data[d].sales_btax = 0;  
                    data[d].sales_atax = 0;                                                                                                    
                  }
                  for(let j=0; j<vhbill_details.length; j++){
                    let vhbill_detail = {...vhbill_details[j]};
                    if(vhbill_detail.date) {                         
                      let day = (new Date(vhbill_detail.date)).getDate();                                                                                      
                      for(let d=0; d < day_array.length; d++){
                        if(day_array[d]=== day){  
                          if(vhbill_detail.bill_type === 3){
                            data[d].sales_btax = data[d].sales_btax - Number(vhbill_detail.price) * vhbill_detail.quantity;  
                            data[d].sales_atax = data[d].sales_atax - Number(vhbill_detail.price) * vhbill_detail.quantity *(1 + vhbill_detail.tax / 100); 
                            json.sales_btax = json.sales_btax - Number(vhbill_detail.price) * vhbill_detail.quantity;
                            json.sales_atax = json.sales_atax - Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100); 
                          }else{
                            data[d].sales_btax = data[d].sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;  
                            data[d].sales_atax = data[d].sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity *(1 + vhbill_detail.tax / 100); 
                            json.sales_btax = json.sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;
                            json.sales_atax = json.sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100); 
                          }                                                                                                                                      
                        }                                    
                      }                                
                    }                
                  }                                 
                  json.docs = data;
                  json.size = day_array.length;                        
                  json.empty = false;                                   
                }                
                resolve(json);   
            })               
    })    
  }   

  /**
   * Báo cáo doanh số tháng
   * lấy về mảng json.docs(array) doanh số theo 12 tháng trong năm
   * @example:
   * let month_array: Array<any> = [0,1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
   * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportSales_byMonthsOut_monthArray(starttime, endtime, month_array)
        .then((reportSales)=>{
          console.log('reportSales', reportSales);
          console.log('reportSales.docs[0]', reportSales.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param hour_array 
   * @param IDbranch : 'all' or id_branch
   */
  public getReportSales_byMonthsOut_monthArray(starttime:any, endtime:any, month_array:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                  
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,
          sales_btax: 0,
          sales_atax: 0                 
        }         
        //nhớ kiểm tra có cần thêm sắp xếp asc ko 
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}};
        }else{
          query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}, id_branch: {$eq:IDbranch}};         
        }
       
        this.getBill_details_byFields(query, {},{date:1},0)     
            .then((vhbill_details:any)=>{
              if(vhbill_details.length>0){       
                  let data = new Array();
                  for(let m=0; m < month_array.length; m++){
                    data[m] =  {};            
                    data[m].sales_btax = 0;  
                    data[m].sales_atax = 0;                                                                                                    
                  }
                  for(let j=0; j<vhbill_details.length; j++){
                    let vhbill_detail = vhbill_details[j];
                    if(vhbill_detail.date) {                         
                      let month = (new Date(vhbill_detail.date)).getMonth();                                                                               
                      for(let m=0; m < month_array.length; m++){
                        if(month_array[m]=== month){    
                          if(vhbill_detail.bill_type === 3){
                            data[m].sales_btax = data[m].sales_btax - Number(vhbill_detail.price) * vhbill_detail.quantity;   
                            data[m].sales_atax = data[m].sales_atax - Number(vhbill_detail.price) * vhbill_detail.quantity *(1 + vhbill_detail.tax / 100); 
                            json.sales_btax = json.sales_btax - Number(vhbill_detail.price) * vhbill_detail.quantity;
                            json.sales_atax = json.sales_atax - Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100);
                          }else{
                            data[m].sales_btax = data[m].sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;  
                            data[m].sales_atax = data[m].sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity *(1 + vhbill_detail.tax / 100); 
                            json.sales_btax = json.sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;
                            json.sales_atax = json.sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100);
                          }                                                                                                                                     
                        }                                    
                      }                                
                    }                
                  }                                 
                  json.docs = data;
                  json.size = month_array.length;                        
                  json.empty = false;                                   
                }
                resolve(json);   
            })               
    })    
  } 

   /**
    * Báo cáo doanh số chi nhánh, tất cả chi nhánh
   * lấy về mảng json.docs(array) doanh số theo một hoặc tất cả các chi nhánh
   * @example:
    this.vhQuerySales.getReportSales_byIDbranch(starttime, endtime, 'fda3s2fd1a3sgghdfg1h')
        .then((reportSales)=>{
          console.log('reportSales', reportSales);
          console.log('reportSales.docs[0]', reportSales.docs[0]);
        })
   * @param starttime 
   * @param endtime 
   * @param IDbranch : 'all' or id_branch
   * @return : 
   * json = {docs(array), empty(boolean), size(number), sales_btax(number), sales_atax(number)}
   * trong đó docs = [{name(string), id_branch(string), sales_btax(number), sales_atax(number)}]
   */
  public getReportSales_byIDbranch(starttime:any, endtime:any, IDbranch?:string){
    return new Promise<any>((resolve, reject) => {                  
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,
          sales_btax: 0,
          sales_atax: 0                 
        }         
        let branchs:any = new Array();    
        let query:any;
        if((IDbranch==='all')||(IDbranch===undefined)){
           branchs = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalBranchs(), 'name');  
           query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}};
        }else{
           let branch = this.getlocalBranch(IDbranch);            
           branchs.push(branch);
           query = {date: {$gte:starttime, $lte:endtime}, bill_type: {$in:[1,3,15,40,50]}, id_branch: {$eq:IDbranch}};  
        }     
       
        this.getBill_details_byFields(query, {},{date:1},0)     
            .then((vhbill_details:any)=>{
              if(vhbill_details.length>0){       
                  let data = new Array();     
                  for(let j=0; j<branchs.length; j++){
                    data[j] = {};
                    data[j].id_branch = branchs[j]._id;
                    data[j].name = branchs[j].name;
                    data[j].sales_btax = 0;
                    data[j].sales_atax = 0;
                  }             
                  for(let i=0; i<vhbill_details.length; i++){
                    let vhbill_detail = vhbill_details[i];                                                                                            
                    for(let j=0; j<branchs.length; j++){                      
                      if(branchs[j]._id=== vhbill_detail.id_branch){    
                        if(vhbill_detail.bill_type === 3){
                          data[j].sales_btax = data[j].sales_btax - Number(vhbill_detail.price) * vhbill_detail.quantity; 
                          data[j].sales_atax = data[j].sales_atax - Number(vhbill_detail.price) * vhbill_detail.quantity *(1 + vhbill_detail.tax / 100); 
                          json.sales_btax = json.sales_btax - Number(vhbill_detail.price) * vhbill_detail.quantity;
                          json.sales_atax = json.sales_atax - Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100);
                        }else{
                          data[j].sales_btax = data[j].sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;  
                          data[j].sales_atax = data[j].sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity *(1 + vhbill_detail.tax / 100); 
                          json.sales_btax = json.sales_btax + Number(vhbill_detail.price) * vhbill_detail.quantity;
                          json.sales_atax = json.sales_atax + Number(vhbill_detail.price) * vhbill_detail.quantity * (1 + vhbill_detail.tax / 100);
                        }                                                                                                                                     
                      }                                    
                    }                                  
                  }                                 
                  json.docs = data;
                  json.size = branchs.length;                        
                  json.empty = false;                                   
              }
              resolve(json);   
            })               
    })    
  } 
 

  /**   
   * VhQuerySales: đã check
   * cashbook_first: tiền mặt đầu kỳ (starttime),
   * income: tiền thu trong kỳ
   * expenditure: tiền chi trong kỳ
   * cashbook_last: tiền mặt cuối kỳ (endtime)  
   * IDwallet = 'all' hoặc id_wallet của ví nào đó
   * @param IDbranch : 'all' or id_branch
   * @notice : ở giao diện APP, chọn IDbranch rồi mới hiện ra những IDwallet của chi nhánh đó để chọn tiếp. Nếu IDbranch = 'all' thì IDwallet phải là 'all'
   */
  public getReportCashBook(starttime:any, endtime:any, IDwallet:any, IDbranch?:any){        
    starttime = new Date(starttime); endtime = new Date(endtime);
    let array_bill_type = [1,7,10,11,15,34,40,50,2,3,8,12,33];    
    let store = this.vhAuth.getStore(); 
    return new Promise((resolve, reject) => {                
      let query:any;
      let cash = 0;
      let day:any = null;
      if(IDwallet==='all'){ 
          if((IDbranch==='all')||(IDbranch===undefined)){//ok
            let wallets = this.getlocalWallets(); 
            let id_branch:any = this.getDefaultBranch()._id;            
            let index:any = null;
            for(let i=0; i<wallets.length; i++){
              if(wallets[i]._id === 'id_cash'){
                if((wallets[i][IDbranch] !=undefined)&&(wallets[i][IDbranch].cashbook !=undefined))
                for(let k=0; k<wallets[i][id_branch].cashbook.length; k++){
                  if((new Date(wallets[i][id_branch].cashbook[k].date)).getTime() > starttime.getTime()){
                    break;
                  }else{
                    day = new Date(wallets[i][id_branch].cashbook[k].date);                 
                    index = k;
                  }
                }                           
              }
            }              
            if(day){
              for(let i=0; i<wallets.length; i++){
                if(wallets[i]._id === 'id_cash'){
                  let branchs = this.getlocalBranchs();                  
                  for(let j=0; j<branchs.length; j++){
                    cash = cash + wallets[i][branchs[j]._id].cashbook[index].cashbook_first;
                  }                
                }else{
                  cash = cash + wallets[i].cashbook[index].cashbook_first;
                }
              }
            }              
          }else{//ok            
            let wallets = this.getlocalWallets().filter((item:any)=> {if(item.id_branch === IDbranch) return true; else if(item._id === 'id_cash') return true; else return false}); 
            let index:any = null;
            for(let i=0; i<wallets.length; i++){
              if(wallets[i]._id === 'id_cash'){
                if((wallets[i][IDbranch] !=undefined)&&(wallets[i][IDbranch].cashbook !=undefined))
                for(let k=0; k<wallets[i][IDbranch].cashbook.length; k++){
                  if((new Date(wallets[i][IDbranch].cashbook[k].date)).getTime() > starttime.getTime()){
                    break;
                  }else{
                    day = new Date(wallets[i][IDbranch].cashbook[k].date);                 
                    index = k;
                  }
                }                            
              }
            }              
            if(day){
              for(let i=0; i<wallets.length; i++){
                if(wallets[i]._id === 'id_cash'){
                  cash = cash + wallets[i][IDbranch].cashbook[index].cashbook_first;
                }else{
                  cash = cash + wallets[i].cashbook[index].cashbook_first;
                }
              }
            }                   
          }
      }else{
          if((IDbranch==='all')||(IDbranch===undefined)){
            console.log('trường hợp này chưa có hàm, liên hệ anh Huy viết');
            //Trương hợp này thực tế chưa sửa dụng
          }else{ 
            let wallet:any = this.getlocalWallet(IDwallet);
            if(wallet._id === 'id_cash'){
              if((wallet[IDbranch] !=undefined)&&(wallet[IDbranch].cashbook !=undefined))
              for(let k=0; k<wallet[IDbranch].cashbook.length; k++){
                if((new Date(wallet[IDbranch].cashbook[k].date)).getTime() > starttime.getTime()){
                  break;
                }else{
                  day = new Date(wallet[IDbranch].cashbook[k].date);
                  cash = wallet[IDbranch].cashbook[k].cashbook_first;
                }
              }                                   
            }else{//ok
              if(wallet.cashbook !=undefined)
              for(let k=0; k<wallet.cashbook.length; k++){
                if((new Date(wallet.cashbook[k].date)).getTime() > starttime.getTime()){
                  break;
                }else{
                  day = new Date(wallet.cashbook[k].date);
                  cash = wallet.cashbook[k].cashbook_first;
                }
              }                           
            }
          }
      }
      
      if(!day) day = new Date(store.registrationdate);      
     
      let promise = new Array();      
      while (array_bill_type.length) {      
        let array_10_bill_type = array_bill_type.splice(0, 10);  
        if(IDwallet==='all'){       
          if((IDbranch==='all')||(IDbranch===undefined)){
            let query_zero = {date:{$gte:day, $lte:endtime}, bill_type: {$in:array_10_bill_type}, payment_type:{$eq:1}}; //ok
            let query_one = {date:{$gte:day, $lte:endtime}, bill_type: {$in:array_10_bill_type}, payment_type:{$eq:3}}; //ok   
            promise.push(this.getBills_byFields(query_zero, {},{date:1},0));  
            promise.push(this.getBills_byFields(query_one, {},{date:1},0));       
          }else{
            let query_zero = {date:{$gte:day, $lte:endtime}, id_branch: {$eq:IDbranch}, bill_type: {$in:array_10_bill_type}, payment_type:{$eq:1}}; //ok
            let query_one = {date:{$gte:day, $lte:endtime}, id_branch: {$eq:IDbranch}, bill_type: {$in:array_10_bill_type}, payment_type:{$eq:3}}; //ok   
            promise.push(this.getBills_byFields(query_zero, {},{date:1},0));  
            promise.push(this.getBills_byFields(query_one, {},{date:1},0));      
          }
        }else{        
          if((IDbranch==='all')||(IDbranch===undefined)){

          }else{
            query = {date:{$gte:day, $lte:endtime}, id_wallet:{$eq:IDwallet}, id_branch: {$eq:IDbranch}, bill_type: {$in:array_10_bill_type}};//ok   
            promise.push(this.getBills_byFields(query, {},{date:1},0));             
          }
        }      
       
        //console.log('query1', query);
        //console.log('cash', cash);
      }   
        
   
      Promise.all(promise).then((_bills:any)=>{ 
        //console.log('_bills', _bills);                      
            let bills = _bills.flat();          
            bills = this.vhAlgorithm.sortDatebyASC(bills, 'date')                
            let json: any={
              docs:  new Array(),
              empty: true,
              size: 0,              
              cashbook_first: cash,
              income: 0,
              expenditure: 0,
              cashbook_last: 0 
            }         
           
            if(bills.length >0){ 
              for(let i=0; i<bills.length; i++){          
                let bill = {...bills[i]};        
                
                if(bill?.payment_type != 2){
                  delete bill.fee; delete bill.discount; delete bill.note; delete bill.total;  delete bill.tax;                  
                  let date = new Date(bill.date);                 
                  //thu tiền
                  if((bill.bill_type === 1)||(bill.bill_type === 7)||(bill.bill_type === 10)||(bill.bill_type === 11)||(bill.bill_type === 15)||(bill.bill_type === 34)||(bill.bill_type === 40)||(bill.bill_type === 50)){
                    if(date >= starttime){
                      json.income = json.income + bill.payment;                    
                      bill.index = json.size + 1;
                      json.docs.push(bill);
                      json.size++;
                      json.empty = false;
                    }else{                     
                      json.cashbook_first = json.cashbook_first + bill.payment; 
                    }
                  }
                  //chi tiền
                  else if((bill.bill_type === 2)||(bill.bill_type === 3)||(bill.bill_type === 8)||(bill.bill_type === 12)||(bill.bill_type === 33)){
                    if(date >= starttime){                      
                      json.expenditure = json.expenditure + bill.payment;                 
                      bill.index = json.size + 1;
                      json.docs.push(bill);
                      json.size++;
                      json.empty = false;
                    }else{                                          
                      json.cashbook_first = json.cashbook_first - bill.payment; 
                    }
                  }

                }else{
                  //console.log('bill', bill);
                }
              } 
            }
            json.cashbook_last = json.cashbook_first + json.income - json.expenditure;           
            resolve(json);              
            //console.log('json1', json);   
          })
    })
  }
  /**
   * VhQuerySales:
   * @param starttime 
   * @param endtime 
   * @param IDwallet 
   * @param IDbranch 
   * @returns 
   */
  private getReportCashBook_old(starttime:any, endtime:any, IDwallet:any, IDbranch?:string){
    starttime = new Date(starttime); endtime = new Date(endtime);
    return new Promise((resolve, reject) => {                
      let query:any;
      if(IDwallet==='all'){       
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date:{$lte:endtime}};
        }else{
          query = {date:{$lte:endtime}, id_branch: {$eq:IDbranch}};          
        }
      }else{        
        if((IDbranch==='all')||(IDbranch===undefined)){
          query = {date:{$lte:endtime}, id_wallet:{$eq:IDwallet}};
        }else{
          query = {date:{$lte:endtime}, id_wallet:{$eq:IDwallet}, id_branch: {$eq:IDbranch}};                
        }
      }      
      this.getBills_byFields(query, {},{date:1},0)
        .then((bills:any)=>{                   
            let json: any={
              docs:  new Array(),
              empty: true,
              size: 0,              
              cashbook_first: 0,
              income: 0,
              expenditure: 0,
              cashbook_last: 0 
            }         
           
            if(bills.length >0){ 
              for(let i=0; i<bills.length; i++){          
                let bill = {...bills[i]};        
                
                if(bill?.payment_type != 2){
                  delete bill.fee; delete bill.discount; delete bill.note; delete bill.total;  delete bill.tax;                  
                  let date = new Date(bill.date);                 
                  //thu tiền
                  if((bill.bill_type === 1)||(bill.bill_type === 7)||(bill.bill_type === 10)||(bill.bill_type === 11)||(bill.bill_type === 15)||(bill.bill_type === 34)){
                    if(date >= starttime){
                      json.income = json.income + bill.payment;                    
                      bill.index = json.size + 1;
                      json.docs.push(bill);
                      json.size++;
                      json.empty = false;
                    }else{                     
                      json.cashbook_first = json.cashbook_first + bill.payment; 
                    }
                  }
                  //chi tiền
                  if((bill.bill_type === 2)||(bill.bill_type === 3)||(bill.bill_type === 8)||(bill.bill_type === 12)||(bill.bill_type === 33)){
                    if(date >= starttime){                      
                      json.expenditure = json.expenditure + bill.payment;                 
                      bill.index = json.size + 1;
                      json.docs.push(bill);
                      json.size++;
                      json.empty = false;
                    }else{                                          
                      json.cashbook_first = json.cashbook_first - bill.payment; 
                    }
                  }
                }
              } 
            }
            json.cashbook_last = json.cashbook_first + json.income - json.expenditure;           
            resolve(json);              

          })
    })
  }
  /**
   * VhQuerySales:
   * @param id_branch 
   * @returns 
   */
  private syncCashBook(id_branch:string){
    return new Promise((resolve, reject) => {    
      let bill_type_array = [1,7,10,11,15,2,3,8,12];
      let query = {id_branch: {$eq:id_branch}, bill_type: {$in:bill_type_array}};
      let wallets = this.getlocalWallets().filter((item:any)=> {if(item.id_branch === id_branch) return true; else if(item._id === 'id_cash') return true; else return false});   
      //console.log('wallets', wallets);
      this.getBills_byFields(query, {},{date:1},0)
          .then((bills:any)=>{       
            if(bills.length >=2){
              let DayArray = this.get1stDayOfMonthArray(bills[0].date, bills[bills.length-1].date);
              //console.log('DayArray', DayArray);
              for(let i=0; i<wallets.length; i++){
                if(wallets[i]._id === 'id_cash'){
                  wallets[i][id_branch] = {};
                  wallets[i][id_branch].cashbook = new Array();
                  for(let k=0; k<DayArray.length; k++){    
                    wallets[i][id_branch].cashbook[k] = {};
                    wallets[i][id_branch].cashbook[k].date = DayArray[k];
                    wallets[i][id_branch].cashbook[k].cashbook_first = 0;
                  }
                  for(let j=0; j<bills.length; j++){
                    if(wallets[i]._id === bills[j].id_wallet){                    
                      for(let k=0; k<wallets[i][id_branch].cashbook.length; k++){                   
                        if((new Date(bills[j].date)) < (new Date(wallets[i][id_branch].cashbook[k].date))){
                          if((bills[j].bill_type === 1)||(bills[j].bill_type === 7)||(bills[j].bill_type === 10)||(bills[j].bill_type === 11)||(bills[j].bill_type === 15)||(bills[j].bill_type === 34)){
                            wallets[i][id_branch].cashbook[k].cashbook_first = wallets[i][id_branch].cashbook[k].cashbook_first + bills[j].payment; 
                          }else if((bills[j].bill_type === 2)||(bills[j].bill_type === 3)||(bills[j].bill_type === 8)||(bills[j].bill_type === 12)||(bills[j].bill_type === 33)){
                            wallets[i][id_branch].cashbook[k].cashbook_first = wallets[i][id_branch].cashbook[k].cashbook_first - bills[j].payment; 
                          }
                        }
                      }
                    }
                  } 
                }else{
                  wallets[i].cashbook = new Array();
                  for(let k=0; k<DayArray.length; k++){    
                    wallets[i].cashbook[k] = {};
                    wallets[i].cashbook[k].date = DayArray[k];
                    wallets[i].cashbook[k].cashbook_first = 0;
                  }
                  for(let j=0; j<bills.length; j++){
                    if(wallets[i]._id === bills[j].id_wallet){                    
                      for(let k=0; k<wallets[i].cashbook.length; k++){                   
                        if((new Date(bills[j].date)) < (new Date(wallets[i].cashbook[k].date))){
                          if((bills[j].bill_type === 1)||(bills[j].bill_type === 7)||(bills[j].bill_type === 10)||(bills[j].bill_type === 11)||(bills[j].bill_type === 15)||(bills[j].bill_type === 34)){
                            wallets[i].cashbook[k].cashbook_first = wallets[i].cashbook[k].cashbook_first + bills[j].payment;                            
                          }else if((bills[j].bill_type === 2)||(bills[j].bill_type === 3)||(bills[j].bill_type === 8)||(bills[j].bill_type === 12)||(bills[j].bill_type === 33)){
                            wallets[i].cashbook[k].cashbook_first = wallets[i].cashbook[k].cashbook_first - bills[j].payment; 
                          }
                        }
                      }
                    }
                  } 
                  
                }                         
              }
              //console.log('wallets', wallets);                     
            }            
          })
    })
  }

  /**
   * VhQuerySales:
   * Hàm này chỉ chạy trên giao diện Desktop
   * @returns Promise
   */
  private syncCashBookEveryDay_Stock1stDayOfMonth(){//lưu ý bill_type 33, 34 đã là công nợ rồi thì hàm này ko cần đưa vô tính
    return new Promise((resolve, reject) => {  
      let store = this.vhAuth.getStore();            
      //let branchs = this.getlocalBranchs();  
      let branchs = [{...this.getDefaultBranch()}];     
       //console.log('branchs', branchs);
      this.vhMGDB_auth.getServerDate()
            .then((serverdate:any)=>{              
              let DayArray = this.get1stDayOfMonthArray(store.registrationdate, serverdate);//'2021-02-29T17:00:00.000Z'                   
              //console.log('DayArray100', DayArray);
              if(DayArray.length >0){
                let promise_branch = new Array();
                for(let m=0; m<branchs.length; m++){
                  let id_branch = branchs[m]._id; 

                      let wallets = this.getlocalWallets().filter((item:any)=> {if(item.id_branch === id_branch) return true; else if(item._id === 'id_cash') return true; else return false}); 
                      //console.log('wallets', wallets);
                      let promise = new Array();
                      for(let i=0; i<wallets.length; i++){                        
                        if(wallets[i]._id === 'id_cash'){
                            if((wallets[i][id_branch] !=undefined)&&(wallets[i][id_branch].cashbook !=undefined)){   
                                let cashbook = wallets[i][id_branch].cashbook[wallets[i][id_branch].cashbook.length -1];    
                                if((new Date(cashbook.date)).getTime() != (new Date(DayArray[DayArray.length-1])).getTime()){
                                  for(let k= wallets[i][id_branch].cashbook.length; k <DayArray.length; k++){
                                    wallets[i][id_branch].cashbook[k] = {};
                                    wallets[i][id_branch].cashbook[k].date = DayArray[k];
                                    wallets[i][id_branch].cashbook[k].cashbook_first =cashbook.cashbook_first;
                                  }                     
                                  
                                  promise[i] = new Promise(resolve=>{
                                    let promise_bill:any = [];
                                    let array_bill_type = [1,7,10,11,15,34,40,50,2,3,8,12,33];
                                    while (array_bill_type.length) {      
                                      let array_10_bill_type = array_bill_type.splice(0, 10);    
                                      let query = {date: {$gte:new Date(cashbook.date)}, id_branch: {$eq:id_branch}, id_wallet: {$eq:'id_cash'}, bill_type: {$in:array_10_bill_type}};
                                      //console.log('query1', query);               
                                      promise_bill.push(this.getBills_byFields(query, {},{date:1},0));
                                    }
                                    Promise.all(promise_bill).then((_bills:any)=>{                     
                                            let bills = _bills.flat();      
                                            //console.log('cash_bills1.length', bills.length);                                              
                                            if(bills.length >0){
                                              for(let j=0; j<bills.length; j++){
                                                if(bills[j].id_wallet === 'id_cash'){                    
                                                  for(let k=0; k<wallets[i][id_branch].cashbook.length; k++){                   
                                                    if((new Date(bills[j].date)) < (new Date(wallets[i][id_branch].cashbook[k].date))){
                                                      if((bills[j].bill_type === 1)||(bills[j].bill_type === 7)||(bills[j].bill_type === 10)||(bills[j].bill_type === 11)||(bills[j].bill_type === 15)||(bills[j].bill_type === 34)||(bills[j].bill_type === 40)||(bills[j].bill_type === 50)){
                                                        wallets[i][id_branch].cashbook[k].cashbook_first = wallets[i][id_branch].cashbook[k].cashbook_first + bills[j].payment; 
                                                      }else if((bills[j].bill_type === 2)||(bills[j].bill_type === 3)||(bills[j].bill_type === 8)||(bills[j].bill_type === 12)||(bills[j].bill_type === 33)){
                                                        wallets[i][id_branch].cashbook[k].cashbook_first = wallets[i][id_branch].cashbook[k].cashbook_first - bills[j].payment; 
                                                      }
                                                    }
                                                  }
                                                }
                                              }                                               
                                            }
                                            resolve(wallets[i]);                                           
                                          })
                                    }) 

                                }else{                                  
                                  resolve(null); 
                                }                                   
                            }else{                                             
                                promise[i] = new Promise(resolve=>{                            
                                    let promise_bill:any = [];
                                    let array_bill_type = [1,7,10,11,15,34,40,50,2,3,8,12,33];
                                    while (array_bill_type.length) {      
                                      let array_10_bill_type = array_bill_type.splice(0, 10);    
                                      let query = {id_branch: {$eq:id_branch}, id_wallet: {$eq:'id_cash'}, bill_type: {$in:array_10_bill_type}};    
                                      //console.log('query0', query);                                    
                                      promise_bill.push(this.getBills_byFields(query, {},{date:1},0));
                                    }
                                    Promise.all(promise_bill).then((_bills:any)=>{                     
                                            let bills = _bills.flat();         
                                            //console.log('cash_bills0.length', bills.length);
                                            wallets[i][id_branch] = {};
                                            wallets[i][id_branch].cashbook = new Array();
                                            for(let k=0; k<DayArray.length; k++){    
                                              wallets[i][id_branch].cashbook[k] = {};
                                              wallets[i][id_branch].cashbook[k].date = DayArray[k];
                                              wallets[i][id_branch].cashbook[k].cashbook_first = 0;
                                            }
                                            if(bills.length >0){                                                 
                                                for(let j=0; j<bills.length; j++){
                                                  if(bills[j].id_wallet === 'id_cash'){                    
                                                    for(let k=0; k<wallets[i][id_branch].cashbook.length; k++){                   
                                                      if((new Date(bills[j].date)) < (new Date(wallets[i][id_branch].cashbook[k].date))){
                                                        if((bills[j].bill_type === 1)||(bills[j].bill_type === 7)||(bills[j].bill_type === 10)||(bills[j].bill_type === 11)||(bills[j].bill_type === 15)||(bills[j].bill_type === 34)||(bills[j].bill_type === 40)||(bills[j].bill_type === 50)){
                                                          wallets[i][id_branch].cashbook[k].cashbook_first = wallets[i][id_branch].cashbook[k].cashbook_first + bills[j].payment; 
                                                        }else if((bills[j].bill_type === 2)||(bills[j].bill_type === 3)||(bills[j].bill_type === 8)||(bills[j].bill_type === 12)||(bills[j].bill_type === 33)){
                                                          wallets[i][id_branch].cashbook[k].cashbook_first = wallets[i][id_branch].cashbook[k].cashbook_first - bills[j].payment; 
                                                        }
                                                      }
                                                    }
                                                  }
                                                }                                          
                                            }
                                            resolve(wallets[i]);
                                          })
                                        })                      
                            }                                          
                        }else if(wallets[i]._id != 'id_cash'){
                            if(wallets[i].cashbook !=undefined){   
                              let cashbook = wallets[i].cashbook[wallets[i].cashbook.length -1];    
                              if((new Date(cashbook.date)).getTime() != (new Date(DayArray[DayArray.length-1])).getTime()){
                                for(let k= wallets[i].cashbook.length; k <DayArray.length; k++){
                                  wallets[i].cashbook[k] = {};
                                  wallets[i].cashbook[k].date = DayArray[k];
                                  wallets[i].cashbook[k].cashbook_first =cashbook.cashbook_first;
                                }                     
                                
                                promise[i] = new Promise(resolve=>{
                                  let promise_bill:any = [];
                                  let array_bill_type = [1,7,10,11,15,34,40,50,2,3,8,12,33];
                                  while (array_bill_type.length) {      
                                    let array_10_bill_type = array_bill_type.splice(0, 10);    
                                    let query = {date: {$gte:new Date(cashbook.date)}, id_branch: {$eq:id_branch}, id_wallet: {$eq:wallets[i]._id}, bill_type: {$in:array_10_bill_type}};
                                    promise_bill.push(this.getBills_byFields(query, {},{date:1},0));
                                  }
                                  Promise.all(promise_bill).then((_bills:any)=>{                     
                                          let bills = _bills.flat();                                                   
                                          if(bills.length >0){
                                              for(let j=0; j<bills.length; j++){
                                                if(bills[j].id_wallet === wallets[i]._id){                    
                                                  for(let k=0; k<wallets[i].cashbook.length; k++){                   
                                                    if((new Date(bills[j].date)) < (new Date(wallets[i].cashbook[k].date))){
                                                      if((bills[j].bill_type === 1)||(bills[j].bill_type === 7)||(bills[j].bill_type === 10)||(bills[j].bill_type === 11)||(bills[j].bill_type === 15)||(bills[j].bill_type === 34)||(bills[j].bill_type === 40)||(bills[j].bill_type === 50)){
                                                        wallets[i].cashbook[k].cashbook_first = wallets[i].cashbook[k].cashbook_first + bills[j].payment; 
                                                      }else if((bills[j].bill_type === 2)||(bills[j].bill_type === 3)||(bills[j].bill_type === 8)||(bills[j].bill_type === 12)||(bills[j].bill_type === 33)){
                                                        wallets[i].cashbook[k].cashbook_first = wallets[i].cashbook[k].cashbook_first - bills[j].payment; 
                                                      }
                                                    }
                                                  }
                                                }
                                              }                                                
                                          }
                                          resolve(wallets[i]);
                                        })
                                  }) 

                              }else{
                                //console.log(wallets[i]._id);
                                resolve(null);
                              }                                   
                            }else{                                                                 
                                promise[i] = new Promise(resolve=>{
                                  let promise_bill:any = [];
                                  let array_bill_type = [1,7,10,11,15,34,40,50,2,3,8,12,33];
                                  while (array_bill_type.length) {                                              
                                    let array_10_bill_type = array_bill_type.splice(0, 10);    
                                    let query = {id_branch: {$eq:id_branch}, id_wallet: {$eq:wallets[i]._id}, bill_type: {$in:array_10_bill_type}};                                      
                                    promise_bill.push(this.getBills_byFields(query, {},{date:1},0));
                                  }
                                  Promise.all(promise_bill).then((_bills:any)=>{                     
                                          let bills = _bills.flat();                                      
                                          //console.log(wallets[i].name, bills.length);
                                          wallets[i].cashbook = new Array();
                                          for(let k=0; k<DayArray.length; k++){    
                                            wallets[i].cashbook[k] = {};
                                            wallets[i].cashbook[k].date = DayArray[k];
                                            wallets[i].cashbook[k].cashbook_first = 0;
                                          }
                                          if(bills.length >0){                                              
                                              for(let j=0; j<bills.length; j++){
                                                if(bills[j].id_wallet === wallets[i]._id){                    
                                                  for(let k=0; k<wallets[i].cashbook.length; k++){                   
                                                    if((new Date(bills[j].date)) < (new Date(wallets[i].cashbook[k].date))){
                                                      if((bills[j].bill_type === 1)||(bills[j].bill_type === 7)||(bills[j].bill_type === 10)||(bills[j].bill_type === 11)||(bills[j].bill_type === 15)||(bills[j].bill_type === 34)||(bills[j].bill_type === 40)||(bills[j].bill_type === 50)){
                                                        wallets[i].cashbook[k].cashbook_first = wallets[i].cashbook[k].cashbook_first + bills[j].payment; 
                                                      }else if((bills[j].bill_type === 2)||(bills[j].bill_type === 3)||(bills[j].bill_type === 8)||(bills[j].bill_type === 12)||(bills[j].bill_type === 33)){
                                                        wallets[i].cashbook[k].cashbook_first = wallets[i].cashbook[k].cashbook_first - bills[j].payment; 
                                                      }
                                                    }
                                                  }
                                                }
                                              }                                               
                                          }
                                          resolve(wallets[i]);
                                        })
                                      })                      
                            }   
                        }
                      }
                      promise_branch[m] = new Promise(resolve=>{
                        Promise.all(promise).then(array=>{                          
                          for(let i=0; i<array.length; i++){
                            if(array[i]){                      
                              if(array[i]._id === 'id_cash'){
                                let value:any = {};
                                value[id_branch] = array[i][id_branch];
                                this.vhMGDB_database.updateDoc('wallets', array[i]._id, {...value});
                              }else{
                                this.vhMGDB_database.updateDoc('wallets', array[i]._id, {cashbook: array[i].cashbook});
                              }
                              
                            }
                          }
                          resolve(array);
                        })
                      })
                        
                }
                Promise.all(promise_branch).then(array_branch=>{  
                  console.log('syncCashBookEveryDay');    
                  resolve(null);   
                })
              }else{
                console.log('syncCashBookEveryDay');    
                resolve(null);   
              }
            },(error:any)=>{
              console.log('syncCashBookEveryDay', error);
            }) 
    })
  }

  /**
   * Sales:
   * @example:
   * let DayArray = this.get1stDayOfMonthArray(store.registrationdate, serverdate);
   * @param startdate 
   * @param enddate 
   * @returns 
   */
  private get1stDayOfMonthArray(startdate: any, enddate: any){
    let dayArray = new Array();
    enddate = new Date(enddate);
    startdate = new Date(startdate);                   
    startdate.setDate(1);
    startdate.setHours(0);
    startdate.setMinutes(0);
    startdate.setSeconds(0);    
    startdate.setMilliseconds(0);        
    startdate.setMonth(startdate.getMonth() + 1);   
    enddate.setDate(1);
    enddate.setHours(0);
    enddate.setMinutes(0);
    enddate.setSeconds(0);  
    enddate.setMilliseconds(0);  
    enddate.setMonth(enddate.getMonth() - 1);                   
    while(startdate.getTime() <= enddate.getTime()){    
      dayArray.push(new Date(startdate));    
      startdate.setMonth(startdate.getMonth() + 1);                      
    }
    return dayArray;
  }

  /**
   * Hàm này kiểm tra ngày tạo bill, sửa bill đã chọn có hợp lệ không
   * Ngày hợp lệ phải thỏa mãn: 
   * 1. phải sau ngày cửa hàng đăng ký sử dụng phần mềm sales viethas
   * 2. thuộc tháng mà trước tháng hiện tại 1 tháng
   * @example:
   * this.vhQuerySales.getValidityDate('2021-06-18T16:27:16.276Z')
        .then((validitydate)=>{          
          if(validitydate) console.log('Bạn chỉ có thể tạo/chỉnh sửa hóa đơn này từ ngày', validitydate);
        })
   * @param date (String or Date): ngày tạo bill, sửa bill 
   * @returns Promise => validitydate = null nếu hợp lệ; validitydate != null nếu không hợp lệ, và từ ngày validitydate trở đi là có thể tạo bill và sửa bill 
   */
  public getValidityDate(date:any){
    return new Promise((resolve, reject) => {  
      date = new Date(date);            
      this.vhMGDB_auth.getServerDate()
          .then((serverdate:any)=>{
            serverdate = new Date(serverdate);
            serverdate.setMonth(serverdate.getMonth() - 1);
            serverdate.setDate(1);
            serverdate.setHours(0);
            serverdate.setMinutes(0);
            serverdate.setSeconds(0);   
            if(date.getTime() > serverdate.getTime()){
              if(date.getTime() < new Date(this.vhAuth.getStore().registrationdate).getTime()){
                resolve(new Date(this.vhAuth.getStore().registrationdate));
              }else{
                resolve(null);
              }
              
            }else{
              if(serverdate.getTime() < new Date(this.vhAuth.getStore().registrationdate).getTime()){
                resolve(new Date(this.vhAuth.getStore().registrationdate));
              }else{
                resolve(serverdate);
              }              
            }                  
          })         
    })
  }

  /**
   * Nhật ký thu chi
   * @param starttime 
   * @param endtime 
   * @param id_wallet là 'all' hoặc id của ví nào đó
   * @param id_employee là 'all' hoặc id của thu ngân nào đó
   * @param array_bill_type
   * @param IDbranch : 'all' or id_branch 
   * array_bill_type (all) = [1,7,10,11,15,34,40,50,2,3,8,12,33]; thu:1,7,10,11,15,34,40,50 - chi: 2,3,8,12,33
   * 
   */
  public getReportIncomeExpenditureDiary(starttime:any, endtime:any,id_wallet:any, id_employee:any, array_bill_type:any, IDbranch?:string){
    //cần xem lại array_bill_type set cứng luôn hay là tham số truyền như hiện có
    return new Promise((resolve, reject) => {       
      let promise:any = [];
      while (array_bill_type.length) {      
        let array_10_bill_type = array_bill_type.splice(0, 10);       
        if((IDbranch==='all')||(IDbranch===undefined)){
          if((id_wallet==='all')&&(id_employee==='all')) promise.push(this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, bill_type: {$in:array_10_bill_type}}, {},{date:1},0));
          if((id_wallet==='all')&&(id_employee!='all')) promise.push(this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_employee:{$eq:id_employee}, bill_type: {$in:array_10_bill_type}}, {},{date:1},0));
          if((id_wallet!='all')&&(id_employee==='all')) promise.push(this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_wallet:{$eq:id_wallet}, bill_type: {$in:array_10_bill_type}}, {},{date:1},0));
          if((id_wallet!='all')&&(id_employee!='all')) promise.push(this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_wallet:{$eq:id_wallet}, id_employee:{$eq:id_employee}, bill_type: {$in:array_10_bill_type}}, {},{date:1},0));  
        }else{
          if((id_wallet==='all')&&(id_employee==='all')) promise.push(this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, bill_type: {$in:array_10_bill_type}, id_branch: {$eq:IDbranch}}, {},{date:1},0));
          if((id_wallet==='all')&&(id_employee!='all')) promise.push(this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_employee:{$eq:id_employee}, bill_type: {$in:array_10_bill_type}, id_branch: {$eq:IDbranch}}, {},{date:1},0));
          if((id_wallet!='all')&&(id_employee==='all')) promise.push(this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_wallet:{$eq:id_wallet}, bill_type: {$in:array_10_bill_type}, id_branch: {$eq:IDbranch}}, {},{date:1},0));
          if((id_wallet!='all')&&(id_employee!='all')) promise.push(this.getBills_byFields({date: {$gte:starttime, $lte:endtime}, id_wallet:{$eq:id_wallet}, id_employee:{$eq:id_employee}, bill_type: {$in:array_10_bill_type}, id_branch: {$eq:IDbranch}}, {},{date:1},0));     
        }                  
      }

      Promise.all(promise).then((_bills:any)=>{                     
        let bills = _bills.flat();     
        let json: any={
          docs:  new Array(),
          empty: true,
          size: 0,                        
          income: 0,
          expenditure: 0         
        }         
       
        if(bills.length >0){ 
          for(let i=0; i<bills.length; i++){          
            let bill = {...bills[i]};                     
            //thu tiền
            if((bill?.payment_type != 2)){
              if((bill.bill_type === 1)||(bill.bill_type === 7)||(bill.bill_type === 10)||(bill.bill_type === 11)||(bill.bill_type === 15)||(bill.bill_type === 34)||(bill.bill_type === 40)||(bill.bill_type === 50)){
                  json.income = json.income + bill.payment;                  
                  json.docs.push(bill);        
                  json.size++;
                  json.empty = false;     
              }
              //chi tiền
              if((bill.bill_type === 2)||(bill.bill_type === 3)||(bill.bill_type === 8)||(bill.bill_type === 12)||(bill.bill_type === 33)){
                  json.expenditure = json.expenditure + bill.payment;                    
                  json.docs.push(bill);            
                  json.size++;
                  json.empty = false;  
              }
            }
          } 
        }              
        //console.log('json', json);
        resolve(json); 
      })
      
    })
  }

/**
 * @example:
 * let endtime = new Date();
 * let starttime = new Date('2020-07-01T05:24:00');
 * this.vhQuerySales.getDebtSuppliers(starttime, endtime, 'yewwg44667njdt443s', 'gtrtyery56646577456')
      .then((debts)=>{
        console.log('getDebtSuppliers', debts);
      })
  * @param starttime
  * @param endtime
  * @param IDsuppiler: id_supplier hoặc 'all' 
  * @param IDbranch: id_branch hoặc 'all' 
  * @return JSON(Array) => json.docs = [{id, name, index, debt, payment, rest,...},{},....]
  * Lưu ý: giá trị này trả về dạng array
  */  
public getDebtSuppliers(starttime:any, endtime:any, IDsuppiler:string, IDbranch?:string){  
  starttime = new Date(starttime); endtime = new Date(endtime);
  let store = this.vhAuth.getStore();  
  return new Promise<any>((resolve,reject) => {
    let suppliers:any = new Array();   
    if(IDsuppiler === 'all') suppliers = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalSuppliers(), 'name');  
    else {
      let supplier = this.getlocalSupplier(IDsuppiler);           
      suppliers.push(supplier);
    }

    let branchs = this.getlocalBranchs();
    let id_branch = this.getDefaultBranch()._id;
    let query_bill:any;     
    let index:any = null;
    let day:any = null;
    if((suppliers[0][id_branch] != undefined)&&(suppliers[0][id_branch].debt != undefined))
      for(let k=0; k<suppliers[0][id_branch].debt.length; k++){
        if((new Date(suppliers[0][id_branch].debt[k].date)).getTime() > starttime.getTime()){
          break;
        }else{
          day = new Date(suppliers[0][id_branch].debt[k].date);
          index = k;
        }
      }            
    if(!day) day = new Date(store.registrationdate);   
    if(IDsuppiler === 'all'){ 
      if((IDbranch === 'all')||(IDbranch === undefined)){              
        query_bill = {date:{$gte:day, $lte:endtime}, bill_type: {$in:[2,10,12]}};        
      }else{        
        query_bill = {date:{$gte:day, $lte:endtime}, bill_type: {$in:[2,10,12]}, id_branch: {$eq:IDbranch}};        
      }     
    }else{
      if((IDbranch === 'all')||(IDbranch === undefined)){              
        query_bill = {date:{$gte:day, $lte:endtime}, id_supplier: {$eq:IDsuppiler}, bill_type: {$in:[2,10,12]}};        
      }else{                   
        query_bill = {date:{$gte:day, $lte:endtime}, id_supplier: {$eq:IDsuppiler}, bill_type: {$in:[2,10,12]}, id_branch: {$eq:IDbranch}}; 
      }    
    }

    this.getBills_byFields(query_bill, {},{date:1},0) 
        .then((bills:any)=>{              
            let json:any = {
              docs: new Array(),   
              debt_beginning: 0,                                 
              payment: 0,
              debt: 0,
              rest: 0
            } 
            
            for(let i=0; i<suppliers.length; i++){
              let supplier:any = {
                _id:  suppliers[i]._id,
                name:  suppliers[i].name
              };                                      
              json.docs.push(supplier);                    
              let debt = 0; let pay = 0; let debt_beginning = 0; let debt_first = 0;
              for(let j=0; j<bills.length; j++){                   
                  if(bills[j].id_supplier === suppliers[i]._id){
                      if((new Date(bills[j].date)).getTime() >= starttime.getTime()){
                          if(bills[j].bill_type === 2){
                            debt = debt + bills[j].total * (1 + bills[j].tax/100);
                            pay = pay + bills[j].payment;
                          }
                          else if(bills[j].bill_type === 12){
                            pay = pay + bills[j].payment;
                          }
                          else if(bills[j].bill_type === 10){
                            pay = pay + bills[j].total * (1 + bills[j].tax/100);
                            debt = debt + bills[j].payment;
                          }
                      }else{
                          if(bills[j].bill_type === 2){                             
                            debt_first = debt_first + bills[j].total * (1 + bills[j].tax/100) - bills[j].payment;
                          }
                          else if(bills[j].bill_type === 10){                             
                            debt_first = debt_first + bills[j].payment - bills[j].total * (1 + bills[j].tax/100);
                          }
                          else if(bills[j].bill_type === 12){                             
                            debt_first = debt_first - bills[j].payment;
                          }                            
                      } 
                  }                                           
              }

              if((IDbranch === 'all')||(IDbranch === undefined)){                 
                for(let j=0; j<branchs.length; j++){
                  if((suppliers[i][branchs[j]._id] != undefined)&&(suppliers[i][branchs[j]._id].debt_beginning != undefined)){
                    debt_beginning = debt_beginning + suppliers[i][branchs[j]._id].debt_beginning;
                  }
                }
              }else{
                if((suppliers[i][IDbranch] != undefined)&&(suppliers[i][IDbranch].debt_beginning != undefined)){
                  debt_beginning = suppliers[i][IDbranch].debt_beginning;
                }

                if((suppliers[i][IDbranch] != undefined)&&(suppliers[i][IDbranch].debt != undefined)){
                  if(!index)
                    if(suppliers[i][IDbranch].debt[index] !=undefined)
                      debt_first = debt_first + suppliers[i][IDbranch].debt[index].debt_first;
                }
              }                  
              
              debt = debt_beginning + debt_first + debt;
              json.docs[json.docs.length -1].index = json.docs.length;
              json.docs[json.docs.length -1].debt = debt;
              json.docs[json.docs.length -1].payment = pay;
              json.docs[json.docs.length -1].rest = debt - pay;
              
              
              json.debt_beginning = json.debt_beginning + debt_beginning;
              json.debt = json.debt + debt;
              json.payment = json.payment + pay;   
              json.rest = json.rest + debt - pay;   

              let _json:any = {
                docs: new Array(), 
                empty: true,
                size:0,
                debt_beginning: debt_beginning + debt_first,
                debt: debt_beginning + debt_first,
                payment: 0,
                rest: debt_beginning + debt_first
              }                 
                      
              for(let j=0; j<bills.length; j++){
                if(suppliers[i]._id === bills[j].id_supplier){                    
                  if((new Date(bills[j].date)).getTime() >= starttime.getTime()){
                    let bill:any = {...bills[j]};
                    delete bill?.discount; delete bill?.fee; delete bill?.id_supplier;
                    delete bill?.note; delete bill?.payment_type; delete bill?.tax;
                    _json.docs.push(bill);         
                    _json.docs[_json.docs.length -1].debt = 0;
                    _json.docs[_json.docs.length -1].payment = 0;
                    
                    if(bills[j].bill_type === 2){
                      _json.docs[_json.docs.length -1].debt = bills[j].total * (1 + bills[j]?.tax/100);
                      _json.docs[_json.docs.length -1].payment = bills[j].payment;         
                      _json.docs[_json.docs.length -1].rest = _json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;     
                    }
                    else if(bills[j].bill_type === 10){
                      _json.docs[_json.docs.length -1].payment = bills[j].total * (1 + bills[j]?.tax/100);
                      _json.docs[_json.docs.length -1].debt = bills[j].payment;           
                      _json.docs[_json.docs.length -1].rest = _json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;      
                    }
                    else if(bills[j].bill_type === 12){
                      _json.docs[_json.docs.length -1].payment = bills[j].payment;
                      _json.docs[_json.docs.length -1].rest = - bills[j].payment;
                    }                      
    
                    _json.debt = _json.debt + _json.docs[_json.docs.length -1].debt;
                    _json.payment = _json.payment + _json.docs[_json.docs.length -1].payment   
                    _json.rest = _json.rest +_json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;   
                    _json.size++;
                    _json.empty = false;   
                    _json.docs[_json.docs.length -1].index = _json.docs.length;    
                  }               
                }
              }
              json.docs[json.docs.length -1].json = _json;
            }
              
            //console.log('json', json)    
            resolve(json);
        })     
  })
}
   
  
/**
 * CÔNG NỢ KHÁCH HÀNG
 * @example:
 * let endtime = new Date();
 * let starttime = new Date('2020-07-01T05:24:00');
 * this.vhQuerySales.getDebtCustomers('gtrtyery56646577456')
      .then((debts)=>{
        console.log('getDebtCustomers', debts);
      })
  * @param IDbranch: id_branch hoặc 'all'  
  * @return JSON(Array) => json.docs = [{id, name, index, debt, payment, rest,...},{},....]
  * Lưu ý: giá trị này trả về dạng array
  */
  private getDebtCustomers_danglam(starttime:any, endtime:any, IDcustomer:string, IDbranch?:string){   
    //sẽ sửa lại theo hướng bỏ starttime, endtime, IDcustomer
    console.log(endtime, IDcustomer, IDbranch)    
    return new Promise<any>((resolve,reject) => {
       (async () => {
        try{
          let serverdate:any = await this.vhMGDB_auth.getServerDate();  
          let isToday = (serverdate.toISOString().split("T")[0] === (new Date(endtime)).toISOString().split("T")[0])? true:false;   
          let json:any = {
            docs: new Array(),   
            debt_beginning: 0,                                 
            payment: 0,
            debt: 0,
            rest: 0
          } 
          if((IDbranch == 'all')|| (IDbranch == undefined)) return resolve(json);
          let store = this.vhAuth.getStore();  
          let customers:any = new Array();   
          if(IDcustomer === 'all'){
            customers = this.getlocalCustomers().filter((item: any) => {
              const hasDebt = (item[IDbranch]?.debtBalance ?? 0) !== 0;
              const isEnabled = item.debt_enable;
              return item._id !== 'id_retail' && (hasDebt || isEnabled);
            });
            customers = this.vhAlgorithm.sortVietnamesebyASC(customers, 'name');  
          }else {
            let customer = this.getlocalCustomer(IDcustomer);           
            customers.push(customer);
          }  
          //console.log('customers', customers)  
          let branchs = this.getlocalBranchs();
          //let id_branch = this.getDefaultBranch()._id;
          let id_branch = IDbranch;
          //let query_bill:any;     
          //let index:any = null;
          if(IDcustomer === 'all'){ 
            if((IDbranch === 'all')||(IDbranch === undefined)){               
              for(let i=0; i<customers.length; i++){
                let customer:any = {
                  _id:  customers[i]._id,
                  name:  customers[i].name,
                  index: i + 1,
                  debt: 0,
                  payment: 0,
                  rest: 0
                };             
                for(let j=0; j<branchs.length; j++){
                  if((customers[i][branchs[j]._id] != undefined)&&(customers[i][branchs[j]._id].debt_beginning != undefined)){
                    json.debt_beginning = json.debt_beginning + customers[i][branchs[j]._id].debt_beginning;
                  }
                  if((customers[i][branchs[j]._id] != undefined)&&(customers[i][branchs[j]._id].debtBalance != undefined)){
                    customer.debt += customers[i][branchs[j]._id].debtBalance;
                    customer.rest += customers[i][branchs[j]._id].debtBalance;

                    json.debt = json.debt + customer.debt;
                    json.rest = json.rest + customer.rest;
                  }    
                }   
                    
                json.docs.push(customer);                    
              }          
            }else{                          
              for(let i=0; i<customers.length; i++){
                let customer:any = {
                  _id:  customers[i]._id,
                  name:  customers[i].name,
                  index: i + 1,
                  debt: 0,
                  payment: 0,
                  rest: 0
                };                
                if((customers[i][id_branch] != undefined)&&(customers[i][id_branch].debt_beginning != undefined)){
                  json.debt_beginning = json.debt_beginning + customers[i][id_branch].debt_beginning;
                }
                if((customers[i][id_branch] != undefined)&&(customers[i][id_branch].debtBalance != undefined)){
                  customer.debt = customers[i][id_branch].debtBalance;
                  customer.rest = customers[i][id_branch].debtBalance;

                  json.debt = json.debt + customer.debt;
                  json.rest = json.rest + customer.rest;
                }      
                json.docs.push(customer);                    
              }              
            }     
            console.log('getDebtCustomers', json)    
            resolve(json);
          }
        } catch (err) {
          console.error('❌ Lỗi getDebtCustomers:', err);
          reject(err);
        }  
      })();  
    })
  }  

/**
 * CÔNG NỢ KHÁCH HÀNG
 * @example:
 * let endtime = new Date();
 * let starttime = new Date('2020-07-01T05:24:00');
 * this.vhQuerySales.getDebtCustomers(starttime, endtime, 'yewwg44667njdt443s', 'gtrtyery56646577456')
      .then((debts)=>{
        console.log('getDebtCustomers', debts);
      })
  * @param starttime
  * @param endtime
  * @param id_customer: id_customer 
  * @param IDbranch: id_branch hoặc 'all'  
  * @return JSON(Array) => json.docs = [{id, name, index, debt, payment, rest,...},{},....]
  * Lưu ý: giá trị này trả về dạng array
  */
  private  getDebtCustomer_byTime(starttime:any, endtime:any, id_customer:string, IDbranch?:string){    
    console.log(endtime, id_customer, IDbranch)    
    return new Promise<any>((resolve,reject) => {
       (async () => {
        try{
          let serverdate:any = await this.vhMGDB_auth.getServerDate();
          //console.log('serverdate', serverdate)    
          let isToday = (serverdate.toISOString().split("T")[0] === (new Date(endtime)).toISOString().split("T")[0])? true:false;
          //console.log('isToday', isToday)    
          let json:any = {
            docs: new Array(),   
            debt_beginning: 0,                                 
            payment: 0,
            debt: 0,
            rest: 0
          } 
          if((IDbranch == 'all')|| (IDbranch == undefined)) return resolve(json);
          if((id_customer == 'all')|| (id_customer == undefined)) return resolve(json);
          let store = this.vhAuth.getStore();  
          let customers:any = new Array();   
          let customer = this.getlocalCustomer(id_customer);           
          customers.push(customer);
          //console.log('customers', customers)  
          let branchs = this.getlocalBranchs();
          //let id_branch = this.getDefaultBranch()._id;
          let id_branch = IDbranch;
          let query_bill:any;     
          let index:any = null;
          let day:any = null;
          // if((customers[0][id_branch] != undefined)&&(customers[0][id_branch].debt != undefined))
          //   for(let k=0; k<customers[0][id_branch].debt.length; k++){
          //     if((new Date(customers[0][id_branch].debt[k].date)).getTime() > starttime.getTime()){
          //       break;
          //     }else{
          //       day = new Date(customers[0][id_branch].debt[k].date);
          //       index = k;
          //     }
          //   }            
          if(!day) day = new Date(store.registrationdate);   
          
          if((IDbranch === 'all')||(IDbranch === undefined)){              
            query_bill = {date:{$gte:day, $lte:endtime}, id_customer: {$eq:id_customer}, bill_type: {$in:[1,3,11,15]}};        
          }else{        
            query_bill = {date:{$gte:day, $lte:endtime}, id_customer: {$eq:id_customer}, bill_type: {$in:[1,3,11,15]}, id_branch: {$eq:IDbranch}};   
          }         

          this.getBills_byFields(query_bill, {},{date:1},0) 
              .then((bills:any)=>{                
                    let _customer:any = {
                      _id:  customer._id,
                      name:  customer.name
                    };                                      
                    //json.docs.push(_customer);                    
                    let debt = 0; let pay = 0; let debt_beginning = 0; let debt_first = 0;
                    for(let j=0; j<bills.length; j++){
                        if(bills[j].id_customer === customer._id){
                          if((new Date(bills[j].date)).getTime() >= starttime.getTime()){
                            if((bills[j].bill_type === 1)||(bills[j].bill_type === 15)){                               
                              debt = debt + bills[j].total * (1 + bills[j].tax/100);
                              pay = pay + bills[j].payment;
                            }
                            else if(bills[j].bill_type === 11){                              
                              pay = pay + bills[j].payment;
                            }
                            else if(bills[j].bill_type === 3){                              
                              pay = pay + bills[j].total * (1 + bills[j].tax/100);
                              debt = debt + bills[j].payment;
                            }
                          }else{
                            if((bills[j].bill_type === 1)||(bills[j].bill_type === 15)){                         
                              debt_first = debt_first + bills[j].total * (1 + bills[j].tax/100) - bills[j].payment;
                            }
                            else if(bills[j].bill_type === 11){    
                              debt_first = debt_first - bills[j].payment;                     
                            }
                            else if(bills[j].bill_type === 3){                          
                              debt_first = debt_first + bills[j].payment - bills[j].total * (1 + bills[j].tax/100);
                            }                            
                          } 
                        }                          
                    }                 

                    if((IDbranch === 'all')||(IDbranch === undefined)){                 
                      for(let j=0; j<branchs.length; j++){
                        if((customer[branchs[j]._id] != undefined)&&(customer[branchs[j]._id].debt_beginning != undefined)){
                          debt_beginning = debt_beginning + customer[branchs[j]._id].debt_beginning;
                        }
                      }
                    }else{
                      if((customer[IDbranch] != undefined)&&(customer[IDbranch].debt_beginning != undefined)){
                        debt_beginning = customer[IDbranch].debt_beginning;
                      }
                      if((customer[IDbranch] != undefined)&&(customer[IDbranch].debt != undefined)){
                        if(!index)
                          if(customer[IDbranch].debt[index] !=undefined)
                            debt_first = debt_first + customer[IDbranch].debt[index].debt_first;
                      }
                    }                  
                    
                    debt = debt_beginning + debt_first + debt;
                    _customer.index = json.docs.length + 1;
                    _customer.debt = debt;
                    _customer.payment = pay;
                    _customer.rest = debt - pay;
                    
                    json.docs.push(_customer);  
                    
                    json.debt_beginning = json.debt_beginning + debt_beginning;
                    json.debt = json.debt + debt;
                    json.payment = json.payment + pay;   
                    json.rest = json.rest + debt - pay;   

                    let _json:any = {
                      docs: new Array(), 
                      empty: true,
                      size:0,
                      debt_beginning: debt_beginning + debt_first,
                      debt: debt_beginning + debt_first,
                      payment: 0,
                      rest: debt_beginning + debt_first
                    }                 
                            
                    for(let j=0; j<bills.length; j++){
                      if(customer._id === bills[j].id_customer){
                        if((new Date(bills[j].date)).getTime() >= starttime.getTime()){
                            let bill:any = {...bills[j]};
                            delete bill?.discount; delete bill?.fee; delete bill?.id_customer;
                            delete bill?.note; delete bill?.payment_type; delete bill?.tax;
                            _json.docs.push(bill);
                            _json.docs[_json.docs.length -1].debt = 0;
                            _json.docs[_json.docs.length -1].payment = 0;
                            
                            if((bills[j].bill_type === 1)||(bills[j].bill_type === 15)){
                              _json.docs[_json.docs.length -1].debt = bills[j].total * (1 + bills[j]?.tax/100);
                              _json.docs[_json.docs.length -1].payment = bills[j].payment;
                              _json.docs[_json.docs.length -1].rest = _json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;  
                            }
                            else if(bills[j].bill_type === 3){
                              _json.docs[_json.docs.length -1].payment = bills[j].total * (1 + bills[j]?.tax/100);
                              _json.docs[_json.docs.length -1].debt = bills[j].payment;   
                              _json.docs[_json.docs.length -1].rest = _json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;  
                            }else if(bills[j].bill_type === 11){
                              _json.docs[_json.docs.length -1].payment = bills[j].payment;
                              _json.docs[_json.docs.length -1].rest = - bills[j].payment;
                            }
                            
                            _json.debt = _json.debt + _json.docs[_json.docs.length -1].debt;
                            _json.payment = _json.payment + _json.docs[_json.docs.length -1].payment   
                            _json.rest = _json.rest +_json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;   
                            _json.size++;
                            _json.empty = false;  
                            _json.docs[_json.docs.length -1].index = _json.docs.length;   
                        }                                  
                      }
                    }
                    json.docs[json.docs.length -1].json = _json;
                    if(isToday){
                      if(customer[id_branch] == undefined) {
                        let obj_val:any = {}
                        obj_val[id_branch] = {
                          debt_beginning: 0,
                          debtBalance: _json.rest
                        }
                        //console.log(1, customer, obj_val)    
                        this._updateCustomer(customer._id, obj_val);
                      }else{
                        let obj_val:any = {};
                        obj_val[id_branch] = customer[id_branch];
                        if(customer[id_branch].debtBalance == undefined){
                          obj_val[id_branch].debtBalance = _json.rest;
                          //console.log(2, customer, obj_val)    
                          this._updateCustomer(customer._id, obj_val);
                        }else{
                          if(customer[id_branch].debtBalance != _json.rest) {
                            obj_val[id_branch].debtBalance = _json.rest;
                            //console.log(3, customer, obj_val)    
                            this._updateCustomer(customer._id, obj_val)
                          }
                        }
                      }
                    }                    
                  console.log('getDebtCustomer_byTime', json)    
                  resolve(json);
              })   
        } catch (err) {
          console.error('❌ Lỗi getDebtCustomer_byTime:', err);
          reject(err);
        }  
      })();  
    })
  } 


  /**
 * CÔNG NỢ KHÁCH HÀNG
 * @example:
 * let endtime = new Date();
 * let starttime = new Date('2020-07-01T05:24:00');
 * this.vhQuerySales.getDebtCustomers(starttime, endtime, 'yewwg44667njdt443s', 'gtrtyery56646577456')
      .then((debts)=>{
        console.log('getDebtCustomers', debts);
      })
  * @param starttime
  * @param endtime
  * @param IDcustomer: id_customer hoặc 'all'  
  * @param IDbranch: id_branch hoặc 'all'  
  * @return JSON(Array) => json.docs = [{id, name, index, debt, payment, rest,...},{},....]
  * Lưu ý: giá trị này trả về dạng array
  */
  public getDebtCustomers(starttime:any, endtime:any, IDcustomer:string, IDbranch?:string){
    return new Promise<any>((resolve,reject) => {
      let json:any = {
        docs: new Array(),   
        debt_beginning: 0,                                 
        payment: 0,
        debt: 0,
        rest: 0
      } 
      if((IDbranch == 'all')|| (IDbranch == undefined)) return resolve(json);
      if((IDcustomer == 'all')|| (IDcustomer == undefined)) return resolve(json);

      let store = this.vhAuth.getStore();  
      let customers:any = new Array();   
      if(IDcustomer === 'all') customers = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalCustomers().filter((item:any)=> item._id != 'id_retail'), 'name');  
      else {
        let customer = this.getlocalCustomer(IDcustomer);           
        customers.push(customer);
      }  
      let branchs = this.getlocalBranchs();
      let id_branch = this.getDefaultBranch()._id;
      let query_bill:any;     
      let index:any = null;
      let day:any = null;
      if((customers[0][id_branch] != undefined)&&(customers[0][id_branch].debt != undefined))
        for(let k=0; k<customers[0][id_branch].debt.length; k++){
          if((new Date(customers[0][id_branch].debt[k].date)).getTime() > starttime.getTime()){
            break;
          }else{
            day = new Date(customers[0][id_branch].debt[k].date);
            index = k;
          }
        }            
      if(!day) day = new Date(store.registrationdate);   
      if(IDcustomer === 'all'){ 
        if((IDbranch === 'all')||(IDbranch === undefined)){              
          query_bill = {date:{$gte:day, $lte:endtime}, bill_type: {$in:[1,3,11,15]}};      
        }else{        
          query_bill = {date:{$gte:day, $lte:endtime}, bill_type: {$in:[1,3,11,15]}, id_branch: {$eq:IDbranch}};        
        }     
      }else{
        if((IDbranch === 'all')||(IDbranch === undefined)){              
          query_bill = {date:{$gte:day, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:[1,3,11,15]}};        
        }else{        
          query_bill = {date:{$gte:day, $lte:endtime}, id_customer: {$eq:IDcustomer}, bill_type: {$in:[1,3,11,15]}, id_branch: {$eq:IDbranch}};   
        }    
      }

      this.getBills_byFields(query_bill, {},{date:1},0) 
          .then((bills:any)=>{              
              // let json:any = {
              //   docs: new Array(),   
              //   debt_beginning: 0,                                 
              //   payment: 0,
              //   debt: 0,
              //   rest: 0
              // } 
              
              for(let i=0; i<customers.length; i++){
                let customer:any = {
                  _id:  customers[i]._id,
                  name:  customers[i].name
                };                                      
                json.docs.push(customer);                    
                let debt = 0; let pay = 0; let debt_beginning = 0; let debt_first = 0;
                for(let j=0; j<bills.length; j++){
                    if(bills[j].id_customer === customers[i]._id){
                      if((new Date(bills[j].date)).getTime() >= starttime.getTime()){
                        if((bills[j].bill_type === 1)||(bills[j].bill_type === 15)){                               
                          debt = debt + bills[j].total * (1 + bills[j].tax/100);
                          pay = pay + bills[j].payment;
                        }
                        else if(bills[j].bill_type === 11){                              
                          pay = pay + bills[j].payment;
                        }
                        else if(bills[j].bill_type === 3){                              
                          pay = pay + bills[j].total * (1 + bills[j].tax/100);
                          debt = debt + bills[j].payment;
                        }
                      }else{
                        if((bills[j].bill_type === 1)||(bills[j].bill_type === 15)){                         
                          debt_first = debt_first + bills[j].total * (1 + bills[j].tax/100) - bills[j].payment;
                        }
                        else if(bills[j].bill_type === 11){    
                          debt_first = debt_first - bills[j].payment;                     
                        }
                        else if(bills[j].bill_type === 3){                          
                          debt_first = debt_first + bills[j].payment - bills[j].total * (1 + bills[j].tax/100);
                        }                            
                      } 
                    }                          
                }                 

                if((IDbranch === 'all')||(IDbranch === undefined)){                 
                  for(let j=0; j<branchs.length; j++){
                    if((customers[i][branchs[j]._id] != undefined)&&(customers[i][branchs[j]._id].debt_beginning != undefined)){
                      debt_beginning = debt_beginning + customers[i][branchs[j]._id].debt_beginning;
                    }
                  }
                }else{
                  if((customers[i][IDbranch] != undefined)&&(customers[i][IDbranch].debt_beginning != undefined)){
                    debt_beginning = customers[i][IDbranch].debt_beginning;
                  }
                  if((customers[i][IDbranch] != undefined)&&(customers[i][IDbranch].debt != undefined)){
                    if(!index)
                      if(customers[i][IDbranch].debt[index] !=undefined)
                        debt_first = debt_first + customers[i][IDbranch].debt[index].debt_first;
                  }
                }                  
                
                debt = debt_beginning + debt_first + debt;
                json.docs[json.docs.length -1].index = json.docs.length;
                json.docs[json.docs.length -1].debt = debt;
                json.docs[json.docs.length -1].payment = pay;
                json.docs[json.docs.length -1].rest = debt - pay;
                
                
                json.debt_beginning = json.debt_beginning + debt_beginning;
                json.debt = json.debt + debt;
                json.payment = json.payment + pay;   
                json.rest = json.rest + debt - pay;   

                let _json:any = {
                  docs: new Array(), 
                  empty: true,
                  size:0,
                  debt_beginning: debt_beginning + debt_first,
                  debt: debt_beginning + debt_first,
                  payment: 0,
                  rest: debt_beginning + debt_first
                }                 
                        
                for(let j=0; j<bills.length; j++){
                  if(customers[i]._id === bills[j].id_customer){
                    if((new Date(bills[j].date)).getTime() >= starttime.getTime()){
                        let bill:any = {...bills[j]};
                        delete bill?.discount; delete bill?.fee; delete bill?.id_customer;
                        delete bill?.note; delete bill?.payment_type; delete bill?.tax;
                        _json.docs.push(bill);
                        _json.docs[_json.docs.length -1].debt = 0;
                        _json.docs[_json.docs.length -1].payment = 0;
                        
                        if((bills[j].bill_type === 1)||(bills[j].bill_type === 15)){
                          _json.docs[_json.docs.length -1].debt = bills[j].total * (1 + bills[j]?.tax/100);
                          _json.docs[_json.docs.length -1].payment = bills[j].payment;
                          _json.docs[_json.docs.length -1].rest = _json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;  
                        }
                        else if(bills[j].bill_type === 3){
                          _json.docs[_json.docs.length -1].payment = bills[j].total * (1 + bills[j]?.tax/100);
                          _json.docs[_json.docs.length -1].debt = bills[j].payment;   
                          _json.docs[_json.docs.length -1].rest = _json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;  
                        }else if(bills[j].bill_type === 11){
                          _json.docs[_json.docs.length -1].payment = bills[j].payment;
                          _json.docs[_json.docs.length -1].rest = - bills[j].payment;
                        }
                        
                        _json.debt = _json.debt + _json.docs[_json.docs.length -1].debt;
                        _json.payment = _json.payment + _json.docs[_json.docs.length -1].payment   
                        _json.rest = _json.rest +_json.docs[_json.docs.length -1].debt - _json.docs[_json.docs.length -1].payment;   
                        _json.size++;
                        _json.empty = false;  
                        _json.docs[_json.docs.length -1].index = _json.docs.length;   
                    }                                  
                  }
                }
                json.docs[json.docs.length -1].json = _json;
              }
                
              console.log('getDebtCustomers')    
              resolve(json);
          })     
    })
  }  

/**
 * lấy về 1 bảng báo cáo kiểm kho (report) theo cấu trúc json ở dưới, nếu có cân bằng kho thì lấy về chung luôn
 * @example:
 * this.vhQuerySales.getReportInventoryTime_byTimes('hNCda0obCvrX6qC3PZ0N')
      .then((reports)=>{
        console.log('getReportInventoryTime_byTimes',reports);          
      })
  * @param id_inventorytime 
  * @return Promise json = {docs(array), empty(boolean), size(number), total_stock(number), realstock, total_inventorynotes(array)}
  * docs(array) --> {id_product(string), id_subproduct(string), lots(array), name(string), img(string), ratio(number), barcode(string), unit(string), stock(number), inventorynotes(array), deviation(number), note(string), balance_quantity(number), balance_cause(string)}
  * inventorynotes(array) --> [{bill_code(string), quantity(number)},{},...]
  */
  public getReportInventoryTime_byTimes(id_inventorytime:any){     
    //inventorytime: đợt kiểm
    //inventorynote: phiếu kiểm
    return new Promise<any>((resolve, reject) => {       
          let inventorytime:any = this.getlocalInventorytime(id_inventorytime);//sau này sẽ bỏ hàm refresh của nó lúc khỏi động         
          let products = this.vhAlgorithm.sortVietnamesebyASC(this.getlocalDetailProducts(3), 'name');  
          let id_branch = this.getDefaultBranch()._id;         
          let json:any = {
            balanced: false,
              docs:  new Array(), 
              empty: true,
              size: 0,       
              total_stock: 0, //tổng số lượng kiểm kho theo phần mềm
              total_realstock: 0, // tổng số lượng kiểm kho thực tế
              total_inventorynotes: new Array()
          }    
          if(products.length>0){                
            let bill_details_stock = new Array();
            let bill_details_inventorytime = new Array();
            let bills_inventorytime = new Array();
            let bill_details_3839 = new Array();
            let promise = new Array();
            let query_01 ={};
            let query_02 ={};
            if(products[0][id_branch + '_ivtr'] != undefined){
              query_01 = {date: {$gte:new Date(products[0][id_branch + '_ivtr'][products[0][id_branch + '_ivtr'].length-1].date), $lte:new Date(inventorytime.date)}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,41,51,2,3,9]}, id_branch: {$eq:id_branch}};
              query_02 = {date: {$gte:new Date(products[0][id_branch + '_ivtr'][products[0][id_branch + '_ivtr'].length-1].date), $lte:new Date(inventorytime.date)}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}};
            }else{
              query_01 = {date: {$gte: new Date(this.vhAuth.getStore().registrationdate), $lte:new Date(inventorytime.date)}, ptype: {$eq:3}, bill_type: {$in:[1,10,15,41,51,2,3,9]}, id_branch: {$eq:id_branch}};
              query_02 = {date: {$gte: new Date(this.vhAuth.getStore().registrationdate), $lte:new Date(inventorytime.date)}, ptype: {$eq:3}, bill_type: {$in:[30,31]}, id_branch: {$eq:id_branch}};
            }
            promise[promise.length] = new Promise<any>((resolve, reject)=>{
                          let promise_0 = new Array();
                          promise_0[0] = this.getBill_details_byFields(query_01, {},{date:1},0);     
                          promise_0[1] = this.getBill_details_byFields(query_02, {},{date:1},0);  
                          Promise.all(promise_0)    
                              .then((bill_details:any)=>{   
                                bill_details = bill_details.flat();
                                bill_details_stock = [...bill_details];                                                 
                                resolve(null);
                              })
                            })                   
            let query_1:any = {id_inventorytime: {$eq:id_inventorytime},  bill_type: {$in:[13]}};
            promise[promise.length] = new Promise<any>((resolve, reject)=>{
                        this.getBill_details_byFields(query_1, {},{date:1},0)            
                            .then((bill_details:any)=>{                                 
                              bill_details_inventorytime = [...bill_details];                                    
                              resolve(null);
                            })
                          })  
            let query_2:any = {id_inventorytime: {$eq:id_inventorytime},  bill_type: {$in:[13]}};
            promise[promise.length] = new Promise<any>((resolve, reject)=>{
                        this.getBills_byFields(query_2, {},{date:1},0)                           
                            .then((bills:any)=>{                                 
                              bills_inventorytime = [...bills];                                     
                              resolve(null);
                            })        
                          })    
            let query_3:any = {id_inventorytime: {$eq:id_inventorytime},  bill_type: {$in:[38,39]}};
            promise[promise.length] = new Promise<any>((resolve, reject)=>{
                        this.getBill_details_byFields(query_3, {},{date:1},0)                           
                            .then((bill_details:any)=>{                                 
                              if(bill_details.length>0){
                                json.balanced = true;
                                bill_details_3839 = [...bill_details];      
                              }                                                               
                              resolve(null);
                            })        
                          })        
            Promise.all(promise)
                .then(()=>{                  
                  let total_stock = 0;
                  let total_realstock = 0;
                  let inventorynotes_total = new Array();
                  for(let j=0; j<bills_inventorytime.length; j++){                
                    inventorynotes_total.push({bill_code: bills_inventorytime[j].bill_code, quantity: 0});
                  }

                  for(let i=0; i<products.length; i++){    
                    if(bill_details_inventorytime.filter((item:any)=>{
                      if(item.id_product === products[i]._id){
                        if(item.id_subproduct){
                          if(item.id_subproduct === products[i].id_subproduct) return <any>true;
                        }else{
                          return true;
                        }
                        return false;
                      }
                    }).length > 0){
                      let unit = this.getUnit_byRatio(products[i].units, 1);   
                      let record:any ={    
                        id_product: products[i]._id,  
                        name: products[i].name, 
                        img: products[i].img,  

                        ratio: unit.ratio,
                        unit: unit.unit,
                        barcode: unit.barcode,     
                                           
                        stock: 0,
                        realstock: 0,                        
                        inventorynotes: [],

                        deviation: '--',
                        note: '--',             
                        balance_quantity: '--',         
                        balance_cause: '--'
                      }    
                      if(products[i].id_subproduct) record.id_subproduct = products[i].id_subproduct;                        
                      if(products[i].lots) {
                        record.lots = new Array();
                        for(let m = 0; m<products[i].lots.length; m++){                                  
                          record.lots[m] = {};
                          record.lots[m]._id = products[i].lots[m]._id;   
                          record.lots[m].barcode = products[i].lots[m].barcode;
                          record.lots[m].date_exp = products[i].lots[m].date_exp;
                          record.lots[m].date_mfg = products[i].lots[m].date_mfg;
                          record.lots[m].lot_number = products[i].lots[m].lot_number;                          
                          record.lots[m].stock = 0;   
                          record.lots[m].realstock = 0;                               
                          
                          record.lots[m].inventorynotes = new Array();                            

                          record.lots[m].deviation = '--';        
                          record.lots[m].note = '--';             
                          record.lots[m].balance_quantity = '--';         
                          record.lots[m].balance_cause = '--';                         
                        }

                        record.note = '';             
                        record.balance_quantity = '';         
                        record.balance_cause = '';
                      } 
                      //thêm số lượng sản phẩm đã kiểm cho mỗi record và record.lots
                      for(let j=0; j<bills_inventorytime.length; j++){                                         
                        record.inventorynotes.push({bill_code: bills_inventorytime[j].bill_code, quantity: 0});         
                        if(record.lots) {
                          for(let m = 0; m<record.lots.length; m++){     
                            record.lots[m].inventorynotes.push({bill_code: bills_inventorytime[j].bill_code, quantity: 0});       
                          }
                        }  
                      }     
                      
                      if(products[0][id_branch + '_ivtr'] != undefined){                           
                        if(products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length-1].lots)  {
                          for(let m = 0; m<products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length-1].lots.length; m++){
                            record.lots[m]._id = products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length-1].lots[m]._id;   
                            record.lots[m].stock = products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length-1].lots[m].stock_first;                           
                          }                          
                        }
                        record.stock = products[i][id_branch + '_ivtr'][products[i][id_branch + '_ivtr'].length-1].stock_first;
                      }
                      
                      for(let j=0; j<bill_details_stock.length; j++){ 
                        let is_sub_or_product = false;
                        if(products[i].id_subproduct) is_sub_or_product = bill_details_stock[j].id_subproduct === products[i].id_subproduct;
                        else is_sub_or_product = bill_details_stock[j].id_product === record.id_product;
                        if(bill_details_stock[j].ptype === 3){  
                          if(is_sub_or_product){  
                            let date = new Date(bill_details_stock[j].date);   
                            if((bill_details_stock[j].bill_type === 1)||(bill_details_stock[j].bill_type === 10)||(bill_details_stock[j].bill_type === 15)||(bill_details_stock[j].bill_type === 30)||(bill_details_stock[j].bill_type === 38)||(bill_details_stock[j].bill_type === 41)||(bill_details_stock[j].bill_type === 51)){
                              if(bill_details_stock[j].id_lotproduct){
                                for(let m=0; m<record.lots.length; m++){
                                  if(record.lots[m]._id === bill_details_stock[j].id_lotproduct){      
                                    record.lots[m].stock = record.lots[m].stock - bill_details_stock[j].quantity * bill_details_stock[j].ratio;     
                                  }
                                }
                              }
                              record.stock = record.stock - bill_details_stock[j].quantity * bill_details_stock[j].ratio;                               
                            }else if((bill_details_stock[j].bill_type === 2)||(bill_details_stock[j].bill_type === 3)||(bill_details_stock[j].bill_type === 9)||(bill_details_stock[j].bill_type === 31)||(bill_details_stock[j].bill_type === 39)){ 
                             
                              if(bill_details_stock[j].id_lotproduct){
                                for(let m=0; m<record.lots.length; m++){
                                  if(record.lots[m]._id === bill_details_stock[j].id_lotproduct){      
                                    record.lots[m].stock = record.lots[m].stock + bill_details_stock[j].quantity * bill_details_stock[j].ratio;     
                                  }
                                }
                              }
                              record.stock = record.stock + bill_details_stock[j].quantity * bill_details_stock[j].ratio; 
                            }                                                      
                          } 
                        }                                    
                      }                

                      for(let j=0; j<bill_details_inventorytime.length; j++){
                        let is_sub_or_product = false;
                        if(record.id_subproduct) is_sub_or_product = bill_details_inventorytime[j].id_subproduct === record.id_subproduct;
                        else is_sub_or_product = bill_details_inventorytime[j].id_product === products[i]._id;
                        for(let k=0; k<record.inventorynotes.length; k++){                          
                          if(is_sub_or_product){    
                            if(record.inventorynotes[k].bill_code === bill_details_inventorytime[j].bill_code){
                              if(bill_details_inventorytime[j].id_lotproduct){
                                for(let m=0; m<record.lots.length; m++){
                                  if(record.lots[m]._id === bill_details_inventorytime[j].id_lotproduct){      
                                    record.lots[m].realstock = record.lots[m].realstock + bill_details_inventorytime[j].quantity * bill_details_inventorytime[j].ratio;
                                    record.lots[m].inventorynotes[k].quantity = record.lots[m].inventorynotes[k].quantity +  bill_details_inventorytime[j].quantity * bill_details_inventorytime[j].ratio;
                                  }
                                }
                              }
                        
                              record.realstock = record.realstock + bill_details_inventorytime[j].quantity * bill_details_inventorytime[j].ratio;
                              record.inventorynotes[k].quantity =  record.inventorynotes[k].quantity + bill_details_inventorytime[j].quantity * bill_details_inventorytime[j].ratio;                              
                              //xem lại hàm dưới
                              inventorynotes_total[k].quantity = inventorynotes_total[k].quantity  + bill_details_inventorytime[j].quantity * bill_details_inventorytime[j].ratio
                            }
                          }
                        }
                      }   
                      
                      //tính toán các giá trị deviation, note, balance
                      if(record.lots){
                        for(let m=0; m<record.lots.length; m++){
                          record.lots[m].deviation = record.lots[m].realstock - record.lots[m].stock;
                          if(record.lots[m].deviation > 0) {
                            record.lots[m].note = 'Dư kho';
                            record.note = 'Lệch kho';
                          }else if(record.lots[m].deviation < 0){ 
                            record.lots[m].note = 'Thiếu kho';
                            record.note = 'Lệch kho';
                          }else if(record.lots[m].deviation === 0){
                            record.lots[m].note = 'Đủ kho';
                          }      
                        }
                        if(record.note != 'Lệch kho') record.note = 'Đủ kho'
                        record.deviation = record.realstock - record.stock;
                      }else{
                        record.deviation = record.realstock - record.stock;
                        if(record.deviation > 0) record.note = 'Dư kho';
                        else if(record.deviation < 0) record.note = 'Thiếu kho';
                        else if(record.deviation === 0) record.note = 'Đủ kho';                         
                      }                      
                      
                      for(let j=0; j<bill_details_3839.length; j++){
                        let is_sub_or_product = false;
                        if(record.id_subproduct) is_sub_or_product = bill_details_3839[j].id_subproduct === record.id_subproduct;
                        else is_sub_or_product = bill_details_3839[j].id_product === record.id_product;

                        if(bill_details_3839[j].bill_type === 38){
                          if(is_sub_or_product){
                            if(record.lots){
                              for(let m=0; m<record.lots.length; m++){
                                if(record.lots[m]._id === bill_details_3839[j].id_lotproduct){
                                  record.lots[m].balance_quantity = bill_details_3839[j].quantity * bill_details_3839[j].ratio;     
                                  record.lots[m].balance_cause = 'Xuất hủy';  
                                }
                              }
                            }else{
                              record.balance_quantity = bill_details_3839[j].quantity * bill_details_3839[j].ratio;       
                              record.balance_cause = 'Xuất hủy';
                            }
                          }
                        }else if(bill_details_3839[j].bill_type === 39){
                          if(is_sub_or_product){
                            if(record.lots){
                              for(let m=0; m<record.lots.length; m++){
                                if(record.lots[m]._id === bill_details_3839[j].id_lotproduct){
                                  record.lots[m].balance_quantity = bill_details_3839[j].quantity * bill_details_3839[j].ratio;     
                                  record.lots[m].balance_cause = 'Nhập bù';  
                                }
                              }
                            }else{                              
                              record.balance_quantity = bill_details_3839[j].quantity * bill_details_3839[j].ratio;       
                              record.balance_cause = 'Nhập bù';
                            }
                          }
                        }
                      }






      
                      total_stock = total_stock + record.stock;
                      total_realstock = total_realstock + record.realstock;
                    
                      json.docs.push(record);
                      json.empty = false;
                      json.size++; 
                    }                   
                  }
    
                  json.total_stock =  total_stock; 
                  json.total_realstock = total_realstock;
                  json.total_inventorynotes =  [...inventorynotes_total];       
                  //console.log('getReportInventoryTime_byTimes', json);                              
                  resolve(json);
                })                      
          }          
      
    })
  }

  /**
   * Tạo cân bằng kho
   * @example:
   * this.vhQuerySales.createBalanceInventoryTime_byTimes('hNCda0obCvrX6qC3PZ0N')
        .then((bool:any)=>{
          console.log('createBalanceInventoryTime_byTimes',bool);          
        })
  * @param id_inventorytime 
  * @return Promise boolean => true or false
  */
  public createBalanceInventoryTime_byTimes(id_inventorytime:any){
    return new Promise<any>((resolve, reject) => {    
      let inventorytime:any = this.getlocalInventorytime(id_inventorytime);  
      this.deleteBalanceInventoryTime_byTimes(id_inventorytime)
          .then(()=>{          
            this.getReportInventoryTime_byTimes(id_inventorytime)
                .then((json)=>{
                  let promise = new Array();
                  if(json.size >0){                    
                    for(let i=0; i<json.size; i++){
                      let record = {...json.docs[i]};
                      if(record.lots){
                        let promise_lot = new Array();
                        let bill_details_balance = new Array(); //bill_details xuất hủy
                        //let bill_details_i = new Array(); //bill_details thêm bù
                        promise[promise.length] = new Promise(resolve=>{
                          for(let m=0; m<record.lots.length; m++){
                            if(record.lots[m].deviation <0){
                              promise_lot[promise_lot.length] = new Promise(resolve=>{
                                let bill_detail:any = {};
                                bill_detail.id_branch = this.getDefaultBranch()._id;
                                bill_detail.bill_code = this.vhAlgorithm.createBillCode(),//chọn lại thời gian cho đúng với bill_code 
                                bill_detail.bill_type = 38; //xuất hủy kho    
                                bill_detail.tax = 0;        
                                bill_detail.date = new Date(inventorytime.date);//thời gian của đợt kiểm
                                bill_detail.id_inventorytime = id_inventorytime;
                                bill_detail.id_employee = this.vhAuth.getUser()._id;     

                                bill_detail.quantity = - record.lots[m].deviation;
                                bill_detail.ratio = record.ratio;
                                bill_detail.ptype = 3;
                                bill_detail.price = 0;
                                bill_detail.id_product = record.id_product;
                                if(record.id_subproduct) bill_detail.id_subproduct = record.id_subproduct;       
                                bill_detail.id_lotproduct = record.lots[m]._id;                
                            
                                this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill_detail.date), bill_detail)                     
                                    .then((message:any)=>{                                                               
                                        bill_detail.balance_negative_or_positive = 1; //số liệu kiểm thực tế nhỏ hơn số liệu kho trên phần mề); lúc này gọi là cân bằng âm (sẽ xuất hủy đi phần chênh lệch này)
                                        bill_details_balance.push(bill_detail);
                                        //console.log('bill_details_balance1', bill_details_balance);       
                                        resolve(true);
                                    })                        
                              })
                            }else if(record.lots[m].deviation >0){
                              promise_lot[promise_lot.length] = new Promise(resolve=>{
                                let bill_detail:any = {};
                                bill_detail.id_branch = this.getDefaultBranch()._id;
                                bill_detail.bill_code = this.vhAlgorithm.createBillCode(),//chọn lại thời gian cho đúng với bill_code 
                                bill_detail.bill_type = 39; //nhập bù kho    
                                bill_detail.tax = 0;        
                                bill_detail.date = new Date();//thời gian của đợt kiểm
                                bill_detail.id_inventorytime = id_inventorytime;
                                bill_detail.id_employee = this.vhAuth.getUser()._id;     

                                bill_detail.quantity = record.lots[m].deviation;
                                bill_detail.ratio = record.ratio;
                                bill_detail.ptype = 3;
                                bill_detail.price = 0;
                                bill_detail.id_product = record.id_product;
                                if(record.id_subproduct) bill_detail.id_subproduct = record.id_subproduct;                    
                                bill_detail.id_lotproduct = record.lots[m]._id;      

                                this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill_detail.date), bill_detail)                     
                                    .then((message:any)=>{                                                                   
                                        bill_detail.balance_negative_or_positive = 2; //số liệu kiểm thực tế lớn hơn số liệu kho trên phần mề); lúc này gọi là cân bằng dương (sẽ nhập bù thêm vào)
                                        bill_details_balance.push(bill_detail);
                                        //console.log('bill_details_balance2', bill_details_balance);    
                                        resolve(true);   
                                    })                        
                              })
                            }
                            
                          }
                          Promise.all(promise_lot)
                                .then(()=>{
                                  let promise_products = new Array();
                                  let id_branch = this.getDefaultBranch()._id;
                                  for(let i=0; i<bill_details_balance.length; i++){  
                                    //console.log('bill_details_balance3', bill_details_balance);
                                    //theo yêu cầu cân bằng dương hay cân bằng âm mà xóa bỏ đi hoặc thêm bù vào, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại  
                                    if(!bill_details_balance[i].calculated){                                                              
                                      let id_sub_or_product = bill_details_balance[i].id_subproduct?bill_details_balance[i].id_subproduct:bill_details_balance[i].id_product
                                      let product = this.getlocalDetailProduct(id_sub_or_product);  
                                      let quantity_all_bill_details = 0;       
                                      let lots = new Array();
                                      if(bill_details_balance[i].id_lotproduct) lots = product.lots;            
                                      for(let j=0; j<bill_details_balance.length; j++){     
                                        if(!bill_details_balance[j].calculated){                               
                                          if(id_sub_or_product === (bill_details_balance[j].id_subproduct?bill_details_balance[j].id_subproduct:bill_details_balance[j].id_product)){   
                                            if(bill_details_balance[j].balance_negative_or_positive === 1){                                           
                                              quantity_all_bill_details = quantity_all_bill_details - bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                              bill_details_balance[j].calculated = true;
                                              for(let m=0; m<lots.length; m++){
                                                if(lots[m]._id === bill_details_balance[j].id_lotproduct){
                                                  lots[m].quantity = lots[m].quantity - bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                                  lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] - bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                                }
                                              }
                                            }else if(bill_details_balance[j].balance_negative_or_positive === 2){ 
                                              quantity_all_bill_details = quantity_all_bill_details + bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                              bill_details_balance[j].calculated = true;
                                              for(let m=0; m<lots.length; m++){
                                                if(lots[m]._id === bill_details_balance[j].id_lotproduct){
                                                  lots[m].quantity = lots[m].quantity + bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                                  lots[m].quantity_branch[id_branch] = lots[m].quantity_branch[id_branch] + bill_details_balance[j].quantity * bill_details_balance[j].ratio;
                                                }
                                              }
                                            }
                                          }                                        
                                        }                                          
                                      }                                                                                         
                                      let quantity_branch = {...product.quantity_branch};     
                                      quantity_branch[id_branch] = quantity_branch[id_branch] + quantity_all_bill_details;                                 
                                      let quantity = product.quantity + quantity_all_bill_details;                                  
                                      if(lots.length >0){             
                                        promise_products[promise_products.length] = this.vhMGDB_database.updateDoc('products', id_sub_or_product,{quantity: quantity, quantity_branch: quantity_branch, lots: lots});       
                                      }                                                                                                                  
                                    }                                                                                             
                                                                  
                                  }  
                                  this.vhQuery.asyncPromiseAll(promise_products)
                                      .then(()=>{  
                                        resolve(null)
                                      })  
                                })
                        })
                      }else{                       
                        if(record.deviation <0){//realstock < stock
                          promise[promise.length] = new Promise(resolve=>{
                            let bill_detail:any = {};
                            bill_detail.id_branch = this.getDefaultBranch()._id;
                            bill_detail.bill_code = this.vhAlgorithm.createBillCode(),//chọn lại thời gian cho đúng với bill_code 
                            bill_detail.bill_type = 38; //xuất hủy kho (phần mềm), do số lượng kiểm thực tế nhỏ hơn số lượng kho trên phần mềm     
                            bill_detail.tax = 0;        
                            bill_detail.date = new Date(inventorytime.date);//thời gian của đợt kiểm
                            bill_detail.id_inventorytime = id_inventorytime;
                            bill_detail.id_employee = this.vhAuth.getUser()._id;     

                            bill_detail.quantity = - record.deviation;
                            bill_detail.ratio = record.ratio;
                            bill_detail.ptype = 3;
                            bill_detail.price = 0;
                            bill_detail.id_product = record.id_product;
                            if(record.id_subproduct) bill_detail.id_subproduct = record.id_subproduct;                       
                        
                            this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill_detail.date), bill_detail)                     
                                .then((message:any)=>{   
                                    //Sau khi xuất, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                         
                                    this.calculateQuantityProduct_DOWN([{...bill_detail}], bill_detail.id_branch)
                                    .then(()=>{
                                      resolve(true);
                                    })     
                                })                        
                          })
                        }else if(record.deviation >0){
                          promise[promise.length] = new Promise(resolve=>{
                            let bill_detail:any = {};
                            bill_detail.id_branch = this.getDefaultBranch()._id;
                            bill_detail.bill_code = this.vhAlgorithm.createBillCode(),//chọn lại thời gian cho đúng với bill_code 
                            bill_detail.bill_type = 39; //nhập bù kho (phần mềm), do số lượng kiểm thực tế lớn hơn số lượng kho trên phần mềm    
                            bill_detail.tax = 0;        
                            bill_detail.date = new Date();//thời gian của đợt kiểm
                            bill_detail.id_inventorytime = id_inventorytime;
                            bill_detail.id_employee = this.vhAuth.getUser()._id;     

                            bill_detail.quantity = record.deviation;
                            bill_detail.ratio = record.ratio;
                            bill_detail.ptype = 3;
                            bill_detail.price = 0;
                            bill_detail.id_product = record.id_product;
                            if(record.id_subproduct) bill_detail.id_subproduct = record.id_subproduct;                    
                        
                            this.vhMGDB_database.addDoc('vhs_bill_details_' + this.getYear(bill_detail.date), bill_detail)                     
                                .then((message:any)=>{   
                                    //Sau khi nhập, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                         
                                    this.calculateQuantityProduct_UP([{...bill_detail}], bill_detail.id_branch)
                                    .then(()=>{
                                      resolve(true);
                                    })     
                                })                        
                          })
                        }
                      }                     
                    }
                  }
                  Promise.all(promise)
                      .then(()=>{            
                        this.vhMGDB_database.updateDoc('inventorytimes', id_inventorytime, {balanced:true});     
                        resolve(true);                       
                        // this.getReportInventoryTime_byTimes(id_inventorytime)
                        //     .then((reports)=>{
                        //       //console.log('reports',reports);   
                        //       resolve(reports);       
                        //     })
                      })        
                })
          })
    })    
  }

  /**
   * Xóa cân bằng kho
   * @example:
   * this.vhQuerySales.deleteBalanceInventoryTime_byTimes('hNCda0obCvrX6qC3PZ0N')
        .then((bool:any)=>{
          console.log('deleteBalanceInventoryTime_byTimes',bool);          
        })
  * @param id_inventorytime 
  * @return Promise boolean => true or false
  */
  public deleteBalanceInventoryTime_byTimes(id_inventorytime:any){
    return new Promise<any>((resolve, reject) => {    
      let promise = new Array(); 
        promise[promise.length] = new Promise(resolve=>{
        let query_delete:any = {id_inventorytime: {$eq:id_inventorytime},  bill_type: {$in:[38,39]}};      
        this.getBill_details_byFields(query_delete, {},{date:1},0)                           
            .then((bill_details:any)=>{   
              if(bill_details.length >0){
                let promise_zero = new Array();
                for(let i=0; i<bill_details.length; i++){
                  promise_zero[promise_zero.length] = this.vhMGDB_database.deleteDoc('vhs_bill_details_' + this.getYear(bill_details[i].date), bill_details[i]._id)
                }    
                Promise.all(promise_zero)
                      .then(()=>{
                        let promise_one = new Array();
                        let bill_details_38 = bill_details.filter((e:any)=>e.bill_type=== 38);                     
                        //Sau khi xóa bill_type_38, tăng số lượng kho lên, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                         
                        promise_one[promise_one.length] = this.calculateQuantityProduct_UP([{...bill_details_38}], this.getDefaultBranch()._id)
                          
                        let bill_details_39 = bill_details.filter((e:any)=>e.bill_type===39);
                        //Sau khi xóa bill_type_39, giảm số lượng kho xuống, tính tổng các bill_detail giống nhau lại để tính số lượng 1 lần, và bill_detail nào đã tính rồi sẽ không tính lại                                                         
                        promise_one[promise_one.length] = this.calculateQuantityProduct_DOWN([{...bill_details_39}], this.getDefaultBranch()._id)
                        Promise.all(promise_one)
                              .then(()=>{   
                                resolve(true);
                              })                      
                      })                            
              }else{
                resolve(true);
              }                      
            }) 
      })    
      Promise.all(promise)
            .then(()=>{     
              this.vhMGDB_database.updateDoc('inventorytimes', id_inventorytime, {balanced:false});
              resolve(true);                             
              // this.getReportInventoryTime_byTimes(id_inventorytime)
              //     .then((reports)=>{                    
              //       resolve(reports);       
              //     })
            })           
    })   
  }

  private getBeginningInventory(){

  }

  private getReportProducts_by3Time(starttime:any, endtime:any){
    return new Promise<any>((resolve, reject) => {     
              let products = this.getlocalProducts();                 
              let json:any = {
                docs: new Array(),
                empty: true,
                size:0
              }              
              if(products.length>0){             
                json={
                  docs:  new Array(),
                  empty: true,
                  size: 0,                  
                  outstock: 0,
                  instock: 0, 
                  revenue_btax: 0,   
                  revenue_atax: 0,  
                  cost_btax: 0,     
                  cost_atax: 0,             
                  profit_btax: 0,
                  profit_atax: 0,               
                }           
                //nhớ kiểm tra có cần thêm sắp xếp asc ko                    
                this.getBill_details_byFields({bill_type:{$in:[1,10,15,2,3,9]}}, {},{date:1},0)     
                //this.load_bill_billdetails_logs_onRAM_all()
                    .then((logs:any)=>{                    
                            for(let i=0; i<products.length; i++){
                              //if(products[i].type === 1){
                                  let product =  {...products[i]};                                 
                                  let data:any ={    
                                    id: product._id,                  
                                    data(){
                                      delete product._id;
                                      return product;
                                    }
                                  }; 
                                  data.outstock =0; 
                                  data.instock =0;

                                  data.revenue_btax = 0; 
                                  data.revenue_atax = 0; 
                                  data.cost_btax = 0;    
                                  data.cost_atax = 0;                              
                                  data.profit_btax = 0;
                                  data.profit_atax = 0;                       
                                  
                                  data.stock_first = 0;   
                                  data.stock_last = 0;   
                                  data.cost_stock_first_btax = 0;   
                                  data.cost_stock_first_atax = 0;                          
                                  data.cost_stock_last_btax = 0;   
                                  data.cost_stock_last_atax = 0;                                     

                                  let outstock_0 =0; 
                                  let instock_0 =0;                                                                
                                  let cost_btax_0 = 0;
                                  let cost_atax_0 = 0;
                                  let revenue_btax_0 = 0;
                                  let revenue_atax_0 = 0;
                                      
                                  for(let j=0; j<logs.length; j++){                                   
                                   
                                    if((logs[j].id_product === products[i]._id)&&(logs[j].date <= endtime)){
                                        let date = logs[j].date;                                                        
                                        if((logs[j].bill_type === 1)||(logs[j].bill_type === 10)||(logs[j].bill_type === 15)){
                                          if(date >= starttime){                                         
                                            data.outstock = data.outstock + logs[j].quantity;
                                            data.revenue_btax = data.revenue_btax + logs[j].price;
                                            data.revenue_atax = data.revenue_atax + logs[j].price *(1 + logs[j].tax /100 );

                                            
                                          }else{         
                                            outstock_0 = outstock_0 + logs[j].quantity;
                                            revenue_btax_0 = revenue_btax_0 + logs[j].price;
                                            revenue_atax_0 = revenue_atax_0 + logs[j].price *(1 + logs[j].tax /100 );                       
                                          }
                                        }else if((logs[j].bill_type === 2)||(logs[j].bill_type === 3)||(logs[j].bill_type === 9)){
                                          if(date >= starttime){  
                                            data.instock = data.instock + logs[j].quantity;
                                            data.cost_btax = data.cost_btax + logs[j].price;
                                            data.cost_atax = data.cost_atax + logs[j].price *(1 + logs[j].tax /100);

                                          }else{
                                            instock_0 = instock_0 + logs[j].quantity;
                                            cost_atax_0 = cost_atax_0 + logs[j].price;
                                            cost_btax_0 = cost_btax_0 + logs[j].price *(1 + logs[j].tax /100);
                                          }
                                        }                                       
                                    }
                                  }                         

                                  data.stock_first = instock_0 - outstock_0;                               
                                  data.stock_last = data.stock_first + data.instock - data.outstock;

                                  data.cost_stock_first_btax =  data.stock_first * cost_btax_0/instock_0;
                                  if(instock_0 != 0) data.cost_stock_first_atax = data.stock_first * data.cost_atax_0/instock_0; 
                                  if((instock_0 + data.instock) != 0) data.cost_stock_last_btax = data.stock_last * (cost_btax_0 + data.cost_btax) / (instock_0 + data.instock);
                                  if((instock_0 + data.instock) != 0) data.cost_stock_last_atax = data.stock_last * (data.cost_atax_0 + data.cost_atax) / (instock_0 + data.instock);    
                                  
                                  if(((outstock_0 + data.outstock) != 0)&&((instock_0 + data.instock) != 0)) data.profit_btax = data.outstock * ((data.revenue_btax_0 + data.revenue_btax) / (outstock_0 + data.outstock) - (cost_btax_0 + data.cost_btax) / (instock_0 + data.instock));
                                  if(((outstock_0 + data.outstock) != 0)&&((instock_0 + data.instock) != 0)) data.profit_atax = data.outstock * ((data.revenue_atax_0 + data.revenue_atax) / (outstock_0 + data.outstock) - (cost_atax_0 + data.cost_btax) / (instock_0 + data.instock));
                                  
                                  json.outstock = json.outstock + data.outstock;
                                  json.revenue_btax = json.revenue_btax + data.revenue_btax;
                                  json.revenue_atax = json.revenue_atax + data.revenue_atax;
                                  
                                  json.instock = json.instock + data.instock;
                                  json.cost_btax = json.cost_btax + data.cost_btax;
                                  json.cost_atax = json.cost_atax + data.cost_atax;

                                  json.profit_btax = json.profit_btax + data.profit_btax;
                                  json.profit_atax = json.profit_atax + data.profit_atax;
                                  
                                  json.docs.push(data);
                                  json.size++;                        
                                  json.empty = false; 
                              //}
                            }                             
                        resolve(json);   
                    })
              
              }else{
                console.log('server -> products khong ton tai trong CSDL: ');
                resolve(json);   
                //reject();
              }  
      //})    
    })
  } 

    /**
   * @example:
   * let endtime = new Date();
    let starttime = new Date('2020-07-01T05:24:00');
    this.vhQuerySales.getReportProduct_byID(starttime, endtime, 'pro002')
        .then((reportReports)=>{
          console.log('reportReports', reportReports);
          console.log('reportReports.docs[0].data()', reportReports.docs[0].data());
        })
   * @param starttime 
   * @param endtime 
   * @param id_product 
   */
  public getReportProduct_byID(starttime:any, endtime:any, id_product:any){
    return new Promise<any>((resolve, reject) => {         
      let json:any = {
        docs: new Array(),
        empty: true,
        size:0        
      }                 
      let query = {date: {$gte:starttime, $lte:endtime}, id_product: {$eq:id_product},  bill_type: {$in:[1,2,3,9,10,15]}};
      this.getBill_details_byFields(query, {},{date:1},0)
         .then((vhbill_details:any)=>{
            if(vhbill_details.length>0){
              for(let i=0; i<vhbill_details.length; i++){
                
                  let data ={    
                    _id: vhbill_details[i]._id,                  
                    data(){
                      let data:any = {...vhbill_details[i]};
                      if(data.date) delete data.date;
                      if(typeof data.tax == 'number') delete data.tax;
                      if(typeof data.bill_type == 'number') delete data.bill_type;
                      if(data.id_cashier) delete data.id_cashier;
                      if(data.id_employee) delete data.id_employee;
                      if(data.id_supplier) delete data.id_supplier;
                      if(data.id_customer) delete data.id_customer;
                      return data;
                    },
                    bill_type: vhbill_details[i].bill_type,
                    tax: vhbill_details[i].tax,
                    date: vhbill_details[i].date
                  };
                  json.docs.push(data);
                  json.size++;
                  json.empty = false;             
              }                    
            }
            resolve(json);
          })                
    
    })
  }

  /*****************************************************************************************************
   ******************************* CHƯƠNG TRÌNH BÁN HÀNG SALES VIETHAS ***********************************************
   *****************************************************************************************************/
  /******************************************TÍCH ĐIỂM THEO HÓA ĐƠN*************************************/

/**
 * @example:
 *  let data ={
      name : 'chương trình tích điểm hóa đơn',
      exchange :{
        money : 100000,
        points : 1
      },
      bill_total_minimum :0,
      payment  :{
        enable : true,
        money : 100000,
        points : 1
      },
      include_discount: false,
      include_promotion_product : false,
      include_paid_points : false,
      include_tax : false,
      include_fee : false,
      //id_branch : '5fb6780ca2148e09806c5b01',  //trong hàm đã thêm vào
      earned_points_clear_auto:{
        enable,
        months_of_year: 1
      }
    }
   this.vhQuerySales.addEarningPointsBill(data)
        .then((earningpoint)=>{
          console.log('addEarningPointsBill', earningpoint);
        },(error:any)=>{
          console.log('error', error);
        })
  * @param data 
  * @return  Promise => obj = {}
  */
  public addEarningPointsBill(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('earning_points_bills', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }  
/**
 * @example:
  let data ={
      name : 'chương trình tích điểm hóa đơn',
      exchange :{
      money : 100000,
      points : 1
      },
      bill_total_minimum :0,
      payment  :{
        enable : true,
        money : 100000,
        points : 1
    },
    include_discount: false,
    include_promotion_product : false,
    include_paid_points : false,
    include_tax : false,
    include_fee : false,
    id_branch : '5fb6780ca2148e09806c5b01'
  }
  * @param id_earning_points_bill 
  * @param data 
  * @return Promise => bool = true or false 
  */
  public updateEarningPointsBill(id_earning_points_bill:string, data:object){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('earning_points_bills', id_earning_points_bill, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
 
  /**
   * @example:
   * this.vhQuerySales.deleteEarningPointsBill('5fb67fda87c0f21d484cbdf3')
      .then((bool:any)=>{
        console.log('deleteEarningPointsBill', bool);
      })
  * @param id_earning_points_bill 
  * @return Promise => bool = true or false 
  */
  public deleteEarningPointsBill(id_earning_points_bill:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('customer_classs',{id_earning_points_bill:{$eq:id_earning_points_bill}})
          .then((customer_classs:any)=>{       
            for(let i=0; i<customer_classs.length; i++){
              this.vhMGDB_database.updateDoc('customer_classs', customer_classs[i]._id, {id_earning_points_bill:null});
            }       
            this.vhMGDB_database.deleteDoc('earning_points_bills', id_earning_points_bill)
                .then((bool:any)=>{            
                  resolve(bool);
                }, error=>{
                  reject(error)
                })  
          },(error:any)=>{
            reject(error);
          })              
    })
  }

  /**
   * @example
   * this.vhQuerySales.getEarningPointsBill('5fb67fda87c0f21d484cbdf3')
            .then((earning_points_bill)=>{
              console.log('getEarningPointsBill', earning_points_bills);
            },(error:any)=>{
              reject(error);
            })  
   * @param id_earning_points_bill 
   * @return Promise => obj ={} or null
   */
    public getEarningPointsBill(id_earning_points_bill:string){
      return new Promise((resolve, reject) => {
        this.vhMGDB_database.getDoc('earning_points_bills', id_earning_points_bill)
              .then((earning_points_bill)=>{
                resolve(earning_points_bill);
              }, error=>{
                reject(error);
             })          
      })
    }

  /**
   * @example
   * this.vhQuerySales.getEarningPointsBills()
            .then((earning_points_bills)=>{
              console.log('getEarningPointsBills', earning_points_bills);
            })
   * @return Promise => array(object) = [{},{},..]
   */
  public getEarningPointsBills(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('earning_points_bills')
              .then((earning_points_bills)=>{              
                resolve(earning_points_bills);
              },(error:any)=>{
                reject(error);
              })          
      }else{
        this.vhMGDB_database.getDocsByFields('earning_points_bills', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((earning_points_bills)=>{              
              resolve(earning_points_bills);
            },(error:any)=>{
              reject(error);
            }) 
      } 
    })
  } 

  /**
 * @example:
 *  let data ={
      name : 'chương trình tích điểm sản phẩm',
      exchange :{
        money : 100000,
        points : 1
      },
      payment  :{
        enable : true,
        money : 100000,
        points : 1
      },
      products:['05ztAR5h3UslYo70Amut','0S8NOcG8wEUYWVo1weHV','0tmbM5SyGe5O1mvuh61l',...],      
      include_promotion_product : false,
      include_paid_points : false,
      //id_branch : '5fb6780ca2148e09806c5b01' //trong hàm đã thêm vào
    }
    this.vhQuerySales.addEarningPointsProduct(data)
        .then((res)=>{
          console.log('addEarningPointsProduct', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return Promise => object or error
  */
  public addEarningPointsProduct(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('earning_points_products', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example:
  let data ={
    name : 'chương trình tích điểm sản phẩm',
      exchange :{
      money : 100000,
      points : 1
    },
    payment  :{
      enable : true,
      money : 100000,
      points : 1
    },
    include_promotion_product : false,
    include_paid_points : false,
    id_branch : '5fb6780ca2148e09806c5b01'
  }
 * this.vhQuerySales.updateEarningPointsProduct(id_earning_points_product,data)
        .then((bool:any)=>{
          console.log('updateEarningPointsProduct', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_earning_points_product
  * @param data
  * @return Promise => bool = true or false
  */
  public updateEarningPointsProduct(id_earning_points_product:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('earning_points_products', id_earning_points_product, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example:
 * this.vhQuerySales.deleteEarningPointsProduct('654QFNMOIYUENC321')
        .then((bool:any)=>{
          console.log('deleteEarningPointsProduct', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_earning_points_product
  * @return Promise => bool = true or false
  */
  public deleteEarningPointsProduct(id_earning_points_product:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('customer_classs',{id_earning_points_product:{$eq:id_earning_points_product}})
          .then((customer_classs:any)=>{       
            for(let i=0; i<customer_classs.length; i++){
              this.vhMGDB_database.updateDoc('customer_classs', customer_classs[i]._id, {id_earning_points_product:null});
            }       
            this.vhMGDB_database.deleteDoc('earning_points_products', id_earning_points_product)
                .then((bool:any)=>{            
                  resolve(bool);
                }, error=>{
                  reject(error)
                })  
          },(error:any)=>{
            reject(error);
          })                     
    })
  }
/**
 * @example:
 * this.vhQuerySales.getEarningPointsProduct('654QFNMOIYUENC321')
        .then((res)=>{
          console.log('getEarningPointsProduct', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_earning_points_product
  * @return Promise => object or null
  */
  public getEarningPointsProduct(id_earning_points_product:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('earning_points_products', id_earning_points_product)
            .then((earning_points_product)=>{
              resolve(earning_points_product);
            }, error=>{
               reject(error);
            })          
    })
  }
/**
 * @example: 
 * this.vhQuerySales.getEarningPointsProducts()
        .then((arr)=>{
          console.log('getEarningPointsProducts', arr);
        }, error=>{
          console.log('error', error);
        })
  * @return Promise => Array<object>
  */
  public getEarningPointsProducts(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('earning_points_products')
              .then((earning_points_products)=>{              
                resolve(earning_points_products);
              },(error:any)=>{
                reject(error);
              })          
      }else{
        this.vhMGDB_database.getDocsByFields('earning_points_products', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((earning_points_products)=>{              
              resolve(earning_points_products);
            },(error:any)=>{
              reject(error);
            }) 
      }          
    })
  }

// *Hạng nhân viên --------------------------------------------------------------
/**
 * @example: 
 * this.vhQuerySales.addEmployeeClass({name : "Gold"})
        .then((res)=>{
          console.log('addEmployeeClass', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return Promise => object or error
  */
  public addEmployeeClass(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('employee_classs', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example: 
 * this.vhQuerySales.updateEmployeeClass('KNOVIYWKN135468',{id_commission : "321SDWC65DWSVDFS"})
        .then((bool:any)=>{
          console.log('updateEmployeeClass', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_employee_class
  * @param data
  * @return Promise => bool = true or false
  */
  public updateEmployeeClass(id_employee_class:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('employee_classs', id_employee_class, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example: 
 * this.vhQuerySales.deleteEmployeeClass('KNOVIYWKN135468')
        .then((bool:any)=>{
          console.log('deleteEmployeeClass', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_employee_class
  * @return Promise => bool = true or false
  */
  public deleteEmployeeClass(id_employee_class:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('employee_classs', id_employee_class)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example: 
 * this.vhQuerySales.getEmployeeClass('KNOVIYWKN135468')
        .then((res)=>{
          console.log('getEmployeeClass', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_employee_class
  * @return Promise => object or null
  */
  public getEmployeeClass(id_employee_class:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('employee_classs', id_employee_class)
            .then((customer_class)=>{
              resolve(customer_class);
            }, error=>{
                reject(error);
            })          
    })
  }
/**
 * @example: 
 * this.vhQuerySales.getEmployeeClasss()
        .then((array:any)=>{
          console.log('getEmployeeClasss', array);
        }, error=>{
          console.log('error', error);
        })
  * @param id_employee_class
  * @return Promise => Array<object>
  */
  public getEmployeeClasss(){
    return new Promise((resolve, reject) => {   
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('employee_classs')
            .then((employee_classs)=>{              
              resolve(employee_classs);
            },(error:any)=>{
              reject(error);
            })             
      }else{
        this.vhMGDB_database.getDocsByFields('employee_classs', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((employee_classs)=>{              
              resolve(employee_classs);
            },(error:any)=>{
              reject(error);
            }) 
      }                
    })
  }

  /**
   * trong local chưa có
   * @example: 
   * let employee_classs = this.vhQuerySales.getlocalEmployeeClasss() 
    * @param data
    * @return Array<object>
    */
  public getlocalEmployeeClasss(){

  }
  /**
  * trong local chưa có
  * @example: 
  * let employee_class = this.vhQuerySales.getlocalEmployeeClass('321987965DOIUEHN') 
  * @param id_employee_class
  * @return object or null
  */
  public getlocalEmployeeClass(id_customer_class:any){

  }

//Phiếu thanh toán ------------------------------------------------------------
/**
 * @example: 
 * let data = {
 * name:"Phiếu thanh toán 100k",
 * value : 100000,
 * point : 1000,
 * id_design_barcode : "",
 * //id_branch :" 316OIUHLKMLSDYW235" //trong hàm đã có thêm vào
 * }
 * this.vhQuerySales.addCoupon(data)
        .then((res)=>{
          console.log('addCoupon', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return Promise => object or error
  */
  public addCoupon(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('coupons', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example: 
 * let data = {
 * name:"Phiếu thanh toán 100k",
 * value : 100000,
 * point : 1000,
 * id_design_barcode : "",
 * }
 * this.vhQuerySales.updateCoupon('FBHYWIBDNIUH1321687',data)
        .then((bool:any)=>{
          console.log('updateCoupon', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @param id_coupon
  * @return Promise => bool = true or false
  */
  public updateCoupon(id_coupon:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('coupons', id_coupon, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
 * @example:  
 * this.vhQuerySales.deleteCoupon("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteCoupon', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do coupon đã được phát hành, vui lòng xóa đợt phát hành liên quan
  */
  public deleteCoupon(id_coupon:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_release_details', {id_coupon:{$eq:id_coupon}}, {})
          .then((coupon_release_details:any)=>{
            if(coupon_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('coupons', id_coupon)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_coupon: ${id_coupon} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do coupon đã được phát hành, vui lòng xóa đợt phát hành liên quan'})           
          }, error=>{
            reject(error)
          })             
    })
  }
/**
 * @example: 
 *
 * this.vhQuerySales.getCoupon('FBHYWIBDNIUH1321687')
        .then((res)=>{
          console.log('getCoupon', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_coupon
  * @return Promise => object or null
  */
  public getCoupon(id_coupon:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('coupons', id_coupon)
            .then((coupon)=>{
              resolve(coupon);
            }, error=>{
                reject(error);
            })          
    })
  }
/**
 * @example: 
 * this.vhQuerySales.getCoupons()
        .then((res)=>{
          console.log('getCoupons', res);
        }, error=>{
          console.log('error', error);
        })
  * @return Promise => Array<object>
  */
  public getCoupons(){
    return new Promise((resolve, reject) => {   
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('coupons')
            .then((coupons)=>{              
              resolve(coupons);
            },(error:any)=>{
              reject(error);
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('coupons', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((coupons)=>{              
              resolve(coupons);
            },(error:any)=>{
              reject(error);
            }) 
      }                  
    })
  }

/**
 * @example:  
 * this.vhQuerySales.addCouponRelease({name : "Đợt phát hành phiếu thanh toán 100k",id_branch :'OHFNEIOUH6549846'})
        .then((res)=>{
          console.log('addCouponRelease', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return Promise => object or error
  */
  public addCouponRelease(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('coupon_releases', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example:  
 * this.vhQuerySales.updateCouponRelease('ANOFIEUPOIUJ49861',{name : "Đợt phát hành phiếu thanh toán 100k"})
        .then((bool:any)=>{
          console.log('updateCouponRelease', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @param id_coupon_release
  * @return Promise => bool = true or false
  */
  public updateCouponRelease(id_coupon_release:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('coupon_releases', id_coupon_release, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
 * @example:  
 * this.vhQuerySales.deleteCouponRelease("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteCouponRelease', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_release
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do trong đợt phát hành đã có coupon cần phát hành, vui lòng xóa coupon khỏi đợt phát hành
  */
  public deleteCouponRelease(id_coupon_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_release_details', {id_coupon_release:{$eq:id_coupon_release}}, {})
          .then((coupon_release_details:any)=>{
            if(coupon_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('coupon_releases', id_coupon_release)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_coupon_release: ${id_coupon_release} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do trong đợt phát hành đã có coupon cần phát hành, vui lòng xóa coupon khỏi đợt phát hành'})           
          }, error=>{
            reject(error)
          })             
    })
  }
/**
 * @example: 
 *
 * this.vhQuerySales.getCouponRelease('FBHYWIBDNIUH1321687')
        .then((res)=>{
          console.log('getCouponRelease', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_coupon_release
  * @return Promise => object or null
  */
  public getCouponRelease(id_coupon_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('coupon_releases', id_coupon_release)
            .then((coupon_release)=>{
              resolve(coupon_release);
            }, error=>{
                reject(error);
            })          
    })
  }

  
/**
 * @example: 
 *
 * this.vhQuerySales.getCouponReleases()
        .then((arr)=>{
          console.log('getCouponReleases', arr);
        }, error=>{
          console.log('error', error);
        })
  * @return Promise => Array< object >
  */
  public getCouponReleases(){
    return new Promise((resolve, reject) => { 
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('coupon_releases')
            .then((coupon_releases)=>{              
              resolve(coupon_releases);
            },(error:any)=>{
              reject(error);
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('coupon_releases', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((coupon_releases)=>{              
              resolve(coupon_releases);
            },(error:any)=>{
              reject(error);
            }) 
      }                    
    })
  }

/**
 * @example: 
  let data = {
    id_coupon : "9841654DOIWSDYW235",
    id_coupon_release :" 316OIUHLKMLSDYW235"
  }
  this.vhQuerySales.addCouponReleaseDetail(data)
        .then((res)=>{
          console.log('addCouponReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @param id_coupon
  * @return Promise => bool = true or false
  */
  public addCouponReleaseDetail(data:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('coupon_release_details', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
 * @example:  
 * this.vhQuerySales.deleteCouponReleaseDetail("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteCouponReleaseDetail', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_release_detail
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do coupon_code của đợt phát hành chi tiết này có status !=1 (đã được đổi điểm, hoặc đã sử dụng) 
  */
  public deleteCouponReleaseDetail(id_coupon_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_codes', {id_coupon_release_detail:{$eq:id_coupon_release_detail}}, {})
          .then((coupon_codes:any)=>{
            let check = true;
            for(let i=0; i<coupon_codes.length; i++){
              if(coupon_codes[i].status !=1) check = false;
            }
            if(check){
              for(let i=0; i<coupon_codes.length; i++){
                this.vhMGDB_database._deleteDoc('coupon_codes', coupon_codes[i]._id);
              }
              this.vhMGDB_database._deleteDoc('coupon_release_details', id_coupon_release_detail)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_coupon_release_detail: ${id_coupon_release_detail} thành công`});
                  }, error=>{
                    reject(error)
                  })
            }else resolve({vcode:1, message:'xóa không thành công, do coupon_code của đợt phát hành chi tiết này có status !=1'})            
          })
          .catch((e)=>{
            reject(e);
          })           
    })
  }

  /**
 * @example: 
 *
 * this.vhQuerySales.getCouponReleaseDetail('FBHYWIBDNIUH1321687')
        .then((res)=>{
          console.log('getCouponReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_coupon_release_detail
  * @return Promise => object or null
  */
  public getCouponReleaseDetail(id_coupon_release_detail:any){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDoc('coupon_release_details', id_coupon_release_detail)
            .then((coupon_release)=>{
              resolve(coupon_release);
            }, error=>{
                reject(error);
            })          
    })
  }

/**
 * hàm này trả về những Coupon Release Detail của đợt coupon đó
 * @example:  
 * this.vhQuerySales.getCouponRelaseDetail_byIdCouponRelease("9841654DOIWSDYW235")
        .then((array:any)=>{
          console.log('getCouponRelaseDetail_byIdCouponRelease', array);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_release
  * @return Promise => Array<any> = [{id_coupon_relase, id_coupon, coupon_name, coupon_value,  coupon_code_numbers}]
  */
  public getCouponRelaseDetail_byIdCouponRelease(id_coupon_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_release_details', {id_coupon_release:{$eq:id_coupon_release}}, {})
              .then((coupon_release_details)=>{
                resolve(coupon_release_details);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }

/**
 *  hàm này để phát hành 1 coupon_code
 * @example:  
  //truyền vào
  let data = { 
    date_validity: new Date(),
    date_expire : new Date(),
    id_coupon_release_detail :"315KHIUHWNIUHCIYUW3187",
    id_coupon: '9841654DOIWSDYW235'    
  }
 * this.vhQuerySales.createCouponCode(data)
        .then((coupon_code)=>{
          console.log('createCouponCode', coupon_code);
        }, error=>{
          console.log('error', error);
        }) 
  //trả về
  let data = { 
    _id:'9841654DOIWSDYW235'
    status: 1,
    id_branch,

    date_validity: new Date(),
    date_expire : new Date(),
    id_coupon_release_detail :"315KHIUHWNIUHCIYUW3187",
    id_coupon: '9841654DOIWSDYW235'    
  }
  * @param data
  * @return Promise => Object
  */
  private createCouponCode(data:any){
    return new Promise((resolve,reject) => {
      let _data = {...data};
      _data.id_branch = this.getDefaultBranch()._id;
      _data.status = 1;
      _data.code = this.vhAlgorithm.createCardCode();     
      this.vhMGDB_database.getDocsByFields('coupon_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
          .then((coupon_codes:any)=>{
            if(coupon_codes.length>0){
              _data.code = this.vhAlgorithm.createCardCode();  
              this.vhMGDB_database.getDocsByFields('coupon_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                  .then((coupon_codes:any)=>{
                    if(coupon_codes.length>0){
                      _data.code = this.vhAlgorithm.createCardCode();  
                      this.vhMGDB_database.getDocsByFields('coupon_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                          .then((coupon_codes:any)=>{
                            if(coupon_codes.length>0){
                              reject({error: {message: 'Nói anh Huy xem lại phần tạo mã code tự động, code tạo mới bị trùng'}});
                            }else{
                              this.vhMGDB_database.addDoc('coupon_codes', _data)
                                  .then((coupon_code)=>{
                                    resolve(coupon_code);
                                  }, error=>{
                                    reject(error)
                                  })
                            }
                          }, error=>{
                              reject(error);
                          })     
                    }else{
                      this.vhMGDB_database.addDoc('coupon_codes', _data)
                          .then((coupon_code)=>{
                            resolve(coupon_code);
                          }, error=>{
                            reject(error)
                          })
                    }
                  }, error=>{
                      reject(error);
                  })                 
            }else{
              this.vhMGDB_database.addDoc('coupon_codes', _data)
                  .then((coupon_code)=>{
                    resolve(coupon_code);
                  }, error=>{
                    reject(error)
                  })
            }
          }, error=>{
              reject(error);
          })     
    })
  }
  /**
 *  hàm này để phát hành nhiều coupon_code theo số lượng truyền vào, và tự động cập nhật trường số lượng đã phát hành (quantity_released) tăng lên 
 * trong collection coupon_release_details 
 * @example:  
  //truyền vào
  let data = {
    date_validity: new Date(),
    date_expire : new Date(),
    id_coupon_release_detail :"315KHIUHWNIUHCIYUW3187",
    id_coupon: '9841654DOIWSDYW235'    
  }
 * this.vhQuerySales.createCouponCodes(data, 10)
        .then((coupon_codes)=>{
          console.log('createCouponCodes', coupon_codes);
        }, error=>{
          console.log('error', error);
        })
  //trả về
  let data = { 
    _id:'9841654DOIWSDYW235'
    status: 1,
    id_branch,

    date_validity: new Date(),
    date_expire : new Date(),
    id_coupon_release_detail :"315KHIUHWNIUHCIYUW3187",
    id_coupon: '9841654DOIWSDYW235'    
  } 
  * @param data
  * @param quantity <=20 : Dev kiểm tra trường quantity nhập vào không được lớn hơn 20
  * @return Promise => Array(object)
  */
  public createCouponCodes(data:any, quantity:number){
    return new Promise((resolve,reject) => {
      if(quantity <=20){
        let promise = new Array();
        for(let i=0; i<quantity; i++){       
          promise[i] = this.createCouponCode(data);
          
        }  
        Promise.all(promise)
                  .then((array:any)=>{
                    array = array.flat();
                    this.vhMGDB_database.getDoc('coupon_release_details', data.id_coupon_release_detail)
                        .then((coupon_release_detail:any)=>{
                          if(coupon_release_detail){
                            if(coupon_release_detail.quantity_released != undefined){
                              let value = {quantity_released: coupon_release_detail.quantity_released + quantity}
                              this.vhMGDB_database.updateDoc('coupon_release_details', coupon_release_detail._id, value)
                                  .then(()=>{
                                    resolve(array);
                                  }, error=>{
                                    reject(error)
                                  })   
                            }else{
                              let value = {quantity_released: quantity}
                              this.vhMGDB_database.updateDoc('coupon_release_details', coupon_release_detail._id, value)
                                  .then(()=>{
                                    resolve(array);
                                  }, error=>{
                                    reject(error)
                                  })
                            }
                          }                     
                        }, error=>{
                            reject(error);
                        })                        
                  })
                  .catch(e=>{
                    reject(e);
                  }) 
      }else reject({warning: 'Dev kiểm tra trường quantity nhập vào không được lớn hơn 20'});     
    })
  }
/**
 * @example:  
 * 
 * this.vhQuerySales.updateCouponCode('OUHEOIWUYGHIQNIDOUW1359478',{date_expire : new Date()})
        .then((bool:any)=>{
          console.log('updateCouponCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code
  * @param data
  * @return Promise => boolean = true or false
  */
  public updateCouponCode(id_coupon_code:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('coupon_codes', id_coupon_code, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * Hàm này chỉ cho phép xóa coupon_code đang ở trạng thái đã phát hành (status ==1),
 * và cập nhật giảm trường số lượng quantity_released bớt 1 trong collection coupon_release_details
 * @example: 
 * this.vhQuerySales.deleteCouponCode('OUHEOIWUYGHIQNIDOUW1359478'})
        .then((bool:any)=>{
          console.log('deleteCouponCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code
  * @param id_coupon_release_detail      
  * @return Promise => boolean = true or false
  */
  public deleteCouponCode(id_coupon_code:string, id_coupon_release_detail:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('coupon_codes', id_coupon_code)
          .then((bool:any)=>{                 
            if(bool){             
              this.vhMGDB_database.getDoc('coupon_release_details', id_coupon_release_detail)
                  .then((coupon_release_detail:any)=>{
                    if(coupon_release_detail){
                      if(coupon_release_detail.quantity_released != undefined){
                        let value = {quantity_released: coupon_release_detail.quantity_released - 1}
                        this.vhMGDB_database.updateDoc('coupon_release_details', coupon_release_detail._id, value)
                            .then(()=>{
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })   
                      }else{                                
                        let value = {quantity_released: 0}//-1 thì vô lý quá, nên kiểm tra lại sau
                        this.vhMGDB_database.updateDoc('coupon_release_details', coupon_release_detail._id, value)
                            .then(()=>{
                              console.log('Báo anh Huy kiểm tra lại trường hợp này');
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })
                      }
                    }                     
                  }, error=>{
                      reject(error);
                  })                    
            }else{
               resolve(false);
            }                                                         
                 
          }, error=>{
            reject(error)
          })          
    })
  }
/** 
 * hàm này trả về danh sách coupon code đã phát hành theo mỗi đợt
 * @example:  
 * 
 * this.vhQuerySales.getCouponCodes_byIdCouponReleaseDetail('OUHEOIWUYGHIQNIDOUW1359478'})
        .then((array:any)=>{
          console.log('getCouponCodes_byIdCouponReleaseDetail', array);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_release_detail
  * @return Promise => Array<any> 
  */
  public getCouponCodes_byIdCouponReleaseDetail(id_coupon_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_codes', {id_coupon_release_detail:{$eq:id_coupon_release_detail}}, {})
              .then((coupon_codes)=>{
                resolve(coupon_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }

  /** 
 * hàm này trả về danh sách coupon code đã phát hành theo điều kiện query
 * @example:  
 * this.vhQuerySales.getCouponCodes_byFields({status:{$eq: 1}}, {}, {}, 0)
        .then((res)=>{
          console.log('getCouponCodes_byFields', res);
        }, error=>{
          console.log('error', error);
        })
  * @param query
  * @param projection
  * @param sort
  * @param limit
  * @return Promise => array(object) = [{},{},..]
  */
  public getCouponCodes_byFields(query: object, projection: object, sort: object, limit: number){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('coupon_codes', query,{},sort,limit)
              .then((coupon_codes)=>{
                resolve(coupon_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }
  
/** 
 *  hàm này trả về coupon_code đã phát hành theo trường _id của Coupon_code
 * @example:  
 * 
 * this.vhQuerySales.getCouponCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getCouponCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getCouponCode(id_coupon_code:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('coupon_codes', id_coupon_code)
            .then((coupon_code)=>{
              resolve(coupon_code);
            }, error=>{
                reject(error);
            })          
    })
  }

  /** 
 *  hàm này trả về coupon_code đã phát hành theo trường code của Coupon_code. 
 * @example:  
 * 
 * this.vhQuerySales.getCouponCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getCouponCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getCouponCode_byCode(code:any){
    return new Promise((resolve, reject) => {
      let id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.getDocsByFields('coupon_codes', {id_branch:{$eq:id_branch}, code:{$eq:code}})
            .then((coupon_codes:any)=>{
              if(coupon_codes.length>0){
                resolve(coupon_codes[0]);
              }else resolve(null);
              
            }, error=>{
                reject(error);
            })          
    })
  }
  
  /** 
 * hàm này trả về coupon_code đã phát hành theo trường _id của voucher_code.
 * @example:  
 * 
 * this.vhQuerySales.getCoupon_Code_Name_Release('OUHEDW0512'})
        .then((res)=>{
          console.log('getCoupon_Code_Name_Release', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getCoupon_Code_Name_Release(id_coupon_code:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('coupon_codes', id_coupon_code)
            .then((coupon_code:any)=>{
              if(coupon_code){
                let coupon = cloneDeep(coupon_code);                
                this.vhMGDB_database.getDoc('coupon_release_details', coupon.id_coupon_release_detail)
                    .then((coupon_release_detail:any)=>{
                      if(coupon_release_detail){
                        Promise.all([
                          this.vhMGDB_database.getDoc('coupons', coupon_release_detail.id_coupon),                            
                          this.vhMGDB_database.getDoc('coupon_releases', coupon_release_detail.id_coupon_release)
                        ]).then((array:any)=>{                          
                          if(coupon.status === 1){                  
                            coupon.points = array[0].points;
                          }   
                          coupon.name_coupon = array[0].name;
                          coupon.name_coupon_release = array[1].name;
                          resolve(coupon);
                        })                            
                      }else resolve(null); 
                    },(error:any)=>{                      
                      reject(error);
                    })
            }else resolve(null);            
          }, error=>{
              reject(error);
          })  
      // this.vhMGDB_database.getDoc('coupon_codes', id_coupon_code)
      //       .then((coupon_code:any)=>{
      //         if(coupon_code){
      //           let coupon = cloneDeep(coupon_code);               
      //           this.vhMGDB_database.getDoc('coupon_release_details', coupon_code.id_coupon_release_detail)
      //               .then((coupon_release_detail:any)=>{
      //                 if(coupon_release_detail){
      //                   Promise.all([
      //                     this.vhMGDB_database.getDoc('coupons', coupon_release_detail.id_coupon),                            
      //                     this.vhMGDB_database.getDoc('coupon_releases', coupon_release_detail.id_coupon_release)
      //                   ]).then((array:any)=>{
      //                     coupon.name_coupon = array[0].name;
      //                     coupon.name_coupon_release = array[1].name;
      //                     resolve(coupon);
      //                   })                            
      //                 }else resolve(null); 
      //               },(error:any)=>{                      
      //                 reject(error);
      //               })
      //         }else resolve(null);             
      //       }, error=>{
      //           reject(error);
      //       })          
    })
  }

/** 
 * hàm này trả về coupon đã phát hành theo trường code của coupon_code. dùng trong thanh toán bằng phiếu, đổi điểm lấy coupon,
 * trả về có cả code, name_coupon, name_coupon_release
 * @example:  
 * 
 * this.vhQuerySales.getCoupon_Code_Name_Release_byCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getCoupon_Code_Name_Release_byCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_coupon_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getCoupon_Code_Name_Release_byCode(code:any){
    return new Promise((resolve, reject) => {
      //let id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.getDocsByFields('coupon_codes', {code:{$eq:code}})
          .then((coupon_codes:any)=>{
            if(coupon_codes.length>0){            
                let coupon = cloneDeep(coupon_codes[0]);               
                this.vhMGDB_database.getDoc('coupon_release_details', coupon.id_coupon_release_detail)
                    .then((coupon_release_detail:any)=>{
                      if(coupon_release_detail){
                        Promise.all([
                          this.vhMGDB_database.getDoc('coupons', coupon_release_detail.id_coupon),                            
                          this.vhMGDB_database.getDoc('coupon_releases', coupon_release_detail.id_coupon_release)
                        ]).then((array:any)=>{                          
                          if(coupon.status === 1){                  
                            coupon.points = array[0].points;
                          }   
                          coupon.name_coupon = array[0].name;
                          coupon.name_coupon_release = array[1].name;
                          resolve(coupon);
                        })                            
                      }else resolve(null); 
                    },(error:any)=>{                      
                      reject(error);
                    })
            }else resolve(null);            
          }, error=>{
              reject(error);
          })     
    })
  }
/** 
 * hàm này để đổi phiếu từ điểm của khách hàng. Đổi thành công tự động tạo lịch sử đổi điểm của khách hàng
 * hàm này đã cập nhật lại trường status, id_customer, date_points_exchanged cho coupon_codes
 * hàm này đã cập nhật lại trường earned_points, id_customer, branch_earned_points cho customers  
 * @example:
 * let array = [{id_coupon_code, points, value},{}...]
 * this.vhQuerySales.exchangeCouponCode_byEarningPoints([array,'1984QIHBSYGWDIOUHIQFE'], 'INBIFDYWUGUHNI65498', 1000})
        .then((bool:any)=>{
          console.log('exchangeCouponCode_byEarningPoints', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param array_id_coupon_code_and_points_and_value : [{id_coupon_code, points, value}]
  * @param id_customer
  * @param total_points_exchanged: tổng điểm của các phiếu đã quy đổi
  * @return Promise => boolean = true or false
  */
  public exchangeCouponCode_byEarningPoints(array_id_coupon_code_and_points_and_value:any, id_customer:any, total_points_exchanged:any){
    return new Promise((resolve, reject) => {
      let promise_zero:any = new Array();
      for(let i=0; i<array_id_coupon_code_and_points_and_value.length; i++){
        promise_zero[i] = this.vhMGDB_database.getDoc('coupon_codes', array_id_coupon_code_and_points_and_value[i].id_coupon_code);
      }
      promise_zero[promise_zero.length] = this.vhMGDB_database.getDoc('customers', id_customer);
      Promise.all(promise_zero)
            .then((array_zero:any)=>{
              let promise_one:any = new Array();
              for(let i=0; i<array_zero.length -1; i++){
                let value_coupon_code = {
                  status: 3,                  
                  date_points_exchanged: new Date(),
                  points: array_id_coupon_code_and_points_and_value[i].points,
                  value: array_id_coupon_code_and_points_and_value[i].value,
                  id_customer: id_customer
                }
                promise_one[i] = this.vhMGDB_database.updateDoc('coupon_codes', array_zero[i]._id, value_coupon_code);
              }
              let customer:any = array_zero[array_zero.length-1];
              if(customer.earned_points != undefined){
                customer.earned_points = customer.earned_points - total_points_exchanged;
              }else{
                customer.earned_points = 0;
              }
              let branch = this.getDefaultBranch();
              if(customer.branch_earned_points !=undefined){
                if(customer.branch_earned_points[branch._id] !=undefined){
                  customer.branch_earned_points[branch._id] = customer.branch_earned_points[branch._id] -total_points_exchanged;
                }else{
                  customer.branch_earned_points[branch._id] = 0;
                }
              }else{
                customer.branch_earned_points = {};
              }
              let value_customer = {
                earned_points: customer.earned_points,
                branch_earned_points: customer.branch_earned_points    
              }
              promise_one[promise_one.length] = this._updateCustomer(customer._id, value_customer);
              Promise.all(promise_one)
                    .then(()=>{
                      resolve(true);
                    })
            })
    })
  }

//Voucher --------------------------------------------------------------------
/**
 * @example: 
 * let data = {
        name : "Siêu khuyến mãi",
        id_design_barcode :"316OIUHLKMLSDYW235",
        products: [{
        id_product : "NIDOUHWIOLDNOIU1142748",
        price : 1000000,
        quantity: 1,
        ptype: 1
      }],
        point: 10,
        price_origin: 9300000,
        price: 9200000,
        id_branch: 4zFGhVUAZyj5d09r01xZ
    }
 * this.vhQuerySales.addVoucher(data)
        .then((res)=>{
          console.log('addVoucher', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return object or error
  */
  public addVoucher(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('vouchers', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
 * @example: 
 * let data = {
        point: 23,
        price_origin: 9400000,
        id_branch: 4zFGhVUAZyj5d09r01xZ
    }
 * this.vhQuerySales.updateVoucher("fuMS21I6othUm34385WV", data)
        .then((bool:any)=>{
          console.log('updateVoucher', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_voucher
  * @param data
  * @return Promise Boolean => true or false
  */
  public updateVoucher(id_voucher:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('vouchers', id_voucher, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example:  
 * this.vhQuerySales.deleteVoucher("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteVoucher', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do voucher đã được phát hành, vui lòng xóa đợt phát hành liên quan
  */
  public deleteVoucher(id_voucher:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('voucher_release_details', {id_voucher:{$eq:id_voucher}}, {})
          .then((voucher_release_details:any)=>{
            if(voucher_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('vouchers', id_voucher)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_voucher: ${id_voucher} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do voucher đã được phát hành, vui lòng xóa đợt phát hành liên quan'})           
          }, error=>{
            reject(error)
          })             
    })
  }
        
/**
 * @example: 
 * this.vhQuerySales.getVoucher(id_voucher)
        .then((res)=>{
          console.log('addVoucher', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_voucher
  * @return Promise => object or null
  */
  public getVoucher(id_voucher:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('vouchers', id_voucher)
            .then((voucher)=>{
              resolve(voucher);
            }, error=>{
                reject(error);
            })          
    })
  }

/**
 * @example: 
 * this.vhQuerySales.getVouchers()
        .then((arr)=>{
          console.log('getVouchers', arr);
        }, error=>{
          console.log('error', error);
        })
  * @return Promise => array(object) =[{},{},...]
  */
  public getVouchers(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('vouchers')
            .then((vouchers)=>{              
              resolve(vouchers);
            },(error:any)=>{
              reject(error);
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('vouchers', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((vouchers)=>{              
              resolve(vouchers);
            },(error:any)=>{
              reject(error);
            }) 
      }               
    })
  }

/**
 * @example: 
 * let data = {
        name : "Tháng 6 bùng nổ",
        id_branch: 4zFGhVUAZyj5d09r01xZ
    }
 * this.vhQuerySales.addVoucherRelease(data)
        .then((res)=>{
          console.log('addVoucherRelease', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return object or error
  */
  public addVoucherRelease(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('voucher_releases', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
 * @example: 
 * let data = {
        name : "Tháng 6 bùng nổ"
    }
 * this.vhQuerySales.updateVoucherRelease("fuMS21I6othUm34385WV", data)
        .then((bool:any)=>{
          console.log('updateVoucherRelease', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param id_voucher_release
  * @param data
  * @return Promise Boolean => true or false
  */
  public updateVoucherRelease(id_voucher_release:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('voucher_releases', id_voucher_release, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
 * @example:  
 * this.vhQuerySales.deleteVoucherRelease("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteVoucherRelease', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_release
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do trong đợt phát hành đã có voucher cần phát hành, vui lòng xóa voucher khỏi đợt phát hành
  */
  public deleteVoucherRelease(id_voucher_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('voucher_release_details', {id_voucher_release:{$eq:id_voucher_release}}, {})
          .then((voucher_release_details:any)=>{
            if(voucher_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('voucher_releases', id_voucher_release)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_voucher_release: ${id_voucher_release} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do trong đợt phát hành đã có voucher cần phát hành, vui lòng xóa voucher khỏi đợt phát hành'})           
          }, error=>{
            reject(error)
          })             
    })
  }
  
  
/**
 * @example: 
 * this.vhQuerySales.getVoucherRelease("fuMS21I6othUm34385WV")
        .then((res)=>{
          console.log('getVoucherRelease', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_voucher_release
  * @return Promise => object or null
  */
  public getVoucherRelease(id_voucher_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('voucher_releases', id_voucher_release)
            .then((voucher_release)=>{
              resolve(voucher_release);
            }, error=>{
                reject(error);
            })          
    })
  }

/**
 * @example: 
 * this.vhQuerySales.getVoucherRelases()
        .then((res)=>{
          console.log('getVoucherRelases', res);
        }, error=>{
          console.log('error', error);
        })
  * @return Promise => array(object) =[{},{},...]
  */
  public getVoucherRelases(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('voucher_releases')
            .then((voucher_releases)=>{              
              resolve(voucher_releases);
            },(error:any)=>{
              reject(error);
            })       
      }else{
        this.vhMGDB_database.getDocsByFields('voucher_releases', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((voucher_releases)=>{              
              resolve(voucher_releases);
            },(error:any)=>{
              reject(error);
            }) 
      } 
               
    })
  }

/**
 * @example: 
 * let data = {
        id_voucher : "fuMS21I6othUm34385WV",
        id_voucher_release: "4zFGhVUAZyj5d09r01xZ"
    }
 * this.vhQuerySales.addVoucherReleaseDetail(data)
        .then((res)=>{
          console.log('addVoucherReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        })
  * @param data
  * @return object or error
  */
  public addVoucherReleaseDetail(data:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('voucher_release_details', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
 * @example:  
 * this.vhQuerySales.deleteVoucherReleaseDetail("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deleteVoucherReleaseDetail', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_release_detail
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do voucher_code của đợt phát hành chi tiết này có status !=1 (đã được đổi điểm, hoặc đã sử dụng) 
  */
  public deleteVoucherReleaseDetail(id_voucher_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('voucher_codes', {id_voucher_release_detail:{$eq:id_voucher_release_detail}}, {})
          .then((voucher_codes:any)=>{
            let check = true;
            for(let i=0; i<voucher_codes.length; i++){
              if(voucher_codes[i].status !=1) check = false;
            }
            if(check){
              for(let i=0; i<voucher_codes.length; i++){
                this.vhMGDB_database._deleteDoc('voucher_codes', voucher_codes[i]._id);
              }
              this.vhMGDB_database._deleteDoc('voucher_release_details', id_voucher_release_detail)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_voucher_release_detail: ${id_voucher_release_detail} thành công`});
                  }, error=>{
                    reject(error)
                  })
            }else resolve({vcode:1, message:'xóa không thành công, do voucher_code của đợt phát hành chi tiết này có status !=1'})            
          })
          .catch((e)=>{
            reject(e);
          })           
    })
  }
      
  /**
 * @example: 
 * this.vhQuerySales.getVoucherReleaseDetail("fuMS21I6othUm34385WV")
        .then((res)=>{
          console.log('getVoucherReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        })
  * @param (id_voucher_release_detail)
  * @return Promise => object or null
  */
  public getVoucherReleaseDetail(id_voucher_release_detail:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('voucher_release_details', (id_voucher_release_detail))
            .then((voucher_release)=>{
              resolve(voucher_release);
            }, error=>{
                reject(error);
            })          
    })
  }

/**
 * @example: 
 * this.vhQuerySales.getVoucherRelaseDetail_byFields({id_voucher:{$eq: "316OIUHLKMLSDYW235"}}, {}, {}, 0)
        .then((res)=>{
          console.log('getVoucherRelaseDetail_byFields', res);
        }, error=>{
          console.log('error', error);
        })
  * @param query
  * @param projection
  * @param sort
  * @param limit
  * @return Promise => array(object) = [{},{},..]
  */
  public getVoucherRelaseDetail_byFields(query: object, projection: object, sort: object, limit: number){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.getDocsByFields('voucher_release_details', query,{},sort,limit)
          .then((voucher_release_details)=>{              
            resolve(voucher_release_details);
          },(error:any)=>{
            reject(error);
          })                    
    })
  }
 
/**
 *  hàm này để phát hành 1 voucher_code
 * @example:  
  let data = {   
      date_validity: new Date(),
      date_expire: new Date(),    
      id_voucher_release_detail: "fuMS21I6othUm34385WV",
      id_voucher: '9841654DOIWSDYW235'   
  }
 * this.vhQuerySales.createVoucherCode(data)
        .then((voucher_code)=>{
          console.log('createVoucherCode', voucher_code);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @return Promise => Object
  */
  createVoucherCode(data:any){
    return new Promise((resolve,reject) => {
      let _data = {...data};
      _data.id_branch = this.getDefaultBranch()._id;
      _data.status = 1;
      _data.code = this.vhAlgorithm.createCardCode();  
      this.vhMGDB_database.getDocsByFields('voucher_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
          .then((voucher_codes:any)=>{
            if(voucher_codes.length>0){
              _data.code = this.vhAlgorithm.createCardCode();  
              this.vhMGDB_database.getDocsByFields('voucher_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                  .then((voucher_codes:any)=>{
                    if(voucher_codes.length>0){
                      _data.code = this.vhAlgorithm.createCardCode();  
                      this.vhMGDB_database.getDocsByFields('voucher_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                          .then((voucher_codes:any)=>{
                            if(voucher_codes.length>0){
                              reject({error: {message: 'Nói anh Huy xem lại phần tạo mã code tự động, code tạo mới bị trùng'}});
                            }else{
                              this.vhMGDB_database.addDoc('voucher_codes', _data)
                                  .then((voucher_code)=>{
                                    resolve(voucher_code);
                                  }, error=>{
                                    reject(error)
                                  })
                            }
                          }, error=>{
                              reject(error);
                          })     
                    }else{
                      this.vhMGDB_database.addDoc('voucher_codes', _data)
                          .then((voucher_code)=>{
                            resolve(voucher_code);
                          }, error=>{
                            reject(error)
                          })
                    }
                  }, error=>{
                      reject(error);
                  })                 
            }else{
              this.vhMGDB_database.addDoc('voucher_codes', _data)
                  .then((voucher_code)=>{
                    resolve(voucher_code);
                  }, error=>{
                    reject(error)
                  })
            }
          }, error=>{
              reject(error);
          })     
    })
  }
  

  /**
 *  hàm này để phát hành nhiều voucher_code theo số lượng truyền vào, và tự động cập nhật trường số lượng đã phát hành (quantity_released) tăng lên 
 * trong collection voucher_release_details  
 * @example:  
  let data = {
      date_validity: new Date(),
      date_expire: new Date(),    
      id_voucher_release_detail: "fuMS21I6othUm34385WV",
      id_voucher: '9841654DOIWSDYW235'    
  }
  * this.vhQuerySales.createVoucherCodes(data, 10)
        .then((voucher_codes)=>{
          console.log('createVoucherCodes', voucher_codes);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @param quantity
  * @return Promise => Array(object)
  */
  public createVoucherCodes(data:any, quantity:number){
    return new Promise((resolve,reject) => {
      let promise = new Array();
      for(let i=0; i<quantity; i++){        
        promise[i] = this.createVoucherCode(data);       
      }    
      Promise.all(promise)
            .then((array:any)=>{
              array = array.flat();             
              this.vhMGDB_database.getDoc('voucher_release_details', data.id_voucher_release_detail)
                  .then((voucher_release_detail:any)=>{
                    if(voucher_release_detail){
                      if(voucher_release_detail.quantity_released != undefined){
                        let value = {quantity_released: voucher_release_detail.quantity_released + quantity}
                        this.vhMGDB_database.updateDoc('voucher_release_details', voucher_release_detail._id, value)
                            .then(()=>{
                              resolve(array);
                            }, error=>{
                              reject(error)
                            })   
                      }else{
                        let value = {quantity_released: quantity}
                        this.vhMGDB_database.updateDoc('voucher_release_details', voucher_release_detail._id, value)
                            .then(()=>{
                              resolve(array);
                            }, error=>{
                              reject(error)
                            })
                      }
                    }                     
                  }, error=>{
                      reject(error);
                  })     
            })
            .catch(e=>{
              reject(e);
            })   
    })
  }
/**
 * @example:  
 * 
 * this.vhQuerySales.updateVoucherCode('OUHEOIWUYGHIQNIDOUW1359478',{date_expire : new Date()})
        .then((bool:any)=>{
          console.log('updateCouponCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_code
  * @param data
  * @return Promise => boolean = true or false
  */
  public updateVoucherCode(id_voucher_code:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('voucher_codes', id_voucher_code, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * Hàm này chỉ cho phép xóa voucher_code đang ở trạng thái đã phát hành (status ==1),
 * và cập nhật giảm trường số lượng quantity_released bớt một trong collection voucher_release_details
 * @example:   
 * this.vhQuerySales.deleteVoucherCode('BjHxEYPWrB0rPwfj2L9R', 'CBrcRQIL11lwcHBljliW'})
        .then((bool:any)=>{
          console.log('deleteVoucherCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_code
  * @param id_voucher_release_detail      
  * @return Promise => boolean = true or false
  */
  public deleteVoucherCode(id_voucher_code:string, id_voucher_release_detail:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('voucher_codes', id_voucher_code)
          .then((bool:any)=>{                        
            if(bool){     
              this.vhMGDB_database.getDoc('voucher_release_details', id_voucher_release_detail)
                  .then((voucher_release_detail:any)=>{                    
                    if(voucher_release_detail){                      
                      if(voucher_release_detail.quantity_released != undefined){                        
                        let value = {quantity_released: voucher_release_detail.quantity_released - 1}
                        this.vhMGDB_database.updateDoc('voucher_release_details', voucher_release_detail._id, value)
                            .then(()=>{                              
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })   
                      }else{                                
                        let value = {quantity_released: 0}//-1 thì vô lý quá, nên kiểm tra lại sau
                        this.vhMGDB_database.updateDoc('voucher_release_details', voucher_release_detail._id, value)
                            .then(()=>{
                              console.log('Báo anh Huy kiểm tra lại trường hợp này');
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })
                      }
                    }                     
                  }, error=>{
                      reject(error);
                  })                    
            }else{
               resolve(false);
            }     
          }, error=>{
            reject(error)
          })          
    })
  }
/** 
 * hàm này trả về danh sách voucher_codes đã phát hành theo mỗi đợt
 * @example:  
 * this.vhQuerySales.getVoucherCodes_byIdCouponReleaseDetail('OUHEOIWUYGHIQNIDOUW1359478'})
        .then((array:any)=>{
          console.log('getVoucherCodes_byIdCouponReleaseDetail', array);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_release_detail
  * @return Promise => Array<any> 
  */
  public getVoucherCodes_byIdCouponReleaseDetail(id_voucher_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('voucher_codes', {id_voucher_release_detail:{$eq:id_voucher_release_detail}}, {})
              .then((voucher_codes)=>{
                resolve(voucher_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }
  /** 
 * hàm này trả về danh sách voucher code đã phát hành theo điều kiện query
 * @example:  
 * this.vhQuerySales.getVoucherCodes_byFields({status:{$eq: 1}}, {}, {}, 0)
        .then((res)=>{
          console.log('getVoucherCodes_byFields', res);
        }, error=>{
          console.log('error', error);
        })
  * @param query
  * @param projection
  * @param sort
  * @param limit
  * @return Promise => array(object) = [{},{},..]
  */
  public getVoucherCodes_byFields(query: object, projection: object, sort: object, limit: number){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('voucher_codes', query,{},sort,limit)
              .then((voucher_codes)=>{
                resolve(voucher_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }
/** 
 *  hàm này trả về voucher code đã phát hành theo trường _id của voucher code. dùng trong trang bán hàng để đổi phiếu
 * @example:  
 * 
 * this.vhQuerySales.getVoucherCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getVoucherCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getVoucherCode(id_voucher_code:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('voucher_codes', id_voucher_code)
            .then((voucher_code)=>{
              resolve(voucher_code);
            }, error=>{
                reject(error);
            })          
    })
  }

  /** 
 * hàm này trả về voucher code đã phát hành theo trường _id của voucher code.
 * trả về có cả code, name_voucher, name_voucher_release
 * @example:  
 * 
 * this.vhQuerySales.getVoucher_Code_Name_Release('OUHEDW0512'})
        .then((res)=>{
          console.log('getVoucher_Code_Name_Release', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_voucher_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getVoucher_Code_Name_Release(id_voucher_code:any){
    return new Promise((resolve, reject) => {
          this.vhMGDB_database.getDoc('voucher_codes', id_voucher_code)
              .then((voucher_code:any)=>{
                if(voucher_code){
                  let voucher = cloneDeep(voucher_code);                 
                  this.vhMGDB_database.getDoc('voucher_release_details', voucher.id_voucher_release_detail)
                      .then((voucher_release_detail:any)=>{
                        if(voucher_release_detail){
                          Promise.all([
                            this.vhMGDB_database.getDoc('vouchers', voucher_release_detail.id_voucher),                            
                            this.vhMGDB_database.getDoc('voucher_releases', voucher_release_detail.id_voucher_release)
                          ]).then((array:any)=>{   
                            voucher.units = array[0].units;
                            if(voucher.status === 1){                                
                              voucher.products = array[0].products;
                              voucher.points = array[0].points;
                            }                                                
                            voucher.name_voucher = array[0].name;
                            voucher.name_voucher_release = array[1].name;                                      
                            //thêm thông tin Name, Units, Lots cho sản phẩm trong products             
                            if(voucher.products){                            
                              for(let j=0; j<voucher.products.length; j++){
                                if((voucher.products[j].ptype ===3)||(voucher.products[j].ptype ===2)){
                                  let id_sub_or_product = voucher.products[j].id_subproduct?voucher.products[j].id_subproduct:voucher.products[j].id_product;
                                  let product = this.getlocalDetailProduct(id_sub_or_product);
                                  voucher.products[j].name = product.name;
                                  voucher.products[j].units = product.units;
                                  if(product.lots) voucher.products[j].lots = product.lots;  
                    
                                }else if(voucher.products[j].ptype ===5){
                                  let product = this.getlocalDetailProduct(voucher.products[j].id_product);
                                  voucher.products[j].name = product.name;
                                  voucher.products[j].units = product.units;
                                  voucher.products[j].combos = product.combos;
                                  for(let m=0; m<voucher.products[j].combos.length; m++){
                                    let _id_sub_or_product = voucher.products[j].combos[m].id_subproduct?voucher.products[j].combos[m].id_subproduct:voucher.products[j].combos[m].id_product;
                                    let _product = this.getlocalDetailProduct(_id_sub_or_product);
                                    voucher.products[j].combos[m].name = _product.name;
                                    voucher.products[j].combos[m].units = _product.units;
                                    if(_product.lots) voucher.products[j].combos[m].lots = _product.lots;
                                  }
                                }
                              }
                            }                                                  
                            resolve(voucher);
                          })                            
                        }else resolve(null); 
                      },(error:any)=>{                      
                        reject(error);
                      })
                
              }else resolve(null);             
            }, error=>{
                reject(error);
            })   
      // this.vhMGDB_database.getDoc('voucher_codes', id_voucher_code)
      //       .then((voucher_code:any)=>{
      //         if(voucher_code){
      //           let voucher = cloneDeep(voucher_code);               
      //           this.vhMGDB_database.getDoc('voucher_release_details', voucher_code.id_voucher_release_detail)
      //               .then((voucher_release_detail:any)=>{
      //                 if(voucher_release_detail){
      //                   Promise.all([
      //                     this.vhMGDB_database.getDoc('vouchers', voucher_release_detail.id_voucher),                            
      //                     this.vhMGDB_database.getDoc('voucher_releases', voucher_release_detail.id_voucher_release)
      //                   ]).then((array:any)=>{
      //                     voucher.name_voucher = array[0].name;
      //                     voucher.name_voucher_release = array[1].name;
      //                     resolve(voucher);
      //                   })                            
      //                 }else resolve(null); 
      //               },(error:any)=>{                      
      //                 reject(error);
      //               })
      //         }else resolve(null);             
      //       }, error=>{
      //           reject(error);
      //       })          
    })
  }

/** 
 * hàm này trả về voucher đã phát hành theo trường code của voucher_code. dùng trong trang đổi điểm lấy voucher và bán voucher, đổi voucher lấy hàng hóa,
 * trả về có cả code, name_voucher, name_voucher_release
 * @example:  
 * 
 * this.vhQuerySales.getVoucher_Code_Name_Release_byCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getVoucher_Code_Name_Release_byCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getVoucher_Code_Name_Release_byCode(code:any){
    return new Promise((resolve, reject) => {
      //let id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.getDocsByFields('voucher_codes', {code:{$eq:code}})
            .then((voucher_codes:any)=>{
              if(voucher_codes.length){
                let voucher = cloneDeep(voucher_codes[0]);               
                  this.vhMGDB_database.getDoc('voucher_release_details', voucher.id_voucher_release_detail)
                      .then((voucher_release_detail:any)=>{
                        if(voucher_release_detail){
                          Promise.all([
                            this.vhMGDB_database.getDoc('vouchers', voucher_release_detail.id_voucher),                            
                            this.vhMGDB_database.getDoc('voucher_releases', voucher_release_detail.id_voucher_release)
                          ]).then((array:any)=>{   
                            voucher.units = array[0].units;
                            if(voucher.status === 1){                                
                              voucher.products = array[0].products;
                              voucher.points = array[0].points;
                            }                                                
                            voucher.name_voucher = array[0].name;
                            voucher.name_voucher_release = array[1].name;                                      
                            //thêm thông tin Name, Units, Lots cho sản phẩm trong products             
                            if(voucher.products){                            
                              for(let j=0; j<voucher.products.length; j++){
                                if((voucher.products[j].ptype ===3)||(voucher.products[j].ptype ===2)){
                                  let id_sub_or_product = voucher.products[j].id_subproduct?voucher.products[j].id_subproduct:voucher.products[j].id_product;
                                  let product = this.getlocalDetailProduct(id_sub_or_product);
                                  voucher.products[j].name = product.name;
                                  voucher.products[j].units = product.units;
                                  if(product.lots) voucher.products[j].lots = product.lots;  
                    
                                }else if(voucher.products[j].ptype ===5){
                                  let product = this.getlocalDetailProduct(voucher.products[j].id_product);
                                  voucher.products[j].name = product.name;
                                  voucher.products[j].units = product.units;
                                  voucher.products[j].combos = product.combos;
                                  for(let m=0; m<voucher.products[j].combos.length; m++){
                                    let _id_sub_or_product = voucher.products[j].combos[m].id_subproduct?voucher.products[j].combos[m].id_subproduct:voucher.products[j].combos[m].id_product;
                                    let _product = this.getlocalDetailProduct(_id_sub_or_product);
                                    voucher.products[j].combos[m].name = _product.name;
                                    voucher.products[j].combos[m].units = _product.units;
                                    if(_product.lots) voucher.products[j].combos[m].lots = _product.lots;
                                  }
                                }
                              }
                            }     
                                               
                            resolve(voucher);
                          })                            
                        }else resolve(null); 
                      },(error:any)=>{                      
                        reject(error);
                      })
                
              }else resolve(null);             
            }, error=>{
                reject(error);
            })          
    })
  }

/* Hàm này để đổi voucher từ điểm của khách hàng. Đổi thành công tự động tạo lịch sử đổi điểm của khách hàng
 * hàm này đã cập nhật lại trường status, id_customer, date_points_exchanged cho voucher_codes
 * hàm này đã cập nhật lại trường earned_points, id_customer, branch_earned_points cho customers  
 * @example: 
 * let array = [{id_voucher_code, points, products},{}...]
 * this.vhQuerySales.exchangeVoucherCode_byEarningPoints(array, "fuMS21I6othUm34385WV", 10)
        .then((bool:any)=>{
          console.log('exchangeVoucherCode_byEarningPoints', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param array_id_voucher_code_and_points_and_products
  * @param id_customer
  * @param points
  * @return Promise Boolean => true or false
  */
  public exchangeVoucherCode_byEarningPoints(array_id_voucher_code_and_points_and_products:any, id_customer:any, points:any){
    return new Promise((resolve, reject) => {
      let promise_zero:any = new Array();
      for(let i=0; i<array_id_voucher_code_and_points_and_products.length; i++){
        promise_zero[i] = this.vhMGDB_database.getDoc('voucher_codes', array_id_voucher_code_and_points_and_products[i].id_voucher_code);
      }
      promise_zero[promise_zero.length] = this.vhMGDB_database.getDoc('customers', id_customer);
      Promise.all(promise_zero)
            .then((array:any)=>{
              let promise_one:any = new Array();
              for(let i=0; i<array.length -1; i++){
                let value_voucher_code = {
                  status: 3,                  
                  date_points_exchanged: new Date(),
                  points: array_id_voucher_code_and_points_and_products[i].points,
                  products: array_id_voucher_code_and_points_and_products[i].products,
                  id_customer: id_customer
                }
                promise_one[i] = this.vhMGDB_database.updateDoc('voucher_codes', array[i]._id, value_voucher_code);
              }
              let customer:any = array[array.length-1];
              if(customer.earned_points != undefined){
                customer.earned_points = customer.earned_points - points;
              }else{
                customer.earned_points = 0;
              }
              let branch = this.getDefaultBranch();
              if(customer.branch_earned_points !=undefined){
                if(customer.branch_earned_points[branch._id] !=undefined){
                  customer.branch_earned_points[branch._id] = customer.branch_earned_points[branch._id] -points;
                }else{
                  customer.branch_earned_points[branch._id] = 0;
                }
              }else{
                customer.branch_earned_points = {};
              }
              let value_customer = {
                earned_points: customer.earned_points,
                branch_earned_points: customer.branch_earned_points    
              }
              promise_one[promise_one.length] = this._updateCustomer(customer._id, value_customer);
              Promise.all(promise_one)
                    .then(()=>{
                      resolve(true);
                    })
            })
    })
  }
  
// *Payment Card ---------------------------------------------------------------
/**  
 * @example:  
 * let data = {
 * name :"Thẻ trả trước",
 * price :1000000,
 * products : [
 *  {
 *    id_product : 'MOIUHWDWIUHG1345674',
 *    price : 100000,
 *    quantity: 5,
 *    quantity_valid : 5,
 *    type : 1
 *  },{
 *    id_product : 'NJIDUEWNBIJUWGHD135',
 *    price : 100000,
 *    quantity: 5,
 *    quantity_valid : 5,
 *    type : 2
 *  }]
 * }
 * this.vhQuerySales.addPaymentCard(data)
        .then((res)=>{
          console.log('addPaymentCard', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @return Promise => Array<any> 
  */
  public addPaymentCard(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('payment_cards', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**  
* @example:  
* let data = {
* name :"Thẻ trả trước",
* price :1000000,
* products : [
*  {
*    id_product : 'MOIUHWDWIUHG1345674',
*    price : 100000,
*    quantity: 5,
*    quantity_valid : 5,
*    type : 1
*  },{
*    id_product : 'NJIDUEWNBIJUWGHD135',
*    price : 100000,
*    quantity: 5,
*    quantity_valid : 5,
*    type : 2
*  }]
* }
* this.vhQuerySales.updatePaymentCard(data)
       .then((bool:any)=>{
         console.log('updatePaymentCard', bool);
       }, error=>{
         console.log('error', error);
       }) 
 * @param data
 * @param id_payment_card
 * @return Promise => bool = true or false
 */
  public updatePaymentCard(id_payment_card:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('payment_cards', id_payment_card, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
 * @example:  
 * this.vhQuerySales.deletePaymentCard("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deletePaymentCard', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do payment_card đã được phát hành, vui lòng xóa đợt phát hành liên quan
  */
  public deletePaymentCard(id_payment_card:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('payment_card_release_details', {id_payment_card:{$eq:id_payment_card}}, {})
          .then((payment_card_release_details:any)=>{
            if(payment_card_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('payment_cards', id_payment_card)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_payment_card: ${id_payment_card} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do payment_card đã được phát hành, vui lòng xóa đợt phát hành liên quan'})           
          }, error=>{
            reject(error)
          })             
    })
  }
  
        
/**  
 * @example:
 * this.vhQuerySales.getPaymentCard('FDNOIUWDHIWH21564DWQ')
        .then((res)=>{
          console.log('getPaymentCard', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card
  * @return Promise => object or null
  */
  public getPaymentCard(id_payment_card:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('payment_cards', id_payment_card)
            .then((payment_card)=>{
              resolve(payment_card);
            }, error=>{
                reject(error);
            })          
    })
  }

/**  
 * @example:
 * this.vhQuerySales.getPaymentCards()
        .then((res)=>{
          console.log('getPaymentCards', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @return Promise => Array<any> 
  */
  public getPaymentCards(){
    return new Promise((resolve, reject) => {      
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('payment_cards')
            .then((payment_cards)=>{              
              resolve(payment_cards);
            },(error:any)=>{
              reject(error);
            })            
      }else{
        this.vhMGDB_database.getDocsByFields('payment_cards', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((payment_cards)=>{              
              resolve(payment_cards);
            },(error:any)=>{
              reject(error);
            }) 
      } 
            
    })
  }

/**  
 * @example:
 * this.vhQuerySales.addPaymentCardRelease({name : "Đợt phát hành thẻ 1", id_branch :"NIOUHDWLJUNBHIU16549"})
        .then((res)=>{
          console.log('addPaymentCardRelease', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @return Promise => object or error
  */
  public addPaymentCardRelease(data:any){
    return new Promise((resolve, reject) => {
      data.id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.addDoc('payment_card_releases', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }
/**  
 * @example:
 * this.vhQuerySales.updatePaymentCardRelease({name : "Đợt phát hành thẻ 1"})
        .then((bool:any)=>{
          console.log('updatePaymentCardRelease', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_release
  * @param data
  * @return Promise => object or error
  */
  public updatePaymentCardRelease(id_payment_card_release:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('payment_card_releases', id_payment_card_release, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
 * @example:  
 * this.vhQuerySales.deletePaymentCardRelease("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deletePaymentCardRelease', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_release
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do trong đợt phát hành đã có payment_card cần phát hành, vui lòng xóa payment_card khỏi đợt phát hành
  */
  public deletePaymentCardRelease(id_payment_card_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('payment_card_release_details', {id_payment_card_release:{$eq:id_payment_card_release}}, {})
          .then((payment_card_release_details:any)=>{
            if(payment_card_release_details.length ===0){
              this.vhMGDB_database._deleteDoc('payment_card_releases', id_payment_card_release)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_payment_card_release: ${id_payment_card_release} thành công`});
                  }, error=>{
                    reject(error)
                  })  
            }else resolve({vcode:1, message:'xóa không thành công, do trong đợt phát hành đã có payment_card cần phát hành, vui lòng xóa payment_card khỏi đợt phát hành'})           
          }, error=>{
            reject(error)
          })             
    })
  }
  
        
/**  
 * @example:
 * this.vhQuerySales.getPaymentCardRelease("OIHIDUWNIDOLW123456")
        .then((res)=>{
          console.log('getPaymentCardRelease', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_release
  * @return Promise => object or null
  */
  public getPaymentCardRelease(id_payment_card_release:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('payment_card_releases', id_payment_card_release)
            .then((payment_card_release)=>{
              resolve(payment_card_release);
            }, error=>{
                reject(error);
            })          
    })
  }
/**  
 * @example:
 * this.vhQuerySales.getPaymentCardReleases()
        .then((res)=>{
          console.log('getPaymentCardReleases', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @return Promise => Array<any>
  */
  public getPaymentCardReleases(){
    return new Promise((resolve, reject) => { 
      if(this.getBranch_Management_Scope().sales_program_scope){
        this.vhMGDB_database.getDocs('payment_card_releases')
            .then((payment_card_release)=>{              
              resolve(payment_card_release);
            },(error:any)=>{
              reject(error);
            })          
      }else{
        this.vhMGDB_database.getDocsByFields('payment_card_releases', {id_branch:{$eq: this.getDefaultBranch()._id}})
            .then((payment_card_releases)=>{              
              resolve(payment_card_releases);
            },(error:any)=>{
              reject(error);
            }) 
      }           
    })
  }

/**  
 * @example:
 * this.vhQuerySales.addPaymentCardReleaseDetail({id_payment_card : "OIUHFIUWHGGU41698496", id_payment_card_release :"NIOUHDWLJUNBHIU16549"})
        .then((res)=>{
          console.log('addPaymentCardReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @return Promise => object or error
  */
  public addPaymentCardReleaseDetail(data:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.addDoc('payment_card_release_details', data)
          .then((obj)=>{
            resolve(obj);
          }, error=>{
            reject(error)
          })          
    })
  }

/**
 * @example:  
 * this.vhQuerySales.deletePaymentCardReleaseDetail("9841654DOIWSDYW235")
        .then((rsp)=>{
          console.log('deletePaymentCardReleaseDetail', rsp);
          if(rsp.vcode == 0){
            //phát thông báo xóa thành công
          }else if(rsp.vcode == 1){
            //phát thông báo lý do xóa ko thành công (dùng câu từ dễ hiểu với khách hàng)
          }
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_release_detail
  * @return Promise => rsp = {vcode, message} / error
  * vcode == 0 : xóa thành công
  * vcode == 1 : xóa không thành công, do payment_card_code của đợt phát hành chi tiết này có status !=1 (đã được đổi điểm, hoặc đã sử dụng) 
  */
  public deletePaymentCardReleaseDetail(id_payment_card_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('payment_card_codes', {id_payment_card_release_detail:{$eq:id_payment_card_release_detail}}, {})
          .then((payment_card_codes:any)=>{
            let check = true;
            for(let i=0; i<payment_card_codes.length; i++){
              if(payment_card_codes[i].status !=1) check = false;
            }
            if(check){
              for(let i=0; i<payment_card_codes.length; i++){
                this.vhMGDB_database._deleteDoc('payment_card_codes', payment_card_codes[i]._id);
              }
              this.vhMGDB_database._deleteDoc('payment_card_release_details', id_payment_card_release_detail)
                  .then(()=>{            
                    resolve({vcode:0, message:`xóa id_payment_card_release_detail: ${id_payment_card_release_detail} thành công`});
                  }, error=>{
                    reject(error)
                  })
            }else resolve({vcode:1, message:'xóa không thành công, do payment_card_code của đợt phát hành chi tiết này có status !=1'})            
          })
          .catch((e)=>{
            reject(e);
          })           
    })
  }
      
        
  /**
 * @example: 
 *
 * this.vhQuerySales.getPaymentCardReleaseDetail('FBHYWIBDNIUH1321687')
        .then((res)=>{
          console.log('getPaymentCardReleaseDetail', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_payment_card_release_detail
  * @return Promise => object or null
  */
  public getPaymentCardReleaseDetail(id_payment_card_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('payment_card_release_details', id_payment_card_release_detail)
            .then((payment_card_release_detail)=>{
              resolve(payment_card_release_detail);
            }, error=>{
                reject(error);
            })          
    })
  }

/**
 * @example: 
 * this.vhQuerySales.getVoucherRelaseDetail_byFields({id_payment_card:{$eq: "316OIUHLKMLSDYW235"}}, {}, {}, 0)
        .then((res)=>{
          console.log('getVoucherRelaseDetail_byFields', res);
        }, error=>{
          console.log('error', error);
        })
  * @param query
  * @param projection
  * @param sort
  * @param limit
  * @return Promise => array(object) = [{},{},..]
  */
  public getPaymentCardRelaseDetail_byFields(query: object, projection: object, sort: object, limit: number){
    return new Promise((resolve, reject) => {  
      this.vhMGDB_database.getDocsByFields('payment_card_release_details', query,{},sort,limit)
          .then((payment_card_release_details)=>{              
            resolve(payment_card_release_details);
          },(error:any)=>{
            reject(error);
          })                    
    })
  }
  
  
/**
 *  hàm này để phát hành 1 payment_card_code
 * @example:  
  let data = {
    date_validity: new Date(),
    date_expire: new Date(),    
    id_payment_card_release_detail: "fuMS21I6othUm34385WV",
    id_payment_card: '9841654DOIWSDYW235'  
  }
 * this.vhQuerySales.createPaymentCardCode(data)
        .then((coupon_code)=>{
          console.log('createPaymentCardCode', coupon_code);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @return Promise => Object
  */
  private createPaymentCardCode(data:any){
    return new Promise((resolve,reject) => {
      let _data = {...data};
      _data.id_branch = this.getDefaultBranch()._id;
      _data.status = 1;
      _data.code = this.vhAlgorithm.createCardCode();     
      this.vhMGDB_database.getDocsByFields('payment_card_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
          .then((payment_card_codes:any)=>{
            if(payment_card_codes.length>0){
              _data.code = this.vhAlgorithm.createCardCode();  
              this.vhMGDB_database.getDocsByFields('payment_card_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                  .then((payment_card_codes:any)=>{
                    if(payment_card_codes.length>0){
                      _data.code = this.vhAlgorithm.createCardCode();  
                      this.vhMGDB_database.getDocsByFields('payment_card_codes', {code:{$eq:_data.code}, id_branch:{$eq:_data.id_branch}})
                          .then((payment_card_codes:any)=>{
                            if(payment_card_codes.length>0){
                              reject({error: {message: 'Nói anh Huy xem lại phần tạo mã code tự động, code tạo mới bị trùng'}});
                            }else{
                              this.vhMGDB_database.addDoc('payment_card_codes', _data)
                                  .then((payment_card_code)=>{
                                    resolve(payment_card_code);
                                  }, error=>{
                                    reject(error)
                                  })
                            }
                          }, error=>{
                              reject(error);
                          })     
                    }else{
                      this.vhMGDB_database.addDoc('payment_card_codes', _data)
                          .then((payment_card_code)=>{
                            resolve(payment_card_code);
                          }, error=>{
                            reject(error)
                          })
                    }
                  }, error=>{
                      reject(error);
                  })                 
            }else{
              this.vhMGDB_database.addDoc('payment_card_codes', _data)
                  .then((payment_card_code)=>{
                    resolve(payment_card_code);
                  }, error=>{
                    reject(error)
                  })
            }
          }, error=>{
              reject(error);
          })     
    })
  }
  

  /**
  *  hàm này để phát hành nhiều payment_card_code theo số lượng truyền vào, và tự động cập nhật trường số lượng đã phát hành (quantity_released) tăng lên 
  * trong collection payment_card_release_details 
  * @example:  
  let data = {
      date_validity: new Date(),
      date_expire: new Date(),    
      id_payment_card_release_detail: "fuMS21I6othUm34385WV",
      id_payment_card: '9841654DOIWSDYW235'  
  }
  * this.vhQuerySales.createPaymentCardCodes(data, 10)
        .then((voucher_codes)=>{
          console.log('createPaymentCardCodes', voucher_codes);
        }, error=>{
          console.log('error', error);
        }) 
  * @param data
  * @param quantity
  * @return Promise => Array(object)
  */
  public createPaymentCardCodes(data:any, quantity:number){
    return new Promise((resolve,reject) => {
      let promise = new Array();
      for(let i=0; i<quantity; i++){        
        promise[i] = this.createPaymentCardCode(data);        
      }       
      Promise.all(promise)
            .then((array:any)=>{
              array = array.flat();
              this.vhMGDB_database.getDoc('payment_card_release_details', data.id_payment_card_release_detail)
                  .then((payment_card_release_detail:any)=>{
                    if(payment_card_release_detail){
                      if(payment_card_release_detail.quantity_released != undefined){
                        let value = {quantity_released: payment_card_release_detail.quantity_released + quantity}
                        this.vhMGDB_database.updateDoc('payment_card_release_details', payment_card_release_detail._id, value)
                            .then(()=>{
                              resolve(array);
                            }, error=>{
                              reject(error)
                            })   
                      }else{
                        let value = {quantity_released: quantity}
                        this.vhMGDB_database.updateDoc('payment_card_release_details', payment_card_release_detail._id, value)
                            .then(()=>{
                              resolve(array);
                            }, error=>{
                              reject(error)
                            })
                      }
                    }                     
                  }, error=>{
                      reject(error);
                  })   
            })
            .catch(e=>{
              reject(e);
            })
    })
  }
/**
  * @example:  
  * let data = {
      date_validity: new Date(),
      date_expire: new Date(),
      id_branch: "4zFGhVUAZyj5d09r01xZ"
    }
  * this.vhQuerySales.updatePaymentCardCode('OUHEOIWUYGHIQNIDOUW1359478',data)
        .then((bool:any)=>{
          console.log('updateCouponCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_code
  * @param data
  * @return Promise => boolean = true or false
  */
  public updatePaymentCardCode(id_payment_card_code:any, data:any){
    return new Promise((resolve,reject) => {
      this.vhMGDB_database.updateDoc('payment_card_codes', id_payment_card_code, data)
          .then((bool:any)=>{
            resolve(bool);
          }, error=>{
            reject(error)
          })          
    })
  }
/**
  * Hàm này chỉ cho phép xóa payment_card đang ở trạng thái đã phát hành (status ==1),
  * và cập nhật giảm trường số lượng quantity_released bớt một trong collection payment_card_release_details
  * @example:   
  * this.vhQuerySales.deletePaymentCardCode('OUHEOIWUYGHIQNIDOUW1359478', 'qKgt3cRPRXtw75JV9URp'})
        .then((bool:any)=>{
          console.log('deletePaymentCardCode', bool);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_code
  * @param id_payment_card_release_detail      
  * @return Promise => boolean = true or false
  */
  public deletePaymentCardCode(id_payment_card_code:string, id_payment_card_release_detail:string){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.deleteDoc('payment_card_codes', id_payment_card_code)
          .then((bool:any)=>{            
            if(bool){      
              this.vhMGDB_database.getDoc('payment_card_release_details', id_payment_card_release_detail)
                  .then((payment_card_release_detail:any)=>{
                    if(payment_card_release_detail){
                      if(payment_card_release_detail.quantity_released != undefined){
                        let value = {quantity_released: payment_card_release_detail.quantity_released - 1}
                        this.vhMGDB_database.updateDoc('payment_card_release_details', payment_card_release_detail._id, value)
                            .then(()=>{
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })   
                      }else{                                
                        let value = {quantity_released: 0}//-1 thì vô lý quá, nên kiểm tra lại sau
                        this.vhMGDB_database.updateDoc('payment_card_release_details', payment_card_release_detail._id, value)
                            .then(()=>{
                              console.log('Báo anh Huy kiểm tra lại trường hợp này');
                              resolve(true);
                            }, error=>{
                              reject(error)
                            })
                      }
                    }                     
                  }, error=>{
                      reject(error);
                  })                     
            }else{
               resolve(false);
            }  
          }, error=>{
            reject(error)
          })          
    })
  }
/** 
  * hàm này trả về danh sách payment_card_codes đã phát hành theo mỗi đợt
  * @example:  
  * 
  * this.vhQuerySales.getPaymentCardCodes_byIdPaymentCardReleaseDetail('OUHEOIWUYGHIQNIDOUW1359478'})
        .then((array:any)=>{
          console.log('getPaymentCardCodes_byIdPaymentCardReleaseDetail', array);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_release_detail
  * @return Promise => Array<any> 
  */
  public getPaymentCardCodes_byIdPaymentCardReleaseDetail(id_payment_card_release_detail:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('payment_card_codes', {id_payment_card_release_detail:{$eq:id_payment_card_release_detail}}, {})
              .then((voucher_codes)=>{
                resolve(voucher_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }  

  /** 
 * hàm này trả về danh sách payment_card code đã phát hành theo điều kiện query
 * @example:  
 * this.vhQuerySales.getPaymentCardCodes_byFields({status:{$eq: 1}}, {}, {}, 0)
        .then((res)=>{
          console.log('getPaymentCardCodes_byFields', res);
        }, error=>{
          console.log('error', error);
        })
  * @param query
  * @param projection
  * @param sort
  * @param limit
  * @return Promise => array(object) = [{},{},..]
  */
  public getPaymentCardCodes_byFields(query: object, projection: object, sort: object, limit: number){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDocsByFields('payment_card_codes', query,{},sort,limit)
              .then((payment_card_codes)=>{
                resolve(payment_card_codes);
              })
              .catch((e)=>{
                reject(e);
              })
    })
  }
/** 
  *  hàm này trả về payment_card_code đã phát hành theo trường _id của payment_card_code. dùng trong trang bán hàng thanh toán bằng payment_card (chỉ lấy được hàng hóa có và còn trong card)
  * @example:  
  * 
  * this.vhQuerySales.getPaymentCardCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getPaymentCardCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_code: cũng chính là code
  * @return Promise => obj = {} or null
  */
  public getPaymentCardCode(id_payment_card_code:any){
    return new Promise((resolve, reject) => {
      this.vhMGDB_database.getDoc('payment_card_codes', id_payment_card_code)
            .then((payment_card_code)=>{
              resolve(payment_card_code);
            }, error=>{
                reject(error);
            })          
    })
  }

  
  /** 
 * hàm này trả về payment_card code đã phát hành theo trường _id của payment_card code
 * trả về có cả code, name_payment_card, name_payment_card_release
 * @example:  
 * 
 * this.vhQuerySales.getPaymentCard_Code_Name_Release('OUHEDW0512'})
        .then((res)=>{
          console.log('getPaymentCard_Code_Name_Release', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param id_payment_card_code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getPaymentCard_Code_Name_Release(id_payment_card_code:any){
    return new Promise((resolve, reject) => {
        this.vhMGDB_database.getDoc('payment_card_codes', id_payment_card_code)
            .then((payment_card_code:any)=>{
              if(payment_card_code){
                let payment_card = cloneDeep(payment_card_code);             
                this.vhMGDB_database.getDoc('payment_card_release_details', payment_card.id_payment_card_release_detail)
                    .then((payment_card_release_detail:any)=>{
                      if(payment_card_release_detail){
                        Promise.all([
                          this.vhMGDB_database.getDoc('payment_cards', payment_card_release_detail.id_payment_card),                            
                          this.vhMGDB_database.getDoc('payment_card_releases', payment_card_release_detail.id_payment_card_release)
                        ]).then((array:any)=>{ 
                          payment_card.units = array[0].units;
                          if(payment_card.status === 1){                                
                            payment_card.products = array[0].products;
                            payment_card.points = array[0].points;
                          }                                                
                          payment_card.name_payment_card = array[0].name;
                          payment_card.name_payment_card_release = array[1].name;
                          if(payment_card.products){
                            for(let j=0; j<payment_card.products.length; j++){
                              if((payment_card.products[j].ptype ===3)||payment_card.products[j].ptype ===2){
                                let id_sub_or_product = payment_card.products[j].id_subproduct?payment_card.products[j].id_subproduct:payment_card.products[j].id_product;
                                let product = this.getlocalDetailProduct(id_sub_or_product);
                                payment_card.products[j].name = product.name;
                                payment_card.products[j].units = product.units;
                                if(product.lots) payment_card.products[j].lots = product.lots;  
                  
                              }else if(payment_card.products[j].ptype ===5){
                                let product = this.getlocalDetailProduct(payment_card.products[j].id_product);
                                payment_card.products[j].name = product.name;
                                payment_card.products[j].units = product.units;
                                payment_card.products[j].combos = product.combos;
                                for(let m=0; m<payment_card.products[j].combos.length; m++){
                                  let _id_sub_or_product = payment_card.products[j].combos[m].id_subproduct?payment_card.products[j].combos[m].id_subproduct:payment_card.products[j].combos[m].id_product;
                                  let _product = this.getlocalDetailProduct(_id_sub_or_product);
                                  payment_card.products[j].combos[m].name = _product.name;
                                  payment_card.products[j].combos[m].units = _product.units;
                                  if(_product.lots) payment_card.products[j].combos[m].lots = _product.lots;
                                }
                              }
                            }
                          }
                          resolve(payment_card);
                        })                            
                      }else resolve(null); 
                    },(error:any)=>{                      
                      reject(error);
                    })
              }else resolve(null);             
            }, error=>{
                reject(error);
            })   
      // this.vhMGDB_database.getDoc('payment_card_codes', id_payment_card_code)
      //       .then((payment_card_code:any)=>{
      //         if(payment_card_code){
      //           let payment_card = cloneDeep(payment_card_code);               
      //           this.vhMGDB_database.getDoc('payment_card_release_details', payment_card_code.id_payment_card_release_detail)
      //               .then((payment_card_release_detail:any)=>{
      //                 if(payment_card_release_detail){
      //                   Promise.all([
      //                     this.vhMGDB_database.getDoc('payment_cards', payment_card_release_detail.id_payment_card),                            
      //                     this.vhMGDB_database.getDoc('payment_card_releases', payment_card_release_detail.id_payment_card_release)
      //                   ]).then((array:any)=>{
      //                     payment_card.name_payment_card = array[0].name;
      //                     payment_card.name_payment_card_release = array[1].name;
      //                     resolve(payment_card);
      //                   })                            
      //                 }else resolve(null); 
      //               },(error:any)=>{                      
      //                 reject(error);
      //               })
      //         }else resolve(null);             
      //       }, error=>{
      //           reject(error);
      //       })          
    })
  }

  /** 
 * hàm này trả về payment_card đã phát hành theo trường code của payment_card_code. dùng trong trang đổi điểm lấy thẻ payment_card và bán payment_card, đổi payment_card lấy hàng hóa,
 * trả về có cả code, name_payment_card, name_payment_card_release
 * @example:  
 * 
 * this.vhQuerySales.getPaymentCard_Code_Name_Release_byCode('OUHEDW0512'})
        .then((res)=>{
          console.log('getPaymentCard_Code_Name_Release_byCode', res);
        }, error=>{
          console.log('error', error);
        }) 
  * @param code: cũng chính là code
  * @return Promise => obj ={} or null
  */
  public getPaymentCard_Code_Name_Release_byCode(code:any){
    return new Promise((resolve, reject) => {
      //let id_branch = this.getDefaultBranch()._id;
      this.vhMGDB_database.getDocsByFields('payment_card_codes', {code:{$eq:code}})
            .then((payment_card_codes:any)=>{
              if(payment_card_codes.length>0){
                let payment_card = cloneDeep(payment_card_codes[0]);               
                this.vhMGDB_database.getDoc('payment_card_release_details', payment_card.id_payment_card_release_detail)
                    .then((payment_card_release_detail:any)=>{
                      if(payment_card_release_detail){
                        Promise.all([
                          this.vhMGDB_database.getDoc('payment_cards', payment_card_release_detail.id_payment_card),                            
                          this.vhMGDB_database.getDoc('payment_card_releases', payment_card_release_detail.id_payment_card_release)
                        ]).then((array:any)=>{ 
                          payment_card.units = array[0].units;
                          if(payment_card.status === 1){                                
                            payment_card.products = array[0].products;
                            payment_card.points = array[0].points;
                          }                                                
                          payment_card.name_payment_card = array[0].name;
                          payment_card.name_payment_card_release = array[1].name;
                          if(payment_card.products){
                            for(let j=0; j<payment_card.products.length; j++){
                              if((payment_card.products[j].ptype ===3)||payment_card.products[j].ptype ===2){
                                let id_sub_or_product = payment_card.products[j].id_subproduct?payment_card.products[j].id_subproduct:payment_card.products[j].id_product;
                                let product = this.getlocalDetailProduct(id_sub_or_product);
                                payment_card.products[j].name = product.name;
                                payment_card.products[j].units = product.units;
                                if(product.lots) payment_card.products[j].lots = product.lots;  
                  
                              }else if(payment_card.products[j].ptype ===5){
                                let product = this.getlocalDetailProduct(payment_card.products[j].id_product);
                                payment_card.products[j].name = product.name;
                                payment_card.products[j].units = product.units;
                                payment_card.products[j].combos = product.combos;
                                for(let m=0; m<payment_card.products[j].combos.length; m++){
                                  let _id_sub_or_product = payment_card.products[j].combos[m].id_subproduct?payment_card.products[j].combos[m].id_subproduct:payment_card.products[j].combos[m].id_product;
                                  let _product = this.getlocalDetailProduct(_id_sub_or_product);
                                  payment_card.products[j].combos[m].name = _product.name;
                                  payment_card.products[j].combos[m].units = _product.units;
                                  if(_product.lots) payment_card.products[j].combos[m].lots = _product.lots;
                                }
                              }
                            }
                          }
                          resolve(payment_card);
                        })                            
                      }else resolve(null); 
                    },(error:any)=>{                      
                      reject(error);
                    })
              }else resolve(null);             
            }, error=>{
                reject(error);
            })          
    })
  }

  
/* Hàm này để đổi payment_card từ điểm của khách hàng. Đổi thành công tự động tạo lịch sử đổi điểm của khách hàng
 * hàm này đã cập nhật lại trường status, id_customer, date_points_exchanged cho payment_cards
 * hàm này đã cập nhật lại trường earned_points, id_customer, branch_earned_points cho customers  
 * @example: 
 * let array = [{id_payment_code, points, products},{}...]
 * this.vhQuerySales.exchangePaymentCardCode_byEarningPoints(array, "fuMS21I6othUm34385WV", 10)
        .then((bool:any)=>{
          console.log('exchangePaymentCardCode_byEarningPoints', bool);
        }, error=>{
          console.log('error', error);
        })
  * @param array_id_payment_card_code_and_points_and_products
  * @param id_customer
  * @param points
  * @return Promise Boolean => true or false
  */
  public exchangePaymentCardCode_byEarningPoints(array_id_payment_card_code_and_points_and_products:any, id_customer:any, points:any){
    //console.log('---array_id_payment_card_code_and_points_and_products', array_id_payment_card_code_and_points_and_products);
    return new Promise((resolve, reject) => {
      let promise_zero:any = new Array();
      for(let i=0; i<array_id_payment_card_code_and_points_and_products.length; i++){
        promise_zero[i] = this.vhMGDB_database.getDoc('payment_card_codes', array_id_payment_card_code_and_points_and_products[i].id_payment_card_code);
      }
      promise_zero[promise_zero.length] = this.vhMGDB_database.getDoc('customers', id_customer);
      Promise.all(promise_zero)
            .then((array:any)=>{
              let promise_one:any = new Array();
              for(let i=0; i<array.length -1; i++){
                let value_payment_card_code = {
                  status: 3,                  
                  date_points_exchanged: new Date(),
                  points: array_id_payment_card_code_and_points_and_products[i].points,
                  products: array_id_payment_card_code_and_points_and_products[i].products,
                  id_customer: id_customer
                }
                 //status 2 hoặc 3 phải cập nhật trường outquantity = 0       
                for(let j=0; j<value_payment_card_code.products.length; j++){
                  value_payment_card_code.products[j].outquantity = 0;                                        
                }
                promise_one[i] = this.vhMGDB_database.updateDoc('payment_card_codes', array[i]._id, value_payment_card_code);
              }
              let customer:any = array[array.length-1];
              if(customer.earned_points != undefined){
                customer.earned_points = customer.earned_points - points;
              }else{
                customer.earned_points = 0;
              }
              let branch = this.getDefaultBranch();
              if(customer.branch_earned_points !=undefined){
                if(customer.branch_earned_points[branch._id] !=undefined){
                  customer.branch_earned_points[branch._id] = customer.branch_earned_points[branch._id] -points;
                }else{
                  customer.branch_earned_points[branch._id] = 0;
                }
              }else{
                customer.branch_earned_points = {};
              }
              let value_customer = {
                earned_points: customer.earned_points,
                branch_earned_points: customer.branch_earned_points    
              }
              promise_one[promise_one.length] = this._updateCustomer(customer._id, value_customer);
              Promise.all(promise_one)
                    .then(()=>{
                      resolve(true);
                    })
            })
    })
  }

/**
 * không cần hàm này vì khi tạo phiếu bill_type51 đã được cập nhật
 * hàm này dùng để cập nhật số lượng sản phẩm trong Payment Card khi đổi thẻ
 * @example:
 * this.vhQuerySales.getPaymentCardCode_byCode("ONHDIWUHIODUWN","NDPIUWUHIOUYEW",{quantity_valid: 0})
        .then((res)=>{
          console.log('getPaymentCardCode_byCode', res);
        }, error=>{
          console.log('error', error);
        })
  * @param id_payment_card
  * @param id_comboproduct
  * @param data
  * @return Promise object or null
  */
  public updateComboPaymentCard(id_payment_card:any, id_comboproduct:any, data:any){//chưa có code
  }


/**
 * Hàm này MÁY ĐANG DÙNG PHẦN MỀM sẽ mở kết nối với tất cả các thiết bị giao tiếp RS232 đã khai báo trong Cài đặt/Cấu hình/Bảng LED hiển thị giá
 * @example:
 *  this.vhQuerySales.connectDisplayLEDScreens();
 */
  public connectDisplayLEDScreens(){
    let displayLEDs:any = this.vhDisplayLEDService.getlocalDisplayLEDs(); 
    //console.log('displayLEDs', displayLEDs);
    for(let i=0; i<displayLEDs.length; i++){
      if(displayLEDs[i].enable)
      this.vhDisplayLEDService.openPort(displayLEDs[i].port, displayLEDs[i].baundrate)
          .then((t: any) => {                      
            this.vhDisplayLEDService.updateLocalDisplayLEDs(displayLEDs[i]._id, {connected:true});
            console.log('ket noi thanh cong', displayLEDs[i].port);
          })
          .catch((f: any) => {           
            console.log('ket noi that bai', displayLEDs[i].port);
          });
    }
    
  }

/**
 * Hàm này MÁY ĐANG DÙNG PHẦN MỀM sẽ đóng kết nối với tất cả các thiết bị giao tiếp RS232 đã khai báo trong Cài đặt/Cấu hình/Bảng LED hiển thị giá
 * @example:
 *  this.vhQuerySales.connectDisplayLEDScreens();
 */
  public disconnectDisplayLEDScreens(){
    let displayLEDs:any = this.vhDisplayLEDService.getlocalDisplayLEDs(); 
    for(let i=0; i<displayLEDs.length; i++){
      if(displayLEDs[i].connected)
      this.vhDisplayLEDService.closePort()
          .then((t: any) => {           
            this.vhDisplayLEDService.updateLocalDisplayLEDs(displayLEDs[i]._id, {connected:false});        
          })
          .catch((f: any) => {            
          });
    }
  }

/**
 * Hàm này PHẦN MỀM sẽ gửi bill và bill_details xuống bảng LED hiển thị giá để hiển thị giá trị lên.
 * Lưu ý bắt sự kiện giá trị tổng hóa đơn (total) thay đổi và gọi lại hàm này.
 * @example:
 *  this.vhQuerySales.writeBill_BillDetails_toDisplayLEDScreens(bill, bill_details);
 */
  public writeBill_BillDetails_toDisplayLEDScreens(bill:any, bill_details:any){
    //console.log('----bill', bill);
    //console.log('----bill_details', bill_details);
    //if((bill.total === undefined)||(bill.total === null)) return null;
    let displayLEDs:any = this.vhDisplayLEDService.getlocalDisplayLEDs(); 
    //console.log('----displayLEDs', displayLEDs);
    for(let i=0; i<displayLEDs.length; i++){
      //-------------------LED 7 đoạn - 1 hàng 8 LED--------------------------------------
      if(displayLEDs[i].connected && displayLEDs[i].enable)
      if(displayLEDs[i].type_display_model === 1){//LED 7 đoạn - 1 hàng 8 LED
        if(displayLEDs[i].type_display_mode === 1){//Chi tiết hóa đơn                
          let str = bill.total + '';
          let str8 = str;
          str8 = this.vhAlgorithm.changeMoneyToDotMoney(str8, 20);   
          for(let k=1; k<=8; k++){
            if(k>str.length) str8 = ' ' + str8;
          }
          if(str.length >= 7) str8 = str8.slice(0, 10);
          else if(str.length >= 4) str8 = str8.slice(0, 9);
          this.vhDisplayLEDService.writeLine(str8)
              .then(() => {})
              .catch((err) => {});        
        }else if(displayLEDs[i].type_display_mode === 2){//Chi tiết hóa đơn & tổng tiền          
          let str = bill.total + '';
          let str8 = str;
          str8 = this.vhAlgorithm.changeMoneyToDotMoney(str8, 20);   
          for(let k=1; k<=8; k++){
            if(k>str.length) str8 = ' ' + str8;
          }
          if(str.length >= 7) str8 = str8.slice(0, 10);
          else if(str.length >= 4) str8 = str8.slice(0, 9);
          this.vhDisplayLEDService.writeLine(str8)
              .then(() => {})
              .catch((err) => {});          
        }else if(displayLEDs[i].type_display_mode === 3){//Tổng tiền  
          let str = bill.total + '';
          let str8 = str;
          str8 = this.vhAlgorithm.changeMoneyToDotMoney(str8, 20);   
          for(let k=1; k<=8; k++){
            if(k>str.length) str8 = ' ' + str8;
          }
          if(str.length >= 7) str8 = str8.slice(0, 10);
          else if(str.length >= 4) str8 = str8.slice(0, 9);
          this.vhDisplayLEDService.writeLine(str8)
              .then(() => {})
              .catch((err) => {});   
            // let str = bill.total + '';
            // str = str.slice(0, 8);
            // let str8 = str;
            // for(let k=1; k<=8; k++){
            //   if(k>str.length) str8 = ' ' + str8;
            // }
            // if(str.length >=7){
            //   str8 = str8.slice(0, 5)  + '.' + str8.slice(5) ;
            //   str8 = str8.slice(0, 2)  + '.' + str8.slice(2) ;
            // }else if(str.length >=4){
            //   str8 = str8.slice(0, 5)  + '.' + str8.slice(5) ;
            // }
            // str8 = str8.slice(0, 10);
            // this.vhDisplayLEDService.writeLine(str8)
            //     .then(() => {})
            //     .catch((err) => {});          
        }
        //-----------------LED ma trận - 2 hàng 20 cột-----------------------------------
      }else if(displayLEDs[i].type_display_model === 2){//LED ma trận - 2 hàng 20 cột
        if(displayLEDs[i].type_display_mode === 1){//Chi tiết hóa đơn          
          if(bill_details.length >0){
            let name1 = 'San Pham1';
            let name2 = 'San Pham2';
            let price1 = '0';
            let price2 = '0';
            if(bill_details[0].name) name1 = bill_details[0].name;
            name1 = this.vhAlgorithm.changeAlias(name1);
            name1 = name1.slice(0, 9);
            if(bill_details[1].name) name2 = bill_details[1].name;
            name2 = this.vhAlgorithm.changeAlias(name2);
            name2 = name2.slice(0, 9);
            if(bill_details[0].price) price1 = bill_details[0].price + '';
            if(bill_details[1].price) price2 = bill_details[1].price + '';            
         
            price1 = this.vhAlgorithm.changeMoneyToDotMoney(price1, 10);
            price2 = this.vhAlgorithm.changeMoneyToDotMoney(price2, 10);

            if(bill_details.length === 1){
              let str1 = name1 + ' ' + price1;
              let str_blank = '                    ';
              this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                  .then(() => {
                    this.vhDisplayLEDService.writeLineAtPos(str1, 0)
                        .then(() => {})
                        .catch((err) => {});   
                  })
                .catch((err) => {});   
                
            }else if(bill_details.length >= 2){
              let str1 = name1 + ' ' + price1;
              let str2 = name2 + ' ' + price2;
              let str_blank = '                    ';
              this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});     
            }              
          }               
        }else if(displayLEDs[i].type_display_mode === 2){//Chi tiết hóa đơn & tổng tiền         
          if(bill_details.length >0){
            let name1 = 'San Pham1';           
            let price1 = '0';         
            if(bill_details[0].name) name1 = bill_details[0].name;
            name1 = this.vhAlgorithm.changeAlias(name1);
            name1 = name1.slice(0, 9);
            if(bill_details[0].price) price1 = bill_details[0].price + '';
            price1 = this.vhAlgorithm.changeMoneyToDotMoney(price1, 10);
            let str1 = name1 + ' ' + price1;

            let str2 = bill.total + '';
            str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 10);    
            if(str2.length >=10) str2 = 'Tong tien:' + str2;
            else str2 = 'Tong tien: ' + str2;               
            str2 = str2.slice(0, 20);

            let str_blank = '                    ';
            this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});               
          }else{
            let str2 = bill.total + '';
            str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 10); 
            if(str2.length >=10) str2 = 'Tong tien:' + str2;
            else str2 = 'Tong tien: ' + str2;                 
            str2 = str2.slice(0, 20);
            let str_blank = '                    ';
            this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(' ', str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});       
          }                            
        }else if(displayLEDs[i].type_display_mode === 3){//Tổng tiền                
          let str1 = 'Tong tien:';           
          let str2 = bill.total + '';
          str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 20);                  
          let str_blank = '                    ';
          this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
              .then(() => {
                this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                    .then(() => {})
                    .catch((err) => {}); 
              })
              .catch((err) => {});             
        }
        //-------------------------------VFD-2100-------------------------------------
      }else if(displayLEDs[i].type_display_model === 3){//VFD-2100
        if(displayLEDs[i].type_display_mode === 1){//Chi tiết hóa đơn          
          if(bill_details.length >0){
            let name1 = 'San Pham1';
            let name2 = 'San Pham2';
            let price1 = '0';
            let price2 = '0';
            if(bill_details[0].name) name1 = bill_details[0].name;
            name1 = this.vhAlgorithm.changeAlias(name1);
            name1 = name1.slice(0, 9);
            if(bill_details[1].name) name2 = bill_details[1].name;
            name2 = this.vhAlgorithm.changeAlias(name2);
            name2 = name2.slice(0, 9);
            if(bill_details[0].price) price1 = bill_details[0].price + '';
            if(bill_details[1].price) price2 = bill_details[1].price + '';            
         
            price1 = this.vhAlgorithm.changeMoneyToDotMoney(price1, 10);
            price2 = this.vhAlgorithm.changeMoneyToDotMoney(price2, 10);

            if(bill_details.length === 1){
              let str1 = name1 + ' ' + price1;
              let str_blank = '                    ';
              this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                  .then(() => {
                    this.vhDisplayLEDService.writeLineAtPos(str1, 0)
                        .then(() => {})
                        .catch((err) => {});   
                  })
                .catch((err) => {});   
                
            }else if(bill_details.length >= 2){
              let str1 = name1 + ' ' + price1;
              let str2 = name2 + ' ' + price2;
              let str_blank = '                    ';
              this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});     
            }              
          }               
        }else if(displayLEDs[i].type_display_mode === 2){//Chi tiết hóa đơn & tổng tiền         
          if(bill_details.length >0){
            let name1 = 'San Pham1';           
            let price1 = '0';         
            if(bill_details[0].name) name1 = bill_details[0].name;
            name1 = this.vhAlgorithm.changeAlias(name1);
            name1 = name1.slice(0, 9);
            if(bill_details[0].price) price1 = bill_details[0].price + '';
            price1 = this.vhAlgorithm.changeMoneyToDotMoney(price1, 10);
            let str1 = name1 + ' ' + price1;

            let str2 = bill.total + '';
            str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 10);    
            if(str2.length >=10) str2 = 'Tong tien:' + str2;
            else str2 = 'Tong tien: ' + str2;               
            str2 = str2.slice(0, 20);

            let str_blank = '                    ';
            this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});               
          }else{
            let str2 = bill.total + '';
            str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 10); 
            if(str2.length >=10) str2 = 'Tong tien:' + str2;
            else str2 = 'Tong tien: ' + str2;                 
            str2 = str2.slice(0, 20);
            let str_blank = '                    ';
            this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
                .then(() => {
                  this.vhDisplayLEDService.writeLinesAtPos(' ', str2, 0)
                      .then(() => {})
                      .catch((err) => {}); 
                })
                .catch((err) => {});       
          }                            
        }else if(displayLEDs[i].type_display_mode === 3){//Tổng tiền                
          let str1 = 'Tong tien:';           
          let str2 = bill.total + '';
          str2 = this.vhAlgorithm.changeMoneyToDotMoney(str2, 20);                  
          let str_blank = '                    ';
          this.vhDisplayLEDService.writeLinesAtPos(str_blank, str_blank, 0)
              .then(() => {
                this.vhDisplayLEDService.writeLinesAtPos(str1, str2, 0)
                    .then(() => {})
                    .catch((err) => {}); 
              })
              .catch((err) => {});             
        }
      }
    }
  }  

  /**
  * @example:
  * let time = new Date();
  * time.setDate(time.getDate()-7);
  * this.vhQuerySales.getAffiliate_byFields({payment_type:{$eq:5}}, {},{},0)
        .then((affiliates)=>{
          console.log('getAffiliate_byFields', affiliates);
        })
  * @param query
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
  public getAffiliate_byFields(query: any, projection?:object, sort?:object, limit?:number) {
    return new Promise((resolve, reject) => {       
      this.vhMGDB_rootdatabase.getDocsByFields('affiliates', query, {}, sort, limit)
          .then((affiliates)=>{
            resolve(affiliates);
          }, error=>{
            console.log(error, error);
          })       
    })
  } 
}

 @Injectable()
 export class VhQueryAdministrator{
  constructor(
    private vhMGDB_auth: VhMGDB_auth, 
    private vhMGDB_database: VhMGDB_database, 
    private vhMGDB_rootdatabase: VhMGDB_rootdatabase, 
    private vhAuth: VhAuth, 
    private vhAlgorithm:VhAlgorithm, 
  ){}

  /**
   * @description: Lấy về tất cả các cửa hàng (shops) đã đăng ký vào hệ thống phần mềm, theo thời gian
   * @example: 
   * let starttime = new Date('2022-03-13T05:24:00');
   * let endtime = new Date();
   * this.VhQueryAdministrator.getShops_byTime(starttime, endtime')
         .then(result=>{
           console.log('result', result);
         }, error=>{
           console.log('error', error);
         })
   * @param starttime 
   * @param endtime 
   * @returns Promise Array
   */
  public getShops_byTime(starttime:any, endtime:any) {
    return new Promise((resolve, reject) => {  
      if(!this.vhMGDB_auth.getAdministrator()._id) reject('bạn chưa đăng nhập');
      starttime = new Date(starttime);  
      endtime = new Date(endtime);  
      let query = {creationdate:{$gte:starttime, $lte:endtime}}
      this.vhMGDB_rootdatabase.getDocsByFields('stores', query, {}, {}, 100)
              .then((stores:any) => {                   
                      let _stores = new Array();
                      for(let i=0; i<stores.length; i++){
                        _stores[i] = {};
                        _stores[i]._id = stores[i]._id;
                        _stores[i].email = stores[i]?.email;
                        _stores[i].address = stores[i]?.address;
                        _stores[i].company = stores[i]?.company;
                        _stores[i].countrycode = stores[i]?.countryCode;
                        _stores[i].registrationdate = stores[i]?.registrationdate;
                        _stores[i].name = stores[i]?.name;
                        _stores[i].phone = stores[i]?.phone;
                        _stores[i].id_employee = stores[i]?.id_employee;
                        _stores[i].id_dealer = stores[i]?.id_dealer;
                        _stores[i].status_store = stores[i]?.status_store;                        
                        _stores[i].id_salesman = stores[i]?.id_salesman;
                        _stores[i].id_carestaff = stores[i]?.id_carestaff;                   
                      }
                      resolve(_stores);                                             
              }).catch(e=>{
                reject(e)
              })
    })
      
  }

    

    /**
    * @example:
    * let time = new Date();
    * time.setDate(time.getDate()-7);
    * this.vhQueryAdministrator.getAffiliaters_byFields({code:{$eq: 'A0001;}}, {},{},0)
          .then((affiliaters)=>{
            console.log('getAffiliaters_byFields', affiliaters);
          })
    * @param query
    * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
    * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
    * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
    * @return — Array -> array = [{},{},...] 
    */
    public getAffiliaters_byFields(query: any, projection?:object, sort?:object, limit?:number) {
      return new Promise((resolve, reject) => {       
        if(!this.vhMGDB_auth.getAdministrator()._id) reject('bạn chưa đăng nhập');
        this.vhMGDB_rootdatabase.getDocsByFields('affiliaters', query, {}, sort, limit)
            .then((affiliaters)=>{
              resolve(affiliaters);
            }, error=>{
              console.log(error, error);
            })       
      })
    }

        /**
    * @example:
    * let time = new Date();
    * time.setDate(time.getDate()-7);
    * this.vhQueryAdministrator.getDealers_byFields({creationdate:{$lte: new Date()}}, {},{},0)
          .then((dealers)=>{
            console.log('getDealers_byFields', dealers);
          })
    * @param query
    * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
    * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
    * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
    * @return — Array -> array = [{},{},...] 
    */
    public getDealers_byFields(query: any, projection?:object, sort?:object, limit?:number) {
      return new Promise((resolve, reject) => {       
        if(!this.vhMGDB_auth.getAdministrator()._id) reject('bạn chưa đăng nhập');
        this.vhMGDB_rootdatabase.getDocsByFields('dealers', query, {}, sort, limit)
            .then((dealers)=>{
              resolve(dealers);
            }, error=>{
              console.log(error, error);
            })       
      })
    }

/**
  * @example:
  * let data = {   
      date: new Date(),    
      code: "A0001",
      name: "Giá tốt mỗi ngày", 
      id_affiliater: "5fb6780ca2148e09806c5b01",
      payment_details:[{
        id_package: "store_main_package_standard_12month",
        original_price: 1980000,
        partner_price: 1980000,
        selling_price: 980000
      },{
        id_package: "store_main_package_super_pro_12month",
        original_price: 3960000,
        partner_price: 3960000,
        original_price: 3960000
      }]
  }
  * this.vhQueryAdministrator.createAffiliate(data)
          .then((affiliate)=>{
            console.log('createAffiliate', affiliate);
          },(error:any)=>{
            console.log('error', error);
          })     
    * @param data : object 
    * @return  Promise => affiliate = {} / error
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
    public createAffiliate(data:any){    
      return new Promise((resolve, reject) => {
        if(!data.code) data.code = Math.random().toString(36).substr(2, 4).toUpperCase();
        if(!this.vhMGDB_auth.getAdministrator()._id) reject('bạn chưa đăng nhập');     
        this.vhMGDB_rootdatabase.addDoc('affiliates', data)
            .then((affiliate)=>{
              resolve(affiliate);
            },(error:any)=>{
              reject(error);
            })         
      })
    }

  /**
   * Hàm lấy về thông tin, giá cả các gói phần mềm mà các affiliater muốn bán cho khách của họ
   * @example:
   * this.vhQueryAdministrator.getAffiliate('5fb67fda87c0f21d484cbdf3')
        .then((affiliate)=>{
          console.log('getAffiliate', affiliate);
        })
    *  @param id_affiliate 
    *  @return Promise => affiliate ={} or null / error
    */
  public getAffiliate(id_affiliate:any) {
    return new Promise((resolve, reject) => { 
      this.vhMGDB_rootdatabase.getDoc('affiliates', id_affiliate)
          .then((response:any) => {              
              resolve(response);
            },
            (error:any) => {
              reject(error);
            }) 
    })
  }   
    
    /**
     * @example:
     * this.vhQueryAdministrator.updateAffiliate('5fb6780ca2148e09806c5b01', {total:990000})
            .then((response)=>{
              console.log('updateAffiliate', response);
            }, error=>{
              console.log('error', error);
            })
      * @param id_affiliate 
      * @param value 
      * @return Promise => response = undefined / error
      */
      public updateAffiliate(id_affiliate:string, value:any){        
        return new Promise((resolve, reject) => {  
          this.vhMGDB_rootdatabase.updateDoc('affiliates', id_affiliate, value)
            .then((response)=>{
              resolve(response);       
            }, error=>{
              reject(error);  
            })     
        })
      }  
    
      /**
       * @example:
       * this.vhQueryAdministrator.deleteAffiliate('5fb67fda87c0f21d484cbdf3')
            .then((response)=>{
              console.log('deleteAffiliate', response);
            }, error=>{
              console.log(error, error);
            }) 
        * @param id_affiliate 
        * @return Promise => response = undefined / error
        */
      public deleteAffiliate(id_affiliate:any){
        return new Promise((resolve, reject) => {
          this.vhMGDB_rootdatabase.deleteDoc('affiliates', id_affiliate)
              .then((response)=>{
                resolve(response);          
              }, error=>{
                console.log(error, error);
              })              
        })
      }
    
        /**
      * @example:
      * let time = new Date();
      * time.setDate(time.getDate()-7);
      * this.vhQueryAdministrator.getAffiliate_byFields({payment_type:{$eq:5}}, {},{},0)
            .then((affiliates)=>{
              console.log('getAffiliate_byFields', affiliates);
            })
      * @param query
      * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
      * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
      * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
      * @return — Array -> array = [{},{},...] 
      */
      public getAffiliate_byFields(query: any, projection?:object, sort?:object, limit?:number) {
        return new Promise((resolve, reject) => {       
          //if(!this.vhMGDB_auth.getAffiliater()._id) reject('bạn chưa đăng nhập');
          //query.id_affiliater = {$eq:this.vhMGDB_auth.getAffiliater()._id} ;
          this.vhMGDB_rootdatabase.getDocsByFields('affiliates', query, {}, sort, limit)
              .then((affiliates)=>{
                resolve(affiliates);
              }, error=>{
                console.log(error, error);
              })       
        })
      } 

      
}

 @Injectable()
 export class VhQueryAffiliater{
  constructor(
    private vhMGDB_auth: VhMGDB_auth, 
    private vhMGDB_database: VhMGDB_database, 
    private vhMGDB_rootdatabase: VhMGDB_rootdatabase, 
    private vhAuth: VhAuth, 
    private vhAlgorithm:VhAlgorithm, 
  ){}

  /**
   * Lấy về các shops đã đăng ký sử dụng nhưng chưa gia hạn
   * this.vhQueryAffiliater.getShops_byFree()
          .then((shops)=>{
          
          })
   * @returns 
   */
  public getShops_byFree(){
    return new Promise((resolve, reject) => { 
      if(!this.vhMGDB_auth.getAffiliater()._id) reject('bạn chưa đăng nhập');
      this.vhMGDB_rootdatabase.getDocsByFields('stores', {affiliaterCode:{$eq: this.vhMGDB_auth.getAffiliater().code}}, {}, {}, 0)
            .then((stores:any)=>{
              for(let i=0; i<stores.length; i++){
                delete stores[i].scrkey;
              }
              resolve(stores);
            }, error=>{
              console.log(error, error);
            })  
    })
  }

 /**
  * Lấy vế các shops đã thanh toán và gia hạn sử dụng
  * this.vhQueryAffiliater.getPayments_byShop()
          .then((shops)=>{
          
          })
  * @returns 
  */
  public getPayments_byShop(){
    return new Promise((resolve, reject) => { 
      if(!this.vhMGDB_auth.getAffiliater()._id) reject('bạn chưa đăng nhập');
      this.vhMGDB_rootdatabase.getDocsByFields('payments', {id_affiliater:{$eq: this.vhMGDB_auth.getAffiliater()._id}}, {}, {}, 0)
            .then((payments:any)=>{             
              let promise_zero = new Array();
              for(let i=0; i<payments.length; i++){
                promise_zero[promise_zero.length] = new Promise((resolve, reject)=>{
                  this.vhMGDB_rootdatabase.getDoc('stores', payments[i].id_store)
                      .then((store:any) => {              
                          payments[i].shop_name = store.name;
                          payments[i].shop_email = store.email;
                          resolve(null)
                        },
                        (error:any) => {
                          reject(error);
                        }) 
                })                  
              }
              Promise.all(promise_zero)
                    .then(()=>{
                      resolve(payments);
                    })
            }, error=>{
              console.log(error, error);
            })  
    })
  }

  /**
   * Hàm lấy về thông tin, giá cả các gói phần mềm mà sales365 ủy quyền cho các affiliater bán cho khách của họ
   * @example:
   * this.vhQueryAffiliater.getAffiliate()
        .then((affiliate)=>{
          console.log('getAffiliate', affiliate);
        })
    *  @return Promise => affiliate ={} or null / error
    */
  public getAffiliate() {
    return new Promise((resolve, reject) => { 
      if(!this.vhMGDB_auth.getAffiliater()._id) reject('bạn chưa đăng nhập');
      let query = {
        id_affiliater: {$eq:this.vhMGDB_auth.getAffiliater()._id}
      }
      this.vhMGDB_rootdatabase.getDocsByFields('affiliates', query, {}, {}, 0)
          .then((affiliates:any)=>{
            if(affiliates.length){
              let affiliate = affiliates[0];
              let promise_zero = new Array();
              for(let i=0; i<affiliate.payment_details.length; i++){
                promise_zero[promise_zero.length] = new Promise((resolve, reject)=>{
                  this.vhMGDB_rootdatabase.getDoc('packages', affiliate.payment_details[i].id_package)
                      .then((_package:any) => {  
                        if(_package){
                          affiliate.payment_details[i].package_name = _package.name;
                        }                        
                        resolve(null)
                      },
                      (error:any) => {
                        reject(error);
                      }) 
                })                  
              }
              Promise.all(promise_zero)
                    .then(()=>{
                      resolve(affiliate);
                    })
              resolve(affiliate);
            }else resolve(null)
            
          }, error=>{
            console.log(error, error);
          })  
    })
  } 

}


 @Injectable()
 export class VhQueryDealer{
  constructor(
    private vhMGDB_auth: VhMGDB_auth, 
    private vhMGDB_database: VhMGDB_database, 
    private vhMGDB_rootdatabase: VhMGDB_rootdatabase, 
    private vhAuth: VhAuth, 
    private vhAlgorithm:VhAlgorithm, 
  ){}

  
  /**
   * Lấy về danh sách các ngân hàng (kèm logo) mà vietqr hỗ trợ tạo mã QR
   * @example:
   * this.vhQueryDealer.vietqr_getBanks()
        	.then((rsp:any)=>{
            if(rsp.vcode === 0){            
            }
          }, error=>{
            console.log(error)
          })
   * @returns Promise => rsp ={vcode, msg, data(array)} / error
   * vcode == 0: success
   */
    public vietqr_getBanks(){
      return new Promise((resolve, reject) => {  
        axios.get('https://api.vietqr.io/v2/banks')
            .then((response:any)=> {                        
              if(response.data.code == '00')  resolve({vcode:0, msg:response.data.desc, data: response.data.data});
              else resolve({code:1, msg:response.data.desc, data: null});
            })
            .catch((e:any)=> {                          
              reject(e.response.data);
            });
      })
    }
  
    /**
     * Tạo mã QR cho Shop quét thanh toán vào tài khoản ngân hàng đã đăng ký Casso
     * @example:
     * this.vhQueryDealer.vietqr_generateQR('0909925354', 'LE DUC HUY', '970422', 'compact2', '674fd94a9ace7267deb685fd', 99000)
            .then((rsp:any)=>{
              if(rsp.vcode === 0){            
              }
            }, error=>{
              console.log(error)
            })
      * @param accountNo: số tài khoản ngân hàng
      * @param accountName: tên chủ tài khoản
      * @param acqId: mã bin của ngân hàng (lấy từ hàm vietqr_getBanks())
      * @param template: compact2, compact, qr_only, print
      + compact2:	540x640	Bao gồm : Mã QR, các logo , thông tin chuyển khoản
      + compact:	540x540	QR kèm logo VietQR, Napas, ngân hàng
      + qr_only:	480x480	Trả về ảnh QR đơn giản, chỉ bao gồm QR
      + print:	600x776	Bao gồm : Mã QR, các logo và đầy đủ thông tin chuyển khoản
      * @param id_bill: _id của đơn hàng
      * @param amount: tổng tiền khách phải thanh toán
      * @returns Promise => rsp ={vcode, msg, data(img_base64)} / error
      * vcode == 0: success
      */
    public vietqr_generateQR(accountNo:string, accountName:string, acqId:string, template:string, id_payment:string, amount:number){
      return new Promise((resolve, reject) => {       
        let data = {
          accountNo,
          accountName,
          acqId,
          template,
          format: "text",
          amount,
        }      
  
        let projectname_code = "-1"; //ko phải là mã của dự án nào cả
        if(this.vhMGDB_auth.getProjectName()  === 'vhsales') projectname_code = "2";
        else if(this.vhMGDB_auth.getProjectName()  === 'bvhsales') projectname_code = "3";
        else if(this.vhMGDB_auth.getProjectName()  === 'vhcafe') projectname_code = "4";
        //let addInfo = btoa(this.vhMGDB_auth.getProjectName() + "||" + "payer_dealer" + "||" + id_payment);
        //"2" là dự án vhsales
        let addInfo = projectname_code + "|" + "PD" + "|" + id_payment; //project + "|" + "payer_dealer" + "|" + id_payment
        //Lấy mảng ký tự gồm những ký tự mà không tồn tại trong chuỗi addInfo
        const allChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"; //mở rộng sẽ làm thêm cho sô '0123456789'
        let missingChars = allChars.split("").filter(char => !addInfo.includes(char));
        let lowerCaseMap = new Map();
        // Đếm số lần xuất hiện của mỗi ký tự (không phân biệt hoa/thường)
        for (let char of missingChars) {
            let lowerChar = char.toLowerCase();
            lowerCaseMap.set(lowerChar, (lowerCaseMap.get(lowerChar) || 0) + 1);
        }
        // Chỉ giữ lại những phần tử xuất hiện từ 2 lần trở lên (không phân biệt hoa/thường)
        missingChars =  missingChars.filter(char => lowerCaseMap.get(char.toLowerCase()) > 1);
        //Xóa tất cả các ký thường chỉ giữ lại ký tự hoa và sô
        missingChars = missingChars.filter(char => char >= 'A' && char <= 'Z');
        //missingChars phải có ít nhất 2 phần tử mới làm thuật toán đc, đó làm mã hóa ký tự "|" và đánh dấu các chuỗi thương
        if(missingChars.length <2) return reject({vcode:1, msg:'no success'})
        //Thay thế tất cả ký tự '|' thành ký tự số missingChars[0]
        addInfo = addInfo.replace(/\|/g, missingChars[1]);     
        //Thêm 1 ký tự vào trước và sau các chuỗi ký tự thường hoặc vừa số vưa chữ thường nắm trong chuỗi cha addInfo
        addInfo = addInfo.replace(/([a-z0-9]*[a-z]+[a-z0-9]*)/g, missingChars[0] + '$&' + missingChars[0]);
        //Đổi các ký tự trong chuỗi addInfo sang chữ hoa
        //addInfo = addInfo.toUpperCase();
        //Thêm vào đầu chuỗi addInfo 1 ký tự số
        addInfo = missingChars[1] + addInfo;
        //Thêm vào đầu chuỗi addInfo 1 ký tự số
        addInfo = missingChars[0] + addInfo;  
        //if(this.vhAuth.getDBstorage() === 'mongo'){        
          axios.post('https://api.vietqr.io/v2/generate', {...data, addInfo})
              .then((response:any)=> {      
                if(response.data.code == '00')  resolve({vcode:0, msg:response.data.desc, data: response.data.data.qrDataURL});
                else resolve({code:1, msg:response.data.desc, data: null});
              })
              .catch((e:any)=> {                          
                reject(e.response.data);
              });
        //}     
      })
    }
  
    
    
    
    /**
  * @example:
  * let data = {   
      date: new Date(),        
      payment_type: 5, //1 lưu (khách đã thanh toán cho vnpay); 5 lưu tạm (khách chưa thanh toán vnpay), hệ thống sẽ tự động xóa những payment này hoặc trên giao diện hiện ra cho khách tự xóa
      payment: 990.000,
      tax: 0,
      total: 990.000      
    }
  * this.vhQueryDealer.createPayment(data)
          .then((payment)=>{
            console.log('createPayment', payment);
          },(error:any)=>{
            console.log('error', error);
          })
    * payment = {
          _id, 
          payment_code, 
          id_dealer, 
  
          date
          payment_type, 
          payment, 
          tax, 
          total          
      }      
    * @param payment : object 
    * @return  Promise => payment = {} / error
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    * @notice : hàm này chỉ dùng tạo những bill_type mà không có phát sinh bill_detail
    */
      public createPayment(data:any){    
      return new Promise((resolve, reject) => {
        data.payment_code = this.vhAlgorithm.createPaymentCode(data?.date);
        if(!this.vhMGDB_auth.getDealer()._id) reject('bạn chưa đăng nhập');
        data.id_dealer = this.vhMGDB_auth.getDealer()._id;          
        this.vhMGDB_rootdatabase.addDoc('payments', data)
            .then((payment)=>{
              resolve(payment);
            },(error:any)=>{
              reject(error);
            })         
      })
    }
    
    /**
     * @example:
     * this.vhQueryDealer.updatePayment('5fb6780ca2148e09806c5b01', {total:990000})
            .then((response)=>{
              console.log('updatePayment', response);
            }, error=>{
              console.log('error', error);
            })
      * @param id_payment 
      * @param value 
      * @return Promise => response = undefined / error
      */
      public updatePayment(id_payment:string, value:any){        
        return new Promise((resolve, reject) => {  
          this.vhMGDB_rootdatabase.updateDoc('payments', id_payment, value)
            .then((response)=>{
              resolve(response);       
            }, error=>{
              reject(error);  
            })     
        })
      }  
    
      /**
       * @example:
       * this.vhQueryDealer.deletePayment('5fb67fda87c0f21d484cbdf3')
            .then((response)=>{
              console.log('deletePayment', response);
            }, error=>{
              console.log(error, error);
            }) 
        * @param id_payment 
        * @return Promise => response = undefined / error
        */
      public deletePayment(id_payment:any){
        return new Promise((resolve, reject) => {
          let query = {id_payment:{$eq:id_payment}};
          this.vhMGDB_rootdatabase.getDocsByFields('payment_details', query, {}, {}, 0)
              .then((payment_details:any)=>{
                if(payment_details.length >0){
                  for(let i=0; i<payment_details.length; i++){
                    this.vhMGDB_rootdatabase.deleteDoc('payment_details', payment_details[i]._id);
                  }
                }            
              }, error=>{
                console.log(error, error);
              })
          this.vhMGDB_rootdatabase.deleteDoc('payments', id_payment)
              .then((response)=>{
                resolve(response);          
              }, error=>{
                console.log(error, error);
              })              
        })
      }
    
        /**
      * @example:
      * let time = new Date();
      * time.setDate(time.getDate()-7);
      * this.vhQueryDealer.getPayments({payment_type:{$eq:5}}, {},{},0)
            .then((payments)=>{
              console.log('getPayments', payments);
            })
      * @param query
      * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
      * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
      * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
      * @return — Array -> array = [{},{},...] 
      */
      public getPayments(query: any, projection?:object, sort?:object, limit?:number) {
        return new Promise((resolve, reject) => {       
          if(!this.vhMGDB_auth.getDealer()._id) reject('bạn chưa đăng nhập');
          query.id_dealer = {$eq:this.vhMGDB_auth.getDealer()._id} ;
          this.vhMGDB_rootdatabase.getDocsByFields('payments', query, {}, sort, limit)
              .then((bills)=>{
                resolve(bills);
              }, error=>{
                console.log(error, error);
              })       
        })
      } 
    
      /**
       * @example:
       * this.vhQueryDealer.getPayment('5fb67fda87c0f21d484cbdf3')
            .then((payment)=>{
              console.log('getPayment', payment);
            })
        *  @param id_payment 
        *  @return Promise => payment ={} or null / error
        */
      public getPayment(id_payment:any) {
        return new Promise((resolve, reject) => { 
          this.vhMGDB_rootdatabase.getDoc('payments', id_payment)
              .then((response:any) => {              
                  resolve(response);
                },
                (error:any) => {
                  reject(error);
                }) 
        })
      }   
      
      /**
       * @example:    
        let payment_detail_main = {      
          id_branch: 'AEUWSWZXA4iHv8BmCNz2', //khách chọn
          id_payment: '5D4XGdZ2q5XLnOUa0mMx', //payment._id     
          id_restriction: 'main_package_advanced', //package.id_restriction
          id_package: 'main_package_advanced_1month', //có được khi khách chọn gói để mua
          package_type: 1,  //gói chinh, gói tmđt hay gói facebook...                                                                                               
          day: 31, //package.day,                                                                                           
          tax: 0, package.tax,                               
          price: 99000, package.price,
          quantity: 1, //khách chọn                        
          payment_detail_type: 1, //1: gói gia hạng mới, 2: gói nâng cấp, 3: gói kéo dài thêm thời gian                           
        }
        this.vhQueryDealer.createPayment_Detail({})
            .then((payment_detail)=>{
              console.log('createPayment_Detail', payment_detail);
            },(error:any)=>{
              console.log('error', error);
            })
        payment_detail = {
            _id, 
            id_dealer,
            payment_type,
            activating,
            invalid,
            date,
          
            id_branch,
            id_payment,
            id_restriction,
            id_package,
            package_type,
            payment_type,
            payment_detail_type,        
            day,
            tax,
            price,
            quantity        
        }      
        * @param data 
        * @return  Promise => response = {} / error
        * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
        */ 
      public createPayment_Detail(data:any):any {      
        return new Promise((resolve, reject) => {
          if((data.id_payment != undefined) && (data.id_payment != null)){
            this.vhMGDB_rootdatabase.getDoc('payments', data.id_payment)
                .then((payment:any)=>{
                    let _data = data;     
                    _data.activating = false;  
                    _data.invalid = false;       
                    _data.date = payment.date;    
                    if(payment.id_dealer) _data.id_dealer = payment.id_dealer;  
                    if(typeof payment.payment_type == 'number') _data.payment_type = payment.payment_type;                                
                    
                    this.vhMGDB_rootdatabase.addDoc('payment_details', _data)
                        .then((payment_detail)=>{                      
                          resolve(payment_detail);
                        },(error:any)=>{
                          reject(error);
                        })   
                    
                },(error:any)=>{
                console.log('error', error);
                })
          }else{
            console.log('error', 'không tồn tại id_bill trong data');
          } 
                
        })
      }  
    
      /**
       * @example:
       * this.vhQueryDealer.updatePayment_Detail('5fb6780ca2148e09806c5b01', {name:'Khuyến mãi 12/12'})
              .then((response)=>{
                console.log('updatePayment_Detail', response);          
              },(error:any)=>{
                reject(error);
              }) 
        * @param id_payment_detail 
        * @param value 
        * @return Promise => response = undefined / error
        */
      public updatePayment_Detail(id_payment_detail:string, value:object){    
        return new Promise((resolve, reject) => {
          this.vhMGDB_rootdatabase.updateDoc('payment_details', id_payment_detail, value)
              .then((response)=>{
                resolve(response);
              },(error:any)=>{
                reject(error);
              })         
        })
      }
    
      /**
      * @example:
      * let time = new Date();
      * time.setDate(time.getDate()-7);
      * this.vhQueryDealer.getPayment_details({id_payment:{$eq:'5fb67fda87c0f21d484cbdf3'}}, {},{},0)
            .then((payment_details)=>{
              console.log('getPayment_details', payment_details);
            })
      * @param query
      * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
      * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
      * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
      * @return Promise Array => array = [{},{},...] / error 
      */
      public getPayment_details(query: any, projection?:object, sort?:object, limit?:number) {//sửa lại hàm này vì chỉ có 1 store thôi
        return new Promise((resolve, reject) => {         
          if(!this.vhMGDB_auth.getDealer()._id) reject('bạn chưa đăng nhập');
          query.id_dealer = {$eq:this.vhMGDB_auth.getDealer()._id} ;
          this.vhMGDB_rootdatabase.getDocsByFields('payment_details', query, {}, sort, limit)
              .then((payment_details)=>{
                resolve(payment_details);
              }, error=>{
                console.log(error, error);
              })       
        })
      }
    
      /**
       * @example:
       * this.vhQueryDealer.getPayment_detail('5fb67fda87c0f21d484cbdf3')
            .then((payment_detail)=>{
              console.log('getPayment_detail', payment_detail);
            })
        *  @param id_payment_detail 
        *  @return Promise => payment_detail ={} or null / error
        */
      public getPayment_detail(id_payment_detail:any) {
        return new Promise((resolve, reject) => { 
          this.vhMGDB_rootdatabase.getDoc('payment_details', id_payment_detail)
              .then((response:any) => {              
                  resolve(response);
                },
                (error:any) => {
                  reject(error);
                }) 
        })
      }
      
      /**
       * @example:
       * this.vhQueryDealer.deletePayment_Detail('5fb67fda87c0f21d484cbdf3')
            .then((response)=>{
              console.log('deletePayment_Detail', response);
            },(error:any)=>{
              reject(error);
            })
        * @param id_payment_detail 
        * @return Promise => Promise => response = undefined / error
        */
      public deletePayment_Detail(id_payment_detail:string){
        return new Promise((resolve, reject) => {
          this.vhMGDB_rootdatabase.deleteDoc('payment_details', id_payment_detail)
              .then((bool:any)=>{            
                resolve(bool);
              },(error:any)=>{
                reject(error);
              })          
        })
      }
    
      /**
       * @example:
       * this.vhQueryDealer.getPackage('5fb67fda87c0f21d484cbdf3')
            .then((package)=>{
              console.log('getPackage', package);
            })
        *  @param id_package 
        *  @return Promise => package ={} or null / error
        */
      public getPackage(id_package:any) {
        return new Promise((resolve, reject) => { 
          this.vhMGDB_rootdatabase.getDoc('packages', id_package)
              .then((response:any) => {              
                  resolve(response);
                },
                (error:any) => {
                  reject(error);
                }) 
        })
      }
  
      /**
     * @example:
     * this.vhQueryDealer.assignLicenseKEY_toStore('5fb6780ca2148e09806c5b01', '5fb67fda87c0f21d484cbdf3')
            .then((response)=>{
              console.log('assignLicenseKEY_toStore', response);
            }, error=>{
              console.log('error', error);
            })
      * @param id_store 
      * @param id_licenseKEY 
      * @return Promise => response = undefined / error
      */
      public assignLicenseKEY_toStore(id_store:string, id_licenseKEY:string){        
        return new Promise((resolve, reject) => {  
          this.vhMGDB_rootdatabase.getDoc('licenseKEYs', id_licenseKEY)
              .then((licenseKEY:any) => {
                if(licenseKEY){
                  if(licenseKEY?.id_dealer != this.vhMGDB_auth.getDealer()._id) return reject({error:`${id_licenseKEY} không thuộc Đại lý`});  
                  this.vhMGDB_rootdatabase.updateDoc('licenseKEYs', id_licenseKEY, {id_store})
                      .then((response)=>{
                        resolve(response);       
                      }, error=>{
                        reject(error);  
                      })    
                }else reject({error:`${id_licenseKEY} không tìm thấy licenseKEY`});                  
              },
              (error:any) => {
                reject(error);
              }) 
          
        })
      }

      /**
      * @example:
      * let time = new Date();
      * time.setDate(time.getDate()-7);
      * this.vhQueryDealer.getLicenseKEYs({payment_type:{$eq:5}}, {},{},0)
            .then((payments)=>{
              console.log('getLicenseKEYs', payments);
            })
      * @param query
      * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
      * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
      * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
      * @return — Array -> array = [{},{},...] 
      */
      public getLicenseKEYs(query: any, projection?:object, sort?:object, limit?:number) {//sửa lại hàm này vì chỉ có 1 store thôi
        return new Promise((resolve, reject) => {       
          if(!this.vhMGDB_auth.getDealer()._id) reject('bạn chưa đăng nhập');
          query.id_dealer = {$eq:this.vhMGDB_auth.getDealer()._id} ;
          this.vhMGDB_rootdatabase.getDocsByFields('licenseKEYs', query, {}, sort, limit)
              .then((bills)=>{
                resolve(bills);
              }, error=>{
                console.log(error, error);
              })       
        })
      } 
    
  
      
      /**
      * Lấy về thông tin Đại lý từ mã đại lý (dealerCode)
      * @example:
      * this.vhQueryDealer.getDealer_byDealerCode()
              .then((dealer)=>{
                if(dealer){
                  console.log('getDealer_byDealerCode', dealer);
                }             
              }, error=>{
                console.log(error);
              })
      * @param dealerCode 
      * @returns object or null
      */
      public getDealer_byDealerCode(dealerCode:any){
        return new Promise((resolve, reject) => {
          if((dealerCode == '')||(dealerCode == null)||(dealerCode == undefined)) return resolve(null);    
          this.vhMGDB_database.getDocsByFields_onRootCollectionsFirebase('dealers', {dealerCode:{$eq:dealerCode}})
          //this.vhMGDB_rootdatabase.getDocsByFields('dealers', {dealerCode:{$eq:dealerCode}}, {})
              .then((dealers:any)=>{
                if(dealers.length) resolve(dealers[0]);
                else resolve(null);            
              }, error=>{
                reject(error)
              }) 
        })
      }
  
      /**
      * @example:
      * this.vhQueryDealer.getStoresAPP_byTime(starttime, endtime, '5fb67fda87c0f21d484cbdf3')
          .then((stores)=>{
            console.log('getStoresAPP_byTime', stores);
          })
      * Lấy về tất cả các Shop đăng ký dùng APP thuộc quản lý của Đại lý (IDdealer)
      * @param starttime 
      * @param endtime 
      * @param IDdealer 
      * @returns Promise => Array -> array = [{},{},...]
      */
    public getStoresAPP_byTime(starttime:any, endtime:any, IDdealer:any){
      return new Promise((resolve, reject) => {                 
        if(!this.vhMGDB_auth.getDealer()._id) reject('bạn chưa đăng nhập');
        let query:any = {registrationdate: {$gte:starttime, $lte:endtime}};   
        query.id_dealer = {$eq:this.vhMGDB_auth.getDealer()._id} ;
        this.vhMGDB_database.getDocsByFields_onRootCollectionsFirebase('stores', query, {}, {}, 0)
            .then((stores:any)=>{
              let _stores = new Array();
              for(let i=0; i<stores.length; i++){
                _stores[i] = {};
                _stores[i]._id = stores[i]._id; 
                _stores[i].email = stores[i].email;
                _stores[i].address = stores[i].address;
                _stores[i].company = stores[i].company;
                _stores[i].countrycode = stores[i].countrycode;
                _stores[i].registrationdate = stores[i].registrationdate;
                _stores[i].name = stores[i].name;
                _stores[i].phone = stores[i].phone;
                _stores[i].id_dealer = stores[i].id_dealer;
                _stores[i].status_store = stores[i].status_store;       
                _stores[i].id_salesman = stores[i].id_salesman;
                _stores[i].id_carestaff = stores[i].id_carestaff;      
                
                let id_branchs:any  = this.findRootFields(stores[i]);
                for(let j=0; j<id_branchs.length; j++){
                  _stores[i][id_branchs[j]] =  stores[i][id_branchs[j]]
                }
              }         
              resolve(_stores);         
            }, error=>{
              reject(error)
            }) 
      })
      }
    /**
     * lấy danh sách các id_branchs của các chi nhánh trong store
     * @param obj 
     * @returns 
     */
    private findRootFields(obj:any) {
      const targets = ["expire_date", "id_restriction", "id_package"];
      const results = [];

      for (const rootKey of Object.keys(obj)) {
        const rootObj = obj[rootKey];

        if (typeof rootObj !== "object" || rootObj === null) continue;

        const found = new Set();

        function traverse(o:any) {
          if (typeof o !== "object" || o === null) return;

          for (const key of Object.keys(o)) {
            if (targets.includes(key)) {
              found.add(key);
            }

            if (typeof o[key] === "object") {
              traverse(o[key]);
            }
          }
        }

        traverse(rootObj);

        if (targets.every(t => found.has(t))) {
          results.push(rootKey);
        }
      }

      return results;
    }

    /**
     * @example:
     * this.vhQueryDealer.getBranchs_byIDstore('5fb67fda87c0f21d484cbdf3')
          .then((branchs)=>{
            console.log('getBranchs_byIDstore', branchs);
          })
      *  @param id_store 
      *  @return Promise => Array -> array = [{},{},...]
      */
      public getBranchs_byIDstore(id_store:any) {
        return new Promise((resolve, reject) => { 
          this.vhMGDB_database.getDocs_byDatabase('branchs', id_store)
              .then((branchs:any)=>{
                resolve(branchs);
              },(error:any) => {
                reject(error);
              })
        })
      } 
      
/**
  * @example:
  * this.vhQueryDealer.extendLicenseValidaty_byLicenseKEY('3I1oQhMvkeySdtCSmsy5', '5fb6780ca2148e09806c5b01', '674fd94a9ace7267deb685fd')
        .then((response)=>{
          console.log('extendLicenseValidaty_byLicenseKEY', response);
        }, error=>{
          console.log('error', error);
        })
  * @param id_store:string
  * @param id_branch 
  * @param id_licenseKEY 
  * @return Promise => response = {vcode, msg}
  * vcode = 0: gia hạn thành công
  * vcode = 1: id_licenseKEY không thuộc về Store
  * vcode = 2: id_licenseKEY đã được kích hoạt trước đây
  * vcode = 3: id_licenseKEY đã bị vô hiệu hóa trước đây
  * vcode = 4: id_licenseKEY không kích hoạt được do khác loại gói đang dùng
  */
  public extendLicenseValidaty_byLicenseKEY(id_store:string, id_branch:string, id_licenseKEY:string){       
    return new Promise((resolve, reject) => {       
      this.vhMGDB_rootdatabase.getDoc('licenseKEYs', id_licenseKEY)
          .then((licenseKEY:any) => {   
              if(licenseKEY){
                if(licenseKEY?.id_dealer != this.vhMGDB_auth.getDealer()._id) return reject({error:`${id_licenseKEY} không thuộc Đại lý`});  
                this.vhMGDB_auth.extendLicenseValidaty_byLicenseKEY_byDealer(id_store, id_branch, id_licenseKEY)
                    .then((rsp)=>{
                      resolve(rsp);             
                    }, error=>{                      
                      reject(error);
                    })
              }else reject({error:`${id_licenseKEY} không tìm thấy licenseKEY`});                          
            },
            (error:any) => {
              reject(error);
            }) 
        
    })
  } 
 }
 
 @Injectable()
 export class VhQuerySCclient{
   private cloudcams: any = new Array();
   private mainboards: any = new Array();
   private functions: any = new Array();
   private components: any = new Array();
   private icons: any = new Array();
   private zones: any = new Array();
 
   private appsettingstations: any = new Array();  
   private scripts: any = new Array();
   private script_details: any = new Array();
   private logs: any = new Array();
   private hwinfo: any = {};
   constructor(
     private vhMGDB_auth: VhMGDB_auth, 
     private vhMGDB_database: VhMGDB_database, 
     private vhMGDB_f3rdclouds: VhMGDB_f3rdclouds, 
     
     private vhQuery:VhQuery, 
     private vhAuth: VhAuth, 
     private vhAlgorithm:VhAlgorithm) {
     Device.getId().then((info:any)=>{
       let local_hwinfo = this.vhAuth.localStorageGET('hwinfo');
       if((local_hwinfo != null)&&(local_hwinfo != undefined)){
         this.hwinfo = local_hwinfo;       
       }else{
          this.hwinfo = {uuid: info.identifier};     
          this.vhAuth.localStorageSET('hwinfo',this.hwinfo);        
       }           
     }); 
   } 
 
   public startLocalStorage(){
     return new Promise<any>((resolve) => {
       this.getEUtokenfromDatabase()
           .then(()=>{
             let promise = new Array();       
             promise[0] = this.vhAuth.refreshLocalMyPermission();       
             promise[1] = this.refreshLocalComponents();
             promise[2] = this.refreshLocalFunctions();
             promise[3] = this.refreshLocalIcons();  
             promise[4] = this.refreshLocalMainboards();  
             promise[5] = this.refreshLocalZones(); 
             promise[6] = this.refreshLocalCloudCams();         
             Promise.all(promise).then(()=>{resolve(null)});        
           })      
     })
   }
 
   private getEUtokenfromDatabase(){
     return new Promise<any>((resolve, reject) => {     
       this.vhMGDB_f3rdclouds.getEUtokenfromDatabase().then(()=>{resolve(null)})
     })
   }
 
   /**
    * 
    * @param licensecam 
    * @param camplaybackURL 
    * @param starttime 
    * @param endtime 
    * @return Promise => array(string) = [,,..]
    */
    public getPlaybackListCamByEndUser(licensecam:string, camplaybackURL:string, starttime:any, endtime:any){
     return new Promise((resolve, reject) => {
       this.vhMGDB_f3rdclouds.getPlaybackListCambyEndUser(licensecam, camplaybackURL, starttime, endtime)
         .then((playbacklist:any)=>{
           if(playbacklist.vcode === 0){           
             resolve(playbacklist.data);                             
           }else{
             //console.log(playbacklist);
             resolve([]);                  
           }    
         },(error:any)=>{         
           reject(error);
         }) 
     })       
   }
 
   /**
    * @example: 
    * let cloudcam = this.vhQuerySecurityCam.getlocalCloudCam('5fb6780ca2148e09806c5b01');
    * @param licensecam 
    * @return Object => obj = {} or null
    */
    public getlocalCloudCam(licensecam:any){
     for(let i=0; i<this.cloudcams.length; i++){
       if(this.cloudcams[i].licensecam === licensecam){
         return {...this.cloudcams[i]};        
       }
     } 
     return null; 
   }
      
 
   /**
    * @example: 
    * let cloudcams = this.vhQuerySecurityCam.getlocalCloudCams();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalCloudCams(){    
     return [...this.cloudcams];
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalCloudCams()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalCloudCam(), getlocalCloudCams() trong localstorage
    * @return Promise => null
    */
   public refreshLocalCloudCams():any{
     return new Promise((resolve) => { 
       this.getCloudCams()
           .then(()=>{resolve(null)})       
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.changeCloudCamEnableDetector('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableDetector', bool);
           })
    * @param licensecam 
    * @param detector_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableDetector(licensecam:string, detector_enable:boolean){   
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableDetectorByEndUser(licensecam, detector_enable)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){       
                   for(let i=0; i<this.cloudcams.length; i++){
                     if(this.cloudcams[i].licensecam === licensecam){
                       this.cloudcams[i].detector_enable = detector_enable;
                       break;        
                     }
                   }            
                   resolve(true);                            
                 }else{
                   ////console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })     
     }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.changeCloudCamEnableRecord('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableRecord', bool);
           })
     * @param licensecam 
     * @param record_enable 
     * @return Promise => bool = true or false 
     */
     public changeCloudCamEnableRecord(licensecam:string, record_enable:boolean){     
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableRecordByEndUser(licensecam, record_enable)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){           
                   for(let i=0; i<this.cloudcams.length; i++){
                     if(this.cloudcams[i].licensecam === licensecam){
                       this.cloudcams[i].record_enable = record_enable;
                       break;        
                     }
                   }         
                   resolve(true);                            
                 }else{
                   ////console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })                 
     }
 
     /**
    * @example:
    * this.vhQuerySecurityCam.changeCloudCamEnableActive('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableActive', bool);
           })
     * @param licensecam 
     * @param active 
     * @return Promise => bool = true or false 
     */
     public changeCloudCamEnableActive(licensecam:string, active:boolean){     
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableActiveByEndUser(licensecam, active)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){           
                   for(let i=0; i<this.cloudcams.length; i++){
                     if(this.cloudcams[i].licensecam === licensecam){
                       this.cloudcams[i].active = active;
                       break;        
                     }
                   }          
                   resolve(true);                            
                 }else{
                   ////console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })                 
     }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.changeCloudCamURL('5fb6780ca2148e09806c5b01', 'udp', 'rtsp://freja.hiof.no:1935/rtplive/definst/hessdalen03.stream')
           .then((bool:any)=>{
             console.log('changeCloudCamURL', bool);
           })
     * @param licensecam 
     * @param url 
     * @return Promise => bool = true or false 
     */
   public changeCloudCamURL(licensecam:string, url:string){  
     return new Promise((resolve) => {
       this.vhMGDB_f3rdclouds.changeCloudCamURLbyEndUser(licensecam, url)
             .then((cloudcam:any)=>{
               if(cloudcam.vcode === 0){  
                 for(let i=0; i<this.cloudcams.length; i++){
                   if(this.cloudcams[i].licensecam === licensecam){
                     this.cloudcams[i].url = url;
                     break;        
                   }
                 }                   
                 resolve(true);                            
               }else{
                 ////console.log(cloudcam.message);
                 resolve(false);                    
               }                    
             })          
     })    
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteCloudCam('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteCloudCam', bool);
         })
    * @param licensecam 
    * @return Promise => bool = true or false 
    */
     public deleteCloudCam(licensecam:string){
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.deleteCloudCamByEndUser(licensecam)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){  
                   for(let i=0; i<this.cloudcams.length; i++){
                     if(this.cloudcams[i].licensecam === licensecam){
                       this.cloudcams.splice(i,1);
                       break;        
                     }
                   }                                  
                   resolve(true);                            
                 }else{
                   ////console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })
     }
 
     /**
    * @example:
    * this.vhQuerySecurityCam.updateCloudCam('5fb6780ca2148e09806c5b01', {name:'camera 3'})
           .then((bool:any)=>{
             console.log('updateCloudCam', bool);
           })
    * @param licensecam 
    * @param data 
    * @return Promise => bool = true or false 
    */
     public updateCloudCam(licensecam:string, data:any){       
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.updateCloudCamDataByEndUser(licensecam, data)
               .then((cloudcam:any)=>{                  
                 if(cloudcam.vcode === 0){                   
                   for(let i=0; i<this.cloudcams.length; i++){
                     if(this.cloudcams[i].licensecam === licensecam){
                       for(const p in data){
                         this.cloudcams[i].data[p] = data[p];
                       } 
                     }
                   } 
                   resolve(true);                            
                 }else{
                   ////console.log(cloudcam.message);
                   resolve(false);                    
                 }                      
               })     
       })                
     }
 
     /**
    * @example:
    * this.vhQuerySecurityCam.addCloudCam('rtsp://freja.hiof.no:1935/rtplive/definst/hessdalen03.stream', 'udp', {name:camera 3})
           .then((cloudcam:any)=>{
             console.log('addCloudCam', cloudcam);
           })
    * @param url       
    * @param data 
    * @return Promise => {} or null 
    */
     public addCloudCam(url:string,data:object){          
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.addCloudCamByEndUser(url, data)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){          
                   this.cloudcams.push(cloudcam.data);        
                   resolve(cloudcam.data);                            
                 }else{
                   ////console.log(cloudcam.message);
                   resolve(null);                    
                 }                        
               })     
 
       })           
     }
 
   public getCloudCams(){
     return new Promise((resolve, reject) => {      
       let query = {id_enduser:{$eq:this.vhMGDB_auth.getUID()}}
       this.vhMGDB_f3rdclouds.getCloudCamsByDataFieldsByEndUser(query, {}, {}, 0)
             .then((cloudcams)=>{
               this.cloudcams = new Array();       
               if(cloudcams.vcode === 0){
                 this.cloudcams = cloudcams.data;                              
               }else{
                 //console.log(cloudcams);                            
               }
               resolve(this.cloudcams);                          
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   /**
    * @example: 
    * let wallet = this.vhQuerySCclient.getlocalFunction('5fb6780ca2148e09806c5b01');
    * @param id_function 
    * @return Object => obj = {} or null
    */
    public getlocalFunction(id_function:any){
     for(let i=0; i<this.functions.length; i++){
       if(this.functions[i]._id === id_function){
         return this.functions[i];        
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQuerySCclient.getlocalFunctions();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalFunctions(){    
     return this.functions;
   }
   
    /**
    * @example:
    * this.vhQuerySCclient.refreshLocalFunctions()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalFunction(), getlocalFunctions() trong localstorage
    * @return Promise => null
    */
   public refreshLocalFunctions():any{
     return new Promise((resolve) => { 
       this.getFunctions()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySCclient.addFunction({name:'camera 2', quantity:20, price:200000})
           .then((func)=>{
             console.log('addFunction', func);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addFunction(data:object){
     return new Promise((resolve, reject) => {
       let _data:any = {...data}; _data.id_enduser = this.vhAuth.getUID();
       this.vhMGDB_database.addDoc('functions', _data)
           .then((func)=>{
             this.functions.push(func);
             resolve(func);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySCclient.updateFunction('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateFunction', bool);
           })
    * @param id_function 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateFunction(id_function:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('functions', id_function, data)
           .then((bool:any)=>{
             for(let i=0; i<this.functions.length; i++){
               if(this.functions[i]._id === id_function){
                 this.functions[i] = {...this.functions[i], data};
                 break;
               }
             }
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })   
   }
 
   /**
    * @example:
    * this.vhQuerySCclient.deleteFunction('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteFunction', bool);
         })
    * @param id_function 
    * @return Promise => bool = true or false 
    */
   public deleteFunction(id_function:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('functions', id_function)
           .then((bool:any)=>{            
             for(let i=0; this.functions.length; i++){ 
               if(this.functions[i]._id === id_function){
                 this.functions.splice(i,1);
                 break;
               }
             }
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
 
   /**
    * @example
    * this.vhQuerySCclient.getFunctions()
             .then((functions)=>{
               console.log('getFunctions', functions);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getFunctions(){
     return new Promise((resolve, reject) => {      
       let id_enduser = this.vhAuth.getUID();
       this.vhMGDB_database.getDocsByFields('functions',{id_enduser:{$eq:id_enduser}},{},{},0)
             .then((functions:any)=>{
               this.functions = [...functions];
               for(let i=0; i<this.functions.length; i++)                
                 delete this.functions[i]?.id_enduser;            
               resolve(functions);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
 /**
  * @example
  * this.vhAuth.getFunctions_byFields({name:{$eq:'name abc'}}, {},{},0)
           .then((functions)=>{
             console.log('getFunctions_byFields', functions);
           })      
   * @param query 
   * @param projection : {}
   * @param sort : {}
   * @param limit : 0
   * @return Promise => array(object) = [{},{},..]
   */
   public getFunctions_byFields(query: any, projection: object, sort: any, limit: number){
     return new Promise((resolve, reject) => {  
       this.vhMGDB_database.getDocsByFields('functions', query,{},sort,limit)
           .then((functions)=>{              
             resolve(functions);
           },(error:any)=>{
             reject(error);
           })                    
     })
   }
   
   
   /**
    * @example: 
    * let wallet = this.vhQuerySCclient.getlocalComponent('5fb6780ca2148e09806c5b01');
    * @param id_component 
    * @return Object => obj = {} or null
    */
    public getlocalComponent(id_component:any){
     for(let i=0; i<this.components.length; i++){
       if(this.components[i]._id === id_component){
         return this.components[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQuerySCclient.getlocalComponents();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalComponents(){    
     return this.components;
   }
   
    /**
    * @example:
    * this.vhQuerySCclient.refreshLocalComponents()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalComponent(), getlocalComponents() trong localstorage
    * @return Promise => null
    */
   public refreshLocalComponents():any{
     return new Promise((resolve) => { 
       this.getComponents()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySCclient.addComponent({name:'camera 2', quantity:20, price:200000})
           .then((component)=>{
             console.log('addComponent', component);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addComponent(data:object){
     return new Promise((resolve, reject) => {
       let _data:any = {...data}; _data.id_enduser = this.vhAuth.getUID();
       this.vhMGDB_database.addDoc('components', _data)
           .then((component)=>{
             this.components.push(component);
             resolve(component);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySCclient.updateComponent('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateComponent', bool);
           })
    * @param id_component 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateComponent(id_component:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('components', id_component, data)
           .then((bool:any)=>{
             for(let i=0; i<this.components.length; i++){
               if(this.components[i]._id === id_component){
                 this.components[i] = {...this.components[i], ...data};
                 break;
               }
             }
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySCclient.deleteComponent('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteComponent', bool);
         })
    * @param id_component 
    * @return Promise => bool = true or false 
    */
   public deleteComponent(id_component:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('components', id_component)
           .then((bool:any)=>{      
             for(let i=0; this.components.length; i++){ 
               if(this.components[i]._id === id_component){
                 this.components.splice(i,1);
                 break;
               }
             }      
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySCclient.getComponents()
             .then((components)=>{
               console.log('getComponents', components);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getComponents(){
     return new Promise((resolve, reject) => {            
       let id_enduser = this.vhAuth.getUID();
       this.vhMGDB_database.getDocsByFields('components',{id_enduser:{$eq:id_enduser}},{},{},0)
             .then((components:any)=>{
               this.components = [...components];
               for(let i=0; i<this.components.length; i++)                
                 delete this.components[i]?.id_enduser;
               resolve(components);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
 /**
  * @example
  * this.vhAuth.getComponents_byFields({name:{$eq:'name abc'}}, {},{},0)
           .then((components)=>{
             console.log('getComponents_byFields', components);
           })      
   * @param query 
   * @param projection : {}
   * @param sort : {}
   * @param limit : 0
   * @return Promise => array(object) = [{},{},..]
   */
   public getComponents_byFields(query: any, projection: object, sort: any, limit: number){
     return new Promise((resolve, reject) => {  
       this.vhMGDB_database.getDocsByFields('components', query,{},sort,limit)
           .then((components)=>{              
             resolve(components);
           },(error:any)=>{
             reject(error);
           })                    
     })
   }
 
   
 
    /**
    * @example: 
    * let wallet = this.vhQuerySCclient.getlocalIcon('5fb6780ca2148e09806c5b01');
    * @param id_icon 
    * @return Object => obj = {} or null
    */
     public getlocalIcon(id_icon:any){
       for(let i=0; i<this.icons.length; i++){
         if(this.icons[i]._id === id_icon){
           return this.icons[i];
           break;
         }
       } 
       return null; 
     }
     /**
      * @example: 
      * let wallets = this.vhQuerySCclient.getlocalIcons();
      * @return Array(object) => array = [{},{},...]
      */
     public getlocalIcons(){    
       return this.icons;
     }
     
      /**
      * @example:
      * this.vhQuerySCclient.refreshLocalIcons()
             .then(()=>{
               do something.....
             })
      * Hàm này refresh giá trị mới nhất cho hàm getlocalIcon(), getlocalIcons() trong localstorage
      * @return Promise => null
      */
     public refreshLocalIcons():any{
       return new Promise((resolve) => { 
         this.getIcons()
             .then(()=>{resolve(null)})       
       })
     }
     /**
      * @example:
      * this.vhQuerySCclient.addIcon({name:'camera 2', quantity:20, price:200000})
             .then((icon)=>{
               console.log('addIcon', icon);
             },(error:any)=>{
               console.log('error', error);
             })
      * @param colname 
      * @param data 
      * @return  Promise => obj = {}
      * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
      */
     public addIcon(data:object){
       return new Promise((resolve, reject) => {
         let _data:any = {...data}; _data.id_enduser = this.vhAuth.getUID();
         this.vhMGDB_database.addDoc('icons', _data)
             .then((icon)=>{
               this.icons.push(icon);
               resolve(icon);
             },(error:any)=>{
               reject(error);
             })         
       })
     }
   
     /**
      * @example:
      * this.vhQuerySCclient.updateIcon('5fb6780ca2148e09806c5b01', {quantity:400})
             .then((bool:any)=>{
               console.log('updateIcon', bool);
             })
      * @param id_icon 
      * @param data 
      * @return Promise => bool = true or false 
      */
     public updateIcon(id_icon:string, data:object){
       return new Promise((resolve,reject) => {
         this.vhMGDB_database.updateDoc('icons', id_icon, data)
             .then((bool:any)=>{
               for(let i=0; i<this.icons.length; i++){
                 if(this.icons[i]._id === id_icon){
                   this.icons[i] = {...this.icons[i], ...data};
                   break;
                 }
               }
               resolve(bool);
             }, error=>{
               reject(error)
             })          
       })
     }
   
     /**
      * @example:
      * this.vhQuerySCclient.deleteIcon('5fb67fda87c0f21d484cbdf3')
           .then((bool:any)=>{
             console.log('deleteIcon', bool);
           })
      * @param id_icon 
      * @return Promise => bool = true or false 
      */
     public deleteIcon(id_icon:string){
       return new Promise((resolve, reject) => {
         this.vhMGDB_database.deleteDoc('icons', id_icon)
             .then((bool:any)=>{            
               for(let i=0; this.icons.length; i++){ 
                 if(this.icons[i]._id === id_icon){
                   this.icons.splice(i,1);
                   break;
                 }
               }
               resolve(bool);
             }, error=>{
               reject(error)
             })          
       })
     } 
 
   
     /**
      * @example
      * this.vhQuerySCclient.getIcons()
               .then((icons)=>{
                 console.log('getIcons', icons);
               })
      * @return Promise => array(object) = [{},{},..]
      */
     public getIcons(){
       return new Promise((resolve, reject) => {             
         let id_enduser = this.vhAuth.getUID();
         this.vhMGDB_database.getDocsByFields('icons',{id_enduser:{$eq:id_enduser}},{},{},0)
               .then((icons:any)=>{
                 this.icons = [...icons];
                 for(let i=0; i<this.icons.length; i++)                
                   delete this.icons[i]?.id_enduser;         
                 resolve(icons);
               },(error:any)=>{
                 reject(error);
               })          
       })
     }
 
 /**
  * @example
  * this.vhAuth.getIcons_byFields({name:{$eq:'name abc'}}, {},{},0)
           .then((icons)=>{
             console.log('getIcons_byFields', icons);
           })      
   * @param query 
   * @param projection : {}
   * @param sort : {}
   * @param limit : 0
   * @return Promise => array(object) = [{},{},..]
   */
   public getIcons_byFields(query: any, projection: object, sort: any, limit: number){
     return new Promise((resolve, reject) => {  
       this.vhMGDB_database.getDocsByFields('icons', query,{},sort,limit)
           .then((icons)=>{              
             resolve(icons);
           },(error:any)=>{
             reject(error);
           })                    
     })
   }
 
     
   /**
    * @example: 
    * let wallet = this.vhQuerySCclient.getlocalMainboard('5fb6780ca2148e09806c5b01');
    * @param id_mainboard 
    * @return Object => obj = {} or null
    */
   public getlocalMainboard(id_mainboard:any){
     for(let i=0; i<this.mainboards.length; i++){
       if(this.mainboards[i]._id === id_mainboard){
         return this.mainboards[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQuerySCclient.getlocalMainboards();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalMainboards(){    
     return this.mainboards;
   }
   
    /**
    * @example:
    * this.vhQuerySCclient.refreshLocalMainboards()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalMainboard(), getlocalMainboards() trong localstorage
    * @return Promise => null
    */
   public refreshLocalMainboards():any{
     return new Promise((resolve) => { 
       this.getMainboards()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySCclient.addMainboard({name:'camera 2', quantity:20, price:200000})
           .then((mainboard)=>{
             console.log('addMainboard', mainboard);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addMainboard(data:object){
     return new Promise((resolve, reject) => {      
       let _data:any = {...data}; _data.id_enduser = this.vhAuth.getUID();
       this.vhMGDB_database.addDoc('mainboards', _data)
           .then((mainboard)=>{
             this.icons.push(mainboard);
             resolve(mainboard);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySCclient.updateMainboard('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateMainboard', bool);
           })
    * @param id_mainboard 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateMainboard(id_mainboard:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('mainboards', id_mainboard, data)
           .then((bool:any)=>{
             for(let i=0; i<this.mainboards.length; i++){
               if(this.mainboards[i]._id === id_mainboard){
                 this.mainboards[i] = {...this.mainboards[i], ...data};
                 break;
               }
             }
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySCclient.deleteMainboard('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteMainboard', bool);
         })
    * @param id_mainboard 
    * @return Promise => bool = true or false 
    */
   public deleteMainboard(id_mainboard:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('mainboards', id_mainboard)
           .then((bool:any)=>{          
             for(let i=0; this.mainboards.length; i++){ 
               if(this.mainboards[i]._id === id_mainboard){
                 this.mainboards.splice(i,1);
                 break;
               }
             }  
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySCclient.getMainboard('5fb67fda87c0f21d484cbdf3')
             .then((mainboard)=>{
               console.log('getMainboard', mainboard);
             })
    * @param id_mainboard 
    * @return Promise => obj ={} or null
    */
   public getMainboard(id_mainboard:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('mainboards', id_mainboard)
             .then((mainboard)=>{
               resolve(mainboard);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySCclient.getMainboards()
             .then((mainboards)=>{
               console.log('getMainboards', mainboards);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getMainboards(){
     return new Promise((resolve, reject) => {      
       let id_enduser = this.vhAuth.getUID();
       this.vhMGDB_database.getDocsByFields('mainboards',{id_enduser:{$eq:id_enduser}},{},{},0)
             .then((mainboards:any)=>{
               this.mainboards = [...mainboards];
               for(let i=0; i<this.mainboards.length; i++)                
                 delete this.mainboards[i]?.id_enduser;        
             resolve(mainboards);
           },(error:any)=>{
             reject(error);
           })          
     })
   }
 
 /**
  * @example
  * this.vhQuerySCclient.getMainboards_byFields({name:{$eq:'name abc'}}, {},{},0)
           .then((mainboards)=>{
             console.log('getMainboards_byFields', mainboards);
           })      
   * @param query 
   * @param projection : {}
   * @param sort : {}
   * @param limit : 0
   * @return Promise => array(object) = [{},{},..]
   */
   public getMainboards_byFields(query: any, projection: object, sort: any, limit: number){
     return new Promise((resolve, reject) => {  
       this.vhMGDB_database.getDocsByFields('mainboards', query,{},sort,limit)
           .then((mainboards)=>{              
             resolve(mainboards);
           },(error:any)=>{
             reject(error);
           })                    
     })
   }
 
    /**
    * @example: 
    * let zone = this.vhQuerySCclient.getlocalZone('5fb6780ca2148e09806c5b01');
    * @param id_zone 
    * @return Object => obj = {} or null
    */
     public getlocalZone(id_zone:any){
       for(let i=0; i<this.zones.length; i++){
         if(this.zones[i]._id === id_zone){
           return this.zones[i];         
         }
       } 
       return null; 
     }
     /**
      * @example: 
      * let zones = this.vhQuerySCclient.getlocalZones();
      * @return Array(object) => array = [{},{},...]
      */
     public getlocalZones(){    
       return this.zones;
     }
     
      /**
      * @example:
      * this.vhQuerySCclient.refreshLocalZones()
             .then(()=>{
               do something.....
             })
      * Hàm này refresh giá trị mới nhất cho hàm getlocalZone(), getlocalZones() trong localstorage
      * @return Promise => null
      */
     public refreshLocalZones():any{
       return new Promise((resolve) => { 
         this.getZones()
             .then(()=>{resolve(null)})       
       })
     }
     /**
      * @example:
      * this.vhQuerySCclient.addZone({name:'camera 2', quantity:20, price:200000})
             .then((zone)=>{
               console.log('addZone', zone);
             },(error:any)=>{
               console.log('error', error);
             })
      * @param colname 
      * @param data 
      * @return  Promise => obj = {}
      * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
      */
     public addZone(data:object){
       return new Promise((resolve, reject) => {
         let _data:any = {...data}; _data.id_enduser = this.vhAuth.getUID();
         this.vhMGDB_database.addDoc('zones', _data)
             .then((zone)=>{
               this.zones.push(zone);
               resolve(zone);
             },(error:any)=>{
               reject(error);
             })         
       })
     }
   
     /**
      * @example:
      * this.vhQuerySCclient.updateZone('5fb6780ca2148e09806c5b01', {quantity:400})
             .then((bool:any)=>{
               console.log('updateZone', bool);
             })
      * @param id_zone 
      * @param data 
      * @return Promise => bool = true or false 
      */
     public updateZone(id_zone:string, data:object){
       return new Promise((resolve,reject) => {
         this.vhMGDB_database.updateDoc('zones', id_zone, data)
             .then((bool:any)=>{
               for(let i=0; i<this.zones.length; i++){
                 if(this.zones[i]._id === id_zone){
                   this.zones[i] = {...this.zones[i], ...data};
                   break;
                 }
               }
               resolve(bool);
             }, error=>{
               reject(error)
             })          
       })
     }
   
     /**
      * @example:
      * this.vhQuerySCclient.deleteZone('5fb67fda87c0f21d484cbdf3')
           .then((bool:any)=>{
             console.log('deleteZone', bool);
           })
      * @param id_zone 
      * @return Promise => bool = true or false 
      */
     public deleteZone(id_zone:string){
       return new Promise((resolve, reject) => {
         this.vhMGDB_database.deleteDoc('zones', id_zone)
             .then((bool:any)=>{            
               for(let i=0; this.zones.length; i++){ 
                 if(this.zones[i]._id === id_zone){
                   this.zones.splice(i,1);
                   break;
                 }
               }
               resolve(bool);
             }, error=>{
               reject(error)
             })          
       })
     } 
 
   
     /**
      * @example
      * this.vhQuerySCclient.getZones()
               .then((zones)=>{
                 console.log('getZones', zones);
               })
      * @return Promise => array(object) = [{},{},..]
      */
     public getZones(){
       return new Promise((resolve, reject) => {             
         let id_enduser = this.vhAuth.getUID();
         this.vhMGDB_database.getDocsByFields('zones',{id_enduser:{$eq:id_enduser}},{},{},0)
               .then((zones:any)=>{
                 this.zones = [...zones];
                 for(let i=0; i<this.zones.length; i++)                
                   delete this.zones[i]?.id_enduser;         
                 resolve(zones);
               },(error:any)=>{
                 reject(error);
               })          
       })
     }
 
 /**
  * @example
  * this.vhAuth.getZones_byFields({name:{$eq:'name abc'}}, {},{},0)
           .then((zones)=>{
             console.log('getZones_byFields', zones);
           })      
   * @param query 
   * @param projection : {}
   * @param sort : {}
   * @param limit : 0
   * @return Promise => array(object) = [{},{},..]
   */
   public getZones_byFields(query: any, projection: object, sort: any, limit: number){
     return new Promise((resolve, reject) => {  
       this.vhMGDB_database.getDocsByFields('zones', query,{},sort,limit)
           .then((zones)=>{              
             resolve(zones);
           },(error:any)=>{
             reject(error);
           })                    
     })
   }
 
 }

 /**
  * Người đăng ký vào hệ thống SecurityCam (securitycam database) để quản lý dịch vụ của mình được gọi là người dùng (user), khi đăng ký user được VhMGDB_clouds (vhclouds database) cấp cho một utoken,
  * utoken này có hạn sử dụng
  * Khách hàng sử dụng dịch vụ SecurityCam của người dùng user được gọi là người dùng cuối (enduser), khi thêm enduser vào hệ thống thì thông qua utoken sẽ cấp cho
  * người dùng cuối eutoken (để hệ thống biết được enduser nào thuộc user nào), eutoken này cũng có hạn sử dụng
  */
 @Injectable()
 export class VhQuerySecurityCam{  
   private cameras: any = new Array();
   //private cloudcams: any = new Array();
   private provinces: any = new Array();
   //private districts: any = new Array();
   //private wards: any = new Array();
   private rooms: any = new Array();
   private positions: any = new Array();
   private areas: any = new Array();
   //private pages: any = new Array();
   private mainboards: any = new Array();
   private functions: any = new Array();
   private components: any = new Array();
   private icons: any = new Array();
   private appsettingstations: any = new Array();  
   private scripts: any = new Array();
   private script_details: any = new Array();
   private logs: any = new Array();
   private hwinfo: any = {};
 
   private subjectcameras = new Subject<any>();
   private subjectappsettingstations = new Subject<any>();
   private subjectrooms = new Subject<any>();
   private subjectmainboards = new Subject<any>();
   private subjectfunctions = new Subject<any>();
   private subjecticons = new Subject<any>();
   private subjectpositions = new Subject<any>();
   private subjectareas = new Subject<any>();
   private subjectpages = new Subject<any>();
   private subjectcomponents = new Subject<any>();   
 
   constructor(
     private vhMGDB_auth: VhMGDB_auth, 
     private vhMGDB_database: VhMGDB_database, 
     private vhMGDB_socketMongoDB: VhMGDB_socketMongoDB, 
     private vhMGDB_f3rdclouds: VhMGDB_f3rdclouds, 
     
     private vhQuery:VhQuery, private vhAuth: VhAuth, private vhAlgorithm:VhAlgorithm) {
     Device.getId().then((info:any)=>{
       let local_hwinfo = this.vhAuth.localStorageGET('hwinfo');
       if((local_hwinfo != null)&&(local_hwinfo != undefined)){
         this.hwinfo = local_hwinfo;       
       }else{
        this.hwinfo = {uuid: info.identifier};    
         this.vhAuth.localStorageSET('hwinfo',this.hwinfo);        
       }           
     }); 
   } 
   
   syncCollections(){    
     return new Promise((resolve, reject)=>{      
       this.initSyncCollections();
       this.callbackCollectionInsert().subscribe();
       this.callbackCollectionUpdate().subscribe();
       this.callbackCollectionDelete().subscribe();
       this.getEUtokenfromDatabase();
       setTimeout(() => {
         resolve(true);
       }, 3000);
     })    
   }
   
 
   private initSyncCollections(){      
     let colname_array = new Array(); colname_array[8] = 'vhemployees'; colname_array[9] = 'appsettingstations';       
     return this.vhMGDB_socketMongoDB.initSyncCollections(colname_array,{},"");  
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.closeSyncCollections();
    * disconnect collections synchronization in the APP
    * @returns void
    */
   public closeSyncCollections(){
     // this.callbackcollections.unsubscribe();
     this.vhMGDB_socketMongoDB.closeSyncCollections();
   }
 
   /**
    * vhQuerySecurityCam
    * @returns 
    */
   private callbackCollectionInsert(){    
     return new Observable((observer:any) => {    
       this.vhMGDB_socketMongoDB.callbackCollectionInsert().subscribe((data:any)=>{  
         if(data.colname === 'vhemployees') data.colname = 'employees';
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
 
         if(data.colname === 'employees'){          
           let obj = {...data.data}; obj._id = data._id;
           this.vhAuth.insertlocalEmployeeFromSyncCollection(obj);         
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);                 
         }else if(data.colname === 'appsettingstations'){         
           if(!this.getLocalAppSettingStation(data._id)){         
             if(data.data.uuid === this.hwinfo.uuid){   
               let obj = {...data.data}; obj._id = data._id;
               delete obj.uuid;
               this.appsettingstations.push(obj);   
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);               
             }            
           }                               
         }
         //console.log('inserted', data.colname);
       })
     })
   }
 
   /**
    * vhQuerySecurityCam
    * @returns 
    */
   private callbackCollectionUpdate(){    
     return new Observable((observer:any) => {          
       this.vhMGDB_socketMongoDB.callbackCollectionUpdate().subscribe((data:any)=>{ 
         if(data.colname === 'vhemployees') data.colname = 'employees';
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
         if(data.colname === 'employees'){          
           this.vhAuth.updateLocalEmployeeFromSyncCollection(data._id, data.data);    
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);
         }else if(data.colname === 'appsettingstations'){
           for(let i=0; i<this.appsettingstations.length; i++){
             if(this.appsettingstations[i]._id === data._id){
               this.appsettingstations[i] = {...this.appsettingstations[i], ...data.data};   
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);               
               break;
             }
           }    
         }    
         //console.log('this.products', this.products);
         ////console.log('updated', data.colname);
       })
     })
   }
  
   /**
    * vhQuerySecurityCam
    * @returns 
    */
   private callbackCollectionDelete(){
     return new Observable((observer:any) => {    
       this.vhMGDB_socketMongoDB.callbackCollectionDelete().subscribe((data:any)=>{       
         if(data.colname === 'vhemployees') data.colname = 'employees';    
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
         if(data.colname === 'employees'){
           this.vhAuth.deleteLocalEmployeeFromSyncCollection(data._id);    
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);    
         }else if(data.colname === 'appsettingstations'){
           for(let i=0; i<this.appsettingstations.length; i++){
             if(this.appsettingstations[i]._id === data._id){
               this.appsettingstations.splice(i, 1); 
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);                
               break;
             }
           }   
         }
         //console.log('deleted', data.colname);           
       })
     })
   }
   
   /**
    * vhQuerySecurityCam
    * @returns 
    */
   public startLocalStorage(){    
     return new Promise<any>((resolve) => {
       let promise = new Array();  
       //promise[0] = this.vhAuth.refreshLocalEmployees();
       promise[0] = this.vhAuth.refreshLocalMyPermission();  
       //promise[2] = this.refreshLocalRooms();
       // promise[3] = this.refreshLocalCameras();     
       // promise[4] = this.refreshLocalComponents();
       // promise[5] = this.refreshLocalFunctions();
       // promise[6] = this.refreshLocalIcons();  
       // promise[7] = this.refreshLocalMainboards();     
       promise[1] = this.refreshLocalProvinces();  
               
       this.vhQuery.asyncPromiseAll(promise).then(()=>{resolve(null)});               
     })
   }
 
   /**
    * vhQuerySecurityCam
    */
   private publishObservableEventCameras() {
     this.subjectcameras.next(this.cameras);
   }  
 
   /**
    * vhQuerySecurityCam
    * @returns 
    */
   private observableLocalCameras():Subject<any> {      
     return this.subjectcameras; 
   }
   
  /**
    * @example:
    * this.observableCamera = this.vhQueryCloudCam.getObservableLocalCameras().subscribe((localCameras:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableCamera.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalCameras(){   
    return new Observable((observer:any) => {    
     this.observableLocalCameras().subscribe((cameras) => {   
       observer.next(cameras);
     })
     this.publishObservableEventCameras();
    })
   }        
 
   /**
    * @example: 
    * let wallet = this.vhQuerySecurityCam.getlocalCamera('5fb6780ca2148e09806c5b01');
    * @param id_camera 
    * @return Object => obj = {} or null
    */
   public getlocalCamera(id_camera:any){
     for(let i=0; i<this.cameras.length; i++){
       if(this.cameras[i]._id === id_camera){
         return this.cameras[i];
         break;
       }
     } 
     return null; 
   }
      
 
   /**
    * @example: 
    * let wallets = this.vhQuerySecurityCam.getlocalCameras();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalCameras(){    
     return this.cameras;
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalCameras()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalCamera(), getlocalCameras() trong localstorage
    * @return Promise => null
    */
   public refreshLocalCameras():any{
     return new Promise((resolve) => { 
       this.getCameras()
           .then(()=>{resolve(null)})       
     })
   }
  
   /**
    * @example:
    * this.vhQuerySecurityCam.addCamera({name:'camera 2', url:'rtsp://admin:admin@115.78.100.57:1020/av_stream/ch0', licensecam:'pTqOFsJEndPrg7AImFxV'})
           .then((camera)=>{
             console.log('addCamera', camera);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    * Trường hợp không thành công:
    * code = 0 : licensecam không đúng
    * code = 1 : licensecam đã và đang được sử dụng
    */
   public addCamera(data:any){
     //let _data = {...data};
     //if(_data.licensecam === undefined) _data.licensecam = _data.licensekey;
     //delete _data.licensekey;    
     return new Promise((resolve, reject) => {
       // this.vhMGDB_clouds.checkLicenseAddCam(data)
       //     .then((result:any)=>{            
       //       if((result.code === 4)||(result.code === 5)){
       //         let firstRegister = {...result};
       //         delete firstRegister.code;
       //         this.vhMGDB_database.addDoc('cameras', {...data, ...firstRegister})
       //             .then((camera)=>{
       //               resolve(camera);
       //             },(error:any)=>{
       //               console.error(error);
       //               reject({code:0});
       //             })    
       //       }else reject(result);            
       //     },(error:any)=>{
       //       console.error(error);
       //       reject({code:0});
       //     })            
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateCamera('5fb6780ca2148e09806c5b01', {name:camera 3})
           .then((bool:any)=>{
             console.log('updateCamera', bool);
           })
    * @param id_camera 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateCamera(id_camera:string, data:any){    
     return new Promise((resolve, reject) => {
       // this.vhMGDB_database.getDoc('cameras', id_camera)
       //     .then((camera:any)=>{            
       //       if(camera){
       //         let _data = {...data};
       //         _data.licensecam = camera.licensecam;
       //         this.vhMGDB_clouds.checkLicenseUpdateCam(_data)
       //             .then((result:any)=>{                                
       //               if(result.code === 3){        
       //                 this.vhMGDB_database.updateDoc('cameras', id_camera, _data)
       //                     .then((bool:any)=>{            
       //                       resolve(bool);
       //                     }, error=>{
       //                       reject(error)
       //                     })   
       //               }                   
       //             },(error:any)=>{
       //               reject(error);
       //             })      
       //       }
       //     }, error=>{
       //       reject(error)
       //     })               
     }) 
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteCamera('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteCamera', bool);
         })
    * @param id_camera 
    * @return Promise => bool = true or false 
    */
   public deleteCamera(id_camera:string){
     return new Promise((resolve, reject) => {
       // this.vhMGDB_database.getDoc('cameras', id_camera)
       //     .then((camera:any)=>{            
       //      if(camera){            
       //       this.vhMGDB_clouds.checkLicenseDeleteCam(camera.licensecam)
       //           .then((result:any)=>{                 
       //               this.vhMGDB_database.deleteDoc('cameras', id_camera)
       //                   .then((bool:any)=>{            
       //                     resolve(bool);
       //                   }, error=>{
       //                     reject(error)
       //                   })                     
       //           },(error:any)=>{
       //             reject(error);
       //           })        
       //      }
       //     }, error=>{
       //       reject(error)
       //     })                   
               
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getCamera('5fb67fda87c0f21d484cbdf3')
             .then((camera)=>{
               console.log('getCamera', camera);
             })
    * @param id_camera 
    * @return Promise => obj ={} or null
    */
   public getCamera(id_camera:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('cameras', id_camera)
             .then((camera)=>{
               resolve(camera);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getCameras()
             .then((cameras)=>{
               console.log('getCameras', cameras);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getCameras(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('cameras')
             .then((cameras)=>{
               this.cameras = new Array();
               this.cameras = cameras;
               resolve(cameras);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
   public getLocalEUtoken(){    
     return  this.vhMGDB_f3rdclouds.getLocalEUtoken();   
   }
 
   private getEUtokenfromDatabase(){
     return new Promise<any>((resolve, reject) => {     
       this.vhMGDB_f3rdclouds.getEUtokenfromDatabase().then(()=>{resolve(null)})
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.checkExpiredUtoken('89wt79w8qb987r9q08r7qv983457qhKAJJDCHXibuqw89r8q20398tyrg9qw3')
         .then((bool:any)=>{
           if(bool){
             do something....
           }
         })
    * @param utoken 
    * @returns Promise => true or false
    */
   public checkExpiredUtoken(){
     return new Promise<any>((resolve, reject) => {          
       this.vhMGDB_f3rdclouds.checkExpiredUtoken()
           .then((response)=>{
             if(response.vcode === 0){                  
               resolve(true);                            
             }else{
               //console.log(response.message);
               resolve(false);                    
             }            
       })  
     })
   }
 
   
   /**
    * @example:
    * this.vhQuerySecurityCam.changeCloudCamEnableCLPRbyEndUser('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableCLPRbyEndUser', bool);
           })
    * @param licensecam 
    * @param cLPR_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableCLPRbyEndUser(licensecam:string, cLPR_enable:boolean){    
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableCLPRbyEndUser(licensecam, cLPR_enable)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   ////console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })           
     }
 
    /**
    * @example:
    * this.vhQuerySecurityCam.changeCloudCamEnableRLPRbyEndUser('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableRLPRbyEndUser', bool);
           })
    * @param licensecam 
    * @param rLPR_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableRLPRbyEndUser(licensecam:string, rLPR_enable:boolean){    
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableRLPRbyEndUser(licensecam, rLPR_enable)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   ////console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })     
     }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.changeCloudCamEnableDetectorByEndUser('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableDetectorByEndUser', bool);
           })
    * @param licensecam 
    * @param detector_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableDetectorByEndUser(licensecam:string, detector_enable:boolean){   
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableDetectorByEndUser(licensecam, detector_enable)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   ////console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })     
     }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.changeCloudCamEnableRecordByEndUser('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableRecordByEndUser', bool);
           })
    * @param licensecam 
    * @param record_enable 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableRecordByEndUser(licensecam:string, record_enable:boolean){     
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableRecordByEndUser(licensecam, record_enable)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   ////console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })                 
     }
 
     /**
    * @example:
    * this.vhQuerySecurityCam.changeCloudCamEnableActiveByEndUser('5fb6780ca2148e09806c5b01', false)
           .then((bool:any)=>{
             console.log('changeCloudCamEnableActiveByEndUser', bool);
           })
    * @param licensecam 
    * @param active 
    * @return Promise => bool = true or false 
    */
     public changeCloudCamEnableActiveByEndUser(licensecam:string, active:boolean){     
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.changeCloudCamEnableActiveByEndUser(licensecam, active)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   ////console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })                 
     }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.changeCloudCamURLbyEndUser('5fb6780ca2148e09806c5b01', 'rtsp://freja.hiof.no:1935/rtplive/definst/hessdalen03.stream', 'udp')
           .then((bool:any)=>{
             console.log('changeCloudCamURLbyEndUser', bool);
           })
    * @param licensecam 
    * @param url 
    * @return Promise => bool = true or false 
    */
   public changeCloudCamURLbyEndUser(licensecam:string, url:string){  
     return new Promise((resolve) => {
       this.vhMGDB_f3rdclouds.changeCloudCamURLbyEndUser(licensecam, url)
             .then((cloudcam:any)=>{
               if(cloudcam.vcode === 0){                  
                 resolve(true);                            
               }else{
                 ////console.log(cloudcam.message);
                 resolve(false);                    
               }                    
             })          
     })    
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.addCloudCamByEndUser('rtsp://freja.hiof.no:1935/rtplive/definst/hessdalen03.stream', 'udp', {name:camera 3})
           .then((cloudcam:any)=>{
             console.log('addCloudCamByEndUser', cloudcam);
           })
    * @param url     
    * @param data 
    * @return Promise => {} or null 
    */
   public addCloudCamByEndUser(url:string, data:object){          
     return new Promise((resolve) => {
       this.vhMGDB_f3rdclouds.addCloudCamByEndUser(url, data)
             .then((cloudcam:any)=>{
               if(cloudcam.vcode === 0){                  
                 resolve(cloudcam.data);                            
               }else{
                 //console.log(cloudcam.message);
                 resolve(null);                    
               }                  
             })          
     })  
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateCloudCamDataByEndUser('5fb6780ca2148e09806c5b01', {name:'camera 3'})
           .then((bool:any)=>{
             console.log('updateCloudCamDataByEndUser', bool);
           })
    * @param licensecam 
    * @param data 
    * @return Promise => bool = true or false 
    */
     public updateCloudCamDataByEndUser(licensecam:string, data:object){       
         return new Promise((resolve) => {
           this.vhMGDB_f3rdclouds.updateCloudCamDataByEndUser(licensecam, data)
                 .then((cloudcam:any)=>{                  
                   if(cloudcam.vcode === 0){                                                
                     resolve(true);                            
                   }else{
                     //console.log(cloudcam.message);
                     resolve(false);                    
                   }                      
                 })          
         })                
     }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteCloudCamByEndUser('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteCloudCamByEndUser', bool);
         })
    * @param licensecam 
    * @return Promise => bool = true or false 
    */
     public deleteCloudCamByEndUser(licensecam:string){
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.deleteCloudCamByEndUser(licensecam)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(true);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(false);                    
                 }
                     
               })          
       })
     }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getCloudCamByEndUser('5fb67fda87c0f21d484cbdf3')
             .then((cloudcam:any)=>{
               console.log('getCloudCamByEndUser', cloudcam);
             })
    * @param licensecam:string 
    * @return Promise => obj ={} or null
    */
     public getCloudCamByEndUser(licensecam:string){
       return new Promise((resolve) => {
         this.vhMGDB_f3rdclouds.getCloudCamByEndUser(licensecam)
               .then((cloudcam:any)=>{
                 if(cloudcam.vcode === 0){                  
                   resolve(cloudcam.data);                            
                 }else{
                   //console.log(cloudcam.message);
                   resolve(null);                    
                 }
                    
               })          
       })
     }
 
    /**
    * @example:
    * this.vhQuerySecurityCam.getCloudCamsByDataFieldsByEndUser({id_enduser:{$gte:'ksdf984ur9weif928'}}, {},{},0)
         .then((response)=>{
           console.log('getCloudCamsByFieldsByEndUser', response);
         })
         .catch(()=>{
         })
   * @param colname 
   * @param query : {}
   * @param projection {} đang tìm hiểu
   * @param sort null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
   * @param limit null hoặc 0: không giới hạn record get về; 2: get về 2 record
   * @return Array -> array = [{},{},...]
   * @notice : trường hợp ko get đc data thì array.length = 0;
   */
   public getCloudCamsByDataFieldsByEndUser(query: any, projection?:object, sort?:any, limit?:number){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_f3rdclouds.getCloudCamsByDataFieldsByEndUser(query, projection, sort, limit)
             .then((cloudcams)=>{
               let _cloudcams = new Array();
               if(cloudcams.vcode === 0){
                 _cloudcams = [...cloudcams.data];                              
               }else{
                 //console.log(cloudcams);                               
               }
               resolve(_cloudcams);                          
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   /**
    * 
    * @param licensecam 
    * @param camplaybackURL 
    * @param starttime 
    * @param endtime 
    * @return Promise => array(string) = [,,..]
    */
   public getPlaybackListCamByEndUser(licensecam:string, camplaybackURL:string, starttime:any, endtime:any){
     return new Promise((resolve, reject) => {
       this.vhMGDB_f3rdclouds.getPlaybackListCambyEndUser(licensecam, camplaybackURL, starttime, endtime)
         .then((playbacklist:any)=>{
           if(playbacklist.vcode === 0){           
             resolve(playbacklist.data);                             
           }else{
             //console.log(playbacklist);
             resolve([]);                  
           }    
         },(error:any)=>{         
           reject(error);
         }) 
     })       
   }
 
   
   
   /**
    * @example: 
    * let province = this.vhQuerySecurityCam.getlocalProvince('5fb6780ca2148e09806c5b01');
    * @param id_province 
    * @return Object => obj = {} or null
    */
    public getlocalProvince(id_province:any){
     for(let i=0; i<this.provinces.length; i++){
       if(this.provinces[i]._id === id_province){      
         let _province = {...this.provinces[i]};
         if(_province.subs != undefined){
           let _subs = [..._province.subs];         
           _province.subs = new Array();
           _subs.forEach(sub => {_province.subs.push({...sub})});     
         }   
         return _province;
       }
     }
     return null; 
   }
   
   /**
    * @example: 
    * let provinces = this.vhQuerySecurityCam.getlocalProvinces();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalProvinces(){    
     return this.provinces;
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalProvinces()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalProvince(), getlocalProvinces() trong localstorage
    * @return Promise => null
    */
   public refreshLocalProvinces():any{
     return new Promise((resolve) => { 
       this.getProvinces()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySecurityCam.addProvince({name:'Thành phố Hồ Chí Minh'})
           .then((province)=>{
             console.log('addProvince', province);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addProvince(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('provinces', data)
           .then((province)=>{
             this.provinces.push(province);
             resolve(province);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateProvince('5fb6780ca2148e09806c5b01', {name:'Tỉnh Đồng Nai'})
           .then((bool:any)=>{
             console.log('updateProvince', bool);
           })
    * @param id_province 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateProvince(id_province:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('provinces', id_province, data)
           .then((bool:any)=>{
             for(let i=0; i<this.provinces.length; i++){
               if(this.provinces[i]._id === id_province){
                 this.provinces[i] = [...this.provinces[i], data];
                 break;
               }
             }
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteProvince('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteProvince', bool);
         })
    * @param id_province
    * @return Promise => bool = true or false 
    */
   public deleteProvince(id_province:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('provinces', id_province)
           .then((bool:any)=>{           
             for(let i=0; i<this.provinces.length; i++){
               if(this.provinces[i]._id === id_province){
                 this.provinces.splice(i,1);
                 break;
               }
             } 
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
 
   /**
    * @example
    * this.vhQuerySecurityCam.getProvinces()
             .then((provinces)=>{
               console.log('getProvinces', provinces);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   private getProvinces(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('provinces')
             .then((provinces)=>{
               this.provinces = new Array();
               this.provinces = provinces;
               resolve(provinces);
             },(error:any)=>{
               reject(error);
             })          
     })
   } 
 
     /**
    * @example:
    * this.vhQuerySecurityCam.addSubsProvince('5fb6780ca2148e09806c5b01',[{name:'Công An Quận Tân Bình', address: '', phoneone: '', phonetwo: '', duty: ''},{},...])
           .then((subs)=>{
             console.log('addSubsProvince', subs);
           }, error=>{
             console.log('error', error);
           })
     * @param id_province 
     * @param data 
     * @return Promise => object = {} hoặc null
     * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là null
     */
   public addSubsProvince(id_province:any, dataArray:any){
     return new Promise((resolve, reject) => {       
         let subs = new Array();
         for(let i=0; i<dataArray.length; i++){        
           subs[i] = {...dataArray[i], _id:this.vhAlgorithm.ObjectId()};   
         }      
         let bool = false;
         let province:any;
         let number = 0;        
         let setinterval = setInterval(() => {
             number++;
             province = this.getlocalProvince(id_province);
             if(province){
               bool = true;
               if(province.subs === undefined)  province.subs = new Array();                              
               let _subs = [...province.subs, ...subs];                         
               this.vhMGDB_database.updateDoc('provinces', id_province, {subs:_subs})
                   .then(()=>{    
                     for(let i=0; i<this.provinces.length; i++){
                       if(this.provinces[i]._id === id_province){
                         this.provinces[i].subs = _subs;
                         break;
                       }
                     }                 
                     resolve(subs);
                   }, ()=>{                       
                     resolve(null);
                   })               
             }       
             if((bool===true)||(number ===20)) clearInterval(setinterval);         
         }, 100);                      
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateSubProvince('5fb6780ca2148e', 'rtw554b5634573456', {name:'Công An Tỉnh Đồng Nai', address: '', phoneone: '', phonetwo: '', duty: ''})
           .then((bool:any)=>{
             console.log('updateSubProvince', bool);
           }, error=>{
             console.log('error', error);
           })
    * @param id_province 
    * @param data 
    * @return Promise => bool = true or false
    */
     public updateSubProvince(id_province:string, id_sub:string, data:any){    
       return new Promise((resolve, reject) => {
         let province:any = this.getlocalProvince(id_province);          
         if(province.subs != undefined){         
           for(let i=0; i<province.subs.length; i++){            
             if(province.subs[i]._id === id_sub){            
               for(const p in data){
                 province.subs[i][p] = data[p];
               }          
               let _subs = [...province.subs];   
               this.vhMGDB_database.updateDoc('provinces', id_province, {subs: _subs})
                   .then((bool:any)=>{
                     for(let j=0; j<this.provinces.length; j++){
                       if(this.provinces[j]._id === id_province){
                         this.provinces[j].subs = _subs;
                         break;
                       }
                     }   
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   })   
               break;
             }
           }   
         }                    
       })
     } 
 
     /**
    * @example:
    * this.vhQuerySecurityCam.deleteSubProvince('5fb67fda87c0f21d484cbdf3', 'jhit98q2rhfn9q38900913fr')
         .then((bool:any)=>{
           console.log('deleteSubProvince', bool);
         }, error=>{
           reject(error)
         })
    * @param id_province 
    * @param id_sub      
    * @return Promise => bool = true or false
    */
   public deleteSubProvince(id_province:string, id_sub:any){
     return new Promise((resolve, reject) => {    
         let province:any = this.getlocalProvince(id_province);            
         if(province.subs != undefined)
           for(let i=0; i<province.subs.length; i++){
             if(province.subs[i]._id === id_sub){
               province.subs.splice(i,1);                      
               this.vhMGDB_database.updateDoc('provinces', id_province, {subs: province.subs})
                   .then((bool:any)=>{
                     for(let m=0; m<this.provinces.length; m++){
                       for(let n=0; n<this.provinces[m].subs.length; n++){
                         if(this.provinces[m].subs[n]._id === id_sub){
                           this.provinces[m].subs.splice(n,1);
                           break;
                         }
                       }
                     }     
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   }) 
               break;
             }
           }                            
     })
   } 
   
   /**
    * @example:
    * this.vhQuerySecurityCam.addDistrict({name:'Quận Bình Thạnh', id_province: 'h982r9ur9hf8ur9q83'})
           .then((district)=>{
             console.log('addDistrict', district);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addDistrict(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('districts', data)
           .then((district)=>{
             resolve(district);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateDistrict('5fb6780ca2148e09806c5b01', {name:'Quận Bình Tân'})
           .then((bool:any)=>{
             console.log('updateDistrict', bool);
           })
    * @param id_district 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateDistrict(id_district:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('districts', id_district, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteDistrict('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteDistrict', bool);
         })
    * @param id_district
    * @return Promise => bool = true or false 
    */
   public deleteDistrict(id_district:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('districts', id_district)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
   
   /**
    * @example
    * this.vhQuerySecurityCam.getDistrict('5fb67fda87c0f21d484cbdf3')
             .then((district)=>{
               console.log('getDistrict', district);
             })
    * @param id_district
    * @return Promise => obj ={} or null
    */
   public getDistrict(id_district:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('districts', id_district)
             .then((district)=>{
               resolve(district);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getDistricts()
             .then((districts)=>{
               console.log('getDistricts', districts);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getDistricts(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('districts')
             .then((districts)=>{              
               resolve(districts);
             },(error:any)=>{
               reject(error);
             })          
     })
   } 
 
   /**
    * @example
    * this.vhQuerySecurityCam.getDistricts_byIDprovince('hjkhklf8f90we8')
             .then((districts)=>{
               console.log('getDistricts_byIDprovince', districts);
             })
    * @param id_province
    * @return Promise => array(object) = [{},{},..]
    */
     public getDistricts_byIDprovince(id_province:string){
       return new Promise((resolve, reject) => {  
         this.vhMGDB_database.getDocsByFields('districts', {id_province:{$eq:id_province}},{},{},0)
             .then((districts)=>{              
               resolve(districts);
             },(error:any)=>{
               reject(error);
             })                    
       })
     } 
 
     /**
    * @example:
    * this.vhQuerySecurityCam.addSubsDistrict('5fb6780ca2148e09806c5b01',[{name:'Công An Quận Tân Bình', address: '', phoneone: '', phonetwo: '', duty: ''},{},...])
           .then((subs)=>{
             console.log('addSubsDistrict', subs);
           }, error=>{
             console.log('error', error);
           })
     * @param data 
     * @return Promise => object = {} hoặc null
     * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là null
     */
   public addSubsDistrict(id_district:any, dataArray:any){
     return new Promise((resolve, reject) => {       
         let subs = new Array();
         for(let i=0; i<dataArray.length; i++){        
           subs[i] = {...dataArray[i], _id:this.vhAlgorithm.ObjectId()};   
         }             
         this.getDistrict(id_district) 
             .then((district:any)=>{
               if(district){
                   if(district.subs === undefined)  district.subs = new Array();                              
                   let _subs = [...district.subs, ...subs];                         
                   this.vhMGDB_database.updateDoc('districts', id_district, {subs:_subs})
                       .then(()=>{                     
                         resolve(subs);
                       }, ()=>{                               
                         resolve(null);
                       })   
                     }
               })                                     
     })
   } 
 
   /**
    * @example:
    * this.vhQueryCafe.updateSubDistrict('5fb6780ca2148e', 'rtw554b5634573456', {name:'Quận Tân Bình', address: '', phoneone: '', phonetwo: '', duty: ''})
           .then((bool:any)=>{
             console.log('updateSubDistrict', bool);
           }, error=>{
             console.log('error', error);
           })
    * @param id_district 
    * @param data 
    * @return Promise => bool = true or false
    */
   public updateSubDistrict(id_district:string, id_sub:string, data:any){    
     return new Promise((resolve, reject) => {
       this.getDistrict(id_district) 
           .then((district:any)=>{
             if(district){
               if(district.subs != undefined)               
                 for(let i=0; i<district.subs.length; i++){            
                   if(district.subs[i]._id === id_sub){              
                     district.subs[i] = {...district.subs[i],...data}; 
                     for(const p in data){
                       district.subs[i][p] = data[p];
                     }          
                     let _subs = [...district.subs];                
                     this.vhMGDB_database.updateDoc('districts', id_district, {subs: _subs})
                         .then((bool:any)=>{
                           resolve(bool);
                         }, error=>{
                           reject(error)
                         })   
                     break;
                   }
                 }   
             }                    
           })
     })
   }  
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteSubDistrict('5fb67fda87c0f21d484cbdf3', 'h7662ry8fy263y')
         .then((bool:any)=>{
           console.log('deleteSubDistrict', bool);
         }, error=>{
           reject(error)
         })
     * @param id_sub 
     * @return Promise => bool = true or false
     */
  
   public deleteSubDistrict(id_district:string, id_sub:any){
     return new Promise((resolve, reject) => {            
       this.getDistrict(id_district) 
           .then((district:any)=>{
             if(district){
               if(district.subs != undefined)
                 for(let i=0; i<district.subs.length; i++){
                   if(district.subs[i]._id === id_sub){
                     district.subs.splice(i,1);                      
                     this.vhMGDB_database.updateDoc('districts', district._id, {subs: district.subs})
                         .then((bool:any)=>{
                           resolve(bool);
                         }, error=>{
                           reject(error)
                         }) 
                     break;
                   }
                 }  
             }
           }, error=>{
             reject(error)
           })                                           
     })
   }  
   
   /**
    * @example:
    * this.vhQuerySecurityCam.addWard({name:'Phường 10', id_district: 'h982r9ur9hf8ur9q83'})
           .then((ward)=>{
             console.log('addWard', ward);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
     public addWard(data:object){
       return new Promise((resolve, reject) => {
         this.vhMGDB_database.addDoc('wards', data)
             .then((ward)=>{
               resolve(ward);
             },(error:any)=>{
               reject(error);
             })         
       })
     }
   
     /**
      * @example:
      * this.vhQuerySecurityCam.updateWard('5fb6780ca2148e09806c5b01', {name:'Quận Bình Tân'})
             .then((bool:any)=>{
               console.log('updateWard', bool);
             })
       * @param id_ward 
       * @param data 
       * @return Promise => bool = true or false 
       */
     public updateWard(id_ward:string, data:object){
       return new Promise((resolve,reject) => {
         this.vhMGDB_database.updateDoc('wards', id_ward, data)
             .then((bool:any)=>{
               resolve(bool);
             }, error=>{
               reject(error)
             })          
       })
     }
   
     /**
      * @example:
      * this.vhQuerySecurityCam.deleteWard('5fb67fda87c0f21d484cbdf3')
           .then((bool:any)=>{
             console.log('deleteWard', bool);
           })
       * @param id_ward
       * @return Promise => bool = true or false 
       */
     public deleteWard(id_ward:string){
       return new Promise((resolve, reject) => {
         this.vhMGDB_database.deleteDoc('wards', id_ward)
             .then((bool:any)=>{            
               resolve(bool);
             }, error=>{
               reject(error)
             })          
       })
     }
     
     /**
      * @example
      * this.vhQuerySecurityCam.getWard('5fb67fda87c0f21d484cbdf3')
               .then((ward)=>{
                 console.log('getWard', ward);
               })
       * @param id_ward
       * @return Promise => obj ={} or null
       */
     public getWard(id_ward:string){
       return new Promise((resolve) => {
         this.vhMGDB_database.getDoc('wards', id_ward)
               .then((ward)=>{
                 resolve(ward);
               })          
       })
     }
   
     /**
      * @example
      * this.vhQuerySecurityCam.getWards()
               .then((wards)=>{
                 console.log('getWards', wards);
               })
       * @return Promise => array(object) = [{},{},..]
       */
     public getWards(){
       return new Promise((resolve, reject) => {      
         this.vhMGDB_database.getDocs('wards')
               .then((wards)=>{               
                 resolve(wards);
               },(error:any)=>{
                 reject(error);
               })          
       })
     } 
 
     /**
    * @example
    * this.vhQuerySecurityCam.getWards_byIDdistrict('hjkhklf8f90we8')
             .then((wards)=>{
               console.log('getWards_byIDdistrict', wards);
             })
    * @param id_district
    * @return Promise => array(object) = [{},{},..]
    */
     public getWards_byIDdistrict(id_district:string){
       return new Promise((resolve, reject) => {  
         this.vhMGDB_database.getDocsByFields('wards', {id_district:{$eq:id_district}},{},{},0)
             .then((wards)=>{              
               resolve(wards);
             },(error:any)=>{
               reject(error);
             })                    
       })
     } 
   
       /**
      * @example:
      * this.vhQuerySecurityCam.addSubsWard('5fb6780ca2148e09806c5b01',[{name:'Phường 1', address: '', phoneone: '', phonetwo: '', duty: ''},{},...])
             .then((subs)=>{
               console.log('addSubsWard', subs);
             }, error=>{
               console.log('error', error);
             })
       * @param data 
       * @param id_ward
       * @return Promise => object = {} hoặc null
       * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là null
       */
     public addSubsWard(id_ward:any, dataArray:any){
       return new Promise((resolve, reject) => {       
           let subs = new Array();
           for(let i=0; i<dataArray.length; i++){        
             subs[i] = {...dataArray[i], _id:this.vhAlgorithm.ObjectId()};   
           }             
           this.getWard(id_ward) 
               .then((ward:any)=>{
                 if(ward){
                     if(ward.subs === undefined)  ward.subs = new Array();                              
                     let _subs = [...ward.subs, ...subs];                         
                     this.vhMGDB_database.updateDoc('wards', id_ward, {subs:_subs})
                         .then(()=>{                     
                           resolve(subs);
                         }, ()=>{                               
                           resolve(null);
                         })   
                       }
                 })                                     
       })
     } 
   
     /**
      * @example:
      * this.vhQuerySecurityCam.updateSubWard('5fb6780ca2148e', 'rtw554b5634573456', {name:'Phường 2', address: '', phoneone: '', phonetwo: '', duty: ''})
             .then((bool:any)=>{
               console.log('updateSubWard', bool);
             }, error=>{
               console.log('error', error);
             })
       * @param id_ward 
       * @param data 
       * @return Promise => bool = true or false
       */
     public updateSubWard(id_ward:string, id_sub:string, data:any){    
       return new Promise((resolve, reject) => {
         this.getWard(id_ward) 
             .then((ward:any)=>{
               if(ward){
                 if(ward.subs != undefined)               
                   for(let i=0; i<ward.subs.length; i++){            
                     if(ward.subs[i]._id === id_sub){                                   
                       for(const p in data){
                         ward.subs[i][p] = data[p];
                       }          
                       let _subs = [...ward.subs];               
                       this.vhMGDB_database.updateDoc('wards', id_ward, {subs: _subs})
                           .then((bool:any)=>{
                             resolve(bool);
                           }, error=>{
                             reject(error)
                           })   
                       break;
                     }
                   }   
               }                    
             })
       })
     }  
   
     /**
      * @example:
      * this.vhQuerySecurityCam.deleteSubWard('5fb67fda87c0f21d484cbdf3','342345u9t83th0u98')
           .then((bool:any)=>{
             console.log('deleteSubWard', bool);
           }, error=>{
             reject(error)
           })
       * @param id_ward 
       * @param id_sub     
       * @return Promise => bool = true or false
       */
     
     public deleteSubWard(id_ward:string, id_sub:any){
       return new Promise((resolve, reject) => {            
         this.getWard(id_ward) 
             .then((ward:any)=>{
               if(ward){
                 if(ward.subs != undefined)
                   for(let i=0; i<ward.subs.length; i++){
                     if(ward.subs[i]._id === id_sub){
                       ward.subs.splice(i,1);                      
                       this.vhMGDB_database.updateDoc('wards', id_ward, {subs: ward.subs})
                           .then((bool:any)=>{
                             resolve(bool);
                           }, error=>{
                             reject(error)
                           }) 
                       break;
                     }
                   }  
               }
             }, error=>{
               reject(error)
             })                                           
       })
     }  
 
   
   private publishObservableEventRooms() {
     this.subjectrooms.next(this.rooms);
   }  
 
   private observableLocalRooms():Subject<any> {      
     return this.subjectrooms; 
   }
   
  /**
    * @example:
    * this.observableRoom = this.vhQuerySecurityCam.getObservableLocalRooms().subscribe((localRooms:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableRoom.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalRooms(){   
    return new Observable((observer:any) => {    
     this.observableLocalRooms().subscribe((rooms) => {   
       observer.next(rooms);
     })
     this.publishObservableEventRooms();
    })
   }
 
 
 
   /**
    * @example: 
    * let room = this.vhQuerySecurityCam.getlocalRoom('5fb6780ca2148e09806c5b01');
    * @param id_room 
    * @return Object => obj = {} or null
    */
   public getlocalRoom(id_room:any){
     for(let i=0; i<this.rooms.length; i++){
       if(this.rooms[i]._id === id_room){
         return this.rooms[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let rooms = this.vhQuerySecurityCam.getlocalRooms();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalRooms(){    
     return this.rooms;
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalRooms()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalRoom(), getlocalRooms() trong localstorage
    * @return Promise => null
    */
   public refreshLocalRooms():any{
     return new Promise((resolve) => { 
       this.getRooms()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySecurityCam.addRoom({name:'camera 2', quantity:20, price:200000})
           .then((room)=>{
             console.log('addRoom', room);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addRoom(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('rooms', data)
           .then((room)=>{
             resolve(room);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateRoom('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateRoom', bool);
           })
    * @param id_room 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateRoom(id_room:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('rooms', id_room, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteRoom('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteRoom', bool);
         })
    * @param id_room 
    * @return Promise => bool = true or false 
    */
   public deleteRoom(id_room:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('rooms', id_room)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getRoom('5fb67fda87c0f21d484cbdf3')
             .then((room)=>{
               console.log('getRoom', room);
             })
    * @param id_room 
    * @return Promise => obj ={} or null
    */
   private getRoom(id_room:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('rooms', id_room)
             .then((room)=>{
               resolve(room);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getRooms()
             .then((rooms)=>{
               console.log('getRooms', rooms);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   private getRooms(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('rooms')
             .then((rooms)=>{
               this.rooms = new Array();
               this.rooms = rooms;
               resolve(rooms);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
 /**
  * @example:
  * this.vhQuerySecurityCam.addPage({name:'Đội BV 1 - Page 1'})
         .then((page)=>{
           console.log('addPage', page);
         },(error:any)=>{
           console.log('error', error);
         })
  * @param colname 
  * @param data 
  * @return  Promise => obj = {}
  * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
  */
 public addPage(data:object){
   return new Promise((resolve, reject) => {
     this.vhMGDB_database.addDoc('pages', data)
         .then((page)=>{
           resolve(page);
         },(error:any)=>{
           reject(error);
         })         
   })
 }
 
 /**
  * @example:
  * this.vhQuerySecurityCam.updatePage('5fb6780ca2148e09806c5b01', {quantity:400})
         .then((bool:any)=>{
           console.log('updatePage', bool);
         })
  * @param id_page 
  * @param data 
  * @return Promise => bool = true or false 
  */
 public updatePage(id_page:string, data:object){
   return new Promise((resolve,reject) => {
     this.vhMGDB_database.updateDoc('pages', id_page, data)
         .then((bool:any)=>{
           resolve(bool);
         }, error=>{
           reject(error)
         })          
   })
 }
 
 /**
  * @example:
  * this.vhQuerySecurityCam.deletePage('5fb67fda87c0f21d484cbdf3')
       .then((bool:any)=>{
         console.log('deletePage', bool);
       })
  * @param id_page 
  * @return Promise => bool = true or false 
  */
 public deletePage(id_page:string){
   return new Promise((resolve, reject) => {
     this.vhMGDB_database.deleteDoc('pages', id_page)
         .then((bool:any)=>{            
           resolve(bool);
         }, error=>{
           reject(error)
         })          
   })
 }
 
 /**
  * @example
  * this.vhQuerySecurityCam.getPage('5fb67fda87c0f21d484cbdf3')
           .then((page)=>{
             console.log('getPage', page);
           })
  * @param id_page 
  * @return Promise => obj ={} or null
  */
   public getPage(id_page:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('pages', id_page)
             .then((page)=>{
               resolve(page);
             })          
     })
   }
 
 /**
  * @example
  * this.vhQuerySecurityCam.getPages()
           .then((pages)=>{
             console.log('getPages', pages);
           })
  * @return Promise => array(object) = [{},{},..]
  */
   public getPages(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('pages')
             .then((pages)=>{            
               resolve(pages);
             },(error:any)=>{
               reject(error);
             })          
     })
   } 
 
   /**
  * @example
  * this.vhQuerySecurityCam.getPages_byIDdistrict('hjkhklf8f90we8')
           .then((pages)=>{
             console.log('getPages_byIDdistrict', pages);
           })
   * @param id_district
   * @return Promise => array(object) = [{},{},..]
   */
 public getPages_byIDdistrict(id_district:string){
   return new Promise((resolve, reject) => {  
     this.vhMGDB_database.getDocsByFields('pages', {id_district:{$eq:id_district}},{},{},0)
         .then((pages)=>{              
           resolve(pages);
         },(error:any)=>{
           reject(error);
         })                    
   })
 } 
 
   
 /**
  * @example
  * this.vhQuerySecurityCam.getPages_byIDemployee('hjkhklf8f90we8')
         .then((pages)=>{
           console.log('getPages_byIDemployee', pages);
         })
 * @param id_employee
 * @return Promise => array(object) = [{},{},..]
 */
 public getPages_byIDemployee(id_employee:string){  
   return new Promise((resolve, reject) => {  
     this.vhMGDB_database.getDocsByFields('pages', {id_employee:{$eq:id_employee}},{},{},0)
         .then((pages)=>{              
           resolve(pages);
         },(error:any)=>{
           reject(error);
         })                    
   })
 } 









 
 /**
  * @example:
  * this.vhQuerySecurityCam.addMonitoring({name:'Đội BV 1 - Page 1'})
         .then((monitoring)=>{
           console.log('addMonitoring', monitoring);
         },(error:any)=>{
           console.log('error', error);
         })
  * @param colname 
  * @param data 
  * @return  Promise => obj = {}
  * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
  */
  public addMonitoring(data:object){
  return new Promise((resolve, reject) => {
    this.vhMGDB_database.addDoc('monitorings', data)
        .then((monitoring)=>{
          resolve(monitoring);
        },(error:any)=>{
          reject(error);
        })         
  })
}

/**
 * @example:
 * this.vhQuerySecurityCam.updateMonitoring('5fb6780ca2148e09806c5b01', {quantity:400})
        .then((bool:any)=>{
          console.log('updateMonitoring', bool);
        })
  * @param id_monitoring 
  * @param data 
  * @return Promise => bool = true or false 
  */
public updateMonitoring(id_monitoring:string, data:object){
  return new Promise((resolve,reject) => {
    this.vhMGDB_database.updateDoc('monitorings', id_monitoring, data)
        .then((bool:any)=>{
          resolve(bool);
        }, error=>{
          reject(error)
        })          
  })
}

/**
  * @example:
  * this.vhQuerySecurityCam.deleteMonitoring('5fb67fda87c0f21d484cbdf3')
      .then((bool:any)=>{
        console.log('deleteMonitoring', bool);
      })
  * @param id_monitoring 
  * @return Promise => bool = true or false 
  */
public deleteMonitoring(id_monitoring:string){
  return new Promise((resolve, reject) => {
    this.vhMGDB_database.deleteDoc('monitorings', id_monitoring)
        .then((bool:any)=>{            
          resolve(bool);
        }, error=>{
          reject(error)
        })          
  })
}

/**
  * @example
  * this.vhQuerySecurityCam.getMonitoring('5fb67fda87c0f21d484cbdf3')
          .then((page)=>{
            console.log('getMonitoring', page);
          })
  * @param id_monitoring 
  * @return Promise => obj ={} or null
  */
  public getMonitoring(id_monitoring:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('monitorings', id_monitoring)
            .then((monitoring)=>{
              resolve(monitoring);
            })          
    })
  }

/**
  * @example
  * this.vhQuerySecurityCam.getMonitorings()
          .then((monitorings)=>{
            console.log('getMonitorings', monitorings);
          })
  * @return Promise => array(object) = [{},{},..]
  */
  public getMonitorings(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('monitorings')
            .then((monitorings)=>{            
              resolve(monitorings);
            },(error:any)=>{
              reject(error);
            })          
    })
  } 

  

 
 /**
  * @example:
  * this.vhQuerySecurityCam.addMonitoringTeam({name:'Đội BV 1 - Page 1'})
         .then((monitoring)=>{
           console.log('addMonitoringTeam', monitoring);
         },(error:any)=>{
           console.log('error', error);
         })
  * @param colname 
  * @param data 
  * @return  Promise => obj = {}
  * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
  */
  public addMonitoringTeam(data:object){
  return new Promise((resolve, reject) => {
    this.vhMGDB_database.addDoc('monitoring_teams', data)
        .then((monitoring_team)=>{
          resolve(monitoring_team);
        },(error:any)=>{
          reject(error);
        })         
  })
}

/**
  * Cập nhật lại các trường của một doc trong collection monitorings
  * @example:
  * this.vhQuerySecurityCam.updateMonitoringTeam('5fb6780ca2148e09806c5b01', {quantity:400})
    .then((bool:any)=>{
      console.log('updateMonitoringTeam', bool);
    })
  * @param id_monitoring_team 
  * @param data 
  * @return Promise => bool = true or false 
  */
public updateMonitoringTeam(id_monitoring_team:string, data:object){
  return new Promise((resolve,reject) => {
    this.vhMGDB_database.updateDoc('monitoring_teams', id_monitoring_team, data)
        .then((bool:any)=>{
          resolve(bool);
        }, error=>{
          reject(error)
        })          
  })
}

/**
  * @example:
  * this.vhQuerySecurityCam.deleteMonitoringTeam('5fb67fda87c0f21d484cbdf3')
      .then((bool:any)=>{
        console.log('deleteMonitoringTeam', bool);
      })
  * @param id_monitoring_team 
  * @return Promise => bool = true or false 
  */
public deleteMonitoringTeam(id_monitoring_team:string){
  return new Promise((resolve, reject) => {
    this.vhMGDB_database.deleteDoc('monitoring_teams', id_monitoring_team)
        .then((bool:any)=>{            
          resolve(bool);
        }, error=>{
          reject(error)
        })          
  })
}

/**
  * @example
  * this.vhQuerySecurityCam.getMonitoringTeam('5fb67fda87c0f21d484cbdf3')
          .then((page)=>{
            console.log('getMonitoringTeam', page);
          })
  * @param id_monitoring_team 
  * @return Promise => obj ={} or null
  */
  public getMonitoringTeam(id_monitoring_team:string){
    return new Promise((resolve) => {
      this.vhMGDB_database.getDoc('monitoring_teams', id_monitoring_team)
            .then((monitoring_team)=>{
              resolve(monitoring_team);
            })          
    })
  }

/**
  * @example
  * this.vhQuerySecurityCam.getMonitors()
          .then((monitoring_teams)=>{
            console.log('getMonitors', monitoring_teams);
          })
  * @return Promise => array(object) = [{},{},..]
  */
  public getMonitoringTeams(){
    return new Promise((resolve, reject) => {      
      this.vhMGDB_database.getDocs('monitoring_teams')
            .then((monitoring_teams)=>{            
              resolve(monitoring_teams);
            },(error:any)=>{
              reject(error);
            })          
    })
  } 
        
 
 private publishObservableEventAreas() {
   this.subjectareas.next(this.areas);
 }  
 
 private observableLocalAreas():Subject<any> {      
   return this.subjectareas; 
 }
 
 /**
  * @example:
  * this.observableArea = this.vhQueryCloudCam.getObservableLocalAreas().subscribe((localAreas:any) => {          
       do something... 
    })       
   
   ngOnDestroy(){
     this.observableArea.unsubscribe();    
   }
  * @returns Observerble (Array) => Array(object) => array = [{},{},...]
  */
 public getObservableLocalAreas(){   
  return new Observable((observer:any) => {    
   this.observableLocalAreas().subscribe((areas) => {   
     observer.next(areas);
   })
   this.publishObservableEventAreas();
  })
 }
 
   /**
    * @example: 
    * let area = this.vhQuerySecurityCam.getlocalArea('5fb6780ca2148e09806c5b01');
    * @param id_area 
    * @return Object => obj = {} or null
    */
    public getlocalArea(id_area:any){
     for(let i=0; i<this.areas.length; i++){
       if(this.areas[i]._id === id_area){
         return this.areas[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let areas = this.vhQuerySecurityCam.getlocalAreas();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalAreas(){    
     return this.areas;
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalAreas()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalArea(), getlocalAreas() trong localstorage
    * @return Promise => null
    */
   public refreshLocalAreas():any{
     return new Promise((resolve) => { 
       this.getAreas()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySecurityCam.addArea({name:'camera 2', quantity:20, price:200000})
           .then((area)=>{
             console.log('addArea', area);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addArea(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('areas', data)
           .then((area)=>{
             resolve(area);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateArea('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateArea', bool);
           })
    * @param id_area 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateArea(id_area:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('areas', id_area, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteArea('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteArea', bool);
         })
    * @param id_area 
    * @return Promise => bool = true or false 
    */
   public deleteArea(id_area:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('areas', id_area)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getArea('5fb67fda87c0f21d484cbdf3')
             .then((area)=>{
               console.log('getArea', area);
             })
    * @param id_area 
    * @return Promise => obj ={} or null
    */
   private getArea(id_area:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('areas', id_area)
             .then((area)=>{
               resolve(area);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getAreas()
             .then((areas)=>{
               console.log('getAreas', areas);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   private getAreas(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('areas')
             .then((areas)=>{
               this.areas = new Array();
               this.areas = areas;
               resolve(areas);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
 
   
   private publishObservableEventPositions() {
     this.subjectpositions.next(this.positions);
   }  
 
   private observableLocalPositions():Subject<any> {      
     return this.subjectpositions; 
   }
   
  /**
    * @example:
    * this.observablePosition = this.vhQueryCloudCam.getObservableLocalPositions().subscribe((localPositions:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observablePosition.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalPositions(){   
    return new Observable((observer:any) => {    
     this.observableLocalPositions().subscribe((positions) => {   
       observer.next(positions);
     })
     this.publishObservableEventPositions();
    })
   }
 
 
   /**
    * @example: 
    * let position = this.vhQuerySecurityCam.getlocalPosition('5fb6780ca2148e09806c5b01');
    * @param id_position 
    * @return Object => obj = {} or null
    */
    public getlocalPosition(id_position:any){
     for(let i=0; i<this.positions.length; i++){
       if(this.positions[i]._id === id_position){
         return this.positions[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let positions = this.vhQuerySecurityCam.getlocalPositions();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalPositions(){    
     return this.positions;
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalPositions()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalPosition(), getlocalPositions() trong localstorage
    * @return Promise => null
    */
   public refreshLocalPositions():any{
     return new Promise((resolve) => { 
       this.getPositions()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySecurityCam.addPosition({name:'camera 2', quantity:20, price:200000})
           .then((room)=>{
             console.log('addPosition', room);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addPosition(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('positions', data)
           .then((position)=>{
             resolve(position);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updatePosition('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updatePosition', bool);
           })
    * @param id_position 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updatePosition(id_position:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('positions', id_position, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deletePosition('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deletePosition', bool);
         })
    * @param id_position 
    * @return Promise => bool = true or false 
    */
   public deletePosition(id_position:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('positions', id_position)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getPosition('5fb67fda87c0f21d484cbdf3')
             .then((room)=>{
               console.log('getPosition', room);
             })
    * @param id_position 
    * @return Promise => obj ={} or null
    */
   private getPosition(id_position:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('positions', id_position)
             .then((position)=>{
               resolve(position);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getPositions()
             .then((positions)=>{
               console.log('getPositions', positions);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   private getPositions(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('positions')
             .then((positions)=>{
               this.positions = new Array();
               this.positions = positions;
               resolve(positions);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
   /**
    * @example: 
    * let log = this.vhQuerySecurityCam.getlocalLog('5fb6780ca2148e09806c5b01');
    * @param id_log 
    * @return Object => obj = {} or null
    */
   public getlocalLog(id_log:any){
     for(let i=0; i<this.logs.length; i++){
       if(this.logs[i]._id === id_log){
         return this.logs[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let logs = this.vhQuerySecurityCam.getlocalLogs(); 
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalLogs(){    
     return this.logs;
   }
   
   /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalLogs()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalLog(), getlocalLogs() trong localstorage
    * @return Promise => null
    */
   public refreshLocalLogs():any{
     return new Promise((resolve) => { 
       this.getLogs()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySecurityCam.addLog({name:'camera 2', quantity:20, price:200000})
           .then((log)=>{
             console.log('addLog', log);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addLog(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('logs', data)
           .then((log)=>{
             resolve(log);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateLog('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateLog', bool);
           })
    * @param id_log 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateLog(id_log:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('logs', id_log, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteLog('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteLog', bool);
         })
    * @param id_log 
    * @return Promise => bool = true or false 
    */
   public deleteLog(id_log:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('logs', id_log)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getLog('5fb67fda87c0f21d484cbdf3')
             .then((log)=>{
               console.log('getLog', log);
             })
    * @param id_log 
    * @return Promise => obj ={} or null
    */
   public getLog(id_log:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('logs', id_log)
             .then((log)=>{
               resolve(log);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getLogs()
             .then((logs)=>{
               console.log('getLogs', logs);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getLogs(){
     return new Promise((resolve, reject) => {
       this.logs = new Array();
       this.vhMGDB_database.getDocs('logs')
             .then((logs)=>{
               this.logs = logs;
               resolve(logs);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
   private publishObservableEventMainboards() {
     this.subjectmainboards.next(this.mainboards);
   }  
 
   private observableLocalMainboards():Subject<any> {      
     return this.subjectmainboards; 
   }
   
  /**
    * @example:
    * this.observableMainboard = this.vhQueryCloudCam.observableLocalMainboards().subscribe((localMainboards:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableMainboard.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalMainboards(){   
    return new Observable((observer:any) => {    
     this.observableLocalMainboards().subscribe((mainboards) => {   
       observer.next(mainboards);
     })
     this.publishObservableEventMainboards();
    })
   }
 
   /**
    * @example: 
    * let wallet = this.vhQuerySecurityCam.getlocalMainboard('5fb6780ca2148e09806c5b01');
    * @param id_mainboard 
    * @return Object => obj = {} or null
    */
   public getlocalMainboard(id_mainboard:any){
     for(let i=0; i<this.mainboards.length; i++){
       if(this.mainboards[i]._id === id_mainboard){
         return this.mainboards[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQuerySecurityCam.getlocalMainboards();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalMainboards(){    
     return this.mainboards;
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalMainboards()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalMainboard(), getlocalMainboards() trong localstorage
    * @return Promise => null
    */
   public refreshLocalMainboards():any{
     return new Promise((resolve) => { 
       this.getMainboards()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySecurityCam.addMainboard({name:'camera 2', quantity:20, price:200000})
           .then((mainboard)=>{
             console.log('addMainboard', mainboard);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addMainboard(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('mainboards', data)
           .then((mainboard)=>{
             resolve(mainboard);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateMainboard('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateMainboard', bool);
           })
    * @param id_mainboard 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateMainboard(id_mainboard:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('mainboards', id_mainboard, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteMainboard('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteMainboard', bool);
         })
    * @param id_mainboard 
    * @return Promise => bool = true or false 
    */
   public deleteMainboard(id_mainboard:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('mainboards', id_mainboard)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getMainboard('5fb67fda87c0f21d484cbdf3')
             .then((mainboard)=>{
               console.log('getMainboard', mainboard);
             })
    * @param id_mainboard 
    * @return Promise => obj ={} or null
    */
   public getMainboard(id_mainboard:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('mainboards', id_mainboard)
             .then((mainboard)=>{
               resolve(mainboard);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getMainboards()
             .then((mainboards)=>{
               console.log('getMainboards', mainboards);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getMainboards(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('mainboards')
             .then((mainboards)=>{
               this.mainboards = new Array();
               this.mainboards = mainboards;
               resolve(mainboards);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
   private publishObservableEventFunctions() {
     this.subjectfunctions.next(this.functions);
   }  
 
   private observableLocalFunctions():Subject<any> {      
     return this.subjectfunctions; 
   }
   
  /**
    * @example:
    * this.observableFunction = this.vhQueryCloudCam.getObservableLocalFunctions().subscribe((localFunctions:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableFunction.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalFunctions(){   
    return new Observable((observer:any) => {    
     this.observableLocalFunctions().subscribe((functions) => {   
       observer.next(functions);
     })
     this.publishObservableEventFunctions();
    })
   }
 
   
   /**
    * @example: 
    * let wallet = this.vhQuerySecurityCam.getlocalFunction('5fb6780ca2148e09806c5b01');
    * @param id_function 
    * @return Object => obj = {} or null
    */
   public getlocalFunction(id_function:any){
     for(let i=0; i<this.functions.length; i++){
       if(this.functions[i]._id === id_function){
         return this.functions[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQuerySecurityCam.getlocalFunctions();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalFunctions(){    
     return this.functions;
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalFunctions()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalFunction(), getlocalFunctions() trong localstorage
    * @return Promise => null
    */
   public refreshLocalFunctions():any{
     return new Promise((resolve) => { 
       this.getFunctions()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySecurityCam.addFunction({name:'camera 2', quantity:20, price:200000})
           .then((func)=>{
             console.log('addFunction', func);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addFunction(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('functions', data)
           .then((func)=>{
             resolve(func);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateFunction('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateFunction', bool);
           })
    * @param id_function 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateFunction(id_function:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('functions', id_function, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteFunction('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteFunction', bool);
         })
    * @param id_function 
    * @return Promise => bool = true or false 
    */
   public deleteFunction(id_function:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('functions', id_function)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getFunction('5fb67fda87c0f21d484cbdf3')
             .then((func)=>{
               console.log('getFunction', func);
             })
    * @param id_function 
    * @return Promise => obj ={} or null
    */
   public getFunction(id_function:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('functions', id_function)
             .then((func)=>{
               resolve(func);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getFunctions()
             .then((functions)=>{
               console.log('getFunctions', functions);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getFunctions(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('functions')
             .then((functions)=>{
               this.functions = new Array();
               this.functions = functions;
               resolve(functions);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   private publishObservableEventComponents() {
     this.subjectcomponents.next(this.components);
   }  
 
   private observableLocalComponents():Subject<any> {      
     return this.subjectcomponents; 
   }
   
  /**
    * @example:
    * this.observableFunction = this.vhQueryCloudCam.getObservableLocalFunctions().subscribe((localFunctions:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableFunction.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalComponents(){   
    return new Observable((observer:any) => {    
     this.observableLocalComponents().subscribe((components) => {   
       observer.next(components);
     })
     this.publishObservableEventComponents();
    })
   }
   
   
   /**
    * @example: 
    * let wallet = this.vhQuerySecurityCam.getlocalComponent('5fb6780ca2148e09806c5b01');
    * @param id_component 
    * @return Object => obj = {} or null
    */
   public getlocalComponent(id_component:any){
     for(let i=0; i<this.components.length; i++){
       if(this.components[i]._id === id_component){
         return this.components[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQuerySecurityCam.getlocalComponents();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalComponents(){    
     return this.components;
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalComponents()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalComponent(), getlocalComponents() trong localstorage
    * @return Promise => null
    */
   public refreshLocalComponents():any{
     return new Promise((resolve) => { 
       this.getComponents()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySecurityCam.addComponent({name:'camera 2', quantity:20, price:200000})
           .then((component)=>{
             console.log('addComponent', component);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addComponent(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('components', data)
           .then((component)=>{
             resolve(component);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateComponent('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateComponent', bool);
           })
    * @param id_component 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateComponent(id_component:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('components', id_component, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteComponent('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteComponent', bool);
         })
    * @param id_component 
    * @return Promise => bool = true or false 
    */
   public deleteComponent(id_component:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('components', id_component)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getComponent('5fb67fda87c0f21d484cbdf3')
             .then((component)=>{
               console.log('getComponent', component);
             })
    * @param id_component 
    * @return Promise => obj ={} or null
    */
   public getComponent(id_component:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('components', id_component)
             .then((component)=>{
               resolve(component);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getComponents()
             .then((components)=>{
               console.log('getComponents', components);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getComponents(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('components')
             .then((components)=>{
               this.components = new Array();
               this.components = components;
               resolve(components);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
   private publishObservableEventIcons() {
     this.subjecticons.next(this.icons);
   }  
 
   private observableLocalIcons():Subject<any> {      
     return this.subjecticons; 
   }
   
  /**
    * @example:
    * this.observableIcon = this.vhQueryCloudCam.getObservableLocalIcons().subscribe((localIcons:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableIcon.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalIcons(){   
    return new Observable((observer:any) => {    
     this.observableLocalIcons().subscribe((icons) => {   
       observer.next(icons);
     })
     this.publishObservableEventIcons();
    })
   }
 
 
    /**
    * @example: 
    * let wallet = this.vhQuerySecurityCam.getlocalIcon('5fb6780ca2148e09806c5b01');
    * @param id_icon 
    * @return Object => obj = {} or null
    */
   public getlocalIcon(id_icon:any){
     for(let i=0; i<this.icons.length; i++){
       if(this.icons[i]._id === id_icon){
         return this.icons[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQuerySecurityCam.getlocalIcons();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalIcons(){    
     return this.icons;
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalIcons()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalIcon(), getlocalIcons() trong localstorage
    * @return Promise => null
    */
   public refreshLocalIcons():any{
     return new Promise((resolve) => { 
       this.getIcons()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySecurityCam.addIcon({name:'camera 2', quantity:20, price:200000})
           .then((icon)=>{
             console.log('addIcon', icon);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addIcon(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('icons', data)
           .then((icon)=>{
             resolve(icon);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateIcon('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateIcon', bool);
           })
    * @param id_icon 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateIcon(id_icon:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('icons', id_icon, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteIcon('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteIcon', bool);
         })
    * @param id_icon 
    * @return Promise => bool = true or false 
    */
   public deleteIcon(id_icon:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('icons', id_icon)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getIcon('5fb67fda87c0f21d484cbdf3')
             .then((icon)=>{
               console.log('getIcon', icon);
             })
    * @param id_icon 
    * @return Promise => obj ={} or null
    */
   public getIcon(id_icon:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('icons', id_icon)
             .then((icon)=>{
               resolve(icon);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getIcons()
             .then((icons)=>{
               console.log('getIcons', icons);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getIcons(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('icons')
             .then((icons)=>{
               this.icons = new Array();
               this.icons = icons;
               resolve(icons);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
   
   private publishObservableEventAppSettingNameStations() {
     this.subjectappsettingstations.next();
   }  
 
   private observableLocalAppSettingNameStations():Subject<any> {      
     return this.subjectappsettingstations; 
   }
   
    /**
    * @example:
    * this.observableAppSetting = this.vhQuerySecurityCam.getObservableLocalAppSettingNameStations().subscribe((localAppSettings:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableAppSetting.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalAppSettingNameStations(){   
    return new Observable((observer:any) => {    
     this.observableLocalAppSettingNameStations().subscribe(() => {   
       let list = new Array();
       for(let i =0; i<this.appsettingstations.length; i++){
         list.push(this.appsettingstations[i].appsetting_name);
       }     
       observer.next(list);
     })
     this.publishObservableEventAppSettingNameStations();
    })
   }
   
   /**
   *@example:
     this.vhQuerySecurityCam.getLocalAppSettingList_Branch()
         .then((list)=>{
             console.log(list);
           })  
   * @return object => list of app_settings
   */
  public getLocalAppSettingNameStations(){  
   let list = new Array();
   for(let i =0; i<this.appsettingstations.length; i++){
     list.push(this.appsettingstations[i].appsetting_name);
   }
   return list;     
 }
 
 /**
  * @example:
   let appsetting = this.vhQuerySecurityCam.getLocalAppSetting_Branch('info_header_footer_bill');
   console.log(appsetting);
  * @param appsetting_name   
  * @return object => {title:'title',name:'name', quantity: 10}
  */
 public getLocalAppSettingNameStation(appsetting_name:any){  
   let obj:any = {};   
   for(let i =0; i<this.appsettingstations.length; i++){
     if(this.appsettingstations[i].appsetting_name === appsetting_name){
       obj = {...this.appsettingstations[i]};
       delete obj._id;
       delete obj.appsetting_name;   
       break;   
     }        
   }
   return obj;
 }
 
  /**
    * @example: 
    * let branch = this.vhQuerySecurityCam.getlocalSetting('5fb6780ca2148e09806c5b01');
    * @param id_branch 
    * @return Object => obj = {} or null
    */
   private getLocalAppSettingStation(id_appsetting:any){
     for(let i=0; i<this.appsettingstations.length; i++){
       if(this.appsettingstations[i]._id === id_appsetting){
         return this.appsettingstations[i];      
       }
     } 
     return null;        
   }
 
     /**
  * Hàm này refresh giá trị mới nhất cho hàm getLocalAppSettingList(), getLocalAppSettingStation() trong localstorage
  * @return Promise => null
  */
 public refreshLocalAppSettingNameStations():any{
   return new Promise((resolve, reject) => { 
     // this.getAppSettingStations().then(()=>{resolve(null)})   
     resolve(null)   
   })
 }
 
 /**
  * @example
  * this.vhQuerySecurityCam.getAppSettingStations()
           .then((settings)=>{
             console.log('getAppSettings', settings);
           })
   * @return Promise => array(object) = [{},{},..]
   */
 private getAppSettingStations():any{
   return new Promise((resolve, reject) => {      
     this.vhMGDB_database.getDocsByFields('appsettingstations',{uuid: {$eq: this.hwinfo.uuid}},{},{},0)
           .then((appsettingstations:any)=>{
             if(appsettingstations.length>0){      
               this.appsettingstations = appsettingstations;  
             }
             resolve(null);
           },(error:any)=>{
             reject(error);
           })          
   })  
 }
 
 /**
  * @example:
   this.vhQuerySecurityCam.updateAppSettingNameStation('ryvSD2tCHYRcpD3AYxUc', 'info_header_footer_bill',{title:'title',name:'name'})
       .then((bool:any)=>{
         console.log(bool);
       })       
  * @param appsetting_name 
  * @param value 
  * @format value = {title:'title',name:'name'} 
  * @return Promise Boolean => bool = true or false 
  */ 
 public updateAppSettingNameStation(appsetting_name:any, value:any) {
   return new Promise((resolve,reject) => {    
     this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid: {$eq: this.hwinfo.uuid}},{},{},0)
         .then((appsettingstations:any)=>{
              if(appsettingstations.length>0){               
               this.vhMGDB_database.updateDoc('appsettingstations', appsettingstations[0]._id, value)
                   .then((bool:any)=>{
                     resolve(bool);                   
                   }, error=>{
                     reject(error)
                   })     
              }else{
                let obj:any = {...value};
                obj.appsetting_name = appsetting_name;               
                obj.uuid = this.hwinfo.uuid;
                this.vhMGDB_database.addDoc('appsettingstations',obj)
                     .then(()=>{
                       resolve(true);
                     }, error=>{
                       reject(error)
                     }) 
              }
         })              
   })  
 }
  
 
 /**
  * @example
  * this.vhQuerySecurityCam.deleteAppSettingNameStation('ryvSD2tCHYRcpD3AYxUc','info_header_footer_bill')
       .then((bool:any)=>{
         console.log(bool); 
       })
  * @param appsetting_name 
  * @return Promise Boolean => bool = true or false 
  */
 public deleteAppSettingNameStation(appsetting_name:any) {
   return new Promise((resolve, reject) => {
     this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid:{$eq:this.hwinfo.uuid}},{},{},0)
         .then((appsettingstations:any)=>{
             if(appsettingstations.length>0){               
               this.vhMGDB_database.deleteDoc('appsettingstations', appsettingstations[0]._id)
                   .then((bool:any)=>{            
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   })              
             }else resolve(false);
           })            
   })     
 }
 
 
   
    /**
    * @example: 
    * let wallet = this.vhQuerySecurityCam.getlocalScript('5fb6780ca2148e09806c5b01');
    * @param id_script 
    * @return Object => obj = {} or null
    */
   public getlocalScript(id_script:any){
     for(let i=0; i<this.scripts.length; i++){
       if(this.scripts[i]._id === id_script){
         return this.scripts[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQuerySecurityCam.getlocalScripts();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalScripts(){    
     return this.scripts;
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalScripts()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalScript(), getlocalScripts() trong localstorage
    * @return Promise => null
    */
   public refreshLocalScripts():any{
     return new Promise((resolve) => { 
       this.getScripts()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySecurityCam.addScript({name:'camera 2', quantity:20, price:200000})
           .then((script)=>{
             console.log('addScript', script);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addScript(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('scripts', data)
           .then((script)=>{
             resolve(script);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateScript('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateScript', bool);
           })
    * @param id_script 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateScript(id_script:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('scripts', id_script, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteScript('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteScript', bool);
         })
    * @param id_script 
    * @return Promise => bool = true or false 
    */
   public deleteScript(id_script:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('scripts', id_script)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getScript('5fb67fda87c0f21d484cbdf3')
             .then((script)=>{
               console.log('getScript', script);
             })
    * @param id_script 
    * @return Promise => obj ={} or null
    */
   public getScript(id_script:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('scripts', id_script)
             .then((script)=>{
               resolve(script);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getScripts()
             .then((scripts)=>{
               console.log('getScripts', scripts);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getScripts(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('scripts')
             .then((scripts)=>{
               this.scripts = new Array();
               this.scripts = scripts;
               resolve(scripts);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
    /**
    * @example: 
    * let wallet = this.vhQuerySecurityCam.getlocalScript_detail('5fb6780ca2148e09806c5b01');
    * @param id_script_detail 
    * @return Object => obj = {} or null
    */
   public getlocalScript_detail(id_script_detail:any){
     for(let i=0; i<this.script_details.length; i++){
       if(this.script_details[i]._id === id_script_detail){
         return this.script_details[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.vhQuerySecurityCam.getlocalScript_details();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalScript_details(){    
     return this.script_details;
   }
   
    /**
    * @example:
    * this.vhQuerySecurityCam.refreshLocalScript_details()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalScript_detail(), getlocalScript_details() trong localstorage
    * @return Promise => null
    */
   public refreshLocalScript_details():any{
     return new Promise((resolve) => { 
       this.getScript_details()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySecurityCam.addScript_detail({name:'camera 2', quantity:20, price:200000})
           .then((script_detail)=>{
             console.log('addScript_detail', script_detail);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addScript_detail(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('script_details', data)
           .then((script_detail)=>{
             resolve(script_detail);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.updateScript_detail('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateScript_detail', bool);
           })
    * @param id_script_detail 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateScript_detail(id_script_detail:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('script_details', id_script_detail, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySecurityCam.deleteScript_detail('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteScript_detail', bool);
         })
    * @param id_script_detail 
    * @return Promise => bool = true or false 
    */
   public deleteScript_detail(id_script_detail:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('script_details', id_script_detail)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getScript_detail('5fb67fda87c0f21d484cbdf3')
             .then((script_detail)=>{
               console.log('getScript_detail', script_detail);
             })
    * @param id_script_detail 
    * @return Promise => obj ={} or null
    */
   public getScript_detail(id_script_detail:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('script_details', id_script_detail)
             .then((script_detail)=>{
               resolve(script_detail);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySecurityCam.getScript_details()
             .then((script_details)=>{
               console.log('getScript_details', script_details);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getScript_details(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('script_details')
             .then((script_details)=>{
               this.script_details = new Array();
               this.script_details = script_details;
               resolve(script_details);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
  
 
 
 }
 
 @Injectable()
 export class VhQuerySmhome{  
   private cameras: any = new Array();
   private rooms: any = new Array();
   private mainboards: any = new Array();
   private functions: any = new Array();
   private components: any = new Array();
   private icons: any = new Array();
   private appsettingstations: any = new Array();
   private scripts: any = new Array();
   private script_details: any = new Array();
   private logs: any = new Array();
   private hwinfo: any = {};
 
   private subjectcameras = new Subject<any>();
   private subjectappsettingstations = new Subject<any>();
   private subjectrooms = new Subject<any>();
   private subjectmainboards = new Subject<any>();
   private subjectfunctions = new Subject<any>();
   private subjecticons = new Subject<any>();
   private subjectcomponents = new Subject<any>();   
   constructor(
     
     private vhMGDB_auth: VhMGDB_auth, 
     private vhMGDB_socketMongoDB: VhMGDB_socketMongoDB, 
     private vhMGDB_rootdatabase: VhMGDB_rootdatabase, 
     private vhMGDB_database: VhMGDB_database, 
     private vhMGDB_f3rdclouds: VhMGDB_f3rdclouds, 
     
     private vhQuery:VhQuery, 
     private vhAuth: VhAuth, 
     private vhAlgorithm:VhAlgorithm) {
     Device.getId().then((info:any)=>{
       let local_hwinfo = this.vhAuth.localStorageGET('hwinfo');
       if((local_hwinfo != null)&&(local_hwinfo != undefined)){
         this.hwinfo = local_hwinfo;       
       }else{
        this.hwinfo = {uuid: info.identifier};    
         this.vhAuth.localStorageSET('hwinfo',this.hwinfo);        
       }           
     }); 
   } 
 
   /**
    * @example:
     this.VhQuerySmhome.syncCollections().then((bool:any)=>{
         if(bool){
           do something...
         }
     })
    * @returns Promise bool = true or false
    */
   syncCollections(){    
     return new Promise((resolve, reject)=>{      
       this.initSyncCollections();
       this.callbackCollectionInsert().subscribe();
       this.callbackCollectionUpdate().subscribe();
       this.callbackCollectionDelete().subscribe();
       setTimeout(() => {
         resolve(true);
       }, 3000);
     })    
   }
 
   
   private initSyncCollections(){      
     let colname_array = new Array(); colname_array[0] = 'cameras'; colname_array[1] = 'rooms'; colname_array[2] = 'mainboards'; 
     colname_array[3] = 'components'; colname_array[4] = 'icons'; colname_array[5] = 'functions'; colname_array[6] = 'vhemployees'; colname_array[7] = 'appsettingstations';     
     return this.vhMGDB_socketMongoDB.initSyncCollections(colname_array,{},"");  
   }
 
       /**
    * @example:
    * this.vhQuerySmhome.closeSyncCollections();
    * disconnect collections synchronization in the APP
    * @returns void
    */
   public closeSyncCollections(){
     // this.callbackcollections.unsubscribe();
     this.vhMGDB_socketMongoDB.closeSyncCollections();
   }
   
   /**
    * VhQuerySmhome
    * @returns 
    */
   private callbackCollectionInsert(){    
     return new Observable((observer:any) => {    
       this.vhMGDB_socketMongoDB.callbackCollectionInsert().subscribe((data:any)=>{  
         if(data.colname === 'vhemployees') data.colname = 'employees';
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
 
         if(data.colname === 'cameras'){
           if(!this.getlocalCamera(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.cameras.push(obj); 
             this.publishObservableEventCameras();    
             observer.next(data.colname);       
           }                  
         }else if(data.colname === 'rooms'){
           if(!this.getlocalRoom(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.rooms.push(obj); 
             this.publishObservableEventRooms();    
             observer.next(data.colname);       
           }            
         }else if(data.colname === 'mainboards'){
           if(!this.getlocalMainboard(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.mainboards.push(obj); 
             this.publishObservableEventMainboards();    
             observer.next(data.colname);       
           }   
         }else if(data.colname === 'components'){
           if(!this.getlocalComponent(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.components.push(obj); 
             this.publishObservableEventComponents();    
             observer.next(data.colname);       
           }             
         }else if(data.colname === 'icons'){
           if(!this.getlocalIcon(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.icons.push(obj); 
             this.publishObservableEventIcons();    
             observer.next(data.colname);       
           } 
         }else if(data.colname === 'functions'){
           if(!this.getlocalFunction(data._id)){
             let obj = {...data.data}; obj._id = data._id;
             this.functions.push(obj); 
             this.publishObservableEventFunctions();    
             observer.next(data.colname);       
           } 
         }else if(data.colname === 'employees'){          
           let obj = {...data.data}; obj._id = data._id;
           this.vhAuth.insertlocalEmployeeFromSyncCollection(obj);         
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);                 
         }else if(data.colname === 'appsettingstations'){         
           if(!this.getLocalAppSettingStation(data._id)){         
             if(data.data.uuid === this.hwinfo.uuid){   
               let obj = {...data.data}; obj._id = data._id;
               delete obj.uuid;
               this.appsettingstations.push(obj);   
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);               
             }            
           }                               
         }
         //console.log('inserted', data.colname);
       })
     })
   }
 
   private callbackCollectionUpdate(){    
     return new Observable((observer:any) => {          
       this.vhMGDB_socketMongoDB.callbackCollectionUpdate().subscribe((data:any)=>{ 
         if(data.colname === 'vhemployees') data.colname = 'employees';
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
         if(data.colname === 'cameras'){
           for(let i=0; i<this.cameras.length; i++){
             if(this.cameras[i]._id === data._id){
               this.cameras[i] = {...this.cameras[i], ...data.data};     
               this.publishObservableEventCameras();  
               observer.next(data.colname);         
               break;
             }
           }  
         }else if(data.colname === 'rooms'){
           for(let i=0; i<this.rooms.length; i++){
             if(this.rooms[i]._id === data._id){
               this.rooms[i] = {...this.rooms[i], ...data.data};     
               this.publishObservableEventRooms();  
               observer.next(data.colname);         
               break;
             }
           }       
         }else if(data.colname === 'mainboards'){
           for(let i=0; i<this.mainboards.length; i++){
             if(this.mainboards[i]._id === data._id){
               this.mainboards[i] = {...this.mainboards[i], ...data.data};     
               this.publishObservableEventMainboards();  
               observer.next(data.colname);         
               break;
             }
           } 
         }else if(data.colname === 'components'){
           for(let i=0; i<this.components.length; i++){
             if(this.rooms[i]._id === data._id){
               this.rooms[i] = {...this.components[i], ...data.data};     
               this.publishObservableEventComponents();  
               observer.next(data.colname);         
               break;
             }
           }   
         }else if(data.colname === 'icons'){
           for(let i=0; i<this.icons.length; i++){
             if(this.icons[i]._id === data._id){
               this.icons[i] = {...this.icons[i], ...data.data};     
               this.publishObservableEventIcons();  
               observer.next(data.colname);         
               break;
             }
           }           
         }else if(data.colname === 'functions'){
           for(let i=0; i<this.icons.functions; i++){
             if(this.functions[i]._id === data._id){
               this.functions[i] = {...this.functions[i], ...data.data};     
               this.publishObservableEventFunctions();  
               observer.next(data.colname);         
               break;
             }
           }      
         }else if(data.colname === 'employees'){          
           this.vhAuth.updateLocalEmployeeFromSyncCollection(data._id, data.data);    
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);
         }else if(data.colname === 'appsettingstations'){
           for(let i=0; i<this.appsettingstations.length; i++){
             if(this.appsettingstations[i]._id === data._id){
               this.appsettingstations[i] = {...this.appsettingstations[i], ...data.data};   
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);               
               break;
             }
           }    
         }    
         //console.log('this.products', this.products);
         //console.log('updated', data.colname);
       })
     })
   }
  
   private callbackCollectionDelete(){
     return new Observable((observer:any) => {    
       this.vhMGDB_socketMongoDB.callbackCollectionDelete().subscribe((data:any)=>{       
         if(data.colname === 'vhemployees') data.colname = 'employees';    
         else if(data.colname === 'appsettingstations') data.colname = 'appsettingstations';
         if(data.colname === 'cameras'){
           for(let i=0; i<this.cameras.length; i++){
             if(this.cameras[i]._id === data._id){
               this.cameras.splice(i, 1);       
               this.publishObservableEventCameras();  
               observer.next(data.colname);                        
               break;
             }
           }   
         }else if(data.colname === 'rooms'){
           for(let i=0; i<this.rooms.length; i++){
             if(this.rooms[i]._id === data._id){
               this.rooms.splice(i, 1);       
               this.publishObservableEventRooms();  
               observer.next(data.colname);                        
               break;
             }
           }          
         }else if(data.colname === 'mainboards'){
           for(let i=0; i<this.mainboards.length; i++){
             if(this.mainboards[i]._id === data._id){
               this.mainboards.splice(i, 1);       
               this.publishObservableEventMainboards();  
               observer.next(data.colname);                        
               break;
             }
           }    
         }else if(data.colname === 'components'){
           for(let i=0; i<this.components.length; i++){
             if(this.components[i]._id === data._id){
               this.components.splice(i, 1);       
               this.publishObservableEventComponents();  
               observer.next(data.colname);                        
               break;
             }
           }   
         }else if(data.colname === 'icons'){
           for(let i=0; i<this.icons.length; i++){
             if(this.icons[i]._id === data._id){
               this.icons.splice(i, 1);       
               this.publishObservableEventIcons();  
               observer.next(data.colname);                        
               break;
             }
           }        
         }else if(data.colname === 'functions'){
           for(let i=0; i<this.functions.length; i++){
             if(this.functions[i]._id === data._id){
               this.functions.splice(i, 1);       
               this.publishObservableEventFunctions();  
               observer.next(data.colname);                        
               break;
             }
           }        
         }else if(data.colname === 'employees'){
           this.vhAuth.deleteLocalEmployeeFromSyncCollection(data._id);    
           this.vhAuth.publishObservableEventEmployees();
           observer.next(data.colname);    
         }else if(data.colname === 'appsettingstations'){
           for(let i=0; i<this.appsettingstations.length; i++){
             if(this.appsettingstations[i]._id === data._id){
               this.appsettingstations.splice(i, 1); 
               this.publishObservableEventAppSettingNameStations(); 
               observer.next(data.colname);                
               break;
             }
           }   
         }
         //console.log('deleted', data.colname);           
       })
     })
   }
   
   
   public startLocalStorage(){
     return new Promise<any>((resolve) => {
       let promise = new Array();  
       promise[0] = this.vhAuth.refreshLocalEmployees();
       promise[1] = this.vhAuth.refreshLocalMyPermission();  
       promise[2] = this.refreshLocalRooms();
       promise[3] = this.refreshLocalCameras();     
       promise[4] = this.refreshLocalComponents();
       promise[5] = this.refreshLocalFunctions();
       promise[6] = this.refreshLocalIcons();  
       promise[7] = this.refreshLocalMainboards();             
       this.vhQuery.asyncPromiseAll(promise).then(()=>{resolve(null)});               
     })
   }
         
   private publishObservableEventCameras() {
     this.subjectcameras.next(this.cameras);
   }  
 
   private observableLocalCameras():Subject<any> {      
     return this.subjectcameras; 
   }
   
  /**
    * @example:
    * this.observableCamera = this.vhQueryCloudCam.getObservableLocalCameras().subscribe((localCameras:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableCamera.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalCameras(){   
    return new Observable((observer:any) => {    
     this.observableLocalCameras().subscribe((cameras) => {   
       observer.next(cameras);
     })
     this.publishObservableEventCameras();
    })
   }
 
   /**
    * @example: 
    * let wallet = this.VhQuerySmhome.getlocalCamera('5fb6780ca2148e09806c5b01');
    * @param id_camera 
    * @return Object => obj = {} or null
    */
   public getlocalCamera(id_camera:any){
     for(let i=0; i<this.cameras.length; i++){
       if(this.cameras[i]._id === id_camera){
         return this.cameras[i];
         break;
       }
     } 
     return null; 
   }
      
 
   /**
    * @example: 
    * let wallets = this.VhQuerySmhome.getlocalCameras();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalCameras(){    
     return this.cameras;
   }
   
    /**
    * @example:
    * this.VhQuerySmhome.refreshLocalCameras()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalCamera(), getlocalCameras() trong localstorage
    * @return Promise => null
    */
   public refreshLocalCameras():any{
     return new Promise((resolve) => { 
       this.getCameras()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.VhQuerySmhome.addCamera({name:'camera 2', url:'rtsp://admin:admin@115.78.100.57:1020/av_stream/ch0', licensecam:'pTqOFsJEndPrg7AImFxV'})
           .then((camera)=>{
             console.log('addCamera', camera);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    * Trường hợp không thành công:
    * code = 0 : licensecam không đúng
    * code = 1 : licensecam đã và đang được sử dụng
    */
   public addCamera(data:any){
     //let _data = {...data};
     //if(_data.licensecam === undefined) _data.licensecam = _data.licensekey;
     //delete _data.licensekey;
     return new Promise((resolve, reject) => {
       // this.vhMGDB_clouds.checkLicenseAddCam(data)
       //     .then((result:any)=>{            
       //       if((result.code === 4)||(result.code === 5)){
       //         this.vhMGDB_database.addDoc('cameras', {...data, camliveURL:result.camliveURL, camplaybackURL:result.camplaybackURL})
       //             .then((camera)=>{
       //               resolve(camera);
       //             },(error:any)=>{
       //               console.error(error);
       //               reject({code:0});
       //             })    
       //       }else reject(result);            
       //     },(error:any)=>{
       //       console.error(error);
       //       reject({code:0});
       //     })            
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.updateCamera('5fb6780ca2148e09806c5b01', {name:camera 3})
           .then((bool:any)=>{
             console.log('updateCamera', bool);
           })
    * @param id_camera 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateCamera(id_camera:string, data:any){//nên thêm 1 tham số vào là licensecam
     //console.log('data', data);
     return new Promise((resolve, reject) => {
       // this.vhMGDB_database.getDoc('cameras', id_camera)
       //     .then((camera:any)=>{            
       //       if(camera){
       //         let _data = {...data};
       //         _data.licensecam = camera.licensecam;
       //         this.vhMGDB_clouds.checkLicenseUpdateCam(_data)
       //             .then((result:any)=>{   
       //               if(result.code === 3){               
       //                   this.vhMGDB_database.updateDoc('cameras', id_camera, _data)
       //                       .then((bool:any)=>{            
       //                         resolve(bool);
       //                       }, error=>{
       //                         reject(error)
       //                       })        
       //               }              
       //             },(error:any)=>{
       //               reject(error);
       //             })      
       //       }
       //     }, error=>{
       //       reject(error)
       //     })               
     }) 
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.deleteCamera('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteCamera', bool);
         })
    * @param id_camera 
    * @return Promise => bool = true or false 
    */
   public deleteCamera(id_camera:string){
     return new Promise((resolve, reject) => {
       // this.vhMGDB_database.getDoc('cameras', id_camera)
       //     .then((camera:any)=>{            
       //      if(camera){            
       //       this.vhMGDB_clouds.checkLicenseDeleteCam(camera.licensecam)
       //           .then((result:any)=>{                 
       //               this.vhMGDB_database.deleteDoc('cameras', id_camera)
       //                   .then((bool:any)=>{            
       //                     resolve(bool);
       //                   }, error=>{
       //                     reject(error)
       //                   })                     
       //           },(error:any)=>{
       //             reject(error);
       //           })        
       //      }
       //     }, error=>{
       //       reject(error)
       //     })                   
               
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getCamera('5fb67fda87c0f21d484cbdf3')
             .then((camera)=>{
               console.log('getCamera', camera);
             })
    * @param id_camera 
    * @return Promise => obj ={} or null
    */
   public getCamera(id_camera:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('cameras', id_camera)
             .then((camera)=>{
               resolve(camera);
             })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getCameras()
             .then((cameras)=>{
               console.log('getCameras', cameras);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getCameras(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('cameras')
             .then((cameras)=>{
               this.cameras = new Array();
               this.cameras = cameras;
               resolve(cameras);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   /**
    * 
    * @param licensecam 
    * @param camplaybackURL 
    * @param starttime 
    * @param endtime 
    * @return Promise => array(string) = [,,..]
    */
   public getPlaybackListCambyEndUser(licensecam:string, camplaybackURL:string, starttime:any, endtime:any){
     return new Promise((resolve, reject) => {
       this.vhMGDB_f3rdclouds.getPlaybackListCambyEndUser(licensecam, camplaybackURL, starttime, endtime)
         .then((playbacklist:any)=>{
           if(playbacklist.vcode === 0){           
             resolve(playbacklist.data);                             
           }else{
             //console.log(playbacklist);
             resolve([]);                  
           }    
         },(error:any)=>{         
           reject(error);
         }) 
     })       
   }
 
   private publishObservableEventRooms() {
     this.subjectrooms.next(this.rooms);
   }  
 
   private observableLocalRooms():Subject<any> {      
     return this.subjectrooms; 
   }
   
  /**
    * @example:
    * this.observableRoom = this.vhQueryCloudCam.getObservableLocalRooms().subscribe((localRooms:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableRoom.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalRooms(){   
    return new Observable((observer:any) => {    
     this.observableLocalRooms().subscribe((rooms) => {   
       observer.next(rooms);
     })
     this.publishObservableEventRooms();
    })
   }
 
   /**
    * @example: 
    * let wallet = this.VhQuerySmhome.getlocalRoom('5fb6780ca2148e09806c5b01');
    * @param id_room 
    * @return Object => obj = {} or null
    */
   public getlocalRoom(id_room:any){
     for(let i=0; i<this.rooms.length; i++){
       if(this.rooms[i]._id === id_room){
         return this.rooms[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.VhQuerySmhome.getlocalRooms();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalRooms(){    
     return this.rooms;
   }
   
    /**
    * @example:
    * this.VhQuerySmhome.refreshLocalRooms()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalRoom(), getlocalRooms() trong localstorage
    * @return Promise => null
    */
   public refreshLocalRooms():any{
     return new Promise((resolve) => { 
       this.getRooms()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.VhQuerySmhome.addRoom({name:'camera 2', quantity:20, price:200000})
           .then((room)=>{
             console.log('addRoom', room);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addRoom(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('rooms', data)
           .then((room)=>{
             resolve(room);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.updateRoom('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateRoom', bool);
           })
    * @param id_room 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateRoom(id_room:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('rooms', id_room, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.deleteRoom('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteRoom', bool);
         })
    * @param id_room 
    * @return Promise => bool = true or false 
    */
   public deleteRoom(id_room:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('rooms', id_room)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getRoom('5fb67fda87c0f21d484cbdf3')
             .then((room)=>{
               console.log('getRoom', room);
             })
    * @param id_room 
    * @return Promise => obj ={} or null
    */
   public getRoom(id_room:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('rooms', id_room)
             .then((room)=>{
               resolve(room);
             })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getRooms()
             .then((rooms)=>{
               console.log('getRooms', rooms);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getRooms(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('rooms')
             .then((rooms)=>{
               this.rooms = new Array();
               this.rooms = rooms;
               resolve(rooms);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
   /**
    * @example: 
    * let log = this.vhQuerySales.getlocalLog('5fb6780ca2148e09806c5b01');
    * @param id_log 
    * @return Object => obj = {} or null
    */
   public getlocalLog(id_log:any){
     for(let i=0; i<this.logs.length; i++){
       if(this.logs[i]._id === id_log){
         return this.logs[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let logs = this.vhQuerySales.getlocalLogs(); 
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalLogs(){    
     return this.logs;
   }
   
   /**
    * @example:
    * this.vhQuerySales.refreshLocalLogs()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalLog(), getlocalLogs() trong localstorage
    * @return Promise => null
    */
   public refreshLocalLogs():any{
     return new Promise((resolve) => { 
       this.getLogs()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.vhQuerySales.addLog({name:'camera 2', quantity:20, price:200000})
           .then((log)=>{
             console.log('addLog', log);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addLog(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('logs', data)
           .then((log)=>{
             resolve(log);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySales.updateLog('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateLog', bool);
           })
    * @param id_log 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateLog(id_log:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('logs', id_log, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySales.deleteLog('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteLog', bool);
         })
    * @param id_log 
    * @return Promise => bool = true or false 
    */
   public deleteLog(id_log:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('logs', id_log)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySales.getLog('5fb67fda87c0f21d484cbdf3')
             .then((log)=>{
               console.log('getLog', log);
             })
    * @param id_log 
    * @return Promise => obj ={} or null
    */
   public getLog(id_log:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('logs', id_log)
             .then((log)=>{
               resolve(log);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySales.getLogs()
             .then((logs)=>{
               console.log('getLogs', logs);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getLogs(){
     return new Promise((resolve, reject) => {
       this.logs = new Array();
       this.vhMGDB_database.getDocs('logs')
             .then((logs)=>{
               this.logs = logs;
               resolve(logs);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
   private publishObservableEventMainboards() {
     this.subjectmainboards.next(this.mainboards);
   }  
 
   private observableLocalMainboards():Subject<any> {      
     return this.subjectmainboards; 
   }
   
  /**
    * @example:
    * this.observableMainboard = this.vhQueryCloudCam.observableLocalMainboards().subscribe((localMainboards:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableMainboard.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalMainboards(){   
    return new Observable((observer:any) => {    
     this.observableLocalMainboards().subscribe((mainboards) => {   
       observer.next(mainboards);
     })
     this.publishObservableEventMainboards();
    })
   }
 
   /**
    * @example: 
    * let wallet = this.VhQuerySmhome.getlocalMainboard('5fb6780ca2148e09806c5b01');
    * @param id_mainboard 
    * @return Object => obj = {} or null
    */
   public getlocalMainboard(id_mainboard:any){
     for(let i=0; i<this.mainboards.length; i++){
       if(this.mainboards[i]._id === id_mainboard){
         return this.mainboards[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.VhQuerySmhome.getlocalMainboards();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalMainboards(){    
     return this.mainboards;
   }
   
    /**
    * @example:
    * this.VhQuerySmhome.refreshLocalMainboards()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalMainboard(), getlocalMainboards() trong localstorage
    * @return Promise => null
    */
   public refreshLocalMainboards():any{
     return new Promise((resolve) => { 
       this.getMainboards()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.VhQuerySmhome.addMainboard({name:'camera 2', quantity:20, price:200000})
           .then((mainboard)=>{
             console.log('addMainboard', mainboard);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addMainboard(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('mainboards', data)
           .then((mainboard)=>{
             resolve(mainboard);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.updateMainboard('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateMainboard', bool);
           })
    * @param id_mainboard 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateMainboard(id_mainboard:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('mainboards', id_mainboard, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.deleteMainboard('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteMainboard', bool);
         })
    * @param id_mainboard 
    * @return Promise => bool = true or false 
    */
   public deleteMainboard(id_mainboard:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('mainboards', id_mainboard)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getMainboard('5fb67fda87c0f21d484cbdf3')
             .then((mainboard)=>{
               console.log('getMainboard', mainboard);
             })
    * @param id_mainboard 
    * @return Promise => obj ={} or null
    */
   public getMainboard(id_mainboard:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('mainboards', id_mainboard)
             .then((mainboard)=>{
               resolve(mainboard);
             })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getMainboards()
             .then((mainboards)=>{
               console.log('getMainboards', mainboards);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getMainboards(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('mainboards')
             .then((mainboards)=>{
               this.mainboards = new Array();
               this.mainboards = mainboards;
               resolve(mainboards);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   private publishObservableEventFunctions() {
     this.subjectfunctions.next(this.functions);
   }  
 
   private observableLocalFunctions():Subject<any> {      
     return this.subjectfunctions; 
   }
   
  /**
    * @example:
    * this.observableFunction = this.vhQueryCloudCam.getObservableLocalFunctions().subscribe((localFunctions:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableFunction.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalFunctions(){   
    return new Observable((observer:any) => {    
     this.observableLocalFunctions().subscribe((functions) => {   
       observer.next(functions);
     })
     this.publishObservableEventFunctions();
    })
   }
   
   /**
    * @example: 
    * let wallet = this.VhQuerySmhome.getlocalFunction('5fb6780ca2148e09806c5b01');
    * @param id_function 
    * @return Object => obj = {} or null
    */
   public getlocalFunction(id_function:any){
     for(let i=0; i<this.functions.length; i++){
       if(this.functions[i]._id === id_function){
         return this.functions[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.VhQuerySmhome.getlocalFunctions();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalFunctions(){    
     return this.functions;
   }
   
    /**
    * @example:
    * this.VhQuerySmhome.refreshLocalFunctions()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalFunction(), getlocalFunctions() trong localstorage
    * @return Promise => null
    */
   public refreshLocalFunctions():any{
     return new Promise((resolve) => { 
       this.getFunctions()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.VhQuerySmhome.addFunction({name:'camera 2', quantity:20, price:200000})
           .then((func)=>{
             console.log('addFunction', func);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addFunction(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('functions', data)
           .then((func)=>{
             resolve(func);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.updateFunction('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateFunction', bool);
           })
    * @param id_function 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateFunction(id_function:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('functions', id_function, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.deleteFunction('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteFunction', bool);
         })
    * @param id_function 
    * @return Promise => bool = true or false 
    */
   public deleteFunction(id_function:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('functions', id_function)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getFunction('5fb67fda87c0f21d484cbdf3')
             .then((func)=>{
               console.log('getFunction', func);
             })
    * @param id_function 
    * @return Promise => obj ={} or null
    */
   public getFunction(id_function:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('functions', id_function)
             .then((func)=>{
               resolve(func);
             })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getFunctions()
             .then((functions)=>{
               console.log('getFunctions', functions);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getFunctions(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('functions')
             .then((functions)=>{
               this.functions = new Array();
               this.functions = functions;
               resolve(functions);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   private publishObservableEventComponents() {
     this.subjectcomponents.next(this.components);
   }  
 
   private observableLocalComponents():Subject<any> {      
     return this.subjectcomponents; 
   }
   
  /**
    * @example:
    * this.observableFunction = this.vhQueryCloudCam.getObservableLocalFunctions().subscribe((localFunctions:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableFunction.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalComponents(){   
    return new Observable((observer:any) => {    
     this.observableLocalComponents().subscribe((components) => {   
       observer.next(components);
     })
     this.publishObservableEventComponents();
    })
   }
   
   /**
    * @example: 
    * let wallet = this.VhQuerySmhome.getlocalComponent('5fb6780ca2148e09806c5b01');
    * @param id_component 
    * @return Object => obj = {} or null
    */
   public getlocalComponent(id_component:any){
     for(let i=0; i<this.components.length; i++){
       if(this.components[i]._id === id_component){
         return this.components[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.VhQuerySmhome.getlocalComponents();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalComponents(){    
     return this.components;
   }
   
    /**
    * @example:
    * this.VhQuerySmhome.refreshLocalComponents()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalComponent(), getlocalComponents() trong localstorage
    * @return Promise => null
    */
   public refreshLocalComponents():any{
     return new Promise((resolve) => { 
       this.getComponents()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.VhQuerySmhome.addComponent({name:'camera 2', quantity:20, price:200000})
           .then((component)=>{
             console.log('addComponent', component);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addComponent(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('components', data)
           .then((component)=>{
             resolve(component);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.vhQuerySmhome.updateComponent('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateComponent', bool);
           })
    * @param id_component 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateComponent(id_component:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('components', id_component, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySmhome.deleteComponent('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteComponent', bool);
         })
    * @param id_component 
    * @return Promise => bool = true or false 
    */
   public deleteComponent(id_component:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('components', id_component)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySmhome.getComponent('5fb67fda87c0f21d484cbdf3')
             .then((component)=>{
               console.log('getComponent', component);
             })
    * @param id_component 
    * @return Promise => obj ={} or null
    */
   public getComponent(id_component:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('components', id_component)
             .then((component)=>{
               resolve(component);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySmhome.getComponents()
             .then((components)=>{
               console.log('getComponents', components);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getComponents(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('components')
             .then((components)=>{
               this.components = new Array();
               this.components = components;
               resolve(components);
             },(error:any)=>{
               reject(error);
             })          
     })
   }  
 
   /**
    * @example:
    * let data = {
    *    name: 'TCL',
    *    code_type: 10,
    *    type: 1
    * }
    * this.vhQuerySmhome.addIRManufacturer_byID('5fb6780ca2148e09806c5b01', data)
           .then((IRmanufacturer)=>{
             console.log('addIRManufacturer', IRmanufacturer);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param id_IRmanufacturer
    * @param data : {}
    * @return  Promise => obj = {} /error
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
     public addIRManufacturer_byID(id_IRmanufacturer:string, data:object){
       return new Promise((resolve, reject) => {
         this.vhMGDB_rootdatabase.addDocbyID('IRmanufacturers', id_IRmanufacturer, data)
             .then((IRmanufacturer)=>{
               resolve(IRmanufacturer);
             },(error:any)=>{
               reject(error);
             })         
       })
     }
   
     /**
      * @example:
      * this.vhQuerySmhome.updateIRManufacturer('5fb6780ca2148e09806c5b01', {code_type: 9})
             .then(()=>{
               console.log('updateIRManufacturer');
             }, error=>{
               console.log('error');
             }) 
       * @param id_IRmanufacturer 
       * @param value : {}
       * @return Promise => response = undefined / error
       */
     public updateIRManufacturer(id_IRmanufacturer:string, value:object){
       return new Promise((resolve,reject) => {
         this.vhMGDB_rootdatabase.updateDoc('IRmanufacturers', id_IRmanufacturer, value)
             .then(()=>{
               resolve(undefined);
             }, error=>{
               reject(error)
             })          
       })
     }
   
     /**
      * @example:
      * this.vhQuerySmhome.deleteIRManufacturer('5fb67fda87c0f21d484cbdf3')
           .then(()=>{
             console.log('deleteIRManufacturer');
           })
       * @param id_IRmanufacturer 
       * @return Promise => response = undefined / error
       */
     public deleteIRManufacturer(id_IRmanufacturer:string){
       return new Promise((resolve, reject) => {
         this.vhMGDB_rootdatabase.deleteDoc('IRmanufacturers', id_IRmanufacturer)
             .then(()=>{            
               resolve(undefined);
             }, error=>{
               reject(error)
             })          
       })
     }
 
     /**
      * @example
      * this.vhQuerySmhome.getIRManufacturer('5fb67fda87c0f21d484cbdf3')
               .then((IRmanufacturer)=>{
                 console.log('getIRManufacturer', IRmanufacturer);
               },(error:any)=>{
                 console.log('error', error);
               })
       * @param id_IRmanufacturer 
       * @return Promise => response ={} or null / error
       */
     public getIRManufacturer(id_IRmanufacturer:string){
       return new Promise((resolve, reject) => {
         this.vhMGDB_rootdatabase.getDoc('IRmanufacturers', id_IRmanufacturer)
               .then((IRmanufacturer)=>{
                 resolve(IRmanufacturer);
               },(error:any)=>{
                 resolve(error);
               })         
       })
     }
   
     /**
      * @example
      * this.vhQuerySmhome.getIRManufacturers(1)
               .then((IRmanufacturers)=>{
                 console.log('getIRManufacturers', IRmanufacturers);
               }, error=>{
                 console.log(error, error); 
               })
       * @return Promise => array(object) = [{},{},..]
       */
     public getIRManufacturers(type:number){
       return new Promise((resolve, reject) => {      
         this.vhMGDB_rootdatabase.getDocsByFields('IRmanufacturers', {type:{$eq:type}}, {})
              .then((IRmanufacturers)=>{
                 resolve(IRmanufacturers);
               }, error=>{
                 reject(error); 
               })             
       })
     }
 
   private publishObservableEventIcons() {
     this.subjecticons.next(this.icons);
   }  
 
   private observableLocalIcons():Subject<any> {      
     return this.subjecticons; 
   }
   
  /**
    * @example:
    * this.observableIcon = this.vhQueryCloudCam.getObservableLocalIcons().subscribe((localIcons:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableIcon.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalIcons(){   
    return new Observable((observer:any) => {    
     this.observableLocalIcons().subscribe((icons) => {   
       observer.next(icons);
     })
     this.publishObservableEventIcons();
    })
   }
 
    /**
    * @example: 
    * let wallet = this.VhQuerySmhome.getlocalIcon('5fb6780ca2148e09806c5b01');
    * @param id_icon 
    * @return Object => obj = {} or null
    */
   public getlocalIcon(id_icon:any){
     for(let i=0; i<this.icons.length; i++){
       if(this.icons[i]._id === id_icon){
         return this.icons[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.VhQuerySmhome.getlocalIcons();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalIcons(){    
     return this.icons;
   }
   
    /**
    * @example:
    * this.VhQuerySmhome.refreshLocalIcons()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalIcon(), getlocalIcons() trong localstorage
    * @return Promise => null
    */
   public refreshLocalIcons():any{
     return new Promise((resolve) => { 
       this.getIcons()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.VhQuerySmhome.addIcon({name:'camera 2', quantity:20, price:200000})
           .then((icon)=>{
             console.log('addIcon', icon);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addIcon(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('icons', data)
           .then((icon)=>{
             resolve(icon);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.updateIcon('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateIcon', bool);
           })
    * @param id_icon 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateIcon(id_icon:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('icons', id_icon, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.deleteIcon('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteIcon', bool);
         })
    * @param id_icon 
    * @return Promise => bool = true or false 
    */
   public deleteIcon(id_icon:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('icons', id_icon)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getIcon('5fb67fda87c0f21d484cbdf3')
             .then((icon)=>{
               console.log('getIcon', icon);
             })
    * @param id_icon 
    * @return Promise => obj ={} or null
    */
   public getIcon(id_icon:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('icons', id_icon)
             .then((icon)=>{
               resolve(icon);
             })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getIcons()
             .then((icons)=>{
               console.log('getIcons', icons);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getIcons(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('icons')
             .then((icons)=>{
               this.icons = new Array();
               this.icons = icons;
               resolve(icons);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
     
   private publishObservableEventAppSettingNameStations() {
     this.subjectappsettingstations.next();
   }  
 
   private observableLocalAppSettingNameStations():Subject<any> {      
     return this.subjectappsettingstations; 
   }
   
    /**
    * @example:
    * this.observableAppSetting = this.VhQuerySmhome.getObservableLocalAppSettingNameStations().subscribe((localAppSettings:any) => {          
         do something... 
      })       
     
     ngOnDestroy(){
       this.observableAppSetting.unsubscribe();    
     }
    * @returns Observerble (Array) => Array(object) => array = [{},{},...]
    */
   public getObservableLocalAppSettingNameStations(){   
    return new Observable((observer:any) => {    
     this.observableLocalAppSettingNameStations().subscribe(() => {   
       let list = new Array();
       for(let i =0; i<this.appsettingstations.length; i++){
         list.push(this.appsettingstations[i].appsetting_name);
       }     
       observer.next(list);
     })
     this.publishObservableEventAppSettingNameStations();
    })
   }
   
   /**
   *@example:
     this.VhQuerySmhome.getLocalAppSettingNameStations()
         .then((list)=>{
             console.log(list);
           })  
   * @return object => list of appsetting_names
   */
  public getLocalAppSettingNameStations(){  
   let list = new Array();
   for(let i =0; i<this.appsettingstations.length; i++){
     list.push(this.appsettingstations[i].appsetting_name);
   }
   return list;     
 }
 
 /**
  * @example:
   let appsetting = this.VhQuerySmhome.getLocalAppSettingNameStation('info_header_footer_bill');
   console.log(appsetting);
  * @param appsetting_name   
  * @return object => {title:'title',name:'name', quantity: 10}
  */
 public getLocalAppSettingNameStation(appsetting_name:any){  
   let obj:any = {};   
   for(let i =0; i<this.appsettingstations.length; i++){
     if(this.appsettingstations[i].appsetting_name === appsetting_name){
       obj = {...this.appsettingstations[i]};
       delete obj._id;
       delete obj.appsetting_name;   
       break;   
     }        
   }
   return obj;
 }
 
  /**
    * @example: 
    * let appsetting = this.VhQuerySmhome.getLocalAppSettingStation('5fb6780ca2148e09806c5b01');
    * @param id_appsetting 
    * @return Object => obj = {} or null
    */
   private getLocalAppSettingStation(id_appsetting:any){
     for(let i=0; i<this.appsettingstations.length; i++){
       if(this.appsettingstations[i]._id === id_appsetting){
         return this.appsettingstations[i];      
       }
     } 
     return null;        
   }
 
     /**
  * Hàm này refresh giá trị mới nhất cho hàm getLocalAppSettingNameStations(), getLocalAppSettingNameStation() trong localstorage
  * @return Promise => null
  */
 public refreshLocalAppSettingNameStations():any{
   return new Promise((resolve, reject) => { 
     // this.getAppSettingStations().then(()=>{resolve(null)})   
     resolve(null)   
   })
 }
 
 /**
  * @example
  * this.VhQuerySmhome.getAppSettingStations()
           .then((settings)=>{
             console.log('getAppSettings', settings);
           })
   * @return Promise => array(object) = [{},{},..]
   */
 private getAppSettingStations():any{
   return new Promise((resolve, reject) => {      
     this.vhMGDB_database.getDocsByFields('appsettingstations',{uuid: {$eq: this.hwinfo.uuid}},{},{},0)
           .then((appsettingstations:any)=>{
             if(appsettingstations.length>0){      
               this.appsettingstations = appsettingstations;  
             }
             resolve(null);
           },(error:any)=>{
             reject(error);
           })          
   })  
 }
 
 /**
  * @example:
   this.VhQuerySmhome.updateAppSettingNameStation('info_header_footer_bill',{title:'title',name:'name'})
       .then((bool:any)=>{
         console.log(bool);
       })       
  * @param appsetting_name 
  * @param value 
  * @format value = {title:'title',name:'name'} 
  * @return Promise Boolean => bool = true or false 
  */ 
 public updateAppSettingNameStation(appsetting_name:any, value:any) {
   return new Promise((resolve,reject) => {    
     this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid: {$eq: this.hwinfo.uuid}},{},{},0)
         .then((appsettingstations:any)=>{
              if(appsettingstations.length>0){               
               this.vhMGDB_database.updateDoc('appsettingstations', appsettingstations[0]._id, value)
                   .then((bool:any)=>{
                     resolve(bool);                   
                   }, error=>{
                     reject(error)
                   })     
              }else{
                let obj:any = {...value};
                obj.appsetting_name = appsetting_name;               
                obj.uuid = this.hwinfo.uuid;
                this.vhMGDB_database.addDoc('appsettingstations',obj)
                     .then(()=>{
                       resolve(true);
                     }, error=>{
                       reject(error)
                     }) 
              }
         })              
   })  
 }
  
 
 /**
  * @example
  * this.VhQuerySmhome.deleteAppSettingNameStation('info_header_footer_bill')
       .then((bool:any)=>{
         console.log(bool); 
       })
  * @param appsetting_name 
  * @return Promise Boolean => bool = true or false 
  */
 public deleteAppSettingNameStation(appsetting_name:any) {
   return new Promise((resolve, reject) => {
     this.vhMGDB_database.getDocsByFields('appsettingstations',{appsetting_name:{$eq:appsetting_name}, uuid:{$eq:this.hwinfo.uuid}},{},{},0)
         .then((appsettingstations:any)=>{
             if(appsettingstations.length>0){               
               this.vhMGDB_database.deleteDoc('appsettingstations', appsettingstations[0]._id)
                   .then((bool:any)=>{            
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   })              
             }else resolve(false);
           })            
   })     
 }
 
   
    /**
    * @example: 
    * let wallet = this.VhQuerySmhome.getlocalScript('5fb6780ca2148e09806c5b01');
    * @param id_script 
    * @return Object => obj = {} or null
    */
   public getlocalScript(id_script:any){
     for(let i=0; i<this.scripts.length; i++){
       if(this.scripts[i]._id === id_script){
         return this.scripts[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.VhQuerySmhome.getlocalScripts();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalScripts(){    
     return this.scripts;
   }
   
    /**
    * @example:
    * this.VhQuerySmhome.refreshLocalScripts()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalScript(), getlocalScripts() trong localstorage
    * @return Promise => null
    */
   public refreshLocalScripts():any{
     return new Promise((resolve) => { 
       this.getScripts()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.VhQuerySmhome.addScript({name:'camera 2', quantity:20, price:200000})
           .then((script)=>{
             console.log('addScript', script);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addScript(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('scripts', data)
           .then((script)=>{
             resolve(script);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.updateScript('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateScript', bool);
           })
    * @param id_script 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateScript(id_script:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('scripts', id_script, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.deleteScript('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteScript', bool);
         })
    * @param id_script 
    * @return Promise => bool = true or false 
    */
   public deleteScript(id_script:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('scripts', id_script)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getScript('5fb67fda87c0f21d484cbdf3')
             .then((script)=>{
               console.log('getScript', script);
             })
    * @param id_script 
    * @return Promise => obj ={} or null
    */
   public getScript(id_script:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('scripts', id_script)
             .then((script)=>{
               resolve(script);
             })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getScripts()
             .then((scripts)=>{
               console.log('getScripts', scripts);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getScripts(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('scripts')
             .then((scripts)=>{
               this.scripts = new Array();
               this.scripts = scripts;
               resolve(scripts);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   
    /**
    * @example: 
    * let wallet = this.VhQuerySmhome.getlocalScript_detail('5fb6780ca2148e09806c5b01');
    * @param id_script_detail 
    * @return Object => obj = {} or null
    */
   public getlocalScript_detail(id_script_detail:any){
     for(let i=0; i<this.script_details.length; i++){
       if(this.script_details[i]._id === id_script_detail){
         return this.script_details[i];
         break;
       }
     } 
     return null; 
   }
   /**
    * @example: 
    * let wallets = this.VhQuerySmhome.getlocalScript_details();
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalScript_details(){    
     return this.script_details;
   }
   
    /**
    * @example:
    * this.VhQuerySmhome.refreshLocalScript_details()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalScript_detail(), getlocalScript_details() trong localstorage
    * @return Promise => null
    */
   public refreshLocalScript_details():any{
     return new Promise((resolve) => { 
       this.getScript_details()
           .then(()=>{resolve(null)})       
     })
   }
   /**
    * @example:
    * this.VhQuerySmhome.addScript_detail({name:'camera 2', quantity:20, price:200000})
           .then((script_detail)=>{
             console.log('addScript_detail', script_detail);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addScript_detail(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('script_details', data)
           .then((script_detail)=>{
             resolve(script_detail);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.updateScript_detail('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateScript_detail', bool);
           })
    * @param id_script_detail 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateScript_detail(id_script_detail:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('script_details', id_script_detail, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.VhQuerySmhome.deleteScript_detail('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteScript_detail', bool);
         })
    * @param id_script_detail 
    * @return Promise => bool = true or false 
    */
   public deleteScript_detail(id_script_detail:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('script_details', id_script_detail)
           .then((bool:any)=>{            
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getScript_detail('5fb67fda87c0f21d484cbdf3')
             .then((script_detail)=>{
               console.log('getScript_detail', script_detail);
             })
    * @param id_script_detail 
    * @return Promise => obj ={} or null
    */
   public getScript_detail(id_script_detail:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('script_details', id_script_detail)
             .then((script_detail)=>{
               resolve(script_detail);
             })          
     })
   }
 
   /**
    * @example
    * this.VhQuerySmhome.getScript_details()
             .then((script_details)=>{
               console.log('getScript_details', script_details);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getScript_details(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('script_details')
             .then((script_details)=>{
               this.script_details = new Array();
               this.script_details = script_details;
               resolve(script_details);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
 
 
 
 }
 
 @Injectable()
 export class HttpLoaderFactory implements TranslateLoader  { 
     constructor(public http: HttpClient) {}
     getTranslation(lang: string): Observable<any>{       
         //let apiAddress:any = "192.168.0.7:8010/i18n/" + lang + ".json";
         //let apiAddress:any = AppConfig.API_URL+"/assets/i18n/"+ lang+".json";
         let apiAddress:any = "assets/i18n/"+ lang + ".json";
         return new Observable((observer:any) => {
           this.http.get(apiAddress).subscribe((res:any) => {                          
                     observer.next(res);
                     observer.complete();               
                 },error => {                             
                 // this.http.get("/assets/i18n/" + lang + ".json").subscribe((res: Response) => {
                 //     observer.next(res.json());
                 //     observer.complete();               
                 // })
             });
         });          
     }
 }
 
 @Injectable()
 export class DefaultLanguage {     
   constructor(private translate: TranslateService){}  
   public list(){ 
     let listRegion: Array<any> = [{ 
       id: "vn",
       name: "Vietnamese",
       icon: "assets/icon/vn.svg" 
     }, {
       id: "en",
       name: "English",
       icon: "assets/icon/en.svg"
     }]
     return listRegion;
   }
   public get():any{
     return  JSON.parse(<any>localStorage.getItem("vh_language"))['id'];
   }
 
   public set(value:any):any{ 
     this.translate.use(value);
     localStorage.setItem("vh_language", JSON.stringify(this.list().filter((item:any) => item.id == value)[0]))
   }
 
   public syncExistedLanguage() {
     const language = localStorage.getItem("vh_language");
     if (!language) {
       this.translate.setDefaultLang("en");
       localStorage.setItem("vh_language", JSON.stringify({ id: "en", name: "English", icon: "assets/icon/en.svg" }))
     } else {
       this.translate.use(JSON.parse(language)['id'])
     }
   }
 }
 
 @Injectable() 
 export class VhDriver {    
   private socketId = 0;      
   private win: any = window;
   private device = new Array();
   private ESC = "\u001B";
   private GS = "\u001D";
   private InitializePrinter = this.ESC + "@";
   private BoldOn = this.ESC + "E" + "\u0001";
   private BoldOff = this.ESC + "E" + "\0";
   private DoubleHeight = this.GS + "!" + "\u0001";
   private DoubleWidth = this.GS + "!" + "\u0010";
   private DoubleOn = this.GS + "!" + "\u0011"; //2x sized text (double-high + double-wide)
   private DoubleOff = this.GS + "!" + "\0";
   private PrintAndFeedMaxLine = this.ESC + "J" + "\u00FF"; //打印并走纸 最大255
   private TextAlignLeft = this.ESC + "a" + "0";
   private TextAlignCenter = this.ESC + "a" + "1";
   private TextAlignRight = this.ESC + "a" + "2";
   private commend =this.ESC + "t"+"19"; 
   private cutpaper = this.GS + "V" + "\u0001";
   private whiteblackmode =this.GS + "B" + "\u0001";
   private leftmargin =this.GS + "L" + "\u0101"  + "\u0101";
   private bitmap =this.ESC + "*" + "\0"  + "\u01100100"+"\0";      
   private font =this.ESC + 'M0';
   private linefeed =this.ESC + 'LF';
   private dots =this.ESC + '4A 20';
 
   constructor(private bluetoothSerial: BluetoothSerial) {
         
   }   
 
   /**
    * let div = document.getElementById('my-node')
    */
   public BluetoothSerialPrinter(){
     let _this=this;
     function connect(address:any){
       return _this.bluetoothSerial.connect(address);  
     }
     return {              
       search(){
         return _this.bluetoothSerial.list();
       },
       printInvoice(value:any, div:any){
         return new Promise<any>((resolve, reject)=>{         
           const divHeight = div.clientHeight; //calculate div height
           const divWidth = div.clientWidth; // calculate div width
           //allowTaint this to allow outsource image url 
           const options = {bgcolor:"white", height:divHeight , width:divWidth, size:value.size};
           //const options = {allowTaint : true,height :divHeight , width : divWidth  };
             
           domtoimage.toJpeg(div, options).then((imageUri:any)=>{    
             //alert('domtoimage');                               
             _this.encodeCommand(imageUri, options)
                 .then((res:any)=>{       
                   //alert('useEscPrintImage');                                             
                             var printCommand = _this.useEscPrintImage(res);                                                  
                             let xyz=connect(value.address).subscribe(data=>{
                               _this.bluetoothSerial.write(printCommand).then(dataz=>{
                                     //console.log("WRITE SUCCESS",dataz);
                                     xyz.unsubscribe();
                                     resolve(null);
                                   },errx=>{
                                     console.log("WRITE FAILED",errx);     
                                     resolve(null);       
                                   })
                             },err=>{
                               console.log("CONNECTION ERROR",err);        
                             })                                  
                 })
           })        
         })
       }   
     }
   }
 
 /**
  * let div = document.getElementById('my-node')
  * @returns 
  */
   public IPSerialPrinter(){
     let _this=this;
     function connect(value:any) {    
       return new Promise<any>((resolve, reject)=>{        
           chrome.sockets.tcp.create((createInfo:any)=>{
               chrome.sockets.tcp.connect(createInfo.socketId, value.ip, value.port,(result:any)=>{    
                   resolve(result);               
               });
           });
       })      
     }      
     function disconnect():any {         
       return new Promise<any>((resolve)=>{
         chrome.sockets.tcp.disconnect(_this.socketId, (result:any)=>{        
           resolve(result);
         });
       })      
     }
     return {
       printInvoice(value:any, div:any) {
         return new Promise<any>((resolve)=>{           
           let count = 0;
           let myInterval = setInterval(()=>{  
               count++;            
               chrome.sockets.tcp.create((createInfo:any)=>{
                 if(!_this.socketId){
                   _this.socketId = createInfo.socketId;              
                   let myTimeout = setTimeout(()=>{
                     clearTimeout(myTimeout);
                     //this.win  same (<any>window)
                     chrome.sockets.tcp.connect(createInfo.socketId, value.ip, value.port,(result:any)=>{   
                         //alert(result);                 
                         if (!result) {    
                           clearInterval(myInterval);   
                           //this.hideLoading(500);                   
                           const divHeight = div.clientHeight; //calculate div height
                           const divWidth = div.clientWidth; // calculate div width
                           //allowTaint this to allow outsource image url 
                           const options = {bgcolor:"white", height:divHeight , width:divWidth, size:value.size};
                           //const options = {allowTaint : true,height :divHeight , width : divWidth  };
                             
                           domtoimage.toJpeg(div, options).then((imageUri:any)=>{                                                              
                             _this.encodeCommand(imageUri, options)
                               .then((res:any)=>{                                                                              
                                   var printCommand = _this.useEscPrintImage(res);                                                  
                                   _this.rawPrint(_this.socketId, printCommand)
                                   .then(()=>{
                                     //chi cat giay                                                                         
                                     var command = new Uint8Array(8);                    
                                     command.set([0x1d, 0x56, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00], 0);
                                     _this.rawPrint(_this.socketId, command)
                                         .then(()=>{
                                           disconnect()
                                               .then(()=>{
                                                   _this.socketId = 0;  
                                                   resolve(true);                                               
                                               })                                     
                                           
                                         });
                                   })                                           
                               })
                           });                        
   
                         }
                     });
                   },1000);
                 }               
               });
             
             if(count > 16) {                  
               clearInterval(myInterval);  
               resolve(false);                 
             }
   
           },500);   
         })           
       }
     }
   }    
 
   private getImageData(image:any, opts:any) {
     if(image.width == 0 && image.height == 0)
     {
       //this.printInvoice();
     }
     else
     {
     opts = opts || {};
     opts.x = opts.x || 0;
     opts.y = opts.y || 0;
     opts.width = typeof opts.width === "number" ? opts.width : image.width;
     opts.height = typeof opts.height === "number" ? opts.height : image.height;      
     var canvas = document.createElement("canvas");
     var context:any = canvas.getContext("2d");
     canvas.width = opts.width;
     canvas.height = opts.height;
     context.drawImage(
       image,
       opts.x,
       opts.y,
       opts.width,
       opts.height,
       0,
       0,
       opts.width,
       opts.height
     );
     var imgData;
     try {
       imgData = context.getImageData(0, 0, opts.width, opts.height);
     } catch (e) {
       throw e;
     }
   
     return imgData;
     }
   }
 
   private rawPrint(socketId:any, uint8array:any):any {
     return new Promise<any>((resolve, reject)=>{
       chrome.sockets.tcp.send(socketId, uint8array.buffer, function (result:any) {      
         //this.InitializePrinter;
         //this.cutpaper;        
         //alert(result);
         resolve(result)
       });
     });
   } 
 
   private useEscPrintImage(img:any) {    
     var imageData:any = this.getImageData(img, 0);    
     this.threshold(imageData,'');    
     var piexlsData = this.rgbToPixel(imageData.data);    
     var width = img.width;
     var height = img.height;
     var printData = this.toEscPrintData(piexlsData, width, height);   
     return this.printImage(0, width, height, printData);
   }    
 
   private rgbToPixel(rgbs:any) {
     var piexlsData = [];
     for (var index = 0; index < rgbs.length; index += 4) {
       var R = rgbs[index];
       var G = rgbs[index + 1];
       var B = rgbs[index + 2];
       var A = rgbs[index + 3];
       var dot = (A << 24) + (R << 16) + (G << 8) + B;
       piexlsData.push(dot);
     }
     return piexlsData;
   }
 
   private threshold(image:any, threshold:any) {     
     if (threshold == void 0) {
       threshold = 180;
     }
     threshold = 180;
     for (var index = 0; index < image.data.length; index += 4) {
       var luminance = (image.data[index] * 0.299) + (image.data[index + 1] * 0.587) + (image.data[index + 2] * 0.114);
       var value = luminance < threshold ? 0 : 255;
       image.data.fill(value, index, index + 3);
     }
   }    
 
   private toEscPrintData(b:any, width:any, height:any) {
     var n = Math.floor((width + 7) / 8);
     var data = new Array(n * height);
     var mask = 0x01;
     for (var y = 0; y < height; y++) {
       for (var x = 0; x < n * 8; x++) {
         if (x < width) {
           if ((b[y * width + x] & 0x00ff0000) >> 16 != 0) {
             data[Math.floor(y * n + x / 8)] |= mask << (7 - x % 8);
           } else {
             data[Math.floor(y * n + x / 8)] &= ~mask << (7 - x % 8);
           }
         } else if (x >= width) {
           data[Math.floor(y * n + x / 8)] |= mask << (7 - x % 8);
         }
       }
     }
     for (var i = 0; i < data.length; i++) {
       data[i] = ~data[i];
     }
     return data;
   }
 
   private encodeCommand(imageUri:any, options:any):any{   
     return new Promise<any>((resolve, reject)=>{
       var c = document.createElement('canvas');
       var ctx:any = c.getContext('2d');
       var img = new Image();
       //8dot/mm
       let size = 568;
       if(options.size == 'K57') size = 400;
       else if(options.size == 'K80') size = 600;
       else if((options.size == 'A4')||(options.size == 'A5')) size = 1500;
       //lỗi thường xảy ra ở onload này, khắc phục npm install rxjs@6.0.0
       img.onload = function () {      
         var aux = this;      
         c.width = size;    
         c.height = options.height*size/options.width + 100;    
         ctx.drawImage(img, 0, 0, size, options.height*size/options.width);      
         //var dataURL = c.toDataURL('image/jpeg');     
         resolve(c);
       };    
       img.src = imageUri;  
       //let imgData = canvas.toDataURL("image/PNG");
     //  var img = new Image();
     //  img.onload = function () {       
     //     resolve(img);        
     //  };    
     //  img.src = canvas;//imgData;
     })
   }
 
   private PrintAndFeedLine(verticalUnit:any) {
     this.ESC = "\u001B";
     if (verticalUnit > 255)
         verticalUnit = 255;
     if (verticalUnit < 0)
         verticalUnit = 0;
     return this.ESC + "J" + String.fromCharCode(verticalUnit);
   }
 
   private CutAndFeedLine(verticalUnit:any) {        
         this.ESC = "\u001B";
         if (verticalUnit === void 0) {
             return this.ESC + "V" + 1;
         }
         if (verticalUnit > 255)
             verticalUnit = 255;
         if (verticalUnit < 0)
             verticalUnit = 0;
         return this.ESC + "V" + String.fromCharCode(verticalUnit);
     }
 
   private printAndFeedLine(verticalUnit:any) {
       if (verticalUnit > 255) verticalUnit = 255;
       if (verticalUnit < 0) verticalUnit = 0;
       return this.ESC + "J" + String.fromCharCode(verticalUnit);
   }
 
   private cutAndFeedLine(verticalUnit:any) {
       if (verticalUnit === void 0) {
         return this.ESC + "V" + 1;
       }
       if (verticalUnit > 255) verticalUnit = 255;
       if (verticalUnit < 0) verticalUnit = 0;
       return this.ESC + "V" + 66 + String.fromCharCode(verticalUnit);
   }
 
   private printImage(mode:any, width:any, height:any, bitmapArray:any) {   
     var xL = Math.floor(((width + 7) / 8) % 256);
     var xH = Math.floor((width + 7) / 8 / 256);
     var yL = Math.floor(height % 256);
     var yH = Math.floor(height / 256);
     //var command = new Uint8Array(8);        
     var command = new Uint8Array(bitmapArray.length + 8);       
     //GS V 0
     //command.set([0x1d, 0x56, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00], 0);//chi cat giay
     //command.set([0x1d, 0x56, 0x01, 0x00, xL, xH, yL, yH], 0);
     //command.set([0x1d, 0x56, 0x01, mode & 0x1, xL, xH, yL, yH], 0);     
 
     //command.set([0x1d, 0x2a, 0x30, mode & 0x1, xL, xH, yL, yH], 0);     
     command.set([0x1d, 0x76, 0x30, mode & 0x1, xL, xH, yL, yH], 0);      
     //command.set([0x1d, 0x56, 0x01, 0x00, xL, xH, yL, yH], 0); 
     command.set(bitmapArray, 8);
     
     return command;
 }
 
 
   
 }
    
 
 @Injectable()
 export class VhMqttService {  
   boolean = true;  
   constructor(
     private mqttService: MqttService, private wifiWizard2: WifiWizard2
   ) {}
    
   // topic(deviceId: string): Observable<IMqttMessage> {
   //   let topicName = `/${deviceId}/${deviceId}`;  
   //   console.log('topicName', topicName);   
   //   return this.mqttService.observe(deviceId);
   // }
 
   /**
    * @example:
    * this.subscription = this.vhMqttService.callbackTopic(this.iot_id+this.iot_topic_string).subscribe((data)=>{      
         //Cách dùng 1:        
           let value = {
             topic: data.topic,
             value: data.payload.toString(),
             date : new Date()
           };     
         //Cách dùng 2:        
           let value = {
             topic: data.topic,
             value: this.vhAlgorithmconvert_STRING2OBJECT(data.payload.toString()),
             date : new Date()
           };      
         //Cách dùng 3:  
           let json = this.vhAlgorithmconvert_STRING2OBJECT(data.payload.toString());
         }) 
    * Lưu ý:
    * import { Subscription } from 'rxjs';
    * subscription: Subscription;
    * this.subscription = callbackTopic....
    * if (this.subscription)  this.subscription.unsubscribe();    
    * @param iotID 
    * @param topic 
    */
   public callbackTopic(iotID:any, topic?:any):Observable<IMqttMessage>{          
     if(topic === undefined) return this.mqttService.observe(iotID);
     else return this.mqttService.observe(iotID + topic);    
   } 
 
   /**
    * @example 1:
    * let obj = {
                  ptype:1,
                  value: {
                           slave:2,
                           addr:3100
                         }
                 };
       this.vhMqttService.publish(this.iot_id, this.vhAlgorithmconvert_OBJECT2STRING(obj));          
    * @example 2:
       this.vhMqttService.publish("CCC27BAE114C", "{\"ptype\":1,\"value\":{\"slave\":2,\"addr\":3100}}");
    * @param iotID 
    * @param message 
    * @param topic 
    */
   public publish(iotID:any, message: any, topic?:any): void {
     if(topic === undefined) this.mqttService.unsafePublish(iotID, message, {qos: 1, retain: false});
     else this.mqttService.unsafePublish(iotID + topic, message, {qos: 1, retain: false});   
     // if(isUndefined(topic)) this.mqttService.unsafePublish(iotID, message);
     // else this.mqttService.unsafePublish(iotID + topic, message);    
   } 
 
  
   /**
    * @example:
    * let value:any = {
         ssid: 'Carol-BH',
         password: '123456789'
       }
     this.vhMqttService.startESPsmartconfig(value)
         .then(iotid=>{
           if(iotid != ''){
             console.log('iotid', iotid)
           }          
         },(error:any)=>{
           console.log(error);
         }) 
    * @param value 
    * @return Promise => iotid
    */
   public startESPsmartconfig(value:any){
     return new Promise((resolve, reject) => {   
       this.wifiWizard2.getConnectedBSSID()
           .then((bssid_router)=>{
             //console.log('my wifi: ', bssid_router);          
             esptouch.start(value.ssid, bssid_router, value.password, "1", "1",
                 (result:any) => { 
                   //console.log('your bssid', result.bssid); 
                   //console.log('your ip', result.ip);              
                   let iotid = '';
                   //let position = result.indexOf('bssid=');
                   //let position
                   if(result.bssid){
                     //let bssid_device = result.substr(position + 6, 12);                 
                     iotid = this.getIotID(result.bssid);   
                     //console.log('iotid', iotid);     
                     if(iotid === '') console.log('vui lòng 1, báo với anh Huy lỗi này startESPsmartconfig');      
                     resolve(iotid);   
                   }else{
                     if(iotid === '') console.log('vui lòng 2, báo với anh Huy lỗi này startESPsmartconfig');      
                     resolve(iotid);  
                   }                         
                 },
                 (error:any) => {     
                   console.log('error', error);                      
                   reject(error);
                 })          
           },
           (error1:any) => {        
             console.log('error1', error1);         
             reject(error1);          
           }) 
        
     })
     // return new Promise((resolve, reject) => {    
     //   this.wifiWizard2.getConnectedBSSID()
     //     .then((bssid_router)=>{
     //       console.log('my wifi: ', bssid_router);          
     //       esptouch.startSearch(value.ssid, value.password,
     //           (result:any) => {   
     //             console.log('result1', result);            
     //             let iotid = '';
     //             let position = result.indexOf('bssid = ');
     //             if(position != -1){
     //               let bssid_device = result.substr(position, 12);                 
     //               iotid = this.getIotID(bssid_device);   
     //               if(iotid === '') console.log('vui lòng 1, báo với anh Huy lỗi này startESPsmartconfig');      
     //               resolve(iotid);   
     //             }else{
     //               if(iotid === '') console.log('vui lòng 2, báo với anh Huy lỗi này startESPsmartconfig');      
     //               resolve(iotid);  
     //             }                         
     //           },
     //           (error:any) => {     
     //             console.log('error', error);                      
     //             reject(error);
     //           })          
     //      },
     //     (error1:any) => {        
     //       console.log('error1', error1);         
     //       reject(error1);          
     //     })        
     // })
   }
 
   public stopESPsmartconfig(){
     return new Promise((resolve, reject) => {   
       esptouch.stop(
         (res:any) => { 
           console.log('res', res);    
           resolve(res) 
         }, 
         (err:any) => {  
           console.log('err', err);    
           reject(err) 
         });
     })
     // return new Promise((resolve, reject) => {   
     //   esptouch.stopSearch(
     //     (res:any) => { 
     //       console.log('res', res);    
     //       resolve(res) 
     //     }, 
     //     (err:any) => {  
     //       console.log('err', err);    
     //       reject(err) 
     //     });
     // })
   }
 
   /**
    * @example:
    * this.vhMqttService.getConnectedSSID()
         .then((ssid)=>{
           console.log('ssid: ', ssid);
         }) 
    * @return Promise => SSID
    */
   public getConnectedSSID(){
      return new Promise((resolve, reject) => {   
       this.wifiWizard2.getConnectedSSID()
         .then((result)=>{
           resolve(result);
         })  
     })
   }
   
   private getIotID(value:any){
     let bssid:any = value;
     let iotid: any =''; 
     if(bssid.length === 12){
       let int1_str = bssid.slice(0,4);         
       let int1_dec = parseInt( int1_str, 16 );  
       let int2_str = bssid.slice(4,8);         
       let int2_dec = parseInt( int2_str, 16 );  
       let int3_str = bssid.slice(8,12);         
       let int3_dec = parseInt( int3_str, 16 );  
       if(parseInt( int3_str, 16 )%2) {
         int1_dec = int1_dec>>>1;
         int1_dec += parseInt( '8000', 16 );
       }
       else int1_dec = int1_dec>>>1;   
       if(parseInt( int1_str, 16 )%2) {
         int2_dec = int2_dec>>>1;
         int2_dec += parseInt( '8000', 16 );
       }
       else int2_dec = int2_dec>>>1;  
       if(parseInt( int2_str, 16 )%2) {
         int3_dec = int3_dec>>>1;
         int3_dec += parseInt( '8000', 16 );
       }
       else int3_dec = int3_dec>>>1;   
       let str1 = '0000'; let str2 = '0000'; let str3 = '0000'; 
       if((int1_dec.toString(16)).length === 1) str1 = '000' + int1_dec.toString(16);  
       else if((int1_dec.toString(16)).length === 2) str1 = '00' + int1_dec.toString(16);   
       else if((int1_dec.toString(16)).length ===3) str1 = '0' + int1_dec.toString(16);
       else if((int1_dec.toString(16)).length ===4) str1 = int1_dec.toString(16);
 
       if((int2_dec.toString(16)).length ===1) str2 = '000' + int2_dec.toString(16);  
       else if((int2_dec.toString(16)).length ===2) str2 = '00' + int2_dec.toString(16);   
       else if((int2_dec.toString(16)).length ===3) str2 = '0' + int2_dec.toString(16);
       else if((int2_dec.toString(16)).length ===4) str2 = int2_dec.toString(16);
 
       if((int3_dec.toString(16)).length ===1) str3 = '000' + int3_dec.toString(16);  
       else if((int3_dec.toString(16)).length ===2) str3 = '00' + int3_dec.toString(16);   
       else if((int3_dec.toString(16)).length ===3) str3 = '0' + int3_dec.toString(16);
       else if((int3_dec.toString(16)).length ===4) str3 = int3_dec.toString(16);
       
       iotid = str1.slice(0,1) + str2 + str3;          
       if(iotid === '000000000000') iotid ='';
       if(iotid.length !=9) iotid ='';
     }
     return iotid;
   }
 
 
  
 }
 
 @Injectable()
 export class VhQuerySalesWebUser{    
   constructor(
     private vhMGDB_database: VhMGDB_database, 
     private vhQuery:VhQuery, 
     private vhAuth: VhAuth, 
     private vhAlgorithm:VhAlgorithm
     ) {}
 
 /**
    * @example
    * this.vhQuerySalesWebUser.getBranch('5fb67fda87c0f21d484cbdf3')
             .then((branch)=>{
               console.log('getBranch', branch);
             },(error:any)=>{
               reject(error);
             })  
    * @param id_branch 
    * @return Promise => obj ={} or null
    */
   public getBranch(id_branch:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('branchs', id_branch)
             .then((branch)=>{
               resolve(branch);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySalesWebUser.getBranchs()
             .then((branchs)=>{
               console.log('getBranchs', branchs);
             },(error:any)=>{
               reject(error);
             })  
     * @return Promise => array(object) = [{},{},..]
     */
   public getBranchs(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('branchs')
             .then((branchs)=>{              
               resolve(branchs);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySalesWebUser.getProduct('5fb67fda87c0f21d484cbdf3')
             .then((product)=>{
               console.log('getProduct', product);
             }, error=>{
               reject(error)
             }) 
     * @param id_product 
     * @return false or object
     */
   public getProduct(id_product:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.getDoc('products', id_product)
             .then((product)=>{
               resolve(product);
             }, error=>{
               reject(error)
             })          
     })
   }
 
    /**
    * @example:
    * this.vhQuerySalesWebUser.getProductsByFields({name:{$eq:'name abc'}}, {},{},0)
           .then((products)=>{
             console.log('getProductsByFields', products);
           },(error:any)=>{
             console.log('error', error);
           })
   * @param query
   * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
   * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
   * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
   * @return — Array -> array = [{},{},...] 
   */
   public getProductsByFields(query: object, projection?:object, sort?:object, limit?:number){
     return new Promise((resolve, reject) => {
       this.vhQuery.getDocsByFields('products', query, projection,sort,limit)
           .then((products)=>{
             resolve(products);           
           }, error=>{
             reject(error)
           }) 
     })
   }
 
   /**
    * @example
    * this.vhQuerySalesWebUser.getCategory('5fb67fda87c0f21d484cbdf3')
             .then((category)=>{
               console.log('getCategory', category);
             })
    * @param id_category 
    * @return Promise => obj ={} or null
    */
   public getCategory(id_category:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('categorys', id_category)
             .then((category)=>{
               resolve(category);
             })          
     })
   }
  /**
    * @example
    * this.vhQuerySalesWebUser.getCategorys()
             .then((categorys)=>{
               console.log('getCategorys', categorys);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getCategorys(){
     return new Promise((resolve, reject) => {     
       this.vhMGDB_database.getDocs('categorys')
             .then((categorys)=>{             
               resolve(categorys);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
   
  /**
    * @example:
    * this.vhQuerySalesWebUser.getCategorysByFields({name:{$eq:'name abc'}}, {},{},0)
       .then((categorys)=>{
         console.log('getCategorysByFields', categorys);
       })
   * @param query
   * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
   * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
   * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
   * @return — Array -> array = [{},{},...] 
   */
   public getCategorysByFields(query: object, projection?:object, sort?:object, limit?:number){
     return new Promise((resolve) => {
       this.vhQuery.getDocsByFields('categorys', query, projection,sort,limit)
           .then((categorys)=>{
             resolve(categorys);           
           })
     })
   }
 
 }
 
 @Injectable()
 export class VhQuerySalesWebAdmin{   
   constructor(
     private vhMGDB_database: VhMGDB_database, 
     private vhQuery:VhQuery, private vhAuth: VhAuth, 
     private vhAlgorithm:VhAlgorithm
     ) {}
 
   /**
    * @example
    * this.vhQuerySalesWebAdmin.getBranch('5fb67fda87c0f21d484cbdf3')
             .then((branch)=>{
               console.log('getBranch', branch);
             },(error:any)=>{
               reject(error);
             })  
    * @param id_branch 
    * @return Promise => obj ={} or null
    */
   public getBranch(id_branch:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('branchs', id_branch)
             .then((branch)=>{
               resolve(branch);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQuerySalesWebAdmin.getBranchs()
             .then((branchs)=>{
               console.log('getBranchs', branchs);
             },(error:any)=>{
               reject(error);
             })  
    * @return Promise => array(object) = [{},{},..]
    */
   public getBranchs(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('branchs')
             .then((branchs)=>{              
               resolve(branchs);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
   
   /**
    * @example:
    * this.vhQuerySalesWebAdmin.addProduct({name:'camera 2', quantity:20, price:200000})
           .then((product)=>{
             console.log('addProduct', product);
           }, error=>{
             console.log('error', error);
           })
    * @param data : object
    * @return Promise => object = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addProduct(data:any){
     return new Promise((resolve, reject) => {    
       if(data?.type === 1) {
         this.getBranchs()
             .then((branchs:any)=>{             
               data.quantity = 0; data.quantity_branch = {};
               branchs.forEach((element:any) => {
                 data.quantity_branch[element._id] = 0;
               }); 
               this.vhMGDB_database.addDoc('products', data)
                   .then((obj)=>{
                     resolve(obj);
                   }, error=>{
                     reject(error)
                   })  
             },(error:any)=>{
               reject(error);
             }) 
         
       }else{
         this.vhMGDB_database.addDoc('products', data)
             .then((obj)=>{
               resolve(obj);
             }, error=>{
               reject(error)
             }) 
       }                    
     })
   }
 
 
   /**
    * @example:
    * this.vhQuerySalesWebAdmin.updateProduct('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateProduct', bool);
           }, error=>{
             console.log('error', error);
           })
     * @param id_product 
     * @param data 
     * @return Promise => bool = true or false
     */
   public updateProduct(id_product:string, data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.updateDoc('products', id_product, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })         
     })
   }
   
   /**
    * @example:
    * this.vhQuerySalesWebAdmin.deleteProduct('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteDoc', bool);
         }, error=>{
           reject(error)
         })
     * @param id_product 
     * @return Promise => bool = true or false
     */
   public deleteProduct(id_product:string){  
     return new Promise((resolve, reject) => {      
         this.vhMGDB_database.getDocsByFields('vhbill_details', {id_product:{$eq:id_product}},{},{},1)
           .then((vhbill_details:any)=>{                      
             if(vhbill_details.length===0){              
               this.vhMGDB_database.deleteDoc('products', id_product)  
                   .then((bool:any)=>{                   
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   }) 
             }else resolve(false);
           }, error=>{
             reject(error)
           })                   
     })   
   }
 
   /**
    * @example
    * this.vhQuerySalesWebAdmin.getProduct('5fb67fda87c0f21d484cbdf3')
             .then((product)=>{
               console.log('getProduct', product);
             })
     * @param id_product 
     * @return false or object
     */
   public getProduct(id_product:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('products', id_product)
             .then((product)=>{
               resolve(product);
             })          
     })
   }
 
    /**
    * @example:
    * this.vhQuerySalesWebAdmin.getProductsByFields({name:{$eq:'name abc'}}, {},{},0)
       .then((products)=>{
         console.log('getProductsByFields', products);
       })
   * @param query
   * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
   * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
   * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
   * @return — Array -> array = [{},{},...] 
   */
   public getProductsByFields(query: object, projection?:object, sort?:object, limit?:number){
     return new Promise((resolve) => {
       this.vhQuery.getDocsByFields('products', query, projection,sort,limit)
           .then((products)=>{
             resolve(products);           
           })
     })
   }
 
   /**
    * @example:
    * this.vhQuerySalesWebAdmin.addCategory({name:'Danh mục 1'})
           .then((category)=>{
             console.log('addCategory', category);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addCategory(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('categorys', data)
           .then((category)=>{
             resolve(category);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
 
   /**
    * @example:
    * this.vhQuerySalesWebAdmin.updateCategory('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateCategory', bool);
           })
    * @param id_category 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateCategory(id_category:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('categorys', id_category, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQuerySalesWebAdmin.deleteCategory('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteCategory', bool);
         })
    * @param id_category 
    * @return Promise => bool = true or false 
    */
   public deleteCategory(id_category:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.getDocsByFields('products', {id_category:{$eq:id_category}},{},{},1)
           .then((products:any)=>{                      
             if(products.length===0){              
               this.vhMGDB_database.deleteDoc('categorys', id_category)
                   .then((bool:any)=>{            
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   })    
             }else resolve(false);
           }, error=>{
             reject(error)
           })             
     })
   }
 
   /**
    * @example
    * this.vhQuerySalesWebAdmin.getCategory('5fb67fda87c0f21d484cbdf3')
             .then((category)=>{
               console.log('getCategory', category);
             })
    * @param id_category 
    * @return Promise => obj ={} or null
    */
   public getCategory(id_category:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('categorys', id_category)
             .then((category)=>{
               resolve(category);
             })          
     })
   }
 
    /**
    * @example
    * this.vhQuerySalesWebAdmin.getCategorys()
             .then((categorys)=>{
               console.log('getCategorys', categorys);
             })
    * @return Promise => array(object) = [{},{},..]
    */
     public getCategorys(){
       return new Promise((resolve, reject) => {     
         this.vhMGDB_database.getDocs('categorys')
               .then((categorys)=>{                
                 resolve(categorys);
               },(error:any)=>{
                 reject(error);
               })          
       })
     }
 
  /**
    * @example:
    * this.vhQuerySalesWebAdmin.getCategorysByFields({name:{$eq:'name abc'}}, {},{},0)
       .then((categorys)=>{
         console.log('getCategorysByFields', categorys);
       })
   * @param query
   * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
   * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
   * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
   * @return — Array -> array = [{},{},...] 
   */
   public getCategorysByFields(query: object, projection?:object, sort?:object, limit?:number){
     return new Promise((resolve) => {
       this.vhQuery.getDocsByFields('categorys', query, projection,sort,limit)
           .then((categorys)=>{
             resolve(categorys);           
           })
     })
   }
 
 }
 
 @Injectable()
 export class VhQueryCafeWebUser{    
   constructor(
     private vhMGDB_database: VhMGDB_database, 
     private vhQuery:VhQuery, private vhAuth: VhAuth, 
     private vhAlgorithm:VhAlgorithm
     ) {}
 
 /**
    * @example
    * this.vhQueryCafeWebUser.getBranch('5fb67fda87c0f21d484cbdf3')
             .then((branch)=>{
               console.log('getBranch', branch);
             },(error:any)=>{
               reject(error);
             })  
    * @param id_branch 
    * @return Promise => obj ={} or null
    */
   public getBranch(id_branch:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('branchs', id_branch)
             .then((branch)=>{
               resolve(branch);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCafeWebUser.getBranchs()
             .then((branchs)=>{
               console.log('getBranchs', branchs);
             },(error:any)=>{
               reject(error);
             })  
     * @return Promise => array(object) = [{},{},..]
     */
   public getBranchs(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('branchs')
             .then((branchs)=>{              
               resolve(branchs);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCafeWebUser.getProduct('5fb67fda87c0f21d484cbdf3')
             .then((product)=>{
               console.log('getProduct', product);
             }, error=>{
               reject(error)
             }) 
     * @param id_product 
     * @return false or object
     */
   public getProduct(id_product:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.getDoc('products', id_product)
             .then((product)=>{
               resolve(product);
             }, error=>{
               reject(error)
             })          
     })
   }
 
    /**
    * @example:
    * this.vhQueryCafeWebUser.getProductsByFields({name:{$eq:'name abc'}}, {},{},0)
           .then((products)=>{
             console.log('getProductsByFields', products);
           },(error:any)=>{
             console.log('error', error);
           })
   * @param query
   * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
   * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
   * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
   * @return — Array -> array = [{},{},...] 
   */
   public getProductsByFields(query: object, projection?:object, sort?:object, limit?:number){
     return new Promise((resolve, reject) => {
       this.vhQuery.getDocsByFields('products', query, projection,sort,limit)
           .then((products)=>{
             resolve(products);           
           }, error=>{
             reject(error)
           }) 
     })
   }
 
   /**
    * @example
    * this.vhQueryCafeWebUser.getCategory('5fb67fda87c0f21d484cbdf3')
             .then((category)=>{
               console.log('getCategory', category);
             })
    * @param id_category 
    * @return Promise => obj ={} or null
    */
   public getCategory(id_category:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('categorys', id_category)
             .then((category)=>{
               resolve(category);
             })          
     })
   }
  /**
    * @example
    * this.vhQueryCafeWebUser.getCategorys()
             .then((categorys)=>{
               console.log('getCategorys', categorys);
             })
    * @return Promise => array(object) = [{},{},..]
    */
   public getCategorys(){
     return new Promise((resolve, reject) => {     
       this.vhMGDB_database.getDocs('categorys')
             .then((categorys)=>{             
               resolve(categorys);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
   
  /**
    * @example:
    * this.vhQueryCafeWebUser.getCategorysByFields({name:{$eq:'name abc'}}, {},{},0)
       .then((categorys)=>{
         console.log('getCategorysByFields', categorys);
       })
   * @param query
   * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
   * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
   * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
   * @return — Array -> array = [{},{},...] 
   */
   public getCategorysByFields(query: object, projection?:object, sort?:object, limit?:number){
     return new Promise((resolve) => {
       this.vhQuery.getDocsByFields('categorys', query, projection,sort,limit)
           .then((categorys)=>{
             resolve(categorys);           
           })
     })
   }
 
 }
 
 @Injectable()
 export class VhQueryCafeWebAdmin{  
   private products: any = new Array(); 
   constructor(
     private vhMGDB_database: VhMGDB_database, 
     private vhQuery:VhQuery, private vhAuth: VhAuth, 
     private vhAlgorithm:VhAlgorithm
   ) {}
 
   private getlocalProductAndCombosAndToppings(id_product:any){
     let _products:any = new Array();
     for(let i=0; i<this.products.length; i++){
       if(this.products[i]._id === id_product){      
         _products.push({...this.products[i]});
         if(this.products[i].subs != undefined){
           let _subs = [...this.products[i].subs];         
           _products[_products.length-1].subs = new Array();
           _subs.forEach(sub => {_products[_products.length-1].subs.push({...sub})});     
         }      
       }
 
       if(this.products[i].combos != undefined)
         for(let j=0; j<this.products[i].combos.length; j++){
           if(this.products[i].combos[j].id_product === id_product){
             _products.push({...this.products[i]});
             break;
           }
         }
 
       if(this.products[i].toppings != undefined)
         for(let j=0; j<this.products[i].toppings.length; j++){
           if(this.products[i].toppings[j].id_product === id_product){
             _products.push({...this.products[i]});
             break;
           }
         }  
       
     }
     return _products;
   }  
 
     /**
    * @example: 
    * let product = this.vhQueryCafe.getlocalProduct('5fb6780ca2148e09806c5b01');
    * @param id_product 
    * @return Object => obj = {} or null
    */
   private getlocalProduct(id_product:any){
   for(let i=0; i<this.products.length; i++){
     if(this.products[i]._id === id_product){      
       let _product = {...this.products[i]};
       if(_product.subs != undefined){
         let _subs = [..._product.subs];         
         _product.subs = new Array();
         _subs.forEach(sub => {_product.subs.push({...sub})});     
       }   
       if(_product.toppings != undefined){
         let _toppings = [..._product.toppings];         
         _product.toppings = new Array();
         _toppings.forEach(topping => {_product.toppings.push({...topping})});     
       }
       if(_product.combos != undefined){
         let _combos = [..._product.combos];         
         _product.combos = new Array();
         _combos.forEach(combo => {_product.combos.push({...combo})});     
       }
       return _product;
     }
   }
   return null; 
 }
 
   /**
    * @example
    * this.vhQueryCafeWebAdmin.getBranch('5fb67fda87c0f21d484cbdf3')
             .then((branch)=>{
               console.log('getBranch', branch);
             },(error:any)=>{
               reject(error);
             })  
    * @param id_branch 
    * @return Promise => obj ={} or null
    */
   public getBranch(id_branch:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('branchs', id_branch)
             .then((branch)=>{
               resolve(branch);
             })          
     })
   }
 
   /**
    * @example
    * this.vhQueryCafeWebAdmin.getBranchs()
             .then((branchs)=>{
               console.log('getBranchs', branchs);
             },(error:any)=>{
               reject(error);
             })  
    * @return Promise => array(object) = [{},{},..]
    */
   public getBranchs(){
     return new Promise((resolve, reject) => {      
       this.vhMGDB_database.getDocs('branchs')
             .then((branchs)=>{              
               resolve(branchs);
             },(error:any)=>{
               reject(error);
             })          
     })
   }
   
 /**
  * @example:
  * this.vhQueryCafeWebAdmin.addProduct({name:'camera 2', quantity:20, price:200000})
         .then((product)=>{
           console.log('addProduct', product);
         }, error=>{
           console.log('error', error);
         })
   * @param data 
   * @return Promise => object = {}
   * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
   */
   public addProduct(data:any){
     return new Promise((resolve, reject) => {    
       if(data?.type === 3) {
         this.getBranchs()
             .then((branchs:any)=>{             
               data.quantity = 0; data.quantity_branch = {};
               branchs.forEach((element:any) => {
                 data.quantity_branch[element._id] = 0;
               }); 
               this.vhMGDB_database.addDoc('products', data)
                   .then((obj)=>{
                     resolve(obj);
                   }, error=>{
                     reject(error)
                   })  
             },(error:any)=>{
               reject(error);
             }) 
         
       }else{
         this.vhMGDB_database.addDoc('products', data)
             .then((obj)=>{
               resolve(obj);
             }, error=>{
               reject(error)
             }) 
       }                    
     })
   }
   
   /**
    * @example:
    * this.vhQueryCafeWebAdmin.addSubsProduct('5fb6780ca2148e09806c5b01',[{price:0, name:'small'},{},...])
           .then((subproducts)=>{
             console.log('addSubsProduct', subproducts);
           }, error=>{
             console.log('error', error);
           })
    * @param id_product 
    * @param id_product 
    * @return Promise => object = {} hoặc null
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là null
    */
   public addSubsProduct(id_product:any, dataArray:any){
     return new Promise((resolve, reject) => {       
         let subs = new Array();
         for(let i=0; i<dataArray.length; i++){        
           subs[i] = {...dataArray[i], _id:this.vhAlgorithm.ObjectId()};   
         }              
         this.vhMGDB_database.getDoc('products', id_product)
             .then((product:any)=>{
               if(product){
                 if(product.subs === undefined)  product.subs = new Array();                              
                 let _subs = [...product.subs, ...subs];                         
                 this.vhMGDB_database.updateDoc('products', id_product, {subs:_subs})
                     .then(()=>{                     
                       resolve(subs);
                     }, error=>{                                     
                       resolve(null);
                     }) 
               }else resolve(null);
               
             })                       
     })
   }
 
   /**
    * @example:
    * this.vhQueryCafeWebAdmin.updateSubProduct('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateSubProduct', bool);
           }, error=>{
             console.log('error', error);
           })
    * @param id_product 
    * @param id_subproduct       
    * @param data 
    * @return Promise => bool = true or false
    */
   public updateSubProduct(id_product: string, id_subproduct:string, data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.getDoc('products', id_product)
             .then((product:any)=>{
               if(!product) resolve(false); 
               if(product.subs === undefined) resolve(false);
               let index = -1;
               for(let j=0; j<product.subs.length; j++){
                 if(product.subs[j]._id === id_subproduct){
                   index = j;  
                   break;
                 }
               }   
               if(index === -1) resolve(false);
               else{
                 product.subs[index] = {...product.subs[index],...data};              
                   this.vhMGDB_database.updateDoc('products', product._id, {subs: product.subs})
                       .then((bool:any)=>{
                         resolve(bool);
                       }, error=>{
                         reject(error)
                       }) 
               }
               
             })  
                          
     })
   }
 
   /**
    * @example:
    * this.vhQueryCafeWebAdmin.deleteSubProduct('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteDoc', bool);
         }, error=>{
           reject(error)
         })
     * @param id_product 
     * @param id_subproduct      
     * @return Promise => bool = true or false
     */
   public deleteSubProduct(id_product: string, id_subproduct:string){//tạm thời dùng hàm này, vì web ko lưu products trên local
     return new Promise((resolve, reject) => {
       let IDproducts = new Array();
       this.getlocalProductAndCombosAndToppings(id_product).forEach((doc:any) => {
         IDproducts.push(doc._id);
       }); 
       if(IDproducts.length === 1){
             this.vhMGDB_database.getDocsByFields('vhbill_details', {id_subproduct:{$eq:id_subproduct}},{},{},1)
                 .then((vhbill_details:any)=>{                      
                   if(vhbill_details.length===0){   
                     let product:any = this.getlocalProduct(id_product);           
                     if(product.subs != undefined)
                       for(let j=0; j<product.subs.length; j++){
                         if(product.subs[j]._id === id_subproduct){
                           product.subs.splice(j,1);                      
                           this.vhMGDB_database.updateDoc('products', product._id, {subs: product.subs})
                               .then((bool:any)=>{
                                 resolve(bool);
                               }, error=>{
                                 reject(error)
                               }) 
                           break;
                         }
                       }                                   
                     //resolve(true)
                   }else resolve(false);
                 }, error=>{
                   reject(error)
                 })  
       }else{
         console.log('Bạn không thể xóa, vì sản phẩm đang liên kết với sản phẩm khác')
         resolve(false);
       }             
     })
   } 
 
 
   /**
    * @example:
    * this.vhQueryCafeWebAdmin.updateProduct('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateProduct', bool);
           }, error=>{
             console.log('error', error);
           })
     * @param id_product 
     * @param data 
     * @return Promise => bool = true or false
     */
   public updateProduct(id_product:string, data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.updateDoc('products', id_product, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })         
     })
   }
   
   /**
    * @example:
    * this.vhQueryCafeWebAdmin.deleteProduct('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteDoc', bool);
         }, error=>{
           reject(error)
         })
     * @param id_product 
     * @return Promise => bool = true or false
     */
   public deleteProduct(id_product:string){  
     return new Promise((resolve, reject) => {      
         this.vhMGDB_database.getDocsByFields('vhbill_details', {id_product:{$eq:id_product}},{},{},1)
           .then((vhbill_details:any)=>{                      
             if(vhbill_details.length===0){              
               this.vhMGDB_database.deleteDoc('products', id_product)  
                   .then((bool:any)=>{                   
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   }) 
             }else resolve(false);
           }, error=>{
             reject(error)
           })                   
     })   
   }
 
   /**
    * @example
    * this.vhQueryCafeWebAdmin.getProduct('5fb67fda87c0f21d484cbdf3')
             .then((product)=>{
               console.log('getProduct', product);
             })
     * @param id_product 
     * @return false or object
     */
   public getProduct(id_product:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('products', id_product)
             .then((product)=>{
               resolve(product);
             })          
     })
   }
 
    /**
    * @example:
    * this.vhQueryCafeWebAdmin.getProductsByFields({name:{$eq:'name abc'}}, {},{},0)
       .then((products)=>{
         console.log('getProductsByFields', products);
       })
   * @param query
   * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
   * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
   * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
   * @return — Array -> array = [{},{},...] 
   */
   public getProductsByFields(query: object, projection?:object, sort?:object, limit?:number){
     return new Promise((resolve) => {
       this.vhQuery.getDocsByFields('products', query, projection,sort,limit)
           .then((products)=>{
             this.products = cloneDeep(products); 
             resolve(products);           
           })
     })
   }
 
   /**
    * @example:
    * this.vhQueryCafeWebAdmin.addCategory({name:'Danh mục 1'})
           .then((category)=>{
             console.log('addCategory', category);
           },(error:any)=>{
             console.log('error', error);
           })
    * @param colname 
    * @param data 
    * @return  Promise => obj = {}
    * Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addCategory(data:object){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.addDoc('categorys', data)
           .then((category)=>{
             resolve(category);
           },(error:any)=>{
             reject(error);
           })         
     })
   }
 
 
   /**
    * @example:
    * this.vhQueryCafeWebAdmin.updateCategory('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateCategory', bool);
           })
    * @param id_category 
    * @param data 
    * @return Promise => bool = true or false 
    */
   public updateCategory(id_category:string, data:object){
     return new Promise((resolve,reject) => {
       this.vhMGDB_database.updateDoc('categorys', id_category, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhQueryCafeWebAdmin.deleteCategory('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteCategory', bool);
         })
    * @param id_category 
    * @return Promise => bool = true or false 
    */
   public deleteCategory(id_category:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.getDocsByFields('products', {id_category:{$eq:id_category}},{},{},1)
           .then((products:any)=>{                      
             if(products.length===0){              
               this.vhMGDB_database.deleteDoc('categorys', id_category)
                   .then((bool:any)=>{            
                     resolve(bool);
                   }, error=>{
                     reject(error)
                   })    
             }else resolve(false);
           }, error=>{
             reject(error)
           })             
     })
   }
 
   /**
    * @example
    * this.vhQueryCafeWebAdmin.getCategory('5fb67fda87c0f21d484cbdf3')
             .then((category)=>{
               console.log('getCategory', category);
             })
    * @param id_category 
    * @return Promise => obj ={} or null
    */
   public getCategory(id_category:string){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDoc('categorys', id_category)
             .then((category)=>{
               resolve(category);
             })          
     })
   }
 
    /**
    * @example
    * this.vhQueryCafeWebAdmin.getCategorys()
             .then((categorys)=>{
               console.log('getCategorys', categorys);
             })
    * @return Promise => array(object) = [{},{},..]
    */
     public getCategorys(){
       return new Promise((resolve, reject) => {     
         this.vhMGDB_database.getDocs('categorys')
               .then((categorys)=>{                
                 resolve(categorys);
               },(error:any)=>{
                 reject(error);
               })          
       })
     }
 
  /**
    * @example:
    * this.vhQueryCafeWebAdmin.getCategorysByFields({name:{$eq:'name abc'}}, {},{},0)
       .then((categorys)=>{
         console.log('getCategorysByFields', categorys);
       })
   * @param query
   * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
   * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
   * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
   * @return — Array -> array = [{},{},...] 
   */
   public getCategorysByFields(query: object, projection?:object, sort?:object, limit?:number){
     return new Promise((resolve) => {
       this.vhQuery.getDocsByFields('categorys', query, projection,sort,limit)
           .then((categorys)=>{
             resolve(categorys);           
           })
     })
   }
 
 }

 @Injectable()
 export class VhQuerySMS{    
  private hwinfo: any = {};
   
 
   constructor(    
     private vhMGDB_auth: VhMGDB_auth, 
     private vhMGDB_rootdatabase: VhMGDB_rootdatabase, 
     private vhMGDB_database: VhMGDB_database, 
     private vhMGDB_socketMongoDB: VhMGDB_socketMongoDB, 
     private vhMGDB_tiki: VhMGDB_tiki, 
     private vhMGDB_sendo: VhMGDB_sendo,
     private vhMGDB_lazada: VhMGDB_lazada,
     private vhMGDB_socketFacebook: VhMGDB_socketFacebook,      
     private vhMGDB_paymentVNPAY: VhMGDB_paymentVNPAY,      
     private vhQuery:VhQuery, 
     private vhAuth: VhAuth, 
     private vhAlgorithm:VhAlgorithm, 
     private vhDisplayLEDService :VhDisplayLEDService, 
     private iap2: InAppPurchase2,
     private platform: Platform
     ) {       
     Device.getId().then((info:any)=>{       
       let local_hwinfo = this.vhAuth.localStorageGET('hwinfo');
       if((local_hwinfo != null)&&(local_hwinfo != undefined)){
         this.hwinfo = local_hwinfo;        
       }else{
         this.hwinfo = {uuid: info.identifier};    
         this.vhAuth.localStorageSET('hwinfo',this.hwinfo);        
       }           
     });       
   }

  /**
  * @example:
  * this.vhQuerySMS.updateSKHDT('5fb6780ca2148e09806c5b01', {name: 'Quảng cáo 1'})
          .then((bool:any)=>{
            console.log('updateSKHDT', bool);
          }, error=>{
            console.log('error', error);
          })
    * @param id_skhdt 
    * @param data 
    * @return Promise => bool = true or false
    */
  public updateSKHDT(id_skhdt:string, data:object){
  return new Promise((resolve, reject) => {
    this.vhMGDB_rootdatabase.updateDoc('data_SKHDTs', id_skhdt, data)
        .then((bool:any)=>{
          resolve(bool);
        }, error=>{
          reject(error)
        })         
  })
}

/**
 * @example:
 * this.vhQuerySMS.deleteSKHDT('5fb67fda87c0f21d484cbdf3')
      .then((bool:any)=>{
        console.log('deleteSKHDT', bool);
      }, error=>{
        reject(error)
      })
  * @param id_skhdt 
  * @return Promise => bool = true or false
  */
public deleteSKHDT(id_skhdt:string){   
  return new Promise((resolve, reject) => {                 
      this.vhMGDB_rootdatabase.deleteDoc('data_SKHDTs', id_skhdt)
          .then((bool:any)=>{            
            resolve(bool);
          }, error=>{
            reject(error)
          })    
                  
  })
}

/**
 * @example:
 * let time = new Date();
 * time.setDate(time.getDate()-7);
 * this.vhQuerySMS.getSKHDTs_byFields({date:{$gte:time}, {bill_type:{$eq:5}}, {},{date:1},0)
       .then((skhdts)=>{
         console.log('getSKHDTs_byFields', skhdts);
        })
  * @param query
  * @param projection — đang tìm hiểu, tạm thời để giá trị là {}
  * @param sort — null hoặc {}:không sắp xếp; {date:1}: sắp xếp theo ASC; {date:-1}: sắp xếp theo DESC
  * @param limit — null hoặc 0: không giới hạn record get về; 2: get về 2 record
  * @return — Array -> array = [{},{},...] 
  */
  public getSKHDTs_byFields(query: object, projection?:object, sort?:object, limit?:number) {
    return new Promise((resolve, reject) => { 
      this.vhMGDB_rootdatabase.getDocsByFields('data_SKHDTs', query, {}, sort, limit)
          .then((skhdts)=>{
            resolve(skhdts);
          })
          .catch((e)=>{
            reject(e);
          })        
    })
  } 
}

 /** Các phương thức tương đương trong file preloader.js cảu bản build electron */
export interface IElectronAPI {
  send: (channel: string, data?: any) => void;
  invoke: (channel: string, data?: any) => Promise<any>;
  on: (channel: string, func: (...args: any[]) => void) => void;
  off: (channel: string) => void;
  // Serial port (LED screen) functionality
  scanPorts: () => Promise<any[]>;
  openPort: (options: { port: string; baudrate: number }) => Promise<boolean>;
  checkPort: () => Promise<boolean>;
  closePort: () => Promise<boolean>;
  clean: () => Promise<boolean>;
  writeLine: (text: string) => Promise<boolean>;
  writeLineAtPos: ( text: string, position: number) => Promise<boolean>;
  writeLinesAtPos: ( textLine1: string, textLine2: string,position: number) => Promise<boolean>;
}

declare global {
  interface Window {
    electronAPI: IElectronAPI
  }
}
 @Injectable({
   providedIn: 'root',
 })
 export class VhDisplayLEDService{
   private displayLEDs: any = new Array();
   private hwinfo: any = {};
   constructor(
     private vhMGDB_database: VhMGDB_database,
     private platform: Platform,     
     private vhAuth: VhAuth
     ) {
     Device.getId().then((info:any)=>{
       let local_hwinfo = this.vhAuth.localStorageGET('hwinfo');
       if((local_hwinfo != null)&&(local_hwinfo != undefined)){
         this.hwinfo = local_hwinfo;        
       }else{
        this.hwinfo = {uuid: info.identifier};    
         this.vhAuth.localStorageSET('hwinfo',this.hwinfo);        
       }           
     });  
   }
 
 
 
 
  //  public scanPorts() {
  //    return new Promise((resolve, reject) => {
  //      if (this.platform.is('electron')) {
  //        electron.ipcRenderer.send('scanPorts');
  //        electron.ipcRenderer.on('portsInfor', (event: any, data: any) => {
  //          resolve(data);
  //        });
  //      }
  //    });
  //  }
 
  //  public openPort(port: string, baudrate: number) {
  //    return new Promise((resolve, reject) => {
  //      electron.ipcRenderer.send('openPort', {
  //        port: port,
  //        baudrate: baudrate,
  //      });
  //      electron.ipcRenderer.on('openComStatus', (event: any, data: any) => {
  //        if (data) resolve(true);
  //        else {
  //          //console.log(data);
  //          reject(false);
  //        }
  //      });
  //    });
  //  }
 
  //  public closePort() {
  //    return new Promise((resolve, reject) => {
  //      electron.ipcRenderer.send('closePort');
  //      electron.ipcRenderer.on('closeComStatus', (event: any, data: any) => {
  //        if (data) resolve(true);
  //        else {
  //          //console.log(data);
  //          reject(false);
  //        }
  //      });
  //    });
  //  }
 
  //  public clean() {
  //    return new Promise((resolve, reject) => {
  //      electron.ipcRenderer.send('clean');
  //      electron.ipcRenderer.on('cleanStatus', (event: any, data: any) => {
  //        if (data) resolve(true);
  //        else {
  //         //console.log(data);
  //          reject(false);
  //        }
  //      });
  //    });
  //  }
 
  //  public writeLine(text: any) {
  //    return new Promise((resolve, reject) => {
  //      electron.ipcRenderer.send('write', {
  //        text: text,
  //      });
  //      electron.ipcRenderer.on('writeStatus', (event: any, data: any) => {
  //        if (data) resolve(true);
  //        else {
  //          //console.log(data);
  //          reject(false);
  //        }
  //      });
  //    });
  //  }
 
  //  public writeLineAtPos(text: string, position: string) {
  //    return new Promise((resolve, reject) => {
  //      electron.ipcRenderer.send('writeLineAtPos', {
  //        text: text,
  //        position: position,
  //      });
  //      electron.ipcRenderer.on('writeLineStatus', (event: any, data: any) => {
  //        if (data) resolve(true);
  //        else {
  //          //console.log(data);
  //          reject(false);
  //        }
  //      });
  //    });
  //  }
 
  //  public writeLinesAtPos(textLine1: string, textLine2: string, position: string) {
  //    return new Promise((resolve, reject) => {
  //      electron.ipcRenderer.send('writeLinesAtPos', {
  //        textLine1: textLine1,
  //        textLine2: textLine2,
  //        position: position,
  //      });
  //      electron.ipcRenderer.on('writeLinesStatus', (event: any, data: any) => {
  //        if (data) resolve(true);
  //        else {
  //         //data);
  //          reject(false);
  //        }
  //      });
  //    });
  //  }

  public scanPorts() {
    return window.electronAPI.scanPorts();
  }

  public openPort(port: string, baudrate: number) {
    return window.electronAPI.openPort({ port, baudrate });
  }

  public checkPort() {
    return window.electronAPI.checkPort();
  }

  public closePort() {
    return window.electronAPI.closePort();
  }

  public clean() {
    return window.electronAPI.clean();
  }

  public writeLine(text: string) {
    return window.electronAPI.writeLine(text);
  }

  public writeLineAtPos(text: string, position: number) {
    return window.electronAPI.writeLineAtPos(text, position);
  }

  public writeLinesAtPos( textLine1: string, textLine2: string, position: number,) {
    return window.electronAPI.writeLinesAtPos(textLine1, textLine2, position);
  }
 
      
     
 /**
    * @example: 
    * let displayLED = this.vhDisplayLEDService.getlocalDisplayLED('5fb6780ca2148e09806c5b01');
    * @param id_displayLED 
    * @return Object => obj = {} or null
    */
   public getlocalDisplayLED(id_displayLED:any){
     for(let i=0; i<this.displayLEDs.length; i++){
       if(this.displayLEDs[i]._id === id_displayLED){
         return this.displayLEDs[i];
         break;
       }
     }
     return null; 
   }
   /**
    * @example
    * let displayLEDs = this.vhDisplayLEDService.getlocalDisplayLEDs(); 
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalDisplayLEDs(){    
     return this.displayLEDs;
   }
 
   public updateLocalDisplayLEDs(id_displayLED:string, value:any){
     for(let i=0; i<this.displayLEDs.length; i++){
       if(this.displayLEDs[i]._id === id_displayLED){        
           for(const q in value){
             this.displayLEDs[i][q] = value[q];            
           }     
           //console.log('1.this.displayLEDs[i]', this.displayLEDs[i]);    
       }
     }    
     //console.log('2.this.displayLEDs', this.displayLEDs);
   }
 
    /**
    * @example:
    * this.vhDisplayLEDService.refreshLocalDisplayLEDs()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalDisplayLED(), getlocalDisplayLEDs() trong localstorage
    * @return Promise => null
    */
   public refreshLocalDisplayLEDs():any{
     return new Promise((resolve, reject) => { 
       this.getDisplayLEDs()
           .then(()=>{resolve(null)})       
       resolve(null)
     })
   }
 
      /**
    * @example:
    * this.vhDisplayLEDService.refreshLocalDisplayLEDs_byEnable()
           .then(()=>{
             do something.....
           })
    * Hàm này refresh giá trị mới nhất cho hàm getlocalDisplayLED(), getlocalDisplayLEDs() trong localstorage
    * @return Promise => null
    */
     public refreshLocalDisplayLEDs_byEnable():any{
       return new Promise((resolve, reject) => { 
         this.getDisplayLEDs_byEnable()
             .then(()=>{resolve(null)})       
         resolve(null)
       })
     }
 
   /**
    * @example:
    * this.vhDisplayLEDService.addDisplayLED({name:'camera 2', quantity:20, price:200000})
           .then((displayLED)=>{
             console.log('addDisplayLED', displayLED);
           }, error=>{
             console.log('error', error);
           })
    * @param data 
    * Promise => object = {} Luu ý: chỉ có 2 trường hợp, hoặc là thêm thành công, hoặc là báo lỗi error
    */
   public addDisplayLED(data:any){
     return new Promise((resolve, reject) => {      
       let obj:any = {...data};
       obj.uuid = this.hwinfo.uuid;
       this.vhMGDB_database.addDoc('displayLEDs', obj)
           .then((displayLED)=>{
             resolve(displayLED);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example:
    * this.vhDisplayLEDService.updateDisplayLED('5fb6780ca2148e09806c5b01', {quantity:400})
           .then((bool:any)=>{
             console.log('updateDisplayLED', bool);
           }, error=>{
             console.log('error', error);
           })
    * @param id_displayLED
    * @param data 
    * @return Promise => bool = true or false
    */
   public updateDisplayLED(id_displayLED:string, data:object){
     return new Promise((resolve, reject) => {  
       this.vhMGDB_database.updateDoc('displayLEDs', id_displayLED, data)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })         
     })
   }
 
   /**
    * @example:
    * this.vhDisplayLEDService.deleteDisplayLED('5fb67fda87c0f21d484cbdf3')
         .then((bool:any)=>{
           console.log('deleteDisplayLED', bool);
         })
    * @param id_displayLED 
    * @return Promise => bool = true or false
    */
   public deleteDisplayLED(id_displayLED:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.deleteDoc('displayLEDs', id_displayLED)
           .then((bool:any)=>{
             resolve(bool);
           }, error=>{
             reject(error)
           })          
     })
   }
 
   /**
    * @example
    * this.vhDisplayLEDService.getDisplayLED('5fb67fda87c0f21d484cbdf3')
             .then((displayLED)=>{
               console.log('getDisplayLED', displayLED);
             })
    * @param id_displayLED
    * @return false or object
    */
   private getDisplayLED(id_displayLED:string){
     return new Promise((resolve, reject) => {
       this.vhMGDB_database.getDoc('displayLEDs', id_displayLED)
             .then((displayLED:any)=>{
               if(displayLED) delete displayLED?.uuid;
               resolve(displayLED);
             }, error=>{
               reject(error)
             })         
     })
   }
 
   /**
    * @example
    * this.vhDisplayLEDService.getDisplayLEDs()
             .then((displayLEDs)=>{
               console.log('getDisplayLEDs', displayLEDs);
             })
    * @return array(object) = [{},{},..]
    */
   public getDisplayLEDs(){
     return new Promise((resolve) => {
       this.vhMGDB_database.getDocsByFields('displayLEDs',{uuid: {$eq: this.hwinfo.uuid}},{},{},0)
             .then((displayLEDs:any)=>{              
               if(displayLEDs.length>0){
                 this.displayLEDs = new Array();
                 displayLEDs.forEach((e:any) => {
                   delete e?.uuid;
                   this.displayLEDs.push(e);
                 });
               }              
               resolve(this.displayLEDs);
             })          
     })
   }
 
     /**
    * @example
    * this.vhDisplayLEDService.getDisplayLEDs_byEnable()
             .then((displayLEDs)=>{
               console.log('getDisplayLEDs_byEnable', displayLEDs);
             })
    * @return array(object) = [{},{},..]
    */
     public getDisplayLEDs_byEnable(){
       return new Promise((resolve) => {
         this.vhMGDB_database.getDocsByFields('displayLEDs',{uuid: {$eq: this.hwinfo.uuid}, enable: {$eq: true}},{},{},0)
               .then((displayLEDs:any)=>{                
                 if(displayLEDs.length>0){
                   this.displayLEDs = new Array();
                   displayLEDs.forEach((e:any) => {
                     delete e?.uuid;
                     this.displayLEDs.push(e);
                   });
                 }              
                 resolve(this.displayLEDs);
               })          
       })
     }
 
   
 /**
    * @example: 
    * let displayMode = this.vhDisplayLEDService.getlocalDisplayMode(1);
    * @param type 
    * @return Object => obj = {} or null
    */
  public getlocalDisplayMode(type:number){
   for(let i=0; i<this.getlocalDisplayModes().length; i++){
     if(this.getlocalDisplayModes()[i].type === type){
       return this.getlocalDisplayModes()[i];
       break;
     }
   }
   return null; 
 }
   /**
    * @example
    * let displayModes = this.vhDisplayLEDService.getlocalDisplayModes(); 
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalDisplayModes(){    
     let displayModes = [{
               name: 'Chi tiết hóa đơn',
               type: 1
             },{
               name: 'Chi tiết hóa đơn & tổng tiền',
               type: 2
             },{
               name: 'Tổng tiền',
               type: 3
     }];
     return displayModes;
   }
   
   /**
      * @example: 
      * let displayModel = this.vhDisplayLEDService.getlocalDisplayModel(1);
      * @param type 
      * @return Object => obj = {} or null
      */
   public getlocalDisplayModel(type:number){
     for(let i=0; i<this.getlocalDisplayModels().length; i++){
       if(this.getlocalDisplayModels()[i].type === type){
         return this.getlocalDisplayModels()[i];
         break;
       }
     }
     return null; 
   }
   /**
    * @example
    * let displayModels = this.vhDisplayLEDService.getlocalDisplayModels(); 
    * @return Array(object) => array = [{},{},...]
    */
   public getlocalDisplayModels(){    
     let displayModels:any = [{
               name: 'LED 7 đoạn - 1 hàng 8 LED',
               type: 1,
               row_number: 1,
               column_number: 8,
               clear_screen: ['0x0c'],
               cursor_home_row1: '',
               cursor_home_row2:'',
               modes:[{
                 name: 'Chi tiết hóa đơn',
                 type: 1            
               },{
                 name: 'Tổng tiền',
                 type: 3
               }]
             },{
               name: 'LED ma trận - 2 hàng 20 cột',
               type: 2,
               row_number: 2,
               column_number: 20,
               clear_screen: ['0x0c'],
               cursor_home_row1: '',
               cursor_home_row2:'',
               modes:[{
                 name: 'Chi tiết hóa đơn',
                 type: 1
               },{
                 name: 'Chi tiết hóa đơn & tổng tiền',
                 type: 2
               },{
                 name: 'Tổng tiền',
                 type: 3
               }]
             },{
               name: 'VFD-2100',
               type: 3,
               row_number: 2,
               column_number: 20,
               clear_screen: ['0x0c'],
               cursor_home_row1: '',
               cursor_home_row2:'',
               modes:[{
                 name: 'Chi tiết hóa đơn',
                 type: 1
               },{
                 name: 'Chi tiết hóa đơn & tổng tiền',
                 type: 2
               },{
                 name: 'Tổng tiền',
                 type: 3
               }]
     }];
     return displayModels;
   }
 
 }

 
 @Pipe({
   name: 'vhcurrency'
 })
 export class VhCurrencyPipe implements PipeTransform {
   transform( 
       value: number,
       currencyCode: string = 'VND',
       display:
           | 'code'
           | 'symbol'
           | 'symbol-narrow'
           | string
           | boolean = 'symbol',
       digitsInfo: string = '',
       locale: string = 'en-VI',
   ): string | null {
       return formatCurrency(
         value,
         locale,
         '',
         currencyCode,
         digitsInfo,
       );
   }
 }
 
 @Pipe({
   name: 'vhcurrencyunit'
 })
 export class VhCurrencyUnitPipe implements PipeTransform {
   transform(
       value: number,
       locale: string = 'en-VI',
       currencyCode: string = '',
       display:
           | 'code'
           | 'symbol'
           | 'symbol'
           | string
           | boolean = 'symbol',
       digitsInfo: string = '4.0-0'      
   ): string | null {
       return formatCurrency(
         value,
         locale,
         getCurrencySymbol(currencyCode, 'wide'),
         currencyCode,
         digitsInfo,
       );
   }
 }
 
 @Pipe({
 name: 'vhpercent'
 })
 export class VhPercentPipe implements PipeTransform {
   transform(
       value: number,     
       locale: string = 'en-VI',
       digitsInfo: string = '1.2-2',
   ): string | null {
       return formatPercent(
         value, 
         locale,
         digitsInfo
         ); 
   }
 }
  
 @Pipe({
 name: 'vhlink' 
 })
 export class VhLinkPipe implements PipeTransform {
     constructor(private dom:DomSanitizer) {}
     transform(value: any, args: any) {
     return this.dom.bypassSecurityTrustResourceUrl(args + value);
     }
 }
 
 @Pipe({
   name: 'vhyoutubelink' 
   })
 export class VhYoutubeLinkPipe implements PipeTransform {
     constructor(private dom:DomSanitizer) {}
     transform(value: any) {
     return this.dom.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + value);
     }
 }
  
 @Pipe({
   name: 'vhdate'
 })
 export class VhDate implements PipeTransform {
   transform(
     value: any,     
     format: string = '',
     locate: string = 'en-VI',   
   ): string | null {
     let _format = '';
     if(format === 'time'){
       _format = 'HH:mm:ss';
     }else if(format === 'date'){
       _format = 'dd/MM/YYYY';
     }else if(format === 'datetime'){
       _format = 'dd/MM/YYYY HH:mm:ss';
     }else{     
       return 'wrong format';
     }
     return formatDate(value, _format, 'en-VI');
   }
 }
 
 
 export interface itfProduct {
   allow_sell: boolean,
   brand: string,
   id_category: string,
   img: string,
   manysize: boolean,
   name: string,
   selling: boolean,
   type: number,
   warning_number: number,
   item_code:  string,
   units: []     
 }


 
 
 
 
 
  
 
 
 
 
 
